/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: number; output: number; }
  Long: { input: number; output: number; }
  Void: { input: any; output: any; }
};

export enum ApNsEnvironment {
  Production = 'Production',
  Sandbox = 'Sandbox',
  UnknownAPNsEnvironment = 'UnknownAPNsEnvironment'
}

export type AccessConstraint = {
  partyRole?: InputMaybe<PartyRole>;
};

/** Report Options */
export enum AccountNumbersDisplay {
  Auto = 'Auto',
  Hidden = 'Hidden'
}

export type AccountReconciliation = {
  category: EntityCategory;
  categoryId: Scalars['String']['output'];
  chartOfAccountsId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** creator and updater are nullable when system opened the reconciliation */
  creator?: Maybe<EntityUser>;
  endDate: Date;
  reconciliationId: Scalars['String']['output'];
  startDate: Date;
  status: AccountReconciliationStatus;
  updatedAt: Scalars['DateTime']['output'];
  updater?: Maybe<EntityUser>;
};

export enum AccountReconciliationStatus {
  Draft = 'Draft',
  Finalized = 'Finalized',
  ManualReopened = 'ManualReopened',
  SystemDraft = 'SystemDraft',
  SystemFinalized = 'SystemFinalized',
  SystemReopened = 'SystemReopened',
  Unknown = 'Unknown'
}

export type AccountReconciliations = {
  account: EntityCategory;
  earliestOpenReconciliation?: Maybe<AccountReconciliation>;
  mostRecentFinalizedReconciliation?: Maybe<AccountReconciliation>;
  reconciliations: Array<AccountReconciliation>;
};

export enum AccountingBasis {
  AccrualBasis = 'AccrualBasis',
  CashBasis = 'CashBasis',
  UnknownAccountingBasis = 'UnknownAccountingBasis'
}

export type ActionItem = {
  action: ActionItemAction;
  author?: Maybe<EntityUser>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  flaggedObjectKinds?: Maybe<Array<ObjectKind>>;
  id: Scalars['String']['output'];
  objectTimestamp?: Maybe<Scalars['DateTime']['output']>;
  organizationAssigneeIds: Array<Scalars['String']['output']>;
  qualityCheck?: Maybe<QualityCheck>;
  status: ActionItemStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userAssignees: Array<EntityUser>;
  value: ActionItemValue;
};

export enum ActionItemAction {
  ClosedPeriodBooksClosedDate = 'ClosedPeriodBooksClosedDate',
  ClosedPeriodTransactionCreate = 'ClosedPeriodTransactionCreate',
  ClosedPeriodTransactionDelete = 'ClosedPeriodTransactionDelete',
  ClosedPeriodTransactionEdit = 'ClosedPeriodTransactionEdit',
  ClosedPeriodTransactionMatch = 'ClosedPeriodTransactionMatch',
  ClosedPeriodTransactionUnmatch = 'ClosedPeriodTransactionUnmatch',
  ConnectionInvestmentUpgrade = 'ConnectionInvestmentUpgrade',
  ConnectionLoginRequired = 'ConnectionLoginRequired',
  FinalizeDraftReport = 'FinalizeDraftReport',
  FixReconciliation = 'FixReconciliation',
  QualityControl = 'QualityControl',
  ReviewDraftSchedule = 'ReviewDraftSchedule',
  ReviewImportedSchedule = 'ReviewImportedSchedule',
  UnknownAction = 'UnknownAction',
  UploadStatement = 'UploadStatement',
  ViewPublishedReport = 'ViewPublishedReport'
}

export enum ActionItemActionType {
  Approve = 'Approve',
  Pay = 'Pay',
  Review = 'Review',
  Submit = 'Submit',
  UnknownActionType = 'UnknownActionType'
}

export type ActionItemBillApproval = {
  bill: EntityBill;
};

export type ActionItemCategory = {
  category: EntityCategory;
};

export type ActionItemClosedPeriodRequest = {
  ledgerTransactions: Array<EntityLedgerTransaction>;
  requestId: Scalars['String']['output'];
  requestType: ClosedPeriodRequestType;
};

export type ActionItemClosedPeriodTransactionRequest = {
  ledgerTransaction: EntityLedgerTransaction;
  requestId: Scalars['String']['output'];
  requestType: ClosedPeriodRequestType;
};

export type ActionItemConnection = {
  connection: EntityConnection;
  dataSource: EntityDataSource;
};

export type ActionItemFilter = {
  betaActions?: InputMaybe<Array<ActionItemAction>>;
  externalKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  groups?: InputMaybe<Array<ActionItemGroup>>;
  includeMode?: InputMaybe<Array<ActionItemTargetMode>>;
  objectIdentifiers?: InputMaybe<Array<InputObjectIdentifier>>;
  objectKinds?: InputMaybe<Array<ObjectKind>>;
  status: Array<ActionItemStatus>;
  targetOrganizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ActionItemGroup {
  BillsAndInvoices = 'BillsAndInvoices',
  Book = 'Book',
  ClosedPeriodRequests = 'ClosedPeriodRequests',
  Collaboration = 'Collaboration',
  Reconcile = 'Reconcile',
  Report = 'Report',
  Review = 'Review',
  Schedule = 'Schedule',
  Setup = 'Setup',
  UnknownGroup = 'UnknownGroup',
  Urgent = 'Urgent'
}

export enum ActionItemKind {
  Bill = 'Bill',
  Comment = 'Comment',
  Onboarding = 'Onboarding',
  Report = 'Report',
  TransactionReview = 'TransactionReview',
  UnknownActionItemKind = 'UnknownActionItemKind',
  WorkItem = 'WorkItem'
}

/**
 * A quality-control finding on a whole journal entry (e.g. transaction_pii),
 * keyed by ledger transaction rather than an individual line.
 */
export type ActionItemLedgerTransaction = {
  ledgerTransaction: EntityLedgerTransaction;
};

/**
 * A quality-control finding on a party (e.g. multiple_categories), keyed by the
 * party grouped over its category set.
 */
export type ActionItemParty = {
  party: EntityParty;
};

export type ActionItemPublishedReport = {
  package: EntityReportPackage;
};

export type ActionItemReconciliation = {
  category: EntityCategory;
  flags: Array<ActionItemReconciliationFlag>;
  reconciliation: EntityReconciliation;
};

export type ActionItemReconciliationFlag = {
  createdAt: Scalars['DateTime']['output'];
  flagId: Scalars['String']['output'];
  flagType: ReconciliationFlagType;
  reconciliationIntentId: Scalars['String']['output'];
  resolutionType?: Maybe<ReconciliationFlagResolutionType>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ActionItemReviewDraftSchedule = {
  transaction: EntityTransaction;
};

export type ActionItemReviewImportedSchedule = {
  scheduleImportCandidateId: Scalars['String']['output'];
};

export enum ActionItemStatus {
  Closed = 'Closed',
  Completed = 'Completed',
  Created = 'Created',
  Invalidated = 'Invalidated',
  Unknown = 'Unknown'
}

export type ActionItemStatusChange = {
  actionItemId: Scalars['String']['input'];
  status: ActionItemStatus;
};

export type ActionItemSummary = {
  count: Scalars['Long']['output'];
  period: Period;
};

export enum ActionItemTargetMode {
  Assign = 'Assign',
  UnknownTargetMode = 'UnknownTargetMode',
  Watch = 'Watch'
}

export type ActionItemThread = {
  targetEntity: ObjectEntity;
  threadId: Scalars['String']['output'];
};

export type ActionItemTransaction = {
  categorySuggestions?: Maybe<Array<CategorySuggestion>>;
  transaction: EntityTransaction;
};

export type ActionItemUploadStatement = {
  category: EntityCategory;
};

export type ActionItemValue = ActionItemBillApproval | ActionItemCategory | ActionItemClosedPeriodRequest | ActionItemClosedPeriodTransactionRequest | ActionItemConnection | ActionItemLedgerTransaction | ActionItemParty | ActionItemPublishedReport | ActionItemReconciliation | ActionItemReviewDraftSchedule | ActionItemReviewImportedSchedule | ActionItemThread | ActionItemTransaction | ActionItemUploadStatement;

export type ActionItemsExternalKeySummary = {
  count: Scalars['Long']['output'];
  externalKey: Scalars['String']['output'];
};

export type ActionItemsGroupSummary = {
  count: Scalars['Long']['output'];
  group: ActionItemGroup;
};

export type ActionItemsObjectKindSummary = {
  count: Scalars['Long']['output'];
  objectKind: ObjectKind;
};

export type ActivePartyRoles = {
  partyId: Scalars['String']['output'];
  roles: Array<PartyRole>;
};

/**
 * ActivityEvent represents one event in an ActivityFeed.
 * Note: The objects represented by subject, target and actor_user_id
 *       will be available externally to this message type.
 */
export type ActivityEvent = {
  computedEvent?: Maybe<ComputedEvent>;
  discreteEvent?: Maybe<DiscreteEvent>;
  id: Scalars['String']['output'];
  legalEntityId: Scalars['String']['output'];
  occurredAt: Scalars['DateTime']['output'];
};

export enum ActivityEventInterval {
  AllTime = 'AllTime',
  Day = 'Day',
  Hour = 'Hour',
  Minute = 'Minute',
  Month = 'Month',
  None = 'None',
  Week = 'Week',
  Year = 'Year'
}

/**
 * Activity Feed
 * ActivityFeed contains a sequence of ActivityEvents
 * and a separate structure describing the hydrated form
 * of the object entities referenced by the author/subject/target
 * of the feed's events.
 */
export type ActivityFeed = {
  entities: ObjectEntities;
  events: Array<ActivityEvent>;
};

export type ActivityObjectIdentifier = {
  context?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind: ObjectKind;
};

export type AddedFeature = {
  featureId: Scalars['String']['output'];
  invalid: Scalars['Boolean']['output'];
};

export type Address = {
  /** city is used for the city/town/village of the address */
  city?: Maybe<Scalars['String']['output']>;
  /** ISO country code */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Latitude */
  lat?: Maybe<Scalars['Float']['output']>;
  /** Longitude */
  long?: Maybe<Scalars['Float']['output']>;
  /** postal identifier for the address */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** region is the state, region, or any other subdivision of the country */
  region?: Maybe<Scalars['String']['output']>;
  /** street contains the housing number and street name */
  street?: Maybe<Scalars['String']['output']>;
  /** street_additional is used for any other additional street identifying information */
  streetAdditional?: Maybe<Scalars['String']['output']>;
};

export type AddressFeatureValue = {
  addressValue: Address;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAdditional?: InputMaybe<Scalars['String']['input']>;
};

export type AdjacentObjectPermission = {
  legalEntity: EntityLegalEntity;
  object: ObjectIdentifier;
  organizationPreview: OrganizationPreview;
  viewType: ViewType;
};

export type AdminCategory = {
  category: Category;
  chartOfAccountsDisplayNumber?: Maybe<Scalars['String']['output']>;
  externalAccountSubtype?: Maybe<Scalars['String']['output']>;
  externalAccountType?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  subtype?: Maybe<CategorySubtype>;
  synthesized: Scalars['Boolean']['output'];
};

export type AdminChartOfAccountsFilter = {
  accountingBasis?: InputMaybe<AccountingBasis>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
};

export type AdminConnectionTemplate = {
  connector: Connector;
  externalId?: Maybe<Scalars['String']['output']>;
  institution: ProductInstitution;
};

export type AdminConnector = {
  connector: Connector;
  installCount?: Maybe<Scalars['Long']['output']>;
};

export type AdminReportPackageDocumentMetadata = {
  documentObjectId: Scalars['String']['output'];
  documentObjectVersionId: Scalars['String']['output'];
  generationHistory?: Maybe<ReportGenerationHistory>;
  id: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  reportFile?: Maybe<ReportFileMetadata>;
  status: ReportPackageDocumentStatus;
  title: Scalars['String']['output'];
  type: ReportPackageDocumentType;
  validationHistories: Array<ReportValidationHistory>;
};

export type AdminReportPackageMetadata = {
  author?: Maybe<Contact>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  documents: Array<AdminReportPackageDocumentMetadata>;
  endedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  interval: Interval;
  publishedAsDraft: Scalars['Boolean']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: ReportPackageStatus;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId: Scalars['String']['output'];
  viewKey: ViewIdentifier;
};

export type AffiliateOrganization = {
  affiliatedUsers: Array<AffiliateUser>;
  organization: Organization;
  type: AffiliateType;
};

export type AffiliateOrganizations = {
  inviteProposals: Array<InvitationProposal>;
  organizations: Array<AffiliateOrganization>;
};

export enum AffiliateType {
  Accounting = 'Accounting',
  Investment = 'Investment'
}

export type AffiliateUser = {
  role: Role;
  user: User;
};

export type Affiliation = {
  legalEntity: EntityLegalEntity;
  organization: EntityOrganization;
  role: Role;
};

export type AgingDimension = {
  by: DimensionSummary;
  summary: TransactionSummary;
};

export type AgingSummary = {
  dimensionSummary: DimensionSummary;
  label: Scalars['String']['output'];
};

export type AgingSummaryChartConfig = {
  /** @deprecated Unused */
  categoryId?: Maybe<Scalars['String']['output']>;
  dimensions: Array<SummaryDimension>;
  kind: ReportKind;
  masks?: Maybe<Array<Array<SummaryDimension>>>;
  origin: ArchiveIntervalOrigin;
};

export type AgingSummaryChartConfigInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  dimensions: Array<SummaryDimension>;
  kind: ReportKind;
  masks?: InputMaybe<Array<Array<SummaryDimension>>>;
  origin: IntervalOrigin;
};

export type AmountRuleFilter = {
  amount: MonetaryValue;
  amountRuleFilterId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  operator: ComparisonOperator;
};

export type App = {
  description?: Maybe<Scalars['String']['output']>;
  developerEmail?: Maybe<Scalars['String']['output']>;
  homepageURL?: Maybe<Scalars['String']['output']>;
  iconObjectName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  privacyPolicyURL?: Maybe<Scalars['String']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  termsOfServiceURL?: Maybe<Scalars['String']['output']>;
  visibility: ConnectorVisibility;
};

export type AppAuthorization = {
  app: App;
  eligibleLegalEntities?: Maybe<Array<EntityLegalEntity>>;
  environment: AppEnvironment;
  ineligibleLegalEntities?: Maybe<Array<EntityLegalEntity>>;
};

export type AppConnectorProperties = {
  developerEmail: Scalars['String']['output'];
  homepageURL: Scalars['String']['output'];
  iconObjectName?: Maybe<Scalars['String']['output']>;
  installUri?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  privacyPolicyURL?: Maybe<Scalars['String']['output']>;
  redirectUris?: Maybe<Array<Scalars['String']['output']>>;
  scopes?: Maybe<Array<Scalars['String']['output']>>;
  supportEmail: Scalars['String']['output'];
  termsOfServiceURL?: Maybe<Scalars['String']['output']>;
  visibility: ConnectorVisibility;
};

export type AppCredential = {
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  environment: AppEnvironment;
};

export enum AppEnvironment {
  Development = 'Development',
  Production = 'Production'
}

export type AppInstance = {
  appBundleId: Scalars['String']['output'];
  appInstanceId: Scalars['String']['output'];
  appName: Scalars['String']['output'];
  appVersion: Scalars['String']['output'];
  deviceModel: Scalars['String']['output'];
  deviceName: Scalars['String']['output'];
  deviceOs: Scalars['String']['output'];
  deviceOsVersion: Scalars['String']['output'];
  lastUsedAt: Scalars['DateTime']['output'];
};

export type AppInstanceChallenge = {
  deviceId: Scalars['String']['input'];
  nonce: Scalars['Int']['input'];
  signature: Scalars['String']['input'];
  timestamp: Scalars['Long']['input'];
  userId: Scalars['String']['input'];
};

export type AppInstanceProfile = {
  appBundleId: Scalars['String']['input'];
  appName: Scalars['String']['input'];
  appVersion: Scalars['String']['input'];
  deviceModel: Scalars['String']['input'];
  deviceName: Scalars['String']['input'];
  deviceOs: Scalars['String']['input'];
  deviceOsVersion: Scalars['String']['input'];
};

export type AppRedirect = {
  uri: Scalars['String']['output'];
};

export type ApplePushConfig = {
  apnsEnvironment: ApNsEnvironment;
  bundleId: Scalars['String']['output'];
};

export type ApplePushConfigInput = {
  apnsEnvironment: ApNsEnvironment;
  bundleId: Scalars['String']['input'];
};

export type ApprovalEligibility = {
  legalEntityId: Scalars['String']['output'];
  status: ApprovalEligibilityStatus;
};

export enum ApprovalEligibilityStatus {
  BelowRequiredTransactionCount = 'BelowRequiredTransactionCount',
  DataValidationHealthNotComputed = 'DataValidationHealthNotComputed',
  DataValidationUnhealthy = 'DataValidationUnhealthy',
  /** Error statuses */
  Error = 'Error',
  InvalidQBOLink = 'InvalidQBOLink',
  LedgerViewError = 'LedgerViewError',
  /** Pending i.e. still computing */
  LedgerViewNotComputed = 'LedgerViewNotComputed',
  NoTransactionCount = 'NoTransactionCount',
  Ready = 'Ready',
  ReportValidationNotComputed = 'ReportValidationNotComputed',
  ReportValidationUnhealthy = 'ReportValidationUnhealthy',
  Unknown = 'Unknown'
}

/**
 * TYPES
 *
 */
export type ArchiveIntervalOrigin = {
  index: Scalars['Long']['output'];
  interval: Interval;
  intervalCount?: Maybe<Scalars['Long']['output']>;
  maxTime?: Maybe<Scalars['DateTime']['output']>;
  year: Scalars['Long']['output'];
};

export type ArchivedComponent = {
  data: ComponentData;
  viewId: ViewIdentifier;
};

export enum ArrivalContext {
  ClientPays = 'ClientPays',
  ReportsBuilder = 'ReportsBuilder',
  ResetClientPays = 'ResetClientPays',
  TransactionReview = 'TransactionReview'
}

export type AspectRequestMeta = {
  createdAt: Scalars['DateTime']['output'];
  requestor: EntityUser;
};

export type Assignee = {
  organization?: InputMaybe<OrganizationAssignee>;
  user?: InputMaybe<UserAssignee>;
};

export type AssistantEvent = {
  comment: Comment;
  entities?: Maybe<ObjectEntities>;
  kind: AssistantEventKind;
  layout?: Maybe<Layout>;
  suggestions?: Maybe<Array<Scalars['String']['output']>>;
  threadId?: Maybe<Scalars['String']['output']>;
};

export enum AssistantEventKind {
  Complete = 'Complete',
  Error = 'Error',
  Unknown = 'Unknown',
  Update = 'Update'
}

export type AssistantMessage = {
  authorId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type AssistantThread = {
  messages: Array<AssistantMessage>;
};

export type AssociationHistory = {
  associationIdentifier: AssociationIdentifier;
  documentInfo?: Maybe<DocumentInfo>;
  events: Array<AssociationHistoryEvent>;
};

export type AssociationHistoryEvent = {
  eventTime: Scalars['DateTime']['output'];
  eventType: AssociationHistoryEventType;
  user?: Maybe<EntityUser>;
};

export enum AssociationHistoryEventType {
  Create = 'Create',
  Delete = 'Delete',
  UnknownAssociationHistoryEventType = 'UnknownAssociationHistoryEventType',
  Unlink = 'Unlink',
  Update = 'Update'
}

export type AssociationIdentifier = {
  documentIdentifier: DocumentIdentifier;
  objectIdentifier: ObjectIdentifier;
};

export enum AssociationSource {
  Onboarding = 'Onboarding',
  UnknownSource = 'UnknownSource'
}

export enum AsyncProcessingStatus {
  AsyncProcessingDone = 'AsyncProcessingDone',
  AsyncProcessingError = 'AsyncProcessingError',
  AsyncProcessingStarted = 'AsyncProcessingStarted',
  UnknownAsyncProcessingStatus = 'UnknownAsyncProcessingStatus'
}

export type AuditRule = {
  action: AuditRuleAction;
  amountFilters?: Maybe<Array<AmountRuleFilter>>;
  auditRuleId: Scalars['String']['output'];
  categoryFilters?: Maybe<Array<CategoryRuleFilter>>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  partyFilters?: Maybe<Array<PartyRuleFilter>>;
  ruleState: AuditRuleState;
  type: AuditRuleType;
};

export enum AuditRuleAction {
  CreateBoost = 'CreateBoost',
  SendClientEmail = 'SendClientEmail',
  SendSelfEmail = 'SendSelfEmail',
  UnknownAction = 'UnknownAction'
}

export enum AuditRuleState {
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  UnknownState = 'UnknownState'
}

export type AuditRuleStatus = {
  recentlyUpdated: Scalars['Boolean']['output'];
  type: AuditRuleType;
  updaterType: AuditRuleUpdaterType;
};

export enum AuditRuleType {
  CategorySuggestion = 'CategorySuggestion',
  InParentCategory = 'InParentCategory',
  NewTransaction = 'NewTransaction',
  SensitiveDataSuggestion = 'SensitiveDataSuggestion',
  UnassignedCategorySuggestion = 'UnassignedCategorySuggestion',
  UnassignedVendorSuggestion = 'UnassignedVendorSuggestion',
  UnknownType = 'UnknownType',
  VendorSuggestion = 'VendorSuggestion'
}

export enum AuditRuleUpdaterType {
  System = 'System',
  UnknownUpdaterType = 'UnknownUpdaterType',
  User = 'User'
}

export type BadgeCount = {
  count: Scalars['Long']['output'];
};

export type BalanceSummary = {
  period: Period;
  total: PeriodMonetaryValue;
};

export type BankAccount = {
  accountIdMask: Scalars['String']['output'];
  iconObjectName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  institutionName: Scalars['String']['output'];
  isAutoPayout: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
};

export type BillAccess = {
  objectId: Scalars['String']['output'];
  objectKind: BillAccessKind;
  role: BillAccessRole;
};

export enum BillAccessKind {
  UnknownBillAccessKind = 'UnknownBillAccessKind',
  User = 'User'
}

export enum BillAccessRole {
  Approver = 'Approver',
  /**
   * The user who manually created the bill (no source document). A bill has
   * either Uploader (document-derived) or Creator (manual), never both.
   */
  Creator = 'Creator',
  Payer = 'Payer',
  UnknownBillAccessRole = 'UnknownBillAccessRole',
  Uploader = 'Uploader'
}

export enum BillCandidateMode {
  Basic = 'Basic',
  DefaultBasic = 'DefaultBasic',
  DefaultSplit = 'DefaultSplit',
  Split = 'Split',
  UnknownBillCandidateMode = 'UnknownBillCandidateMode'
}

export type BillConnectorProperties = {
  /** Bill.com requires manual entry of the credentials so we will not have anything here */
  empty?: Maybe<Scalars['Boolean']['output']>;
};

export type BillEdit = {
  dataSourceBillId: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  dueDate: Scalars['DateTime']['input'];
};

/**
 * Payment recorded outside Digits for a bill on an externally managed
 * entity (Bill Workflow API or mark-as-paid).
 */
export type BillExternalPayment = {
  amount?: Maybe<EntityMonetaryValue>;
  externalReferenceNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  status: BillExternalPaymentStatus;
  statusAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum BillExternalPaymentStatus {
  Failed = 'Failed',
  Paid = 'Paid',
  Refunded = 'Refunded',
  UnknownStatus = 'UnknownStatus'
}

export enum BillStatus {
  Approved = 'Approved',
  Assigned = 'Assigned',
  Draft = 'Draft',
  MarkedAsPaid = 'MarkedAsPaid',
  New = 'New',
  OnHold = 'OnHold',
  Paid = 'Paid',
  PaymentCanceled = 'PaymentCanceled',
  PaymentCreated = 'PaymentCreated',
  PaymentFailed = 'PaymentFailed',
  PaymentRejected = 'PaymentRejected',
  PaymentRequiresAttention = 'PaymentRequiresAttention',
  PaymentReturned = 'PaymentReturned',
  PayoutFailed = 'PayoutFailed',
  Pending = 'Pending',
  Refunded = 'Refunded',
  Rejected = 'Rejected',
  ScheduledToBeSentForApproval = 'ScheduledToBeSentForApproval',
  Settled = 'Settled',
  /**
   * Bill_Status proto zero value stringifies to "Unknown"; the resolver emits it
   * verbatim via .String(). A populated bill should never be status 0, but accepting
   * the value keeps a stray status-0 bill from erroring the whole non-null status
   * field. Kept distinct from UnknownBillStatus, which can't be removed (it's a
   * protected mobile enum value).
   */
  Unknown = 'Unknown',
  UnknownBillStatus = 'UnknownBillStatus',
  Voided = 'Voided'
}

export type Billing = BillingAccountingFirm | BillingLegacyFirm | BillingNone | BillingOperator;

export type BillingAccountingFirm = {
  activeSubscription: Scalars['Boolean']['output'];
  /** @deprecated Use firmPaidClients instead. Retained for backwards compatibility with old clients. */
  affiliated: Array<BillingAffiliated>;
  firmPaidClients: Array<BillingFirmPayer>;
  organizationId: Scalars['String']['output'];
  product: BillingProduct;
  selfPaidClients: Array<BillingClientPayer>;
  subscriptionId: Scalars['String']['output'];
};

export type BillingAddress = {
  billingAddress?: Maybe<Address>;
  fullName?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
};

/** Deprecated: Use BillingFirmPayer instead. Retained for backwards compatibility with old clients. */
export type BillingAffiliated = {
  availablePlans: Array<SubscriptionPlan>;
  legalEntityId: Scalars['String']['output'];
  product: BillingProduct;
};

export type BillingArrangement = {
  legalEntities: Array<BillingArrangementLegalEntityBilling>;
  organizationId: Scalars['String']['output'];
  subscription?: Maybe<BillingArrangementSubscription>;
};

export type BillingArrangementContributor = {
  id: Scalars['String']['output'];
  type: BillingArrangementContributorType;
};

export enum BillingArrangementContributorType {
  LegalEntity = 'LegalEntity',
  Organization = 'Organization',
  UnknownType = 'UnknownType'
}

export type BillingArrangementLegalEntityBilling = {
  eligiblePlans: Array<SubscriptionPlan>;
  legalEntityId: Scalars['String']['output'];
  payerOrganizationId: Scalars['String']['output'];
  payerSubscriptionStatus: BillingArrangementSubscriptionStatus;
  plan?: Maybe<SubscriptionPlan>;
  viewerOrganizationIds: Array<Scalars['String']['output']>;
};

export type BillingArrangementSubscription = {
  items: Array<BillingArrangementSubscriptionItem>;
  stripe?: Maybe<BillingArrangementSubscriptionStripe>;
  subscriptionId: Scalars['String']['output'];
};

export type BillingArrangementSubscriptionItem = {
  contributors: Array<BillingArrangementContributor>;
  plan?: Maybe<SubscriptionPlan>;
};

/** --- Billing Arrangement types --- */
export enum BillingArrangementSubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  PastDue = 'PastDue',
  Trialing = 'Trialing',
  UnknownStatus = 'UnknownStatus',
  Unpaid = 'Unpaid'
}

export type BillingArrangementSubscriptionStripe = {
  billingCycleEnd?: Maybe<Scalars['DateTime']['output']>;
  billingCycleStart?: Maybe<Scalars['DateTime']['output']>;
  cancelAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: BillingArrangementSubscriptionStatus;
  trial?: Maybe<BillingTrial>;
};

export type BillingCardDetails = {
  brand: Scalars['String']['output'];
  country: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  last4: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BillingClientPayer = {
  legalEntityId: Scalars['String']['output'];
  operator: BillingOperator;
};

export type BillingCustomerProfile = {
  cardDetails: BillingCardDetails;
  subscription: BillingSubscription;
};

export type BillingFirmPayer = {
  availablePlans: Array<SubscriptionPlan>;
  /**
   * Whether the firm is currently being charged for this affiliate.
   * Sourced from organization_subscription_affiliation_prices.billed.
   * Reflects whether the price increments the firm's Stripe subscription, not whether the
   * product is intrinsically billable in the catalog.
   */
  billed: Scalars['Boolean']['output'];
  legalEntityId: Scalars['String']['output'];
  product: BillingProduct;
};

export type BillingLegacyFirm = {
  activeSubscription: Scalars['Boolean']['output'];
  organizationId: Scalars['String']['output'];
  product: BillingProduct;
  subscriptionId: Scalars['String']['output'];
};

export type BillingLegalEntityLimit = {
  id: Scalars['String']['output'];
  maxLegalEntityLimit?: Maybe<Scalars['Int']['output']>;
  minLegalEntityLimit: Scalars['Int']['output'];
};

export type BillingNone = {
  /**
   * No known billing plan found
   * Placeholder field required for GraphQL compatibility
   * This field is always ignored and should not be set
   */
  unused: Scalars['Boolean']['output'];
};

export type BillingOperator = {
  activeSubscription: Scalars['Boolean']['output'];
  availableCoupons: Array<Coupon>;
  availablePlans: Array<SubscriptionPlan>;
  organizationId: Scalars['String']['output'];
  product: BillingProduct;
  subscriptionDetails?: Maybe<SubscriptionDetails>;
  subscriptionId: Scalars['String']['output'];
  trial?: Maybe<BillingTrial>;
};

export enum BillingPaymentIntentStatus {
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  Paid = 'Paid',
  UnknownStatus = 'UnknownStatus',
  Upcoming = 'Upcoming'
}

export type BillingPlan = {
  legalEntityLimit?: Maybe<BillingLegalEntityLimit>;
  price: BillingPrice;
  product: BillingProduct;
};

export type BillingPreview = {
  amountDue: MonetaryValue;
  monthlyBillingDay: Scalars['Long']['output'];
  proratedAmount: MonetaryValue;
  subscriptionCoupons?: Maybe<Array<Coupon>>;
};

export type BillingPrice = {
  amount: MonetaryValue;
  id: Scalars['String']['output'];
  interval: Interval;
  intervalCount?: Maybe<Scalars['Int']['output']>;
};

export type BillingProduct = {
  availability: BillingProductAvailability;
  billable: Scalars['Boolean']['output'];
  callout?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  listing: ProductListing;
  name: BillingProductName;
  trialPeriodDays?: Maybe<Scalars['Int']['output']>;
};

export enum BillingProductAvailability {
  Default = 'Default',
  None = 'None',
  Optional = 'Optional',
  UnknownAvailability = 'UnknownAvailability'
}

export enum BillingProductName {
  AIAccounting = 'AIAccounting',
  AffiliatedAIAccounting = 'AffiliatedAIAccounting',
  AffiliatedEssentials = 'AffiliatedEssentials',
  AffiliatedFirmBooks = 'AffiliatedFirmBooks',
  AffiliatedLedgerOnly = 'AffiliatedLedgerOnly',
  AffiliatedLowVolume = 'AffiliatedLowVolume',
  AffiliatedReportsOnly = 'AffiliatedReportsOnly',
  AffiliatedStarter = 'AffiliatedStarter',
  Essentials = 'Essentials',
  Free = 'Free',
  FreeForever = 'FreeForever',
  Growth = 'Growth',
  Premium = 'Premium',
  ProspectFirm = 'ProspectFirm',
  UnknownName = 'UnknownName'
}

export type BillingSubscription = {
  id: Scalars['String']['output'];
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
};

export type BillingSubscriptionHistory = {
  cardDetails?: Maybe<BillingCardDetails>;
  createdAt: Scalars['DateTime']['output'];
  invoiceURL: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  prorationAmount: MonetaryValue;
  recurringAmount: MonetaryValue;
  status: BillingPaymentIntentStatus;
  totalAmount: MonetaryValue;
};

export enum BillingSubscriptionStatus {
  Active = 'Active',
  All = 'All',
  Canceled = 'Canceled',
  Incomplete = 'Incomplete',
  IncompleteExpired = 'IncompleteExpired',
  PastDue = 'PastDue',
  Trialing = 'Trialing',
  Unknown = 'Unknown',
  Unpaid = 'Unpaid'
}

export type BillingSubscriptionWithoutStatus = {
  id: Scalars['String']['output'];
  periodEnd: Scalars['DateTime']['output'];
  periodStart: Scalars['DateTime']['output'];
};

export type BillingTrial = {
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type BooksClosedDate = {
  latestBooksClosedDateFact?: Maybe<Scalars['DateTime']['output']>;
  legalEntityId: Scalars['String']['output'];
  user?: Maybe<EntityUser>;
  /** @deprecated unused */
  viewBooksClosedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type BooksClosedFact = {
  booksClosedDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dataSourceId?: Maybe<Scalars['String']['output']>;
  legalEntityId: Scalars['String']['output'];
  superUserId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type BusinessVerification = {
  url?: Maybe<Scalars['String']['output']>;
};

export type BusinessVerificationApplication = {
  address?: Maybe<Address>;
  annualRevenue?: Maybe<MonetaryValue>;
  businessName?: Maybe<Scalars['String']['output']>;
  companyType: BusinessVerificationCompanyType;
  companyWebsite?: Maybe<Scalars['String']['output']>;
  industryCode?: Maybe<Scalars['String']['output']>;
  industryCodeId?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Owner>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  physicalStoreAddress?: Maybe<Address>;
};

export type BusinessVerificationApplicationInput = {
  address?: InputMaybe<AddressInput>;
  annualRevenue?: InputMaybe<InputMonetaryValue>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  companyType: BusinessVerificationCompanyType;
  companyWebsite?: InputMaybe<Scalars['String']['input']>;
  industryCode?: InputMaybe<Scalars['String']['input']>;
  industryCodeId?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<OwnerInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  physicalStoreAddress?: InputMaybe<AddressInput>;
};

export type BusinessVerificationBankAccount = {
  accountName: Scalars['String']['output'];
  accountNumberMask: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export enum BusinessVerificationCompanyType {
  Organization = 'Organization',
  SoleProprietor = 'SoleProprietor',
  Unknown = 'Unknown'
}

export enum BusinessVerificationStatus {
  Expired = 'Expired',
  InProgress = 'InProgress',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Unknown = 'Unknown',
  Unverified = 'Unverified',
  Verified = 'Verified',
  VerifiedInGracePeriod = 'VerifiedInGracePeriod'
}

export type BusinessVerificationStatusResult = {
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  isRestricted: Scalars['Boolean']['output'];
  needsPciSaqSigned: Scalars['Boolean']['output'];
  pciSaqDeadline?: Maybe<Scalars['DateTime']['output']>;
  status: BusinessVerificationStatus;
};

export type CsvColumnMappingInput = {
  columns: Array<ColumnAssignmentInput>;
  options?: InputMaybe<CsvParseOptionsInput>;
};

export enum CsvFieldType {
  Amount = 'Amount',
  Credit = 'Credit',
  Date = 'Date',
  Debit = 'Debit',
  Department = 'Department',
  Description = 'Description',
  Location = 'Location'
}

export type CsvParseOptionsInput = {
  dateFormat?: InputMaybe<Scalars['String']['input']>;
  invertSign?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CanResetLegalEntityResponse = {
  canReset: Scalars['Boolean']['output'];
  outstandingBalance: MonetaryValue;
};

export enum CanonicalCategoryType {
  Cash = 'Cash',
  CashNoClearing = 'CashNoClearing',
  Unknown = 'Unknown'
}

export type CardBillingAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAdditional?: InputMaybe<Scalars['String']['input']>;
};

export type CardHolder = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum CardPaymentResultStatus {
  /** Payment was successful */
  Authorised = 'Authorised',
  /** An error occurred */
  Error = 'Error',
  /** Additional action required (e.g., 3DS) */
  Pending = 'Pending',
  /** Payment is being processed */
  Received = 'Received',
  /** Payment was refused */
  Refused = 'Refused',
  Unknown = 'Unknown'
}

export type CashSummary = {
  cashChange: DimensionSummary;
  cashTotal: DimensionSummary;
};

export type CashSummaryChartConfig = {
  origin: ArchiveIntervalOrigin;
};

export type CashSummaryChartConfigInput = {
  origin: IntervalOrigin;
};

/** Categories */
export type Category = {
  active: Scalars['Boolean']['output'];
  ancestors?: Maybe<Array<EntityCategory>>;
  categoryState: CategoryState;
  description: Scalars['String']['output'];
  displayKey: Scalars['String']['output'];
  displayNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentCategoryId?: Maybe<Scalars['String']['output']>;
  productArea?: Maybe<ProductArea>;
  subtype: CategorySubtype;
  synthesized?: Maybe<Scalars['Boolean']['output']>;
  type: CategoryType;
};

/** Balances */
export type CategoryBalanceFilter = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  categoryType?: InputMaybe<CategoryType>;
  includeCategoryChildren?: InputMaybe<Scalars['Boolean']['input']>;
  legalEntityId: Scalars['String']['input'];
  productArea?: InputMaybe<ProductArea>;
  viewVersion?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryByDepartmentChartConfig = {
  categoryId: Scalars['String']['output'];
  departmentIds: Array<Scalars['String']['output']>;
  origin: ArchiveIntervalOrigin;
};

export type CategoryByDepartmentChartConfigInput = {
  categoryId: Scalars['String']['input'];
  departmentIds: Array<Scalars['String']['input']>;
  origin: IntervalOrigin;
};

export type CategoryByDepartmentOptions = {
  departmentIds?: Maybe<Array<Scalars['String']['output']>>;
  departments?: Maybe<Array<DepartmentOption>>;
  showOther?: Maybe<Scalars['Boolean']['output']>;
  showUnassigned?: Maybe<Scalars['Boolean']['output']>;
};

export type CategoryByDepartmentOptionsInput = {
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  departments?: InputMaybe<Array<DepartmentOptionInput>>;
  showOther?: InputMaybe<Scalars['Boolean']['input']>;
  showUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryByLocationChartConfig = {
  categoryId: Scalars['String']['output'];
  locationIds: Array<Scalars['String']['output']>;
  origin: ArchiveIntervalOrigin;
};

export type CategoryByLocationChartConfigInput = {
  categoryId: Scalars['String']['input'];
  locationIds: Array<Scalars['String']['input']>;
  origin: IntervalOrigin;
};

export type CategoryByLocationOptions = {
  locationIds?: Maybe<Array<Scalars['String']['output']>>;
  locations?: Maybe<Array<LocationOption>>;
  showOther?: Maybe<Scalars['Boolean']['output']>;
  showUnassigned?: Maybe<Scalars['Boolean']['output']>;
};

export type CategoryByLocationOptionsInput = {
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locations?: InputMaybe<Array<LocationOptionInput>>;
  showOther?: InputMaybe<Scalars['Boolean']['input']>;
  showUnassigned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryChartConfig = {
  asPermanent?: Maybe<Scalars['Boolean']['output']>;
  categoryId: Scalars['String']['output'];
  origin: ArchiveIntervalOrigin;
  withoutCategoryAncestors?: Maybe<Scalars['Boolean']['output']>;
};

export type CategoryChartConfigInput = {
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId: Scalars['String']['input'];
  origin: IntervalOrigin;
  withoutCategoryAncestors?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CategoryDimension = {
  by: DimensionSummary;
  categoryId: Scalars['String']['output'];
  categoryObject: EntityCategory;
  summary: TransactionSummary;
};

export type CategoryFacet = {
  categoryObject: EntityCategory;
  count: Scalars['Int']['output'];
};

export type CategoryHover = {
  balance?: Maybe<Scalars['Boolean']['output']>;
  context?: Maybe<DimensionSummary>;
  entity: EntityCategory;
  history: DimensionSummary;
  missingClass?: Maybe<DimensionSummary>;
  otherClass?: Maybe<DimensionSummary>;
  topTransactions?: Maybe<Array<EntityTransaction>>;
};

export type CategoryIntegrations = {
  categoryId: Scalars['String']['output'];
  connect: Array<ConnectionCategoryIntegrations>;
  pay?: Maybe<PayCategoryIntegrations>;
};

/** Inputs */
export type CategoryLabelInput = {
  categoryId: Scalars['String']['input'];
  label: Scalars['String']['input'];
};

/** Category Mappings */
export type CategoryMapping = {
  category: EntityCategory;
  mappingType: CategoryToLabelMappingType;
  mappingValue: Scalars['String']['output'];
  product: CategoryToLabelMappingProduct;
};

export type CategoryParams = {
  categoryIcon?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['String']['input'];
  categoryName: Scalars['String']['input'];
};

export type CategoryRef = {
  id: Scalars['String']['output'];
};

export type CategoryRuleFilter = {
  categories: Array<CategoryRuleFilterCategory>;
  categoryRuleFilterId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  operation: Operation;
};

export type CategoryRuleFilterCategory = {
  categoryId: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
};

export enum CategoryState {
  CategoryActive = 'CategoryActive',
  CategoryDisabled = 'CategoryDisabled',
  CategoryInactive = 'CategoryInactive',
  UnknownCategoryState = 'UnknownCategoryState'
}

export enum CategorySubtype {
  AccountsPayable = 'AccountsPayable',
  AccountsReceivable = 'AccountsReceivable',
  AccruedExpenses = 'AccruedExpenses',
  AccruedRevenue = 'AccruedRevenue',
  AdditionalPaidInCapital = 'AdditionalPaidInCapital',
  AssetClearing = 'AssetClearing',
  BadDebtExpense = 'BadDebtExpense',
  BankAccounts = 'BankAccounts',
  BusinessApplicationsAndSoftware = 'BusinessApplicationsAndSoftware',
  CommonStock = 'CommonStock',
  ConvertibleNotes = 'ConvertibleNotes',
  CostOfGoods = 'CostOfGoods',
  CostOfLabor = 'CostOfLabor',
  CreditCardRewards = 'CreditCardRewards',
  CreditCards = 'CreditCards',
  DeferredRevenue = 'DeferredRevenue',
  DepreciationAndAmortization = 'DepreciationAndAmortization',
  Facilities = 'Facilities',
  FixedAssets = 'FixedAssets',
  GeneralOperations = 'GeneralOperations',
  Goodwill = 'Goodwill',
  HostingFees = 'HostingFees',
  IntangibleAssets = 'IntangibleAssets',
  InterestAndDividends = 'InterestAndDividends',
  InterestExpense = 'InterestExpense',
  Inventory = 'Inventory',
  Investments = 'Investments',
  LiabilityClearing = 'LiabilityClearing',
  LongTermDebt = 'LongTermDebt',
  None = 'None',
  Other = 'Other',
  OtherComprehensiveIncome = 'OtherComprehensiveIncome',
  OtherCostOfRevenue = 'OtherCostOfRevenue',
  OtherCurrentAssets = 'OtherCurrentAssets',
  OtherCurrentLiabilities = 'OtherCurrentLiabilities',
  OtherLongTermAssets = 'OtherLongTermAssets',
  OtherLongTermLiabilities = 'OtherLongTermLiabilities',
  OtherMiscellaneousExpenses = 'OtherMiscellaneousExpenses',
  OtherMiscellaneousIncome = 'OtherMiscellaneousIncome',
  OwnersEquity = 'OwnersEquity',
  PartnerRevenue = 'PartnerRevenue',
  PaymentProcessingFees = 'PaymentProcessingFees',
  Payroll = 'Payroll',
  PayrollExpenses = 'PayrollExpenses',
  Pending = 'Pending',
  PreferredStock = 'PreferredStock',
  PrepaidExpenses = 'PrepaidExpenses',
  ProfessionalFees = 'ProfessionalFees',
  RefundsAndDiscounts = 'RefundsAndDiscounts',
  RetainedEarnings = 'RetainedEarnings',
  Safes = 'Safes',
  SalesAndMarketing = 'SalesAndMarketing',
  SalesRevenue = 'SalesRevenue',
  ShareholderLoans = 'ShareholderLoans',
  ShortTermDebt = 'ShortTermDebt',
  SubscriptionRevenue = 'SubscriptionRevenue',
  SuppliesAndMaterials = 'SuppliesAndMaterials',
  Taxes = 'Taxes',
  TransactionRevenue = 'TransactionRevenue',
  TravelAndEntertainment = 'TravelAndEntertainment',
  TreasuryStock = 'TreasuryStock',
  UncategorizedAssets = 'UncategorizedAssets',
  UncategorizedEquity = 'UncategorizedEquity',
  UncategorizedExpense = 'UncategorizedExpense',
  UncategorizedIncome = 'UncategorizedIncome',
  /**
   * Prior values
   * UnknownSubtype
   * Payroll
   * Pending
   * Current values
   */
  UnknownSubtype = 'UnknownSubtype'
}

/** Category Suggestions */
export type CategorySuggestion = {
  categoryId: Scalars['String']['output'];
  classificationVersionId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dataSourceId: Scalars['String']['output'];
  modelConfidence?: Maybe<Scalars['Long']['output']>;
  modelVersionId?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Long']['output'];
  transactionFactId: Scalars['String']['output'];
  type: EntryType;
  updatedAt: Scalars['DateTime']['output'];
};

export enum CategoryToLabelMappingLabel {
  AccountsPayable = 'AccountsPayable',
  AccountsReceivable = 'AccountsReceivable',
  CashAccount = 'CashAccount',
  ClearingAccount = 'ClearingAccount',
  ContraRevenue = 'ContraRevenue',
  Fees = 'Fees',
  SalesRevenue = 'SalesRevenue',
  UncategorizedExpenses = 'UncategorizedExpenses',
  UnknownLabel = 'UnknownLabel'
}

export enum CategoryToLabelMappingProduct {
  DigitsPayAP = 'DigitsPayAP',
  DigitsPayAR = 'DigitsPayAR',
  UnknownProduct = 'UnknownProduct'
}

export enum CategoryToLabelMappingType {
  CategoryLabel = 'CategoryLabel',
  PaymentInstrument = 'PaymentInstrument',
  UnknownType = 'UnknownType'
}

export enum CategoryType {
  Assets = 'Assets',
  CostOfGoodsSold = 'CostOfGoodsSold',
  Equity = 'Equity',
  Expenses = 'Expenses',
  Income = 'Income',
  Liabilities = 'Liabilities',
  OtherExpenses = 'OtherExpenses',
  OtherIncome = 'OtherIncome',
  UnknownType = 'UnknownType'
}

export type CategoryTypeDimension = {
  by: DimensionSummary;
  summary: TransactionSummary;
};

export type ChangeDateFlagDetails = {
  statementLineItem: StatementLineItem;
  suggestedDate: Scalars['DateTime']['output'];
  transaction: Transaction;
  transactionFactId: Scalars['String']['output'];
};

export enum ChannelKind {
  Email = 'Email',
  Push = 'Push',
  UnspecifiedChannelKind = 'UnspecifiedChannelKind',
  Web = 'Web'
}

export type Chart = {
  entity: ObjectEntity;
  summary: DimensionSummary;
};

/** Chart of Accounts */
export type ChartOfAccounts = {
  accountingBasis: AccountingBasis;
  categories: Array<Category>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ChartOfAccountsListEntry = {
  accountingBasis: AccountingBasis;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  legalEntityId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type ChartOfAccountsTemplate = {
  categories: Array<TemplateCategory>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
};

export type ChartOfAccountsTemplateSummary = {
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
};

export type Check = {
  address?: Maybe<Address>;
  id: Scalars['String']['output'];
  isAutoPayout: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  nickname: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
};

export type CheckAffiliatedSubscriptionProduct = {
  exists: Scalars['Boolean']['output'];
  product?: Maybe<BillingProduct>;
};

export type CheckBillingCustomerProfile = {
  billingCustomerProfile?: Maybe<BillingCustomerProfile>;
  exists: Scalars['Boolean']['output'];
};

export type CheckBillingPlan = {
  billingPlan?: Maybe<BillingPlan>;
  exists: Scalars['Boolean']['output'];
  subscriptionDetails?: Maybe<SubscriptionDetails>;
  trial?: Maybe<BillingTrial>;
};

export enum ClassificationConfidenceLevel {
  Default = 'Default',
  Low = 'Low',
  Unspecified = 'Unspecified'
}

export type ClassificationProvenance = {
  changedAt?: Maybe<Scalars['DateTime']['output']>;
  confidenceLevel: ClassificationConfidenceLevel;
  settingsName?: Maybe<Scalars['String']['output']>;
  source?: Maybe<TransactionSource>;
  type: ClassificationProvenanceType;
};

export enum ClassificationProvenanceType {
  AICompanyModel = 'AICompanyModel',
  AIFallbackMapping = 'AIFallbackMapping',
  AIFirmModel = 'AIFirmModel',
  AIGlobalModel = 'AIGlobalModel',
  AILLMFallthrough = 'AILLMFallthrough',
  Manual = 'Manual',
  StaticMapping = 'StaticMapping',
  Unknown = 'Unknown'
}

export enum ClassificationSource {
  Digits = 'Digits',
  Manual = 'Manual',
  None = 'None',
  QuickBooks = 'QuickBooks'
}

export enum ClosedPeriodRequestResolution {
  Approve = 'Approve',
  Reject = 'Reject',
  UnknownResolution = 'UnknownResolution'
}

export enum ClosedPeriodRequestStatus {
  Applied = 'Applied',
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected',
  UnknownStatus = 'UnknownStatus'
}

export enum ClosedPeriodRequestType {
  Date = 'Date',
  Match = 'Match',
  Transaction = 'Transaction',
  UnknownType = 'UnknownType'
}

export type ClosedPeriodTransactionChangeDiff = {
  /** Null when the field could not be read from the requested view. */
  currentValue?: Maybe<ClosedPeriodTransactionChangeValue>;
  kind: ClosedPeriodTransactionChangeKind;
  proposedValue: ClosedPeriodTransactionChangeValue;
  status: ClosedPeriodRequestStatus;
  transactionChangeId: Scalars['String']['output'];
  transactionFactId?: Maybe<Scalars['String']['output']>;
};

export type ClosedPeriodTransactionChangeDiffs = {
  diffs: Array<ClosedPeriodTransactionChangeDiff>;
  requestId: Scalars['String']['output'];
};

export type ClosedPeriodTransactionChangeEntityValue = {
  entity: ObjectEntity;
  id: Scalars['String']['output'];
  kind: ObjectKind;
};

export enum ClosedPeriodTransactionChangeKind {
  Create = 'Create',
  Delete = 'Delete',
  UnknownKind = 'UnknownKind',
  UpdateCategory = 'UpdateCategory',
  UpdateDepartment = 'UpdateDepartment',
  UpdateExternalDescription = 'UpdateExternalDescription',
  UpdateLedgerParty = 'UpdateLedgerParty',
  UpdateLocation = 'UpdateLocation',
  UpdateParty = 'UpdateParty',
  UpdateReferenceNumber = 'UpdateReferenceNumber',
  UpdateTimestamp = 'UpdateTimestamp'
}

export type ClosedPeriodTransactionChangeTextValue = {
  value: Scalars['String']['output'];
};

export type ClosedPeriodTransactionChangeTimestampValue = {
  value: Scalars['DateTime']['output'];
};

export type ClosedPeriodTransactionChangeUnsetValue = {
  isUnset: Scalars['Boolean']['output'];
};

export type ClosedPeriodTransactionChangeValue = ClosedPeriodTransactionChangeEntityValue | ClosedPeriodTransactionChangeTextValue | ClosedPeriodTransactionChangeTimestampValue | ClosedPeriodTransactionChangeUnsetValue;

export type ClosedPeriodTransactionChangeValueInput = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  unset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClosedWorkItem = {
  ignoredFields: Array<WorkItemPushFieldType>;
  workItemId: Scalars['String']['input'];
};

export type CollapsedSections = {
  sections: Array<Scalars['String']['output']>;
};

export type CollapsedSectionsInput = {
  sections: Array<Scalars['String']['input']>;
};

export type ColumnAssignmentInput = {
  field: CsvFieldType;
  headerName: Scalars['String']['input'];
};

/**
 * Comment represents a single thread comment, with additional
 * properties resolved by the backend.
 */
export type Comment = {
  authorId: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  layoutAttachment?: Maybe<LayoutAttachment>;
  reactions?: Maybe<Array<CommentReaction>>;
  text: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export enum CommentReaction {
  Dislike = 'Dislike',
  Like = 'Like',
  UnknownReaction = 'UnknownReaction'
}

export type CommentWithEntities = {
  comment: Comment;
  entities?: Maybe<ObjectEntities>;
};

export type CompanyDetails = {
  address?: Maybe<Address>;
  categories?: Maybe<Array<Scalars['String']['output']>>;
  companyName: Scalars['String']['output'];
  companySize?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  foreignSubsidiaryCount?: Maybe<Scalars['String']['output']>;
  incorporationState?: Maybe<Scalars['String']['output']>;
  incorporationYear?: Maybe<Scalars['String']['output']>;
  lastTaxFiling?: Maybe<Scalars['String']['output']>;
  subsidiaryCount?: Maybe<Scalars['String']['output']>;
  websiteURL?: Maybe<Scalars['String']['output']>;
};

export type CompanyDetailsInput = {
  address?: InputMaybe<AddressInput>;
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  companyName: Scalars['String']['input'];
  companySize?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  foreignSubsidiaryCount?: InputMaybe<Scalars['String']['input']>;
  incorporationState?: InputMaybe<Scalars['String']['input']>;
  incorporationYear?: InputMaybe<Scalars['String']['input']>;
  lastTaxFiling?: InputMaybe<Scalars['String']['input']>;
  subsidiaryCount?: InputMaybe<Scalars['String']['input']>;
  websiteURL?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyFinancialValue = {
  institutionId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type CompanyFinancialValueInput = {
  institutionId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CompanyFinancials = {
  product: InstitutionProduct;
  values: Array<CompanyFinancialValue>;
};

export type CompanyFinancialsInput = {
  product: InstitutionProduct;
  values: Array<CompanyFinancialValueInput>;
};

export enum ComparisonOperator {
  EqualTo = 'EqualTo',
  GreaterThan = 'GreaterThan',
  LessThan = 'LessThan',
  UnknownComparisonOperator = 'UnknownComparisonOperator'
}

export enum CompileSource {
  SpeedLayer = 'SpeedLayer',
  UnknownCompileSource = 'UnknownCompileSource',
  ViewGeneration = 'ViewGeneration',
  ViewGenerationIncomplete = 'ViewGenerationIncomplete'
}

export type ComponentData = CashSummary | Chart | DimensionSummary | EntitiesList | EntityHovers | InsightComponent | LocationSummary | Runway | SourceAccountMetric | Statement | TopEntities | TopTransactions;

/**
 * ComputedEvent represents batches of activity feed events
 * that are counted over a given interval
 */
export type ComputedEvent = {
  eventInterval: ActivityEventInterval;
  kind: ComputedEventKind;
  priority?: Maybe<Scalars['Float']['output']>;
  value: Scalars['Float']['output'];
};

export enum ComputedEventKind {
  AssetInsights = 'AssetInsights',
  ClassifiedCategory = 'ClassifiedCategory',
  ClassifiedCustomer = 'ClassifiedCustomer',
  ClassifiedSupplier = 'ClassifiedSupplier',
  ClassifiedVendor = 'ClassifiedVendor',
  EquityInsights = 'EquityInsights',
  ExpenseInsights = 'ExpenseInsights',
  LiabilityInsights = 'LiabilityInsights',
  MatchedTransactions = 'MatchedTransactions',
  NewRecurringTransactions = 'NewRecurringTransactions',
  NewTransactions = 'NewTransactions',
  NewVendors = 'NewVendors',
  PerformedCalculations = 'PerformedCalculations',
  RevenueInsights = 'RevenueInsights',
  UpdatedVendors = 'UpdatedVendors',
  VendorTransactions = 'VendorTransactions'
}

export type ConnectCredentialInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectInstitutionInput = {
  kind: InstitutionKind;
  name: Scalars['String']['input'];
};

export type Connection = {
  accounts?: Maybe<Array<ConnectionAccount>>;
  authorizationDescription?: Maybe<Scalars['String']['output']>;
  authorizationReason?: Maybe<Scalars['String']['output']>;
  authorizationRequired?: Maybe<Scalars['Boolean']['output']>;
  connector?: Maybe<Connector>;
  connectorClassName?: Maybe<Scalars['String']['output']>;
  connectorUpgrade?: Maybe<Connector>;
  dataSourceId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  scopes?: Maybe<Array<Scalars['String']['output']>>;
  settings?: Maybe<ConnectionSettings>;
  sourceIconURL?: Maybe<Scalars['String']['output']>;
  sourceName: Scalars['String']['output'];
  /** stripe, plaid */
  status: ConnectionStatus;
  sync?: Maybe<ConnectionSyncState>;
  upgradedFromConnectionId?: Maybe<Scalars['String']['output']>;
};

export type ConnectionAccount = {
  cardHolders?: Maybe<Array<CardHolder>>;
  connectionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mask?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<ConnectionAccountSettings>;
  sourceAccountId: Scalars['String']['output'];
  status: ConnectionAccountStatus;
  statusUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ConnectionAccountInput = {
  connectionAccountId: Scalars['String']['input'];
  settings: ConnectionAccountSettingsInput;
};

export type ConnectionAccountSettings = {
  cutoverDate?: Maybe<Scalars['DateTime']['output']>;
  labelCategories?: Maybe<Array<LabelCategory>>;
};

export type ConnectionAccountSettingsInput = {
  categoryLabels?: InputMaybe<Array<CategoryLabelInput>>;
  cutoverDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum ConnectionAccountStatus {
  Active = 'Active',
  Archived = 'Archived',
  Pending = 'Pending',
  Removed = 'Removed',
  UnknownAccountStatus = 'UnknownAccountStatus'
}

export type ConnectionAccountSummary = {
  cardHolders?: Maybe<Array<CardHolder>>;
  connectionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mask?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sourceAccountId: Scalars['String']['output'];
  status: ConnectionAccountStatus;
  statusUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ConnectionBadgeCountFilter = {
  authorizationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  connectionStatuses?: InputMaybe<Array<ConnectionStatus>>;
  legalEntityIds: Array<Scalars['String']['input']>;
  syncStatuses?: InputMaybe<Array<ConnectionSyncStatus>>;
};

export type ConnectionCategoryIntegrations = {
  connectionAccountSummaries: Array<ConnectionAccountSummary>;
  party?: Maybe<EntityParty>;
};

export type ConnectionSettings = {
  cutoverDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ConnectionSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ConnectionStatus {
  AccountsPending = 'AccountsPending',
  ActivationPending = 'ActivationPending',
  Archived = 'Archived',
  ConfigurationPending = 'ConfigurationPending',
  DelayedActivation = 'DelayedActivation',
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  Failed = 'Failed',
  SystemDisabled = 'SystemDisabled',
  Unknown = 'Unknown',
  Upgraded = 'Upgraded'
}

export type ConnectionSummary = {
  accounts?: Maybe<Array<ConnectionAccountSummary>>;
  authorizationDescription?: Maybe<Scalars['String']['output']>;
  authorizationReason?: Maybe<Scalars['String']['output']>;
  authorizationRequired?: Maybe<Scalars['Boolean']['output']>;
  connector?: Maybe<Connector>;
  connectorClassName?: Maybe<Scalars['String']['output']>;
  connectorUpgrade?: Maybe<Connector>;
  dataSourceId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  scopes?: Maybe<Array<Scalars['String']['output']>>;
  sourceIconURL?: Maybe<Scalars['String']['output']>;
  sourceName: Scalars['String']['output'];
  /** stripe, plaid */
  status: ConnectionStatus;
  sync?: Maybe<ConnectionSyncState>;
  upgradeAvailable?: Maybe<Scalars['Boolean']['output']>;
};

export type ConnectionSyncState = {
  dataLastModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  dataUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  lastEventAt?: Maybe<Scalars['DateTime']['output']>;
  lastSuccessAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ConnectionSyncStatus>;
};

export enum ConnectionSyncStatus {
  Configured = 'Configured',
  Delayed = 'Delayed',
  Failed = 'Failed',
  LoginRequired = 'LoginRequired',
  Success = 'Success'
}

export type ConnectionTemplate = {
  connector: Connector;
  externalId?: Maybe<Scalars['String']['output']>;
  institution: ProductInstitution;
};

export type Connector = {
  canInstall: Scalars['Boolean']['output'];
  category: ConnectorCategory;
  className?: Maybe<Scalars['String']['output']>;
  connectorProperties?: Maybe<ConnectorProperties>;
  description?: Maybe<Scalars['String']['output']>;
  iconObjectName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tagline?: Maybe<Scalars['String']['output']>;
};

export enum ConnectorCategory {
  BanksAndCards = 'BanksAndCards',
  CategoryUnspecified = 'CategoryUnspecified',
  Ecommerce = 'Ecommerce',
  ExpenseManagement = 'ExpenseManagement',
  Payment = 'Payment',
  Payroll = 'Payroll',
  Reporting = 'Reporting'
}

export type ConnectorInstallCandidates = {
  appConnectors: Array<Connector>;
  templates: Array<ConnectionTemplate>;
};

export type ConnectorProperties = AppConnectorProperties | BillConnectorProperties | EmptyConnectorProperties | FinchConnectorProperties | GustoConnectorProperties | PlaidConnectorProperties | RampConnectorProperties | StripeConnectorProperties;

export enum ConnectorVisibility {
  Approved = 'Approved',
  Internal = 'Internal',
  Published = 'Published',
  UnknownVisibility = 'UnknownVisibility'
}

export type Contact = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
};

export type ContactInput = {
  emailAddress: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
};

export type ContractLineItemInput = {
  amount: InputMonetaryValue;
  recurrence: ProductRecurrence;
  stripeProductId: Scalars['String']['input'];
};

export type Coupon = {
  amountOff?: Maybe<MonetaryValue>;
  duration: CouponDuration;
  durationInMonths: Scalars['Long']['output'];
  end?: Maybe<Scalars['DateTime']['output']>;
  percentOff?: Maybe<Scalars['Float']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  stripePromoCodeId: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

export enum CouponDuration {
  Forever = 'Forever',
  Once = 'Once',
  Repeating = 'Repeating',
  UnknownDuration = 'UnknownDuration'
}

export enum CoverLogoSource {
  AccountingFirm = 'AccountingFirm',
  Client = 'Client'
}

export type CreateBulkCategoryInput = {
  active: Scalars['Boolean']['input'];
  chartOfAccountsDisplayNumber: Scalars['String']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentCategoryName: Scalars['String']['input'];
  parentCategoryNumber?: InputMaybe<Scalars['String']['input']>;
  subtype: CategorySubtype;
  type: CategoryType;
};

export type CreateCategoryInput = {
  chartOfAccountsDisplayNumber: Scalars['String']['input'];
  description: Scalars['String']['input'];
  displayKey: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentCategoryId: Scalars['String']['input'];
  subtype: CategorySubtype;
  type: CategoryType;
};

export type CreateCategoryResponse = {
  categoryId: Scalars['String']['output'];
};

export type CreateClientPaysBillingSubscription = {
  customerId: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  stripeClientSecret: Scalars['String']['output'];
};

export type CreateConnectionResponse = {
  connection: Connection;
};

export type CreateDepartmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayKey?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDepartmentResponse = {
  departmentId: Scalars['String']['output'];
};

export type CreateLocationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayKey?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLocationResponse = {
  locationId: Scalars['String']['output'];
};

export type CreateManyTransactionsResponse = {
  createdTransactions: Array<CreateTransactionResponse>;
};

export type CreateNewTransactionFlagDetails = {
  statementLineItem: StatementLineItem;
};

export type CreateReconciliationFlagsTransactionsInput = {
  flagId: Scalars['String']['input'];
  statementLineItem: StatementLineItemInput;
};

export type CreateReconciliationIntentResponse = {
  reconciliationIntentId: Scalars['String']['output'];
  state: ReconciliationIntentState;
};

export type CreateReconciliationIntentsResponse = {
  createReconciliationIntentResponses: Array<CreateReconciliationIntentResponse>;
};

export type CreateTransactionResponse = {
  ledgerTransactionId?: Maybe<Scalars['String']['output']>;
  transactionFactIds: Array<Scalars['String']['output']>;
};

export type CreatedLegalEntity = {
  legalEntity?: Maybe<LegalEntity>;
  quickBooksCompany?: Maybe<QuickBooksCompany>;
};

export type CreatedQuickBooksDataSource = {
  dataSource?: Maybe<EnrichedDataSource>;
  quickBooksCompany?: Maybe<QuickBooksCompany>;
};

export enum CreationMethod {
  Auto = 'Auto',
  Manual = 'Manual',
  Unknown = 'Unknown',
  Validation = 'Validation'
}

export type CreditCard = {
  cardBrand: Scalars['String']['output'];
  cardLastFour: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  nickname: Scalars['String']['output'];
};

export type CsvExportField = {
  fieldName: CsvExportFieldName;
  label?: InputMaybe<Scalars['String']['input']>;
};

export enum CsvExportFieldName {
  CategoryName = 'CategoryName',
  CategoryNumber = 'CategoryNumber',
  DepartmentName = 'DepartmentName',
  LocationName = 'LocationName',
  Memo = 'Memo',
  Party1099Status = 'Party1099Status',
  PartyEntityType = 'PartyEntityType',
  PartyName = 'PartyName',
  PartyW9Status = 'PartyW9Status',
  SplitCategoryName = 'SplitCategoryName',
  SplitCategoryNumber = 'SplitCategoryNumber',
  TaxStatus = 'TaxStatus',
  TransactionAmount = 'TransactionAmount',
  TransactionCreditAmount = 'TransactionCreditAmount',
  TransactionDate = 'TransactionDate',
  TransactionDebitAmount = 'TransactionDebitAmount'
}

export type CsvImport = {
  createdAt: Scalars['DateTime']['output'];
  csvImportId: Scalars['String']['output'];
  dataSourceId: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fileName: Scalars['String']['output'];
  source: Scalars['String']['output'];
  transactionCount: Scalars['Long']['output'];
};

export type CsvImportSort = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<CsvImportSortOrderBy>;
};

export enum CsvImportSortOrderBy {
  CreatedAt = 'CreatedAt',
  FileName = 'FileName',
  TransactionCount = 'TransactionCount'
}

export type Customer = {
  address?: Maybe<CustomerAddress>;
  email: Scalars['String']['output'];
  finalized?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  providerType: ProviderType;
};

export type CustomerAddress = {
  address?: Maybe<Address>;
  id: Scalars['String']['output'];
};

/** Customer Events (Logs) */
export type CustomerEvent = {
  eventId: Scalars['String']['input'];
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  occurredAt: Scalars['DateTime']['input'];
  payload: CustomerEventPayload;
};

export type CustomerEventPayload = {
  marketingEvent?: InputMaybe<MarketingEvent>;
  pageView?: InputMaybe<PageView>;
  reportAction?: InputMaybe<ReportActionEvent>;
  signUpEvent?: InputMaybe<SignUpEvent>;
};

export type CustomerSummary = {
  email: Scalars['String']['output'];
  finalized?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DataSource = {
  accountAlias?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  institution: Institution;
  legalEntityId: Scalars['String']['output'];
  providerType: ProviderType;
  status: DataSourceStatus;
  statusReason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DataSourceManualRefresh = {
  dataSourceId: Scalars['String']['output'];
  earliestViewVersion?: Maybe<Scalars['String']['output']>;
  errors: Array<DataSourceManualRefreshError>;
  requestedAt: Scalars['DateTime']['output'];
  syncCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  viewFinishedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DataSourceManualRefreshError = {
  erroredAt: Scalars['DateTime']['output'];
};

export type DataSourcePreference = {
  accountingBasis: AccountingBasis;
  dataSourceId: Scalars['String']['output'];
  departmentTerminology?: Maybe<Scalars['String']['output']>;
  providerType: ProviderType;
  taxForm: TaxForm;
};

export enum DataSourceStatus {
  Archived = 'Archived',
  Deleted = 'Deleted',
  EngineeringRequired = 'EngineeringRequired',
  Linked = 'Linked',
  LogInRequired = 'LogInRequired',
  Unknown = 'Unknown',
  Unsupported = 'Unsupported'
}

export type DataSources = {
  legalEntityId: Scalars['String']['output'];
  sources: Array<EnrichedDataSource>;
};

export type Date = {
  day: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type DateClosedPeriodRequestAffectedCountResult = {
  affectedCount: Scalars['Int']['output'];
};

export type DateFeatureValue = {
  dateValue: Date;
};

export type DateInput = {
  day?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** DayOfMonth */
export enum DayOfMonth {
  Fifteenth = 'Fifteenth',
  First = 'First',
  Last = 'Last'
}

/** DayOfWeek */
export enum DayOfWeek {
  Friday = 'Friday',
  Monday = 'Monday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type DeletePotentialDuplicateFlagTransactionsInput = {
  deleteUnsettled: Scalars['Boolean']['input'];
  documentFeatureGroupId: Scalars['String']['input'];
  flagId: Scalars['String']['input'];
  reconciledLedgerTransactionId: Scalars['String']['input'];
  unsettledLedgerTransactionId: Scalars['String']['input'];
};

export type DeletedAmountFilter = {
  amountRuleFilterId: Scalars['String']['input'];
  operator: ComparisonOperator;
};

export type DeletedCategory = {
  categoryId: Scalars['String']['input'];
  operation: Operation;
};

export type DeletedCategoryFilter = {
  categoryRuleFilterId: Scalars['String']['input'];
  operation: Operation;
};

export type Delivery = {
  deliveryMethod?: Maybe<DeliveryMethod>;
  destinationInstrument?: Maybe<PayoutInstrument>;
  estimatedDelivery?: Maybe<Scalars['DateTime']['output']>;
  milestones: Array<DeliveryMilestone>;
  sourceInstrument?: Maybe<PaymentInstrument>;
};

export enum DeliveryMethod {
  ACH = 'ACH',
  Check = 'Check',
  UnknownDeliveryMethod = 'UnknownDeliveryMethod'
}

export type DeliveryMilestone = {
  date?: Maybe<Scalars['DateTime']['output']>;
  status: DeliveryStatus;
};

export enum DeliveryStatus {
  Delivered = 'Delivered',
  EstimatedDelivery = 'EstimatedDelivery',
  PaymentReturned = 'PaymentReturned',
  PayoutReturned = 'PayoutReturned',
  Processed = 'Processed',
  Rescheduled = 'Rescheduled',
  Scheduled = 'Scheduled',
  Sent = 'Sent',
  UnknownDeliveryStatus = 'UnknownDeliveryStatus'
}

export type DenormalizedViewStatus = {
  activeViewCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  legalEntityId: Scalars['String']['output'];
  ongoingViewStartedAt?: Maybe<Scalars['DateTime']['output']>;
  viewType: ViewType;
};

export type DenormalizedViewStatusSummary = {
  entries: Array<DenormalizedViewStatus>;
};

export type Department = {
  active: Scalars['Boolean']['output'];
  ancestors: Array<EntityDepartment>;
  dataSource?: Maybe<EntityDataSource>;
  /** @deprecated Use data source instead */
  dataSourceId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  matches: Array<MatchedDepartment>;
  name: Scalars['String']['output'];
  /** @deprecated Use parentId instead */
  parentDepartmentId?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
};

export type DepartmentChartConfig = {
  departmentId: Scalars['String']['output'];
  origin: ArchiveIntervalOrigin;
};

export type DepartmentChartConfigInput = {
  departmentId: Scalars['String']['input'];
  origin: IntervalOrigin;
};

export type DepartmentDimension = {
  by: DimensionSummary;
  departmentId: Scalars['String']['output'];
  departmentObject: EntityDepartment;
  summary: TransactionSummary;
};

export type DepartmentFacet = {
  count: Scalars['Int']['output'];
  departmentObject: EntityDepartment;
};

export type DepartmentOption = {
  departmentId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DepartmentOptionInput = {
  departmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum DepartmentStatus {
  Active = 'Active',
  Disabled = 'Disabled',
  Unknown = 'Unknown'
}

export type DigitsWorkItemPushParams = {
  categoryParams?: InputMaybe<CategoryParams>;
  partyParams?: InputMaybe<PartyParams>;
  skipClose?: InputMaybe<Scalars['Boolean']['input']>;
  workItemId: Scalars['String']['input'];
};

export type DimensionFacetField = {
  kind: DimensionFacetKind;
  type: FacetType;
};

export enum DimensionFacetKind {
  UnknownDimensionKind = 'UnknownDimensionKind'
}

export type DimensionPaginationInput = {
  page: Pagination;
  sortBy: DimensionalSortBy;
  sortDirection: SortDirection;
};

export enum DimensionSortMode {
  Active = 'Active',
  Growing = 'Growing',
  Shrinking = 'Shrinking',
  Total = 'Total'
}

export type DimensionSummary = {
  aggregateFacetCount?: Maybe<Scalars['Int']['output']>;
  aging: Array<AgingDimension>;
  category: Array<CategoryDimension>;
  categoryType: Array<CategoryTypeDimension>;
  department: Array<DepartmentDimension>;
  location: Array<LocationDimension>;
  partialData: Scalars['Boolean']['output'];
  party: Array<PartyDimension>;
  product: Array<ProductDimension>;
  schedule: Array<ScheduleDimension>;
  /**
   * Summary implements dimensionless top-level summaries.
   * All other summaries are in the dimension fields above.
   */
  summary: TransactionSummary;
  /**
   * Each below Dimension field allows queries to organize their output
   * by specifying each field in the structural order desired.
   */
  time: Array<TimeDimension>;
};


export type DimensionSummaryAgingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
};


export type DimensionSummaryCategoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
};


export type DimensionSummaryCategoryTypeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
};


export type DimensionSummaryDepartmentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
};


export type DimensionSummaryLocationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
};


export type DimensionSummaryPartyArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
};


export type DimensionSummaryProductArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
};


export type DimensionSummaryScheduleArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
};


export type DimensionSummaryTimeArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
};

export enum DimensionalSortBy {
  Amount = 'Amount',
  Count = 'Count',
  Name = 'Name'
}

export enum DirectionFromOrigin {
  Future = 'Future',
  Past = 'Past'
}

export type Discount = {
  categoryId?: Maybe<Scalars['String']['output']>;
  discountId: Scalars['String']['output'];
  fixedDiscountAmount?: Maybe<MonetaryValue>;
  name: Scalars['String']['output'];
  providerType: ProviderType;
  variablePercentage?: Maybe<Scalars['Float']['output']>;
};

export enum DiscountLevel {
  LineItem = 'LineItem',
  Subscription = 'Subscription',
  UnknownDiscountLevel = 'UnknownDiscountLevel'
}

/**
 * DiscreteEvent represents one-time activity feed events
 * that are created via our go-services APIs
 */
export type DiscreteEvent = {
  actorUserId?: Maybe<Scalars['String']['output']>;
  kind: DiscreteEventKind;
  subject: ActivityObjectIdentifier;
  target: ActivityObjectIdentifier;
  targetEmailAddress?: Maybe<Scalars['String']['output']>;
};

export enum DiscreteEventKind {
  CreatedGrant = 'CreatedGrant',
  CreatedIntent = 'CreatedIntent',
  /**
   * DisabledLink
   * RejectedRequest
   */
  CreatedReportPackage = 'CreatedReportPackage',
  /** RegeneratedReportPackage */
  DeletedReportPackage = 'DeletedReportPackage',
  IntegrationFixed = 'IntegrationFixed',
  NewComment = 'NewComment',
  NewIntegration = 'NewIntegration',
  NewReport = 'NewReport',
  NewUser = 'NewUser',
  /**
   * CreatedReport
   * ViewedReport
   * UpdatedReport
   * RegeneratedReport
   */
  PublishedDraftReportPackage = 'PublishedDraftReportPackage',
  PublishedFinalReportPackage = 'PublishedFinalReportPackage',
  /**
   * FixedIntegration
   * CreatedIntegration
   * CreatedUser
   * CreatedThread
   * CreatedComment
   */
  ResolvedThread = 'ResolvedThread',
  RevokedGrant = 'RevokedGrant',
  /**
   * UpdatedLink
   * AcceptedRequest
   */
  RevokedIntent = 'RevokedIntent',
  UpdatedGrant = 'UpdatedGrant',
  /**
   * CreatedLink
   * CreatedRequest
   */
  UpdatedIntent = 'UpdatedIntent',
  UpdatedReportPackage = 'UpdatedReportPackage',
  VendorEdited = 'VendorEdited',
  ViewedReportPackage = 'ViewedReportPackage'
}

export enum DisplayEntry {
  Credit = 'Credit',
  Debit = 'Debit',
  TransferCredit = 'TransferCredit',
  TransferDebit = 'TransferDebit',
  Unknown = 'Unknown'
}

export type DocumentCollectionConfig = {
  collectionId: Scalars['String']['output'];
};

export type DocumentCollectionConfigInput = {
  collectionId: Scalars['String']['input'];
};

export type DocumentDownload = {
  url: Scalars['String']['output'];
};

export type DocumentDownloadUrls = {
  urls: Array<Scalars['String']['output']>;
};

export type DocumentFilter = {
  creatorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dataSourceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  documentCollectionId?: InputMaybe<Scalars['String']['input']>;
  documentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  documentTypes?: InputMaybe<Array<DocumentType>>;
  featureKinds?: InputMaybe<Array<FeatureKind>>;
  mimeTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DocumentIdentifier = {
  collectionId: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
};

export type DocumentInfo = {
  creator?: Maybe<EntityUser>;
  dataSource?: Maybe<EntityDataSource>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DocumentInitialSegment = {
  collectionId: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
};

export type DocumentLineItem = {
  amount: MonetaryValue;
  categoryId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  position: Scalars['Long']['output'];
  quantity: Scalars['Long']['output'];
  quantityMultiplier?: Maybe<Scalars['Long']['output']>;
  rate: MonetaryValue;
};

export type DocumentSort = {
  direction?: InputMaybe<SortDirection>;
  field: DocumentSortBy;
};

export enum DocumentSortBy {
  CreatedAt = 'CreatedAt',
  DocumentType = 'DocumentType',
  FileName = 'FileName',
  FileSize = 'FileSize',
  Title = 'Title'
}

export enum DocumentStatus {
  Done = 'Done',
  New = 'New',
  Processing = 'Processing',
  UnknownStatus = 'UnknownStatus'
}

export type DocumentTransactionFeatures = {
  documentId: Scalars['String']['output'];
  transactionFeatures: Array<TransactionFeatureMapping>;
};

export enum DocumentType {
  AccountsPayableAging = 'AccountsPayableAging',
  AccountsReceivableAging = 'AccountsReceivableAging',
  AdyenStatement = 'AdyenStatement',
  BalanceSheet = 'BalanceSheet',
  Bill = 'Bill',
  CashFlowStatement = 'CashFlowStatement',
  Check = 'Check',
  Compliance = 'Compliance',
  Contract = 'Contract',
  Equity = 'Equity',
  Form1099 = 'Form1099',
  FormW9 = 'FormW9',
  GeneralLedger = 'GeneralLedger',
  Invoice = 'Invoice',
  K1 = 'K1',
  LoanAgreement = 'LoanAgreement',
  Payroll = 'Payroll',
  ProfitAndLoss = 'ProfitAndLoss',
  Receipt = 'Receipt',
  Schedule = 'Schedule',
  Statement = 'Statement',
  TaxID = 'TaxID',
  TaxReturn = 'TaxReturn',
  TrialBalance = 'TrialBalance',
  UnknownType = 'UnknownType',
  Valuation = 'Valuation'
}

export type DocumentsSummary = {
  count: Scalars['Long']['output'];
};

export type DoppelgangerPermit = {
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  user: User;
};

export type DoubleEntry = {
  firstEntryCategoryId: Scalars['String']['input'];
  secondEntryCategoryId: Scalars['String']['input'];
  withoutFirstEntryAncestors?: InputMaybe<Scalars['Boolean']['input']>;
  withoutSecondEntryAncestors?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DraftInvoice = {
  branding: InvoiceBranding;
  customer?: Maybe<Customer>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoicingProfile?: Maybe<InvoicingProfile>;
  lineItems?: Maybe<Array<DraftInvoiceLineItem>>;
  memo?: Maybe<Scalars['String']['output']>;
  status: InvoiceStatus;
  subtotal?: Maybe<MonetaryValue>;
  taxPercent?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<MonetaryValue>;
  totalTax?: Maybe<MonetaryValue>;
  validationErrors?: Maybe<Array<DraftInvoiceValidationError>>;
};

export type DraftInvoiceLineItem = {
  description?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Long']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  quantityValue?: Maybe<QuantityValue>;
  taxable: Scalars['Boolean']['output'];
  unitPrice: MonetaryValue;
};

export type DraftInvoiceSummary = InvoiceSummaryInterface & {
  amount: EntityMonetaryValue;
  createdAt: Scalars['DateTime']['output'];
  customer: CustomerSummary;
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  status: InvoiceStatus;
  statusAt: Scalars['DateTime']['output'];
};

export enum DraftInvoiceValidationError {
  DuplicateInvoiceNumber = 'DuplicateInvoiceNumber',
  InvoiceNumberMissingDigit = 'InvoiceNumberMissingDigit',
  InvoiceNumberTooLong = 'InvoiceNumberTooLong',
  InvoiceNumberTooShort = 'InvoiceNumberTooShort',
  InvoiceNumberWhitespace = 'InvoiceNumberWhitespace',
  Unknown = 'Unknown'
}

/**
 * Result of draftQualityCheckInstruction: either the drafted instruction or a
 * guardrail block. A block is an expected outcome (the instruction abandons its
 * base check's purpose), surfaced as data rather than a mutation error so the
 * reasons reach the author. Switch on __typename.
 */
export type DraftQualityCheckInstructionResult = QualityCheckInstruction | QualityCheckInstructionBlocked;

export type DuplicateBill = {
  billId: Scalars['String']['output'];
};

export type EmailStatus = {
  rawStatus: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Employee = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  defaultEntityRole?: Maybe<Role>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  hiddenAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  invitation?: Maybe<Invitation>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  legalEntityRoles?: Maybe<Array<EmployeeLegalEntityRole>>;
  organizationId: Scalars['String']['output'];
  role?: Maybe<Role>;
  status: EmployeeStatus;
  user?: Maybe<User>;
};

export type EmployeeAffiliations = {
  affiliations: Array<Affiliation>;
  employee: Employee;
};

export type EmployeeFilter = {
  employeeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<EmployeeStatus>>;
  visibility?: InputMaybe<EmployeeVisibility>;
};

export type EmployeeIdentifier = {
  employeeId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type EmployeeLegalEntityRole = {
  legalEntityId: Scalars['String']['output'];
  role?: Maybe<Role>;
};

export enum EmployeeOrigin {
  Bootstrapped = 'Bootstrapped',
  External = 'External',
  Invitation = 'Invitation',
  Manual = 'Manual',
  Synthesized = 'Synthesized',
  UnknownOrigin = 'UnknownOrigin'
}

export type EmployeeSort = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<EmployeeSortOrderBy>;
};

export enum EmployeeSortOrderBy {
  Name = 'Name',
  Status = 'Status'
}

export enum EmployeeStatus {
  Activated = 'Activated',
  Deactivated = 'Deactivated',
  Initialized = 'Initialized',
  UnknownStatus = 'UnknownStatus'
}

export enum EmployeeVisibility {
  Active = 'Active',
  All = 'All',
  Hidden = 'Hidden'
}

export type EmptyConnectorProperties = {
  empty?: Maybe<Scalars['Boolean']['output']>;
};

export type EnqueueStatementImportWorkflowsInput = {
  documents: Array<StatementImportDocumentInput>;
  legalEntityId: Scalars['String']['input'];
  /** Forwarded to every fanned-out workflow. */
  skipSpeed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnqueueStatementImportWorkflowsPayload = {
  /** One workflow id per enqueued document, in request order. */
  workflowIds: Array<Scalars['String']['output']>;
};

export type EnrichedDataSource = {
  accountAlias?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  hasTransactions: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  institution: Party;
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  legalEntityId: Scalars['String']['output'];
  plaidConfig?: Maybe<PlaidConfig>;
  providerType: ProviderType;
  quickBooksConfig?: Maybe<QuickBooksConfig>;
  sourceAccounts?: Maybe<Array<SourceAccount>>;
  status: DataSourceStatus;
  statusReason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type EntitiesList = {
  entities: ObjectEntities;
};

export type EntitiesListConfig = {
  entities: ObjectEntities;
  origin: ArchiveIntervalOrigin;
};

export type EntityBill = {
  approvalAccess?: Maybe<BillAccess>;
  billDescription: Scalars['String']['output'];
  billStatus: BillStatus;
  dueDate?: Maybe<Date>;
  format: Format;
  id: Scalars['String']['output'];
  totalAmount: EntityMonetaryValue;
  vendorName: Scalars['String']['output'];
};

export type EntityCategory = {
  active: Scalars['Boolean']['output'];
  chartOfAccountsDisplayNumber?: Maybe<Scalars['String']['output']>;
  displayKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentCategoryId?: Maybe<Scalars['String']['output']>;
  productArea?: Maybe<ProductArea>;
  subtype: CategorySubtype;
  type: CategoryType;
};

/** Comments */
export type EntityComment = {
  authorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type EntityConnection = {
  connectorId: Scalars['String']['output'];
  dataSourceId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type EntityDataSource = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type EntityDepartment = {
  active: Scalars['Boolean']['output'];
  displayKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** @deprecated Use parentId */
  parentDepartmentId?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
};

/** Employees */
export type EntityEmployee = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type EntityHovers = {
  hovers: Array<Hover>;
};

export type EntityIdentityVerification = {
  legalEntityId: Scalars['String']['output'];
  status: IdentityVerificationStatus;
};

export type EntityInstitution = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Invoices */
export type EntityInvoice = {
  amount: EntityMonetaryValue;
  createdAt: Scalars['DateTime']['output'];
  customer: EntityInvoiceCustomer;
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  externalDisplayId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type EntityInvoiceCustomer = {
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  party: EntityParty;
  phone?: Maybe<Scalars['String']['output']>;
};

export type EntityLedgerTransaction = {
  factIds?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parties: Array<EntityParty>;
  referenceNumber: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  totalAmount: EntityMonetaryValue;
};

export type EntityLegalEntity = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type EntityLocation = {
  active: Scalars['Boolean']['output'];
  displayKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
};

export type EntityMonetaryValue = {
  amount: Scalars['Long']['output'];
  currencyMultiplier: Scalars['Long']['output'];
  iso4217CurrencyCode: Scalars['String']['output'];
};

export type EntityOrganization = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

/** Parties */
export type EntityParty = {
  designation: PartyDesignation;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  roles?: Maybe<Array<PartyRole>>;
  shortDescription?: Maybe<Scalars['String']['output']>;
};

export type EntityProduct = {
  dataSourceId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productId: Scalars['String']['output'];
};

export type EntityReconciliation = {
  categoryId: Scalars['String']['output'];
  endDate: Date;
  id: Scalars['String']['output'];
  reconciliationStatus: AccountReconciliationStatus;
  startDate: Date;
};

/** Reports */
export type EntityReport = {
  authorId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  reportFor: Date;
  title: Scalars['String']['output'];
};

export type EntityReportPackage = {
  authorId: Scalars['String']['output'];
  coverUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  documents: Array<SharedReportDocumentMetadata>;
  id: Scalars['String']['output'];
  interval: Interval;
  periodEndedAt: Scalars['DateTime']['output'];
  periodStartedAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EntitySchedule = {
  amount?: Maybe<MonetaryValue>;
  categoryId: Scalars['String']['output'];
  cutoverAmount?: Maybe<MonetaryValue>;
  cutoverDate?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partyId?: Maybe<Scalars['String']['output']>;
  relatedCategoryId?: Maybe<Scalars['String']['output']>;
  scheduleNumber: Scalars['String']['output'];
  scheduleTemplateId: Scalars['String']['output'];
  scheduleType: ScheduleType;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated No longer used */
  status?: Maybe<ScheduleStatus>;
};

export type EntityThread = {
  id: Scalars['String']['output'];
  resolvedAt: Scalars['DateTime']['output'];
};

/**
 * ObjectEntities
 * Note: some definitions exist in shared/common/
 * Transactions
 */
export type EntityTransaction = {
  description?: Maybe<Scalars['String']['output']>;
  displayCategory: EntityCategory;
  displayEntry: DisplayEntry;
  /** @deprecated Use moneyFlow */
  displayValue?: Maybe<EntityMonetaryValue>;
  externalId?: Maybe<Scalars['String']['output']>;
  factId?: Maybe<Scalars['String']['output']>;
  moneyFlow: MoneyFlow;
  name?: Maybe<Scalars['String']['output']>;
  party?: Maybe<EntityParty>;
  splitCategory?: Maybe<EntityCategory>;
  timestamp: Scalars['DateTime']['output'];
  viewId: Scalars['String']['output'];
};

export type EntityUser = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** Work Items */
export type EntityWorkItem = {
  id: Scalars['String']['output'];
  ledgerType: LedgerType;
  objectTransaction: EntityTransaction;
  reviewCreatedById: Scalars['String']['output'];
  reviewState?: Maybe<WorkItemReviewState>;
  time: Scalars['DateTime']['output'];
  workItemState: WorkItemState;
  workItemType: WorkItemType;
};

export enum EntryType {
  Credit = 'Credit',
  Debit = 'Debit',
  Unknown = 'Unknown'
}

export enum EventType {
  /** Invitations */
  AffiliateLegalEntityInvitation = 'AffiliateLegalEntityInvitation',
  AffiliationsCreated = 'AffiliationsCreated',
  AffiliationsInvitationCreated = 'AffiliationsInvitationCreated',
  ApplicationApproved = 'ApplicationApproved',
  ApplicationSubmitted = 'ApplicationSubmitted',
  /** Signups */
  ApplicationSubmittedByInvitee = 'ApplicationSubmittedByInvitee',
  AutoDepositSet = 'AutoDepositSet',
  /** Bills */
  BillAssigned = 'BillAssigned',
  BillAssignedReminder = 'BillAssignedReminder',
  BillError = 'BillError',
  BillMention = 'BillMention',
  BillPaymentCreated = 'BillPaymentCreated',
  BillPaymentCreatedAch = 'BillPaymentCreatedAch',
  BillPaymentCreatedAutoDepositBankAccount = 'BillPaymentCreatedAutoDepositBankAccount',
  BillPaymentCreatedAutoDepositCheck = 'BillPaymentCreatedAutoDepositCheck',
  BillPaymentCreatedCheck = 'BillPaymentCreatedCheck',
  BillPaymentCreatedDigitsPay = 'BillPaymentCreatedDigitsPay',
  BillPaymentError = 'BillPaymentError',
  BillRejected = 'BillRejected',
  BoostSummary = 'BoostSummary',
  BusinessVerificationApproved = 'BusinessVerificationApproved',
  BusinessVerificationExpiring = 'BusinessVerificationExpiring',
  /** Business Verification */
  BusinessVerificationPending = 'BusinessVerificationPending',
  CashBalanceAlert = 'CashBalanceAlert',
  ConfirmEmail = 'ConfirmEmail',
  ConfirmPasswordReset = 'ConfirmPasswordReset',
  /** Password Management */
  CreatePasswordReset = 'CreatePasswordReset',
  DirectPayoutCreatedBankAccount = 'DirectPayoutCreatedBankAccount',
  DirectPayoutCreatedCheck = 'DirectPayoutCreatedCheck',
  /** Documents */
  DocumentUpload = 'DocumentUpload',
  InitialInvitation = 'InitialInvitation',
  InstructionsAffiliateInvitation = 'InstructionsAffiliateInvitation',
  InstructionsInvitation = 'InstructionsInvitation',
  InvoicePaid = 'InvoicePaid',
  InvoicePaidSender = 'InvoicePaidSender',
  InvoicePaymentFailed = 'InvoicePaymentFailed',
  InvoicePaymentFailedSender = 'InvoicePaymentFailedSender',
  InvoiceResent = 'InvoiceResent',
  /** Invoices */
  InvoiceSent = 'InvoiceSent',
  LedgerBillPayoutError = 'LedgerBillPayoutError',
  LedgerTransactionComment = 'LedgerTransactionComment',
  LedgerTransactionMention = 'LedgerTransactionMention',
  ObjectAccessAccepted = 'ObjectAccessAccepted',
  ObjectAccessApproved = 'ObjectAccessApproved',
  ObjectAccessRequested = 'ObjectAccessRequested',
  ObjectBulkComment = 'ObjectBulkComment',
  ObjectComment = 'ObjectComment',
  /** Sharing */
  ObjectGrantCreated = 'ObjectGrantCreated',
  ObjectMention = 'ObjectMention',
  PaymentMethodSet = 'PaymentMethodSet',
  PlanInvitation = 'PlanInvitation',
  ReportComment = 'ReportComment',
  ReportCommentThreadResolved = 'ReportCommentThreadResolved',
  ReportMention = 'ReportMention',
  ReportPackageViewed = 'ReportPackageViewed',
  ReportPublished = 'ReportPublished',
  ReportsCreated = 'ReportsCreated',
  SystemReportCreated = 'SystemReportCreated',
  TransactionMention = 'TransactionMention',
  TransactionQuestionsAsked = 'TransactionQuestionsAsked',
  TransactionQuestionsReminder = 'TransactionQuestionsReminder',
  UnclaimedBill = 'UnclaimedBill',
  UnclaimedBillReminder = 'UnclaimedBillReminder',
  UnclaimedLedgerBill = 'UnclaimedLedgerBill',
  UnknownEvent = 'UnknownEvent',
  UserInvitation = 'UserInvitation',
  UserLockedOut = 'UserLockedOut',
  WorkItemComment = 'WorkItemComment'
}

export type ExistingReportAttachment = {
  position: Scalars['Int']['input'];
  reportId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};

/** Facet output types */
export type Facet = {
  aggregate: Scalars['Int']['output'];
  department: Array<DepartmentFacet>;
  institution: Array<InstitutionFacet>;
  location: Array<LocationFacet>;
  matchedStatus: Array<MatchedStatusFacet>;
  party: Array<PartyFacet>;
  /**
   * Each field below allows queries to organize their output
   * by specifying which facet is being requested.
   */
  user: Array<UserFacet>;
};

export type FacetFilter = {
  facetFilterTerm?: InputMaybe<Scalars['String']['input']>;
  transactionFilter: TransactionFilter;
};

export enum FacetType {
  AggregateCount = 'AggregateCount',
  CountPerValue = 'CountPerValue',
  UnknownFacetType = 'UnknownFacetType'
}

export type Feature = {
  featurePage: Scalars['Long']['output'];
  /**
   * Restored after #3327 removed it: stale iOS and web clients still in
   * the wild select this field. Server populates it from `groups`,
   * picking the LineItem-kind group for line-item features and the first
   * group otherwise. New code should use `groups` and filter by kind;
   * this field will be removed again once the long-tail clients migrate.
   * @deprecated Use `groups` and filter by kind.
   */
  group?: Maybe<FeatureGroup>;
  /**
   * A feature may be a member of more than one group (e.g. LineItem +
   * AccountGroup on multi-account bank statements). Readers iterate
   * `groups` and filter by kind.
   */
  groups?: Maybe<Array<FeatureGroup>>;
  height: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  invalid: Scalars['Boolean']['output'];
  kind: FeatureKind;
  originX: Scalars['Float']['output'];
  originY: Scalars['Float']['output'];
  value: FeatureValue;
  width: Scalars['Float']['output'];
};

export type FeatureGroup = {
  featureGroupId: Scalars['String']['output'];
  kind: FeatureKind;
  position: Scalars['Long']['output'];
};

export enum FeatureKind {
  AccountExternalId = 'AccountExternalId',
  /**
   * feature-group kinds used when a feature is a member of a grouping
   * (e.g. per-account groups on multi-account bank statements)
   */
  AccountGroup = 'AccountGroup',
  AccountName = 'AccountName',
  AccountNumber = 'AccountNumber',
  AccountType = 'AccountType',
  AmountDue = 'AmountDue',
  BankAddress = 'BankAddress',
  BankStatementLineItem = 'BankStatementLineItem',
  BillCategory = 'BillCategory',
  BusinessAddress = 'BusinessAddress',
  /** W9 feature kinds */
  BusinessName = 'BusinessName',
  CheckInfo = 'CheckInfo',
  /** check feature kinds */
  CheckNumber = 'CheckNumber',
  CheckPayee = 'CheckPayee',
  DocumentCustomer = 'DocumentCustomer',
  DocumentDate = 'DocumentDate',
  DocumentKeyword = 'DocumentKeyword',
  DocumentParty = 'DocumentParty',
  /** generic document feature kinds */
  DocumentRawText = 'DocumentRawText',
  DocumentReference = 'DocumentReference',
  DocumentSummary = 'DocumentSummary',
  DocumentType = 'DocumentType',
  DocumentVendor = 'DocumentVendor',
  DueDate = 'DueDate',
  EndingBalance = 'EndingBalance',
  EndingDate = 'EndingDate',
  Iban = 'Iban',
  InstitutionAccountNumber = 'InstitutionAccountNumber',
  /** bank statement feature kinds */
  InstitutionName = 'InstitutionName',
  InvoiceDate = 'InvoiceDate',
  InvoiceId = 'InvoiceId',
  LineItem = 'LineItem',
  LineItemAmount = 'LineItemAmount',
  LineItemDate = 'LineItemDate',
  LineItemDescription = 'LineItemDescription',
  Memo = 'Memo',
  Other = 'Other',
  OtherPaymentInfo = 'OtherPaymentInfo',
  PayerAddress = 'PayerAddress',
  PayerCompanyName = 'PayerCompanyName',
  PayerEmail = 'PayerEmail',
  PayerName = 'PayerName',
  PayerPhoneNumber = 'PayerPhoneNumber',
  PaymentInstructions = 'PaymentInstructions',
  ReceiptNumber = 'ReceiptNumber',
  /** receipt feature kinds */
  ReceiptPaymentProcessor = 'ReceiptPaymentProcessor',
  RemittanceAddress = 'RemittanceAddress',
  /** binds a remittance item's anchor feature to its SwiftCode/Iban/BankAddress */
  RemittanceGroup = 'RemittanceGroup',
  RemittanceInformation = 'RemittanceInformation',
  /** contract and schedule extraction feature kinds */
  Schedule = 'Schedule',
  ScheduleAccountGroupName = 'ScheduleAccountGroupName',
  ScheduleAccountGroupNumber = 'ScheduleAccountGroupNumber',
  ScheduleAccrualFormulaText = 'ScheduleAccrualFormulaText',
  ScheduleAccumulatedToDateAmount = 'ScheduleAccumulatedToDateAmount',
  ScheduleAmount = 'ScheduleAmount',
  ScheduleArchetype = 'ScheduleArchetype',
  ScheduleConfidenceBasisPoints = 'ScheduleConfidenceBasisPoints',
  ScheduleEndDate = 'ScheduleEndDate',
  ScheduleExtractorId = 'ScheduleExtractorId',
  ScheduleExtractorVersion = 'ScheduleExtractorVersion',
  ScheduleFormulaDisplay = 'ScheduleFormulaDisplay',
  ScheduleInterval = 'ScheduleInterval',
  ScheduleItem = 'ScheduleItem',
  ScheduleMappingSource = 'ScheduleMappingSource',
  ScheduleName = 'ScheduleName',
  SchedulePartyName = 'SchedulePartyName',
  SchedulePeriod = 'SchedulePeriod',
  SchedulePeriodAmount = 'SchedulePeriodAmount',
  SchedulePeriodIndex = 'SchedulePeriodIndex',
  SchedulePeriodMonth = 'SchedulePeriodMonth',
  ScheduleSalvageValueAmount = 'ScheduleSalvageValueAmount',
  ScheduleSourceAccount = 'ScheduleSourceAccount',
  ScheduleSourceFile = 'ScheduleSourceFile',
  ScheduleSourceRow = 'ScheduleSourceRow',
  ScheduleSourceTab = 'ScheduleSourceTab',
  ScheduleStartDate = 'ScheduleStartDate',
  ScheduleTargetCategory = 'ScheduleTargetCategory',
  ScheduleTargetCategoryName = 'ScheduleTargetCategoryName',
  ScheduleTermIntervals = 'ScheduleTermIntervals',
  ScheduleType = 'ScheduleType',
  StartingBalance = 'StartingBalance',
  StartingDate = 'StartingDate',
  /**
   * wire-remittance attributes stored as their own string features and
   * reassembled onto RemittanceItem via a RemittanceGroup
   */
  SwiftCode = 'SwiftCode',
  TaxNumber = 'TaxNumber',
  Terms = 'Terms',
  Title = 'Title',
  TotalAmount = 'TotalAmount',
  TotalCashback = 'TotalCashback',
  TotalCredits = 'TotalCredits',
  TotalDebits = 'TotalDebits',
  TotalDeposits = 'TotalDeposits',
  TotalDividends = 'TotalDividends',
  TotalFees = 'TotalFees',
  TotalInterestCharged = 'TotalInterestCharged',
  TotalInterestEarned = 'TotalInterestEarned',
  TotalWithdrawals = 'TotalWithdrawals',
  UnknownKind = 'UnknownKind',
  VendorAddress = 'VendorAddress',
  VendorEmail = 'VendorEmail',
  VendorName = 'VendorName',
  VendorPhoneNumber = 'VendorPhoneNumber',
  VendorWebsite = 'VendorWebsite',
  WireInfo = 'WireInfo'
}

export type FeatureValue = AddressFeatureValue | DateFeatureValue | LineItemFeatureValue | MonetaryFeatureValue | NumericFeatureValue | RemittanceFeatureValue | TextFeatureValue;

export enum FetchType {
  Backfill = 'Backfill',
  ChangeDataCapture = 'ChangeDataCapture',
  Onboard = 'Onboard',
  Refresh = 'Refresh'
}

export type FieldFilterTermInput = {
  field: TermField;
  term: Scalars['String']['input'];
};

export type FinchConnectToken = {
  sessionId: Scalars['String']['output'];
};

export type FinchConnectorProperties = {
  /**
   * Finch uses Finch Connect embedded widget which is initiated via createFinchSession
   * No authorization URL needed as the token is used directly by the frontend widget
   */
  empty?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * FirmClient is a row in the Firm Work Management dashboard.
 * `id` mirrors legalEntity.id so Apollo can normalize and surgically
 * update a row without refetching the whole list.
 */
export type FirmClient = {
  billingPlan?: Maybe<BillingProduct>;
  counts: Array<ActionItemsGroupSummary>;
  id: Scalars['String']['output'];
  legalEntity: EntityLegalEntity;
  /**
   * Ids reference FirmClientList.entities.users (EntityUser), keeping
   * member lookups deduped across rows.
   */
  memberUserIds: Array<Scalars['String']['output']>;
  organization: EntityOrganization;
  /**
   * payerOrganizationId tells the frontend who pays for this client's
   * subscription. Compare against the firm org id (firm pays) vs the
   * client's organizationId (client pays); null = unknown.
   * Mirrors BillingArrangementLegalEntityBilling.payerOrganizationId.
   */
  payerOrganizationId?: Maybe<Scalars['String']['output']>;
  status: LegalEntityStatus;
};

export type FirmClientFilter = {
  firmOrganizationId: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<LegalEntityStatus>>;
};

export type FirmClientList = {
  clients: Array<FirmClient>;
  /** Deduped lookup tables for ids referenced by rows */
  entities?: Maybe<ObjectEntities>;
  totalCount: Scalars['Int']['output'];
};

export type FirmClientSort = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<FirmClientSortField>;
};

export enum FirmClientSortField {
  Book = 'Book',
  Comments = 'Comments',
  Name = 'Name',
  Reconcile = 'Reconcile',
  Report = 'Report',
  Review = 'Review',
  Schedule = 'Schedule',
  Setup = 'Setup',
  Status = 'Status'
}

export type FirstTransactionOccurrence = {
  firstTransactionOccurredAt: Scalars['DateTime']['output'];
};

export enum Flow {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
  UnknownFlow = 'UnknownFlow'
}

export type Format = {
  formatClass?: Maybe<FormatClass>;
  id: Scalars['String']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  segments: Array<Segment>;
};

export enum FormatClass {
  AnnotatedTableJson = 'AnnotatedTableJson',
  CSV = 'CSV',
  Email = 'Email',
  ImageDocument = 'ImageDocument',
  ImageLarge = 'ImageLarge',
  ImageSmall = 'ImageSmall',
  ImageThumbnail = 'ImageThumbnail',
  LabelJson = 'LabelJson',
  OcrJson = 'OcrJson',
  OcrProto = 'OcrProto',
  PDF = 'PDF',
  RawMIME = 'RawMIME'
}

export enum GenerationStatus {
  Failed = 'Failed',
  InProgress = 'InProgress',
  Success = 'Success',
  UnknownStatus = 'UnknownStatus'
}

export enum GrantPolicy {
  Allow = 'Allow',
  Deny = 'Deny'
}

export type GustoConnectorProperties = {
  authorizationURL: Scalars['String']['output'];
};

export enum HandleNone {
  Both = 'Both',
  Either = 'Either',
  Ignore = 'Ignore'
}

export type HighlightedToken = {
  score: Scalars['Long']['output'];
  token: Scalars['String']['output'];
};

export type HighlightedTokens = {
  description?: Maybe<Array<HighlightedToken>>;
  name?: Maybe<Array<HighlightedToken>>;
};

/**
 * Highlight describes the positional offsets of a search term
 * within the result document, which will allow clients to highlight
 * that term during presentation of the result.
 */
export type HitHighlight = {
  end: Scalars['Long']['output'];
  field: Scalars['String']['output'];
  start: Scalars['Long']['output'];
  term: Scalars['String']['output'];
};

export type Hover = CategoryHover | PartyHover | SummaryLineItemHover;

/**
 * HydrateIdentifier is a (kind, id) pair for HydrateEntities requests.
 * legal_entity_id is not included here because it's carried by the request's
 * ViewKey — all identifiers in a single call resolve under the same view.
 */
export type HydrateIdentifier = {
  id: Scalars['String']['input'];
  kind: ObjectKind;
};

/** IdentifiersByKind represents a kind, legalEntityId and list of object ids */
export type IdentifiersByKind = {
  ids: Array<Scalars['String']['input']>;
  kind: ObjectKind;
  legalEntityId: Scalars['String']['input'];
};

export type Identity = {
  domain?: Maybe<Scalars['String']['output']>;
  identifier: Scalars['String']['output'];
  provider: OAuthService;
};

/** Identity Verification */
export type IdentityVerification = {
  url?: Maybe<Scalars['String']['output']>;
};

export enum IdentityVerificationStatus {
  ApplicationReview = 'ApplicationReview',
  Approved = 'Approved',
  Denied = 'Denied',
  IdentityVerificationStatusUnknown = 'IdentityVerificationStatusUnknown',
  Ineligible = 'Ineligible',
  Pending = 'Pending'
}

export type IdentityVerificationStatusResult = {
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  status: IdentityVerificationStatus;
};

export type ImportedEmployees = {
  employees: Array<Employee>;
  newEmployeeCount: Scalars['Int']['output'];
};

export enum IngestSource {
  BankStatementUpload = 'BankStatementUpload',
  BillPayEmail = 'BillPayEmail',
  BillPayUpload = 'BillPayUpload',
  Ledger = 'Ledger',
  Report = 'Report',
  StatementImport = 'StatementImport',
  Vault = 'Vault'
}

export type InputAccountReconciliation = {
  abnormalTotal?: InputMaybe<InputMonetaryValue>;
  categoryId: Scalars['String']['input'];
  closingBalance: InputMonetaryValue;
  endDate: DateInput;
  normalTotal?: InputMaybe<InputMonetaryValue>;
};

export type InputAccountReconciliationUpdate = {
  abnormalTotal?: InputMaybe<InputReconciliationAmount>;
  closingBalance?: InputMaybe<InputMonetaryValue>;
  /** fields used for reconfiguring a reconciliation */
  endDate?: InputMaybe<DateInput>;
  /** fields used for reconfiguring or updating a reconciliation */
  normalTotal?: InputMaybe<InputReconciliationAmount>;
};

export type InputAccountReconciliationsFilter = {
  direction: DirectionFromOrigin;
  hasActivity: Scalars['Boolean']['input'];
  origin: IntervalOrigin;
};

export type InputAmountRuleFilter = {
  amount: InputMonetaryValue;
  amountRuleFilterId?: InputMaybe<Scalars['String']['input']>;
  operator: ComparisonOperator;
};

export type InputAssociationIdentifier = {
  documentIdentifier: InputDocumentIdentifier;
  objectIdentifier: InputObjectIdentifier;
};

export type InputCategoryRuleFilter = {
  categories: Array<InputCategoryRuleFilterCategory>;
  categoryRuleFilterId?: InputMaybe<Scalars['String']['input']>;
  operation: Operation;
};

export type InputCategoryRuleFilterCategory = {
  categoryId: Scalars['String']['input'];
  categoryName: Scalars['String']['input'];
};

/** # TODO - should be unified with Party/NewParty once addresses land */
export type InputCustomer = {
  address?: InputMaybe<InputCustomerAddress>;
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  providerType: ProviderType;
};

export type InputCustomerAddress = {
  address?: InputMaybe<AddressInput>;
  id: Scalars['String']['input'];
};

export type InputDataSourceDiscount = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  discountId: Scalars['String']['input'];
  fixedDiscountAmount?: InputMaybe<InputMonetaryValue>;
  name: Scalars['String']['input'];
  providerType: ProviderType;
  variablePercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type InputDocumentIdentifier = {
  collectionId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
};

export type InputInvoice = {
  brandingId?: InputMaybe<Scalars['String']['input']>;
  customerAddressId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputInvoiceDiscount>>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceNumber: Scalars['String']['input'];
  lineItems: Array<InputInvoiceLineItem>;
  memo?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['String']['input'];
  status: InvoiceStatus;
  taxPercent?: InputMaybe<Scalars['Float']['input']>;
};

export type InputInvoiceBranding = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  coverURL?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type InputInvoiceDiscount = {
  /** frontend generated stableId */
  discountId: Scalars['String']['input'];
  fixedDiscountAmount?: InputMaybe<InputMonetaryValue>;
  invoiceDiscountId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  providerType: ProviderType;
  variablePercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type InputInvoiceEmailDetails = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  companyIcon: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  coverURL?: InputMaybe<Scalars['String']['input']>;
  partyEmail: Scalars['String']['input'];
};

export type InputInvoiceLineItem = {
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputInvoiceDiscount>>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  position: Scalars['Long']['input'];
  productId?: InputMaybe<Scalars['String']['input']>;
  quantityValue?: InputMaybe<InputQuantityValue>;
  taxable: Scalars['Boolean']['input'];
  unitPrice: InputMonetaryValue;
};

export type InputInvoiceProduct = {
  departmentId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  incomeCategoryId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  productVariantId?: InputMaybe<Scalars['String']['input']>;
  providerType: ProviderType;
  unitPrice?: InputMaybe<InputMonetaryValue>;
};

export type InputInvoicingAddress = {
  address: AddressInput;
  id: Scalars['String']['input'];
};

export type InputInvoicingProfile = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  companyAddress: InputInvoicingAddress;
  companyEmail: Scalars['String']['input'];
  companyIcon?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  coverURL?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  invoiceNumberFormat?: InputMaybe<Scalars['String']['input']>;
  newCompanyIconBase64?: InputMaybe<Scalars['String']['input']>;
  payoutInstrumentID: Scalars['String']['input'];
};

export type InputLedgerCustomer = {
  billingAddress?: InputMaybe<InputCustomerAddress>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  paymentTerms?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  secondaryEmail?: InputMaybe<Scalars['String']['input']>;
  shippingAddress?: InputMaybe<InputCustomerAddress>;
};

export type InputMonetaryValue = {
  amount: Scalars['Long']['input'];
  currencyMultiplier: Scalars['Long']['input'];
  iso4217CurrencyCode: Scalars['String']['input'];
};

/**
 * ObjectIdentifier is a generic identifier with an enumerated kind.
 * It can be used to identify different Digits' core objects.
 */
export type InputObjectIdentifier = {
  id: Scalars['String']['input'];
  kind: ObjectKind;
  legalEntityId: Scalars['String']['input'];
};

export type InputOrganizationBranding = {
  headerColor: Scalars['String']['input'];
  headerTextColor: Scalars['String']['input'];
};

export type InputPartyRuleFilter = {
  operation: Operation;
  parties: Array<InputPartyRuleFilterParty>;
  partyRuleFilterId?: InputMaybe<Scalars['String']['input']>;
};

export type InputPartyRuleFilterParty = {
  partyId: Scalars['String']['input'];
  partyName: Scalars['String']['input'];
};

export type InputQuantityValue = {
  quantity: Scalars['Long']['input'];
  quantityMultiplier: Scalars['Long']['input'];
};

export type InputReconciliationAmount = {
  amount?: InputMaybe<InputMonetaryValue>;
  delete: Scalars['Boolean']['input'];
};

export type InputStatusUpdate = {
  categoryId: Scalars['String']['input'];
  reconciliationId: Scalars['String']['input'];
  status: TransactionReconciliationStatus;
  transactionFactId: Scalars['String']['input'];
};

/** # input types */
export type InputTransaction = {
  bill?: InputMaybe<BillEdit>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<InvoiceEdit>;
  lines: Array<InputTransactionLine>;
  memo: Scalars['String']['input'];
  /** Fact IDs of lines that existed before editing. Used to derive the data source. */
  originalFactIds?: InputMaybe<Array<Scalars['String']['input']>>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  timestamp: Scalars['DateTime']['input'];
  type: TransactionType;
};

export type InputTransactionLine = {
  amount: InputMonetaryValue;
  categoryId: Scalars['String']['input'];
  /** department ID is optional */
  departmentId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  entryType: EntryType;
  id: Scalars['String']['input'];
  lineItemId: Scalars['String']['input'];
  /** location ID is optional */
  locationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * newDepartment is optional
   * if provided (and departmentId is blank) a new department will be created and associated with the transaction line
   */
  newDepartment?: InputMaybe<Scalars['String']['input']>;
  /**
   * newLocation is optional
   * if provided (and locationId is blank) a new location will be created and associated with the transaction line
   */
  newLocation?: InputMaybe<Scalars['String']['input']>;
  /**
   * newParty is optional
   * if provided (and partyId is blank) a new party will be created and associated with the transaction line
   */
  newParty?: InputMaybe<Scalars['String']['input']>;
  /** party classification is optional */
  partyId?: InputMaybe<Scalars['String']['input']>;
};

export type InputUpdateFields = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  digitsTransactionType: TransactionType;
  entryType: EntryType;
  locationId?: InputMaybe<Scalars['String']['input']>;
  /** optional fields to update */
  partyId?: InputMaybe<Scalars['String']['input']>;
  splitCategoryId?: InputMaybe<Scalars['String']['input']>;
  splitDepartmentId?: InputMaybe<Scalars['String']['input']>;
  splitLocationId?: InputMaybe<Scalars['String']['input']>;
  taxStatus?: InputMaybe<TaxStatus>;
  transactionFactId: Scalars['String']['input'];
};

export type InputUpdatePartyFields = {
  entityType?: InputMaybe<PartyEntityType>;
  partyId: Scalars['String']['input'];
  /** optional fields to update */
  taxpayerIdentification?: InputMaybe<TaxpayerIdentification>;
};

export type Insight = {
  absoluteDelta?: Maybe<MonetaryValue>;
  comparisonIntervalOffset: Scalars['Long']['output'];
  comparisonPeriodValue?: Maybe<MonetaryValue>;
  designation?: Maybe<PartyDesignation>;
  globalScore?: Maybe<Scalars['Float']['output']>;
  periodValue?: Maybe<MonetaryValue>;
  productArea?: Maybe<ProductArea>;
  ruleType: InsightRuleType;
  score: Scalars['Long']['output'];
  sentence?: Maybe<Scalars['String']['output']>;
  subjectDisplayKey: Scalars['String']['output'];
  subjectIconUrl?: Maybe<Scalars['String']['output']>;
  subjectId: Scalars['String']['output'];
  subjectType: InsightSubjectType;
  type: InsightType;
};

export type InsightComponent = {
  hovers: Array<Hover>;
  sentence: Scalars['String']['output'];
};

export type InsightComponentConfig = {
  lookback: ArchiveIntervalOrigin;
  objectId: ObjectIdentifier;
  options?: Maybe<InsightComponentConfigOptions>;
  origin: ArchiveIntervalOrigin;
};

export type InsightComponentConfigOptions = {
  partyRole?: Maybe<PartyRole>;
};

export type InsightConfigInput = {
  lookback: IntervalOrigin;
  objectId: InputObjectIdentifier;
  origin: IntervalOrigin;
  partyRole?: InputMaybe<PartyRole>;
};

export type InsightFilter = {
  categoryTypes?: InputMaybe<Array<CategoryType>>;
  insightTypes?: InputMaybe<Array<InsightType>>;
  insightVisibility?: InputMaybe<InsightVisibility>;
  objectId?: InputMaybe<InputObjectIdentifier>;
  partyRole?: InputMaybe<PartyRole>;
  productArea?: InputMaybe<ProductArea>;
  scoreType?: InputMaybe<InsightScoreType>;
  subjectId?: InputMaybe<Scalars['String']['input']>;
  subjectTypes?: InputMaybe<Array<InsightSubjectType>>;
  topLevelOnly?: InputMaybe<Scalars['Boolean']['input']>;
  viewKey: ViewKey;
};

export enum InsightRuleType {
  Delta = 'Delta',
  Growth = 'Growth',
  Inconsistent = 'Inconsistent',
  New = 'New',
  Outlier = 'Outlier',
  Regression = 'Regression',
  UnspecifiedRuleType = 'UnspecifiedRuleType'
}

export enum InsightScoreType {
  Global = 'Global',
  Local = 'Local',
  UnknownScoreType = 'UnknownScoreType'
}

export enum InsightSubjectType {
  Category = 'Category',
  Department = 'Department',
  LegalEntity = 'LegalEntity',
  Location = 'Location',
  Party = 'Party',
  Recurring = 'Recurring',
  TransactionFact = 'TransactionFact',
  UnspecifiedSubjectType = 'UnspecifiedSubjectType'
}

export enum InsightType {
  AssetsPrepaid = 'AssetsPrepaid',
  AssetsReceivable = 'AssetsReceivable',
  Cash = 'Cash',
  CostOfGoodsSold = 'CostOfGoodsSold',
  Equity = 'Equity',
  Expenses = 'Expenses',
  Income = 'Income',
  LiabilitiesLongTerm = 'LiabilitiesLongTerm',
  LiabilitiesPayable = 'LiabilitiesPayable',
  UnspecifiedInsightType = 'UnspecifiedInsightType'
}

export enum InsightVisibility {
  DuplicateVisibility = 'DuplicateVisibility',
  FullVisibility = 'FullVisibility',
  UnspecifiedInsightVisibility = 'UnspecifiedInsightVisibility'
}

export type Institution = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partyId?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type InstitutionFacet = {
  count: Scalars['Int']['output'];
  institutionObject: EntityInstitution;
};

export type InstitutionFilter = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InstitutionProduct>>;
};

export enum InstitutionKind {
  Bank = 'Bank',
  Expense = 'Expense',
  Ledger = 'Ledger',
  Payment = 'Payment',
  Payroll = 'Payroll'
}

export enum InstitutionProduct {
  BankAccount = 'BankAccount',
  BillPay = 'BillPay',
  CapTable = 'CapTable',
  CreditDebitCard = 'CreditDebitCard',
  Invoicing = 'Invoicing',
  PayrollProvider = 'PayrollProvider',
  Revenue = 'Revenue',
  UnknownProduct = 'UnknownProduct'
}

export enum Interval {
  Biweek = 'Biweek',
  Day = 'Day',
  Hour = 'Hour',
  IntervalNone = 'IntervalNone',
  Minute = 'Minute',
  Month = 'Month',
  Quarter = 'Quarter',
  Week = 'Week',
  Year = 'Year'
}

/** Intervals */
export type IntervalOrigin = {
  index: Scalars['Int']['input'];
  interval: Interval;
  intervalCount?: InputMaybe<Scalars['Int']['input']>;
  maxTime?: InputMaybe<Scalars['DateTime']['input']>;
  year: Scalars['Int']['input'];
};

export type IntervalPartition = {
  origin: IntervalPartitionOrigin;
  step: IntervalPartitionStep;
};

export type IntervalPartitionOrigin = {
  index: Scalars['Int']['input'];
  interval: Interval;
  intervalCount: Scalars['Int']['input'];
};

export type IntervalPartitionStep = {
  interval: Interval;
};

export type Invitation = {
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  invitationType: InvitationType;
  legalEntityRoles?: Maybe<Array<EmployeeLegalEntityRole>>;
  notifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Organization>;
  organizationTemplateId?: Maybe<Scalars['String']['output']>;
  recipient: Contact;
  role?: Maybe<Role>;
  sender?: Maybe<Contact>;
  service?: Maybe<OAuthService>;
  signupId?: Maybe<Scalars['String']['output']>;
  status: InvitationStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type InvitationProposal = {
  createdAt: Scalars['DateTime']['output'];
  invitationId: Scalars['String']['output'];
  legalEntity?: Maybe<EntityLegalEntity>;
  organization?: Maybe<EntityOrganization>;
  organizationTemplateId?: Maybe<Scalars['String']['output']>;
  proposalId: Scalars['String']['output'];
  proposalType: ProposalType;
  recipient?: Maybe<Contact>;
  sender?: Maybe<EntityUser>;
  status: InvitationProposalStatus;
};

export enum InvitationProposalStatus {
  Accepted = 'Accepted',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Rejected = 'Rejected',
  Sent = 'Sent',
  Unknown = 'Unknown'
}

export enum InvitationStatus {
  Accepted = 'Accepted',
  Active = 'Active',
  Cancelled = 'Cancelled',
  Unknown = 'Unknown'
}

export type InvitationToken = {
  token: Scalars['String']['output'];
};

export enum InvitationType {
  Accountant = 'Accountant',
  Operator = 'Operator',
  Passwordless = 'Passwordless',
  UnknownType = 'UnknownType'
}

export type Invoice = {
  branding: InvoiceBranding;
  customer?: Maybe<Customer>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<Array<InvoiceFile>>;
  id: Scalars['String']['output'];
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoicingProfile?: Maybe<InvoicingProfile>;
  legalEntityId: Scalars['String']['output'];
  lineItems: Array<InvoiceLineItem>;
  memo?: Maybe<Scalars['String']['output']>;
  receivableInvoiceId: Scalars['String']['output'];
  status: InvoiceStatus;
  statusSummary?: Maybe<InvoiceStatusSummary>;
  subtotal?: Maybe<MonetaryValue>;
  taxPercent?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<MonetaryValue>;
  totalTax?: Maybe<MonetaryValue>;
};

export type InvoiceBranding = {
  backgroundColor?: Maybe<Scalars['String']['output']>;
  coverURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

/** Result of a card payment submission */
export type InvoiceCardPaymentResult = {
  /** Action data for additional authentication (3DS) - pass to handleAction */
  actionData?: Maybe<Scalars['String']['output']>;
  /** Card brand (e.g. "visa", "mc") */
  cardBrand?: Maybe<Scalars['String']['output']>;
  /** Last four digits of the card */
  cardLastFour?: Maybe<Scalars['String']['output']>;
  /** Error message if payment failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Payment confirmation ID (if successful) */
  paymentConfirmationId?: Maybe<Scalars['String']['output']>;
  /** Adyen PSP reference */
  pspReference?: Maybe<Scalars['String']['output']>;
  /** Refusal reason code from Adyen (if refused) */
  refusalReasonCode?: Maybe<Scalars['String']['output']>;
  /** Result status of the payment attempt */
  result: CardPaymentResultStatus;
};

export type InvoiceDefaults = {
  branding: InvoiceBranding;
  dueDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceNumber: Scalars['String']['output'];
};

export type InvoiceDiscount = {
  amount: MonetaryValue;
  discount: Discount;
  discountAmount?: Maybe<MonetaryValue>;
  invoiceDiscountId: Scalars['String']['output'];
};

export type InvoiceEdit = {
  dataSourceId: Scalars['String']['input'];
  dataSourceInvoiceId: Scalars['String']['input'];
  dueDate: Scalars['DateTime']['input'];
};

export type InvoiceEmailConfig = {
  bcc: Array<Scalars['String']['output']>;
  cc: Array<Scalars['String']['output']>;
  invoiceId: Scalars['String']['output'];
  memo: Scalars['String']['output'];
  recipients: Array<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
};

export type InvoiceFile = {
  documentId: Scalars['String']['output'];
  fileType?: Maybe<InvoiceFileType>;
};

export enum InvoiceFileType {
  InvoicePDF = 'InvoicePDF',
  Unknown = 'Unknown'
}

export type InvoiceLineItem = {
  amount: MonetaryValue;
  description?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  position: Scalars['Long']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  quantityValue?: Maybe<QuantityValue>;
  sku?: Maybe<Scalars['String']['output']>;
  taxable: Scalars['Boolean']['output'];
  unitPrice: MonetaryValue;
};

export type InvoiceNumber = {
  invoiceNumber: Scalars['String']['output'];
};

export type InvoicePaymentDetails = {
  paymentAmount: MonetaryValue;
  paymentConfirmationId: Scalars['String']['output'];
  paymentDate: Scalars['DateTime']['output'];
  paymentInstrument: PaymentInstrument;
};

export type InvoicePaymentMethods = {
  /** Client key for initializing Adyen on the frontend */
  clientKey: Scalars['String']['output'];
  /** Environment (test or live) */
  environment: Scalars['String']['output'];
  /** Available payment methods as JSON string */
  paymentMethodsResponse?: Maybe<Scalars['String']['output']>;
};

export type InvoiceProduct = {
  departmentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  incomeCategoryId?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  productVariantId?: Maybe<Scalars['String']['output']>;
  providerType: ProviderType;
  unitPrice?: Maybe<MonetaryValue>;
};

export enum InvoiceStatus {
  Cancelled = 'Cancelled',
  Created = 'Created',
  /** adding this temporarily to fix an ops issue */
  Draft = 'Draft',
  Failed = 'Failed',
  ManuallySent = 'ManuallySent',
  MarkedAsPaid = 'MarkedAsPaid',
  OnHold = 'OnHold',
  Paid = 'Paid',
  PaymentCanceled = 'PaymentCanceled',
  PaymentProcessing = 'PaymentProcessing',
  PaymentRejected = 'PaymentRejected',
  PaymentRequiresAttention = 'PaymentRequiresAttention',
  PaymentReturned = 'PaymentReturned',
  Pending = 'Pending',
  Refunded = 'Refunded',
  Sent = 'Sent',
  Settled = 'Settled',
  Submitted = 'Submitted',
  Unknown = 'Unknown',
  UnspecifiedBillStatus = 'UnspecifiedBillStatus',
  Voided = 'Voided'
}

export type InvoiceStatusSummary = {
  internalNoteForStatus?: Maybe<Scalars['String']['output']>;
  invoiceSentDate: Scalars['DateTime']['output'];
  status: InvoiceStatus;
  statusAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type InvoiceSummary = InvoiceSummaryInterface & {
  amount: EntityMonetaryValue;
  createdAt: Scalars['DateTime']['output'];
  customer: CustomerSummary;
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  status: InvoiceStatus;
  statusAt: Scalars['DateTime']['output'];
};

/** Invoices */
export type InvoiceSummaryInterface = {
  amount: EntityMonetaryValue;
  createdAt: Scalars['DateTime']['output'];
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  status: InvoiceStatus;
  statusAt: Scalars['DateTime']['output'];
};

export type InvoicingAddress = {
  address: Address;
  id: Scalars['String']['output'];
};

export type InvoicingProfile = {
  companyAddress: InvoicingAddress;
  companyEmail: Scalars['String']['output'];
  companyIcon?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  finalized?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  invoiceNumberFormat?: Maybe<Scalars['String']['output']>;
  invoiceNumberFormatDefault: Scalars['String']['output'];
  payoutInstrumentID: Scalars['String']['output'];
};

export type JournalEntriesColumnMappingInput = {
  /**
   * At least one of accountNameColumn / accountNumberColumn must be set.
   * When both are mapped, the workflow resolves accounts via a combined
   * name+number lookup, falling back to number-only then name-only.
   */
  accountNameColumn?: InputMaybe<Scalars['String']['input']>;
  accountNumberColumn?: InputMaybe<Scalars['String']['input']>;
  creditColumn: Scalars['String']['input'];
  dateColumn: Scalars['String']['input'];
  debitColumn: Scalars['String']['input'];
  departmentColumn?: InputMaybe<Scalars['String']['input']>;
  descriptionColumn?: InputMaybe<Scalars['String']['input']>;
  entryIdColumn: Scalars['String']['input'];
  locationColumn?: InputMaybe<Scalars['String']['input']>;
  memoColumn?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<JournalEntriesParseOptionsInput>;
  partyColumn?: InputMaybe<Scalars['String']['input']>;
};

export type JournalEntriesParseOptionsInput = {
  dateFormat?: InputMaybe<Scalars['String']['input']>;
};

export type LabelCategory = {
  category?: Maybe<EntityCategory>;
  digitsAi?: Maybe<Scalars['Boolean']['output']>;
  displayName: Scalars['String']['output'];
  label: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  tooltip?: Maybe<Scalars['String']['output']>;
  /**
   * This contains a exhaustive list of all of the valid category types
   * that can be assigned to this label for the given connector.
   */
  validCategoryTypes: Array<CategoryType>;
};

export type Layout = {
  layoutId: Scalars['String']['output'];
  layoutVersionId?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<LayoutSection>>;
  viewKey: ViewIdentifier;
};

export type LayoutAttachment = {
  layoutId: Scalars['String']['output'];
  legalEntityId: Scalars['String']['output'];
};

export type LayoutComponent = {
  componentId: Scalars['String']['output'];
  config: LayoutComponentConfig;
  dataId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LayoutComponentConfig = {
  agingSummaryChart?: Maybe<AgingSummaryChartConfig>;
  cashSummaryChart?: Maybe<CashSummaryChartConfig>;
  categoryByDepartmentChart?: Maybe<CategoryByDepartmentChartConfig>;
  categoryByLocationChart?: Maybe<CategoryByLocationChartConfig>;
  categoryChart?: Maybe<CategoryChartConfig>;
  departmentChart?: Maybe<DepartmentChartConfig>;
  documentCollection?: Maybe<DocumentCollectionConfig>;
  entitiesList?: Maybe<EntitiesListConfig>;
  insight?: Maybe<InsightComponentConfig>;
  locationChart?: Maybe<LocationChartConfig>;
  metricChart?: Maybe<MetricChartConfig>;
  partyChart?: Maybe<PartyChartConfig>;
  portalMetric?: Maybe<PortalMetricConfig>;
  runwayChart?: Maybe<RunwayChartConfig>;
  sourceAccountMetric?: Maybe<SourceAccountMetricConfig>;
  statement?: Maybe<StatementConfig>;
  staticMetric?: Maybe<StaticMetricConfig>;
  summaryLineItem?: Maybe<SummaryLineItemConfig>;
  text?: Maybe<TextComponentConfig>;
  topEntities?: Maybe<TopEntitiesConfig>;
  topTransactions?: Maybe<TopTransactionsConfig>;
  type: LayoutComponentType;
};

export type LayoutComponentConfigInput = {
  agingSummaryChart?: InputMaybe<AgingSummaryChartConfigInput>;
  cashSummaryChart?: InputMaybe<CashSummaryChartConfigInput>;
  categoryByDepartmentChart?: InputMaybe<CategoryByDepartmentChartConfigInput>;
  categoryByLocationChart?: InputMaybe<CategoryByLocationChartConfigInput>;
  categoryChart?: InputMaybe<CategoryChartConfigInput>;
  departmentChart?: InputMaybe<DepartmentChartConfigInput>;
  documentCollection?: InputMaybe<DocumentCollectionConfigInput>;
  insight?: InputMaybe<InsightConfigInput>;
  locationChart?: InputMaybe<LocationChartConfigInput>;
  metricChart?: InputMaybe<MetricChartConfigInput>;
  partyChart?: InputMaybe<PartyChartConfigInput>;
  portalMetric?: InputMaybe<PortalMetricConfigInput>;
  runwayChart?: InputMaybe<RunwayChartConfigInput>;
  sourceAccountMetric?: InputMaybe<SourceAccountMetricConfigInput>;
  statement?: InputMaybe<StatementConfigInput>;
  staticMetric?: InputMaybe<StaticMetricConfigInput>;
  summaryLineItem?: InputMaybe<SummaryLineItemConfigInput>;
  text?: InputMaybe<TextComponentConfigInput>;
  topEntities?: InputMaybe<TopEntitiesConfigInput>;
  topTransactions?: InputMaybe<TopTransactionsConfigInput>;
  type: LayoutComponentType;
};

export type LayoutComponentInput = {
  componentId: Scalars['String']['input'];
  config: LayoutComponentConfigInput;
  dataId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum LayoutComponentType {
  AgingSummaryChart = 'AgingSummaryChart',
  CashSummaryChart = 'CashSummaryChart',
  CategoryBalanceSummaryChart = 'CategoryBalanceSummaryChart',
  CategoryByDepartmentChart = 'CategoryByDepartmentChart',
  CategoryByLocationChart = 'CategoryByLocationChart',
  CategoryTransactionSummaryChart = 'CategoryTransactionSummaryChart',
  DepartmentChart = 'DepartmentChart',
  DocumentCollection = 'DocumentCollection',
  EntitiesList = 'EntitiesList',
  Insight = 'Insight',
  LocationChart = 'LocationChart',
  MetricSummaryChart = 'MetricSummaryChart',
  PartyRoleBalanceSummaryChart = 'PartyRoleBalanceSummaryChart',
  PartyTransactionSummaryChart = 'PartyTransactionSummaryChart',
  PortalMetric = 'PortalMetric',
  RunwayChart = 'RunwayChart',
  SourceAccountMetric = 'SourceAccountMetric',
  Statement = 'Statement',
  StaticMetric = 'StaticMetric',
  SummaryLineItemChart = 'SummaryLineItemChart',
  Text = 'Text',
  TopEntities = 'TopEntities',
  TopTransactions = 'TopTransactions'
}

export type LayoutDocument = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  layoutId: Scalars['String']['output'];
  status: ReportPackageDocumentStatus;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LayoutInput = {
  layoutId: Scalars['String']['input'];
  sections?: InputMaybe<Array<LayoutSectionInput>>;
};

export type LayoutRow = {
  components?: Maybe<Array<LayoutComponent>>;
  rowId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type LayoutRowInput = {
  components?: InputMaybe<Array<LayoutComponentInput>>;
  rowId: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LayoutSection = {
  rows?: Maybe<Array<LayoutRow>>;
  sectionId: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type LayoutSectionInput = {
  rows?: InputMaybe<Array<LayoutRowInput>>;
  sectionId: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LeafAgingSummary = {
  amounts: Array<LeafAgingSummaryAmount>;
  /** @deprecated Use `amounts` instead */
  dimensionSummary: DimensionSummary;
  dueDate: Scalars['DateTime']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  link: LeafAgingSummaryLink;
  referenceNumber?: Maybe<Scalars['String']['output']>;
};

export type LeafAgingSummaryAmount = {
  column: LeafAgingSummaryAmountColumn;
  moneyFlow: MoneyFlow;
};

export enum LeafAgingSummaryAmountColumn {
  Current = 'Current',
  Older = 'Older',
  OneToThirty = 'OneToThirty',
  SixtyOneToNinety = 'SixtyOneToNinety',
  ThirtyOneToSixty = 'ThirtyOneToSixty'
}

export type LeafAgingSummaryLink = {
  hasLink: Scalars['Boolean']['output'];
};

export type LedgerAccountDifferences = {
  creditDifference?: Maybe<MoneyFlow>;
  debitDifference?: Maybe<MoneyFlow>;
  unreconciledDifference: MoneyFlow;
};

export type LedgerApproveAndPayBillResult = {
  billPaymentId?: Maybe<Scalars['String']['output']>;
  status: BillStatus;
};

export type LedgerBalances = {
  closingBalance: MoneyFlow;
  creditTotal: MoneyFlow;
  debitTotal: MoneyFlow;
  netTotal: MoneyFlow;
  unsettledTotal: MoneyFlow;
};

export type LedgerBillCandidateFactSet = {
  candidateMode: BillCandidateMode;
  transactionFactIds: Array<Scalars['String']['output']>;
};

export type LedgerBillDocument = {
  asyncProcessingStatus: AsyncProcessingStatus;
  collectionId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  features: Array<Feature>;
  formats: Array<Format>;
  id: Scalars['String']['output'];
  isSplitLineItemView: Scalars['Boolean']['output'];
  sourceFormatId?: Maybe<Scalars['String']['output']>;
  status: DocumentStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type LedgerBillLineItem = {
  amount?: Maybe<MonetaryValue>;
  category?: Maybe<EntityCategory>;
  classificationId?: Maybe<Scalars['String']['output']>;
  department?: Maybe<EntityDepartment>;
  description?: Maybe<Scalars['String']['output']>;
  documentFeatureId?: Maybe<Scalars['String']['output']>;
  entryType: EntryType;
  externalLineItemId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  location?: Maybe<EntityLocation>;
  name?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  unitPrice?: Maybe<MonetaryValue>;
};

export type LedgerBillSummary = {
  amount: EntityMonetaryValue;
  amountDue?: Maybe<EntityMonetaryValue>;
  billDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  detectedVendor?: Maybe<VendorSummary>;
  documentId?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  duplicateDataSourceBillIds: Array<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  providerType: ProviderType;
  referenceId: Scalars['String']['output'];
  scheduleSendForApproval?: Maybe<Scalars['DateTime']['output']>;
  sourceIconUrls?: Maybe<Array<Scalars['String']['output']>>;
  status: BillStatus;
  statusAt?: Maybe<Scalars['DateTime']['output']>;
  transactionFactId: Scalars['String']['output'];
  vendor: VendorSummary;
};

export type LedgerBillWorkflowStatusUpdate = {
  id: Scalars['String']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusAt: Scalars['DateTime']['output'];
  statusSource?: Maybe<Scalars['String']['output']>;
  user?: Maybe<EntityUser>;
};

export type LedgerCustomerDetail = {
  billingAddress?: Maybe<CustomerAddress>;
  contactName?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  dataSourcePartyId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  party: LedgerCustomerParty;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  providerType: ProviderType;
  secondaryEmail?: Maybe<Scalars['String']['output']>;
  shippingAddress?: Maybe<CustomerAddress>;
};

export type LedgerCustomerParty = {
  iconUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LedgerDraftInvoice = {
  branding: InvoiceBranding;
  customer?: Maybe<Customer>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoicingProfile?: Maybe<InvoicingProfile>;
  lineItems?: Maybe<Array<LedgerDraftInvoiceLineItem>>;
  memo?: Maybe<Scalars['String']['output']>;
  status: InvoiceStatus;
  subtotal?: Maybe<MonetaryValue>;
  taxPercent?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<MonetaryValue>;
  totalTax?: Maybe<MonetaryValue>;
  transactionFactId?: Maybe<Scalars['String']['output']>;
  validationErrors?: Maybe<Array<DraftInvoiceValidationError>>;
};

export type LedgerDraftInvoiceLineItem = {
  category?: Maybe<EntityCategory>;
  department?: Maybe<EntityDepartment>;
  description?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Long']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  quantityValue?: Maybe<QuantityValue>;
  taxable: Scalars['Boolean']['output'];
  unitPrice: MonetaryValue;
};

export type LedgerInputBill = {
  apFactId: Scalars['String']['input'];
  billDate?: InputMaybe<Scalars['DateTime']['input']>;
  billNumber?: InputMaybe<Scalars['String']['input']>;
  candidateMode?: InputMaybe<BillCandidateMode>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  lineItems: Array<LedgerInputBillLineItem>;
  memo?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  scheduleSendForApproval?: InputMaybe<Scalars['DateTime']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type LedgerInputBillLineItem = {
  amount: InputMonetaryValue;
  classificationId?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expenseCategoryId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  positionId: Scalars['Long']['input'];
  productDataSourceId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantityValue?: InputMaybe<InputQuantityValue>;
  unitPrice?: InputMaybe<InputMonetaryValue>;
};

export type LedgerInputDiscount = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  classificationId: Scalars['String']['input'];
  departmentId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountId: Scalars['String']['input'];
  fixedDiscountAmount?: InputMaybe<InputMonetaryValue>;
  id: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  variablePercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type LedgerInputInvoice = {
  arFactId: Scalars['String']['input'];
  brandingId?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  dataSourcePartyId?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceDiscounts?: InputMaybe<Array<LedgerInputDiscount>>;
  invoiceNumber: Scalars['String']['input'];
  lineItems: Array<LedgerInputLineItem>;
  memo?: InputMaybe<Scalars['String']['input']>;
  partyId?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  status: InvoiceStatus;
};

export type LedgerInputLineItem = {
  classificationId?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<LedgerInputDiscount>>;
  id: Scalars['String']['input'];
  incomeCategoryId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  positionId: Scalars['Long']['input'];
  productDataSourceId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  productVariantId?: InputMaybe<Scalars['String']['input']>;
  quantityValue?: InputMaybe<InputQuantityValue>;
  sku?: InputMaybe<Scalars['String']['input']>;
  taxable: Scalars['Boolean']['input'];
  unitPrice: InputMonetaryValue;
};

export type LedgerInvoiceDiscount = {
  amount: MonetaryValue;
  category?: Maybe<EntityCategory>;
  classificationId?: Maybe<Scalars['String']['output']>;
  department?: Maybe<EntityDepartment>;
  description?: Maybe<Scalars['String']['output']>;
  discountId: Scalars['String']['output'];
  fixedDiscountAmount?: Maybe<MonetaryValue>;
  id: Scalars['String']['output'];
  location?: Maybe<EntityLocation>;
  name: Scalars['String']['output'];
  variablePercentage?: Maybe<Scalars['Float']['output']>;
};

export type LedgerInvoiceLineItem = {
  amount: MonetaryValue;
  category?: Maybe<EntityCategory>;
  classificationId?: Maybe<Scalars['String']['output']>;
  department?: Maybe<EntityDepartment>;
  description?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Array<LedgerInvoiceDiscount>>;
  externalLineItemId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  location?: Maybe<EntityLocation>;
  name: Scalars['String']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  productVariantId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  unitPrice: MonetaryValue;
};

export type LedgerInvoiceProduct = {
  dataSourceId: Scalars['String']['output'];
  department?: Maybe<EntityDepartment>;
  departmentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  incomeCategory?: Maybe<EntityCategory>;
  incomeCategoryId?: Maybe<Scalars['String']['output']>;
  location?: Maybe<EntityLocation>;
  locationId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  productVariantId?: Maybe<Scalars['String']['output']>;
  providerType: ProviderType;
  unitPrice?: Maybe<MonetaryValue>;
};

export type LedgerInvoiceSummary = {
  amount: EntityMonetaryValue;
  amountDue?: Maybe<EntityMonetaryValue>;
  createdAt: Scalars['DateTime']['output'];
  customer: CustomerSummary;
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  providerType: ProviderType;
  referenceNumber: Scalars['String']['output'];
  sourceIconUrls?: Maybe<Array<Scalars['String']['output']>>;
  status: InvoiceStatus;
  statusAt: Scalars['DateTime']['output'];
  transactionFactId: Scalars['String']['output'];
};

export type LedgerInvoiceWorkflowStatusUpdate = {
  id: Scalars['String']['output'];
  internalNote?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusAt: Scalars['DateTime']['output'];
  statusSource?: Maybe<Scalars['String']['output']>;
  user?: Maybe<EntityUser>;
};

export type LedgerPreviewInvoiceEmailInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  companyIcon?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  coverURL?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceId: Scalars['String']['input'];
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  partyEmail?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  totalAmount: InputMonetaryValue;
};

export type LedgerReadBillTransaction = {
  apCategory?: Maybe<EntityCategory>;
  apFactId?: Maybe<Scalars['String']['output']>;
  billAccess: Array<BillAccess>;
  billDate?: Maybe<Scalars['DateTime']['output']>;
  billId: Scalars['String']['output'];
  billNumber?: Maybe<Scalars['String']['output']>;
  candidateFactSets?: Maybe<Array<LedgerBillCandidateFactSet>>;
  candidateMode?: Maybe<BillCandidateMode>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataSourceId: Scalars['String']['output'];
  document?: Maybe<LedgerBillDocument>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  duplicates: Array<DuplicateBill>;
  ledgerTransactionId: Scalars['String']['output'];
  lineItems: Array<LedgerBillLineItem>;
  memo?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  scheduleSendForApproval?: Maybe<Scalars['DateTime']['output']>;
  status: BillStatus;
  statusAt: Scalars['DateTime']['output'];
  totalAmount?: Maybe<MonetaryValue>;
  transactionFactId: Scalars['String']['output'];
  users: Array<User>;
  vendor?: Maybe<Vendor>;
};

export type LedgerReadInvoiceTransaction = {
  arCategory?: Maybe<EntityCategory>;
  arFactId?: Maybe<Scalars['String']['output']>;
  branding?: Maybe<InvoiceBranding>;
  customer?: Maybe<LedgerCustomerDetail>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceDiscounts: Array<LedgerInvoiceDiscount>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  ledgerTransactionId: Scalars['String']['output'];
  lineItems: Array<LedgerInvoiceLineItem>;
  memo?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  status: InvoiceStatus;
  subtotal?: Maybe<MonetaryValue>;
  totalAmount?: Maybe<MonetaryValue>;
  transactionFactId: Scalars['String']['output'];
};

export type LedgerSaveBillResult = {
  ledgerTransactionId: Scalars['String']['output'];
};

export type LedgerSaveInvoiceResult = {
  ledgerTransactionId: Scalars['String']['output'];
};

export type LedgerSearchInvoiceCustomersResult = {
  customers: Array<LedgerCustomerDetail>;
};

export type LedgerStartBillSplitLineItemsWorkflowResult = {
  workflowId: Scalars['String']['output'];
};

/** Bills */
export type LedgerStartBillWorkflowFromDocumentResult = {
  workflowId: Scalars['String']['output'];
};

/**
 * # output types
 * LedgerTransaction is a transaction with multiple lines that are in balance
 */
export type LedgerTransaction = {
  compileSource?: Maybe<CompileSource>;
  externalId: Scalars['String']['output'];
  isMetadataEditable: Scalars['Boolean']['output'];
  isSupersedingLedgerTransaction: Scalars['Boolean']['output'];
  ledgerTransactionId: Scalars['String']['output'];
  lines: Array<TransactionLine>;
  linkedBill?: Maybe<LinkedBill>;
  linkedInvoice?: Maybe<LinkedInvoice>;
  matchedLedgerTransactionIds: Array<Scalars['String']['output']>;
  memo: Scalars['String']['output'];
  providerTypes: Array<ProviderType>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  sources: Array<TransactionSource>;
  supersededLedgerTransactionIds: Array<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  type: TransactionType;
};

export type LedgerTransactionStale = {
  newViewAvailable: Scalars['Boolean']['output'];
  stale: Scalars['Boolean']['output'];
};

export enum LedgerType {
  Digits = 'Digits',
  QuickBooks = 'QuickBooks',
  Unspecified = 'Unspecified'
}

export type LegalEntity = {
  address: Address;
  fiscalYearNumberOffset: Scalars['Long']['output'];
  fiscalYearStartMonth: Scalars['Long']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  incorporatedOn?: Maybe<Date>;
  industry?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  sensitive: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  status: LegalEntityStatus;
  timezone?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type LegalEntityBadgeCount = {
  count: Scalars['Long']['output'];
  legalEntityId: Scalars['String']['output'];
};

export type LegalEntityPermission = {
  canManageTransactions: Scalars['Boolean']['input'];
  legalEntityId: Scalars['String']['input'];
};

export type LegalEntityPreferences = {
  bookkeeperAiCutoverAt?: Maybe<Scalars['DateTime']['output']>;
  isCogsInExpenses: Scalars['Boolean']['output'];
  legalEntityId: Scalars['String']['output'];
  lineClassDisplayName: Scalars['String']['output'];
  lineClassPluralDisplayName: Scalars['String']['output'];
  showAgingReports: Scalars['Boolean']['output'];
};

export type LegalEntityReset = {
  isReset: Scalars['Boolean']['output'];
};

export type LegalEntityRole = {
  legalEntityId: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type LegalEntityRoleOptions = {
  legalEntityId: Scalars['String']['output'];
  legalEntityRoles: Array<Role>;
  organizationRoles: Array<Role>;
};

export enum LegalEntityStatus {
  Active = 'Active',
  Approved = 'Approved',
  New = 'New',
  Pending = 'Pending',
  PendingHold = 'PendingHold',
  Removed = 'Removed',
  Unknown = 'Unknown'
}

export type LegalEntityUserInfo = {
  legalEntity: LegalEntity;
  userInfo: UserInfo;
};

export type LineItemFeatureValue = {
  lineItemValue: DocumentLineItem;
};

export type LinkedBill = {
  billDate: Scalars['DateTime']['output'];
  dataSourceId: Scalars['String']['output'];
  dueDate: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoiceNumber: Scalars['String']['output'];
  party?: Maybe<EntityParty>;
  providerType: ProviderType;
};

export type LinkedInvoice = {
  customerDetail?: Maybe<LedgerCustomerDetail>;
  dataSourceId: Scalars['String']['output'];
  dueDate: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceNumber: Scalars['String']['output'];
  party?: Maybe<EntityParty>;
  providerType: ProviderType;
  referenceNumber: Scalars['String']['output'];
  status: InvoiceStatus;
};

export type LinkedObjectDetails = {
  linkedTransactions: Array<Maybe<Transaction>>;
  paid: Scalars['Boolean']['output'];
  paidDate?: Maybe<Scalars['DateTime']['output']>;
  reversed?: Maybe<Scalars['Boolean']['output']>;
  sourceTransaction?: Maybe<Transaction>;
};

export enum LinkedObjectType {
  Bill = 'Bill',
  Invoice = 'Invoice'
}

export type ListBulkCategorySuggestionsResponse = {
  transactionCategorySuggestions: Array<TransactionCategorySuggestions>;
};

export type ListConnectionsFilter = {
  statusFilter?: InputMaybe<Array<ConnectionStatus>>;
};

export enum ListSignupRequestStatus {
  AllSignups = 'AllSignups',
  Applied = 'Applied',
  Ignored = 'Ignored',
  InviteAccepted = 'InviteAccepted',
  Invited = 'Invited',
  PrimerSent = 'PrimerSent',
  Qualified = 'Qualified',
  Unknown = 'Unknown',
  Unqualified = 'Unqualified',
  Waitlisted = 'Waitlisted'
}

/** TODO: deprecate */
export type ListSimilarTransactionsItem = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type Location = {
  active: Scalars['Boolean']['output'];
  ancestors: Array<EntityLocation>;
  dataSource?: Maybe<EntityDataSource>;
  description?: Maybe<Scalars['String']['output']>;
  displayKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use parentId instead */
  parentLocationId?: Maybe<Scalars['String']['output']>;
};

export type LocationChartConfig = {
  locationId: Scalars['String']['output'];
  origin: ArchiveIntervalOrigin;
};

export type LocationChartConfigInput = {
  locationId: Scalars['String']['input'];
  origin: IntervalOrigin;
};

export type LocationDimension = {
  by: DimensionSummary;
  locationId: Scalars['String']['output'];
  locationObject: EntityLocation;
  summary: TransactionSummary;
};

export type LocationFacet = {
  count: Scalars['Int']['output'];
  locationObject: EntityLocation;
};

export type LocationOption = {
  locationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LocationOptionInput = {
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum LocationStatus {
  Active = 'Active',
  Disabled = 'Disabled',
  Unknown = 'Unknown'
}

export type LocationSummary = {
  cogsChange: DimensionSummary;
  expensesChange: DimensionSummary;
  incomeChange: DimensionSummary;
  location: EntityLocation;
  otherExpensesChange: DimensionSummary;
  otherIncomeChange: DimensionSummary;
  total: DimensionSummary;
};

export enum MappingValidity {
  Invalid = 'Invalid',
  PartiallyValid = 'PartiallyValid',
  Valid = 'Valid'
}

export type MarketingEvent = {
  attributes?: InputMaybe<MarketingEventAttributes>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  persona?: InputMaybe<MarketingEventPersona>;
  state?: InputMaybe<Scalars['String']['input']>;
  type: MarketingEventType;
};

export type MarketingEventAttributes = {
  accountState?: InputMaybe<Scalars['String']['input']>;
  accountantCount?: InputMaybe<Scalars['String']['input']>;
  affiliationCount?: InputMaybe<Scalars['String']['input']>;
  clientCount?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  createAt?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  formerProvider?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  ledger?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export enum MarketingEventPersona {
  Accountant = 'Accountant',
  Developer = 'Developer',
  Operator = 'Operator',
  UnknownPersona = 'UnknownPersona'
}

export enum MarketingEventType {
  OnboardingAccountDetailsComplete = 'OnboardingAccountDetailsComplete',
  OnboardingAccountSetupComplete = 'OnboardingAccountSetupComplete',
  OnboardingAddCC = 'OnboardingAddCC',
  OnboardingAddClient = 'OnboardingAddClient',
  OnboardingAddClientInviteSent = 'OnboardingAddClientInviteSent',
  OnboardingConnectQBO = 'OnboardingConnectQBO',
  OnboardingConnectionAdded = 'OnboardingConnectionAdded',
  OnboardingFormerProvider = 'OnboardingFormerProvider',
  OnboardingSelectBank = 'OnboardingSelectBank',
  OnboardingSelectFinanceTools = 'OnboardingSelectFinanceTools',
  OnboardingSelfPaidClientBillingAddressComplete = 'OnboardingSelfPaidClientBillingAddressComplete',
  OnboardingSelfPaidClientConnectionsComplete = 'OnboardingSelfPaidClientConnectionsComplete',
  OnboardingSelfPaidClientPaymentMethodAdded = 'OnboardingSelfPaidClientPaymentMethodAdded',
  OnboardingSelfPaidClientRequiredConnectionMet = 'OnboardingSelfPaidClientRequiredConnectionMet',
  OnboardingSelfPaidClientSignIn = 'OnboardingSelfPaidClientSignIn',
  OnboardingSelfPaidClientSignUp = 'OnboardingSelfPaidClientSignUp',
  OnboardingSignIn = 'OnboardingSignIn',
  OnboardingSignUp = 'OnboardingSignUp',
  PlanManagementAddUser = 'PlanManagementAddUser',
  PlanManagementPaymentComplete = 'PlanManagementPaymentComplete',
  PlanManagementPlanCancelled = 'PlanManagementPlanCancelled',
  PlanManagementPlanDowngrade = 'PlanManagementPlanDowngrade',
  PlanManagementPlanUpgrade = 'PlanManagementPlanUpgrade',
  PlanManagementTrialCancel = 'PlanManagementTrialCancel',
  TrialEnd = 'TrialEnd',
  TrialStart = 'TrialStart',
  UnknownType = 'UnknownType',
  UsageActivateLegalEntity = 'UsageActivateLegalEntity',
  UsageAddUser = 'UsageAddUser',
  UsageBillPayed = 'UsageBillPayed',
  UsageCreateReport = 'UsageCreateReport',
  UsageRecategorizeTransaction = 'UsageRecategorizeTransaction',
  UsageSendInvoice = 'UsageSendInvoice',
  UsageShareReport = 'UsageShareReport',
  UsageSignIn = 'UsageSignIn'
}

export type MatchPotentialDuplicateFlagTransactionsInput = {
  documentFeatureGroupId: Scalars['String']['input'];
  flagId: Scalars['String']['input'];
  reconciledLedgerTransactionId: Scalars['String']['input'];
  unsettledLedgerTransactionId: Scalars['String']['input'];
};

export type MatchSetEntry = {
  createdAt: Scalars['DateTime']['output'];
  dataSourceId: Scalars['String']['output'];
  entryType: MatchedSetRowType;
  id: Scalars['String']['output'];
  legalEntityId: Scalars['String']['output'];
  matchSetId: Scalars['String']['output'];
  transactionFactId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MatchedDepartment = {
  dataSourceId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export enum MatchedSetRowType {
  JournalEntry = 'JournalEntry',
  Recorded = 'Recorded',
  SourceCredit = 'SourceCredit',
  SourceDebit = 'SourceDebit',
  Unknown = 'Unknown'
}

export enum MatchedStatus {
  Matched = 'Matched',
  UnknownMatchedStatus = 'UnknownMatchedStatus',
  Unmatched = 'Unmatched'
}

export type MatchedStatusFacet = {
  count: Scalars['Int']['output'];
  status: MatchedStatus;
};

export enum Matcher {
  Category = 'Category',
  CategoryType = 'CategoryType',
  PartyRole = 'PartyRole',
  ProductArea = 'ProductArea'
}

export enum MergeableStatus {
  Behind = 'Behind',
  Blocked = 'Blocked',
  Clean = 'Clean',
  Dirty = 'Dirty',
  Draft = 'Draft',
  HasHooks = 'HasHooks',
  UnknownMergeableStatus = 'UnknownMergeableStatus',
  Unstable = 'Unstable'
}

export type MetricCategoriesOperand = {
  categories: Array<EntityCategory>;
  defaultCategoryType: CategoryType;
  isBalance: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  naturalFlow: Flow;
  period?: Maybe<Period>;
};

export type MetricChartConfig = {
  item: MetricSummaryItem;
  origin: ArchiveIntervalOrigin;
};

export type MetricChartConfigInput = {
  item: MetricSummaryItem;
  origin: IntervalOrigin;
};

export type MetricEquation = {
  terms: Array<MetricTerm>;
};

export type MetricOperation = {
  symbol: MetricSymbol;
};

export enum MetricSummaryItem {
  GrossBurn = 'GrossBurn',
  GrossIncome = 'GrossIncome',
  NetBurn = 'NetBurn',
  UnknownMetricType = 'UnknownMetricType'
}

export type MetricSummaryTypeOperand = {
  defaultCategoryType: CategoryType;
  isBalance: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  naturalFlow: Flow;
  period?: Maybe<Period>;
  type: MetricSummaryItem;
};

export enum MetricSymbol {
  Add = 'Add',
  Divide = 'Divide',
  Subtract = 'Subtract'
}

export type MetricTerm = MetricCategoriesOperand | MetricOperation | MetricSummaryTypeOperand;

export enum MetricType {
  COGS = 'COGS',
  Expenses = 'Expenses',
  GrossProfit = 'GrossProfit',
  Income = 'Income',
  NetIncome = 'NetIncome',
  NetOperatingIncome = 'NetOperatingIncome',
  ProfitPercentage = 'ProfitPercentage'
}

export enum MfaMethod {
  RecoveryCode = 'RecoveryCode',
  TOTP = 'TOTP',
  UnknownMfaMethod = 'UnknownMfaMethod'
}

export type MigrationFileSummary = {
  file: PullRequestFile;
  hasRun: Scalars['Boolean']['output'];
};

export type MigrationPullRequest = {
  fileSummaries: Array<MigrationFileSummary>;
  pullRequestSummary: PullRequestSummary;
};

export type MinMaxAmount = {
  maxAmount: MonetaryValue;
  minAmount: MonetaryValue;
};

export enum MissingObject {
  Exclude = 'Exclude',
  Include = 'Include',
  Unknown = 'Unknown'
}

export type MonetaryFeatureValue = {
  monetaryValue: MonetaryValue;
};

/** MonetaryValue */
export type MonetaryValue = {
  amount: Scalars['Long']['output'];
  currencyMultiplier: Scalars['Long']['output'];
  iso4217CurrencyCode: Scalars['String']['output'];
};

export type MoneyFlow = {
  businessFlow: Flow;
  isNormal: Scalars['Boolean']['output'];
  value: MonetaryValue;
};

export type MoneyFlowInput = {
  businessFlow: Flow;
  isNormal: Scalars['Boolean']['input'];
  value: InputMonetaryValue;
};

export type Mutation = {
  acceptAffiliation?: Maybe<Scalars['Void']['output']>;
  /** TODO: This call is a dead end. We are leaving it in the schema to handle old clients that may still be using it. */
  acceptAllTerms?: Maybe<Scalars['Void']['output']>;
  acceptTerms?: Maybe<Scalars['Void']['output']>;
  activateCurrentUserEmployment?: Maybe<Scalars['Void']['output']>;
  activateLegalEntity?: Maybe<Scalars['Void']['output']>;
  activateRampConnection?: Maybe<Scalars['Void']['output']>;
  addAffiliatedSubscriptionPrice?: Maybe<Scalars['Void']['output']>;
  addAssociations?: Maybe<Scalars['Void']['output']>;
  /** Documents */
  addDocumentFeature: AddedFeature;
  addSubscriptionItem?: Maybe<Scalars['Void']['output']>;
  /** OAuth Authorization */
  approveOAuthAuthorization: OAuthAuthorizationApproval;
  approveObjectAccessRequest?: Maybe<Scalars['Void']['output']>;
  /** Component Data */
  archiveComponentData: Scalars['String']['output'];
  archiveConnection?: Maybe<Scalars['Void']['output']>;
  archiveConnectionAccount?: Maybe<Scalars['Void']['output']>;
  attachReportPackageDocument: Scalars['Void']['output'];
  autoConfigureConnection?: Maybe<Scalars['Void']['output']>;
  autoConfigureProduct?: Maybe<Scalars['Void']['output']>;
  /** Classes (dimensions) */
  bootstrapDepartments: CreateDepartmentResponse;
  bootstrapLocations: CreateLocationResponse;
  bootstrapSandboxAccountingOrganization?: Maybe<Scalars['Void']['output']>;
  bulkCreateOrReplyThreads: Array<Scalars['String']['output']>;
  cancelBillingSubscription?: Maybe<Scalars['Void']['output']>;
  cancelInvitation?: Maybe<Scalars['Void']['output']>;
  cancelReconciliationIntents?: Maybe<Scalars['Void']['output']>;
  closeWorkItems?: Maybe<Scalars['Void']['output']>;
  closedPeriodCreateSupersedingTransaction?: Maybe<Scalars['Void']['output']>;
  closedPeriodCreateTransaction?: Maybe<Scalars['Void']['output']>;
  closedPeriodDeleteTransactions?: Maybe<Scalars['Void']['output']>;
  closedPeriodMatch?: Maybe<Scalars['Void']['output']>;
  closedPeriodUnmatch?: Maybe<Scalars['Void']['output']>;
  closedPeriodUpdateTransaction?: Maybe<Scalars['Void']['output']>;
  confirmAccountantClient?: Maybe<Scalars['Void']['output']>;
  confirmAffiliatedSubscription?: Maybe<Scalars['Void']['output']>;
  confirmBillingSubscription?: Maybe<Scalars['Void']['output']>;
  confirmClientPays?: Maybe<Scalars['Void']['output']>;
  confirmCustomQualityCheckInstruction?: Maybe<Scalars['Void']['output']>;
  confirmOperatorReset?: Maybe<Scalars['Void']['output']>;
  confirmOperatorTrial?: Maybe<Scalars['Void']['output']>;
  /**
   * Activates a pending TOTP factor. Returns one-time recovery codes that
   * the client must present to the user exactly once.
   */
  confirmTotpEnrollment: TotpEnrollmentConfirmation;
  copyReportPackage: ReportPackageMetadata;
  /** Reconciliations */
  createAccountReconciliation: Scalars['String']['output'];
  createAffiliatedSubscription?: Maybe<NewAffiliatedBillingSubscription>;
  /** Affiliations (Affiliation mutating an associate to a legal entity or the legal entity directly) */
  createAffiliationFromOAuthIdentity: CreatedLegalEntity;
  /** Affiliations (Affiliation mutating an associate to a legal entity or the legal entity directly) */
  createAffiliationFromOAuthService: CreatedLegalEntity;
  /** Connect */
  createApp: Scalars['String']['output'];
  createBillConnection: CreateConnectionResponse;
  createBillingOnboardingSubscription: BillingSubscriptionWithoutStatus;
  /** Billing */
  createBillingSubscription: NewBillingSubscription;
  createBooksClosedDate?: Maybe<Scalars['Void']['output']>;
  /** Chart of Accounts */
  createCategory: CreateCategoryResponse;
  /** Category Mapping */
  createCategoryMapping: Scalars['Void']['output'];
  createClientPaysSubscription: CreateClientPaysBillingSubscription;
  createConnectPlaidLinkToken: PlaidLinkToken;
  createConnection: CreateConnectionResponse;
  createDepartment: CreateDepartmentResponse;
  createEmployeeAffiliations?: Maybe<Scalars['Void']['output']>;
  createFinchConnection: CreateConnectionResponse;
  createFinchSession: FinchConnectToken;
  createFirmAffiliation: LegalEntity;
  createFirmAffiliationFromOAuthService: CreatedLegalEntity;
  createGustoConnection: CreateConnectionResponse;
  createIntent?: Maybe<Scalars['Void']['output']>;
  createLegalEntityFromOAuthIdentity: LegalEntity;
  createLegalEntityFromOAuthService: LegalEntityUserInfo;
  createLocation: CreateLocationResponse;
  createManyTransactions?: Maybe<CreateManyTransactionsResponse>;
  /**
   * Proposals
   * Organizations
   */
  createOrganization: Organization;
  /** Parties */
  createParties: Array<Party>;
  /** Users */
  createPasswordReset?: Maybe<Scalars['Void']['output']>;
  createPlaidConnection: CreateConnectionResponse;
  /** Used by iOS app up to at least v1.1.1 */
  createPortal: Portal;
  createRampConnection: CreateConnectionResponse;
  createReaction?: Maybe<Scalars['Void']['output']>;
  createReconciliationFlagsTransactions?: Maybe<Scalars['Void']['output']>;
  createReconciliationIntents: CreateReconciliationIntentsResponse;
  createReportFromUpload: Array<Report>;
  /** Report Packages */
  createReportPackage: ReportPackageMetadata;
  createSchedule?: Maybe<Scalars['Void']['output']>;
  createStripeConnection: CreateConnectionResponse;
  createSupersedingTransaction?: Maybe<CreateTransactionResponse>;
  /** Comments */
  createThread: ThreadWithEntities;
  /** Transaction Editing */
  createTransaction?: Maybe<CreateTransactionResponse>;
  createWebhookEndpoint: WebhookEndpoint;
  deactivateEmployee?: Maybe<Scalars['Void']['output']>;
  declineApp: AppRedirect;
  deleteAccountReconciliation?: Maybe<Scalars['Void']['output']>;
  deleteComment?: Maybe<Scalars['Void']['output']>;
  deleteConnectionAccount?: Maybe<Scalars['Void']['output']>;
  /** Data Sources */
  deleteDataSource?: Maybe<Scalars['Void']['output']>;
  /** Vault */
  deleteDocument: Scalars['Void']['output'];
  deleteDraftInvoice: Scalars['Void']['output'];
  deleteEmployeeAffiliations?: Maybe<Scalars['Void']['output']>;
  deleteOrganizationBranding?: Maybe<Scalars['Void']['output']>;
  deletePotentialDuplicateFlagTransactions?: Maybe<Scalars['Void']['output']>;
  deleteProductGroup?: Maybe<Scalars['Void']['output']>;
  deleteProductVariant?: Maybe<Scalars['Void']['output']>;
  deleteProductVariantPrice?: Maybe<Scalars['Void']['output']>;
  deleteReaction?: Maybe<Scalars['Void']['output']>;
  deleteReportPackage?: Maybe<Scalars['Void']['output']>;
  deleteSchedule?: Maybe<Scalars['Void']['output']>;
  deleteTransactions?: Maybe<Scalars['Void']['output']>;
  deleteWebhookEndpoint?: Maybe<Scalars['Void']['output']>;
  deregisterAppInstance?: Maybe<Scalars['Void']['output']>;
  destroyConnection?: Maybe<Scalars['Void']['output']>;
  disableObjectLink?: Maybe<Scalars['Void']['output']>;
  /**
   * Disables the caller's TOTP factor. Requires a current TOTP code or a
   * recovery code as proof of possession.
   */
  disableTotp?: Maybe<Scalars['Void']['output']>;
  disableWebhookEndpoint: WebhookEndpoint;
  disaffiliateLegalEntity?: Maybe<Scalars['Void']['output']>;
  /**
   * Drafts an instruction and returns it directly. A guardrail block surfaces
   * as a mutation error here, since this return type cannot carry one.
   * @deprecated Use draftQualityCheckInstruction, which carries a guardrail block as data instead of erroring.
   */
  draftCustomQualityCheckInstruction: QualityCheckInstruction;
  /**
   * Drafts an instruction. Returns either the drafted QualityCheckInstruction or
   * a QualityCheckInstructionBlocked when a guardrail refused the instruction
   * (e.g. it abandons its base check's purpose) — the block is data, not an
   * error, so switch on __typename.
   */
  draftQualityCheckInstruction: DraftQualityCheckInstructionResult;
  duplicateInvoice: Scalars['String']['output'];
  editAffiliationBusiness?: Maybe<Scalars['Void']['output']>;
  editComment?: Maybe<Scalars['Void']['output']>;
  editFieldRequest: Scalars['Void']['output'];
  editReportPackage: ReportPackageMetadata;
  enableObjectLink?: Maybe<Scalars['Void']['output']>;
  enableWebhookEndpoint: WebhookEndpoint;
  enqueueStatementImportWorkflows: EnqueueStatementImportWorkflowsPayload;
  exportReconciliationsPdfs?: Maybe<Scalars['Void']['output']>;
  finalizeAccountReconciliation?: Maybe<Scalars['Void']['output']>;
  generateLayoutComponentPdf: DocumentDownload;
  generateReportPackagePdf: DocumentDownload;
  grantFromShare?: Maybe<Scalars['Void']['output']>;
  installApp: AppRedirect;
  ledgerApproveAndPayBill: LedgerApproveAndPayBillResult;
  ledgerApproveBill: Scalars['Void']['output'];
  ledgerDeleteBill: Scalars['Void']['output'];
  ledgerDeleteDraftInvoice: Scalars['Void']['output'];
  ledgerDuplicateInvoice: Scalars['String']['output'];
  ledgerMarkBillAsPaid: Scalars['Void']['output'];
  ledgerMarkDraftInvoiceAsPaid: Scalars['Void']['output'];
  ledgerMarkInvoiceAsPaid: Scalars['Void']['output'];
  ledgerPayBill: Scalars['String']['output'];
  ledgerPayInvoice: PayInvoiceSummary;
  ledgerRejectBill: Scalars['Void']['output'];
  ledgerResendInvoice: Scalars['Void']['output'];
  ledgerResendInvoiceManually: Scalars['Void']['output'];
  ledgerRetryBillPayment: Scalars['String']['output'];
  ledgerRetryBillPayouts: Scalars['Void']['output'];
  ledgerSaveBill: LedgerSaveBillResult;
  ledgerSaveInvoice: LedgerSaveInvoiceResult;
  ledgerSaveInvoiceCustomer: LedgerCustomerDetail;
  ledgerSaveInvoiceDiscount: Discount;
  ledgerSaveInvoiceEmailConfig: Scalars['Void']['output'];
  ledgerSaveInvoiceProduct: LedgerInvoiceProduct;
  ledgerSaveInvoicingProfile: InvoicingProfile;
  ledgerScheduleSendForApproval: Scalars['Void']['output'];
  ledgerSendForApproval: Scalars['Void']['output'];
  ledgerSendInvoice: Scalars['String']['output'];
  ledgerSendInvoiceManually: Scalars['String']['output'];
  ledgerSetDataSourceBillRole: Scalars['Void']['output'];
  ledgerSetInvoiceBranding: InvoiceBranding;
  ledgerStartBillSplitLineItemsWorkflow: LedgerStartBillSplitLineItemsWorkflowResult;
  /** Bills */
  ledgerStartBillWorkflowFromDocument: LedgerStartBillWorkflowFromDocumentResult;
  /** Submits a card payment for a ledger invoice using encrypted card data from Adyen */
  ledgerSubmitInvoiceCardPayment: InvoiceCardPaymentResult;
  ledgerVoidBill: Scalars['Void']['output'];
  ledgerVoidInvoice: Scalars['Void']['output'];
  /** Customer Events */
  logCustomerEvents?: Maybe<Scalars['Void']['output']>;
  markDraftInvoiceAsPaid: Scalars['Void']['output'];
  markInvoiceAsPaid: Scalars['Void']['output'];
  matchPotentialDuplicateFlagTransactions?: Maybe<Scalars['Void']['output']>;
  /** Transaction Matching */
  matchTransactions?: Maybe<Scalars['Void']['output']>;
  migrateDepartmentQuickBooks?: Maybe<Scalars['Void']['output']>;
  migrateLocationQuickBooks?: Maybe<Scalars['Void']['output']>;
  onboardLegalEntity: NewAiBookkeeperLegalEntity;
  onboardLegalEntityFromOAuthService: NewAiBookkeeperLegalEntity;
  payInvoice: PayInvoiceSummary;
  provisionClientPaysSubscription?: Maybe<Scalars['Void']['output']>;
  provisionLegalEntity: LegalEntity;
  provisionTrialBillingSubscription: NewTrialBillingSubscription;
  publishApp?: Maybe<Scalars['Void']['output']>;
  publishReportPackage?: Maybe<Scalars['Void']['output']>;
  pushDigitsWorkItems?: Maybe<Scalars['Void']['output']>;
  pushWorkItems?: Maybe<Scalars['Void']['output']>;
  reauthorizeFinchSession: FinchConnectToken;
  refreshDataSource: DataSourceManualRefresh;
  refreshReportPackage: ReportRefreshRequest;
  /** App Instances */
  registerAppInstance: AppInstance;
  registerPushDevice?: Maybe<PushDevice>;
  rejectAffiliation?: Maybe<Scalars['Void']['output']>;
  rejectFieldRequest: Scalars['Void']['output'];
  rejectObjectAccessRequest?: Maybe<Scalars['Void']['output']>;
  removeAssociations?: Maybe<Scalars['Void']['output']>;
  removeFirmAffiliation?: Maybe<Scalars['Void']['output']>;
  reopenAccountReconciliation?: Maybe<Scalars['Void']['output']>;
  reopenWorkItem?: Maybe<Scalars['Void']['output']>;
  replyThread: CommentWithEntities;
  requestAccess?: Maybe<Scalars['Void']['output']>;
  requestObjectAccess?: Maybe<Scalars['Void']['output']>;
  resendInvitation?: Maybe<Scalars['Void']['output']>;
  resendInvoice: Scalars['Void']['output'];
  resendInvoiceManually: Scalars['Void']['output'];
  resendManagedOperatorInvitation?: Maybe<Scalars['Void']['output']>;
  resetCustomQualityCheckInstruction?: Maybe<Scalars['Void']['output']>;
  /** Client Reset / Start Over */
  resetFirmAffiliation: LegalEntity;
  resetFirmAffiliationFromOAuthService: CreatedLegalEntity;
  /** Operator Reset / Start Over */
  resetOperatorLegalEntity: LegalEntity;
  resetOperatorLegalEntityFromOAuthService: CreatedLegalEntity;
  resetSandboxAccountingOrganization?: Maybe<Scalars['Void']['output']>;
  resolveClosedPeriodRequest?: Maybe<Scalars['Void']['output']>;
  resolvePotentialMismatchFlag?: Maybe<Scalars['Void']['output']>;
  resolveThread?: Maybe<Scalars['Void']['output']>;
  retryWebhookEndpointDelivery?: Maybe<Scalars['Void']['output']>;
  /** Sharing and Access Control */
  revokeGrant?: Maybe<Scalars['Void']['output']>;
  revokeIntent?: Maybe<Scalars['Void']['output']>;
  rotateWebhookEndpointSecret: Scalars['String']['output'];
  /** Business Verification */
  saveBusinessVerificationApplication?: Maybe<Scalars['Void']['output']>;
  saveDraftInvoice: Scalars['Void']['output'];
  saveInvoiceBranding: InvoiceBranding;
  saveInvoiceCustomer: Customer;
  saveInvoiceDiscount: Discount;
  saveInvoiceProduct: InvoiceProduct;
  /** Invoices */
  saveInvoicingProfile: InvoicingProfile;
  saveOrganizationBranding?: Maybe<OrganizationBranding>;
  saveProduct: Product;
  saveProductGroup: ProductGroup;
  saveProductVariant: ProductVariant;
  saveProductVariantPrice: ProductVariantPrice;
  sendBusinessVerificationApplication: BusinessVerification;
  /** Invitations */
  sendInvitation?: Maybe<Scalars['Void']['output']>;
  sendInvoice: Scalars['String']['output'];
  sendInvoiceManually: Scalars['String']['output'];
  sendManagedOperatorInvitation?: Maybe<Scalars['Void']['output']>;
  sendManagedOperatorReset?: Maybe<Scalars['Void']['output']>;
  sendTransactionReviewReminder?: Maybe<Scalars['Void']['output']>;
  sendWebhookEndpointTestEvent: Scalars['String']['output'];
  setDefaultApprover?: Maybe<Scalars['Void']['output']>;
  setRequireBillApproverDifferentFromCreator?: Maybe<Scalars['Void']['output']>;
  setupSubscription: SetupSubscriptionResult;
  startBulkCSVImport: StartBulkCsvImportPayload;
  startJournalEntriesImport: StartJournalEntriesImportPayload;
  /**
   * Begins TOTP enrollment. Returns an otpauth:// URI for QR rendering and
   * the base32-encoded shared secret for manual entry into authenticator apps.
   */
  startTotpEnrollment: TotpEnrollmentInit;
  /** Onboarding */
  submitAccountantOnboarding?: Maybe<Scalars['Void']['output']>;
  /** Submits a card payment for an invoice using encrypted card data from Adyen */
  submitInvoiceCardPayment: InvoiceCardPaymentResult;
  syncConnection?: Maybe<Scalars['Void']['output']>;
  transferProductsAndDeleteProductGroup?: Maybe<Scalars['Void']['output']>;
  triggerQualityCheckDryRun?: Maybe<Scalars['Void']['output']>;
  unmatchTransactions?: Maybe<Scalars['Void']['output']>;
  unregisterPushDevice?: Maybe<Scalars['Void']['output']>;
  updateAIBookkeeperCutoverDate?: Maybe<Scalars['Void']['output']>;
  updateAccountReconciliation?: Maybe<Scalars['Void']['output']>;
  /** Work Items */
  updateAccountantReviewStates?: Maybe<Scalars['Void']['output']>;
  updateActionItemAssignmentStatus: Scalars['Void']['output'];
  updateActionItemStatus: Scalars['Void']['output'];
  updateActionItemWatchStatus: Scalars['Void']['output'];
  updateAffiliatedSubscriptionPrice?: Maybe<Scalars['Void']['output']>;
  updateApp?: Maybe<Scalars['Void']['output']>;
  updateAuditRules?: Maybe<Scalars['Void']['output']>;
  updateBillingAddress?: Maybe<Scalars['Void']['output']>;
  updateBillingPaymentMethod?: Maybe<Scalars['Void']['output']>;
  updateBillingSubscription?: Maybe<Scalars['Void']['output']>;
  updateCategory: Scalars['Void']['output'];
  updateCategoryStatus: Scalars['Void']['output'];
  updateClientReviewStates?: Maybe<Scalars['Void']['output']>;
  updateConnectPlaidLinkToken: PlaidLinkToken;
  updateConnection?: Maybe<Scalars['Void']['output']>;
  updateConnectionAccounts?: Maybe<Scalars['Void']['output']>;
  updateConnectionCutoverTime?: Maybe<Scalars['Void']['output']>;
  updateContract: Scalars['Void']['output'];
  updateDepartment: UpdateDepartmentResponse;
  updateDepartmentStatus?: Maybe<Scalars['Void']['output']>;
  /**
   * Aspects
   * Employees
   */
  updateEmployee?: Maybe<Scalars['Void']['output']>;
  updateEmployeeAffiliations?: Maybe<Scalars['Void']['output']>;
  updateExecutiveSummary?: Maybe<Scalars['Void']['output']>;
  updateFinchConnection: CreateConnectionResponse;
  updateGrant?: Maybe<Scalars['Void']['output']>;
  updateIntent?: Maybe<Scalars['Void']['output']>;
  /** Layouts */
  updateLayout: Layout;
  updateLegalEntity?: Maybe<Scalars['Void']['output']>;
  /** Legal Entity Preferences */
  updateLineClassDisplayName?: Maybe<Scalars['Void']['output']>;
  updateLocation: UpdateLocationResponse;
  updateLocationStatus?: Maybe<Scalars['Void']['output']>;
  updateNotificationChannelSetting?: Maybe<Scalars['Void']['output']>;
  /**
   * Teams management
   * Notifications
   */
  updateNotificationStatus?: Maybe<Scalars['Void']['output']>;
  updateObjectLink?: Maybe<Scalars['Void']['output']>;
  /** Object Mapping */
  updateObjectMappings: ObjectMappingHierarchies;
  updateOrganization?: Maybe<Scalars['Void']['output']>;
  updateOrganizationIcon?: Maybe<Scalars['Void']['output']>;
  updateOrganizationPreferences?: Maybe<Scalars['Void']['output']>;
  updatePartyFields?: Maybe<Scalars['Void']['output']>;
  updatePlaidConnection?: Maybe<Scalars['Void']['output']>;
  updateProductsActive?: Maybe<Scalars['Void']['output']>;
  /** Quality Control */
  updateQualityCheck?: Maybe<Scalars['Void']['output']>;
  updateQuickBooksCredentials?: Maybe<Scalars['Void']['output']>;
  /** Customer Quotes */
  updateQuotePackage: Scalars['Void']['output'];
  updateReconciliationFlagResolution: ReconciliationFlag;
  updateReconciliationFlagTransactionDate?: Maybe<Scalars['Void']['output']>;
  /** Report automation settings */
  updateReportAutomationSettings: Scalars['Void']['output'];
  updateReportLayout: Layout;
  updateReportOptions?: Maybe<Scalars['Void']['output']>;
  updateReportPackage?: Maybe<Scalars['Void']['output']>;
  updateSchedule?: Maybe<Scalars['Void']['output']>;
  updateScheduleImportCandidateStatus?: Maybe<Scalars['Void']['output']>;
  updateTransaction?: Maybe<Scalars['Void']['output']>;
  updateTransactionBill?: Maybe<Scalars['Void']['output']>;
  updateTransactionFields?: Maybe<Scalars['Void']['output']>;
  updateTransactionInvoice?: Maybe<Scalars['Void']['output']>;
  updateTransactionReconciliationStatuses?: Maybe<Scalars['Void']['output']>;
  updateTransactionReviewQuestions?: Maybe<Scalars['Void']['output']>;
  updateTransactionReviewReminderMessage?: Maybe<Scalars['Void']['output']>;
  updateTransactionReviewSchedule?: Maybe<Scalars['Void']['output']>;
  updateUser?: Maybe<Scalars['Void']['output']>;
  updateUserLegalEntityRoles?: Maybe<Scalars['Void']['output']>;
  updateWebhookEndpoint: WebhookEndpoint;
  /**
   * Replaces the endpoint's OAuth client credentials wholesale. Omit
   * oauthClientCredentials to clear it and fall back to Event Signatures only.
   */
  updateWebhookEndpointOAuthCredential: WebhookEndpoint;
  upgradeGustoConnection: CreateConnectionResponse;
  upgradeStripeConnection: CreateConnectionResponse;
  uploadBulkCategory: Scalars['Void']['output'];
  uploadInvoicingProfileIcon: Scalars['String']['output'];
  /** Legal Entities */
  uploadLegalEntityIcon?: Maybe<Scalars['Void']['output']>;
  uploadOrganizationIcon?: Maybe<Scalars['Void']['output']>;
  uploadProductCatalogIcon: ProductCatalogIconUploadResult;
  uploadProfileIcon: Array<ProfileIconUploadResult>;
  uploadProfileIconFromWebsite: Array<ProfileIconUploadResult>;
  voidInvoice: Scalars['Void']['output'];
};


export type MutationAcceptAffiliationArgs = {
  organizationId: Scalars['String']['input'];
  proposalId: Scalars['String']['input'];
};


export type MutationAcceptAllTermsArgs = {
  legalEntityIds: Array<Scalars['String']['input']>;
  version: Scalars['String']['input'];
};


export type MutationAcceptTermsArgs = {
  version: Scalars['String']['input'];
};


export type MutationActivateCurrentUserEmploymentArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationActivateLegalEntityArgs = {
  id: Scalars['String']['input'];
};


export type MutationActivateRampConnectionArgs = {
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationAddAffiliatedSubscriptionPriceArgs = {
  affiliatedLegalEntityId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
};


export type MutationAddAssociationsArgs = {
  associationIdentifiers: Array<InputAssociationIdentifier>;
  legalEntityId: Scalars['String']['input'];
};


export type MutationAddDocumentFeatureArgs = {
  correctedFeatureId?: InputMaybe<Scalars['String']['input']>;
  documentCollectionId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  feature: NewDocumentFeature;
};


export type MutationAddSubscriptionItemArgs = {
  legalEntityId: Scalars['String']['input'];
  payerOrganizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
};


export type MutationApproveOAuthAuthorizationArgs = {
  clientId: Scalars['String']['input'];
  codeChallenge: Scalars['String']['input'];
  codeChallengeMethod: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type MutationApproveObjectAccessRequestArgs = {
  constraint?: InputMaybe<AccessConstraint>;
  permission: Permission;
  requestId: Scalars['String']['input'];
};


export type MutationArchiveComponentDataArgs = {
  config: LayoutComponentConfigInput;
  layoutId: Scalars['String']['input'];
  viewId: ViewIdentifierInput;
};


export type MutationArchiveConnectionArgs = {
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationArchiveConnectionAccountArgs = {
  connectionAccountId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationAttachReportPackageDocumentArgs = {
  attachments: NewReportAttachments;
  origin: IntervalOrigin;
  packageId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationAutoConfigureConnectionArgs = {
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationAutoConfigureProductArgs = {
  legalEntityId: Scalars['String']['input'];
  product: CategoryToLabelMappingProduct;
};


export type MutationBootstrapDepartmentsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type MutationBootstrapLocationsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type MutationBulkCreateOrReplyThreadsArgs = {
  assignee?: InputMaybe<Assignee>;
  comment: NewComment;
  targetObjects: Array<InputObjectIdentifier>;
  viewKey?: InputMaybe<ViewKey>;
};


export type MutationCancelBillingSubscriptionArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationCancelInvitationArgs = {
  token: Scalars['String']['input'];
};


export type MutationCancelReconciliationIntentsArgs = {
  legalEntityId: Scalars['String']['input'];
  reconciliationIntentIds: Array<Scalars['String']['input']>;
};


export type MutationCloseWorkItemsArgs = {
  closedWorkItems: Array<ClosedWorkItem>;
  legalEntityId: Scalars['String']['input'];
  viewKey?: InputMaybe<ViewKey>;
};


export type MutationClosedPeriodCreateSupersedingTransactionArgs = {
  legalEntityId: Scalars['String']['input'];
  supersededLedgerTransactionIds: Array<Scalars['String']['input']>;
  transaction: InputTransaction;
};


export type MutationClosedPeriodCreateTransactionArgs = {
  legalEntityId: Scalars['String']['input'];
  transaction: InputTransaction;
};


export type MutationClosedPeriodDeleteTransactionsArgs = {
  factIds: Array<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
};


export type MutationClosedPeriodMatchArgs = {
  ledgerTransactionIds: Array<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
};


export type MutationClosedPeriodUnmatchArgs = {
  ledgerTransactionIds: Array<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
};


export type MutationClosedPeriodUpdateTransactionArgs = {
  filter: TransactionFilter;
  legalEntityId: Scalars['String']['input'];
  transaction: InputTransaction;
};


export type MutationConfirmAccountantClientArgs = {
  affiliatedLegalEntityId: Scalars['String']['input'];
  affiliatedOrganizationId: Scalars['String']['input'];
  hasConnections?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationConfirmAffiliatedSubscriptionArgs = {
  affiliatedLegalEntityId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  stripePaymentMethodId: Scalars['String']['input'];
};


export type MutationConfirmBillingSubscriptionArgs = {
  customerId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  stripePaymentMethodId: Scalars['String']['input'];
};


export type MutationConfirmClientPaysArgs = {
  legalEntityId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationConfirmCustomQualityCheckInstructionArgs = {
  checkId: Scalars['String']['input'];
  instructionId: Scalars['String']['input'];
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationConfirmOperatorResetArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type MutationConfirmOperatorTrialArgs = {
  legalEntityId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationConfirmTotpEnrollmentArgs = {
  code: Scalars['String']['input'];
  factorId: Scalars['String']['input'];
};


export type MutationCopyReportPackageArgs = {
  attachments: NewReportAttachments;
  interval: Interval;
  packageId: Scalars['String']['input'];
  periodEndAt: DateInput;
  periodStartAt: DateInput;
  title: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationCreateAccountReconciliationArgs = {
  legalEntityId: Scalars['String']['input'];
  reconciliation: InputAccountReconciliation;
  viewKey: ViewKey;
};


export type MutationCreateAffiliatedSubscriptionArgs = {
  affiliatedLegalEntityId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  promoCodeId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId: Scalars['String']['input'];
};


export type MutationCreateAffiliationFromOAuthIdentityArgs = {
  organizationId: Scalars['String']['input'];
  proposalOrganizationId?: InputMaybe<Scalars['String']['input']>;
  realmId: Scalars['String']['input'];
  service: OAuthService;
};


export type MutationCreateAffiliationFromOAuthServiceArgs = {
  code: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  proposalOrganizationId?: InputMaybe<Scalars['String']['input']>;
  service: OAuthService;
};


export type MutationCreateAppArgs = {
  acceptedTermsOfServiceVersion: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  developerEmail: Scalars['String']['input'];
  homepageUrl: Scalars['String']['input'];
  iconBase64: Scalars['String']['input'];
  installUri?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  redirectUris?: InputMaybe<Array<Scalars['String']['input']>>;
  scopes: Array<Scalars['String']['input']>;
  supportEmail: Scalars['String']['input'];
  tagline: Scalars['String']['input'];
};


export type MutationCreateBillConnectionArgs = {
  connectorId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationCreateBillingOnboardingSubscriptionArgs = {
  organizationId: Scalars['String']['input'];
  productName?: InputMaybe<BillingProductName>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateBillingSubscriptionArgs = {
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateBooksClosedDateArgs = {
  booksClosedDate?: InputMaybe<Scalars['Float']['input']>;
  legalEntityId: Scalars['String']['input'];
};


export type MutationCreateCategoryArgs = {
  category: CreateCategoryInput;
  legalEntityId: Scalars['String']['input'];
};


export type MutationCreateCategoryMappingArgs = {
  categoryId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  mappingType: CategoryToLabelMappingType;
  mappingValue: Scalars['String']['input'];
  product: CategoryToLabelMappingProduct;
};


export type MutationCreateClientPaysSubscriptionArgs = {
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  promoCodeId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId: Scalars['String']['input'];
};


export type MutationCreateConnectPlaidLinkTokenArgs = {
  connectorId?: InputMaybe<Scalars['String']['input']>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  linkCustomizationName?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateConnectionArgs = {
  connectorId: Scalars['String']['input'];
  credential?: InputMaybe<ConnectCredentialInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  institution: ConnectInstitutionInput;
  legalEntityId: Scalars['String']['input'];
  status: ConnectionStatus;
};


export type MutationCreateDepartmentArgs = {
  department: CreateDepartmentInput;
  viewKey: ViewKey;
};


export type MutationCreateEmployeeAffiliationsArgs = {
  affiliations: Array<LegalEntityRole>;
  emailAddress: Scalars['String']['input'];
  employeeId?: InputMaybe<Scalars['String']['input']>;
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  organizationRole: Scalars['String']['input'];
};


export type MutationCreateFinchConnectionArgs = {
  authorizationCode: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationCreateFinchSessionArgs = {
  connectorId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  payrollProvider?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateFirmAffiliationArgs = {
  address?: InputMaybe<AddressInput>;
  minimalCoa?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateFirmAffiliationFromOAuthServiceArgs = {
  code: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  service: OAuthService;
};


export type MutationCreateGustoConnectionArgs = {
  authorizationCode: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationCreateIntentArgs = {
  constraint?: InputMaybe<AccessConstraint>;
  message: Scalars['String']['input'];
  object: InputObjectIdentifier;
  permissions: Array<NewUserGrant>;
  sendNotification: Scalars['Boolean']['input'];
  viewKey?: InputMaybe<ViewKey>;
};


export type MutationCreateLegalEntityFromOAuthIdentityArgs = {
  realmId: Scalars['String']['input'];
  service: OAuthService;
};


export type MutationCreateLegalEntityFromOAuthServiceArgs = {
  code: Scalars['String']['input'];
  service: OAuthService;
};


export type MutationCreateLocationArgs = {
  location: CreateLocationInput;
  viewKey: ViewKey;
};


export type MutationCreateManyTransactionsArgs = {
  legalEntityId: Scalars['String']['input'];
  transactions: Array<InputTransaction>;
};


export type MutationCreateOrganizationArgs = {
  iconObjectName?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  kind: OrganizationKind;
  name: Scalars['String']['input'];
  numberOfAccountants?: InputMaybe<Scalars['String']['input']>;
  numberOfClients?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreatePartiesArgs = {
  legalEntityId: Scalars['String']['input'];
  partyNames: Array<Scalars['String']['input']>;
};


export type MutationCreatePasswordResetArgs = {
  emailAddress: Scalars['String']['input'];
};


export type MutationCreatePlaidConnectionArgs = {
  accounts: Array<PlaidAccount>;
  connectorId: Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
  institutionName: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
};


export type MutationCreatePortalArgs = {
  viewId: ViewIdentifierInput;
};


export type MutationCreateRampConnectionArgs = {
  authorizationCode: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationCreateReactionArgs = {
  commentId: Scalars['String']['input'];
  reaction: CommentReaction;
  threadId: Scalars['String']['input'];
};


export type MutationCreateReconciliationFlagsTransactionsArgs = {
  flags: Array<CreateReconciliationFlagsTransactionsInput>;
  reconciliationIntentId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationCreateReconciliationIntentsArgs = {
  actionItemId?: InputMaybe<Scalars['String']['input']>;
  documentCollectionId?: InputMaybe<Scalars['String']['input']>;
  documentIds: Array<Scalars['String']['input']>;
  intentCategoryId?: InputMaybe<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
  reconciliationCategoryId?: InputMaybe<Scalars['String']['input']>;
  reconciliationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateReportFromUploadArgs = {
  legalEntityId: Scalars['String']['input'];
  reports: Array<NewReportUpload>;
};


export type MutationCreateReportPackageArgs = {
  attachments: NewReportAttachments;
  coverUrl?: InputMaybe<Scalars['String']['input']>;
  interval: Interval;
  periodEndAt: DateInput;
  periodStartAt: DateInput;
  title: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationCreateScheduleArgs = {
  legalEntityId: Scalars['String']['input'];
  recategorizeSource?: InputMaybe<SourceRecategorizationInput>;
  schedule: ScheduleInput;
  scheduleImportCandidateId?: InputMaybe<Scalars['String']['input']>;
  viewKey?: InputMaybe<ViewKey>;
};


export type MutationCreateStripeConnectionArgs = {
  connectorId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationCreateSupersedingTransactionArgs = {
  legalEntityId: Scalars['String']['input'];
  supersededLedgerTransactionIds: Array<Scalars['String']['input']>;
  transaction: InputTransaction;
};


export type MutationCreateThreadArgs = {
  assignee?: InputMaybe<Assignee>;
  comment: NewComment;
  context?: InputMaybe<Scalars['String']['input']>;
  targetObject: InputObjectIdentifier;
  viewKey?: InputMaybe<ViewKey>;
};


export type MutationCreateTransactionArgs = {
  legalEntityId: Scalars['String']['input'];
  transaction: InputTransaction;
};


export type MutationCreateWebhookEndpointArgs = {
  connectorId: Scalars['String']['input'];
  endpointUrl: Scalars['String']['input'];
  environment: AppEnvironment;
  eventCategories: Array<WebhookEventCategory>;
  oauthClientCredentials?: InputMaybe<WebhookEndpointOAuthClientCredentialsInput>;
  organizationId: Scalars['String']['input'];
};


export type MutationDeactivateEmployeeArgs = {
  employeeId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationDeclineAppArgs = {
  clientId: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteAccountReconciliationArgs = {
  legalEntityId: Scalars['String']['input'];
  reconciliationId: Scalars['String']['input'];
};


export type MutationDeleteCommentArgs = {
  commentId: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};


export type MutationDeleteConnectionAccountArgs = {
  connectionAccountId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationDeleteDataSourceArgs = {
  dataSourceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  providerType: ProviderType;
};


export type MutationDeleteDocumentArgs = {
  documentCollectionId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationDeleteDraftInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationDeleteEmployeeAffiliationsArgs = {
  employeeIdentifier: EmployeeIdentifier;
  legalEntityIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteOrganizationBrandingArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationDeletePotentialDuplicateFlagTransactionsArgs = {
  flag: DeletePotentialDuplicateFlagTransactionsInput;
  reconciliationIntentId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationDeleteProductGroupArgs = {
  legalEntityId: Scalars['String']['input'];
  productGroupId: Scalars['String']['input'];
};


export type MutationDeleteProductVariantArgs = {
  dataSourceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
};


export type MutationDeleteProductVariantPriceArgs = {
  dataSourceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
};


export type MutationDeleteReactionArgs = {
  commentId: Scalars['String']['input'];
  reaction: CommentReaction;
  threadId: Scalars['String']['input'];
};


export type MutationDeleteReportPackageArgs = {
  legalEntityId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
};


export type MutationDeleteScheduleArgs = {
  legalEntityId: Scalars['String']['input'];
  scheduleId: Scalars['String']['input'];
  scheduleTemplateId: Scalars['String']['input'];
};


export type MutationDeleteTransactionsArgs = {
  factIds: Array<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
};


export type MutationDeleteWebhookEndpointArgs = {
  connectorId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  webhookEndpointId: Scalars['String']['input'];
};


export type MutationDeregisterAppInstanceArgs = {
  id: Scalars['String']['input'];
};


export type MutationDestroyConnectionArgs = {
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationDisableObjectLinkArgs = {
  object: InputObjectIdentifier;
};


export type MutationDisableTotpArgs = {
  factorId: Scalars['String']['input'];
  method: MfaMethod;
  verificationCode: Scalars['String']['input'];
};


export type MutationDisableWebhookEndpointArgs = {
  connectorId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  webhookEndpointId: Scalars['String']['input'];
};


export type MutationDisaffiliateLegalEntityArgs = {
  affiliatedLegalEntityId: Scalars['String']['input'];
  affiliatedOrganizationId: Scalars['String']['input'];
  affiliationId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationDraftCustomQualityCheckInstructionArgs = {
  checkId: Scalars['String']['input'];
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  userInstruction: Scalars['String']['input'];
};


export type MutationDraftQualityCheckInstructionArgs = {
  checkId: Scalars['String']['input'];
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  userInstruction: Scalars['String']['input'];
};


export type MutationDuplicateInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationEditAffiliationBusinessArgs = {
  legalEntityId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditCommentArgs = {
  comment: NewComment;
  commentId: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};


export type MutationEditFieldRequestArgs = {
  legalEntityId: Scalars['String']['input'];
  newValue: ClosedPeriodTransactionChangeValueInput;
  rejectionReason: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  transactionChangeId: Scalars['String']['input'];
};


export type MutationEditReportPackageArgs = {
  packageId: Scalars['String']['input'];
  packageVersionId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationEnableObjectLinkArgs = {
  object: InputObjectIdentifier;
  permission?: InputMaybe<Permission>;
  viewType?: InputMaybe<ViewType>;
};


export type MutationEnableWebhookEndpointArgs = {
  connectorId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  webhookEndpointId: Scalars['String']['input'];
};


export type MutationEnqueueStatementImportWorkflowsArgs = {
  input: EnqueueStatementImportWorkflowsInput;
};


export type MutationExportReconciliationsPdfsArgs = {
  documentCollectionId: Scalars['String']['input'];
  reconciliationIds: Array<Scalars['String']['input']>;
  viewKey: ViewKey;
};


export type MutationFinalizeAccountReconciliationArgs = {
  legalEntityId: Scalars['String']['input'];
  reconciliationId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationGenerateLayoutComponentPdfArgs = {
  config: LayoutComponentConfigInput;
  dataId?: InputMaybe<Scalars['String']['input']>;
  layoutId?: InputMaybe<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
  legalEntityName: Scalars['String']['input'];
  periodName: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  viewId: ViewIdentifierInput;
};


export type MutationGenerateReportPackagePdfArgs = {
  coverUrl?: InputMaybe<Scalars['String']['input']>;
  packageId: Scalars['String']['input'];
  packageVersionId: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  viewId: ViewIdentifierInput;
};


export type MutationGrantFromShareArgs = {
  constraint?: InputMaybe<AccessConstraint>;
  intentId?: InputMaybe<Scalars['String']['input']>;
  object: InputObjectIdentifier;
  viewKey?: InputMaybe<ViewKey>;
};


export type MutationInstallAppArgs = {
  clientId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  responseType: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLedgerApproveAndPayBillArgs = {
  billId: Scalars['String']['input'];
  instrumentId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationLedgerApproveBillArgs = {
  billId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationLedgerDeleteBillArgs = {
  billId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationLedgerDeleteDraftInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationLedgerDuplicateInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationLedgerMarkBillAsPaidArgs = {
  billId: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
  datePaid: Scalars['DateTime']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  viewKey: ViewKey;
};


export type MutationLedgerMarkDraftInvoiceAsPaidArgs = {
  categoryId: Scalars['String']['input'];
  datePaid: Scalars['DateTime']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  viewKey: ViewKey;
};


export type MutationLedgerMarkInvoiceAsPaidArgs = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  datePaid: Scalars['DateTime']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  viewKey: ViewKey;
};


export type MutationLedgerPayBillArgs = {
  billId: Scalars['String']['input'];
  instrumentId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationLedgerPayInvoiceArgs = {
  expectedAmount: InputMonetaryValue;
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  paymentInstrumentId: Scalars['String']['input'];
};


export type MutationLedgerRejectBillArgs = {
  billId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationLedgerResendInvoiceArgs = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  companyIcon?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  coverURL?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceId: Scalars['String']['input'];
  invoiceNumber: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  totalAmount: InputMonetaryValue;
};


export type MutationLedgerResendInvoiceManuallyArgs = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  companyIcon?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  coverURL?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceId: Scalars['String']['input'];
  invoiceNumber: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  totalAmount: InputMonetaryValue;
};


export type MutationLedgerRetryBillPaymentArgs = {
  billId: Scalars['String']['input'];
  sourcePaymentInstrumentId?: InputMaybe<Scalars['String']['input']>;
  viewKey: ViewKey;
};


export type MutationLedgerRetryBillPayoutsArgs = {
  billIds: Array<Scalars['String']['input']>;
  correctedDestinationPaymentInstrumentId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationLedgerSaveBillArgs = {
  approverUserId?: InputMaybe<Scalars['String']['input']>;
  bill: LedgerInputBill;
  legalEntityId: Scalars['String']['input'];
};


export type MutationLedgerSaveInvoiceArgs = {
  invoice: LedgerInputInvoice;
  legalEntityId: Scalars['String']['input'];
};


export type MutationLedgerSaveInvoiceCustomerArgs = {
  customer: InputLedgerCustomer;
  legalEntityId: Scalars['String']['input'];
};


export type MutationLedgerSaveInvoiceDiscountArgs = {
  discount: InputDataSourceDiscount;
  legalEntityId: Scalars['String']['input'];
};


export type MutationLedgerSaveInvoiceEmailConfigArgs = {
  bcc?: InputMaybe<Array<Scalars['String']['input']>>;
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  memo?: InputMaybe<Scalars['String']['input']>;
  recipients?: InputMaybe<Array<Scalars['String']['input']>>;
  subject?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLedgerSaveInvoiceProductArgs = {
  legalEntityId: Scalars['String']['input'];
  product: InputInvoiceProduct;
  viewKey: ViewKey;
};


export type MutationLedgerSaveInvoicingProfileArgs = {
  legalEntityId: Scalars['String']['input'];
  profile: InputInvoicingProfile;
};


export type MutationLedgerScheduleSendForApprovalArgs = {
  billId: Scalars['String']['input'];
  scheduleSendForApprovalAt: Scalars['DateTime']['input'];
  viewKey: ViewKey;
};


export type MutationLedgerSendForApprovalArgs = {
  billId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationLedgerSendInvoiceArgs = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  companyIcon?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  coverURL?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceId: Scalars['String']['input'];
  invoiceNumber: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  totalAmount: InputMonetaryValue;
};


export type MutationLedgerSendInvoiceManuallyArgs = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  companyIcon?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  coverURL?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceId: Scalars['String']['input'];
  invoiceNumber: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  totalAmount: InputMonetaryValue;
};


export type MutationLedgerSetDataSourceBillRoleArgs = {
  dataSourceBillId: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  role: BillAccessRole;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLedgerSetInvoiceBrandingArgs = {
  branding: InputInvoiceBranding;
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationLedgerStartBillSplitLineItemsWorkflowArgs = {
  dataSourceBillId: Scalars['String']['input'];
  documentCollectionId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationLedgerStartBillWorkflowFromDocumentArgs = {
  documentCollectionId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  objectToken: Scalars['String']['input'];
};


export type MutationLedgerSubmitInvoiceCardPaymentArgs = {
  billingAddress?: InputMaybe<CardBillingAddressInput>;
  browserInfo?: InputMaybe<Scalars['String']['input']>;
  expectedAmount: InputMonetaryValue;
  holderName?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  payerLegalEntityId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodData: Scalars['String']['input'];
  requestedTestAcquirerResponseCode?: InputMaybe<Scalars['String']['input']>;
  returnUrl: Scalars['String']['input'];
  riskData?: InputMaybe<Scalars['String']['input']>;
  storePaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationLedgerVoidBillArgs = {
  billId: Scalars['String']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
};


export type MutationLedgerVoidInvoiceArgs = {
  internalNote?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationLogCustomerEventsArgs = {
  events: Array<CustomerEvent>;
};


export type MutationMarkDraftInvoiceAsPaidArgs = {
  datePaid: Scalars['DateTime']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationMarkInvoiceAsPaidArgs = {
  datePaid: Scalars['DateTime']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationMatchPotentialDuplicateFlagTransactionsArgs = {
  flag: MatchPotentialDuplicateFlagTransactionsInput;
  reconciliationIntentId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationMatchTransactionsArgs = {
  ledgerTransactionIds: Array<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
};


export type MutationMigrateDepartmentQuickBooksArgs = {
  departmentFactIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lineClassFactIds?: InputMaybe<Array<Scalars['String']['input']>>;
  viewKey: ViewKey;
};


export type MutationMigrateLocationQuickBooksArgs = {
  departmentFactIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lineClassFactIds?: InputMaybe<Array<Scalars['String']['input']>>;
  viewKey: ViewKey;
};


export type MutationOnboardLegalEntityArgs = {
  contact: ContactInput;
  minimalCoa?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOnboardLegalEntityFromOAuthServiceArgs = {
  code: Scalars['String']['input'];
  service: OAuthService;
};


export type MutationPayInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  paymentInstrumentId: Scalars['String']['input'];
  receivableInvoiceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProvisionClientPaysSubscriptionArgs = {
  affiliatedLegalEntityId: Scalars['String']['input'];
  affiliatedOrganizationId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  firmOrganizationId: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  message: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
};


export type MutationProvisionLegalEntityArgs = {
  affiliatedOrganizationId?: InputMaybe<Scalars['String']['input']>;
  iconObjectName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProvisionTrialBillingSubscriptionArgs = {
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  promoCodeId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId: Scalars['String']['input'];
};


export type MutationPublishAppArgs = {
  connectorId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationPublishReportPackageArgs = {
  legalEntityId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
  packageVersionId: Scalars['String']['input'];
  publishAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  sendNotification?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPushDigitsWorkItemsArgs = {
  legalEntityId: Scalars['String']['input'];
  workItems: Array<DigitsWorkItemPushParams>;
};


export type MutationPushWorkItemsArgs = {
  legalEntityId: Scalars['String']['input'];
  workItems: Array<WorkItemPushParams>;
};


export type MutationReauthorizeFinchSessionArgs = {
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationRefreshDataSourceArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type MutationRefreshReportPackageArgs = {
  packageId: Scalars['String']['input'];
  packageVersionId?: InputMaybe<Scalars['String']['input']>;
  viewKey: ViewKey;
};


export type MutationRegisterAppInstanceArgs = {
  challenge: AppInstanceChallenge;
  deviceId: Scalars['String']['input'];
  profile: AppInstanceProfile;
  publicKey: Scalars['String']['input'];
};


export type MutationRegisterPushDeviceArgs = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  apple: ApplePushConfigInput;
  buildNumber?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationRejectAffiliationArgs = {
  proposalId: Scalars['String']['input'];
};


export type MutationRejectFieldRequestArgs = {
  legalEntityId: Scalars['String']['input'];
  rejectionReason: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  transactionChangeId: Scalars['String']['input'];
};


export type MutationRejectObjectAccessRequestArgs = {
  requestId: Scalars['String']['input'];
};


export type MutationRemoveAssociationsArgs = {
  associationIdentifiers: Array<InputAssociationIdentifier>;
  legalEntityId: Scalars['String']['input'];
};


export type MutationRemoveFirmAffiliationArgs = {
  affiliatedLegalEntityId: Scalars['String']['input'];
  affiliationId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationReopenAccountReconciliationArgs = {
  legalEntityId: Scalars['String']['input'];
  reconciliationId: Scalars['String']['input'];
};


export type MutationReopenWorkItemArgs = {
  legalEntityId: Scalars['String']['input'];
  workItemId: Scalars['String']['input'];
};


export type MutationReplyThreadArgs = {
  assignee?: InputMaybe<Assignee>;
  comment: NewComment;
  threadId: Scalars['String']['input'];
  viewKey?: InputMaybe<ViewKey>;
};


export type MutationRequestAccessArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type MutationRequestObjectAccessArgs = {
  constraint?: InputMaybe<AccessConstraint>;
  intentId?: InputMaybe<Scalars['String']['input']>;
  object: InputObjectIdentifier;
};


export type MutationResendInvitationArgs = {
  token: Scalars['String']['input'];
};


export type MutationResendInvoiceArgs = {
  branding?: InputMaybe<InputInvoiceBranding>;
  customer?: InputMaybe<InputCustomer>;
  invoice?: InputMaybe<InputInvoice>;
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  profile?: InputMaybe<InputInvoicingProfile>;
  receivableInvoiceId: Scalars['String']['input'];
};


export type MutationResendInvoiceManuallyArgs = {
  branding?: InputMaybe<InputInvoiceBranding>;
  customer?: InputMaybe<InputCustomer>;
  invoice?: InputMaybe<InputInvoice>;
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  profile?: InputMaybe<InputInvoicingProfile>;
  receivableInvoiceId: Scalars['String']['input'];
};


export type MutationResendManagedOperatorInvitationArgs = {
  emailAddress: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationResetCustomQualityCheckInstructionArgs = {
  checkId: Scalars['String']['input'];
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetFirmAffiliationArgs = {
  affiliatedLegalEntityId: Scalars['String']['input'];
  affiliationId: Scalars['String']['input'];
  minimalCoa?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationResetFirmAffiliationFromOAuthServiceArgs = {
  affiliatedLegalEntityId: Scalars['String']['input'];
  affiliationId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  service: OAuthService;
};


export type MutationResetOperatorLegalEntityArgs = {
  legalEntityId: Scalars['String']['input'];
  minimalCoa?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};


export type MutationResetOperatorLegalEntityFromOAuthServiceArgs = {
  code: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  service: OAuthService;
};


export type MutationResolveClosedPeriodRequestArgs = {
  legalEntityId: Scalars['String']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
  requestType: ClosedPeriodRequestType;
  resolution: ClosedPeriodRequestResolution;
};


export type MutationResolvePotentialMismatchFlagArgs = {
  flag: ResolvePotentialMismatchInput;
  reconciliationIntentId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationResolveThreadArgs = {
  threadId: Scalars['String']['input'];
  viewKey?: InputMaybe<ViewKey>;
};


export type MutationRetryWebhookEndpointDeliveryArgs = {
  connectorId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  webhookDeliveryId: Scalars['String']['input'];
  webhookEndpointId: Scalars['String']['input'];
};


export type MutationRevokeGrantArgs = {
  constraint?: InputMaybe<AccessConstraint>;
  grantId: Scalars['String']['input'];
  object: InputObjectIdentifier;
};


export type MutationRevokeIntentArgs = {
  constraint?: InputMaybe<AccessConstraint>;
  intentId: Scalars['String']['input'];
  object: InputObjectIdentifier;
};


export type MutationRotateWebhookEndpointSecretArgs = {
  connectorId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  webhookEndpointId: Scalars['String']['input'];
};


export type MutationSaveBusinessVerificationApplicationArgs = {
  application: BusinessVerificationApplicationInput;
  legalEntityId: Scalars['String']['input'];
};


export type MutationSaveDraftInvoiceArgs = {
  invoice: InputInvoice;
  legalEntityId: Scalars['String']['input'];
};


export type MutationSaveInvoiceBrandingArgs = {
  branding: InputInvoiceBranding;
  legalEntityId: Scalars['String']['input'];
};


export type MutationSaveInvoiceCustomerArgs = {
  customer: InputCustomer;
  legalEntityId: Scalars['String']['input'];
};


export type MutationSaveInvoiceDiscountArgs = {
  discount: InputDataSourceDiscount;
  legalEntityId: Scalars['String']['input'];
};


export type MutationSaveInvoiceProductArgs = {
  legalEntityId: Scalars['String']['input'];
  product: InputInvoiceProduct;
};


export type MutationSaveInvoicingProfileArgs = {
  legalEntityId: Scalars['String']['input'];
  profile: InputInvoicingProfile;
};


export type MutationSaveOrganizationBrandingArgs = {
  branding: InputOrganizationBranding;
  organizationId: Scalars['String']['input'];
};


export type MutationSaveProductArgs = {
  legalEntityId: Scalars['String']['input'];
  product: ProductInput;
  providerType: ProviderType;
};


export type MutationSaveProductGroupArgs = {
  group: ProductGroupInput;
  legalEntityId: Scalars['String']['input'];
};


export type MutationSaveProductVariantArgs = {
  legalEntityId: Scalars['String']['input'];
  variant: ProductVariantInput;
};


export type MutationSaveProductVariantPriceArgs = {
  legalEntityId: Scalars['String']['input'];
  price: ProductVariantPriceInput;
};


export type MutationSendBusinessVerificationApplicationArgs = {
  ein?: InputMaybe<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
  ownerDOB: DateInput;
  ownerSSN: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
};


export type MutationSendInvitationArgs = {
  defaultEntityRole?: InputMaybe<Scalars['String']['input']>;
  destinationOrganizationId?: InputMaybe<Scalars['String']['input']>;
  destinationOrganizationRole?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  invitationType: Scalars['String']['input'];
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  legalEntityRoles?: InputMaybe<Array<LegalEntityRole>>;
  message?: InputMaybe<Scalars['String']['input']>;
  proposalType?: InputMaybe<Scalars['String']['input']>;
  recipient: ContactInput;
};


export type MutationSendInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationSendInvoiceManuallyArgs = {
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationSendManagedOperatorInvitationArgs = {
  context?: InputMaybe<ArrivalContext>;
  contextObject?: InputMaybe<InputObjectIdentifier>;
  legalEntityId: Scalars['String']['input'];
  legalEntityRole?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  recipient: ContactInput;
  redirectPath?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendManagedOperatorResetArgs = {
  affiliatedLegalEntityId: Scalars['String']['input'];
  firmOrganizationId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationSendTransactionReviewReminderArgs = {
  legalEntityId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationSendWebhookEndpointTestEventArgs = {
  connectorId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  webhookEndpointId: Scalars['String']['input'];
};


export type MutationSetDefaultApproverArgs = {
  legalEntityId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetRequireBillApproverDifferentFromCreatorArgs = {
  legalEntityId: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
};


export type MutationSetupSubscriptionArgs = {
  legalEntityId: Scalars['String']['input'];
  payerOrganizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  stripePaymentMethodId: Scalars['String']['input'];
  stripePromoCodeId?: InputMaybe<Scalars['String']['input']>;
  trial: SetupSubscriptionTrial;
  viewerOrganizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStartBulkCsvImportArgs = {
  input: StartBulkCsvImportInput;
};


export type MutationStartJournalEntriesImportArgs = {
  input: StartJournalEntriesImportInput;
};


export type MutationSubmitAccountantOnboardingArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type MutationSubmitInvoiceCardPaymentArgs = {
  billingAddress?: InputMaybe<CardBillingAddressInput>;
  browserInfo?: InputMaybe<Scalars['String']['input']>;
  holderName?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  payerLegalEntityId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodData: Scalars['String']['input'];
  requestedTestAcquirerResponseCode?: InputMaybe<Scalars['String']['input']>;
  returnUrl: Scalars['String']['input'];
  riskData?: InputMaybe<Scalars['String']['input']>;
  storePaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSyncConnectionArgs = {
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationTransferProductsAndDeleteProductGroupArgs = {
  legalEntityId: Scalars['String']['input'];
  sourceProductGroupId: Scalars['String']['input'];
  targetProductGroupId: Scalars['String']['input'];
};


export type MutationTriggerQualityCheckDryRunArgs = {
  checkId: Scalars['String']['input'];
  draftInstructionId?: InputMaybe<Scalars['String']['input']>;
  viewKey: ViewKey;
};


export type MutationUnmatchTransactionsArgs = {
  ledgerTransactionIds: Array<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
};


export type MutationUnregisterPushDeviceArgs = {
  deviceId: Scalars['String']['input'];
};


export type MutationUpdateAiBookkeeperCutoverDateArgs = {
  cutoverDate: Scalars['DateTime']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationUpdateAccountReconciliationArgs = {
  legalEntityId: Scalars['String']['input'];
  reconciliationId: Scalars['String']['input'];
  update: InputAccountReconciliationUpdate;
  viewKey: ViewKey;
};


export type MutationUpdateAccountantReviewStatesArgs = {
  legalEntityId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  period: PeriodInput;
  workItemSubjects: Array<WorkItemSubject>;
};


export type MutationUpdateActionItemAssignmentStatusArgs = {
  action?: InputMaybe<ActionItemAction>;
  actionItemId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  organizationAssignees: Array<OrganizationAssignee>;
  userAssignees: Array<UserAssignee>;
};


export type MutationUpdateActionItemStatusArgs = {
  action?: InputMaybe<ActionItemAction>;
  actionItems?: InputMaybe<Array<ActionItemStatusChange>>;
  legalEntityId: Scalars['String']['input'];
};


export type MutationUpdateActionItemWatchStatusArgs = {
  action?: InputMaybe<ActionItemAction>;
  actionItemId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  watch: Scalars['Boolean']['input'];
};


export type MutationUpdateAffiliatedSubscriptionPriceArgs = {
  affiliatedLegalEntityId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationUpdateAppArgs = {
  connectorId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  developerEmail?: InputMaybe<Scalars['String']['input']>;
  homepageUrl?: InputMaybe<Scalars['String']['input']>;
  iconBase64?: InputMaybe<Scalars['String']['input']>;
  installUri?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  redirectUris?: InputMaybe<Array<Scalars['String']['input']>>;
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  termsOfServiceUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAuditRulesArgs = {
  isFTE?: InputMaybe<Scalars['Boolean']['input']>;
  legalEntityId: Scalars['String']['input'];
  rules: Array<UpdateAuditRule>;
  usedSuggestedCategories?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateBillingAddressArgs = {
  address: AddressInput;
  fullName: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationUpdateBillingPaymentMethodArgs = {
  organizationId: Scalars['String']['input'];
  stripePaymentMethodId: Scalars['String']['input'];
};


export type MutationUpdateBillingSubscriptionArgs = {
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
};


export type MutationUpdateCategoryArgs = {
  category: UpdateCategoryInput;
  legalEntityId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationUpdateCategoryStatusArgs = {
  categoryId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  legalEntityId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationUpdateClientReviewStatesArgs = {
  legalEntityId: Scalars['String']['input'];
  responses: Array<WorkItemResponse>;
};


export type MutationUpdateConnectPlaidLinkTokenArgs = {
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationUpdateConnectionArgs = {
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  settings: ConnectionSettingsInput;
};


export type MutationUpdateConnectionAccountsArgs = {
  accounts: Array<ConnectionAccountInput>;
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationUpdateConnectionCutoverTimeArgs = {
  connectionId: Scalars['String']['input'];
  cutoverTime: Scalars['DateTime']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationUpdateContractArgs = {
  id: Scalars['String']['input'];
  items: Array<ContractLineItemInput>;
  legalEntityId: Scalars['String']['input'];
};


export type MutationUpdateDepartmentArgs = {
  department: UpdateDepartmentInput;
  departmentId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationUpdateDepartmentStatusArgs = {
  departmentId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  viewKey: ViewKey;
};


export type MutationUpdateEmployeeArgs = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  defaultEntityRole?: InputMaybe<RoleIdentifier>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  fieldToUpdate: UpdatableEmployeeField;
  givenName?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
  role?: InputMaybe<RoleIdentifier>;
};


export type MutationUpdateEmployeeAffiliationsArgs = {
  affiliations: Array<LegalEntityRole>;
  employeeIdentifier: EmployeeIdentifier;
};


export type MutationUpdateExecutiveSummaryArgs = {
  documentId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateFinchConnectionArgs = {
  authorizationCode: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationUpdateGrantArgs = {
  constraint?: InputMaybe<AccessConstraint>;
  grantId: Scalars['String']['input'];
  object: InputObjectIdentifier;
  permission?: InputMaybe<Permission>;
  policy?: InputMaybe<GrantPolicy>;
};


export type MutationUpdateIntentArgs = {
  constraint?: InputMaybe<AccessConstraint>;
  intentId: Scalars['String']['input'];
  object: InputObjectIdentifier;
  permission?: InputMaybe<Permission>;
};


export type MutationUpdateLayoutArgs = {
  layout: LayoutInput;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  viewKey?: InputMaybe<ViewKey>;
};


export type MutationUpdateLegalEntityArgs = {
  address?: InputMaybe<AddressInput>;
  fiscalYearNumberOffset?: InputMaybe<Scalars['Int']['input']>;
  fiscalYearStartMonth?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  incorporatedOn?: InputMaybe<DateInput>;
  industry?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateLineClassDisplayNameArgs = {
  legalEntityId: Scalars['String']['input'];
  lineClassDisplayName: Scalars['String']['input'];
};


export type MutationUpdateLocationArgs = {
  location: UpdateLocationInput;
  locationId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationUpdateLocationStatusArgs = {
  enabled: Scalars['Boolean']['input'];
  locationId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationUpdateNotificationChannelSettingArgs = {
  channelKind: ChannelKind;
  enabled: Scalars['Boolean']['input'];
  eventType: EventType;
  legalEntityId: Scalars['String']['input'];
};


export type MutationUpdateNotificationStatusArgs = {
  id: Scalars['String']['input'];
  status: WebNotificationStatus;
};


export type MutationUpdateObjectLinkArgs = {
  object: InputObjectIdentifier;
  permission?: InputMaybe<Permission>;
};


export type MutationUpdateObjectMappingsArgs = {
  departmentIds: Array<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
  lineClassIds: Array<Scalars['String']['input']>;
  mappedTo: ObjectKind;
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOrganizationIconArgs = {
  iconObjectName?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationUpdateOrganizationPreferencesArgs = {
  anonymizeEmployees: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};


export type MutationUpdatePartyFieldsArgs = {
  legalEntityId: Scalars['String']['input'];
  updates: Array<InputUpdatePartyFields>;
};


export type MutationUpdatePlaidConnectionArgs = {
  accounts: Array<PlaidAccount>;
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationUpdateProductsActiveArgs = {
  input: UpdateProductsActiveInput;
};


export type MutationUpdateQualityCheckArgs = {
  checkId: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateQuickBooksCredentialsArgs = {
  code: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  service: OAuthService;
};


export type MutationUpdateQuotePackageArgs = {
  companyDetails: CompanyDetailsInput;
  contractDocumentId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  recipient?: InputMaybe<ContactInput>;
};


export type MutationUpdateReconciliationFlagResolutionArgs = {
  flagId: Scalars['String']['input'];
  reconciliationIntentId: Scalars['String']['input'];
  resolutionType: ReconciliationFlagResolutionType;
  resolved: Scalars['Boolean']['input'];
  viewKey: ViewKey;
};


export type MutationUpdateReconciliationFlagTransactionDateArgs = {
  flag: UpdateReconciliationFlagTransactionDateInput;
  reconciliationIntentId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationUpdateReportAutomationSettingsArgs = {
  autoCreateDraft: Scalars['Boolean']['input'];
  autoPublishDraft: Scalars['Boolean']['input'];
  autoPublishDraftDay: Scalars['Int']['input'];
  autoPublishFinal: Scalars['Boolean']['input'];
  autoPublishFinalDay: Scalars['Int']['input'];
  interval: Interval;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type MutationUpdateReportLayoutArgs = {
  documentId: Scalars['String']['input'];
  layout: LayoutInput;
  packageId: Scalars['String']['input'];
  packageVersionId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type MutationUpdateReportOptionsArgs = {
  breakdownByClass?: InputMaybe<ReportBreakdownByClass>;
  categoryByDepartmentOptions?: InputMaybe<CategoryByDepartmentOptionsInput>;
  categoryByLocationOptions?: InputMaybe<CategoryByLocationOptionsInput>;
  collapsedSections?: InputMaybe<CollapsedSectionsInput>;
  comparedToIncome?: InputMaybe<ReportOptionComparison>;
  comparedToTotal?: InputMaybe<ReportOptionComparison>;
  deltaMonthOverMonth?: InputMaybe<ReportOptionComparison>;
  deltaYearOverYear?: InputMaybe<ReportOptionComparison>;
  legalEntityId: Scalars['String']['input'];
  packageVersionId: Scalars['String']['input'];
  reportId: Scalars['String']['input'];
  reportLookbackPeriods?: InputMaybe<Scalars['Int']['input']>;
  reportPackageId: Scalars['String']['input'];
  reportVersionId: Scalars['String']['input'];
  sparklineLookbackPeriods?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateReportPackageArgs = {
  accountNumbersDisplay?: InputMaybe<AccountNumbersDisplay>;
  coverLogoSource?: InputMaybe<CoverLogoSource>;
  coverUrl?: InputMaybe<Scalars['String']['input']>;
  customFooter?: InputMaybe<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
  packageVersionId: Scalars['String']['input'];
  preparedBy?: InputMaybe<Scalars['String']['input']>;
  publishedAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateScheduleArgs = {
  legalEntityId: Scalars['String']['input'];
  schedule: ScheduleInput;
  viewKey?: InputMaybe<ViewKey>;
};


export type MutationUpdateScheduleImportCandidateStatusArgs = {
  legalEntityId: Scalars['String']['input'];
  scheduleImportCandidateId: Scalars['String']['input'];
  status: ScheduleImportCandidateStatus;
};


export type MutationUpdateTransactionArgs = {
  filter: TransactionFilter;
  legalEntityId: Scalars['String']['input'];
  transaction: InputTransaction;
};


export type MutationUpdateTransactionBillArgs = {
  bill: BillEdit;
  legalEntityId: Scalars['String']['input'];
};


export type MutationUpdateTransactionFieldsArgs = {
  legalEntityId: Scalars['String']['input'];
  updates: Array<InputUpdateFields>;
  viewKey: ViewKey;
};


export type MutationUpdateTransactionInvoiceArgs = {
  invoice: InvoiceEdit;
  legalEntityId: Scalars['String']['input'];
};


export type MutationUpdateTransactionReconciliationStatusesArgs = {
  statusUpdates: Array<InputStatusUpdate>;
  viewKey: ViewKey;
};


export type MutationUpdateTransactionReviewQuestionsArgs = {
  deletedQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  newQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId: Scalars['String']['input'];
};


export type MutationUpdateTransactionReviewReminderMessageArgs = {
  legalEntityId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationUpdateTransactionReviewScheduleArgs = {
  daysOfMonth?: InputMaybe<Array<DayOfMonth>>;
  daysOfWeek?: InputMaybe<Array<DayOfWeek>>;
  enabled: Scalars['Boolean']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserLegalEntityRolesArgs = {
  deletes?: InputMaybe<Array<UserLegalEntityRoleDelete>>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<UpdateUserLegalEntityRoleEntry>>;
};


export type MutationUpdateWebhookEndpointArgs = {
  connectorId: Scalars['String']['input'];
  endpointUrl: Scalars['String']['input'];
  eventCategories: Array<WebhookEventCategory>;
  organizationId: Scalars['String']['input'];
  webhookEndpointId: Scalars['String']['input'];
};


export type MutationUpdateWebhookEndpointOAuthCredentialArgs = {
  connectorId: Scalars['String']['input'];
  oauthClientCredentials?: InputMaybe<WebhookEndpointOAuthClientCredentialsInput>;
  organizationId: Scalars['String']['input'];
  webhookEndpointId: Scalars['String']['input'];
};


export type MutationUpgradeGustoConnectionArgs = {
  authorizationCode: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  cutoverTime?: InputMaybe<Scalars['DateTime']['input']>;
  legalEntityId: Scalars['String']['input'];
};


export type MutationUpgradeStripeConnectionArgs = {
  connectionId: Scalars['String']['input'];
  cutoverTime?: InputMaybe<Scalars['DateTime']['input']>;
  externalId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationUploadBulkCategoryArgs = {
  categories: Array<CreateBulkCategoryInput>;
  fileName: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationUploadInvoicingProfileIconArgs = {
  iconBase64: Scalars['String']['input'];
  orgName: Scalars['String']['input'];
};


export type MutationUploadLegalEntityIconArgs = {
  iconBase64: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUploadOrganizationIconArgs = {
  iconBase64: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUploadProductCatalogIconArgs = {
  iconBase64: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type MutationUploadProfileIconArgs = {
  iconBase64: Scalars['String']['input'];
  kinds: Array<ProfileIconKind>;
};


export type MutationUploadProfileIconFromWebsiteArgs = {
  kinds: Array<ProfileIconKind>;
  website: Scalars['String']['input'];
};


export type MutationVoidInvoiceArgs = {
  internalNote?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};

export type NewAiBookkeeperLegalEntity = {
  legalEntity: LegalEntity;
  quotePackage: QuotePackage;
  userInfo: UserInfo;
};

export type NewAffiliatedBillingSubscription = {
  customerId: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  stripeClientSecret: Scalars['String']['output'];
};

export type NewBillingSubscription = {
  customerId: Scalars['String']['output'];
  stripeClientSecret: Scalars['String']['output'];
};

/** NewComment represents an input comment. */
export type NewComment = {
  text: Scalars['String']['input'];
};

export type NewDocumentFeature = {
  kind: FeatureKind;
  value: NewDocumentFeatureValue;
};

export type NewDocumentFeatureValue = {
  textValue?: InputMaybe<Scalars['String']['input']>;
};

export type NewLayoutDocument = {
  initialText?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  tags?: InputMaybe<Array<TextComponentConfigTagInput>>;
  title: Scalars['String']['input'];
};

export type NewObjectGrant = {
  object: InputObjectIdentifier;
  permission?: InputMaybe<Permission>;
  policy?: InputMaybe<GrantPolicy>;
};

export type NewParty = {
  designation?: InputMaybe<PartyDesignation>;
  facebookUrl?: InputMaybe<Scalars['String']['input']>;
  iconUrl: Scalars['String']['input'];
  instagramUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  shortDescription: Scalars['String']['input'];
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  supportPhone?: InputMaybe<Scalars['String']['input']>;
  supportUrl?: InputMaybe<Scalars['String']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  yelpUrl?: InputMaybe<Scalars['String']['input']>;
};

export type NewReportAttachments = {
  existing: Array<ExistingReportAttachment>;
  insightObjectIds?: InputMaybe<Array<InputObjectIdentifier>>;
  layout: Array<NewLayoutDocument>;
  statementKinds: Array<ReportKind>;
  text: Array<NewTextDocument>;
};

export type NewReportUpload = {
  fileId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  interval: Interval;
  mimeType: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  reportFor: DateInput;
  title: Scalars['String']['input'];
};

export type NewTextDocument = {
  position: Scalars['Int']['input'];
  summary: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type NewTrialBillingSubscription = {
  customerId: Scalars['String']['output'];
  productId: Scalars['String']['output'];
};

export type NewUserGrant = {
  emailAddress: Scalars['String']['input'];
  permission: Permission;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationChannelSetting = {
  channel: ChannelKind;
  enabled: Scalars['Boolean']['output'];
};

export type NotificationSetting = {
  channelSettings: Array<NotificationChannelSetting>;
  displayKey: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  eventType: EventType;
  legalEntityId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type NumericFeatureValue = {
  numericValue: Scalars['Long']['output'];
};

/** OAuth Authorization */
export type OAuthAuthorizationApproval = {
  redirectURL: Scalars['String']['output'];
};

export type OAuthClientInfo = {
  clientId: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  redirectUris: Array<Scalars['String']['output']>;
};

export type OAuthCredentialFields = {
  code: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  service: OAuthService;
};

export enum OAuthService {
  Google = 'Google',
  LinkedIn = 'LinkedIn',
  QuickBooks = 'QuickBooks',
  Unknown = 'Unknown'
}

export type ObjectAcl = {
  entities: ObjectEntities;
  grants: Array<UserGrant>;
  intents: Array<UserIntent>;
  link?: Maybe<Permission>;
  object: ObjectIdentifier;
  requests: Array<UserRequest>;
};

/**
 * ObjectEntities is a structure to thread through populated objects
 * indicated by ObjectIdentifiers to clients.
 */
export type ObjectEntities = {
  bills?: Maybe<Array<EntityBill>>;
  categories?: Maybe<Array<EntityCategory>>;
  comments?: Maybe<Array<EntityComment>>;
  datasources?: Maybe<Array<EntityDataSource>>;
  departments?: Maybe<Array<EntityDepartment>>;
  identityVerifications?: Maybe<Array<EntityIdentityVerification>>;
  invoices?: Maybe<Array<EntityInvoice>>;
  ledgerTransactions?: Maybe<Array<EntityLedgerTransaction>>;
  legalEntities?: Maybe<Array<EntityLegalEntity>>;
  locations?: Maybe<Array<EntityLocation>>;
  parties?: Maybe<Array<EntityParty>>;
  products?: Maybe<Array<EntityProduct>>;
  reconciliations?: Maybe<Array<EntityReconciliation>>;
  reportPackages?: Maybe<Array<EntityReportPackage>>;
  reports?: Maybe<Array<EntityReport>>;
  schedules?: Maybe<Array<EntitySchedule>>;
  threads?: Maybe<Array<EntityThread>>;
  transactions?: Maybe<Array<EntityTransaction>>;
  users?: Maybe<Array<EntityUser>>;
  workItems?: Maybe<Array<EntityWorkItem>>;
};

export type ObjectEntity = EntityBill | EntityCategory | EntityComment | EntityDataSource | EntityDepartment | EntityIdentityVerification | EntityInvoice | EntityLedgerTransaction | EntityLegalEntity | EntityLocation | EntityParty | EntityProduct | EntityReconciliation | EntityReport | EntityReportPackage | EntitySchedule | EntityThread | EntityTransaction | EntityUser | EntityWorkItem;

export type ObjectGrant = {
  createdAt: Scalars['DateTime']['output'];
  grantId: Scalars['String']['output'];
  object: ObjectIdentifier;
  permission: Permission;
  viewType?: Maybe<ViewType>;
};

/**
 * ObjectIdentifier is a generic identifier with an enumerated kind.
 * It can be used to identify different Digits' core objects.
 */
export type ObjectIdentifier = {
  id: Scalars['String']['output'];
  kind: ObjectKind;
  legalEntityId: Scalars['String']['output'];
};

export type ObjectIntent = {
  creatorUserId: Scalars['String']['output'];
  intentId: Scalars['String']['output'];
  object: ObjectIdentifier;
  permission: Permission;
};

export enum ObjectKind {
  Bill = 'Bill',
  Category = 'Category',
  Comment = 'Comment',
  Connection = 'Connection',
  DataSource = 'DataSource',
  Department = 'Department',
  Invoice = 'Invoice',
  LedgerTransaction = 'LedgerTransaction',
  LegalEntity = 'LegalEntity',
  Location = 'Location',
  Party = 'Party',
  Portal = 'Portal',
  Product = 'Product',
  Reconciliation = 'Reconciliation',
  Report = 'Report',
  ReportPackage = 'ReportPackage',
  Schedule = 'Schedule',
  Thread = 'Thread',
  Transaction = 'Transaction',
  User = 'User',
  WorkItem = 'WorkItem'
}

export type ObjectKindFacet = {
  count: Scalars['Long']['output'];
  kind: ObjectKind;
};

export type ObjectMappingHierarchies = {
  departmentHierarchy: Array<ObjectMappingHierarchyNode>;
  lineClassHierarchy: Array<ObjectMappingHierarchyNode>;
};

export type ObjectMappingHierarchyNode = {
  active: Scalars['Boolean']['output'];
  depth: Scalars['Long']['output'];
  factId: Scalars['String']['output'];
  fullyQualifiedName: Scalars['String']['output'];
  mappedTo?: Maybe<ObjectKind>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  transactionCount: Scalars['Long']['output'];
};

export type ObjectPermission = {
  action: ShareAction;
  legalEntity: EntityLegalEntity;
  object: ObjectIdentifier;
  organizationPreview: OrganizationPreview;
  permission?: Maybe<Permission>;
  viewType: ViewType;
};

export type ObjectRequest = {
  object: ObjectIdentifier;
  requestId: Scalars['String']['output'];
};

export enum Operation {
  Contains = 'Contains',
  Excludes = 'Excludes',
  UnknownOperation = 'UnknownOperation'
}

export type Organization = {
  branding?: Maybe<OrganizationBranding>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind?: Maybe<OrganizationKind>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type OrganizationAffiliation = {
  legalEntity: EntityLegalEntity;
  organization: EntityOrganization;
};

export type OrganizationAssignee = {
  organizationId: Scalars['String']['input'];
};

export type OrganizationBillingPlan = {
  plan: BillingPlan;
  trial?: Maybe<BillingTrial>;
};

export type OrganizationBranding = {
  headerColor: Scalars['String']['output'];
  headerTextColor: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type OrganizationEmployment = {
  employeeId: Scalars['String']['output'];
  legalEntityRoles?: Maybe<Array<EmployeeLegalEntityRole>>;
  organization: Organization;
  role: Role;
};

export enum OrganizationKind {
  AccountingFirm = 'AccountingFirm',
  Developer = 'Developer',
  Operator = 'Operator',
  SandboxAccountingFirm = 'SandboxAccountingFirm',
  SandboxOperator = 'SandboxOperator',
  UnknownKind = 'UnknownKind'
}

export type OrganizationPreferences = {
  anonymizeEmployees: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
};

export type OrganizationPreview = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type OrganizationTemplate = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type OwnedDataSource = {
  dataSource: EnrichedDataSource;
  dataSourcePreference?: Maybe<DataSourcePreference>;
  ownedSourceAccounts?: Maybe<Array<OwnedSourceAccount>>;
};

export type OwnedSourceAccount = {
  owner?: Maybe<Employee>;
  sourceAccount: SourceAccount;
};

export type Owner = {
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  residentialAddress?: Maybe<Address>;
};

export type OwnerInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  residentialAddress?: InputMaybe<AddressInput>;
};

export type PackageCount = {
  interval: Interval;
  total: Scalars['Long']['output'];
};

export type PackageCounts = {
  counts: Array<PackageCount>;
  total: Scalars['Long']['output'];
};

export type PackagesFilter = {
  hideDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Interval>;
};

export type PackagesSort = {
  direction?: InputMaybe<SortDirection>;
  orderBy?: InputMaybe<PackagesSortOrderBy>;
};

export enum PackagesSortOrderBy {
  UpdatedAt = 'UpdatedAt'
}

export type PageView = {
  url: Scalars['String']['input'];
};

export type Pagination = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

/** Parties */
export type Party = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  designation: PartyDesignation;
  facebookUrl?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  instagramUrl?: Maybe<Scalars['String']['output']>;
  legalEntityId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shortDescription?: Maybe<Scalars['String']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  supportPhone?: Maybe<Scalars['String']['output']>;
  supportUrl?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  yelpUrl?: Maybe<Scalars['String']['output']>;
};

export type PartyAndRoleBalanceFilter = {
  legalEntityId: Scalars['String']['input'];
  partyId: Scalars['String']['input'];
  partyRole: PartyRole;
  viewVersion?: InputMaybe<Scalars['String']['input']>;
};

export type PartyChartConfig = {
  asPermanent?: Maybe<Scalars['Boolean']['output']>;
  origin: ArchiveIntervalOrigin;
  partyId: Scalars['String']['output'];
  partyRole?: Maybe<PartyRole>;
};

export type PartyChartConfigInput = {
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  origin: IntervalOrigin;
  partyId: Scalars['String']['input'];
  partyRole?: InputMaybe<PartyRole>;
};

export enum PartyDesignation {
  BusinessDesignation = 'BusinessDesignation',
  IgnoredDesignation = 'IgnoredDesignation',
  InvalidDesignation = 'InvalidDesignation',
  PeopleDesignation = 'PeopleDesignation',
  SMBMealsDesignation = 'SMBMealsDesignation',
  SMBOtherDesignation = 'SMBOtherDesignation',
  UnknownDesignation = 'UnknownDesignation'
}

export type PartyDimension = {
  by: DimensionSummary;
  partyId: Scalars['String']['output'];
  partyObject: EntityParty;
  summary: TransactionSummary;
};

export enum PartyEntityType {
  Corporation = 'Corporation',
  ForeignEntities = 'ForeignEntities',
  Individual = 'Individual',
  LimitedLiabilityCompany = 'LimitedLiabilityCompany',
  Other = 'Other',
  Partnerships = 'Partnerships',
  SoleProprietorship = 'SoleProprietorship',
  TrustsAndEstates = 'TrustsAndEstates',
  Undetermined = 'Undetermined',
  UnknownEntityType = 'UnknownEntityType'
}

export type PartyFacet = {
  count: Scalars['Int']['output'];
  partyObject: EntityParty;
};

export type PartyHistory = {
  entityTypeClassification: PartyHistoryEntry;
  partyId: Scalars['String']['output'];
  taxpayerIdentificationClassification: PartyHistoryEntry;
};

export type PartyHistoryEntry = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type PartyHover = {
  context?: Maybe<DimensionSummary>;
  entity: EntityParty;
  history: DimensionSummary;
  topTransactions?: Maybe<Array<EntityTransaction>>;
};

export type PartyIconMetadata = {
  iconUrl: Scalars['String']['output'];
};

export type PartyParams = {
  action: PushAction;
  partyID?: InputMaybe<Scalars['String']['input']>;
  partyIconUrl?: InputMaybe<Scalars['String']['input']>;
  partyName: Scalars['String']['input'];
};

export type PartyRef = {
  id: Scalars['String']['output'];
};

export enum PartyRole {
  EntityAssetRole = 'EntityAssetRole',
  EntityAssetSupplierRole = 'EntityAssetSupplierRole',
  EntityAssetVendorRole = 'EntityAssetVendorRole',
  EntityBanksRole = 'EntityBanksRole',
  EntityCreditCardsRole = 'EntityCreditCardsRole',
  EntityCustomerRole = 'EntityCustomerRole',
  EntityDebtorRole = 'EntityDebtorRole',
  EntityInvesteeRole = 'EntityInvesteeRole',
  EntityLenderRole = 'EntityLenderRole',
  EntityLiabilitiesRole = 'EntityLiabilitiesRole',
  EntityOtherExpensesRole = 'EntityOtherExpensesRole',
  EntityOtherIncomeRole = 'EntityOtherIncomeRole',
  EntityOtherLiabilitiesRole = 'EntityOtherLiabilitiesRole',
  EntityOwedVendorRole = 'EntityOwedVendorRole',
  EntityPrepaidVendorRole = 'EntityPrepaidVendorRole',
  EntityProcessorRole = 'EntityProcessorRole',
  EntityRevenuePartnerRole = 'EntityRevenuePartnerRole',
  EntityShareholderRole = 'EntityShareholderRole',
  EntitySupplierRole = 'EntitySupplierRole',
  EntityUnpaidCustomerRole = 'EntityUnpaidCustomerRole',
  EntityUnspecifiedRole = 'EntityUnspecifiedRole',
  EntityVendorRole = 'EntityVendorRole',
  FacilitatorRole = 'FacilitatorRole',
  InstitutionCreditRole = 'InstitutionCreditRole',
  InstitutionDebitRole = 'InstitutionDebitRole',
  OwnerRole = 'OwnerRole',
  PaymentProcessorRole = 'PaymentProcessorRole',
  UnknownRole = 'UnknownRole'
}

export type PartyRuleFilter = {
  createdAt: Scalars['DateTime']['output'];
  operation: Operation;
  parties: Array<PartyRuleFilterParty>;
  partyRuleFilterId: Scalars['String']['output'];
};

export type PartyRuleFilterParty = {
  partyId: Scalars['String']['output'];
  partyName: Scalars['String']['output'];
};

export type PartyTaxInfo = {
  entityType: PartyEntityType;
  partyId: Scalars['String']['output'];
  taxpayerIdentification: TaxpayerIdentification;
};

export enum PartyType {
  Global = 'Global',
  Implied = 'Implied',
  Imported = 'Imported',
  Synthesized = 'Synthesized',
  Unknown = 'Unknown',
  UserCreated = 'UserCreated',
  WireImplied = 'WireImplied'
}

export type PayCategoryIntegrations = {
  party?: Maybe<EntityParty>;
  products: Array<CategoryToLabelMappingProduct>;
};

export type PayInvoiceSummary = {
  invoicePaymentDetails: InvoicePaymentDetails;
  status: InvoiceStatus;
};

export enum PaymentErrorProduct {
  Bills = 'Bills',
  Invoices = 'Invoices'
}

export type PaymentErrorState = {
  hasPendingBalance: Scalars['Boolean']['output'];
  pendingBalanceUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentInstrument = BankAccount | CreditCard;

export enum PaymentStatus {
  Blocked = 'Blocked',
  Canceled = 'Canceled',
  Created = 'Created',
  Deposited = 'Deposited',
  Held = 'Held',
  Mailed = 'Mailed',
  OnHold = 'OnHold',
  Paid = 'Paid',
  Pending = 'Pending',
  PendingApproval = 'PendingApproval',
  PendingIncreaseReview = 'PendingIncreaseReview',
  PendingMailing = 'PendingMailing',
  PendingSubmission = 'PendingSubmission',
  ProcessingReturn = 'ProcessingReturn',
  ProcessingSettlement = 'ProcessingSettlement',
  Refunded = 'Refunded',
  Rejected = 'Rejected',
  RequiresAttention = 'RequiresAttention',
  Returned = 'Returned',
  Settled = 'Settled',
  Stopped = 'Stopped',
  Submitted = 'Submitted',
  Unknown = 'Unknown'
}

export type PayoutInstrument = BankAccount | Check;

export type PayrollProvider = {
  legalEntityId: Scalars['String']['output'];
  partyId: Scalars['String']['output'];
  partyName: Scalars['String']['output'];
  payrollProviderType: PayrollProviderType;
  rangeEndedAt?: Maybe<Scalars['DateTime']['output']>;
  rangeStartedAt: Scalars['DateTime']['output'];
};

export enum PayrollProviderType {
  Primary = 'Primary',
  UnknownPayrollProvider = 'UnknownPayrollProvider'
}

export type Period = {
  endedAt: Scalars['DateTime']['output'];
  interval: Interval;
  name: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export type PeriodInput = {
  endedAt: Scalars['DateTime']['input'];
  interval: Interval;
  name: Scalars['String']['input'];
  startedAt: Scalars['DateTime']['input'];
};

/** Insights */
export type PeriodInsights = {
  entities?: Maybe<ObjectEntities>;
  insights: Array<Insight>;
  period: Period;
};

/** Periods */
export type PeriodMonetaryValue = {
  current?: Maybe<SummaryTotal>;
  deltaPrevious?: Maybe<Scalars['Float']['output']>;
  /** @deprecated unpopulated */
  deltaYearAgo?: Maybe<Scalars['Float']['output']>;
  /** @deprecated unpopulated */
  isFirstOccurrencePeriod?: Maybe<Scalars['Boolean']['output']>;
  moneyFlow?: Maybe<MoneyFlow>;
  prior?: Maybe<SummaryTotal>;
  transactionsCount: Scalars['Long']['output'];
  value: MonetaryValue;
};

export type PeriodReport = {
  author?: Maybe<Contact>;
  createdAt: Scalars['DateTime']['output'];
  generationHistory?: Maybe<ReportGenerationHistory>;
  id: Scalars['String']['output'];
  interval: Interval;
  reportFile: ReportFileMetadata;
  reportFor?: Maybe<Date>;
  status: ReportPackageDocumentStatus;
  threadDetails?: Maybe<Array<ThreadDetails>>;
  title: Scalars['String']['output'];
};

export enum Permission {
  CommentRead = 'CommentRead',
  CommentShare = 'CommentShare',
  FullAccess = 'FullAccess',
  None = 'None',
  ReadOnly = 'ReadOnly',
  SensitiveFullAccess = 'SensitiveFullAccess'
}

export enum Persona {
  AccountingLarge = 'AccountingLarge',
  AccountingMedium = 'AccountingMedium',
  AccountingSmall = 'AccountingSmall',
  Business = 'Business',
  BusinessAndSubsidiaries = 'BusinessAndSubsidiaries',
  InvestmentMedium = 'InvestmentMedium',
  InvestmentSmall = 'InvestmentSmall',
  MailingList = 'MailingList',
  UnknownPersona = 'UnknownPersona'
}

export type PlaidAccount = {
  id: Scalars['String']['input'];
  mask?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subtype?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PlaidConfig = {
  createdAt: Scalars['DateTime']['output'];
  externalInstitutionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PlaidConnectorProperties = {
  /**
   * For the initial implementation, we wont have anything special here
   * however in the future we may use this to add things like filters
   * for specific account types, icons for different banks, etc
   */
  empty?: Maybe<Scalars['Boolean']['output']>;
};

export type PlaidLinkToken = {
  token: Scalars['String']['output'];
};

export type Portal = {
  backgroundUrl?: Maybe<Scalars['String']['output']>;
  layoutId: Scalars['String']['output'];
  legalEntityId: Scalars['String']['output'];
  portalId: Scalars['String']['output'];
};

export type PortalLayout = {
  hasPortal: Scalars['Boolean']['output'];
  layout?: Maybe<Layout>;
  portalId?: Maybe<Scalars['String']['output']>;
};

export type PortalMetricConfig = {
  metricType: MetricType;
  origin: ArchiveIntervalOrigin;
};

export type PortalMetricConfigInput = {
  metricType: MetricType;
  origin: IntervalOrigin;
};

export type PotentialDuplicateFlagDetails = {
  potentialDuplicateTransaction: Transaction;
  potentialDuplicateTransactionFactId: Scalars['String']['output'];
  statementLineItem: StatementLineItem;
  transaction: Transaction;
  transactionFactId: Scalars['String']['output'];
};

export type PotentialMismatchFlagDetails = {
  statementLineItem: StatementLineItem;
  transaction: Transaction;
  transactionFactId: Scalars['String']['output'];
};

export type PredictedDataSource = {
  institution: Party;
  providerType: ProviderType;
  type: PredictedDataSourceType;
};

export enum PredictedDataSourceType {
  BankAccount = 'BankAccount',
  BankAccountAndCreditCard = 'BankAccountAndCreditCard',
  CreditCard = 'CreditCard',
  UnknownType = 'UnknownType'
}

export type PricePreview = {
  coupons?: Maybe<Array<Coupon>>;
  total: MonetaryValue;
};

export type Product = {
  active: Scalars['Boolean']['output'];
  assetCategoryId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  customIconObjectName?: Maybe<Scalars['String']['output']>;
  customIconUrl?: Maybe<Scalars['String']['output']>;
  dataSourceId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  iconDisplayKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  institutionIconUrl?: Maybe<Scalars['String']['output']>;
  institutionId: Scalars['String']['output'];
  institutionName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productGroupId?: Maybe<Scalars['String']['output']>;
  providerType: ProviderType;
  sku?: Maybe<Scalars['String']['output']>;
  taxable?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  variants?: Maybe<Array<ProductVariant>>;
};

export enum ProductActivityEntityType {
  Product = 'Product',
  UnknownEntityType = 'UnknownEntityType',
  Variant = 'Variant'
}

export type ProductActivityEvent = {
  entityId: Scalars['String']['output'];
  entityType: ProductActivityEntityType;
  eventAt: Scalars['DateTime']['output'];
  eventByUserId?: Maybe<Scalars['String']['output']>;
  eventType: ProductActivityEventType;
  name?: Maybe<Scalars['String']['output']>;
};

export enum ProductActivityEventType {
  Created = 'Created',
  Deleted = 'Deleted',
  UnknownEventType = 'UnknownEventType'
}

export enum ProductArea {
  All = 'All',
  Cash = 'Cash',
  Expenses = 'Expenses',
  None = 'None',
  Revenue = 'Revenue'
}

export type ProductCatalogIconUploadResult = {
  iconUrl: Scalars['String']['output'];
  objectName: Scalars['String']['output'];
};

export type ProductCategoryClassification = {
  categoryId: Scalars['String']['output'];
  classificationVersionId: Scalars['String']['output'];
};

export type ProductClassifications = {
  buyDepartment?: Maybe<ProductDepartmentClassification>;
  buyLocation?: Maybe<ProductLocationClassification>;
  department?: Maybe<ProductDepartmentClassification>;
  expenseCategory?: Maybe<ProductCategoryClassification>;
  incomeCategory?: Maybe<ProductCategoryClassification>;
  location?: Maybe<ProductLocationClassification>;
  sellDepartment?: Maybe<ProductDepartmentClassification>;
  sellLocation?: Maybe<ProductLocationClassification>;
};

export type ProductDepartmentClassification = {
  classificationVersionId: Scalars['String']['output'];
  departmentId: Scalars['String']['output'];
  productSide?: Maybe<ProductSide>;
};

export type ProductDimension = {
  by: DimensionSummary;
  productId: Scalars['String']['output'];
  productObject: EntityProduct;
  summary: TransactionSummary;
};

export type ProductGroup = {
  createdAt: Scalars['DateTime']['output'];
  customIconObjectName?: Maybe<Scalars['String']['output']>;
  customIconUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  iconColorKey?: Maybe<Scalars['String']['output']>;
  iconDisplayKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductGroupInput = {
  customIconObjectName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  iconColorKey?: InputMaybe<Scalars['String']['input']>;
  iconDisplayKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ProductIdentifierInput = {
  dataSourceId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type ProductInput = {
  active: Scalars['Boolean']['input'];
  assetCategoryId?: InputMaybe<Scalars['String']['input']>;
  customIconObjectName?: InputMaybe<Scalars['String']['input']>;
  dataSourceId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  iconDisplayKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  productGroupId?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  taxable: Scalars['Boolean']['input'];
  variants?: InputMaybe<Array<SaveProductVariantInput>>;
};

export type ProductInstitution = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  party?: Maybe<Party>;
  products?: Maybe<Array<InstitutionProduct>>;
  routingNumber?: Maybe<Scalars['String']['output']>;
};

export enum ProductListing {
  Partner = 'Partner',
  Public = 'Public',
  UnknownListing = 'UnknownListing',
  Unlisted = 'Unlisted'
}

export type ProductLocationClassification = {
  classificationVersionId: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  productSide?: Maybe<ProductSide>;
};

export enum ProductRecurrence {
  Monthly = 'Monthly',
  OneTime = 'OneTime',
  UnknownRecurrence = 'UnknownRecurrence',
  Yearly = 'Yearly'
}

export enum ProductSide {
  Buy = 'Buy',
  Sell = 'Sell'
}

export type ProductTransactionListItem = {
  linkedObjectNumber?: Maybe<Scalars['String']['output']>;
  linkedObjectParty?: Maybe<EntityParty>;
  linkedObjectType?: Maybe<LinkedObjectType>;
  transaction: Transaction;
};

export type ProductVariant = {
  classifications?: Maybe<ProductClassifications>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  customIconObjectName?: Maybe<Scalars['String']['output']>;
  customIconUrl?: Maybe<Scalars['String']['output']>;
  dataSourceId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  iconDisplayKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Long']['output'];
  prices?: Maybe<Array<ProductVariantPrice>>;
  productId: Scalars['String']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductVariantClassificationsInput = {
  buyDepartmentId?: InputMaybe<Scalars['String']['input']>;
  buyLocationId?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['String']['input']>;
  expenseCategory?: InputMaybe<Scalars['String']['input']>;
  incomeCategory?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  sellDepartmentId?: InputMaybe<Scalars['String']['input']>;
  sellLocationId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductVariantInput = {
  classifications?: InputMaybe<ProductVariantClassificationsInput>;
  customIconObjectName?: InputMaybe<Scalars['String']['input']>;
  dataSourceId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  iconDisplayKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type ProductVariantPrice = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataSourceId: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  type?: Maybe<ProductVariantPriceType>;
  unitPrice: MonetaryValue;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  variantId: Scalars['String']['output'];
};

export type ProductVariantPriceInput = {
  dataSourceId: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  type?: InputMaybe<ProductVariantPriceType>;
  unitPrice: InputMonetaryValue;
  variantId: Scalars['String']['input'];
};

export enum ProductVariantPriceType {
  Buy = 'Buy',
  Sell = 'Sell'
}

export enum ProfileIconKind {
  LegalEntity = 'LegalEntity',
  Organization = 'Organization'
}

/** Where an uploaded profile icon was stored, for a single kind. */
export type ProfileIconUploadResult = {
  bucket: Scalars['String']['output'];
  bucketHost: Scalars['String']['output'];
  bucketPath: Scalars['String']['output'];
  kind: ProfileIconKind;
  objectName: Scalars['String']['output'];
};

export enum ProposalType {
  AffiliateInviteManagedOperator = 'AffiliateInviteManagedOperator',
  AffiliationAssistClient = 'AffiliationAssistClient',
  AffiliationCreateClient = 'AffiliationCreateClient',
  AffiliationJoinClient = 'AffiliationJoinClient',
  CreateOrganization = 'CreateOrganization',
  EmploymentAssistOperator = 'EmploymentAssistOperator',
  EmploymentJoinOrg = 'EmploymentJoinOrg',
  EnterprisePackageInvite = 'EnterprisePackageInvite',
  OperatorAssistAffiliate = 'OperatorAssistAffiliate',
  UnknownProposalType = 'UnknownProposalType'
}

export type ProposedGlobalParty = {
  designation: PartyDesignation;
  iconUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shortDescription: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Provider = {
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum ProviderType {
  CSVImport = 'CSVImport',
  Connect = 'Connect',
  DigitsInvoicing = 'DigitsInvoicing',
  DigitsLedgerInvoicing = 'DigitsLedgerInvoicing',
  DigitsLedgerPay = 'DigitsLedgerPay',
  DigitsPay = 'DigitsPay',
  DigitsPaymentsLedger = 'DigitsPaymentsLedger',
  DigitsSchedule = 'DigitsSchedule',
  Manual = 'Manual',
  Plaid = 'Plaid',
  QuickBooks = 'QuickBooks',
  UnknownProvider = 'UnknownProvider',
  Xero = 'Xero'
}

export type PublicInvoice = {
  branding: InvoiceBranding;
  customer?: Maybe<Customer>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<Array<InvoiceFile>>;
  id: Scalars['String']['output'];
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoicingProfile?: Maybe<InvoicingProfile>;
  legalEntityId: Scalars['String']['output'];
  lineItems: Array<InvoiceLineItem>;
  memo?: Maybe<Scalars['String']['output']>;
  receivableInvoiceId: Scalars['String']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
  status: InvoiceStatus;
  subtotal?: Maybe<MonetaryValue>;
  taxPercent?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<MonetaryValue>;
  totalTax?: Maybe<MonetaryValue>;
};

export type PullRequest = {
  author: PullRequestAuthor;
  branch: Scalars['String']['output'];
  labels?: Maybe<Array<PullRequestLabel>>;
  number: Scalars['Int']['output'];
  prState: PullRequestState;
  repo: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PullRequestAuthor = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  login: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PullRequestFile = {
  contents: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum PullRequestFilterState {
  All = 'All',
  Closed = 'Closed',
  Open = 'Open'
}

export type PullRequestLabel = {
  hexColor: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum PullRequestState {
  Closed = 'Closed',
  Open = 'Open'
}

export type PullRequestSummary = {
  mergeableStatus: MergeableStatus;
  merged: Scalars['Boolean']['output'];
  pullRequest: PullRequest;
  reviewStatus: ReviewStatus;
};

export enum PushAction {
  Reassign = 'Reassign',
  Rename = 'Rename',
  UnknownPushAction = 'UnknownPushAction'
}

export type PushDevice = {
  active: Scalars['Boolean']['output'];
  config?: Maybe<PushDeviceConfig>;
  deviceId: Scalars['String']['output'];
  platform: PushPlatform;
  userId: Scalars['String']['output'];
};

/**
 * Single-member union today; additional platforms (e.g. AndroidPushConfig) are
 * added as union members without changing the PushDevice shape.
 */
export type PushDeviceConfig = ApplePushConfig;

export enum PushPlatform {
  Apple = 'Apple',
  UnknownPushPlatform = 'UnknownPushPlatform'
}

export type QualityCheck = {
  description: Scalars['String']['output'];
  /**
   * Effective on/off state for the caller's legal entity: the LE's override
   * if present, otherwise the per-check global default.
   */
  enabled: Scalars['Boolean']['output'];
  /** The entity this check evaluates. Source of truth for objectKind. */
  entityKind: QualityCheckEntityKind;
  flaggedObjectKinds: Array<ObjectKind>;
  id: Scalars['String']['output'];
  /** Created timestamp of the latest trigger for this check in the caller's legal entity. */
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  legalEntityId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated Use entityKind instead; objectKind is derived from it (CategoryTimeseries -> Category). */
  objectKind: ObjectKind;
  organizationId?: Maybe<Scalars['String']['output']>;
  owner: QualityCheckOwner;
  qualityCheckType: QualityCheckType;
  /** Latest trigger status for this check in the caller's legal entity. */
  status: QualityCheckStatus;
};

/**
 * Result of readQualityCheckDryRun. Flagged results are returned as the same
 * ActionItems the dashboard renders elsewhere, with each flagged object hydrated
 * inline on its item — so no separate entities bag is needed.
 */
export type QualityCheckDryRun = {
  flaggedCount: Scalars['Long']['output'];
  results: Array<ActionItem>;
  status: QualityCheckDryRunStatus;
  timeRangeEndedAt?: Maybe<Scalars['DateTime']['output']>;
  timeRangeStartedAt?: Maybe<Scalars['DateTime']['output']>;
  triggerId: Scalars['String']['output'];
};

/**
 * Dry-run lifecycle status. A non-terminal value (incl. UnknownStatus) means the
 * run is still in flight and the caller should keep polling readQualityCheckDryRun.
 */
export enum QualityCheckDryRunStatus {
  Failed = 'Failed',
  InProgress = 'InProgress',
  Pending = 'Pending',
  Succeeded = 'Succeeded',
  UnknownStatus = 'UnknownStatus'
}

export enum QualityCheckEntityKind {
  Category = 'Category',
  CategoryTimeseries = 'CategoryTimeseries',
  LedgerTransaction = 'LedgerTransaction',
  Party = 'Party',
  Transaction = 'Transaction',
  UnknownKind = 'UnknownKind'
}

export type QualityCheckGroup = {
  checks: Array<QualityCheck>;
  name: ActionItemGroup;
};

/**
 * A confirmed customization. Each confirmed save is a new immutable version;
 * drafts (awaiting confirmation) are never surfaced and don't shift version
 * numbers.
 *
 * `userInstruction` and `summary` carry inline entity markup in the
 * `<Kind|UUIDv4|Title>` format used by Comment.text, parsed by the shared
 * objectentities parser. The response-level `entities` bag hydrates `*Tags`.
 */
export type QualityCheckInstruction = {
  authorId: Scalars['String']['output'];
  checkId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  /**
   * True only for draft-authoring responses. Read paths return confirmed
   * instructions with isDraft = false.
   */
  isDraft: Scalars['Boolean']['output'];
  summary: Scalars['String']['output'];
  summaryTags: Array<ObjectIdentifier>;
  updatedAt: Scalars['DateTime']['output'];
  userInstruction: Scalars['String']['output'];
  userInstructionTags: Array<ObjectIdentifier>;
  /**
   * Confirmed instruction edit timestamp. Draft-authoring responses use 0
   * because drafts are not effective versions.
   */
  versionNumber: Scalars['Long']['output'];
};

/**
 * A guardrail refused the instruction before generation. `reasons` holds one
 * plain-English sentence per failing gate; show them so the author can revise.
 */
export type QualityCheckInstructionBlocked = {
  reasons: Array<Scalars['String']['output']>;
};

export enum QualityCheckOwner {
  Digits = 'Digits',
  Firm = 'Firm',
  LegalEntity = 'LegalEntity',
  UnknownOwner = 'UnknownOwner'
}

export enum QualityCheckStatus {
  Failed = 'Failed',
  InProgress = 'InProgress',
  Pending = 'Pending',
  Succeeded = 'Succeeded',
  UnknownStatus = 'UnknownStatus'
}

export enum QualityCheckType {
  Custom = 'Custom',
  LowConfidenceCategory = 'LowConfidenceCategory',
  MaterialAsset = 'MaterialAsset',
  MaterialEquity = 'MaterialEquity',
  MaterialExpense = 'MaterialExpense',
  MaterialLiability = 'MaterialLiability',
  MissingCustomer = 'MissingCustomer',
  MissingDepartment = 'MissingDepartment',
  MissingInvoice = 'MissingInvoice',
  MissingLocation = 'MissingLocation',
  MissingReceipt = 'MissingReceipt',
  MissingVendor = 'MissingVendor',
  MultipleCategoriesCustomers = 'MultipleCategoriesCustomers',
  MultipleCategoriesVendors = 'MultipleCategoriesVendors',
  NegativeAsset = 'NegativeAsset',
  NegativeLiability = 'NegativeLiability',
  NegativeRevenue = 'NegativeRevenue',
  NonZeroClearing = 'NonZeroClearing',
  Other = 'Other',
  TransactionInParentCategory = 'TransactionInParentCategory',
  TransactionPii = 'TransactionPii',
  Uncategorized = 'Uncategorized',
  UnknownQualityCheckType = 'UnknownQualityCheckType',
  UnusualSpend = 'UnusualSpend'
}

/** Response wrapper carries hydrated entities, mirroring CommentWithEntities. */
export type QualityCheckWithEntities = {
  check: QualityCheck;
  /** Preconfigured instruction shown before any custom one; empty for bespoke checks. */
  defaultInstruction: Scalars['String']['output'];
  entities?: Maybe<ObjectEntities>;
  /**
   * The latest confirmed instruction for this check. Null until the LE has
   * authored any confirmed instruction.
   */
  instruction?: Maybe<QualityCheckInstruction>;
};

export type QuantityValue = {
  quantity: Scalars['Long']['output'];
  quantityMultiplier: Scalars['Long']['output'];
};

export type Query = {
  canResetLegalEntity: CanResetLegalEntityResponse;
  checkAffiliatedSubscriptionProduct: CheckAffiliatedSubscriptionProduct;
  checkBillingCustomerProfile: CheckBillingCustomerProfile;
  checkBillingOrganizationPlan: CheckBillingPlan;
  checkLedgerTransactionStale: LedgerTransactionStale;
  /**
   * TODO: this reuses TransactionSource but this is more of a TransactionEditHistory so we may want to create a new type
   * dimensions are derivable from the query but that requires
   * requires a patch to our fork, so just passing them in for
   * now.
   */
  dimensionalTransactionSummary: DimensionSummary;
  documentDownloadUrl: DocumentDownload;
  documentDownloadUrls: DocumentDownloadUrls;
  exportTransactions: DocumentInitialSegment;
  factIdForLedgerTransactionId: Scalars['String']['output'];
  /** TODO: delete fetchSimilarTransactions when old FE code ages out */
  fetchSimilarTransactions: Array<Transaction>;
  findConnectionsByInstitution: Array<ConnectionSummary>;
  findThreadByComment?: Maybe<ThreadDetails>;
  generateExecutiveSummary: Scalars['String']['output'];
  /** Business Verification */
  getBusinessVerificationApplication?: Maybe<BusinessVerificationApplication>;
  getBusinessVerificationStatus: BusinessVerificationStatusResult;
  getDocumentsTransactionFeatures: Array<DocumentTransactionFeatures>;
  /** Invoices */
  getDraftInvoiceDefaults: InvoiceDefaults;
  getHostedOnboardingLink: BusinessVerification;
  getNextInvoiceNumber: InvoiceNumber;
  hasExternallyManagedPayments: Scalars['Boolean']['output'];
  hasRawCategories: Scalars['Boolean']['output'];
  highlightWorkItem: HighlightedTokens;
  /**
   * Hydrates a mixed list of entity identifiers into their full entity
   * shapes. Designed for callers that need multiple entity kinds in a
   * single call (e.g. hydrating URL parameters). All identifiers resolve
   * under the given view context.
   */
  hydrateEntities: ObjectEntities;
  ledgerGetBillDeliveryTimeline?: Maybe<Delivery>;
  ledgerGetBillExternalPayment?: Maybe<BillExternalPayment>;
  ledgerGetDraftInvoiceDefaults: InvoiceDefaults;
  ledgerGetNextInvoiceNumber: InvoiceNumber;
  ledgerListBillWorkflowStatusUpdates: Array<LedgerBillWorkflowStatusUpdate>;
  ledgerListBillWorkflows: Array<WorkflowSummary>;
  ledgerListBillsByVendor: Array<LedgerBillSummary>;
  ledgerListConnectBills: Array<LedgerBillSummary>;
  ledgerListConnectInvoices: Array<LedgerInvoiceSummary>;
  ledgerListInvoiceWorkflowStatusUpdates: Array<LedgerInvoiceWorkflowStatusUpdate>;
  ledgerListInvoicesByCustomer: Array<LedgerInvoiceSummary>;
  ledgerListInvoicingProfiles: Array<InvoicingProfile>;
  ledgerListPaidBills: Array<LedgerBillSummary>;
  ledgerListPaidInvoices: Array<LedgerInvoiceSummary>;
  /** Bills */
  ledgerListPendingBills: Array<LedgerBillSummary>;
  ledgerListPendingInvoices: Array<LedgerInvoiceSummary>;
  ledgerListRetryableBillPayoutIds: Array<Scalars['String']['output']>;
  ledgerListVoidedInvoices: Array<LedgerInvoiceSummary>;
  ledgerPreviewInputInvoiceEmail: Scalars['String']['output'];
  ledgerPreviewInvoiceEmail: Scalars['String']['output'];
  ledgerReadBillTransaction: LedgerReadBillTransaction;
  ledgerReadInvoiceEmailConfig?: Maybe<InvoiceEmailConfig>;
  ledgerReadInvoiceTransaction: LedgerReadInvoiceTransaction;
  ledgerReadPaymentErrorState: PaymentErrorState;
  ledgerReadSentInvoiceFiles: Array<InvoiceFile>;
  ledgerSearchInvoiceCustomers: LedgerSearchInvoiceCustomersResult;
  ledgerSearchInvoiceDiscounts: Array<Discount>;
  ledgerSearchInvoiceProducts: Array<LedgerInvoiceProduct>;
  ledgerValidateInvoiceNumber: Array<DraftInvoiceValidationError>;
  listAccountReconciliations: Array<AccountReconciliations>;
  listAccountantSuggestedUsers: Array<User>;
  listActionItems: Array<ActionItem>;
  listActionItemsBadgeCounts: Array<LegalEntityBadgeCount>;
  listActivePartyRoles: Array<PartyRole>;
  listActivePartyRolesBatch: Array<ActivePartyRoles>;
  /**
   * Teams management
   * Affiliates of a Legal Entity
   */
  listAffiliates: AffiliateOrganizations;
  listAllWorkItems: Array<WorkItem>;
  /** App Instances */
  listAppInstances: Array<AppInstance>;
  /**
   * Connect
   * Apps
   * apps are connectors, but namespaced as Apps to avoid confusion with the installable connectors
   * listApps lists connectors developed by this organization
   */
  listApps: Array<Connector>;
  listAssociationsHistories: Array<AssociationHistory>;
  listAuditRuleStatuses: Array<AuditRuleStatus>;
  listAuditRules: Array<AuditRule>;
  listAuthConnections: Array<ConnectionSummary>;
  listAvailableBillingPlans: Array<SubscriptionPlan>;
  listBillingSubscriptionHistory: Array<BillingSubscriptionHistory>;
  listBoostBadgeCounts: Array<LegalEntityBadgeCount>;
  /**
   * listCascadeFinalizableReconciliations returns subsequent reconciliations
   * in the same category that satisfy the auto-cascade criteria, evaluated
   * one at a time after the trigger reconciliation. Used after a manual
   * finalize to surface a "you can also finalize these" prompt.
   */
  listCascadeFinalizableReconciliations: Array<AccountReconciliation>;
  /**
   * Source Accounts
   * Chart of Accounts
   */
  listCategories: Array<Category>;
  listCategoryIntegrations: Array<CategoryIntegrations>;
  /** Category Mappings */
  listCategoryMappings: Array<CategoryMapping>;
  listClientBillingPlans: Array<SubscriptionPlan>;
  listClosedPeriodMatchRequestTransactions: Array<EntityLedgerTransaction>;
  listClosedPeriodTransactionChangeDiffs: Array<ClosedPeriodTransactionChangeDiffs>;
  listConnectionBadgeCounts: Array<LegalEntityBadgeCount>;
  /** Connections */
  listConnections: Array<ConnectionSummary>;
  listConnectorInstallCandidates: ConnectorInstallCandidates;
  listConnectorTemplates: Array<ConnectionTemplate>;
  /** list installable connectors (i.e. Plaid, Ramp) */
  listConnectors: Array<Connector>;
  /** Data Sources */
  listDataSources: Array<DataSource>;
  listDataSourcesByIds: Array<DataSources>;
  listDepartmentFactHierarchy: Array<ObjectMappingHierarchyNode>;
  listDepartments: Array<Department>;
  listDocumentAssociations: Array<AssociationIdentifier>;
  listDocuments: Array<RawDocument>;
  listDocumentsByType: Array<RawDocument>;
  /** Doppelganger */
  listDoppelgangerPermits: Array<Maybe<DoppelgangerPermit>>;
  listDraftInvoiceSummaries: Array<InvoiceSummary>;
  /** @deprecated Use listDraftInvoiceSummaries instead */
  listDraftInvoices: Array<DraftInvoiceSummary>;
  listEmployees: Array<Employee>;
  listEmployeesAffiliations: Array<EmployeeAffiliations>;
  listEnrichedDataSources: Array<EnrichedDataSource>;
  /** Firm Work Management */
  listFirmClients: FirmClientList;
  /** Insights */
  listInsights: Array<PeriodInsights>;
  listInstitutions: Array<ProductInstitution>;
  listInvoiceBrandings: Array<InvoiceBranding>;
  listInvoicingProfiles: Array<InvoicingProfile>;
  listLatestDataSourceRefreshes: Array<DataSourceManualRefresh>;
  listLatestPartyHistories: Array<PartyHistory>;
  listLedgerTransactions: Array<EntityLedgerTransaction>;
  listLegalEntityUsers: Array<User>;
  listLimitedSuggestedUsers: Array<User>;
  /** Object Mapping */
  listLineClassFactHierarchy: Array<ObjectMappingHierarchyNode>;
  listLocations: Array<Location>;
  listMetricTransactions: Array<Transaction>;
  /** Metrics */
  listMetrics: Array<SourceAccountMetricIdentifier>;
  listNotificationSettings: Array<NotificationSetting>;
  listNotifications: Array<WebNotification>;
  /** Sharing and Access Control */
  listObjectACLs: Array<ObjectAcl>;
  listObjectAssociations: Array<AssociationIdentifier>;
  listOnboardingPromotionCodes: Array<Scalars['String']['output']>;
  listOrganizationAffiliations: Array<OrganizationAffiliation>;
  listOrganizationDefaultLegalEntityRoles: Array<Role>;
  listOrganizationInvitations: Array<Invitation>;
  /**
   * The organization's legal entities scoped to what the caller may see:
   * members with org-level legal-entity read get every owned entity (incl.
   * ones they hold no role on); others get the entities in their claims.
   */
  listOrganizationLegalEntities: Array<LegalEntity>;
  listOrganizationRoleOptions: Array<LegalEntityRoleOptions>;
  listOrganizationUsers: Array<User>;
  listOwnedDataSources: Array<OwnedDataSource>;
  listPartyTaxInfo: Array<PartyTaxInfo>;
  listProductGroups: Array<ProductGroup>;
  listProductTransactions: Array<ProductTransactionListItem>;
  listProductVariantsForCatalog: Array<Product>;
  listProductVariantsForInvoice: Array<Product>;
  listProducts: Array<Product>;
  listQualityCheckGroups: Array<QualityCheckGroup>;
  /** Quality Control */
  listQualityChecks: Array<QualityCheck>;
  /** Quotes */
  listQuotePackagesByLegalEntity?: Maybe<Array<QuotePackage>>;
  listRawCategories: Array<EntityCategory>;
  listReconciliationFlags: Array<ReconciliationFlag>;
  listReconciliationHistory: Array<ReconciliationHistoryEvent>;
  listReconciliationIntents: Array<ReconciliationIntentDetails>;
  listReconciliationIntentsByReconciliationId: Array<ReconciliationIntentDetails>;
  listReportPackages: Array<ReportPackageMetadata>;
  listReportTemplates: Array<ReportTemplate>;
  listReportsBadgeCounts: Array<LegalEntityBadgeCount>;
  listScheduleEventTemplates: Array<ScheduleEventTemplate>;
  listScheduleSnapshots: Array<ScheduleSnapshot>;
  listScheduleSpecializations: Array<ScheduleSpecialization>;
  listScheduleTemplatesByIDs: Array<ScheduleTemplate>;
  listScheduleTemplatesByTypes: Array<ScheduleTemplate>;
  listSentInvoices: Array<InvoiceSummary>;
  listShareSuggestedUsers: Array<User>;
  listSimilarActionItems: Array<Maybe<Array<Scalars['String']['output']>>>;
  listSimilarTransactions: Array<Transaction>;
  /** Autocomplete */
  listSuggestedUsers: Array<User>;
  /** Comments */
  listThreads: Threads;
  listTransactionEditingHistory: Array<TransactionSource>;
  listTransactionReviewQuestions?: Maybe<Array<TransactionReviewQuestion>>;
  /** Transactions */
  listTransactions: Array<Transaction>;
  listTransactionsByFactIds: Array<Transaction>;
  listWebhookEndpointDeliveryEvents: Array<WebhookDeliveryEvent>;
  listWebhookEndpoints: Array<WebhookEndpoint>;
  listWorkItems: Array<WorkItem>;
  /** Work Items */
  listWorkItemsByIds: Array<WorkItem>;
  /** Component Data */
  liveComponentData: ComponentData;
  metricTransactionSummary: DimensionSummary;
  minMaxAmount: MinMaxAmount;
  onboardConnections: Array<SuggestedConnection>;
  previewBillingSubscription: MonetaryValue;
  previewBillingSubscriptionPrice: PricePreview;
  previewInputInvoiceEmail: Scalars['String']['output'];
  previewInvoiceEmail: Scalars['String']['output'];
  previewSubscriptionUpdate: BillingPreview;
  productInsightTransactionSummary: DimensionSummary;
  /** Reconciliations */
  readAccountReconciliation?: Maybe<ReconciliationDetails>;
  readActionItem: ActionItem;
  /** Activity Feed */
  readActivityFeed: ActivityFeed;
  readApp: Connector;
  readAppAuthorization: AppAuthorization;
  readAppCredentials: Array<Maybe<AppCredential>>;
  readAppInstance: AppInstance;
  readAssociatedThreads: ThreadListWithEntities;
  readBilling: Billing;
  readBillingAddress: BillingAddress;
  readBillingArrangement: BillingArrangement;
  readBillingCustomerProfile: BillingCustomerProfile;
  /**
   * Billing
   * deprecated: remove after 10/3/2024
   */
  readBillingOrganizationPlan: BillingPlan;
  /** @deprecated This should only be called for legacy firms */
  readBillingPlans: Array<BillingPlan>;
  /** @deprecated Use listBillingSubscriptionHistory instead */
  readBillingSubscriptionHistory: Array<BillingSubscriptionHistory>;
  readBillingSubscriptionStatus: BillingSubscription;
  readBooksClosedDate: BooksClosedDate;
  readCategory: Category;
  readCategorySuggestions: Array<CategorySuggestion>;
  readComponentData: ArchivedComponent;
  readConnection: Connection;
  readDataSourcePreferences: Array<DataSourcePreference>;
  readDateClosedPeriodRequestAffectedCount: DateClosedPeriodRequestAffectedCountResult;
  readDefaultApprover?: Maybe<Scalars['String']['output']>;
  /** Departments */
  readDepartment: Department;
  /** Documents */
  readDocument: RawDocument;
  readDraftInvoice: DraftInvoice;
  /**
   * Aspects
   * Employees
   */
  readEmployee: Employee;
  readFactId: Scalars['String']['output'];
  readFirmBillingPlans: Array<BillingPlan>;
  /** Proposals */
  readInvitationProposal: InvitationProposal;
  /** Layouts */
  readLayout: Layout;
  /** Transaction Editing */
  readLedgerTransaction: ReadLedgerTransaction;
  readLedgerTransactionById: ReadLedgerTransaction;
  /** Legal Entity */
  readLegalEntity: LegalEntity;
  /** Metadata */
  readLegalEntityMetadata: ViewMetadata;
  /** Legal Entity Preferences */
  readLegalEntityPreferences: LegalEntityPreferences;
  readLegalEntityReset: LegalEntityReset;
  /** Linked Objects */
  readLinkedObjectDetails: LinkedObjectDetails;
  /** Locations */
  readLocation: Location;
  readMetricEquation: MetricEquation;
  /** Notifications */
  readNotification: WebNotification;
  readNotificationSettings: Array<NotificationSetting>;
  /** OAuth */
  readOAuthClient?: Maybe<OAuthClientInfo>;
  readOrCreatePortalLayout: PortalLayout;
  /** Organization */
  readOrganization: Organization;
  readOrganizationBillingPlan: OrganizationBillingPlan;
  readOrganizationBranding?: Maybe<OrganizationBranding>;
  readOrganizationPreferences: OrganizationPreferences;
  /** Parties */
  readParty: Party;
  readPaymentErrorState: PaymentErrorState;
  /** Used by iOS app up to at least v1.1.1 */
  readPortalLayout: PortalLayout;
  readProduct: Product;
  readProductActivity: Array<ProductActivityEvent>;
  /** Product Groups */
  readProductGroup: ProductGroup;
  readQualityCheck?: Maybe<QualityCheckWithEntities>;
  readQualityCheckDryRun?: Maybe<QualityCheckDryRun>;
  readReconciliationDiff?: Maybe<ReconciliationDiff>;
  readReconciliationFactClassification?: Maybe<TransactionReconciliationClassification>;
  readReconciliationPeriodStats: ReconciliationPeriodStats;
  readReconciliationsPdfs: ReconciliationsPdfs;
  readReportArchive: Statement;
  /** Report automation settings */
  readReportAutomationSettings: ReportAutomationSettings;
  readReportPackage: ReportPackage;
  readRequireBillApproverDifferentFromCreator: Scalars['Boolean']['output'];
  /** Schedules */
  readSchedule: Schedule;
  readScheduleCandidate?: Maybe<ScheduleCandidate>;
  readScheduleDefaults: ScheduleDefaults;
  readScheduleEditingHistory: Array<ScheduleHistoryEntry>;
  readScheduleImportCandidate?: Maybe<ScheduleImportCandidate>;
  readSchedulePreview: Array<EntityTransaction>;
  readSentInvoice: SentInvoiceUsers;
  readSentInvoiceFiles: Array<InvoiceFile>;
  readShare: ObjectPermission;
  readShareAdjacency: AdjacentObjectPermission;
  readThread: ThreadWithEntities;
  readTransactionDetails: TransactionWithDetails;
  readTransactionReviewNextReminder?: Maybe<Scalars['DateTime']['output']>;
  readTransactionReviewReminderMessage: TransactionReviewReminderMessage;
  readTransactionReviewSchedule: TransactionReviewSchedule;
  readTransactionWorkItemId: Scalars['String']['output'];
  readUncategorizedExpenseCategory: EntityCategory;
  /** User */
  readUser: User;
  readUserACL: UserAcl;
  /** Vanity */
  readVanityStats: VanityStats;
  reportDownloadUrl: ReportDownload;
  scheduleFacet: ScheduleFacet;
  /** Search */
  searchEntities: SearchResult;
  searchGlobalParties: SearchResult;
  /** TODO: Handle search as part of normal entity search */
  searchInvoiceCustomers: SearchInvoiceCustomersResult;
  searchInvoiceDiscounts: Array<Discount>;
  /** TODO: Handle search as part of normal entity search */
  searchInvoiceProducts: Array<InvoiceProduct>;
  searchTerms: SearchResult;
  suggestedConnections: Array<SuggestedConnection>;
  summarizeActionItemsByExternalKey: Array<ActionItemsExternalKeySummary>;
  summarizeActionItemsByGroup: Array<ActionItemsGroupSummary>;
  summarizeActionItemsByObjectKind: Array<ActionItemsObjectKindSummary>;
  summarizeActionItemsByTime: Array<ActionItemSummary>;
  summarizeDocuments: DocumentsSummary;
  /**
   * Invitations
   * Report Packages
   */
  summarizeReportPackages: Array<ReportPackageSummary>;
  /** Trial Balance */
  summarizeTrialBalance: TrialBalance;
  summarizeWorkItems: Array<WorkItemSummary>;
  /** Facets */
  transactionFacet: Facet;
  userWorkflowActivity: Array<WorkflowActivityItem>;
  validateCategoryMappings: MappingValidity;
  validateInvoiceNumber: Array<DraftInvoiceValidationError>;
};


export type QueryCanResetLegalEntityArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryCheckAffiliatedSubscriptionProductArgs = {
  affiliatedLegalEntityId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryCheckBillingCustomerProfileArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryCheckBillingOrganizationPlanArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryCheckLedgerTransactionStaleArgs = {
  ledgerTransactionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryDimensionalTransactionSummaryArgs = {
  aggregateFacetKind?: InputMaybe<TransactionFacetKind>;
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  defaultCategoryType?: InputMaybe<CategoryType>;
  dimensions: Array<SummaryDimension>;
  directBookings?: InputMaybe<Scalars['Boolean']['input']>;
  direction: DirectionFromOrigin;
  filter: SummaryFilterInput;
  intervalPartition?: InputMaybe<IntervalPartition>;
  masks?: InputMaybe<Array<Array<SummaryDimension>>>;
  matchBy?: InputMaybe<Matcher>;
  naturalFlow?: InputMaybe<Flow>;
  origin: IntervalOrigin;
  pagination?: InputMaybe<DimensionPaginationInput>;
};


export type QueryDocumentDownloadUrlArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryDocumentDownloadUrlsArgs = {
  ids: Array<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
};


export type QueryExportTransactionsArgs = {
  direction: DirectionFromOrigin;
  fields?: InputMaybe<Array<CsvExportField>>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  filter: TransactionFilter;
  order?: InputMaybe<TransactionOrder>;
  origin: IntervalOrigin;
  singleColumnAmount?: InputMaybe<Scalars['Boolean']['input']>;
  temporary?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFactIdForLedgerTransactionIdArgs = {
  ledgerTransactionId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryFetchSimilarTransactionsArgs = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  entryType: EntryType;
  factId: Scalars['String']['input'];
  numNeighbors?: InputMaybe<Scalars['Int']['input']>;
  viewKey: ViewKey;
};


export type QueryFindConnectionsByInstitutionArgs = {
  institutionName: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryFindThreadByCommentArgs = {
  commentId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryGenerateExecutiveSummaryArgs = {
  legalEntityId: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
  tone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBusinessVerificationApplicationArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryGetBusinessVerificationStatusArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryGetDocumentsTransactionFeaturesArgs = {
  documentIds: Array<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
};


export type QueryGetDraftInvoiceDefaultsArgs = {
  invoiceProfileId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryGetHostedOnboardingLinkArgs = {
  legalEntityId: Scalars['String']['input'];
  returnURL: Scalars['String']['input'];
};


export type QueryGetNextInvoiceNumberArgs = {
  invoiceProfileId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryHasExternallyManagedPaymentsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryHasRawCategoriesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryHighlightWorkItemArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  similarityType: SimilarityType;
};


export type QueryHydrateEntitiesArgs = {
  allowMissing?: InputMaybe<Scalars['Boolean']['input']>;
  identifiers: Array<HydrateIdentifier>;
  viewKey: ViewKey;
};


export type QueryLedgerGetBillDeliveryTimelineArgs = {
  billId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryLedgerGetBillExternalPaymentArgs = {
  billId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryLedgerGetDraftInvoiceDefaultsArgs = {
  invoiceProfileId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryLedgerGetNextInvoiceNumberArgs = {
  invoiceProfileId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryLedgerListBillWorkflowStatusUpdatesArgs = {
  billId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryLedgerListBillWorkflowsArgs = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
  prepareSplitLineItems?: InputMaybe<Scalars['Boolean']['input']>;
  splitLineItems?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<WorkflowStatus>>;
};


export type QueryLedgerListBillsByVendorArgs = {
  vendorId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryLedgerListConnectBillsArgs = {
  paidSinceDays?: InputMaybe<Scalars['Int']['input']>;
  viewKey: ViewKey;
};


export type QueryLedgerListConnectInvoicesArgs = {
  paidSinceDays?: InputMaybe<Scalars['Int']['input']>;
  viewKey: ViewKey;
};


export type QueryLedgerListInvoiceWorkflowStatusUpdatesArgs = {
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryLedgerListInvoicesByCustomerArgs = {
  customerId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryLedgerListInvoicingProfilesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryLedgerListPaidBillsArgs = {
  paidSinceDays?: InputMaybe<Scalars['Int']['input']>;
  viewKey: ViewKey;
};


export type QueryLedgerListPaidInvoicesArgs = {
  paidSinceDays?: InputMaybe<Scalars['Int']['input']>;
  viewKey: ViewKey;
};


export type QueryLedgerListPendingBillsArgs = {
  viewKey: ViewKey;
};


export type QueryLedgerListPendingInvoicesArgs = {
  viewKey: ViewKey;
};


export type QueryLedgerListRetryableBillPayoutIdsArgs = {
  vendorId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryLedgerListVoidedInvoicesArgs = {
  viewKey: ViewKey;
};


export type QueryLedgerPreviewInputInvoiceEmailArgs = {
  details: InputInvoiceEmailDetails;
  invoice: InputInvoice;
  legalEntityId: Scalars['String']['input'];
};


export type QueryLedgerPreviewInvoiceEmailArgs = {
  input: LedgerPreviewInvoiceEmailInput;
  legalEntityId: Scalars['String']['input'];
};


export type QueryLedgerReadBillTransactionArgs = {
  billId?: InputMaybe<Scalars['String']['input']>;
  transactionFactId?: InputMaybe<Scalars['String']['input']>;
  viewKey: ViewKey;
};


export type QueryLedgerReadInvoiceEmailConfigArgs = {
  dataSourcePartyId?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  profileId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLedgerReadInvoiceTransactionArgs = {
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  transactionFactId?: InputMaybe<Scalars['String']['input']>;
  viewKey: ViewKey;
};


export type QueryLedgerReadPaymentErrorStateArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryLedgerReadSentInvoiceFilesArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryLedgerSearchInvoiceCustomersArgs = {
  legalEntityId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type QueryLedgerSearchInvoiceDiscountsArgs = {
  legalEntityId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type QueryLedgerSearchInvoiceProductsArgs = {
  legalEntityId: Scalars['String']['input'];
  text: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryLedgerValidateInvoiceNumberArgs = {
  invoiceNumber: Scalars['String']['input'];
  invoiceProfileId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryListAccountReconciliationsArgs = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  direction: DirectionFromOrigin;
  filter?: InputMaybe<InputAccountReconciliationsFilter>;
  legalEntityId: Scalars['String']['input'];
  origin: IntervalOrigin;
  viewKey: ViewKey;
};


export type QueryListAccountantSuggestedUsersArgs = {
  object: InputObjectIdentifier;
  organizationId: Scalars['String']['input'];
};


export type QueryListActionItemsArgs = {
  filter: ActionItemFilter;
  origin?: InputMaybe<IntervalOrigin>;
  pagination: Pagination;
  viewKey: ViewKey;
};


export type QueryListActionItemsBadgeCountsArgs = {
  direction?: InputMaybe<DirectionFromOrigin>;
  filter: ActionItemFilter;
  legalEntities?: InputMaybe<Array<InputMaybe<LegalEntityPermission>>>;
  legalEntityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  origin: IntervalOrigin;
};


export type QueryListActivePartyRolesArgs = {
  direction?: InputMaybe<DirectionFromOrigin>;
  filter: SummaryFilterInput;
  origin?: InputMaybe<IntervalOrigin>;
};


export type QueryListActivePartyRolesBatchArgs = {
  inputs: Array<SummarizeInput>;
};


export type QueryListAffiliatesArgs = {
  affiliateType: AffiliateType;
  legalEntityId: Scalars['String']['input'];
};


export type QueryListAllWorkItemsArgs = {
  filter: WorkItemFilter;
  pagination: Pagination;
};


export type QueryListAppsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryListAssociationsHistoriesArgs = {
  legalEntityId: Scalars['String']['input'];
  objectIdentifiers: Array<InputObjectIdentifier>;
};


export type QueryListAuditRuleStatusesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListAuditRulesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListAuthConnectionsArgs = {
  legalEntityId: Scalars['String']['input'];
  useNewPaymentProvider?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryListAvailableBillingPlansArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryListBillingSubscriptionHistoryArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryListBoostBadgeCountsArgs = {
  direction: DirectionFromOrigin;
  filter: WorkItemBadgeCountFilter;
  origin: IntervalOrigin;
};


export type QueryListCascadeFinalizableReconciliationsArgs = {
  legalEntityId: Scalars['String']['input'];
  reconciliationId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryListCategoriesArgs = {
  categoryType?: InputMaybe<CategoryType>;
  viewKey: ViewKey;
};


export type QueryListCategoryIntegrationsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListCategoryMappingsArgs = {
  legalEntityId: Scalars['String']['input'];
  product: CategoryToLabelMappingProduct;
};


export type QueryListClientBillingPlansArgs = {
  affiliatedLegalEntityId: Scalars['String']['input'];
  affiliatedOrganizationId: Scalars['String']['input'];
  firmOrganizationId: Scalars['String']['input'];
};


export type QueryListClosedPeriodMatchRequestTransactionsArgs = {
  requestId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryListClosedPeriodTransactionChangeDiffsArgs = {
  ledgerTransactionId: Scalars['String']['input'];
  requestIds: Array<Scalars['String']['input']>;
  viewKey: ViewKey;
};


export type QueryListConnectionBadgeCountsArgs = {
  filter: ConnectionBadgeCountFilter;
};


export type QueryListConnectionsArgs = {
  filter?: InputMaybe<ListConnectionsFilter>;
  legalEntityId: Scalars['String']['input'];
};


export type QueryListConnectorInstallCandidatesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListConnectorTemplatesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListConnectorsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListDataSourcesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListDataSourcesByIdsArgs = {
  legalEntityIds: Array<Scalars['String']['input']>;
};


export type QueryListDepartmentFactHierarchyArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListDepartmentsArgs = {
  status?: InputMaybe<DepartmentStatus>;
  viewKey: ViewKey;
};


export type QueryListDocumentAssociationsArgs = {
  documentIds: Array<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
};


export type QueryListDocumentsArgs = {
  filter?: InputMaybe<DocumentFilter>;
  legalEntityId: Scalars['String']['input'];
  order?: InputMaybe<DocumentSort>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryListDocumentsByTypeArgs = {
  documentType: DocumentType;
  featureKinds?: InputMaybe<Array<FeatureKind>>;
  legalEntityId: Scalars['String']['input'];
  pagination?: InputMaybe<Pagination>;
};


export type QueryListDraftInvoiceSummariesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListDraftInvoicesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListEmployeesArgs = {
  filter: EmployeeFilter;
  pagination: Pagination;
  sort?: InputMaybe<EmployeeSort>;
};


export type QueryListEmployeesAffiliationsArgs = {
  filter: EmployeeFilter;
  pagination: Pagination;
  sort?: InputMaybe<EmployeeSort>;
};


export type QueryListEnrichedDataSourcesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListFirmClientsArgs = {
  direction: DirectionFromOrigin;
  filter: FirmClientFilter;
  origin: IntervalOrigin;
  pagination: Pagination;
  sort?: InputMaybe<FirmClientSort>;
};


export type QueryListInsightsArgs = {
  direction: DirectionFromOrigin;
  filter: InsightFilter;
  origin: IntervalOrigin;
  pagination: Pagination;
};


export type QueryListInstitutionsArgs = {
  filter?: InputMaybe<InstitutionFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryListInvoiceBrandingsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListInvoicingProfilesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListLatestDataSourceRefreshesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListLatestPartyHistoriesArgs = {
  legalEntityId: Scalars['String']['input'];
  partyIds: Array<Scalars['String']['input']>;
};


export type QueryListLedgerTransactionsArgs = {
  ledgerTransactionIds: Array<Scalars['String']['input']>;
  viewKey: ViewKey;
};


export type QueryListLegalEntityUsersArgs = {
  id: Scalars['String']['input'];
};


export type QueryListLimitedSuggestedUsersArgs = {
  object: InputObjectIdentifier;
};


export type QueryListLineClassFactHierarchyArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListLocationsArgs = {
  status?: InputMaybe<LocationStatus>;
  viewKey: ViewKey;
};


export type QueryListMetricTransactionsArgs = {
  metricSummaryType?: InputMaybe<MetricSummaryItem>;
  order?: InputMaybe<TransactionOrder>;
  origin: IntervalOrigin;
  pagination: Pagination;
  summaryLineType?: InputMaybe<SummaryLineItem>;
  viewKey: ViewKey;
};


export type QueryListMetricsArgs = {
  key: SourceAccountMetricKey;
  legalEntityId: Scalars['String']['input'];
  origin: IntervalOrigin;
};


export type QueryListObjectAcLsArgs = {
  ids: Array<Scalars['String']['input']>;
  kind: ObjectKind;
  legalEntityId: Scalars['String']['input'];
};


export type QueryListObjectAssociationsArgs = {
  legalEntityId: Scalars['String']['input'];
  objectIdentifiers: Array<InputObjectIdentifier>;
};


export type QueryListOnboardingPromotionCodesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryListOrganizationAffiliationsArgs = {
  id: Scalars['String']['input'];
};


export type QueryListOrganizationDefaultLegalEntityRolesArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryListOrganizationInvitationsArgs = {
  id: Scalars['String']['input'];
};


export type QueryListOrganizationLegalEntitiesArgs = {
  id: Scalars['String']['input'];
};


export type QueryListOrganizationRoleOptionsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryListOrganizationUsersArgs = {
  id: Scalars['String']['input'];
};


export type QueryListOwnedDataSourcesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListPartyTaxInfoArgs = {
  direction: DirectionFromOrigin;
  filter: TransactionFilter;
  origin: IntervalOrigin;
};


export type QueryListProductGroupsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListProductTransactionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryListProductVariantsForCatalogArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListProductVariantsForInvoiceArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListProductsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListQualityCheckGroupsArgs = {
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListQualityChecksArgs = {
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListQuotePackagesByLegalEntityArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListRawCategoriesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListReconciliationFlagsArgs = {
  reconciliationIntentId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryListReconciliationHistoryArgs = {
  legalEntityId: Scalars['String']['input'];
  reconciliationId: Scalars['String']['input'];
};


export type QueryListReconciliationIntentsArgs = {
  actionItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  intentCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  legalEntityId: Scalars['String']['input'];
  states?: InputMaybe<Array<ReconciliationIntentState>>;
};


export type QueryListReconciliationIntentsByReconciliationIdArgs = {
  legalEntityId: Scalars['String']['input'];
  reconciliationId: Scalars['String']['input'];
  states?: InputMaybe<Array<ReconciliationIntentState>>;
};


export type QueryListReportPackagesArgs = {
  direction: DirectionFromOrigin;
  filter?: InputMaybe<PackagesFilter>;
  legalEntityId: Scalars['String']['input'];
  origin: IntervalOrigin;
  pagination: Pagination;
  sort?: InputMaybe<PackagesSort>;
};


export type QueryListReportTemplatesArgs = {
  interval: Interval;
  legalEntityId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
};


export type QueryListReportsBadgeCountsArgs = {
  direction: DirectionFromOrigin;
  legalEntityIds: Array<Scalars['String']['input']>;
  origin: IntervalOrigin;
};


export type QueryListScheduleEventTemplatesArgs = {
  legalEntityId: Scalars['String']['input'];
  scheduleTemplateId: Scalars['String']['input'];
};


export type QueryListScheduleSnapshotsArgs = {
  direction: DirectionFromOrigin;
  filter: ScheduleDashboardFilter;
  order?: InputMaybe<ScheduleOrder>;
  origin: IntervalOrigin;
  pagination: Pagination;
};


export type QueryListScheduleSpecializationsArgs = {
  legalEntityId: Scalars['String']['input'];
  scheduleTemplateId: Scalars['String']['input'];
};


export type QueryListScheduleTemplatesByIDsArgs = {
  legalEntityId: Scalars['String']['input'];
  scheduleTemplateIds: Array<Scalars['String']['input']>;
};


export type QueryListScheduleTemplatesByTypesArgs = {
  legalEntityId: Scalars['String']['input'];
  types?: InputMaybe<Array<ScheduleType>>;
};


export type QueryListSentInvoicesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListShareSuggestedUsersArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryListSimilarActionItemsArgs = {
  items: Array<SimilarActionItem>;
  legalEntityId: Scalars['String']['input'];
};


export type QueryListSimilarTransactionsArgs = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  entryType: EntryType;
  factId: Scalars['String']['input'];
  numNeighbors?: InputMaybe<Scalars['Int']['input']>;
  viewKey: ViewKey;
};


export type QueryListSuggestedUsersArgs = {
  object: InputObjectIdentifier;
  organizationId: Scalars['String']['input'];
};


export type QueryListThreadsArgs = {
  idsByKind: IdentifiersByKind;
  viewType: ViewType;
};


export type QueryListTransactionEditingHistoryArgs = {
  factId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryListTransactionReviewQuestionsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryListTransactionsArgs = {
  direction: DirectionFromOrigin;
  filter: TransactionFilter;
  naturalFlow?: InputMaybe<Flow>;
  order?: InputMaybe<TransactionOrder>;
  origin: IntervalOrigin;
  pagination: Pagination;
};


export type QueryListTransactionsByFactIdsArgs = {
  factIds: Array<Scalars['String']['input']>;
  viewKey: ViewKey;
};


export type QueryListWebhookEndpointDeliveryEventsArgs = {
  connectorId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  pagination: Pagination;
  webhookEndpointId: Scalars['String']['input'];
};


export type QueryListWebhookEndpointsArgs = {
  connectorId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryListWorkItemsArgs = {
  direction: DirectionFromOrigin;
  filter: WorkItemFilter;
  origin: IntervalOrigin;
};


export type QueryListWorkItemsByIdsArgs = {
  legalEntityId: Scalars['String']['input'];
  workItemIds: Array<Scalars['String']['input']>;
};


export type QueryLiveComponentDataArgs = {
  config: LayoutComponentConfigInput;
  viewId: ViewIdentifierInput;
};


export type QueryMetricTransactionSummaryArgs = {
  metricSummaryType?: InputMaybe<MetricSummaryItem>;
  origin: IntervalOrigin;
  summaryLineType?: InputMaybe<SummaryLineItem>;
  viewKey: ViewKey;
};


export type QueryMinMaxAmountArgs = {
  direction: DirectionFromOrigin;
  filter: TransactionFilter;
  origin: IntervalOrigin;
};


export type QueryOnboardConnectionsArgs = {
  institutionProducts: Array<InstitutionProduct>;
  legalEntityId: Scalars['String']['input'];
};


export type QueryPreviewBillingSubscriptionArgs = {
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
};


export type QueryPreviewBillingSubscriptionPriceArgs = {
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPreviewInputInvoiceEmailArgs = {
  details: InputInvoiceEmailDetails;
  invoice: InputInvoice;
  legalEntityId: Scalars['String']['input'];
};


export type QueryPreviewInvoiceEmailArgs = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryPreviewSubscriptionUpdateArgs = {
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductInsightTransactionSummaryArgs = {
  defaultCategoryType?: InputMaybe<CategoryType>;
  dimensions: Array<SummaryDimension>;
  direction: DirectionFromOrigin;
  filter: SummaryFilterInput;
  masks?: InputMaybe<Array<Array<SummaryDimension>>>;
  origin: IntervalOrigin;
};


export type QueryReadAccountReconciliationArgs = {
  legalEntityId: Scalars['String']['input'];
  reconciliationId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryReadActionItemArgs = {
  actionItemId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryReadActivityFeedArgs = {
  identifier?: InputMaybe<InputObjectIdentifier>;
  legalEntityId: Scalars['String']['input'];
  page: Pagination;
};


export type QueryReadAppArgs = {
  connectorId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryReadAppAuthorizationArgs = {
  clientId: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  responseType: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']>;
};


export type QueryReadAppCredentialsArgs = {
  connectorId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryReadAppInstanceArgs = {
  id: Scalars['String']['input'];
};


export type QueryReadAssociatedThreadsArgs = {
  allowResolved?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  kind: ObjectKind;
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadBillingArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryReadBillingAddressArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryReadBillingArrangementArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryReadBillingCustomerProfileArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryReadBillingOrganizationPlanArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryReadBillingPlansArgs = {
  organizationId: Scalars['String']['input'];
  productNames: Array<Scalars['String']['input']>;
};


export type QueryReadBillingSubscriptionHistoryArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryReadBillingSubscriptionStatusArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryReadBooksClosedDateArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadCategoryArgs = {
  categoryId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryReadCategorySuggestionsArgs = {
  entryType: EntryType;
  legalEntityId: Scalars['String']['input'];
  transactionFactId: Scalars['String']['input'];
};


export type QueryReadComponentDataArgs = {
  dataId: Scalars['String']['input'];
  layoutId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadConnectionArgs = {
  connectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadDataSourcePreferencesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadDateClosedPeriodRequestAffectedCountArgs = {
  legalEntityId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
};


export type QueryReadDefaultApproverArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadDepartmentArgs = {
  departmentId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryReadDocumentArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadDraftInvoiceArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadEmployeeArgs = {
  employeeId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryReadFactIdArgs = {
  dataSourceId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  externalLineItemId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadFirmBillingPlansArgs = {
  affiliatedLegalEntityId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type QueryReadInvitationProposalArgs = {
  proposalId: Scalars['String']['input'];
};


export type QueryReadLayoutArgs = {
  includeEntities?: InputMaybe<Scalars['Boolean']['input']>;
  layoutId: Scalars['String']['input'];
  layoutVersionId?: InputMaybe<Scalars['String']['input']>;
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadLedgerTransactionArgs = {
  filter: TransactionFilter;
  transactionFactId: Scalars['String']['input'];
};


export type QueryReadLedgerTransactionByIdArgs = {
  ledgerTransactionId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryReadLegalEntityArgs = {
  id: Scalars['String']['input'];
};


export type QueryReadLegalEntityMetadataArgs = {
  viewKey: ViewKey;
};


export type QueryReadLegalEntityPreferencesArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadLegalEntityResetArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadLinkedObjectDetailsArgs = {
  linkedObjectId: Scalars['String']['input'];
  linkedObjectType: LinkedObjectType;
  viewKey: ViewKey;
};


export type QueryReadLocationArgs = {
  locationId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryReadMetricEquationArgs = {
  layoutComponentConfig?: InputMaybe<LayoutComponentConfigInput>;
  layoutComponentType?: InputMaybe<LayoutComponentType>;
  metricSummaryType?: InputMaybe<MetricSummaryItem>;
  origin?: InputMaybe<IntervalOrigin>;
  summaryLineType?: InputMaybe<SummaryLineItem>;
  viewKey: ViewKey;
};


export type QueryReadNotificationArgs = {
  id: Scalars['String']['input'];
};


export type QueryReadNotificationSettingsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadOAuthClientArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryReadOrCreatePortalLayoutArgs = {
  viewId: ViewIdentifierInput;
};


export type QueryReadOrganizationArgs = {
  id: Scalars['String']['input'];
};


export type QueryReadOrganizationBillingPlanArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryReadOrganizationBrandingArgs = {
  id: Scalars['String']['input'];
};


export type QueryReadOrganizationPreferencesArgs = {
  id: Scalars['String']['input'];
};


export type QueryReadPartyArgs = {
  partyId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryReadPaymentErrorStateArgs = {
  legalEntityId: Scalars['String']['input'];
  product: PaymentErrorProduct;
};


export type QueryReadPortalLayoutArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadProductArgs = {
  dataSourceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type QueryReadProductActivityArgs = {
  dataSourceId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type QueryReadProductGroupArgs = {
  legalEntityId: Scalars['String']['input'];
  productGroupId: Scalars['String']['input'];
};


export type QueryReadQualityCheckArgs = {
  checkId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  viewKey?: InputMaybe<ViewKey>;
};


export type QueryReadQualityCheckDryRunArgs = {
  checkId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  viewKey: ViewKey;
};


export type QueryReadReconciliationDiffArgs = {
  reconciliationId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryReadReconciliationFactClassificationArgs = {
  legalEntityId: Scalars['String']['input'];
  transactionFactId: Scalars['String']['input'];
};


export type QueryReadReconciliationPeriodStatsArgs = {
  direction: DirectionFromOrigin;
  legalEntityId: Scalars['String']['input'];
  origin: IntervalOrigin;
  viewKey: ViewKey;
};


export type QueryReadReconciliationsPdfsArgs = {
  documentCollectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadReportArchiveArgs = {
  legalEntityId: Scalars['String']['input'];
  reportFileSource?: InputMaybe<ReportFileSource>;
  reportId: Scalars['String']['input'];
  reportPackageId: Scalars['String']['input'];
  reportVersionId: Scalars['String']['input'];
};


export type QueryReadReportAutomationSettingsArgs = {
  interval: Interval;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type QueryReadReportPackageArgs = {
  legalEntityId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
  packageVersionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReadRequireBillApproverDifferentFromCreatorArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadScheduleArgs = {
  scheduleId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryReadScheduleCandidateArgs = {
  sourceTransactionFactId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryReadScheduleDefaultsArgs = {
  inCreateFlow?: InputMaybe<Scalars['Boolean']['input']>;
  recategorizedSourceCategoryId?: InputMaybe<Scalars['String']['input']>;
  scheduleImportCandidateId?: InputMaybe<Scalars['String']['input']>;
  scheduleTemplateId: Scalars['String']['input'];
  sourceTransactionFactId?: InputMaybe<Scalars['String']['input']>;
  specializationId?: InputMaybe<Scalars['String']['input']>;
  viewKey: ViewKey;
};


export type QueryReadScheduleEditingHistoryArgs = {
  legalEntityId: Scalars['String']['input'];
  scheduleId: Scalars['String']['input'];
  scheduleTemplateId: Scalars['String']['input'];
};


export type QueryReadScheduleImportCandidateArgs = {
  scheduleImportCandidateId: Scalars['String']['input'];
  viewKey: ViewKey;
};


export type QueryReadSchedulePreviewArgs = {
  events: Array<ScheduleEventInput>;
  recategorizedSourceCategoryId?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  scheduleTemplateId: Scalars['String']['input'];
  sourceTransactionFactId?: InputMaybe<Scalars['String']['input']>;
  viewKey: ViewKey;
};


export type QueryReadSentInvoiceArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadSentInvoiceFilesArgs = {
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadShareArgs = {
  id: Scalars['String']['input'];
  intentId?: InputMaybe<Scalars['String']['input']>;
  kind: ObjectKind;
};


export type QueryReadShareAdjacencyArgs = {
  id: Scalars['String']['input'];
  kind: ObjectKind;
  legalEntitySlug: Scalars['String']['input'];
};


export type QueryReadThreadArgs = {
  allowResolved?: InputMaybe<Scalars['Boolean']['input']>;
  threadId: Scalars['String']['input'];
};


export type QueryReadTransactionDetailsArgs = {
  filter: TransactionFilter;
  transactionFactId: Scalars['String']['input'];
};


export type QueryReadTransactionReviewNextReminderArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadTransactionReviewReminderMessageArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadTransactionReviewScheduleArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadTransactionWorkItemIdArgs = {
  factId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};


export type QueryReadUncategorizedExpenseCategoryArgs = {
  viewKey: ViewKey;
};


export type QueryReadUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryReadVanityStatsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryReportDownloadUrlArgs = {
  legalEntityId: Scalars['String']['input'];
  reportFileSource?: InputMaybe<ReportFileSource>;
  reportId: Scalars['String']['input'];
  reportPackageId: Scalars['String']['input'];
  reportVersionId: Scalars['String']['input'];
};


export type QueryScheduleFacetArgs = {
  direction: DirectionFromOrigin;
  field: ScheduleFacetField;
  filter: ScheduleDashboardFilter;
  origin: IntervalOrigin;
  pagination: Pagination;
};


export type QuerySearchEntitiesArgs = {
  kind: ObjectKind;
  legalEntityId: Scalars['String']['input'];
  occurredAfter?: InputMaybe<Scalars['Float']['input']>;
  occurredBefore?: InputMaybe<Scalars['Float']['input']>;
  page: Pagination;
  sort?: InputMaybe<Array<SearchEntitiesSort>>;
  sortHitsLeftmost?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  viewType?: InputMaybe<ViewType>;
  viewVersion?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchGlobalPartiesArgs = {
  page: Pagination;
  sort?: InputMaybe<Array<SearchEntitiesSort>>;
  sortHitsLeftmost?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  viewType?: InputMaybe<ViewType>;
};


export type QuerySearchInvoiceCustomersArgs = {
  legalEntityId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type QuerySearchInvoiceDiscountsArgs = {
  legalEntityId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type QuerySearchInvoiceProductsArgs = {
  legalEntityId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type QuerySearchTermsArgs = {
  kinds?: InputMaybe<Array<ObjectKind>>;
  legalEntityId: Scalars['String']['input'];
  sort?: InputMaybe<Array<SearchEntitiesSort>>;
  text: Scalars['String']['input'];
  viewType?: InputMaybe<ViewType>;
  viewVersion?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySuggestedConnectionsArgs = {
  filter: SuggestedConnectionsFilter;
  legalEntityId: Scalars['String']['input'];
};


export type QuerySummarizeActionItemsByExternalKeyArgs = {
  filter: ActionItemFilter;
  legalEntityId: Scalars['String']['input'];
  origin?: InputMaybe<IntervalOrigin>;
};


export type QuerySummarizeActionItemsByGroupArgs = {
  filter: ActionItemFilter;
  legalEntityId: Scalars['String']['input'];
  origin?: InputMaybe<IntervalOrigin>;
};


export type QuerySummarizeActionItemsByObjectKindArgs = {
  filter: ActionItemFilter;
  legalEntityId: Scalars['String']['input'];
  origin?: InputMaybe<IntervalOrigin>;
};


export type QuerySummarizeActionItemsByTimeArgs = {
  filter: ActionItemFilter;
  origin: IntervalOrigin;
  viewKey: ViewKey;
};


export type QuerySummarizeDocumentsArgs = {
  filter?: InputMaybe<DocumentFilter>;
  legalEntityId: Scalars['String']['input'];
};


export type QuerySummarizeReportPackagesArgs = {
  direction: DirectionFromOrigin;
  legalEntityId: Scalars['String']['input'];
  origin: IntervalOrigin;
};


export type QuerySummarizeTrialBalanceArgs = {
  origin: IntervalOrigin;
  viewKey: ViewKey;
};


export type QuerySummarizeWorkItemsArgs = {
  direction: DirectionFromOrigin;
  filter: WorkItemFilter;
  origin: IntervalOrigin;
};


export type QueryTransactionFacetArgs = {
  direction: DirectionFromOrigin;
  field: TransactionFacetField;
  filter: FacetFilter;
  origin: IntervalOrigin;
  pagination: Pagination;
};


export type QueryUserWorkflowActivityArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryValidateCategoryMappingsArgs = {
  legalEntityId: Scalars['String']['input'];
  product: CategoryToLabelMappingProduct;
  useNewPaymentProvider?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryValidateInvoiceNumberArgs = {
  invoiceNumber: Scalars['String']['input'];
  invoiceProfileId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};

export type QuickBooksAccountingInfoPreferences = {
  bookCloseDate?: Maybe<Date>;
};

export type QuickBooksCompany = {
  preferences?: Maybe<QuickBooksPreferences>;
};

export type QuickBooksConfig = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  realmId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type QuickBooksPreferences = {
  accountingInfo?: Maybe<QuickBooksAccountingInfoPreferences>;
};

export type QuotePackage = {
  companyDetails: CompanyDetails;
  contractDocumentId?: Maybe<Scalars['String']['output']>;
  financials?: Maybe<Array<CompanyFinancials>>;
  id: Scalars['String']['output'];
  recipient?: Maybe<Contact>;
  status: QuoteStatus;
};

export type QuotePackageId = {
  id: Scalars['String']['output'];
};

export enum QuoteStatus {
  Accepted = 'Accepted',
  Created = 'Created',
  CustomerReview = 'CustomerReview',
  Deferred = 'Deferred',
  New = 'New',
  UnknownQuoteStatus = 'UnknownQuoteStatus'
}

export type RampConnectorProperties = {
  authorizationURL: Scalars['String']['output'];
};

export type RawDocument = {
  asyncProcessingStatus: AsyncProcessingStatus;
  collectionId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<EntityUser>;
  dataSource?: Maybe<EntityDataSource>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  features: Array<Feature>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Float']['output']>;
  formats: Array<Format>;
  id: Scalars['String']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  sourceFormat?: Maybe<Format>;
  sourceFormatId?: Maybe<Scalars['String']['output']>;
  status: DocumentStatus;
  thumbnail?: Maybe<Segment>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** ReadLedgerTransaction is the output type of readLedgerTransaction GraphQL query */
export type ReadLedgerTransaction = {
  transaction: LedgerTransaction;
};

export enum RealtimeHealthStatus {
  HasLoginRequired = 'HasLoginRequired',
  HasPredictions = 'HasPredictions',
  Healthy = 'Healthy',
  UnknownHealthStatus = 'UnknownHealthStatus'
}

export enum Reconciliation {
  Reconciled = 'Reconciled',
  Unreconciled = 'Unreconciled'
}

export type ReconciliationBalances = {
  ledgerAccountDifferences: LedgerAccountDifferences;
  ledgerBalances: LedgerBalances;
  statementBalances: StatementBalances;
};

export type ReconciliationDetails = {
  balances: ReconciliationBalances;
  maxClassificationUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  normalEntryType: EntryType;
  reconciledSystemClassificationsCount: Scalars['Int']['output'];
  reconciliation: AccountReconciliation;
  transactionCounts: TransactionCounts;
  unsettledSystemClassificationsCount: Scalars['Int']['output'];
};

export type ReconciliationDiff = {
  reconciliationId: Scalars['String']['output'];
  toEndDate: Date;
  toStartDate: Date;
  transactions: Array<ReconciliationDiffTransaction>;
};

export enum ReconciliationDiffReason {
  Added = 'Added',
  Amount = 'Amount',
  EntryType = 'EntryType',
  OccurredAt = 'OccurredAt',
  ReconciliationStatus = 'ReconciliationStatus',
  Removed = 'Removed',
  UnknownReason = 'UnknownReason'
}

export type ReconciliationDiffTransaction = {
  diffReasons: Array<ReconciliationDiffReason>;
  fromAmount?: Maybe<MonetaryValue>;
  fromEntryType?: Maybe<EntryType>;
  fromOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  fromStatus?: Maybe<TransactionReconciliationStatus>;
  toAmount?: Maybe<MonetaryValue>;
  toEntryType?: Maybe<EntryType>;
  toOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  toStatus?: Maybe<TransactionReconciliationStatus>;
  transaction?: Maybe<Transaction>;
  transactionFactId: Scalars['String']['output'];
};

export enum ReconciliationEventType {
  AutoCreatedReconciliation = 'AutoCreatedReconciliation',
  FinalizedReconciliation = 'FinalizedReconciliation',
  ManualCreatedReconciliation = 'ManualCreatedReconciliation',
  ReconfiguredReconciliation = 'ReconfiguredReconciliation',
  ReopenedReconciliation = 'ReopenedReconciliation',
  UnknownReconciliation = 'UnknownReconciliation'
}

export enum ReconciliationFilter {
  FindAll = 'FindAll',
  OccurredInPeriodReconciled = 'OccurredInPeriodReconciled',
  OccurredInPeriodUnreconciled = 'OccurredInPeriodUnreconciled',
  Reconciled = 'Reconciled',
  Unreconciled = 'Unreconciled',
  Unspecified = 'Unspecified'
}

export type ReconciliationFlag = {
  changeDateDetails?: Maybe<ChangeDateFlagDetails>;
  createNewTransactionDetails?: Maybe<CreateNewTransactionFlagDetails>;
  createdAt: Scalars['DateTime']['output'];
  flagId: Scalars['String']['output'];
  flagType: ReconciliationFlagType;
  /** Exactly one of these will be populated based on flagType */
  potentialDuplicateDetails?: Maybe<PotentialDuplicateFlagDetails>;
  potentialMismatchDetails?: Maybe<PotentialMismatchFlagDetails>;
  reconciliationIntentId: Scalars['String']['output'];
  resolutionType?: Maybe<ReconciliationFlagResolutionType>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedByUser?: Maybe<EntityUser>;
};

export enum ReconciliationFlagResolutionType {
  Dismissed = 'Dismissed',
  Resolved = 'Resolved',
  UnknownResolutionType = 'UnknownResolutionType'
}

export enum ReconciliationFlagType {
  ChangeDateFlagType = 'ChangeDateFlagType',
  CreateNewTransactionFlagType = 'CreateNewTransactionFlagType',
  PotentialDuplicateFlagType = 'PotentialDuplicateFlagType',
  PotentialMismatchFlagType = 'PotentialMismatchFlagType',
  UnknownFlagType = 'UnknownFlagType'
}

export type ReconciliationHistoryEvent = {
  eventType: ReconciliationEventType;
  reconciliationId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  user?: Maybe<EntityUser>;
};

export type ReconciliationIntent = {
  actionItemId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  documentCollectionId?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['String']['output'];
  initiatedByUserId?: Maybe<Scalars['String']['output']>;
  intentCategoryId?: Maybe<Scalars['String']['output']>;
  intentChartOfAccountsId?: Maybe<Scalars['String']['output']>;
  legalEntityId: Scalars['String']['output'];
  /**
   * AccountGroup feature_group_id ABR resolved for this intent. When set,
   * FE callers scope feature-level rendering to features whose `groups`
   * include this id so a multi-account document surfaces only the
   * account that belongs to this intent's reconciliation. Empty for
   * single-account statements and legacy intents.
   */
  matchedAccountFeatureGroupId?: Maybe<Scalars['String']['output']>;
  processingEndedAt?: Maybe<Scalars['DateTime']['output']>;
  processingStartedAt?: Maybe<Scalars['DateTime']['output']>;
  reconciliationCategoryId?: Maybe<Scalars['String']['output']>;
  reconciliationChartOfAccountsId?: Maybe<Scalars['String']['output']>;
  reconciliationId?: Maybe<Scalars['String']['output']>;
  reconciliationIntentId: Scalars['String']['output'];
  state: ReconciliationIntentState;
};

export type ReconciliationIntentDetails = {
  actionItemId?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['String']['output'];
  initiatedByUserId?: Maybe<Scalars['String']['output']>;
  intentCategoryId?: Maybe<Scalars['String']['output']>;
  /**
   * AccountGroup feature_group_id ABR resolved for this intent. When set,
   * FE callers scope feature-level rendering (e.g. bounding boxes) to
   * features whose `groups` include this id.
   */
  matchedAccountFeatureGroupId?: Maybe<Scalars['String']['output']>;
  processingEndedAt?: Maybe<Scalars['DateTime']['output']>;
  reconciliationIntentId: Scalars['String']['output'];
  state: ReconciliationIntentState;
};

export enum ReconciliationIntentState {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  DocumentProcessing = 'DocumentProcessing',
  Failed = 'Failed',
  InvalidCategory = 'InvalidCategory',
  InvalidDocument = 'InvalidDocument',
  ReconciliationProcessing = 'ReconciliationProcessing',
  UnknownState = 'UnknownState'
}

export type ReconciliationPeriodStats = {
  drafts: Scalars['Int']['output'];
  finalized: Scalars['Int']['output'];
  noActivity?: Maybe<Scalars['Int']['output']>;
  notStarted: Scalars['Int']['output'];
  totalCategories: Scalars['Int']['output'];
};

export enum ReconciliationsExportStatus {
  Completed = 'Completed',
  Pending = 'Pending',
  Unknown = 'Unknown'
}

export type ReconciliationsPdfs = {
  completedDocumentCount: Scalars['Long']['output'];
  documentCollectionId: Scalars['String']['output'];
  documentUrls: Array<Scalars['String']['output']>;
  status: ReconciliationsExportStatus;
  totalDocumentCount: Scalars['Long']['output'];
};

export type RemittanceFeatureValue = {
  remittanceValue: RemittanceItem;
};

export type RemittanceItem = {
  BankAccountName?: Maybe<Scalars['String']['output']>;
  BankAccountNumber: Scalars['String']['output'];
  BankName: Scalars['String']['output'];
  BankRoutingNumber: Scalars['String']['output'];
  RemittanceType: RemittanceType;
};

export enum RemittanceType {
  ACH = 'ACH',
  Unknown = 'Unknown',
  Wire = 'Wire'
}

export type Report = {
  author?: Maybe<Contact>;
  createdAt: Scalars['DateTime']['output'];
  generationHistory?: Maybe<ReportGenerationHistory>;
  id: Scalars['String']['output'];
  interval: Interval;
  options?: Maybe<ReportDocumentOptions>;
  reportFile: ReportFileMetadata;
  reportFor?: Maybe<Date>;
  status: ReportPackageDocumentStatus;
  title: Scalars['String']['output'];
  versionId: Scalars['String']['output'];
};

export enum ReportAction {
  Print = 'Print'
}

export type ReportActionEvent = {
  action: ReportAction;
  packageId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** Report automation settings */
export type ReportAutomationSettings = {
  autoCreateDraft: Scalars['Boolean']['output'];
  autoPublishDraft: Scalars['Boolean']['output'];
  autoPublishDraftDay: Scalars['Long']['output'];
  autoPublishFinal: Scalars['Boolean']['output'];
  autoPublishFinalDay: Scalars['Long']['output'];
  interval: Interval;
  legalEntityId?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
};

export enum ReportBreakdownByClass {
  Department = 'Department',
  InvalidBreakdown = 'InvalidBreakdown',
  Location = 'Location'
}

export type ReportDocumentOptions = {
  amountPrecision?: Maybe<ReportNumberPrecision>;
  breakdownByClass?: Maybe<ReportBreakdownByClass>;
  categoryByDepartmentOptions?: Maybe<CategoryByDepartmentOptions>;
  categoryByLocationOptions?: Maybe<CategoryByLocationOptions>;
  collapsedSections?: Maybe<CollapsedSections>;
  comparedToIncome?: Maybe<ReportOptionComparison>;
  comparedToTotal?: Maybe<ReportOptionComparison>;
  deltaMonthOverMonth?: Maybe<ReportOptionComparison>;
  deltaMonthOverMonthPeriods?: Maybe<Scalars['Int']['output']>;
  deltaYearOverYear?: Maybe<ReportOptionComparison>;
  deltaYearToDate?: Maybe<ReportOptionComparison>;
  reportLookbackPeriods?: Maybe<Scalars['Int']['output']>;
  sparklineLookbackPeriods?: Maybe<Scalars['Int']['output']>;
  yearToDate?: Maybe<ReportOptionComparison>;
};

export type ReportDocumentOptionsInput = {
  amountPrecision?: InputMaybe<ReportNumberPrecision>;
  breakdownByClass?: InputMaybe<ReportBreakdownByClass>;
  categoryByDepartmentOptions?: InputMaybe<CategoryByDepartmentOptionsInput>;
  categoryByLocationOptions?: InputMaybe<CategoryByLocationOptionsInput>;
  collapsedSections?: InputMaybe<CollapsedSectionsInput>;
  comparedToIncome?: InputMaybe<ReportOptionComparison>;
  comparedToTotal?: InputMaybe<ReportOptionComparison>;
  deltaMonthOverMonth?: InputMaybe<ReportOptionComparison>;
  deltaMonthOverMonthPeriods?: InputMaybe<Scalars['Int']['input']>;
  deltaYearOverYear?: InputMaybe<ReportOptionComparison>;
  deltaYearToDate?: InputMaybe<ReportOptionComparison>;
  reportLookbackPeriods?: InputMaybe<Scalars['Int']['input']>;
  sparklineLookbackPeriods?: InputMaybe<Scalars['Int']['input']>;
  yearToDate?: InputMaybe<ReportOptionComparison>;
};

export type ReportDownload = {
  url: Scalars['String']['output'];
};

export type ReportFileMetadata = {
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  source: ReportFileSource;
};

export enum ReportFileSource {
  AVS = 'AVS',
  DataIngestion = 'DataIngestion',
  UnknownFileSource = 'UnknownFileSource',
  UserUploaded = 'UserUploaded'
}

export type ReportGenerationHistory = {
  authorId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  generationEndedAt?: Maybe<Scalars['DateTime']['output']>;
  generationStartedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  kind: ReportKind;
  legalEntityId: Scalars['String']['output'];
  periodEndedAt: Scalars['DateTime']['output'];
  periodStartedAt: Scalars['DateTime']['output'];
  reportId: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  versionId: Scalars['String']['output'];
  viewVersion: Scalars['Float']['output'];
};

export type ReportGenerationStatus = {
  reportId: Scalars['String']['output'];
  status: GenerationStatus;
  versionId: Scalars['String']['output'];
};

export enum ReportKind {
  APAging = 'APAging',
  ARAging = 'ARAging',
  BalanceSheet = 'BalanceSheet',
  CashFlow = 'CashFlow',
  ExpenseSummary = 'ExpenseSummary',
  ProfitAndLoss = 'ProfitAndLoss',
  Unknown = 'Unknown'
}

export enum ReportNumberPrecision {
  Decimal = 'Decimal',
  InvalidNumberPrecision = 'InvalidNumberPrecision',
  Rounded = 'Rounded'
}

export enum ReportOptionComparison {
  Amount = 'Amount',
  DeltaPercent = 'DeltaPercent',
  InvalidComparison = 'InvalidComparison',
  LookbackAverageDeltaPercent = 'LookbackAverageDeltaPercent',
  Percent = 'Percent',
  Total = 'Total',
  /** @deprecated Use LookbackAverageDeltaPercent */
  TriPeriodDeltaPercent = 'TriPeriodDeltaPercent'
}

export enum ReportOptionTimelineInterval {
  InvalidInterval = 'InvalidInterval',
  Last3Months = 'Last3Months',
  Last6Months = 'Last6Months',
  Last12Months = 'Last12Months'
}

export type ReportPackage = {
  author?: Maybe<Contact>;
  authorOrganization?: Maybe<OrganizationPreview>;
  createdAt: Scalars['DateTime']['output'];
  documents: Array<ReportPackageDocumentDetails>;
  endedAt: Scalars['DateTime']['output'];
  entities: ObjectEntities;
  id: Scalars['String']['output'];
  interval: Interval;
  legalEntityOrganization?: Maybe<OrganizationPreview>;
  packageOptions?: Maybe<ReportPackageOptions>;
  startedAt: Scalars['DateTime']['output'];
  status: ReportPackageStatus;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version: ReportPackageVersionMetadata;
  versionId: Scalars['String']['output'];
  viewKey: ViewIdentifier;
};

export type ReportPackageDocument = LayoutDocument | Report | TextDocument;

export type ReportPackageDocumentDetails = {
  document?: Maybe<ReportPackageDocument>;
  metadata: ReportPackageDocumentMetadata;
};

export type ReportPackageDocumentMetadata = {
  documentObjectId: Scalars['String']['output'];
  documentObjectVersionId: Scalars['String']['output'];
  generationHistory?: Maybe<ReportGenerationHistory>;
  id: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  reportFile?: Maybe<ReportFileMetadata>;
  status: ReportPackageDocumentStatus;
  title: Scalars['String']['output'];
  type: ReportPackageDocumentType;
};

export enum ReportPackageDocumentStatus {
  Complete = 'Complete',
  Failed = 'Failed',
  Pending = 'Pending',
  UnknownStatus = 'UnknownStatus'
}

export enum ReportPackageDocumentType {
  Layout = 'Layout',
  Report = 'Report',
  Text = 'Text'
}

export type ReportPackageMetadata = {
  author?: Maybe<Contact>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creationMethod: CreationMethod;
  documents: Array<ReportPackageDocumentMetadata>;
  endedAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  interval: Interval;
  publishedAsDraft: Scalars['Boolean']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: ReportPackageStatus;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId: Scalars['String']['output'];
  versions: Array<ReportPackageVersionMetadata>;
  viewKey: ViewIdentifier;
};


export type ReportPackageMetadataVersionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ReportPackageStatus>;
};

export type ReportPackageOptions = {
  accountNumbersDisplay?: Maybe<AccountNumbersDisplay>;
  coverLogoSource?: Maybe<CoverLogoSource>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  customFooter?: Maybe<Scalars['String']['output']>;
  preparedBy?: Maybe<Scalars['String']['output']>;
  publishedAsDraft?: Maybe<Scalars['Boolean']['output']>;
};

export enum ReportPackageStatus {
  Draft = 'Draft',
  Published = 'Published',
  Transient = 'Transient',
  Unknown = 'Unknown'
}

/** Reports */
export type ReportPackageSummary = {
  draftCount: Scalars['Long']['output'];
  packagesCount: Scalars['Long']['output'];
  period: Period;
  publishedCount: Scalars['Long']['output'];
};

export type ReportPackageVersionMetadata = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  status: ReportPackageStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReportRefreshRequest = {
  requestId: Scalars['String']['output'];
};

export enum ReportSource {
  Digits = 'Digits',
  None = 'None',
  QuickBooks = 'QuickBooks'
}

export type ReportTemplate = {
  coverUrl: Scalars['String']['output'];
  hasBalanceSheet: Scalars['Boolean']['output'];
  hasCashFlow: Scalars['Boolean']['output'];
  hasExecutiveSummary: Scalars['Boolean']['output'];
  hasProfitAndLoss: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ReportValidationArchive = {
  avs?: Maybe<Scalars['String']['output']>;
  digits?: Maybe<Scalars['String']['output']>;
  quickbooks: Scalars['String']['output'];
};

export type ReportValidationHistory = {
  errorMessage?: Maybe<Scalars['String']['output']>;
  isValid: Scalars['Boolean']['output'];
  legalEntityId: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
  source: ReportFileSource;
  validatedAt: Scalars['DateTime']['output'];
  versionId: Scalars['String']['output'];
};

export type RequestParameter = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ResolvePotentialMismatchInput = {
  documentFeatureGroupId: Scalars['String']['input'];
  flagId: Scalars['String']['input'];
  ledgerTransactionId: Scalars['String']['input'];
  transactionFactId: Scalars['String']['input'];
};

export enum ReviewStatus {
  Approved = 'Approved',
  ChangesRequested = 'ChangesRequested',
  Commented = 'Commented',
  Dismissed = 'Dismissed',
  Pending = 'Pending'
}

export type RichComment = {
  comment: Comment;
  entities?: Maybe<ObjectEntities>;
  layout: Layout;
};

export type Role = {
  id: Scalars['String']['output'];
};

export type RoleIdentifier = {
  id: Scalars['String']['input'];
};

export type Runway = {
  cashOutDate?: Maybe<Scalars['DateTime']['output']>;
  current: DimensionSummary;
  future: DimensionSummary;
  previousCashOutDate?: Maybe<Scalars['DateTime']['output']>;
};

export type RunwayChartConfig = {
  netBurnLookback?: Maybe<ArchiveIntervalOrigin>;
  origin: ArchiveIntervalOrigin;
};

export type RunwayChartConfigInput = {
  netBurnLookback?: InputMaybe<IntervalOrigin>;
  origin: IntervalOrigin;
};

export enum SandboxIndustry {
  Retail = 'Retail',
  Technology = 'Technology',
  UnknownIndustry = 'UnknownIndustry'
}

export enum SandboxType {
  Accountant = 'Accountant',
  Operator = 'Operator',
  UnknownSandboxType = 'UnknownSandboxType'
}

export type SaveProductVariantInput = {
  classifications?: InputMaybe<ProductVariantClassificationsInput>;
  customIconObjectName?: InputMaybe<Scalars['String']['input']>;
  dataSourceId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  iconDisplayKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Long']['input'];
  prices?: InputMaybe<Array<SaveProductVariantPriceInput>>;
  productId?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};

export type SaveProductVariantPriceInput = {
  dataSourceId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProductVariantPriceType>;
  unitPrice: InputMonetaryValue;
  variantId?: InputMaybe<Scalars['String']['input']>;
};

export type Schedule = {
  createdAt: Scalars['DateTime']['output'];
  createdBy: EntityUser;
  cutoverAmount?: Maybe<MonetaryValue>;
  cutoverDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  events: Array<ScheduleEvent>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  party?: Maybe<EntityParty>;
  scheduleNumber: Scalars['String']['output'];
  scheduleTemplateId: Scalars['String']['output'];
  scheduleType: ScheduleType;
  sourceTransaction?: Maybe<EntityTransaction>;
  specializationId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: EntityUser;
};

export type ScheduleBooleanValue = {
  boolValue: Scalars['Boolean']['output'];
};

export type ScheduleBooleanValueInput = {
  boolValue: Scalars['Boolean']['input'];
};

export type ScheduleCandidate = {
  scheduleTemplate: ScheduleTemplate;
  scheduleType: ScheduleType;
  sourceRecategorizeCategory?: Maybe<EntityCategory>;
  sourceTransactionFactId: Scalars['String']['output'];
  specialization?: Maybe<ScheduleSpecialization>;
};

export type ScheduleCategoryValue = {
  category: EntityCategory;
};

export enum ScheduleColumnName {
  Category = 'Category',
  EndDate = 'EndDate',
  Name = 'Name',
  RelatedCategory = 'RelatedCategory',
  StartDate = 'StartDate',
  TotalAmount = 'TotalAmount'
}

export type ScheduleDashboardFilter = {
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDateMax?: InputMaybe<Scalars['DateTime']['input']>;
  endDateMin?: InputMaybe<Scalars['DateTime']['input']>;
  filterText?: InputMaybe<Scalars['String']['input']>;
  maxAmount?: InputMaybe<InputMonetaryValue>;
  minAmount?: InputMaybe<InputMonetaryValue>;
  partyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  relatedCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleTypes?: InputMaybe<Array<ScheduleType>>;
  startDateMax?: InputMaybe<Scalars['DateTime']['input']>;
  startDateMin?: InputMaybe<Scalars['DateTime']['input']>;
  viewKey: ViewKey;
};

export type ScheduleDateValue = {
  dateValue: Scalars['DateTime']['output'];
};

export type ScheduleDateValueInput = {
  dateValue: Scalars['DateTime']['input'];
};

export type ScheduleDefaults = {
  eventTemplates: Array<ScheduleEventTemplate>;
  events: Array<ScheduleEvent>;
  specialization?: Maybe<ScheduleSpecialization>;
};

export type ScheduleDimension = {
  by: DimensionSummary;
  scheduleId: Scalars['String']['output'];
  scheduleObject?: Maybe<EntitySchedule>;
  summary: TransactionSummary;
};

export type ScheduleEditedObject = {
  action: ScheduleEditedObjectAction;
  id: Scalars['String']['output'];
  kind: ScheduleEditedObjectKind;
};

export enum ScheduleEditedObjectAction {
  Created = 'Created',
  Deleted = 'Deleted',
  Edited = 'Edited',
  UnknownAction = 'UnknownAction'
}

/** Schedule Editing History */
export enum ScheduleEditedObjectKind {
  Event = 'Event',
  Schedule = 'Schedule',
  UnknownKind = 'UnknownKind'
}

export type ScheduleEvent = {
  createdAt: Scalars['DateTime']['output'];
  createdBy: EntityUser;
  displayKey?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  eventDate: Scalars['DateTime']['output'];
  eventTemplateId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isGenerated: Scalars['Boolean']['output'];
  isInstantiating: Scalars['Boolean']['output'];
  isSingleton: Scalars['Boolean']['output'];
  isTerminating: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  updatedBy: EntityUser;
  variables: Array<ScheduleEventVariable>;
};

export type ScheduleEventInput = {
  displayName: Scalars['String']['input'];
  eventDate: Scalars['DateTime']['input'];
  eventTemplateId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  variables: Array<ScheduleEventVariableInput>;
};

export type ScheduleEventTemplate = {
  description?: Maybe<Scalars['String']['output']>;
  displayKey?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  inCreateFlow: Scalars['Boolean']['output'];
  isInstantiating: Scalars['Boolean']['output'];
  isSingleton: Scalars['Boolean']['output'];
  isTerminating: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  ordinal: Scalars['Int']['output'];
  variables: Array<ScheduleEventVariableTemplate>;
};

export type ScheduleEventVariable = {
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  value: ScheduleVariableValue;
  variableName: Scalars['String']['output'];
  variableTemplateId: Scalars['String']['output'];
  variableType: ScheduleEventVariableType;
};

export enum ScheduleEventVariableDisplayMode {
  Editable = 'Editable',
  Hidden = 'Hidden',
  ReadOnly = 'ReadOnly',
  UnknownDisplayMode = 'UnknownDisplayMode'
}

export type ScheduleEventVariableInput = {
  displayName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  value: ScheduleVariableValueInput;
  variableName: Scalars['String']['input'];
  variableTemplateId: Scalars['String']['input'];
  variableType: ScheduleEventVariableType;
};

export type ScheduleEventVariableTemplate = {
  displayMode: ScheduleEventVariableDisplayMode;
  displayName: Scalars['String']['output'];
  formulas?: Maybe<Array<ScheduleEventVariableTemplateFormula>>;
  id: Scalars['String']['output'];
  ordinal: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  variableName: Scalars['String']['output'];
  variableType: ScheduleEventVariableType;
};

export type ScheduleEventVariableTemplateFormula = {
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export enum ScheduleEventVariableType {
  AnchorDate = 'AnchorDate',
  Boolean = 'Boolean',
  CategoryId = 'CategoryId',
  Date = 'Date',
  Float = 'Float',
  Formula = 'Formula',
  Interval = 'Interval',
  Long = 'Long',
  MonetaryValue = 'MonetaryValue',
  PartyId = 'PartyId',
  String = 'String',
  Term = 'Term',
  TransactionId = 'TransactionId',
  UnknownType = 'UnknownType'
}

/** Schedule facet output types */
export type ScheduleFacet = {
  aggregate: Scalars['Int']['output'];
  category: Array<CategoryFacet>;
  party: Array<PartyFacet>;
  relatedCategory: Array<CategoryFacet>;
  scheduleType: Array<ScheduleTypeFacet>;
};

/** Schedule facets */
export type ScheduleFacetField = {
  kind: ScheduleFacetKind;
  type: FacetType;
};

export enum ScheduleFacetKind {
  ScheduleCategory = 'ScheduleCategory',
  ScheduleParty = 'ScheduleParty',
  ScheduleRelatedCategory = 'ScheduleRelatedCategory',
  ScheduleType = 'ScheduleType',
  UnknownScheduleKind = 'UnknownScheduleKind'
}

export type ScheduleFloatValue = {
  floatValue: Scalars['Float']['output'];
};

export type ScheduleFloatValueInput = {
  floatValue: Scalars['Float']['input'];
};

export type ScheduleFormulaValue = {
  formulaDisplayName: Scalars['String']['output'];
  formulaId: Scalars['String']['output'];
};

export type ScheduleFormulaValueInput = {
  formulaDisplayName: Scalars['String']['input'];
  formulaId: Scalars['String']['input'];
};

export type ScheduleHistoryEntry = {
  editedObjects: Array<ScheduleEditedObject>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<EntityUser>;
};

export type ScheduleImportCandidate = {
  cutoverAmount?: Maybe<MonetaryValue>;
  cutoverDate?: Maybe<Scalars['DateTime']['output']>;
  scheduleImportCandidateId: Scalars['String']['output'];
  scheduleTemplate: ScheduleTemplate;
  scheduleType: ScheduleType;
  sourceRecategorizeCategory?: Maybe<EntityCategory>;
  sourceTransaction?: Maybe<EntityTransaction>;
  sourceTransactionFactId: Scalars['String']['output'];
  specialization?: Maybe<ScheduleSpecialization>;
};

export enum ScheduleImportCandidateStatus {
  Closed = 'Closed',
  Created = 'Created',
  Pending = 'Pending',
  Unknown = 'Unknown'
}

export type ScheduleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  events: Array<ScheduleEventInput>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  scheduleNumber: Scalars['String']['input'];
  scheduleTemplateId: Scalars['String']['input'];
  scheduleType: ScheduleType;
  sourceTransactionId?: InputMaybe<Scalars['String']['input']>;
  specializationId?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduleIntervalValue = {
  intervalValue: Interval;
};

export type ScheduleIntervalValueInput = {
  intervalValue: Interval;
};

export type ScheduleLongValue = {
  longValue: Scalars['Long']['output'];
};

export type ScheduleLongValueInput = {
  longValue: Scalars['Long']['input'];
};

export type ScheduleMonetaryValue = {
  monetaryValue: MonetaryValue;
};

export type ScheduleMonetaryValueInput = {
  amount: Scalars['Long']['input'];
  currencyCode: Scalars['String']['input'];
  currencyMultiplier: Scalars['Int']['input'];
};

export type ScheduleOrder = {
  scheduleOrderPairs: Array<ScheduleOrderPair>;
};

export type ScheduleOrderPair = {
  columnName: ScheduleColumnName;
  direction: SortDirection;
};

export type SchedulePartyValue = {
  party: EntityParty;
};

export enum ScheduleScope {
  AllScheduleTransactions = 'AllScheduleTransactions',
  ScheduleInitialization = 'ScheduleInitialization',
  ScheduleRecognition = 'ScheduleRecognition',
  UnknownScheduleScope = 'UnknownScheduleScope'
}

/** Schedule Dashboard */
export type ScheduleSnapshot = {
  amount: MonetaryValue;
  category?: Maybe<EntityCategory>;
  cutoverAmount?: Maybe<MonetaryValue>;
  cutoverDate?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  party?: Maybe<EntityParty>;
  relatedCategory?: Maybe<EntityCategory>;
  remainingAmount: MonetaryValue;
  scheduleNumber: Scalars['String']['output'];
  scheduleType: ScheduleType;
  startDate: Scalars['DateTime']['output'];
};

export type ScheduleSpecialization = {
  description?: Maybe<Scalars['String']['output']>;
  displayKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  legalEntityId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  scheduleTemplateId: Scalars['String']['output'];
};

/** TODO: Remove this enum once backwards compatibility is no longer needed */
export enum ScheduleStatus {
  Active = 'Active',
  Closed = 'Closed',
  Draft = 'Draft'
}

export type ScheduleStringValue = {
  stringValue: Scalars['String']['output'];
};

export type ScheduleStringValueInput = {
  stringValue: Scalars['String']['input'];
};

export type ScheduleTemplate = {
  description?: Maybe<Scalars['String']['output']>;
  displayKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  scheduleType: ScheduleType;
};

export type ScheduleTermValue = {
  endDate?: Maybe<Scalars['DateTime']['output']>;
  intervalCount?: Maybe<Scalars['Long']['output']>;
};

export type ScheduleTermValueInput = {
  endDate: Scalars['DateTime']['input'];
};

export type ScheduleTransactionValue = {
  transaction: EntityTransaction;
};

export enum ScheduleType {
  FixedAsset = 'FixedAsset',
  PrepaidExpense = 'PrepaidExpense',
  UnknownType = 'UnknownType'
}

export type ScheduleTypeFacet = {
  count: Scalars['Int']['output'];
  scheduleType: ScheduleType;
};

export type ScheduleVariableValue = ScheduleBooleanValue | ScheduleCategoryValue | ScheduleDateValue | ScheduleFloatValue | ScheduleFormulaValue | ScheduleIntervalValue | ScheduleLongValue | ScheduleMonetaryValue | SchedulePartyValue | ScheduleStringValue | ScheduleTermValue | ScheduleTransactionValue;

export type ScheduleVariableValueInput = {
  boolValue?: InputMaybe<ScheduleBooleanValueInput>;
  dateValue?: InputMaybe<ScheduleDateValueInput>;
  floatValue?: InputMaybe<ScheduleFloatValueInput>;
  formulaValue?: InputMaybe<ScheduleFormulaValueInput>;
  intervalValue?: InputMaybe<ScheduleIntervalValueInput>;
  longValue?: InputMaybe<ScheduleLongValueInput>;
  monetaryValue?: InputMaybe<ScheduleMonetaryValueInput>;
  stringValue?: InputMaybe<ScheduleStringValueInput>;
  termValue?: InputMaybe<ScheduleTermValueInput>;
};

export enum SearchEntitiesField {
  Date = 'Date',
  DisplayNumber = 'DisplayNumber',
  Name = 'Name',
  Score = 'Score',
  Type = 'Type',
  Unspecified = 'Unspecified'
}

export type SearchEntitiesSort = {
  ascending: Scalars['Boolean']['input'];
  field: SearchEntitiesField;
};

/** Hit describes a single search result within a result set */
export type SearchHit = {
  /** The search-term highlight offsets within the result contents */
  highlights: Array<HitHighlight>;
  /** The object this search hit references */
  objectId: ObjectIdentifier;
  /** The bleve-assigned score of this result. Uses TDF-IF */
  score: Scalars['Float']['output'];
};

export type SearchInvoiceCustomersResult = {
  customers: Array<Customer>;
};

/**
 * Search
 * Result represents a customer-facing set of search results.
 */
export type SearchResult = {
  entities: ObjectEntities;
  kindCounts: Array<ObjectKindFacet>;
  results: Array<SearchHit>;
  tookSecs: Scalars['Float']['output'];
  total: Scalars['Long']['output'];
};

export type Segment = {
  collectionId: Scalars['String']['output'];
  fileId: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Long']['output']>;
  sequence: Scalars['Long']['output'];
  token: Scalars['String']['output'];
};

export type SentInvoiceUsers = {
  invoice: Invoice;
  users?: Maybe<Array<User>>;
};

export type SetupSubscriptionResult = {
  arrangement: BillingArrangement;
  /** Stripe client secret used to confirm payment. Empty for trials / fully-discounted setups. */
  stripeClientSecret?: Maybe<Scalars['String']['output']>;
};

/** Mirrors the billing SetupSubscriptionRequest.Trial proto enum. */
export enum SetupSubscriptionTrial {
  NoTrial = 'NoTrial',
  TrialDays = 'TrialDays',
  UnknownTrial = 'UnknownTrial'
}

export enum ShareAction {
  CreateGrant = 'CreateGrant',
  IntentRevoked = 'IntentRevoked',
  Proceed = 'Proceed',
  RequestAccess = 'RequestAccess',
  RequestPending = 'RequestPending',
  Unknown = 'Unknown'
}

export type SharedReportDocumentMetadata = {
  documentObjectId: Scalars['String']['output'];
  documentObjectVersionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SignUpEvent = {
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type Signup = {
  companyCurrency?: Maybe<Scalars['String']['output']>;
  companyLedger?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyUrl?: Maybe<Scalars['String']['output']>;
  contact: Contact;
  id: Scalars['String']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  oAuthEmailAddress?: Maybe<Scalars['String']['output']>;
  oAuthService?: Maybe<Scalars['String']['output']>;
  persona: Persona;
  positionTitle?: Maybe<Scalars['String']['output']>;
  profileURL?: Maybe<Scalars['String']['output']>;
  status: SignupStatus;
  statusReason?: Maybe<Scalars['String']['output']>;
};

export enum SignupStatus {
  Applied = 'Applied',
  Approved = 'Approved',
  Ignored = 'Ignored',
  InviteAccepted = 'InviteAccepted',
  Invited = 'Invited',
  PrimerSent = 'PrimerSent',
  Qualified = 'Qualified',
  Unknown = 'Unknown',
  Unqualified = 'Unqualified',
  Waitlisted = 'Waitlisted'
}

export type SimilarActionItem = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export enum SimilarityType {
  Category = 'Category',
  Party = 'Party',
  Unknown = 'Unknown'
}

export enum SortDirection {
  Ascending = 'Ascending',
  Descending = 'Descending'
}

export type SourceAccount = {
  dataSource?: Maybe<EnrichedDataSource>;
  externalId: Scalars['String']['output'];
  externalName?: Maybe<Scalars['String']['output']>;
  externalOfficialName?: Maybe<Scalars['String']['output']>;
  externalOwnerName?: Maybe<Scalars['String']['output']>;
  externalSubtype?: Maybe<Scalars['String']['output']>;
  externalType?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mask?: Maybe<Scalars['String']['output']>;
  ownerEmployeeId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SourceAccountStatus>;
};

export type SourceAccountMetric = {
  metrics: Array<SourceAccountMetricSeriesData>;
};

export type SourceAccountMetricConfig = {
  dataSourceId: Scalars['String']['output'];
  key: SourceAccountMetricKey;
  origin: ArchiveIntervalOrigin;
  sourceAccountId: Scalars['String']['output'];
};

export type SourceAccountMetricConfigInput = {
  dataSourceId: Scalars['String']['input'];
  key: SourceAccountMetricKey;
  origin: IntervalOrigin;
  sourceAccountId: Scalars['String']['input'];
};

export type SourceAccountMetricIdentifier = {
  dataSourceId: Scalars['String']['output'];
  key: SourceAccountMetricKey;
  sourceAccountId: Scalars['String']['output'];
};

export enum SourceAccountMetricKey {
  AccountLimit = 'AccountLimit',
  AvailableBalance = 'AvailableBalance',
  CurrentBalance = 'CurrentBalance',
  Headcount = 'Headcount',
  Unknown = 'Unknown'
}

export type SourceAccountMetricPoint = {
  time: Scalars['DateTime']['output'];
  value: Scalars['Long']['output'];
};

export type SourceAccountMetricSeries = {
  identifier: SourceAccountMetricIdentifier;
  points: Array<SourceAccountMetricPoint>;
};

export type SourceAccountMetricSeriesData = {
  iconObjectName?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  series: SourceAccountMetricSeries;
};

export enum SourceAccountStatus {
  Deleted = 'Deleted',
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  UnknownStatus = 'UnknownStatus'
}

/**
 * SourceRecategorizationInput recategorizes the source transaction's named
 * entry line as part of schedule creation. The digits transaction type is
 * read from the source fact server-side.
 */
export type SourceRecategorizationInput = {
  categoryId: Scalars['String']['input'];
  entryType: EntryType;
};

/** # Bulk CSV Import */
export type StartBulkCsvImportInput = {
  categoryId: Scalars['String']['input'];
  collectionId: Scalars['String']['input'];
  columnMapping: CsvColumnMappingInput;
  documentId: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};

export type StartBulkCsvImportPayload = {
  workflowId: Scalars['String']['output'];
};

/** # Journal Entries Async Import */
export type StartJournalEntriesImportInput = {
  collectionId: Scalars['String']['input'];
  columnMapping: JournalEntriesColumnMappingInput;
  documentId: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  /**
   * Client-generated key, one per submit attempt. A bare retry of a failed
   * mutation (same key, same payload) dedupes to the existing workflow.
   * Editing the CSV / column mapping and resubmitting generates a fresh key
   * and gets a new workflow.
   */
  idempotencyKey: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
};

export type StartJournalEntriesImportPayload = {
  workflowId: Scalars['String']['output'];
};

export type Statement = {
  kind: ReportKind;
  rows: Array<StatementRow>;
};

export type StatementBalances = {
  closingBalance: MoneyFlow;
  creditTotal?: Maybe<MoneyFlow>;
  debitTotal?: Maybe<MoneyFlow>;
  netTotal: MoneyFlow;
  openingBalance: MoneyFlow;
};

export type StatementConfig = {
  /** @deprecated Unused */
  categoryId?: Maybe<Scalars['String']['output']>;
  kind: ReportKind;
  options?: Maybe<ReportDocumentOptions>;
  origin: ArchiveIntervalOrigin;
};

export type StatementConfigInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  kind: ReportKind;
  options?: InputMaybe<ReportDocumentOptionsInput>;
  origin: IntervalOrigin;
};

export type StatementDeltaValue = {
  moneyFlow: MoneyFlow;
  percentageOfAmount: Scalars['Float']['output'];
};

export type StatementDeltas = {
  percentageIncome?: Maybe<StatementDeltaValue>;
  percentageTotal?: Maybe<StatementDeltaValue>;
  previousPeriod?: Maybe<StatementDeltaValue>;
  previousYear?: Maybe<StatementDeltaValue>;
};

export type StatementDetails = {
  hover: Hover;
  insight?: Maybe<Insight>;
};

export type StatementImportDocumentInput = {
  categoryId: Scalars['String']['input'];
  documentCollectionId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  /** Original uploaded filename, surfaced in the import workflow's notifications. */
  fileName?: InputMaybe<Scalars['String']['input']>;
};

export type StatementLineItem = {
  amount: MonetaryValue;
  date: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  entryType: EntryType;
  featureGroupId: Scalars['String']['output'];
  featureIds: Array<Scalars['String']['output']>;
};

export type StatementLineItemInput = {
  amount: InputMonetaryValue;
  date: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  entryType: EntryType;
  featureGroupId: Scalars['String']['input'];
};

export type StatementRow = {
  agingSummary?: Maybe<AgingSummary>;
  agingTitle?: Maybe<StatementRowTitle>;
  deltas?: Maybe<StatementDeltas>;
  depth: Scalars['Int']['output'];
  details?: Maybe<StatementDetails>;
  leafAgingSummary?: Maybe<LeafAgingSummary>;
  leafCategorySummary?: Maybe<StatementRowSummary>;
  parentAgingSummary?: Maybe<AgingSummary>;
  parentAgingTitle?: Maybe<StatementRowTitle>;
  parentCategorySummary?: Maybe<StatementRowSummary>;
  parentCategoryTitle?: Maybe<StatementRowTitle>;
  rowId: Scalars['String']['output'];
  sectionSummary?: Maybe<StatementRowSummary>;
  sectionTitle?: Maybe<StatementRowTitle>;
  ytdDetails?: Maybe<StatementDetails>;
};

export type StatementRowSummary = {
  displayNumber?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  moneyFlow: MoneyFlow;
};

export type StatementRowTitle = {
  displayNumber?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type StatementSummary = {
  summaries: Array<Scalars['String']['output']>;
};

export type StaticMetricConfig = {
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type StaticMetricConfigInput = {
  name: Scalars['String']['input'];
  updatedAt: Scalars['DateTime']['input'];
  value: Scalars['String']['input'];
};

export type StripeConnectorProperties = {
  appLinkURL: Scalars['String']['output'];
};

export type Subscription = {
  askAssistant: AssistantEvent;
  notificationCreated: WebNotification;
  workflowEvents: WorkflowEvent;
  workflowNotifications: WorkflowNotificationEvent;
};


export type SubscriptionAskAssistantArgs = {
  includeEntities?: InputMaybe<Scalars['Boolean']['input']>;
  messages?: InputMaybe<Array<Scalars['String']['input']>>;
  thread?: InputMaybe<AssistantThread>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  viewKey: ViewKey;
};


export type SubscriptionWorkflowEventsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type SubscriptionWorkflowNotificationsArgs = {
  legalEntityID: Scalars['String']['input'];
};

export type SubscriptionDetails = {
  billingCycleEnd: Scalars['DateTime']['output'];
  billingCycleStart: Scalars['DateTime']['output'];
  cancelAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt: Scalars['DateTime']['output'];
  status: BillingSubscriptionStatus;
};

/**
 * Better names for this but are already taken...
 * - BillingPlan
 * - Subscription
 * - BillingSubscription
 *
 * This unfortunately leaves us having to be creative with our name since GQL is all one flat namespace.
 */
export type SubscriptionPlan = {
  price: BillingPrice;
  product: BillingProduct;
};

export type SuggestedConnection = {
  template: ConnectionTemplate;
};

export type SuggestedConnectionsFilter = {
  institutionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SummarizeInput = {
  direction?: InputMaybe<DirectionFromOrigin>;
  filter: SummaryFilterInput;
  origin?: InputMaybe<IntervalOrigin>;
};

export enum SummaryDimension {
  Aging = 'Aging',
  Category = 'Category',
  CategoryType = 'CategoryType',
  Department = 'Department',
  Location = 'Location',
  Party = 'Party',
  Product = 'Product',
  Schedule = 'Schedule',
  Time = 'Time'
}

export type SummaryFilterInput = {
  categoryClassificationSources?: InputMaybe<Array<ClassificationSource>>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  categorySubtypes?: InputMaybe<Array<CategorySubtype>>;
  categoryType?: InputMaybe<CategoryType>;
  categoryTypes?: InputMaybe<Array<CategoryType>>;
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  digitsTransactionTypes?: InputMaybe<Array<TransactionType>>;
  filterTerm?: InputMaybe<Scalars['String']['input']>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ledgerTransactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  linkedObjectTypes?: InputMaybe<Array<LinkedObjectType>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  matchedStatuses?: InputMaybe<Array<MatchedStatus>>;
  maxValue?: InputMaybe<InputMonetaryValue>;
  minValue?: InputMaybe<InputMonetaryValue>;
  missingDepartment?: InputMaybe<MissingObject>;
  missingLocation?: InputMaybe<MissingObject>;
  missingParty?: InputMaybe<MissingObject>;
  missingProduct?: InputMaybe<MissingObject>;
  missingSchedule?: InputMaybe<MissingObject>;
  ownerEmployeeId?: InputMaybe<Scalars['String']['input']>;
  partyEntityTypes?: InputMaybe<Array<PartyEntityType>>;
  partyId?: InputMaybe<Scalars['String']['input']>;
  partyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  partyName?: InputMaybe<Scalars['String']['input']>;
  partyRole?: InputMaybe<PartyRole>;
  partyRoles?: InputMaybe<Array<PartyRole>>;
  productArea?: InputMaybe<ProductArea>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reconciliationFilter?: InputMaybe<ReconciliationFilter>;
  scheduleCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleEndDateMax?: InputMaybe<Scalars['DateTime']['input']>;
  scheduleEndDateMin?: InputMaybe<Scalars['DateTime']['input']>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  scheduleMaxAmount?: InputMaybe<InputMonetaryValue>;
  scheduleMinAmount?: InputMaybe<InputMonetaryValue>;
  schedulePartyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleRelatedCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduleScope?: InputMaybe<ScheduleScope>;
  scheduleStartDateMax?: InputMaybe<Scalars['DateTime']['input']>;
  scheduleStartDateMin?: InputMaybe<Scalars['DateTime']['input']>;
  scheduleTypes?: InputMaybe<Array<ScheduleType>>;
  taxStatuses?: InputMaybe<Array<TaxStatus>>;
  taxpayerIdentifications?: InputMaybe<Array<TaxpayerIdentification>>;
  useAbsAmount?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
  viewKey: ViewKey;
  withoutCategoryAncestors?: InputMaybe<Scalars['Boolean']['input']>;
  withoutDepartmentAncestors?: InputMaybe<Scalars['Boolean']['input']>;
  withoutLocationAncestors?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SummaryLineItem {
  GrossProfit = 'GrossProfit',
  NetIncome = 'NetIncome',
  NetOperatingIncome = 'NetOperatingIncome',
  NetOtherIncome = 'NetOtherIncome',
  TotalCash = 'TotalCash'
}

export type SummaryLineItemConfig = {
  item: SummaryLineItem;
  origin: ArchiveIntervalOrigin;
};

export type SummaryLineItemConfigInput = {
  item: SummaryLineItem;
  origin: IntervalOrigin;
};

export type SummaryLineItemHover = {
  history: DimensionSummary;
  lineType: SummaryLineItem;
  missingClass?: Maybe<DimensionSummary>;
  otherClass?: Maybe<DimensionSummary>;
};

export type SummaryTotal = {
  count: Scalars['Long']['output'];
  total: MoneyFlow;
};

export enum TaxForm {
  Corporation = 'Corporation',
  LimitedLiability = 'LimitedLiability',
  NonprofitOrganization = 'NonprofitOrganization',
  Other = 'Other',
  PartnershipOrLimitedLiability = 'PartnershipOrLimitedLiability',
  SmallBusinessCorporation = 'SmallBusinessCorporation',
  SoleProprietor = 'SoleProprietor',
  UnknownTaxForm = 'UnknownTaxForm'
}

export enum TaxStatus {
  NonTaxable = 'NonTaxable',
  Taxable = 'Taxable',
  Undetermined = 'Undetermined',
  UnspecifiedTaxStatus = 'UnspecifiedTaxStatus'
}

export enum TaxpayerIdentification {
  Available = 'Available',
  NotRequired = 'NotRequired',
  Required = 'Required',
  Undetermined = 'Undetermined',
  UnknownTaxpayerIdentification = 'UnknownTaxpayerIdentification'
}

export type TaxpayerIdentificationCount = {
  partyCount: Scalars['Int']['output'];
  taxpayerIdentification: TaxpayerIdentification;
};

export type TaxpayerIdentificationInput = {
  partyId: Scalars['String']['input'];
  taxpayerIdentification: TaxpayerIdentification;
};

export type Team = {
  description?: Maybe<Scalars['String']['output']>;
  iconObjectName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invites: Array<TeamMemberInvite>;
  members: Array<TeamMember>;
  name: Scalars['String']['output'];
};

export type TeamAcl = {
  entities: ObjectEntities;
  grants: Array<ObjectGrant>;
};

export type TeamMember = {
  role: TeamRole;
  user: EntityUser;
};

export type TeamMemberInvite = {
  emailAddress: Scalars['String']['output'];
  role: TeamRole;
};

export enum TeamRole {
  Manager = 'Manager',
  Member = 'Member'
}

export type TemplateCategory = {
  categoryId: Scalars['String']['output'];
  categoryState: CategoryState;
  chartOfAccountsDisplayNumber: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayKey?: Maybe<Scalars['String']['output']>;
  externalAccountSubtype?: Maybe<Scalars['String']['output']>;
  externalAccountType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  parentCategoryId?: Maybe<Scalars['String']['output']>;
  subtype: CategorySubtype;
  templateId: Scalars['String']['output'];
  type: CategoryType;
};

export enum TermField {
  AmountTerm = 'AmountTerm',
  CanonicalCategoryName = 'CanonicalCategoryName',
  CategoryName = 'CategoryName',
  Description = 'Description',
  FacilitatorName = 'FacilitatorName',
  InstitutionName = 'InstitutionName',
  Name = 'Name',
  PartyName = 'PartyName',
  ProductName = 'ProductName'
}

export type TextComponentConfig = {
  body: Scalars['String']['output'];
  current?: Maybe<ArchiveIntervalOrigin>;
  lookback?: Maybe<ArchiveIntervalOrigin>;
  tags?: Maybe<Array<TextComponentConfigTag>>;
};

export type TextComponentConfigInput = {
  body: Scalars['String']['input'];
  current?: InputMaybe<IntervalOrigin>;
  lookback?: InputMaybe<IntervalOrigin>;
  tags?: InputMaybe<Array<TextComponentConfigTagInput>>;
};

export type TextComponentConfigTag = {
  displayText: Scalars['String']['output'];
  objectId: ObjectIdentifier;
  options?: Maybe<TextTagOptions>;
};

export type TextComponentConfigTagInput = {
  displayText: Scalars['String']['input'];
  objectId: InputObjectIdentifier;
  options?: InputMaybe<TextTagOptionsInput>;
};

export type TextDocument = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  status: ReportPackageDocumentStatus;
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TextFeatureValue = {
  textValue: Scalars['String']['output'];
};

export type TextTagOptions = {
  partyRole?: Maybe<PartyRole>;
};

export type TextTagOptionsInput = {
  partyRole?: InputMaybe<Scalars['String']['input']>;
};

/** Thread contains the ThreadDetails and associated Comments. */
export type Thread = {
  comments: Array<Comment>;
  details: ThreadDetails;
  id: Scalars['String']['output'];
};

/**
 * ThreadDetails represents metadata about a thread.
 * This type is intended to be read-only and resolved
 * by the backend.
 */
export type ThreadDetails = {
  authorId: Scalars['String']['output'];
  commentCount: Scalars['Long']['output'];
  commenterIds: Array<Scalars['String']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pending?: Maybe<Scalars['Boolean']['output']>;
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  tags: Array<ObjectIdentifier>;
  targetObject: ObjectIdentifier;
};

export type ThreadList = {
  targetObject: ObjectIdentifier;
  threads: Array<ThreadDetails>;
};

export type ThreadListWithEntities = {
  entities?: Maybe<ObjectEntities>;
  threads: Array<Thread>;
};

export type ThreadWithEntities = {
  entities?: Maybe<ObjectEntities>;
  thread: Thread;
};

export type Threads = {
  entities?: Maybe<ObjectEntities>;
  threads: Array<ThreadList>;
};

export type TimeDimension = {
  by: DimensionSummary;
  summary: TransactionSummary;
  timestamp: Scalars['Float']['output'];
};

export type TopEntities = {
  entities: DimensionSummary;
};

export type TopEntitiesConfig = {
  categoryType?: Maybe<CategoryType>;
  filteredBy?: Maybe<ObjectIdentifier>;
  kind: ObjectKind;
  limit: Scalars['Int']['output'];
  origin: ArchiveIntervalOrigin;
  partyRole?: Maybe<PartyRole>;
  sort: DimensionSortMode;
};

export type TopEntitiesConfigInput = {
  categoryType?: InputMaybe<CategoryType>;
  filteredBy?: InputMaybe<InputObjectIdentifier>;
  kind: ObjectKind;
  limit: Scalars['Int']['input'];
  origin: IntervalOrigin;
  partyRole?: InputMaybe<PartyRole>;
  sort: DimensionSortMode;
};

export type TopTransactions = {
  partialData: Scalars['Boolean']['output'];
  transactions: Array<EntityTransaction>;
};

export type TopTransactionsConfig = {
  categoryType?: Maybe<CategoryType>;
  filteredBy?: Maybe<ObjectIdentifier>;
  limit: Scalars['Int']['output'];
  origin: ArchiveIntervalOrigin;
  partyRole?: Maybe<PartyRole>;
};

/**
 * INPUTS
 *
 */
export type TopTransactionsConfigInput = {
  categoryType?: InputMaybe<CategoryType>;
  filteredBy?: InputMaybe<InputObjectIdentifier>;
  limit: Scalars['Int']['input'];
  origin: IntervalOrigin;
  partyRole?: InputMaybe<PartyRole>;
};

/**
 * Returned by confirmTotpEnrollment. Recovery codes must be shown to the user
 * exactly once and never persisted client-side beyond the confirmation view.
 */
export type TotpEnrollmentConfirmation = {
  recoveryCodes: Array<Scalars['String']['output']>;
};

/**
 * Returned by startTotpEnrollment. The provisioning URI is the otpauth:// value
 * an authenticator app scans from a QR code; sharedSecretBase32 is the same
 * secret in a human-friendly form for apps that don't support QR input.
 */
export type TotpEnrollmentInit = {
  factorId: Scalars['String']['output'];
  provisioningUri: Scalars['String']['output'];
  sharedSecretBase32: Scalars['String']['output'];
};

export type Transaction = {
  compileSource?: Maybe<CompileSource>;
  creditCategoryClassificationProvenance?: Maybe<ClassificationProvenance>;
  creditSources: Array<TransactionSource>;
  debitCategoryClassificationProvenance?: Maybe<ClassificationProvenance>;
  debitSources: Array<TransactionSource>;
  department?: Maybe<EntityDepartment>;
  description?: Maybe<Scalars['String']['output']>;
  digitsTransactionType?: Maybe<TransactionType>;
  displayCanonicalCategoryName?: Maybe<Scalars['String']['output']>;
  displayCategory: Category;
  displayCategoryClassificationProvenance?: Maybe<ClassificationProvenance>;
  displayCategorySource: ClassificationSource;
  /** display* fields for use when a single field is preferred over displaying both debit and credit. */
  displayEntry: DisplayEntry;
  displayInstitution?: Maybe<TransactionParty>;
  displayProductArea?: Maybe<ProductArea>;
  displayUncategorizedReason: UncategorizedReason;
  /** @deprecated Use moneyFlow */
  displayValue?: Maybe<MonetaryValue>;
  facilitatorParty?: Maybe<TransactionParty>;
  factId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use lineItem */
  invoiceLineItem?: Maybe<TransactionInvoiceLineItem>;
  isSupersedingLedgerTransaction: Scalars['Boolean']['output'];
  ledgerTransactionId: Scalars['String']['output'];
  lineItem?: Maybe<TransactionLineItem>;
  location?: Maybe<EntityLocation>;
  matchedLedgerTransactionIds: Array<Scalars['String']['output']>;
  moneyFlow: MoneyFlow;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<EntityEmployee>;
  ownerSource: ClassificationSource;
  party?: Maybe<TransactionParty>;
  partySource: ClassificationSource;
  product?: Maybe<Product>;
  providerTypes: Array<ProviderType>;
  providers: Array<Provider>;
  reconciliationStatus: TransactionReconciliationStatus;
  recordType: TransactionRecordType;
  recurrence?: Maybe<TransactionRecurrence>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  runningTotal?: Maybe<MoneyFlow>;
  schedule?: Maybe<EntitySchedule>;
  sources: Array<TransactionSource>;
  splitCategory?: Maybe<Category>;
  splitCategoryClassificationProvenance?: Maybe<ClassificationProvenance>;
  splitDepartment?: Maybe<EntityDepartment>;
  splitInstitution?: Maybe<TransactionParty>;
  splitLocation?: Maybe<EntityLocation>;
  splitSchedule?: Maybe<EntitySchedule>;
  supersededFactIds: Array<Scalars['String']['output']>;
  supersededLedgerTransactionIds: Array<Scalars['String']['output']>;
  taxStatus: TaxStatus;
  /** @deprecated unpopulated */
  threadDetails?: Maybe<Array<ThreadDetails>>;
  timestamp: Scalars['DateTime']['output'];
  transactionClassificationType?: Maybe<TransactionClassificationType>;
  viewId: Scalars['String']['output'];
};

export type TransactionCategorySuggestions = {
  categorySuggestions: Array<CategorySuggestion>;
  transactionFactId: Scalars['String']['output'];
};

export enum TransactionClassification {
  Credit = 'Credit',
  Debit = 'Debit'
}

export enum TransactionClassificationType {
  ACH = 'ACH',
  ATM = 'ATM',
  AccountsPayable = 'AccountsPayable',
  Charge = 'Charge',
  Check = 'Check',
  DebitCard = 'DebitCard',
  DirectDeposit = 'DirectDeposit',
  ExpenseReport = 'ExpenseReport',
  OnlineTransfer = 'OnlineTransfer',
  Transfer = 'Transfer',
  UnspecifiedTransactionClassificationType = 'UnspecifiedTransactionClassificationType',
  Wire = 'Wire'
}

export enum TransactionColumnName {
  AbsoluteAmount = 'AbsoluteAmount',
  Amount = 'Amount',
  Category = 'Category',
  Department = 'Department',
  Description = 'Description',
  FirstRecurredAt = 'FirstRecurredAt',
  Location = 'Location',
  Name = 'Name',
  OccurredAt = 'OccurredAt',
  Party = 'Party',
  ReconciliationStatus = 'ReconciliationStatus',
  RecurrenceInterval = 'RecurrenceInterval',
  SplitCategory = 'SplitCategory',
  SplitDepartment = 'SplitDepartment',
  SplitLocation = 'SplitLocation'
}

export type TransactionCounts = {
  reconciled: Scalars['Int']['output'];
  unsettled: Scalars['Int']['output'];
};

export type TransactionDiscountLineItem = {
  appliesToTransactionFactId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  discount?: Maybe<TransactionInvoiceLineItemDiscount>;
  fixedAmount?: Maybe<MonetaryValue>;
  name: Scalars['String']['output'];
  variablePercentage: Scalars['Long']['output'];
};

export type TransactionEntry = {
  amount: MonetaryValue;
  description: Scalars['String']['output'];
  externalLineId: Scalars['String']['output'];
  factId: Scalars['String']['output'];
};

export type TransactionEntryLine = {
  category: Category;
  categoryClassificationProvenance?: Maybe<ClassificationProvenance>;
  description?: Maybe<Scalars['String']['output']>;
  factId?: Maybe<Scalars['String']['output']>;
  highlighted: Scalars['Boolean']['output'];
  isCredit: Scalars['Boolean']['output'];
  lineId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  value: MonetaryValue;
};

/** Facet input types and enums */
export type TransactionFacetField = {
  kind: TransactionFacetKind;
  type: FacetType;
};

export enum TransactionFacetKind {
  TransactionDepartment = 'TransactionDepartment',
  TransactionLocation = 'TransactionLocation',
  TransactionMatchedStatus = 'TransactionMatchedStatus',
  TransactionNewParty = 'TransactionNewParty',
  TransactionParty = 'TransactionParty',
  TransactionSourceInstitution = 'TransactionSourceInstitution',
  TransactionSourceUser = 'TransactionSourceUser',
  UnknownTransactionKind = 'UnknownTransactionKind'
}

export type TransactionFactEntryType = {
  entryType: EntryType;
  transactionFactId: Scalars['String']['input'];
};

export type TransactionFeatureMapping = {
  featureIds: Array<Scalars['String']['output']>;
  transactionFactId: Scalars['String']['output'];
};

export type TransactionFilter = {
  canonicalCategoryType?: InputMaybe<CanonicalCategoryType>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  categorySubtypes?: InputMaybe<Array<CategorySubtype>>;
  categoryType?: InputMaybe<CategoryType>;
  categoryTypes?: InputMaybe<Array<CategoryType>>;
  classification?: InputMaybe<TransactionClassification>;
  dataSourceId?: InputMaybe<Scalars['String']['input']>;
  departmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  digitsTransactionTypes?: InputMaybe<Array<TransactionType>>;
  doubleEntry?: InputMaybe<DoubleEntry>;
  fieldFilterTerm?: InputMaybe<FieldFilterTermInput>;
  filterTerm?: InputMaybe<Scalars['String']['input']>;
  handleNone?: InputMaybe<HandleNone>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<TransactionKind>;
  ledgerTransactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  linkedObjectId?: InputMaybe<Scalars['String']['input']>;
  linkedObjectTypes?: InputMaybe<Array<LinkedObjectType>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  matchedStatuses?: InputMaybe<Array<MatchedStatus>>;
  maxValue?: InputMaybe<InputMonetaryValue>;
  minValue?: InputMaybe<InputMonetaryValue>;
  missingDepartment?: InputMaybe<MissingObject>;
  missingLocation?: InputMaybe<MissingObject>;
  missingParty?: InputMaybe<MissingObject>;
  missingProduct?: InputMaybe<MissingObject>;
  missingSchedule?: InputMaybe<MissingObject>;
  occurredAfter?: InputMaybe<Scalars['Float']['input']>;
  occurredBefore?: InputMaybe<Scalars['Float']['input']>;
  ownerEmployeeId?: InputMaybe<Scalars['String']['input']>;
  partyEntityTypes?: InputMaybe<Array<PartyEntityType>>;
  partyId?: InputMaybe<Scalars['String']['input']>;
  partyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  partyName?: InputMaybe<Scalars['String']['input']>;
  partyRole?: InputMaybe<PartyRole>;
  partyRoles?: InputMaybe<Array<PartyRole>>;
  productArea?: InputMaybe<ProductArea>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reconciliation?: InputMaybe<Reconciliation>;
  reconciliationFilter?: InputMaybe<ReconciliationFilter>;
  recurrenceInterval?: InputMaybe<Interval>;
  recurrenceStatus?: InputMaybe<TransactionFilterRecurrenceStatus>;
  recurringThreadId?: InputMaybe<Scalars['String']['input']>;
  referenceTransactionId?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  scheduleTypes?: InputMaybe<Array<ScheduleType>>;
  sourceAccountId?: InputMaybe<Scalars['String']['input']>;
  taxStatuses?: InputMaybe<Array<TaxStatus>>;
  taxpayerIdentifications?: InputMaybe<Array<TaxpayerIdentification>>;
  useAbsAmount?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
  viewKey: ViewKey;
  withoutCategoryAncestors?: InputMaybe<Scalars['Boolean']['input']>;
  withoutDepartmentAncestors?: InputMaybe<Scalars['Boolean']['input']>;
  withoutLocationAncestors?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TransactionFilterRecurrenceStatus {
  AllRecurring = 'AllRecurring',
  Occurred = 'Occurred'
}

export type TransactionGroup = {
  category: Category;
  description?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  party?: Maybe<TransactionParty>;
  timestamp: Scalars['DateTime']['output'];
  totalAmount: MoneyFlow;
  transactions: Array<Transaction>;
};

export type TransactionInvoiceLineItem = {
  value: TransactionInvoiceLineItemKind;
};

export type TransactionInvoiceLineItemDiscount = {
  description: Scalars['String']['output'];
  discountId: Scalars['String']['output'];
  fixedAmount?: Maybe<MonetaryValue>;
  name: Scalars['String']['output'];
  variablePercentage: Scalars['Long']['output'];
};

export type TransactionInvoiceLineItemKind = TransactionDiscountLineItem | TransactionProductLineItem;

export type TransactionInvoiceLineItemProduct = {
  category?: Maybe<Category>;
  department?: Maybe<EntityDepartment>;
  description: Scalars['String']['output'];
  location?: Maybe<EntityLocation>;
  name: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  unitPrice?: Maybe<MonetaryValue>;
};

export enum TransactionKind {
  Deposit = 'Deposit',
  Expense = 'Expense',
  Invoice = 'Invoice',
  Journal = 'Journal',
  Payment = 'Payment',
  Transfer = 'Transfer'
}

export type TransactionLine = {
  category: EntityCategory;
  categoryClassificationProvenance?: Maybe<ClassificationProvenance>;
  department?: Maybe<EntityDepartment>;
  entry: TransactionEntry;
  entryType: EntryType;
  location?: Maybe<EntityLocation>;
  party?: Maybe<EntityParty>;
  schedule?: Maybe<EntitySchedule>;
};

export type TransactionLineItem = {
  value: TransactionLineItemKind;
};

export type TransactionLineItemDiscount = {
  description: Scalars['String']['output'];
  discountId: Scalars['String']['output'];
  fixedAmount?: Maybe<MonetaryValue>;
  name: Scalars['String']['output'];
  variablePercentage: Scalars['Long']['output'];
};

export type TransactionLineItemKind = TransactionDiscountLineItem | TransactionProductLineItem;

export type TransactionLineItemProduct = {
  category?: Maybe<Category>;
  department?: Maybe<EntityDepartment>;
  description: Scalars['String']['output'];
  location?: Maybe<EntityLocation>;
  name: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  unitPrice?: Maybe<MonetaryValue>;
};

/** Transactions */
export type TransactionOrder = {
  transactionOrderPairs: Array<TransactionOrderPair>;
};

export type TransactionOrderPair = {
  columnName: TransactionColumnName;
  direction: SortDirection;
};

export type TransactionParty = {
  designation: PartyDesignation;
  iconObjectName?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  roles?: Maybe<Array<PartyRole>>;
};

export type TransactionProductLineItem = {
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  product?: Maybe<TransactionInvoiceLineItemProduct>;
  quantity: Scalars['Float']['output'];
  unitPrice?: Maybe<MonetaryValue>;
};

export type TransactionReconciliation = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** creator/created and updater/updatedAt are null when it was auto-reconciled/auto-unsettled */
  creator?: Maybe<EntityUser>;
  status: TransactionReconciliationStatus;
  transaction: Transaction;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updater?: Maybe<EntityUser>;
};

export type TransactionReconciliationClassification = {
  classificationVersion: TransactionReconciliationClassificationVersion;
  transactionFactId: Scalars['String']['output'];
  user: EntityUser;
};

export enum TransactionReconciliationClassificationVersion {
  DataSource = 'DataSource',
  PostStatementManual = 'PostStatementManual',
  PreStatementManual = 'PreStatementManual',
  SystemReconciliation = 'SystemReconciliation',
  Unknown = 'Unknown'
}

export enum TransactionReconciliationStatus {
  Reconciled = 'Reconciled',
  Unknown = 'Unknown',
  Unsettled = 'Unsettled'
}

export enum TransactionRecordType {
  ExpectedTransaction = 'ExpectedTransaction',
  Journal = 'Journal',
  MissedTransaction = 'MissedTransaction',
  Transaction = 'Transaction',
  UnknownRecordType = 'UnknownRecordType',
  UnreconciledSourceTransaction = 'UnreconciledSourceTransaction'
}

export type TransactionRecurrence = {
  firstOccurredAt: Scalars['DateTime']['output'];
  interval: Interval;
  intervalMultiplier: Scalars['Long']['output'];
  isHidden: Scalars['Boolean']['output'];
  lastOccurredAt: Scalars['DateTime']['output'];
  recurrenceThreadId: Scalars['String']['output'];
  threadIndex: Scalars['Long']['output'];
  totalThreadCount: Scalars['Long']['output'];
};

export type TransactionReviewQuestion = {
  createdAt: Scalars['DateTime']['output'];
  question: Scalars['String']['output'];
};

export type TransactionReviewReminderMessage = {
  legalEntityId: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type TransactionReviewSchedule = {
  daysOfMonth?: Maybe<Array<DayOfMonth>>;
  daysOfWeek?: Maybe<Array<DayOfWeek>>;
  enabled: Scalars['Boolean']['output'];
  legalEntityId: Scalars['String']['output'];
};

export type TransactionSource = {
  account?: Maybe<TransactionSourceAccount>;
  externalDisplayId?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  type: TransactionSourceType;
};

export type TransactionSourceAccount = {
  externalName?: Maybe<Scalars['String']['output']>;
  externalOfficialName?: Maybe<Scalars['String']['output']>;
  externalOwnerName?: Maybe<Scalars['String']['output']>;
  mask?: Maybe<Scalars['String']['output']>;
  sourceAccountId: Scalars['String']['output'];
};

export enum TransactionSourceType {
  CSVImport = 'CSVImport',
  Institution = 'Institution',
  Unknown = 'Unknown',
  User = 'User'
}

export type TransactionSummary = {
  isPeriodBookClosed: Scalars['Boolean']['output'];
  period: Period;
  total: PeriodMonetaryValue;
};

/** Transaction Editing */
export enum TransactionType {
  BankTransfer = 'BankTransfer',
  Bill = 'Bill',
  Invoice = 'Invoice',
  JournalEntry = 'JournalEntry',
  PayIn = 'PayIn',
  PayOut = 'PayOut',
  Unknown = 'Unknown'
}

export type TransactionViewDetail = {
  creditAmount?: Maybe<MonetaryValue>;
  creditCategoryHierarchy: Array<Category>;
  debitAmount?: Maybe<MonetaryValue>;
  /** First node is the top most parent of the hierarchy */
  debitCategoryHierarchy: Array<Category>;
  description?: Maybe<Scalars['String']['output']>;
  /** First node is the top most parent of the hierarchy */
  entryLines: Array<TransactionEntryLine>;
  externalCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  externalDisplayId?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  factId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  institution: Institution;
  name?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  party?: Maybe<TransactionParty>;
  quickbooksAppName?: Maybe<Scalars['String']['output']>;
  recordType: TransactionRecordType;
  sourceAccount?: Maybe<SourceAccount>;
};

export type TransactionViewDetails = {
  details: Array<TransactionViewDetail>;
};

/** Transaction Details */
export type TransactionWithDetails = {
  details: Array<TransactionViewDetail>;
  isInBooksClosedPeriod?: Maybe<Scalars['Boolean']['output']>;
  transaction: Transaction;
};

export type TrialBalance = {
  categories: Array<EntityCategory>;
  rows: Array<TrialBalanceRow>;
};

export type TrialBalanceRow = {
  credits: MonetaryValue;
  debits: MonetaryValue;
  name: Scalars['String']['output'];
  rowId: Scalars['String']['output'];
};

export enum UncategorizedReason {
  New = 'New',
  None = 'None',
  /** @deprecated No longer used */
  Split = 'Split'
}

export enum UpdatableEmployeeField {
  AvatarUrl = 'AvatarUrl',
  DefaultEntityRole = 'DefaultEntityRole',
  EmailAddress = 'EmailAddress',
  FamilyName = 'FamilyName',
  GivenName = 'GivenName',
  Hidden = 'Hidden',
  JobTitle = 'JobTitle',
  Role = 'Role'
}

export type UpdateAuditRule = {
  amountFilters?: InputMaybe<Array<InputAmountRuleFilter>>;
  auditRuleId: Scalars['String']['input'];
  auditRuleName: Scalars['String']['input'];
  categoryFilters?: InputMaybe<Array<InputCategoryRuleFilter>>;
  deletedAmountFilters?: InputMaybe<Array<DeletedAmountFilter>>;
  deletedCategories?: InputMaybe<Array<DeletedCategory>>;
  deletedCategoryFilters?: InputMaybe<Array<DeletedCategoryFilter>>;
  deletedPartyFilterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  deletedPartyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  partyFilters?: InputMaybe<Array<InputPartyRuleFilter>>;
  ruleState: AuditRuleState;
};

export type UpdateCategoryInput = {
  categoryId: Scalars['String']['input'];
  chartOfAccountsDisplayNumber: Scalars['String']['input'];
  description: Scalars['String']['input'];
  displayKey: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentCategoryId: Scalars['String']['input'];
  subtype: CategorySubtype;
  type: CategoryType;
};

export type UpdateDepartmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayKey?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
};

export type UpdateDepartmentResponse = {
  departmentId: Scalars['String']['output'];
};

export type UpdateLocationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayKey?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
};

export type UpdateLocationResponse = {
  locationId: Scalars['String']['output'];
};

export type UpdateProductsActiveInput = {
  active: Scalars['Boolean']['input'];
  legalEntityId: Scalars['String']['input'];
  products: Array<ProductIdentifierInput>;
};

export type UpdateReconciliationFlagTransactionDateInput = {
  date: Scalars['DateTime']['input'];
  featureGroupId: Scalars['String']['input'];
  flagId: Scalars['String']['input'];
  ledgerTransactionId: Scalars['String']['input'];
};

export type UpdateUserLegalEntityRoleEntry = {
  legalEntityId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type User = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  employments?: Maybe<Array<OrganizationEmployment>>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identities?: Maybe<Array<Identity>>;
  lastActivityAt: Scalars['DateTime']['output'];
  /** Timestamp when the user activated an MFA factor (e.g. TOTP). Null when no factor is enrolled. */
  mfaEnforcedAt?: Maybe<Scalars['DateTime']['output']>;
  passwordSet: Scalars['Boolean']['output'];
  primaryEmailAddress: Scalars['String']['output'];
};

export type UserAcl = {
  entities: ObjectEntities;
  grants: Array<ObjectGrant>;
  intents: Array<ObjectIntent>;
  requests: Array<ObjectRequest>;
};

export type UserAssignee = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UserContact = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserFacet = {
  count: Scalars['Int']['output'];
  userObject: EntityUser;
};

export type UserGrant = {
  grantId: Scalars['String']['output'];
  permission: Permission;
  userId: Scalars['String']['output'];
};

export type UserInfo = {
  emailAddress: Scalars['String']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
};

export type UserIntent = {
  emailAddress: Scalars['String']['output'];
  intentId: Scalars['String']['output'];
  permission: Permission;
};

export type UserLegalEntityRoleDelete = {
  legalEntityId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UserRequest = {
  requestId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/** Vanity Stats */
export type VanityStats = {
  totalCalculations: Scalars['Long']['output'];
  totalParties: Scalars['Long']['output'];
  totalPartiesIdentified: Scalars['Long']['output'];
  totalTransactions: Scalars['Long']['output'];
  totalTransactionsEnhanced: Scalars['Long']['output'];
  totalTransactionsValue: MonetaryValue;
};

export type Vendor = {
  email?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  partyId?: Maybe<Scalars['String']['output']>;
  providerType?: Maybe<Scalars['String']['output']>;
  vendorId: Scalars['String']['output'];
};

export type VendorSummary = {
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum VerificationRequestDestination {
  AIAccounting = 'AIAccounting',
  Bill = 'Bill',
  Developer = 'Developer',
  LedgerBill = 'LedgerBill',
  ProspectFirm = 'ProspectFirm',
  Share = 'Share',
  StartBusiness = 'StartBusiness',
  StartDeveloper = 'StartDeveloper',
  StartFirm = 'StartFirm',
  StartUnknown = 'StartUnknown',
  Unspecified = 'Unspecified'
}

export type ViewIdentifier = {
  legalEntityId: Scalars['String']['output'];
  mutationVersion?: Maybe<Scalars['String']['output']>;
  viewType: ViewType;
  viewVersion: Scalars['String']['output'];
};

export type ViewIdentifierInput = {
  legalEntityId: Scalars['String']['input'];
  mutationVersion?: InputMaybe<Scalars['String']['input']>;
  viewType: ViewType;
  viewVersion: Scalars['String']['input'];
};

export type ViewInvoiceSummary = {
  creditCardsEnabled: Scalars['Boolean']['output'];
  invoice: PublicInvoice;
  invoicePaymentDetails?: Maybe<InvoicePaymentDetails>;
  isPayable: Scalars['Boolean']['output'];
  useNewPaymentProvider: Scalars['Boolean']['output'];
};

export type ViewKey = {
  legalEntityId: Scalars['String']['input'];
  mutationVersion?: InputMaybe<Scalars['String']['input']>;
  viewType?: InputMaybe<ViewType>;
  viewVersion?: InputMaybe<Scalars['String']['input']>;
};

export type ViewMetadata = {
  firstTransactionTimestamp: Scalars['DateTime']['output'];
  latestTransactionTimestamp?: Maybe<Scalars['DateTime']['output']>;
  legalEntityId: Scalars['String']['output'];
  viewType?: Maybe<ViewType>;
  viewVersion?: Maybe<Scalars['String']['output']>;
};

export enum ViewType {
  AIBookkeeper = 'AIBookkeeper',
  Ledger = 'Ledger',
  Unknown = 'Unknown'
}

/** Notifications */
export type WebNotification = {
  assetLink?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayKey: Scalars['String']['output'];
  eventType: EventType;
  id: Scalars['String']['output'];
  legalEntityId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: WebNotificationStatus;
  targetAction: Scalars['String']['output'];
};

export enum WebNotificationStatus {
  DelayedDelivered = 'DelayedDelivered',
  Dismissed = 'Dismissed',
  Enqueued = 'Enqueued',
  Read = 'Read',
  Received = 'Received',
  UnknownStatus = 'UnknownStatus'
}

export type WebhookDeliveryEvent = {
  createdAt: Scalars['DateTime']['output'];
  deliveryStatus: WebhookDeliveryStatus;
  endpointUrl: Scalars['String']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  httpStatus?: Maybe<Scalars['Int']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  status: WebhookDeliveryEventStatus;
  webhookDeliveryEventId: Scalars['String']['output'];
  webhookDeliveryId: Scalars['String']['output'];
  webhookEventId: Scalars['String']['output'];
};

export enum WebhookDeliveryEventStatus {
  Failed = 'Failed',
  Succeeded = 'Succeeded'
}

export enum WebhookDeliveryStatus {
  Canceled = 'Canceled',
  Failed = 'Failed',
  InFlight = 'InFlight',
  Pending = 'Pending',
  Succeeded = 'Succeeded'
}

export type WebhookEndpoint = {
  connectorId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  endpointUrl: Scalars['String']['output'];
  environment: AppEnvironment;
  eventCategories: Array<WebhookEventCategory>;
  /**
   * Present only when the endpoint uses OAuth + Signatures; absent means Event
   * Signatures only.
   */
  oauthCredential?: Maybe<WebhookEndpointOAuthCredential>;
  signingSecret: Scalars['String']['output'];
  status: WebhookEndpointStatus;
  statusReason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  webhookEndpointId: Scalars['String']['output'];
};

export type WebhookEndpointOAuthClientCredentialsInput = {
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  tokenEndpointUrl: Scalars['String']['input'];
};

/**
 * Public metadata for an endpoint's active OAuth credential. Client secrets are
 * never returned.
 */
export type WebhookEndpointOAuthCredential = {
  clientId: Scalars['String']['output'];
  tokenEndpointUrl: Scalars['String']['output'];
};

export enum WebhookEndpointStatus {
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  SystemDisabled = 'SystemDisabled'
}

export enum WebhookEventCategory {
  Bill = 'Bill'
}

export type WorkItem = {
  actionable: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  generatedQuestions: Array<WorkItemGeneratedQuestion>;
  itemState: WorkItemState;
  itemType: WorkItemType;
  ledgerType: LedgerType;
  legalEntityId: Scalars['String']['output'];
  pushes: Array<WorkItemPush>;
  review?: Maybe<WorkItemReview>;
  reviewState?: Maybe<WorkItemReviewState>;
  time: Scalars['DateTime']['output'];
  transactions: Array<WorkItemTransaction>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** TODO: Hydrate user. */
  updatedBy?: Maybe<Scalars['String']['output']>;
  workItemId: Scalars['String']['output'];
};

export type WorkItemBadgeCountFilter = {
  itemStates?: InputMaybe<Array<WorkItemState>>;
  itemTypes?: InputMaybe<Array<WorkItemType>>;
  ledgerType?: InputMaybe<LedgerType>;
  legalEntityIds: Array<Scalars['String']['input']>;
  reviewStatesFilter?: InputMaybe<WorkItemReviewStatesFilter>;
};

export enum WorkItemErrorType {
  DuplicateVendor = 'DuplicateVendor',
  NoError = 'NoError',
  NotSupported = 'NotSupported',
  Other = 'Other',
  PeriodClosed = 'PeriodClosed'
}

export type WorkItemFilter = {
  excludedReviewStates?: InputMaybe<Array<WorkItemReviewState>>;
  itemStates?: InputMaybe<Array<WorkItemState>>;
  ledgerType?: InputMaybe<LedgerType>;
  legalEntityId: Scalars['String']['input'];
  reviewStates?: InputMaybe<Array<WorkItemReviewState>>;
  types?: InputMaybe<Array<WorkItemType>>;
};

export type WorkItemGeneratedQuestion = {
  active: Scalars['Boolean']['output'];
  contextType: WorkItemGeneratedQuestionContextType;
  question: Scalars['String']['output'];
};

export enum WorkItemGeneratedQuestionContextType {
  AccountantSpecific = 'AccountantSpecific',
  Direct = 'Direct',
  Friendly = 'Friendly'
}

export type WorkItemPush = {
  errorType?: Maybe<WorkItemErrorType>;
  field: WorkItemPushFieldType;
  pushState: WorkItemPushState;
  updatedAt: Scalars['DateTime']['output'];
};

export enum WorkItemPushFieldType {
  Category = 'Category',
  LineDescription = 'LineDescription',
  Memo = 'Memo',
  Party = 'Party',
  UnknownFieldType = 'UnknownFieldType'
}

export type WorkItemPushParams = {
  appendCommentsToQBO?: InputMaybe<Scalars['Boolean']['input']>;
  categoryParams?: InputMaybe<CategoryParams>;
  partyParams?: InputMaybe<PartyParams>;
  skipClose?: InputMaybe<Scalars['Boolean']['input']>;
  workItemId: Scalars['String']['input'];
};

export enum WorkItemPushState {
  Error = 'Error',
  Ignored = 'Ignored',
  Pushed = 'Pushed',
  UnknownState = 'UnknownState'
}

export type WorkItemResponse = {
  responseText?: InputMaybe<Scalars['String']['input']>;
  workItemId: Scalars['String']['input'];
};

export type WorkItemReview = {
  createdAt: Scalars['DateTime']['output'];
  creator: EntityUser;
  subject: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum WorkItemReviewState {
  ClientResponded = 'ClientResponded',
  PendingClientResponse = 'PendingClientResponse'
}

export type WorkItemReviewStatesFilter = {
  includeNullReviewState?: InputMaybe<Scalars['Boolean']['input']>;
  reviewStates?: InputMaybe<Array<WorkItemReviewState>>;
};

export enum WorkItemState {
  Accepted = 'Accepted',
  Active = 'Active',
  Completed = 'Completed',
  Invalidated = 'Invalidated',
  UnknownState = 'UnknownState'
}

export type WorkItemSubject = {
  saveAsTemplate: Scalars['Boolean']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  workItemId: Scalars['String']['input'];
};

export type WorkItemSummary = {
  count: Scalars['Long']['output'];
  period: Period;
};

export enum WorkItemSupportType {
  Context = 'Context',
  From = 'From',
  Object = 'Object',
  ObjectHighlight = 'ObjectHighlight',
  ResponseBasedPrediction = 'ResponseBasedPrediction',
  To = 'To',
  UnknownSupportType = 'UnknownSupportType',
  UserProvided = 'UserProvided'
}

export type WorkItemTransaction = {
  creditValue?: Maybe<MonetaryValue>;
  dataSourceId?: Maybe<Scalars['String']['output']>;
  debitValue?: Maybe<MonetaryValue>;
  description?: Maybe<Scalars['String']['output']>;
  displayCategory?: Maybe<EntityCategory>;
  displayEntry: DisplayEntry;
  displayPartyRole: PartyRole;
  /** @deprecated Use moneyFlow instead. */
  displayValue?: Maybe<MonetaryValue>;
  externalTransactionId: Scalars['String']['output'];
  externalTransactionLineId?: Maybe<Scalars['String']['output']>;
  ledgerTransactionId?: Maybe<Scalars['String']['output']>;
  moneyFlow?: Maybe<MoneyFlow>;
  name?: Maybe<Scalars['String']['output']>;
  occurredAt?: Maybe<Scalars['DateTime']['output']>;
  party?: Maybe<EntityParty>;
  quickbooksAppName?: Maybe<Scalars['String']['output']>;
  splitCategory?: Maybe<EntityCategory>;
  supportType: WorkItemSupportType;
};

export enum WorkItemType {
  HighConfidenceCategory = 'HighConfidenceCategory',
  HighConfidenceVendor = 'HighConfidenceVendor',
  InParentCategory = 'InParentCategory',
  PII = 'PII',
  UnassignedCategory = 'UnassignedCategory',
  UnassignedVendor = 'UnassignedVendor',
  UnknownType = 'UnknownType'
}

export type WorkflowActivityItem = {
  businessOutcome: WorkflowBusinessOutcome;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  definitionName: Scalars['String']['output'];
  displayKey: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
  message: Scalars['String']['output'];
  messageKind: WorkflowNotificationKind;
  status: WorkflowStatus;
  targetAction: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  workflowId: Scalars['String']['output'];
};

export enum WorkflowBusinessOutcome {
  BusinessOutcomeUnspecified = 'BusinessOutcomeUnspecified',
  Successful = 'Successful',
  Unsuccessful = 'Unsuccessful'
}

/**
 * WorkflowEvent is a refetch nudge, not state: when one arrives, clients should
 * refetch userWorkflowActivity rather than rendering these fields directly.
 * eventKind is a free-form String (not an enum) to discourage coupling to the
 * event taxonomy.
 */
export type WorkflowEvent = {
  businessOutcome: WorkflowBusinessOutcome;
  definitionName: Scalars['String']['output'];
  eventKind: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  workflowId: Scalars['String']['output'];
};

/**
 * Workflow user notifications and status indicators.
 *
 * When `bearerUpdated` is true and the event carries no user-facing payload
 * (a pure bearer-reissue signal), `message`, `targetAction`, and
 * `workflowNotificationID` may all be empty strings / null. Clients that
 * render notifications should gate on a non-empty `message` before showing
 * a toast.
 */
export type WorkflowNotificationEvent = {
  /**
   * Modifier on bearerUpdated: defer applying the reissue (and the
   * view-version change it carries) until the next route change so an
   * in-progress page isn't refetched out from under the user. Only
   * meaningful when bearerUpdated is true.
   */
  bearerRefreshDeferred: Scalars['Boolean']['output'];
  /**
   * Signals that the client must reissue its bearer token. Transient —
   * carried only on the live event; not reconstructible from history.
   * May arrive with an empty `message` when no user-facing toast is
   * warranted (silent refresh).
   */
  bearerUpdated: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  definitionName: Scalars['String']['output'];
  kind: WorkflowNotificationKind;
  message: Scalars['String']['output'];
  notificationType: WorkflowNotificationType;
  targetAction?: Maybe<Scalars['String']['output']>;
  workflowID: Scalars['String']['output'];
  workflowNotificationID: Scalars['String']['output'];
};

export enum WorkflowNotificationKind {
  Error = 'Error',
  Info = 'Info',
  Success = 'Success',
  UnspecifiedKind = 'UnspecifiedKind',
  Warning = 'Warning'
}

export enum WorkflowNotificationType {
  Notification = 'Notification',
  Status = 'Status',
  UnspecifiedType = 'UnspecifiedType'
}

export enum WorkflowStatus {
  Compensated = 'Compensated',
  Compensating = 'Compensating',
  Completed = 'Completed',
  Failed = 'Failed',
  PartiallyCompensated = 'PartiallyCompensated',
  Pending = 'Pending',
  Running = 'Running',
  Suspended = 'Suspended',
  Unspecified = 'Unspecified'
}

export type WorkflowSummary = {
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  definitionName: Scalars['String']['output'];
  idempotencyKey: Scalars['String']['output'];
  legalEntityId: Scalars['String']['output'];
  status: WorkflowStatus;
  updatedAt: Scalars['DateTime']['output'];
  workflowId: Scalars['String']['output'];
};

export type DeleteDocumentMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
  documentCollectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type DeleteDocumentMutation = Pick<Mutation, 'deleteDocument'>;

export type ObjectAclFieldsFragment = (
  Pick<ObjectAcl, 'link'>
  & {
    object: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
    grants: Array<Pick<UserGrant, 'grantId' | 'userId' | 'permission'>>,
    intents: Array<Pick<UserIntent, 'intentId' | 'emailAddress' | 'permission'>>,
    requests: Array<Pick<UserRequest, 'requestId' | 'userId'>>,
    entities: (
      { __typename: 'ObjectEntities' }
      & {
        users?: Maybe<Array<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>>,
        transactions?: Maybe<Array<(
          Pick<
            EntityTransaction,
            | 'viewId'
            | 'factId'
            | 'timestamp'
            | 'description'
            | 'externalId'
            | 'displayEntry'
          >
          & {
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            party?: Maybe<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
            displayCategory: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            splitCategory?: Maybe<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>,
          }
        )>>,
        comments?: Maybe<Array<Pick<
            EntityComment,
            | 'id'
            | 'authorId'
            | 'text'
            | 'timestamp'
          >>>,
        reports?: Maybe<Array<(
          Pick<
            EntityReport,
            | 'id'
            | 'title'
            | 'authorId'
            | 'mimeType'
            | 'createdAt'
          >
          & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
        )>>,
        reportPackages?: Maybe<Array<(
          Pick<
            EntityReportPackage,
            | 'id'
            | 'title'
            | 'authorId'
            | 'interval'
            | 'periodStartedAt'
            | 'periodEndedAt'
            | 'createdAt'
            | 'updatedAt'
            | 'coverUrl'
          >
          & { documents: Array<Pick<
              SharedReportDocumentMetadata,
              | 'id'
              | 'documentObjectId'
              | 'documentObjectVersionId'
              | 'title'
              | 'mimeType'
            >> }
        )>>,
        parties?: Maybe<Array<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>>,
        datasources?: Maybe<Array<Pick<
            EntityDataSource,
            | 'id'
            | 'name'
            | 'url'
            | 'iconUrl'
          >>>,
        categories?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>>,
        threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
        legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
        workItems?: Maybe<Array<(
          Pick<
            EntityWorkItem,
            | 'id'
            | 'time'
            | 'workItemState'
            | 'workItemType'
            | 'reviewCreatedById'
            | 'reviewState'
            | 'ledgerType'
          >
          & { objectTransaction: (
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          ) }
        )>>,
        invoices?: Maybe<Array<(
          Pick<
            EntityInvoice,
            | 'id'
            | 'externalDisplayId'
            | 'createdAt'
            | 'dueAt'
          >
          & {
            amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            customer: (
              Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
              & { party: Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                > }
            ),
          }
        )>>,
        bills?: Maybe<Array<(
          Pick<
            EntityBill,
            | 'id'
            | 'billStatus'
            | 'vendorName'
            | 'billDescription'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
            format: (
              Pick<Format, 'id' | 'formatClass'>
              & { segments: Array<Pick<
                  Segment,
                  | 'collectionId'
                  | 'fileId'
                  | 'sequence'
                  | 'token'
                >> }
            ),
            approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
          }
        )>>,
        identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
        departments?: Maybe<Array<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        locations?: Maybe<Array<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        reconciliations?: Maybe<Array<(
          { __typename: 'EntityReconciliation' }
          & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
          & {
            startDate: Pick<Date, 'year' | 'month' | 'day'>,
            endDate: Pick<Date, 'year' | 'month' | 'day'>,
          }
        )>>,
        ledgerTransactions?: Maybe<Array<(
          Pick<
            EntityLedgerTransaction,
            | 'id'
            | 'timestamp'
            | 'factIds'
            | 'name'
            | 'referenceNumber'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            parties: Array<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
          }
        )>>,
        schedules?: Maybe<Array<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
            | 'cutoverDate'
          >
          & {
            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>>,
      }
    ),
  }
);

export type UserGrantFieldsFragment = Pick<UserGrant, 'grantId' | 'userId' | 'permission'>;

export type UserIntentFieldsFragment = Pick<UserIntent, 'intentId' | 'emailAddress' | 'permission'>;

export type UserRequestFieldsFragment = Pick<UserRequest, 'requestId' | 'userId'>;

export type ObjectGrantFieldsFragment = (
  Pick<
    ObjectGrant,
    | 'grantId'
    | 'permission'
    | 'createdAt'
    | 'viewType'
  >
  & { object: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'> }
);

export type UserAclFieldsFragment = {
    grants: Array<(
      Pick<
        ObjectGrant,
        | 'grantId'
        | 'permission'
        | 'createdAt'
        | 'viewType'
      >
      & { object: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'> }
    )>,
    entities: (
      { __typename: 'ObjectEntities' }
      & {
        users?: Maybe<Array<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>>,
        transactions?: Maybe<Array<(
          Pick<
            EntityTransaction,
            | 'viewId'
            | 'factId'
            | 'timestamp'
            | 'description'
            | 'externalId'
            | 'displayEntry'
          >
          & {
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            party?: Maybe<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
            displayCategory: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            splitCategory?: Maybe<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>,
          }
        )>>,
        comments?: Maybe<Array<Pick<
            EntityComment,
            | 'id'
            | 'authorId'
            | 'text'
            | 'timestamp'
          >>>,
        reports?: Maybe<Array<(
          Pick<
            EntityReport,
            | 'id'
            | 'title'
            | 'authorId'
            | 'mimeType'
            | 'createdAt'
          >
          & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
        )>>,
        reportPackages?: Maybe<Array<(
          Pick<
            EntityReportPackage,
            | 'id'
            | 'title'
            | 'authorId'
            | 'interval'
            | 'periodStartedAt'
            | 'periodEndedAt'
            | 'createdAt'
            | 'updatedAt'
            | 'coverUrl'
          >
          & { documents: Array<Pick<
              SharedReportDocumentMetadata,
              | 'id'
              | 'documentObjectId'
              | 'documentObjectVersionId'
              | 'title'
              | 'mimeType'
            >> }
        )>>,
        parties?: Maybe<Array<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>>,
        datasources?: Maybe<Array<Pick<
            EntityDataSource,
            | 'id'
            | 'name'
            | 'url'
            | 'iconUrl'
          >>>,
        categories?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>>,
        threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
        legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
        workItems?: Maybe<Array<(
          Pick<
            EntityWorkItem,
            | 'id'
            | 'time'
            | 'workItemState'
            | 'workItemType'
            | 'reviewCreatedById'
            | 'reviewState'
            | 'ledgerType'
          >
          & { objectTransaction: (
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          ) }
        )>>,
        invoices?: Maybe<Array<(
          Pick<
            EntityInvoice,
            | 'id'
            | 'externalDisplayId'
            | 'createdAt'
            | 'dueAt'
          >
          & {
            amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            customer: (
              Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
              & { party: Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                > }
            ),
          }
        )>>,
        bills?: Maybe<Array<(
          Pick<
            EntityBill,
            | 'id'
            | 'billStatus'
            | 'vendorName'
            | 'billDescription'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
            format: (
              Pick<Format, 'id' | 'formatClass'>
              & { segments: Array<Pick<
                  Segment,
                  | 'collectionId'
                  | 'fileId'
                  | 'sequence'
                  | 'token'
                >> }
            ),
            approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
          }
        )>>,
        identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
        departments?: Maybe<Array<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        locations?: Maybe<Array<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        reconciliations?: Maybe<Array<(
          { __typename: 'EntityReconciliation' }
          & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
          & {
            startDate: Pick<Date, 'year' | 'month' | 'day'>,
            endDate: Pick<Date, 'year' | 'month' | 'day'>,
          }
        )>>,
        ledgerTransactions?: Maybe<Array<(
          Pick<
            EntityLedgerTransaction,
            | 'id'
            | 'timestamp'
            | 'factIds'
            | 'name'
            | 'referenceNumber'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            parties: Array<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
          }
        )>>,
        schedules?: Maybe<Array<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
            | 'cutoverDate'
          >
          & {
            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>>,
      }
    ),
  };

export type ApproveObjectAccessRequestMutationVariables = Exact<{
  requestId: Scalars['String']['input'];
  permission: Permission;
  constraint?: InputMaybe<AccessConstraint>;
}>;


export type ApproveObjectAccessRequestMutation = Pick<Mutation, 'approveObjectAccessRequest'>;

export type CreateIntentMutationVariables = Exact<{
  identifier: InputObjectIdentifier;
  permissions: Array<NewUserGrant> | NewUserGrant;
  message: Scalars['String']['input'];
  sendNotification: Scalars['Boolean']['input'];
  constraint?: InputMaybe<AccessConstraint>;
  viewKey?: InputMaybe<ViewKey>;
}>;


export type CreateIntentMutation = Pick<Mutation, 'createIntent'>;

export type DisableObjectLinkMutationVariables = Exact<{
  identifier: InputObjectIdentifier;
}>;


export type DisableObjectLinkMutation = Pick<Mutation, 'disableObjectLink'>;

export type EnableObjectLinkMutationVariables = Exact<{
  identifier: InputObjectIdentifier;
  permission: Permission;
  viewType?: InputMaybe<ViewType>;
}>;


export type EnableObjectLinkMutation = Pick<Mutation, 'enableObjectLink'>;

export type GrantFromShareMutationVariables = Exact<{
  object: InputObjectIdentifier;
  intentId?: InputMaybe<Scalars['String']['input']>;
  constraint?: InputMaybe<AccessConstraint>;
}>;


export type GrantFromShareMutation = Pick<Mutation, 'grantFromShare'>;

export type RejectObjectAccessRequestMutationVariables = Exact<{
  requestId: Scalars['String']['input'];
}>;


export type RejectObjectAccessRequestMutation = Pick<Mutation, 'rejectObjectAccessRequest'>;

export type RequestObjectAccessMutationVariables = Exact<{
  object: InputObjectIdentifier;
  intentId?: InputMaybe<Scalars['String']['input']>;
  constraint?: InputMaybe<AccessConstraint>;
}>;


export type RequestObjectAccessMutation = Pick<Mutation, 'requestObjectAccess'>;

export type RevokeGrantMutationVariables = Exact<{
  grantId: Scalars['String']['input'];
  identifier: InputObjectIdentifier;
  constraint?: InputMaybe<AccessConstraint>;
}>;


export type RevokeGrantMutation = Pick<Mutation, 'revokeGrant'>;

export type RevokeIntentMutationVariables = Exact<{
  intentId: Scalars['String']['input'];
  identifier: InputObjectIdentifier;
  constraint?: InputMaybe<AccessConstraint>;
}>;


export type RevokeIntentMutation = Pick<Mutation, 'revokeIntent'>;

export type UpdateGrantMutationVariables = Exact<{
  grantId: Scalars['String']['input'];
  identifier: InputObjectIdentifier;
  permission: Permission;
  constraint?: InputMaybe<AccessConstraint>;
}>;


export type UpdateGrantMutation = Pick<Mutation, 'updateGrant'>;

export type UpdateIntentMutationVariables = Exact<{
  intentId: Scalars['String']['input'];
  identifier: InputObjectIdentifier;
  permission: Permission;
  constraint?: InputMaybe<AccessConstraint>;
}>;


export type UpdateIntentMutation = Pick<Mutation, 'updateIntent'>;

export type UpdateObjectLinkMutationVariables = Exact<{
  identifier: InputObjectIdentifier;
  permission: Permission;
}>;


export type UpdateObjectLinkMutation = Pick<Mutation, 'updateObjectLink'>;

export type ListObjectAcLsQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  kind: ObjectKind;
  legalEntityId: Scalars['String']['input'];
}>;


export type ListObjectAcLsQuery = { listObjectACLs: Array<(
    Pick<ObjectAcl, 'link'>
    & {
      object: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
      grants: Array<Pick<UserGrant, 'grantId' | 'userId' | 'permission'>>,
      intents: Array<Pick<UserIntent, 'intentId' | 'emailAddress' | 'permission'>>,
      requests: Array<Pick<UserRequest, 'requestId' | 'userId'>>,
      entities: (
        { __typename: 'ObjectEntities' }
        & {
          users?: Maybe<Array<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>>,
          transactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          comments?: Maybe<Array<Pick<
              EntityComment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
            >>>,
          reports?: Maybe<Array<(
            Pick<
              EntityReport,
              | 'id'
              | 'title'
              | 'authorId'
              | 'mimeType'
              | 'createdAt'
            >
            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
          )>>,
          reportPackages?: Maybe<Array<(
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )>>,
          parties?: Maybe<Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>>,
          datasources?: Maybe<Array<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>>,
          categories?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>>,
          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
          workItems?: Maybe<Array<(
            Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )>>,
          invoices?: Maybe<Array<(
            Pick<
              EntityInvoice,
              | 'id'
              | 'externalDisplayId'
              | 'createdAt'
              | 'dueAt'
            >
            & {
              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              customer: (
                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                & { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              ),
            }
          )>>,
          bills?: Maybe<Array<(
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )>>,
          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
          departments?: Maybe<Array<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          locations?: Maybe<Array<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          reconciliations?: Maybe<Array<(
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )>>,
          ledgerTransactions?: Maybe<Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )>>,
          schedules?: Maybe<Array<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>>,
        }
      ),
    }
  )> };

export type ReadShareQueryVariables = Exact<{
  id: Scalars['String']['input'];
  kind: ObjectKind;
  intentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReadShareQuery = { readShare: (
    Pick<ObjectPermission, 'permission' | 'action' | 'viewType'>
    & {
      object: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
      legalEntity: Pick<EntityLegalEntity, 'id' | 'slug' | 'name'>,
      organizationPreview: Pick<OrganizationPreview, 'id' | 'slug' | 'name'>,
    }
  ) };

export type ReadShareAdjacencyQueryVariables = Exact<{
  id: Scalars['String']['input'];
  kind: ObjectKind;
  legalEntitySlug: Scalars['String']['input'];
}>;


export type ReadShareAdjacencyQuery = { readShareAdjacency: (
    Pick<AdjacentObjectPermission, 'viewType'>
    & {
      object: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
      legalEntity: Pick<EntityLegalEntity, 'id' | 'slug' | 'name'>,
      organizationPreview: Pick<OrganizationPreview, 'id' | 'slug' | 'name'>,
    }
  ) };

export type ReadUserAclQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadUserAclQuery = { readUserACL: {
      grants: Array<(
        Pick<
          ObjectGrant,
          | 'grantId'
          | 'permission'
          | 'createdAt'
          | 'viewType'
        >
        & { object: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'> }
      )>,
      entities: (
        { __typename: 'ObjectEntities' }
        & {
          users?: Maybe<Array<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>>,
          transactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          comments?: Maybe<Array<Pick<
              EntityComment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
            >>>,
          reports?: Maybe<Array<(
            Pick<
              EntityReport,
              | 'id'
              | 'title'
              | 'authorId'
              | 'mimeType'
              | 'createdAt'
            >
            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
          )>>,
          reportPackages?: Maybe<Array<(
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )>>,
          parties?: Maybe<Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>>,
          datasources?: Maybe<Array<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>>,
          categories?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>>,
          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
          workItems?: Maybe<Array<(
            Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )>>,
          invoices?: Maybe<Array<(
            Pick<
              EntityInvoice,
              | 'id'
              | 'externalDisplayId'
              | 'createdAt'
              | 'dueAt'
            >
            & {
              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              customer: (
                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                & { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              ),
            }
          )>>,
          bills?: Maybe<Array<(
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )>>,
          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
          departments?: Maybe<Array<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          locations?: Maybe<Array<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          reconciliations?: Maybe<Array<(
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )>>,
          ledgerTransactions?: Maybe<Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )>>,
          schedules?: Maybe<Array<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>>,
        }
      ),
    } };

export type AccountReconciliationFieldsFragment = (
  Pick<
    AccountReconciliation,
    | 'chartOfAccountsId'
    | 'categoryId'
    | 'reconciliationId'
    | 'status'
    | 'createdAt'
    | 'updatedAt'
  >
  & {
    category: Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >,
    startDate: Pick<Date, 'year' | 'month' | 'day'>,
    endDate: Pick<Date, 'year' | 'month' | 'day'>,
    updater?: Maybe<Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
  }
);

export type LedgerAccountDifferencesFieldsFragment = {
    debitDifference?: Maybe<(
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    )>,
    creditDifference?: Maybe<(
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    )>,
    unreconciledDifference: (
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    ),
  };

export type LedgerBalancesFieldsFragment = {
    debitTotal: (
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    ),
    creditTotal: (
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    ),
    netTotal: (
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    ),
    unsettledTotal: (
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    ),
    closingBalance: (
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    ),
  };

export type ReconciliationBalancesFieldsFragment = {
    ledgerBalances: {
        debitTotal: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        creditTotal: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        netTotal: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        unsettledTotal: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        closingBalance: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
      },
    statementBalances: {
        debitTotal?: Maybe<(
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        )>,
        creditTotal?: Maybe<(
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        )>,
        netTotal: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        openingBalance: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        closingBalance: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
      },
    ledgerAccountDifferences: {
        debitDifference?: Maybe<(
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        )>,
        creditDifference?: Maybe<(
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        )>,
        unreconciledDifference: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
      },
  };

export type ReconciliationFlagFieldsFragment = (
  Pick<
    ReconciliationFlag,
    | 'flagId'
    | 'flagType'
    | 'reconciliationIntentId'
    | 'createdAt'
    | 'resolvedAt'
    | 'resolutionType'
  >
  & {
    resolvedByUser?: Maybe<Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
    potentialDuplicateDetails?: Maybe<(
      Pick<PotentialDuplicateFlagDetails, 'transactionFactId' | 'potentialDuplicateTransactionFactId'>
      & {
        transaction: (
          Pick<
            Transaction,
            | 'viewId'
            | 'factId'
            | 'ledgerTransactionId'
            | 'supersededFactIds'
            | 'timestamp'
            | 'recordType'
            | 'name'
            | 'description'
            | 'digitsTransactionType'
            | 'partySource'
            | 'displayEntry'
            | 'displayCategorySource'
            | 'displayCanonicalCategoryName'
            | 'displayUncategorizedReason'
            | 'displayProductArea'
            | 'ownerSource'
            | 'transactionClassificationType'
            | 'compileSource'
            | 'reconciliationStatus'
            | 'referenceNumber'
            | 'taxStatus'
            | 'matchedLedgerTransactionIds'
            | 'providerTypes'
            | 'isSupersedingLedgerTransaction'
            | 'supersededLedgerTransactionIds'
          >
          & {
            party?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            facilitatorParty?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            product?: Maybe<Pick<
                Product,
                | 'id'
                | 'dataSourceId'
                | 'name'
                | 'providerType'
                | 'active'
                | 'institutionId'
                | 'institutionName'
              >>,
            department?: Maybe<(
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            splitDepartment?: Maybe<(
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            location?: Maybe<(
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            splitLocation?: Maybe<(
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            providers: Array<Pick<Provider, 'name'>>,
            recurrence?: Maybe<Pick<
                TransactionRecurrence,
                | 'recurrenceThreadId'
                | 'interval'
                | 'intervalMultiplier'
                | 'threadIndex'
                | 'totalThreadCount'
                | 'isHidden'
                | 'firstOccurredAt'
                | 'lastOccurredAt'
              >>,
            displayInstitution?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            displayCategory: (
              Pick<
                Category,
                | 'id'
                | 'name'
                | 'description'
                | 'displayKey'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'displayNumber'
                | 'active'
                | 'categoryState'
                | 'productArea'
                | 'synthesized'
              >
              & { ancestors?: Maybe<Array<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>> }
            ),
            displayCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            splitCategory?: Maybe<(
              Pick<
                Category,
                | 'id'
                | 'name'
                | 'description'
                | 'displayKey'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'displayNumber'
                | 'active'
                | 'categoryState'
                | 'productArea'
                | 'synthesized'
              >
              & { ancestors?: Maybe<Array<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>> }
            )>,
            splitCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            splitInstitution?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            creditCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            debitCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            runningTotal?: Maybe<(
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            )>,
            owner?: Maybe<Pick<
                EntityEmployee,
                | 'id'
                | 'organizationId'
                | 'givenName'
                | 'familyName'
                | 'avatarUrl'
              >>,
            sources: Array<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )>,
            creditSources: Array<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )>,
            debitSources: Array<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )>,
            invoiceLineItem?: Maybe<{ value:
                | (
                  Pick<
                    TransactionDiscountLineItem,
                    | 'name'
                    | 'description'
                    | 'variablePercentage'
                    | 'appliesToTransactionFactId'
                  >
                  & {
                    fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                    discount?: Maybe<(
                      Pick<
                        TransactionInvoiceLineItemDiscount,
                        | 'discountId'
                        | 'name'
                        | 'description'
                        | 'variablePercentage'
                      >
                      & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                    )>,
                  }
                )
                | (
                  Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                  & {
                    unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                    product?: Maybe<(
                      Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                      & {
                        unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                        category?: Maybe<(
                          Pick<
                            Category,
                            | 'id'
                            | 'name'
                            | 'description'
                            | 'displayKey'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'displayNumber'
                            | 'active'
                            | 'categoryState'
                            | 'productArea'
                            | 'synthesized'
                          >
                          & { ancestors?: Maybe<Array<Pick<
                              EntityCategory,
                              | 'id'
                              | 'name'
                              | 'displayKey'
                              | 'chartOfAccountsDisplayNumber'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'productArea'
                              | 'active'
                            >>> }
                        )>,
                        department?: Maybe<(
                          { __typename: 'EntityDepartment' }
                          & Pick<
                            EntityDepartment,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        )>,
                        location?: Maybe<(
                          { __typename: 'EntityLocation' }
                          & Pick<
                            EntityLocation,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        )>,
                      }
                    )>,
                  }
                )
               }>,
            schedule?: Maybe<(
              { __typename: 'EntitySchedule' }
              & Pick<
                EntitySchedule,
                | 'id'
                | 'name'
                | 'scheduleNumber'
                | 'scheduleType'
                | 'scheduleTemplateId'
                | 'categoryId'
                | 'relatedCategoryId'
                | 'partyId'
                | 'startDate'
                | 'endDate'
                | 'cutoverDate'
              >
              & {
                amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              }
            )>,
            splitSchedule?: Maybe<(
              { __typename: 'EntitySchedule' }
              & Pick<
                EntitySchedule,
                | 'id'
                | 'name'
                | 'scheduleNumber'
                | 'scheduleType'
                | 'scheduleTemplateId'
                | 'categoryId'
                | 'relatedCategoryId'
                | 'partyId'
                | 'startDate'
                | 'endDate'
                | 'cutoverDate'
              >
              & {
                amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              }
            )>,
          }
        ),
        potentialDuplicateTransaction: (
          Pick<
            Transaction,
            | 'viewId'
            | 'factId'
            | 'ledgerTransactionId'
            | 'supersededFactIds'
            | 'timestamp'
            | 'recordType'
            | 'name'
            | 'description'
            | 'digitsTransactionType'
            | 'partySource'
            | 'displayEntry'
            | 'displayCategorySource'
            | 'displayCanonicalCategoryName'
            | 'displayUncategorizedReason'
            | 'displayProductArea'
            | 'ownerSource'
            | 'transactionClassificationType'
            | 'compileSource'
            | 'reconciliationStatus'
            | 'referenceNumber'
            | 'taxStatus'
            | 'matchedLedgerTransactionIds'
            | 'providerTypes'
            | 'isSupersedingLedgerTransaction'
            | 'supersededLedgerTransactionIds'
          >
          & {
            party?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            facilitatorParty?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            product?: Maybe<Pick<
                Product,
                | 'id'
                | 'dataSourceId'
                | 'name'
                | 'providerType'
                | 'active'
                | 'institutionId'
                | 'institutionName'
              >>,
            department?: Maybe<(
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            splitDepartment?: Maybe<(
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            location?: Maybe<(
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            splitLocation?: Maybe<(
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            providers: Array<Pick<Provider, 'name'>>,
            recurrence?: Maybe<Pick<
                TransactionRecurrence,
                | 'recurrenceThreadId'
                | 'interval'
                | 'intervalMultiplier'
                | 'threadIndex'
                | 'totalThreadCount'
                | 'isHidden'
                | 'firstOccurredAt'
                | 'lastOccurredAt'
              >>,
            displayInstitution?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            displayCategory: (
              Pick<
                Category,
                | 'id'
                | 'name'
                | 'description'
                | 'displayKey'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'displayNumber'
                | 'active'
                | 'categoryState'
                | 'productArea'
                | 'synthesized'
              >
              & { ancestors?: Maybe<Array<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>> }
            ),
            displayCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            splitCategory?: Maybe<(
              Pick<
                Category,
                | 'id'
                | 'name'
                | 'description'
                | 'displayKey'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'displayNumber'
                | 'active'
                | 'categoryState'
                | 'productArea'
                | 'synthesized'
              >
              & { ancestors?: Maybe<Array<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>> }
            )>,
            splitCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            splitInstitution?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            creditCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            debitCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            runningTotal?: Maybe<(
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            )>,
            owner?: Maybe<Pick<
                EntityEmployee,
                | 'id'
                | 'organizationId'
                | 'givenName'
                | 'familyName'
                | 'avatarUrl'
              >>,
            sources: Array<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )>,
            creditSources: Array<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )>,
            debitSources: Array<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )>,
            invoiceLineItem?: Maybe<{ value:
                | (
                  Pick<
                    TransactionDiscountLineItem,
                    | 'name'
                    | 'description'
                    | 'variablePercentage'
                    | 'appliesToTransactionFactId'
                  >
                  & {
                    fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                    discount?: Maybe<(
                      Pick<
                        TransactionInvoiceLineItemDiscount,
                        | 'discountId'
                        | 'name'
                        | 'description'
                        | 'variablePercentage'
                      >
                      & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                    )>,
                  }
                )
                | (
                  Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                  & {
                    unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                    product?: Maybe<(
                      Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                      & {
                        unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                        category?: Maybe<(
                          Pick<
                            Category,
                            | 'id'
                            | 'name'
                            | 'description'
                            | 'displayKey'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'displayNumber'
                            | 'active'
                            | 'categoryState'
                            | 'productArea'
                            | 'synthesized'
                          >
                          & { ancestors?: Maybe<Array<Pick<
                              EntityCategory,
                              | 'id'
                              | 'name'
                              | 'displayKey'
                              | 'chartOfAccountsDisplayNumber'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'productArea'
                              | 'active'
                            >>> }
                        )>,
                        department?: Maybe<(
                          { __typename: 'EntityDepartment' }
                          & Pick<
                            EntityDepartment,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        )>,
                        location?: Maybe<(
                          { __typename: 'EntityLocation' }
                          & Pick<
                            EntityLocation,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        )>,
                      }
                    )>,
                  }
                )
               }>,
            schedule?: Maybe<(
              { __typename: 'EntitySchedule' }
              & Pick<
                EntitySchedule,
                | 'id'
                | 'name'
                | 'scheduleNumber'
                | 'scheduleType'
                | 'scheduleTemplateId'
                | 'categoryId'
                | 'relatedCategoryId'
                | 'partyId'
                | 'startDate'
                | 'endDate'
                | 'cutoverDate'
              >
              & {
                amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              }
            )>,
            splitSchedule?: Maybe<(
              { __typename: 'EntitySchedule' }
              & Pick<
                EntitySchedule,
                | 'id'
                | 'name'
                | 'scheduleNumber'
                | 'scheduleType'
                | 'scheduleTemplateId'
                | 'categoryId'
                | 'relatedCategoryId'
                | 'partyId'
                | 'startDate'
                | 'endDate'
                | 'cutoverDate'
              >
              & {
                amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              }
            )>,
          }
        ),
        statementLineItem: (
          Pick<
            StatementLineItem,
            | 'featureGroupId'
            | 'featureIds'
            | 'date'
            | 'description'
            | 'entryType'
          >
          & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
      }
    )>,
    changeDateDetails?: Maybe<(
      Pick<ChangeDateFlagDetails, 'transactionFactId' | 'suggestedDate'>
      & {
        statementLineItem: (
          Pick<
            StatementLineItem,
            | 'featureGroupId'
            | 'featureIds'
            | 'date'
            | 'description'
            | 'entryType'
          >
          & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        transaction: (
          Pick<
            Transaction,
            | 'viewId'
            | 'factId'
            | 'ledgerTransactionId'
            | 'supersededFactIds'
            | 'timestamp'
            | 'recordType'
            | 'name'
            | 'description'
            | 'digitsTransactionType'
            | 'partySource'
            | 'displayEntry'
            | 'displayCategorySource'
            | 'displayCanonicalCategoryName'
            | 'displayUncategorizedReason'
            | 'displayProductArea'
            | 'ownerSource'
            | 'transactionClassificationType'
            | 'compileSource'
            | 'reconciliationStatus'
            | 'referenceNumber'
            | 'taxStatus'
            | 'matchedLedgerTransactionIds'
            | 'providerTypes'
            | 'isSupersedingLedgerTransaction'
            | 'supersededLedgerTransactionIds'
          >
          & {
            party?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            facilitatorParty?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            product?: Maybe<Pick<
                Product,
                | 'id'
                | 'dataSourceId'
                | 'name'
                | 'providerType'
                | 'active'
                | 'institutionId'
                | 'institutionName'
              >>,
            department?: Maybe<(
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            splitDepartment?: Maybe<(
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            location?: Maybe<(
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            splitLocation?: Maybe<(
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            providers: Array<Pick<Provider, 'name'>>,
            recurrence?: Maybe<Pick<
                TransactionRecurrence,
                | 'recurrenceThreadId'
                | 'interval'
                | 'intervalMultiplier'
                | 'threadIndex'
                | 'totalThreadCount'
                | 'isHidden'
                | 'firstOccurredAt'
                | 'lastOccurredAt'
              >>,
            displayInstitution?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            displayCategory: (
              Pick<
                Category,
                | 'id'
                | 'name'
                | 'description'
                | 'displayKey'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'displayNumber'
                | 'active'
                | 'categoryState'
                | 'productArea'
                | 'synthesized'
              >
              & { ancestors?: Maybe<Array<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>> }
            ),
            displayCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            splitCategory?: Maybe<(
              Pick<
                Category,
                | 'id'
                | 'name'
                | 'description'
                | 'displayKey'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'displayNumber'
                | 'active'
                | 'categoryState'
                | 'productArea'
                | 'synthesized'
              >
              & { ancestors?: Maybe<Array<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>> }
            )>,
            splitCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            splitInstitution?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            creditCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            debitCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            runningTotal?: Maybe<(
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            )>,
            owner?: Maybe<Pick<
                EntityEmployee,
                | 'id'
                | 'organizationId'
                | 'givenName'
                | 'familyName'
                | 'avatarUrl'
              >>,
            sources: Array<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )>,
            creditSources: Array<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )>,
            debitSources: Array<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )>,
            invoiceLineItem?: Maybe<{ value:
                | (
                  Pick<
                    TransactionDiscountLineItem,
                    | 'name'
                    | 'description'
                    | 'variablePercentage'
                    | 'appliesToTransactionFactId'
                  >
                  & {
                    fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                    discount?: Maybe<(
                      Pick<
                        TransactionInvoiceLineItemDiscount,
                        | 'discountId'
                        | 'name'
                        | 'description'
                        | 'variablePercentage'
                      >
                      & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                    )>,
                  }
                )
                | (
                  Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                  & {
                    unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                    product?: Maybe<(
                      Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                      & {
                        unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                        category?: Maybe<(
                          Pick<
                            Category,
                            | 'id'
                            | 'name'
                            | 'description'
                            | 'displayKey'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'displayNumber'
                            | 'active'
                            | 'categoryState'
                            | 'productArea'
                            | 'synthesized'
                          >
                          & { ancestors?: Maybe<Array<Pick<
                              EntityCategory,
                              | 'id'
                              | 'name'
                              | 'displayKey'
                              | 'chartOfAccountsDisplayNumber'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'productArea'
                              | 'active'
                            >>> }
                        )>,
                        department?: Maybe<(
                          { __typename: 'EntityDepartment' }
                          & Pick<
                            EntityDepartment,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        )>,
                        location?: Maybe<(
                          { __typename: 'EntityLocation' }
                          & Pick<
                            EntityLocation,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        )>,
                      }
                    )>,
                  }
                )
               }>,
            schedule?: Maybe<(
              { __typename: 'EntitySchedule' }
              & Pick<
                EntitySchedule,
                | 'id'
                | 'name'
                | 'scheduleNumber'
                | 'scheduleType'
                | 'scheduleTemplateId'
                | 'categoryId'
                | 'relatedCategoryId'
                | 'partyId'
                | 'startDate'
                | 'endDate'
                | 'cutoverDate'
              >
              & {
                amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              }
            )>,
            splitSchedule?: Maybe<(
              { __typename: 'EntitySchedule' }
              & Pick<
                EntitySchedule,
                | 'id'
                | 'name'
                | 'scheduleNumber'
                | 'scheduleType'
                | 'scheduleTemplateId'
                | 'categoryId'
                | 'relatedCategoryId'
                | 'partyId'
                | 'startDate'
                | 'endDate'
                | 'cutoverDate'
              >
              & {
                amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              }
            )>,
          }
        ),
      }
    )>,
    potentialMismatchDetails?: Maybe<(
      Pick<PotentialMismatchFlagDetails, 'transactionFactId'>
      & {
        statementLineItem: (
          Pick<
            StatementLineItem,
            | 'featureGroupId'
            | 'featureIds'
            | 'date'
            | 'description'
            | 'entryType'
          >
          & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        transaction: (
          Pick<
            Transaction,
            | 'viewId'
            | 'factId'
            | 'ledgerTransactionId'
            | 'supersededFactIds'
            | 'timestamp'
            | 'recordType'
            | 'name'
            | 'description'
            | 'digitsTransactionType'
            | 'partySource'
            | 'displayEntry'
            | 'displayCategorySource'
            | 'displayCanonicalCategoryName'
            | 'displayUncategorizedReason'
            | 'displayProductArea'
            | 'ownerSource'
            | 'transactionClassificationType'
            | 'compileSource'
            | 'reconciliationStatus'
            | 'referenceNumber'
            | 'taxStatus'
            | 'matchedLedgerTransactionIds'
            | 'providerTypes'
            | 'isSupersedingLedgerTransaction'
            | 'supersededLedgerTransactionIds'
          >
          & {
            party?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            facilitatorParty?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            product?: Maybe<Pick<
                Product,
                | 'id'
                | 'dataSourceId'
                | 'name'
                | 'providerType'
                | 'active'
                | 'institutionId'
                | 'institutionName'
              >>,
            department?: Maybe<(
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            splitDepartment?: Maybe<(
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            location?: Maybe<(
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            splitLocation?: Maybe<(
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            providers: Array<Pick<Provider, 'name'>>,
            recurrence?: Maybe<Pick<
                TransactionRecurrence,
                | 'recurrenceThreadId'
                | 'interval'
                | 'intervalMultiplier'
                | 'threadIndex'
                | 'totalThreadCount'
                | 'isHidden'
                | 'firstOccurredAt'
                | 'lastOccurredAt'
              >>,
            displayInstitution?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            displayCategory: (
              Pick<
                Category,
                | 'id'
                | 'name'
                | 'description'
                | 'displayKey'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'displayNumber'
                | 'active'
                | 'categoryState'
                | 'productArea'
                | 'synthesized'
              >
              & { ancestors?: Maybe<Array<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>> }
            ),
            displayCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            splitCategory?: Maybe<(
              Pick<
                Category,
                | 'id'
                | 'name'
                | 'description'
                | 'displayKey'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'displayNumber'
                | 'active'
                | 'categoryState'
                | 'productArea'
                | 'synthesized'
              >
              & { ancestors?: Maybe<Array<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>> }
            )>,
            splitCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            splitInstitution?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            creditCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            debitCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            runningTotal?: Maybe<(
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            )>,
            owner?: Maybe<Pick<
                EntityEmployee,
                | 'id'
                | 'organizationId'
                | 'givenName'
                | 'familyName'
                | 'avatarUrl'
              >>,
            sources: Array<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )>,
            creditSources: Array<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )>,
            debitSources: Array<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )>,
            invoiceLineItem?: Maybe<{ value:
                | (
                  Pick<
                    TransactionDiscountLineItem,
                    | 'name'
                    | 'description'
                    | 'variablePercentage'
                    | 'appliesToTransactionFactId'
                  >
                  & {
                    fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                    discount?: Maybe<(
                      Pick<
                        TransactionInvoiceLineItemDiscount,
                        | 'discountId'
                        | 'name'
                        | 'description'
                        | 'variablePercentage'
                      >
                      & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                    )>,
                  }
                )
                | (
                  Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                  & {
                    unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                    product?: Maybe<(
                      Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                      & {
                        unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                        category?: Maybe<(
                          Pick<
                            Category,
                            | 'id'
                            | 'name'
                            | 'description'
                            | 'displayKey'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'displayNumber'
                            | 'active'
                            | 'categoryState'
                            | 'productArea'
                            | 'synthesized'
                          >
                          & { ancestors?: Maybe<Array<Pick<
                              EntityCategory,
                              | 'id'
                              | 'name'
                              | 'displayKey'
                              | 'chartOfAccountsDisplayNumber'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'productArea'
                              | 'active'
                            >>> }
                        )>,
                        department?: Maybe<(
                          { __typename: 'EntityDepartment' }
                          & Pick<
                            EntityDepartment,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        )>,
                        location?: Maybe<(
                          { __typename: 'EntityLocation' }
                          & Pick<
                            EntityLocation,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        )>,
                      }
                    )>,
                  }
                )
               }>,
            schedule?: Maybe<(
              { __typename: 'EntitySchedule' }
              & Pick<
                EntitySchedule,
                | 'id'
                | 'name'
                | 'scheduleNumber'
                | 'scheduleType'
                | 'scheduleTemplateId'
                | 'categoryId'
                | 'relatedCategoryId'
                | 'partyId'
                | 'startDate'
                | 'endDate'
                | 'cutoverDate'
              >
              & {
                amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              }
            )>,
            splitSchedule?: Maybe<(
              { __typename: 'EntitySchedule' }
              & Pick<
                EntitySchedule,
                | 'id'
                | 'name'
                | 'scheduleNumber'
                | 'scheduleType'
                | 'scheduleTemplateId'
                | 'categoryId'
                | 'relatedCategoryId'
                | 'partyId'
                | 'startDate'
                | 'endDate'
                | 'cutoverDate'
              >
              & {
                amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              }
            )>,
          }
        ),
      }
    )>,
    createNewTransactionDetails?: Maybe<{ statementLineItem: (
        Pick<
          StatementLineItem,
          | 'featureGroupId'
          | 'featureIds'
          | 'date'
          | 'description'
          | 'entryType'
        >
        & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ) }>,
  }
);

export type StatementLineItemFieldsFragment = (
  Pick<
    StatementLineItem,
    | 'featureGroupId'
    | 'featureIds'
    | 'date'
    | 'description'
    | 'entryType'
  >
  & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
);

export type ReconciliationPeriodStatsFieldsFragment = Pick<
    ReconciliationPeriodStats,
    | 'notStarted'
    | 'noActivity'
    | 'drafts'
    | 'finalized'
    | 'totalCategories'
  >;

export type StatementBalancesFieldsFragment = {
    debitTotal?: Maybe<(
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    )>,
    creditTotal?: Maybe<(
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    )>,
    netTotal: (
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    ),
    openingBalance: (
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    ),
    closingBalance: (
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    ),
  };

export type TransactionCountsFieldsFragment = Pick<TransactionCounts, 'reconciled' | 'unsettled'>;

export type TransactionReconciliationClassificationFieldsFragment = (
  Pick<TransactionReconciliationClassification, 'classificationVersion' | 'transactionFactId'>
  & { user: Pick<
      EntityUser,
      | 'id'
      | 'givenName'
      | 'familyName'
      | 'emailAddress'
      | 'avatarUrl'
    > }
);

export type CancelReconciliationIntentsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  reconciliationIntentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CancelReconciliationIntentsMutation = Pick<Mutation, 'cancelReconciliationIntents'>;

export type CreateAccountReconciliationMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  viewKey: ViewKey;
  reconciliation: InputAccountReconciliation;
}>;


export type CreateAccountReconciliationMutation = Pick<Mutation, 'createAccountReconciliation'>;

export type CreateReconciliationFlagsTransactionsMutationVariables = Exact<{
  reconciliationIntentId: Scalars['String']['input'];
  flags: Array<CreateReconciliationFlagsTransactionsInput> | CreateReconciliationFlagsTransactionsInput;
  viewKey: ViewKey;
}>;


export type CreateReconciliationFlagsTransactionsMutation = Pick<Mutation, 'createReconciliationFlagsTransactions'>;

export type CreateReconciliationIntentsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  documentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  documentCollectionId?: InputMaybe<Scalars['String']['input']>;
  intentCategoryId?: InputMaybe<Scalars['String']['input']>;
  reconciliationId?: InputMaybe<Scalars['String']['input']>;
  reconciliationCategoryId?: InputMaybe<Scalars['String']['input']>;
  actionItemId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateReconciliationIntentsMutation = { createReconciliationIntents: { createReconciliationIntentResponses: Array<Pick<CreateReconciliationIntentResponse, 'reconciliationIntentId' | 'state'>> } };

export type DeleteAccountReconciliationMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  reconciliationId: Scalars['String']['input'];
}>;


export type DeleteAccountReconciliationMutation = Pick<Mutation, 'deleteAccountReconciliation'>;

export type DeletePotentialDuplicateFlagTransactionsMutationVariables = Exact<{
  reconciliationIntentId: Scalars['String']['input'];
  flag: DeletePotentialDuplicateFlagTransactionsInput;
  viewKey: ViewKey;
}>;


export type DeletePotentialDuplicateFlagTransactionsMutation = Pick<Mutation, 'deletePotentialDuplicateFlagTransactions'>;

export type ExportReconciliationsPdfsMutationVariables = Exact<{
  viewKey: ViewKey;
  reconciliationIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  documentCollectionId: Scalars['String']['input'];
}>;


export type ExportReconciliationsPdfsMutation = Pick<Mutation, 'exportReconciliationsPdfs'>;

export type FinalizeAccountReconciliationMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  reconciliationId: Scalars['String']['input'];
  viewKey: ViewKey;
}>;


export type FinalizeAccountReconciliationMutation = Pick<Mutation, 'finalizeAccountReconciliation'>;

export type MatchPotentialDuplicateFlagTransactionsMutationVariables = Exact<{
  reconciliationIntentId: Scalars['String']['input'];
  flag: MatchPotentialDuplicateFlagTransactionsInput;
  viewKey: ViewKey;
}>;


export type MatchPotentialDuplicateFlagTransactionsMutation = Pick<Mutation, 'matchPotentialDuplicateFlagTransactions'>;

export type ReopenAccountReconciliationMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  reconciliationId: Scalars['String']['input'];
}>;


export type ReopenAccountReconciliationMutation = Pick<Mutation, 'reopenAccountReconciliation'>;

export type ResolvePotentialMismatchFlagMutationVariables = Exact<{
  reconciliationIntentId: Scalars['String']['input'];
  flag: ResolvePotentialMismatchInput;
  viewKey: ViewKey;
}>;


export type ResolvePotentialMismatchFlagMutation = Pick<Mutation, 'resolvePotentialMismatchFlag'>;

export type UpdateAccountReconciliationMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  reconciliationId: Scalars['String']['input'];
  viewKey: ViewKey;
  update: InputAccountReconciliationUpdate;
}>;


export type UpdateAccountReconciliationMutation = Pick<Mutation, 'updateAccountReconciliation'>;

export type UpdateReconciliationFlagResolutionMutationVariables = Exact<{
  reconciliationIntentId: Scalars['String']['input'];
  flagId: Scalars['String']['input'];
  resolved: Scalars['Boolean']['input'];
  resolutionType: ReconciliationFlagResolutionType;
  viewKey: ViewKey;
}>;


export type UpdateReconciliationFlagResolutionMutation = { updateReconciliationFlagResolution: (
    Pick<
      ReconciliationFlag,
      | 'flagId'
      | 'flagType'
      | 'reconciliationIntentId'
      | 'createdAt'
      | 'resolvedAt'
      | 'resolutionType'
    >
    & {
      resolvedByUser?: Maybe<Pick<
          EntityUser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >>,
      potentialDuplicateDetails?: Maybe<(
        Pick<PotentialDuplicateFlagDetails, 'transactionFactId' | 'potentialDuplicateTransactionFactId'>
        & {
          transaction: (
            Pick<
              Transaction,
              | 'viewId'
              | 'factId'
              | 'ledgerTransactionId'
              | 'supersededFactIds'
              | 'timestamp'
              | 'recordType'
              | 'name'
              | 'description'
              | 'digitsTransactionType'
              | 'partySource'
              | 'displayEntry'
              | 'displayCategorySource'
              | 'displayCanonicalCategoryName'
              | 'displayUncategorizedReason'
              | 'displayProductArea'
              | 'ownerSource'
              | 'transactionClassificationType'
              | 'compileSource'
              | 'reconciliationStatus'
              | 'referenceNumber'
              | 'taxStatus'
              | 'matchedLedgerTransactionIds'
              | 'providerTypes'
              | 'isSupersedingLedgerTransaction'
              | 'supersededLedgerTransactionIds'
            >
            & {
              party?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              facilitatorParty?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              product?: Maybe<Pick<
                  Product,
                  | 'id'
                  | 'dataSourceId'
                  | 'name'
                  | 'providerType'
                  | 'active'
                  | 'institutionId'
                  | 'institutionName'
                >>,
              department?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitDepartment?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              location?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitLocation?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              providers: Array<Pick<Provider, 'name'>>,
              recurrence?: Maybe<Pick<
                  TransactionRecurrence,
                  | 'recurrenceThreadId'
                  | 'interval'
                  | 'intervalMultiplier'
                  | 'threadIndex'
                  | 'totalThreadCount'
                  | 'isHidden'
                  | 'firstOccurredAt'
                  | 'lastOccurredAt'
                >>,
              displayInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              displayCategory: (
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              ),
              displayCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitCategory?: Maybe<(
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              )>,
              splitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              creditCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              debitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              runningTotal?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              owner?: Maybe<Pick<
                  EntityEmployee,
                  | 'id'
                  | 'organizationId'
                  | 'givenName'
                  | 'familyName'
                  | 'avatarUrl'
                >>,
              sources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              creditSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              debitSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              invoiceLineItem?: Maybe<{ value:
                  | (
                    Pick<
                      TransactionDiscountLineItem,
                      | 'name'
                      | 'description'
                      | 'variablePercentage'
                      | 'appliesToTransactionFactId'
                    >
                    & {
                      fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      discount?: Maybe<(
                        Pick<
                          TransactionInvoiceLineItemDiscount,
                          | 'discountId'
                          | 'name'
                          | 'description'
                          | 'variablePercentage'
                        >
                        & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                      )>,
                    }
                  )
                  | (
                    Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                    & {
                      unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      product?: Maybe<(
                        Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                        & {
                          unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                          category?: Maybe<(
                            Pick<
                              Category,
                              | 'id'
                              | 'name'
                              | 'description'
                              | 'displayKey'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'displayNumber'
                              | 'active'
                              | 'categoryState'
                              | 'productArea'
                              | 'synthesized'
                            >
                            & { ancestors?: Maybe<Array<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>> }
                          )>,
                          department?: Maybe<(
                            { __typename: 'EntityDepartment' }
                            & Pick<
                              EntityDepartment,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                          location?: Maybe<(
                            { __typename: 'EntityLocation' }
                            & Pick<
                              EntityLocation,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                        }
                      )>,
                    }
                  )
                 }>,
              schedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                  | 'cutoverDate'
                >
                & {
                  amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
              splitSchedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                  | 'cutoverDate'
                >
                & {
                  amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
            }
          ),
          potentialDuplicateTransaction: (
            Pick<
              Transaction,
              | 'viewId'
              | 'factId'
              | 'ledgerTransactionId'
              | 'supersededFactIds'
              | 'timestamp'
              | 'recordType'
              | 'name'
              | 'description'
              | 'digitsTransactionType'
              | 'partySource'
              | 'displayEntry'
              | 'displayCategorySource'
              | 'displayCanonicalCategoryName'
              | 'displayUncategorizedReason'
              | 'displayProductArea'
              | 'ownerSource'
              | 'transactionClassificationType'
              | 'compileSource'
              | 'reconciliationStatus'
              | 'referenceNumber'
              | 'taxStatus'
              | 'matchedLedgerTransactionIds'
              | 'providerTypes'
              | 'isSupersedingLedgerTransaction'
              | 'supersededLedgerTransactionIds'
            >
            & {
              party?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              facilitatorParty?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              product?: Maybe<Pick<
                  Product,
                  | 'id'
                  | 'dataSourceId'
                  | 'name'
                  | 'providerType'
                  | 'active'
                  | 'institutionId'
                  | 'institutionName'
                >>,
              department?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitDepartment?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              location?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitLocation?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              providers: Array<Pick<Provider, 'name'>>,
              recurrence?: Maybe<Pick<
                  TransactionRecurrence,
                  | 'recurrenceThreadId'
                  | 'interval'
                  | 'intervalMultiplier'
                  | 'threadIndex'
                  | 'totalThreadCount'
                  | 'isHidden'
                  | 'firstOccurredAt'
                  | 'lastOccurredAt'
                >>,
              displayInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              displayCategory: (
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              ),
              displayCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitCategory?: Maybe<(
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              )>,
              splitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              creditCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              debitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              runningTotal?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              owner?: Maybe<Pick<
                  EntityEmployee,
                  | 'id'
                  | 'organizationId'
                  | 'givenName'
                  | 'familyName'
                  | 'avatarUrl'
                >>,
              sources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              creditSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              debitSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              invoiceLineItem?: Maybe<{ value:
                  | (
                    Pick<
                      TransactionDiscountLineItem,
                      | 'name'
                      | 'description'
                      | 'variablePercentage'
                      | 'appliesToTransactionFactId'
                    >
                    & {
                      fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      discount?: Maybe<(
                        Pick<
                          TransactionInvoiceLineItemDiscount,
                          | 'discountId'
                          | 'name'
                          | 'description'
                          | 'variablePercentage'
                        >
                        & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                      )>,
                    }
                  )
                  | (
                    Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                    & {
                      unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      product?: Maybe<(
                        Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                        & {
                          unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                          category?: Maybe<(
                            Pick<
                              Category,
                              | 'id'
                              | 'name'
                              | 'description'
                              | 'displayKey'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'displayNumber'
                              | 'active'
                              | 'categoryState'
                              | 'productArea'
                              | 'synthesized'
                            >
                            & { ancestors?: Maybe<Array<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>> }
                          )>,
                          department?: Maybe<(
                            { __typename: 'EntityDepartment' }
                            & Pick<
                              EntityDepartment,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                          location?: Maybe<(
                            { __typename: 'EntityLocation' }
                            & Pick<
                              EntityLocation,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                        }
                      )>,
                    }
                  )
                 }>,
              schedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                  | 'cutoverDate'
                >
                & {
                  amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
              splitSchedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                  | 'cutoverDate'
                >
                & {
                  amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
            }
          ),
          statementLineItem: (
            Pick<
              StatementLineItem,
              | 'featureGroupId'
              | 'featureIds'
              | 'date'
              | 'description'
              | 'entryType'
            >
            & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
        }
      )>,
      changeDateDetails?: Maybe<(
        Pick<ChangeDateFlagDetails, 'transactionFactId' | 'suggestedDate'>
        & {
          statementLineItem: (
            Pick<
              StatementLineItem,
              | 'featureGroupId'
              | 'featureIds'
              | 'date'
              | 'description'
              | 'entryType'
            >
            & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          transaction: (
            Pick<
              Transaction,
              | 'viewId'
              | 'factId'
              | 'ledgerTransactionId'
              | 'supersededFactIds'
              | 'timestamp'
              | 'recordType'
              | 'name'
              | 'description'
              | 'digitsTransactionType'
              | 'partySource'
              | 'displayEntry'
              | 'displayCategorySource'
              | 'displayCanonicalCategoryName'
              | 'displayUncategorizedReason'
              | 'displayProductArea'
              | 'ownerSource'
              | 'transactionClassificationType'
              | 'compileSource'
              | 'reconciliationStatus'
              | 'referenceNumber'
              | 'taxStatus'
              | 'matchedLedgerTransactionIds'
              | 'providerTypes'
              | 'isSupersedingLedgerTransaction'
              | 'supersededLedgerTransactionIds'
            >
            & {
              party?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              facilitatorParty?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              product?: Maybe<Pick<
                  Product,
                  | 'id'
                  | 'dataSourceId'
                  | 'name'
                  | 'providerType'
                  | 'active'
                  | 'institutionId'
                  | 'institutionName'
                >>,
              department?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitDepartment?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              location?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitLocation?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              providers: Array<Pick<Provider, 'name'>>,
              recurrence?: Maybe<Pick<
                  TransactionRecurrence,
                  | 'recurrenceThreadId'
                  | 'interval'
                  | 'intervalMultiplier'
                  | 'threadIndex'
                  | 'totalThreadCount'
                  | 'isHidden'
                  | 'firstOccurredAt'
                  | 'lastOccurredAt'
                >>,
              displayInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              displayCategory: (
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              ),
              displayCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitCategory?: Maybe<(
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              )>,
              splitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              creditCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              debitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              runningTotal?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              owner?: Maybe<Pick<
                  EntityEmployee,
                  | 'id'
                  | 'organizationId'
                  | 'givenName'
                  | 'familyName'
                  | 'avatarUrl'
                >>,
              sources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              creditSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              debitSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              invoiceLineItem?: Maybe<{ value:
                  | (
                    Pick<
                      TransactionDiscountLineItem,
                      | 'name'
                      | 'description'
                      | 'variablePercentage'
                      | 'appliesToTransactionFactId'
                    >
                    & {
                      fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      discount?: Maybe<(
                        Pick<
                          TransactionInvoiceLineItemDiscount,
                          | 'discountId'
                          | 'name'
                          | 'description'
                          | 'variablePercentage'
                        >
                        & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                      )>,
                    }
                  )
                  | (
                    Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                    & {
                      unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      product?: Maybe<(
                        Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                        & {
                          unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                          category?: Maybe<(
                            Pick<
                              Category,
                              | 'id'
                              | 'name'
                              | 'description'
                              | 'displayKey'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'displayNumber'
                              | 'active'
                              | 'categoryState'
                              | 'productArea'
                              | 'synthesized'
                            >
                            & { ancestors?: Maybe<Array<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>> }
                          )>,
                          department?: Maybe<(
                            { __typename: 'EntityDepartment' }
                            & Pick<
                              EntityDepartment,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                          location?: Maybe<(
                            { __typename: 'EntityLocation' }
                            & Pick<
                              EntityLocation,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                        }
                      )>,
                    }
                  )
                 }>,
              schedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                  | 'cutoverDate'
                >
                & {
                  amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
              splitSchedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                  | 'cutoverDate'
                >
                & {
                  amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
            }
          ),
        }
      )>,
      potentialMismatchDetails?: Maybe<(
        Pick<PotentialMismatchFlagDetails, 'transactionFactId'>
        & {
          statementLineItem: (
            Pick<
              StatementLineItem,
              | 'featureGroupId'
              | 'featureIds'
              | 'date'
              | 'description'
              | 'entryType'
            >
            & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          transaction: (
            Pick<
              Transaction,
              | 'viewId'
              | 'factId'
              | 'ledgerTransactionId'
              | 'supersededFactIds'
              | 'timestamp'
              | 'recordType'
              | 'name'
              | 'description'
              | 'digitsTransactionType'
              | 'partySource'
              | 'displayEntry'
              | 'displayCategorySource'
              | 'displayCanonicalCategoryName'
              | 'displayUncategorizedReason'
              | 'displayProductArea'
              | 'ownerSource'
              | 'transactionClassificationType'
              | 'compileSource'
              | 'reconciliationStatus'
              | 'referenceNumber'
              | 'taxStatus'
              | 'matchedLedgerTransactionIds'
              | 'providerTypes'
              | 'isSupersedingLedgerTransaction'
              | 'supersededLedgerTransactionIds'
            >
            & {
              party?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              facilitatorParty?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              product?: Maybe<Pick<
                  Product,
                  | 'id'
                  | 'dataSourceId'
                  | 'name'
                  | 'providerType'
                  | 'active'
                  | 'institutionId'
                  | 'institutionName'
                >>,
              department?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitDepartment?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              location?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitLocation?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              providers: Array<Pick<Provider, 'name'>>,
              recurrence?: Maybe<Pick<
                  TransactionRecurrence,
                  | 'recurrenceThreadId'
                  | 'interval'
                  | 'intervalMultiplier'
                  | 'threadIndex'
                  | 'totalThreadCount'
                  | 'isHidden'
                  | 'firstOccurredAt'
                  | 'lastOccurredAt'
                >>,
              displayInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              displayCategory: (
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              ),
              displayCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitCategory?: Maybe<(
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              )>,
              splitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              creditCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              debitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              runningTotal?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              owner?: Maybe<Pick<
                  EntityEmployee,
                  | 'id'
                  | 'organizationId'
                  | 'givenName'
                  | 'familyName'
                  | 'avatarUrl'
                >>,
              sources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              creditSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              debitSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              invoiceLineItem?: Maybe<{ value:
                  | (
                    Pick<
                      TransactionDiscountLineItem,
                      | 'name'
                      | 'description'
                      | 'variablePercentage'
                      | 'appliesToTransactionFactId'
                    >
                    & {
                      fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      discount?: Maybe<(
                        Pick<
                          TransactionInvoiceLineItemDiscount,
                          | 'discountId'
                          | 'name'
                          | 'description'
                          | 'variablePercentage'
                        >
                        & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                      )>,
                    }
                  )
                  | (
                    Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                    & {
                      unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      product?: Maybe<(
                        Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                        & {
                          unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                          category?: Maybe<(
                            Pick<
                              Category,
                              | 'id'
                              | 'name'
                              | 'description'
                              | 'displayKey'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'displayNumber'
                              | 'active'
                              | 'categoryState'
                              | 'productArea'
                              | 'synthesized'
                            >
                            & { ancestors?: Maybe<Array<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>> }
                          )>,
                          department?: Maybe<(
                            { __typename: 'EntityDepartment' }
                            & Pick<
                              EntityDepartment,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                          location?: Maybe<(
                            { __typename: 'EntityLocation' }
                            & Pick<
                              EntityLocation,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                        }
                      )>,
                    }
                  )
                 }>,
              schedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                  | 'cutoverDate'
                >
                & {
                  amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
              splitSchedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                  | 'cutoverDate'
                >
                & {
                  amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
            }
          ),
        }
      )>,
      createNewTransactionDetails?: Maybe<{ statementLineItem: (
          Pick<
            StatementLineItem,
            | 'featureGroupId'
            | 'featureIds'
            | 'date'
            | 'description'
            | 'entryType'
          >
          & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ) }>,
    }
  ) };

export type UpdateReconciliationFlagTransactionDateMutationVariables = Exact<{
  reconciliationIntentId: Scalars['String']['input'];
  flag: UpdateReconciliationFlagTransactionDateInput;
  viewKey: ViewKey;
}>;


export type UpdateReconciliationFlagTransactionDateMutation = Pick<Mutation, 'updateReconciliationFlagTransactionDate'>;

export type UpdateTransactionReconciliationStatusesMutationVariables = Exact<{
  viewKey: ViewKey;
  statusUpdates: Array<InputStatusUpdate> | InputStatusUpdate;
}>;


export type UpdateTransactionReconciliationStatusesMutation = Pick<Mutation, 'updateTransactionReconciliationStatuses'>;

export type GetDocumentsTransactionFeaturesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  documentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetDocumentsTransactionFeaturesQuery = { getDocumentsTransactionFeatures: Array<(
    Pick<DocumentTransactionFeatures, 'documentId'>
    & { transactionFeatures: Array<Pick<TransactionFeatureMapping, 'transactionFactId' | 'featureIds'>> }
  )> };

export type ListAccountReconciliationsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  viewKey: ViewKey;
  origin: IntervalOrigin;
  direction: DirectionFromOrigin;
  filter?: InputMaybe<InputAccountReconciliationsFilter>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListAccountReconciliationsQuery = { listAccountReconciliations: Array<{
      account: Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >,
      reconciliations: Array<(
        Pick<
          AccountReconciliation,
          | 'chartOfAccountsId'
          | 'categoryId'
          | 'reconciliationId'
          | 'status'
          | 'createdAt'
          | 'updatedAt'
        >
        & {
          category: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          startDate: Pick<Date, 'year' | 'month' | 'day'>,
          endDate: Pick<Date, 'year' | 'month' | 'day'>,
          updater?: Maybe<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>,
        }
      )>,
      mostRecentFinalizedReconciliation?: Maybe<(
        Pick<
          AccountReconciliation,
          | 'chartOfAccountsId'
          | 'categoryId'
          | 'reconciliationId'
          | 'status'
          | 'createdAt'
          | 'updatedAt'
        >
        & {
          category: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          startDate: Pick<Date, 'year' | 'month' | 'day'>,
          endDate: Pick<Date, 'year' | 'month' | 'day'>,
          updater?: Maybe<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>,
        }
      )>,
      earliestOpenReconciliation?: Maybe<(
        Pick<
          AccountReconciliation,
          | 'chartOfAccountsId'
          | 'categoryId'
          | 'reconciliationId'
          | 'status'
          | 'createdAt'
          | 'updatedAt'
        >
        & {
          category: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          startDate: Pick<Date, 'year' | 'month' | 'day'>,
          endDate: Pick<Date, 'year' | 'month' | 'day'>,
          updater?: Maybe<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>,
        }
      )>,
    }> };

export type ListCascadeFinalizableReconciliationsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  reconciliationId: Scalars['String']['input'];
  viewKey: ViewKey;
}>;


export type ListCascadeFinalizableReconciliationsQuery = { listCascadeFinalizableReconciliations: Array<(
    Pick<
      AccountReconciliation,
      | 'chartOfAccountsId'
      | 'categoryId'
      | 'reconciliationId'
      | 'status'
      | 'createdAt'
      | 'updatedAt'
    >
    & {
      category: Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >,
      startDate: Pick<Date, 'year' | 'month' | 'day'>,
      endDate: Pick<Date, 'year' | 'month' | 'day'>,
      updater?: Maybe<Pick<
          EntityUser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >>,
    }
  )> };

export type ListReconciliationFlagsQueryVariables = Exact<{
  reconciliationIntentId: Scalars['String']['input'];
  viewKey: ViewKey;
}>;


export type ListReconciliationFlagsQuery = { listReconciliationFlags: Array<(
    Pick<
      ReconciliationFlag,
      | 'flagId'
      | 'flagType'
      | 'reconciliationIntentId'
      | 'createdAt'
      | 'resolvedAt'
      | 'resolutionType'
    >
    & {
      resolvedByUser?: Maybe<Pick<
          EntityUser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >>,
      potentialDuplicateDetails?: Maybe<(
        Pick<PotentialDuplicateFlagDetails, 'transactionFactId' | 'potentialDuplicateTransactionFactId'>
        & {
          transaction: (
            Pick<
              Transaction,
              | 'viewId'
              | 'factId'
              | 'ledgerTransactionId'
              | 'supersededFactIds'
              | 'timestamp'
              | 'recordType'
              | 'name'
              | 'description'
              | 'digitsTransactionType'
              | 'partySource'
              | 'displayEntry'
              | 'displayCategorySource'
              | 'displayCanonicalCategoryName'
              | 'displayUncategorizedReason'
              | 'displayProductArea'
              | 'ownerSource'
              | 'transactionClassificationType'
              | 'compileSource'
              | 'reconciliationStatus'
              | 'referenceNumber'
              | 'taxStatus'
              | 'matchedLedgerTransactionIds'
              | 'providerTypes'
              | 'isSupersedingLedgerTransaction'
              | 'supersededLedgerTransactionIds'
            >
            & {
              party?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              facilitatorParty?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              product?: Maybe<Pick<
                  Product,
                  | 'id'
                  | 'dataSourceId'
                  | 'name'
                  | 'providerType'
                  | 'active'
                  | 'institutionId'
                  | 'institutionName'
                >>,
              department?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitDepartment?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              location?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitLocation?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              providers: Array<Pick<Provider, 'name'>>,
              recurrence?: Maybe<Pick<
                  TransactionRecurrence,
                  | 'recurrenceThreadId'
                  | 'interval'
                  | 'intervalMultiplier'
                  | 'threadIndex'
                  | 'totalThreadCount'
                  | 'isHidden'
                  | 'firstOccurredAt'
                  | 'lastOccurredAt'
                >>,
              displayInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              displayCategory: (
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              ),
              displayCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitCategory?: Maybe<(
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              )>,
              splitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              creditCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              debitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              runningTotal?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              owner?: Maybe<Pick<
                  EntityEmployee,
                  | 'id'
                  | 'organizationId'
                  | 'givenName'
                  | 'familyName'
                  | 'avatarUrl'
                >>,
              sources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              creditSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              debitSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              invoiceLineItem?: Maybe<{ value:
                  | (
                    Pick<
                      TransactionDiscountLineItem,
                      | 'name'
                      | 'description'
                      | 'variablePercentage'
                      | 'appliesToTransactionFactId'
                    >
                    & {
                      fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      discount?: Maybe<(
                        Pick<
                          TransactionInvoiceLineItemDiscount,
                          | 'discountId'
                          | 'name'
                          | 'description'
                          | 'variablePercentage'
                        >
                        & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                      )>,
                    }
                  )
                  | (
                    Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                    & {
                      unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      product?: Maybe<(
                        Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                        & {
                          unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                          category?: Maybe<(
                            Pick<
                              Category,
                              | 'id'
                              | 'name'
                              | 'description'
                              | 'displayKey'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'displayNumber'
                              | 'active'
                              | 'categoryState'
                              | 'productArea'
                              | 'synthesized'
                            >
                            & { ancestors?: Maybe<Array<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>> }
                          )>,
                          department?: Maybe<(
                            { __typename: 'EntityDepartment' }
                            & Pick<
                              EntityDepartment,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                          location?: Maybe<(
                            { __typename: 'EntityLocation' }
                            & Pick<
                              EntityLocation,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                        }
                      )>,
                    }
                  )
                 }>,
              schedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                  | 'cutoverDate'
                >
                & {
                  amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
              splitSchedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                  | 'cutoverDate'
                >
                & {
                  amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
            }
          ),
          potentialDuplicateTransaction: (
            Pick<
              Transaction,
              | 'viewId'
              | 'factId'
              | 'ledgerTransactionId'
              | 'supersededFactIds'
              | 'timestamp'
              | 'recordType'
              | 'name'
              | 'description'
              | 'digitsTransactionType'
              | 'partySource'
              | 'displayEntry'
              | 'displayCategorySource'
              | 'displayCanonicalCategoryName'
              | 'displayUncategorizedReason'
              | 'displayProductArea'
              | 'ownerSource'
              | 'transactionClassificationType'
              | 'compileSource'
              | 'reconciliationStatus'
              | 'referenceNumber'
              | 'taxStatus'
              | 'matchedLedgerTransactionIds'
              | 'providerTypes'
              | 'isSupersedingLedgerTransaction'
              | 'supersededLedgerTransactionIds'
            >
            & {
              party?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              facilitatorParty?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              product?: Maybe<Pick<
                  Product,
                  | 'id'
                  | 'dataSourceId'
                  | 'name'
                  | 'providerType'
                  | 'active'
                  | 'institutionId'
                  | 'institutionName'
                >>,
              department?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitDepartment?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              location?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitLocation?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              providers: Array<Pick<Provider, 'name'>>,
              recurrence?: Maybe<Pick<
                  TransactionRecurrence,
                  | 'recurrenceThreadId'
                  | 'interval'
                  | 'intervalMultiplier'
                  | 'threadIndex'
                  | 'totalThreadCount'
                  | 'isHidden'
                  | 'firstOccurredAt'
                  | 'lastOccurredAt'
                >>,
              displayInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              displayCategory: (
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              ),
              displayCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitCategory?: Maybe<(
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              )>,
              splitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              creditCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              debitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              runningTotal?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              owner?: Maybe<Pick<
                  EntityEmployee,
                  | 'id'
                  | 'organizationId'
                  | 'givenName'
                  | 'familyName'
                  | 'avatarUrl'
                >>,
              sources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              creditSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              debitSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              invoiceLineItem?: Maybe<{ value:
                  | (
                    Pick<
                      TransactionDiscountLineItem,
                      | 'name'
                      | 'description'
                      | 'variablePercentage'
                      | 'appliesToTransactionFactId'
                    >
                    & {
                      fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      discount?: Maybe<(
                        Pick<
                          TransactionInvoiceLineItemDiscount,
                          | 'discountId'
                          | 'name'
                          | 'description'
                          | 'variablePercentage'
                        >
                        & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                      )>,
                    }
                  )
                  | (
                    Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                    & {
                      unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      product?: Maybe<(
                        Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                        & {
                          unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                          category?: Maybe<(
                            Pick<
                              Category,
                              | 'id'
                              | 'name'
                              | 'description'
                              | 'displayKey'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'displayNumber'
                              | 'active'
                              | 'categoryState'
                              | 'productArea'
                              | 'synthesized'
                            >
                            & { ancestors?: Maybe<Array<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>> }
                          )>,
                          department?: Maybe<(
                            { __typename: 'EntityDepartment' }
                            & Pick<
                              EntityDepartment,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                          location?: Maybe<(
                            { __typename: 'EntityLocation' }
                            & Pick<
                              EntityLocation,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                        }
                      )>,
                    }
                  )
                 }>,
              schedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                  | 'cutoverDate'
                >
                & {
                  amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
              splitSchedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                  | 'cutoverDate'
                >
                & {
                  amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
            }
          ),
          statementLineItem: (
            Pick<
              StatementLineItem,
              | 'featureGroupId'
              | 'featureIds'
              | 'date'
              | 'description'
              | 'entryType'
            >
            & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
        }
      )>,
      changeDateDetails?: Maybe<(
        Pick<ChangeDateFlagDetails, 'transactionFactId' | 'suggestedDate'>
        & {
          statementLineItem: (
            Pick<
              StatementLineItem,
              | 'featureGroupId'
              | 'featureIds'
              | 'date'
              | 'description'
              | 'entryType'
            >
            & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          transaction: (
            Pick<
              Transaction,
              | 'viewId'
              | 'factId'
              | 'ledgerTransactionId'
              | 'supersededFactIds'
              | 'timestamp'
              | 'recordType'
              | 'name'
              | 'description'
              | 'digitsTransactionType'
              | 'partySource'
              | 'displayEntry'
              | 'displayCategorySource'
              | 'displayCanonicalCategoryName'
              | 'displayUncategorizedReason'
              | 'displayProductArea'
              | 'ownerSource'
              | 'transactionClassificationType'
              | 'compileSource'
              | 'reconciliationStatus'
              | 'referenceNumber'
              | 'taxStatus'
              | 'matchedLedgerTransactionIds'
              | 'providerTypes'
              | 'isSupersedingLedgerTransaction'
              | 'supersededLedgerTransactionIds'
            >
            & {
              party?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              facilitatorParty?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              product?: Maybe<Pick<
                  Product,
                  | 'id'
                  | 'dataSourceId'
                  | 'name'
                  | 'providerType'
                  | 'active'
                  | 'institutionId'
                  | 'institutionName'
                >>,
              department?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitDepartment?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              location?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitLocation?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              providers: Array<Pick<Provider, 'name'>>,
              recurrence?: Maybe<Pick<
                  TransactionRecurrence,
                  | 'recurrenceThreadId'
                  | 'interval'
                  | 'intervalMultiplier'
                  | 'threadIndex'
                  | 'totalThreadCount'
                  | 'isHidden'
                  | 'firstOccurredAt'
                  | 'lastOccurredAt'
                >>,
              displayInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              displayCategory: (
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              ),
              displayCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitCategory?: Maybe<(
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              )>,
              splitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              creditCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              debitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              runningTotal?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              owner?: Maybe<Pick<
                  EntityEmployee,
                  | 'id'
                  | 'organizationId'
                  | 'givenName'
                  | 'familyName'
                  | 'avatarUrl'
                >>,
              sources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              creditSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              debitSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              invoiceLineItem?: Maybe<{ value:
                  | (
                    Pick<
                      TransactionDiscountLineItem,
                      | 'name'
                      | 'description'
                      | 'variablePercentage'
                      | 'appliesToTransactionFactId'
                    >
                    & {
                      fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      discount?: Maybe<(
                        Pick<
                          TransactionInvoiceLineItemDiscount,
                          | 'discountId'
                          | 'name'
                          | 'description'
                          | 'variablePercentage'
                        >
                        & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                      )>,
                    }
                  )
                  | (
                    Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                    & {
                      unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      product?: Maybe<(
                        Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                        & {
                          unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                          category?: Maybe<(
                            Pick<
                              Category,
                              | 'id'
                              | 'name'
                              | 'description'
                              | 'displayKey'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'displayNumber'
                              | 'active'
                              | 'categoryState'
                              | 'productArea'
                              | 'synthesized'
                            >
                            & { ancestors?: Maybe<Array<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>> }
                          )>,
                          department?: Maybe<(
                            { __typename: 'EntityDepartment' }
                            & Pick<
                              EntityDepartment,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                          location?: Maybe<(
                            { __typename: 'EntityLocation' }
                            & Pick<
                              EntityLocation,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                        }
                      )>,
                    }
                  )
                 }>,
              schedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                  | 'cutoverDate'
                >
                & {
                  amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
              splitSchedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                  | 'cutoverDate'
                >
                & {
                  amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
            }
          ),
        }
      )>,
      potentialMismatchDetails?: Maybe<(
        Pick<PotentialMismatchFlagDetails, 'transactionFactId'>
        & {
          statementLineItem: (
            Pick<
              StatementLineItem,
              | 'featureGroupId'
              | 'featureIds'
              | 'date'
              | 'description'
              | 'entryType'
            >
            & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          transaction: (
            Pick<
              Transaction,
              | 'viewId'
              | 'factId'
              | 'ledgerTransactionId'
              | 'supersededFactIds'
              | 'timestamp'
              | 'recordType'
              | 'name'
              | 'description'
              | 'digitsTransactionType'
              | 'partySource'
              | 'displayEntry'
              | 'displayCategorySource'
              | 'displayCanonicalCategoryName'
              | 'displayUncategorizedReason'
              | 'displayProductArea'
              | 'ownerSource'
              | 'transactionClassificationType'
              | 'compileSource'
              | 'reconciliationStatus'
              | 'referenceNumber'
              | 'taxStatus'
              | 'matchedLedgerTransactionIds'
              | 'providerTypes'
              | 'isSupersedingLedgerTransaction'
              | 'supersededLedgerTransactionIds'
            >
            & {
              party?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              facilitatorParty?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              product?: Maybe<Pick<
                  Product,
                  | 'id'
                  | 'dataSourceId'
                  | 'name'
                  | 'providerType'
                  | 'active'
                  | 'institutionId'
                  | 'institutionName'
                >>,
              department?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitDepartment?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              location?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitLocation?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              providers: Array<Pick<Provider, 'name'>>,
              recurrence?: Maybe<Pick<
                  TransactionRecurrence,
                  | 'recurrenceThreadId'
                  | 'interval'
                  | 'intervalMultiplier'
                  | 'threadIndex'
                  | 'totalThreadCount'
                  | 'isHidden'
                  | 'firstOccurredAt'
                  | 'lastOccurredAt'
                >>,
              displayInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              displayCategory: (
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              ),
              displayCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitCategory?: Maybe<(
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              )>,
              splitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              creditCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              debitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              runningTotal?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              owner?: Maybe<Pick<
                  EntityEmployee,
                  | 'id'
                  | 'organizationId'
                  | 'givenName'
                  | 'familyName'
                  | 'avatarUrl'
                >>,
              sources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              creditSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              debitSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              invoiceLineItem?: Maybe<{ value:
                  | (
                    Pick<
                      TransactionDiscountLineItem,
                      | 'name'
                      | 'description'
                      | 'variablePercentage'
                      | 'appliesToTransactionFactId'
                    >
                    & {
                      fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      discount?: Maybe<(
                        Pick<
                          TransactionInvoiceLineItemDiscount,
                          | 'discountId'
                          | 'name'
                          | 'description'
                          | 'variablePercentage'
                        >
                        & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                      )>,
                    }
                  )
                  | (
                    Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                    & {
                      unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      product?: Maybe<(
                        Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                        & {
                          unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                          category?: Maybe<(
                            Pick<
                              Category,
                              | 'id'
                              | 'name'
                              | 'description'
                              | 'displayKey'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'displayNumber'
                              | 'active'
                              | 'categoryState'
                              | 'productArea'
                              | 'synthesized'
                            >
                            & { ancestors?: Maybe<Array<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>> }
                          )>,
                          department?: Maybe<(
                            { __typename: 'EntityDepartment' }
                            & Pick<
                              EntityDepartment,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                          location?: Maybe<(
                            { __typename: 'EntityLocation' }
                            & Pick<
                              EntityLocation,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                        }
                      )>,
                    }
                  )
                 }>,
              schedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                  | 'cutoverDate'
                >
                & {
                  amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
              splitSchedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                  | 'cutoverDate'
                >
                & {
                  amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
            }
          ),
        }
      )>,
      createNewTransactionDetails?: Maybe<{ statementLineItem: (
          Pick<
            StatementLineItem,
            | 'featureGroupId'
            | 'featureIds'
            | 'date'
            | 'description'
            | 'entryType'
          >
          & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ) }>,
    }
  )> };

export type ListReconciliationHistoryQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  reconciliationId: Scalars['String']['input'];
}>;


export type ListReconciliationHistoryQuery = { listReconciliationHistory: Array<(
    Pick<ReconciliationHistoryEvent, 'reconciliationId' | 'eventType' | 'timestamp'>
    & { user?: Maybe<Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >> }
  )> };

export type ListReconciliationIntentsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  intentCategoryIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  states?: InputMaybe<Array<ReconciliationIntentState> | ReconciliationIntentState>;
  actionItemIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ListReconciliationIntentsQuery = { listReconciliationIntents: Array<Pick<
      ReconciliationIntentDetails,
      | 'reconciliationIntentId'
      | 'documentId'
      | 'state'
      | 'intentCategoryId'
      | 'initiatedByUserId'
      | 'processingEndedAt'
      | 'actionItemId'
      | 'matchedAccountFeatureGroupId'
    >> };

export type ListReconciliationIntentsByReconciliationIdQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  reconciliationId: Scalars['String']['input'];
  states?: InputMaybe<Array<ReconciliationIntentState> | ReconciliationIntentState>;
}>;


export type ListReconciliationIntentsByReconciliationIdQuery = { listReconciliationIntentsByReconciliationId: Array<Pick<
      ReconciliationIntentDetails,
      | 'reconciliationIntentId'
      | 'documentId'
      | 'state'
      | 'intentCategoryId'
      | 'initiatedByUserId'
      | 'processingEndedAt'
      | 'matchedAccountFeatureGroupId'
    >> };

export type ReadAccountReconciliationQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  reconciliationId: Scalars['String']['input'];
  viewKey: ViewKey;
}>;


export type ReadAccountReconciliationQuery = { readAccountReconciliation?: Maybe<(
    Pick<
      ReconciliationDetails,
      | 'normalEntryType'
      | 'maxClassificationUpdatedAt'
      | 'reconciledSystemClassificationsCount'
      | 'unsettledSystemClassificationsCount'
    >
    & {
      reconciliation: (
        Pick<
          AccountReconciliation,
          | 'chartOfAccountsId'
          | 'categoryId'
          | 'reconciliationId'
          | 'status'
          | 'createdAt'
          | 'updatedAt'
        >
        & {
          category: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          startDate: Pick<Date, 'year' | 'month' | 'day'>,
          endDate: Pick<Date, 'year' | 'month' | 'day'>,
          updater?: Maybe<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>,
        }
      ),
      balances: {
          ledgerBalances: {
              debitTotal: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              creditTotal: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              netTotal: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              unsettledTotal: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              closingBalance: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
            },
          statementBalances: {
              debitTotal?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              creditTotal?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              netTotal: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              openingBalance: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              closingBalance: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
            },
          ledgerAccountDifferences: {
              debitDifference?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              creditDifference?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              unreconciledDifference: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
            },
        },
      transactionCounts: Pick<TransactionCounts, 'reconciled' | 'unsettled'>,
    }
  )> };

export type ReadReconciliationDiffQueryVariables = Exact<{
  viewKey: ViewKey;
  reconciliationId: Scalars['String']['input'];
}>;


export type ReadReconciliationDiffQuery = { readReconciliationDiff?: Maybe<(
    Pick<ReconciliationDiff, 'reconciliationId'>
    & {
      toStartDate: Pick<Date, 'year' | 'month' | 'day'>,
      toEndDate: Pick<Date, 'year' | 'month' | 'day'>,
      transactions: Array<(
        Pick<
          ReconciliationDiffTransaction,
          | 'transactionFactId'
          | 'diffReasons'
          | 'fromStatus'
          | 'toStatus'
          | 'fromOccurredAt'
          | 'toOccurredAt'
          | 'fromEntryType'
          | 'toEntryType'
        >
        & {
          transaction?: Maybe<(
            Pick<
              Transaction,
              | 'viewId'
              | 'factId'
              | 'ledgerTransactionId'
              | 'supersededFactIds'
              | 'timestamp'
              | 'recordType'
              | 'name'
              | 'description'
              | 'digitsTransactionType'
              | 'partySource'
              | 'displayEntry'
              | 'displayCategorySource'
              | 'displayCanonicalCategoryName'
              | 'displayUncategorizedReason'
              | 'displayProductArea'
              | 'ownerSource'
              | 'transactionClassificationType'
              | 'compileSource'
              | 'reconciliationStatus'
              | 'referenceNumber'
              | 'taxStatus'
              | 'matchedLedgerTransactionIds'
              | 'providerTypes'
              | 'isSupersedingLedgerTransaction'
              | 'supersededLedgerTransactionIds'
            >
            & {
              party?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              facilitatorParty?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              product?: Maybe<Pick<
                  Product,
                  | 'id'
                  | 'dataSourceId'
                  | 'name'
                  | 'providerType'
                  | 'active'
                  | 'institutionId'
                  | 'institutionName'
                >>,
              department?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitDepartment?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              location?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              splitLocation?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              providers: Array<Pick<Provider, 'name'>>,
              recurrence?: Maybe<Pick<
                  TransactionRecurrence,
                  | 'recurrenceThreadId'
                  | 'interval'
                  | 'intervalMultiplier'
                  | 'threadIndex'
                  | 'totalThreadCount'
                  | 'isHidden'
                  | 'firstOccurredAt'
                  | 'lastOccurredAt'
                >>,
              displayInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              displayCategory: (
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              ),
              displayCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitCategory?: Maybe<(
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              )>,
              splitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              splitInstitution?: Maybe<Pick<
                  TransactionParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'iconObjectName'
                  | 'designation'
                  | 'roles'
                >>,
              creditCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              debitCategoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              runningTotal?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              owner?: Maybe<Pick<
                  EntityEmployee,
                  | 'id'
                  | 'organizationId'
                  | 'givenName'
                  | 'familyName'
                  | 'avatarUrl'
                >>,
              sources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              creditSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              debitSources: Array<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )>,
              invoiceLineItem?: Maybe<{ value:
                  | (
                    Pick<
                      TransactionDiscountLineItem,
                      | 'name'
                      | 'description'
                      | 'variablePercentage'
                      | 'appliesToTransactionFactId'
                    >
                    & {
                      fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      discount?: Maybe<(
                        Pick<
                          TransactionInvoiceLineItemDiscount,
                          | 'discountId'
                          | 'name'
                          | 'description'
                          | 'variablePercentage'
                        >
                        & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                      )>,
                    }
                  )
                  | (
                    Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                    & {
                      unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      product?: Maybe<(
                        Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                        & {
                          unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                          category?: Maybe<(
                            Pick<
                              Category,
                              | 'id'
                              | 'name'
                              | 'description'
                              | 'displayKey'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'displayNumber'
                              | 'active'
                              | 'categoryState'
                              | 'productArea'
                              | 'synthesized'
                            >
                            & { ancestors?: Maybe<Array<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>> }
                          )>,
                          department?: Maybe<(
                            { __typename: 'EntityDepartment' }
                            & Pick<
                              EntityDepartment,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                          location?: Maybe<(
                            { __typename: 'EntityLocation' }
                            & Pick<
                              EntityLocation,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>,
                        }
                      )>,
                    }
                  )
                 }>,
              schedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                  | 'cutoverDate'
                >
                & {
                  amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
              splitSchedule?: Maybe<(
                { __typename: 'EntitySchedule' }
                & Pick<
                  EntitySchedule,
                  | 'id'
                  | 'name'
                  | 'scheduleNumber'
                  | 'scheduleType'
                  | 'scheduleTemplateId'
                  | 'categoryId'
                  | 'relatedCategoryId'
                  | 'partyId'
                  | 'startDate'
                  | 'endDate'
                  | 'cutoverDate'
                >
                & {
                  amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
            }
          )>,
          fromAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          toAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        }
      )>,
    }
  )> };

export type ReadReconciliationFactClassificationQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  transactionFactId: Scalars['String']['input'];
}>;


export type ReadReconciliationFactClassificationQuery = { readReconciliationFactClassification?: Maybe<(
    Pick<TransactionReconciliationClassification, 'classificationVersion' | 'transactionFactId'>
    & { user: Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      > }
  )> };

export type ReadReconciliationPeriodStatsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  viewKey: ViewKey;
  origin: IntervalOrigin;
  direction: DirectionFromOrigin;
}>;


export type ReadReconciliationPeriodStatsQuery = { readReconciliationPeriodStats: Pick<
      ReconciliationPeriodStats,
      | 'notStarted'
      | 'noActivity'
      | 'drafts'
      | 'finalized'
      | 'totalCategories'
    > };

export type ReadReconciliationsPdfsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  documentCollectionId: Scalars['String']['input'];
}>;


export type ReadReconciliationsPdfsQuery = { readReconciliationsPdfs: Pick<
      ReconciliationsPdfs,
      | 'documentCollectionId'
      | 'documentUrls'
      | 'status'
      | 'totalDocumentCount'
      | 'completedDocumentCount'
    > };

export type ActionItemBillApprovalFieldsFragment = { bill: (
    Pick<
      EntityBill,
      | 'id'
      | 'billStatus'
      | 'vendorName'
      | 'billDescription'
    >
    & {
      totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
      format: (
        Pick<Format, 'id' | 'formatClass'>
        & { segments: Array<Pick<
            Segment,
            | 'collectionId'
            | 'fileId'
            | 'sequence'
            | 'token'
          >> }
      ),
      approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
    }
  ) };

export type ActionItemCategoryFieldsFragment = { category: Pick<
      EntityCategory,
      | 'id'
      | 'name'
      | 'displayKey'
      | 'chartOfAccountsDisplayNumber'
      | 'type'
      | 'subtype'
      | 'parentCategoryId'
      | 'productArea'
      | 'active'
    > };

export type ActionItemClosedPeriodRequestFieldsFragment = (
  Pick<ActionItemClosedPeriodRequest, 'requestId' | 'requestType'>
  & { ledgerTransactions: Array<(
    Pick<
      EntityLedgerTransaction,
      | 'id'
      | 'timestamp'
      | 'factIds'
      | 'name'
      | 'referenceNumber'
    >
    & {
      totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      parties: Array<Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        >>,
    }
  )> }
);

export type ActionItemClosedPeriodTransactionRequestFieldsFragment = (
  Pick<ActionItemClosedPeriodTransactionRequest, 'requestId' | 'requestType'>
  & { ledgerTransaction: (
    Pick<
      EntityLedgerTransaction,
      | 'id'
      | 'timestamp'
      | 'factIds'
      | 'name'
      | 'referenceNumber'
    >
    & {
      totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      parties: Array<Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        >>,
    }
  ) }
);

export type ActionItemConnectionFieldsFragment = {
    connection: Pick<EntityConnection, 'id' | 'connectorId' | 'dataSourceId'>,
    dataSource: Pick<
        EntityDataSource,
        | 'id'
        | 'name'
        | 'url'
        | 'iconUrl'
      >,
  };

export type ActionItemsExternalKeySummaryFieldsFragment = Pick<ActionItemsExternalKeySummary, 'externalKey' | 'count'>;

export type ActionItemsGroupSummaryFieldsFragment = Pick<ActionItemsGroupSummary, 'group' | 'count'>;

export type ActionItemsObjectKindSummaryFieldsFragment = Pick<ActionItemsObjectKindSummary, 'objectKind' | 'count'>;

export type ActionItemFieldsFragment = (
  Pick<
    ActionItem,
    | 'id'
    | 'title'
    | 'description'
    | 'status'
    | 'createdAt'
    | 'updatedAt'
    | 'organizationAssigneeIds'
    | 'action'
    | 'objectTimestamp'
    | 'flaggedObjectKinds'
  >
  & {
    author?: Maybe<Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
    userAssignees: Array<Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
    qualityCheck?: Maybe<Pick<QualityCheck, 'id' | 'qualityCheckType'>>,
    value:
      | (
        { __typename: 'ActionItemBillApproval' }
        & { bill: (
          Pick<
            EntityBill,
            | 'id'
            | 'billStatus'
            | 'vendorName'
            | 'billDescription'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
            format: (
              Pick<Format, 'id' | 'formatClass'>
              & { segments: Array<Pick<
                  Segment,
                  | 'collectionId'
                  | 'fileId'
                  | 'sequence'
                  | 'token'
                >> }
            ),
            approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
          }
        ) }
      )
      | (
        { __typename: 'ActionItemCategory' }
        & { category: Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          > }
      )
      | (
        { __typename: 'ActionItemClosedPeriodRequest' }
        & Pick<ActionItemClosedPeriodRequest, 'requestId' | 'requestType'>
        & { ledgerTransactions: Array<(
          Pick<
            EntityLedgerTransaction,
            | 'id'
            | 'timestamp'
            | 'factIds'
            | 'name'
            | 'referenceNumber'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            parties: Array<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
          }
        )> }
      )
      | (
        { __typename: 'ActionItemClosedPeriodTransactionRequest' }
        & Pick<ActionItemClosedPeriodTransactionRequest, 'requestId' | 'requestType'>
        & { ledgerTransaction: (
          Pick<
            EntityLedgerTransaction,
            | 'id'
            | 'timestamp'
            | 'factIds'
            | 'name'
            | 'referenceNumber'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            parties: Array<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
          }
        ) }
      )
      | (
        { __typename: 'ActionItemConnection' }
        & {
          connection: Pick<EntityConnection, 'id' | 'connectorId' | 'dataSourceId'>,
          dataSource: Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >,
        }
      )
      | (
        { __typename: 'ActionItemLedgerTransaction' }
        & { ledgerTransaction: (
          Pick<
            EntityLedgerTransaction,
            | 'id'
            | 'timestamp'
            | 'factIds'
            | 'name'
            | 'referenceNumber'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            parties: Array<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
          }
        ) }
      )
      | (
        { __typename: 'ActionItemParty' }
        & { party: Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          > }
      )
      | (
        { __typename: 'ActionItemPublishedReport' }
        & { package: (
          Pick<
            EntityReportPackage,
            | 'id'
            | 'title'
            | 'authorId'
            | 'interval'
            | 'periodStartedAt'
            | 'periodEndedAt'
            | 'createdAt'
            | 'updatedAt'
            | 'coverUrl'
          >
          & { documents: Array<Pick<
              SharedReportDocumentMetadata,
              | 'id'
              | 'documentObjectId'
              | 'documentObjectVersionId'
              | 'title'
              | 'mimeType'
            >> }
        ) }
      )
      | (
        { __typename: 'ActionItemReconciliation' }
        & {
          reconciliation: (
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          ),
          category: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          flags: Array<Pick<
              ActionItemReconciliationFlag,
              | 'flagId'
              | 'reconciliationIntentId'
              | 'flagType'
              | 'createdAt'
              | 'resolvedAt'
              | 'resolutionType'
            >>,
        }
      )
      | (
        { __typename: 'ActionItemReviewDraftSchedule' }
        & { transaction: (
          Pick<
            EntityTransaction,
            | 'viewId'
            | 'factId'
            | 'timestamp'
            | 'description'
            | 'externalId'
            | 'displayEntry'
          >
          & {
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            party?: Maybe<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
            displayCategory: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            splitCategory?: Maybe<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>,
          }
        ) }
      )
      | (
        { __typename: 'ActionItemReviewImportedSchedule' }
        & Pick<ActionItemReviewImportedSchedule, 'scheduleImportCandidateId'>
      )
      | (
        { __typename: 'ActionItemThread' }
        & Pick<ActionItemThread, 'threadId'>
        & { targetEntity:
          | (
            { __typename: 'EntityBill' }
            & Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )
          | (
            { __typename: 'EntityCategory' }
            & Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >
          )
          | { __typename: 'EntityComment' }
          | { __typename: 'EntityDataSource' }
          | (
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )
          | { __typename: 'EntityIdentityVerification' }
          | { __typename: 'EntityInvoice' }
          | (
            { __typename: 'EntityLedgerTransaction' }
            & Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )
          | { __typename: 'EntityLegalEntity' }
          | (
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )
          | (
            { __typename: 'EntityParty' }
            & Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >
          )
          | { __typename: 'EntityProduct' }
          | (
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )
          | { __typename: 'EntityReport' }
          | (
            { __typename: 'EntityReportPackage' }
            & Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )
          | { __typename: 'EntitySchedule' }
          | { __typename: 'EntityThread' }
          | (
            { __typename: 'EntityTransaction' }
            & Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )
          | { __typename: 'EntityUser' }
          | (
            { __typename: 'EntityWorkItem' }
            & Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )
         }
      )
      | (
        { __typename: 'ActionItemTransaction' }
        & {
          transaction: (
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          ),
          categorySuggestions?: Maybe<Array<Pick<
              CategorySuggestion,
              | 'dataSourceId'
              | 'transactionFactId'
              | 'classificationVersionId'
              | 'categoryId'
              | 'type'
              | 'modelConfidence'
              | 'modelVersionId'
              | 'priority'
              | 'createdAt'
              | 'updatedAt'
            >>>,
        }
      )
      | (
        { __typename: 'ActionItemUploadStatement' }
        & { category: Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          > }
      )
    ,
  }
);

export type ActionItemLedgerTransactionFieldsFragment = { ledgerTransaction: (
    Pick<
      EntityLedgerTransaction,
      | 'id'
      | 'timestamp'
      | 'factIds'
      | 'name'
      | 'referenceNumber'
    >
    & {
      totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      parties: Array<Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        >>,
    }
  ) };

export type ActionItemPartyFieldsFragment = { party: Pick<
      EntityParty,
      | 'id'
      | 'name'
      | 'iconUrl'
      | 'shortDescription'
      | 'roles'
      | 'designation'
    > };

export type ActionItemPublishedReportFieldsFragment = { package: (
    Pick<
      EntityReportPackage,
      | 'id'
      | 'title'
      | 'authorId'
      | 'interval'
      | 'periodStartedAt'
      | 'periodEndedAt'
      | 'createdAt'
      | 'updatedAt'
      | 'coverUrl'
    >
    & { documents: Array<Pick<
        SharedReportDocumentMetadata,
        | 'id'
        | 'documentObjectId'
        | 'documentObjectVersionId'
        | 'title'
        | 'mimeType'
      >> }
  ) };

export type ActionItemReconciliationFieldsFragment = {
    reconciliation: (
      { __typename: 'EntityReconciliation' }
      & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
      & {
        startDate: Pick<Date, 'year' | 'month' | 'day'>,
        endDate: Pick<Date, 'year' | 'month' | 'day'>,
      }
    ),
    category: Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >,
    flags: Array<Pick<
        ActionItemReconciliationFlag,
        | 'flagId'
        | 'reconciliationIntentId'
        | 'flagType'
        | 'createdAt'
        | 'resolvedAt'
        | 'resolutionType'
      >>,
  };

export type ActionItemReconciliationFlagFieldsFragment = Pick<
    ActionItemReconciliationFlag,
    | 'flagId'
    | 'reconciliationIntentId'
    | 'flagType'
    | 'createdAt'
    | 'resolvedAt'
    | 'resolutionType'
  >;

export type ActionItemReviewDraftScheduleFieldsFragment = { transaction: (
    Pick<
      EntityTransaction,
      | 'viewId'
      | 'factId'
      | 'timestamp'
      | 'description'
      | 'externalId'
      | 'displayEntry'
    >
    & {
      moneyFlow: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ),
      party?: Maybe<Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        >>,
      displayCategory: Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >,
      splitCategory?: Maybe<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>,
    }
  ) };

export type ActionItemReviewImportedScheduleFieldsFragment = Pick<ActionItemReviewImportedSchedule, 'scheduleImportCandidateId'>;

export type ActionItemSummaryFieldsFragment = (
  Pick<ActionItemSummary, 'count'>
  & { period: Pick<
      Period,
      | 'name'
      | 'interval'
      | 'startedAt'
      | 'endedAt'
    > }
);

export type ActionItemThreadFieldsFragment = (
  Pick<ActionItemThread, 'threadId'>
  & { targetEntity:
    | (
      { __typename: 'EntityBill' }
      & Pick<
        EntityBill,
        | 'id'
        | 'billStatus'
        | 'vendorName'
        | 'billDescription'
      >
      & {
        totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
        format: (
          Pick<Format, 'id' | 'formatClass'>
          & { segments: Array<Pick<
              Segment,
              | 'collectionId'
              | 'fileId'
              | 'sequence'
              | 'token'
            >> }
        ),
        approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
      }
    )
    | (
      { __typename: 'EntityCategory' }
      & Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >
    )
    | { __typename: 'EntityComment' }
    | { __typename: 'EntityDataSource' }
    | (
      { __typename: 'EntityDepartment' }
      & Pick<
        EntityDepartment,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )
    | { __typename: 'EntityIdentityVerification' }
    | { __typename: 'EntityInvoice' }
    | (
      { __typename: 'EntityLedgerTransaction' }
      & Pick<
        EntityLedgerTransaction,
        | 'id'
        | 'timestamp'
        | 'factIds'
        | 'name'
        | 'referenceNumber'
      >
      & {
        totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        parties: Array<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>,
      }
    )
    | { __typename: 'EntityLegalEntity' }
    | (
      { __typename: 'EntityLocation' }
      & Pick<
        EntityLocation,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )
    | (
      { __typename: 'EntityParty' }
      & Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >
    )
    | { __typename: 'EntityProduct' }
    | (
      { __typename: 'EntityReconciliation' }
      & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
      & {
        startDate: Pick<Date, 'year' | 'month' | 'day'>,
        endDate: Pick<Date, 'year' | 'month' | 'day'>,
      }
    )
    | { __typename: 'EntityReport' }
    | (
      { __typename: 'EntityReportPackage' }
      & Pick<
        EntityReportPackage,
        | 'id'
        | 'title'
        | 'authorId'
        | 'interval'
        | 'periodStartedAt'
        | 'periodEndedAt'
        | 'createdAt'
        | 'updatedAt'
        | 'coverUrl'
      >
      & { documents: Array<Pick<
          SharedReportDocumentMetadata,
          | 'id'
          | 'documentObjectId'
          | 'documentObjectVersionId'
          | 'title'
          | 'mimeType'
        >> }
    )
    | { __typename: 'EntitySchedule' }
    | { __typename: 'EntityThread' }
    | (
      { __typename: 'EntityTransaction' }
      & Pick<
        EntityTransaction,
        | 'viewId'
        | 'factId'
        | 'timestamp'
        | 'description'
        | 'externalId'
        | 'displayEntry'
      >
      & {
        moneyFlow: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        party?: Maybe<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>,
        displayCategory: Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >,
        splitCategory?: Maybe<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>,
      }
    )
    | { __typename: 'EntityUser' }
    | (
      { __typename: 'EntityWorkItem' }
      & Pick<
        EntityWorkItem,
        | 'id'
        | 'time'
        | 'workItemState'
        | 'workItemType'
        | 'reviewCreatedById'
        | 'reviewState'
        | 'ledgerType'
      >
      & { objectTransaction: (
        Pick<
          EntityTransaction,
          | 'viewId'
          | 'factId'
          | 'timestamp'
          | 'description'
          | 'externalId'
          | 'displayEntry'
        >
        & {
          moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          party?: Maybe<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>,
          displayCategory: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          splitCategory?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
        }
      ) }
    )
   }
);

export type ActionItemTransactionFieldsFragment = {
    transaction: (
      Pick<
        EntityTransaction,
        | 'viewId'
        | 'factId'
        | 'timestamp'
        | 'description'
        | 'externalId'
        | 'displayEntry'
      >
      & {
        moneyFlow: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        party?: Maybe<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>,
        displayCategory: Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >,
        splitCategory?: Maybe<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>,
      }
    ),
    categorySuggestions?: Maybe<Array<Pick<
        CategorySuggestion,
        | 'dataSourceId'
        | 'transactionFactId'
        | 'classificationVersionId'
        | 'categoryId'
        | 'type'
        | 'modelConfidence'
        | 'modelVersionId'
        | 'priority'
        | 'createdAt'
        | 'updatedAt'
      >>>,
  };

export type ActionItemUploadStatementFieldsFragment = { category: Pick<
      EntityCategory,
      | 'id'
      | 'name'
      | 'displayKey'
      | 'chartOfAccountsDisplayNumber'
      | 'type'
      | 'subtype'
      | 'parentCategoryId'
      | 'productArea'
      | 'active'
    > };

export type UpdateActionItemAssignmentStatusMutationVariables = Exact<{
  actionItemId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  userAssignees: Array<UserAssignee> | UserAssignee;
  organizationAssignees: Array<OrganizationAssignee> | OrganizationAssignee;
  action?: InputMaybe<ActionItemAction>;
}>;


export type UpdateActionItemAssignmentStatusMutation = Pick<Mutation, 'updateActionItemAssignmentStatus'>;

export type UpdateActionItemStatusMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  actionItems: Array<ActionItemStatusChange> | ActionItemStatusChange;
  action?: InputMaybe<ActionItemAction>;
}>;


export type UpdateActionItemStatusMutation = Pick<Mutation, 'updateActionItemStatus'>;

export type UpdateActionItemWatchStatusMutationVariables = Exact<{
  actionItemId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  watch: Scalars['Boolean']['input'];
  action?: InputMaybe<ActionItemAction>;
}>;


export type UpdateActionItemWatchStatusMutation = Pick<Mutation, 'updateActionItemWatchStatus'>;

export type ListActionItemsQueryVariables = Exact<{
  filter: ActionItemFilter;
  pagination: Pagination;
  viewKey: ViewKey;
  origin?: InputMaybe<IntervalOrigin>;
}>;


export type ListActionItemsQuery = { listActionItems: Array<(
    Pick<
      ActionItem,
      | 'id'
      | 'title'
      | 'description'
      | 'status'
      | 'createdAt'
      | 'updatedAt'
      | 'organizationAssigneeIds'
      | 'action'
      | 'objectTimestamp'
      | 'flaggedObjectKinds'
    >
    & {
      author?: Maybe<Pick<
          EntityUser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >>,
      userAssignees: Array<Pick<
          EntityUser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >>,
      qualityCheck?: Maybe<Pick<QualityCheck, 'id' | 'qualityCheckType'>>,
      value:
        | (
          { __typename: 'ActionItemBillApproval' }
          & { bill: (
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          ) }
        )
        | (
          { __typename: 'ActionItemCategory' }
          & { category: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            > }
        )
        | (
          { __typename: 'ActionItemClosedPeriodRequest' }
          & Pick<ActionItemClosedPeriodRequest, 'requestId' | 'requestType'>
          & { ledgerTransactions: Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )> }
        )
        | (
          { __typename: 'ActionItemClosedPeriodTransactionRequest' }
          & Pick<ActionItemClosedPeriodTransactionRequest, 'requestId' | 'requestType'>
          & { ledgerTransaction: (
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          ) }
        )
        | (
          { __typename: 'ActionItemConnection' }
          & {
            connection: Pick<EntityConnection, 'id' | 'connectorId' | 'dataSourceId'>,
            dataSource: Pick<
                EntityDataSource,
                | 'id'
                | 'name'
                | 'url'
                | 'iconUrl'
              >,
          }
        )
        | (
          { __typename: 'ActionItemLedgerTransaction' }
          & { ledgerTransaction: (
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          ) }
        )
        | (
          { __typename: 'ActionItemParty' }
          & { party: Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            > }
        )
        | (
          { __typename: 'ActionItemPublishedReport' }
          & { package: (
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          ) }
        )
        | (
          { __typename: 'ActionItemReconciliation' }
          & {
            reconciliation: (
              { __typename: 'EntityReconciliation' }
              & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
              & {
                startDate: Pick<Date, 'year' | 'month' | 'day'>,
                endDate: Pick<Date, 'year' | 'month' | 'day'>,
              }
            ),
            category: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            flags: Array<Pick<
                ActionItemReconciliationFlag,
                | 'flagId'
                | 'reconciliationIntentId'
                | 'flagType'
                | 'createdAt'
                | 'resolvedAt'
                | 'resolutionType'
              >>,
          }
        )
        | (
          { __typename: 'ActionItemReviewDraftSchedule' }
          & { transaction: (
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          ) }
        )
        | (
          { __typename: 'ActionItemReviewImportedSchedule' }
          & Pick<ActionItemReviewImportedSchedule, 'scheduleImportCandidateId'>
        )
        | (
          { __typename: 'ActionItemThread' }
          & Pick<ActionItemThread, 'threadId'>
          & { targetEntity:
            | (
              { __typename: 'EntityBill' }
              & Pick<
                EntityBill,
                | 'id'
                | 'billStatus'
                | 'vendorName'
                | 'billDescription'
              >
              & {
                totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
                format: (
                  Pick<Format, 'id' | 'formatClass'>
                  & { segments: Array<Pick<
                      Segment,
                      | 'collectionId'
                      | 'fileId'
                      | 'sequence'
                      | 'token'
                    >> }
                ),
                approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
              }
            )
            | (
              { __typename: 'EntityCategory' }
              & Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >
            )
            | { __typename: 'EntityComment' }
            | { __typename: 'EntityDataSource' }
            | (
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )
            | { __typename: 'EntityIdentityVerification' }
            | { __typename: 'EntityInvoice' }
            | (
              { __typename: 'EntityLedgerTransaction' }
              & Pick<
                EntityLedgerTransaction,
                | 'id'
                | 'timestamp'
                | 'factIds'
                | 'name'
                | 'referenceNumber'
              >
              & {
                totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                parties: Array<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
              }
            )
            | { __typename: 'EntityLegalEntity' }
            | (
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )
            | (
              { __typename: 'EntityParty' }
              & Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >
            )
            | { __typename: 'EntityProduct' }
            | (
              { __typename: 'EntityReconciliation' }
              & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
              & {
                startDate: Pick<Date, 'year' | 'month' | 'day'>,
                endDate: Pick<Date, 'year' | 'month' | 'day'>,
              }
            )
            | { __typename: 'EntityReport' }
            | (
              { __typename: 'EntityReportPackage' }
              & Pick<
                EntityReportPackage,
                | 'id'
                | 'title'
                | 'authorId'
                | 'interval'
                | 'periodStartedAt'
                | 'periodEndedAt'
                | 'createdAt'
                | 'updatedAt'
                | 'coverUrl'
              >
              & { documents: Array<Pick<
                  SharedReportDocumentMetadata,
                  | 'id'
                  | 'documentObjectId'
                  | 'documentObjectVersionId'
                  | 'title'
                  | 'mimeType'
                >> }
            )
            | { __typename: 'EntitySchedule' }
            | { __typename: 'EntityThread' }
            | (
              { __typename: 'EntityTransaction' }
              & Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            )
            | { __typename: 'EntityUser' }
            | (
              { __typename: 'EntityWorkItem' }
              & Pick<
                EntityWorkItem,
                | 'id'
                | 'time'
                | 'workItemState'
                | 'workItemType'
                | 'reviewCreatedById'
                | 'reviewState'
                | 'ledgerType'
              >
              & { objectTransaction: (
                Pick<
                  EntityTransaction,
                  | 'viewId'
                  | 'factId'
                  | 'timestamp'
                  | 'description'
                  | 'externalId'
                  | 'displayEntry'
                >
                & {
                  moneyFlow: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ),
                  party?: Maybe<Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    >>,
                  displayCategory: Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >,
                  splitCategory?: Maybe<Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >>,
                }
              ) }
            )
           }
        )
        | (
          { __typename: 'ActionItemTransaction' }
          & {
            transaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ),
            categorySuggestions?: Maybe<Array<Pick<
                CategorySuggestion,
                | 'dataSourceId'
                | 'transactionFactId'
                | 'classificationVersionId'
                | 'categoryId'
                | 'type'
                | 'modelConfidence'
                | 'modelVersionId'
                | 'priority'
                | 'createdAt'
                | 'updatedAt'
              >>>,
          }
        )
        | (
          { __typename: 'ActionItemUploadStatement' }
          & { category: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            > }
        )
      ,
    }
  )> };

export type ListActionItemsAndBadgeCountQueryVariables = Exact<{
  listFilter: ActionItemFilter;
  pagination: Pagination;
  viewKey: ViewKey;
  direction?: InputMaybe<DirectionFromOrigin>;
  badgeCountFilter: ActionItemFilter;
  legalEntityIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  legalEntities?: InputMaybe<Array<InputMaybe<LegalEntityPermission>> | InputMaybe<LegalEntityPermission>>;
  origin: IntervalOrigin;
}>;


export type ListActionItemsAndBadgeCountQuery = {
    listActionItems: Array<(
      Pick<
        ActionItem,
        | 'id'
        | 'title'
        | 'description'
        | 'status'
        | 'createdAt'
        | 'updatedAt'
        | 'organizationAssigneeIds'
        | 'action'
        | 'objectTimestamp'
        | 'flaggedObjectKinds'
      >
      & {
        author?: Maybe<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>,
        userAssignees: Array<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>,
        qualityCheck?: Maybe<Pick<QualityCheck, 'id' | 'qualityCheckType'>>,
        value:
          | (
            { __typename: 'ActionItemBillApproval' }
            & { bill: (
              Pick<
                EntityBill,
                | 'id'
                | 'billStatus'
                | 'vendorName'
                | 'billDescription'
              >
              & {
                totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
                format: (
                  Pick<Format, 'id' | 'formatClass'>
                  & { segments: Array<Pick<
                      Segment,
                      | 'collectionId'
                      | 'fileId'
                      | 'sequence'
                      | 'token'
                    >> }
                ),
                approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
              }
            ) }
          )
          | (
            { __typename: 'ActionItemCategory' }
            & { category: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              > }
          )
          | (
            { __typename: 'ActionItemClosedPeriodRequest' }
            & Pick<ActionItemClosedPeriodRequest, 'requestId' | 'requestType'>
            & { ledgerTransactions: Array<(
              Pick<
                EntityLedgerTransaction,
                | 'id'
                | 'timestamp'
                | 'factIds'
                | 'name'
                | 'referenceNumber'
              >
              & {
                totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                parties: Array<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
              }
            )> }
          )
          | (
            { __typename: 'ActionItemClosedPeriodTransactionRequest' }
            & Pick<ActionItemClosedPeriodTransactionRequest, 'requestId' | 'requestType'>
            & { ledgerTransaction: (
              Pick<
                EntityLedgerTransaction,
                | 'id'
                | 'timestamp'
                | 'factIds'
                | 'name'
                | 'referenceNumber'
              >
              & {
                totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                parties: Array<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
              }
            ) }
          )
          | (
            { __typename: 'ActionItemConnection' }
            & {
              connection: Pick<EntityConnection, 'id' | 'connectorId' | 'dataSourceId'>,
              dataSource: Pick<
                  EntityDataSource,
                  | 'id'
                  | 'name'
                  | 'url'
                  | 'iconUrl'
                >,
            }
          )
          | (
            { __typename: 'ActionItemLedgerTransaction' }
            & { ledgerTransaction: (
              Pick<
                EntityLedgerTransaction,
                | 'id'
                | 'timestamp'
                | 'factIds'
                | 'name'
                | 'referenceNumber'
              >
              & {
                totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                parties: Array<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
              }
            ) }
          )
          | (
            { __typename: 'ActionItemParty' }
            & { party: Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              > }
          )
          | (
            { __typename: 'ActionItemPublishedReport' }
            & { package: (
              Pick<
                EntityReportPackage,
                | 'id'
                | 'title'
                | 'authorId'
                | 'interval'
                | 'periodStartedAt'
                | 'periodEndedAt'
                | 'createdAt'
                | 'updatedAt'
                | 'coverUrl'
              >
              & { documents: Array<Pick<
                  SharedReportDocumentMetadata,
                  | 'id'
                  | 'documentObjectId'
                  | 'documentObjectVersionId'
                  | 'title'
                  | 'mimeType'
                >> }
            ) }
          )
          | (
            { __typename: 'ActionItemReconciliation' }
            & {
              reconciliation: (
                { __typename: 'EntityReconciliation' }
                & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
                & {
                  startDate: Pick<Date, 'year' | 'month' | 'day'>,
                  endDate: Pick<Date, 'year' | 'month' | 'day'>,
                }
              ),
              category: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              flags: Array<Pick<
                  ActionItemReconciliationFlag,
                  | 'flagId'
                  | 'reconciliationIntentId'
                  | 'flagType'
                  | 'createdAt'
                  | 'resolvedAt'
                  | 'resolutionType'
                >>,
            }
          )
          | (
            { __typename: 'ActionItemReviewDraftSchedule' }
            & { transaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )
          | (
            { __typename: 'ActionItemReviewImportedSchedule' }
            & Pick<ActionItemReviewImportedSchedule, 'scheduleImportCandidateId'>
          )
          | (
            { __typename: 'ActionItemThread' }
            & Pick<ActionItemThread, 'threadId'>
            & { targetEntity:
              | (
                { __typename: 'EntityBill' }
                & Pick<
                  EntityBill,
                  | 'id'
                  | 'billStatus'
                  | 'vendorName'
                  | 'billDescription'
                >
                & {
                  totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
                  format: (
                    Pick<Format, 'id' | 'formatClass'>
                    & { segments: Array<Pick<
                        Segment,
                        | 'collectionId'
                        | 'fileId'
                        | 'sequence'
                        | 'token'
                      >> }
                  ),
                  approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
                }
              )
              | (
                { __typename: 'EntityCategory' }
                & Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >
              )
              | { __typename: 'EntityComment' }
              | { __typename: 'EntityDataSource' }
              | (
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )
              | { __typename: 'EntityIdentityVerification' }
              | { __typename: 'EntityInvoice' }
              | (
                { __typename: 'EntityLedgerTransaction' }
                & Pick<
                  EntityLedgerTransaction,
                  | 'id'
                  | 'timestamp'
                  | 'factIds'
                  | 'name'
                  | 'referenceNumber'
                >
                & {
                  totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  parties: Array<Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    >>,
                }
              )
              | { __typename: 'EntityLegalEntity' }
              | (
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )
              | (
                { __typename: 'EntityParty' }
                & Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >
              )
              | { __typename: 'EntityProduct' }
              | (
                { __typename: 'EntityReconciliation' }
                & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
                & {
                  startDate: Pick<Date, 'year' | 'month' | 'day'>,
                  endDate: Pick<Date, 'year' | 'month' | 'day'>,
                }
              )
              | { __typename: 'EntityReport' }
              | (
                { __typename: 'EntityReportPackage' }
                & Pick<
                  EntityReportPackage,
                  | 'id'
                  | 'title'
                  | 'authorId'
                  | 'interval'
                  | 'periodStartedAt'
                  | 'periodEndedAt'
                  | 'createdAt'
                  | 'updatedAt'
                  | 'coverUrl'
                >
                & { documents: Array<Pick<
                    SharedReportDocumentMetadata,
                    | 'id'
                    | 'documentObjectId'
                    | 'documentObjectVersionId'
                    | 'title'
                    | 'mimeType'
                  >> }
              )
              | { __typename: 'EntitySchedule' }
              | { __typename: 'EntityThread' }
              | (
                { __typename: 'EntityTransaction' }
                & Pick<
                  EntityTransaction,
                  | 'viewId'
                  | 'factId'
                  | 'timestamp'
                  | 'description'
                  | 'externalId'
                  | 'displayEntry'
                >
                & {
                  moneyFlow: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ),
                  party?: Maybe<Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    >>,
                  displayCategory: Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >,
                  splitCategory?: Maybe<Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >>,
                }
              )
              | { __typename: 'EntityUser' }
              | (
                { __typename: 'EntityWorkItem' }
                & Pick<
                  EntityWorkItem,
                  | 'id'
                  | 'time'
                  | 'workItemState'
                  | 'workItemType'
                  | 'reviewCreatedById'
                  | 'reviewState'
                  | 'ledgerType'
                >
                & { objectTransaction: (
                  Pick<
                    EntityTransaction,
                    | 'viewId'
                    | 'factId'
                    | 'timestamp'
                    | 'description'
                    | 'externalId'
                    | 'displayEntry'
                  >
                  & {
                    moneyFlow: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ),
                    party?: Maybe<Pick<
                        EntityParty,
                        | 'id'
                        | 'name'
                        | 'iconUrl'
                        | 'shortDescription'
                        | 'roles'
                        | 'designation'
                      >>,
                    displayCategory: Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >,
                    splitCategory?: Maybe<Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >>,
                  }
                ) }
              )
             }
          )
          | (
            { __typename: 'ActionItemTransaction' }
            & {
              transaction: (
                Pick<
                  EntityTransaction,
                  | 'viewId'
                  | 'factId'
                  | 'timestamp'
                  | 'description'
                  | 'externalId'
                  | 'displayEntry'
                >
                & {
                  moneyFlow: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ),
                  party?: Maybe<Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    >>,
                  displayCategory: Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >,
                  splitCategory?: Maybe<Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >>,
                }
              ),
              categorySuggestions?: Maybe<Array<Pick<
                  CategorySuggestion,
                  | 'dataSourceId'
                  | 'transactionFactId'
                  | 'classificationVersionId'
                  | 'categoryId'
                  | 'type'
                  | 'modelConfidence'
                  | 'modelVersionId'
                  | 'priority'
                  | 'createdAt'
                  | 'updatedAt'
                >>>,
            }
          )
          | (
            { __typename: 'ActionItemUploadStatement' }
            & { category: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              > }
          )
        ,
      }
    )>,
    listActionItemsBadgeCounts: Array<Pick<LegalEntityBadgeCount, 'legalEntityId' | 'count'>>,
  };

export type ListSimilarActionItemsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  items: Array<SimilarActionItem> | SimilarActionItem;
}>;


export type ListSimilarActionItemsQuery = Pick<Query, 'listSimilarActionItems'>;

export type ReadActionItemQueryVariables = Exact<{
  actionItemId: Scalars['String']['input'];
  viewKey: ViewKey;
}>;


export type ReadActionItemQuery = { readActionItem: (
    Pick<
      ActionItem,
      | 'id'
      | 'title'
      | 'description'
      | 'status'
      | 'createdAt'
      | 'updatedAt'
      | 'organizationAssigneeIds'
      | 'action'
      | 'objectTimestamp'
      | 'flaggedObjectKinds'
    >
    & {
      author?: Maybe<Pick<
          EntityUser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >>,
      userAssignees: Array<Pick<
          EntityUser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >>,
      qualityCheck?: Maybe<Pick<QualityCheck, 'id' | 'qualityCheckType'>>,
      value:
        | (
          { __typename: 'ActionItemBillApproval' }
          & { bill: (
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          ) }
        )
        | (
          { __typename: 'ActionItemCategory' }
          & { category: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            > }
        )
        | (
          { __typename: 'ActionItemClosedPeriodRequest' }
          & Pick<ActionItemClosedPeriodRequest, 'requestId' | 'requestType'>
          & { ledgerTransactions: Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )> }
        )
        | (
          { __typename: 'ActionItemClosedPeriodTransactionRequest' }
          & Pick<ActionItemClosedPeriodTransactionRequest, 'requestId' | 'requestType'>
          & { ledgerTransaction: (
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          ) }
        )
        | (
          { __typename: 'ActionItemConnection' }
          & {
            connection: Pick<EntityConnection, 'id' | 'connectorId' | 'dataSourceId'>,
            dataSource: Pick<
                EntityDataSource,
                | 'id'
                | 'name'
                | 'url'
                | 'iconUrl'
              >,
          }
        )
        | (
          { __typename: 'ActionItemLedgerTransaction' }
          & { ledgerTransaction: (
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          ) }
        )
        | (
          { __typename: 'ActionItemParty' }
          & { party: Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            > }
        )
        | (
          { __typename: 'ActionItemPublishedReport' }
          & { package: (
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          ) }
        )
        | (
          { __typename: 'ActionItemReconciliation' }
          & {
            reconciliation: (
              { __typename: 'EntityReconciliation' }
              & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
              & {
                startDate: Pick<Date, 'year' | 'month' | 'day'>,
                endDate: Pick<Date, 'year' | 'month' | 'day'>,
              }
            ),
            category: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            flags: Array<Pick<
                ActionItemReconciliationFlag,
                | 'flagId'
                | 'reconciliationIntentId'
                | 'flagType'
                | 'createdAt'
                | 'resolvedAt'
                | 'resolutionType'
              >>,
          }
        )
        | (
          { __typename: 'ActionItemReviewDraftSchedule' }
          & { transaction: (
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          ) }
        )
        | (
          { __typename: 'ActionItemReviewImportedSchedule' }
          & Pick<ActionItemReviewImportedSchedule, 'scheduleImportCandidateId'>
        )
        | (
          { __typename: 'ActionItemThread' }
          & Pick<ActionItemThread, 'threadId'>
          & { targetEntity:
            | (
              { __typename: 'EntityBill' }
              & Pick<
                EntityBill,
                | 'id'
                | 'billStatus'
                | 'vendorName'
                | 'billDescription'
              >
              & {
                totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
                format: (
                  Pick<Format, 'id' | 'formatClass'>
                  & { segments: Array<Pick<
                      Segment,
                      | 'collectionId'
                      | 'fileId'
                      | 'sequence'
                      | 'token'
                    >> }
                ),
                approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
              }
            )
            | (
              { __typename: 'EntityCategory' }
              & Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >
            )
            | { __typename: 'EntityComment' }
            | { __typename: 'EntityDataSource' }
            | (
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )
            | { __typename: 'EntityIdentityVerification' }
            | { __typename: 'EntityInvoice' }
            | (
              { __typename: 'EntityLedgerTransaction' }
              & Pick<
                EntityLedgerTransaction,
                | 'id'
                | 'timestamp'
                | 'factIds'
                | 'name'
                | 'referenceNumber'
              >
              & {
                totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                parties: Array<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
              }
            )
            | { __typename: 'EntityLegalEntity' }
            | (
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )
            | (
              { __typename: 'EntityParty' }
              & Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >
            )
            | { __typename: 'EntityProduct' }
            | (
              { __typename: 'EntityReconciliation' }
              & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
              & {
                startDate: Pick<Date, 'year' | 'month' | 'day'>,
                endDate: Pick<Date, 'year' | 'month' | 'day'>,
              }
            )
            | { __typename: 'EntityReport' }
            | (
              { __typename: 'EntityReportPackage' }
              & Pick<
                EntityReportPackage,
                | 'id'
                | 'title'
                | 'authorId'
                | 'interval'
                | 'periodStartedAt'
                | 'periodEndedAt'
                | 'createdAt'
                | 'updatedAt'
                | 'coverUrl'
              >
              & { documents: Array<Pick<
                  SharedReportDocumentMetadata,
                  | 'id'
                  | 'documentObjectId'
                  | 'documentObjectVersionId'
                  | 'title'
                  | 'mimeType'
                >> }
            )
            | { __typename: 'EntitySchedule' }
            | { __typename: 'EntityThread' }
            | (
              { __typename: 'EntityTransaction' }
              & Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            )
            | { __typename: 'EntityUser' }
            | (
              { __typename: 'EntityWorkItem' }
              & Pick<
                EntityWorkItem,
                | 'id'
                | 'time'
                | 'workItemState'
                | 'workItemType'
                | 'reviewCreatedById'
                | 'reviewState'
                | 'ledgerType'
              >
              & { objectTransaction: (
                Pick<
                  EntityTransaction,
                  | 'viewId'
                  | 'factId'
                  | 'timestamp'
                  | 'description'
                  | 'externalId'
                  | 'displayEntry'
                >
                & {
                  moneyFlow: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ),
                  party?: Maybe<Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    >>,
                  displayCategory: Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >,
                  splitCategory?: Maybe<Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >>,
                }
              ) }
            )
           }
        )
        | (
          { __typename: 'ActionItemTransaction' }
          & {
            transaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ),
            categorySuggestions?: Maybe<Array<Pick<
                CategorySuggestion,
                | 'dataSourceId'
                | 'transactionFactId'
                | 'classificationVersionId'
                | 'categoryId'
                | 'type'
                | 'modelConfidence'
                | 'modelVersionId'
                | 'priority'
                | 'createdAt'
                | 'updatedAt'
              >>>,
          }
        )
        | (
          { __typename: 'ActionItemUploadStatement' }
          & { category: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            > }
        )
      ,
    }
  ) };

export type SummarizeActionItemsByExternalKeyQueryVariables = Exact<{
  filter: ActionItemFilter;
  legalEntityId: Scalars['String']['input'];
  origin?: InputMaybe<IntervalOrigin>;
}>;


export type SummarizeActionItemsByExternalKeyQuery = { summarizeActionItemsByExternalKey: Array<Pick<ActionItemsExternalKeySummary, 'externalKey' | 'count'>> };

export type SummarizeActionItemsByGroupQueryVariables = Exact<{
  filter: ActionItemFilter;
  legalEntityId: Scalars['String']['input'];
  origin?: InputMaybe<IntervalOrigin>;
}>;


export type SummarizeActionItemsByGroupQuery = { summarizeActionItemsByGroup: Array<Pick<ActionItemsGroupSummary, 'group' | 'count'>> };

export type SummarizeActionItemsByObjectKindQueryVariables = Exact<{
  filter: ActionItemFilter;
  legalEntityId: Scalars['String']['input'];
  origin?: InputMaybe<IntervalOrigin>;
}>;


export type SummarizeActionItemsByObjectKindQuery = { summarizeActionItemsByObjectKind: Array<Pick<ActionItemsObjectKindSummary, 'objectKind' | 'count'>> };

export type SummarizeActionItemsByTimeQueryVariables = Exact<{
  filter: ActionItemFilter;
  viewKey: ViewKey;
  origin: IntervalOrigin;
}>;


export type SummarizeActionItemsByTimeQuery = { summarizeActionItemsByTime: Array<(
    Pick<ActionItemSummary, 'count'>
    & { period: Pick<
        Period,
        | 'name'
        | 'interval'
        | 'startedAt'
        | 'endedAt'
      > }
  )> };

export type SummarizeClosedPeriodActionItemSectionsQueryVariables = Exact<{
  dateChangesFilter: ActionItemFilter;
  transactionCreatesFilter: ActionItemFilter;
  existingTransactionsFilter: ActionItemFilter;
  matchRequestsFilter: ActionItemFilter;
  legalEntityId: Scalars['String']['input'];
}>;


export type SummarizeClosedPeriodActionItemSectionsQuery = {
    dateChanges: Array<Pick<ActionItemsGroupSummary, 'group' | 'count'>>,
    transactionCreates: Array<Pick<ActionItemsGroupSummary, 'group' | 'count'>>,
    existingTransactions: Array<Pick<ActionItemsGroupSummary, 'group' | 'count'>>,
    matchRequests: Array<Pick<ActionItemsGroupSummary, 'group' | 'count'>>,
  };

export type ActivityEventFieldsFragment = (
  Pick<ActivityEvent, 'id' | 'legalEntityId' | 'occurredAt'>
  & { discreteEvent?: Maybe<(
    Pick<DiscreteEvent, 'kind' | 'actorUserId' | 'targetEmailAddress'>
    & {
      target: Pick<ActivityObjectIdentifier, 'kind' | 'id' | 'context'>,
      subject: Pick<ActivityObjectIdentifier, 'kind' | 'id' | 'context'>,
    }
  )> }
);

export type ActivityFeedFieldsFragment = {
    events: Array<(
      Pick<ActivityEvent, 'id' | 'legalEntityId' | 'occurredAt'>
      & { discreteEvent?: Maybe<(
        Pick<DiscreteEvent, 'kind' | 'actorUserId' | 'targetEmailAddress'>
        & {
          target: Pick<ActivityObjectIdentifier, 'kind' | 'id' | 'context'>,
          subject: Pick<ActivityObjectIdentifier, 'kind' | 'id' | 'context'>,
        }
      )> }
    )>,
    entities: (
      { __typename: 'ObjectEntities' }
      & {
        users?: Maybe<Array<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>>,
        transactions?: Maybe<Array<(
          Pick<
            EntityTransaction,
            | 'viewId'
            | 'factId'
            | 'timestamp'
            | 'description'
            | 'externalId'
            | 'displayEntry'
          >
          & {
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            party?: Maybe<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
            displayCategory: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            splitCategory?: Maybe<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>,
          }
        )>>,
        comments?: Maybe<Array<Pick<
            EntityComment,
            | 'id'
            | 'authorId'
            | 'text'
            | 'timestamp'
          >>>,
        reports?: Maybe<Array<(
          Pick<
            EntityReport,
            | 'id'
            | 'title'
            | 'authorId'
            | 'mimeType'
            | 'createdAt'
          >
          & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
        )>>,
        reportPackages?: Maybe<Array<(
          Pick<
            EntityReportPackage,
            | 'id'
            | 'title'
            | 'authorId'
            | 'interval'
            | 'periodStartedAt'
            | 'periodEndedAt'
            | 'createdAt'
            | 'updatedAt'
            | 'coverUrl'
          >
          & { documents: Array<Pick<
              SharedReportDocumentMetadata,
              | 'id'
              | 'documentObjectId'
              | 'documentObjectVersionId'
              | 'title'
              | 'mimeType'
            >> }
        )>>,
        parties?: Maybe<Array<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>>,
        datasources?: Maybe<Array<Pick<
            EntityDataSource,
            | 'id'
            | 'name'
            | 'url'
            | 'iconUrl'
          >>>,
        categories?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>>,
        threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
        legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
        workItems?: Maybe<Array<(
          Pick<
            EntityWorkItem,
            | 'id'
            | 'time'
            | 'workItemState'
            | 'workItemType'
            | 'reviewCreatedById'
            | 'reviewState'
            | 'ledgerType'
          >
          & { objectTransaction: (
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          ) }
        )>>,
        invoices?: Maybe<Array<(
          Pick<
            EntityInvoice,
            | 'id'
            | 'externalDisplayId'
            | 'createdAt'
            | 'dueAt'
          >
          & {
            amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            customer: (
              Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
              & { party: Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                > }
            ),
          }
        )>>,
        bills?: Maybe<Array<(
          Pick<
            EntityBill,
            | 'id'
            | 'billStatus'
            | 'vendorName'
            | 'billDescription'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
            format: (
              Pick<Format, 'id' | 'formatClass'>
              & { segments: Array<Pick<
                  Segment,
                  | 'collectionId'
                  | 'fileId'
                  | 'sequence'
                  | 'token'
                >> }
            ),
            approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
          }
        )>>,
        identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
        departments?: Maybe<Array<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        locations?: Maybe<Array<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        reconciliations?: Maybe<Array<(
          { __typename: 'EntityReconciliation' }
          & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
          & {
            startDate: Pick<Date, 'year' | 'month' | 'day'>,
            endDate: Pick<Date, 'year' | 'month' | 'day'>,
          }
        )>>,
        ledgerTransactions?: Maybe<Array<(
          Pick<
            EntityLedgerTransaction,
            | 'id'
            | 'timestamp'
            | 'factIds'
            | 'name'
            | 'referenceNumber'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            parties: Array<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
          }
        )>>,
        schedules?: Maybe<Array<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
            | 'cutoverDate'
          >
          & {
            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>>,
      }
    ),
  };

export type DiscreteEventFieldsFragment = (
  Pick<DiscreteEvent, 'kind' | 'actorUserId' | 'targetEmailAddress'>
  & {
    target: Pick<ActivityObjectIdentifier, 'kind' | 'id' | 'context'>,
    subject: Pick<ActivityObjectIdentifier, 'kind' | 'id' | 'context'>,
  }
);

export type ReadActivityFeedQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  identifier?: InputMaybe<InputObjectIdentifier>;
  pagination: Pagination;
}>;


export type ReadActivityFeedQuery = { activityFeed: {
      events: Array<(
        Pick<ActivityEvent, 'id' | 'legalEntityId' | 'occurredAt'>
        & { discreteEvent?: Maybe<(
          Pick<DiscreteEvent, 'kind' | 'actorUserId' | 'targetEmailAddress'>
          & {
            target: Pick<ActivityObjectIdentifier, 'kind' | 'id' | 'context'>,
            subject: Pick<ActivityObjectIdentifier, 'kind' | 'id' | 'context'>,
          }
        )> }
      )>,
      entities: (
        { __typename: 'ObjectEntities' }
        & {
          users?: Maybe<Array<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>>,
          transactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          comments?: Maybe<Array<Pick<
              EntityComment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
            >>>,
          reports?: Maybe<Array<(
            Pick<
              EntityReport,
              | 'id'
              | 'title'
              | 'authorId'
              | 'mimeType'
              | 'createdAt'
            >
            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
          )>>,
          reportPackages?: Maybe<Array<(
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )>>,
          parties?: Maybe<Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>>,
          datasources?: Maybe<Array<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>>,
          categories?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>>,
          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
          workItems?: Maybe<Array<(
            Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )>>,
          invoices?: Maybe<Array<(
            Pick<
              EntityInvoice,
              | 'id'
              | 'externalDisplayId'
              | 'createdAt'
              | 'dueAt'
            >
            & {
              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              customer: (
                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                & { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              ),
            }
          )>>,
          bills?: Maybe<Array<(
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )>>,
          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
          departments?: Maybe<Array<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          locations?: Maybe<Array<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          reconciliations?: Maybe<Array<(
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )>>,
          ledgerTransactions?: Maybe<Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )>>,
          schedules?: Maybe<Array<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>>,
        }
      ),
    } };

export type AffiliateOrganizationFieldsFragment = (
  Pick<AffiliateOrganization, 'type'>
  & {
    organization: (
      Pick<
        Organization,
        | 'id'
        | 'slug'
        | 'name'
        | 'iconUrl'
        | 'websiteUrl'
        | 'kind'
      >
      & { branding?: Maybe<Pick<
          OrganizationBranding,
          | 'id'
          | 'organizationId'
          | 'headerColor'
          | 'headerTextColor'
        >> }
    ),
    affiliatedUsers: Array<{
        user: (
          Pick<
            User,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'primaryEmailAddress'
            | 'passwordSet'
            | 'avatarUrl'
            | 'createdAt'
            | 'lastActivityAt'
          >
          & {
            employments?: Maybe<Array<(
              Pick<OrganizationEmployment, 'employeeId'>
              & {
                role: Pick<Role, 'id'>,
                organization: Pick<
                    Organization,
                    | 'id'
                    | 'slug'
                    | 'name'
                    | 'iconUrl'
                    | 'websiteUrl'
                    | 'kind'
                  >,
                legalEntityRoles?: Maybe<Array<(
                  Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                  & { role?: Maybe<Pick<Role, 'id'>> }
                )>>,
              }
            )>>,
            identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
          }
        ),
        role: Pick<Role, 'id'>,
      }>,
  }
);

export type AffiliateOrganizationsFieldsFragment = {
    organizations: Array<(
      Pick<AffiliateOrganization, 'type'>
      & {
        organization: (
          Pick<
            Organization,
            | 'id'
            | 'slug'
            | 'name'
            | 'iconUrl'
            | 'websiteUrl'
            | 'kind'
          >
          & { branding?: Maybe<Pick<
              OrganizationBranding,
              | 'id'
              | 'organizationId'
              | 'headerColor'
              | 'headerTextColor'
            >> }
        ),
        affiliatedUsers: Array<{
            user: (
              Pick<
                User,
                | 'id'
                | 'givenName'
                | 'familyName'
                | 'primaryEmailAddress'
                | 'passwordSet'
                | 'avatarUrl'
                | 'createdAt'
                | 'lastActivityAt'
              >
              & {
                employments?: Maybe<Array<(
                  Pick<OrganizationEmployment, 'employeeId'>
                  & {
                    role: Pick<Role, 'id'>,
                    organization: Pick<
                        Organization,
                        | 'id'
                        | 'slug'
                        | 'name'
                        | 'iconUrl'
                        | 'websiteUrl'
                        | 'kind'
                      >,
                    legalEntityRoles?: Maybe<Array<(
                      Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                      & { role?: Maybe<Pick<Role, 'id'>> }
                    )>>,
                  }
                )>>,
                identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
              }
            ),
            role: Pick<Role, 'id'>,
          }>,
      }
    )>,
    inviteProposals: Array<(
      Pick<
        InvitationProposal,
        | 'proposalId'
        | 'proposalType'
        | 'status'
        | 'invitationId'
        | 'organizationTemplateId'
        | 'createdAt'
      >
      & {
        legalEntity?: Maybe<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>,
        organization?: Maybe<Pick<
            EntityOrganization,
            | 'id'
            | 'name'
            | 'slug'
            | 'iconUrl'
          >>,
        sender?: Maybe<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>,
        recipient?: Maybe<Pick<
            Contact,
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>,
      }
    )>,
  };

export type AffiliateUserFieldsFragment = {
    user: (
      Pick<
        User,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'primaryEmailAddress'
        | 'passwordSet'
        | 'avatarUrl'
        | 'createdAt'
        | 'lastActivityAt'
      >
      & {
        employments?: Maybe<Array<(
          Pick<OrganizationEmployment, 'employeeId'>
          & {
            role: Pick<Role, 'id'>,
            organization: Pick<
                Organization,
                | 'id'
                | 'slug'
                | 'name'
                | 'iconUrl'
                | 'websiteUrl'
                | 'kind'
              >,
            legalEntityRoles?: Maybe<Array<(
              Pick<EmployeeLegalEntityRole, 'legalEntityId'>
              & { role?: Maybe<Pick<Role, 'id'>> }
            )>>,
          }
        )>>,
        identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
      }
    ),
    role: Pick<Role, 'id'>,
  };

export type DisaffiliateLegalEntityMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  affiliationId: Scalars['String']['input'];
  affiliatedLegalEntityId: Scalars['String']['input'];
  affiliatedOrganizationId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type DisaffiliateLegalEntityMutation = Pick<Mutation, 'disaffiliateLegalEntity'>;

export type RemoveFirmAffiliationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  affiliationId: Scalars['String']['input'];
  affiliatedLegalEntityId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveFirmAffiliationMutation = Pick<Mutation, 'removeFirmAffiliation'>;

export type ListAffiliatesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  affiliateType: AffiliateType;
}>;


export type ListAffiliatesQuery = { listAffiliates: {
      organizations: Array<(
        Pick<AffiliateOrganization, 'type'>
        & {
          organization: (
            Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >
            & { branding?: Maybe<Pick<
                OrganizationBranding,
                | 'id'
                | 'organizationId'
                | 'headerColor'
                | 'headerTextColor'
              >> }
          ),
          affiliatedUsers: Array<{
              user: (
                Pick<
                  User,
                  | 'id'
                  | 'givenName'
                  | 'familyName'
                  | 'primaryEmailAddress'
                  | 'passwordSet'
                  | 'avatarUrl'
                  | 'createdAt'
                  | 'lastActivityAt'
                >
                & {
                  employments?: Maybe<Array<(
                    Pick<OrganizationEmployment, 'employeeId'>
                    & {
                      role: Pick<Role, 'id'>,
                      organization: Pick<
                          Organization,
                          | 'id'
                          | 'slug'
                          | 'name'
                          | 'iconUrl'
                          | 'websiteUrl'
                          | 'kind'
                        >,
                      legalEntityRoles?: Maybe<Array<(
                        Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                        & { role?: Maybe<Pick<Role, 'id'>> }
                      )>>,
                    }
                  )>>,
                  identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
                }
              ),
              role: Pick<Role, 'id'>,
            }>,
        }
      )>,
      inviteProposals: Array<(
        Pick<
          InvitationProposal,
          | 'proposalId'
          | 'proposalType'
          | 'status'
          | 'invitationId'
          | 'organizationTemplateId'
          | 'createdAt'
        >
        & {
          legalEntity?: Maybe<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>,
          organization?: Maybe<Pick<
              EntityOrganization,
              | 'id'
              | 'name'
              | 'slug'
              | 'iconUrl'
            >>,
          sender?: Maybe<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>,
          recipient?: Maybe<Pick<
              Contact,
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>,
        }
      )>,
    } };

export type GenerateExecutiveSummaryQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
}>;


export type GenerateExecutiveSummaryQuery = Pick<Query, 'generateExecutiveSummary'>;

export type AskAssistantSubscriptionVariables = Exact<{
  viewKey: ViewKey;
  threadId?: InputMaybe<Scalars['String']['input']>;
  thread?: InputMaybe<AssistantThread>;
  includeEntities?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AskAssistantSubscription = { askAssistant: (
    Pick<AssistantEvent, 'kind' | 'threadId' | 'suggestions'>
    & {
      comment: (
        { __typename: 'Comment' }
        & Pick<
          Comment,
          | 'id'
          | 'authorId'
          | 'text'
          | 'timestamp'
          | 'editedAt'
          | 'deletedAt'
          | 'reactions'
        >
        & { layoutAttachment?: Maybe<Pick<LayoutAttachment, 'layoutId' | 'legalEntityId'>> }
      ),
      layout?: Maybe<(
        Pick<Layout, 'layoutId' | 'layoutVersionId'>
        & {
          viewKey: Pick<
              ViewIdentifier,
              | 'legalEntityId'
              | 'viewVersion'
              | 'mutationVersion'
              | 'viewType'
            >,
          sections?: Maybe<Array<(
            Pick<LayoutSection, 'sectionId' | 'title'>
            & { rows?: Maybe<Array<(
              Pick<LayoutRow, 'rowId' | 'title'>
              & { components?: Maybe<Array<(
                Pick<LayoutComponent, 'componentId' | 'title' | 'dataId'>
                & { config: (
                  Pick<LayoutComponentConfig, 'type'>
                  & {
                    text?: Maybe<(
                      Pick<TextComponentConfig, 'body'>
                      & {
                        current?: Maybe<Pick<
                            ArchiveIntervalOrigin,
                            | 'interval'
                            | 'year'
                            | 'index'
                            | 'intervalCount'
                            | 'maxTime'
                          >>,
                        lookback?: Maybe<Pick<
                            ArchiveIntervalOrigin,
                            | 'interval'
                            | 'year'
                            | 'index'
                            | 'intervalCount'
                            | 'maxTime'
                          >>,
                        tags?: Maybe<Array<(
                          Pick<TextComponentConfigTag, 'displayText'>
                          & {
                            objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
                            options?: Maybe<Pick<TextTagOptions, 'partyRole'>>,
                          }
                        )>>,
                      }
                    )>,
                    categoryChart?: Maybe<(
                      Pick<CategoryChartConfig, 'categoryId' | 'withoutCategoryAncestors' | 'asPermanent'>
                      & { origin: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        > }
                    )>,
                    partyChart?: Maybe<(
                      Pick<PartyChartConfig, 'partyId' | 'partyRole' | 'asPermanent'>
                      & { origin: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        > }
                    )>,
                    topEntities?: Maybe<(
                      Pick<
                        TopEntitiesConfig,
                        | 'limit'
                        | 'kind'
                        | 'partyRole'
                        | 'categoryType'
                        | 'sort'
                      >
                      & {
                        origin: Pick<
                            ArchiveIntervalOrigin,
                            | 'interval'
                            | 'year'
                            | 'index'
                            | 'intervalCount'
                            | 'maxTime'
                          >,
                        filteredBy?: Maybe<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
                      }
                    )>,
                    topTransactions?: Maybe<(
                      Pick<TopTransactionsConfig, 'limit' | 'partyRole' | 'categoryType'>
                      & {
                        origin: Pick<
                            ArchiveIntervalOrigin,
                            | 'interval'
                            | 'year'
                            | 'index'
                            | 'intervalCount'
                            | 'maxTime'
                          >,
                        filteredBy?: Maybe<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
                      }
                    )>,
                    summaryLineItem?: Maybe<(
                      Pick<SummaryLineItemConfig, 'item'>
                      & { origin: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        > }
                    )>,
                    portalMetric?: Maybe<(
                      Pick<PortalMetricConfig, 'metricType'>
                      & { origin: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        > }
                    )>,
                    entitiesList?: Maybe<{
                        origin: Pick<
                            ArchiveIntervalOrigin,
                            | 'interval'
                            | 'year'
                            | 'index'
                            | 'intervalCount'
                            | 'maxTime'
                          >,
                        entities: (
                          { __typename: 'ObjectEntities' }
                          & {
                            users?: Maybe<Array<Pick<
                                EntityUser,
                                | 'id'
                                | 'givenName'
                                | 'familyName'
                                | 'emailAddress'
                                | 'avatarUrl'
                              >>>,
                            transactions?: Maybe<Array<(
                              Pick<
                                EntityTransaction,
                                | 'viewId'
                                | 'factId'
                                | 'timestamp'
                                | 'description'
                                | 'externalId'
                                | 'displayEntry'
                              >
                              & {
                                moneyFlow: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ),
                                party?: Maybe<Pick<
                                    EntityParty,
                                    | 'id'
                                    | 'name'
                                    | 'iconUrl'
                                    | 'shortDescription'
                                    | 'roles'
                                    | 'designation'
                                  >>,
                                displayCategory: Pick<
                                    EntityCategory,
                                    | 'id'
                                    | 'name'
                                    | 'displayKey'
                                    | 'chartOfAccountsDisplayNumber'
                                    | 'type'
                                    | 'subtype'
                                    | 'parentCategoryId'
                                    | 'productArea'
                                    | 'active'
                                  >,
                                splitCategory?: Maybe<Pick<
                                    EntityCategory,
                                    | 'id'
                                    | 'name'
                                    | 'displayKey'
                                    | 'chartOfAccountsDisplayNumber'
                                    | 'type'
                                    | 'subtype'
                                    | 'parentCategoryId'
                                    | 'productArea'
                                    | 'active'
                                  >>,
                              }
                            )>>,
                            comments?: Maybe<Array<Pick<
                                EntityComment,
                                | 'id'
                                | 'authorId'
                                | 'text'
                                | 'timestamp'
                              >>>,
                            reports?: Maybe<Array<(
                              Pick<
                                EntityReport,
                                | 'id'
                                | 'title'
                                | 'authorId'
                                | 'mimeType'
                                | 'createdAt'
                              >
                              & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
                            )>>,
                            reportPackages?: Maybe<Array<(
                              Pick<
                                EntityReportPackage,
                                | 'id'
                                | 'title'
                                | 'authorId'
                                | 'interval'
                                | 'periodStartedAt'
                                | 'periodEndedAt'
                                | 'createdAt'
                                | 'updatedAt'
                                | 'coverUrl'
                              >
                              & { documents: Array<Pick<
                                  SharedReportDocumentMetadata,
                                  | 'id'
                                  | 'documentObjectId'
                                  | 'documentObjectVersionId'
                                  | 'title'
                                  | 'mimeType'
                                >> }
                            )>>,
                            parties?: Maybe<Array<Pick<
                                EntityParty,
                                | 'id'
                                | 'name'
                                | 'iconUrl'
                                | 'shortDescription'
                                | 'roles'
                                | 'designation'
                              >>>,
                            datasources?: Maybe<Array<Pick<
                                EntityDataSource,
                                | 'id'
                                | 'name'
                                | 'url'
                                | 'iconUrl'
                              >>>,
                            categories?: Maybe<Array<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>>,
                            threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
                            legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
                            workItems?: Maybe<Array<(
                              Pick<
                                EntityWorkItem,
                                | 'id'
                                | 'time'
                                | 'workItemState'
                                | 'workItemType'
                                | 'reviewCreatedById'
                                | 'reviewState'
                                | 'ledgerType'
                              >
                              & { objectTransaction: (
                                Pick<
                                  EntityTransaction,
                                  | 'viewId'
                                  | 'factId'
                                  | 'timestamp'
                                  | 'description'
                                  | 'externalId'
                                  | 'displayEntry'
                                >
                                & {
                                  moneyFlow: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ),
                                  party?: Maybe<Pick<
                                      EntityParty,
                                      | 'id'
                                      | 'name'
                                      | 'iconUrl'
                                      | 'shortDescription'
                                      | 'roles'
                                      | 'designation'
                                    >>,
                                  displayCategory: Pick<
                                      EntityCategory,
                                      | 'id'
                                      | 'name'
                                      | 'displayKey'
                                      | 'chartOfAccountsDisplayNumber'
                                      | 'type'
                                      | 'subtype'
                                      | 'parentCategoryId'
                                      | 'productArea'
                                      | 'active'
                                    >,
                                  splitCategory?: Maybe<Pick<
                                      EntityCategory,
                                      | 'id'
                                      | 'name'
                                      | 'displayKey'
                                      | 'chartOfAccountsDisplayNumber'
                                      | 'type'
                                      | 'subtype'
                                      | 'parentCategoryId'
                                      | 'productArea'
                                      | 'active'
                                    >>,
                                }
                              ) }
                            )>>,
                            invoices?: Maybe<Array<(
                              Pick<
                                EntityInvoice,
                                | 'id'
                                | 'externalDisplayId'
                                | 'createdAt'
                                | 'dueAt'
                              >
                              & {
                                amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                customer: (
                                  Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                                  & { party: Pick<
                                      EntityParty,
                                      | 'id'
                                      | 'name'
                                      | 'iconUrl'
                                      | 'shortDescription'
                                      | 'roles'
                                      | 'designation'
                                    > }
                                ),
                              }
                            )>>,
                            bills?: Maybe<Array<(
                              Pick<
                                EntityBill,
                                | 'id'
                                | 'billStatus'
                                | 'vendorName'
                                | 'billDescription'
                              >
                              & {
                                totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
                                format: (
                                  Pick<Format, 'id' | 'formatClass'>
                                  & { segments: Array<Pick<
                                      Segment,
                                      | 'collectionId'
                                      | 'fileId'
                                      | 'sequence'
                                      | 'token'
                                    >> }
                                ),
                                approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
                              }
                            )>>,
                            identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
                            departments?: Maybe<Array<(
                              { __typename: 'EntityDepartment' }
                              & Pick<
                                EntityDepartment,
                                | 'id'
                                | 'name'
                                | 'parentId'
                                | 'active'
                              >
                            )>>,
                            locations?: Maybe<Array<(
                              { __typename: 'EntityLocation' }
                              & Pick<
                                EntityLocation,
                                | 'id'
                                | 'name'
                                | 'parentId'
                                | 'active'
                              >
                            )>>,
                            reconciliations?: Maybe<Array<(
                              { __typename: 'EntityReconciliation' }
                              & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
                              & {
                                startDate: Pick<Date, 'year' | 'month' | 'day'>,
                                endDate: Pick<Date, 'year' | 'month' | 'day'>,
                              }
                            )>>,
                            ledgerTransactions?: Maybe<Array<(
                              Pick<
                                EntityLedgerTransaction,
                                | 'id'
                                | 'timestamp'
                                | 'factIds'
                                | 'name'
                                | 'referenceNumber'
                              >
                              & {
                                totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                parties: Array<Pick<
                                    EntityParty,
                                    | 'id'
                                    | 'name'
                                    | 'iconUrl'
                                    | 'shortDescription'
                                    | 'roles'
                                    | 'designation'
                                  >>,
                              }
                            )>>,
                            schedules?: Maybe<Array<(
                              { __typename: 'EntitySchedule' }
                              & Pick<
                                EntitySchedule,
                                | 'id'
                                | 'name'
                                | 'scheduleNumber'
                                | 'scheduleType'
                                | 'scheduleTemplateId'
                                | 'categoryId'
                                | 'relatedCategoryId'
                                | 'partyId'
                                | 'startDate'
                                | 'endDate'
                                | 'cutoverDate'
                              >
                              & {
                                amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                                cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                              }
                            )>>,
                          }
                        ),
                      }>,
                    statement?: Maybe<(
                      Pick<StatementConfig, 'kind'>
                      & {
                        origin: Pick<
                            ArchiveIntervalOrigin,
                            | 'interval'
                            | 'year'
                            | 'index'
                            | 'intervalCount'
                            | 'maxTime'
                          >,
                        options?: Maybe<(
                          { __typename: 'ReportDocumentOptions' }
                          & Pick<
                            ReportDocumentOptions,
                            | 'sparklineLookbackPeriods'
                            | 'reportLookbackPeriods'
                            | 'deltaMonthOverMonth'
                            | 'deltaMonthOverMonthPeriods'
                            | 'deltaYearOverYear'
                            | 'comparedToTotal'
                            | 'comparedToIncome'
                            | 'amountPrecision'
                            | 'yearToDate'
                            | 'deltaYearToDate'
                            | 'breakdownByClass'
                          >
                          & {
                            collapsedSections?: Maybe<Pick<CollapsedSections, 'sections'>>,
                            categoryByDepartmentOptions?: Maybe<(
                              Pick<CategoryByDepartmentOptions, 'showOther' | 'showUnassigned'>
                              & { departments?: Maybe<Array<Pick<DepartmentOption, 'departmentId' | 'name'>>> }
                            )>,
                            categoryByLocationOptions?: Maybe<(
                              Pick<CategoryByLocationOptions, 'showOther' | 'showUnassigned'>
                              & { locations?: Maybe<Array<Pick<LocationOption, 'locationId' | 'name'>>> }
                            )>,
                          }
                        )>,
                      }
                    )>,
                    metricChart?: Maybe<(
                      Pick<MetricChartConfig, 'item'>
                      & { origin: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        > }
                    )>,
                    runwayChart?: Maybe<{
                        origin: Pick<
                            ArchiveIntervalOrigin,
                            | 'interval'
                            | 'year'
                            | 'index'
                            | 'intervalCount'
                            | 'maxTime'
                          >,
                        netBurnLookback?: Maybe<Pick<
                            ArchiveIntervalOrigin,
                            | 'interval'
                            | 'year'
                            | 'index'
                            | 'intervalCount'
                            | 'maxTime'
                          >>,
                      }>,
                    cashSummaryChart?: Maybe<{ origin: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        > }>,
                    staticMetric?: Maybe<Pick<StaticMetricConfig, 'name' | 'value' | 'updatedAt'>>,
                    documentCollection?: Maybe<Pick<DocumentCollectionConfig, 'collectionId'>>,
                    insight?: Maybe<{
                        objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
                        options?: Maybe<Pick<InsightComponentConfigOptions, 'partyRole'>>,
                        origin: Pick<
                            ArchiveIntervalOrigin,
                            | 'interval'
                            | 'year'
                            | 'index'
                            | 'intervalCount'
                            | 'maxTime'
                          >,
                        lookback: Pick<
                            ArchiveIntervalOrigin,
                            | 'interval'
                            | 'year'
                            | 'index'
                            | 'intervalCount'
                            | 'maxTime'
                          >,
                      }>,
                    departmentChart?: Maybe<(
                      Pick<DepartmentChartConfig, 'departmentId'>
                      & { origin: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        > }
                    )>,
                    locationChart?: Maybe<(
                      Pick<LocationChartConfig, 'locationId'>
                      & { origin: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        > }
                    )>,
                    sourceAccountMetric?: Maybe<(
                      Pick<SourceAccountMetricConfig, 'key' | 'sourceAccountId' | 'dataSourceId'>
                      & { origin: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        > }
                    )>,
                    agingSummaryChart?: Maybe<(
                      Pick<AgingSummaryChartConfig, 'kind' | 'dimensions' | 'masks'>
                      & { origin: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        > }
                    )>,
                    categoryByDepartmentChart?: Maybe<(
                      Pick<CategoryByDepartmentChartConfig, 'categoryId' | 'departmentIds'>
                      & { origin: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        > }
                    )>,
                    categoryByLocationChart?: Maybe<(
                      Pick<CategoryByLocationChartConfig, 'categoryId' | 'locationIds'>
                      & { origin: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        > }
                    )>,
                  }
                ) }
              )>> }
            )>> }
          )>>,
        }
      )>,
      entities?: Maybe<(
        { __typename: 'ObjectEntities' }
        & {
          users?: Maybe<Array<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>>,
          transactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          comments?: Maybe<Array<Pick<
              EntityComment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
            >>>,
          reports?: Maybe<Array<(
            Pick<
              EntityReport,
              | 'id'
              | 'title'
              | 'authorId'
              | 'mimeType'
              | 'createdAt'
            >
            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
          )>>,
          reportPackages?: Maybe<Array<(
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )>>,
          parties?: Maybe<Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>>,
          datasources?: Maybe<Array<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>>,
          categories?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>>,
          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
          workItems?: Maybe<Array<(
            Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )>>,
          invoices?: Maybe<Array<(
            Pick<
              EntityInvoice,
              | 'id'
              | 'externalDisplayId'
              | 'createdAt'
              | 'dueAt'
            >
            & {
              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              customer: (
                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                & { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              ),
            }
          )>>,
          bills?: Maybe<Array<(
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )>>,
          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
          departments?: Maybe<Array<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          locations?: Maybe<Array<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          reconciliations?: Maybe<Array<(
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )>>,
          ledgerTransactions?: Maybe<Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )>>,
          schedules?: Maybe<Array<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>>,
        }
      )>,
    }
  ) };

export type AuditRuleFieldsFragment = (
  Pick<
    AuditRule,
    | 'auditRuleId'
    | 'name'
    | 'description'
    | 'type'
    | 'action'
    | 'ruleState'
  >
  & {
    amountFilters?: Maybe<Array<(
      Pick<AmountRuleFilter, 'amountRuleFilterId' | 'operator' | 'createdAt'>
      & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    )>>,
    partyFilters?: Maybe<Array<(
      Pick<PartyRuleFilter, 'partyRuleFilterId' | 'operation' | 'createdAt'>
      & { parties: Array<Pick<PartyRuleFilterParty, 'partyId' | 'partyName'>> }
    )>>,
    categoryFilters?: Maybe<Array<(
      Pick<CategoryRuleFilter, 'categoryRuleFilterId' | 'operation' | 'createdAt'>
      & { categories: Array<Pick<CategoryRuleFilterCategory, 'categoryId' | 'categoryName'>> }
    )>>,
  }
);

export type AmountRuleFilterFieldsFragment = (
  Pick<AmountRuleFilter, 'amountRuleFilterId' | 'operator' | 'createdAt'>
  & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
);

export type PartyRuleFilterFieldsFragment = (
  Pick<PartyRuleFilter, 'partyRuleFilterId' | 'operation' | 'createdAt'>
  & { parties: Array<Pick<PartyRuleFilterParty, 'partyId' | 'partyName'>> }
);

export type PartyRuleFilterPartyFieldsFragment = Pick<PartyRuleFilterParty, 'partyId' | 'partyName'>;

export type CategoryRuleFilterFieldsFragment = (
  Pick<CategoryRuleFilter, 'categoryRuleFilterId' | 'operation' | 'createdAt'>
  & { categories: Array<Pick<CategoryRuleFilterCategory, 'categoryId' | 'categoryName'>> }
);

export type CategoryRuleFilterCategoryFieldsFragment = Pick<CategoryRuleFilterCategory, 'categoryId' | 'categoryName'>;

export type AuditRuleStatusFieldsFragment = Pick<AuditRuleStatus, 'type' | 'recentlyUpdated' | 'updaterType'>;

export type UpdateAuditRulesMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  rules: Array<UpdateAuditRule> | UpdateAuditRule;
  isFTE?: InputMaybe<Scalars['Boolean']['input']>;
  usedSuggestedCategories?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateAuditRulesMutation = Pick<Mutation, 'updateAuditRules'>;

export type ListAuditRulesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListAuditRulesQuery = { listAuditRules: Array<(
    Pick<
      AuditRule,
      | 'auditRuleId'
      | 'name'
      | 'description'
      | 'type'
      | 'action'
      | 'ruleState'
    >
    & {
      amountFilters?: Maybe<Array<(
        Pick<AmountRuleFilter, 'amountRuleFilterId' | 'operator' | 'createdAt'>
        & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      )>>,
      partyFilters?: Maybe<Array<(
        Pick<PartyRuleFilter, 'partyRuleFilterId' | 'operation' | 'createdAt'>
        & { parties: Array<Pick<PartyRuleFilterParty, 'partyId' | 'partyName'>> }
      )>>,
      categoryFilters?: Maybe<Array<(
        Pick<CategoryRuleFilter, 'categoryRuleFilterId' | 'operation' | 'createdAt'>
        & { categories: Array<Pick<CategoryRuleFilterCategory, 'categoryId' | 'categoryName'>> }
      )>>,
    }
  )> };

export type BillingProductFieldsFragment = Pick<
    BillingProduct,
    | 'id'
    | 'name'
    | 'displayName'
    | 'description'
    | 'callout'
    | 'trialPeriodDays'
    | 'availability'
    | 'listing'
    | 'billable'
  >;

export type BillingPriceFieldsFragment = (
  Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
  & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
);

export type BillingLegalEntityLimitFieldsFragment = Pick<BillingLegalEntityLimit, 'id' | 'minLegalEntityLimit' | 'maxLegalEntityLimit'>;

export type BillingOperatorFieldsFragment = (
  Pick<BillingOperator, 'organizationId' | 'subscriptionId' | 'activeSubscription'>
  & {
    product: Pick<
        BillingProduct,
        | 'id'
        | 'name'
        | 'displayName'
        | 'description'
        | 'callout'
        | 'trialPeriodDays'
        | 'availability'
        | 'listing'
        | 'billable'
      >,
    trial?: Maybe<Pick<BillingTrial, 'start' | 'end'>>,
    availablePlans: Array<{
        product: Pick<
            BillingProduct,
            | 'id'
            | 'name'
            | 'displayName'
            | 'description'
            | 'callout'
            | 'trialPeriodDays'
            | 'availability'
            | 'listing'
            | 'billable'
          >,
        price: (
          Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
          & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
      }>,
    availableCoupons: Array<(
      Pick<
        Coupon,
        | 'valid'
        | 'percentOff'
        | 'duration'
        | 'durationInMonths'
        | 'stripePromoCodeId'
        | 'start'
        | 'end'
      >
      & { amountOff?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
    )>,
    subscriptionDetails?: Maybe<Pick<SubscriptionDetails, 'status'>>,
  }
);

export type BillingPlanFieldsFragment = {
    product: Pick<
        BillingProduct,
        | 'id'
        | 'name'
        | 'displayName'
        | 'description'
        | 'callout'
        | 'trialPeriodDays'
        | 'availability'
        | 'listing'
        | 'billable'
      >,
    price: (
      Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
      & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    ),
    legalEntityLimit?: Maybe<Pick<BillingLegalEntityLimit, 'id' | 'minLegalEntityLimit' | 'maxLegalEntityLimit'>>,
  };

export type BillingTrialFieldsFragment = Pick<BillingTrial, 'start' | 'end'>;

export type BillingCardDetailsFieldsFragment = Pick<
    BillingCardDetails,
    | 'name'
    | 'brand'
    | 'country'
    | 'expMonth'
    | 'expYear'
    | 'last4'
  >;

export type CouponFieldsFragment = (
  Pick<
    Coupon,
    | 'valid'
    | 'percentOff'
    | 'duration'
    | 'durationInMonths'
    | 'stripePromoCodeId'
    | 'start'
    | 'end'
  >
  & { amountOff?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
);

export type CreateBillingOnboardingSubscriptionFieldsFragment = Pick<BillingSubscriptionWithoutStatus, 'id' | 'periodEnd' | 'periodStart'>;

export type NewAffiliatedBillingSubscriptionFieldsFragment = Pick<NewAffiliatedBillingSubscription, 'customerId' | 'productId' | 'stripeClientSecret'>;

export type NewBillingSubscriptionFieldsFragment = Pick<NewBillingSubscription, 'customerId' | 'stripeClientSecret'>;

export type NewTrialBillingSubscriptionFieldsFragment = Pick<NewTrialBillingSubscription, 'customerId'>;

export type PricePreviewFieldsFragment = {
    total: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    coupons?: Maybe<Array<(
      Pick<
        Coupon,
        | 'valid'
        | 'percentOff'
        | 'duration'
        | 'durationInMonths'
        | 'stripePromoCodeId'
        | 'start'
        | 'end'
      >
      & { amountOff?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
    )>>,
  };

export type SubscriptionDetailsFieldsFragment = Pick<
    SubscriptionDetails,
    | 'startedAt'
    | 'billingCycleStart'
    | 'billingCycleEnd'
    | 'status'
    | 'cancelAt'
  >;

export type AddAffiliatedSubscriptionPriceMutationVariables = Exact<{
  affiliatedLegalEntityId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
}>;


export type AddAffiliatedSubscriptionPriceMutation = Pick<Mutation, 'addAffiliatedSubscriptionPrice'>;

export type AddSubscriptionItemMutationVariables = Exact<{
  payerOrganizationId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
}>;


export type AddSubscriptionItemMutation = Pick<Mutation, 'addSubscriptionItem'>;

export type CancelBillingSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
}>;


export type CancelBillingSubscriptionMutation = Pick<Mutation, 'cancelBillingSubscription'>;

export type ConfirmAccountantClientMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  affiliatedLegalEntityId: Scalars['String']['input'];
  affiliatedOrganizationId: Scalars['String']['input'];
  hasConnections?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ConfirmAccountantClientMutation = Pick<Mutation, 'confirmAccountantClient'>;

export type ConfirmAffiliatedSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  affiliatedLegalEntityId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  stripePaymentMethodId: Scalars['String']['input'];
}>;


export type ConfirmAffiliatedSubscriptionMutation = Pick<Mutation, 'confirmAffiliatedSubscription'>;

export type ConfirmBillingSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  customerId: Scalars['String']['input'];
  stripePaymentMethodId: Scalars['String']['input'];
}>;


export type ConfirmBillingSubscriptionMutation = Pick<Mutation, 'confirmBillingSubscription'>;

export type ConfirmClientPaysMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type ConfirmClientPaysMutation = Pick<Mutation, 'confirmClientPays'>;

export type CreateAffiliatedSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  affiliatedLegalEntityId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  promoCodeId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId: Scalars['String']['input'];
}>;


export type CreateAffiliatedSubscriptionMutation = { createAffiliatedSubscription?: Maybe<Pick<NewAffiliatedBillingSubscription, 'customerId' | 'productId' | 'stripeClientSecret'>> };

export type CreateBillingOnboardingSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  productName?: InputMaybe<BillingProductName>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateBillingOnboardingSubscriptionMutation = { createBillingOnboardingSubscription: Pick<BillingSubscriptionWithoutStatus, 'id' | 'periodEnd' | 'periodStart'> };

export type CreateBillingSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateBillingSubscriptionMutation = { createBillingSubscription: Pick<NewBillingSubscription, 'customerId' | 'stripeClientSecret'> };

export type CreateClientPaysSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  promoCodeId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId: Scalars['String']['input'];
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateClientPaysSubscriptionMutation = { createClientPaysSubscription: Pick<CreateClientPaysBillingSubscription, 'stripeClientSecret' | 'customerId' | 'productId'> };

export type ProvisionClientPaysSubscriptionMutationVariables = Exact<{
  firmOrganizationId: Scalars['String']['input'];
  affiliatedOrganizationId: Scalars['String']['input'];
  affiliatedLegalEntityId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type ProvisionClientPaysSubscriptionMutation = Pick<Mutation, 'provisionClientPaysSubscription'>;

export type ProvisionTrialBillingSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  stripePaymentMethodId: Scalars['String']['input'];
  promoCodeId?: InputMaybe<Scalars['String']['input']>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProvisionTrialBillingSubscriptionMutation = { provisionTrialBillingSubscription: Pick<NewTrialBillingSubscription, 'customerId'> };

export type SetupSubscriptionMutationVariables = Exact<{
  payerOrganizationId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  stripePaymentMethodId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  stripePromoCodeId?: InputMaybe<Scalars['String']['input']>;
  trial: SetupSubscriptionTrial;
}>;


export type SetupSubscriptionMutation = { setupSubscription: (
    Pick<SetupSubscriptionResult, 'stripeClientSecret'>
    & { arrangement: (
      Pick<BillingArrangement, 'organizationId'>
      & { subscription?: Maybe<Pick<BillingArrangementSubscription, 'subscriptionId'>> }
    ) }
  ) };

export type UpdateAffiliatedSubscriptionPriceMutationVariables = Exact<{
  affiliatedLegalEntityId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
}>;


export type UpdateAffiliatedSubscriptionPriceMutation = Pick<Mutation, 'updateAffiliatedSubscriptionPrice'>;

export type UpdateBillingAddressMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  address: AddressInput;
}>;


export type UpdateBillingAddressMutation = Pick<Mutation, 'updateBillingAddress'>;

export type UpdateBillingPaymentMethodMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  stripePaymentMethodId: Scalars['String']['input'];
}>;


export type UpdateBillingPaymentMethodMutation = Pick<Mutation, 'updateBillingPaymentMethod'>;

export type UpdateBillingSubscriptionMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
}>;


export type UpdateBillingSubscriptionMutation = Pick<Mutation, 'updateBillingSubscription'>;

export type CheckAffiliatedSubscriptionProductQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  affiliatedLegalEntityId: Scalars['String']['input'];
}>;


export type CheckAffiliatedSubscriptionProductQuery = { checkAffiliatedSubscriptionProduct: (
    Pick<CheckAffiliatedSubscriptionProduct, 'exists'>
    & { product?: Maybe<Pick<
        BillingProduct,
        | 'id'
        | 'name'
        | 'displayName'
        | 'description'
        | 'callout'
        | 'trialPeriodDays'
        | 'availability'
        | 'listing'
        | 'billable'
      >> }
  ) };

export type CheckBillingCustomerProfileQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type CheckBillingCustomerProfileQuery = { checkBillingCustomerProfile: (
    Pick<CheckBillingCustomerProfile, 'exists'>
    & { billingCustomerProfile?: Maybe<{ cardDetails: Pick<
          BillingCardDetails,
          | 'name'
          | 'brand'
          | 'country'
          | 'expMonth'
          | 'expYear'
          | 'last4'
        > }> }
  ) };

export type CheckBillingOrganizationPlanQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type CheckBillingOrganizationPlanQuery = { checkBillingOrganizationPlan: (
    Pick<CheckBillingPlan, 'exists'>
    & {
      billingPlan?: Maybe<{
          product: Pick<
              BillingProduct,
              | 'id'
              | 'name'
              | 'displayName'
              | 'description'
              | 'callout'
              | 'trialPeriodDays'
              | 'availability'
              | 'listing'
              | 'billable'
            >,
          price: (
            Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
            & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          legalEntityLimit?: Maybe<Pick<BillingLegalEntityLimit, 'id' | 'minLegalEntityLimit' | 'maxLegalEntityLimit'>>,
        }>,
      trial?: Maybe<Pick<BillingTrial, 'start' | 'end'>>,
      subscriptionDetails?: Maybe<Pick<
          SubscriptionDetails,
          | 'startedAt'
          | 'billingCycleStart'
          | 'billingCycleEnd'
          | 'status'
          | 'cancelAt'
        >>,
    }
  ) };

export type ListAvailableBillingPlansQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ListAvailableBillingPlansQuery = { listAvailableBillingPlans: Array<{
      product: Pick<
          BillingProduct,
          | 'id'
          | 'name'
          | 'displayName'
          | 'description'
          | 'callout'
          | 'trialPeriodDays'
          | 'availability'
          | 'listing'
          | 'billable'
        >,
      price: (
        Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
        & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ),
    }> };

export type ListBillingSubscriptionHistoryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ListBillingSubscriptionHistoryQuery = { listBillingSubscriptionHistory: Array<(
    Pick<
      BillingSubscriptionHistory,
      | 'createdAt'
      | 'paidAt'
      | 'status'
      | 'invoiceURL'
    >
    & {
      prorationAmount: Pick<MonetaryValue, 'amount' | 'currencyMultiplier' | 'iso4217CurrencyCode'>,
      recurringAmount: Pick<MonetaryValue, 'amount' | 'currencyMultiplier' | 'iso4217CurrencyCode'>,
      totalAmount: Pick<MonetaryValue, 'amount' | 'currencyMultiplier' | 'iso4217CurrencyCode'>,
      cardDetails?: Maybe<Pick<
          BillingCardDetails,
          | 'name'
          | 'brand'
          | 'country'
          | 'expMonth'
          | 'expYear'
          | 'last4'
        >>,
    }
  )> };

export type ListClientBillingPlansQueryVariables = Exact<{
  firmOrganizationId: Scalars['String']['input'];
  affiliatedOrganizationId: Scalars['String']['input'];
  affiliatedLegalEntityId: Scalars['String']['input'];
}>;


export type ListClientBillingPlansQuery = { listClientBillingPlans: Array<{
      product: Pick<
          BillingProduct,
          | 'id'
          | 'name'
          | 'displayName'
          | 'description'
          | 'callout'
          | 'trialPeriodDays'
          | 'availability'
          | 'listing'
          | 'billable'
        >,
      price: (
        Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
        & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ),
    }> };

export type ListOnboardingPromotionCodesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ListOnboardingPromotionCodesQuery = Pick<Query, 'listOnboardingPromotionCodes'>;

export type PreviewBillingSubscriptionQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
}>;


export type PreviewBillingSubscriptionQuery = { previewBillingSubscription: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> };

export type PreviewBillingSubscriptionPriceQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type PreviewBillingSubscriptionPriceQuery = { previewBillingSubscriptionPrice: {
      total: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      coupons?: Maybe<Array<(
        Pick<
          Coupon,
          | 'valid'
          | 'percentOff'
          | 'duration'
          | 'durationInMonths'
          | 'stripePromoCodeId'
          | 'start'
          | 'end'
        >
        & { amountOff?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
      )>>,
    } };

export type PreviewSubscriptionUpdateQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type PreviewSubscriptionUpdateQuery = { previewSubscriptionUpdate: (
    Pick<BillingPreview, 'monthlyBillingDay'>
    & {
      amountDue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      proratedAmount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      subscriptionCoupons?: Maybe<Array<(
        Pick<
          Coupon,
          | 'valid'
          | 'percentOff'
          | 'duration'
          | 'durationInMonths'
          | 'stripePromoCodeId'
          | 'start'
          | 'end'
        >
        & { amountOff?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
      )>>,
    }
  ) };

export type ReadBillingQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ReadBillingQuery = { readBilling:
    | (
      Pick<BillingAccountingFirm, 'organizationId' | 'subscriptionId' | 'activeSubscription'>
      & {
        product: Pick<
            BillingProduct,
            | 'id'
            | 'name'
            | 'displayName'
            | 'description'
            | 'callout'
            | 'trialPeriodDays'
            | 'availability'
            | 'listing'
            | 'billable'
          >,
        firmPaidClients: Array<(
          Pick<BillingFirmPayer, 'legalEntityId' | 'billed'>
          & {
            product: Pick<
                BillingProduct,
                | 'id'
                | 'name'
                | 'displayName'
                | 'description'
                | 'callout'
                | 'trialPeriodDays'
                | 'availability'
                | 'listing'
                | 'billable'
              >,
            availablePlans: Array<{
                product: Pick<
                    BillingProduct,
                    | 'id'
                    | 'name'
                    | 'displayName'
                    | 'description'
                    | 'callout'
                    | 'trialPeriodDays'
                    | 'availability'
                    | 'listing'
                    | 'billable'
                  >,
                price: (
                  Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
                  & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
              }>,
          }
        )>,
        selfPaidClients: Array<(
          Pick<BillingClientPayer, 'legalEntityId'>
          & { operator: (
            Pick<BillingOperator, 'organizationId' | 'subscriptionId' | 'activeSubscription'>
            & {
              product: Pick<
                  BillingProduct,
                  | 'id'
                  | 'name'
                  | 'displayName'
                  | 'description'
                  | 'callout'
                  | 'trialPeriodDays'
                  | 'availability'
                  | 'listing'
                  | 'billable'
                >,
              trial?: Maybe<Pick<BillingTrial, 'start' | 'end'>>,
              availablePlans: Array<{
                  product: Pick<
                      BillingProduct,
                      | 'id'
                      | 'name'
                      | 'displayName'
                      | 'description'
                      | 'callout'
                      | 'trialPeriodDays'
                      | 'availability'
                      | 'listing'
                      | 'billable'
                    >,
                  price: (
                    Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
                    & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ),
                }>,
              availableCoupons: Array<(
                Pick<
                  Coupon,
                  | 'valid'
                  | 'percentOff'
                  | 'duration'
                  | 'durationInMonths'
                  | 'stripePromoCodeId'
                  | 'start'
                  | 'end'
                >
                & { amountOff?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
              )>,
              subscriptionDetails?: Maybe<Pick<SubscriptionDetails, 'status'>>,
            }
          ) }
        )>,
      }
    )
    | (
      Pick<BillingLegacyFirm, 'organizationId' | 'subscriptionId' | 'activeSubscription'>
      & { product: Pick<
          BillingProduct,
          | 'id'
          | 'name'
          | 'displayName'
          | 'description'
          | 'callout'
          | 'trialPeriodDays'
          | 'availability'
          | 'listing'
          | 'billable'
        > }
    )
    | Pick<BillingNone, 'unused'>
    | (
      Pick<BillingOperator, 'organizationId' | 'subscriptionId' | 'activeSubscription'>
      & {
        product: Pick<
            BillingProduct,
            | 'id'
            | 'name'
            | 'displayName'
            | 'description'
            | 'callout'
            | 'trialPeriodDays'
            | 'availability'
            | 'listing'
            | 'billable'
          >,
        trial?: Maybe<Pick<BillingTrial, 'start' | 'end'>>,
        availablePlans: Array<{
            product: Pick<
                BillingProduct,
                | 'id'
                | 'name'
                | 'displayName'
                | 'description'
                | 'callout'
                | 'trialPeriodDays'
                | 'availability'
                | 'listing'
                | 'billable'
              >,
            price: (
              Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
              & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
          }>,
        availableCoupons: Array<(
          Pick<
            Coupon,
            | 'valid'
            | 'percentOff'
            | 'duration'
            | 'durationInMonths'
            | 'stripePromoCodeId'
            | 'start'
            | 'end'
          >
          & { amountOff?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
        )>,
        subscriptionDetails?: Maybe<Pick<SubscriptionDetails, 'status'>>,
      }
    )
   };

export type ReadBillingAddressQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ReadBillingAddressQuery = { readBillingAddress: (
    Pick<BillingAddress, 'organizationId' | 'fullName'>
    & { billingAddress?: Maybe<Pick<
        Address,
        | 'street'
        | 'streetAdditional'
        | 'city'
        | 'region'
        | 'postalCode'
        | 'countryCode'
        | 'lat'
        | 'long'
      >> }
  ) };

export type ReadBillingArrangementQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ReadBillingArrangementQuery = { readBillingArrangement: (
    Pick<BillingArrangement, 'organizationId'>
    & {
      subscription?: Maybe<(
        Pick<BillingArrangementSubscription, 'subscriptionId'>
        & {
          stripe?: Maybe<(
            Pick<
              BillingArrangementSubscriptionStripe,
              | 'status'
              | 'startedAt'
              | 'billingCycleStart'
              | 'billingCycleEnd'
              | 'cancelAt'
            >
            & { trial?: Maybe<Pick<BillingTrial, 'start' | 'end'>> }
          )>,
          items: Array<{
              plan?: Maybe<{
                  product: Pick<
                      BillingProduct,
                      | 'id'
                      | 'name'
                      | 'displayName'
                      | 'description'
                      | 'callout'
                      | 'trialPeriodDays'
                      | 'availability'
                      | 'listing'
                      | 'billable'
                    >,
                  price: (
                    Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
                    & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ),
                }>,
              contributors: Array<Pick<BillingArrangementContributor, 'id' | 'type'>>,
            }>,
        }
      )>,
      legalEntities: Array<(
        Pick<
          BillingArrangementLegalEntityBilling,
          | 'legalEntityId'
          | 'payerOrganizationId'
          | 'payerSubscriptionStatus'
          | 'viewerOrganizationIds'
        >
        & {
          plan?: Maybe<{
              product: Pick<
                  BillingProduct,
                  | 'id'
                  | 'name'
                  | 'displayName'
                  | 'description'
                  | 'callout'
                  | 'trialPeriodDays'
                  | 'availability'
                  | 'listing'
                  | 'billable'
                >,
              price: (
                Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
                & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
            }>,
          eligiblePlans: Array<{
              product: Pick<
                  BillingProduct,
                  | 'id'
                  | 'name'
                  | 'displayName'
                  | 'description'
                  | 'callout'
                  | 'trialPeriodDays'
                  | 'availability'
                  | 'listing'
                  | 'billable'
                >,
              price: (
                Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
                & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
            }>,
        }
      )>,
    }
  ) };

export type ReadBillingCustomerProfileQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ReadBillingCustomerProfileQuery = { readBillingCustomerProfile: { cardDetails: Pick<
        BillingCardDetails,
        | 'name'
        | 'brand'
        | 'country'
        | 'expMonth'
        | 'expYear'
        | 'last4'
      > } };

export type ReadBillingPlansQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  productNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadBillingPlansQuery = { readBillingPlans: Array<{
      product: Pick<
          BillingProduct,
          | 'id'
          | 'name'
          | 'displayName'
          | 'description'
          | 'callout'
          | 'trialPeriodDays'
          | 'availability'
          | 'listing'
          | 'billable'
        >,
      price: (
        Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
        & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ),
    }> };

export type ReadFirmBillingPlansQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  affiliatedLegalEntityId: Scalars['String']['input'];
}>;


export type ReadFirmBillingPlansQuery = { readFirmBillingPlans: Array<{
      product: Pick<
          BillingProduct,
          | 'id'
          | 'name'
          | 'displayName'
          | 'description'
          | 'callout'
          | 'trialPeriodDays'
          | 'availability'
          | 'listing'
          | 'billable'
        >,
      price: (
        Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
        & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ),
      legalEntityLimit?: Maybe<Pick<BillingLegalEntityLimit, 'id' | 'minLegalEntityLimit' | 'maxLegalEntityLimit'>>,
    }> };

export type ReadLegalEntityResetQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadLegalEntityResetQuery = { readLegalEntityReset: Pick<LegalEntityReset, 'isReset'> };

export type ReadOrganizationBillingPlanQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ReadOrganizationBillingPlanQuery = { readOrganizationBillingPlan: {
      plan: {
          product: Pick<
              BillingProduct,
              | 'id'
              | 'name'
              | 'displayName'
              | 'description'
              | 'callout'
              | 'trialPeriodDays'
              | 'availability'
              | 'listing'
              | 'billable'
            >,
          price: (
            Pick<BillingPrice, 'id' | 'interval' | 'intervalCount'>
            & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          legalEntityLimit?: Maybe<Pick<BillingLegalEntityLimit, 'id' | 'minLegalEntityLimit' | 'maxLegalEntityLimit'>>,
        },
      trial?: Maybe<Pick<BillingTrial, 'start' | 'end'>>,
    } };

export type DuplicateBillFieldsFragment = Pick<DuplicateBill, 'billId'>;

export type LedgerBillAccessFieldsFragment = Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>;

export type LedgerBillAddressFieldsFragment = Pick<
    Address,
    | 'street'
    | 'streetAdditional'
    | 'city'
    | 'region'
    | 'postalCode'
    | 'countryCode'
    | 'lat'
    | 'long'
  >;

export type LedgerBillDocumentFieldsFragment = (
  Pick<
    LedgerBillDocument,
    | 'id'
    | 'collectionId'
    | 'sourceFormatId'
    | 'status'
    | 'asyncProcessingStatus'
    | 'isSplitLineItemView'
    | 'createdAt'
    | 'updatedAt'
    | 'deletedAt'
  >
  & {
    formats: Array<(
      Pick<Format, 'id' | 'formatClass' | 'mimeType'>
      & { segments: Array<Pick<
          Segment,
          | 'fileId'
          | 'sequence'
          | 'collectionId'
          | 'token'
        >> }
    )>,
    features: Array<(
      { __typename: 'Feature' }
      & Pick<
        Feature,
        | 'id'
        | 'kind'
        | 'featurePage'
        | 'originX'
        | 'originY'
        | 'width'
        | 'height'
        | 'invalid'
      >
      & { value:
        | (
          { __typename: 'AddressFeatureValue' }
          & { addressValue: Pick<
              Address,
              | 'street'
              | 'streetAdditional'
              | 'city'
              | 'region'
              | 'postalCode'
              | 'countryCode'
              | 'lat'
              | 'long'
            > }
        )
        | (
          { __typename: 'DateFeatureValue' }
          & { dateValue: Pick<Date, 'year' | 'month' | 'day'> }
        )
        | (
          { __typename: 'LineItemFeatureValue' }
          & { lineItemValue: (
            Pick<
              DocumentLineItem,
              | 'description'
              | 'quantity'
              | 'position'
              | 'categoryId'
            >
            & {
              rate: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            }
          ) }
        )
        | (
          { __typename: 'MonetaryFeatureValue' }
          & { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        )
        | (
          { __typename: 'NumericFeatureValue' }
          & Pick<NumericFeatureValue, 'numericValue'>
        )
        | (
          { __typename: 'RemittanceFeatureValue' }
          & { remittanceValue: Pick<
              RemittanceItem,
              | 'BankName'
              | 'BankAccountNumber'
              | 'BankAccountName'
              | 'BankRoutingNumber'
              | 'RemittanceType'
            > }
        )
        | (
          { __typename: 'TextFeatureValue' }
          & Pick<TextFeatureValue, 'textValue'>
        )
       }
    )>,
  }
);

export type LedgerBillFormatFieldsFragment = (
  Pick<Format, 'id' | 'formatClass' | 'mimeType'>
  & { segments: Array<Pick<
      Segment,
      | 'fileId'
      | 'sequence'
      | 'collectionId'
      | 'token'
    >> }
);

export type LedgerBillFeatureFieldsFragment = (
  { __typename: 'Feature' }
  & Pick<
    Feature,
    | 'id'
    | 'kind'
    | 'featurePage'
    | 'originX'
    | 'originY'
    | 'width'
    | 'height'
    | 'invalid'
  >
  & { value:
    | (
      { __typename: 'AddressFeatureValue' }
      & { addressValue: Pick<
          Address,
          | 'street'
          | 'streetAdditional'
          | 'city'
          | 'region'
          | 'postalCode'
          | 'countryCode'
          | 'lat'
          | 'long'
        > }
    )
    | (
      { __typename: 'DateFeatureValue' }
      & { dateValue: Pick<Date, 'year' | 'month' | 'day'> }
    )
    | (
      { __typename: 'LineItemFeatureValue' }
      & { lineItemValue: (
        Pick<
          DocumentLineItem,
          | 'description'
          | 'quantity'
          | 'position'
          | 'categoryId'
        >
        & {
          rate: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
          amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        }
      ) }
    )
    | (
      { __typename: 'MonetaryFeatureValue' }
      & { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    )
    | (
      { __typename: 'NumericFeatureValue' }
      & Pick<NumericFeatureValue, 'numericValue'>
    )
    | (
      { __typename: 'RemittanceFeatureValue' }
      & { remittanceValue: Pick<
          RemittanceItem,
          | 'BankName'
          | 'BankAccountNumber'
          | 'BankAccountName'
          | 'BankRoutingNumber'
          | 'RemittanceType'
        > }
    )
    | (
      { __typename: 'TextFeatureValue' }
      & Pick<TextFeatureValue, 'textValue'>
    )
   }
);

export type LedgerBillTextFeatureValueFieldsFragment = (
  { __typename: 'TextFeatureValue' }
  & Pick<TextFeatureValue, 'textValue'>
);

export type LedgerBillNumericFeatureValueFieldsFragment = (
  { __typename: 'NumericFeatureValue' }
  & Pick<NumericFeatureValue, 'numericValue'>
);

export type LedgerBillDateFeatureValueFieldsFragment = (
  { __typename: 'DateFeatureValue' }
  & { dateValue: Pick<Date, 'year' | 'month' | 'day'> }
);

export type LedgerBillMonetaryFeatureValueFieldsFragment = (
  { __typename: 'MonetaryFeatureValue' }
  & { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
);

export type LedgerBillAddressFeatureValueFieldsFragment = (
  { __typename: 'AddressFeatureValue' }
  & { addressValue: Pick<
      Address,
      | 'street'
      | 'streetAdditional'
      | 'city'
      | 'region'
      | 'postalCode'
      | 'countryCode'
      | 'lat'
      | 'long'
    > }
);

export type LedgerBillLineItemFeatureValueFieldsFragment = (
  { __typename: 'LineItemFeatureValue' }
  & { lineItemValue: (
    Pick<
      DocumentLineItem,
      | 'description'
      | 'quantity'
      | 'position'
      | 'categoryId'
    >
    & {
      rate: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    }
  ) }
);

export type LedgerBillRemittanceFeatureValueFieldsFragment = (
  { __typename: 'RemittanceFeatureValue' }
  & { remittanceValue: Pick<
      RemittanceItem,
      | 'BankName'
      | 'BankAccountNumber'
      | 'BankAccountName'
      | 'BankRoutingNumber'
      | 'RemittanceType'
    > }
);

export type LedgerBillIdentityFieldsFragment = Pick<Identity, 'identifier' | 'provider' | 'domain'>;

export type LedgerBillMonetaryValueFieldsFragment = Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>;

export type LedgerBillOrganizationFieldsFragment = Pick<
    Organization,
    | 'id'
    | 'slug'
    | 'name'
    | 'iconUrl'
    | 'websiteUrl'
    | 'kind'
  >;

export type LedgerBillRoleFieldsFragment = Pick<Role, 'id'>;

export type LedgerBillSummaryFieldsFragment = (
  Pick<
    LedgerBillSummary,
    | 'id'
    | 'documentId'
    | 'invoiceNumber'
    | 'externalId'
    | 'referenceId'
    | 'providerType'
    | 'status'
    | 'billDate'
    | 'dueDate'
    | 'scheduleSendForApproval'
    | 'paidAt'
    | 'statusAt'
    | 'createdAt'
    | 'transactionFactId'
    | 'duplicateDataSourceBillIds'
    | 'sourceIconUrls'
  >
  & {
    vendor: Pick<VendorSummary, 'id' | 'name' | 'icon'>,
    detectedVendor?: Maybe<Pick<VendorSummary, 'id' | 'name' | 'icon'>>,
    amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    amountDue?: Maybe<Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
  }
);

export type LedgerBillUserFieldsFragment = (
  Pick<
    User,
    | 'id'
    | 'givenName'
    | 'familyName'
    | 'primaryEmailAddress'
    | 'passwordSet'
    | 'avatarUrl'
    | 'createdAt'
    | 'lastActivityAt'
  >
  & {
    employments?: Maybe<Array<(
      Pick<OrganizationEmployment, 'employeeId'>
      & {
        role: Pick<Role, 'id'>,
        organization: Pick<
            Organization,
            | 'id'
            | 'slug'
            | 'name'
            | 'iconUrl'
            | 'websiteUrl'
            | 'kind'
          >,
      }
    )>>,
    identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
  }
);

export type VendorFieldsFragment = Pick<
    Vendor,
    | 'vendorId'
    | 'name'
    | 'email'
    | 'providerType'
    | 'partyId'
    | 'iconUrl'
  >;

export type VendorSummaryFieldsFragment = Pick<VendorSummary, 'id' | 'name' | 'icon'>;

export type LedgerApproveAndPayBillMutationVariables = Exact<{
  viewKey: ViewKey;
  billId: Scalars['String']['input'];
  instrumentId: Scalars['String']['input'];
}>;


export type LedgerApproveAndPayBillMutation = { ledgerApproveAndPayBill: Pick<LedgerApproveAndPayBillResult, 'status' | 'billPaymentId'> };

export type LedgerApproveBillMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  billId: Scalars['String']['input'];
}>;


export type LedgerApproveBillMutation = Pick<Mutation, 'ledgerApproveBill'>;

export type LedgerDeleteBillMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  billId: Scalars['String']['input'];
}>;


export type LedgerDeleteBillMutation = Pick<Mutation, 'ledgerDeleteBill'>;

export type LedgerMarkBillAsPaidMutationVariables = Exact<{
  viewKey: ViewKey;
  legalEntityId: Scalars['String']['input'];
  billId: Scalars['String']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  datePaid: Scalars['DateTime']['input'];
  categoryId: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type LedgerMarkBillAsPaidMutation = Pick<Mutation, 'ledgerMarkBillAsPaid'>;

export type LedgerPayBillMutationVariables = Exact<{
  viewKey: ViewKey;
  billId: Scalars['String']['input'];
  instrumentId: Scalars['String']['input'];
}>;


export type LedgerPayBillMutation = Pick<Mutation, 'ledgerPayBill'>;

export type LedgerRejectBillMutationVariables = Exact<{
  viewKey: ViewKey;
  billId: Scalars['String']['input'];
  comment: Scalars['String']['input'];
}>;


export type LedgerRejectBillMutation = Pick<Mutation, 'ledgerRejectBill'>;

export type LedgerRetryBillPaymentMutationVariables = Exact<{
  viewKey: ViewKey;
  billId: Scalars['String']['input'];
  sourcePaymentInstrumentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LedgerRetryBillPaymentMutation = Pick<Mutation, 'ledgerRetryBillPayment'>;

export type LedgerRetryBillPayoutsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  billIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  correctedDestinationPaymentInstrumentId: Scalars['String']['input'];
}>;


export type LedgerRetryBillPayoutsMutation = Pick<Mutation, 'ledgerRetryBillPayouts'>;

export type LedgerSaveBillMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  bill: LedgerInputBill;
  approverUserId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LedgerSaveBillMutation = { ledgerSaveBill: Pick<LedgerSaveBillResult, 'ledgerTransactionId'> };

export type LedgerScheduleSendForApprovalMutationVariables = Exact<{
  billId: Scalars['String']['input'];
  viewKey: ViewKey;
  scheduleSendForApprovalAt: Scalars['DateTime']['input'];
}>;


export type LedgerScheduleSendForApprovalMutation = Pick<Mutation, 'ledgerScheduleSendForApproval'>;

export type LedgerSendForApprovalMutationVariables = Exact<{
  billId: Scalars['String']['input'];
  viewKey: ViewKey;
}>;


export type LedgerSendForApprovalMutation = Pick<Mutation, 'ledgerSendForApproval'>;

export type LedgerSetDataSourceBillRoleMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  dataSourceBillId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  role: BillAccessRole;
}>;


export type LedgerSetDataSourceBillRoleMutation = Pick<Mutation, 'ledgerSetDataSourceBillRole'>;

export type LedgerStartBillSplitLineItemsWorkflowMutationVariables = Exact<{
  viewKey: ViewKey;
  dataSourceBillId: Scalars['String']['input'];
  documentCollectionId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
}>;


export type LedgerStartBillSplitLineItemsWorkflowMutation = { ledgerStartBillSplitLineItemsWorkflow: Pick<LedgerStartBillSplitLineItemsWorkflowResult, 'workflowId'> };

export type LedgerStartBillWorkflowFromDocumentMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
  documentCollectionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  objectToken: Scalars['String']['input'];
}>;


export type LedgerStartBillWorkflowFromDocumentMutation = { ledgerStartBillWorkflowFromDocument: Pick<LedgerStartBillWorkflowFromDocumentResult, 'workflowId'> };

export type LedgerVoidBillMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  billId: Scalars['String']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
}>;


export type LedgerVoidBillMutation = Pick<Mutation, 'ledgerVoidBill'>;

export type LedgerGetBillDeliveryTimelineQueryVariables = Exact<{
  viewKey: ViewKey;
  billId: Scalars['String']['input'];
}>;


export type LedgerGetBillDeliveryTimelineQuery = { ledgerGetBillDeliveryTimeline?: Maybe<(
    Pick<Delivery, 'estimatedDelivery' | 'deliveryMethod'>
    & {
      sourceInstrument?: Maybe<
        | (
          { __typename: 'BankAccount' }
          & Pick<
            BankAccount,
            | 'id'
            | 'institutionName'
            | 'name'
            | 'accountIdMask'
            | 'isDefault'
            | 'nickname'
            | 'isAutoPayout'
            | 'iconObjectName'
            | 'isDisabled'
          >
        )
        | (
          { __typename: 'CreditCard' }
          & Pick<
            CreditCard,
            | 'id'
            | 'cardLastFour'
            | 'cardBrand'
            | 'isDefault'
            | 'nickname'
          >
        )
      >,
      destinationInstrument?: Maybe<
        | (
          { __typename: 'BankAccount' }
          & Pick<
            BankAccount,
            | 'id'
            | 'institutionName'
            | 'name'
            | 'accountIdMask'
            | 'isDefault'
            | 'nickname'
            | 'isAutoPayout'
            | 'iconObjectName'
            | 'isDisabled'
          >
        )
        | (
          { __typename: 'Check' }
          & Pick<
            Check,
            | 'id'
            | 'recipientName'
            | 'isDefault'
            | 'nickname'
            | 'isAutoPayout'
            | 'isDisabled'
          >
          & { address?: Maybe<Pick<
              Address,
              | 'street'
              | 'streetAdditional'
              | 'city'
              | 'region'
              | 'postalCode'
              | 'countryCode'
              | 'lat'
              | 'long'
            >> }
        )
      >,
      milestones: Array<Pick<DeliveryMilestone, 'status' | 'date'>>,
    }
  )> };

export type LedgerGetBillExternalPaymentQueryVariables = Exact<{
  viewKey: ViewKey;
  billId: Scalars['String']['input'];
}>;


export type LedgerGetBillExternalPaymentQuery = { ledgerGetBillExternalPayment?: Maybe<(
    Pick<
      BillExternalPayment,
      | 'id'
      | 'status'
      | 'statusAt'
      | 'paidAt'
      | 'externalReferenceNumber'
    >
    & { amount?: Maybe<Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
  )> };

export type LedgerListBillWorkflowStatusUpdatesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  billId: Scalars['String']['input'];
}>;


export type LedgerListBillWorkflowStatusUpdatesQuery = { ledgerListBillWorkflowStatusUpdates: Array<(
    Pick<
      LedgerBillWorkflowStatusUpdate,
      | 'id'
      | 'status'
      | 'statusAt'
      | 'statusSource'
      | 'internalNote'
    >
    & { user?: Maybe<Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >> }
  )> };

export type LedgerListBillWorkflowsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  statuses?: InputMaybe<Array<WorkflowStatus> | WorkflowStatus>;
  splitLineItems?: InputMaybe<Scalars['Boolean']['input']>;
  prepareSplitLineItems?: InputMaybe<Scalars['Boolean']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type LedgerListBillWorkflowsQuery = { ledgerListBillWorkflows: Array<Pick<
      WorkflowSummary,
      | 'legalEntityId'
      | 'workflowId'
      | 'idempotencyKey'
      | 'definitionName'
      | 'status'
      | 'createdAt'
      | 'updatedAt'
      | 'completedAt'
    >> };

export type LedgerListBillsByVendorQueryVariables = Exact<{
  viewKey: ViewKey;
  vendorId: Scalars['String']['input'];
}>;


export type LedgerListBillsByVendorQuery = { ledgerListBillsByVendor: Array<(
    Pick<
      LedgerBillSummary,
      | 'id'
      | 'status'
      | 'statusAt'
      | 'billDate'
      | 'createdAt'
    >
    & {
      vendor: Pick<VendorSummary, 'id' | 'icon' | 'name'>,
      amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    }
  )> };

export type LedgerListConnectBillsQueryVariables = Exact<{
  viewKey: ViewKey;
  paidSinceDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LedgerListConnectBillsQuery = { ledgerListConnectBills: Array<(
    Pick<
      LedgerBillSummary,
      | 'id'
      | 'documentId'
      | 'invoiceNumber'
      | 'externalId'
      | 'referenceId'
      | 'providerType'
      | 'status'
      | 'billDate'
      | 'dueDate'
      | 'scheduleSendForApproval'
      | 'paidAt'
      | 'statusAt'
      | 'createdAt'
      | 'transactionFactId'
      | 'duplicateDataSourceBillIds'
      | 'sourceIconUrls'
    >
    & {
      vendor: Pick<VendorSummary, 'id' | 'name' | 'icon'>,
      detectedVendor?: Maybe<Pick<VendorSummary, 'id' | 'name' | 'icon'>>,
      amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      amountDue?: Maybe<Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    }
  )> };

export type LedgerListPaidBillsQueryVariables = Exact<{
  viewKey: ViewKey;
  paidSinceDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LedgerListPaidBillsQuery = { ledgerListPaidBills: Array<(
    Pick<
      LedgerBillSummary,
      | 'id'
      | 'documentId'
      | 'invoiceNumber'
      | 'externalId'
      | 'referenceId'
      | 'providerType'
      | 'status'
      | 'billDate'
      | 'dueDate'
      | 'scheduleSendForApproval'
      | 'paidAt'
      | 'statusAt'
      | 'createdAt'
      | 'transactionFactId'
      | 'duplicateDataSourceBillIds'
      | 'sourceIconUrls'
    >
    & {
      vendor: Pick<VendorSummary, 'id' | 'name' | 'icon'>,
      detectedVendor?: Maybe<Pick<VendorSummary, 'id' | 'name' | 'icon'>>,
      amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      amountDue?: Maybe<Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    }
  )> };

export type LedgerListPendingBillsQueryVariables = Exact<{
  viewKey: ViewKey;
}>;


export type LedgerListPendingBillsQuery = { ledgerListPendingBills: Array<(
    Pick<
      LedgerBillSummary,
      | 'id'
      | 'documentId'
      | 'invoiceNumber'
      | 'externalId'
      | 'referenceId'
      | 'providerType'
      | 'status'
      | 'billDate'
      | 'dueDate'
      | 'scheduleSendForApproval'
      | 'paidAt'
      | 'statusAt'
      | 'createdAt'
      | 'transactionFactId'
      | 'duplicateDataSourceBillIds'
      | 'sourceIconUrls'
    >
    & {
      vendor: Pick<VendorSummary, 'id' | 'name' | 'icon'>,
      detectedVendor?: Maybe<Pick<VendorSummary, 'id' | 'name' | 'icon'>>,
      amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      amountDue?: Maybe<Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    }
  )> };

export type LedgerListRetryableBillPayoutIdsQueryVariables = Exact<{
  viewKey: ViewKey;
  vendorId: Scalars['String']['input'];
}>;


export type LedgerListRetryableBillPayoutIdsQuery = Pick<Query, 'ledgerListRetryableBillPayoutIds'>;

export type LedgerReadBillTransactionQueryVariables = Exact<{
  transactionFactId?: InputMaybe<Scalars['String']['input']>;
  billId?: InputMaybe<Scalars['String']['input']>;
  viewKey: ViewKey;
}>;


export type LedgerReadBillTransactionQuery = { ledgerReadBillTransaction: (
    Pick<
      LedgerReadBillTransaction,
      | 'billId'
      | 'dataSourceId'
      | 'transactionFactId'
      | 'ledgerTransactionId'
      | 'apFactId'
      | 'status'
      | 'statusAt'
      | 'createdAt'
      | 'billDate'
      | 'dueDate'
      | 'scheduleSendForApproval'
      | 'billNumber'
      | 'referenceNumber'
      | 'memo'
      | 'candidateMode'
    >
    & {
      apCategory?: Maybe<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>,
      candidateFactSets?: Maybe<Array<Pick<LedgerBillCandidateFactSet, 'candidateMode' | 'transactionFactIds'>>>,
      totalAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
      vendor?: Maybe<Pick<
          Vendor,
          | 'vendorId'
          | 'name'
          | 'email'
          | 'providerType'
          | 'partyId'
          | 'iconUrl'
        >>,
      document?: Maybe<(
        Pick<
          LedgerBillDocument,
          | 'id'
          | 'collectionId'
          | 'sourceFormatId'
          | 'status'
          | 'asyncProcessingStatus'
          | 'isSplitLineItemView'
          | 'createdAt'
          | 'updatedAt'
          | 'deletedAt'
        >
        & {
          formats: Array<(
            Pick<Format, 'id' | 'formatClass' | 'mimeType'>
            & { segments: Array<Pick<
                Segment,
                | 'fileId'
                | 'sequence'
                | 'collectionId'
                | 'token'
              >> }
          )>,
          features: Array<(
            { __typename: 'Feature' }
            & Pick<
              Feature,
              | 'id'
              | 'kind'
              | 'featurePage'
              | 'originX'
              | 'originY'
              | 'width'
              | 'height'
              | 'invalid'
            >
            & { value:
              | (
                { __typename: 'AddressFeatureValue' }
                & { addressValue: Pick<
                    Address,
                    | 'street'
                    | 'streetAdditional'
                    | 'city'
                    | 'region'
                    | 'postalCode'
                    | 'countryCode'
                    | 'lat'
                    | 'long'
                  > }
              )
              | (
                { __typename: 'DateFeatureValue' }
                & { dateValue: Pick<Date, 'year' | 'month' | 'day'> }
              )
              | (
                { __typename: 'LineItemFeatureValue' }
                & { lineItemValue: (
                  Pick<
                    DocumentLineItem,
                    | 'description'
                    | 'quantity'
                    | 'position'
                    | 'categoryId'
                  >
                  & {
                    rate: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  }
                ) }
              )
              | (
                { __typename: 'MonetaryFeatureValue' }
                & { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )
              | (
                { __typename: 'NumericFeatureValue' }
                & Pick<NumericFeatureValue, 'numericValue'>
              )
              | (
                { __typename: 'RemittanceFeatureValue' }
                & { remittanceValue: Pick<
                    RemittanceItem,
                    | 'BankName'
                    | 'BankAccountNumber'
                    | 'BankAccountName'
                    | 'BankRoutingNumber'
                    | 'RemittanceType'
                  > }
              )
              | (
                { __typename: 'TextFeatureValue' }
                & Pick<TextFeatureValue, 'textValue'>
              )
             }
          )>,
        }
      )>,
      billAccess: Array<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
      users: Array<(
        Pick<
          User,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'primaryEmailAddress'
          | 'passwordSet'
          | 'avatarUrl'
          | 'createdAt'
          | 'lastActivityAt'
        >
        & {
          employments?: Maybe<Array<(
            Pick<OrganizationEmployment, 'employeeId'>
            & {
              role: Pick<Role, 'id'>,
              organization: Pick<
                  Organization,
                  | 'id'
                  | 'slug'
                  | 'name'
                  | 'iconUrl'
                  | 'websiteUrl'
                  | 'kind'
                >,
            }
          )>>,
          identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
        }
      )>,
      duplicates: Array<Pick<DuplicateBill, 'billId'>>,
      lineItems: Array<(
        Pick<
          LedgerBillLineItem,
          | 'id'
          | 'entryType'
          | 'name'
          | 'description'
          | 'quantity'
          | 'productId'
          | 'classificationId'
          | 'externalLineItemId'
          | 'documentFeatureId'
        >
        & {
          amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          category?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
          department?: Maybe<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          location?: Maybe<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
        }
      )>,
    }
  ) };

export type ReadCategoryQueryVariables = Exact<{
  viewKey: ViewKey;
  categoryId: Scalars['String']['input'];
}>;


export type ReadCategoryQuery = { readCategory: (
    Pick<
      Category,
      | 'id'
      | 'name'
      | 'description'
      | 'displayKey'
      | 'type'
      | 'subtype'
      | 'parentCategoryId'
      | 'displayNumber'
      | 'active'
      | 'categoryState'
      | 'productArea'
      | 'synthesized'
    >
    & { ancestors?: Maybe<Array<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>> }
  ) };

export type AutoConfigureProductMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  product: CategoryToLabelMappingProduct;
}>;


export type AutoConfigureProductMutation = Pick<Mutation, 'autoConfigureProduct'>;

export type CreateCategoryMappingMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  mappingValue: Scalars['String']['input'];
  mappingType: CategoryToLabelMappingType;
  product: CategoryToLabelMappingProduct;
  categoryId: Scalars['String']['input'];
}>;


export type CreateCategoryMappingMutation = Pick<Mutation, 'createCategoryMapping'>;

export type ListCategoryMappingsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  product: CategoryToLabelMappingProduct;
}>;


export type ListCategoryMappingsQuery = { listCategoryMappings: Array<(
    Pick<CategoryMapping, 'mappingValue' | 'mappingType' | 'product'>
    & { category: Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      > }
  )> };

export type ValidateCategoryMappingsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  product: CategoryToLabelMappingProduct;
}>;


export type ValidateCategoryMappingsQuery = Pick<Query, 'validateCategoryMappings'>;

export type CategoryIntegrationsFieldsFragment = (
  Pick<CategoryIntegrations, 'categoryId'>
  & {
    connect: Array<{
        connectionAccountSummaries: Array<(
          Pick<
            ConnectionAccountSummary,
            | 'id'
            | 'connectionId'
            | 'sourceAccountId'
            | 'name'
            | 'mask'
            | 'status'
            | 'statusUpdatedAt'
          >
          & { cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>> }
        )>,
        party?: Maybe<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>,
      }>,
    pay?: Maybe<(
      Pick<PayCategoryIntegrations, 'products'>
      & { party?: Maybe<Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        >> }
    )>,
  }
);

export type ConnectionCategoryIntegrationsFieldsFragment = {
    connectionAccountSummaries: Array<(
      Pick<
        ConnectionAccountSummary,
        | 'id'
        | 'connectionId'
        | 'sourceAccountId'
        | 'name'
        | 'mask'
        | 'status'
        | 'statusUpdatedAt'
      >
      & { cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>> }
    )>,
    party?: Maybe<Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >>,
  };

export type PayCategoryIntegrationsFieldsFragment = (
  Pick<PayCategoryIntegrations, 'products'>
  & { party?: Maybe<Pick<
      EntityParty,
      | 'id'
      | 'name'
      | 'iconUrl'
      | 'shortDescription'
      | 'roles'
      | 'designation'
    >> }
);

export type CreateCategoryMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  category: CreateCategoryInput;
}>;


export type CreateCategoryMutation = { createCategory: Pick<CreateCategoryResponse, 'categoryId'> };

export type UpdateCategoryMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  viewKey: ViewKey;
  category: UpdateCategoryInput;
}>;


export type UpdateCategoryMutation = Pick<Mutation, 'updateCategory'>;

export type UpdateCategoryStatusMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  viewKey: ViewKey;
  categoryId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type UpdateCategoryStatusMutation = Pick<Mutation, 'updateCategoryStatus'>;

export type UploadBulkCategoryMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  categories: Array<CreateBulkCategoryInput> | CreateBulkCategoryInput;
}>;


export type UploadBulkCategoryMutation = Pick<Mutation, 'uploadBulkCategory'>;

export type ListCategoriesQueryVariables = Exact<{
  viewKey: ViewKey;
  categoryType?: InputMaybe<CategoryType>;
}>;


export type ListCategoriesQuery = { listCategories: Array<(
    Pick<
      Category,
      | 'id'
      | 'name'
      | 'description'
      | 'displayKey'
      | 'type'
      | 'subtype'
      | 'parentCategoryId'
      | 'displayNumber'
      | 'active'
      | 'categoryState'
      | 'productArea'
      | 'synthesized'
    >
    & { ancestors?: Maybe<Array<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>> }
  )> };

export type ListCategoryIntegrationsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListCategoryIntegrationsQuery = { listCategoryIntegrations: Array<(
    Pick<CategoryIntegrations, 'categoryId'>
    & {
      connect: Array<{
          connectionAccountSummaries: Array<(
            Pick<
              ConnectionAccountSummary,
              | 'id'
              | 'connectionId'
              | 'sourceAccountId'
              | 'name'
              | 'mask'
              | 'status'
              | 'statusUpdatedAt'
            >
            & { cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>> }
          )>,
          party?: Maybe<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>,
        }>,
      pay?: Maybe<(
        Pick<PayCategoryIntegrations, 'products'>
        & { party?: Maybe<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >> }
      )>,
    }
  )> };

export type ListRawCategoriesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListRawCategoriesQuery = { listRawCategories: Array<Pick<
      EntityCategory,
      | 'id'
      | 'name'
      | 'displayKey'
      | 'chartOfAccountsDisplayNumber'
      | 'type'
      | 'subtype'
      | 'parentCategoryId'
      | 'productArea'
      | 'active'
    >> };

export type ClosedPeriodTransactionChangeEntityValueFieldsFragment = (
  { __typename: 'ClosedPeriodTransactionChangeEntityValue' }
  & Pick<ClosedPeriodTransactionChangeEntityValue, 'id' | 'kind'>
  & { entity:
    | { __typename: 'EntityBill' }
    | (
      { __typename: 'EntityCategory' }
      & Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >
    )
    | { __typename: 'EntityComment' }
    | { __typename: 'EntityDataSource' }
    | (
      { __typename: 'EntityDepartment' }
      & Pick<
        EntityDepartment,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
      & { departmentDisplayKey: EntityDepartment['displayKey'] }
    )
    | { __typename: 'EntityIdentityVerification' }
    | { __typename: 'EntityInvoice' }
    | { __typename: 'EntityLedgerTransaction' }
    | { __typename: 'EntityLegalEntity' }
    | (
      { __typename: 'EntityLocation' }
      & Pick<
        EntityLocation,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
      & { locationDisplayKey: EntityLocation['displayKey'] }
    )
    | (
      { __typename: 'EntityParty' }
      & Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >
    )
    | { __typename: 'EntityProduct' }
    | { __typename: 'EntityReconciliation' }
    | { __typename: 'EntityReport' }
    | { __typename: 'EntityReportPackage' }
    | { __typename: 'EntitySchedule' }
    | { __typename: 'EntityThread' }
    | { __typename: 'EntityTransaction' }
    | { __typename: 'EntityUser' }
    | { __typename: 'EntityWorkItem' }
   }
);

export type ClosedPeriodTransactionChangeTextValueFieldsFragment = (
  { __typename: 'ClosedPeriodTransactionChangeTextValue' }
  & { text: ClosedPeriodTransactionChangeTextValue['value'] }
);

export type ClosedPeriodTransactionChangeTimestampValueFieldsFragment = (
  { __typename: 'ClosedPeriodTransactionChangeTimestampValue' }
  & { timestamp: ClosedPeriodTransactionChangeTimestampValue['value'] }
);

export type ClosedPeriodTransactionChangeUnsetValueFieldsFragment = (
  { __typename: 'ClosedPeriodTransactionChangeUnsetValue' }
  & Pick<ClosedPeriodTransactionChangeUnsetValue, 'isUnset'>
);

export type ClosedPeriodTransactionChangeDiffFieldsFragment = (
  { __typename: 'ClosedPeriodTransactionChangeDiff' }
  & Pick<
    ClosedPeriodTransactionChangeDiff,
    | 'transactionChangeId'
    | 'transactionFactId'
    | 'status'
    | 'kind'
  >
  & {
    currentValue?: Maybe<
      | (
        { __typename: 'ClosedPeriodTransactionChangeEntityValue' }
        & Pick<ClosedPeriodTransactionChangeEntityValue, 'id' | 'kind'>
        & { entity:
          | { __typename: 'EntityBill' }
          | (
            { __typename: 'EntityCategory' }
            & Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >
          )
          | { __typename: 'EntityComment' }
          | { __typename: 'EntityDataSource' }
          | (
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
            & { departmentDisplayKey: EntityDepartment['displayKey'] }
          )
          | { __typename: 'EntityIdentityVerification' }
          | { __typename: 'EntityInvoice' }
          | { __typename: 'EntityLedgerTransaction' }
          | { __typename: 'EntityLegalEntity' }
          | (
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
            & { locationDisplayKey: EntityLocation['displayKey'] }
          )
          | (
            { __typename: 'EntityParty' }
            & Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >
          )
          | { __typename: 'EntityProduct' }
          | { __typename: 'EntityReconciliation' }
          | { __typename: 'EntityReport' }
          | { __typename: 'EntityReportPackage' }
          | { __typename: 'EntitySchedule' }
          | { __typename: 'EntityThread' }
          | { __typename: 'EntityTransaction' }
          | { __typename: 'EntityUser' }
          | { __typename: 'EntityWorkItem' }
         }
      )
      | (
        { __typename: 'ClosedPeriodTransactionChangeTextValue' }
        & { text: ClosedPeriodTransactionChangeTextValue['value'] }
      )
      | (
        { __typename: 'ClosedPeriodTransactionChangeTimestampValue' }
        & { timestamp: ClosedPeriodTransactionChangeTimestampValue['value'] }
      )
      | (
        { __typename: 'ClosedPeriodTransactionChangeUnsetValue' }
        & Pick<ClosedPeriodTransactionChangeUnsetValue, 'isUnset'>
      )
    >,
    proposedValue:
      | (
        { __typename: 'ClosedPeriodTransactionChangeEntityValue' }
        & Pick<ClosedPeriodTransactionChangeEntityValue, 'id' | 'kind'>
        & { entity:
          | { __typename: 'EntityBill' }
          | (
            { __typename: 'EntityCategory' }
            & Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >
          )
          | { __typename: 'EntityComment' }
          | { __typename: 'EntityDataSource' }
          | (
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
            & { departmentDisplayKey: EntityDepartment['displayKey'] }
          )
          | { __typename: 'EntityIdentityVerification' }
          | { __typename: 'EntityInvoice' }
          | { __typename: 'EntityLedgerTransaction' }
          | { __typename: 'EntityLegalEntity' }
          | (
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
            & { locationDisplayKey: EntityLocation['displayKey'] }
          )
          | (
            { __typename: 'EntityParty' }
            & Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >
          )
          | { __typename: 'EntityProduct' }
          | { __typename: 'EntityReconciliation' }
          | { __typename: 'EntityReport' }
          | { __typename: 'EntityReportPackage' }
          | { __typename: 'EntitySchedule' }
          | { __typename: 'EntityThread' }
          | { __typename: 'EntityTransaction' }
          | { __typename: 'EntityUser' }
          | { __typename: 'EntityWorkItem' }
         }
      )
      | (
        { __typename: 'ClosedPeriodTransactionChangeTextValue' }
        & { text: ClosedPeriodTransactionChangeTextValue['value'] }
      )
      | (
        { __typename: 'ClosedPeriodTransactionChangeTimestampValue' }
        & { timestamp: ClosedPeriodTransactionChangeTimestampValue['value'] }
      )
      | (
        { __typename: 'ClosedPeriodTransactionChangeUnsetValue' }
        & Pick<ClosedPeriodTransactionChangeUnsetValue, 'isUnset'>
      )
    ,
  }
);

export type ClosedPeriodUpdateTransactionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  transaction: InputTransaction;
  filter: TransactionFilter;
}>;


export type ClosedPeriodUpdateTransactionMutation = Pick<Mutation, 'closedPeriodUpdateTransaction'>;

export type EditClosedPeriodTransactionChangeFieldMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  transactionChangeId: Scalars['String']['input'];
  rejectionReason: Scalars['String']['input'];
  newValue: ClosedPeriodTransactionChangeValueInput;
}>;


export type EditClosedPeriodTransactionChangeFieldMutation = Pick<Mutation, 'editFieldRequest'>;

export type RejectClosedPeriodTransactionChangeFieldMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  transactionChangeId: Scalars['String']['input'];
  rejectionReason: Scalars['String']['input'];
}>;


export type RejectClosedPeriodTransactionChangeFieldMutation = Pick<Mutation, 'rejectFieldRequest'>;

export type ResolveClosedPeriodRequestMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  requestType: ClosedPeriodRequestType;
  resolution: ClosedPeriodRequestResolution;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResolveClosedPeriodRequestMutation = Pick<Mutation, 'resolveClosedPeriodRequest'>;

export type ListClosedPeriodTransactionChangeDiffsQueryVariables = Exact<{
  viewKey: ViewKey;
  ledgerTransactionId: Scalars['String']['input'];
  requestIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ListClosedPeriodTransactionChangeDiffsQuery = { listClosedPeriodTransactionChangeDiffs: Array<(
    Pick<ClosedPeriodTransactionChangeDiffs, 'requestId'>
    & { diffs: Array<(
      { __typename: 'ClosedPeriodTransactionChangeDiff' }
      & Pick<
        ClosedPeriodTransactionChangeDiff,
        | 'transactionChangeId'
        | 'transactionFactId'
        | 'status'
        | 'kind'
      >
      & {
        currentValue?: Maybe<
          | (
            { __typename: 'ClosedPeriodTransactionChangeEntityValue' }
            & Pick<ClosedPeriodTransactionChangeEntityValue, 'id' | 'kind'>
            & { entity:
              | { __typename: 'EntityBill' }
              | (
                { __typename: 'EntityCategory' }
                & Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >
              )
              | { __typename: 'EntityComment' }
              | { __typename: 'EntityDataSource' }
              | (
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
                & { departmentDisplayKey: EntityDepartment['displayKey'] }
              )
              | { __typename: 'EntityIdentityVerification' }
              | { __typename: 'EntityInvoice' }
              | { __typename: 'EntityLedgerTransaction' }
              | { __typename: 'EntityLegalEntity' }
              | (
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
                & { locationDisplayKey: EntityLocation['displayKey'] }
              )
              | (
                { __typename: 'EntityParty' }
                & Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >
              )
              | { __typename: 'EntityProduct' }
              | { __typename: 'EntityReconciliation' }
              | { __typename: 'EntityReport' }
              | { __typename: 'EntityReportPackage' }
              | { __typename: 'EntitySchedule' }
              | { __typename: 'EntityThread' }
              | { __typename: 'EntityTransaction' }
              | { __typename: 'EntityUser' }
              | { __typename: 'EntityWorkItem' }
             }
          )
          | (
            { __typename: 'ClosedPeriodTransactionChangeTextValue' }
            & { text: ClosedPeriodTransactionChangeTextValue['value'] }
          )
          | (
            { __typename: 'ClosedPeriodTransactionChangeTimestampValue' }
            & { timestamp: ClosedPeriodTransactionChangeTimestampValue['value'] }
          )
          | (
            { __typename: 'ClosedPeriodTransactionChangeUnsetValue' }
            & Pick<ClosedPeriodTransactionChangeUnsetValue, 'isUnset'>
          )
        >,
        proposedValue:
          | (
            { __typename: 'ClosedPeriodTransactionChangeEntityValue' }
            & Pick<ClosedPeriodTransactionChangeEntityValue, 'id' | 'kind'>
            & { entity:
              | { __typename: 'EntityBill' }
              | (
                { __typename: 'EntityCategory' }
                & Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >
              )
              | { __typename: 'EntityComment' }
              | { __typename: 'EntityDataSource' }
              | (
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
                & { departmentDisplayKey: EntityDepartment['displayKey'] }
              )
              | { __typename: 'EntityIdentityVerification' }
              | { __typename: 'EntityInvoice' }
              | { __typename: 'EntityLedgerTransaction' }
              | { __typename: 'EntityLegalEntity' }
              | (
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
                & { locationDisplayKey: EntityLocation['displayKey'] }
              )
              | (
                { __typename: 'EntityParty' }
                & Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >
              )
              | { __typename: 'EntityProduct' }
              | { __typename: 'EntityReconciliation' }
              | { __typename: 'EntityReport' }
              | { __typename: 'EntityReportPackage' }
              | { __typename: 'EntitySchedule' }
              | { __typename: 'EntityThread' }
              | { __typename: 'EntityTransaction' }
              | { __typename: 'EntityUser' }
              | { __typename: 'EntityWorkItem' }
             }
          )
          | (
            { __typename: 'ClosedPeriodTransactionChangeTextValue' }
            & { text: ClosedPeriodTransactionChangeTextValue['value'] }
          )
          | (
            { __typename: 'ClosedPeriodTransactionChangeTimestampValue' }
            & { timestamp: ClosedPeriodTransactionChangeTimestampValue['value'] }
          )
          | (
            { __typename: 'ClosedPeriodTransactionChangeUnsetValue' }
            & Pick<ClosedPeriodTransactionChangeUnsetValue, 'isUnset'>
          )
        ,
      }
    )> }
  )> };

export type ReadDateClosedPeriodRequestAffectedCountQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
}>;


export type ReadDateClosedPeriodRequestAffectedCountQuery = { readDateClosedPeriodRequestAffectedCount: Pick<DateClosedPeriodRequestAffectedCountResult, 'affectedCount'> };

export type BulkCreateOrReplyThreadsMutationVariables = Exact<{
  targetObjects: Array<InputObjectIdentifier> | InputObjectIdentifier;
  comment: NewComment;
  viewKey: ViewKey;
  assignee?: InputMaybe<Assignee>;
}>;


export type BulkCreateOrReplyThreadsMutation = Pick<Mutation, 'bulkCreateOrReplyThreads'>;

export type CreateReactionMutationVariables = Exact<{
  threadId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  reaction: CommentReaction;
}>;


export type CreateReactionMutation = Pick<Mutation, 'createReaction'>;

export type CreateThreadMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  kind: ObjectKind;
  id: Scalars['String']['input'];
  comment: NewComment;
  context?: InputMaybe<Scalars['String']['input']>;
  viewKey?: InputMaybe<ViewKey>;
  assignee?: InputMaybe<Assignee>;
}>;


export type CreateThreadMutation = { thread: (
    { __typename: 'ThreadWithEntities' }
    & {
      thread: (
        { __typename: 'Thread' }
        & Pick<Thread, 'id'>
        & {
          details: (
            Pick<
              ThreadDetails,
              | 'id'
              | 'commentCount'
              | 'resolvedAt'
              | 'authorId'
              | 'commenterIds'
              | 'context'
              | 'pending'
            >
            & {
              targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
              tags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
            }
          ),
          comments: Array<(
            { __typename: 'Comment' }
            & Pick<
              Comment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
              | 'editedAt'
              | 'deletedAt'
              | 'reactions'
            >
            & { layoutAttachment?: Maybe<Pick<LayoutAttachment, 'layoutId' | 'legalEntityId'>> }
          )>,
        }
      ),
      entities?: Maybe<(
        { __typename: 'ObjectEntities' }
        & {
          users?: Maybe<Array<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>>,
          transactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          comments?: Maybe<Array<Pick<
              EntityComment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
            >>>,
          reports?: Maybe<Array<(
            Pick<
              EntityReport,
              | 'id'
              | 'title'
              | 'authorId'
              | 'mimeType'
              | 'createdAt'
            >
            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
          )>>,
          reportPackages?: Maybe<Array<(
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )>>,
          parties?: Maybe<Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>>,
          datasources?: Maybe<Array<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>>,
          categories?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>>,
          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
          workItems?: Maybe<Array<(
            Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )>>,
          invoices?: Maybe<Array<(
            Pick<
              EntityInvoice,
              | 'id'
              | 'externalDisplayId'
              | 'createdAt'
              | 'dueAt'
            >
            & {
              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              customer: (
                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                & { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              ),
            }
          )>>,
          bills?: Maybe<Array<(
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )>>,
          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
          departments?: Maybe<Array<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          locations?: Maybe<Array<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          reconciliations?: Maybe<Array<(
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )>>,
          ledgerTransactions?: Maybe<Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )>>,
          schedules?: Maybe<Array<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>>,
        }
      )>,
    }
  ) };

export type DeleteReactionMutationVariables = Exact<{
  threadId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  reaction: CommentReaction;
}>;


export type DeleteReactionMutation = Pick<Mutation, 'deleteReaction'>;

export type ReplyThreadMutationVariables = Exact<{
  threadId: Scalars['String']['input'];
  comment: NewComment;
  assignee?: InputMaybe<Assignee>;
  viewKey?: InputMaybe<ViewKey>;
}>;


export type ReplyThreadMutation = { comment: {
      comment: (
        { __typename: 'Comment' }
        & Pick<
          Comment,
          | 'id'
          | 'authorId'
          | 'text'
          | 'timestamp'
          | 'editedAt'
          | 'deletedAt'
          | 'reactions'
        >
        & { layoutAttachment?: Maybe<Pick<LayoutAttachment, 'layoutId' | 'legalEntityId'>> }
      ),
      entities?: Maybe<(
        { __typename: 'ObjectEntities' }
        & {
          users?: Maybe<Array<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>>,
          transactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          comments?: Maybe<Array<Pick<
              EntityComment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
            >>>,
          reports?: Maybe<Array<(
            Pick<
              EntityReport,
              | 'id'
              | 'title'
              | 'authorId'
              | 'mimeType'
              | 'createdAt'
            >
            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
          )>>,
          reportPackages?: Maybe<Array<(
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )>>,
          parties?: Maybe<Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>>,
          datasources?: Maybe<Array<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>>,
          categories?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>>,
          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
          workItems?: Maybe<Array<(
            Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )>>,
          invoices?: Maybe<Array<(
            Pick<
              EntityInvoice,
              | 'id'
              | 'externalDisplayId'
              | 'createdAt'
              | 'dueAt'
            >
            & {
              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              customer: (
                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                & { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              ),
            }
          )>>,
          bills?: Maybe<Array<(
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )>>,
          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
          departments?: Maybe<Array<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          locations?: Maybe<Array<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          reconciliations?: Maybe<Array<(
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )>>,
          ledgerTransactions?: Maybe<Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )>>,
          schedules?: Maybe<Array<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>>,
        }
      )>,
    } };

export type ResolveThreadMutationVariables = Exact<{
  threadId: Scalars['String']['input'];
  viewKey?: InputMaybe<ViewKey>;
}>;


export type ResolveThreadMutation = Pick<Mutation, 'resolveThread'>;

export type FindThreadByCommentQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
}>;


export type FindThreadByCommentQuery = { thread?: Maybe<(
    Pick<
      ThreadDetails,
      | 'id'
      | 'commentCount'
      | 'resolvedAt'
      | 'authorId'
      | 'commenterIds'
      | 'context'
      | 'pending'
    >
    & {
      targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
      tags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
    }
  )> };

export type ListThreadsQueryVariables = Exact<{
  idsByKind: IdentifiersByKind;
  viewType: ViewType;
}>;


export type ListThreadsQuery = { listThreads: {
      threads: Array<{
          targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
          threads: Array<(
            Pick<
              ThreadDetails,
              | 'id'
              | 'commentCount'
              | 'resolvedAt'
              | 'authorId'
              | 'commenterIds'
              | 'context'
              | 'pending'
            >
            & {
              targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
              tags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
            }
          )>,
        }>,
      entities?: Maybe<(
        { __typename: 'ObjectEntities' }
        & {
          users?: Maybe<Array<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>>,
          transactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          comments?: Maybe<Array<Pick<
              EntityComment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
            >>>,
          reports?: Maybe<Array<(
            Pick<
              EntityReport,
              | 'id'
              | 'title'
              | 'authorId'
              | 'mimeType'
              | 'createdAt'
            >
            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
          )>>,
          reportPackages?: Maybe<Array<(
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )>>,
          parties?: Maybe<Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>>,
          datasources?: Maybe<Array<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>>,
          categories?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>>,
          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
          workItems?: Maybe<Array<(
            Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )>>,
          invoices?: Maybe<Array<(
            Pick<
              EntityInvoice,
              | 'id'
              | 'externalDisplayId'
              | 'createdAt'
              | 'dueAt'
            >
            & {
              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              customer: (
                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                & { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              ),
            }
          )>>,
          bills?: Maybe<Array<(
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )>>,
          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
          departments?: Maybe<Array<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          locations?: Maybe<Array<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          reconciliations?: Maybe<Array<(
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )>>,
          ledgerTransactions?: Maybe<Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )>>,
          schedules?: Maybe<Array<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>>,
        }
      )>,
    } };

export type ReadAssociatedThreadsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  kind: ObjectKind;
  allowResolved?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ReadAssociatedThreadsQuery = { response: {
      threads: Array<(
        { __typename: 'Thread' }
        & Pick<Thread, 'id'>
        & {
          details: (
            Pick<
              ThreadDetails,
              | 'id'
              | 'commentCount'
              | 'resolvedAt'
              | 'authorId'
              | 'commenterIds'
              | 'context'
              | 'pending'
            >
            & {
              targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
              tags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
            }
          ),
          comments: Array<(
            { __typename: 'Comment' }
            & Pick<
              Comment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
              | 'editedAt'
              | 'deletedAt'
              | 'reactions'
            >
            & { layoutAttachment?: Maybe<Pick<LayoutAttachment, 'layoutId' | 'legalEntityId'>> }
          )>,
        }
      )>,
      entities?: Maybe<(
        { __typename: 'ObjectEntities' }
        & {
          users?: Maybe<Array<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>>,
          transactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          comments?: Maybe<Array<Pick<
              EntityComment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
            >>>,
          reports?: Maybe<Array<(
            Pick<
              EntityReport,
              | 'id'
              | 'title'
              | 'authorId'
              | 'mimeType'
              | 'createdAt'
            >
            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
          )>>,
          reportPackages?: Maybe<Array<(
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )>>,
          parties?: Maybe<Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>>,
          datasources?: Maybe<Array<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>>,
          categories?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>>,
          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
          workItems?: Maybe<Array<(
            Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )>>,
          invoices?: Maybe<Array<(
            Pick<
              EntityInvoice,
              | 'id'
              | 'externalDisplayId'
              | 'createdAt'
              | 'dueAt'
            >
            & {
              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              customer: (
                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                & { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              ),
            }
          )>>,
          bills?: Maybe<Array<(
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )>>,
          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
          departments?: Maybe<Array<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          locations?: Maybe<Array<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          reconciliations?: Maybe<Array<(
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )>>,
          ledgerTransactions?: Maybe<Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )>>,
          schedules?: Maybe<Array<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>>,
        }
      )>,
    } };

export type ReadThreadQueryVariables = Exact<{
  id: Scalars['String']['input'];
  allowResolved?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ReadThreadQuery = { thread: (
    { __typename: 'ThreadWithEntities' }
    & {
      thread: (
        { __typename: 'Thread' }
        & Pick<Thread, 'id'>
        & {
          details: (
            Pick<
              ThreadDetails,
              | 'id'
              | 'commentCount'
              | 'resolvedAt'
              | 'authorId'
              | 'commenterIds'
              | 'context'
              | 'pending'
            >
            & {
              targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
              tags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
            }
          ),
          comments: Array<(
            { __typename: 'Comment' }
            & Pick<
              Comment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
              | 'editedAt'
              | 'deletedAt'
              | 'reactions'
            >
            & { layoutAttachment?: Maybe<Pick<LayoutAttachment, 'layoutId' | 'legalEntityId'>> }
          )>,
        }
      ),
      entities?: Maybe<(
        { __typename: 'ObjectEntities' }
        & {
          users?: Maybe<Array<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>>,
          transactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          comments?: Maybe<Array<Pick<
              EntityComment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
            >>>,
          reports?: Maybe<Array<(
            Pick<
              EntityReport,
              | 'id'
              | 'title'
              | 'authorId'
              | 'mimeType'
              | 'createdAt'
            >
            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
          )>>,
          reportPackages?: Maybe<Array<(
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )>>,
          parties?: Maybe<Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>>,
          datasources?: Maybe<Array<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>>,
          categories?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>>,
          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
          workItems?: Maybe<Array<(
            Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )>>,
          invoices?: Maybe<Array<(
            Pick<
              EntityInvoice,
              | 'id'
              | 'externalDisplayId'
              | 'createdAt'
              | 'dueAt'
            >
            & {
              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              customer: (
                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                & { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              ),
            }
          )>>,
          bills?: Maybe<Array<(
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )>>,
          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
          departments?: Maybe<Array<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          locations?: Maybe<Array<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          reconciliations?: Maybe<Array<(
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )>>,
          ledgerTransactions?: Maybe<Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )>>,
          schedules?: Maybe<Array<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>>,
        }
      )>,
    }
  ) };

export type AppAuthorizationFieldsFragment = (
  Pick<AppAuthorization, 'environment'>
  & {
    app: Pick<
        App,
        | 'id'
        | 'organizationId'
        | 'visibility'
        | 'name'
        | 'description'
        | 'homepageURL'
        | 'supportEmail'
        | 'developerEmail'
        | 'privacyPolicyURL'
        | 'termsOfServiceURL'
        | 'iconObjectName'
      >,
    eligibleLegalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
    ineligibleLegalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
  }
);

export type AppCredentialFieldsFragment = Pick<AppCredential, 'environment' | 'clientId' | 'clientSecret'>;

export type AppFieldsFragment = Pick<
    App,
    | 'id'
    | 'organizationId'
    | 'visibility'
    | 'name'
    | 'description'
    | 'homepageURL'
    | 'supportEmail'
    | 'developerEmail'
    | 'privacyPolicyURL'
    | 'termsOfServiceURL'
    | 'iconObjectName'
  >;

export type ConnectionFieldsFragment = (
  Pick<
    Connection,
    | 'id'
    | 'dataSourceId'
    | 'sourceName'
    | 'sourceIconURL'
    | 'description'
    | 'status'
    | 'authorizationRequired'
    | 'authorizationReason'
    | 'authorizationDescription'
    | 'upgradedFromConnectionId'
    | 'scopes'
  >
  & {
    sync?: Maybe<Pick<
        ConnectionSyncState,
        | 'lastSuccessAt'
        | 'lastEventAt'
        | 'status'
        | 'dataLastModifiedAt'
        | 'dataUpdatedAt'
      >>,
    settings?: Maybe<Pick<ConnectionSettings, 'cutoverDate'>>,
    accounts?: Maybe<Array<(
      Pick<
        ConnectionAccount,
        | 'id'
        | 'connectionId'
        | 'sourceAccountId'
        | 'name'
        | 'mask'
        | 'status'
        | 'statusUpdatedAt'
      >
      & {
        settings?: Maybe<(
          Pick<ConnectionAccountSettings, 'cutoverDate'>
          & { labelCategories?: Maybe<Array<(
            Pick<
              LabelCategory,
              | 'label'
              | 'validCategoryTypes'
              | 'displayName'
              | 'required'
              | 'tooltip'
              | 'digitsAi'
            >
            & { category?: Maybe<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >> }
          )>> }
        )>,
        cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>>,
      }
    )>>,
    connector?: Maybe<(
      Pick<
        Connector,
        | 'id'
        | 'name'
        | 'tagline'
        | 'description'
        | 'category'
        | 'iconObjectName'
        | 'className'
        | 'canInstall'
      >
      & { connectorProperties?: Maybe<
        | (
          { __typename: 'AppConnectorProperties' }
          & Pick<
            AppConnectorProperties,
            | 'organizationId'
            | 'visibility'
            | 'homepageURL'
            | 'supportEmail'
            | 'developerEmail'
            | 'privacyPolicyURL'
            | 'termsOfServiceURL'
            | 'scopes'
            | 'redirectUris'
            | 'installUri'
          >
        )
        | (
          { __typename: 'BillConnectorProperties' }
          & Pick<BillConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'EmptyConnectorProperties' }
          & Pick<EmptyConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'FinchConnectorProperties' }
          & Pick<FinchConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'GustoConnectorProperties' }
          & Pick<GustoConnectorProperties, 'authorizationURL'>
        )
        | (
          { __typename: 'PlaidConnectorProperties' }
          & Pick<PlaidConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'RampConnectorProperties' }
          & Pick<RampConnectorProperties, 'authorizationURL'>
        )
        | (
          { __typename: 'StripeConnectorProperties' }
          & Pick<StripeConnectorProperties, 'appLinkURL'>
        )
      > }
    )>,
    connectorUpgrade?: Maybe<(
      Pick<
        Connector,
        | 'id'
        | 'name'
        | 'tagline'
        | 'description'
        | 'category'
        | 'iconObjectName'
        | 'className'
        | 'canInstall'
      >
      & { connectorProperties?: Maybe<
        | (
          { __typename: 'AppConnectorProperties' }
          & Pick<
            AppConnectorProperties,
            | 'organizationId'
            | 'visibility'
            | 'homepageURL'
            | 'supportEmail'
            | 'developerEmail'
            | 'privacyPolicyURL'
            | 'termsOfServiceURL'
            | 'scopes'
            | 'redirectUris'
            | 'installUri'
          >
        )
        | (
          { __typename: 'BillConnectorProperties' }
          & Pick<BillConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'EmptyConnectorProperties' }
          & Pick<EmptyConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'FinchConnectorProperties' }
          & Pick<FinchConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'GustoConnectorProperties' }
          & Pick<GustoConnectorProperties, 'authorizationURL'>
        )
        | (
          { __typename: 'PlaidConnectorProperties' }
          & Pick<PlaidConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'RampConnectorProperties' }
          & Pick<RampConnectorProperties, 'authorizationURL'>
        )
        | (
          { __typename: 'StripeConnectorProperties' }
          & Pick<StripeConnectorProperties, 'appLinkURL'>
        )
      > }
    )>,
  }
);

export type ConnectionAccountFieldsFragment = (
  Pick<
    ConnectionAccount,
    | 'id'
    | 'connectionId'
    | 'sourceAccountId'
    | 'name'
    | 'mask'
    | 'status'
    | 'statusUpdatedAt'
  >
  & {
    settings?: Maybe<(
      Pick<ConnectionAccountSettings, 'cutoverDate'>
      & { labelCategories?: Maybe<Array<(
        Pick<
          LabelCategory,
          | 'label'
          | 'validCategoryTypes'
          | 'displayName'
          | 'required'
          | 'tooltip'
          | 'digitsAi'
        >
        & { category?: Maybe<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >> }
      )>> }
    )>,
    cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>>,
  }
);

export type ConnectionAccountSettingsFieldsFragment = (
  Pick<ConnectionAccountSettings, 'cutoverDate'>
  & { labelCategories?: Maybe<Array<(
    Pick<
      LabelCategory,
      | 'label'
      | 'validCategoryTypes'
      | 'displayName'
      | 'required'
      | 'tooltip'
      | 'digitsAi'
    >
    & { category?: Maybe<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >> }
  )>> }
);

export type LabelCategoryFieldsFragment = (
  Pick<
    LabelCategory,
    | 'label'
    | 'validCategoryTypes'
    | 'displayName'
    | 'required'
    | 'tooltip'
    | 'digitsAi'
  >
  & { category?: Maybe<Pick<
      EntityCategory,
      | 'id'
      | 'name'
      | 'displayKey'
      | 'chartOfAccountsDisplayNumber'
      | 'type'
      | 'subtype'
      | 'parentCategoryId'
      | 'productArea'
      | 'active'
    >> }
);

export type CreateConnectionResponseFieldsFragment = { connection: (
    Pick<
      Connection,
      | 'id'
      | 'dataSourceId'
      | 'sourceName'
      | 'sourceIconURL'
      | 'description'
      | 'status'
      | 'authorizationRequired'
      | 'authorizationReason'
      | 'authorizationDescription'
      | 'upgradedFromConnectionId'
      | 'scopes'
    >
    & {
      sync?: Maybe<Pick<
          ConnectionSyncState,
          | 'lastSuccessAt'
          | 'lastEventAt'
          | 'status'
          | 'dataLastModifiedAt'
          | 'dataUpdatedAt'
        >>,
      settings?: Maybe<Pick<ConnectionSettings, 'cutoverDate'>>,
      accounts?: Maybe<Array<(
        Pick<
          ConnectionAccount,
          | 'id'
          | 'connectionId'
          | 'sourceAccountId'
          | 'name'
          | 'mask'
          | 'status'
          | 'statusUpdatedAt'
        >
        & {
          settings?: Maybe<(
            Pick<ConnectionAccountSettings, 'cutoverDate'>
            & { labelCategories?: Maybe<Array<(
              Pick<
                LabelCategory,
                | 'label'
                | 'validCategoryTypes'
                | 'displayName'
                | 'required'
                | 'tooltip'
                | 'digitsAi'
              >
              & { category?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >> }
            )>> }
          )>,
          cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>>,
        }
      )>>,
      connector?: Maybe<(
        Pick<
          Connector,
          | 'id'
          | 'name'
          | 'tagline'
          | 'description'
          | 'category'
          | 'iconObjectName'
          | 'className'
          | 'canInstall'
        >
        & { connectorProperties?: Maybe<
          | (
            { __typename: 'AppConnectorProperties' }
            & Pick<
              AppConnectorProperties,
              | 'organizationId'
              | 'visibility'
              | 'homepageURL'
              | 'supportEmail'
              | 'developerEmail'
              | 'privacyPolicyURL'
              | 'termsOfServiceURL'
              | 'scopes'
              | 'redirectUris'
              | 'installUri'
            >
          )
          | (
            { __typename: 'BillConnectorProperties' }
            & Pick<BillConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'EmptyConnectorProperties' }
            & Pick<EmptyConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'FinchConnectorProperties' }
            & Pick<FinchConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'GustoConnectorProperties' }
            & Pick<GustoConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'PlaidConnectorProperties' }
            & Pick<PlaidConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'RampConnectorProperties' }
            & Pick<RampConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'StripeConnectorProperties' }
            & Pick<StripeConnectorProperties, 'appLinkURL'>
          )
        > }
      )>,
      connectorUpgrade?: Maybe<(
        Pick<
          Connector,
          | 'id'
          | 'name'
          | 'tagline'
          | 'description'
          | 'category'
          | 'iconObjectName'
          | 'className'
          | 'canInstall'
        >
        & { connectorProperties?: Maybe<
          | (
            { __typename: 'AppConnectorProperties' }
            & Pick<
              AppConnectorProperties,
              | 'organizationId'
              | 'visibility'
              | 'homepageURL'
              | 'supportEmail'
              | 'developerEmail'
              | 'privacyPolicyURL'
              | 'termsOfServiceURL'
              | 'scopes'
              | 'redirectUris'
              | 'installUri'
            >
          )
          | (
            { __typename: 'BillConnectorProperties' }
            & Pick<BillConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'EmptyConnectorProperties' }
            & Pick<EmptyConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'FinchConnectorProperties' }
            & Pick<FinchConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'GustoConnectorProperties' }
            & Pick<GustoConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'PlaidConnectorProperties' }
            & Pick<PlaidConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'RampConnectorProperties' }
            & Pick<RampConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'StripeConnectorProperties' }
            & Pick<StripeConnectorProperties, 'appLinkURL'>
          )
        > }
      )>,
    }
  ) };

export type UpgradeConnectionResponseFieldsFragment = { connection: (
    Pick<
      Connection,
      | 'id'
      | 'dataSourceId'
      | 'sourceName'
      | 'sourceIconURL'
      | 'description'
      | 'status'
      | 'authorizationRequired'
      | 'authorizationReason'
      | 'authorizationDescription'
      | 'upgradedFromConnectionId'
      | 'scopes'
    >
    & {
      sync?: Maybe<Pick<
          ConnectionSyncState,
          | 'lastSuccessAt'
          | 'lastEventAt'
          | 'status'
          | 'dataLastModifiedAt'
          | 'dataUpdatedAt'
        >>,
      settings?: Maybe<Pick<ConnectionSettings, 'cutoverDate'>>,
      accounts?: Maybe<Array<(
        Pick<
          ConnectionAccount,
          | 'id'
          | 'connectionId'
          | 'sourceAccountId'
          | 'name'
          | 'mask'
          | 'status'
          | 'statusUpdatedAt'
        >
        & {
          settings?: Maybe<(
            Pick<ConnectionAccountSettings, 'cutoverDate'>
            & { labelCategories?: Maybe<Array<(
              Pick<
                LabelCategory,
                | 'label'
                | 'validCategoryTypes'
                | 'displayName'
                | 'required'
                | 'tooltip'
                | 'digitsAi'
              >
              & { category?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >> }
            )>> }
          )>,
          cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>>,
        }
      )>>,
      connector?: Maybe<(
        Pick<
          Connector,
          | 'id'
          | 'name'
          | 'tagline'
          | 'description'
          | 'category'
          | 'iconObjectName'
          | 'className'
          | 'canInstall'
        >
        & { connectorProperties?: Maybe<
          | (
            { __typename: 'AppConnectorProperties' }
            & Pick<
              AppConnectorProperties,
              | 'organizationId'
              | 'visibility'
              | 'homepageURL'
              | 'supportEmail'
              | 'developerEmail'
              | 'privacyPolicyURL'
              | 'termsOfServiceURL'
              | 'scopes'
              | 'redirectUris'
              | 'installUri'
            >
          )
          | (
            { __typename: 'BillConnectorProperties' }
            & Pick<BillConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'EmptyConnectorProperties' }
            & Pick<EmptyConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'FinchConnectorProperties' }
            & Pick<FinchConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'GustoConnectorProperties' }
            & Pick<GustoConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'PlaidConnectorProperties' }
            & Pick<PlaidConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'RampConnectorProperties' }
            & Pick<RampConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'StripeConnectorProperties' }
            & Pick<StripeConnectorProperties, 'appLinkURL'>
          )
        > }
      )>,
      connectorUpgrade?: Maybe<(
        Pick<
          Connector,
          | 'id'
          | 'name'
          | 'tagline'
          | 'description'
          | 'category'
          | 'iconObjectName'
          | 'className'
          | 'canInstall'
        >
        & { connectorProperties?: Maybe<
          | (
            { __typename: 'AppConnectorProperties' }
            & Pick<
              AppConnectorProperties,
              | 'organizationId'
              | 'visibility'
              | 'homepageURL'
              | 'supportEmail'
              | 'developerEmail'
              | 'privacyPolicyURL'
              | 'termsOfServiceURL'
              | 'scopes'
              | 'redirectUris'
              | 'installUri'
            >
          )
          | (
            { __typename: 'BillConnectorProperties' }
            & Pick<BillConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'EmptyConnectorProperties' }
            & Pick<EmptyConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'FinchConnectorProperties' }
            & Pick<FinchConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'GustoConnectorProperties' }
            & Pick<GustoConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'PlaidConnectorProperties' }
            & Pick<PlaidConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'RampConnectorProperties' }
            & Pick<RampConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'StripeConnectorProperties' }
            & Pick<StripeConnectorProperties, 'appLinkURL'>
          )
        > }
      )>,
    }
  ) };

export type ConnectionSummaryFieldsFragment = (
  Pick<
    ConnectionSummary,
    | 'id'
    | 'dataSourceId'
    | 'sourceName'
    | 'sourceIconURL'
    | 'description'
    | 'status'
    | 'authorizationRequired'
    | 'authorizationReason'
    | 'authorizationDescription'
    | 'upgradeAvailable'
  >
  & {
    sync?: Maybe<Pick<
        ConnectionSyncState,
        | 'lastSuccessAt'
        | 'lastEventAt'
        | 'status'
        | 'dataLastModifiedAt'
        | 'dataUpdatedAt'
      >>,
    accounts?: Maybe<Array<(
      Pick<
        ConnectionAccountSummary,
        | 'id'
        | 'connectionId'
        | 'sourceAccountId'
        | 'name'
        | 'mask'
        | 'status'
        | 'statusUpdatedAt'
      >
      & { cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>> }
    )>>,
    connector?: Maybe<(
      Pick<
        Connector,
        | 'id'
        | 'name'
        | 'tagline'
        | 'description'
        | 'category'
        | 'iconObjectName'
        | 'className'
        | 'canInstall'
      >
      & { connectorProperties?: Maybe<
        | (
          { __typename: 'AppConnectorProperties' }
          & Pick<
            AppConnectorProperties,
            | 'organizationId'
            | 'visibility'
            | 'homepageURL'
            | 'supportEmail'
            | 'developerEmail'
            | 'privacyPolicyURL'
            | 'termsOfServiceURL'
            | 'scopes'
            | 'redirectUris'
            | 'installUri'
          >
        )
        | (
          { __typename: 'BillConnectorProperties' }
          & Pick<BillConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'EmptyConnectorProperties' }
          & Pick<EmptyConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'FinchConnectorProperties' }
          & Pick<FinchConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'GustoConnectorProperties' }
          & Pick<GustoConnectorProperties, 'authorizationURL'>
        )
        | (
          { __typename: 'PlaidConnectorProperties' }
          & Pick<PlaidConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'RampConnectorProperties' }
          & Pick<RampConnectorProperties, 'authorizationURL'>
        )
        | (
          { __typename: 'StripeConnectorProperties' }
          & Pick<StripeConnectorProperties, 'appLinkURL'>
        )
      > }
    )>,
    connectorUpgrade?: Maybe<(
      Pick<
        Connector,
        | 'id'
        | 'name'
        | 'tagline'
        | 'description'
        | 'category'
        | 'iconObjectName'
        | 'className'
        | 'canInstall'
      >
      & { connectorProperties?: Maybe<
        | (
          { __typename: 'AppConnectorProperties' }
          & Pick<
            AppConnectorProperties,
            | 'organizationId'
            | 'visibility'
            | 'homepageURL'
            | 'supportEmail'
            | 'developerEmail'
            | 'privacyPolicyURL'
            | 'termsOfServiceURL'
            | 'scopes'
            | 'redirectUris'
            | 'installUri'
          >
        )
        | (
          { __typename: 'BillConnectorProperties' }
          & Pick<BillConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'EmptyConnectorProperties' }
          & Pick<EmptyConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'FinchConnectorProperties' }
          & Pick<FinchConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'GustoConnectorProperties' }
          & Pick<GustoConnectorProperties, 'authorizationURL'>
        )
        | (
          { __typename: 'PlaidConnectorProperties' }
          & Pick<PlaidConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'RampConnectorProperties' }
          & Pick<RampConnectorProperties, 'authorizationURL'>
        )
        | (
          { __typename: 'StripeConnectorProperties' }
          & Pick<StripeConnectorProperties, 'appLinkURL'>
        )
      > }
    )>,
  }
);

export type ConnectionAccountSummaryFieldsFragment = (
  Pick<
    ConnectionAccountSummary,
    | 'id'
    | 'connectionId'
    | 'sourceAccountId'
    | 'name'
    | 'mask'
    | 'status'
    | 'statusUpdatedAt'
  >
  & { cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>> }
);

export type ConnectionSyncStateFieldsFragment = Pick<
    ConnectionSyncState,
    | 'lastSuccessAt'
    | 'lastEventAt'
    | 'status'
    | 'dataLastModifiedAt'
    | 'dataUpdatedAt'
  >;

export type ConnectionTemplateFieldsFragment = (
  Pick<ConnectionTemplate, 'externalId'>
  & {
    connector: (
      Pick<
        Connector,
        | 'id'
        | 'name'
        | 'tagline'
        | 'description'
        | 'category'
        | 'iconObjectName'
        | 'className'
        | 'canInstall'
      >
      & { connectorProperties?: Maybe<
        | (
          { __typename: 'AppConnectorProperties' }
          & Pick<
            AppConnectorProperties,
            | 'organizationId'
            | 'visibility'
            | 'homepageURL'
            | 'supportEmail'
            | 'developerEmail'
            | 'privacyPolicyURL'
            | 'termsOfServiceURL'
            | 'scopes'
            | 'redirectUris'
            | 'installUri'
          >
        )
        | (
          { __typename: 'BillConnectorProperties' }
          & Pick<BillConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'EmptyConnectorProperties' }
          & Pick<EmptyConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'FinchConnectorProperties' }
          & Pick<FinchConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'GustoConnectorProperties' }
          & Pick<GustoConnectorProperties, 'authorizationURL'>
        )
        | (
          { __typename: 'PlaidConnectorProperties' }
          & Pick<PlaidConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'RampConnectorProperties' }
          & Pick<RampConnectorProperties, 'authorizationURL'>
        )
        | (
          { __typename: 'StripeConnectorProperties' }
          & Pick<StripeConnectorProperties, 'appLinkURL'>
        )
      > }
    ),
    institution: (
      Pick<
        ProductInstitution,
        | 'id'
        | 'name'
        | 'products'
        | 'routingNumber'
      >
      & { party?: Maybe<Pick<
          Party,
          | 'id'
          | 'legalEntityId'
          | 'name'
          | 'url'
          | 'supportUrl'
          | 'supportEmail'
          | 'supportPhone'
          | 'twitterUrl'
          | 'facebookUrl'
          | 'instagramUrl'
          | 'yelpUrl'
          | 'iconUrl'
          | 'shortDescription'
          | 'designation'
        >> }
    ),
  }
);

export type ConnectorTemplateFieldsFragment = (
  Pick<ConnectionTemplate, 'externalId'>
  & {
    connector: (
      Pick<
        Connector,
        | 'id'
        | 'name'
        | 'tagline'
        | 'description'
        | 'category'
        | 'iconObjectName'
        | 'className'
        | 'canInstall'
      >
      & { connectorProperties?: Maybe<
        | (
          { __typename: 'AppConnectorProperties' }
          & Pick<
            AppConnectorProperties,
            | 'organizationId'
            | 'visibility'
            | 'homepageURL'
            | 'supportEmail'
            | 'developerEmail'
            | 'privacyPolicyURL'
            | 'termsOfServiceURL'
            | 'scopes'
            | 'redirectUris'
            | 'installUri'
          >
        )
        | (
          { __typename: 'BillConnectorProperties' }
          & Pick<BillConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'EmptyConnectorProperties' }
          & Pick<EmptyConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'FinchConnectorProperties' }
          & Pick<FinchConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'GustoConnectorProperties' }
          & Pick<GustoConnectorProperties, 'authorizationURL'>
        )
        | (
          { __typename: 'PlaidConnectorProperties' }
          & Pick<PlaidConnectorProperties, 'empty'>
        )
        | (
          { __typename: 'RampConnectorProperties' }
          & Pick<RampConnectorProperties, 'authorizationURL'>
        )
        | (
          { __typename: 'StripeConnectorProperties' }
          & Pick<StripeConnectorProperties, 'appLinkURL'>
        )
      > }
    ),
    institution: (
      Pick<
        ProductInstitution,
        | 'id'
        | 'name'
        | 'products'
        | 'routingNumber'
      >
      & { party?: Maybe<Pick<
          Party,
          | 'id'
          | 'legalEntityId'
          | 'name'
          | 'url'
          | 'supportUrl'
          | 'supportEmail'
          | 'supportPhone'
          | 'twitterUrl'
          | 'facebookUrl'
          | 'instagramUrl'
          | 'yelpUrl'
          | 'iconUrl'
          | 'shortDescription'
          | 'designation'
        >> }
    ),
  }
);

export type SuggestedConnectionFieldsFragment = { template: (
    Pick<ConnectionTemplate, 'externalId'>
    & {
      connector: (
        Pick<
          Connector,
          | 'id'
          | 'name'
          | 'tagline'
          | 'description'
          | 'category'
          | 'iconObjectName'
          | 'className'
          | 'canInstall'
        >
        & { connectorProperties?: Maybe<
          | (
            { __typename: 'AppConnectorProperties' }
            & Pick<
              AppConnectorProperties,
              | 'organizationId'
              | 'visibility'
              | 'homepageURL'
              | 'supportEmail'
              | 'developerEmail'
              | 'privacyPolicyURL'
              | 'termsOfServiceURL'
              | 'scopes'
              | 'redirectUris'
              | 'installUri'
            >
          )
          | (
            { __typename: 'BillConnectorProperties' }
            & Pick<BillConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'EmptyConnectorProperties' }
            & Pick<EmptyConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'FinchConnectorProperties' }
            & Pick<FinchConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'GustoConnectorProperties' }
            & Pick<GustoConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'PlaidConnectorProperties' }
            & Pick<PlaidConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'RampConnectorProperties' }
            & Pick<RampConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'StripeConnectorProperties' }
            & Pick<StripeConnectorProperties, 'appLinkURL'>
          )
        > }
      ),
      institution: (
        Pick<
          ProductInstitution,
          | 'id'
          | 'name'
          | 'products'
          | 'routingNumber'
        >
        & { party?: Maybe<Pick<
            Party,
            | 'id'
            | 'legalEntityId'
            | 'name'
            | 'url'
            | 'supportUrl'
            | 'supportEmail'
            | 'supportPhone'
            | 'twitterUrl'
            | 'facebookUrl'
            | 'instagramUrl'
            | 'yelpUrl'
            | 'iconUrl'
            | 'shortDescription'
            | 'designation'
          >> }
      ),
    }
  ) };

export type WebhookDeliveryEventFieldsFragment = Pick<
    WebhookDeliveryEvent,
    | 'webhookDeliveryEventId'
    | 'webhookEventId'
    | 'webhookDeliveryId'
    | 'eventType'
    | 'createdAt'
    | 'deliveryStatus'
    | 'endpointUrl'
    | 'httpStatus'
    | 'errorCode'
  >;

export type WebhookEndpointFieldsFragment = (
  Pick<
    WebhookEndpoint,
    | 'webhookEndpointId'
    | 'connectorId'
    | 'environment'
    | 'endpointUrl'
    | 'status'
    | 'statusReason'
    | 'eventCategories'
    | 'createdAt'
    | 'updatedAt'
    | 'signingSecret'
  >
  & { oauthCredential?: Maybe<Pick<WebhookEndpointOAuthCredential, 'tokenEndpointUrl' | 'clientId'>> }
);

export type ActivateRampConnectionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
}>;


export type ActivateRampConnectionMutation = Pick<Mutation, 'activateRampConnection'>;

export type ArchiveConnectionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
}>;


export type ArchiveConnectionMutation = Pick<Mutation, 'archiveConnection'>;

export type ArchiveConnectionAccountMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  connectionAccountId: Scalars['String']['input'];
}>;


export type ArchiveConnectionAccountMutation = Pick<Mutation, 'archiveConnectionAccount'>;

export type AutoConfigureConnectionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
}>;


export type AutoConfigureConnectionMutation = Pick<Mutation, 'autoConfigureConnection'>;

export type CreateAppMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tagline: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  homepageUrl: Scalars['String']['input'];
  supportEmail: Scalars['String']['input'];
  developerEmail: Scalars['String']['input'];
  iconBase64: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  redirectUris?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  installUri?: InputMaybe<Scalars['String']['input']>;
  acceptedTermsOfServiceVersion: Scalars['String']['input'];
}>;


export type CreateAppMutation = Pick<Mutation, 'createApp'>;

export type CreateBillConnectionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type CreateBillConnectionMutation = { createBillConnection: { connection: (
      Pick<
        Connection,
        | 'id'
        | 'dataSourceId'
        | 'sourceName'
        | 'sourceIconURL'
        | 'description'
        | 'status'
        | 'authorizationRequired'
        | 'authorizationReason'
        | 'authorizationDescription'
        | 'upgradedFromConnectionId'
        | 'scopes'
      >
      & {
        sync?: Maybe<Pick<
            ConnectionSyncState,
            | 'lastSuccessAt'
            | 'lastEventAt'
            | 'status'
            | 'dataLastModifiedAt'
            | 'dataUpdatedAt'
          >>,
        settings?: Maybe<Pick<ConnectionSettings, 'cutoverDate'>>,
        accounts?: Maybe<Array<(
          Pick<
            ConnectionAccount,
            | 'id'
            | 'connectionId'
            | 'sourceAccountId'
            | 'name'
            | 'mask'
            | 'status'
            | 'statusUpdatedAt'
          >
          & {
            settings?: Maybe<(
              Pick<ConnectionAccountSettings, 'cutoverDate'>
              & { labelCategories?: Maybe<Array<(
                Pick<
                  LabelCategory,
                  | 'label'
                  | 'validCategoryTypes'
                  | 'displayName'
                  | 'required'
                  | 'tooltip'
                  | 'digitsAi'
                >
                & { category?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >> }
              )>> }
            )>,
            cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>>,
          }
        )>>,
        connector?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
        connectorUpgrade?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
      }
    ) } };

export type CreateConnectPlaidLinkTokenMutationVariables = Exact<{
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  linkCustomizationName?: InputMaybe<Scalars['String']['input']>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  connectorId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateConnectPlaidLinkTokenMutation = { createConnectPlaidLinkToken: Pick<PlaidLinkToken, 'token'> };

export type CreateConnectionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  status: ConnectionStatus;
  institution: ConnectInstitutionInput;
  credential?: InputMaybe<ConnectCredentialInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateConnectionMutation = { createConnection: { connection: (
      Pick<
        Connection,
        | 'id'
        | 'dataSourceId'
        | 'sourceName'
        | 'sourceIconURL'
        | 'description'
        | 'status'
        | 'authorizationRequired'
        | 'authorizationReason'
        | 'authorizationDescription'
        | 'upgradedFromConnectionId'
        | 'scopes'
      >
      & {
        sync?: Maybe<Pick<
            ConnectionSyncState,
            | 'lastSuccessAt'
            | 'lastEventAt'
            | 'status'
            | 'dataLastModifiedAt'
            | 'dataUpdatedAt'
          >>,
        settings?: Maybe<Pick<ConnectionSettings, 'cutoverDate'>>,
        accounts?: Maybe<Array<(
          Pick<
            ConnectionAccount,
            | 'id'
            | 'connectionId'
            | 'sourceAccountId'
            | 'name'
            | 'mask'
            | 'status'
            | 'statusUpdatedAt'
          >
          & {
            settings?: Maybe<(
              Pick<ConnectionAccountSettings, 'cutoverDate'>
              & { labelCategories?: Maybe<Array<(
                Pick<
                  LabelCategory,
                  | 'label'
                  | 'validCategoryTypes'
                  | 'displayName'
                  | 'required'
                  | 'tooltip'
                  | 'digitsAi'
                >
                & { category?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >> }
              )>> }
            )>,
            cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>>,
          }
        )>>,
        connector?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
        connectorUpgrade?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
      }
    ) } };

export type CreateFinchConnectionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  authorizationCode: Scalars['String']['input'];
}>;


export type CreateFinchConnectionMutation = { createFinchConnection: { connection: (
      Pick<
        Connection,
        | 'id'
        | 'dataSourceId'
        | 'sourceName'
        | 'sourceIconURL'
        | 'description'
        | 'status'
        | 'authorizationRequired'
        | 'authorizationReason'
        | 'authorizationDescription'
        | 'upgradedFromConnectionId'
        | 'scopes'
      >
      & {
        sync?: Maybe<Pick<
            ConnectionSyncState,
            | 'lastSuccessAt'
            | 'lastEventAt'
            | 'status'
            | 'dataLastModifiedAt'
            | 'dataUpdatedAt'
          >>,
        settings?: Maybe<Pick<ConnectionSettings, 'cutoverDate'>>,
        accounts?: Maybe<Array<(
          Pick<
            ConnectionAccount,
            | 'id'
            | 'connectionId'
            | 'sourceAccountId'
            | 'name'
            | 'mask'
            | 'status'
            | 'statusUpdatedAt'
          >
          & {
            settings?: Maybe<(
              Pick<ConnectionAccountSettings, 'cutoverDate'>
              & { labelCategories?: Maybe<Array<(
                Pick<
                  LabelCategory,
                  | 'label'
                  | 'validCategoryTypes'
                  | 'displayName'
                  | 'required'
                  | 'tooltip'
                  | 'digitsAi'
                >
                & { category?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >> }
              )>> }
            )>,
            cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>>,
          }
        )>>,
        connector?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
        connectorUpgrade?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
      }
    ) } };

export type CreateFinchSessionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  payrollProvider?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateFinchSessionMutation = { createFinchSession: Pick<FinchConnectToken, 'sessionId'> };

export type CreateGustoConnectionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  authorizationCode: Scalars['String']['input'];
}>;


export type CreateGustoConnectionMutation = { createGustoConnection: { connection: (
      Pick<
        Connection,
        | 'id'
        | 'dataSourceId'
        | 'sourceName'
        | 'sourceIconURL'
        | 'description'
        | 'status'
        | 'authorizationRequired'
        | 'authorizationReason'
        | 'authorizationDescription'
        | 'upgradedFromConnectionId'
        | 'scopes'
      >
      & {
        sync?: Maybe<Pick<
            ConnectionSyncState,
            | 'lastSuccessAt'
            | 'lastEventAt'
            | 'status'
            | 'dataLastModifiedAt'
            | 'dataUpdatedAt'
          >>,
        settings?: Maybe<Pick<ConnectionSettings, 'cutoverDate'>>,
        accounts?: Maybe<Array<(
          Pick<
            ConnectionAccount,
            | 'id'
            | 'connectionId'
            | 'sourceAccountId'
            | 'name'
            | 'mask'
            | 'status'
            | 'statusUpdatedAt'
          >
          & {
            settings?: Maybe<(
              Pick<ConnectionAccountSettings, 'cutoverDate'>
              & { labelCategories?: Maybe<Array<(
                Pick<
                  LabelCategory,
                  | 'label'
                  | 'validCategoryTypes'
                  | 'displayName'
                  | 'required'
                  | 'tooltip'
                  | 'digitsAi'
                >
                & { category?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >> }
              )>> }
            )>,
            cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>>,
          }
        )>>,
        connector?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
        connectorUpgrade?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
      }
    ) } };

export type CreatePlaidConnectionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
  institutionName: Scalars['String']['input'];
  accounts: Array<PlaidAccount> | PlaidAccount;
}>;


export type CreatePlaidConnectionMutation = { createPlaidConnection: { connection: (
      Pick<
        Connection,
        | 'id'
        | 'dataSourceId'
        | 'sourceName'
        | 'sourceIconURL'
        | 'description'
        | 'status'
        | 'authorizationRequired'
        | 'authorizationReason'
        | 'authorizationDescription'
        | 'upgradedFromConnectionId'
        | 'scopes'
      >
      & {
        sync?: Maybe<Pick<
            ConnectionSyncState,
            | 'lastSuccessAt'
            | 'lastEventAt'
            | 'status'
            | 'dataLastModifiedAt'
            | 'dataUpdatedAt'
          >>,
        settings?: Maybe<Pick<ConnectionSettings, 'cutoverDate'>>,
        accounts?: Maybe<Array<(
          Pick<
            ConnectionAccount,
            | 'id'
            | 'connectionId'
            | 'sourceAccountId'
            | 'name'
            | 'mask'
            | 'status'
            | 'statusUpdatedAt'
          >
          & {
            settings?: Maybe<(
              Pick<ConnectionAccountSettings, 'cutoverDate'>
              & { labelCategories?: Maybe<Array<(
                Pick<
                  LabelCategory,
                  | 'label'
                  | 'validCategoryTypes'
                  | 'displayName'
                  | 'required'
                  | 'tooltip'
                  | 'digitsAi'
                >
                & { category?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >> }
              )>> }
            )>,
            cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>>,
          }
        )>>,
        connector?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
        connectorUpgrade?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
      }
    ) } };

export type CreateRampConnectionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  authorizationCode: Scalars['String']['input'];
}>;


export type CreateRampConnectionMutation = { createRampConnection: { connection: (
      Pick<
        Connection,
        | 'id'
        | 'dataSourceId'
        | 'sourceName'
        | 'sourceIconURL'
        | 'description'
        | 'status'
        | 'authorizationRequired'
        | 'authorizationReason'
        | 'authorizationDescription'
        | 'upgradedFromConnectionId'
        | 'scopes'
      >
      & {
        sync?: Maybe<Pick<
            ConnectionSyncState,
            | 'lastSuccessAt'
            | 'lastEventAt'
            | 'status'
            | 'dataLastModifiedAt'
            | 'dataUpdatedAt'
          >>,
        settings?: Maybe<Pick<ConnectionSettings, 'cutoverDate'>>,
        accounts?: Maybe<Array<(
          Pick<
            ConnectionAccount,
            | 'id'
            | 'connectionId'
            | 'sourceAccountId'
            | 'name'
            | 'mask'
            | 'status'
            | 'statusUpdatedAt'
          >
          & {
            settings?: Maybe<(
              Pick<ConnectionAccountSettings, 'cutoverDate'>
              & { labelCategories?: Maybe<Array<(
                Pick<
                  LabelCategory,
                  | 'label'
                  | 'validCategoryTypes'
                  | 'displayName'
                  | 'required'
                  | 'tooltip'
                  | 'digitsAi'
                >
                & { category?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >> }
              )>> }
            )>,
            cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>>,
          }
        )>>,
        connector?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
        connectorUpgrade?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
      }
    ) } };

export type CreateStripeConnectionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
}>;


export type CreateStripeConnectionMutation = { createStripeConnection: { connection: (
      Pick<
        Connection,
        | 'id'
        | 'dataSourceId'
        | 'sourceName'
        | 'sourceIconURL'
        | 'description'
        | 'status'
        | 'authorizationRequired'
        | 'authorizationReason'
        | 'authorizationDescription'
        | 'upgradedFromConnectionId'
        | 'scopes'
      >
      & {
        sync?: Maybe<Pick<
            ConnectionSyncState,
            | 'lastSuccessAt'
            | 'lastEventAt'
            | 'status'
            | 'dataLastModifiedAt'
            | 'dataUpdatedAt'
          >>,
        settings?: Maybe<Pick<ConnectionSettings, 'cutoverDate'>>,
        accounts?: Maybe<Array<(
          Pick<
            ConnectionAccount,
            | 'id'
            | 'connectionId'
            | 'sourceAccountId'
            | 'name'
            | 'mask'
            | 'status'
            | 'statusUpdatedAt'
          >
          & {
            settings?: Maybe<(
              Pick<ConnectionAccountSettings, 'cutoverDate'>
              & { labelCategories?: Maybe<Array<(
                Pick<
                  LabelCategory,
                  | 'label'
                  | 'validCategoryTypes'
                  | 'displayName'
                  | 'required'
                  | 'tooltip'
                  | 'digitsAi'
                >
                & { category?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >> }
              )>> }
            )>,
            cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>>,
          }
        )>>,
        connector?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
        connectorUpgrade?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
      }
    ) } };

export type CreateWebhookEndpointMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  environment: AppEnvironment;
  endpointUrl: Scalars['String']['input'];
  eventCategories: Array<WebhookEventCategory> | WebhookEventCategory;
  oauthClientCredentials?: InputMaybe<WebhookEndpointOAuthClientCredentialsInput>;
}>;


export type CreateWebhookEndpointMutation = { createWebhookEndpoint: (
    Pick<
      WebhookEndpoint,
      | 'webhookEndpointId'
      | 'connectorId'
      | 'environment'
      | 'endpointUrl'
      | 'status'
      | 'statusReason'
      | 'eventCategories'
      | 'createdAt'
      | 'updatedAt'
      | 'signingSecret'
    >
    & { oauthCredential?: Maybe<Pick<WebhookEndpointOAuthCredential, 'tokenEndpointUrl' | 'clientId'>> }
  ) };

export type DeclineAppMutationVariables = Exact<{
  clientId: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeclineAppMutation = { declineApp: Pick<AppRedirect, 'uri'> };

export type DeleteConnectionAccountMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  connectionAccountId: Scalars['String']['input'];
}>;


export type DeleteConnectionAccountMutation = Pick<Mutation, 'deleteConnectionAccount'>;

export type DeleteWebhookEndpointMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  webhookEndpointId: Scalars['String']['input'];
}>;


export type DeleteWebhookEndpointMutation = Pick<Mutation, 'deleteWebhookEndpoint'>;

export type DestroyConnectionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
}>;


export type DestroyConnectionMutation = Pick<Mutation, 'destroyConnection'>;

export type DisableWebhookEndpointMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  webhookEndpointId: Scalars['String']['input'];
}>;


export type DisableWebhookEndpointMutation = { disableWebhookEndpoint: (
    Pick<
      WebhookEndpoint,
      | 'webhookEndpointId'
      | 'connectorId'
      | 'environment'
      | 'endpointUrl'
      | 'status'
      | 'statusReason'
      | 'eventCategories'
      | 'createdAt'
      | 'updatedAt'
      | 'signingSecret'
    >
    & { oauthCredential?: Maybe<Pick<WebhookEndpointOAuthCredential, 'tokenEndpointUrl' | 'clientId'>> }
  ) };

export type EnableWebhookEndpointMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  webhookEndpointId: Scalars['String']['input'];
}>;


export type EnableWebhookEndpointMutation = { enableWebhookEndpoint: (
    Pick<
      WebhookEndpoint,
      | 'webhookEndpointId'
      | 'connectorId'
      | 'environment'
      | 'endpointUrl'
      | 'status'
      | 'statusReason'
      | 'eventCategories'
      | 'createdAt'
      | 'updatedAt'
      | 'signingSecret'
    >
    & { oauthCredential?: Maybe<Pick<WebhookEndpointOAuthCredential, 'tokenEndpointUrl' | 'clientId'>> }
  ) };

export type InstallAppMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  responseType: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type InstallAppMutation = { installApp: Pick<AppRedirect, 'uri'> };

export type ReauthorizeFinchSessionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
}>;


export type ReauthorizeFinchSessionMutation = { reauthorizeFinchSession: Pick<FinchConnectToken, 'sessionId'> };

export type RetryWebhookEndpointDeliveryMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  webhookEndpointId: Scalars['String']['input'];
  webhookDeliveryId: Scalars['String']['input'];
}>;


export type RetryWebhookEndpointDeliveryMutation = Pick<Mutation, 'retryWebhookEndpointDelivery'>;

export type RotateWebhookEndpointSecretMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  webhookEndpointId: Scalars['String']['input'];
}>;


export type RotateWebhookEndpointSecretMutation = Pick<Mutation, 'rotateWebhookEndpointSecret'>;

export type SendWebhookEndpointTestEventMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  webhookEndpointId: Scalars['String']['input'];
}>;


export type SendWebhookEndpointTestEventMutation = Pick<Mutation, 'sendWebhookEndpointTestEvent'>;

export type SyncConnectionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
}>;


export type SyncConnectionMutation = Pick<Mutation, 'syncConnection'>;

export type UpdateAppMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tagline: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  homepageUrl?: InputMaybe<Scalars['String']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  developerEmail?: InputMaybe<Scalars['String']['input']>;
  iconBase64?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyURL?: InputMaybe<Scalars['String']['input']>;
  termsOfServiceURL?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  redirectUris?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  installUri?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAppMutation = Pick<Mutation, 'updateApp'>;

export type UpdateConnectPlaidLinkTokenMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
}>;


export type UpdateConnectPlaidLinkTokenMutation = { updateConnectPlaidLinkToken: Pick<PlaidLinkToken, 'token'> };

export type UpdateConnectionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  settings: ConnectionSettingsInput;
}>;


export type UpdateConnectionMutation = Pick<Mutation, 'updateConnection'>;

export type UpdateConnectionAccountsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  accounts: Array<ConnectionAccountInput> | ConnectionAccountInput;
}>;


export type UpdateConnectionAccountsMutation = Pick<Mutation, 'updateConnectionAccounts'>;

export type UpdateConnectionCutoverTimeMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  cutoverTime: Scalars['DateTime']['input'];
}>;


export type UpdateConnectionCutoverTimeMutation = Pick<Mutation, 'updateConnectionCutoverTime'>;

export type UpdateFinchConnectionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  authorizationCode: Scalars['String']['input'];
}>;


export type UpdateFinchConnectionMutation = { updateFinchConnection: { connection: (
      Pick<
        Connection,
        | 'id'
        | 'dataSourceId'
        | 'sourceName'
        | 'sourceIconURL'
        | 'description'
        | 'status'
        | 'authorizationRequired'
        | 'authorizationReason'
        | 'authorizationDescription'
        | 'upgradedFromConnectionId'
        | 'scopes'
      >
      & {
        sync?: Maybe<Pick<
            ConnectionSyncState,
            | 'lastSuccessAt'
            | 'lastEventAt'
            | 'status'
            | 'dataLastModifiedAt'
            | 'dataUpdatedAt'
          >>,
        settings?: Maybe<Pick<ConnectionSettings, 'cutoverDate'>>,
        accounts?: Maybe<Array<(
          Pick<
            ConnectionAccount,
            | 'id'
            | 'connectionId'
            | 'sourceAccountId'
            | 'name'
            | 'mask'
            | 'status'
            | 'statusUpdatedAt'
          >
          & {
            settings?: Maybe<(
              Pick<ConnectionAccountSettings, 'cutoverDate'>
              & { labelCategories?: Maybe<Array<(
                Pick<
                  LabelCategory,
                  | 'label'
                  | 'validCategoryTypes'
                  | 'displayName'
                  | 'required'
                  | 'tooltip'
                  | 'digitsAi'
                >
                & { category?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >> }
              )>> }
            )>,
            cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>>,
          }
        )>>,
        connector?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
        connectorUpgrade?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
      }
    ) } };

export type UpdatePlaidConnectionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  accounts: Array<PlaidAccount> | PlaidAccount;
}>;


export type UpdatePlaidConnectionMutation = Pick<Mutation, 'updatePlaidConnection'>;

export type UpdateWebhookEndpointMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  webhookEndpointId: Scalars['String']['input'];
  endpointUrl: Scalars['String']['input'];
  eventCategories: Array<WebhookEventCategory> | WebhookEventCategory;
}>;


export type UpdateWebhookEndpointMutation = { updateWebhookEndpoint: (
    Pick<
      WebhookEndpoint,
      | 'webhookEndpointId'
      | 'connectorId'
      | 'environment'
      | 'endpointUrl'
      | 'status'
      | 'statusReason'
      | 'eventCategories'
      | 'createdAt'
      | 'updatedAt'
      | 'signingSecret'
    >
    & { oauthCredential?: Maybe<Pick<WebhookEndpointOAuthCredential, 'tokenEndpointUrl' | 'clientId'>> }
  ) };

export type UpdateWebhookEndpointOAuthCredentialMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  webhookEndpointId: Scalars['String']['input'];
  oauthClientCredentials?: InputMaybe<WebhookEndpointOAuthClientCredentialsInput>;
}>;


export type UpdateWebhookEndpointOAuthCredentialMutation = { updateWebhookEndpointOAuthCredential: (
    Pick<
      WebhookEndpoint,
      | 'webhookEndpointId'
      | 'connectorId'
      | 'environment'
      | 'endpointUrl'
      | 'status'
      | 'statusReason'
      | 'eventCategories'
      | 'createdAt'
      | 'updatedAt'
      | 'signingSecret'
    >
    & { oauthCredential?: Maybe<Pick<WebhookEndpointOAuthCredential, 'tokenEndpointUrl' | 'clientId'>> }
  ) };

export type UpgradeGustoConnectionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  authorizationCode: Scalars['String']['input'];
}>;


export type UpgradeGustoConnectionMutation = { upgradeGustoConnection: { connection: (
      Pick<
        Connection,
        | 'id'
        | 'dataSourceId'
        | 'sourceName'
        | 'sourceIconURL'
        | 'description'
        | 'status'
        | 'authorizationRequired'
        | 'authorizationReason'
        | 'authorizationDescription'
        | 'upgradedFromConnectionId'
        | 'scopes'
      >
      & {
        sync?: Maybe<Pick<
            ConnectionSyncState,
            | 'lastSuccessAt'
            | 'lastEventAt'
            | 'status'
            | 'dataLastModifiedAt'
            | 'dataUpdatedAt'
          >>,
        settings?: Maybe<Pick<ConnectionSettings, 'cutoverDate'>>,
        accounts?: Maybe<Array<(
          Pick<
            ConnectionAccount,
            | 'id'
            | 'connectionId'
            | 'sourceAccountId'
            | 'name'
            | 'mask'
            | 'status'
            | 'statusUpdatedAt'
          >
          & {
            settings?: Maybe<(
              Pick<ConnectionAccountSettings, 'cutoverDate'>
              & { labelCategories?: Maybe<Array<(
                Pick<
                  LabelCategory,
                  | 'label'
                  | 'validCategoryTypes'
                  | 'displayName'
                  | 'required'
                  | 'tooltip'
                  | 'digitsAi'
                >
                & { category?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >> }
              )>> }
            )>,
            cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>>,
          }
        )>>,
        connector?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
        connectorUpgrade?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
      }
    ) } };

export type UpgradeStripeConnectionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
}>;


export type UpgradeStripeConnectionMutation = { upgradeStripeConnection: { connection: (
      Pick<
        Connection,
        | 'id'
        | 'dataSourceId'
        | 'sourceName'
        | 'sourceIconURL'
        | 'description'
        | 'status'
        | 'authorizationRequired'
        | 'authorizationReason'
        | 'authorizationDescription'
        | 'upgradedFromConnectionId'
        | 'scopes'
      >
      & {
        sync?: Maybe<Pick<
            ConnectionSyncState,
            | 'lastSuccessAt'
            | 'lastEventAt'
            | 'status'
            | 'dataLastModifiedAt'
            | 'dataUpdatedAt'
          >>,
        settings?: Maybe<Pick<ConnectionSettings, 'cutoverDate'>>,
        accounts?: Maybe<Array<(
          Pick<
            ConnectionAccount,
            | 'id'
            | 'connectionId'
            | 'sourceAccountId'
            | 'name'
            | 'mask'
            | 'status'
            | 'statusUpdatedAt'
          >
          & {
            settings?: Maybe<(
              Pick<ConnectionAccountSettings, 'cutoverDate'>
              & { labelCategories?: Maybe<Array<(
                Pick<
                  LabelCategory,
                  | 'label'
                  | 'validCategoryTypes'
                  | 'displayName'
                  | 'required'
                  | 'tooltip'
                  | 'digitsAi'
                >
                & { category?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >> }
              )>> }
            )>,
            cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>>,
          }
        )>>,
        connector?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
        connectorUpgrade?: Maybe<(
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        )>,
      }
    ) } };

export type FindConnectionsByInstitutionQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  institutionName: Scalars['String']['input'];
}>;


export type FindConnectionsByInstitutionQuery = { findConnectionsByInstitution: Array<(
    Pick<
      ConnectionSummary,
      | 'id'
      | 'dataSourceId'
      | 'sourceName'
      | 'sourceIconURL'
      | 'description'
      | 'status'
      | 'authorizationRequired'
      | 'authorizationReason'
      | 'authorizationDescription'
      | 'upgradeAvailable'
    >
    & {
      sync?: Maybe<Pick<
          ConnectionSyncState,
          | 'lastSuccessAt'
          | 'lastEventAt'
          | 'status'
          | 'dataLastModifiedAt'
          | 'dataUpdatedAt'
        >>,
      accounts?: Maybe<Array<(
        Pick<
          ConnectionAccountSummary,
          | 'id'
          | 'connectionId'
          | 'sourceAccountId'
          | 'name'
          | 'mask'
          | 'status'
          | 'statusUpdatedAt'
        >
        & { cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>> }
      )>>,
      connector?: Maybe<(
        Pick<
          Connector,
          | 'id'
          | 'name'
          | 'tagline'
          | 'description'
          | 'category'
          | 'iconObjectName'
          | 'className'
          | 'canInstall'
        >
        & { connectorProperties?: Maybe<
          | (
            { __typename: 'AppConnectorProperties' }
            & Pick<
              AppConnectorProperties,
              | 'organizationId'
              | 'visibility'
              | 'homepageURL'
              | 'supportEmail'
              | 'developerEmail'
              | 'privacyPolicyURL'
              | 'termsOfServiceURL'
              | 'scopes'
              | 'redirectUris'
              | 'installUri'
            >
          )
          | (
            { __typename: 'BillConnectorProperties' }
            & Pick<BillConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'EmptyConnectorProperties' }
            & Pick<EmptyConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'FinchConnectorProperties' }
            & Pick<FinchConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'GustoConnectorProperties' }
            & Pick<GustoConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'PlaidConnectorProperties' }
            & Pick<PlaidConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'RampConnectorProperties' }
            & Pick<RampConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'StripeConnectorProperties' }
            & Pick<StripeConnectorProperties, 'appLinkURL'>
          )
        > }
      )>,
      connectorUpgrade?: Maybe<(
        Pick<
          Connector,
          | 'id'
          | 'name'
          | 'tagline'
          | 'description'
          | 'category'
          | 'iconObjectName'
          | 'className'
          | 'canInstall'
        >
        & { connectorProperties?: Maybe<
          | (
            { __typename: 'AppConnectorProperties' }
            & Pick<
              AppConnectorProperties,
              | 'organizationId'
              | 'visibility'
              | 'homepageURL'
              | 'supportEmail'
              | 'developerEmail'
              | 'privacyPolicyURL'
              | 'termsOfServiceURL'
              | 'scopes'
              | 'redirectUris'
              | 'installUri'
            >
          )
          | (
            { __typename: 'BillConnectorProperties' }
            & Pick<BillConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'EmptyConnectorProperties' }
            & Pick<EmptyConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'FinchConnectorProperties' }
            & Pick<FinchConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'GustoConnectorProperties' }
            & Pick<GustoConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'PlaidConnectorProperties' }
            & Pick<PlaidConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'RampConnectorProperties' }
            & Pick<RampConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'StripeConnectorProperties' }
            & Pick<StripeConnectorProperties, 'appLinkURL'>
          )
        > }
      )>,
    }
  )> };

export type ListAppsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ListAppsQuery = { listApps: Array<(
    Pick<
      Connector,
      | 'id'
      | 'name'
      | 'tagline'
      | 'description'
      | 'category'
      | 'iconObjectName'
      | 'className'
      | 'canInstall'
    >
    & { connectorProperties?: Maybe<
      | (
        { __typename: 'AppConnectorProperties' }
        & Pick<
          AppConnectorProperties,
          | 'organizationId'
          | 'visibility'
          | 'homepageURL'
          | 'supportEmail'
          | 'developerEmail'
          | 'privacyPolicyURL'
          | 'termsOfServiceURL'
          | 'scopes'
          | 'redirectUris'
          | 'installUri'
        >
      )
      | (
        { __typename: 'BillConnectorProperties' }
        & Pick<BillConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'EmptyConnectorProperties' }
        & Pick<EmptyConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'FinchConnectorProperties' }
        & Pick<FinchConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'GustoConnectorProperties' }
        & Pick<GustoConnectorProperties, 'authorizationURL'>
      )
      | (
        { __typename: 'PlaidConnectorProperties' }
        & Pick<PlaidConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'RampConnectorProperties' }
        & Pick<RampConnectorProperties, 'authorizationURL'>
      )
      | (
        { __typename: 'StripeConnectorProperties' }
        & Pick<StripeConnectorProperties, 'appLinkURL'>
      )
    > }
  )> };

export type ListAuthConnectionsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListAuthConnectionsQuery = { listAuthConnections: Array<(
    Pick<
      ConnectionSummary,
      | 'id'
      | 'dataSourceId'
      | 'sourceName'
      | 'sourceIconURL'
      | 'description'
      | 'status'
      | 'authorizationRequired'
      | 'authorizationReason'
      | 'authorizationDescription'
      | 'upgradeAvailable'
    >
    & {
      sync?: Maybe<Pick<
          ConnectionSyncState,
          | 'lastSuccessAt'
          | 'lastEventAt'
          | 'status'
          | 'dataLastModifiedAt'
          | 'dataUpdatedAt'
        >>,
      accounts?: Maybe<Array<(
        Pick<
          ConnectionAccountSummary,
          | 'id'
          | 'connectionId'
          | 'sourceAccountId'
          | 'name'
          | 'mask'
          | 'status'
          | 'statusUpdatedAt'
        >
        & { cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>> }
      )>>,
      connector?: Maybe<(
        Pick<
          Connector,
          | 'id'
          | 'name'
          | 'tagline'
          | 'description'
          | 'category'
          | 'iconObjectName'
          | 'className'
          | 'canInstall'
        >
        & { connectorProperties?: Maybe<
          | (
            { __typename: 'AppConnectorProperties' }
            & Pick<
              AppConnectorProperties,
              | 'organizationId'
              | 'visibility'
              | 'homepageURL'
              | 'supportEmail'
              | 'developerEmail'
              | 'privacyPolicyURL'
              | 'termsOfServiceURL'
              | 'scopes'
              | 'redirectUris'
              | 'installUri'
            >
          )
          | (
            { __typename: 'BillConnectorProperties' }
            & Pick<BillConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'EmptyConnectorProperties' }
            & Pick<EmptyConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'FinchConnectorProperties' }
            & Pick<FinchConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'GustoConnectorProperties' }
            & Pick<GustoConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'PlaidConnectorProperties' }
            & Pick<PlaidConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'RampConnectorProperties' }
            & Pick<RampConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'StripeConnectorProperties' }
            & Pick<StripeConnectorProperties, 'appLinkURL'>
          )
        > }
      )>,
      connectorUpgrade?: Maybe<(
        Pick<
          Connector,
          | 'id'
          | 'name'
          | 'tagline'
          | 'description'
          | 'category'
          | 'iconObjectName'
          | 'className'
          | 'canInstall'
        >
        & { connectorProperties?: Maybe<
          | (
            { __typename: 'AppConnectorProperties' }
            & Pick<
              AppConnectorProperties,
              | 'organizationId'
              | 'visibility'
              | 'homepageURL'
              | 'supportEmail'
              | 'developerEmail'
              | 'privacyPolicyURL'
              | 'termsOfServiceURL'
              | 'scopes'
              | 'redirectUris'
              | 'installUri'
            >
          )
          | (
            { __typename: 'BillConnectorProperties' }
            & Pick<BillConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'EmptyConnectorProperties' }
            & Pick<EmptyConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'FinchConnectorProperties' }
            & Pick<FinchConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'GustoConnectorProperties' }
            & Pick<GustoConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'PlaidConnectorProperties' }
            & Pick<PlaidConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'RampConnectorProperties' }
            & Pick<RampConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'StripeConnectorProperties' }
            & Pick<StripeConnectorProperties, 'appLinkURL'>
          )
        > }
      )>,
    }
  )> };

export type ListConnectionsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  filter?: InputMaybe<ListConnectionsFilter>;
}>;


export type ListConnectionsQuery = { listConnections: Array<(
    Pick<
      ConnectionSummary,
      | 'id'
      | 'dataSourceId'
      | 'sourceName'
      | 'sourceIconURL'
      | 'description'
      | 'status'
      | 'authorizationRequired'
      | 'authorizationReason'
      | 'authorizationDescription'
      | 'upgradeAvailable'
    >
    & {
      sync?: Maybe<Pick<
          ConnectionSyncState,
          | 'lastSuccessAt'
          | 'lastEventAt'
          | 'status'
          | 'dataLastModifiedAt'
          | 'dataUpdatedAt'
        >>,
      accounts?: Maybe<Array<(
        Pick<
          ConnectionAccountSummary,
          | 'id'
          | 'connectionId'
          | 'sourceAccountId'
          | 'name'
          | 'mask'
          | 'status'
          | 'statusUpdatedAt'
        >
        & { cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>> }
      )>>,
      connector?: Maybe<(
        Pick<
          Connector,
          | 'id'
          | 'name'
          | 'tagline'
          | 'description'
          | 'category'
          | 'iconObjectName'
          | 'className'
          | 'canInstall'
        >
        & { connectorProperties?: Maybe<
          | (
            { __typename: 'AppConnectorProperties' }
            & Pick<
              AppConnectorProperties,
              | 'organizationId'
              | 'visibility'
              | 'homepageURL'
              | 'supportEmail'
              | 'developerEmail'
              | 'privacyPolicyURL'
              | 'termsOfServiceURL'
              | 'scopes'
              | 'redirectUris'
              | 'installUri'
            >
          )
          | (
            { __typename: 'BillConnectorProperties' }
            & Pick<BillConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'EmptyConnectorProperties' }
            & Pick<EmptyConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'FinchConnectorProperties' }
            & Pick<FinchConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'GustoConnectorProperties' }
            & Pick<GustoConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'PlaidConnectorProperties' }
            & Pick<PlaidConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'RampConnectorProperties' }
            & Pick<RampConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'StripeConnectorProperties' }
            & Pick<StripeConnectorProperties, 'appLinkURL'>
          )
        > }
      )>,
      connectorUpgrade?: Maybe<(
        Pick<
          Connector,
          | 'id'
          | 'name'
          | 'tagline'
          | 'description'
          | 'category'
          | 'iconObjectName'
          | 'className'
          | 'canInstall'
        >
        & { connectorProperties?: Maybe<
          | (
            { __typename: 'AppConnectorProperties' }
            & Pick<
              AppConnectorProperties,
              | 'organizationId'
              | 'visibility'
              | 'homepageURL'
              | 'supportEmail'
              | 'developerEmail'
              | 'privacyPolicyURL'
              | 'termsOfServiceURL'
              | 'scopes'
              | 'redirectUris'
              | 'installUri'
            >
          )
          | (
            { __typename: 'BillConnectorProperties' }
            & Pick<BillConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'EmptyConnectorProperties' }
            & Pick<EmptyConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'FinchConnectorProperties' }
            & Pick<FinchConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'GustoConnectorProperties' }
            & Pick<GustoConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'PlaidConnectorProperties' }
            & Pick<PlaidConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'RampConnectorProperties' }
            & Pick<RampConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'StripeConnectorProperties' }
            & Pick<StripeConnectorProperties, 'appLinkURL'>
          )
        > }
      )>,
    }
  )> };

export type ListConnectorInstallCandidatesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListConnectorInstallCandidatesQuery = { listConnectorInstallCandidates: {
      templates: Array<(
        Pick<ConnectionTemplate, 'externalId'>
        & {
          connector: (
            Pick<
              Connector,
              | 'id'
              | 'name'
              | 'tagline'
              | 'description'
              | 'category'
              | 'iconObjectName'
              | 'className'
              | 'canInstall'
            >
            & { connectorProperties?: Maybe<
              | (
                { __typename: 'AppConnectorProperties' }
                & Pick<
                  AppConnectorProperties,
                  | 'organizationId'
                  | 'visibility'
                  | 'homepageURL'
                  | 'supportEmail'
                  | 'developerEmail'
                  | 'privacyPolicyURL'
                  | 'termsOfServiceURL'
                  | 'scopes'
                  | 'redirectUris'
                  | 'installUri'
                >
              )
              | (
                { __typename: 'BillConnectorProperties' }
                & Pick<BillConnectorProperties, 'empty'>
              )
              | (
                { __typename: 'EmptyConnectorProperties' }
                & Pick<EmptyConnectorProperties, 'empty'>
              )
              | (
                { __typename: 'FinchConnectorProperties' }
                & Pick<FinchConnectorProperties, 'empty'>
              )
              | (
                { __typename: 'GustoConnectorProperties' }
                & Pick<GustoConnectorProperties, 'authorizationURL'>
              )
              | (
                { __typename: 'PlaidConnectorProperties' }
                & Pick<PlaidConnectorProperties, 'empty'>
              )
              | (
                { __typename: 'RampConnectorProperties' }
                & Pick<RampConnectorProperties, 'authorizationURL'>
              )
              | (
                { __typename: 'StripeConnectorProperties' }
                & Pick<StripeConnectorProperties, 'appLinkURL'>
              )
            > }
          ),
          institution: (
            Pick<
              ProductInstitution,
              | 'id'
              | 'name'
              | 'products'
              | 'routingNumber'
            >
            & { party?: Maybe<Pick<
                Party,
                | 'id'
                | 'legalEntityId'
                | 'name'
                | 'url'
                | 'supportUrl'
                | 'supportEmail'
                | 'supportPhone'
                | 'twitterUrl'
                | 'facebookUrl'
                | 'instagramUrl'
                | 'yelpUrl'
                | 'iconUrl'
                | 'shortDescription'
                | 'designation'
              >> }
          ),
        }
      )>,
      appConnectors: Array<(
        Pick<
          Connector,
          | 'id'
          | 'name'
          | 'tagline'
          | 'description'
          | 'category'
          | 'iconObjectName'
          | 'className'
          | 'canInstall'
        >
        & { connectorProperties?: Maybe<
          | (
            { __typename: 'AppConnectorProperties' }
            & Pick<
              AppConnectorProperties,
              | 'organizationId'
              | 'visibility'
              | 'homepageURL'
              | 'supportEmail'
              | 'developerEmail'
              | 'privacyPolicyURL'
              | 'termsOfServiceURL'
              | 'scopes'
              | 'redirectUris'
              | 'installUri'
            >
          )
          | (
            { __typename: 'BillConnectorProperties' }
            & Pick<BillConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'EmptyConnectorProperties' }
            & Pick<EmptyConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'FinchConnectorProperties' }
            & Pick<FinchConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'GustoConnectorProperties' }
            & Pick<GustoConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'PlaidConnectorProperties' }
            & Pick<PlaidConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'RampConnectorProperties' }
            & Pick<RampConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'StripeConnectorProperties' }
            & Pick<StripeConnectorProperties, 'appLinkURL'>
          )
        > }
      )>,
    } };

export type ListConnectorTemplatesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListConnectorTemplatesQuery = { listConnectorTemplates: Array<(
    Pick<ConnectionTemplate, 'externalId'>
    & {
      connector: (
        Pick<
          Connector,
          | 'id'
          | 'name'
          | 'tagline'
          | 'description'
          | 'category'
          | 'iconObjectName'
          | 'className'
          | 'canInstall'
        >
        & { connectorProperties?: Maybe<
          | (
            { __typename: 'AppConnectorProperties' }
            & Pick<
              AppConnectorProperties,
              | 'organizationId'
              | 'visibility'
              | 'homepageURL'
              | 'supportEmail'
              | 'developerEmail'
              | 'privacyPolicyURL'
              | 'termsOfServiceURL'
              | 'scopes'
              | 'redirectUris'
              | 'installUri'
            >
          )
          | (
            { __typename: 'BillConnectorProperties' }
            & Pick<BillConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'EmptyConnectorProperties' }
            & Pick<EmptyConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'FinchConnectorProperties' }
            & Pick<FinchConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'GustoConnectorProperties' }
            & Pick<GustoConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'PlaidConnectorProperties' }
            & Pick<PlaidConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'RampConnectorProperties' }
            & Pick<RampConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'StripeConnectorProperties' }
            & Pick<StripeConnectorProperties, 'appLinkURL'>
          )
        > }
      ),
      institution: (
        Pick<
          ProductInstitution,
          | 'id'
          | 'name'
          | 'products'
          | 'routingNumber'
        >
        & { party?: Maybe<Pick<
            Party,
            | 'id'
            | 'legalEntityId'
            | 'name'
            | 'url'
            | 'supportUrl'
            | 'supportEmail'
            | 'supportPhone'
            | 'twitterUrl'
            | 'facebookUrl'
            | 'instagramUrl'
            | 'yelpUrl'
            | 'iconUrl'
            | 'shortDescription'
            | 'designation'
          >> }
      ),
    }
  )> };

export type ListConnectorsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListConnectorsQuery = { listConnectors: Array<(
    Pick<
      Connector,
      | 'id'
      | 'name'
      | 'tagline'
      | 'description'
      | 'category'
      | 'iconObjectName'
      | 'className'
      | 'canInstall'
    >
    & { connectorProperties?: Maybe<
      | (
        { __typename: 'AppConnectorProperties' }
        & Pick<
          AppConnectorProperties,
          | 'organizationId'
          | 'visibility'
          | 'homepageURL'
          | 'supportEmail'
          | 'developerEmail'
          | 'privacyPolicyURL'
          | 'termsOfServiceURL'
          | 'scopes'
          | 'redirectUris'
          | 'installUri'
        >
      )
      | (
        { __typename: 'BillConnectorProperties' }
        & Pick<BillConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'EmptyConnectorProperties' }
        & Pick<EmptyConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'FinchConnectorProperties' }
        & Pick<FinchConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'GustoConnectorProperties' }
        & Pick<GustoConnectorProperties, 'authorizationURL'>
      )
      | (
        { __typename: 'PlaidConnectorProperties' }
        & Pick<PlaidConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'RampConnectorProperties' }
        & Pick<RampConnectorProperties, 'authorizationURL'>
      )
      | (
        { __typename: 'StripeConnectorProperties' }
        & Pick<StripeConnectorProperties, 'appLinkURL'>
      )
    > }
  )> };

export type ListPaymentConnectorsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListPaymentConnectorsQuery = { listConnectors: Array<(
    Pick<
      Connector,
      | 'id'
      | 'name'
      | 'tagline'
      | 'description'
      | 'category'
      | 'iconObjectName'
      | 'className'
      | 'canInstall'
    >
    & { connectorProperties?: Maybe<
      | (
        { __typename: 'AppConnectorProperties' }
        & Pick<
          AppConnectorProperties,
          | 'organizationId'
          | 'visibility'
          | 'homepageURL'
          | 'supportEmail'
          | 'developerEmail'
          | 'privacyPolicyURL'
          | 'termsOfServiceURL'
          | 'scopes'
          | 'redirectUris'
          | 'installUri'
        >
      )
      | (
        { __typename: 'BillConnectorProperties' }
        & Pick<BillConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'EmptyConnectorProperties' }
        & Pick<EmptyConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'FinchConnectorProperties' }
        & Pick<FinchConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'GustoConnectorProperties' }
        & Pick<GustoConnectorProperties, 'authorizationURL'>
      )
      | (
        { __typename: 'PlaidConnectorProperties' }
        & Pick<PlaidConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'RampConnectorProperties' }
        & Pick<RampConnectorProperties, 'authorizationURL'>
      )
      | (
        { __typename: 'StripeConnectorProperties' }
        & Pick<StripeConnectorProperties, 'appLinkURL'>
      )
    > }
  )> };

export type ListWebhookEndpointDeliveryEventsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
  webhookEndpointId: Scalars['String']['input'];
  pagination: Pagination;
}>;


export type ListWebhookEndpointDeliveryEventsQuery = { listWebhookEndpointDeliveryEvents: Array<Pick<
      WebhookDeliveryEvent,
      | 'webhookDeliveryEventId'
      | 'webhookEventId'
      | 'webhookDeliveryId'
      | 'eventType'
      | 'createdAt'
      | 'deliveryStatus'
      | 'endpointUrl'
      | 'httpStatus'
      | 'errorCode'
    >> };

export type ListWebhookEndpointsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
}>;


export type ListWebhookEndpointsQuery = { listWebhookEndpoints: Array<(
    Pick<
      WebhookEndpoint,
      | 'webhookEndpointId'
      | 'connectorId'
      | 'environment'
      | 'endpointUrl'
      | 'status'
      | 'statusReason'
      | 'eventCategories'
      | 'createdAt'
      | 'updatedAt'
      | 'signingSecret'
    >
    & { oauthCredential?: Maybe<Pick<WebhookEndpointOAuthCredential, 'tokenEndpointUrl' | 'clientId'>> }
  )> };

export type OnboardConnectionsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  institutionProducts: Array<InstitutionProduct> | InstitutionProduct;
}>;


export type OnboardConnectionsQuery = { onboardConnections: Array<{ template: (
      Pick<ConnectionTemplate, 'externalId'>
      & {
        connector: (
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        ),
        institution: (
          Pick<
            ProductInstitution,
            | 'id'
            | 'name'
            | 'products'
            | 'routingNumber'
          >
          & { party?: Maybe<Pick<
              Party,
              | 'id'
              | 'legalEntityId'
              | 'name'
              | 'url'
              | 'supportUrl'
              | 'supportEmail'
              | 'supportPhone'
              | 'twitterUrl'
              | 'facebookUrl'
              | 'instagramUrl'
              | 'yelpUrl'
              | 'iconUrl'
              | 'shortDescription'
              | 'designation'
            >> }
        ),
      }
    ) }> };

export type ReadAppQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
}>;


export type ReadAppQuery = { readApp: (
    Pick<
      Connector,
      | 'id'
      | 'name'
      | 'tagline'
      | 'description'
      | 'category'
      | 'iconObjectName'
      | 'className'
      | 'canInstall'
    >
    & { connectorProperties?: Maybe<
      | (
        { __typename: 'AppConnectorProperties' }
        & Pick<
          AppConnectorProperties,
          | 'organizationId'
          | 'visibility'
          | 'homepageURL'
          | 'supportEmail'
          | 'developerEmail'
          | 'privacyPolicyURL'
          | 'termsOfServiceURL'
          | 'scopes'
          | 'redirectUris'
          | 'installUri'
        >
      )
      | (
        { __typename: 'BillConnectorProperties' }
        & Pick<BillConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'EmptyConnectorProperties' }
        & Pick<EmptyConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'FinchConnectorProperties' }
        & Pick<FinchConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'GustoConnectorProperties' }
        & Pick<GustoConnectorProperties, 'authorizationURL'>
      )
      | (
        { __typename: 'PlaidConnectorProperties' }
        & Pick<PlaidConnectorProperties, 'empty'>
      )
      | (
        { __typename: 'RampConnectorProperties' }
        & Pick<RampConnectorProperties, 'authorizationURL'>
      )
      | (
        { __typename: 'StripeConnectorProperties' }
        & Pick<StripeConnectorProperties, 'appLinkURL'>
      )
    > }
  ) };

export type ReadAppAuthorizationQueryVariables = Exact<{
  clientId: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  responseType: Scalars['String']['input'];
  scopes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadAppAuthorizationQuery = { readAppAuthorization: (
    Pick<AppAuthorization, 'environment'>
    & {
      app: Pick<
          App,
          | 'id'
          | 'organizationId'
          | 'visibility'
          | 'name'
          | 'description'
          | 'homepageURL'
          | 'supportEmail'
          | 'developerEmail'
          | 'privacyPolicyURL'
          | 'termsOfServiceURL'
          | 'iconObjectName'
        >,
      eligibleLegalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
      ineligibleLegalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
    }
  ) };

export type ReadAppCredentialsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  connectorId: Scalars['String']['input'];
}>;


export type ReadAppCredentialsQuery = { readAppCredentials: Array<Maybe<Pick<AppCredential, 'environment' | 'clientId' | 'clientSecret'>>> };

export type ReadConnectionQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  connectionId: Scalars['String']['input'];
}>;


export type ReadConnectionQuery = { readConnection: (
    Pick<
      Connection,
      | 'id'
      | 'dataSourceId'
      | 'sourceName'
      | 'sourceIconURL'
      | 'description'
      | 'status'
      | 'authorizationRequired'
      | 'authorizationReason'
      | 'authorizationDescription'
      | 'upgradedFromConnectionId'
      | 'scopes'
    >
    & {
      sync?: Maybe<Pick<
          ConnectionSyncState,
          | 'lastSuccessAt'
          | 'lastEventAt'
          | 'status'
          | 'dataLastModifiedAt'
          | 'dataUpdatedAt'
        >>,
      settings?: Maybe<Pick<ConnectionSettings, 'cutoverDate'>>,
      accounts?: Maybe<Array<(
        Pick<
          ConnectionAccount,
          | 'id'
          | 'connectionId'
          | 'sourceAccountId'
          | 'name'
          | 'mask'
          | 'status'
          | 'statusUpdatedAt'
        >
        & {
          settings?: Maybe<(
            Pick<ConnectionAccountSettings, 'cutoverDate'>
            & { labelCategories?: Maybe<Array<(
              Pick<
                LabelCategory,
                | 'label'
                | 'validCategoryTypes'
                | 'displayName'
                | 'required'
                | 'tooltip'
                | 'digitsAi'
              >
              & { category?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >> }
            )>> }
          )>,
          cardHolders?: Maybe<Array<Pick<CardHolder, 'id' | 'name'>>>,
        }
      )>>,
      connector?: Maybe<(
        Pick<
          Connector,
          | 'id'
          | 'name'
          | 'tagline'
          | 'description'
          | 'category'
          | 'iconObjectName'
          | 'className'
          | 'canInstall'
        >
        & { connectorProperties?: Maybe<
          | (
            { __typename: 'AppConnectorProperties' }
            & Pick<
              AppConnectorProperties,
              | 'organizationId'
              | 'visibility'
              | 'homepageURL'
              | 'supportEmail'
              | 'developerEmail'
              | 'privacyPolicyURL'
              | 'termsOfServiceURL'
              | 'scopes'
              | 'redirectUris'
              | 'installUri'
            >
          )
          | (
            { __typename: 'BillConnectorProperties' }
            & Pick<BillConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'EmptyConnectorProperties' }
            & Pick<EmptyConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'FinchConnectorProperties' }
            & Pick<FinchConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'GustoConnectorProperties' }
            & Pick<GustoConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'PlaidConnectorProperties' }
            & Pick<PlaidConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'RampConnectorProperties' }
            & Pick<RampConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'StripeConnectorProperties' }
            & Pick<StripeConnectorProperties, 'appLinkURL'>
          )
        > }
      )>,
      connectorUpgrade?: Maybe<(
        Pick<
          Connector,
          | 'id'
          | 'name'
          | 'tagline'
          | 'description'
          | 'category'
          | 'iconObjectName'
          | 'className'
          | 'canInstall'
        >
        & { connectorProperties?: Maybe<
          | (
            { __typename: 'AppConnectorProperties' }
            & Pick<
              AppConnectorProperties,
              | 'organizationId'
              | 'visibility'
              | 'homepageURL'
              | 'supportEmail'
              | 'developerEmail'
              | 'privacyPolicyURL'
              | 'termsOfServiceURL'
              | 'scopes'
              | 'redirectUris'
              | 'installUri'
            >
          )
          | (
            { __typename: 'BillConnectorProperties' }
            & Pick<BillConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'EmptyConnectorProperties' }
            & Pick<EmptyConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'FinchConnectorProperties' }
            & Pick<FinchConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'GustoConnectorProperties' }
            & Pick<GustoConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'PlaidConnectorProperties' }
            & Pick<PlaidConnectorProperties, 'empty'>
          )
          | (
            { __typename: 'RampConnectorProperties' }
            & Pick<RampConnectorProperties, 'authorizationURL'>
          )
          | (
            { __typename: 'StripeConnectorProperties' }
            & Pick<StripeConnectorProperties, 'appLinkURL'>
          )
        > }
      )>,
    }
  ) };

export type SuggestedConnectionsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  filter: SuggestedConnectionsFilter;
}>;


export type SuggestedConnectionsQuery = { suggestedConnections: Array<{ template: (
      Pick<ConnectionTemplate, 'externalId'>
      & {
        connector: (
          Pick<
            Connector,
            | 'id'
            | 'name'
            | 'tagline'
            | 'description'
            | 'category'
            | 'iconObjectName'
            | 'className'
            | 'canInstall'
          >
          & { connectorProperties?: Maybe<
            | (
              { __typename: 'AppConnectorProperties' }
              & Pick<
                AppConnectorProperties,
                | 'organizationId'
                | 'visibility'
                | 'homepageURL'
                | 'supportEmail'
                | 'developerEmail'
                | 'privacyPolicyURL'
                | 'termsOfServiceURL'
                | 'scopes'
                | 'redirectUris'
                | 'installUri'
              >
            )
            | (
              { __typename: 'BillConnectorProperties' }
              & Pick<BillConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'EmptyConnectorProperties' }
              & Pick<EmptyConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'FinchConnectorProperties' }
              & Pick<FinchConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'GustoConnectorProperties' }
              & Pick<GustoConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'PlaidConnectorProperties' }
              & Pick<PlaidConnectorProperties, 'empty'>
            )
            | (
              { __typename: 'RampConnectorProperties' }
              & Pick<RampConnectorProperties, 'authorizationURL'>
            )
            | (
              { __typename: 'StripeConnectorProperties' }
              & Pick<StripeConnectorProperties, 'appLinkURL'>
            )
          > }
        ),
        institution: (
          Pick<
            ProductInstitution,
            | 'id'
            | 'name'
            | 'products'
            | 'routingNumber'
          >
          & { party?: Maybe<Pick<
              Party,
              | 'id'
              | 'legalEntityId'
              | 'name'
              | 'url'
              | 'supportUrl'
              | 'supportEmail'
              | 'supportPhone'
              | 'twitterUrl'
              | 'facebookUrl'
              | 'instagramUrl'
              | 'yelpUrl'
              | 'iconUrl'
              | 'shortDescription'
              | 'designation'
            >> }
        ),
      }
    ) }> };

export type LogCustomerEventsMutationVariables = Exact<{
  events: Array<CustomerEvent> | CustomerEvent;
}>;


export type LogCustomerEventsMutation = Pick<Mutation, 'logCustomerEvents'>;

export type DataSourceManualRefreshFieldsFragment = (
  Pick<
    DataSourceManualRefresh,
    | 'dataSourceId'
    | 'requestedAt'
    | 'syncCompletedAt'
    | 'earliestViewVersion'
    | 'viewFinishedAt'
  >
  & { errors: Array<Pick<DataSourceManualRefreshError, 'erroredAt'>> }
);

export type QuickBooksAccountingInfoPreferencesFieldsFragment = { bookCloseDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>> };

export type QuickBooksCompanyFieldsFragment = { preferences?: Maybe<{ accountingInfo?: Maybe<{ bookCloseDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>> }> }> };

export type QuickBooksPreferencesFieldsFragment = { accountingInfo?: Maybe<{ bookCloseDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>> }> };

export type CreateBooksClosedDateMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  booksClosedDate?: InputMaybe<Scalars['Float']['input']>;
}>;


export type CreateBooksClosedDateMutation = Pick<Mutation, 'createBooksClosedDate'>;

export type DeleteDataSourceMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  providerType: ProviderType;
}>;


export type DeleteDataSourceMutation = Pick<Mutation, 'deleteDataSource'>;

export type RefreshDataSourceMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type RefreshDataSourceMutation = { refreshDataSource: (
    Pick<
      DataSourceManualRefresh,
      | 'dataSourceId'
      | 'requestedAt'
      | 'syncCompletedAt'
      | 'earliestViewVersion'
      | 'viewFinishedAt'
    >
    & { errors: Array<Pick<DataSourceManualRefreshError, 'erroredAt'>> }
  ) };

export type ListDataSourcesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListDataSourcesQuery = { listDataSources: Array<(
    Pick<
      DataSource,
      | 'id'
      | 'legalEntityId'
      | 'status'
      | 'statusReason'
      | 'providerType'
      | 'accountAlias'
      | 'createdAt'
      | 'updatedAt'
    >
    & { institution: Pick<
        Institution,
        | 'id'
        | 'name'
        | 'url'
        | 'routingNumber'
        | 'iconUrl'
        | 'partyId'
        | 'createdAt'
      > }
  )> };

export type ListEnrichedDataSourcesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListEnrichedDataSourcesQuery = { listEnrichedDataSources: Array<(
    Pick<
      EnrichedDataSource,
      | 'id'
      | 'legalEntityId'
      | 'status'
      | 'statusReason'
      | 'providerType'
      | 'accountAlias'
      | 'createdAt'
      | 'updatedAt'
      | 'lastActivityAt'
      | 'hasTransactions'
    >
    & {
      institution: Pick<
          Party,
          | 'id'
          | 'legalEntityId'
          | 'name'
          | 'url'
          | 'supportUrl'
          | 'supportEmail'
          | 'supportPhone'
          | 'twitterUrl'
          | 'facebookUrl'
          | 'instagramUrl'
          | 'yelpUrl'
          | 'iconUrl'
          | 'shortDescription'
          | 'designation'
        >,
      quickBooksConfig?: Maybe<Pick<
          QuickBooksConfig,
          | 'id'
          | 'realmId'
          | 'createdAt'
          | 'updatedAt'
        >>,
      plaidConfig?: Maybe<Pick<
          PlaidConfig,
          | 'id'
          | 'itemId'
          | 'externalInstitutionId'
          | 'createdAt'
          | 'updatedAt'
        >>,
      sourceAccounts?: Maybe<Array<Pick<
          SourceAccount,
          | 'id'
          | 'externalId'
          | 'externalName'
          | 'externalOwnerName'
          | 'externalOfficialName'
          | 'externalType'
          | 'externalSubtype'
          | 'mask'
          | 'status'
          | 'ownerEmployeeId'
        >>>,
    }
  )> };

export type ListLatestDataSourceRefreshesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListLatestDataSourceRefreshesQuery = { listLatestDataSourceRefreshes: Array<(
    Pick<
      DataSourceManualRefresh,
      | 'dataSourceId'
      | 'requestedAt'
      | 'syncCompletedAt'
      | 'earliestViewVersion'
      | 'viewFinishedAt'
    >
    & { errors: Array<Pick<DataSourceManualRefreshError, 'erroredAt'>> }
  )> };

export type ListOwnedDataSourcesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListOwnedDataSourcesQuery = { listOwnedDataSources: Array<{
      dataSource: (
        Pick<
          EnrichedDataSource,
          | 'id'
          | 'legalEntityId'
          | 'status'
          | 'statusReason'
          | 'providerType'
          | 'accountAlias'
          | 'createdAt'
          | 'updatedAt'
          | 'lastActivityAt'
          | 'hasTransactions'
        >
        & {
          institution: Pick<
              Party,
              | 'id'
              | 'legalEntityId'
              | 'name'
              | 'url'
              | 'supportUrl'
              | 'supportEmail'
              | 'supportPhone'
              | 'twitterUrl'
              | 'facebookUrl'
              | 'instagramUrl'
              | 'yelpUrl'
              | 'iconUrl'
              | 'shortDescription'
              | 'designation'
            >,
          quickBooksConfig?: Maybe<Pick<
              QuickBooksConfig,
              | 'id'
              | 'realmId'
              | 'createdAt'
              | 'updatedAt'
            >>,
          plaidConfig?: Maybe<Pick<
              PlaidConfig,
              | 'id'
              | 'itemId'
              | 'externalInstitutionId'
              | 'createdAt'
              | 'updatedAt'
            >>,
          sourceAccounts?: Maybe<Array<Pick<
              SourceAccount,
              | 'id'
              | 'externalId'
              | 'externalName'
              | 'externalOwnerName'
              | 'externalOfficialName'
              | 'externalType'
              | 'externalSubtype'
              | 'mask'
              | 'status'
              | 'ownerEmployeeId'
            >>>,
        }
      ),
      ownedSourceAccounts?: Maybe<Array<{
          sourceAccount: Pick<
              SourceAccount,
              | 'id'
              | 'externalId'
              | 'externalName'
              | 'externalOwnerName'
              | 'externalOfficialName'
              | 'externalType'
              | 'externalSubtype'
              | 'mask'
              | 'status'
              | 'ownerEmployeeId'
            >,
          owner?: Maybe<(
            Pick<
              Employee,
              | 'id'
              | 'organizationId'
              | 'givenName'
              | 'familyName'
              | 'avatarUrl'
              | 'emailAddress'
              | 'jobTitle'
              | 'lastActivityAt'
              | 'status'
              | 'hiddenAt'
            >
            & {
              role?: Maybe<Pick<Role, 'id'>>,
              defaultEntityRole?: Maybe<Pick<Role, 'id'>>,
              user?: Maybe<(
                Pick<
                  User,
                  | 'id'
                  | 'givenName'
                  | 'familyName'
                  | 'primaryEmailAddress'
                  | 'passwordSet'
                  | 'avatarUrl'
                  | 'createdAt'
                  | 'lastActivityAt'
                >
                & {
                  employments?: Maybe<Array<(
                    Pick<OrganizationEmployment, 'employeeId'>
                    & {
                      role: Pick<Role, 'id'>,
                      organization: Pick<
                          Organization,
                          | 'id'
                          | 'slug'
                          | 'name'
                          | 'iconUrl'
                          | 'websiteUrl'
                          | 'kind'
                        >,
                      legalEntityRoles?: Maybe<Array<(
                        Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                        & { role?: Maybe<Pick<Role, 'id'>> }
                      )>>,
                    }
                  )>>,
                  identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
                }
              )>,
              invitation?: Maybe<(
                Pick<
                  Invitation,
                  | 'id'
                  | 'invitationType'
                  | 'status'
                  | 'service'
                  | 'organizationTemplateId'
                  | 'createdAt'
                  | 'updatedAt'
                  | 'notifiedAt'
                >
                & {
                  recipient: Pick<
                      Contact,
                      | 'givenName'
                      | 'familyName'
                      | 'emailAddress'
                      | 'avatarUrl'
                    >,
                  sender?: Maybe<Pick<
                      Contact,
                      | 'givenName'
                      | 'familyName'
                      | 'emailAddress'
                      | 'avatarUrl'
                    >>,
                  organization?: Maybe<Pick<
                      Organization,
                      | 'id'
                      | 'slug'
                      | 'name'
                      | 'iconUrl'
                      | 'websiteUrl'
                      | 'kind'
                    >>,
                  role?: Maybe<Pick<Role, 'id'>>,
                }
              )>,
              legalEntityRoles?: Maybe<Array<(
                Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                & { role?: Maybe<Pick<Role, 'id'>> }
              )>>,
            }
          )>,
        }>>,
    }> };

export type ReadBooksClosedDateQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadBooksClosedDateQuery = { readBooksClosedDate: (
    Pick<BooksClosedDate, 'legalEntityId' | 'latestBooksClosedDateFact'>
    & { user?: Maybe<Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >> }
  ) };

export type ReadDataSourcePreferencesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadDataSourcePreferencesQuery = { readDataSourcePreferences: Array<Pick<
      DataSourcePreference,
      | 'dataSourceId'
      | 'accountingBasis'
      | 'taxForm'
      | 'providerType'
      | 'departmentTerminology'
    >> };

export type BootstrapDepartmentMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type BootstrapDepartmentMutation = { bootstrapDepartments: Pick<CreateDepartmentResponse, 'departmentId'> };

export type CreateDepartmentMutationVariables = Exact<{
  viewKey: ViewKey;
  dimension: CreateDepartmentInput;
}>;


export type CreateDepartmentMutation = { createDepartment: Pick<CreateDepartmentResponse, 'departmentId'> };

export type MigrateDepartmentQuickBooksMutationVariables = Exact<{
  viewKey: ViewKey;
  departmentFactIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  lineClassFactIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type MigrateDepartmentQuickBooksMutation = Pick<Mutation, 'migrateDepartmentQuickBooks'>;

export type UpdateDepartmentMutationVariables = Exact<{
  viewKey: ViewKey;
  dimensionId: Scalars['String']['input'];
  dimension: UpdateDepartmentInput;
}>;


export type UpdateDepartmentMutation = { updateDepartment: { entityId: UpdateDepartmentResponse['departmentId'] } };

export type UpdateDepartmentStatusMutationVariables = Exact<{
  viewKey: ViewKey;
  dimensionId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type UpdateDepartmentStatusMutation = Pick<Mutation, 'updateDepartmentStatus'>;

export type ListDepartmentsQueryVariables = Exact<{
  viewKey: ViewKey;
  status?: InputMaybe<DepartmentStatus>;
}>;


export type ListDepartmentsQuery = { listDepartments: Array<(
    Pick<
      Department,
      | 'id'
      | 'name'
      | 'parentId'
      | 'active'
      | 'description'
      | 'displayKey'
    >
    & {
      ancestors: Array<(
        { __typename: 'EntityDepartment' }
        & Pick<
          EntityDepartment,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      matches: Array<Pick<MatchedDepartment, 'id' | 'dataSourceId'>>,
      dataSource?: Maybe<Pick<
          EntityDataSource,
          | 'id'
          | 'name'
          | 'url'
          | 'iconUrl'
        >>,
    }
  )> };

export type ReadDepartmentQueryVariables = Exact<{
  viewKey: ViewKey;
  departmentId: Scalars['String']['input'];
}>;


export type ReadDepartmentQuery = { readDepartment: (
    Pick<
      Department,
      | 'id'
      | 'name'
      | 'parentId'
      | 'active'
      | 'description'
      | 'displayKey'
    >
    & {
      ancestors: Array<(
        { __typename: 'EntityDepartment' }
        & Pick<
          EntityDepartment,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      matches: Array<Pick<MatchedDepartment, 'id' | 'dataSourceId'>>,
      dataSource?: Maybe<Pick<
          EntityDataSource,
          | 'id'
          | 'name'
          | 'url'
          | 'iconUrl'
        >>,
    }
  ) };

export type AssociationHistoryFieldsFragment = (
  { __typename: 'AssociationHistory' }
  & {
    associationIdentifier: (
      { __typename: 'AssociationIdentifier' }
      & {
        documentIdentifier: (
          { __typename: 'DocumentIdentifier' }
          & Pick<DocumentIdentifier, 'collectionId' | 'documentId'>
        ),
        objectIdentifier: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
      }
    ),
    events: Array<(
      { __typename: 'AssociationHistoryEvent' }
      & Pick<AssociationHistoryEvent, 'eventType' | 'eventTime'>
      & { user?: Maybe<Pick<
          EntityUser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >> }
    )>,
    documentInfo?: Maybe<(
      { __typename: 'DocumentInfo' }
      & Pick<DocumentInfo, 'title' | 'deletedAt'>
      & {
        creator?: Maybe<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>,
        dataSource?: Maybe<Pick<
            EntityDataSource,
            | 'id'
            | 'name'
            | 'url'
            | 'iconUrl'
          >>,
      }
    )>,
  }
);

export type AssociationHistoryEventFieldsFragment = (
  { __typename: 'AssociationHistoryEvent' }
  & Pick<AssociationHistoryEvent, 'eventType' | 'eventTime'>
  & { user?: Maybe<Pick<
      EntityUser,
      | 'id'
      | 'givenName'
      | 'familyName'
      | 'emailAddress'
      | 'avatarUrl'
    >> }
);

export type DocumentInfoFieldsFragment = (
  { __typename: 'DocumentInfo' }
  & Pick<DocumentInfo, 'title' | 'deletedAt'>
  & {
    creator?: Maybe<Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
    dataSource?: Maybe<Pick<
        EntityDataSource,
        | 'id'
        | 'name'
        | 'url'
        | 'iconUrl'
      >>,
  }
);

export type AssociationIdentifierFieldsFragment = (
  { __typename: 'AssociationIdentifier' }
  & {
    documentIdentifier: (
      { __typename: 'DocumentIdentifier' }
      & Pick<DocumentIdentifier, 'collectionId' | 'documentId'>
    ),
    objectIdentifier: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
  }
);

export type DocumentIdentifierFieldsFragment = (
  { __typename: 'DocumentIdentifier' }
  & Pick<DocumentIdentifier, 'collectionId' | 'documentId'>
);

export type AddAssociationsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  associationIdentifiers: Array<InputAssociationIdentifier> | InputAssociationIdentifier;
}>;


export type AddAssociationsMutation = Pick<Mutation, 'addAssociations'>;

export type RemoveAssociationsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  associationIdentifiers: Array<InputAssociationIdentifier> | InputAssociationIdentifier;
}>;


export type RemoveAssociationsMutation = Pick<Mutation, 'removeAssociations'>;

export type ListAssociationsHistoriesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  objectIdentifiers: Array<InputObjectIdentifier> | InputObjectIdentifier;
}>;


export type ListAssociationsHistoriesQuery = { listAssociationsHistories: Array<(
    { __typename: 'AssociationHistory' }
    & {
      associationIdentifier: (
        { __typename: 'AssociationIdentifier' }
        & {
          documentIdentifier: (
            { __typename: 'DocumentIdentifier' }
            & Pick<DocumentIdentifier, 'collectionId' | 'documentId'>
          ),
          objectIdentifier: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
        }
      ),
      events: Array<(
        { __typename: 'AssociationHistoryEvent' }
        & Pick<AssociationHistoryEvent, 'eventType' | 'eventTime'>
        & { user?: Maybe<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >> }
      )>,
      documentInfo?: Maybe<(
        { __typename: 'DocumentInfo' }
        & Pick<DocumentInfo, 'title' | 'deletedAt'>
        & {
          creator?: Maybe<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>,
          dataSource?: Maybe<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>,
        }
      )>,
    }
  )> };

export type ListDocumentAssociationsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  documentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ListDocumentAssociationsQuery = { listDocumentAssociations: Array<(
    { __typename: 'AssociationIdentifier' }
    & {
      documentIdentifier: (
        { __typename: 'DocumentIdentifier' }
        & Pick<DocumentIdentifier, 'collectionId' | 'documentId'>
      ),
      objectIdentifier: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
    }
  )> };

export type ListObjectAssociationsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  objectIdentifiers: Array<InputObjectIdentifier> | InputObjectIdentifier;
}>;


export type ListObjectAssociationsQuery = { listObjectAssociations: Array<(
    { __typename: 'AssociationIdentifier' }
    & {
      documentIdentifier: (
        { __typename: 'DocumentIdentifier' }
        & Pick<DocumentIdentifier, 'collectionId' | 'documentId'>
      ),
      objectIdentifier: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
    }
  )> };

export type ListDoppelgangerPermitsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListDoppelgangerPermitsQuery = { listDoppelgangerPermits: Array<Maybe<(
    Pick<DoppelgangerPermit, 'id' | 'expiresAt' | 'createdAt'>
    & { user: (
      Pick<
        User,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'primaryEmailAddress'
        | 'passwordSet'
        | 'avatarUrl'
        | 'createdAt'
        | 'lastActivityAt'
      >
      & {
        employments?: Maybe<Array<(
          Pick<OrganizationEmployment, 'employeeId'>
          & {
            role: Pick<Role, 'id'>,
            organization: Pick<
                Organization,
                | 'id'
                | 'slug'
                | 'name'
                | 'iconUrl'
                | 'websiteUrl'
                | 'kind'
              >,
            legalEntityRoles?: Maybe<Array<(
              Pick<EmployeeLegalEntityRole, 'legalEntityId'>
              & { role?: Maybe<Pick<Role, 'id'>> }
            )>>,
          }
        )>>,
        identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
      }
    ) }
  )>> };

export type ActivateCurrentUserEmploymentMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ActivateCurrentUserEmploymentMutation = Pick<Mutation, 'activateCurrentUserEmployment'>;

export type CreateEmployeeAffiliationsMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  organizationRole: Scalars['String']['input'];
  employeeId?: InputMaybe<Scalars['String']['input']>;
  givenName: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  affiliations: Array<LegalEntityRole> | LegalEntityRole;
}>;


export type CreateEmployeeAffiliationsMutation = Pick<Mutation, 'createEmployeeAffiliations'>;

export type DeactivateEmployeeMutationVariables = Exact<{
  employeeId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
}>;


export type DeactivateEmployeeMutation = Pick<Mutation, 'deactivateEmployee'>;

export type DeleteEmployeeAffiliationsMutationVariables = Exact<{
  employeeIdentifier: EmployeeIdentifier;
  legalEntityIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteEmployeeAffiliationsMutation = Pick<Mutation, 'deleteEmployeeAffiliations'>;

export type UpdateEmployeeMutationVariables = Exact<{
  employeeId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<RoleIdentifier>;
  defaultEntityRole?: InputMaybe<RoleIdentifier>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  fieldToUpdate: UpdatableEmployeeField;
}>;


export type UpdateEmployeeMutation = Pick<Mutation, 'updateEmployee'>;

export type UpdateEmployeeAffiliationsMutationVariables = Exact<{
  employeeIdentifier: EmployeeIdentifier;
  affiliations: Array<LegalEntityRole> | LegalEntityRole;
}>;


export type UpdateEmployeeAffiliationsMutation = Pick<Mutation, 'updateEmployeeAffiliations'>;

export type UpdateOrganizationUserLegalEntityRolesMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  roles?: InputMaybe<Array<UpdateUserLegalEntityRoleEntry> | UpdateUserLegalEntityRoleEntry>;
  deletes?: InputMaybe<Array<UserLegalEntityRoleDelete> | UserLegalEntityRoleDelete>;
}>;


export type UpdateOrganizationUserLegalEntityRolesMutation = Pick<Mutation, 'updateUserLegalEntityRoles'>;

export type UpdateUserLegalEntityRolesMutationVariables = Exact<{
  roles?: InputMaybe<Array<UpdateUserLegalEntityRoleEntry> | UpdateUserLegalEntityRoleEntry>;
  deletes?: InputMaybe<Array<UserLegalEntityRoleDelete> | UserLegalEntityRoleDelete>;
}>;


export type UpdateUserLegalEntityRolesMutation = Pick<Mutation, 'updateUserLegalEntityRoles'>;

export type ListEmployeesQueryVariables = Exact<{
  filter: EmployeeFilter;
  pagination: Pagination;
  sort?: InputMaybe<EmployeeSort>;
}>;


export type ListEmployeesQuery = { listEmployees: Array<(
    Pick<
      Employee,
      | 'id'
      | 'organizationId'
      | 'givenName'
      | 'familyName'
      | 'avatarUrl'
      | 'emailAddress'
      | 'jobTitle'
      | 'lastActivityAt'
      | 'status'
      | 'hiddenAt'
    >
    & {
      role?: Maybe<Pick<Role, 'id'>>,
      defaultEntityRole?: Maybe<Pick<Role, 'id'>>,
      user?: Maybe<(
        Pick<
          User,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'primaryEmailAddress'
          | 'passwordSet'
          | 'avatarUrl'
          | 'createdAt'
          | 'lastActivityAt'
        >
        & {
          employments?: Maybe<Array<(
            Pick<OrganizationEmployment, 'employeeId'>
            & {
              role: Pick<Role, 'id'>,
              organization: Pick<
                  Organization,
                  | 'id'
                  | 'slug'
                  | 'name'
                  | 'iconUrl'
                  | 'websiteUrl'
                  | 'kind'
                >,
              legalEntityRoles?: Maybe<Array<(
                Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                & { role?: Maybe<Pick<Role, 'id'>> }
              )>>,
            }
          )>>,
          identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
        }
      )>,
      invitation?: Maybe<(
        Pick<
          Invitation,
          | 'id'
          | 'invitationType'
          | 'status'
          | 'service'
          | 'organizationTemplateId'
          | 'createdAt'
          | 'updatedAt'
          | 'notifiedAt'
        >
        & {
          recipient: Pick<
              Contact,
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >,
          sender?: Maybe<Pick<
              Contact,
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>,
          organization?: Maybe<Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >>,
          role?: Maybe<Pick<Role, 'id'>>,
        }
      )>,
      legalEntityRoles?: Maybe<Array<(
        Pick<EmployeeLegalEntityRole, 'legalEntityId'>
        & { role?: Maybe<Pick<Role, 'id'>> }
      )>>,
    }
  )> };

export type ListEmployeesAffiliationsQueryVariables = Exact<{
  filter: EmployeeFilter;
  pagination: Pagination;
  sort?: InputMaybe<EmployeeSort>;
}>;


export type ListEmployeesAffiliationsQuery = { listEmployeesAffiliations: Array<{
      employee: (
        Pick<
          Employee,
          | 'id'
          | 'organizationId'
          | 'givenName'
          | 'familyName'
          | 'avatarUrl'
          | 'emailAddress'
          | 'jobTitle'
          | 'lastActivityAt'
          | 'status'
          | 'hiddenAt'
        >
        & {
          role?: Maybe<Pick<Role, 'id'>>,
          defaultEntityRole?: Maybe<Pick<Role, 'id'>>,
          user?: Maybe<(
            Pick<
              User,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'primaryEmailAddress'
              | 'passwordSet'
              | 'avatarUrl'
              | 'createdAt'
              | 'lastActivityAt'
            >
            & {
              employments?: Maybe<Array<(
                Pick<OrganizationEmployment, 'employeeId'>
                & {
                  role: Pick<Role, 'id'>,
                  organization: Pick<
                      Organization,
                      | 'id'
                      | 'slug'
                      | 'name'
                      | 'iconUrl'
                      | 'websiteUrl'
                      | 'kind'
                    >,
                  legalEntityRoles?: Maybe<Array<(
                    Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                    & { role?: Maybe<Pick<Role, 'id'>> }
                  )>>,
                }
              )>>,
              identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
            }
          )>,
          invitation?: Maybe<(
            Pick<
              Invitation,
              | 'id'
              | 'invitationType'
              | 'status'
              | 'service'
              | 'organizationTemplateId'
              | 'createdAt'
              | 'updatedAt'
              | 'notifiedAt'
            >
            & {
              recipient: Pick<
                  Contact,
                  | 'givenName'
                  | 'familyName'
                  | 'emailAddress'
                  | 'avatarUrl'
                >,
              sender?: Maybe<Pick<
                  Contact,
                  | 'givenName'
                  | 'familyName'
                  | 'emailAddress'
                  | 'avatarUrl'
                >>,
              organization?: Maybe<Pick<
                  Organization,
                  | 'id'
                  | 'slug'
                  | 'name'
                  | 'iconUrl'
                  | 'websiteUrl'
                  | 'kind'
                >>,
              role?: Maybe<Pick<Role, 'id'>>,
            }
          )>,
          legalEntityRoles?: Maybe<Array<(
            Pick<EmployeeLegalEntityRole, 'legalEntityId'>
            & { role?: Maybe<Pick<Role, 'id'>> }
          )>>,
        }
      ),
      affiliations: Array<{
          organization: Pick<
              EntityOrganization,
              | 'id'
              | 'name'
              | 'slug'
              | 'iconUrl'
            >,
          legalEntity: Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>,
          role: Pick<Role, 'id'>,
        }>,
    }> };

export type GenerateLayoutComponentPdfMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  legalEntityName: Scalars['String']['input'];
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
  title: Scalars['String']['input'];
  periodName: Scalars['String']['input'];
  layoutId?: InputMaybe<Scalars['String']['input']>;
  dataId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateLayoutComponentPdfMutation = { generateLayoutComponentPdf: Pick<DocumentDownload, 'url'> };

export type ListFirmClientsQueryVariables = Exact<{
  filter: FirmClientFilter;
  origin: IntervalOrigin;
  direction: DirectionFromOrigin;
  pagination: Pagination;
  sort?: InputMaybe<FirmClientSort>;
}>;


export type ListFirmClientsQuery = { listFirmClients: (
    Pick<FirmClientList, 'totalCount'>
    & {
      clients: Array<(
        Pick<
          FirmClient,
          | 'id'
          | 'status'
          | 'payerOrganizationId'
          | 'memberUserIds'
        >
        & {
          legalEntity: Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>,
          organization: Pick<
              EntityOrganization,
              | 'id'
              | 'name'
              | 'slug'
              | 'iconUrl'
            >,
          billingPlan?: Maybe<Pick<
              BillingProduct,
              | 'id'
              | 'name'
              | 'displayName'
              | 'description'
              | 'callout'
              | 'trialPeriodDays'
              | 'availability'
              | 'listing'
              | 'billable'
            >>,
          counts: Array<Pick<ActionItemsGroupSummary, 'group' | 'count'>>,
        }
      )>,
      entities?: Maybe<(
        { __typename: 'ObjectEntities' }
        & {
          users?: Maybe<Array<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>>,
          transactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          comments?: Maybe<Array<Pick<
              EntityComment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
            >>>,
          reports?: Maybe<Array<(
            Pick<
              EntityReport,
              | 'id'
              | 'title'
              | 'authorId'
              | 'mimeType'
              | 'createdAt'
            >
            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
          )>>,
          reportPackages?: Maybe<Array<(
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )>>,
          parties?: Maybe<Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>>,
          datasources?: Maybe<Array<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>>,
          categories?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>>,
          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
          workItems?: Maybe<Array<(
            Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )>>,
          invoices?: Maybe<Array<(
            Pick<
              EntityInvoice,
              | 'id'
              | 'externalDisplayId'
              | 'createdAt'
              | 'dueAt'
            >
            & {
              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              customer: (
                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                & { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              ),
            }
          )>>,
          bills?: Maybe<Array<(
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )>>,
          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
          departments?: Maybe<Array<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          locations?: Maybe<Array<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          reconciliations?: Maybe<Array<(
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )>>,
          ledgerTransactions?: Maybe<Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )>>,
          schedules?: Maybe<Array<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>>,
        }
      )>,
    }
  ) };

export type ListInsightsQueryVariables = Exact<{
  interval: Interval;
  intervalCount?: InputMaybe<Scalars['Int']['input']>;
  year: Scalars['Int']['input'];
  index: Scalars['Int']['input'];
  paginationDirection: DirectionFromOrigin;
  paginationLimit: Scalars['Int']['input'];
  paginationOffset: Scalars['Int']['input'];
  filter: InsightFilter;
}>;


export type ListInsightsQuery = { listInsights: Array<{
      period: Pick<
          Period,
          | 'name'
          | 'interval'
          | 'startedAt'
          | 'endedAt'
        >,
      insights: Array<(
        Pick<
          Insight,
          | 'score'
          | 'globalScore'
          | 'subjectType'
          | 'subjectId'
          | 'subjectDisplayKey'
          | 'comparisonIntervalOffset'
          | 'ruleType'
          | 'sentence'
          | 'subjectIconUrl'
          | 'designation'
          | 'type'
          | 'productArea'
        >
        & {
          periodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          absoluteDelta?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          comparisonPeriodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        }
      )>,
      entities?: Maybe<(
        { __typename: 'ObjectEntities' }
        & {
          users?: Maybe<Array<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>>,
          transactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          comments?: Maybe<Array<Pick<
              EntityComment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
            >>>,
          reports?: Maybe<Array<(
            Pick<
              EntityReport,
              | 'id'
              | 'title'
              | 'authorId'
              | 'mimeType'
              | 'createdAt'
            >
            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
          )>>,
          reportPackages?: Maybe<Array<(
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )>>,
          parties?: Maybe<Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>>,
          datasources?: Maybe<Array<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>>,
          categories?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>>,
          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
          workItems?: Maybe<Array<(
            Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )>>,
          invoices?: Maybe<Array<(
            Pick<
              EntityInvoice,
              | 'id'
              | 'externalDisplayId'
              | 'createdAt'
              | 'dueAt'
            >
            & {
              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              customer: (
                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                & { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              ),
            }
          )>>,
          bills?: Maybe<Array<(
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )>>,
          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
          departments?: Maybe<Array<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          locations?: Maybe<Array<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          reconciliations?: Maybe<Array<(
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )>>,
          ledgerTransactions?: Maybe<Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )>>,
          schedules?: Maybe<Array<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>>,
        }
      )>,
    }> };

export type ListInstitutionsQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>;
  filter?: InputMaybe<InstitutionFilter>;
}>;


export type ListInstitutionsQuery = { listInstitutions: Array<(
    Pick<
      ProductInstitution,
      | 'id'
      | 'name'
      | 'products'
      | 'routingNumber'
    >
    & { party?: Maybe<Pick<
        Party,
        | 'id'
        | 'legalEntityId'
        | 'name'
        | 'url'
        | 'supportUrl'
        | 'supportEmail'
        | 'supportPhone'
        | 'twitterUrl'
        | 'facebookUrl'
        | 'instagramUrl'
        | 'yelpUrl'
        | 'iconUrl'
        | 'shortDescription'
        | 'designation'
      >> }
  )> };

export type CancelInvitationMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type CancelInvitationMutation = Pick<Mutation, 'cancelInvitation'>;

export type CreateFirmAffiliationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressInput>;
  minimalCoa?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateFirmAffiliationMutation = { createFirmAffiliation: (
    Pick<
      LegalEntity,
      | 'id'
      | 'slug'
      | 'name'
      | 'websiteUrl'
      | 'industry'
      | 'timezone'
      | 'fiscalYearStartMonth'
      | 'fiscalYearNumberOffset'
      | 'status'
      | 'organizationId'
      | 'sensitive'
      | 'phoneNumber'
      | 'iconUrl'
    >
    & {
      address: Pick<
          Address,
          | 'street'
          | 'streetAdditional'
          | 'city'
          | 'region'
          | 'postalCode'
          | 'countryCode'
          | 'lat'
          | 'long'
        >,
      incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
    }
  ) };

export type ResendInvitationMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ResendInvitationMutation = Pick<Mutation, 'resendInvitation'>;

export type ResendManagedOperatorInvitationMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  token: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type ResendManagedOperatorInvitationMutation = Pick<Mutation, 'resendManagedOperatorInvitation'>;

export type SendInvitationMutationVariables = Exact<{
  givenName?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  employeeId?: InputMaybe<Scalars['String']['input']>;
  destinationOrganizationId?: InputMaybe<Scalars['String']['input']>;
  destinationOrganizationRole?: InputMaybe<Scalars['String']['input']>;
  defaultEntityRole?: InputMaybe<Scalars['String']['input']>;
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  legalEntityRoles?: InputMaybe<Array<LegalEntityRole> | LegalEntityRole>;
  invitationType: Scalars['String']['input'];
  proposalType?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendInvitationMutation = Pick<Mutation, 'sendInvitation'>;

export type SendManagedOperatorInvitationMutationVariables = Exact<{
  recipient: ContactInput;
  legalEntityId: Scalars['String']['input'];
  legalEntityRole?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  redirectPath?: InputMaybe<Scalars['String']['input']>;
  contextObject?: InputMaybe<InputObjectIdentifier>;
}>;


export type SendManagedOperatorInvitationMutation = Pick<Mutation, 'sendManagedOperatorInvitation'>;

export type BankAccountFieldsFragment = (
  { __typename: 'BankAccount' }
  & Pick<
    BankAccount,
    | 'id'
    | 'institutionName'
    | 'name'
    | 'accountIdMask'
    | 'isDefault'
    | 'nickname'
    | 'isAutoPayout'
    | 'iconObjectName'
  >
);

export type CreditCardFieldsFragment = (
  { __typename: 'CreditCard' }
  & Pick<CreditCard, 'id' | 'cardLastFour' | 'cardBrand'>
);

export type CustomerAddressFieldsFragment = (
  Pick<CustomerAddress, 'id'>
  & { address?: Maybe<Pick<
      Address,
      | 'street'
      | 'streetAdditional'
      | 'city'
      | 'region'
      | 'postalCode'
      | 'countryCode'
      | 'lat'
      | 'long'
    >> }
);

export type CustomerSummaryFieldsFragment = Pick<
    CustomerSummary,
    | 'id'
    | 'name'
    | 'email'
    | 'icon'
  >;

export type DiscountFieldsFragment = (
  Pick<
    Discount,
    | 'discountId'
    | 'name'
    | 'variablePercentage'
    | 'providerType'
    | 'categoryId'
  >
  & { fixedDiscountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
);

export type InvoiceBrandingFieldsFragment = Pick<InvoiceBranding, 'id' | 'backgroundColor' | 'coverURL'>;

export type InvoiceDefaultsFieldsFragment = (
  Pick<
    InvoiceDefaults,
    | 'id'
    | 'invoiceDate'
    | 'dueDate'
    | 'invoiceNumber'
  >
  & { branding: Pick<InvoiceBranding, 'id' | 'backgroundColor' | 'coverURL'> }
);

export type InvoiceFileFieldsFragment = Pick<InvoiceFile, 'documentId' | 'fileType'>;

export type InvoiceNumberFieldsFragment = Pick<InvoiceNumber, 'invoiceNumber'>;

export type InvoicePaymentDetailsFieldsFragment = (
  Pick<InvoicePaymentDetails, 'paymentConfirmationId' | 'paymentDate'>
  & {
    paymentAmount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    paymentInstrument:
      | (
        { __typename: 'BankAccount' }
        & Pick<
          BankAccount,
          | 'id'
          | 'institutionName'
          | 'name'
          | 'accountIdMask'
          | 'isDefault'
          | 'nickname'
          | 'isAutoPayout'
          | 'iconObjectName'
        >
      )
      | (
        { __typename: 'CreditCard' }
        & Pick<CreditCard, 'id' | 'cardLastFour' | 'cardBrand'>
      )
    ,
  }
);

export type InvoicingAddressFieldsFragment = (
  Pick<InvoicingAddress, 'id'>
  & { address: Pick<
      Address,
      | 'street'
      | 'streetAdditional'
      | 'city'
      | 'region'
      | 'postalCode'
      | 'countryCode'
      | 'lat'
      | 'long'
    > }
);

export type InvoicingProfileFieldsFragment = (
  Pick<
    InvoicingProfile,
    | 'id'
    | 'companyEmail'
    | 'companyName'
    | 'companyIcon'
    | 'payoutInstrumentID'
    | 'invoiceNumberFormatDefault'
    | 'invoiceNumberFormat'
  >
  & { companyAddress: (
    Pick<InvoicingAddress, 'id'>
    & { address: Pick<
        Address,
        | 'street'
        | 'streetAdditional'
        | 'city'
        | 'region'
        | 'postalCode'
        | 'countryCode'
        | 'lat'
        | 'long'
      > }
  ) }
);

export type LedgerCustomerDetailFieldsFragment = (
  Pick<
    LedgerCustomerDetail,
    | 'name'
    | 'email'
    | 'phone'
    | 'contactName'
    | 'secondaryEmail'
    | 'paymentTerms'
    | 'description'
    | 'providerType'
    | 'dataSourcePartyId'
  >
  & { id: LedgerCustomerDetail['customerId'] }
  & {
    party: Pick<LedgerCustomerParty, 'id' | 'iconUrl'>,
    billingAddress?: Maybe<(
      Pick<CustomerAddress, 'id'>
      & { address?: Maybe<Pick<
          Address,
          | 'street'
          | 'streetAdditional'
          | 'city'
          | 'region'
          | 'postalCode'
          | 'countryCode'
          | 'lat'
          | 'long'
        >> }
    )>,
  }
);

export type LedgerInvoiceDiscountFieldsFragment = (
  Pick<
    LedgerInvoiceDiscount,
    | 'id'
    | 'discountId'
    | 'name'
    | 'description'
    | 'variablePercentage'
    | 'classificationId'
  >
  & {
    amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    fixedDiscountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    category?: Maybe<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>,
    department?: Maybe<(
      { __typename: 'EntityDepartment' }
      & Pick<
        EntityDepartment,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    location?: Maybe<(
      { __typename: 'EntityLocation' }
      & Pick<
        EntityLocation,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
  }
);

export type LedgerInvoiceLineItemFieldsFragment = (
  Pick<
    LedgerInvoiceLineItem,
    | 'id'
    | 'name'
    | 'description'
    | 'quantity'
    | 'imageUrl'
    | 'productId'
    | 'productVariantId'
    | 'classificationId'
    | 'externalLineItemId'
    | 'sku'
  >
  & {
    amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    unitPrice: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    category?: Maybe<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>,
    department?: Maybe<(
      { __typename: 'EntityDepartment' }
      & Pick<
        EntityDepartment,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    location?: Maybe<(
      { __typename: 'EntityLocation' }
      & Pick<
        EntityLocation,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    discounts?: Maybe<Array<(
      Pick<
        LedgerInvoiceDiscount,
        | 'id'
        | 'discountId'
        | 'name'
        | 'description'
        | 'variablePercentage'
        | 'classificationId'
      >
      & {
        amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        fixedDiscountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        category?: Maybe<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>,
        department?: Maybe<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        location?: Maybe<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
      }
    )>>,
  }
);

export type LedgerInvoiceSummaryFieldsFragment = (
  Pick<
    LedgerInvoiceSummary,
    | 'id'
    | 'dueAt'
    | 'paidAt'
    | 'invoiceNumber'
    | 'referenceNumber'
    | 'status'
    | 'transactionFactId'
    | 'statusAt'
    | 'createdAt'
    | 'providerType'
    | 'sourceIconUrls'
  >
  & {
    customer: Pick<
        CustomerSummary,
        | 'id'
        | 'name'
        | 'email'
        | 'icon'
      >,
    amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    amountDue?: Maybe<Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
  }
);

export type PayInvoiceSummaryFieldsFragment = (
  Pick<PayInvoiceSummary, 'status'>
  & { invoicePaymentDetails: (
    Pick<InvoicePaymentDetails, 'paymentConfirmationId' | 'paymentDate'>
    & {
      paymentAmount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      paymentInstrument:
        | (
          { __typename: 'BankAccount' }
          & Pick<
            BankAccount,
            | 'id'
            | 'institutionName'
            | 'name'
            | 'accountIdMask'
            | 'isDefault'
            | 'nickname'
            | 'isAutoPayout'
            | 'iconObjectName'
          >
        )
        | (
          { __typename: 'CreditCard' }
          & Pick<CreditCard, 'id' | 'cardLastFour' | 'cardBrand'>
        )
      ,
    }
  ) }
);

export type LedgerDeleteDraftInvoiceMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
}>;


export type LedgerDeleteDraftInvoiceMutation = Pick<Mutation, 'ledgerDeleteDraftInvoice'>;

export type LedgerDuplicateInvoiceMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
}>;


export type LedgerDuplicateInvoiceMutation = Pick<Mutation, 'ledgerDuplicateInvoice'>;

export type LedgerMarkDraftInvoiceAsPaidMutationVariables = Exact<{
  viewKey: ViewKey;
  legalEntityId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  datePaid: Scalars['DateTime']['input'];
  categoryId: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type LedgerMarkDraftInvoiceAsPaidMutation = Pick<Mutation, 'ledgerMarkDraftInvoiceAsPaid'>;

export type LedgerMarkInvoiceAsPaidMutationVariables = Exact<{
  viewKey: ViewKey;
  legalEntityId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
  datePaid: Scalars['DateTime']['input'];
  categoryId?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type LedgerMarkInvoiceAsPaidMutation = Pick<Mutation, 'ledgerMarkInvoiceAsPaid'>;

export type LedgerPayInvoiceMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  paymentInstrumentId: Scalars['String']['input'];
  expectedAmount: InputMonetaryValue;
}>;


export type LedgerPayInvoiceMutation = { ledgerPayInvoice: (
    Pick<PayInvoiceSummary, 'status'>
    & { invoicePaymentDetails: (
      Pick<InvoicePaymentDetails, 'paymentConfirmationId' | 'paymentDate'>
      & {
        paymentAmount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        paymentInstrument:
          | (
            { __typename: 'BankAccount' }
            & Pick<
              BankAccount,
              | 'id'
              | 'institutionName'
              | 'name'
              | 'accountIdMask'
              | 'isDefault'
              | 'nickname'
              | 'isAutoPayout'
              | 'iconObjectName'
            >
          )
          | (
            { __typename: 'CreditCard' }
            & Pick<CreditCard, 'id' | 'cardLastFour' | 'cardBrand'>
          )
        ,
      }
    ) }
  ) };

export type LedgerResendInvoiceMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  invoiceNumber: Scalars['String']['input'];
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  totalAmount: InputMonetaryValue;
  companyName: Scalars['String']['input'];
  companyIcon?: InputMaybe<Scalars['String']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  coverURL?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type LedgerResendInvoiceMutation = Pick<Mutation, 'ledgerResendInvoice'>;

export type LedgerResendInvoiceManuallyMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  invoiceNumber: Scalars['String']['input'];
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  totalAmount: InputMonetaryValue;
  companyName: Scalars['String']['input'];
  companyIcon?: InputMaybe<Scalars['String']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  coverURL?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type LedgerResendInvoiceManuallyMutation = Pick<Mutation, 'ledgerResendInvoiceManually'>;

export type LedgerSaveInvoiceMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoice: LedgerInputInvoice;
}>;


export type LedgerSaveInvoiceMutation = { ledgerSaveInvoice: Pick<LedgerSaveInvoiceResult, 'ledgerTransactionId'> };

export type LedgerSaveInvoiceCustomerMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  customer: InputLedgerCustomer;
}>;


export type LedgerSaveInvoiceCustomerMutation = { ledgerSaveInvoiceCustomer: (
    Pick<
      LedgerCustomerDetail,
      | 'name'
      | 'email'
      | 'phone'
      | 'contactName'
      | 'secondaryEmail'
      | 'paymentTerms'
      | 'description'
      | 'providerType'
      | 'dataSourcePartyId'
    >
    & { id: LedgerCustomerDetail['customerId'] }
    & {
      party: Pick<LedgerCustomerParty, 'id' | 'iconUrl'>,
      billingAddress?: Maybe<(
        Pick<CustomerAddress, 'id'>
        & { address?: Maybe<Pick<
            Address,
            | 'street'
            | 'streetAdditional'
            | 'city'
            | 'region'
            | 'postalCode'
            | 'countryCode'
            | 'lat'
            | 'long'
          >> }
      )>,
    }
  ) };

export type LedgerSaveInvoiceDiscountMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  discount: InputDataSourceDiscount;
}>;


export type LedgerSaveInvoiceDiscountMutation = { ledgerSaveInvoiceDiscount: (
    Pick<
      Discount,
      | 'discountId'
      | 'name'
      | 'variablePercentage'
      | 'providerType'
      | 'categoryId'
    >
    & { fixedDiscountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
  ) };

export type LedgerSaveInvoiceEmailConfigMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  recipients?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  cc?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  bcc?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
}>;


export type LedgerSaveInvoiceEmailConfigMutation = Pick<Mutation, 'ledgerSaveInvoiceEmailConfig'>;

export type LedgerSaveInvoicingProfileMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  profile: InputInvoicingProfile;
}>;


export type LedgerSaveInvoicingProfileMutation = { ledgerSaveInvoicingProfile: (
    Pick<
      InvoicingProfile,
      | 'id'
      | 'companyEmail'
      | 'companyName'
      | 'companyIcon'
      | 'payoutInstrumentID'
      | 'invoiceNumberFormatDefault'
      | 'invoiceNumberFormat'
    >
    & { companyAddress: (
      Pick<InvoicingAddress, 'id'>
      & { address: Pick<
          Address,
          | 'street'
          | 'streetAdditional'
          | 'city'
          | 'region'
          | 'postalCode'
          | 'countryCode'
          | 'lat'
          | 'long'
        > }
    ) }
  ) };

export type LedgerSendInvoiceMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  invoiceNumber: Scalars['String']['input'];
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  totalAmount: InputMonetaryValue;
  companyName: Scalars['String']['input'];
  companyIcon?: InputMaybe<Scalars['String']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  coverURL?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type LedgerSendInvoiceMutation = Pick<Mutation, 'ledgerSendInvoice'>;

export type LedgerSendInvoiceManuallyMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  invoiceNumber: Scalars['String']['input'];
  invoiceDate?: InputMaybe<Scalars['DateTime']['input']>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  totalAmount: InputMonetaryValue;
  companyName: Scalars['String']['input'];
  companyIcon?: InputMaybe<Scalars['String']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  coverURL?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type LedgerSendInvoiceManuallyMutation = Pick<Mutation, 'ledgerSendInvoiceManually'>;

export type LedgerSetInvoiceBrandingMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  branding: InputInvoiceBranding;
}>;


export type LedgerSetInvoiceBrandingMutation = { ledgerSetInvoiceBranding: Pick<InvoiceBranding, 'id' | 'backgroundColor' | 'coverURL'> };

export type LedgerVoidInvoiceMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  internalNote?: InputMaybe<Scalars['String']['input']>;
}>;


export type LedgerVoidInvoiceMutation = Pick<Mutation, 'ledgerVoidInvoice'>;

export type PayInvoiceMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  receivableInvoiceId?: InputMaybe<Scalars['String']['input']>;
  paymentInstrumentId: Scalars['String']['input'];
}>;


export type PayInvoiceMutation = { payInvoice: (
    Pick<PayInvoiceSummary, 'status'>
    & { invoicePaymentDetails: (
      Pick<InvoicePaymentDetails, 'paymentConfirmationId' | 'paymentDate'>
      & {
        paymentAmount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        paymentInstrument:
          | (
            { __typename: 'BankAccount' }
            & Pick<
              BankAccount,
              | 'id'
              | 'institutionName'
              | 'name'
              | 'accountIdMask'
              | 'isDefault'
              | 'nickname'
              | 'isAutoPayout'
              | 'iconObjectName'
            >
          )
          | (
            { __typename: 'CreditCard' }
            & Pick<CreditCard, 'id' | 'cardLastFour' | 'cardBrand'>
          )
        ,
      }
    ) }
  ) };

export type SubmitInvoiceCardPaymentMutationVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  paymentMethodData: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
  browserInfo?: InputMaybe<Scalars['String']['input']>;
  riskData?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<CardBillingAddressInput>;
  holderName?: InputMaybe<Scalars['String']['input']>;
  storePaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  payerLegalEntityId?: InputMaybe<Scalars['String']['input']>;
  requestedTestAcquirerResponseCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubmitInvoiceCardPaymentMutation = { submitInvoiceCardPayment: Pick<
      InvoiceCardPaymentResult,
      | 'result'
      | 'paymentConfirmationId'
      | 'pspReference'
      | 'actionData'
      | 'errorMessage'
      | 'refusalReasonCode'
      | 'cardBrand'
      | 'cardLastFour'
    > };

export type UploadInvoicingProfileIconMutationVariables = Exact<{
  orgName: Scalars['String']['input'];
  iconBase64: Scalars['String']['input'];
}>;


export type UploadInvoicingProfileIconMutation = Pick<Mutation, 'uploadInvoicingProfileIcon'>;

export type LedgerGetDraftInvoiceDefaultsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoiceProfileId: Scalars['String']['input'];
}>;


export type LedgerGetDraftInvoiceDefaultsQuery = { ledgerGetDraftInvoiceDefaults: (
    Pick<
      InvoiceDefaults,
      | 'id'
      | 'invoiceDate'
      | 'dueDate'
      | 'invoiceNumber'
    >
    & { branding: Pick<InvoiceBranding, 'id' | 'backgroundColor' | 'coverURL'> }
  ) };

export type LedgerGetNextInvoiceNumberQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoiceProfileId: Scalars['String']['input'];
}>;


export type LedgerGetNextInvoiceNumberQuery = { ledgerGetNextInvoiceNumber: Pick<InvoiceNumber, 'invoiceNumber'> };

export type LedgerListConnectInvoicesQueryVariables = Exact<{
  viewKey: ViewKey;
  paidSinceDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LedgerListConnectInvoicesQuery = { ledgerListConnectInvoices: Array<(
    Pick<
      LedgerInvoiceSummary,
      | 'id'
      | 'dueAt'
      | 'paidAt'
      | 'invoiceNumber'
      | 'referenceNumber'
      | 'status'
      | 'transactionFactId'
      | 'statusAt'
      | 'createdAt'
      | 'providerType'
      | 'sourceIconUrls'
    >
    & {
      customer: Pick<
          CustomerSummary,
          | 'id'
          | 'name'
          | 'email'
          | 'icon'
        >,
      amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      amountDue?: Maybe<Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    }
  )> };

export type LedgerListInvoiceWorkflowStatusUpdatesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
}>;


export type LedgerListInvoiceWorkflowStatusUpdatesQuery = { ledgerListInvoiceWorkflowStatusUpdates: Array<(
    Pick<
      LedgerInvoiceWorkflowStatusUpdate,
      | 'id'
      | 'status'
      | 'statusAt'
      | 'statusSource'
      | 'internalNote'
    >
    & { user?: Maybe<Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >> }
  )> };

export type LedgerListInvoicesByCustomerQueryVariables = Exact<{
  viewKey: ViewKey;
  customerId: Scalars['String']['input'];
}>;


export type LedgerListInvoicesByCustomerQuery = { ledgerListInvoicesByCustomer: Array<(
    Pick<
      LedgerInvoiceSummary,
      | 'id'
      | 'dueAt'
      | 'paidAt'
      | 'invoiceNumber'
      | 'referenceNumber'
      | 'status'
      | 'transactionFactId'
      | 'statusAt'
      | 'createdAt'
      | 'providerType'
      | 'sourceIconUrls'
    >
    & {
      customer: Pick<
          CustomerSummary,
          | 'id'
          | 'name'
          | 'email'
          | 'icon'
        >,
      amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      amountDue?: Maybe<Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    }
  )> };

export type LedgerListInvoicingProfilesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type LedgerListInvoicingProfilesQuery = { ledgerListInvoicingProfiles: Array<(
    Pick<
      InvoicingProfile,
      | 'id'
      | 'companyEmail'
      | 'companyName'
      | 'companyIcon'
      | 'payoutInstrumentID'
      | 'invoiceNumberFormatDefault'
      | 'invoiceNumberFormat'
    >
    & { companyAddress: (
      Pick<InvoicingAddress, 'id'>
      & { address: Pick<
          Address,
          | 'street'
          | 'streetAdditional'
          | 'city'
          | 'region'
          | 'postalCode'
          | 'countryCode'
          | 'lat'
          | 'long'
        > }
    ) }
  )> };

export type LedgerListPaidInvoicesQueryVariables = Exact<{
  viewKey: ViewKey;
  paidSinceDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LedgerListPaidInvoicesQuery = { ledgerListPaidInvoices: Array<(
    Pick<
      LedgerInvoiceSummary,
      | 'id'
      | 'dueAt'
      | 'paidAt'
      | 'invoiceNumber'
      | 'referenceNumber'
      | 'status'
      | 'transactionFactId'
      | 'statusAt'
      | 'createdAt'
      | 'providerType'
      | 'sourceIconUrls'
    >
    & {
      customer: Pick<
          CustomerSummary,
          | 'id'
          | 'name'
          | 'email'
          | 'icon'
        >,
      amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      amountDue?: Maybe<Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    }
  )> };

export type LedgerListPendingInvoicesQueryVariables = Exact<{
  viewKey: ViewKey;
}>;


export type LedgerListPendingInvoicesQuery = { ledgerListPendingInvoices: Array<(
    Pick<
      LedgerInvoiceSummary,
      | 'id'
      | 'dueAt'
      | 'paidAt'
      | 'invoiceNumber'
      | 'referenceNumber'
      | 'status'
      | 'transactionFactId'
      | 'statusAt'
      | 'createdAt'
      | 'providerType'
      | 'sourceIconUrls'
    >
    & {
      customer: Pick<
          CustomerSummary,
          | 'id'
          | 'name'
          | 'email'
          | 'icon'
        >,
      amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      amountDue?: Maybe<Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    }
  )> };

export type LedgerListVoidedInvoicesQueryVariables = Exact<{
  viewKey: ViewKey;
}>;


export type LedgerListVoidedInvoicesQuery = { ledgerListVoidedInvoices: Array<(
    Pick<
      LedgerInvoiceSummary,
      | 'id'
      | 'dueAt'
      | 'paidAt'
      | 'invoiceNumber'
      | 'referenceNumber'
      | 'status'
      | 'transactionFactId'
      | 'statusAt'
      | 'createdAt'
      | 'providerType'
      | 'sourceIconUrls'
    >
    & {
      customer: Pick<
          CustomerSummary,
          | 'id'
          | 'name'
          | 'email'
          | 'icon'
        >,
      amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      amountDue?: Maybe<Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    }
  )> };

export type LedgerPreviewInputInvoiceEmailQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoice: InputInvoice;
  details: InputInvoiceEmailDetails;
}>;


export type LedgerPreviewInputInvoiceEmailQuery = Pick<Query, 'ledgerPreviewInputInvoiceEmail'>;

export type LedgerPreviewInvoiceEmailQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  input: LedgerPreviewInvoiceEmailInput;
}>;


export type LedgerPreviewInvoiceEmailQuery = Pick<Query, 'ledgerPreviewInvoiceEmail'>;

export type LedgerReadInvoiceEmailConfigQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  dataSourcePartyId?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LedgerReadInvoiceEmailConfigQuery = { ledgerReadInvoiceEmailConfig?: Maybe<Pick<
      InvoiceEmailConfig,
      | 'invoiceId'
      | 'recipients'
      | 'cc'
      | 'bcc'
      | 'subject'
      | 'memo'
    >> };

export type LedgerReadInvoiceTransactionQueryVariables = Exact<{
  transactionFactId?: InputMaybe<Scalars['String']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  viewKey: ViewKey;
}>;


export type LedgerReadInvoiceTransactionQuery = { ledgerReadInvoiceTransaction: (
    Pick<
      LedgerReadInvoiceTransaction,
      | 'id'
      | 'transactionFactId'
      | 'arFactId'
      | 'ledgerTransactionId'
      | 'status'
      | 'invoiceNumber'
      | 'referenceNumber'
      | 'invoiceDate'
      | 'dueDate'
      | 'memo'
    >
    & {
      arCategory?: Maybe<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>,
      customer?: Maybe<(
        Pick<
          LedgerCustomerDetail,
          | 'name'
          | 'email'
          | 'phone'
          | 'contactName'
          | 'secondaryEmail'
          | 'paymentTerms'
          | 'description'
          | 'providerType'
          | 'dataSourcePartyId'
        >
        & { id: LedgerCustomerDetail['customerId'] }
        & {
          party: Pick<LedgerCustomerParty, 'id' | 'iconUrl'>,
          billingAddress?: Maybe<(
            Pick<CustomerAddress, 'id'>
            & { address?: Maybe<Pick<
                Address,
                | 'street'
                | 'streetAdditional'
                | 'city'
                | 'region'
                | 'postalCode'
                | 'countryCode'
                | 'lat'
                | 'long'
              >> }
          )>,
        }
      )>,
      lineItems: Array<(
        Pick<
          LedgerInvoiceLineItem,
          | 'id'
          | 'name'
          | 'description'
          | 'quantity'
          | 'imageUrl'
          | 'productId'
          | 'productVariantId'
          | 'classificationId'
          | 'externalLineItemId'
          | 'sku'
        >
        & {
          amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
          unitPrice: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
          category?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
          department?: Maybe<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          location?: Maybe<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          discounts?: Maybe<Array<(
            Pick<
              LedgerInvoiceDiscount,
              | 'id'
              | 'discountId'
              | 'name'
              | 'description'
              | 'variablePercentage'
              | 'classificationId'
            >
            & {
              amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              fixedDiscountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              category?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
              department?: Maybe<(
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
              location?: Maybe<(
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )>,
            }
          )>>,
        }
      )>,
      invoiceDiscounts: Array<(
        Pick<
          LedgerInvoiceDiscount,
          | 'id'
          | 'discountId'
          | 'name'
          | 'description'
          | 'variablePercentage'
          | 'classificationId'
        >
        & {
          amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
          fixedDiscountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          category?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
          department?: Maybe<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          location?: Maybe<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
        }
      )>,
      subtotal?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
      totalAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
      branding?: Maybe<Pick<InvoiceBranding, 'id' | 'backgroundColor' | 'coverURL'>>,
    }
  ) };

export type LedgerReadSentInvoiceFilesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type LedgerReadSentInvoiceFilesQuery = { ledgerReadSentInvoiceFiles: Array<Pick<InvoiceFile, 'documentId' | 'fileType'>> };

export type LedgerSearchInvoiceCustomersQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  text: Scalars['String']['input'];
}>;


export type LedgerSearchInvoiceCustomersQuery = { ledgerSearchInvoiceCustomers: { customers: Array<(
      Pick<
        LedgerCustomerDetail,
        | 'name'
        | 'email'
        | 'phone'
        | 'contactName'
        | 'secondaryEmail'
        | 'paymentTerms'
        | 'description'
        | 'providerType'
        | 'dataSourcePartyId'
      >
      & { id: LedgerCustomerDetail['customerId'] }
      & {
        party: Pick<LedgerCustomerParty, 'id' | 'iconUrl'>,
        billingAddress?: Maybe<(
          Pick<CustomerAddress, 'id'>
          & { address?: Maybe<Pick<
              Address,
              | 'street'
              | 'streetAdditional'
              | 'city'
              | 'region'
              | 'postalCode'
              | 'countryCode'
              | 'lat'
              | 'long'
            >> }
        )>,
      }
    )> } };

export type LedgerSearchInvoiceDiscountsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  text: Scalars['String']['input'];
}>;


export type LedgerSearchInvoiceDiscountsQuery = { ledgerSearchInvoiceDiscounts: Array<(
    Pick<
      Discount,
      | 'discountId'
      | 'name'
      | 'variablePercentage'
      | 'providerType'
      | 'categoryId'
    >
    & { fixedDiscountAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
  )> };

export type LedgerValidateInvoiceNumberQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoiceProfileId: Scalars['String']['input'];
  invoiceNumber: Scalars['String']['input'];
}>;


export type LedgerValidateInvoiceNumberQuery = Pick<Query, 'ledgerValidateInvoiceNumber'>;

export type ListInvoicingProfilesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListInvoicingProfilesQuery = { listInvoicingProfiles: Array<(
    Pick<
      InvoicingProfile,
      | 'id'
      | 'companyEmail'
      | 'companyName'
      | 'companyIcon'
      | 'payoutInstrumentID'
      | 'invoiceNumberFormatDefault'
      | 'invoiceNumberFormat'
    >
    & { companyAddress: (
      Pick<InvoicingAddress, 'id'>
      & { address: Pick<
          Address,
          | 'street'
          | 'streetAdditional'
          | 'city'
          | 'region'
          | 'postalCode'
          | 'countryCode'
          | 'lat'
          | 'long'
        > }
    ) }
  )> };

export type BusinessVerificationApplicationFieldsFragment = (
  Pick<
    BusinessVerificationApplication,
    | 'companyType'
    | 'businessName'
    | 'phoneNumber'
    | 'industryCode'
    | 'industryCodeId'
    | 'companyWebsite'
  >
  & {
    annualRevenue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    owner?: Maybe<(
      Pick<Owner, 'firstName' | 'lastName'>
      & { residentialAddress?: Maybe<Pick<
          Address,
          | 'street'
          | 'streetAdditional'
          | 'city'
          | 'region'
          | 'postalCode'
          | 'countryCode'
          | 'lat'
          | 'long'
        >> }
    )>,
    address?: Maybe<Pick<
        Address,
        | 'street'
        | 'streetAdditional'
        | 'city'
        | 'region'
        | 'postalCode'
        | 'countryCode'
        | 'lat'
        | 'long'
      >>,
    physicalStoreAddress?: Maybe<Pick<
        Address,
        | 'street'
        | 'streetAdditional'
        | 'city'
        | 'region'
        | 'postalCode'
        | 'countryCode'
        | 'lat'
        | 'long'
      >>,
  }
);

export type BusinessVerificationStatusResultFieldsFragment = Pick<
    BusinessVerificationStatusResult,
    | 'status'
    | 'expiresAt'
    | 'needsPciSaqSigned'
    | 'pciSaqDeadline'
    | 'isRestricted'
  >;

export type SaveBusinessVerificationApplicationMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  application: BusinessVerificationApplicationInput;
}>;


export type SaveBusinessVerificationApplicationMutation = Pick<Mutation, 'saveBusinessVerificationApplication'>;

export type SendBusinessVerificationApplicationMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
  ownerSSN: Scalars['String']['input'];
  ownerDOB: DateInput;
  ein?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendBusinessVerificationApplicationMutation = { sendBusinessVerificationApplication: Pick<BusinessVerification, 'url'> };

export type GetBusinessVerificationApplicationQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type GetBusinessVerificationApplicationQuery = { getBusinessVerificationApplication?: Maybe<(
    Pick<
      BusinessVerificationApplication,
      | 'companyType'
      | 'businessName'
      | 'phoneNumber'
      | 'industryCode'
      | 'industryCodeId'
      | 'companyWebsite'
    >
    & {
      annualRevenue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
      owner?: Maybe<(
        Pick<Owner, 'firstName' | 'lastName'>
        & { residentialAddress?: Maybe<Pick<
            Address,
            | 'street'
            | 'streetAdditional'
            | 'city'
            | 'region'
            | 'postalCode'
            | 'countryCode'
            | 'lat'
            | 'long'
          >> }
      )>,
      address?: Maybe<Pick<
          Address,
          | 'street'
          | 'streetAdditional'
          | 'city'
          | 'region'
          | 'postalCode'
          | 'countryCode'
          | 'lat'
          | 'long'
        >>,
      physicalStoreAddress?: Maybe<Pick<
          Address,
          | 'street'
          | 'streetAdditional'
          | 'city'
          | 'region'
          | 'postalCode'
          | 'countryCode'
          | 'lat'
          | 'long'
        >>,
    }
  )> };

export type GetBusinessVerificationStatusQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type GetBusinessVerificationStatusQuery = { getBusinessVerificationStatus: Pick<
      BusinessVerificationStatusResult,
      | 'status'
      | 'expiresAt'
      | 'needsPciSaqSigned'
      | 'pciSaqDeadline'
      | 'isRestricted'
    > };

export type GetHostedOnboardingLinkQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  returnURL: Scalars['String']['input'];
}>;


export type GetHostedOnboardingLinkQuery = { getHostedOnboardingLink: Pick<BusinessVerification, 'url'> };

export type AgingSummaryChartConfigFieldsFragment = (
  Pick<AgingSummaryChartConfig, 'kind' | 'dimensions' | 'masks'>
  & { origin: Pick<
      ArchiveIntervalOrigin,
      | 'interval'
      | 'year'
      | 'index'
      | 'intervalCount'
      | 'maxTime'
    > }
);

export type CashSummaryChartConfigFieldsFragment = { origin: Pick<
      ArchiveIntervalOrigin,
      | 'interval'
      | 'year'
      | 'index'
      | 'intervalCount'
      | 'maxTime'
    > };

export type CashSummaryFieldsFragment = {
    cashTotal: (
      Pick<DimensionSummary, 'partialData'>
      & { time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> }
    ),
    cashChange: (
      Pick<DimensionSummary, 'partialData'>
      & { category: Array<{
          categoryObject: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          by: { time: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }> },
        }> }
    ),
  };

export type CategoryByDepartmentChartConfigFieldsFragment = (
  Pick<CategoryByDepartmentChartConfig, 'categoryId' | 'departmentIds'>
  & { origin: Pick<
      ArchiveIntervalOrigin,
      | 'interval'
      | 'year'
      | 'index'
      | 'intervalCount'
      | 'maxTime'
    > }
);

export type CategoryByLocationChartConfigFieldsFragment = (
  Pick<CategoryByLocationChartConfig, 'categoryId' | 'locationIds'>
  & { origin: Pick<
      ArchiveIntervalOrigin,
      | 'interval'
      | 'year'
      | 'index'
      | 'intervalCount'
      | 'maxTime'
    > }
);

export type CategoryChartConfigFieldsFragment = (
  Pick<CategoryChartConfig, 'categoryId' | 'withoutCategoryAncestors' | 'asPermanent'>
  & { origin: Pick<
      ArchiveIntervalOrigin,
      | 'interval'
      | 'year'
      | 'index'
      | 'intervalCount'
      | 'maxTime'
    > }
);

export type CategoryHoverFieldsFragment = (
  { __typename: 'CategoryHover' }
  & Pick<CategoryHover, 'balance'>
  & {
    entity: (
      { __typename: 'EntityCategory' }
      & Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >
    ),
    history: (
      Pick<DimensionSummary, 'partialData'>
      & { time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> }
    ),
    context?: Maybe<(
      Pick<DimensionSummary, 'partialData'>
      & { party: Array<{
          partyObject: Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >,
          summary: (
            Pick<TransactionSummary, 'isPeriodBookClosed'>
            & {
              period: Pick<
                  Period,
                  | 'name'
                  | 'interval'
                  | 'startedAt'
                  | 'endedAt'
                >,
              total: (
                Pick<
                  PeriodMonetaryValue,
                  | 'transactionsCount'
                  | 'deltaPrevious'
                  | 'deltaYearAgo'
                  | 'isFirstOccurrencePeriod'
                >
                & {
                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  moneyFlow?: Maybe<(
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  )>,
                  current?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                  prior?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                }
              ),
            }
          ),
        }> }
    )>,
    topTransactions?: Maybe<Array<(
      Pick<
        EntityTransaction,
        | 'viewId'
        | 'factId'
        | 'timestamp'
        | 'description'
        | 'externalId'
        | 'displayEntry'
      >
      & {
        moneyFlow: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        party?: Maybe<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>,
        displayCategory: Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >,
        splitCategory?: Maybe<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>,
      }
    )>>,
  }
);

export type DepartmentChartConfigFieldsFragment = (
  Pick<DepartmentChartConfig, 'departmentId'>
  & { origin: Pick<
      ArchiveIntervalOrigin,
      | 'interval'
      | 'year'
      | 'index'
      | 'intervalCount'
      | 'maxTime'
    > }
);

export type DepartmentHistoryFieldsFragment = { department: Array<(
    Pick<DepartmentDimension, 'departmentId'>
    & {
      departmentObject: (
        { __typename: 'EntityDepartment' }
        & Pick<
          EntityDepartment,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      ),
      by: { time: Array<{ summary: (
            Pick<TransactionSummary, 'isPeriodBookClosed'>
            & {
              period: Pick<
                  Period,
                  | 'name'
                  | 'interval'
                  | 'startedAt'
                  | 'endedAt'
                >,
              total: (
                Pick<
                  PeriodMonetaryValue,
                  | 'transactionsCount'
                  | 'deltaPrevious'
                  | 'deltaYearAgo'
                  | 'isFirstOccurrencePeriod'
                >
                & {
                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  moneyFlow?: Maybe<(
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  )>,
                  current?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                  prior?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                }
              ),
            }
          ) }> },
    }
  )> };

export type EntitiesListConfigFieldsFragment = {
    origin: Pick<
        ArchiveIntervalOrigin,
        | 'interval'
        | 'year'
        | 'index'
        | 'intervalCount'
        | 'maxTime'
      >,
    entities: (
      { __typename: 'ObjectEntities' }
      & {
        users?: Maybe<Array<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>>,
        transactions?: Maybe<Array<(
          Pick<
            EntityTransaction,
            | 'viewId'
            | 'factId'
            | 'timestamp'
            | 'description'
            | 'externalId'
            | 'displayEntry'
          >
          & {
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            party?: Maybe<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
            displayCategory: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            splitCategory?: Maybe<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>,
          }
        )>>,
        comments?: Maybe<Array<Pick<
            EntityComment,
            | 'id'
            | 'authorId'
            | 'text'
            | 'timestamp'
          >>>,
        reports?: Maybe<Array<(
          Pick<
            EntityReport,
            | 'id'
            | 'title'
            | 'authorId'
            | 'mimeType'
            | 'createdAt'
          >
          & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
        )>>,
        reportPackages?: Maybe<Array<(
          Pick<
            EntityReportPackage,
            | 'id'
            | 'title'
            | 'authorId'
            | 'interval'
            | 'periodStartedAt'
            | 'periodEndedAt'
            | 'createdAt'
            | 'updatedAt'
            | 'coverUrl'
          >
          & { documents: Array<Pick<
              SharedReportDocumentMetadata,
              | 'id'
              | 'documentObjectId'
              | 'documentObjectVersionId'
              | 'title'
              | 'mimeType'
            >> }
        )>>,
        parties?: Maybe<Array<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>>,
        datasources?: Maybe<Array<Pick<
            EntityDataSource,
            | 'id'
            | 'name'
            | 'url'
            | 'iconUrl'
          >>>,
        categories?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>>,
        threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
        legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
        workItems?: Maybe<Array<(
          Pick<
            EntityWorkItem,
            | 'id'
            | 'time'
            | 'workItemState'
            | 'workItemType'
            | 'reviewCreatedById'
            | 'reviewState'
            | 'ledgerType'
          >
          & { objectTransaction: (
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          ) }
        )>>,
        invoices?: Maybe<Array<(
          Pick<
            EntityInvoice,
            | 'id'
            | 'externalDisplayId'
            | 'createdAt'
            | 'dueAt'
          >
          & {
            amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            customer: (
              Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
              & { party: Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                > }
            ),
          }
        )>>,
        bills?: Maybe<Array<(
          Pick<
            EntityBill,
            | 'id'
            | 'billStatus'
            | 'vendorName'
            | 'billDescription'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
            format: (
              Pick<Format, 'id' | 'formatClass'>
              & { segments: Array<Pick<
                  Segment,
                  | 'collectionId'
                  | 'fileId'
                  | 'sequence'
                  | 'token'
                >> }
            ),
            approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
          }
        )>>,
        identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
        departments?: Maybe<Array<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        locations?: Maybe<Array<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        reconciliations?: Maybe<Array<(
          { __typename: 'EntityReconciliation' }
          & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
          & {
            startDate: Pick<Date, 'year' | 'month' | 'day'>,
            endDate: Pick<Date, 'year' | 'month' | 'day'>,
          }
        )>>,
        ledgerTransactions?: Maybe<Array<(
          Pick<
            EntityLedgerTransaction,
            | 'id'
            | 'timestamp'
            | 'factIds'
            | 'name'
            | 'referenceNumber'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            parties: Array<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
          }
        )>>,
        schedules?: Maybe<Array<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
            | 'cutoverDate'
          >
          & {
            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>>,
      }
    ),
  };

export type InsightComponentConfigFieldsFragment = {
    objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
    options?: Maybe<Pick<InsightComponentConfigOptions, 'partyRole'>>,
    origin: Pick<
        ArchiveIntervalOrigin,
        | 'interval'
        | 'year'
        | 'index'
        | 'intervalCount'
        | 'maxTime'
      >,
    lookback: Pick<
        ArchiveIntervalOrigin,
        | 'interval'
        | 'year'
        | 'index'
        | 'intervalCount'
        | 'maxTime'
      >,
  };

export type LayoutComponentConfigFieldsFragment = (
  Pick<LayoutComponentConfig, 'type'>
  & {
    text?: Maybe<(
      Pick<TextComponentConfig, 'body'>
      & {
        current?: Maybe<Pick<
            ArchiveIntervalOrigin,
            | 'interval'
            | 'year'
            | 'index'
            | 'intervalCount'
            | 'maxTime'
          >>,
        lookback?: Maybe<Pick<
            ArchiveIntervalOrigin,
            | 'interval'
            | 'year'
            | 'index'
            | 'intervalCount'
            | 'maxTime'
          >>,
        tags?: Maybe<Array<(
          Pick<TextComponentConfigTag, 'displayText'>
          & {
            objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
            options?: Maybe<Pick<TextTagOptions, 'partyRole'>>,
          }
        )>>,
      }
    )>,
    categoryChart?: Maybe<(
      Pick<CategoryChartConfig, 'categoryId' | 'withoutCategoryAncestors' | 'asPermanent'>
      & { origin: Pick<
          ArchiveIntervalOrigin,
          | 'interval'
          | 'year'
          | 'index'
          | 'intervalCount'
          | 'maxTime'
        > }
    )>,
    partyChart?: Maybe<(
      Pick<PartyChartConfig, 'partyId' | 'partyRole' | 'asPermanent'>
      & { origin: Pick<
          ArchiveIntervalOrigin,
          | 'interval'
          | 'year'
          | 'index'
          | 'intervalCount'
          | 'maxTime'
        > }
    )>,
    topEntities?: Maybe<(
      Pick<
        TopEntitiesConfig,
        | 'limit'
        | 'kind'
        | 'partyRole'
        | 'categoryType'
        | 'sort'
      >
      & {
        origin: Pick<
            ArchiveIntervalOrigin,
            | 'interval'
            | 'year'
            | 'index'
            | 'intervalCount'
            | 'maxTime'
          >,
        filteredBy?: Maybe<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
      }
    )>,
    topTransactions?: Maybe<(
      Pick<TopTransactionsConfig, 'limit' | 'partyRole' | 'categoryType'>
      & {
        origin: Pick<
            ArchiveIntervalOrigin,
            | 'interval'
            | 'year'
            | 'index'
            | 'intervalCount'
            | 'maxTime'
          >,
        filteredBy?: Maybe<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
      }
    )>,
    summaryLineItem?: Maybe<(
      Pick<SummaryLineItemConfig, 'item'>
      & { origin: Pick<
          ArchiveIntervalOrigin,
          | 'interval'
          | 'year'
          | 'index'
          | 'intervalCount'
          | 'maxTime'
        > }
    )>,
    portalMetric?: Maybe<(
      Pick<PortalMetricConfig, 'metricType'>
      & { origin: Pick<
          ArchiveIntervalOrigin,
          | 'interval'
          | 'year'
          | 'index'
          | 'intervalCount'
          | 'maxTime'
        > }
    )>,
    entitiesList?: Maybe<{
        origin: Pick<
            ArchiveIntervalOrigin,
            | 'interval'
            | 'year'
            | 'index'
            | 'intervalCount'
            | 'maxTime'
          >,
        entities: (
          { __typename: 'ObjectEntities' }
          & {
            users?: Maybe<Array<Pick<
                EntityUser,
                | 'id'
                | 'givenName'
                | 'familyName'
                | 'emailAddress'
                | 'avatarUrl'
              >>>,
            transactions?: Maybe<Array<(
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            )>>,
            comments?: Maybe<Array<Pick<
                EntityComment,
                | 'id'
                | 'authorId'
                | 'text'
                | 'timestamp'
              >>>,
            reports?: Maybe<Array<(
              Pick<
                EntityReport,
                | 'id'
                | 'title'
                | 'authorId'
                | 'mimeType'
                | 'createdAt'
              >
              & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
            )>>,
            reportPackages?: Maybe<Array<(
              Pick<
                EntityReportPackage,
                | 'id'
                | 'title'
                | 'authorId'
                | 'interval'
                | 'periodStartedAt'
                | 'periodEndedAt'
                | 'createdAt'
                | 'updatedAt'
                | 'coverUrl'
              >
              & { documents: Array<Pick<
                  SharedReportDocumentMetadata,
                  | 'id'
                  | 'documentObjectId'
                  | 'documentObjectVersionId'
                  | 'title'
                  | 'mimeType'
                >> }
            )>>,
            parties?: Maybe<Array<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>>,
            datasources?: Maybe<Array<Pick<
                EntityDataSource,
                | 'id'
                | 'name'
                | 'url'
                | 'iconUrl'
              >>>,
            categories?: Maybe<Array<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>>,
            threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
            legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
            workItems?: Maybe<Array<(
              Pick<
                EntityWorkItem,
                | 'id'
                | 'time'
                | 'workItemState'
                | 'workItemType'
                | 'reviewCreatedById'
                | 'reviewState'
                | 'ledgerType'
              >
              & { objectTransaction: (
                Pick<
                  EntityTransaction,
                  | 'viewId'
                  | 'factId'
                  | 'timestamp'
                  | 'description'
                  | 'externalId'
                  | 'displayEntry'
                >
                & {
                  moneyFlow: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ),
                  party?: Maybe<Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    >>,
                  displayCategory: Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >,
                  splitCategory?: Maybe<Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >>,
                }
              ) }
            )>>,
            invoices?: Maybe<Array<(
              Pick<
                EntityInvoice,
                | 'id'
                | 'externalDisplayId'
                | 'createdAt'
                | 'dueAt'
              >
              & {
                amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                customer: (
                  Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                  & { party: Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    > }
                ),
              }
            )>>,
            bills?: Maybe<Array<(
              Pick<
                EntityBill,
                | 'id'
                | 'billStatus'
                | 'vendorName'
                | 'billDescription'
              >
              & {
                totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
                format: (
                  Pick<Format, 'id' | 'formatClass'>
                  & { segments: Array<Pick<
                      Segment,
                      | 'collectionId'
                      | 'fileId'
                      | 'sequence'
                      | 'token'
                    >> }
                ),
                approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
              }
            )>>,
            identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
            departments?: Maybe<Array<(
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>>,
            locations?: Maybe<Array<(
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>>,
            reconciliations?: Maybe<Array<(
              { __typename: 'EntityReconciliation' }
              & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
              & {
                startDate: Pick<Date, 'year' | 'month' | 'day'>,
                endDate: Pick<Date, 'year' | 'month' | 'day'>,
              }
            )>>,
            ledgerTransactions?: Maybe<Array<(
              Pick<
                EntityLedgerTransaction,
                | 'id'
                | 'timestamp'
                | 'factIds'
                | 'name'
                | 'referenceNumber'
              >
              & {
                totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                parties: Array<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
              }
            )>>,
            schedules?: Maybe<Array<(
              { __typename: 'EntitySchedule' }
              & Pick<
                EntitySchedule,
                | 'id'
                | 'name'
                | 'scheduleNumber'
                | 'scheduleType'
                | 'scheduleTemplateId'
                | 'categoryId'
                | 'relatedCategoryId'
                | 'partyId'
                | 'startDate'
                | 'endDate'
                | 'cutoverDate'
              >
              & {
                amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              }
            )>>,
          }
        ),
      }>,
    statement?: Maybe<(
      Pick<StatementConfig, 'kind'>
      & {
        origin: Pick<
            ArchiveIntervalOrigin,
            | 'interval'
            | 'year'
            | 'index'
            | 'intervalCount'
            | 'maxTime'
          >,
        options?: Maybe<(
          { __typename: 'ReportDocumentOptions' }
          & Pick<
            ReportDocumentOptions,
            | 'sparklineLookbackPeriods'
            | 'reportLookbackPeriods'
            | 'deltaMonthOverMonth'
            | 'deltaMonthOverMonthPeriods'
            | 'deltaYearOverYear'
            | 'comparedToTotal'
            | 'comparedToIncome'
            | 'amountPrecision'
            | 'yearToDate'
            | 'deltaYearToDate'
            | 'breakdownByClass'
          >
          & {
            collapsedSections?: Maybe<Pick<CollapsedSections, 'sections'>>,
            categoryByDepartmentOptions?: Maybe<(
              Pick<CategoryByDepartmentOptions, 'showOther' | 'showUnassigned'>
              & { departments?: Maybe<Array<Pick<DepartmentOption, 'departmentId' | 'name'>>> }
            )>,
            categoryByLocationOptions?: Maybe<(
              Pick<CategoryByLocationOptions, 'showOther' | 'showUnassigned'>
              & { locations?: Maybe<Array<Pick<LocationOption, 'locationId' | 'name'>>> }
            )>,
          }
        )>,
      }
    )>,
    metricChart?: Maybe<(
      Pick<MetricChartConfig, 'item'>
      & { origin: Pick<
          ArchiveIntervalOrigin,
          | 'interval'
          | 'year'
          | 'index'
          | 'intervalCount'
          | 'maxTime'
        > }
    )>,
    runwayChart?: Maybe<{
        origin: Pick<
            ArchiveIntervalOrigin,
            | 'interval'
            | 'year'
            | 'index'
            | 'intervalCount'
            | 'maxTime'
          >,
        netBurnLookback?: Maybe<Pick<
            ArchiveIntervalOrigin,
            | 'interval'
            | 'year'
            | 'index'
            | 'intervalCount'
            | 'maxTime'
          >>,
      }>,
    cashSummaryChart?: Maybe<{ origin: Pick<
          ArchiveIntervalOrigin,
          | 'interval'
          | 'year'
          | 'index'
          | 'intervalCount'
          | 'maxTime'
        > }>,
    staticMetric?: Maybe<Pick<StaticMetricConfig, 'name' | 'value' | 'updatedAt'>>,
    documentCollection?: Maybe<Pick<DocumentCollectionConfig, 'collectionId'>>,
    insight?: Maybe<{
        objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
        options?: Maybe<Pick<InsightComponentConfigOptions, 'partyRole'>>,
        origin: Pick<
            ArchiveIntervalOrigin,
            | 'interval'
            | 'year'
            | 'index'
            | 'intervalCount'
            | 'maxTime'
          >,
        lookback: Pick<
            ArchiveIntervalOrigin,
            | 'interval'
            | 'year'
            | 'index'
            | 'intervalCount'
            | 'maxTime'
          >,
      }>,
    departmentChart?: Maybe<(
      Pick<DepartmentChartConfig, 'departmentId'>
      & { origin: Pick<
          ArchiveIntervalOrigin,
          | 'interval'
          | 'year'
          | 'index'
          | 'intervalCount'
          | 'maxTime'
        > }
    )>,
    locationChart?: Maybe<(
      Pick<LocationChartConfig, 'locationId'>
      & { origin: Pick<
          ArchiveIntervalOrigin,
          | 'interval'
          | 'year'
          | 'index'
          | 'intervalCount'
          | 'maxTime'
        > }
    )>,
    sourceAccountMetric?: Maybe<(
      Pick<SourceAccountMetricConfig, 'key' | 'sourceAccountId' | 'dataSourceId'>
      & { origin: Pick<
          ArchiveIntervalOrigin,
          | 'interval'
          | 'year'
          | 'index'
          | 'intervalCount'
          | 'maxTime'
        > }
    )>,
    agingSummaryChart?: Maybe<(
      Pick<AgingSummaryChartConfig, 'kind' | 'dimensions' | 'masks'>
      & { origin: Pick<
          ArchiveIntervalOrigin,
          | 'interval'
          | 'year'
          | 'index'
          | 'intervalCount'
          | 'maxTime'
        > }
    )>,
    categoryByDepartmentChart?: Maybe<(
      Pick<CategoryByDepartmentChartConfig, 'categoryId' | 'departmentIds'>
      & { origin: Pick<
          ArchiveIntervalOrigin,
          | 'interval'
          | 'year'
          | 'index'
          | 'intervalCount'
          | 'maxTime'
        > }
    )>,
    categoryByLocationChart?: Maybe<(
      Pick<CategoryByLocationChartConfig, 'categoryId' | 'locationIds'>
      & { origin: Pick<
          ArchiveIntervalOrigin,
          | 'interval'
          | 'year'
          | 'index'
          | 'intervalCount'
          | 'maxTime'
        > }
    )>,
  }
);

export type LayoutDocumentFieldsFragment = Pick<
    LayoutDocument,
    | 'id'
    | 'title'
    | 'layoutId'
    | 'status'
    | 'createdAt'
    | 'updatedAt'
  >;

export type LayoutFieldsFragment = (
  Pick<Layout, 'layoutId' | 'layoutVersionId'>
  & {
    viewKey: Pick<
        ViewIdentifier,
        | 'legalEntityId'
        | 'viewVersion'
        | 'mutationVersion'
        | 'viewType'
      >,
    sections?: Maybe<Array<(
      Pick<LayoutSection, 'sectionId' | 'title'>
      & { rows?: Maybe<Array<(
        Pick<LayoutRow, 'rowId' | 'title'>
        & { components?: Maybe<Array<(
          Pick<LayoutComponent, 'componentId' | 'title' | 'dataId'>
          & { config: (
            Pick<LayoutComponentConfig, 'type'>
            & {
              text?: Maybe<(
                Pick<TextComponentConfig, 'body'>
                & {
                  current?: Maybe<Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    >>,
                  lookback?: Maybe<Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    >>,
                  tags?: Maybe<Array<(
                    Pick<TextComponentConfigTag, 'displayText'>
                    & {
                      objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
                      options?: Maybe<Pick<TextTagOptions, 'partyRole'>>,
                    }
                  )>>,
                }
              )>,
              categoryChart?: Maybe<(
                Pick<CategoryChartConfig, 'categoryId' | 'withoutCategoryAncestors' | 'asPermanent'>
                & { origin: Pick<
                    ArchiveIntervalOrigin,
                    | 'interval'
                    | 'year'
                    | 'index'
                    | 'intervalCount'
                    | 'maxTime'
                  > }
              )>,
              partyChart?: Maybe<(
                Pick<PartyChartConfig, 'partyId' | 'partyRole' | 'asPermanent'>
                & { origin: Pick<
                    ArchiveIntervalOrigin,
                    | 'interval'
                    | 'year'
                    | 'index'
                    | 'intervalCount'
                    | 'maxTime'
                  > }
              )>,
              topEntities?: Maybe<(
                Pick<
                  TopEntitiesConfig,
                  | 'limit'
                  | 'kind'
                  | 'partyRole'
                  | 'categoryType'
                  | 'sort'
                >
                & {
                  origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    >,
                  filteredBy?: Maybe<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
                }
              )>,
              topTransactions?: Maybe<(
                Pick<TopTransactionsConfig, 'limit' | 'partyRole' | 'categoryType'>
                & {
                  origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    >,
                  filteredBy?: Maybe<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
                }
              )>,
              summaryLineItem?: Maybe<(
                Pick<SummaryLineItemConfig, 'item'>
                & { origin: Pick<
                    ArchiveIntervalOrigin,
                    | 'interval'
                    | 'year'
                    | 'index'
                    | 'intervalCount'
                    | 'maxTime'
                  > }
              )>,
              portalMetric?: Maybe<(
                Pick<PortalMetricConfig, 'metricType'>
                & { origin: Pick<
                    ArchiveIntervalOrigin,
                    | 'interval'
                    | 'year'
                    | 'index'
                    | 'intervalCount'
                    | 'maxTime'
                  > }
              )>,
              entitiesList?: Maybe<{
                  origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    >,
                  entities: (
                    { __typename: 'ObjectEntities' }
                    & {
                      users?: Maybe<Array<Pick<
                          EntityUser,
                          | 'id'
                          | 'givenName'
                          | 'familyName'
                          | 'emailAddress'
                          | 'avatarUrl'
                        >>>,
                      transactions?: Maybe<Array<(
                        Pick<
                          EntityTransaction,
                          | 'viewId'
                          | 'factId'
                          | 'timestamp'
                          | 'description'
                          | 'externalId'
                          | 'displayEntry'
                        >
                        & {
                          moneyFlow: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ),
                          party?: Maybe<Pick<
                              EntityParty,
                              | 'id'
                              | 'name'
                              | 'iconUrl'
                              | 'shortDescription'
                              | 'roles'
                              | 'designation'
                            >>,
                          displayCategory: Pick<
                              EntityCategory,
                              | 'id'
                              | 'name'
                              | 'displayKey'
                              | 'chartOfAccountsDisplayNumber'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'productArea'
                              | 'active'
                            >,
                          splitCategory?: Maybe<Pick<
                              EntityCategory,
                              | 'id'
                              | 'name'
                              | 'displayKey'
                              | 'chartOfAccountsDisplayNumber'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'productArea'
                              | 'active'
                            >>,
                        }
                      )>>,
                      comments?: Maybe<Array<Pick<
                          EntityComment,
                          | 'id'
                          | 'authorId'
                          | 'text'
                          | 'timestamp'
                        >>>,
                      reports?: Maybe<Array<(
                        Pick<
                          EntityReport,
                          | 'id'
                          | 'title'
                          | 'authorId'
                          | 'mimeType'
                          | 'createdAt'
                        >
                        & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
                      )>>,
                      reportPackages?: Maybe<Array<(
                        Pick<
                          EntityReportPackage,
                          | 'id'
                          | 'title'
                          | 'authorId'
                          | 'interval'
                          | 'periodStartedAt'
                          | 'periodEndedAt'
                          | 'createdAt'
                          | 'updatedAt'
                          | 'coverUrl'
                        >
                        & { documents: Array<Pick<
                            SharedReportDocumentMetadata,
                            | 'id'
                            | 'documentObjectId'
                            | 'documentObjectVersionId'
                            | 'title'
                            | 'mimeType'
                          >> }
                      )>>,
                      parties?: Maybe<Array<Pick<
                          EntityParty,
                          | 'id'
                          | 'name'
                          | 'iconUrl'
                          | 'shortDescription'
                          | 'roles'
                          | 'designation'
                        >>>,
                      datasources?: Maybe<Array<Pick<
                          EntityDataSource,
                          | 'id'
                          | 'name'
                          | 'url'
                          | 'iconUrl'
                        >>>,
                      categories?: Maybe<Array<Pick<
                          EntityCategory,
                          | 'id'
                          | 'name'
                          | 'displayKey'
                          | 'chartOfAccountsDisplayNumber'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'productArea'
                          | 'active'
                        >>>,
                      threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
                      legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
                      workItems?: Maybe<Array<(
                        Pick<
                          EntityWorkItem,
                          | 'id'
                          | 'time'
                          | 'workItemState'
                          | 'workItemType'
                          | 'reviewCreatedById'
                          | 'reviewState'
                          | 'ledgerType'
                        >
                        & { objectTransaction: (
                          Pick<
                            EntityTransaction,
                            | 'viewId'
                            | 'factId'
                            | 'timestamp'
                            | 'description'
                            | 'externalId'
                            | 'displayEntry'
                          >
                          & {
                            moneyFlow: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ),
                            party?: Maybe<Pick<
                                EntityParty,
                                | 'id'
                                | 'name'
                                | 'iconUrl'
                                | 'shortDescription'
                                | 'roles'
                                | 'designation'
                              >>,
                            displayCategory: Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >,
                            splitCategory?: Maybe<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>,
                          }
                        ) }
                      )>>,
                      invoices?: Maybe<Array<(
                        Pick<
                          EntityInvoice,
                          | 'id'
                          | 'externalDisplayId'
                          | 'createdAt'
                          | 'dueAt'
                        >
                        & {
                          amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          customer: (
                            Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                            & { party: Pick<
                                EntityParty,
                                | 'id'
                                | 'name'
                                | 'iconUrl'
                                | 'shortDescription'
                                | 'roles'
                                | 'designation'
                              > }
                          ),
                        }
                      )>>,
                      bills?: Maybe<Array<(
                        Pick<
                          EntityBill,
                          | 'id'
                          | 'billStatus'
                          | 'vendorName'
                          | 'billDescription'
                        >
                        & {
                          totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
                          format: (
                            Pick<Format, 'id' | 'formatClass'>
                            & { segments: Array<Pick<
                                Segment,
                                | 'collectionId'
                                | 'fileId'
                                | 'sequence'
                                | 'token'
                              >> }
                          ),
                          approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
                        }
                      )>>,
                      identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
                      departments?: Maybe<Array<(
                        { __typename: 'EntityDepartment' }
                        & Pick<
                          EntityDepartment,
                          | 'id'
                          | 'name'
                          | 'parentId'
                          | 'active'
                        >
                      )>>,
                      locations?: Maybe<Array<(
                        { __typename: 'EntityLocation' }
                        & Pick<
                          EntityLocation,
                          | 'id'
                          | 'name'
                          | 'parentId'
                          | 'active'
                        >
                      )>>,
                      reconciliations?: Maybe<Array<(
                        { __typename: 'EntityReconciliation' }
                        & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
                        & {
                          startDate: Pick<Date, 'year' | 'month' | 'day'>,
                          endDate: Pick<Date, 'year' | 'month' | 'day'>,
                        }
                      )>>,
                      ledgerTransactions?: Maybe<Array<(
                        Pick<
                          EntityLedgerTransaction,
                          | 'id'
                          | 'timestamp'
                          | 'factIds'
                          | 'name'
                          | 'referenceNumber'
                        >
                        & {
                          totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          parties: Array<Pick<
                              EntityParty,
                              | 'id'
                              | 'name'
                              | 'iconUrl'
                              | 'shortDescription'
                              | 'roles'
                              | 'designation'
                            >>,
                        }
                      )>>,
                      schedules?: Maybe<Array<(
                        { __typename: 'EntitySchedule' }
                        & Pick<
                          EntitySchedule,
                          | 'id'
                          | 'name'
                          | 'scheduleNumber'
                          | 'scheduleType'
                          | 'scheduleTemplateId'
                          | 'categoryId'
                          | 'relatedCategoryId'
                          | 'partyId'
                          | 'startDate'
                          | 'endDate'
                          | 'cutoverDate'
                        >
                        & {
                          amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                          cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                        }
                      )>>,
                    }
                  ),
                }>,
              statement?: Maybe<(
                Pick<StatementConfig, 'kind'>
                & {
                  origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    >,
                  options?: Maybe<(
                    { __typename: 'ReportDocumentOptions' }
                    & Pick<
                      ReportDocumentOptions,
                      | 'sparklineLookbackPeriods'
                      | 'reportLookbackPeriods'
                      | 'deltaMonthOverMonth'
                      | 'deltaMonthOverMonthPeriods'
                      | 'deltaYearOverYear'
                      | 'comparedToTotal'
                      | 'comparedToIncome'
                      | 'amountPrecision'
                      | 'yearToDate'
                      | 'deltaYearToDate'
                      | 'breakdownByClass'
                    >
                    & {
                      collapsedSections?: Maybe<Pick<CollapsedSections, 'sections'>>,
                      categoryByDepartmentOptions?: Maybe<(
                        Pick<CategoryByDepartmentOptions, 'showOther' | 'showUnassigned'>
                        & { departments?: Maybe<Array<Pick<DepartmentOption, 'departmentId' | 'name'>>> }
                      )>,
                      categoryByLocationOptions?: Maybe<(
                        Pick<CategoryByLocationOptions, 'showOther' | 'showUnassigned'>
                        & { locations?: Maybe<Array<Pick<LocationOption, 'locationId' | 'name'>>> }
                      )>,
                    }
                  )>,
                }
              )>,
              metricChart?: Maybe<(
                Pick<MetricChartConfig, 'item'>
                & { origin: Pick<
                    ArchiveIntervalOrigin,
                    | 'interval'
                    | 'year'
                    | 'index'
                    | 'intervalCount'
                    | 'maxTime'
                  > }
              )>,
              runwayChart?: Maybe<{
                  origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    >,
                  netBurnLookback?: Maybe<Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    >>,
                }>,
              cashSummaryChart?: Maybe<{ origin: Pick<
                    ArchiveIntervalOrigin,
                    | 'interval'
                    | 'year'
                    | 'index'
                    | 'intervalCount'
                    | 'maxTime'
                  > }>,
              staticMetric?: Maybe<Pick<StaticMetricConfig, 'name' | 'value' | 'updatedAt'>>,
              documentCollection?: Maybe<Pick<DocumentCollectionConfig, 'collectionId'>>,
              insight?: Maybe<{
                  objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
                  options?: Maybe<Pick<InsightComponentConfigOptions, 'partyRole'>>,
                  origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    >,
                  lookback: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    >,
                }>,
              departmentChart?: Maybe<(
                Pick<DepartmentChartConfig, 'departmentId'>
                & { origin: Pick<
                    ArchiveIntervalOrigin,
                    | 'interval'
                    | 'year'
                    | 'index'
                    | 'intervalCount'
                    | 'maxTime'
                  > }
              )>,
              locationChart?: Maybe<(
                Pick<LocationChartConfig, 'locationId'>
                & { origin: Pick<
                    ArchiveIntervalOrigin,
                    | 'interval'
                    | 'year'
                    | 'index'
                    | 'intervalCount'
                    | 'maxTime'
                  > }
              )>,
              sourceAccountMetric?: Maybe<(
                Pick<SourceAccountMetricConfig, 'key' | 'sourceAccountId' | 'dataSourceId'>
                & { origin: Pick<
                    ArchiveIntervalOrigin,
                    | 'interval'
                    | 'year'
                    | 'index'
                    | 'intervalCount'
                    | 'maxTime'
                  > }
              )>,
              agingSummaryChart?: Maybe<(
                Pick<AgingSummaryChartConfig, 'kind' | 'dimensions' | 'masks'>
                & { origin: Pick<
                    ArchiveIntervalOrigin,
                    | 'interval'
                    | 'year'
                    | 'index'
                    | 'intervalCount'
                    | 'maxTime'
                  > }
              )>,
              categoryByDepartmentChart?: Maybe<(
                Pick<CategoryByDepartmentChartConfig, 'categoryId' | 'departmentIds'>
                & { origin: Pick<
                    ArchiveIntervalOrigin,
                    | 'interval'
                    | 'year'
                    | 'index'
                    | 'intervalCount'
                    | 'maxTime'
                  > }
              )>,
              categoryByLocationChart?: Maybe<(
                Pick<CategoryByLocationChartConfig, 'categoryId' | 'locationIds'>
                & { origin: Pick<
                    ArchiveIntervalOrigin,
                    | 'interval'
                    | 'year'
                    | 'index'
                    | 'intervalCount'
                    | 'maxTime'
                  > }
              )>,
            }
          ) }
        )>> }
      )>> }
    )>>,
  }
);

export type LocationChartConfigFieldsFragment = (
  Pick<LocationChartConfig, 'locationId'>
  & { origin: Pick<
      ArchiveIntervalOrigin,
      | 'interval'
      | 'year'
      | 'index'
      | 'intervalCount'
      | 'maxTime'
    > }
);

export type LocationHistoryFieldsFragment = { location: Array<(
    Pick<LocationDimension, 'locationId'>
    & {
      locationObject: (
        { __typename: 'EntityLocation' }
        & Pick<
          EntityLocation,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      ),
      by: { time: Array<{ summary: (
            Pick<TransactionSummary, 'isPeriodBookClosed'>
            & {
              period: Pick<
                  Period,
                  | 'name'
                  | 'interval'
                  | 'startedAt'
                  | 'endedAt'
                >,
              total: (
                Pick<
                  PeriodMonetaryValue,
                  | 'transactionsCount'
                  | 'deltaPrevious'
                  | 'deltaYearAgo'
                  | 'isFirstOccurrencePeriod'
                >
                & {
                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  moneyFlow?: Maybe<(
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  )>,
                  current?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                  prior?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                }
              ),
            }
          ) }> },
    }
  )> };

export type LocationSummaryFieldsFragment = {
    location: (
      { __typename: 'EntityLocation' }
      & Pick<
        EntityLocation,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    ),
    total: { time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> },
    expensesChange: { time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> },
    otherExpensesChange: { time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> },
    incomeChange: { time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> },
    otherIncomeChange: { time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> },
    cogsChange: { time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> },
  };

export type MetricChartConfigFieldsFragment = (
  Pick<MetricChartConfig, 'item'>
  & { origin: Pick<
      ArchiveIntervalOrigin,
      | 'interval'
      | 'year'
      | 'index'
      | 'intervalCount'
      | 'maxTime'
    > }
);

export type PartyChartConfigFieldsFragment = (
  Pick<PartyChartConfig, 'partyId' | 'partyRole' | 'asPermanent'>
  & { origin: Pick<
      ArchiveIntervalOrigin,
      | 'interval'
      | 'year'
      | 'index'
      | 'intervalCount'
      | 'maxTime'
    > }
);

export type PartyHoverFieldsFragment = (
  { __typename: 'PartyHover' }
  & {
    entity: (
      { __typename: 'EntityParty' }
      & Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >
    ),
    history: (
      Pick<DimensionSummary, 'partialData'>
      & { time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> }
    ),
    context?: Maybe<(
      Pick<DimensionSummary, 'partialData'>
      & { category: Array<{
          categoryObject: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          summary: (
            Pick<TransactionSummary, 'isPeriodBookClosed'>
            & {
              period: Pick<
                  Period,
                  | 'name'
                  | 'interval'
                  | 'startedAt'
                  | 'endedAt'
                >,
              total: (
                Pick<
                  PeriodMonetaryValue,
                  | 'transactionsCount'
                  | 'deltaPrevious'
                  | 'deltaYearAgo'
                  | 'isFirstOccurrencePeriod'
                >
                & {
                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  moneyFlow?: Maybe<(
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  )>,
                  current?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                  prior?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                }
              ),
            }
          ),
        }> }
    )>,
    topTransactions?: Maybe<Array<(
      Pick<
        EntityTransaction,
        | 'viewId'
        | 'factId'
        | 'timestamp'
        | 'description'
        | 'externalId'
        | 'displayEntry'
      >
      & {
        moneyFlow: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        party?: Maybe<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>,
        displayCategory: Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >,
        splitCategory?: Maybe<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>,
      }
    )>>,
  }
);

export type PortalMetricConfigFieldsFragment = (
  Pick<PortalMetricConfig, 'metricType'>
  & { origin: Pick<
      ArchiveIntervalOrigin,
      | 'interval'
      | 'year'
      | 'index'
      | 'intervalCount'
      | 'maxTime'
    > }
);

export type RunwayChartConfigFieldsFragment = {
    origin: Pick<
        ArchiveIntervalOrigin,
        | 'interval'
        | 'year'
        | 'index'
        | 'intervalCount'
        | 'maxTime'
      >,
    netBurnLookback?: Maybe<Pick<
        ArchiveIntervalOrigin,
        | 'interval'
        | 'year'
        | 'index'
        | 'intervalCount'
        | 'maxTime'
      >>,
  };

export type RunwayFieldsFragment = (
  Pick<Runway, 'cashOutDate' | 'previousCashOutDate'>
  & {
    current: (
      Pick<DimensionSummary, 'partialData'>
      & { time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> }
    ),
    future: (
      Pick<DimensionSummary, 'partialData'>
      & { time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> }
    ),
  }
);

export type SourceAccountMetricConfigFieldsFragment = (
  Pick<SourceAccountMetricConfig, 'key' | 'sourceAccountId' | 'dataSourceId'>
  & { origin: Pick<
      ArchiveIntervalOrigin,
      | 'interval'
      | 'year'
      | 'index'
      | 'intervalCount'
      | 'maxTime'
    > }
);

export type SourceAccountMetricFieldsFragment = { metrics: Array<(
    Pick<SourceAccountMetricSeriesData, 'label' | 'iconObjectName'>
    & { series: {
        identifier: Pick<SourceAccountMetricIdentifier, 'dataSourceId' | 'sourceAccountId' | 'key'>,
        points: Array<Pick<SourceAccountMetricPoint, 'time' | 'value'>>,
      } }
  )> };

export type SourceAccountMetricIdentifierFieldsFragment = Pick<SourceAccountMetricIdentifier, 'dataSourceId' | 'sourceAccountId' | 'key'>;

export type SourceAccountMetricPointFieldsFragment = Pick<SourceAccountMetricPoint, 'time' | 'value'>;

export type SourceAccountMetricSeriesDataFieldsFragment = (
  Pick<SourceAccountMetricSeriesData, 'label' | 'iconObjectName'>
  & { series: {
      identifier: Pick<SourceAccountMetricIdentifier, 'dataSourceId' | 'sourceAccountId' | 'key'>,
      points: Array<Pick<SourceAccountMetricPoint, 'time' | 'value'>>,
    } }
);

export type SourceAccountMetricSeriesFieldsFragment = {
    identifier: Pick<SourceAccountMetricIdentifier, 'dataSourceId' | 'sourceAccountId' | 'key'>,
    points: Array<Pick<SourceAccountMetricPoint, 'time' | 'value'>>,
  };

export type StatementCategoryHoverFieldsFragment = (
  { __typename: 'CategoryHover' }
  & Pick<CategoryHover, 'balance'>
  & {
    entity: (
      { __typename: 'EntityCategory' }
      & Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >
    ),
    history: (
      Pick<DimensionSummary, 'partialData'>
      & {
        time: Array<{ summary: (
            Pick<TransactionSummary, 'isPeriodBookClosed'>
            & {
              period: Pick<
                  Period,
                  | 'name'
                  | 'interval'
                  | 'startedAt'
                  | 'endedAt'
                >,
              total: (
                Pick<
                  PeriodMonetaryValue,
                  | 'transactionsCount'
                  | 'deltaPrevious'
                  | 'deltaYearAgo'
                  | 'isFirstOccurrencePeriod'
                >
                & {
                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  moneyFlow?: Maybe<(
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  )>,
                  current?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                  prior?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                }
              ),
            }
          ) }>,
        department: Array<(
          Pick<DepartmentDimension, 'departmentId'>
          & {
            departmentObject: (
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            ),
            by: { time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }> },
          }
        )>,
        location: Array<(
          Pick<LocationDimension, 'locationId'>
          & {
            locationObject: (
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            ),
            by: { time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }> },
          }
        )>,
      }
    ),
    context?: Maybe<(
      Pick<DimensionSummary, 'partialData'>
      & { party: Array<{
          partyObject: Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >,
          summary: (
            Pick<TransactionSummary, 'isPeriodBookClosed'>
            & {
              period: Pick<
                  Period,
                  | 'name'
                  | 'interval'
                  | 'startedAt'
                  | 'endedAt'
                >,
              total: (
                Pick<
                  PeriodMonetaryValue,
                  | 'transactionsCount'
                  | 'deltaPrevious'
                  | 'deltaYearAgo'
                  | 'isFirstOccurrencePeriod'
                >
                & {
                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  moneyFlow?: Maybe<(
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  )>,
                  current?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                  prior?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                }
              ),
            }
          ),
        }> }
    )>,
    topTransactions?: Maybe<Array<(
      Pick<
        EntityTransaction,
        | 'viewId'
        | 'factId'
        | 'timestamp'
        | 'description'
        | 'externalId'
        | 'displayEntry'
      >
      & {
        moneyFlow: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        party?: Maybe<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>,
        displayCategory: Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >,
        splitCategory?: Maybe<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>,
      }
    )>>,
    missingClass?: Maybe<{ time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> }>,
    otherClass?: Maybe<{ time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> }>,
  }
);

export type StatementConfigFieldsFragment = (
  Pick<StatementConfig, 'kind'>
  & {
    origin: Pick<
        ArchiveIntervalOrigin,
        | 'interval'
        | 'year'
        | 'index'
        | 'intervalCount'
        | 'maxTime'
      >,
    options?: Maybe<(
      { __typename: 'ReportDocumentOptions' }
      & Pick<
        ReportDocumentOptions,
        | 'sparklineLookbackPeriods'
        | 'reportLookbackPeriods'
        | 'deltaMonthOverMonth'
        | 'deltaMonthOverMonthPeriods'
        | 'deltaYearOverYear'
        | 'comparedToTotal'
        | 'comparedToIncome'
        | 'amountPrecision'
        | 'yearToDate'
        | 'deltaYearToDate'
        | 'breakdownByClass'
      >
      & {
        collapsedSections?: Maybe<Pick<CollapsedSections, 'sections'>>,
        categoryByDepartmentOptions?: Maybe<(
          Pick<CategoryByDepartmentOptions, 'showOther' | 'showUnassigned'>
          & { departments?: Maybe<Array<Pick<DepartmentOption, 'departmentId' | 'name'>>> }
        )>,
        categoryByLocationOptions?: Maybe<(
          Pick<CategoryByLocationOptions, 'showOther' | 'showUnassigned'>
          & { locations?: Maybe<Array<Pick<LocationOption, 'locationId' | 'name'>>> }
        )>,
      }
    )>,
  }
);

export type StatementSummaryLineItemHoverFieldsFragment = (
  { __typename: 'SummaryLineItemHover' }
  & Pick<SummaryLineItemHover, 'lineType'>
  & {
    history: (
      Pick<DimensionSummary, 'partialData'>
      & {
        time: Array<{ summary: (
            Pick<TransactionSummary, 'isPeriodBookClosed'>
            & {
              period: Pick<
                  Period,
                  | 'name'
                  | 'interval'
                  | 'startedAt'
                  | 'endedAt'
                >,
              total: (
                Pick<
                  PeriodMonetaryValue,
                  | 'transactionsCount'
                  | 'deltaPrevious'
                  | 'deltaYearAgo'
                  | 'isFirstOccurrencePeriod'
                >
                & {
                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  moneyFlow?: Maybe<(
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  )>,
                  current?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                  prior?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                }
              ),
            }
          ) }>,
        department: Array<(
          Pick<DepartmentDimension, 'departmentId'>
          & {
            departmentObject: (
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            ),
            by: { time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }> },
          }
        )>,
        location: Array<(
          Pick<LocationDimension, 'locationId'>
          & {
            locationObject: (
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            ),
            by: { time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }> },
          }
        )>,
      }
    ),
    missingClass?: Maybe<{ time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> }>,
    otherClass?: Maybe<{ time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> }>,
  }
);

export type StaticMetricConfigFieldsFragment = Pick<StaticMetricConfig, 'name' | 'value' | 'updatedAt'>;

export type SummaryLineItemConfigFieldsFragment = (
  Pick<SummaryLineItemConfig, 'item'>
  & { origin: Pick<
      ArchiveIntervalOrigin,
      | 'interval'
      | 'year'
      | 'index'
      | 'intervalCount'
      | 'maxTime'
    > }
);

export type SummaryLineItemHoverFieldsFragment = (
  { __typename: 'SummaryLineItemHover' }
  & Pick<SummaryLineItemHover, 'lineType'>
  & { history: (
    Pick<DimensionSummary, 'partialData'>
    & { time: Array<{ summary: (
        Pick<TransactionSummary, 'isPeriodBookClosed'>
        & {
          period: Pick<
              Period,
              | 'name'
              | 'interval'
              | 'startedAt'
              | 'endedAt'
            >,
          total: (
            Pick<
              PeriodMonetaryValue,
              | 'transactionsCount'
              | 'deltaPrevious'
              | 'deltaYearAgo'
              | 'isFirstOccurrencePeriod'
            >
            & {
              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              moneyFlow?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              current?: Maybe<(
                Pick<SummaryTotal, 'count'>
                & { total: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
              prior?: Maybe<(
                Pick<SummaryTotal, 'count'>
                & { total: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
            }
          ),
        }
      ) }> }
  ) }
);

export type TextComponentConfigFieldsFragment = (
  Pick<TextComponentConfig, 'body'>
  & {
    current?: Maybe<Pick<
        ArchiveIntervalOrigin,
        | 'interval'
        | 'year'
        | 'index'
        | 'intervalCount'
        | 'maxTime'
      >>,
    lookback?: Maybe<Pick<
        ArchiveIntervalOrigin,
        | 'interval'
        | 'year'
        | 'index'
        | 'intervalCount'
        | 'maxTime'
      >>,
    tags?: Maybe<Array<(
      Pick<TextComponentConfigTag, 'displayText'>
      & {
        objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
        options?: Maybe<Pick<TextTagOptions, 'partyRole'>>,
      }
    )>>,
  }
);

export type TextTagOptionsFieldsFragment = Pick<TextTagOptions, 'partyRole'>;

export type TimeHistoryFieldsFragment = { time: Array<{ summary: (
      Pick<TransactionSummary, 'isPeriodBookClosed'>
      & {
        period: Pick<
            Period,
            | 'name'
            | 'interval'
            | 'startedAt'
            | 'endedAt'
          >,
        total: (
          Pick<
            PeriodMonetaryValue,
            | 'transactionsCount'
            | 'deltaPrevious'
            | 'deltaYearAgo'
            | 'isFirstOccurrencePeriod'
          >
          & {
            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            moneyFlow?: Maybe<(
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            )>,
            current?: Maybe<(
              Pick<SummaryTotal, 'count'>
              & { total: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ) }
            )>,
            prior?: Maybe<(
              Pick<SummaryTotal, 'count'>
              & { total: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ) }
            )>,
          }
        ),
      }
    ) }> };

export type TopEntitiesConfigFieldsFragment = (
  Pick<
    TopEntitiesConfig,
    | 'limit'
    | 'kind'
    | 'partyRole'
    | 'categoryType'
    | 'sort'
  >
  & {
    origin: Pick<
        ArchiveIntervalOrigin,
        | 'interval'
        | 'year'
        | 'index'
        | 'intervalCount'
        | 'maxTime'
      >,
    filteredBy?: Maybe<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
  }
);

export type TopTransactionsConfigFieldsFragment = (
  Pick<TopTransactionsConfig, 'limit' | 'partyRole' | 'categoryType'>
  & {
    origin: Pick<
        ArchiveIntervalOrigin,
        | 'interval'
        | 'year'
        | 'index'
        | 'intervalCount'
        | 'maxTime'
      >,
    filteredBy?: Maybe<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
  }
);

export type ArchiveComponentDataMutationVariables = Exact<{
  layoutId: Scalars['String']['input'];
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
}>;


export type ArchiveComponentDataMutation = Pick<Mutation, 'archiveComponentData'>;

export type UpdateLayoutMutationVariables = Exact<{
  viewKey?: InputMaybe<ViewKey>;
  layout: LayoutInput;
}>;


export type UpdateLayoutMutation = { updateLayout: (
    { __typename: 'Layout' }
    & Pick<Layout, 'layoutId' | 'layoutVersionId'>
    & {
      viewKey: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      sections?: Maybe<Array<(
        Pick<LayoutSection, 'sectionId' | 'title'>
        & { rows?: Maybe<Array<(
          Pick<LayoutRow, 'rowId' | 'title'>
          & { components?: Maybe<Array<(
            Pick<LayoutComponent, 'componentId' | 'title' | 'dataId'>
            & { config: (
              Pick<LayoutComponentConfig, 'type'>
              & {
                text?: Maybe<(
                  Pick<TextComponentConfig, 'body'>
                  & {
                    current?: Maybe<Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >>,
                    lookback?: Maybe<Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >>,
                    tags?: Maybe<Array<(
                      Pick<TextComponentConfigTag, 'displayText'>
                      & {
                        objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
                        options?: Maybe<Pick<TextTagOptions, 'partyRole'>>,
                      }
                    )>>,
                  }
                )>,
                categoryChart?: Maybe<(
                  Pick<CategoryChartConfig, 'categoryId' | 'withoutCategoryAncestors' | 'asPermanent'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                partyChart?: Maybe<(
                  Pick<PartyChartConfig, 'partyId' | 'partyRole' | 'asPermanent'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                topEntities?: Maybe<(
                  Pick<
                    TopEntitiesConfig,
                    | 'limit'
                    | 'kind'
                    | 'partyRole'
                    | 'categoryType'
                    | 'sort'
                  >
                  & {
                    origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                    filteredBy?: Maybe<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
                  }
                )>,
                topTransactions?: Maybe<(
                  Pick<TopTransactionsConfig, 'limit' | 'partyRole' | 'categoryType'>
                  & {
                    origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                    filteredBy?: Maybe<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
                  }
                )>,
                summaryLineItem?: Maybe<(
                  Pick<SummaryLineItemConfig, 'item'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                portalMetric?: Maybe<(
                  Pick<PortalMetricConfig, 'metricType'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                entitiesList?: Maybe<{
                    origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                    entities: (
                      { __typename: 'ObjectEntities' }
                      & {
                        users?: Maybe<Array<Pick<
                            EntityUser,
                            | 'id'
                            | 'givenName'
                            | 'familyName'
                            | 'emailAddress'
                            | 'avatarUrl'
                          >>>,
                        transactions?: Maybe<Array<(
                          Pick<
                            EntityTransaction,
                            | 'viewId'
                            | 'factId'
                            | 'timestamp'
                            | 'description'
                            | 'externalId'
                            | 'displayEntry'
                          >
                          & {
                            moneyFlow: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ),
                            party?: Maybe<Pick<
                                EntityParty,
                                | 'id'
                                | 'name'
                                | 'iconUrl'
                                | 'shortDescription'
                                | 'roles'
                                | 'designation'
                              >>,
                            displayCategory: Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >,
                            splitCategory?: Maybe<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>,
                          }
                        )>>,
                        comments?: Maybe<Array<Pick<
                            EntityComment,
                            | 'id'
                            | 'authorId'
                            | 'text'
                            | 'timestamp'
                          >>>,
                        reports?: Maybe<Array<(
                          Pick<
                            EntityReport,
                            | 'id'
                            | 'title'
                            | 'authorId'
                            | 'mimeType'
                            | 'createdAt'
                          >
                          & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
                        )>>,
                        reportPackages?: Maybe<Array<(
                          Pick<
                            EntityReportPackage,
                            | 'id'
                            | 'title'
                            | 'authorId'
                            | 'interval'
                            | 'periodStartedAt'
                            | 'periodEndedAt'
                            | 'createdAt'
                            | 'updatedAt'
                            | 'coverUrl'
                          >
                          & { documents: Array<Pick<
                              SharedReportDocumentMetadata,
                              | 'id'
                              | 'documentObjectId'
                              | 'documentObjectVersionId'
                              | 'title'
                              | 'mimeType'
                            >> }
                        )>>,
                        parties?: Maybe<Array<Pick<
                            EntityParty,
                            | 'id'
                            | 'name'
                            | 'iconUrl'
                            | 'shortDescription'
                            | 'roles'
                            | 'designation'
                          >>>,
                        datasources?: Maybe<Array<Pick<
                            EntityDataSource,
                            | 'id'
                            | 'name'
                            | 'url'
                            | 'iconUrl'
                          >>>,
                        categories?: Maybe<Array<Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >>>,
                        threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
                        legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
                        workItems?: Maybe<Array<(
                          Pick<
                            EntityWorkItem,
                            | 'id'
                            | 'time'
                            | 'workItemState'
                            | 'workItemType'
                            | 'reviewCreatedById'
                            | 'reviewState'
                            | 'ledgerType'
                          >
                          & { objectTransaction: (
                            Pick<
                              EntityTransaction,
                              | 'viewId'
                              | 'factId'
                              | 'timestamp'
                              | 'description'
                              | 'externalId'
                              | 'displayEntry'
                            >
                            & {
                              moneyFlow: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ),
                              party?: Maybe<Pick<
                                  EntityParty,
                                  | 'id'
                                  | 'name'
                                  | 'iconUrl'
                                  | 'shortDescription'
                                  | 'roles'
                                  | 'designation'
                                >>,
                              displayCategory: Pick<
                                  EntityCategory,
                                  | 'id'
                                  | 'name'
                                  | 'displayKey'
                                  | 'chartOfAccountsDisplayNumber'
                                  | 'type'
                                  | 'subtype'
                                  | 'parentCategoryId'
                                  | 'productArea'
                                  | 'active'
                                >,
                              splitCategory?: Maybe<Pick<
                                  EntityCategory,
                                  | 'id'
                                  | 'name'
                                  | 'displayKey'
                                  | 'chartOfAccountsDisplayNumber'
                                  | 'type'
                                  | 'subtype'
                                  | 'parentCategoryId'
                                  | 'productArea'
                                  | 'active'
                                >>,
                            }
                          ) }
                        )>>,
                        invoices?: Maybe<Array<(
                          Pick<
                            EntityInvoice,
                            | 'id'
                            | 'externalDisplayId'
                            | 'createdAt'
                            | 'dueAt'
                          >
                          & {
                            amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            customer: (
                              Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                              & { party: Pick<
                                  EntityParty,
                                  | 'id'
                                  | 'name'
                                  | 'iconUrl'
                                  | 'shortDescription'
                                  | 'roles'
                                  | 'designation'
                                > }
                            ),
                          }
                        )>>,
                        bills?: Maybe<Array<(
                          Pick<
                            EntityBill,
                            | 'id'
                            | 'billStatus'
                            | 'vendorName'
                            | 'billDescription'
                          >
                          & {
                            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
                            format: (
                              Pick<Format, 'id' | 'formatClass'>
                              & { segments: Array<Pick<
                                  Segment,
                                  | 'collectionId'
                                  | 'fileId'
                                  | 'sequence'
                                  | 'token'
                                >> }
                            ),
                            approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
                          }
                        )>>,
                        identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
                        departments?: Maybe<Array<(
                          { __typename: 'EntityDepartment' }
                          & Pick<
                            EntityDepartment,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        )>>,
                        locations?: Maybe<Array<(
                          { __typename: 'EntityLocation' }
                          & Pick<
                            EntityLocation,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        )>>,
                        reconciliations?: Maybe<Array<(
                          { __typename: 'EntityReconciliation' }
                          & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
                          & {
                            startDate: Pick<Date, 'year' | 'month' | 'day'>,
                            endDate: Pick<Date, 'year' | 'month' | 'day'>,
                          }
                        )>>,
                        ledgerTransactions?: Maybe<Array<(
                          Pick<
                            EntityLedgerTransaction,
                            | 'id'
                            | 'timestamp'
                            | 'factIds'
                            | 'name'
                            | 'referenceNumber'
                          >
                          & {
                            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            parties: Array<Pick<
                                EntityParty,
                                | 'id'
                                | 'name'
                                | 'iconUrl'
                                | 'shortDescription'
                                | 'roles'
                                | 'designation'
                              >>,
                          }
                        )>>,
                        schedules?: Maybe<Array<(
                          { __typename: 'EntitySchedule' }
                          & Pick<
                            EntitySchedule,
                            | 'id'
                            | 'name'
                            | 'scheduleNumber'
                            | 'scheduleType'
                            | 'scheduleTemplateId'
                            | 'categoryId'
                            | 'relatedCategoryId'
                            | 'partyId'
                            | 'startDate'
                            | 'endDate'
                            | 'cutoverDate'
                          >
                          & {
                            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                          }
                        )>>,
                      }
                    ),
                  }>,
                statement?: Maybe<(
                  Pick<StatementConfig, 'kind'>
                  & {
                    origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                    options?: Maybe<(
                      { __typename: 'ReportDocumentOptions' }
                      & Pick<
                        ReportDocumentOptions,
                        | 'sparklineLookbackPeriods'
                        | 'reportLookbackPeriods'
                        | 'deltaMonthOverMonth'
                        | 'deltaMonthOverMonthPeriods'
                        | 'deltaYearOverYear'
                        | 'comparedToTotal'
                        | 'comparedToIncome'
                        | 'amountPrecision'
                        | 'yearToDate'
                        | 'deltaYearToDate'
                        | 'breakdownByClass'
                      >
                      & {
                        collapsedSections?: Maybe<Pick<CollapsedSections, 'sections'>>,
                        categoryByDepartmentOptions?: Maybe<(
                          Pick<CategoryByDepartmentOptions, 'showOther' | 'showUnassigned'>
                          & { departments?: Maybe<Array<Pick<DepartmentOption, 'departmentId' | 'name'>>> }
                        )>,
                        categoryByLocationOptions?: Maybe<(
                          Pick<CategoryByLocationOptions, 'showOther' | 'showUnassigned'>
                          & { locations?: Maybe<Array<Pick<LocationOption, 'locationId' | 'name'>>> }
                        )>,
                      }
                    )>,
                  }
                )>,
                metricChart?: Maybe<(
                  Pick<MetricChartConfig, 'item'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                runwayChart?: Maybe<{
                    origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                    netBurnLookback?: Maybe<Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >>,
                  }>,
                cashSummaryChart?: Maybe<{ origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }>,
                staticMetric?: Maybe<Pick<StaticMetricConfig, 'name' | 'value' | 'updatedAt'>>,
                documentCollection?: Maybe<Pick<DocumentCollectionConfig, 'collectionId'>>,
                insight?: Maybe<{
                    objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
                    options?: Maybe<Pick<InsightComponentConfigOptions, 'partyRole'>>,
                    origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                    lookback: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                  }>,
                departmentChart?: Maybe<(
                  Pick<DepartmentChartConfig, 'departmentId'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                locationChart?: Maybe<(
                  Pick<LocationChartConfig, 'locationId'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                sourceAccountMetric?: Maybe<(
                  Pick<SourceAccountMetricConfig, 'key' | 'sourceAccountId' | 'dataSourceId'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                agingSummaryChart?: Maybe<(
                  Pick<AgingSummaryChartConfig, 'kind' | 'dimensions' | 'masks'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                categoryByDepartmentChart?: Maybe<(
                  Pick<CategoryByDepartmentChartConfig, 'categoryId' | 'departmentIds'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                categoryByLocationChart?: Maybe<(
                  Pick<CategoryByLocationChartConfig, 'categoryId' | 'locationIds'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
              }
            ) }
          )>> }
        )>> }
      )>>,
    }
  ) };

export type UpdateReportLayoutMutationVariables = Exact<{
  viewKey: ViewKey;
  packageId: Scalars['String']['input'];
  packageVersionId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  layout: LayoutInput;
}>;


export type UpdateReportLayoutMutation = { updateReportLayout: (
    { __typename: 'Layout' }
    & Pick<Layout, 'layoutId' | 'layoutVersionId'>
    & {
      viewKey: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      sections?: Maybe<Array<(
        Pick<LayoutSection, 'sectionId' | 'title'>
        & { rows?: Maybe<Array<(
          Pick<LayoutRow, 'rowId' | 'title'>
          & { components?: Maybe<Array<(
            Pick<LayoutComponent, 'componentId' | 'title' | 'dataId'>
            & { config: (
              Pick<LayoutComponentConfig, 'type'>
              & {
                text?: Maybe<(
                  Pick<TextComponentConfig, 'body'>
                  & {
                    current?: Maybe<Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >>,
                    lookback?: Maybe<Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >>,
                    tags?: Maybe<Array<(
                      Pick<TextComponentConfigTag, 'displayText'>
                      & {
                        objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
                        options?: Maybe<Pick<TextTagOptions, 'partyRole'>>,
                      }
                    )>>,
                  }
                )>,
                categoryChart?: Maybe<(
                  Pick<CategoryChartConfig, 'categoryId' | 'withoutCategoryAncestors' | 'asPermanent'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                partyChart?: Maybe<(
                  Pick<PartyChartConfig, 'partyId' | 'partyRole' | 'asPermanent'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                topEntities?: Maybe<(
                  Pick<
                    TopEntitiesConfig,
                    | 'limit'
                    | 'kind'
                    | 'partyRole'
                    | 'categoryType'
                    | 'sort'
                  >
                  & {
                    origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                    filteredBy?: Maybe<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
                  }
                )>,
                topTransactions?: Maybe<(
                  Pick<TopTransactionsConfig, 'limit' | 'partyRole' | 'categoryType'>
                  & {
                    origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                    filteredBy?: Maybe<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
                  }
                )>,
                summaryLineItem?: Maybe<(
                  Pick<SummaryLineItemConfig, 'item'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                portalMetric?: Maybe<(
                  Pick<PortalMetricConfig, 'metricType'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                entitiesList?: Maybe<{
                    origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                    entities: (
                      { __typename: 'ObjectEntities' }
                      & {
                        users?: Maybe<Array<Pick<
                            EntityUser,
                            | 'id'
                            | 'givenName'
                            | 'familyName'
                            | 'emailAddress'
                            | 'avatarUrl'
                          >>>,
                        transactions?: Maybe<Array<(
                          Pick<
                            EntityTransaction,
                            | 'viewId'
                            | 'factId'
                            | 'timestamp'
                            | 'description'
                            | 'externalId'
                            | 'displayEntry'
                          >
                          & {
                            moneyFlow: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ),
                            party?: Maybe<Pick<
                                EntityParty,
                                | 'id'
                                | 'name'
                                | 'iconUrl'
                                | 'shortDescription'
                                | 'roles'
                                | 'designation'
                              >>,
                            displayCategory: Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >,
                            splitCategory?: Maybe<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>,
                          }
                        )>>,
                        comments?: Maybe<Array<Pick<
                            EntityComment,
                            | 'id'
                            | 'authorId'
                            | 'text'
                            | 'timestamp'
                          >>>,
                        reports?: Maybe<Array<(
                          Pick<
                            EntityReport,
                            | 'id'
                            | 'title'
                            | 'authorId'
                            | 'mimeType'
                            | 'createdAt'
                          >
                          & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
                        )>>,
                        reportPackages?: Maybe<Array<(
                          Pick<
                            EntityReportPackage,
                            | 'id'
                            | 'title'
                            | 'authorId'
                            | 'interval'
                            | 'periodStartedAt'
                            | 'periodEndedAt'
                            | 'createdAt'
                            | 'updatedAt'
                            | 'coverUrl'
                          >
                          & { documents: Array<Pick<
                              SharedReportDocumentMetadata,
                              | 'id'
                              | 'documentObjectId'
                              | 'documentObjectVersionId'
                              | 'title'
                              | 'mimeType'
                            >> }
                        )>>,
                        parties?: Maybe<Array<Pick<
                            EntityParty,
                            | 'id'
                            | 'name'
                            | 'iconUrl'
                            | 'shortDescription'
                            | 'roles'
                            | 'designation'
                          >>>,
                        datasources?: Maybe<Array<Pick<
                            EntityDataSource,
                            | 'id'
                            | 'name'
                            | 'url'
                            | 'iconUrl'
                          >>>,
                        categories?: Maybe<Array<Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >>>,
                        threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
                        legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
                        workItems?: Maybe<Array<(
                          Pick<
                            EntityWorkItem,
                            | 'id'
                            | 'time'
                            | 'workItemState'
                            | 'workItemType'
                            | 'reviewCreatedById'
                            | 'reviewState'
                            | 'ledgerType'
                          >
                          & { objectTransaction: (
                            Pick<
                              EntityTransaction,
                              | 'viewId'
                              | 'factId'
                              | 'timestamp'
                              | 'description'
                              | 'externalId'
                              | 'displayEntry'
                            >
                            & {
                              moneyFlow: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ),
                              party?: Maybe<Pick<
                                  EntityParty,
                                  | 'id'
                                  | 'name'
                                  | 'iconUrl'
                                  | 'shortDescription'
                                  | 'roles'
                                  | 'designation'
                                >>,
                              displayCategory: Pick<
                                  EntityCategory,
                                  | 'id'
                                  | 'name'
                                  | 'displayKey'
                                  | 'chartOfAccountsDisplayNumber'
                                  | 'type'
                                  | 'subtype'
                                  | 'parentCategoryId'
                                  | 'productArea'
                                  | 'active'
                                >,
                              splitCategory?: Maybe<Pick<
                                  EntityCategory,
                                  | 'id'
                                  | 'name'
                                  | 'displayKey'
                                  | 'chartOfAccountsDisplayNumber'
                                  | 'type'
                                  | 'subtype'
                                  | 'parentCategoryId'
                                  | 'productArea'
                                  | 'active'
                                >>,
                            }
                          ) }
                        )>>,
                        invoices?: Maybe<Array<(
                          Pick<
                            EntityInvoice,
                            | 'id'
                            | 'externalDisplayId'
                            | 'createdAt'
                            | 'dueAt'
                          >
                          & {
                            amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            customer: (
                              Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                              & { party: Pick<
                                  EntityParty,
                                  | 'id'
                                  | 'name'
                                  | 'iconUrl'
                                  | 'shortDescription'
                                  | 'roles'
                                  | 'designation'
                                > }
                            ),
                          }
                        )>>,
                        bills?: Maybe<Array<(
                          Pick<
                            EntityBill,
                            | 'id'
                            | 'billStatus'
                            | 'vendorName'
                            | 'billDescription'
                          >
                          & {
                            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
                            format: (
                              Pick<Format, 'id' | 'formatClass'>
                              & { segments: Array<Pick<
                                  Segment,
                                  | 'collectionId'
                                  | 'fileId'
                                  | 'sequence'
                                  | 'token'
                                >> }
                            ),
                            approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
                          }
                        )>>,
                        identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
                        departments?: Maybe<Array<(
                          { __typename: 'EntityDepartment' }
                          & Pick<
                            EntityDepartment,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        )>>,
                        locations?: Maybe<Array<(
                          { __typename: 'EntityLocation' }
                          & Pick<
                            EntityLocation,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        )>>,
                        reconciliations?: Maybe<Array<(
                          { __typename: 'EntityReconciliation' }
                          & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
                          & {
                            startDate: Pick<Date, 'year' | 'month' | 'day'>,
                            endDate: Pick<Date, 'year' | 'month' | 'day'>,
                          }
                        )>>,
                        ledgerTransactions?: Maybe<Array<(
                          Pick<
                            EntityLedgerTransaction,
                            | 'id'
                            | 'timestamp'
                            | 'factIds'
                            | 'name'
                            | 'referenceNumber'
                          >
                          & {
                            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            parties: Array<Pick<
                                EntityParty,
                                | 'id'
                                | 'name'
                                | 'iconUrl'
                                | 'shortDescription'
                                | 'roles'
                                | 'designation'
                              >>,
                          }
                        )>>,
                        schedules?: Maybe<Array<(
                          { __typename: 'EntitySchedule' }
                          & Pick<
                            EntitySchedule,
                            | 'id'
                            | 'name'
                            | 'scheduleNumber'
                            | 'scheduleType'
                            | 'scheduleTemplateId'
                            | 'categoryId'
                            | 'relatedCategoryId'
                            | 'partyId'
                            | 'startDate'
                            | 'endDate'
                            | 'cutoverDate'
                          >
                          & {
                            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                          }
                        )>>,
                      }
                    ),
                  }>,
                statement?: Maybe<(
                  Pick<StatementConfig, 'kind'>
                  & {
                    origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                    options?: Maybe<(
                      { __typename: 'ReportDocumentOptions' }
                      & Pick<
                        ReportDocumentOptions,
                        | 'sparklineLookbackPeriods'
                        | 'reportLookbackPeriods'
                        | 'deltaMonthOverMonth'
                        | 'deltaMonthOverMonthPeriods'
                        | 'deltaYearOverYear'
                        | 'comparedToTotal'
                        | 'comparedToIncome'
                        | 'amountPrecision'
                        | 'yearToDate'
                        | 'deltaYearToDate'
                        | 'breakdownByClass'
                      >
                      & {
                        collapsedSections?: Maybe<Pick<CollapsedSections, 'sections'>>,
                        categoryByDepartmentOptions?: Maybe<(
                          Pick<CategoryByDepartmentOptions, 'showOther' | 'showUnassigned'>
                          & { departments?: Maybe<Array<Pick<DepartmentOption, 'departmentId' | 'name'>>> }
                        )>,
                        categoryByLocationOptions?: Maybe<(
                          Pick<CategoryByLocationOptions, 'showOther' | 'showUnassigned'>
                          & { locations?: Maybe<Array<Pick<LocationOption, 'locationId' | 'name'>>> }
                        )>,
                      }
                    )>,
                  }
                )>,
                metricChart?: Maybe<(
                  Pick<MetricChartConfig, 'item'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                runwayChart?: Maybe<{
                    origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                    netBurnLookback?: Maybe<Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >>,
                  }>,
                cashSummaryChart?: Maybe<{ origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }>,
                staticMetric?: Maybe<Pick<StaticMetricConfig, 'name' | 'value' | 'updatedAt'>>,
                documentCollection?: Maybe<Pick<DocumentCollectionConfig, 'collectionId'>>,
                insight?: Maybe<{
                    objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
                    options?: Maybe<Pick<InsightComponentConfigOptions, 'partyRole'>>,
                    origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                    lookback: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                  }>,
                departmentChart?: Maybe<(
                  Pick<DepartmentChartConfig, 'departmentId'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                locationChart?: Maybe<(
                  Pick<LocationChartConfig, 'locationId'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                sourceAccountMetric?: Maybe<(
                  Pick<SourceAccountMetricConfig, 'key' | 'sourceAccountId' | 'dataSourceId'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                agingSummaryChart?: Maybe<(
                  Pick<AgingSummaryChartConfig, 'kind' | 'dimensions' | 'masks'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                categoryByDepartmentChart?: Maybe<(
                  Pick<CategoryByDepartmentChartConfig, 'categoryId' | 'departmentIds'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                categoryByLocationChart?: Maybe<(
                  Pick<CategoryByLocationChartConfig, 'categoryId' | 'locationIds'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
              }
            ) }
          )>> }
        )>> }
      )>>,
    }
  ) };

export type ReadAgingSummaryChartComponentDataQueryVariables = Exact<{
  layoutId: Scalars['String']['input'];
  dataId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadAgingSummaryChartComponentDataQuery = { readComponentData: {
      viewId: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      data:
        | { __typename: 'CashSummary' }
        | (
          { __typename: 'Chart' }
          & { summary: {
              aging: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }>,
              summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ),
            } }
        )
        | { __typename: 'DimensionSummary' }
        | { __typename: 'EntitiesList' }
        | { __typename: 'EntityHovers' }
        | { __typename: 'InsightComponent' }
        | { __typename: 'LocationSummary' }
        | { __typename: 'Runway' }
        | { __typename: 'SourceAccountMetric' }
        | { __typename: 'Statement' }
        | { __typename: 'TopEntities' }
        | { __typename: 'TopTransactions' }
      ,
    } };

export type ReadAgingSummaryChartLiveDataQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
}>;


export type ReadAgingSummaryChartLiveDataQuery = { liveComponentData:
    | { __typename: 'CashSummary' }
    | (
      { __typename: 'Chart' }
      & { summary: {
          aging: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }>,
          summary: (
            Pick<TransactionSummary, 'isPeriodBookClosed'>
            & {
              period: Pick<
                  Period,
                  | 'name'
                  | 'interval'
                  | 'startedAt'
                  | 'endedAt'
                >,
              total: (
                Pick<
                  PeriodMonetaryValue,
                  | 'transactionsCount'
                  | 'deltaPrevious'
                  | 'deltaYearAgo'
                  | 'isFirstOccurrencePeriod'
                >
                & {
                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  moneyFlow?: Maybe<(
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  )>,
                  current?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                  prior?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                }
              ),
            }
          ),
        } }
    )
    | { __typename: 'DimensionSummary' }
    | { __typename: 'EntitiesList' }
    | { __typename: 'EntityHovers' }
    | { __typename: 'InsightComponent' }
    | { __typename: 'LocationSummary' }
    | { __typename: 'Runway' }
    | { __typename: 'SourceAccountMetric' }
    | { __typename: 'Statement' }
    | { __typename: 'TopEntities' }
    | { __typename: 'TopTransactions' }
   };

export type ReadCashSummaryChartComponentDataQueryVariables = Exact<{
  layoutId: Scalars['String']['input'];
  dataId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadCashSummaryChartComponentDataQuery = { readComponentData: {
      viewId: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      data:
        | (
          { __typename: 'CashSummary' }
          & {
            cashTotal: (
              Pick<DimensionSummary, 'partialData'>
              & { time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }> }
            ),
            cashChange: (
              Pick<DimensionSummary, 'partialData'>
              & { category: Array<{
                  categoryObject: Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >,
                  by: { time: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }> },
                }> }
            ),
          }
        )
        | { __typename: 'Chart' }
        | { __typename: 'DimensionSummary' }
        | { __typename: 'EntitiesList' }
        | { __typename: 'EntityHovers' }
        | { __typename: 'InsightComponent' }
        | { __typename: 'LocationSummary' }
        | { __typename: 'Runway' }
        | { __typename: 'SourceAccountMetric' }
        | { __typename: 'Statement' }
        | { __typename: 'TopEntities' }
        | { __typename: 'TopTransactions' }
      ,
    } };

export type ReadCashSummaryChartLiveDataQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
}>;


export type ReadCashSummaryChartLiveDataQuery = { liveComponentData:
    | (
      { __typename: 'CashSummary' }
      & {
        cashTotal: (
          Pick<DimensionSummary, 'partialData'>
          & { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> }
        ),
        cashChange: (
          Pick<DimensionSummary, 'partialData'>
          & { category: Array<{
              categoryObject: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              by: { time: Array<{ summary: (
                    Pick<TransactionSummary, 'isPeriodBookClosed'>
                    & {
                      period: Pick<
                          Period,
                          | 'name'
                          | 'interval'
                          | 'startedAt'
                          | 'endedAt'
                        >,
                      total: (
                        Pick<
                          PeriodMonetaryValue,
                          | 'transactionsCount'
                          | 'deltaPrevious'
                          | 'deltaYearAgo'
                          | 'isFirstOccurrencePeriod'
                        >
                        & {
                          value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          moneyFlow?: Maybe<(
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          )>,
                          current?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                          prior?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                        }
                      ),
                    }
                  ) }> },
            }> }
        ),
      }
    )
    | { __typename: 'Chart' }
    | { __typename: 'DimensionSummary' }
    | { __typename: 'EntitiesList' }
    | { __typename: 'EntityHovers' }
    | { __typename: 'InsightComponent' }
    | { __typename: 'LocationSummary' }
    | { __typename: 'Runway' }
    | { __typename: 'SourceAccountMetric' }
    | { __typename: 'Statement' }
    | { __typename: 'TopEntities' }
    | { __typename: 'TopTransactions' }
   };

export type ReadCategoryByDepartmentComponentDataQueryVariables = Exact<{
  layoutId: Scalars['String']['input'];
  dataId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadCategoryByDepartmentComponentDataQuery = { readComponentData: {
      viewId: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      data:
        | { __typename: 'CashSummary' }
        | (
          { __typename: 'Chart' }
          & {
            entity:
              | { __typename: 'EntityBill' }
              | (
                { __typename: 'EntityCategory' }
                & Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >
              )
              | { __typename: 'EntityComment' }
              | { __typename: 'EntityDataSource' }
              | { __typename: 'EntityDepartment' }
              | { __typename: 'EntityIdentityVerification' }
              | { __typename: 'EntityInvoice' }
              | { __typename: 'EntityLedgerTransaction' }
              | { __typename: 'EntityLegalEntity' }
              | { __typename: 'EntityLocation' }
              | { __typename: 'EntityParty' }
              | { __typename: 'EntityProduct' }
              | { __typename: 'EntityReconciliation' }
              | { __typename: 'EntityReport' }
              | { __typename: 'EntityReportPackage' }
              | { __typename: 'EntitySchedule' }
              | { __typename: 'EntityThread' }
              | { __typename: 'EntityTransaction' }
              | { __typename: 'EntityUser' }
              | { __typename: 'EntityWorkItem' }
            ,
            summary: (
              Pick<DimensionSummary, 'partialData'>
              & { department: Array<(
                Pick<DepartmentDimension, 'departmentId'>
                & {
                  departmentObject: (
                    { __typename: 'EntityDepartment' }
                    & Pick<
                      EntityDepartment,
                      | 'id'
                      | 'name'
                      | 'parentId'
                      | 'active'
                    >
                  ),
                  by: { time: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }> },
                }
              )> }
            ),
          }
        )
        | { __typename: 'DimensionSummary' }
        | { __typename: 'EntitiesList' }
        | { __typename: 'EntityHovers' }
        | { __typename: 'InsightComponent' }
        | { __typename: 'LocationSummary' }
        | { __typename: 'Runway' }
        | { __typename: 'SourceAccountMetric' }
        | { __typename: 'Statement' }
        | { __typename: 'TopEntities' }
        | { __typename: 'TopTransactions' }
      ,
    } };

export type ReadCategoryByDepartmentChartLiveDataQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
}>;


export type ReadCategoryByDepartmentChartLiveDataQuery = { liveComponentData:
    | { __typename: 'CashSummary' }
    | (
      { __typename: 'Chart' }
      & {
        entity:
          | { __typename: 'EntityBill' }
          | (
            { __typename: 'EntityCategory' }
            & Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >
          )
          | { __typename: 'EntityComment' }
          | { __typename: 'EntityDataSource' }
          | { __typename: 'EntityDepartment' }
          | { __typename: 'EntityIdentityVerification' }
          | { __typename: 'EntityInvoice' }
          | { __typename: 'EntityLedgerTransaction' }
          | { __typename: 'EntityLegalEntity' }
          | { __typename: 'EntityLocation' }
          | { __typename: 'EntityParty' }
          | { __typename: 'EntityProduct' }
          | { __typename: 'EntityReconciliation' }
          | { __typename: 'EntityReport' }
          | { __typename: 'EntityReportPackage' }
          | { __typename: 'EntitySchedule' }
          | { __typename: 'EntityThread' }
          | { __typename: 'EntityTransaction' }
          | { __typename: 'EntityUser' }
          | { __typename: 'EntityWorkItem' }
        ,
        summary: (
          Pick<DimensionSummary, 'partialData'>
          & { department: Array<(
            Pick<DepartmentDimension, 'departmentId'>
            & {
              departmentObject: (
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              ),
              by: { time: Array<{ summary: (
                    Pick<TransactionSummary, 'isPeriodBookClosed'>
                    & {
                      period: Pick<
                          Period,
                          | 'name'
                          | 'interval'
                          | 'startedAt'
                          | 'endedAt'
                        >,
                      total: (
                        Pick<
                          PeriodMonetaryValue,
                          | 'transactionsCount'
                          | 'deltaPrevious'
                          | 'deltaYearAgo'
                          | 'isFirstOccurrencePeriod'
                        >
                        & {
                          value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          moneyFlow?: Maybe<(
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          )>,
                          current?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                          prior?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                        }
                      ),
                    }
                  ) }> },
            }
          )> }
        ),
      }
    )
    | { __typename: 'DimensionSummary' }
    | { __typename: 'EntitiesList' }
    | { __typename: 'EntityHovers' }
    | { __typename: 'InsightComponent' }
    | { __typename: 'LocationSummary' }
    | { __typename: 'Runway' }
    | { __typename: 'SourceAccountMetric' }
    | { __typename: 'Statement' }
    | { __typename: 'TopEntities' }
    | { __typename: 'TopTransactions' }
   };

export type ReadCategoryByLocationComponentDataQueryVariables = Exact<{
  layoutId: Scalars['String']['input'];
  dataId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadCategoryByLocationComponentDataQuery = { readComponentData: {
      viewId: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      data:
        | { __typename: 'CashSummary' }
        | (
          { __typename: 'Chart' }
          & {
            entity:
              | { __typename: 'EntityBill' }
              | (
                { __typename: 'EntityCategory' }
                & Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >
              )
              | { __typename: 'EntityComment' }
              | { __typename: 'EntityDataSource' }
              | { __typename: 'EntityDepartment' }
              | { __typename: 'EntityIdentityVerification' }
              | { __typename: 'EntityInvoice' }
              | { __typename: 'EntityLedgerTransaction' }
              | { __typename: 'EntityLegalEntity' }
              | { __typename: 'EntityLocation' }
              | { __typename: 'EntityParty' }
              | { __typename: 'EntityProduct' }
              | { __typename: 'EntityReconciliation' }
              | { __typename: 'EntityReport' }
              | { __typename: 'EntityReportPackage' }
              | { __typename: 'EntitySchedule' }
              | { __typename: 'EntityThread' }
              | { __typename: 'EntityTransaction' }
              | { __typename: 'EntityUser' }
              | { __typename: 'EntityWorkItem' }
            ,
            summary: (
              Pick<DimensionSummary, 'partialData'>
              & { location: Array<(
                Pick<LocationDimension, 'locationId'>
                & {
                  locationObject: (
                    { __typename: 'EntityLocation' }
                    & Pick<
                      EntityLocation,
                      | 'id'
                      | 'name'
                      | 'parentId'
                      | 'active'
                    >
                  ),
                  by: { time: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }> },
                }
              )> }
            ),
          }
        )
        | { __typename: 'DimensionSummary' }
        | { __typename: 'EntitiesList' }
        | { __typename: 'EntityHovers' }
        | { __typename: 'InsightComponent' }
        | { __typename: 'LocationSummary' }
        | { __typename: 'Runway' }
        | { __typename: 'SourceAccountMetric' }
        | { __typename: 'Statement' }
        | { __typename: 'TopEntities' }
        | { __typename: 'TopTransactions' }
      ,
    } };

export type ReadCategoryByLocationChartLiveDataQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
}>;


export type ReadCategoryByLocationChartLiveDataQuery = { liveComponentData:
    | { __typename: 'CashSummary' }
    | (
      { __typename: 'Chart' }
      & {
        entity:
          | { __typename: 'EntityBill' }
          | (
            { __typename: 'EntityCategory' }
            & Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >
          )
          | { __typename: 'EntityComment' }
          | { __typename: 'EntityDataSource' }
          | { __typename: 'EntityDepartment' }
          | { __typename: 'EntityIdentityVerification' }
          | { __typename: 'EntityInvoice' }
          | { __typename: 'EntityLedgerTransaction' }
          | { __typename: 'EntityLegalEntity' }
          | { __typename: 'EntityLocation' }
          | { __typename: 'EntityParty' }
          | { __typename: 'EntityProduct' }
          | { __typename: 'EntityReconciliation' }
          | { __typename: 'EntityReport' }
          | { __typename: 'EntityReportPackage' }
          | { __typename: 'EntitySchedule' }
          | { __typename: 'EntityThread' }
          | { __typename: 'EntityTransaction' }
          | { __typename: 'EntityUser' }
          | { __typename: 'EntityWorkItem' }
        ,
        summary: (
          Pick<DimensionSummary, 'partialData'>
          & { location: Array<(
            Pick<LocationDimension, 'locationId'>
            & {
              locationObject: (
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              ),
              by: { time: Array<{ summary: (
                    Pick<TransactionSummary, 'isPeriodBookClosed'>
                    & {
                      period: Pick<
                          Period,
                          | 'name'
                          | 'interval'
                          | 'startedAt'
                          | 'endedAt'
                        >,
                      total: (
                        Pick<
                          PeriodMonetaryValue,
                          | 'transactionsCount'
                          | 'deltaPrevious'
                          | 'deltaYearAgo'
                          | 'isFirstOccurrencePeriod'
                        >
                        & {
                          value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          moneyFlow?: Maybe<(
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          )>,
                          current?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                          prior?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                        }
                      ),
                    }
                  ) }> },
            }
          )> }
        ),
      }
    )
    | { __typename: 'DimensionSummary' }
    | { __typename: 'EntitiesList' }
    | { __typename: 'EntityHovers' }
    | { __typename: 'InsightComponent' }
    | { __typename: 'LocationSummary' }
    | { __typename: 'Runway' }
    | { __typename: 'SourceAccountMetric' }
    | { __typename: 'Statement' }
    | { __typename: 'TopEntities' }
    | { __typename: 'TopTransactions' }
   };

export type ReadCategorySummaryByTimeComponentDataQueryVariables = Exact<{
  layoutId: Scalars['String']['input'];
  dataId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadCategorySummaryByTimeComponentDataQuery = { readComponentData: {
      viewId: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      data:
        | { __typename: 'CashSummary' }
        | (
          { __typename: 'Chart' }
          & {
            entity:
              | { __typename: 'EntityBill' }
              | (
                { __typename: 'EntityCategory' }
                & Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >
              )
              | { __typename: 'EntityComment' }
              | { __typename: 'EntityDataSource' }
              | { __typename: 'EntityDepartment' }
              | { __typename: 'EntityIdentityVerification' }
              | { __typename: 'EntityInvoice' }
              | { __typename: 'EntityLedgerTransaction' }
              | { __typename: 'EntityLegalEntity' }
              | { __typename: 'EntityLocation' }
              | { __typename: 'EntityParty' }
              | { __typename: 'EntityProduct' }
              | { __typename: 'EntityReconciliation' }
              | { __typename: 'EntityReport' }
              | { __typename: 'EntityReportPackage' }
              | { __typename: 'EntitySchedule' }
              | { __typename: 'EntityThread' }
              | { __typename: 'EntityTransaction' }
              | { __typename: 'EntityUser' }
              | { __typename: 'EntityWorkItem' }
            ,
            summary: (
              Pick<DimensionSummary, 'partialData'>
              & { time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }> }
            ),
          }
        )
        | { __typename: 'DimensionSummary' }
        | { __typename: 'EntitiesList' }
        | { __typename: 'EntityHovers' }
        | { __typename: 'InsightComponent' }
        | { __typename: 'LocationSummary' }
        | { __typename: 'Runway' }
        | { __typename: 'SourceAccountMetric' }
        | { __typename: 'Statement' }
        | { __typename: 'TopEntities' }
        | { __typename: 'TopTransactions' }
      ,
    } };

export type ReadCategorySummaryByTimeLiveDataQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
}>;


export type ReadCategorySummaryByTimeLiveDataQuery = { liveComponentData:
    | { __typename: 'CashSummary' }
    | (
      { __typename: 'Chart' }
      & {
        entity:
          | { __typename: 'EntityBill' }
          | (
            { __typename: 'EntityCategory' }
            & Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >
          )
          | { __typename: 'EntityComment' }
          | { __typename: 'EntityDataSource' }
          | { __typename: 'EntityDepartment' }
          | { __typename: 'EntityIdentityVerification' }
          | { __typename: 'EntityInvoice' }
          | { __typename: 'EntityLedgerTransaction' }
          | { __typename: 'EntityLegalEntity' }
          | { __typename: 'EntityLocation' }
          | { __typename: 'EntityParty' }
          | { __typename: 'EntityProduct' }
          | { __typename: 'EntityReconciliation' }
          | { __typename: 'EntityReport' }
          | { __typename: 'EntityReportPackage' }
          | { __typename: 'EntitySchedule' }
          | { __typename: 'EntityThread' }
          | { __typename: 'EntityTransaction' }
          | { __typename: 'EntityUser' }
          | { __typename: 'EntityWorkItem' }
        ,
        summary: (
          Pick<DimensionSummary, 'partialData'>
          & { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> }
        ),
      }
    )
    | { __typename: 'DimensionSummary' }
    | { __typename: 'EntitiesList' }
    | { __typename: 'EntityHovers' }
    | { __typename: 'InsightComponent' }
    | { __typename: 'LocationSummary' }
    | { __typename: 'Runway' }
    | { __typename: 'SourceAccountMetric' }
    | { __typename: 'Statement' }
    | { __typename: 'TopEntities' }
    | { __typename: 'TopTransactions' }
   };

export type ReadDepartmentSummaryByTimeComponentDataQueryVariables = Exact<{
  layoutId: Scalars['String']['input'];
  dataId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadDepartmentSummaryByTimeComponentDataQuery = { readComponentData: {
      viewId: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      data:
        | { __typename: 'CashSummary' }
        | (
          { __typename: 'Chart' }
          & {
            entity:
              | { __typename: 'EntityBill' }
              | { __typename: 'EntityCategory' }
              | { __typename: 'EntityComment' }
              | { __typename: 'EntityDataSource' }
              | (
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )
              | { __typename: 'EntityIdentityVerification' }
              | { __typename: 'EntityInvoice' }
              | { __typename: 'EntityLedgerTransaction' }
              | { __typename: 'EntityLegalEntity' }
              | { __typename: 'EntityLocation' }
              | { __typename: 'EntityParty' }
              | { __typename: 'EntityProduct' }
              | { __typename: 'EntityReconciliation' }
              | { __typename: 'EntityReport' }
              | { __typename: 'EntityReportPackage' }
              | { __typename: 'EntitySchedule' }
              | { __typename: 'EntityThread' }
              | { __typename: 'EntityTransaction' }
              | { __typename: 'EntityUser' }
              | { __typename: 'EntityWorkItem' }
            ,
            summary: (
              Pick<DimensionSummary, 'partialData'>
              & { department: Array<(
                Pick<DepartmentDimension, 'departmentId'>
                & {
                  departmentObject: (
                    { __typename: 'EntityDepartment' }
                    & Pick<
                      EntityDepartment,
                      | 'id'
                      | 'name'
                      | 'parentId'
                      | 'active'
                    >
                  ),
                  by: { time: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }> },
                }
              )> }
            ),
          }
        )
        | { __typename: 'DimensionSummary' }
        | { __typename: 'EntitiesList' }
        | { __typename: 'EntityHovers' }
        | { __typename: 'InsightComponent' }
        | { __typename: 'LocationSummary' }
        | { __typename: 'Runway' }
        | { __typename: 'SourceAccountMetric' }
        | { __typename: 'Statement' }
        | { __typename: 'TopEntities' }
        | { __typename: 'TopTransactions' }
      ,
    } };

export type ReadDepartmentSummaryByTimeLiveDataQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
}>;


export type ReadDepartmentSummaryByTimeLiveDataQuery = { liveComponentData:
    | { __typename: 'CashSummary' }
    | (
      { __typename: 'Chart' }
      & {
        entity:
          | { __typename: 'EntityBill' }
          | { __typename: 'EntityCategory' }
          | { __typename: 'EntityComment' }
          | { __typename: 'EntityDataSource' }
          | (
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )
          | { __typename: 'EntityIdentityVerification' }
          | { __typename: 'EntityInvoice' }
          | { __typename: 'EntityLedgerTransaction' }
          | { __typename: 'EntityLegalEntity' }
          | { __typename: 'EntityLocation' }
          | { __typename: 'EntityParty' }
          | { __typename: 'EntityProduct' }
          | { __typename: 'EntityReconciliation' }
          | { __typename: 'EntityReport' }
          | { __typename: 'EntityReportPackage' }
          | { __typename: 'EntitySchedule' }
          | { __typename: 'EntityThread' }
          | { __typename: 'EntityTransaction' }
          | { __typename: 'EntityUser' }
          | { __typename: 'EntityWorkItem' }
        ,
        summary: (
          Pick<DimensionSummary, 'partialData'>
          & { department: Array<(
            Pick<DepartmentDimension, 'departmentId'>
            & {
              departmentObject: (
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              ),
              by: { time: Array<{ summary: (
                    Pick<TransactionSummary, 'isPeriodBookClosed'>
                    & {
                      period: Pick<
                          Period,
                          | 'name'
                          | 'interval'
                          | 'startedAt'
                          | 'endedAt'
                        >,
                      total: (
                        Pick<
                          PeriodMonetaryValue,
                          | 'transactionsCount'
                          | 'deltaPrevious'
                          | 'deltaYearAgo'
                          | 'isFirstOccurrencePeriod'
                        >
                        & {
                          value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          moneyFlow?: Maybe<(
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          )>,
                          current?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                          prior?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                        }
                      ),
                    }
                  ) }> },
            }
          )> }
        ),
      }
    )
    | { __typename: 'DimensionSummary' }
    | { __typename: 'EntitiesList' }
    | { __typename: 'EntityHovers' }
    | { __typename: 'InsightComponent' }
    | { __typename: 'LocationSummary' }
    | { __typename: 'Runway' }
    | { __typename: 'SourceAccountMetric' }
    | { __typename: 'Statement' }
    | { __typename: 'TopEntities' }
    | { __typename: 'TopTransactions' }
   };

export type ReadInsightComponentDataQueryVariables = Exact<{
  layoutId: Scalars['String']['input'];
  dataId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<DimensionSortMode>;
}>;


export type ReadInsightComponentDataQuery = { readComponentData: {
      viewId: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      data:
        | { __typename: 'CashSummary' }
        | { __typename: 'Chart' }
        | { __typename: 'DimensionSummary' }
        | { __typename: 'EntitiesList' }
        | { __typename: 'EntityHovers' }
        | (
          { __typename: 'InsightComponent' }
          & Pick<InsightComponent, 'sentence'>
          & { hovers: Array<
            | (
              { __typename: 'CategoryHover' }
              & Pick<CategoryHover, 'balance'>
              & {
                entity: (
                  { __typename: 'EntityCategory' }
                  & Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >
                ),
                history: (
                  Pick<DimensionSummary, 'partialData'>
                  & { time: Array<{ summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ) }> }
                ),
                context?: Maybe<(
                  Pick<DimensionSummary, 'partialData'>
                  & { party: Array<{
                      partyObject: Pick<
                          EntityParty,
                          | 'id'
                          | 'name'
                          | 'iconUrl'
                          | 'shortDescription'
                          | 'roles'
                          | 'designation'
                        >,
                      summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ),
                    }> }
                )>,
                topTransactions?: Maybe<Array<(
                  Pick<
                    EntityTransaction,
                    | 'viewId'
                    | 'factId'
                    | 'timestamp'
                    | 'description'
                    | 'externalId'
                    | 'displayEntry'
                  >
                  & {
                    moneyFlow: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ),
                    party?: Maybe<Pick<
                        EntityParty,
                        | 'id'
                        | 'name'
                        | 'iconUrl'
                        | 'shortDescription'
                        | 'roles'
                        | 'designation'
                      >>,
                    displayCategory: Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >,
                    splitCategory?: Maybe<Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >>,
                  }
                )>>,
              }
            )
            | (
              { __typename: 'PartyHover' }
              & {
                entity: (
                  { __typename: 'EntityParty' }
                  & Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >
                ),
                history: (
                  Pick<DimensionSummary, 'partialData'>
                  & { time: Array<{ summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ) }> }
                ),
                context?: Maybe<(
                  Pick<DimensionSummary, 'partialData'>
                  & { category: Array<{
                      categoryObject: Pick<
                          EntityCategory,
                          | 'id'
                          | 'name'
                          | 'displayKey'
                          | 'chartOfAccountsDisplayNumber'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'productArea'
                          | 'active'
                        >,
                      summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ),
                    }> }
                )>,
                topTransactions?: Maybe<Array<(
                  Pick<
                    EntityTransaction,
                    | 'viewId'
                    | 'factId'
                    | 'timestamp'
                    | 'description'
                    | 'externalId'
                    | 'displayEntry'
                  >
                  & {
                    moneyFlow: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ),
                    party?: Maybe<Pick<
                        EntityParty,
                        | 'id'
                        | 'name'
                        | 'iconUrl'
                        | 'shortDescription'
                        | 'roles'
                        | 'designation'
                      >>,
                    displayCategory: Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >,
                    splitCategory?: Maybe<Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >>,
                  }
                )>>,
              }
            )
            | (
              { __typename: 'SummaryLineItemHover' }
              & Pick<SummaryLineItemHover, 'lineType'>
              & { history: (
                Pick<DimensionSummary, 'partialData'>
                & { time: Array<{ summary: (
                    Pick<TransactionSummary, 'isPeriodBookClosed'>
                    & {
                      period: Pick<
                          Period,
                          | 'name'
                          | 'interval'
                          | 'startedAt'
                          | 'endedAt'
                        >,
                      total: (
                        Pick<
                          PeriodMonetaryValue,
                          | 'transactionsCount'
                          | 'deltaPrevious'
                          | 'deltaYearAgo'
                          | 'isFirstOccurrencePeriod'
                        >
                        & {
                          value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          moneyFlow?: Maybe<(
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          )>,
                          current?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                          prior?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                        }
                      ),
                    }
                  ) }> }
              ) }
            )
          > }
        )
        | { __typename: 'LocationSummary' }
        | { __typename: 'Runway' }
        | { __typename: 'SourceAccountMetric' }
        | { __typename: 'Statement' }
        | { __typename: 'TopEntities' }
        | { __typename: 'TopTransactions' }
      ,
    } };

export type ReadInsightLiveDataQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<DimensionSortMode>;
}>;


export type ReadInsightLiveDataQuery = { liveComponentData:
    | { __typename: 'CashSummary' }
    | { __typename: 'Chart' }
    | { __typename: 'DimensionSummary' }
    | { __typename: 'EntitiesList' }
    | { __typename: 'EntityHovers' }
    | (
      { __typename: 'InsightComponent' }
      & Pick<InsightComponent, 'sentence'>
      & { hovers: Array<
        | (
          { __typename: 'CategoryHover' }
          & Pick<CategoryHover, 'balance'>
          & {
            entity: (
              { __typename: 'EntityCategory' }
              & Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >
            ),
            history: (
              Pick<DimensionSummary, 'partialData'>
              & { time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }> }
            ),
            context?: Maybe<(
              Pick<DimensionSummary, 'partialData'>
              & { party: Array<{
                  partyObject: Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    >,
                  summary: (
                    Pick<TransactionSummary, 'isPeriodBookClosed'>
                    & {
                      period: Pick<
                          Period,
                          | 'name'
                          | 'interval'
                          | 'startedAt'
                          | 'endedAt'
                        >,
                      total: (
                        Pick<
                          PeriodMonetaryValue,
                          | 'transactionsCount'
                          | 'deltaPrevious'
                          | 'deltaYearAgo'
                          | 'isFirstOccurrencePeriod'
                        >
                        & {
                          value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          moneyFlow?: Maybe<(
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          )>,
                          current?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                          prior?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                        }
                      ),
                    }
                  ),
                }> }
            )>,
            topTransactions?: Maybe<Array<(
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            )>>,
          }
        )
        | (
          { __typename: 'PartyHover' }
          & {
            entity: (
              { __typename: 'EntityParty' }
              & Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >
            ),
            history: (
              Pick<DimensionSummary, 'partialData'>
              & { time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }> }
            ),
            context?: Maybe<(
              Pick<DimensionSummary, 'partialData'>
              & { category: Array<{
                  categoryObject: Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >,
                  summary: (
                    Pick<TransactionSummary, 'isPeriodBookClosed'>
                    & {
                      period: Pick<
                          Period,
                          | 'name'
                          | 'interval'
                          | 'startedAt'
                          | 'endedAt'
                        >,
                      total: (
                        Pick<
                          PeriodMonetaryValue,
                          | 'transactionsCount'
                          | 'deltaPrevious'
                          | 'deltaYearAgo'
                          | 'isFirstOccurrencePeriod'
                        >
                        & {
                          value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          moneyFlow?: Maybe<(
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          )>,
                          current?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                          prior?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                        }
                      ),
                    }
                  ),
                }> }
            )>,
            topTransactions?: Maybe<Array<(
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            )>>,
          }
        )
        | (
          { __typename: 'SummaryLineItemHover' }
          & Pick<SummaryLineItemHover, 'lineType'>
          & { history: (
            Pick<DimensionSummary, 'partialData'>
            & { time: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }> }
          ) }
        )
      > }
    )
    | { __typename: 'LocationSummary' }
    | { __typename: 'Runway' }
    | { __typename: 'SourceAccountMetric' }
    | { __typename: 'Statement' }
    | { __typename: 'TopEntities' }
    | { __typename: 'TopTransactions' }
   };

export type ReadLayoutQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  layoutId: Scalars['String']['input'];
  layoutVersionId?: InputMaybe<Scalars['String']['input']>;
  includeEntities?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ReadLayoutQuery = { readLayout: (
    Pick<Layout, 'layoutId' | 'layoutVersionId'>
    & {
      viewKey: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      sections?: Maybe<Array<(
        Pick<LayoutSection, 'sectionId' | 'title'>
        & { rows?: Maybe<Array<(
          Pick<LayoutRow, 'rowId' | 'title'>
          & { components?: Maybe<Array<(
            Pick<LayoutComponent, 'componentId' | 'title' | 'dataId'>
            & { config: (
              Pick<LayoutComponentConfig, 'type'>
              & {
                text?: Maybe<(
                  Pick<TextComponentConfig, 'body'>
                  & {
                    current?: Maybe<Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >>,
                    lookback?: Maybe<Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >>,
                    tags?: Maybe<Array<(
                      Pick<TextComponentConfigTag, 'displayText'>
                      & {
                        objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
                        options?: Maybe<Pick<TextTagOptions, 'partyRole'>>,
                      }
                    )>>,
                  }
                )>,
                categoryChart?: Maybe<(
                  Pick<CategoryChartConfig, 'categoryId' | 'withoutCategoryAncestors' | 'asPermanent'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                partyChart?: Maybe<(
                  Pick<PartyChartConfig, 'partyId' | 'partyRole' | 'asPermanent'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                topEntities?: Maybe<(
                  Pick<
                    TopEntitiesConfig,
                    | 'limit'
                    | 'kind'
                    | 'partyRole'
                    | 'categoryType'
                    | 'sort'
                  >
                  & {
                    origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                    filteredBy?: Maybe<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
                  }
                )>,
                topTransactions?: Maybe<(
                  Pick<TopTransactionsConfig, 'limit' | 'partyRole' | 'categoryType'>
                  & {
                    origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                    filteredBy?: Maybe<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
                  }
                )>,
                summaryLineItem?: Maybe<(
                  Pick<SummaryLineItemConfig, 'item'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                portalMetric?: Maybe<(
                  Pick<PortalMetricConfig, 'metricType'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                entitiesList?: Maybe<{
                    origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                    entities: (
                      { __typename: 'ObjectEntities' }
                      & {
                        users?: Maybe<Array<Pick<
                            EntityUser,
                            | 'id'
                            | 'givenName'
                            | 'familyName'
                            | 'emailAddress'
                            | 'avatarUrl'
                          >>>,
                        transactions?: Maybe<Array<(
                          Pick<
                            EntityTransaction,
                            | 'viewId'
                            | 'factId'
                            | 'timestamp'
                            | 'description'
                            | 'externalId'
                            | 'displayEntry'
                          >
                          & {
                            moneyFlow: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ),
                            party?: Maybe<Pick<
                                EntityParty,
                                | 'id'
                                | 'name'
                                | 'iconUrl'
                                | 'shortDescription'
                                | 'roles'
                                | 'designation'
                              >>,
                            displayCategory: Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >,
                            splitCategory?: Maybe<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>,
                          }
                        )>>,
                        comments?: Maybe<Array<Pick<
                            EntityComment,
                            | 'id'
                            | 'authorId'
                            | 'text'
                            | 'timestamp'
                          >>>,
                        reports?: Maybe<Array<(
                          Pick<
                            EntityReport,
                            | 'id'
                            | 'title'
                            | 'authorId'
                            | 'mimeType'
                            | 'createdAt'
                          >
                          & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
                        )>>,
                        reportPackages?: Maybe<Array<(
                          Pick<
                            EntityReportPackage,
                            | 'id'
                            | 'title'
                            | 'authorId'
                            | 'interval'
                            | 'periodStartedAt'
                            | 'periodEndedAt'
                            | 'createdAt'
                            | 'updatedAt'
                            | 'coverUrl'
                          >
                          & { documents: Array<Pick<
                              SharedReportDocumentMetadata,
                              | 'id'
                              | 'documentObjectId'
                              | 'documentObjectVersionId'
                              | 'title'
                              | 'mimeType'
                            >> }
                        )>>,
                        parties?: Maybe<Array<Pick<
                            EntityParty,
                            | 'id'
                            | 'name'
                            | 'iconUrl'
                            | 'shortDescription'
                            | 'roles'
                            | 'designation'
                          >>>,
                        datasources?: Maybe<Array<Pick<
                            EntityDataSource,
                            | 'id'
                            | 'name'
                            | 'url'
                            | 'iconUrl'
                          >>>,
                        categories?: Maybe<Array<Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >>>,
                        threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
                        legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
                        workItems?: Maybe<Array<(
                          Pick<
                            EntityWorkItem,
                            | 'id'
                            | 'time'
                            | 'workItemState'
                            | 'workItemType'
                            | 'reviewCreatedById'
                            | 'reviewState'
                            | 'ledgerType'
                          >
                          & { objectTransaction: (
                            Pick<
                              EntityTransaction,
                              | 'viewId'
                              | 'factId'
                              | 'timestamp'
                              | 'description'
                              | 'externalId'
                              | 'displayEntry'
                            >
                            & {
                              moneyFlow: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ),
                              party?: Maybe<Pick<
                                  EntityParty,
                                  | 'id'
                                  | 'name'
                                  | 'iconUrl'
                                  | 'shortDescription'
                                  | 'roles'
                                  | 'designation'
                                >>,
                              displayCategory: Pick<
                                  EntityCategory,
                                  | 'id'
                                  | 'name'
                                  | 'displayKey'
                                  | 'chartOfAccountsDisplayNumber'
                                  | 'type'
                                  | 'subtype'
                                  | 'parentCategoryId'
                                  | 'productArea'
                                  | 'active'
                                >,
                              splitCategory?: Maybe<Pick<
                                  EntityCategory,
                                  | 'id'
                                  | 'name'
                                  | 'displayKey'
                                  | 'chartOfAccountsDisplayNumber'
                                  | 'type'
                                  | 'subtype'
                                  | 'parentCategoryId'
                                  | 'productArea'
                                  | 'active'
                                >>,
                            }
                          ) }
                        )>>,
                        invoices?: Maybe<Array<(
                          Pick<
                            EntityInvoice,
                            | 'id'
                            | 'externalDisplayId'
                            | 'createdAt'
                            | 'dueAt'
                          >
                          & {
                            amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            customer: (
                              Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                              & { party: Pick<
                                  EntityParty,
                                  | 'id'
                                  | 'name'
                                  | 'iconUrl'
                                  | 'shortDescription'
                                  | 'roles'
                                  | 'designation'
                                > }
                            ),
                          }
                        )>>,
                        bills?: Maybe<Array<(
                          Pick<
                            EntityBill,
                            | 'id'
                            | 'billStatus'
                            | 'vendorName'
                            | 'billDescription'
                          >
                          & {
                            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
                            format: (
                              Pick<Format, 'id' | 'formatClass'>
                              & { segments: Array<Pick<
                                  Segment,
                                  | 'collectionId'
                                  | 'fileId'
                                  | 'sequence'
                                  | 'token'
                                >> }
                            ),
                            approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
                          }
                        )>>,
                        identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
                        departments?: Maybe<Array<(
                          { __typename: 'EntityDepartment' }
                          & Pick<
                            EntityDepartment,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        )>>,
                        locations?: Maybe<Array<(
                          { __typename: 'EntityLocation' }
                          & Pick<
                            EntityLocation,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        )>>,
                        reconciliations?: Maybe<Array<(
                          { __typename: 'EntityReconciliation' }
                          & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
                          & {
                            startDate: Pick<Date, 'year' | 'month' | 'day'>,
                            endDate: Pick<Date, 'year' | 'month' | 'day'>,
                          }
                        )>>,
                        ledgerTransactions?: Maybe<Array<(
                          Pick<
                            EntityLedgerTransaction,
                            | 'id'
                            | 'timestamp'
                            | 'factIds'
                            | 'name'
                            | 'referenceNumber'
                          >
                          & {
                            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            parties: Array<Pick<
                                EntityParty,
                                | 'id'
                                | 'name'
                                | 'iconUrl'
                                | 'shortDescription'
                                | 'roles'
                                | 'designation'
                              >>,
                          }
                        )>>,
                        schedules?: Maybe<Array<(
                          { __typename: 'EntitySchedule' }
                          & Pick<
                            EntitySchedule,
                            | 'id'
                            | 'name'
                            | 'scheduleNumber'
                            | 'scheduleType'
                            | 'scheduleTemplateId'
                            | 'categoryId'
                            | 'relatedCategoryId'
                            | 'partyId'
                            | 'startDate'
                            | 'endDate'
                            | 'cutoverDate'
                          >
                          & {
                            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                          }
                        )>>,
                      }
                    ),
                  }>,
                statement?: Maybe<(
                  Pick<StatementConfig, 'kind'>
                  & {
                    origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                    options?: Maybe<(
                      { __typename: 'ReportDocumentOptions' }
                      & Pick<
                        ReportDocumentOptions,
                        | 'sparklineLookbackPeriods'
                        | 'reportLookbackPeriods'
                        | 'deltaMonthOverMonth'
                        | 'deltaMonthOverMonthPeriods'
                        | 'deltaYearOverYear'
                        | 'comparedToTotal'
                        | 'comparedToIncome'
                        | 'amountPrecision'
                        | 'yearToDate'
                        | 'deltaYearToDate'
                        | 'breakdownByClass'
                      >
                      & {
                        collapsedSections?: Maybe<Pick<CollapsedSections, 'sections'>>,
                        categoryByDepartmentOptions?: Maybe<(
                          Pick<CategoryByDepartmentOptions, 'showOther' | 'showUnassigned'>
                          & { departments?: Maybe<Array<Pick<DepartmentOption, 'departmentId' | 'name'>>> }
                        )>,
                        categoryByLocationOptions?: Maybe<(
                          Pick<CategoryByLocationOptions, 'showOther' | 'showUnassigned'>
                          & { locations?: Maybe<Array<Pick<LocationOption, 'locationId' | 'name'>>> }
                        )>,
                      }
                    )>,
                  }
                )>,
                metricChart?: Maybe<(
                  Pick<MetricChartConfig, 'item'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                runwayChart?: Maybe<{
                    origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                    netBurnLookback?: Maybe<Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >>,
                  }>,
                cashSummaryChart?: Maybe<{ origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }>,
                staticMetric?: Maybe<Pick<StaticMetricConfig, 'name' | 'value' | 'updatedAt'>>,
                documentCollection?: Maybe<Pick<DocumentCollectionConfig, 'collectionId'>>,
                insight?: Maybe<{
                    objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
                    options?: Maybe<Pick<InsightComponentConfigOptions, 'partyRole'>>,
                    origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                    lookback: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      >,
                  }>,
                departmentChart?: Maybe<(
                  Pick<DepartmentChartConfig, 'departmentId'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                locationChart?: Maybe<(
                  Pick<LocationChartConfig, 'locationId'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                sourceAccountMetric?: Maybe<(
                  Pick<SourceAccountMetricConfig, 'key' | 'sourceAccountId' | 'dataSourceId'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                agingSummaryChart?: Maybe<(
                  Pick<AgingSummaryChartConfig, 'kind' | 'dimensions' | 'masks'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                categoryByDepartmentChart?: Maybe<(
                  Pick<CategoryByDepartmentChartConfig, 'categoryId' | 'departmentIds'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
                categoryByLocationChart?: Maybe<(
                  Pick<CategoryByLocationChartConfig, 'categoryId' | 'locationIds'>
                  & { origin: Pick<
                      ArchiveIntervalOrigin,
                      | 'interval'
                      | 'year'
                      | 'index'
                      | 'intervalCount'
                      | 'maxTime'
                    > }
                )>,
              }
            ) }
          )>> }
        )>> }
      )>>,
    }
  ) };

export type ReadLocationChartComponentDataQueryVariables = Exact<{
  layoutId: Scalars['String']['input'];
  dataId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadLocationChartComponentDataQuery = { readComponentData: {
      viewId: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      data:
        | { __typename: 'CashSummary' }
        | { __typename: 'Chart' }
        | { __typename: 'DimensionSummary' }
        | { __typename: 'EntitiesList' }
        | { __typename: 'EntityHovers' }
        | { __typename: 'InsightComponent' }
        | (
          { __typename: 'LocationSummary' }
          & {
            location: (
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            ),
            total: { time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }> },
            expensesChange: { time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }> },
            otherExpensesChange: { time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }> },
            incomeChange: { time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }> },
            otherIncomeChange: { time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }> },
            cogsChange: { time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }> },
          }
        )
        | { __typename: 'Runway' }
        | { __typename: 'SourceAccountMetric' }
        | { __typename: 'Statement' }
        | { __typename: 'TopEntities' }
        | { __typename: 'TopTransactions' }
      ,
    } };

export type ReadLocationChartLiveDataQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
}>;


export type ReadLocationChartLiveDataQuery = { liveComponentData:
    | { __typename: 'CashSummary' }
    | { __typename: 'Chart' }
    | { __typename: 'DimensionSummary' }
    | { __typename: 'EntitiesList' }
    | { __typename: 'EntityHovers' }
    | { __typename: 'InsightComponent' }
    | (
      { __typename: 'LocationSummary' }
      & {
        location: (
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        ),
        total: { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> },
        expensesChange: { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> },
        otherExpensesChange: { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> },
        incomeChange: { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> },
        otherIncomeChange: { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> },
        cogsChange: { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> },
      }
    )
    | { __typename: 'Runway' }
    | { __typename: 'SourceAccountMetric' }
    | { __typename: 'Statement' }
    | { __typename: 'TopEntities' }
    | { __typename: 'TopTransactions' }
   };

export type ReadMetricByTimeComponentDataQueryVariables = Exact<{
  layoutId: Scalars['String']['input'];
  dataId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadMetricByTimeComponentDataQuery = { readComponentData: {
      viewId: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      data:
        | { __typename: 'CashSummary' }
        | { __typename: 'Chart' }
        | (
          { __typename: 'DimensionSummary' }
          & Pick<DimensionSummary, 'partialData'>
          & { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> }
        )
        | { __typename: 'EntitiesList' }
        | { __typename: 'EntityHovers' }
        | { __typename: 'InsightComponent' }
        | { __typename: 'LocationSummary' }
        | { __typename: 'Runway' }
        | { __typename: 'SourceAccountMetric' }
        | { __typename: 'Statement' }
        | { __typename: 'TopEntities' }
        | { __typename: 'TopTransactions' }
      ,
    } };

export type ReadMetricByTimeLiveDataQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
}>;


export type ReadMetricByTimeLiveDataQuery = { liveComponentData:
    | { __typename: 'CashSummary' }
    | { __typename: 'Chart' }
    | (
      { __typename: 'DimensionSummary' }
      & Pick<DimensionSummary, 'partialData'>
      & { time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> }
    )
    | { __typename: 'EntitiesList' }
    | { __typename: 'EntityHovers' }
    | { __typename: 'InsightComponent' }
    | { __typename: 'LocationSummary' }
    | { __typename: 'Runway' }
    | { __typename: 'SourceAccountMetric' }
    | { __typename: 'Statement' }
    | { __typename: 'TopEntities' }
    | { __typename: 'TopTransactions' }
   };

export type ReadPartySummaryByTimeComponentDataQueryVariables = Exact<{
  layoutId: Scalars['String']['input'];
  dataId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadPartySummaryByTimeComponentDataQuery = { readComponentData: {
      viewId: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      data:
        | { __typename: 'CashSummary' }
        | (
          { __typename: 'Chart' }
          & {
            entity:
              | { __typename: 'EntityBill' }
              | { __typename: 'EntityCategory' }
              | { __typename: 'EntityComment' }
              | { __typename: 'EntityDataSource' }
              | { __typename: 'EntityDepartment' }
              | { __typename: 'EntityIdentityVerification' }
              | { __typename: 'EntityInvoice' }
              | { __typename: 'EntityLedgerTransaction' }
              | { __typename: 'EntityLegalEntity' }
              | { __typename: 'EntityLocation' }
              | (
                { __typename: 'EntityParty' }
                & Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >
              )
              | { __typename: 'EntityProduct' }
              | { __typename: 'EntityReconciliation' }
              | { __typename: 'EntityReport' }
              | { __typename: 'EntityReportPackage' }
              | { __typename: 'EntitySchedule' }
              | { __typename: 'EntityThread' }
              | { __typename: 'EntityTransaction' }
              | { __typename: 'EntityUser' }
              | { __typename: 'EntityWorkItem' }
            ,
            summary: (
              Pick<DimensionSummary, 'partialData'>
              & { time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }> }
            ),
          }
        )
        | { __typename: 'DimensionSummary' }
        | { __typename: 'EntitiesList' }
        | { __typename: 'EntityHovers' }
        | { __typename: 'InsightComponent' }
        | { __typename: 'LocationSummary' }
        | { __typename: 'Runway' }
        | { __typename: 'SourceAccountMetric' }
        | { __typename: 'Statement' }
        | { __typename: 'TopEntities' }
        | { __typename: 'TopTransactions' }
      ,
    } };

export type ReadPartySummaryByTimeLiveDataQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
}>;


export type ReadPartySummaryByTimeLiveDataQuery = { liveComponentData:
    | { __typename: 'CashSummary' }
    | (
      { __typename: 'Chart' }
      & {
        entity:
          | { __typename: 'EntityBill' }
          | { __typename: 'EntityCategory' }
          | { __typename: 'EntityComment' }
          | { __typename: 'EntityDataSource' }
          | { __typename: 'EntityDepartment' }
          | { __typename: 'EntityIdentityVerification' }
          | { __typename: 'EntityInvoice' }
          | { __typename: 'EntityLedgerTransaction' }
          | { __typename: 'EntityLegalEntity' }
          | { __typename: 'EntityLocation' }
          | (
            { __typename: 'EntityParty' }
            & Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >
          )
          | { __typename: 'EntityProduct' }
          | { __typename: 'EntityReconciliation' }
          | { __typename: 'EntityReport' }
          | { __typename: 'EntityReportPackage' }
          | { __typename: 'EntitySchedule' }
          | { __typename: 'EntityThread' }
          | { __typename: 'EntityTransaction' }
          | { __typename: 'EntityUser' }
          | { __typename: 'EntityWorkItem' }
        ,
        summary: (
          Pick<DimensionSummary, 'partialData'>
          & { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> }
        ),
      }
    )
    | { __typename: 'DimensionSummary' }
    | { __typename: 'EntitiesList' }
    | { __typename: 'EntityHovers' }
    | { __typename: 'InsightComponent' }
    | { __typename: 'LocationSummary' }
    | { __typename: 'Runway' }
    | { __typename: 'SourceAccountMetric' }
    | { __typename: 'Statement' }
    | { __typename: 'TopEntities' }
    | { __typename: 'TopTransactions' }
   };

export type ReadReportStatementComponentDataQueryVariables = Exact<{
  layoutId: Scalars['String']['input'];
  dataId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<DimensionSortMode>;
  timeHistory: Scalars['Boolean']['input'];
  departmentHistory: Scalars['Boolean']['input'];
  locationHistory: Scalars['Boolean']['input'];
}>;


export type ReadReportStatementComponentDataQuery = { readComponentData: {
      viewId: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      data:
        | { __typename: 'CashSummary' }
        | { __typename: 'Chart' }
        | { __typename: 'DimensionSummary' }
        | { __typename: 'EntitiesList' }
        | { __typename: 'EntityHovers' }
        | { __typename: 'InsightComponent' }
        | { __typename: 'LocationSummary' }
        | { __typename: 'Runway' }
        | { __typename: 'SourceAccountMetric' }
        | (
          { __typename: 'Statement' }
          & Pick<Statement, 'kind'>
          & { rows: Array<(
            Pick<StatementRow, 'rowId' | 'depth'>
            & {
              sectionTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
              sectionSummary?: Maybe<(
                Pick<StatementRowSummary, 'displayNumber' | 'label'>
                & { moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
              parentCategoryTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
              parentCategorySummary?: Maybe<(
                Pick<StatementRowSummary, 'displayNumber' | 'label'>
                & { moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
              leafCategorySummary?: Maybe<(
                Pick<StatementRowSummary, 'displayNumber' | 'label'>
                & { moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
              agingTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
              agingSummary?: Maybe<(
                Pick<AgingSummary, 'label'>
                & { dimensionSummary: (
                  Pick<DimensionSummary, 'partialData'>
                  & {
                    aging: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }>,
                    summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ),
                  }
                ) }
              )>,
              parentAgingTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
              parentAgingSummary?: Maybe<(
                Pick<AgingSummary, 'label'>
                & { dimensionSummary: (
                  Pick<DimensionSummary, 'partialData'>
                  & {
                    aging: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }>,
                    summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ),
                  }
                ) }
              )>,
              leafAgingSummary?: Maybe<(
                Pick<LeafAgingSummary, 'dueDate' | 'referenceNumber' | 'invoiceDate'>
                & {
                  amounts: Array<(
                    Pick<LeafAgingSummaryAmount, 'column'>
                    & { moneyFlow: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                  link: Pick<LeafAgingSummaryLink, 'hasLink'>,
                }
              )>,
              details?: Maybe<{
                  hover:
                    | (
                      { __typename: 'CategoryHover' }
                      & Pick<CategoryHover, 'balance'>
                      & {
                        entity: (
                          { __typename: 'EntityCategory' }
                          & Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >
                        ),
                        history: (
                          Pick<DimensionSummary, 'partialData'>
                          & {
                            time: Array<{ summary: (
                                Pick<TransactionSummary, 'isPeriodBookClosed'>
                                & {
                                  period: Pick<
                                      Period,
                                      | 'name'
                                      | 'interval'
                                      | 'startedAt'
                                      | 'endedAt'
                                    >,
                                  total: (
                                    Pick<
                                      PeriodMonetaryValue,
                                      | 'transactionsCount'
                                      | 'deltaPrevious'
                                      | 'deltaYearAgo'
                                      | 'isFirstOccurrencePeriod'
                                    >
                                    & {
                                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                      moneyFlow?: Maybe<(
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      )>,
                                      current?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                      prior?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                    }
                                  ),
                                }
                              ) }>,
                            department: Array<(
                              Pick<DepartmentDimension, 'departmentId'>
                              & {
                                departmentObject: (
                                  { __typename: 'EntityDepartment' }
                                  & Pick<
                                    EntityDepartment,
                                    | 'id'
                                    | 'name'
                                    | 'parentId'
                                    | 'active'
                                  >
                                ),
                                by: { time: Array<{ summary: (
                                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                                      & {
                                        period: Pick<
                                            Period,
                                            | 'name'
                                            | 'interval'
                                            | 'startedAt'
                                            | 'endedAt'
                                          >,
                                        total: (
                                          Pick<
                                            PeriodMonetaryValue,
                                            | 'transactionsCount'
                                            | 'deltaPrevious'
                                            | 'deltaYearAgo'
                                            | 'isFirstOccurrencePeriod'
                                          >
                                          & {
                                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                            moneyFlow?: Maybe<(
                                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                            )>,
                                            current?: Maybe<(
                                              Pick<SummaryTotal, 'count'>
                                              & { total: (
                                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                              ) }
                                            )>,
                                            prior?: Maybe<(
                                              Pick<SummaryTotal, 'count'>
                                              & { total: (
                                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                              ) }
                                            )>,
                                          }
                                        ),
                                      }
                                    ) }> },
                              }
                            )>,
                            location: Array<(
                              Pick<LocationDimension, 'locationId'>
                              & {
                                locationObject: (
                                  { __typename: 'EntityLocation' }
                                  & Pick<
                                    EntityLocation,
                                    | 'id'
                                    | 'name'
                                    | 'parentId'
                                    | 'active'
                                  >
                                ),
                                by: { time: Array<{ summary: (
                                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                                      & {
                                        period: Pick<
                                            Period,
                                            | 'name'
                                            | 'interval'
                                            | 'startedAt'
                                            | 'endedAt'
                                          >,
                                        total: (
                                          Pick<
                                            PeriodMonetaryValue,
                                            | 'transactionsCount'
                                            | 'deltaPrevious'
                                            | 'deltaYearAgo'
                                            | 'isFirstOccurrencePeriod'
                                          >
                                          & {
                                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                            moneyFlow?: Maybe<(
                                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                            )>,
                                            current?: Maybe<(
                                              Pick<SummaryTotal, 'count'>
                                              & { total: (
                                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                              ) }
                                            )>,
                                            prior?: Maybe<(
                                              Pick<SummaryTotal, 'count'>
                                              & { total: (
                                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                              ) }
                                            )>,
                                          }
                                        ),
                                      }
                                    ) }> },
                              }
                            )>,
                          }
                        ),
                        context?: Maybe<(
                          Pick<DimensionSummary, 'partialData'>
                          & { party: Array<{
                              partyObject: Pick<
                                  EntityParty,
                                  | 'id'
                                  | 'name'
                                  | 'iconUrl'
                                  | 'shortDescription'
                                  | 'roles'
                                  | 'designation'
                                >,
                              summary: (
                                Pick<TransactionSummary, 'isPeriodBookClosed'>
                                & {
                                  period: Pick<
                                      Period,
                                      | 'name'
                                      | 'interval'
                                      | 'startedAt'
                                      | 'endedAt'
                                    >,
                                  total: (
                                    Pick<
                                      PeriodMonetaryValue,
                                      | 'transactionsCount'
                                      | 'deltaPrevious'
                                      | 'deltaYearAgo'
                                      | 'isFirstOccurrencePeriod'
                                    >
                                    & {
                                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                      moneyFlow?: Maybe<(
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      )>,
                                      current?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                      prior?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                    }
                                  ),
                                }
                              ),
                            }> }
                        )>,
                        topTransactions?: Maybe<Array<(
                          Pick<
                            EntityTransaction,
                            | 'viewId'
                            | 'factId'
                            | 'timestamp'
                            | 'description'
                            | 'externalId'
                            | 'displayEntry'
                          >
                          & {
                            moneyFlow: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ),
                            party?: Maybe<Pick<
                                EntityParty,
                                | 'id'
                                | 'name'
                                | 'iconUrl'
                                | 'shortDescription'
                                | 'roles'
                                | 'designation'
                              >>,
                            displayCategory: Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >,
                            splitCategory?: Maybe<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>,
                          }
                        )>>,
                        missingClass?: Maybe<{ time: Array<{ summary: (
                              Pick<TransactionSummary, 'isPeriodBookClosed'>
                              & {
                                period: Pick<
                                    Period,
                                    | 'name'
                                    | 'interval'
                                    | 'startedAt'
                                    | 'endedAt'
                                  >,
                                total: (
                                  Pick<
                                    PeriodMonetaryValue,
                                    | 'transactionsCount'
                                    | 'deltaPrevious'
                                    | 'deltaYearAgo'
                                    | 'isFirstOccurrencePeriod'
                                  >
                                  & {
                                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                    moneyFlow?: Maybe<(
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    )>,
                                    current?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                    prior?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                  }
                                ),
                              }
                            ) }> }>,
                        otherClass?: Maybe<{ time: Array<{ summary: (
                              Pick<TransactionSummary, 'isPeriodBookClosed'>
                              & {
                                period: Pick<
                                    Period,
                                    | 'name'
                                    | 'interval'
                                    | 'startedAt'
                                    | 'endedAt'
                                  >,
                                total: (
                                  Pick<
                                    PeriodMonetaryValue,
                                    | 'transactionsCount'
                                    | 'deltaPrevious'
                                    | 'deltaYearAgo'
                                    | 'isFirstOccurrencePeriod'
                                  >
                                  & {
                                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                    moneyFlow?: Maybe<(
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    )>,
                                    current?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                    prior?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                  }
                                ),
                              }
                            ) }> }>,
                      }
                    )
                    | (
                      { __typename: 'PartyHover' }
                      & {
                        entity: (
                          { __typename: 'EntityParty' }
                          & Pick<
                            EntityParty,
                            | 'id'
                            | 'name'
                            | 'iconUrl'
                            | 'shortDescription'
                            | 'roles'
                            | 'designation'
                          >
                        ),
                        history: (
                          Pick<DimensionSummary, 'partialData'>
                          & { time: Array<{ summary: (
                              Pick<TransactionSummary, 'isPeriodBookClosed'>
                              & {
                                period: Pick<
                                    Period,
                                    | 'name'
                                    | 'interval'
                                    | 'startedAt'
                                    | 'endedAt'
                                  >,
                                total: (
                                  Pick<
                                    PeriodMonetaryValue,
                                    | 'transactionsCount'
                                    | 'deltaPrevious'
                                    | 'deltaYearAgo'
                                    | 'isFirstOccurrencePeriod'
                                  >
                                  & {
                                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                    moneyFlow?: Maybe<(
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    )>,
                                    current?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                    prior?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                  }
                                ),
                              }
                            ) }> }
                        ),
                        context?: Maybe<(
                          Pick<DimensionSummary, 'partialData'>
                          & { category: Array<{
                              categoryObject: Pick<
                                  EntityCategory,
                                  | 'id'
                                  | 'name'
                                  | 'displayKey'
                                  | 'chartOfAccountsDisplayNumber'
                                  | 'type'
                                  | 'subtype'
                                  | 'parentCategoryId'
                                  | 'productArea'
                                  | 'active'
                                >,
                              summary: (
                                Pick<TransactionSummary, 'isPeriodBookClosed'>
                                & {
                                  period: Pick<
                                      Period,
                                      | 'name'
                                      | 'interval'
                                      | 'startedAt'
                                      | 'endedAt'
                                    >,
                                  total: (
                                    Pick<
                                      PeriodMonetaryValue,
                                      | 'transactionsCount'
                                      | 'deltaPrevious'
                                      | 'deltaYearAgo'
                                      | 'isFirstOccurrencePeriod'
                                    >
                                    & {
                                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                      moneyFlow?: Maybe<(
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      )>,
                                      current?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                      prior?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                    }
                                  ),
                                }
                              ),
                            }> }
                        )>,
                        topTransactions?: Maybe<Array<(
                          Pick<
                            EntityTransaction,
                            | 'viewId'
                            | 'factId'
                            | 'timestamp'
                            | 'description'
                            | 'externalId'
                            | 'displayEntry'
                          >
                          & {
                            moneyFlow: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ),
                            party?: Maybe<Pick<
                                EntityParty,
                                | 'id'
                                | 'name'
                                | 'iconUrl'
                                | 'shortDescription'
                                | 'roles'
                                | 'designation'
                              >>,
                            displayCategory: Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >,
                            splitCategory?: Maybe<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>,
                          }
                        )>>,
                      }
                    )
                    | (
                      { __typename: 'SummaryLineItemHover' }
                      & Pick<SummaryLineItemHover, 'lineType'>
                      & {
                        history: (
                          Pick<DimensionSummary, 'partialData'>
                          & {
                            time: Array<{ summary: (
                                Pick<TransactionSummary, 'isPeriodBookClosed'>
                                & {
                                  period: Pick<
                                      Period,
                                      | 'name'
                                      | 'interval'
                                      | 'startedAt'
                                      | 'endedAt'
                                    >,
                                  total: (
                                    Pick<
                                      PeriodMonetaryValue,
                                      | 'transactionsCount'
                                      | 'deltaPrevious'
                                      | 'deltaYearAgo'
                                      | 'isFirstOccurrencePeriod'
                                    >
                                    & {
                                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                      moneyFlow?: Maybe<(
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      )>,
                                      current?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                      prior?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                    }
                                  ),
                                }
                              ) }>,
                            department: Array<(
                              Pick<DepartmentDimension, 'departmentId'>
                              & {
                                departmentObject: (
                                  { __typename: 'EntityDepartment' }
                                  & Pick<
                                    EntityDepartment,
                                    | 'id'
                                    | 'name'
                                    | 'parentId'
                                    | 'active'
                                  >
                                ),
                                by: { time: Array<{ summary: (
                                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                                      & {
                                        period: Pick<
                                            Period,
                                            | 'name'
                                            | 'interval'
                                            | 'startedAt'
                                            | 'endedAt'
                                          >,
                                        total: (
                                          Pick<
                                            PeriodMonetaryValue,
                                            | 'transactionsCount'
                                            | 'deltaPrevious'
                                            | 'deltaYearAgo'
                                            | 'isFirstOccurrencePeriod'
                                          >
                                          & {
                                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                            moneyFlow?: Maybe<(
                                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                            )>,
                                            current?: Maybe<(
                                              Pick<SummaryTotal, 'count'>
                                              & { total: (
                                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                              ) }
                                            )>,
                                            prior?: Maybe<(
                                              Pick<SummaryTotal, 'count'>
                                              & { total: (
                                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                              ) }
                                            )>,
                                          }
                                        ),
                                      }
                                    ) }> },
                              }
                            )>,
                            location: Array<(
                              Pick<LocationDimension, 'locationId'>
                              & {
                                locationObject: (
                                  { __typename: 'EntityLocation' }
                                  & Pick<
                                    EntityLocation,
                                    | 'id'
                                    | 'name'
                                    | 'parentId'
                                    | 'active'
                                  >
                                ),
                                by: { time: Array<{ summary: (
                                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                                      & {
                                        period: Pick<
                                            Period,
                                            | 'name'
                                            | 'interval'
                                            | 'startedAt'
                                            | 'endedAt'
                                          >,
                                        total: (
                                          Pick<
                                            PeriodMonetaryValue,
                                            | 'transactionsCount'
                                            | 'deltaPrevious'
                                            | 'deltaYearAgo'
                                            | 'isFirstOccurrencePeriod'
                                          >
                                          & {
                                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                            moneyFlow?: Maybe<(
                                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                            )>,
                                            current?: Maybe<(
                                              Pick<SummaryTotal, 'count'>
                                              & { total: (
                                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                              ) }
                                            )>,
                                            prior?: Maybe<(
                                              Pick<SummaryTotal, 'count'>
                                              & { total: (
                                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                              ) }
                                            )>,
                                          }
                                        ),
                                      }
                                    ) }> },
                              }
                            )>,
                          }
                        ),
                        missingClass?: Maybe<{ time: Array<{ summary: (
                              Pick<TransactionSummary, 'isPeriodBookClosed'>
                              & {
                                period: Pick<
                                    Period,
                                    | 'name'
                                    | 'interval'
                                    | 'startedAt'
                                    | 'endedAt'
                                  >,
                                total: (
                                  Pick<
                                    PeriodMonetaryValue,
                                    | 'transactionsCount'
                                    | 'deltaPrevious'
                                    | 'deltaYearAgo'
                                    | 'isFirstOccurrencePeriod'
                                  >
                                  & {
                                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                    moneyFlow?: Maybe<(
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    )>,
                                    current?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                    prior?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                  }
                                ),
                              }
                            ) }> }>,
                        otherClass?: Maybe<{ time: Array<{ summary: (
                              Pick<TransactionSummary, 'isPeriodBookClosed'>
                              & {
                                period: Pick<
                                    Period,
                                    | 'name'
                                    | 'interval'
                                    | 'startedAt'
                                    | 'endedAt'
                                  >,
                                total: (
                                  Pick<
                                    PeriodMonetaryValue,
                                    | 'transactionsCount'
                                    | 'deltaPrevious'
                                    | 'deltaYearAgo'
                                    | 'isFirstOccurrencePeriod'
                                  >
                                  & {
                                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                    moneyFlow?: Maybe<(
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    )>,
                                    current?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                    prior?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                  }
                                ),
                              }
                            ) }> }>,
                      }
                    )
                  ,
                  insight?: Maybe<(
                    Pick<
                      Insight,
                      | 'score'
                      | 'globalScore'
                      | 'subjectType'
                      | 'subjectId'
                      | 'subjectDisplayKey'
                      | 'comparisonIntervalOffset'
                      | 'ruleType'
                      | 'sentence'
                      | 'subjectIconUrl'
                      | 'designation'
                      | 'type'
                      | 'productArea'
                    >
                    & {
                      periodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      absoluteDelta?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      comparisonPeriodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                    }
                  )>,
                }>,
              ytdDetails?: Maybe<{
                  hover:
                    | (
                      { __typename: 'CategoryHover' }
                      & Pick<CategoryHover, 'balance'>
                      & {
                        entity: (
                          { __typename: 'EntityCategory' }
                          & Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >
                        ),
                        history: (
                          Pick<DimensionSummary, 'partialData'>
                          & { time: Array<{ summary: (
                              Pick<TransactionSummary, 'isPeriodBookClosed'>
                              & {
                                period: Pick<
                                    Period,
                                    | 'name'
                                    | 'interval'
                                    | 'startedAt'
                                    | 'endedAt'
                                  >,
                                total: (
                                  Pick<
                                    PeriodMonetaryValue,
                                    | 'transactionsCount'
                                    | 'deltaPrevious'
                                    | 'deltaYearAgo'
                                    | 'isFirstOccurrencePeriod'
                                  >
                                  & {
                                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                    moneyFlow?: Maybe<(
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    )>,
                                    current?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                    prior?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                  }
                                ),
                              }
                            ) }> }
                        ),
                        context?: Maybe<(
                          Pick<DimensionSummary, 'partialData'>
                          & { party: Array<{
                              partyObject: Pick<
                                  EntityParty,
                                  | 'id'
                                  | 'name'
                                  | 'iconUrl'
                                  | 'shortDescription'
                                  | 'roles'
                                  | 'designation'
                                >,
                              summary: (
                                Pick<TransactionSummary, 'isPeriodBookClosed'>
                                & {
                                  period: Pick<
                                      Period,
                                      | 'name'
                                      | 'interval'
                                      | 'startedAt'
                                      | 'endedAt'
                                    >,
                                  total: (
                                    Pick<
                                      PeriodMonetaryValue,
                                      | 'transactionsCount'
                                      | 'deltaPrevious'
                                      | 'deltaYearAgo'
                                      | 'isFirstOccurrencePeriod'
                                    >
                                    & {
                                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                      moneyFlow?: Maybe<(
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      )>,
                                      current?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                      prior?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                    }
                                  ),
                                }
                              ),
                            }> }
                        )>,
                        topTransactions?: Maybe<Array<(
                          Pick<
                            EntityTransaction,
                            | 'viewId'
                            | 'factId'
                            | 'timestamp'
                            | 'description'
                            | 'externalId'
                            | 'displayEntry'
                          >
                          & {
                            moneyFlow: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ),
                            party?: Maybe<Pick<
                                EntityParty,
                                | 'id'
                                | 'name'
                                | 'iconUrl'
                                | 'shortDescription'
                                | 'roles'
                                | 'designation'
                              >>,
                            displayCategory: Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >,
                            splitCategory?: Maybe<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>,
                          }
                        )>>,
                      }
                    )
                    | (
                      { __typename: 'PartyHover' }
                      & {
                        entity: (
                          { __typename: 'EntityParty' }
                          & Pick<
                            EntityParty,
                            | 'id'
                            | 'name'
                            | 'iconUrl'
                            | 'shortDescription'
                            | 'roles'
                            | 'designation'
                          >
                        ),
                        history: (
                          Pick<DimensionSummary, 'partialData'>
                          & { time: Array<{ summary: (
                              Pick<TransactionSummary, 'isPeriodBookClosed'>
                              & {
                                period: Pick<
                                    Period,
                                    | 'name'
                                    | 'interval'
                                    | 'startedAt'
                                    | 'endedAt'
                                  >,
                                total: (
                                  Pick<
                                    PeriodMonetaryValue,
                                    | 'transactionsCount'
                                    | 'deltaPrevious'
                                    | 'deltaYearAgo'
                                    | 'isFirstOccurrencePeriod'
                                  >
                                  & {
                                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                    moneyFlow?: Maybe<(
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    )>,
                                    current?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                    prior?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                  }
                                ),
                              }
                            ) }> }
                        ),
                        context?: Maybe<(
                          Pick<DimensionSummary, 'partialData'>
                          & { category: Array<{
                              categoryObject: Pick<
                                  EntityCategory,
                                  | 'id'
                                  | 'name'
                                  | 'displayKey'
                                  | 'chartOfAccountsDisplayNumber'
                                  | 'type'
                                  | 'subtype'
                                  | 'parentCategoryId'
                                  | 'productArea'
                                  | 'active'
                                >,
                              summary: (
                                Pick<TransactionSummary, 'isPeriodBookClosed'>
                                & {
                                  period: Pick<
                                      Period,
                                      | 'name'
                                      | 'interval'
                                      | 'startedAt'
                                      | 'endedAt'
                                    >,
                                  total: (
                                    Pick<
                                      PeriodMonetaryValue,
                                      | 'transactionsCount'
                                      | 'deltaPrevious'
                                      | 'deltaYearAgo'
                                      | 'isFirstOccurrencePeriod'
                                    >
                                    & {
                                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                      moneyFlow?: Maybe<(
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      )>,
                                      current?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                      prior?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                    }
                                  ),
                                }
                              ),
                            }> }
                        )>,
                        topTransactions?: Maybe<Array<(
                          Pick<
                            EntityTransaction,
                            | 'viewId'
                            | 'factId'
                            | 'timestamp'
                            | 'description'
                            | 'externalId'
                            | 'displayEntry'
                          >
                          & {
                            moneyFlow: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ),
                            party?: Maybe<Pick<
                                EntityParty,
                                | 'id'
                                | 'name'
                                | 'iconUrl'
                                | 'shortDescription'
                                | 'roles'
                                | 'designation'
                              >>,
                            displayCategory: Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >,
                            splitCategory?: Maybe<Pick<
                                EntityCategory,
                                | 'id'
                                | 'name'
                                | 'displayKey'
                                | 'chartOfAccountsDisplayNumber'
                                | 'type'
                                | 'subtype'
                                | 'parentCategoryId'
                                | 'productArea'
                                | 'active'
                              >>,
                          }
                        )>>,
                      }
                    )
                    | (
                      { __typename: 'SummaryLineItemHover' }
                      & Pick<SummaryLineItemHover, 'lineType'>
                      & { history: (
                        Pick<DimensionSummary, 'partialData'>
                        & { time: Array<{ summary: (
                            Pick<TransactionSummary, 'isPeriodBookClosed'>
                            & {
                              period: Pick<
                                  Period,
                                  | 'name'
                                  | 'interval'
                                  | 'startedAt'
                                  | 'endedAt'
                                >,
                              total: (
                                Pick<
                                  PeriodMonetaryValue,
                                  | 'transactionsCount'
                                  | 'deltaPrevious'
                                  | 'deltaYearAgo'
                                  | 'isFirstOccurrencePeriod'
                                >
                                & {
                                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                  moneyFlow?: Maybe<(
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  )>,
                                  current?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                  prior?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                }
                              ),
                            }
                          ) }> }
                      ) }
                    )
                  ,
                  insight?: Maybe<(
                    Pick<
                      Insight,
                      | 'score'
                      | 'globalScore'
                      | 'subjectType'
                      | 'subjectId'
                      | 'subjectDisplayKey'
                      | 'comparisonIntervalOffset'
                      | 'ruleType'
                      | 'sentence'
                      | 'subjectIconUrl'
                      | 'designation'
                      | 'type'
                      | 'productArea'
                    >
                    & {
                      periodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      absoluteDelta?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      comparisonPeriodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                    }
                  )>,
                }>,
              deltas?: Maybe<{
                  percentageTotal?: Maybe<(
                    Pick<StatementDeltaValue, 'percentageOfAmount'>
                    & { moneyFlow: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                  percentageIncome?: Maybe<(
                    Pick<StatementDeltaValue, 'percentageOfAmount'>
                    & { moneyFlow: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                  previousPeriod?: Maybe<(
                    Pick<StatementDeltaValue, 'percentageOfAmount'>
                    & { moneyFlow: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                  previousYear?: Maybe<(
                    Pick<StatementDeltaValue, 'percentageOfAmount'>
                    & { moneyFlow: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                }>,
            }
          )> }
        )
        | { __typename: 'TopEntities' }
        | { __typename: 'TopTransactions' }
      ,
    } };

export type ReadReportStatementLiveDataQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<DimensionSortMode>;
  timeHistory: Scalars['Boolean']['input'];
  departmentHistory: Scalars['Boolean']['input'];
  locationHistory: Scalars['Boolean']['input'];
}>;


export type ReadReportStatementLiveDataQuery = { liveComponentData:
    | { __typename: 'CashSummary' }
    | { __typename: 'Chart' }
    | { __typename: 'DimensionSummary' }
    | { __typename: 'EntitiesList' }
    | { __typename: 'EntityHovers' }
    | { __typename: 'InsightComponent' }
    | { __typename: 'LocationSummary' }
    | { __typename: 'Runway' }
    | { __typename: 'SourceAccountMetric' }
    | (
      { __typename: 'Statement' }
      & Pick<Statement, 'kind'>
      & { rows: Array<(
        Pick<StatementRow, 'rowId' | 'depth'>
        & {
          sectionTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
          sectionSummary?: Maybe<(
            Pick<StatementRowSummary, 'displayNumber' | 'label'>
            & { moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ) }
          )>,
          parentCategoryTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
          parentCategorySummary?: Maybe<(
            Pick<StatementRowSummary, 'displayNumber' | 'label'>
            & { moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ) }
          )>,
          leafCategorySummary?: Maybe<(
            Pick<StatementRowSummary, 'displayNumber' | 'label'>
            & { moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ) }
          )>,
          agingTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
          agingSummary?: Maybe<(
            Pick<AgingSummary, 'label'>
            & { dimensionSummary: (
              Pick<DimensionSummary, 'partialData'>
              & {
                aging: Array<{ summary: (
                    Pick<TransactionSummary, 'isPeriodBookClosed'>
                    & {
                      period: Pick<
                          Period,
                          | 'name'
                          | 'interval'
                          | 'startedAt'
                          | 'endedAt'
                        >,
                      total: (
                        Pick<
                          PeriodMonetaryValue,
                          | 'transactionsCount'
                          | 'deltaPrevious'
                          | 'deltaYearAgo'
                          | 'isFirstOccurrencePeriod'
                        >
                        & {
                          value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          moneyFlow?: Maybe<(
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          )>,
                          current?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                          prior?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                        }
                      ),
                    }
                  ) }>,
                summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ),
              }
            ) }
          )>,
          parentAgingTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
          parentAgingSummary?: Maybe<(
            Pick<AgingSummary, 'label'>
            & { dimensionSummary: (
              Pick<DimensionSummary, 'partialData'>
              & {
                aging: Array<{ summary: (
                    Pick<TransactionSummary, 'isPeriodBookClosed'>
                    & {
                      period: Pick<
                          Period,
                          | 'name'
                          | 'interval'
                          | 'startedAt'
                          | 'endedAt'
                        >,
                      total: (
                        Pick<
                          PeriodMonetaryValue,
                          | 'transactionsCount'
                          | 'deltaPrevious'
                          | 'deltaYearAgo'
                          | 'isFirstOccurrencePeriod'
                        >
                        & {
                          value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          moneyFlow?: Maybe<(
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          )>,
                          current?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                          prior?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                        }
                      ),
                    }
                  ) }>,
                summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ),
              }
            ) }
          )>,
          leafAgingSummary?: Maybe<(
            Pick<LeafAgingSummary, 'dueDate' | 'referenceNumber' | 'invoiceDate'>
            & {
              amounts: Array<(
                Pick<LeafAgingSummaryAmount, 'column'>
                & { moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
              link: Pick<LeafAgingSummaryLink, 'hasLink'>,
            }
          )>,
          details?: Maybe<{
              hover:
                | (
                  { __typename: 'CategoryHover' }
                  & Pick<CategoryHover, 'balance'>
                  & {
                    entity: (
                      { __typename: 'EntityCategory' }
                      & Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >
                    ),
                    history: (
                      Pick<DimensionSummary, 'partialData'>
                      & {
                        time: Array<{ summary: (
                            Pick<TransactionSummary, 'isPeriodBookClosed'>
                            & {
                              period: Pick<
                                  Period,
                                  | 'name'
                                  | 'interval'
                                  | 'startedAt'
                                  | 'endedAt'
                                >,
                              total: (
                                Pick<
                                  PeriodMonetaryValue,
                                  | 'transactionsCount'
                                  | 'deltaPrevious'
                                  | 'deltaYearAgo'
                                  | 'isFirstOccurrencePeriod'
                                >
                                & {
                                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                  moneyFlow?: Maybe<(
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  )>,
                                  current?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                  prior?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                }
                              ),
                            }
                          ) }>,
                        department: Array<(
                          Pick<DepartmentDimension, 'departmentId'>
                          & {
                            departmentObject: (
                              { __typename: 'EntityDepartment' }
                              & Pick<
                                EntityDepartment,
                                | 'id'
                                | 'name'
                                | 'parentId'
                                | 'active'
                              >
                            ),
                            by: { time: Array<{ summary: (
                                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                                  & {
                                    period: Pick<
                                        Period,
                                        | 'name'
                                        | 'interval'
                                        | 'startedAt'
                                        | 'endedAt'
                                      >,
                                    total: (
                                      Pick<
                                        PeriodMonetaryValue,
                                        | 'transactionsCount'
                                        | 'deltaPrevious'
                                        | 'deltaYearAgo'
                                        | 'isFirstOccurrencePeriod'
                                      >
                                      & {
                                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                        moneyFlow?: Maybe<(
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        )>,
                                        current?: Maybe<(
                                          Pick<SummaryTotal, 'count'>
                                          & { total: (
                                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                          ) }
                                        )>,
                                        prior?: Maybe<(
                                          Pick<SummaryTotal, 'count'>
                                          & { total: (
                                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                          ) }
                                        )>,
                                      }
                                    ),
                                  }
                                ) }> },
                          }
                        )>,
                        location: Array<(
                          Pick<LocationDimension, 'locationId'>
                          & {
                            locationObject: (
                              { __typename: 'EntityLocation' }
                              & Pick<
                                EntityLocation,
                                | 'id'
                                | 'name'
                                | 'parentId'
                                | 'active'
                              >
                            ),
                            by: { time: Array<{ summary: (
                                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                                  & {
                                    period: Pick<
                                        Period,
                                        | 'name'
                                        | 'interval'
                                        | 'startedAt'
                                        | 'endedAt'
                                      >,
                                    total: (
                                      Pick<
                                        PeriodMonetaryValue,
                                        | 'transactionsCount'
                                        | 'deltaPrevious'
                                        | 'deltaYearAgo'
                                        | 'isFirstOccurrencePeriod'
                                      >
                                      & {
                                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                        moneyFlow?: Maybe<(
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        )>,
                                        current?: Maybe<(
                                          Pick<SummaryTotal, 'count'>
                                          & { total: (
                                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                          ) }
                                        )>,
                                        prior?: Maybe<(
                                          Pick<SummaryTotal, 'count'>
                                          & { total: (
                                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                          ) }
                                        )>,
                                      }
                                    ),
                                  }
                                ) }> },
                          }
                        )>,
                      }
                    ),
                    context?: Maybe<(
                      Pick<DimensionSummary, 'partialData'>
                      & { party: Array<{
                          partyObject: Pick<
                              EntityParty,
                              | 'id'
                              | 'name'
                              | 'iconUrl'
                              | 'shortDescription'
                              | 'roles'
                              | 'designation'
                            >,
                          summary: (
                            Pick<TransactionSummary, 'isPeriodBookClosed'>
                            & {
                              period: Pick<
                                  Period,
                                  | 'name'
                                  | 'interval'
                                  | 'startedAt'
                                  | 'endedAt'
                                >,
                              total: (
                                Pick<
                                  PeriodMonetaryValue,
                                  | 'transactionsCount'
                                  | 'deltaPrevious'
                                  | 'deltaYearAgo'
                                  | 'isFirstOccurrencePeriod'
                                >
                                & {
                                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                  moneyFlow?: Maybe<(
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  )>,
                                  current?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                  prior?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                }
                              ),
                            }
                          ),
                        }> }
                    )>,
                    topTransactions?: Maybe<Array<(
                      Pick<
                        EntityTransaction,
                        | 'viewId'
                        | 'factId'
                        | 'timestamp'
                        | 'description'
                        | 'externalId'
                        | 'displayEntry'
                      >
                      & {
                        moneyFlow: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ),
                        party?: Maybe<Pick<
                            EntityParty,
                            | 'id'
                            | 'name'
                            | 'iconUrl'
                            | 'shortDescription'
                            | 'roles'
                            | 'designation'
                          >>,
                        displayCategory: Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >,
                        splitCategory?: Maybe<Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >>,
                      }
                    )>>,
                    missingClass?: Maybe<{ time: Array<{ summary: (
                          Pick<TransactionSummary, 'isPeriodBookClosed'>
                          & {
                            period: Pick<
                                Period,
                                | 'name'
                                | 'interval'
                                | 'startedAt'
                                | 'endedAt'
                              >,
                            total: (
                              Pick<
                                PeriodMonetaryValue,
                                | 'transactionsCount'
                                | 'deltaPrevious'
                                | 'deltaYearAgo'
                                | 'isFirstOccurrencePeriod'
                              >
                              & {
                                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                moneyFlow?: Maybe<(
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                )>,
                                current?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                                prior?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                              }
                            ),
                          }
                        ) }> }>,
                    otherClass?: Maybe<{ time: Array<{ summary: (
                          Pick<TransactionSummary, 'isPeriodBookClosed'>
                          & {
                            period: Pick<
                                Period,
                                | 'name'
                                | 'interval'
                                | 'startedAt'
                                | 'endedAt'
                              >,
                            total: (
                              Pick<
                                PeriodMonetaryValue,
                                | 'transactionsCount'
                                | 'deltaPrevious'
                                | 'deltaYearAgo'
                                | 'isFirstOccurrencePeriod'
                              >
                              & {
                                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                moneyFlow?: Maybe<(
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                )>,
                                current?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                                prior?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                              }
                            ),
                          }
                        ) }> }>,
                  }
                )
                | (
                  { __typename: 'PartyHover' }
                  & {
                    entity: (
                      { __typename: 'EntityParty' }
                      & Pick<
                        EntityParty,
                        | 'id'
                        | 'name'
                        | 'iconUrl'
                        | 'shortDescription'
                        | 'roles'
                        | 'designation'
                      >
                    ),
                    history: (
                      Pick<DimensionSummary, 'partialData'>
                      & { time: Array<{ summary: (
                          Pick<TransactionSummary, 'isPeriodBookClosed'>
                          & {
                            period: Pick<
                                Period,
                                | 'name'
                                | 'interval'
                                | 'startedAt'
                                | 'endedAt'
                              >,
                            total: (
                              Pick<
                                PeriodMonetaryValue,
                                | 'transactionsCount'
                                | 'deltaPrevious'
                                | 'deltaYearAgo'
                                | 'isFirstOccurrencePeriod'
                              >
                              & {
                                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                moneyFlow?: Maybe<(
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                )>,
                                current?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                                prior?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                              }
                            ),
                          }
                        ) }> }
                    ),
                    context?: Maybe<(
                      Pick<DimensionSummary, 'partialData'>
                      & { category: Array<{
                          categoryObject: Pick<
                              EntityCategory,
                              | 'id'
                              | 'name'
                              | 'displayKey'
                              | 'chartOfAccountsDisplayNumber'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'productArea'
                              | 'active'
                            >,
                          summary: (
                            Pick<TransactionSummary, 'isPeriodBookClosed'>
                            & {
                              period: Pick<
                                  Period,
                                  | 'name'
                                  | 'interval'
                                  | 'startedAt'
                                  | 'endedAt'
                                >,
                              total: (
                                Pick<
                                  PeriodMonetaryValue,
                                  | 'transactionsCount'
                                  | 'deltaPrevious'
                                  | 'deltaYearAgo'
                                  | 'isFirstOccurrencePeriod'
                                >
                                & {
                                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                  moneyFlow?: Maybe<(
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  )>,
                                  current?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                  prior?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                }
                              ),
                            }
                          ),
                        }> }
                    )>,
                    topTransactions?: Maybe<Array<(
                      Pick<
                        EntityTransaction,
                        | 'viewId'
                        | 'factId'
                        | 'timestamp'
                        | 'description'
                        | 'externalId'
                        | 'displayEntry'
                      >
                      & {
                        moneyFlow: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ),
                        party?: Maybe<Pick<
                            EntityParty,
                            | 'id'
                            | 'name'
                            | 'iconUrl'
                            | 'shortDescription'
                            | 'roles'
                            | 'designation'
                          >>,
                        displayCategory: Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >,
                        splitCategory?: Maybe<Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >>,
                      }
                    )>>,
                  }
                )
                | (
                  { __typename: 'SummaryLineItemHover' }
                  & Pick<SummaryLineItemHover, 'lineType'>
                  & {
                    history: (
                      Pick<DimensionSummary, 'partialData'>
                      & {
                        time: Array<{ summary: (
                            Pick<TransactionSummary, 'isPeriodBookClosed'>
                            & {
                              period: Pick<
                                  Period,
                                  | 'name'
                                  | 'interval'
                                  | 'startedAt'
                                  | 'endedAt'
                                >,
                              total: (
                                Pick<
                                  PeriodMonetaryValue,
                                  | 'transactionsCount'
                                  | 'deltaPrevious'
                                  | 'deltaYearAgo'
                                  | 'isFirstOccurrencePeriod'
                                >
                                & {
                                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                  moneyFlow?: Maybe<(
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  )>,
                                  current?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                  prior?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                }
                              ),
                            }
                          ) }>,
                        department: Array<(
                          Pick<DepartmentDimension, 'departmentId'>
                          & {
                            departmentObject: (
                              { __typename: 'EntityDepartment' }
                              & Pick<
                                EntityDepartment,
                                | 'id'
                                | 'name'
                                | 'parentId'
                                | 'active'
                              >
                            ),
                            by: { time: Array<{ summary: (
                                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                                  & {
                                    period: Pick<
                                        Period,
                                        | 'name'
                                        | 'interval'
                                        | 'startedAt'
                                        | 'endedAt'
                                      >,
                                    total: (
                                      Pick<
                                        PeriodMonetaryValue,
                                        | 'transactionsCount'
                                        | 'deltaPrevious'
                                        | 'deltaYearAgo'
                                        | 'isFirstOccurrencePeriod'
                                      >
                                      & {
                                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                        moneyFlow?: Maybe<(
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        )>,
                                        current?: Maybe<(
                                          Pick<SummaryTotal, 'count'>
                                          & { total: (
                                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                          ) }
                                        )>,
                                        prior?: Maybe<(
                                          Pick<SummaryTotal, 'count'>
                                          & { total: (
                                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                          ) }
                                        )>,
                                      }
                                    ),
                                  }
                                ) }> },
                          }
                        )>,
                        location: Array<(
                          Pick<LocationDimension, 'locationId'>
                          & {
                            locationObject: (
                              { __typename: 'EntityLocation' }
                              & Pick<
                                EntityLocation,
                                | 'id'
                                | 'name'
                                | 'parentId'
                                | 'active'
                              >
                            ),
                            by: { time: Array<{ summary: (
                                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                                  & {
                                    period: Pick<
                                        Period,
                                        | 'name'
                                        | 'interval'
                                        | 'startedAt'
                                        | 'endedAt'
                                      >,
                                    total: (
                                      Pick<
                                        PeriodMonetaryValue,
                                        | 'transactionsCount'
                                        | 'deltaPrevious'
                                        | 'deltaYearAgo'
                                        | 'isFirstOccurrencePeriod'
                                      >
                                      & {
                                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                        moneyFlow?: Maybe<(
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        )>,
                                        current?: Maybe<(
                                          Pick<SummaryTotal, 'count'>
                                          & { total: (
                                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                          ) }
                                        )>,
                                        prior?: Maybe<(
                                          Pick<SummaryTotal, 'count'>
                                          & { total: (
                                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                          ) }
                                        )>,
                                      }
                                    ),
                                  }
                                ) }> },
                          }
                        )>,
                      }
                    ),
                    missingClass?: Maybe<{ time: Array<{ summary: (
                          Pick<TransactionSummary, 'isPeriodBookClosed'>
                          & {
                            period: Pick<
                                Period,
                                | 'name'
                                | 'interval'
                                | 'startedAt'
                                | 'endedAt'
                              >,
                            total: (
                              Pick<
                                PeriodMonetaryValue,
                                | 'transactionsCount'
                                | 'deltaPrevious'
                                | 'deltaYearAgo'
                                | 'isFirstOccurrencePeriod'
                              >
                              & {
                                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                moneyFlow?: Maybe<(
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                )>,
                                current?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                                prior?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                              }
                            ),
                          }
                        ) }> }>,
                    otherClass?: Maybe<{ time: Array<{ summary: (
                          Pick<TransactionSummary, 'isPeriodBookClosed'>
                          & {
                            period: Pick<
                                Period,
                                | 'name'
                                | 'interval'
                                | 'startedAt'
                                | 'endedAt'
                              >,
                            total: (
                              Pick<
                                PeriodMonetaryValue,
                                | 'transactionsCount'
                                | 'deltaPrevious'
                                | 'deltaYearAgo'
                                | 'isFirstOccurrencePeriod'
                              >
                              & {
                                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                moneyFlow?: Maybe<(
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                )>,
                                current?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                                prior?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                              }
                            ),
                          }
                        ) }> }>,
                  }
                )
              ,
              insight?: Maybe<(
                Pick<
                  Insight,
                  | 'score'
                  | 'globalScore'
                  | 'subjectType'
                  | 'subjectId'
                  | 'subjectDisplayKey'
                  | 'comparisonIntervalOffset'
                  | 'ruleType'
                  | 'sentence'
                  | 'subjectIconUrl'
                  | 'designation'
                  | 'type'
                  | 'productArea'
                >
                & {
                  periodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  absoluteDelta?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  comparisonPeriodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
            }>,
          ytdDetails?: Maybe<{
              hover:
                | (
                  { __typename: 'CategoryHover' }
                  & Pick<CategoryHover, 'balance'>
                  & {
                    entity: (
                      { __typename: 'EntityCategory' }
                      & Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >
                    ),
                    history: (
                      Pick<DimensionSummary, 'partialData'>
                      & { time: Array<{ summary: (
                          Pick<TransactionSummary, 'isPeriodBookClosed'>
                          & {
                            period: Pick<
                                Period,
                                | 'name'
                                | 'interval'
                                | 'startedAt'
                                | 'endedAt'
                              >,
                            total: (
                              Pick<
                                PeriodMonetaryValue,
                                | 'transactionsCount'
                                | 'deltaPrevious'
                                | 'deltaYearAgo'
                                | 'isFirstOccurrencePeriod'
                              >
                              & {
                                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                moneyFlow?: Maybe<(
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                )>,
                                current?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                                prior?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                              }
                            ),
                          }
                        ) }> }
                    ),
                    context?: Maybe<(
                      Pick<DimensionSummary, 'partialData'>
                      & { party: Array<{
                          partyObject: Pick<
                              EntityParty,
                              | 'id'
                              | 'name'
                              | 'iconUrl'
                              | 'shortDescription'
                              | 'roles'
                              | 'designation'
                            >,
                          summary: (
                            Pick<TransactionSummary, 'isPeriodBookClosed'>
                            & {
                              period: Pick<
                                  Period,
                                  | 'name'
                                  | 'interval'
                                  | 'startedAt'
                                  | 'endedAt'
                                >,
                              total: (
                                Pick<
                                  PeriodMonetaryValue,
                                  | 'transactionsCount'
                                  | 'deltaPrevious'
                                  | 'deltaYearAgo'
                                  | 'isFirstOccurrencePeriod'
                                >
                                & {
                                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                  moneyFlow?: Maybe<(
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  )>,
                                  current?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                  prior?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                }
                              ),
                            }
                          ),
                        }> }
                    )>,
                    topTransactions?: Maybe<Array<(
                      Pick<
                        EntityTransaction,
                        | 'viewId'
                        | 'factId'
                        | 'timestamp'
                        | 'description'
                        | 'externalId'
                        | 'displayEntry'
                      >
                      & {
                        moneyFlow: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ),
                        party?: Maybe<Pick<
                            EntityParty,
                            | 'id'
                            | 'name'
                            | 'iconUrl'
                            | 'shortDescription'
                            | 'roles'
                            | 'designation'
                          >>,
                        displayCategory: Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >,
                        splitCategory?: Maybe<Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >>,
                      }
                    )>>,
                  }
                )
                | (
                  { __typename: 'PartyHover' }
                  & {
                    entity: (
                      { __typename: 'EntityParty' }
                      & Pick<
                        EntityParty,
                        | 'id'
                        | 'name'
                        | 'iconUrl'
                        | 'shortDescription'
                        | 'roles'
                        | 'designation'
                      >
                    ),
                    history: (
                      Pick<DimensionSummary, 'partialData'>
                      & { time: Array<{ summary: (
                          Pick<TransactionSummary, 'isPeriodBookClosed'>
                          & {
                            period: Pick<
                                Period,
                                | 'name'
                                | 'interval'
                                | 'startedAt'
                                | 'endedAt'
                              >,
                            total: (
                              Pick<
                                PeriodMonetaryValue,
                                | 'transactionsCount'
                                | 'deltaPrevious'
                                | 'deltaYearAgo'
                                | 'isFirstOccurrencePeriod'
                              >
                              & {
                                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                moneyFlow?: Maybe<(
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                )>,
                                current?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                                prior?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                              }
                            ),
                          }
                        ) }> }
                    ),
                    context?: Maybe<(
                      Pick<DimensionSummary, 'partialData'>
                      & { category: Array<{
                          categoryObject: Pick<
                              EntityCategory,
                              | 'id'
                              | 'name'
                              | 'displayKey'
                              | 'chartOfAccountsDisplayNumber'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'productArea'
                              | 'active'
                            >,
                          summary: (
                            Pick<TransactionSummary, 'isPeriodBookClosed'>
                            & {
                              period: Pick<
                                  Period,
                                  | 'name'
                                  | 'interval'
                                  | 'startedAt'
                                  | 'endedAt'
                                >,
                              total: (
                                Pick<
                                  PeriodMonetaryValue,
                                  | 'transactionsCount'
                                  | 'deltaPrevious'
                                  | 'deltaYearAgo'
                                  | 'isFirstOccurrencePeriod'
                                >
                                & {
                                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                  moneyFlow?: Maybe<(
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  )>,
                                  current?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                  prior?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                }
                              ),
                            }
                          ),
                        }> }
                    )>,
                    topTransactions?: Maybe<Array<(
                      Pick<
                        EntityTransaction,
                        | 'viewId'
                        | 'factId'
                        | 'timestamp'
                        | 'description'
                        | 'externalId'
                        | 'displayEntry'
                      >
                      & {
                        moneyFlow: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ),
                        party?: Maybe<Pick<
                            EntityParty,
                            | 'id'
                            | 'name'
                            | 'iconUrl'
                            | 'shortDescription'
                            | 'roles'
                            | 'designation'
                          >>,
                        displayCategory: Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >,
                        splitCategory?: Maybe<Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >>,
                      }
                    )>>,
                  }
                )
                | (
                  { __typename: 'SummaryLineItemHover' }
                  & Pick<SummaryLineItemHover, 'lineType'>
                  & { history: (
                    Pick<DimensionSummary, 'partialData'>
                    & { time: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }> }
                  ) }
                )
              ,
              insight?: Maybe<(
                Pick<
                  Insight,
                  | 'score'
                  | 'globalScore'
                  | 'subjectType'
                  | 'subjectId'
                  | 'subjectDisplayKey'
                  | 'comparisonIntervalOffset'
                  | 'ruleType'
                  | 'sentence'
                  | 'subjectIconUrl'
                  | 'designation'
                  | 'type'
                  | 'productArea'
                >
                & {
                  periodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  absoluteDelta?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  comparisonPeriodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                }
              )>,
            }>,
          deltas?: Maybe<{
              percentageTotal?: Maybe<(
                Pick<StatementDeltaValue, 'percentageOfAmount'>
                & { moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
              percentageIncome?: Maybe<(
                Pick<StatementDeltaValue, 'percentageOfAmount'>
                & { moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
              previousPeriod?: Maybe<(
                Pick<StatementDeltaValue, 'percentageOfAmount'>
                & { moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
              previousYear?: Maybe<(
                Pick<StatementDeltaValue, 'percentageOfAmount'>
                & { moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
            }>,
        }
      )> }
    )
    | { __typename: 'TopEntities' }
    | { __typename: 'TopTransactions' }
   };

export type ReadRunwayComponentDataQueryVariables = Exact<{
  layoutId: Scalars['String']['input'];
  dataId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadRunwayComponentDataQuery = { readComponentData: {
      viewId: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      data:
        | { __typename: 'CashSummary' }
        | { __typename: 'Chart' }
        | { __typename: 'DimensionSummary' }
        | { __typename: 'EntitiesList' }
        | { __typename: 'EntityHovers' }
        | { __typename: 'InsightComponent' }
        | { __typename: 'LocationSummary' }
        | (
          { __typename: 'Runway' }
          & Pick<Runway, 'cashOutDate' | 'previousCashOutDate'>
          & {
            current: (
              Pick<DimensionSummary, 'partialData'>
              & { time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }> }
            ),
            future: (
              Pick<DimensionSummary, 'partialData'>
              & { time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }> }
            ),
          }
        )
        | { __typename: 'SourceAccountMetric' }
        | { __typename: 'Statement' }
        | { __typename: 'TopEntities' }
        | { __typename: 'TopTransactions' }
      ,
    } };

export type ReadRunwayLiveDataQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
}>;


export type ReadRunwayLiveDataQuery = { liveComponentData:
    | { __typename: 'CashSummary' }
    | { __typename: 'Chart' }
    | { __typename: 'DimensionSummary' }
    | { __typename: 'EntitiesList' }
    | { __typename: 'EntityHovers' }
    | { __typename: 'InsightComponent' }
    | { __typename: 'LocationSummary' }
    | (
      { __typename: 'Runway' }
      & Pick<Runway, 'cashOutDate' | 'previousCashOutDate'>
      & {
        current: (
          Pick<DimensionSummary, 'partialData'>
          & { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> }
        ),
        future: (
          Pick<DimensionSummary, 'partialData'>
          & { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> }
        ),
      }
    )
    | { __typename: 'SourceAccountMetric' }
    | { __typename: 'Statement' }
    | { __typename: 'TopEntities' }
    | { __typename: 'TopTransactions' }
   };

export type ReadSourceAccountMetricComponentDataQueryVariables = Exact<{
  layoutId: Scalars['String']['input'];
  dataId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadSourceAccountMetricComponentDataQuery = { readComponentData: {
      viewId: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      data:
        | { __typename: 'CashSummary' }
        | { __typename: 'Chart' }
        | { __typename: 'DimensionSummary' }
        | { __typename: 'EntitiesList' }
        | { __typename: 'EntityHovers' }
        | { __typename: 'InsightComponent' }
        | { __typename: 'LocationSummary' }
        | { __typename: 'Runway' }
        | (
          { __typename: 'SourceAccountMetric' }
          & { metrics: Array<(
            Pick<SourceAccountMetricSeriesData, 'label' | 'iconObjectName'>
            & { series: {
                identifier: Pick<SourceAccountMetricIdentifier, 'dataSourceId' | 'sourceAccountId' | 'key'>,
                points: Array<Pick<SourceAccountMetricPoint, 'time' | 'value'>>,
              } }
          )> }
        )
        | { __typename: 'Statement' }
        | { __typename: 'TopEntities' }
        | { __typename: 'TopTransactions' }
      ,
    } };

export type ReadSourceAccountMetricLiveDataQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
}>;


export type ReadSourceAccountMetricLiveDataQuery = { liveComponentData:
    | { __typename: 'CashSummary' }
    | { __typename: 'Chart' }
    | { __typename: 'DimensionSummary' }
    | { __typename: 'EntitiesList' }
    | { __typename: 'EntityHovers' }
    | { __typename: 'InsightComponent' }
    | { __typename: 'LocationSummary' }
    | { __typename: 'Runway' }
    | (
      { __typename: 'SourceAccountMetric' }
      & { metrics: Array<(
        Pick<SourceAccountMetricSeriesData, 'label' | 'iconObjectName'>
        & { series: {
            identifier: Pick<SourceAccountMetricIdentifier, 'dataSourceId' | 'sourceAccountId' | 'key'>,
            points: Array<Pick<SourceAccountMetricPoint, 'time' | 'value'>>,
          } }
      )> }
    )
    | { __typename: 'Statement' }
    | { __typename: 'TopEntities' }
    | { __typename: 'TopTransactions' }
   };

export type ReadSummaryLineItemByTimeCategoryLiveDataQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
}>;


export type ReadSummaryLineItemByTimeCategoryLiveDataQuery = {
    total:
      | { __typename: 'CashSummary' }
      | { __typename: 'Chart' }
      | (
        { __typename: 'DimensionSummary' }
        & Pick<DimensionSummary, 'partialData'>
        & { time: Array<{ summary: (
            Pick<TransactionSummary, 'isPeriodBookClosed'>
            & {
              period: Pick<
                  Period,
                  | 'name'
                  | 'interval'
                  | 'startedAt'
                  | 'endedAt'
                >,
              total: (
                Pick<
                  PeriodMonetaryValue,
                  | 'transactionsCount'
                  | 'deltaPrevious'
                  | 'deltaYearAgo'
                  | 'isFirstOccurrencePeriod'
                >
                & {
                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  moneyFlow?: Maybe<(
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  )>,
                  current?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                  prior?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                }
              ),
            }
          ) }> }
      )
      | { __typename: 'EntitiesList' }
      | { __typename: 'EntityHovers' }
      | { __typename: 'InsightComponent' }
      | { __typename: 'LocationSummary' }
      | { __typename: 'Runway' }
      | { __typename: 'SourceAccountMetric' }
      | { __typename: 'Statement' }
      | { __typename: 'TopEntities' }
      | { __typename: 'TopTransactions' }
    ,
    breakdown:
      | { __typename: 'CashSummary' }
      | { __typename: 'Chart' }
      | (
        { __typename: 'DimensionSummary' }
        & Pick<DimensionSummary, 'partialData'>
        & { time: Array<{ by: { category: Array<{
                categoryObject: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ),
              }> } }> }
      )
      | { __typename: 'EntitiesList' }
      | { __typename: 'EntityHovers' }
      | { __typename: 'InsightComponent' }
      | { __typename: 'LocationSummary' }
      | { __typename: 'Runway' }
      | { __typename: 'SourceAccountMetric' }
      | { __typename: 'Statement' }
      | { __typename: 'TopEntities' }
      | { __typename: 'TopTransactions' }
    ,
  };

export type ReadSummaryLineItemByTimeComponentDataQueryVariables = Exact<{
  layoutId: Scalars['String']['input'];
  dataId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadSummaryLineItemByTimeComponentDataQuery = { readComponentData: {
      viewId: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      data:
        | { __typename: 'CashSummary' }
        | { __typename: 'Chart' }
        | (
          { __typename: 'DimensionSummary' }
          & Pick<DimensionSummary, 'partialData'>
          & { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> }
        )
        | { __typename: 'EntitiesList' }
        | { __typename: 'EntityHovers' }
        | { __typename: 'InsightComponent' }
        | { __typename: 'LocationSummary' }
        | { __typename: 'Runway' }
        | { __typename: 'SourceAccountMetric' }
        | { __typename: 'Statement' }
        | { __typename: 'TopEntities' }
        | { __typename: 'TopTransactions' }
      ,
    } };

export type ReadSummaryLineItemByTimeLiveDataQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
}>;


export type ReadSummaryLineItemByTimeLiveDataQuery = { liveComponentData:
    | { __typename: 'CashSummary' }
    | { __typename: 'Chart' }
    | (
      { __typename: 'DimensionSummary' }
      & Pick<DimensionSummary, 'partialData'>
      & { time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> }
    )
    | { __typename: 'EntitiesList' }
    | { __typename: 'EntityHovers' }
    | { __typename: 'InsightComponent' }
    | { __typename: 'LocationSummary' }
    | { __typename: 'Runway' }
    | { __typename: 'SourceAccountMetric' }
    | { __typename: 'Statement' }
    | { __typename: 'TopEntities' }
    | { __typename: 'TopTransactions' }
   };

export type ReadTextComponentDataQueryVariables = Exact<{
  layoutId: Scalars['String']['input'];
  dataId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<DimensionSortMode>;
}>;


export type ReadTextComponentDataQuery = { readComponentData: {
      viewId: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      data:
        | { __typename: 'CashSummary' }
        | { __typename: 'Chart' }
        | { __typename: 'DimensionSummary' }
        | { __typename: 'EntitiesList' }
        | (
          { __typename: 'EntityHovers' }
          & { hovers: Array<
            | (
              { __typename: 'CategoryHover' }
              & Pick<CategoryHover, 'balance'>
              & {
                entity: (
                  { __typename: 'EntityCategory' }
                  & Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >
                ),
                history: (
                  Pick<DimensionSummary, 'partialData'>
                  & { time: Array<{ summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ) }> }
                ),
                context?: Maybe<(
                  Pick<DimensionSummary, 'partialData'>
                  & { party: Array<{
                      partyObject: Pick<
                          EntityParty,
                          | 'id'
                          | 'name'
                          | 'iconUrl'
                          | 'shortDescription'
                          | 'roles'
                          | 'designation'
                        >,
                      summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ),
                    }> }
                )>,
                topTransactions?: Maybe<Array<(
                  Pick<
                    EntityTransaction,
                    | 'viewId'
                    | 'factId'
                    | 'timestamp'
                    | 'description'
                    | 'externalId'
                    | 'displayEntry'
                  >
                  & {
                    moneyFlow: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ),
                    party?: Maybe<Pick<
                        EntityParty,
                        | 'id'
                        | 'name'
                        | 'iconUrl'
                        | 'shortDescription'
                        | 'roles'
                        | 'designation'
                      >>,
                    displayCategory: Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >,
                    splitCategory?: Maybe<Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >>,
                  }
                )>>,
              }
            )
            | (
              { __typename: 'PartyHover' }
              & {
                entity: (
                  { __typename: 'EntityParty' }
                  & Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >
                ),
                history: (
                  Pick<DimensionSummary, 'partialData'>
                  & { time: Array<{ summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ) }> }
                ),
                context?: Maybe<(
                  Pick<DimensionSummary, 'partialData'>
                  & { category: Array<{
                      categoryObject: Pick<
                          EntityCategory,
                          | 'id'
                          | 'name'
                          | 'displayKey'
                          | 'chartOfAccountsDisplayNumber'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'productArea'
                          | 'active'
                        >,
                      summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ),
                    }> }
                )>,
                topTransactions?: Maybe<Array<(
                  Pick<
                    EntityTransaction,
                    | 'viewId'
                    | 'factId'
                    | 'timestamp'
                    | 'description'
                    | 'externalId'
                    | 'displayEntry'
                  >
                  & {
                    moneyFlow: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ),
                    party?: Maybe<Pick<
                        EntityParty,
                        | 'id'
                        | 'name'
                        | 'iconUrl'
                        | 'shortDescription'
                        | 'roles'
                        | 'designation'
                      >>,
                    displayCategory: Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >,
                    splitCategory?: Maybe<Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >>,
                  }
                )>>,
              }
            )
            | (
              { __typename: 'SummaryLineItemHover' }
              & Pick<SummaryLineItemHover, 'lineType'>
              & { history: (
                Pick<DimensionSummary, 'partialData'>
                & { time: Array<{ summary: (
                    Pick<TransactionSummary, 'isPeriodBookClosed'>
                    & {
                      period: Pick<
                          Period,
                          | 'name'
                          | 'interval'
                          | 'startedAt'
                          | 'endedAt'
                        >,
                      total: (
                        Pick<
                          PeriodMonetaryValue,
                          | 'transactionsCount'
                          | 'deltaPrevious'
                          | 'deltaYearAgo'
                          | 'isFirstOccurrencePeriod'
                        >
                        & {
                          value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          moneyFlow?: Maybe<(
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          )>,
                          current?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                          prior?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                        }
                      ),
                    }
                  ) }> }
              ) }
            )
          > }
        )
        | { __typename: 'InsightComponent' }
        | { __typename: 'LocationSummary' }
        | { __typename: 'Runway' }
        | { __typename: 'SourceAccountMetric' }
        | { __typename: 'Statement' }
        | { __typename: 'TopEntities' }
        | { __typename: 'TopTransactions' }
      ,
    } };

export type ReadTopCategoriesComponentDataQueryVariables = Exact<{
  layoutId: Scalars['String']['input'];
  dataId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<DimensionSortMode>;
}>;


export type ReadTopCategoriesComponentDataQuery = { readComponentData: {
      viewId: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      data:
        | { __typename: 'CashSummary' }
        | { __typename: 'Chart' }
        | { __typename: 'DimensionSummary' }
        | { __typename: 'EntitiesList' }
        | { __typename: 'EntityHovers' }
        | { __typename: 'InsightComponent' }
        | { __typename: 'LocationSummary' }
        | { __typename: 'Runway' }
        | { __typename: 'SourceAccountMetric' }
        | { __typename: 'Statement' }
        | (
          { __typename: 'TopEntities' }
          & { entities: (
            Pick<DimensionSummary, 'partialData'>
            & { category: Array<{
                category: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ),
              }> }
          ) }
        )
        | { __typename: 'TopTransactions' }
      ,
    } };

export type ReadTopCategoriesLiveDataQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<DimensionSortMode>;
}>;


export type ReadTopCategoriesLiveDataQuery = { liveComponentData:
    | { __typename: 'CashSummary' }
    | { __typename: 'Chart' }
    | { __typename: 'DimensionSummary' }
    | { __typename: 'EntitiesList' }
    | { __typename: 'EntityHovers' }
    | { __typename: 'InsightComponent' }
    | { __typename: 'LocationSummary' }
    | { __typename: 'Runway' }
    | { __typename: 'SourceAccountMetric' }
    | { __typename: 'Statement' }
    | (
      { __typename: 'TopEntities' }
      & { entities: (
        Pick<DimensionSummary, 'partialData'>
        & { category: Array<{
            category: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ),
          }> }
      ) }
    )
    | { __typename: 'TopTransactions' }
   };

export type ReadTopPartiesComponentDataQueryVariables = Exact<{
  layoutId: Scalars['String']['input'];
  dataId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<DimensionSortMode>;
}>;


export type ReadTopPartiesComponentDataQuery = { readComponentData: {
      viewId: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      data:
        | { __typename: 'CashSummary' }
        | { __typename: 'Chart' }
        | { __typename: 'DimensionSummary' }
        | { __typename: 'EntitiesList' }
        | { __typename: 'EntityHovers' }
        | { __typename: 'InsightComponent' }
        | { __typename: 'LocationSummary' }
        | { __typename: 'Runway' }
        | { __typename: 'SourceAccountMetric' }
        | { __typename: 'Statement' }
        | (
          { __typename: 'TopEntities' }
          & { entities: (
            Pick<DimensionSummary, 'partialData'>
            & { party: Array<{
                party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >,
                summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ),
                by: { categories: Array<{ category: Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      > }> },
              }> }
          ) }
        )
        | { __typename: 'TopTransactions' }
      ,
    } };

export type ReadTopPartiesLiveDataQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<DimensionSortMode>;
}>;


export type ReadTopPartiesLiveDataQuery = { liveComponentData:
    | { __typename: 'CashSummary' }
    | { __typename: 'Chart' }
    | { __typename: 'DimensionSummary' }
    | { __typename: 'EntitiesList' }
    | { __typename: 'EntityHovers' }
    | { __typename: 'InsightComponent' }
    | { __typename: 'LocationSummary' }
    | { __typename: 'Runway' }
    | { __typename: 'SourceAccountMetric' }
    | { __typename: 'Statement' }
    | (
      { __typename: 'TopEntities' }
      & { entities: (
        Pick<DimensionSummary, 'partialData'>
        & { party: Array<{
            party: Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >,
            summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ),
            by: { categories: Array<{ category: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  > }> },
          }> }
      ) }
    )
    | { __typename: 'TopTransactions' }
   };

export type ReadTopTransactionsComponentDataQueryVariables = Exact<{
  layoutId: Scalars['String']['input'];
  dataId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadTopTransactionsComponentDataQuery = { readComponentData: {
      viewId: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      data:
        | { __typename: 'CashSummary' }
        | { __typename: 'Chart' }
        | { __typename: 'DimensionSummary' }
        | { __typename: 'EntitiesList' }
        | { __typename: 'EntityHovers' }
        | { __typename: 'InsightComponent' }
        | { __typename: 'LocationSummary' }
        | { __typename: 'Runway' }
        | { __typename: 'SourceAccountMetric' }
        | { __typename: 'Statement' }
        | { __typename: 'TopEntities' }
        | (
          { __typename: 'TopTransactions' }
          & Pick<TopTransactions, 'partialData'>
          & { transactions: Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )> }
        )
      ,
    } };

export type ReadTopTransactionsLiveDataQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
  config: LayoutComponentConfigInput;
}>;


export type ReadTopTransactionsLiveDataQuery = { liveComponentData:
    | { __typename: 'CashSummary' }
    | { __typename: 'Chart' }
    | { __typename: 'DimensionSummary' }
    | { __typename: 'EntitiesList' }
    | { __typename: 'EntityHovers' }
    | { __typename: 'InsightComponent' }
    | { __typename: 'LocationSummary' }
    | { __typename: 'Runway' }
    | { __typename: 'SourceAccountMetric' }
    | { __typename: 'Statement' }
    | { __typename: 'TopEntities' }
    | (
      { __typename: 'TopTransactions' }
      & Pick<TopTransactions, 'partialData'>
      & { transactions: Array<(
        Pick<
          EntityTransaction,
          | 'viewId'
          | 'factId'
          | 'timestamp'
          | 'description'
          | 'externalId'
          | 'displayEntry'
        >
        & {
          moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          party?: Maybe<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>,
          displayCategory: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          splitCategory?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
        }
      )> }
    )
   };

export type FactIdForLedgerTransactionIdQueryVariables = Exact<{
  ledgerTransactionId: Scalars['String']['input'];
  viewKey: ViewKey;
}>;


export type FactIdForLedgerTransactionIdQuery = Pick<Query, 'factIdForLedgerTransactionId'>;

export type ListLedgerTransactionsQueryVariables = Exact<{
  ledgerTransactionIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  viewKey: ViewKey;
}>;


export type ListLedgerTransactionsQuery = { listLedgerTransactions: Array<(
    Pick<
      EntityLedgerTransaction,
      | 'id'
      | 'timestamp'
      | 'factIds'
      | 'name'
      | 'referenceNumber'
    >
    & {
      totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      parties: Array<Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        >>,
    }
  )> };

export type AiBookkeeperLegalEntityFieldsFragment = {
    legalEntity: (
      Pick<
        LegalEntity,
        | 'id'
        | 'slug'
        | 'name'
        | 'websiteUrl'
        | 'industry'
        | 'timezone'
        | 'fiscalYearStartMonth'
        | 'fiscalYearNumberOffset'
        | 'status'
        | 'organizationId'
        | 'sensitive'
        | 'phoneNumber'
        | 'iconUrl'
      >
      & {
        address: Pick<
            Address,
            | 'street'
            | 'streetAdditional'
            | 'city'
            | 'region'
            | 'postalCode'
            | 'countryCode'
            | 'lat'
            | 'long'
          >,
        incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
      }
    ),
    userInfo: Pick<UserInfo, 'givenName' | 'familyName' | 'emailAddress'>,
    quotePackage: (
      Pick<QuotePackage, 'id' | 'contractDocumentId' | 'status'>
      & {
        recipient?: Maybe<Pick<
            Contact,
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>,
        companyDetails: (
          Pick<
            CompanyDetails,
            | 'categories'
            | 'companyName'
            | 'websiteURL'
            | 'companySize'
            | 'incorporationState'
            | 'entityType'
            | 'subsidiaryCount'
            | 'foreignSubsidiaryCount'
            | 'incorporationYear'
            | 'lastTaxFiling'
          >
          & { address?: Maybe<Pick<
              Address,
              | 'street'
              | 'streetAdditional'
              | 'city'
              | 'region'
              | 'postalCode'
              | 'countryCode'
              | 'lat'
              | 'long'
            >> }
        ),
        financials?: Maybe<Array<(
          Pick<CompanyFinancials, 'product'>
          & { values: Array<Pick<CompanyFinancialValue, 'name' | 'institutionId'>> }
        )>>,
      }
    ),
  };

export type ViewMetadataFieldsFragment = Pick<
    ViewMetadata,
    | 'firstTransactionTimestamp'
    | 'latestTransactionTimestamp'
    | 'legalEntityId'
    | 'viewType'
    | 'viewVersion'
  >;

export type ActivateLegalEntityMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ActivateLegalEntityMutation = Pick<Mutation, 'activateLegalEntity'>;

export type RequestAccessMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type RequestAccessMutation = Pick<Mutation, 'requestAccess'>;

export type UpdateAiBookkeeperCutoverDateMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  cutoverDate: Scalars['DateTime']['input'];
}>;


export type UpdateAiBookkeeperCutoverDateMutation = Pick<Mutation, 'updateAIBookkeeperCutoverDate'>;

export type UpdateLegalEntityMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAdditional?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  long?: InputMaybe<Scalars['Float']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  incorporatedOn?: InputMaybe<DateInput>;
  fiscalYearStartMonth?: InputMaybe<Scalars['Int']['input']>;
  fiscalYearNumberOffset?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateLegalEntityMutation = Pick<Mutation, 'updateLegalEntity'>;

export type UploadLegalEntityIconMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  iconBase64: Scalars['String']['input'];
}>;


export type UploadLegalEntityIconMutation = Pick<Mutation, 'uploadLegalEntityIcon'>;

export type ReadLegalEntityQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReadLegalEntityQuery = { readLegalEntity: (
    Pick<
      LegalEntity,
      | 'id'
      | 'slug'
      | 'name'
      | 'websiteUrl'
      | 'industry'
      | 'timezone'
      | 'fiscalYearStartMonth'
      | 'fiscalYearNumberOffset'
      | 'status'
      | 'organizationId'
      | 'sensitive'
      | 'phoneNumber'
      | 'iconUrl'
    >
    & {
      address: Pick<
          Address,
          | 'street'
          | 'streetAdditional'
          | 'city'
          | 'region'
          | 'postalCode'
          | 'countryCode'
          | 'lat'
          | 'long'
        >,
      incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
    }
  ) };

export type ReadLegalEntityPreferencesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadLegalEntityPreferencesQuery = { readLegalEntityPreferences: Pick<
      LegalEntityPreferences,
      | 'legalEntityId'
      | 'isCogsInExpenses'
      | 'lineClassDisplayName'
      | 'lineClassPluralDisplayName'
      | 'bookkeeperAiCutoverAt'
    > };

export type ReadLegalEntityMetadataQueryVariables = Exact<{
  viewKey: ViewKey;
}>;


export type ReadLegalEntityMetadataQuery = { readLegalEntityMetadata: Pick<
      ViewMetadata,
      | 'firstTransactionTimestamp'
      | 'latestTransactionTimestamp'
      | 'legalEntityId'
      | 'viewType'
      | 'viewVersion'
    > };

export type LinkedObjectDetailsFieldsFragment = (
  Pick<LinkedObjectDetails, 'paid' | 'paidDate' | 'reversed'>
  & {
    sourceTransaction?: Maybe<(
      Pick<
        Transaction,
        | 'viewId'
        | 'factId'
        | 'ledgerTransactionId'
        | 'supersededFactIds'
        | 'timestamp'
        | 'recordType'
        | 'name'
        | 'description'
        | 'digitsTransactionType'
        | 'partySource'
        | 'displayEntry'
        | 'displayCategorySource'
        | 'displayCanonicalCategoryName'
        | 'displayUncategorizedReason'
        | 'displayProductArea'
        | 'ownerSource'
        | 'transactionClassificationType'
        | 'compileSource'
        | 'reconciliationStatus'
        | 'referenceNumber'
        | 'taxStatus'
        | 'matchedLedgerTransactionIds'
        | 'providerTypes'
        | 'isSupersedingLedgerTransaction'
        | 'supersededLedgerTransactionIds'
      >
      & {
        party?: Maybe<Pick<
            TransactionParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'iconObjectName'
            | 'designation'
            | 'roles'
          >>,
        facilitatorParty?: Maybe<Pick<
            TransactionParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'iconObjectName'
            | 'designation'
            | 'roles'
          >>,
        product?: Maybe<Pick<
            Product,
            | 'id'
            | 'dataSourceId'
            | 'name'
            | 'providerType'
            | 'active'
            | 'institutionId'
            | 'institutionName'
          >>,
        department?: Maybe<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        splitDepartment?: Maybe<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        location?: Maybe<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        splitLocation?: Maybe<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        providers: Array<Pick<Provider, 'name'>>,
        recurrence?: Maybe<Pick<
            TransactionRecurrence,
            | 'recurrenceThreadId'
            | 'interval'
            | 'intervalMultiplier'
            | 'threadIndex'
            | 'totalThreadCount'
            | 'isHidden'
            | 'firstOccurredAt'
            | 'lastOccurredAt'
          >>,
        displayInstitution?: Maybe<Pick<
            TransactionParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'iconObjectName'
            | 'designation'
            | 'roles'
          >>,
        displayCategory: (
          Pick<
            Category,
            | 'id'
            | 'name'
            | 'description'
            | 'displayKey'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'displayNumber'
            | 'active'
            | 'categoryState'
            | 'productArea'
            | 'synthesized'
          >
          & { ancestors?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>> }
        ),
        displayCategoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
        splitCategory?: Maybe<(
          Pick<
            Category,
            | 'id'
            | 'name'
            | 'description'
            | 'displayKey'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'displayNumber'
            | 'active'
            | 'categoryState'
            | 'productArea'
            | 'synthesized'
          >
          & { ancestors?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>> }
        )>,
        splitCategoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
        splitInstitution?: Maybe<Pick<
            TransactionParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'iconObjectName'
            | 'designation'
            | 'roles'
          >>,
        creditCategoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
        debitCategoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
        moneyFlow: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        runningTotal?: Maybe<(
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        )>,
        owner?: Maybe<Pick<
            EntityEmployee,
            | 'id'
            | 'organizationId'
            | 'givenName'
            | 'familyName'
            | 'avatarUrl'
          >>,
        sources: Array<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )>,
        creditSources: Array<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )>,
        debitSources: Array<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )>,
        invoiceLineItem?: Maybe<{ value:
            | (
              Pick<
                TransactionDiscountLineItem,
                | 'name'
                | 'description'
                | 'variablePercentage'
                | 'appliesToTransactionFactId'
              >
              & {
                fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                discount?: Maybe<(
                  Pick<
                    TransactionInvoiceLineItemDiscount,
                    | 'discountId'
                    | 'name'
                    | 'description'
                    | 'variablePercentage'
                  >
                  & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                )>,
              }
            )
            | (
              Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
              & {
                unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                product?: Maybe<(
                  Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                  & {
                    unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                    category?: Maybe<(
                      Pick<
                        Category,
                        | 'id'
                        | 'name'
                        | 'description'
                        | 'displayKey'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'displayNumber'
                        | 'active'
                        | 'categoryState'
                        | 'productArea'
                        | 'synthesized'
                      >
                      & { ancestors?: Maybe<Array<Pick<
                          EntityCategory,
                          | 'id'
                          | 'name'
                          | 'displayKey'
                          | 'chartOfAccountsDisplayNumber'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'productArea'
                          | 'active'
                        >>> }
                    )>,
                    department?: Maybe<(
                      { __typename: 'EntityDepartment' }
                      & Pick<
                        EntityDepartment,
                        | 'id'
                        | 'name'
                        | 'parentId'
                        | 'active'
                      >
                    )>,
                    location?: Maybe<(
                      { __typename: 'EntityLocation' }
                      & Pick<
                        EntityLocation,
                        | 'id'
                        | 'name'
                        | 'parentId'
                        | 'active'
                      >
                    )>,
                  }
                )>,
              }
            )
           }>,
        schedule?: Maybe<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
            | 'cutoverDate'
          >
          & {
            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>,
        splitSchedule?: Maybe<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
            | 'cutoverDate'
          >
          & {
            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>,
      }
    )>,
    linkedTransactions: Array<Maybe<(
      Pick<
        Transaction,
        | 'viewId'
        | 'factId'
        | 'ledgerTransactionId'
        | 'supersededFactIds'
        | 'timestamp'
        | 'recordType'
        | 'name'
        | 'description'
        | 'digitsTransactionType'
        | 'partySource'
        | 'displayEntry'
        | 'displayCategorySource'
        | 'displayCanonicalCategoryName'
        | 'displayUncategorizedReason'
        | 'displayProductArea'
        | 'ownerSource'
        | 'transactionClassificationType'
        | 'compileSource'
        | 'reconciliationStatus'
        | 'referenceNumber'
        | 'taxStatus'
        | 'matchedLedgerTransactionIds'
        | 'providerTypes'
        | 'isSupersedingLedgerTransaction'
        | 'supersededLedgerTransactionIds'
      >
      & {
        party?: Maybe<Pick<
            TransactionParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'iconObjectName'
            | 'designation'
            | 'roles'
          >>,
        facilitatorParty?: Maybe<Pick<
            TransactionParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'iconObjectName'
            | 'designation'
            | 'roles'
          >>,
        product?: Maybe<Pick<
            Product,
            | 'id'
            | 'dataSourceId'
            | 'name'
            | 'providerType'
            | 'active'
            | 'institutionId'
            | 'institutionName'
          >>,
        department?: Maybe<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        splitDepartment?: Maybe<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        location?: Maybe<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        splitLocation?: Maybe<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        providers: Array<Pick<Provider, 'name'>>,
        recurrence?: Maybe<Pick<
            TransactionRecurrence,
            | 'recurrenceThreadId'
            | 'interval'
            | 'intervalMultiplier'
            | 'threadIndex'
            | 'totalThreadCount'
            | 'isHidden'
            | 'firstOccurredAt'
            | 'lastOccurredAt'
          >>,
        displayInstitution?: Maybe<Pick<
            TransactionParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'iconObjectName'
            | 'designation'
            | 'roles'
          >>,
        displayCategory: (
          Pick<
            Category,
            | 'id'
            | 'name'
            | 'description'
            | 'displayKey'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'displayNumber'
            | 'active'
            | 'categoryState'
            | 'productArea'
            | 'synthesized'
          >
          & { ancestors?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>> }
        ),
        displayCategoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
        splitCategory?: Maybe<(
          Pick<
            Category,
            | 'id'
            | 'name'
            | 'description'
            | 'displayKey'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'displayNumber'
            | 'active'
            | 'categoryState'
            | 'productArea'
            | 'synthesized'
          >
          & { ancestors?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>> }
        )>,
        splitCategoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
        splitInstitution?: Maybe<Pick<
            TransactionParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'iconObjectName'
            | 'designation'
            | 'roles'
          >>,
        creditCategoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
        debitCategoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
        moneyFlow: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        runningTotal?: Maybe<(
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        )>,
        owner?: Maybe<Pick<
            EntityEmployee,
            | 'id'
            | 'organizationId'
            | 'givenName'
            | 'familyName'
            | 'avatarUrl'
          >>,
        sources: Array<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )>,
        creditSources: Array<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )>,
        debitSources: Array<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )>,
        invoiceLineItem?: Maybe<{ value:
            | (
              Pick<
                TransactionDiscountLineItem,
                | 'name'
                | 'description'
                | 'variablePercentage'
                | 'appliesToTransactionFactId'
              >
              & {
                fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                discount?: Maybe<(
                  Pick<
                    TransactionInvoiceLineItemDiscount,
                    | 'discountId'
                    | 'name'
                    | 'description'
                    | 'variablePercentage'
                  >
                  & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                )>,
              }
            )
            | (
              Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
              & {
                unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                product?: Maybe<(
                  Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                  & {
                    unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                    category?: Maybe<(
                      Pick<
                        Category,
                        | 'id'
                        | 'name'
                        | 'description'
                        | 'displayKey'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'displayNumber'
                        | 'active'
                        | 'categoryState'
                        | 'productArea'
                        | 'synthesized'
                      >
                      & { ancestors?: Maybe<Array<Pick<
                          EntityCategory,
                          | 'id'
                          | 'name'
                          | 'displayKey'
                          | 'chartOfAccountsDisplayNumber'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'productArea'
                          | 'active'
                        >>> }
                    )>,
                    department?: Maybe<(
                      { __typename: 'EntityDepartment' }
                      & Pick<
                        EntityDepartment,
                        | 'id'
                        | 'name'
                        | 'parentId'
                        | 'active'
                      >
                    )>,
                    location?: Maybe<(
                      { __typename: 'EntityLocation' }
                      & Pick<
                        EntityLocation,
                        | 'id'
                        | 'name'
                        | 'parentId'
                        | 'active'
                      >
                    )>,
                  }
                )>,
              }
            )
           }>,
        schedule?: Maybe<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
            | 'cutoverDate'
          >
          & {
            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>,
        splitSchedule?: Maybe<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
            | 'cutoverDate'
          >
          & {
            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>,
      }
    )>>,
  }
);

export type ReadLinkedObjectDetailsQueryVariables = Exact<{
  viewKey: ViewKey;
  linkedObjectId: Scalars['String']['input'];
  linkedObjectType: LinkedObjectType;
}>;


export type ReadLinkedObjectDetailsQuery = { readLinkedObjectDetails: (
    Pick<LinkedObjectDetails, 'paid' | 'paidDate' | 'reversed'>
    & {
      sourceTransaction?: Maybe<(
        Pick<
          Transaction,
          | 'viewId'
          | 'factId'
          | 'ledgerTransactionId'
          | 'supersededFactIds'
          | 'timestamp'
          | 'recordType'
          | 'name'
          | 'description'
          | 'digitsTransactionType'
          | 'partySource'
          | 'displayEntry'
          | 'displayCategorySource'
          | 'displayCanonicalCategoryName'
          | 'displayUncategorizedReason'
          | 'displayProductArea'
          | 'ownerSource'
          | 'transactionClassificationType'
          | 'compileSource'
          | 'reconciliationStatus'
          | 'referenceNumber'
          | 'taxStatus'
          | 'matchedLedgerTransactionIds'
          | 'providerTypes'
          | 'isSupersedingLedgerTransaction'
          | 'supersededLedgerTransactionIds'
        >
        & {
          party?: Maybe<Pick<
              TransactionParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'iconObjectName'
              | 'designation'
              | 'roles'
            >>,
          facilitatorParty?: Maybe<Pick<
              TransactionParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'iconObjectName'
              | 'designation'
              | 'roles'
            >>,
          product?: Maybe<Pick<
              Product,
              | 'id'
              | 'dataSourceId'
              | 'name'
              | 'providerType'
              | 'active'
              | 'institutionId'
              | 'institutionName'
            >>,
          department?: Maybe<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          splitDepartment?: Maybe<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          location?: Maybe<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          splitLocation?: Maybe<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          providers: Array<Pick<Provider, 'name'>>,
          recurrence?: Maybe<Pick<
              TransactionRecurrence,
              | 'recurrenceThreadId'
              | 'interval'
              | 'intervalMultiplier'
              | 'threadIndex'
              | 'totalThreadCount'
              | 'isHidden'
              | 'firstOccurredAt'
              | 'lastOccurredAt'
            >>,
          displayInstitution?: Maybe<Pick<
              TransactionParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'iconObjectName'
              | 'designation'
              | 'roles'
            >>,
          displayCategory: (
            Pick<
              Category,
              | 'id'
              | 'name'
              | 'description'
              | 'displayKey'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'displayNumber'
              | 'active'
              | 'categoryState'
              | 'productArea'
              | 'synthesized'
            >
            & { ancestors?: Maybe<Array<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>> }
          ),
          displayCategoryClassificationProvenance?: Maybe<(
            Pick<
              ClassificationProvenance,
              | 'type'
              | 'changedAt'
              | 'confidenceLevel'
              | 'settingsName'
            >
            & { source?: Maybe<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )> }
          )>,
          splitCategory?: Maybe<(
            Pick<
              Category,
              | 'id'
              | 'name'
              | 'description'
              | 'displayKey'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'displayNumber'
              | 'active'
              | 'categoryState'
              | 'productArea'
              | 'synthesized'
            >
            & { ancestors?: Maybe<Array<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>> }
          )>,
          splitCategoryClassificationProvenance?: Maybe<(
            Pick<
              ClassificationProvenance,
              | 'type'
              | 'changedAt'
              | 'confidenceLevel'
              | 'settingsName'
            >
            & { source?: Maybe<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )> }
          )>,
          splitInstitution?: Maybe<Pick<
              TransactionParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'iconObjectName'
              | 'designation'
              | 'roles'
            >>,
          creditCategoryClassificationProvenance?: Maybe<(
            Pick<
              ClassificationProvenance,
              | 'type'
              | 'changedAt'
              | 'confidenceLevel'
              | 'settingsName'
            >
            & { source?: Maybe<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )> }
          )>,
          debitCategoryClassificationProvenance?: Maybe<(
            Pick<
              ClassificationProvenance,
              | 'type'
              | 'changedAt'
              | 'confidenceLevel'
              | 'settingsName'
            >
            & { source?: Maybe<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )> }
          )>,
          moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          runningTotal?: Maybe<(
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          )>,
          owner?: Maybe<Pick<
              EntityEmployee,
              | 'id'
              | 'organizationId'
              | 'givenName'
              | 'familyName'
              | 'avatarUrl'
            >>,
          sources: Array<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )>,
          creditSources: Array<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )>,
          debitSources: Array<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )>,
          invoiceLineItem?: Maybe<{ value:
              | (
                Pick<
                  TransactionDiscountLineItem,
                  | 'name'
                  | 'description'
                  | 'variablePercentage'
                  | 'appliesToTransactionFactId'
                >
                & {
                  fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  discount?: Maybe<(
                    Pick<
                      TransactionInvoiceLineItemDiscount,
                      | 'discountId'
                      | 'name'
                      | 'description'
                      | 'variablePercentage'
                    >
                    & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                  )>,
                }
              )
              | (
                Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                & {
                  unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  product?: Maybe<(
                    Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                    & {
                      unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      category?: Maybe<(
                        Pick<
                          Category,
                          | 'id'
                          | 'name'
                          | 'description'
                          | 'displayKey'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'displayNumber'
                          | 'active'
                          | 'categoryState'
                          | 'productArea'
                          | 'synthesized'
                        >
                        & { ancestors?: Maybe<Array<Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >>> }
                      )>,
                      department?: Maybe<(
                        { __typename: 'EntityDepartment' }
                        & Pick<
                          EntityDepartment,
                          | 'id'
                          | 'name'
                          | 'parentId'
                          | 'active'
                        >
                      )>,
                      location?: Maybe<(
                        { __typename: 'EntityLocation' }
                        & Pick<
                          EntityLocation,
                          | 'id'
                          | 'name'
                          | 'parentId'
                          | 'active'
                        >
                      )>,
                    }
                  )>,
                }
              )
             }>,
          schedule?: Maybe<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>,
          splitSchedule?: Maybe<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>,
        }
      )>,
      linkedTransactions: Array<Maybe<(
        Pick<
          Transaction,
          | 'viewId'
          | 'factId'
          | 'ledgerTransactionId'
          | 'supersededFactIds'
          | 'timestamp'
          | 'recordType'
          | 'name'
          | 'description'
          | 'digitsTransactionType'
          | 'partySource'
          | 'displayEntry'
          | 'displayCategorySource'
          | 'displayCanonicalCategoryName'
          | 'displayUncategorizedReason'
          | 'displayProductArea'
          | 'ownerSource'
          | 'transactionClassificationType'
          | 'compileSource'
          | 'reconciliationStatus'
          | 'referenceNumber'
          | 'taxStatus'
          | 'matchedLedgerTransactionIds'
          | 'providerTypes'
          | 'isSupersedingLedgerTransaction'
          | 'supersededLedgerTransactionIds'
        >
        & {
          party?: Maybe<Pick<
              TransactionParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'iconObjectName'
              | 'designation'
              | 'roles'
            >>,
          facilitatorParty?: Maybe<Pick<
              TransactionParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'iconObjectName'
              | 'designation'
              | 'roles'
            >>,
          product?: Maybe<Pick<
              Product,
              | 'id'
              | 'dataSourceId'
              | 'name'
              | 'providerType'
              | 'active'
              | 'institutionId'
              | 'institutionName'
            >>,
          department?: Maybe<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          splitDepartment?: Maybe<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          location?: Maybe<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          splitLocation?: Maybe<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          providers: Array<Pick<Provider, 'name'>>,
          recurrence?: Maybe<Pick<
              TransactionRecurrence,
              | 'recurrenceThreadId'
              | 'interval'
              | 'intervalMultiplier'
              | 'threadIndex'
              | 'totalThreadCount'
              | 'isHidden'
              | 'firstOccurredAt'
              | 'lastOccurredAt'
            >>,
          displayInstitution?: Maybe<Pick<
              TransactionParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'iconObjectName'
              | 'designation'
              | 'roles'
            >>,
          displayCategory: (
            Pick<
              Category,
              | 'id'
              | 'name'
              | 'description'
              | 'displayKey'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'displayNumber'
              | 'active'
              | 'categoryState'
              | 'productArea'
              | 'synthesized'
            >
            & { ancestors?: Maybe<Array<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>> }
          ),
          displayCategoryClassificationProvenance?: Maybe<(
            Pick<
              ClassificationProvenance,
              | 'type'
              | 'changedAt'
              | 'confidenceLevel'
              | 'settingsName'
            >
            & { source?: Maybe<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )> }
          )>,
          splitCategory?: Maybe<(
            Pick<
              Category,
              | 'id'
              | 'name'
              | 'description'
              | 'displayKey'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'displayNumber'
              | 'active'
              | 'categoryState'
              | 'productArea'
              | 'synthesized'
            >
            & { ancestors?: Maybe<Array<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>> }
          )>,
          splitCategoryClassificationProvenance?: Maybe<(
            Pick<
              ClassificationProvenance,
              | 'type'
              | 'changedAt'
              | 'confidenceLevel'
              | 'settingsName'
            >
            & { source?: Maybe<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )> }
          )>,
          splitInstitution?: Maybe<Pick<
              TransactionParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'iconObjectName'
              | 'designation'
              | 'roles'
            >>,
          creditCategoryClassificationProvenance?: Maybe<(
            Pick<
              ClassificationProvenance,
              | 'type'
              | 'changedAt'
              | 'confidenceLevel'
              | 'settingsName'
            >
            & { source?: Maybe<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )> }
          )>,
          debitCategoryClassificationProvenance?: Maybe<(
            Pick<
              ClassificationProvenance,
              | 'type'
              | 'changedAt'
              | 'confidenceLevel'
              | 'settingsName'
            >
            & { source?: Maybe<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )> }
          )>,
          moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          runningTotal?: Maybe<(
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          )>,
          owner?: Maybe<Pick<
              EntityEmployee,
              | 'id'
              | 'organizationId'
              | 'givenName'
              | 'familyName'
              | 'avatarUrl'
            >>,
          sources: Array<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )>,
          creditSources: Array<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )>,
          debitSources: Array<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )>,
          invoiceLineItem?: Maybe<{ value:
              | (
                Pick<
                  TransactionDiscountLineItem,
                  | 'name'
                  | 'description'
                  | 'variablePercentage'
                  | 'appliesToTransactionFactId'
                >
                & {
                  fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  discount?: Maybe<(
                    Pick<
                      TransactionInvoiceLineItemDiscount,
                      | 'discountId'
                      | 'name'
                      | 'description'
                      | 'variablePercentage'
                    >
                    & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                  )>,
                }
              )
              | (
                Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                & {
                  unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  product?: Maybe<(
                    Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                    & {
                      unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      category?: Maybe<(
                        Pick<
                          Category,
                          | 'id'
                          | 'name'
                          | 'description'
                          | 'displayKey'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'displayNumber'
                          | 'active'
                          | 'categoryState'
                          | 'productArea'
                          | 'synthesized'
                        >
                        & { ancestors?: Maybe<Array<Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >>> }
                      )>,
                      department?: Maybe<(
                        { __typename: 'EntityDepartment' }
                        & Pick<
                          EntityDepartment,
                          | 'id'
                          | 'name'
                          | 'parentId'
                          | 'active'
                        >
                      )>,
                      location?: Maybe<(
                        { __typename: 'EntityLocation' }
                        & Pick<
                          EntityLocation,
                          | 'id'
                          | 'name'
                          | 'parentId'
                          | 'active'
                        >
                      )>,
                    }
                  )>,
                }
              )
             }>,
          schedule?: Maybe<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>,
          splitSchedule?: Maybe<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>,
        }
      )>>,
    }
  ) };

export type BootstrapLocationMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type BootstrapLocationMutation = { bootstrapLocations: Pick<CreateLocationResponse, 'locationId'> };

export type CreateLocationMutationVariables = Exact<{
  viewKey: ViewKey;
  dimension: CreateLocationInput;
}>;


export type CreateLocationMutation = { createLocation: Pick<CreateLocationResponse, 'locationId'> };

export type MigrateLocationQuickBooksMutationVariables = Exact<{
  viewKey: ViewKey;
  departmentFactIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  lineClassFactIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type MigrateLocationQuickBooksMutation = Pick<Mutation, 'migrateLocationQuickBooks'>;

export type UpdateLocationMutationVariables = Exact<{
  viewKey: ViewKey;
  dimensionId: Scalars['String']['input'];
  dimension: UpdateLocationInput;
}>;


export type UpdateLocationMutation = { updateLocation: { entityId: UpdateLocationResponse['locationId'] } };

export type UpdateLocationStatusMutationVariables = Exact<{
  viewKey: ViewKey;
  dimensionId: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type UpdateLocationStatusMutation = Pick<Mutation, 'updateLocationStatus'>;

export type ListLocationsQueryVariables = Exact<{
  viewKey: ViewKey;
  status?: InputMaybe<LocationStatus>;
}>;


export type ListLocationsQuery = { listLocations: Array<(
    Pick<
      Location,
      | 'id'
      | 'name'
      | 'parentId'
      | 'active'
      | 'description'
      | 'displayKey'
    >
    & {
      ancestors: Array<(
        { __typename: 'EntityLocation' }
        & Pick<
          EntityLocation,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      dataSource?: Maybe<Pick<
          EntityDataSource,
          | 'id'
          | 'name'
          | 'url'
          | 'iconUrl'
        >>,
    }
  )> };

export type ReadLocationQueryVariables = Exact<{
  viewKey: ViewKey;
  locationId: Scalars['String']['input'];
}>;


export type ReadLocationQuery = { readLocation: (
    Pick<
      Location,
      | 'id'
      | 'name'
      | 'parentId'
      | 'active'
      | 'description'
      | 'displayKey'
    >
    & {
      ancestors: Array<(
        { __typename: 'EntityLocation' }
        & Pick<
          EntityLocation,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      dataSource?: Maybe<Pick<
          EntityDataSource,
          | 'id'
          | 'name'
          | 'url'
          | 'iconUrl'
        >>,
    }
  ) };

export type ListMetricsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  origin: IntervalOrigin;
  key: SourceAccountMetricKey;
}>;


export type ListMetricsQuery = { listMetrics: Array<Pick<SourceAccountMetricIdentifier, 'dataSourceId' | 'sourceAccountId' | 'key'>> };

export type WebNotificationFieldsFragment = Pick<
    WebNotification,
    | 'id'
    | 'legalEntityId'
    | 'eventType'
    | 'name'
    | 'displayKey'
    | 'targetAction'
    | 'assetLink'
    | 'status'
    | 'message'
    | 'createdAt'
  >;

export type UpdateNotificationStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  status: WebNotificationStatus;
}>;


export type UpdateNotificationStatusMutation = Pick<Mutation, 'updateNotificationStatus'>;

export type ListNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListNotificationsQuery = { listNotifications: Array<Pick<
      WebNotification,
      | 'id'
      | 'legalEntityId'
      | 'eventType'
      | 'name'
      | 'displayKey'
      | 'targetAction'
      | 'assetLink'
      | 'status'
      | 'message'
      | 'createdAt'
    >> };

export type NotificationCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type NotificationCreatedSubscription = { notificationCreated: Pick<
      WebNotification,
      | 'id'
      | 'legalEntityId'
      | 'eventType'
      | 'name'
      | 'displayKey'
      | 'targetAction'
      | 'assetLink'
      | 'status'
      | 'message'
      | 'createdAt'
    > };

export type ApproveOAuthAuthorizationMutationVariables = Exact<{
  clientId: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  codeChallenge: Scalars['String']['input'];
  codeChallengeMethod: Scalars['String']['input'];
  state: Scalars['String']['input'];
}>;


export type ApproveOAuthAuthorizationMutation = { approveOAuthAuthorization: Pick<OAuthAuthorizationApproval, 'redirectURL'> };

export type ReadOAuthClientQueryVariables = Exact<{
  clientId: Scalars['String']['input'];
}>;


export type ReadOAuthClientQuery = { readOAuthClient?: Maybe<Pick<OAuthClientInfo, 'clientId' | 'clientName' | 'redirectUris'>> };

export type HydrateEntitiesQueryVariables = Exact<{
  viewKey: ViewKey;
  identifiers: Array<HydrateIdentifier> | HydrateIdentifier;
  allowMissing?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HydrateEntitiesQuery = { hydrateEntities: (
    { __typename: 'ObjectEntities' }
    & {
      users?: Maybe<Array<Pick<
          EntityUser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >>>,
      transactions?: Maybe<Array<(
        Pick<
          EntityTransaction,
          | 'viewId'
          | 'factId'
          | 'timestamp'
          | 'description'
          | 'externalId'
          | 'displayEntry'
        >
        & {
          moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          party?: Maybe<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>,
          displayCategory: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          splitCategory?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
        }
      )>>,
      comments?: Maybe<Array<Pick<
          EntityComment,
          | 'id'
          | 'authorId'
          | 'text'
          | 'timestamp'
        >>>,
      reports?: Maybe<Array<(
        Pick<
          EntityReport,
          | 'id'
          | 'title'
          | 'authorId'
          | 'mimeType'
          | 'createdAt'
        >
        & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
      )>>,
      reportPackages?: Maybe<Array<(
        Pick<
          EntityReportPackage,
          | 'id'
          | 'title'
          | 'authorId'
          | 'interval'
          | 'periodStartedAt'
          | 'periodEndedAt'
          | 'createdAt'
          | 'updatedAt'
          | 'coverUrl'
        >
        & { documents: Array<Pick<
            SharedReportDocumentMetadata,
            | 'id'
            | 'documentObjectId'
            | 'documentObjectVersionId'
            | 'title'
            | 'mimeType'
          >> }
      )>>,
      parties?: Maybe<Array<Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        >>>,
      datasources?: Maybe<Array<Pick<
          EntityDataSource,
          | 'id'
          | 'name'
          | 'url'
          | 'iconUrl'
        >>>,
      categories?: Maybe<Array<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>>,
      threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
      legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
      workItems?: Maybe<Array<(
        Pick<
          EntityWorkItem,
          | 'id'
          | 'time'
          | 'workItemState'
          | 'workItemType'
          | 'reviewCreatedById'
          | 'reviewState'
          | 'ledgerType'
        >
        & { objectTransaction: (
          Pick<
            EntityTransaction,
            | 'viewId'
            | 'factId'
            | 'timestamp'
            | 'description'
            | 'externalId'
            | 'displayEntry'
          >
          & {
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            party?: Maybe<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
            displayCategory: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            splitCategory?: Maybe<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>,
          }
        ) }
      )>>,
      invoices?: Maybe<Array<(
        Pick<
          EntityInvoice,
          | 'id'
          | 'externalDisplayId'
          | 'createdAt'
          | 'dueAt'
        >
        & {
          amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
          customer: (
            Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
            & { party: Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              > }
          ),
        }
      )>>,
      bills?: Maybe<Array<(
        Pick<
          EntityBill,
          | 'id'
          | 'billStatus'
          | 'vendorName'
          | 'billDescription'
        >
        & {
          totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
          dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
          format: (
            Pick<Format, 'id' | 'formatClass'>
            & { segments: Array<Pick<
                Segment,
                | 'collectionId'
                | 'fileId'
                | 'sequence'
                | 'token'
              >> }
          ),
          approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
        }
      )>>,
      identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
      departments?: Maybe<Array<(
        { __typename: 'EntityDepartment' }
        & Pick<
          EntityDepartment,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>>,
      locations?: Maybe<Array<(
        { __typename: 'EntityLocation' }
        & Pick<
          EntityLocation,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>>,
      reconciliations?: Maybe<Array<(
        { __typename: 'EntityReconciliation' }
        & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
        & {
          startDate: Pick<Date, 'year' | 'month' | 'day'>,
          endDate: Pick<Date, 'year' | 'month' | 'day'>,
        }
      )>>,
      ledgerTransactions?: Maybe<Array<(
        Pick<
          EntityLedgerTransaction,
          | 'id'
          | 'timestamp'
          | 'factIds'
          | 'name'
          | 'referenceNumber'
        >
        & {
          totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
          parties: Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>,
        }
      )>>,
      schedules?: Maybe<Array<(
        { __typename: 'EntitySchedule' }
        & Pick<
          EntitySchedule,
          | 'id'
          | 'name'
          | 'scheduleNumber'
          | 'scheduleType'
          | 'scheduleTemplateId'
          | 'categoryId'
          | 'relatedCategoryId'
          | 'partyId'
          | 'startDate'
          | 'endDate'
          | 'cutoverDate'
        >
        & {
          amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        }
      )>>,
    }
  ) };

export type ObjectMappingHierarchyNodeFieldsFragment = Pick<
    ObjectMappingHierarchyNode,
    | 'factId'
    | 'name'
    | 'parentId'
    | 'active'
    | 'transactionCount'
    | 'mappedTo'
    | 'depth'
    | 'fullyQualifiedName'
  >;

export type UpdateObjectMappingsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  mappedTo: ObjectKind;
  lineClassIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  departmentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateObjectMappingsMutation = { updateObjectMappings: {
      lineClassHierarchy: Array<Pick<
          ObjectMappingHierarchyNode,
          | 'factId'
          | 'name'
          | 'parentId'
          | 'active'
          | 'transactionCount'
          | 'mappedTo'
          | 'depth'
          | 'fullyQualifiedName'
        >>,
      departmentHierarchy: Array<Pick<
          ObjectMappingHierarchyNode,
          | 'factId'
          | 'name'
          | 'parentId'
          | 'active'
          | 'transactionCount'
          | 'mappedTo'
          | 'depth'
          | 'fullyQualifiedName'
        >>,
    } };

export type ListDepartmentFactHierarchyQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListDepartmentFactHierarchyQuery = { listDepartmentFactHierarchy: Array<Pick<
      ObjectMappingHierarchyNode,
      | 'factId'
      | 'name'
      | 'parentId'
      | 'active'
      | 'transactionCount'
      | 'mappedTo'
      | 'depth'
      | 'fullyQualifiedName'
    >> };

export type ListLineClassFactHierarchyQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListLineClassFactHierarchyQuery = { listLineClassFactHierarchy: Array<Pick<
      ObjectMappingHierarchyNode,
      | 'factId'
      | 'name'
      | 'parentId'
      | 'active'
      | 'transactionCount'
      | 'mappedTo'
      | 'depth'
      | 'fullyQualifiedName'
    >> };

export type ConfirmOperatorResetMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ConfirmOperatorResetMutation = Pick<Mutation, 'confirmOperatorReset'>;

export type ConfirmOperatorTrialMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
}>;


export type ConfirmOperatorTrialMutation = Pick<Mutation, 'confirmOperatorTrial'>;

export type OnboardLegalEntityMutationVariables = Exact<{
  name: Scalars['String']['input'];
  contact: ContactInput;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  minimalCoa?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OnboardLegalEntityMutation = { onboardLegalEntity: {
      legalEntity: (
        Pick<
          LegalEntity,
          | 'id'
          | 'slug'
          | 'name'
          | 'websiteUrl'
          | 'industry'
          | 'timezone'
          | 'fiscalYearStartMonth'
          | 'fiscalYearNumberOffset'
          | 'status'
          | 'organizationId'
          | 'sensitive'
          | 'phoneNumber'
          | 'iconUrl'
        >
        & {
          address: Pick<
              Address,
              | 'street'
              | 'streetAdditional'
              | 'city'
              | 'region'
              | 'postalCode'
              | 'countryCode'
              | 'lat'
              | 'long'
            >,
          incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
        }
      ),
      userInfo: Pick<UserInfo, 'givenName' | 'familyName' | 'emailAddress'>,
      quotePackage: (
        Pick<QuotePackage, 'id' | 'contractDocumentId' | 'status'>
        & {
          recipient?: Maybe<Pick<
              Contact,
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>,
          companyDetails: (
            Pick<
              CompanyDetails,
              | 'categories'
              | 'companyName'
              | 'websiteURL'
              | 'companySize'
              | 'incorporationState'
              | 'entityType'
              | 'subsidiaryCount'
              | 'foreignSubsidiaryCount'
              | 'incorporationYear'
              | 'lastTaxFiling'
            >
            & { address?: Maybe<Pick<
                Address,
                | 'street'
                | 'streetAdditional'
                | 'city'
                | 'region'
                | 'postalCode'
                | 'countryCode'
                | 'lat'
                | 'long'
              >> }
          ),
          financials?: Maybe<Array<(
            Pick<CompanyFinancials, 'product'>
            & { values: Array<Pick<CompanyFinancialValue, 'name' | 'institutionId'>> }
          )>>,
        }
      ),
    } };

export type OnboardLegalEntityFromOAuthServiceMutationVariables = Exact<{
  code: Scalars['String']['input'];
  service: OAuthService;
}>;


export type OnboardLegalEntityFromOAuthServiceMutation = { onboardLegalEntityFromOAuthService: {
      legalEntity: (
        Pick<
          LegalEntity,
          | 'id'
          | 'slug'
          | 'name'
          | 'websiteUrl'
          | 'industry'
          | 'timezone'
          | 'fiscalYearStartMonth'
          | 'fiscalYearNumberOffset'
          | 'status'
          | 'organizationId'
          | 'sensitive'
          | 'phoneNumber'
          | 'iconUrl'
        >
        & {
          address: Pick<
              Address,
              | 'street'
              | 'streetAdditional'
              | 'city'
              | 'region'
              | 'postalCode'
              | 'countryCode'
              | 'lat'
              | 'long'
            >,
          incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
        }
      ),
      userInfo: Pick<UserInfo, 'givenName' | 'familyName' | 'emailAddress'>,
      quotePackage: (
        Pick<QuotePackage, 'id' | 'contractDocumentId' | 'status'>
        & {
          recipient?: Maybe<Pick<
              Contact,
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>,
          companyDetails: (
            Pick<
              CompanyDetails,
              | 'categories'
              | 'companyName'
              | 'websiteURL'
              | 'companySize'
              | 'incorporationState'
              | 'entityType'
              | 'subsidiaryCount'
              | 'foreignSubsidiaryCount'
              | 'incorporationYear'
              | 'lastTaxFiling'
            >
            & { address?: Maybe<Pick<
                Address,
                | 'street'
                | 'streetAdditional'
                | 'city'
                | 'region'
                | 'postalCode'
                | 'countryCode'
                | 'lat'
                | 'long'
              >> }
          ),
          financials?: Maybe<Array<(
            Pick<CompanyFinancials, 'product'>
            & { values: Array<Pick<CompanyFinancialValue, 'name' | 'institutionId'>> }
          )>>,
        }
      ),
    } };

export type CreateAffiliationFromOAuthServiceMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  service: OAuthService;
  proposalOrganizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAffiliationFromOAuthServiceMutation = { createAffiliationFromOAuthService: {
      legalEntity?: Maybe<(
        Pick<
          LegalEntity,
          | 'id'
          | 'slug'
          | 'name'
          | 'websiteUrl'
          | 'industry'
          | 'timezone'
          | 'fiscalYearStartMonth'
          | 'fiscalYearNumberOffset'
          | 'status'
          | 'organizationId'
          | 'sensitive'
          | 'phoneNumber'
          | 'iconUrl'
        >
        & {
          address: Pick<
              Address,
              | 'street'
              | 'streetAdditional'
              | 'city'
              | 'region'
              | 'postalCode'
              | 'countryCode'
              | 'lat'
              | 'long'
            >,
          incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
        }
      )>,
      quickBooksCompany?: Maybe<{ preferences?: Maybe<{ accountingInfo?: Maybe<{ bookCloseDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>> }> }> }>,
    } };

export type CreateFirmAffiliationFromOAuthServiceMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  service: OAuthService;
}>;


export type CreateFirmAffiliationFromOAuthServiceMutation = { createFirmAffiliationFromOAuthService: {
      legalEntity?: Maybe<(
        Pick<
          LegalEntity,
          | 'id'
          | 'slug'
          | 'name'
          | 'websiteUrl'
          | 'industry'
          | 'timezone'
          | 'fiscalYearStartMonth'
          | 'fiscalYearNumberOffset'
          | 'status'
          | 'organizationId'
          | 'sensitive'
          | 'phoneNumber'
          | 'iconUrl'
        >
        & {
          address: Pick<
              Address,
              | 'street'
              | 'streetAdditional'
              | 'city'
              | 'region'
              | 'postalCode'
              | 'countryCode'
              | 'lat'
              | 'long'
            >,
          incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
        }
      )>,
      quickBooksCompany?: Maybe<{ preferences?: Maybe<{ accountingInfo?: Maybe<{ bookCloseDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>> }> }> }>,
    } };

export type CreateOrganizationMutationVariables = Exact<{
  companyName: Scalars['String']['input'];
  kind: OrganizationKind;
  iconObjectName?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  numberOfAccountants?: InputMaybe<Scalars['String']['input']>;
  numberOfClients?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOrganizationMutation = { createOrganization: Pick<
      Organization,
      | 'id'
      | 'slug'
      | 'name'
      | 'iconUrl'
      | 'websiteUrl'
      | 'kind'
    > };

export type ProvisionLegalEntityMutationVariables = Exact<{
  name: Scalars['String']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  iconObjectName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  affiliatedOrganizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProvisionLegalEntityMutation = { provisionLegalEntity: (
    Pick<
      LegalEntity,
      | 'id'
      | 'slug'
      | 'name'
      | 'websiteUrl'
      | 'industry'
      | 'timezone'
      | 'fiscalYearStartMonth'
      | 'fiscalYearNumberOffset'
      | 'status'
      | 'organizationId'
      | 'sensitive'
      | 'phoneNumber'
      | 'iconUrl'
    >
    & {
      address: Pick<
          Address,
          | 'street'
          | 'streetAdditional'
          | 'city'
          | 'region'
          | 'postalCode'
          | 'countryCode'
          | 'lat'
          | 'long'
        >,
      incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
    }
  ) };

export type ResetFirmAffiliationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  affiliationId: Scalars['String']['input'];
  affiliatedLegalEntityId: Scalars['String']['input'];
  minimalCoa?: InputMaybe<Scalars['Boolean']['input']>;
  reason: Scalars['String']['input'];
}>;


export type ResetFirmAffiliationMutation = { resetFirmAffiliation: (
    Pick<
      LegalEntity,
      | 'id'
      | 'slug'
      | 'name'
      | 'websiteUrl'
      | 'industry'
      | 'timezone'
      | 'fiscalYearStartMonth'
      | 'fiscalYearNumberOffset'
      | 'status'
      | 'organizationId'
      | 'sensitive'
      | 'phoneNumber'
      | 'iconUrl'
    >
    & {
      address: Pick<
          Address,
          | 'street'
          | 'streetAdditional'
          | 'city'
          | 'region'
          | 'postalCode'
          | 'countryCode'
          | 'lat'
          | 'long'
        >,
      incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
    }
  ) };

export type ResetFirmAffiliationFromOAuthServiceMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  affiliationId: Scalars['String']['input'];
  affiliatedLegalEntityId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  service: OAuthService;
  reason: Scalars['String']['input'];
}>;


export type ResetFirmAffiliationFromOAuthServiceMutation = { resetFirmAffiliationFromOAuthService: {
      legalEntity?: Maybe<(
        Pick<
          LegalEntity,
          | 'id'
          | 'slug'
          | 'name'
          | 'websiteUrl'
          | 'industry'
          | 'timezone'
          | 'fiscalYearStartMonth'
          | 'fiscalYearNumberOffset'
          | 'status'
          | 'organizationId'
          | 'sensitive'
          | 'phoneNumber'
          | 'iconUrl'
        >
        & {
          address: Pick<
              Address,
              | 'street'
              | 'streetAdditional'
              | 'city'
              | 'region'
              | 'postalCode'
              | 'countryCode'
              | 'lat'
              | 'long'
            >,
          incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
        }
      )>,
      quickBooksCompany?: Maybe<{ preferences?: Maybe<{ accountingInfo?: Maybe<{ bookCloseDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>> }> }> }>,
    } };

export type ResetOperatorLegalEntityMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  minimalCoa?: InputMaybe<Scalars['Boolean']['input']>;
  reason: Scalars['String']['input'];
}>;


export type ResetOperatorLegalEntityMutation = { resetOperatorLegalEntity: (
    Pick<
      LegalEntity,
      | 'id'
      | 'slug'
      | 'name'
      | 'websiteUrl'
      | 'industry'
      | 'timezone'
      | 'fiscalYearStartMonth'
      | 'fiscalYearNumberOffset'
      | 'status'
      | 'organizationId'
      | 'sensitive'
      | 'phoneNumber'
      | 'iconUrl'
    >
    & {
      address: Pick<
          Address,
          | 'street'
          | 'streetAdditional'
          | 'city'
          | 'region'
          | 'postalCode'
          | 'countryCode'
          | 'lat'
          | 'long'
        >,
      incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
    }
  ) };

export type ResetOperatorLegalEntityFromOAuthServiceMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  service: OAuthService;
  reason: Scalars['String']['input'];
}>;


export type ResetOperatorLegalEntityFromOAuthServiceMutation = { resetOperatorLegalEntityFromOAuthService: {
      legalEntity?: Maybe<(
        Pick<
          LegalEntity,
          | 'id'
          | 'slug'
          | 'name'
          | 'websiteUrl'
          | 'industry'
          | 'timezone'
          | 'fiscalYearStartMonth'
          | 'fiscalYearNumberOffset'
          | 'status'
          | 'organizationId'
          | 'sensitive'
          | 'phoneNumber'
          | 'iconUrl'
        >
        & {
          address: Pick<
              Address,
              | 'street'
              | 'streetAdditional'
              | 'city'
              | 'region'
              | 'postalCode'
              | 'countryCode'
              | 'lat'
              | 'long'
            >,
          incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
        }
      )>,
      quickBooksCompany?: Maybe<{ preferences?: Maybe<{ accountingInfo?: Maybe<{ bookCloseDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>> }> }> }>,
    } };

export type SendManagedOperatorResetMutationVariables = Exact<{
  firmOrganizationId: Scalars['String']['input'];
  affiliatedLegalEntityId: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type SendManagedOperatorResetMutation = Pick<Mutation, 'sendManagedOperatorReset'>;

export type SubmitAccountantOnboardingMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type SubmitAccountantOnboardingMutation = Pick<Mutation, 'submitAccountantOnboarding'>;

export type UpdateQuickBooksCredentialsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  service: OAuthService;
}>;


export type UpdateQuickBooksCredentialsMutation = Pick<Mutation, 'updateQuickBooksCredentials'>;

export type CanResetLegalEntityQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type CanResetLegalEntityQuery = { canResetLegalEntity: (
    Pick<CanResetLegalEntityResponse, 'canReset'>
    & { outstandingBalance: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
  ) };

export type OrganizationAffiliationFieldsFragment = {
    legalEntity: Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>,
    organization: Pick<
        EntityOrganization,
        | 'id'
        | 'name'
        | 'slug'
        | 'iconUrl'
      >,
  };

export type OrganizationBrandingFieldsFragment = Pick<
    OrganizationBranding,
    | 'id'
    | 'organizationId'
    | 'headerColor'
    | 'headerTextColor'
  >;

export type BootstrapSandboxAccountingOrganizationMutationVariables = Exact<{ [key: string]: never; }>;


export type BootstrapSandboxAccountingOrganizationMutation = Pick<Mutation, 'bootstrapSandboxAccountingOrganization'>;

export type DeleteOrganizationBrandingMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type DeleteOrganizationBrandingMutation = Pick<Mutation, 'deleteOrganizationBranding'>;

export type ResetSandboxAccountingOrganizationMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetSandboxAccountingOrganizationMutation = Pick<Mutation, 'resetSandboxAccountingOrganization'>;

export type SaveOrganizationBrandingMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  branding: InputOrganizationBranding;
}>;


export type SaveOrganizationBrandingMutation = { saveOrganizationBranding?: Maybe<Pick<
      OrganizationBranding,
      | 'id'
      | 'organizationId'
      | 'headerColor'
      | 'headerTextColor'
    >> };

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrganizationMutation = Pick<Mutation, 'updateOrganization'>;

export type UpdateOrganizationIconMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  iconObjectName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOrganizationIconMutation = Pick<Mutation, 'updateOrganizationIcon'>;

export type UpdateOrganizationPreferencesMutationVariables = Exact<{
  id: Scalars['String']['input'];
  anonymizeEmployees: Scalars['Boolean']['input'];
}>;


export type UpdateOrganizationPreferencesMutation = Pick<Mutation, 'updateOrganizationPreferences'>;

export type UploadOrganizationIconMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  iconBase64: Scalars['String']['input'];
}>;


export type UploadOrganizationIconMutation = Pick<Mutation, 'uploadOrganizationIcon'>;

export type UploadProfileIconMutationVariables = Exact<{
  kinds: Array<ProfileIconKind> | ProfileIconKind;
  iconBase64: Scalars['String']['input'];
}>;


export type UploadProfileIconMutation = { uploadProfileIcon: Array<Pick<ProfileIconUploadResult, 'kind' | 'objectName'>> };

export type UploadProfileIconFromWebsiteMutationVariables = Exact<{
  kinds: Array<ProfileIconKind> | ProfileIconKind;
  website: Scalars['String']['input'];
}>;


export type UploadProfileIconFromWebsiteMutation = { uploadProfileIconFromWebsite: Array<Pick<ProfileIconUploadResult, 'kind' | 'objectName'>> };

export type ListAllOrganizationUsersQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ListAllOrganizationUsersQuery = {
    listOrganizationUsers: Array<(
      Pick<
        User,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'primaryEmailAddress'
        | 'passwordSet'
        | 'avatarUrl'
        | 'createdAt'
        | 'lastActivityAt'
      >
      & {
        employments?: Maybe<Array<(
          Pick<OrganizationEmployment, 'employeeId'>
          & {
            role: Pick<Role, 'id'>,
            organization: Pick<
                Organization,
                | 'id'
                | 'slug'
                | 'name'
                | 'iconUrl'
                | 'websiteUrl'
                | 'kind'
              >,
            legalEntityRoles?: Maybe<Array<(
              Pick<EmployeeLegalEntityRole, 'legalEntityId'>
              & { role?: Maybe<Pick<Role, 'id'>> }
            )>>,
          }
        )>>,
        identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
      }
    )>,
    listOrganizationInvitations: Array<(
      Pick<
        Invitation,
        | 'id'
        | 'invitationType'
        | 'status'
        | 'service'
        | 'organizationTemplateId'
        | 'createdAt'
        | 'updatedAt'
        | 'notifiedAt'
      >
      & {
        recipient: Pick<
            Contact,
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >,
        sender?: Maybe<Pick<
            Contact,
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>,
        organization?: Maybe<Pick<
            Organization,
            | 'id'
            | 'slug'
            | 'name'
            | 'iconUrl'
            | 'websiteUrl'
            | 'kind'
          >>,
        role?: Maybe<Pick<Role, 'id'>>,
      }
    )>,
  };

export type ListOrganizationAffiliationsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ListOrganizationAffiliationsQuery = { listOrganizationAffiliations: Array<{
      legalEntity: Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>,
      organization: Pick<
          EntityOrganization,
          | 'id'
          | 'name'
          | 'slug'
          | 'iconUrl'
        >,
    }> };

export type ListOrganizationDefaultLegalEntityRolesQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ListOrganizationDefaultLegalEntityRolesQuery = { listOrganizationDefaultLegalEntityRoles: Array<Pick<Role, 'id'>> };

export type ListOrganizationLegalEntitiesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ListOrganizationLegalEntitiesQuery = { listOrganizationLegalEntities: Array<Pick<
      LegalEntity,
      | 'id'
      | 'name'
      | 'slug'
      | 'iconUrl'
    >> };

export type ListOrganizationRoleOptionsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ListOrganizationRoleOptionsQuery = { listOrganizationRoleOptions: Array<(
    Pick<LegalEntityRoleOptions, 'legalEntityId'>
    & {
      organizationRoles: Array<Pick<Role, 'id'>>,
      legalEntityRoles: Array<Pick<Role, 'id'>>,
    }
  )> };

export type ListOrganizationUsersQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ListOrganizationUsersQuery = { listOrganizationUsers: Array<(
    Pick<
      User,
      | 'id'
      | 'givenName'
      | 'familyName'
      | 'primaryEmailAddress'
      | 'passwordSet'
      | 'avatarUrl'
      | 'createdAt'
      | 'lastActivityAt'
    >
    & {
      employments?: Maybe<Array<(
        Pick<OrganizationEmployment, 'employeeId'>
        & {
          role: Pick<Role, 'id'>,
          organization: Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >,
          legalEntityRoles?: Maybe<Array<(
            Pick<EmployeeLegalEntityRole, 'legalEntityId'>
            & { role?: Maybe<Pick<Role, 'id'>> }
          )>>,
        }
      )>>,
      identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
    }
  )> };

export type ReadOrganizationQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReadOrganizationQuery = { readOrganization: Pick<
      Organization,
      | 'id'
      | 'slug'
      | 'name'
      | 'iconUrl'
      | 'websiteUrl'
      | 'kind'
    > };

export type ReadOrganizationBrandingQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReadOrganizationBrandingQuery = { readOrganizationBranding?: Maybe<Pick<
      OrganizationBranding,
      | 'id'
      | 'organizationId'
      | 'headerColor'
      | 'headerTextColor'
    >> };

export type ReadOrganizationPreferencesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReadOrganizationPreferencesQuery = { readOrganizationPreferences: Pick<OrganizationPreferences, 'id' | 'anonymizeEmployees'> };

export type PartyHistoryEntryFieldsFragment = Pick<PartyHistoryEntry, 'userId' | 'name' | 'iconUrl'>;

export type CreatePartiesMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  partyNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CreatePartiesMutation = { createParties: Array<Pick<
      Party,
      | 'id'
      | 'legalEntityId'
      | 'name'
      | 'url'
      | 'supportUrl'
      | 'supportEmail'
      | 'supportPhone'
      | 'twitterUrl'
      | 'facebookUrl'
      | 'instagramUrl'
      | 'yelpUrl'
      | 'iconUrl'
      | 'shortDescription'
      | 'designation'
    >> };

export type UpdatePartyFieldsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  updates: Array<InputUpdatePartyFields> | InputUpdatePartyFields;
}>;


export type UpdatePartyFieldsMutation = Pick<Mutation, 'updatePartyFields'>;

export type ListActivePartyRolesQueryVariables = Exact<{
  filter: SummaryFilterInput;
  direction?: InputMaybe<DirectionFromOrigin>;
  intervalOrigin?: InputMaybe<IntervalOrigin>;
}>;


export type ListActivePartyRolesQuery = Pick<Query, 'listActivePartyRoles'>;

export type ListActivePartyRolesBatchQueryVariables = Exact<{
  inputs: Array<SummarizeInput> | SummarizeInput;
}>;


export type ListActivePartyRolesBatchQuery = { listActivePartyRolesBatch: Array<Pick<ActivePartyRoles, 'partyId' | 'roles'>> };

export type ListLatestPartyHistoriesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  partyIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ListLatestPartyHistoriesQuery = { listLatestPartyHistories: Array<(
    Pick<PartyHistory, 'partyId'>
    & {
      taxpayerIdentificationClassification: Pick<PartyHistoryEntry, 'userId' | 'name' | 'iconUrl'>,
      entityTypeClassification: Pick<PartyHistoryEntry, 'userId' | 'name' | 'iconUrl'>,
    }
  )> };

export type ListPartyTaxInfoQueryVariables = Exact<{
  filter: TransactionFilter;
  origin: IntervalOrigin;
  direction: DirectionFromOrigin;
}>;


export type ListPartyTaxInfoQuery = { listPartyTaxInfo: Array<Pick<PartyTaxInfo, 'partyId' | 'taxpayerIdentification' | 'entityType'>> };

export type ReadPartyQueryVariables = Exact<{
  viewKey: ViewKey;
  partyId: Scalars['String']['input'];
}>;


export type ReadPartyQuery = { readParty: Pick<
      Party,
      | 'id'
      | 'legalEntityId'
      | 'name'
      | 'url'
      | 'supportUrl'
      | 'supportEmail'
      | 'supportPhone'
      | 'twitterUrl'
      | 'facebookUrl'
      | 'instagramUrl'
      | 'yelpUrl'
      | 'iconUrl'
      | 'shortDescription'
      | 'designation'
    > };

export type LedgerReadPaymentErrorStateQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type LedgerReadPaymentErrorStateQuery = { ledgerReadPaymentErrorState: Pick<PaymentErrorState, 'hasPendingBalance' | 'pendingBalanceUpdatedAt'> };

export type ReadPaymentErrorStateQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  product: PaymentErrorProduct;
}>;


export type ReadPaymentErrorStateQuery = { readPaymentErrorState: Pick<PaymentErrorState, 'hasPendingBalance' | 'pendingBalanceUpdatedAt'> };

export type ReadOrCreatePortalLayoutQueryVariables = Exact<{
  viewId: ViewIdentifierInput;
}>;


export type ReadOrCreatePortalLayoutQuery = { readOrCreatePortalLayout: (
    Pick<PortalLayout, 'portalId'>
    & { layout?: Maybe<(
      Pick<Layout, 'layoutId' | 'layoutVersionId'>
      & {
        viewKey: Pick<
            ViewIdentifier,
            | 'legalEntityId'
            | 'viewVersion'
            | 'mutationVersion'
            | 'viewType'
          >,
        sections?: Maybe<Array<(
          Pick<LayoutSection, 'sectionId' | 'title'>
          & { rows?: Maybe<Array<(
            Pick<LayoutRow, 'rowId' | 'title'>
            & { components?: Maybe<Array<(
              Pick<LayoutComponent, 'componentId' | 'title' | 'dataId'>
              & { config: (
                Pick<LayoutComponentConfig, 'type'>
                & {
                  text?: Maybe<(
                    Pick<TextComponentConfig, 'body'>
                    & {
                      current?: Maybe<Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        >>,
                      lookback?: Maybe<Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        >>,
                      tags?: Maybe<Array<(
                        Pick<TextComponentConfigTag, 'displayText'>
                        & {
                          objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
                          options?: Maybe<Pick<TextTagOptions, 'partyRole'>>,
                        }
                      )>>,
                    }
                  )>,
                  categoryChart?: Maybe<(
                    Pick<CategoryChartConfig, 'categoryId' | 'withoutCategoryAncestors' | 'asPermanent'>
                    & { origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      > }
                  )>,
                  partyChart?: Maybe<(
                    Pick<PartyChartConfig, 'partyId' | 'partyRole' | 'asPermanent'>
                    & { origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      > }
                  )>,
                  topEntities?: Maybe<(
                    Pick<
                      TopEntitiesConfig,
                      | 'limit'
                      | 'kind'
                      | 'partyRole'
                      | 'categoryType'
                      | 'sort'
                    >
                    & {
                      origin: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        >,
                      filteredBy?: Maybe<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
                    }
                  )>,
                  topTransactions?: Maybe<(
                    Pick<TopTransactionsConfig, 'limit' | 'partyRole' | 'categoryType'>
                    & {
                      origin: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        >,
                      filteredBy?: Maybe<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
                    }
                  )>,
                  summaryLineItem?: Maybe<(
                    Pick<SummaryLineItemConfig, 'item'>
                    & { origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      > }
                  )>,
                  portalMetric?: Maybe<(
                    Pick<PortalMetricConfig, 'metricType'>
                    & { origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      > }
                  )>,
                  entitiesList?: Maybe<{
                      origin: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        >,
                      entities: (
                        { __typename: 'ObjectEntities' }
                        & {
                          users?: Maybe<Array<Pick<
                              EntityUser,
                              | 'id'
                              | 'givenName'
                              | 'familyName'
                              | 'emailAddress'
                              | 'avatarUrl'
                            >>>,
                          transactions?: Maybe<Array<(
                            Pick<
                              EntityTransaction,
                              | 'viewId'
                              | 'factId'
                              | 'timestamp'
                              | 'description'
                              | 'externalId'
                              | 'displayEntry'
                            >
                            & {
                              moneyFlow: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ),
                              party?: Maybe<Pick<
                                  EntityParty,
                                  | 'id'
                                  | 'name'
                                  | 'iconUrl'
                                  | 'shortDescription'
                                  | 'roles'
                                  | 'designation'
                                >>,
                              displayCategory: Pick<
                                  EntityCategory,
                                  | 'id'
                                  | 'name'
                                  | 'displayKey'
                                  | 'chartOfAccountsDisplayNumber'
                                  | 'type'
                                  | 'subtype'
                                  | 'parentCategoryId'
                                  | 'productArea'
                                  | 'active'
                                >,
                              splitCategory?: Maybe<Pick<
                                  EntityCategory,
                                  | 'id'
                                  | 'name'
                                  | 'displayKey'
                                  | 'chartOfAccountsDisplayNumber'
                                  | 'type'
                                  | 'subtype'
                                  | 'parentCategoryId'
                                  | 'productArea'
                                  | 'active'
                                >>,
                            }
                          )>>,
                          comments?: Maybe<Array<Pick<
                              EntityComment,
                              | 'id'
                              | 'authorId'
                              | 'text'
                              | 'timestamp'
                            >>>,
                          reports?: Maybe<Array<(
                            Pick<
                              EntityReport,
                              | 'id'
                              | 'title'
                              | 'authorId'
                              | 'mimeType'
                              | 'createdAt'
                            >
                            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
                          )>>,
                          reportPackages?: Maybe<Array<(
                            Pick<
                              EntityReportPackage,
                              | 'id'
                              | 'title'
                              | 'authorId'
                              | 'interval'
                              | 'periodStartedAt'
                              | 'periodEndedAt'
                              | 'createdAt'
                              | 'updatedAt'
                              | 'coverUrl'
                            >
                            & { documents: Array<Pick<
                                SharedReportDocumentMetadata,
                                | 'id'
                                | 'documentObjectId'
                                | 'documentObjectVersionId'
                                | 'title'
                                | 'mimeType'
                              >> }
                          )>>,
                          parties?: Maybe<Array<Pick<
                              EntityParty,
                              | 'id'
                              | 'name'
                              | 'iconUrl'
                              | 'shortDescription'
                              | 'roles'
                              | 'designation'
                            >>>,
                          datasources?: Maybe<Array<Pick<
                              EntityDataSource,
                              | 'id'
                              | 'name'
                              | 'url'
                              | 'iconUrl'
                            >>>,
                          categories?: Maybe<Array<Pick<
                              EntityCategory,
                              | 'id'
                              | 'name'
                              | 'displayKey'
                              | 'chartOfAccountsDisplayNumber'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'productArea'
                              | 'active'
                            >>>,
                          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
                          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
                          workItems?: Maybe<Array<(
                            Pick<
                              EntityWorkItem,
                              | 'id'
                              | 'time'
                              | 'workItemState'
                              | 'workItemType'
                              | 'reviewCreatedById'
                              | 'reviewState'
                              | 'ledgerType'
                            >
                            & { objectTransaction: (
                              Pick<
                                EntityTransaction,
                                | 'viewId'
                                | 'factId'
                                | 'timestamp'
                                | 'description'
                                | 'externalId'
                                | 'displayEntry'
                              >
                              & {
                                moneyFlow: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ),
                                party?: Maybe<Pick<
                                    EntityParty,
                                    | 'id'
                                    | 'name'
                                    | 'iconUrl'
                                    | 'shortDescription'
                                    | 'roles'
                                    | 'designation'
                                  >>,
                                displayCategory: Pick<
                                    EntityCategory,
                                    | 'id'
                                    | 'name'
                                    | 'displayKey'
                                    | 'chartOfAccountsDisplayNumber'
                                    | 'type'
                                    | 'subtype'
                                    | 'parentCategoryId'
                                    | 'productArea'
                                    | 'active'
                                  >,
                                splitCategory?: Maybe<Pick<
                                    EntityCategory,
                                    | 'id'
                                    | 'name'
                                    | 'displayKey'
                                    | 'chartOfAccountsDisplayNumber'
                                    | 'type'
                                    | 'subtype'
                                    | 'parentCategoryId'
                                    | 'productArea'
                                    | 'active'
                                  >>,
                              }
                            ) }
                          )>>,
                          invoices?: Maybe<Array<(
                            Pick<
                              EntityInvoice,
                              | 'id'
                              | 'externalDisplayId'
                              | 'createdAt'
                              | 'dueAt'
                            >
                            & {
                              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              customer: (
                                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                                & { party: Pick<
                                    EntityParty,
                                    | 'id'
                                    | 'name'
                                    | 'iconUrl'
                                    | 'shortDescription'
                                    | 'roles'
                                    | 'designation'
                                  > }
                              ),
                            }
                          )>>,
                          bills?: Maybe<Array<(
                            Pick<
                              EntityBill,
                              | 'id'
                              | 'billStatus'
                              | 'vendorName'
                              | 'billDescription'
                            >
                            & {
                              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
                              format: (
                                Pick<Format, 'id' | 'formatClass'>
                                & { segments: Array<Pick<
                                    Segment,
                                    | 'collectionId'
                                    | 'fileId'
                                    | 'sequence'
                                    | 'token'
                                  >> }
                              ),
                              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
                            }
                          )>>,
                          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
                          departments?: Maybe<Array<(
                            { __typename: 'EntityDepartment' }
                            & Pick<
                              EntityDepartment,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>>,
                          locations?: Maybe<Array<(
                            { __typename: 'EntityLocation' }
                            & Pick<
                              EntityLocation,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          )>>,
                          reconciliations?: Maybe<Array<(
                            { __typename: 'EntityReconciliation' }
                            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
                            & {
                              startDate: Pick<Date, 'year' | 'month' | 'day'>,
                              endDate: Pick<Date, 'year' | 'month' | 'day'>,
                            }
                          )>>,
                          ledgerTransactions?: Maybe<Array<(
                            Pick<
                              EntityLedgerTransaction,
                              | 'id'
                              | 'timestamp'
                              | 'factIds'
                              | 'name'
                              | 'referenceNumber'
                            >
                            & {
                              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              parties: Array<Pick<
                                  EntityParty,
                                  | 'id'
                                  | 'name'
                                  | 'iconUrl'
                                  | 'shortDescription'
                                  | 'roles'
                                  | 'designation'
                                >>,
                            }
                          )>>,
                          schedules?: Maybe<Array<(
                            { __typename: 'EntitySchedule' }
                            & Pick<
                              EntitySchedule,
                              | 'id'
                              | 'name'
                              | 'scheduleNumber'
                              | 'scheduleType'
                              | 'scheduleTemplateId'
                              | 'categoryId'
                              | 'relatedCategoryId'
                              | 'partyId'
                              | 'startDate'
                              | 'endDate'
                              | 'cutoverDate'
                            >
                            & {
                              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                            }
                          )>>,
                        }
                      ),
                    }>,
                  statement?: Maybe<(
                    Pick<StatementConfig, 'kind'>
                    & {
                      origin: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        >,
                      options?: Maybe<(
                        { __typename: 'ReportDocumentOptions' }
                        & Pick<
                          ReportDocumentOptions,
                          | 'sparklineLookbackPeriods'
                          | 'reportLookbackPeriods'
                          | 'deltaMonthOverMonth'
                          | 'deltaMonthOverMonthPeriods'
                          | 'deltaYearOverYear'
                          | 'comparedToTotal'
                          | 'comparedToIncome'
                          | 'amountPrecision'
                          | 'yearToDate'
                          | 'deltaYearToDate'
                          | 'breakdownByClass'
                        >
                        & {
                          collapsedSections?: Maybe<Pick<CollapsedSections, 'sections'>>,
                          categoryByDepartmentOptions?: Maybe<(
                            Pick<CategoryByDepartmentOptions, 'showOther' | 'showUnassigned'>
                            & { departments?: Maybe<Array<Pick<DepartmentOption, 'departmentId' | 'name'>>> }
                          )>,
                          categoryByLocationOptions?: Maybe<(
                            Pick<CategoryByLocationOptions, 'showOther' | 'showUnassigned'>
                            & { locations?: Maybe<Array<Pick<LocationOption, 'locationId' | 'name'>>> }
                          )>,
                        }
                      )>,
                    }
                  )>,
                  metricChart?: Maybe<(
                    Pick<MetricChartConfig, 'item'>
                    & { origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      > }
                  )>,
                  runwayChart?: Maybe<{
                      origin: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        >,
                      netBurnLookback?: Maybe<Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        >>,
                    }>,
                  cashSummaryChart?: Maybe<{ origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      > }>,
                  staticMetric?: Maybe<Pick<StaticMetricConfig, 'name' | 'value' | 'updatedAt'>>,
                  documentCollection?: Maybe<Pick<DocumentCollectionConfig, 'collectionId'>>,
                  insight?: Maybe<{
                      objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
                      options?: Maybe<Pick<InsightComponentConfigOptions, 'partyRole'>>,
                      origin: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        >,
                      lookback: Pick<
                          ArchiveIntervalOrigin,
                          | 'interval'
                          | 'year'
                          | 'index'
                          | 'intervalCount'
                          | 'maxTime'
                        >,
                    }>,
                  departmentChart?: Maybe<(
                    Pick<DepartmentChartConfig, 'departmentId'>
                    & { origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      > }
                  )>,
                  locationChart?: Maybe<(
                    Pick<LocationChartConfig, 'locationId'>
                    & { origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      > }
                  )>,
                  sourceAccountMetric?: Maybe<(
                    Pick<SourceAccountMetricConfig, 'key' | 'sourceAccountId' | 'dataSourceId'>
                    & { origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      > }
                  )>,
                  agingSummaryChart?: Maybe<(
                    Pick<AgingSummaryChartConfig, 'kind' | 'dimensions' | 'masks'>
                    & { origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      > }
                  )>,
                  categoryByDepartmentChart?: Maybe<(
                    Pick<CategoryByDepartmentChartConfig, 'categoryId' | 'departmentIds'>
                    & { origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      > }
                  )>,
                  categoryByLocationChart?: Maybe<(
                    Pick<CategoryByLocationChartConfig, 'categoryId' | 'locationIds'>
                    & { origin: Pick<
                        ArchiveIntervalOrigin,
                        | 'interval'
                        | 'year'
                        | 'index'
                        | 'intervalCount'
                        | 'maxTime'
                      > }
                  )>,
                }
              ) }
            )>> }
          )>> }
        )>>,
      }
    )> }
  ) };

export type CatalogProductClassificationsFieldsFragment = {
    incomeCategory?: Maybe<Pick<ProductCategoryClassification, 'classificationVersionId' | 'categoryId'>>,
    expenseCategory?: Maybe<Pick<ProductCategoryClassification, 'classificationVersionId' | 'categoryId'>>,
    department?: Maybe<Pick<ProductDepartmentClassification, 'classificationVersionId' | 'departmentId'>>,
    buyDepartment?: Maybe<Pick<ProductDepartmentClassification, 'classificationVersionId' | 'departmentId'>>,
    sellDepartment?: Maybe<Pick<ProductDepartmentClassification, 'classificationVersionId' | 'departmentId'>>,
    location?: Maybe<Pick<ProductLocationClassification, 'classificationVersionId' | 'locationId'>>,
    buyLocation?: Maybe<Pick<ProductLocationClassification, 'classificationVersionId' | 'locationId'>>,
    sellLocation?: Maybe<Pick<ProductLocationClassification, 'classificationVersionId' | 'locationId'>>,
  };

export type CatalogProductFieldsFragment = Pick<
    Product,
    | 'id'
    | 'dataSourceId'
    | 'providerType'
    | 'institutionId'
    | 'institutionName'
    | 'institutionIconUrl'
    | 'productGroupId'
    | 'sku'
    | 'name'
    | 'description'
    | 'active'
    | 'taxable'
    | 'assetCategoryId'
    | 'iconDisplayKey'
    | 'customIconObjectName'
    | 'customIconUrl'
    | 'createdAt'
    | 'updatedAt'
    | 'createdByUserId'
  >;

export type CatalogProductVariantFieldsFragment = (
  Pick<
    ProductVariant,
    | 'id'
    | 'dataSourceId'
    | 'productId'
    | 'externalId'
    | 'sku'
    | 'name'
    | 'description'
    | 'position'
    | 'iconDisplayKey'
    | 'customIconObjectName'
    | 'createdAt'
    | 'updatedAt'
    | 'createdByUserId'
  >
  & { prices?: Maybe<Array<(
    Pick<
      ProductVariantPrice,
      | 'id'
      | 'dataSourceId'
      | 'productId'
      | 'variantId'
      | 'externalId'
      | 'type'
      | 'createdAt'
      | 'updatedAt'
    >
    & { unitPrice: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
  )>> }
);

export type CatalogProductVariantPriceFieldsFragment = (
  Pick<
    ProductVariantPrice,
    | 'id'
    | 'dataSourceId'
    | 'productId'
    | 'variantId'
    | 'externalId'
    | 'type'
    | 'createdAt'
    | 'updatedAt'
  >
  & { unitPrice: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
);

export type DeleteProductVariantMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
}>;


export type DeleteProductVariantMutation = Pick<Mutation, 'deleteProductVariant'>;

export type DeleteProductVariantPriceMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
}>;


export type DeleteProductVariantPriceMutation = Pick<Mutation, 'deleteProductVariantPrice'>;

export type SaveProductMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  providerType: ProviderType;
  product: ProductInput;
}>;


export type SaveProductMutation = { saveProduct: Pick<
      Product,
      | 'id'
      | 'dataSourceId'
      | 'providerType'
      | 'institutionId'
      | 'institutionName'
      | 'institutionIconUrl'
      | 'productGroupId'
      | 'sku'
      | 'name'
      | 'description'
      | 'active'
      | 'taxable'
      | 'assetCategoryId'
      | 'iconDisplayKey'
      | 'customIconObjectName'
      | 'customIconUrl'
      | 'createdAt'
      | 'updatedAt'
      | 'createdByUserId'
    > };

export type SaveProductVariantPriceMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  price: ProductVariantPriceInput;
}>;


export type SaveProductVariantPriceMutation = { saveProductVariantPrice: (
    Pick<
      ProductVariantPrice,
      | 'id'
      | 'dataSourceId'
      | 'productId'
      | 'variantId'
      | 'externalId'
      | 'type'
      | 'createdAt'
      | 'updatedAt'
    >
    & { unitPrice: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
  ) };

export type UpdateProductsActiveMutationVariables = Exact<{
  input: UpdateProductsActiveInput;
}>;


export type UpdateProductsActiveMutation = Pick<Mutation, 'updateProductsActive'>;

export type UploadProductCatalogIconMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  iconBase64: Scalars['String']['input'];
}>;


export type UploadProductCatalogIconMutation = { uploadProductCatalogIcon: Pick<ProductCatalogIconUploadResult, 'objectName' | 'iconUrl'> };

export type LedgerSummarizeProductNetSalesByTimeQueryVariables = Exact<{
  viewKey: ViewKey;
  productId: Scalars['String']['input'];
  origin: IntervalOrigin;
  direction: DirectionFromOrigin;
}>;


export type LedgerSummarizeProductNetSalesByTimeQuery = {
    invoices: (
      Pick<DimensionSummary, 'partialData'>
      & { time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> }
    ),
    bills: (
      Pick<DimensionSummary, 'partialData'>
      & { time: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }> }
    ),
  };

export type ListProductDepartmentOptionsQueryVariables = Exact<{
  viewKey: ViewKey;
  status?: InputMaybe<DepartmentStatus>;
}>;


export type ListProductDepartmentOptionsQuery = { listDepartments: Array<Pick<
      Department,
      | 'id'
      | 'name'
      | 'parentId'
      | 'active'
    >> };

export type ListProductLocationOptionsQueryVariables = Exact<{
  viewKey: ViewKey;
  status?: InputMaybe<LocationStatus>;
}>;


export type ListProductLocationOptionsQuery = { listLocations: Array<Pick<
      Location,
      | 'id'
      | 'name'
      | 'parentId'
      | 'active'
    >> };

export type ListProductTransactionsQueryVariables = Exact<{
  viewKey: ViewKey;
  productId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListProductTransactionsQuery = { listProductTransactions: Array<(
    Pick<ProductTransactionListItem, 'linkedObjectNumber' | 'linkedObjectType'>
    & {
      transaction: (
        Pick<
          Transaction,
          | 'viewId'
          | 'factId'
          | 'ledgerTransactionId'
          | 'supersededFactIds'
          | 'timestamp'
          | 'recordType'
          | 'name'
          | 'description'
          | 'digitsTransactionType'
          | 'partySource'
          | 'displayEntry'
          | 'displayCategorySource'
          | 'displayCanonicalCategoryName'
          | 'displayUncategorizedReason'
          | 'displayProductArea'
          | 'ownerSource'
          | 'transactionClassificationType'
          | 'compileSource'
          | 'reconciliationStatus'
          | 'referenceNumber'
          | 'taxStatus'
          | 'matchedLedgerTransactionIds'
          | 'providerTypes'
          | 'isSupersedingLedgerTransaction'
          | 'supersededLedgerTransactionIds'
        >
        & {
          party?: Maybe<Pick<
              TransactionParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'iconObjectName'
              | 'designation'
              | 'roles'
            >>,
          facilitatorParty?: Maybe<Pick<
              TransactionParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'iconObjectName'
              | 'designation'
              | 'roles'
            >>,
          product?: Maybe<Pick<
              Product,
              | 'id'
              | 'dataSourceId'
              | 'name'
              | 'providerType'
              | 'active'
              | 'institutionId'
              | 'institutionName'
            >>,
          department?: Maybe<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          splitDepartment?: Maybe<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          location?: Maybe<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          splitLocation?: Maybe<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          providers: Array<Pick<Provider, 'name'>>,
          recurrence?: Maybe<Pick<
              TransactionRecurrence,
              | 'recurrenceThreadId'
              | 'interval'
              | 'intervalMultiplier'
              | 'threadIndex'
              | 'totalThreadCount'
              | 'isHidden'
              | 'firstOccurredAt'
              | 'lastOccurredAt'
            >>,
          displayInstitution?: Maybe<Pick<
              TransactionParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'iconObjectName'
              | 'designation'
              | 'roles'
            >>,
          displayCategory: (
            Pick<
              Category,
              | 'id'
              | 'name'
              | 'description'
              | 'displayKey'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'displayNumber'
              | 'active'
              | 'categoryState'
              | 'productArea'
              | 'synthesized'
            >
            & { ancestors?: Maybe<Array<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>> }
          ),
          displayCategoryClassificationProvenance?: Maybe<(
            Pick<
              ClassificationProvenance,
              | 'type'
              | 'changedAt'
              | 'confidenceLevel'
              | 'settingsName'
            >
            & { source?: Maybe<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )> }
          )>,
          splitCategory?: Maybe<(
            Pick<
              Category,
              | 'id'
              | 'name'
              | 'description'
              | 'displayKey'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'displayNumber'
              | 'active'
              | 'categoryState'
              | 'productArea'
              | 'synthesized'
            >
            & { ancestors?: Maybe<Array<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>> }
          )>,
          splitCategoryClassificationProvenance?: Maybe<(
            Pick<
              ClassificationProvenance,
              | 'type'
              | 'changedAt'
              | 'confidenceLevel'
              | 'settingsName'
            >
            & { source?: Maybe<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )> }
          )>,
          splitInstitution?: Maybe<Pick<
              TransactionParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'iconObjectName'
              | 'designation'
              | 'roles'
            >>,
          creditCategoryClassificationProvenance?: Maybe<(
            Pick<
              ClassificationProvenance,
              | 'type'
              | 'changedAt'
              | 'confidenceLevel'
              | 'settingsName'
            >
            & { source?: Maybe<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )> }
          )>,
          debitCategoryClassificationProvenance?: Maybe<(
            Pick<
              ClassificationProvenance,
              | 'type'
              | 'changedAt'
              | 'confidenceLevel'
              | 'settingsName'
            >
            & { source?: Maybe<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )> }
          )>,
          moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          runningTotal?: Maybe<(
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          )>,
          owner?: Maybe<Pick<
              EntityEmployee,
              | 'id'
              | 'organizationId'
              | 'givenName'
              | 'familyName'
              | 'avatarUrl'
            >>,
          sources: Array<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )>,
          creditSources: Array<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )>,
          debitSources: Array<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )>,
          invoiceLineItem?: Maybe<{ value:
              | (
                Pick<
                  TransactionDiscountLineItem,
                  | 'name'
                  | 'description'
                  | 'variablePercentage'
                  | 'appliesToTransactionFactId'
                >
                & {
                  fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  discount?: Maybe<(
                    Pick<
                      TransactionInvoiceLineItemDiscount,
                      | 'discountId'
                      | 'name'
                      | 'description'
                      | 'variablePercentage'
                    >
                    & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                  )>,
                }
              )
              | (
                Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                & {
                  unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  product?: Maybe<(
                    Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                    & {
                      unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      category?: Maybe<(
                        Pick<
                          Category,
                          | 'id'
                          | 'name'
                          | 'description'
                          | 'displayKey'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'displayNumber'
                          | 'active'
                          | 'categoryState'
                          | 'productArea'
                          | 'synthesized'
                        >
                        & { ancestors?: Maybe<Array<Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >>> }
                      )>,
                      department?: Maybe<(
                        { __typename: 'EntityDepartment' }
                        & Pick<
                          EntityDepartment,
                          | 'id'
                          | 'name'
                          | 'parentId'
                          | 'active'
                        >
                      )>,
                      location?: Maybe<(
                        { __typename: 'EntityLocation' }
                        & Pick<
                          EntityLocation,
                          | 'id'
                          | 'name'
                          | 'parentId'
                          | 'active'
                        >
                      )>,
                    }
                  )>,
                }
              )
             }>,
          schedule?: Maybe<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>,
          splitSchedule?: Maybe<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>,
        }
      ),
      linkedObjectParty?: Maybe<Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        >>,
    }
  )> };

export type ListProductVariantsForCatalogQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListProductVariantsForCatalogQuery = { listProductVariantsForCatalog: Array<(
    Pick<
      Product,
      | 'id'
      | 'dataSourceId'
      | 'providerType'
      | 'institutionId'
      | 'institutionName'
      | 'institutionIconUrl'
      | 'productGroupId'
      | 'sku'
      | 'name'
      | 'description'
      | 'active'
      | 'taxable'
      | 'assetCategoryId'
      | 'iconDisplayKey'
      | 'customIconObjectName'
      | 'customIconUrl'
      | 'createdAt'
      | 'updatedAt'
      | 'createdByUserId'
    >
    & { variants?: Maybe<Array<(
      Pick<
        ProductVariant,
        | 'id'
        | 'dataSourceId'
        | 'productId'
        | 'externalId'
        | 'sku'
        | 'name'
        | 'description'
        | 'position'
        | 'iconDisplayKey'
        | 'customIconObjectName'
        | 'createdAt'
        | 'updatedAt'
        | 'createdByUserId'
      >
      & { prices?: Maybe<Array<(
        Pick<
          ProductVariantPrice,
          | 'id'
          | 'dataSourceId'
          | 'productId'
          | 'variantId'
          | 'externalId'
          | 'type'
          | 'createdAt'
          | 'updatedAt'
        >
        & { unitPrice: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      )>> }
    )>> }
  )> };

export type ListProductVariantsForInvoiceQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListProductVariantsForInvoiceQuery = { listProductVariantsForInvoice: Array<(
    Pick<
      Product,
      | 'id'
      | 'dataSourceId'
      | 'providerType'
      | 'institutionId'
      | 'institutionName'
      | 'institutionIconUrl'
      | 'productGroupId'
      | 'sku'
      | 'name'
      | 'description'
      | 'active'
      | 'taxable'
      | 'assetCategoryId'
      | 'iconDisplayKey'
      | 'customIconObjectName'
      | 'customIconUrl'
      | 'createdAt'
      | 'updatedAt'
      | 'createdByUserId'
    >
    & { variants?: Maybe<Array<(
      Pick<
        ProductVariant,
        | 'id'
        | 'dataSourceId'
        | 'productId'
        | 'externalId'
        | 'sku'
        | 'name'
        | 'description'
        | 'position'
        | 'iconDisplayKey'
        | 'customIconObjectName'
        | 'createdAt'
        | 'updatedAt'
        | 'createdByUserId'
      >
      & {
        classifications?: Maybe<{
            incomeCategory?: Maybe<Pick<ProductCategoryClassification, 'classificationVersionId' | 'categoryId'>>,
            expenseCategory?: Maybe<Pick<ProductCategoryClassification, 'classificationVersionId' | 'categoryId'>>,
            department?: Maybe<Pick<ProductDepartmentClassification, 'classificationVersionId' | 'departmentId'>>,
            buyDepartment?: Maybe<Pick<ProductDepartmentClassification, 'classificationVersionId' | 'departmentId'>>,
            sellDepartment?: Maybe<Pick<ProductDepartmentClassification, 'classificationVersionId' | 'departmentId'>>,
            location?: Maybe<Pick<ProductLocationClassification, 'classificationVersionId' | 'locationId'>>,
            buyLocation?: Maybe<Pick<ProductLocationClassification, 'classificationVersionId' | 'locationId'>>,
            sellLocation?: Maybe<Pick<ProductLocationClassification, 'classificationVersionId' | 'locationId'>>,
          }>,
        prices?: Maybe<Array<(
          Pick<
            ProductVariantPrice,
            | 'id'
            | 'dataSourceId'
            | 'productId'
            | 'variantId'
            | 'externalId'
            | 'type'
            | 'createdAt'
            | 'updatedAt'
          >
          & { unitPrice: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        )>>,
      }
    )>> }
  )> };

export type ListProductsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListProductsQuery = { listProducts: Array<Pick<
      Product,
      | 'id'
      | 'dataSourceId'
      | 'providerType'
      | 'institutionId'
      | 'institutionName'
      | 'institutionIconUrl'
      | 'productGroupId'
      | 'sku'
      | 'name'
      | 'description'
      | 'active'
      | 'taxable'
      | 'assetCategoryId'
      | 'iconDisplayKey'
      | 'customIconObjectName'
      | 'customIconUrl'
      | 'createdAt'
      | 'updatedAt'
      | 'createdByUserId'
    >> };

export type ProductCatalogRevenueByTimeQueryVariables = Exact<{
  viewKey: ViewKey;
  origin: IntervalOrigin;
  direction: DirectionFromOrigin;
}>;


export type ProductCatalogRevenueByTimeQuery = { productRevenue: (
    Pick<DimensionSummary, 'partialData'>
    & { time: Array<{ summary: (
        Pick<TransactionSummary, 'isPeriodBookClosed'>
        & {
          period: Pick<
              Period,
              | 'name'
              | 'interval'
              | 'startedAt'
              | 'endedAt'
            >,
          total: (
            Pick<
              PeriodMonetaryValue,
              | 'transactionsCount'
              | 'deltaPrevious'
              | 'deltaYearAgo'
              | 'isFirstOccurrencePeriod'
            >
            & {
              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              moneyFlow?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              current?: Maybe<(
                Pick<SummaryTotal, 'count'>
                & { total: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
              prior?: Maybe<(
                Pick<SummaryTotal, 'count'>
                & { total: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
            }
          ),
        }
      ) }> }
  ) };

export type ProductCatalogTopSellersQueryVariables = Exact<{
  viewKey: ViewKey;
  origin: IntervalOrigin;
  direction: DirectionFromOrigin;
  sort: DimensionSortMode;
  limit: Scalars['Int']['input'];
}>;


export type ProductCatalogTopSellersQuery = { topSellers: {
      summary: (
        Pick<TransactionSummary, 'isPeriodBookClosed'>
        & {
          period: Pick<
              Period,
              | 'name'
              | 'interval'
              | 'startedAt'
              | 'endedAt'
            >,
          total: (
            Pick<
              PeriodMonetaryValue,
              | 'transactionsCount'
              | 'deltaPrevious'
              | 'deltaYearAgo'
              | 'isFirstOccurrencePeriod'
            >
            & {
              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              moneyFlow?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              current?: Maybe<(
                Pick<SummaryTotal, 'count'>
                & { total: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
              prior?: Maybe<(
                Pick<SummaryTotal, 'count'>
                & { total: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
            }
          ),
        }
      ),
      product: Array<(
        Pick<ProductDimension, 'productId'>
        & {
          productObject: Pick<EntityProduct, 'dataSourceId' | 'id' | 'name'>,
          summary: (
            Pick<TransactionSummary, 'isPeriodBookClosed'>
            & {
              period: Pick<
                  Period,
                  | 'name'
                  | 'interval'
                  | 'startedAt'
                  | 'endedAt'
                >,
              total: (
                Pick<
                  PeriodMonetaryValue,
                  | 'transactionsCount'
                  | 'deltaPrevious'
                  | 'deltaYearAgo'
                  | 'isFirstOccurrencePeriod'
                >
                & {
                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  moneyFlow?: Maybe<(
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  )>,
                  current?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                  prior?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                }
              ),
            }
          ),
        }
      )>,
    } };

export type ReadProductQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type ReadProductQuery = { readProduct: (
    Pick<
      Product,
      | 'id'
      | 'dataSourceId'
      | 'providerType'
      | 'institutionId'
      | 'institutionName'
      | 'institutionIconUrl'
      | 'productGroupId'
      | 'sku'
      | 'name'
      | 'description'
      | 'active'
      | 'taxable'
      | 'assetCategoryId'
      | 'iconDisplayKey'
      | 'customIconObjectName'
      | 'customIconUrl'
      | 'createdAt'
      | 'updatedAt'
      | 'createdByUserId'
    >
    & { variants?: Maybe<Array<(
      Pick<
        ProductVariant,
        | 'id'
        | 'dataSourceId'
        | 'productId'
        | 'externalId'
        | 'sku'
        | 'name'
        | 'description'
        | 'position'
        | 'iconDisplayKey'
        | 'customIconObjectName'
        | 'createdAt'
        | 'updatedAt'
        | 'createdByUserId'
      >
      & {
        classifications?: Maybe<{
            incomeCategory?: Maybe<Pick<ProductCategoryClassification, 'classificationVersionId' | 'categoryId'>>,
            expenseCategory?: Maybe<Pick<ProductCategoryClassification, 'classificationVersionId' | 'categoryId'>>,
            department?: Maybe<Pick<ProductDepartmentClassification, 'classificationVersionId' | 'departmentId'>>,
            buyDepartment?: Maybe<Pick<ProductDepartmentClassification, 'classificationVersionId' | 'departmentId'>>,
            sellDepartment?: Maybe<Pick<ProductDepartmentClassification, 'classificationVersionId' | 'departmentId'>>,
            location?: Maybe<Pick<ProductLocationClassification, 'classificationVersionId' | 'locationId'>>,
            buyLocation?: Maybe<Pick<ProductLocationClassification, 'classificationVersionId' | 'locationId'>>,
            sellLocation?: Maybe<Pick<ProductLocationClassification, 'classificationVersionId' | 'locationId'>>,
          }>,
        prices?: Maybe<Array<(
          Pick<
            ProductVariantPrice,
            | 'id'
            | 'dataSourceId'
            | 'productId'
            | 'variantId'
            | 'externalId'
            | 'type'
            | 'createdAt'
            | 'updatedAt'
          >
          & { unitPrice: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        )>>,
      }
    )>> }
  ) };

export type ReadProductActivityQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
}>;


export type ReadProductActivityQuery = { readProductActivity: Array<Pick<
      ProductActivityEvent,
      | 'entityType'
      | 'entityId'
      | 'name'
      | 'eventType'
      | 'eventAt'
      | 'eventByUserId'
    >> };

export type DeleteProductGroupMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  productGroupId: Scalars['String']['input'];
}>;


export type DeleteProductGroupMutation = Pick<Mutation, 'deleteProductGroup'>;

export type SaveProductGroupMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  group: ProductGroupInput;
}>;


export type SaveProductGroupMutation = { saveProductGroup: Pick<
      ProductGroup,
      | 'id'
      | 'name'
      | 'description'
      | 'iconDisplayKey'
      | 'iconColorKey'
      | 'customIconObjectName'
      | 'customIconUrl'
      | 'createdAt'
      | 'updatedAt'
    > };

export type TransferProductsAndDeleteProductGroupMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  sourceProductGroupId: Scalars['String']['input'];
  targetProductGroupId: Scalars['String']['input'];
}>;


export type TransferProductsAndDeleteProductGroupMutation = Pick<Mutation, 'transferProductsAndDeleteProductGroup'>;

export type ListProductGroupsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListProductGroupsQuery = { listProductGroups: Array<Pick<
      ProductGroup,
      | 'id'
      | 'name'
      | 'description'
      | 'iconDisplayKey'
      | 'iconColorKey'
      | 'customIconObjectName'
      | 'customIconUrl'
      | 'createdAt'
      | 'updatedAt'
    >> };

export type ReadProductGroupQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  productGroupId: Scalars['String']['input'];
}>;


export type ReadProductGroupQuery = { readProductGroup: Pick<
      ProductGroup,
      | 'id'
      | 'name'
      | 'description'
      | 'iconDisplayKey'
      | 'iconColorKey'
      | 'customIconObjectName'
      | 'customIconUrl'
      | 'createdAt'
      | 'updatedAt'
    > };

export type QualityCheckWithEntitiesFieldsFragment = (
  { __typename: 'QualityCheckWithEntities' }
  & Pick<QualityCheckWithEntities, 'defaultInstruction'>
  & {
    check: (
      { __typename: 'QualityCheck' }
      & Pick<
        QualityCheck,
        | 'id'
        | 'legalEntityId'
        | 'organizationId'
        | 'name'
        | 'description'
        | 'qualityCheckType'
        | 'objectKind'
        | 'flaggedObjectKinds'
        | 'owner'
        | 'enabled'
        | 'lastRunAt'
        | 'status'
      >
    ),
    instruction?: Maybe<(
      { __typename: 'QualityCheckInstruction' }
      & Pick<
        QualityCheckInstruction,
        | 'id'
        | 'checkId'
        | 'authorId'
        | 'userInstruction'
        | 'versionNumber'
        | 'summary'
        | 'createdAt'
        | 'updatedAt'
      >
      & {
        userInstructionTags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
        summaryTags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
      }
    )>,
    entities?: Maybe<(
      { __typename: 'ObjectEntities' }
      & {
        users?: Maybe<Array<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>>,
        transactions?: Maybe<Array<(
          Pick<
            EntityTransaction,
            | 'viewId'
            | 'factId'
            | 'timestamp'
            | 'description'
            | 'externalId'
            | 'displayEntry'
          >
          & {
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            party?: Maybe<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
            displayCategory: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            splitCategory?: Maybe<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>,
          }
        )>>,
        comments?: Maybe<Array<Pick<
            EntityComment,
            | 'id'
            | 'authorId'
            | 'text'
            | 'timestamp'
          >>>,
        reports?: Maybe<Array<(
          Pick<
            EntityReport,
            | 'id'
            | 'title'
            | 'authorId'
            | 'mimeType'
            | 'createdAt'
          >
          & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
        )>>,
        reportPackages?: Maybe<Array<(
          Pick<
            EntityReportPackage,
            | 'id'
            | 'title'
            | 'authorId'
            | 'interval'
            | 'periodStartedAt'
            | 'periodEndedAt'
            | 'createdAt'
            | 'updatedAt'
            | 'coverUrl'
          >
          & { documents: Array<Pick<
              SharedReportDocumentMetadata,
              | 'id'
              | 'documentObjectId'
              | 'documentObjectVersionId'
              | 'title'
              | 'mimeType'
            >> }
        )>>,
        parties?: Maybe<Array<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>>,
        datasources?: Maybe<Array<Pick<
            EntityDataSource,
            | 'id'
            | 'name'
            | 'url'
            | 'iconUrl'
          >>>,
        categories?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>>,
        threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
        legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
        workItems?: Maybe<Array<(
          Pick<
            EntityWorkItem,
            | 'id'
            | 'time'
            | 'workItemState'
            | 'workItemType'
            | 'reviewCreatedById'
            | 'reviewState'
            | 'ledgerType'
          >
          & { objectTransaction: (
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          ) }
        )>>,
        invoices?: Maybe<Array<(
          Pick<
            EntityInvoice,
            | 'id'
            | 'externalDisplayId'
            | 'createdAt'
            | 'dueAt'
          >
          & {
            amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            customer: (
              Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
              & { party: Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                > }
            ),
          }
        )>>,
        bills?: Maybe<Array<(
          Pick<
            EntityBill,
            | 'id'
            | 'billStatus'
            | 'vendorName'
            | 'billDescription'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
            format: (
              Pick<Format, 'id' | 'formatClass'>
              & { segments: Array<Pick<
                  Segment,
                  | 'collectionId'
                  | 'fileId'
                  | 'sequence'
                  | 'token'
                >> }
            ),
            approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
          }
        )>>,
        identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
        departments?: Maybe<Array<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        locations?: Maybe<Array<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        reconciliations?: Maybe<Array<(
          { __typename: 'EntityReconciliation' }
          & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
          & {
            startDate: Pick<Date, 'year' | 'month' | 'day'>,
            endDate: Pick<Date, 'year' | 'month' | 'day'>,
          }
        )>>,
        ledgerTransactions?: Maybe<Array<(
          Pick<
            EntityLedgerTransaction,
            | 'id'
            | 'timestamp'
            | 'factIds'
            | 'name'
            | 'referenceNumber'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            parties: Array<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
          }
        )>>,
        schedules?: Maybe<Array<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
            | 'cutoverDate'
          >
          & {
            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>>,
      }
    )>,
  }
);

export type QualityCheckGroupFieldsFragment = (
  { __typename: 'QualityCheckGroup' }
  & Pick<QualityCheckGroup, 'name'>
  & { checks: Array<(
    { __typename: 'QualityCheck' }
    & Pick<
      QualityCheck,
      | 'id'
      | 'legalEntityId'
      | 'organizationId'
      | 'name'
      | 'description'
      | 'qualityCheckType'
      | 'objectKind'
      | 'flaggedObjectKinds'
      | 'owner'
      | 'enabled'
      | 'lastRunAt'
      | 'status'
    >
  )> }
);

export type QualityCheckFieldsFragment = (
  { __typename: 'QualityCheck' }
  & Pick<
    QualityCheck,
    | 'id'
    | 'legalEntityId'
    | 'organizationId'
    | 'name'
    | 'description'
    | 'qualityCheckType'
    | 'objectKind'
    | 'flaggedObjectKinds'
    | 'owner'
    | 'enabled'
    | 'lastRunAt'
    | 'status'
  >
);

export type QualityCheckInstructionFieldsFragment = (
  { __typename: 'QualityCheckInstruction' }
  & Pick<
    QualityCheckInstruction,
    | 'id'
    | 'checkId'
    | 'authorId'
    | 'userInstruction'
    | 'versionNumber'
    | 'summary'
    | 'createdAt'
    | 'updatedAt'
  >
  & {
    userInstructionTags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
    summaryTags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
  }
);

export type ConfirmCustomQualityCheckInstructionMutationVariables = Exact<{
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  checkId: Scalars['String']['input'];
  instructionId: Scalars['String']['input'];
}>;


export type ConfirmCustomQualityCheckInstructionMutation = Pick<Mutation, 'confirmCustomQualityCheckInstruction'>;

export type DraftCustomQualityCheckInstructionMutationVariables = Exact<{
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  checkId: Scalars['String']['input'];
  userInstruction: Scalars['String']['input'];
}>;


export type DraftCustomQualityCheckInstructionMutation = { draftCustomQualityCheckInstruction: (
    { __typename: 'QualityCheckInstruction' }
    & Pick<
      QualityCheckInstruction,
      | 'id'
      | 'checkId'
      | 'authorId'
      | 'userInstruction'
      | 'versionNumber'
      | 'summary'
      | 'createdAt'
      | 'updatedAt'
    >
    & {
      userInstructionTags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
      summaryTags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
    }
  ) };

export type ResetCustomQualityCheckInstructionMutationVariables = Exact<{
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  checkId: Scalars['String']['input'];
}>;


export type ResetCustomQualityCheckInstructionMutation = Pick<Mutation, 'resetCustomQualityCheckInstruction'>;

export type TriggerQualityCheckDryRunMutationVariables = Exact<{
  viewKey: ViewKey;
  checkId: Scalars['String']['input'];
  draftInstructionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TriggerQualityCheckDryRunMutation = Pick<Mutation, 'triggerQualityCheckDryRun'>;

export type UpdateQualityCheckMutationVariables = Exact<{
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  checkId: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
}>;


export type UpdateQualityCheckMutation = Pick<Mutation, 'updateQualityCheck'>;

export type ListQualityCheckGroupsQueryVariables = Exact<{
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListQualityCheckGroupsQuery = { listQualityCheckGroups: Array<(
    { __typename: 'QualityCheckGroup' }
    & Pick<QualityCheckGroup, 'name'>
    & { checks: Array<(
      { __typename: 'QualityCheck' }
      & Pick<
        QualityCheck,
        | 'id'
        | 'legalEntityId'
        | 'organizationId'
        | 'name'
        | 'description'
        | 'qualityCheckType'
        | 'objectKind'
        | 'flaggedObjectKinds'
        | 'owner'
        | 'enabled'
        | 'lastRunAt'
        | 'status'
      >
    )> }
  )> };

export type ReadQualityCheckQueryVariables = Exact<{
  viewKey?: InputMaybe<ViewKey>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  checkId: Scalars['String']['input'];
}>;


export type ReadQualityCheckQuery = { readQualityCheck?: Maybe<(
    { __typename: 'QualityCheckWithEntities' }
    & Pick<QualityCheckWithEntities, 'defaultInstruction'>
    & {
      check: (
        { __typename: 'QualityCheck' }
        & Pick<
          QualityCheck,
          | 'id'
          | 'legalEntityId'
          | 'organizationId'
          | 'name'
          | 'description'
          | 'qualityCheckType'
          | 'objectKind'
          | 'flaggedObjectKinds'
          | 'owner'
          | 'enabled'
          | 'lastRunAt'
          | 'status'
        >
      ),
      instruction?: Maybe<(
        { __typename: 'QualityCheckInstruction' }
        & Pick<
          QualityCheckInstruction,
          | 'id'
          | 'checkId'
          | 'authorId'
          | 'userInstruction'
          | 'versionNumber'
          | 'summary'
          | 'createdAt'
          | 'updatedAt'
        >
        & {
          userInstructionTags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
          summaryTags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
        }
      )>,
      entities?: Maybe<(
        { __typename: 'ObjectEntities' }
        & {
          users?: Maybe<Array<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>>,
          transactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          comments?: Maybe<Array<Pick<
              EntityComment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
            >>>,
          reports?: Maybe<Array<(
            Pick<
              EntityReport,
              | 'id'
              | 'title'
              | 'authorId'
              | 'mimeType'
              | 'createdAt'
            >
            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
          )>>,
          reportPackages?: Maybe<Array<(
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )>>,
          parties?: Maybe<Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>>,
          datasources?: Maybe<Array<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>>,
          categories?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>>,
          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
          workItems?: Maybe<Array<(
            Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )>>,
          invoices?: Maybe<Array<(
            Pick<
              EntityInvoice,
              | 'id'
              | 'externalDisplayId'
              | 'createdAt'
              | 'dueAt'
            >
            & {
              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              customer: (
                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                & { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              ),
            }
          )>>,
          bills?: Maybe<Array<(
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )>>,
          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
          departments?: Maybe<Array<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          locations?: Maybe<Array<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          reconciliations?: Maybe<Array<(
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )>>,
          ledgerTransactions?: Maybe<Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )>>,
          schedules?: Maybe<Array<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>>,
        }
      )>,
    }
  )> };

export type ReadQualityCheckDryRunQueryVariables = Exact<{
  viewKey: ViewKey;
  checkId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReadQualityCheckDryRunQuery = { readQualityCheckDryRun?: Maybe<(
    Pick<
      QualityCheckDryRun,
      | 'triggerId'
      | 'status'
      | 'flaggedCount'
      | 'timeRangeStartedAt'
      | 'timeRangeEndedAt'
    >
    & { results: Array<(
      Pick<
        ActionItem,
        | 'id'
        | 'title'
        | 'description'
        | 'status'
        | 'createdAt'
        | 'updatedAt'
        | 'organizationAssigneeIds'
        | 'action'
        | 'objectTimestamp'
        | 'flaggedObjectKinds'
      >
      & {
        author?: Maybe<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>,
        userAssignees: Array<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>,
        qualityCheck?: Maybe<Pick<QualityCheck, 'id' | 'qualityCheckType'>>,
        value:
          | (
            { __typename: 'ActionItemBillApproval' }
            & { bill: (
              Pick<
                EntityBill,
                | 'id'
                | 'billStatus'
                | 'vendorName'
                | 'billDescription'
              >
              & {
                totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
                format: (
                  Pick<Format, 'id' | 'formatClass'>
                  & { segments: Array<Pick<
                      Segment,
                      | 'collectionId'
                      | 'fileId'
                      | 'sequence'
                      | 'token'
                    >> }
                ),
                approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
              }
            ) }
          )
          | (
            { __typename: 'ActionItemCategory' }
            & { category: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              > }
          )
          | (
            { __typename: 'ActionItemClosedPeriodRequest' }
            & Pick<ActionItemClosedPeriodRequest, 'requestId' | 'requestType'>
            & { ledgerTransactions: Array<(
              Pick<
                EntityLedgerTransaction,
                | 'id'
                | 'timestamp'
                | 'factIds'
                | 'name'
                | 'referenceNumber'
              >
              & {
                totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                parties: Array<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
              }
            )> }
          )
          | (
            { __typename: 'ActionItemClosedPeriodTransactionRequest' }
            & Pick<ActionItemClosedPeriodTransactionRequest, 'requestId' | 'requestType'>
            & { ledgerTransaction: (
              Pick<
                EntityLedgerTransaction,
                | 'id'
                | 'timestamp'
                | 'factIds'
                | 'name'
                | 'referenceNumber'
              >
              & {
                totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                parties: Array<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
              }
            ) }
          )
          | (
            { __typename: 'ActionItemConnection' }
            & {
              connection: Pick<EntityConnection, 'id' | 'connectorId' | 'dataSourceId'>,
              dataSource: Pick<
                  EntityDataSource,
                  | 'id'
                  | 'name'
                  | 'url'
                  | 'iconUrl'
                >,
            }
          )
          | (
            { __typename: 'ActionItemLedgerTransaction' }
            & { ledgerTransaction: (
              Pick<
                EntityLedgerTransaction,
                | 'id'
                | 'timestamp'
                | 'factIds'
                | 'name'
                | 'referenceNumber'
              >
              & {
                totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                parties: Array<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
              }
            ) }
          )
          | (
            { __typename: 'ActionItemParty' }
            & { party: Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              > }
          )
          | (
            { __typename: 'ActionItemPublishedReport' }
            & { package: (
              Pick<
                EntityReportPackage,
                | 'id'
                | 'title'
                | 'authorId'
                | 'interval'
                | 'periodStartedAt'
                | 'periodEndedAt'
                | 'createdAt'
                | 'updatedAt'
                | 'coverUrl'
              >
              & { documents: Array<Pick<
                  SharedReportDocumentMetadata,
                  | 'id'
                  | 'documentObjectId'
                  | 'documentObjectVersionId'
                  | 'title'
                  | 'mimeType'
                >> }
            ) }
          )
          | (
            { __typename: 'ActionItemReconciliation' }
            & {
              reconciliation: (
                { __typename: 'EntityReconciliation' }
                & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
                & {
                  startDate: Pick<Date, 'year' | 'month' | 'day'>,
                  endDate: Pick<Date, 'year' | 'month' | 'day'>,
                }
              ),
              category: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              flags: Array<Pick<
                  ActionItemReconciliationFlag,
                  | 'flagId'
                  | 'reconciliationIntentId'
                  | 'flagType'
                  | 'createdAt'
                  | 'resolvedAt'
                  | 'resolutionType'
                >>,
            }
          )
          | (
            { __typename: 'ActionItemReviewDraftSchedule' }
            & { transaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )
          | (
            { __typename: 'ActionItemReviewImportedSchedule' }
            & Pick<ActionItemReviewImportedSchedule, 'scheduleImportCandidateId'>
          )
          | (
            { __typename: 'ActionItemThread' }
            & Pick<ActionItemThread, 'threadId'>
            & { targetEntity:
              | (
                { __typename: 'EntityBill' }
                & Pick<
                  EntityBill,
                  | 'id'
                  | 'billStatus'
                  | 'vendorName'
                  | 'billDescription'
                >
                & {
                  totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
                  format: (
                    Pick<Format, 'id' | 'formatClass'>
                    & { segments: Array<Pick<
                        Segment,
                        | 'collectionId'
                        | 'fileId'
                        | 'sequence'
                        | 'token'
                      >> }
                  ),
                  approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
                }
              )
              | (
                { __typename: 'EntityCategory' }
                & Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >
              )
              | { __typename: 'EntityComment' }
              | { __typename: 'EntityDataSource' }
              | (
                { __typename: 'EntityDepartment' }
                & Pick<
                  EntityDepartment,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )
              | { __typename: 'EntityIdentityVerification' }
              | { __typename: 'EntityInvoice' }
              | (
                { __typename: 'EntityLedgerTransaction' }
                & Pick<
                  EntityLedgerTransaction,
                  | 'id'
                  | 'timestamp'
                  | 'factIds'
                  | 'name'
                  | 'referenceNumber'
                >
                & {
                  totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  parties: Array<Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    >>,
                }
              )
              | { __typename: 'EntityLegalEntity' }
              | (
                { __typename: 'EntityLocation' }
                & Pick<
                  EntityLocation,
                  | 'id'
                  | 'name'
                  | 'parentId'
                  | 'active'
                >
              )
              | (
                { __typename: 'EntityParty' }
                & Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >
              )
              | { __typename: 'EntityProduct' }
              | (
                { __typename: 'EntityReconciliation' }
                & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
                & {
                  startDate: Pick<Date, 'year' | 'month' | 'day'>,
                  endDate: Pick<Date, 'year' | 'month' | 'day'>,
                }
              )
              | { __typename: 'EntityReport' }
              | (
                { __typename: 'EntityReportPackage' }
                & Pick<
                  EntityReportPackage,
                  | 'id'
                  | 'title'
                  | 'authorId'
                  | 'interval'
                  | 'periodStartedAt'
                  | 'periodEndedAt'
                  | 'createdAt'
                  | 'updatedAt'
                  | 'coverUrl'
                >
                & { documents: Array<Pick<
                    SharedReportDocumentMetadata,
                    | 'id'
                    | 'documentObjectId'
                    | 'documentObjectVersionId'
                    | 'title'
                    | 'mimeType'
                  >> }
              )
              | { __typename: 'EntitySchedule' }
              | { __typename: 'EntityThread' }
              | (
                { __typename: 'EntityTransaction' }
                & Pick<
                  EntityTransaction,
                  | 'viewId'
                  | 'factId'
                  | 'timestamp'
                  | 'description'
                  | 'externalId'
                  | 'displayEntry'
                >
                & {
                  moneyFlow: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ),
                  party?: Maybe<Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    >>,
                  displayCategory: Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >,
                  splitCategory?: Maybe<Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >>,
                }
              )
              | { __typename: 'EntityUser' }
              | (
                { __typename: 'EntityWorkItem' }
                & Pick<
                  EntityWorkItem,
                  | 'id'
                  | 'time'
                  | 'workItemState'
                  | 'workItemType'
                  | 'reviewCreatedById'
                  | 'reviewState'
                  | 'ledgerType'
                >
                & { objectTransaction: (
                  Pick<
                    EntityTransaction,
                    | 'viewId'
                    | 'factId'
                    | 'timestamp'
                    | 'description'
                    | 'externalId'
                    | 'displayEntry'
                  >
                  & {
                    moneyFlow: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ),
                    party?: Maybe<Pick<
                        EntityParty,
                        | 'id'
                        | 'name'
                        | 'iconUrl'
                        | 'shortDescription'
                        | 'roles'
                        | 'designation'
                      >>,
                    displayCategory: Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >,
                    splitCategory?: Maybe<Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >>,
                  }
                ) }
              )
             }
          )
          | (
            { __typename: 'ActionItemTransaction' }
            & {
              transaction: (
                Pick<
                  EntityTransaction,
                  | 'viewId'
                  | 'factId'
                  | 'timestamp'
                  | 'description'
                  | 'externalId'
                  | 'displayEntry'
                >
                & {
                  moneyFlow: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ),
                  party?: Maybe<Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    >>,
                  displayCategory: Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >,
                  splitCategory?: Maybe<Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >>,
                }
              ),
              categorySuggestions?: Maybe<Array<Pick<
                  CategorySuggestion,
                  | 'dataSourceId'
                  | 'transactionFactId'
                  | 'classificationVersionId'
                  | 'categoryId'
                  | 'type'
                  | 'modelConfidence'
                  | 'modelVersionId'
                  | 'priority'
                  | 'createdAt'
                  | 'updatedAt'
                >>>,
            }
          )
          | (
            { __typename: 'ActionItemUploadStatement' }
            & { category: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              > }
          )
        ,
      }
    )> }
  )> };

export type CompanyDetailsFieldsFragment = (
  Pick<
    CompanyDetails,
    | 'categories'
    | 'companyName'
    | 'websiteURL'
    | 'companySize'
    | 'incorporationState'
    | 'entityType'
    | 'subsidiaryCount'
    | 'foreignSubsidiaryCount'
    | 'incorporationYear'
    | 'lastTaxFiling'
  >
  & { address?: Maybe<Pick<
      Address,
      | 'street'
      | 'streetAdditional'
      | 'city'
      | 'region'
      | 'postalCode'
      | 'countryCode'
      | 'lat'
      | 'long'
    >> }
);

export type CompanyFinancialValueFieldsFragment = Pick<CompanyFinancialValue, 'name' | 'institutionId'>;

export type CompanyFinancialsFieldsFragment = (
  Pick<CompanyFinancials, 'product'>
  & { values: Array<Pick<CompanyFinancialValue, 'name' | 'institutionId'>> }
);

export type QuotePackageFieldsFragment = (
  Pick<QuotePackage, 'id' | 'contractDocumentId' | 'status'>
  & {
    recipient?: Maybe<Pick<
        Contact,
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
    companyDetails: (
      Pick<
        CompanyDetails,
        | 'categories'
        | 'companyName'
        | 'websiteURL'
        | 'companySize'
        | 'incorporationState'
        | 'entityType'
        | 'subsidiaryCount'
        | 'foreignSubsidiaryCount'
        | 'incorporationYear'
        | 'lastTaxFiling'
      >
      & { address?: Maybe<Pick<
          Address,
          | 'street'
          | 'streetAdditional'
          | 'city'
          | 'region'
          | 'postalCode'
          | 'countryCode'
          | 'lat'
          | 'long'
        >> }
    ),
    financials?: Maybe<Array<(
      Pick<CompanyFinancials, 'product'>
      & { values: Array<Pick<CompanyFinancialValue, 'name' | 'institutionId'>> }
    )>>,
  }
);

export type UpdateQuotePackageMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  recipient?: InputMaybe<ContactInput>;
  contractDocumentId?: InputMaybe<Scalars['String']['input']>;
  companyDetails: CompanyDetailsInput;
}>;


export type UpdateQuotePackageMutation = Pick<Mutation, 'updateQuotePackage'>;

export type ListQuotePackagesByLegalEntityQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListQuotePackagesByLegalEntityQuery = { listQuotePackagesByLegalEntity?: Maybe<Array<(
    Pick<QuotePackage, 'id' | 'contractDocumentId' | 'status'>
    & {
      recipient?: Maybe<Pick<
          Contact,
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >>,
      companyDetails: (
        Pick<
          CompanyDetails,
          | 'categories'
          | 'companyName'
          | 'websiteURL'
          | 'companySize'
          | 'incorporationState'
          | 'entityType'
          | 'subsidiaryCount'
          | 'foreignSubsidiaryCount'
          | 'incorporationYear'
          | 'lastTaxFiling'
        >
        & { address?: Maybe<Pick<
            Address,
            | 'street'
            | 'streetAdditional'
            | 'city'
            | 'region'
            | 'postalCode'
            | 'countryCode'
            | 'lat'
            | 'long'
          >> }
      ),
      financials?: Maybe<Array<(
        Pick<CompanyFinancials, 'product'>
        & { values: Array<Pick<CompanyFinancialValue, 'name' | 'institutionId'>> }
      )>>,
    }
  )>> };

export type AgingSummaryFieldsFragment = (
  Pick<AgingSummary, 'label'>
  & { dimensionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & {
      aging: Array<{ summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ) }>,
      summary: (
        Pick<TransactionSummary, 'isPeriodBookClosed'>
        & {
          period: Pick<
              Period,
              | 'name'
              | 'interval'
              | 'startedAt'
              | 'endedAt'
            >,
          total: (
            Pick<
              PeriodMonetaryValue,
              | 'transactionsCount'
              | 'deltaPrevious'
              | 'deltaYearAgo'
              | 'isFirstOccurrencePeriod'
            >
            & {
              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              moneyFlow?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              current?: Maybe<(
                Pick<SummaryTotal, 'count'>
                & { total: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
              prior?: Maybe<(
                Pick<SummaryTotal, 'count'>
                & { total: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
            }
          ),
        }
      ),
    }
  ) }
);

export type LeafAgingSummaryFieldsFragment = (
  Pick<LeafAgingSummary, 'dueDate' | 'referenceNumber' | 'invoiceDate'>
  & {
    amounts: Array<(
      Pick<LeafAgingSummaryAmount, 'column'>
      & { moneyFlow: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ) }
    )>,
    link: Pick<LeafAgingSummaryLink, 'hasLink'>,
  }
);

export type ReportAutomationSettingsFieldsFragment = Pick<
    ReportAutomationSettings,
    | 'organizationId'
    | 'legalEntityId'
    | 'interval'
    | 'autoCreateDraft'
    | 'autoPublishDraft'
    | 'autoPublishDraftDay'
    | 'autoPublishFinal'
    | 'autoPublishFinalDay'
  >;

export type ReportFieldsFragment = (
  Pick<
    Report,
    | 'id'
    | 'versionId'
    | 'title'
    | 'status'
    | 'interval'
    | 'createdAt'
  >
  & {
    author?: Maybe<Pick<
        Contact,
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
    reportFile: Pick<
        ReportFileMetadata,
        | 'id'
        | 'fileName'
        | 'mimeType'
        | 'fileSize'
        | 'source'
      >,
    reportFor?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
    generationHistory?: Maybe<Pick<
        ReportGenerationHistory,
        | 'id'
        | 'requestId'
        | 'reportId'
        | 'versionId'
        | 'legalEntityId'
        | 'authorId'
        | 'viewVersion'
        | 'kind'
        | 'timezone'
        | 'periodStartedAt'
        | 'periodEndedAt'
        | 'generationStartedAt'
        | 'generationEndedAt'
        | 'error'
        | 'createdAt'
        | 'updatedAt'
      >>,
    options?: Maybe<(
      { __typename: 'ReportDocumentOptions' }
      & Pick<
        ReportDocumentOptions,
        | 'sparklineLookbackPeriods'
        | 'reportLookbackPeriods'
        | 'deltaMonthOverMonth'
        | 'deltaMonthOverMonthPeriods'
        | 'deltaYearOverYear'
        | 'comparedToTotal'
        | 'comparedToIncome'
        | 'amountPrecision'
        | 'yearToDate'
        | 'deltaYearToDate'
        | 'breakdownByClass'
      >
      & {
        collapsedSections?: Maybe<Pick<CollapsedSections, 'sections'>>,
        categoryByDepartmentOptions?: Maybe<(
          Pick<CategoryByDepartmentOptions, 'showOther' | 'showUnassigned'>
          & { departments?: Maybe<Array<Pick<DepartmentOption, 'departmentId' | 'name'>>> }
        )>,
        categoryByLocationOptions?: Maybe<(
          Pick<CategoryByLocationOptions, 'showOther' | 'showUnassigned'>
          & { locations?: Maybe<Array<Pick<LocationOption, 'locationId' | 'name'>>> }
        )>,
      }
    )>,
  }
);

export type ReportOptionsFieldsFragment = (
  { __typename: 'ReportDocumentOptions' }
  & Pick<
    ReportDocumentOptions,
    | 'sparklineLookbackPeriods'
    | 'reportLookbackPeriods'
    | 'deltaMonthOverMonth'
    | 'deltaMonthOverMonthPeriods'
    | 'deltaYearOverYear'
    | 'comparedToTotal'
    | 'comparedToIncome'
    | 'amountPrecision'
    | 'yearToDate'
    | 'deltaYearToDate'
    | 'breakdownByClass'
  >
  & {
    collapsedSections?: Maybe<Pick<CollapsedSections, 'sections'>>,
    categoryByDepartmentOptions?: Maybe<(
      Pick<CategoryByDepartmentOptions, 'showOther' | 'showUnassigned'>
      & { departments?: Maybe<Array<Pick<DepartmentOption, 'departmentId' | 'name'>>> }
    )>,
    categoryByLocationOptions?: Maybe<(
      Pick<CategoryByLocationOptions, 'showOther' | 'showUnassigned'>
      & { locations?: Maybe<Array<Pick<LocationOption, 'locationId' | 'name'>>> }
    )>,
  }
);

export type ReportPackageFieldsFragment = (
  Pick<
    ReportPackage,
    | 'id'
    | 'versionId'
    | 'title'
    | 'status'
    | 'createdAt'
    | 'updatedAt'
    | 'startedAt'
    | 'endedAt'
    | 'interval'
  >
  & {
    viewKey: Pick<
        ViewIdentifier,
        | 'legalEntityId'
        | 'viewVersion'
        | 'mutationVersion'
        | 'viewType'
      >,
    author?: Maybe<Pick<
        Contact,
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
    authorOrganization?: Maybe<Pick<
        OrganizationPreview,
        | 'id'
        | 'slug'
        | 'name'
        | 'iconUrl'
      >>,
    legalEntityOrganization?: Maybe<Pick<
        OrganizationPreview,
        | 'id'
        | 'slug'
        | 'name'
        | 'iconUrl'
      >>,
    packageOptions?: Maybe<Pick<
        ReportPackageOptions,
        | 'customFooter'
        | 'preparedBy'
        | 'accountNumbersDisplay'
        | 'coverUrl'
        | 'coverLogoSource'
        | 'publishedAsDraft'
      >>,
    documents: Array<{
        metadata: (
          Pick<
            ReportPackageDocumentMetadata,
            | 'id'
            | 'title'
            | 'documentObjectId'
            | 'documentObjectVersionId'
            | 'type'
            | 'status'
            | 'position'
          >
          & {
            reportFile?: Maybe<Pick<
                ReportFileMetadata,
                | 'id'
                | 'fileName'
                | 'mimeType'
                | 'fileSize'
                | 'source'
              >>,
            generationHistory?: Maybe<Pick<
                ReportGenerationHistory,
                | 'id'
                | 'requestId'
                | 'reportId'
                | 'versionId'
                | 'legalEntityId'
                | 'authorId'
                | 'viewVersion'
                | 'kind'
                | 'timezone'
                | 'periodStartedAt'
                | 'periodEndedAt'
                | 'generationStartedAt'
                | 'generationEndedAt'
                | 'error'
                | 'createdAt'
                | 'updatedAt'
              >>,
          }
        ),
        document?: Maybe<
          | Pick<
              LayoutDocument,
              | 'id'
              | 'title'
              | 'layoutId'
              | 'status'
              | 'createdAt'
              | 'updatedAt'
            >
          | (
            Pick<
              Report,
              | 'id'
              | 'versionId'
              | 'title'
              | 'status'
              | 'interval'
              | 'createdAt'
            >
            & {
              author?: Maybe<Pick<
                  Contact,
                  | 'givenName'
                  | 'familyName'
                  | 'emailAddress'
                  | 'avatarUrl'
                >>,
              reportFile: Pick<
                  ReportFileMetadata,
                  | 'id'
                  | 'fileName'
                  | 'mimeType'
                  | 'fileSize'
                  | 'source'
                >,
              reportFor?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              generationHistory?: Maybe<Pick<
                  ReportGenerationHistory,
                  | 'id'
                  | 'requestId'
                  | 'reportId'
                  | 'versionId'
                  | 'legalEntityId'
                  | 'authorId'
                  | 'viewVersion'
                  | 'kind'
                  | 'timezone'
                  | 'periodStartedAt'
                  | 'periodEndedAt'
                  | 'generationStartedAt'
                  | 'generationEndedAt'
                  | 'error'
                  | 'createdAt'
                  | 'updatedAt'
                >>,
              options?: Maybe<(
                { __typename: 'ReportDocumentOptions' }
                & Pick<
                  ReportDocumentOptions,
                  | 'sparklineLookbackPeriods'
                  | 'reportLookbackPeriods'
                  | 'deltaMonthOverMonth'
                  | 'deltaMonthOverMonthPeriods'
                  | 'deltaYearOverYear'
                  | 'comparedToTotal'
                  | 'comparedToIncome'
                  | 'amountPrecision'
                  | 'yearToDate'
                  | 'deltaYearToDate'
                  | 'breakdownByClass'
                >
                & {
                  collapsedSections?: Maybe<Pick<CollapsedSections, 'sections'>>,
                  categoryByDepartmentOptions?: Maybe<(
                    Pick<CategoryByDepartmentOptions, 'showOther' | 'showUnassigned'>
                    & { departments?: Maybe<Array<Pick<DepartmentOption, 'departmentId' | 'name'>>> }
                  )>,
                  categoryByLocationOptions?: Maybe<(
                    Pick<CategoryByLocationOptions, 'showOther' | 'showUnassigned'>
                    & { locations?: Maybe<Array<Pick<LocationOption, 'locationId' | 'name'>>> }
                  )>,
                }
              )>,
            }
          )
          | Pick<
              TextDocument,
              | 'id'
              | 'title'
              | 'summary'
              | 'status'
              | 'createdAt'
              | 'updatedAt'
            >
        >,
      }>,
    entities: (
      { __typename: 'ObjectEntities' }
      & {
        users?: Maybe<Array<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>>,
        transactions?: Maybe<Array<(
          Pick<
            EntityTransaction,
            | 'viewId'
            | 'factId'
            | 'timestamp'
            | 'description'
            | 'externalId'
            | 'displayEntry'
          >
          & {
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            party?: Maybe<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
            displayCategory: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            splitCategory?: Maybe<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>,
          }
        )>>,
        comments?: Maybe<Array<Pick<
            EntityComment,
            | 'id'
            | 'authorId'
            | 'text'
            | 'timestamp'
          >>>,
        reports?: Maybe<Array<(
          Pick<
            EntityReport,
            | 'id'
            | 'title'
            | 'authorId'
            | 'mimeType'
            | 'createdAt'
          >
          & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
        )>>,
        reportPackages?: Maybe<Array<(
          Pick<
            EntityReportPackage,
            | 'id'
            | 'title'
            | 'authorId'
            | 'interval'
            | 'periodStartedAt'
            | 'periodEndedAt'
            | 'createdAt'
            | 'updatedAt'
            | 'coverUrl'
          >
          & { documents: Array<Pick<
              SharedReportDocumentMetadata,
              | 'id'
              | 'documentObjectId'
              | 'documentObjectVersionId'
              | 'title'
              | 'mimeType'
            >> }
        )>>,
        parties?: Maybe<Array<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>>,
        datasources?: Maybe<Array<Pick<
            EntityDataSource,
            | 'id'
            | 'name'
            | 'url'
            | 'iconUrl'
          >>>,
        categories?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>>,
        threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
        legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
        workItems?: Maybe<Array<(
          Pick<
            EntityWorkItem,
            | 'id'
            | 'time'
            | 'workItemState'
            | 'workItemType'
            | 'reviewCreatedById'
            | 'reviewState'
            | 'ledgerType'
          >
          & { objectTransaction: (
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          ) }
        )>>,
        invoices?: Maybe<Array<(
          Pick<
            EntityInvoice,
            | 'id'
            | 'externalDisplayId'
            | 'createdAt'
            | 'dueAt'
          >
          & {
            amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            customer: (
              Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
              & { party: Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                > }
            ),
          }
        )>>,
        bills?: Maybe<Array<(
          Pick<
            EntityBill,
            | 'id'
            | 'billStatus'
            | 'vendorName'
            | 'billDescription'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
            format: (
              Pick<Format, 'id' | 'formatClass'>
              & { segments: Array<Pick<
                  Segment,
                  | 'collectionId'
                  | 'fileId'
                  | 'sequence'
                  | 'token'
                >> }
            ),
            approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
          }
        )>>,
        identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
        departments?: Maybe<Array<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        locations?: Maybe<Array<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        reconciliations?: Maybe<Array<(
          { __typename: 'EntityReconciliation' }
          & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
          & {
            startDate: Pick<Date, 'year' | 'month' | 'day'>,
            endDate: Pick<Date, 'year' | 'month' | 'day'>,
          }
        )>>,
        ledgerTransactions?: Maybe<Array<(
          Pick<
            EntityLedgerTransaction,
            | 'id'
            | 'timestamp'
            | 'factIds'
            | 'name'
            | 'referenceNumber'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            parties: Array<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
          }
        )>>,
        schedules?: Maybe<Array<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
            | 'cutoverDate'
          >
          & {
            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>>,
      }
    ),
    version: Pick<
        ReportPackageVersionMetadata,
        | 'id'
        | 'status'
        | 'createdAt'
        | 'updatedAt'
      >,
  }
);

export type StatementDeltasFieldsFragment = {
    percentageTotal?: Maybe<(
      Pick<StatementDeltaValue, 'percentageOfAmount'>
      & { moneyFlow: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ) }
    )>,
    percentageIncome?: Maybe<(
      Pick<StatementDeltaValue, 'percentageOfAmount'>
      & { moneyFlow: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ) }
    )>,
    previousPeriod?: Maybe<(
      Pick<StatementDeltaValue, 'percentageOfAmount'>
      & { moneyFlow: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ) }
    )>,
    previousYear?: Maybe<(
      Pick<StatementDeltaValue, 'percentageOfAmount'>
      & { moneyFlow: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ) }
    )>,
  };

export type StatementDeltaValueFieldsFragment = (
  Pick<StatementDeltaValue, 'percentageOfAmount'>
  & { moneyFlow: (
    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
  ) }
);

export type StatementDetailsFieldsFragment = {
    hover:
      | (
        { __typename: 'CategoryHover' }
        & Pick<CategoryHover, 'balance'>
        & {
          entity: (
            { __typename: 'EntityCategory' }
            & Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >
          ),
          history: (
            Pick<DimensionSummary, 'partialData'>
            & {
              time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }>,
              department: Array<(
                Pick<DepartmentDimension, 'departmentId'>
                & {
                  departmentObject: (
                    { __typename: 'EntityDepartment' }
                    & Pick<
                      EntityDepartment,
                      | 'id'
                      | 'name'
                      | 'parentId'
                      | 'active'
                    >
                  ),
                  by: { time: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }> },
                }
              )>,
              location: Array<(
                Pick<LocationDimension, 'locationId'>
                & {
                  locationObject: (
                    { __typename: 'EntityLocation' }
                    & Pick<
                      EntityLocation,
                      | 'id'
                      | 'name'
                      | 'parentId'
                      | 'active'
                    >
                  ),
                  by: { time: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }> },
                }
              )>,
            }
          ),
          context?: Maybe<(
            Pick<DimensionSummary, 'partialData'>
            & { party: Array<{
                partyObject: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >,
                summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ),
              }> }
          )>,
          topTransactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          missingClass?: Maybe<{ time: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }> }>,
          otherClass?: Maybe<{ time: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }> }>,
        }
      )
      | (
        { __typename: 'PartyHover' }
        & {
          entity: (
            { __typename: 'EntityParty' }
            & Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >
          ),
          history: (
            Pick<DimensionSummary, 'partialData'>
            & { time: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }> }
          ),
          context?: Maybe<(
            Pick<DimensionSummary, 'partialData'>
            & { category: Array<{
                categoryObject: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ),
              }> }
          )>,
          topTransactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
        }
      )
      | (
        { __typename: 'SummaryLineItemHover' }
        & Pick<SummaryLineItemHover, 'lineType'>
        & {
          history: (
            Pick<DimensionSummary, 'partialData'>
            & {
              time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }>,
              department: Array<(
                Pick<DepartmentDimension, 'departmentId'>
                & {
                  departmentObject: (
                    { __typename: 'EntityDepartment' }
                    & Pick<
                      EntityDepartment,
                      | 'id'
                      | 'name'
                      | 'parentId'
                      | 'active'
                    >
                  ),
                  by: { time: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }> },
                }
              )>,
              location: Array<(
                Pick<LocationDimension, 'locationId'>
                & {
                  locationObject: (
                    { __typename: 'EntityLocation' }
                    & Pick<
                      EntityLocation,
                      | 'id'
                      | 'name'
                      | 'parentId'
                      | 'active'
                    >
                  ),
                  by: { time: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }> },
                }
              )>,
            }
          ),
          missingClass?: Maybe<{ time: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }> }>,
          otherClass?: Maybe<{ time: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }> }>,
        }
      )
    ,
    insight?: Maybe<(
      Pick<
        Insight,
        | 'score'
        | 'globalScore'
        | 'subjectType'
        | 'subjectId'
        | 'subjectDisplayKey'
        | 'comparisonIntervalOffset'
        | 'ruleType'
        | 'sentence'
        | 'subjectIconUrl'
        | 'designation'
        | 'type'
        | 'productArea'
      >
      & {
        periodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        absoluteDelta?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        comparisonPeriodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
      }
    )>,
  };

export type YtdStatementDetailsFieldsFragment = {
    hover:
      | (
        { __typename: 'CategoryHover' }
        & Pick<CategoryHover, 'balance'>
        & {
          entity: (
            { __typename: 'EntityCategory' }
            & Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >
          ),
          history: (
            Pick<DimensionSummary, 'partialData'>
            & { time: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }> }
          ),
          context?: Maybe<(
            Pick<DimensionSummary, 'partialData'>
            & { party: Array<{
                partyObject: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >,
                summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ),
              }> }
          )>,
          topTransactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
        }
      )
      | (
        { __typename: 'PartyHover' }
        & {
          entity: (
            { __typename: 'EntityParty' }
            & Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >
          ),
          history: (
            Pick<DimensionSummary, 'partialData'>
            & { time: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }> }
          ),
          context?: Maybe<(
            Pick<DimensionSummary, 'partialData'>
            & { category: Array<{
                categoryObject: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ),
              }> }
          )>,
          topTransactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
        }
      )
      | (
        { __typename: 'SummaryLineItemHover' }
        & Pick<SummaryLineItemHover, 'lineType'>
        & { history: (
          Pick<DimensionSummary, 'partialData'>
          & { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> }
        ) }
      )
    ,
    insight?: Maybe<(
      Pick<
        Insight,
        | 'score'
        | 'globalScore'
        | 'subjectType'
        | 'subjectId'
        | 'subjectDisplayKey'
        | 'comparisonIntervalOffset'
        | 'ruleType'
        | 'sentence'
        | 'subjectIconUrl'
        | 'designation'
        | 'type'
        | 'productArea'
      >
      & {
        periodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        absoluteDelta?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        comparisonPeriodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
      }
    )>,
  };

export type StatementFieldsFragment = (
  Pick<Statement, 'kind'>
  & { rows: Array<(
    Pick<StatementRow, 'rowId' | 'depth'>
    & {
      sectionTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
      sectionSummary?: Maybe<(
        Pick<StatementRowSummary, 'displayNumber' | 'label'>
        & { moneyFlow: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ) }
      )>,
      parentCategoryTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
      parentCategorySummary?: Maybe<(
        Pick<StatementRowSummary, 'displayNumber' | 'label'>
        & { moneyFlow: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ) }
      )>,
      leafCategorySummary?: Maybe<(
        Pick<StatementRowSummary, 'displayNumber' | 'label'>
        & { moneyFlow: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ) }
      )>,
      agingTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
      agingSummary?: Maybe<(
        Pick<AgingSummary, 'label'>
        & { dimensionSummary: (
          Pick<DimensionSummary, 'partialData'>
          & {
            aging: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }>,
            summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ),
          }
        ) }
      )>,
      parentAgingTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
      parentAgingSummary?: Maybe<(
        Pick<AgingSummary, 'label'>
        & { dimensionSummary: (
          Pick<DimensionSummary, 'partialData'>
          & {
            aging: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }>,
            summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ),
          }
        ) }
      )>,
      leafAgingSummary?: Maybe<(
        Pick<LeafAgingSummary, 'dueDate' | 'referenceNumber' | 'invoiceDate'>
        & {
          amounts: Array<(
            Pick<LeafAgingSummaryAmount, 'column'>
            & { moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ) }
          )>,
          link: Pick<LeafAgingSummaryLink, 'hasLink'>,
        }
      )>,
      details?: Maybe<{
          hover:
            | (
              { __typename: 'CategoryHover' }
              & Pick<CategoryHover, 'balance'>
              & {
                entity: (
                  { __typename: 'EntityCategory' }
                  & Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >
                ),
                history: (
                  Pick<DimensionSummary, 'partialData'>
                  & {
                    time: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }>,
                    department: Array<(
                      Pick<DepartmentDimension, 'departmentId'>
                      & {
                        departmentObject: (
                          { __typename: 'EntityDepartment' }
                          & Pick<
                            EntityDepartment,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        ),
                        by: { time: Array<{ summary: (
                              Pick<TransactionSummary, 'isPeriodBookClosed'>
                              & {
                                period: Pick<
                                    Period,
                                    | 'name'
                                    | 'interval'
                                    | 'startedAt'
                                    | 'endedAt'
                                  >,
                                total: (
                                  Pick<
                                    PeriodMonetaryValue,
                                    | 'transactionsCount'
                                    | 'deltaPrevious'
                                    | 'deltaYearAgo'
                                    | 'isFirstOccurrencePeriod'
                                  >
                                  & {
                                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                    moneyFlow?: Maybe<(
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    )>,
                                    current?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                    prior?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                  }
                                ),
                              }
                            ) }> },
                      }
                    )>,
                    location: Array<(
                      Pick<LocationDimension, 'locationId'>
                      & {
                        locationObject: (
                          { __typename: 'EntityLocation' }
                          & Pick<
                            EntityLocation,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        ),
                        by: { time: Array<{ summary: (
                              Pick<TransactionSummary, 'isPeriodBookClosed'>
                              & {
                                period: Pick<
                                    Period,
                                    | 'name'
                                    | 'interval'
                                    | 'startedAt'
                                    | 'endedAt'
                                  >,
                                total: (
                                  Pick<
                                    PeriodMonetaryValue,
                                    | 'transactionsCount'
                                    | 'deltaPrevious'
                                    | 'deltaYearAgo'
                                    | 'isFirstOccurrencePeriod'
                                  >
                                  & {
                                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                    moneyFlow?: Maybe<(
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    )>,
                                    current?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                    prior?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                  }
                                ),
                              }
                            ) }> },
                      }
                    )>,
                  }
                ),
                context?: Maybe<(
                  Pick<DimensionSummary, 'partialData'>
                  & { party: Array<{
                      partyObject: Pick<
                          EntityParty,
                          | 'id'
                          | 'name'
                          | 'iconUrl'
                          | 'shortDescription'
                          | 'roles'
                          | 'designation'
                        >,
                      summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ),
                    }> }
                )>,
                topTransactions?: Maybe<Array<(
                  Pick<
                    EntityTransaction,
                    | 'viewId'
                    | 'factId'
                    | 'timestamp'
                    | 'description'
                    | 'externalId'
                    | 'displayEntry'
                  >
                  & {
                    moneyFlow: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ),
                    party?: Maybe<Pick<
                        EntityParty,
                        | 'id'
                        | 'name'
                        | 'iconUrl'
                        | 'shortDescription'
                        | 'roles'
                        | 'designation'
                      >>,
                    displayCategory: Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >,
                    splitCategory?: Maybe<Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >>,
                  }
                )>>,
                missingClass?: Maybe<{ time: Array<{ summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ) }> }>,
                otherClass?: Maybe<{ time: Array<{ summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ) }> }>,
              }
            )
            | (
              { __typename: 'PartyHover' }
              & {
                entity: (
                  { __typename: 'EntityParty' }
                  & Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >
                ),
                history: (
                  Pick<DimensionSummary, 'partialData'>
                  & { time: Array<{ summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ) }> }
                ),
                context?: Maybe<(
                  Pick<DimensionSummary, 'partialData'>
                  & { category: Array<{
                      categoryObject: Pick<
                          EntityCategory,
                          | 'id'
                          | 'name'
                          | 'displayKey'
                          | 'chartOfAccountsDisplayNumber'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'productArea'
                          | 'active'
                        >,
                      summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ),
                    }> }
                )>,
                topTransactions?: Maybe<Array<(
                  Pick<
                    EntityTransaction,
                    | 'viewId'
                    | 'factId'
                    | 'timestamp'
                    | 'description'
                    | 'externalId'
                    | 'displayEntry'
                  >
                  & {
                    moneyFlow: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ),
                    party?: Maybe<Pick<
                        EntityParty,
                        | 'id'
                        | 'name'
                        | 'iconUrl'
                        | 'shortDescription'
                        | 'roles'
                        | 'designation'
                      >>,
                    displayCategory: Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >,
                    splitCategory?: Maybe<Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >>,
                  }
                )>>,
              }
            )
            | (
              { __typename: 'SummaryLineItemHover' }
              & Pick<SummaryLineItemHover, 'lineType'>
              & {
                history: (
                  Pick<DimensionSummary, 'partialData'>
                  & {
                    time: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }>,
                    department: Array<(
                      Pick<DepartmentDimension, 'departmentId'>
                      & {
                        departmentObject: (
                          { __typename: 'EntityDepartment' }
                          & Pick<
                            EntityDepartment,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        ),
                        by: { time: Array<{ summary: (
                              Pick<TransactionSummary, 'isPeriodBookClosed'>
                              & {
                                period: Pick<
                                    Period,
                                    | 'name'
                                    | 'interval'
                                    | 'startedAt'
                                    | 'endedAt'
                                  >,
                                total: (
                                  Pick<
                                    PeriodMonetaryValue,
                                    | 'transactionsCount'
                                    | 'deltaPrevious'
                                    | 'deltaYearAgo'
                                    | 'isFirstOccurrencePeriod'
                                  >
                                  & {
                                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                    moneyFlow?: Maybe<(
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    )>,
                                    current?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                    prior?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                  }
                                ),
                              }
                            ) }> },
                      }
                    )>,
                    location: Array<(
                      Pick<LocationDimension, 'locationId'>
                      & {
                        locationObject: (
                          { __typename: 'EntityLocation' }
                          & Pick<
                            EntityLocation,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        ),
                        by: { time: Array<{ summary: (
                              Pick<TransactionSummary, 'isPeriodBookClosed'>
                              & {
                                period: Pick<
                                    Period,
                                    | 'name'
                                    | 'interval'
                                    | 'startedAt'
                                    | 'endedAt'
                                  >,
                                total: (
                                  Pick<
                                    PeriodMonetaryValue,
                                    | 'transactionsCount'
                                    | 'deltaPrevious'
                                    | 'deltaYearAgo'
                                    | 'isFirstOccurrencePeriod'
                                  >
                                  & {
                                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                    moneyFlow?: Maybe<(
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    )>,
                                    current?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                    prior?: Maybe<(
                                      Pick<SummaryTotal, 'count'>
                                      & { total: (
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      ) }
                                    )>,
                                  }
                                ),
                              }
                            ) }> },
                      }
                    )>,
                  }
                ),
                missingClass?: Maybe<{ time: Array<{ summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ) }> }>,
                otherClass?: Maybe<{ time: Array<{ summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ) }> }>,
              }
            )
          ,
          insight?: Maybe<(
            Pick<
              Insight,
              | 'score'
              | 'globalScore'
              | 'subjectType'
              | 'subjectId'
              | 'subjectDisplayKey'
              | 'comparisonIntervalOffset'
              | 'ruleType'
              | 'sentence'
              | 'subjectIconUrl'
              | 'designation'
              | 'type'
              | 'productArea'
            >
            & {
              periodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              absoluteDelta?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              comparisonPeriodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>,
        }>,
      ytdDetails?: Maybe<{
          hover:
            | (
              { __typename: 'CategoryHover' }
              & Pick<CategoryHover, 'balance'>
              & {
                entity: (
                  { __typename: 'EntityCategory' }
                  & Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >
                ),
                history: (
                  Pick<DimensionSummary, 'partialData'>
                  & { time: Array<{ summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ) }> }
                ),
                context?: Maybe<(
                  Pick<DimensionSummary, 'partialData'>
                  & { party: Array<{
                      partyObject: Pick<
                          EntityParty,
                          | 'id'
                          | 'name'
                          | 'iconUrl'
                          | 'shortDescription'
                          | 'roles'
                          | 'designation'
                        >,
                      summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ),
                    }> }
                )>,
                topTransactions?: Maybe<Array<(
                  Pick<
                    EntityTransaction,
                    | 'viewId'
                    | 'factId'
                    | 'timestamp'
                    | 'description'
                    | 'externalId'
                    | 'displayEntry'
                  >
                  & {
                    moneyFlow: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ),
                    party?: Maybe<Pick<
                        EntityParty,
                        | 'id'
                        | 'name'
                        | 'iconUrl'
                        | 'shortDescription'
                        | 'roles'
                        | 'designation'
                      >>,
                    displayCategory: Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >,
                    splitCategory?: Maybe<Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >>,
                  }
                )>>,
              }
            )
            | (
              { __typename: 'PartyHover' }
              & {
                entity: (
                  { __typename: 'EntityParty' }
                  & Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >
                ),
                history: (
                  Pick<DimensionSummary, 'partialData'>
                  & { time: Array<{ summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ) }> }
                ),
                context?: Maybe<(
                  Pick<DimensionSummary, 'partialData'>
                  & { category: Array<{
                      categoryObject: Pick<
                          EntityCategory,
                          | 'id'
                          | 'name'
                          | 'displayKey'
                          | 'chartOfAccountsDisplayNumber'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'productArea'
                          | 'active'
                        >,
                      summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ),
                    }> }
                )>,
                topTransactions?: Maybe<Array<(
                  Pick<
                    EntityTransaction,
                    | 'viewId'
                    | 'factId'
                    | 'timestamp'
                    | 'description'
                    | 'externalId'
                    | 'displayEntry'
                  >
                  & {
                    moneyFlow: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ),
                    party?: Maybe<Pick<
                        EntityParty,
                        | 'id'
                        | 'name'
                        | 'iconUrl'
                        | 'shortDescription'
                        | 'roles'
                        | 'designation'
                      >>,
                    displayCategory: Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >,
                    splitCategory?: Maybe<Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >>,
                  }
                )>>,
              }
            )
            | (
              { __typename: 'SummaryLineItemHover' }
              & Pick<SummaryLineItemHover, 'lineType'>
              & { history: (
                Pick<DimensionSummary, 'partialData'>
                & { time: Array<{ summary: (
                    Pick<TransactionSummary, 'isPeriodBookClosed'>
                    & {
                      period: Pick<
                          Period,
                          | 'name'
                          | 'interval'
                          | 'startedAt'
                          | 'endedAt'
                        >,
                      total: (
                        Pick<
                          PeriodMonetaryValue,
                          | 'transactionsCount'
                          | 'deltaPrevious'
                          | 'deltaYearAgo'
                          | 'isFirstOccurrencePeriod'
                        >
                        & {
                          value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          moneyFlow?: Maybe<(
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          )>,
                          current?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                          prior?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                        }
                      ),
                    }
                  ) }> }
              ) }
            )
          ,
          insight?: Maybe<(
            Pick<
              Insight,
              | 'score'
              | 'globalScore'
              | 'subjectType'
              | 'subjectId'
              | 'subjectDisplayKey'
              | 'comparisonIntervalOffset'
              | 'ruleType'
              | 'sentence'
              | 'subjectIconUrl'
              | 'designation'
              | 'type'
              | 'productArea'
            >
            & {
              periodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              absoluteDelta?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              comparisonPeriodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>,
        }>,
      deltas?: Maybe<{
          percentageTotal?: Maybe<(
            Pick<StatementDeltaValue, 'percentageOfAmount'>
            & { moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ) }
          )>,
          percentageIncome?: Maybe<(
            Pick<StatementDeltaValue, 'percentageOfAmount'>
            & { moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ) }
          )>,
          previousPeriod?: Maybe<(
            Pick<StatementDeltaValue, 'percentageOfAmount'>
            & { moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ) }
          )>,
          previousYear?: Maybe<(
            Pick<StatementDeltaValue, 'percentageOfAmount'>
            & { moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ) }
          )>,
        }>,
    }
  )> }
);

export type StatementRowFieldsFragment = (
  Pick<StatementRow, 'rowId' | 'depth'>
  & {
    sectionTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
    sectionSummary?: Maybe<(
      Pick<StatementRowSummary, 'displayNumber' | 'label'>
      & { moneyFlow: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ) }
    )>,
    parentCategoryTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
    parentCategorySummary?: Maybe<(
      Pick<StatementRowSummary, 'displayNumber' | 'label'>
      & { moneyFlow: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ) }
    )>,
    leafCategorySummary?: Maybe<(
      Pick<StatementRowSummary, 'displayNumber' | 'label'>
      & { moneyFlow: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ) }
    )>,
    agingTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
    agingSummary?: Maybe<(
      Pick<AgingSummary, 'label'>
      & { dimensionSummary: (
        Pick<DimensionSummary, 'partialData'>
        & {
          aging: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }>,
          summary: (
            Pick<TransactionSummary, 'isPeriodBookClosed'>
            & {
              period: Pick<
                  Period,
                  | 'name'
                  | 'interval'
                  | 'startedAt'
                  | 'endedAt'
                >,
              total: (
                Pick<
                  PeriodMonetaryValue,
                  | 'transactionsCount'
                  | 'deltaPrevious'
                  | 'deltaYearAgo'
                  | 'isFirstOccurrencePeriod'
                >
                & {
                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  moneyFlow?: Maybe<(
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  )>,
                  current?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                  prior?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                }
              ),
            }
          ),
        }
      ) }
    )>,
    parentAgingTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
    parentAgingSummary?: Maybe<(
      Pick<AgingSummary, 'label'>
      & { dimensionSummary: (
        Pick<DimensionSummary, 'partialData'>
        & {
          aging: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }>,
          summary: (
            Pick<TransactionSummary, 'isPeriodBookClosed'>
            & {
              period: Pick<
                  Period,
                  | 'name'
                  | 'interval'
                  | 'startedAt'
                  | 'endedAt'
                >,
              total: (
                Pick<
                  PeriodMonetaryValue,
                  | 'transactionsCount'
                  | 'deltaPrevious'
                  | 'deltaYearAgo'
                  | 'isFirstOccurrencePeriod'
                >
                & {
                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  moneyFlow?: Maybe<(
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  )>,
                  current?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                  prior?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                }
              ),
            }
          ),
        }
      ) }
    )>,
    leafAgingSummary?: Maybe<(
      Pick<LeafAgingSummary, 'dueDate' | 'referenceNumber' | 'invoiceDate'>
      & {
        amounts: Array<(
          Pick<LeafAgingSummaryAmount, 'column'>
          & { moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ) }
        )>,
        link: Pick<LeafAgingSummaryLink, 'hasLink'>,
      }
    )>,
    details?: Maybe<{
        hover:
          | (
            { __typename: 'CategoryHover' }
            & Pick<CategoryHover, 'balance'>
            & {
              entity: (
                { __typename: 'EntityCategory' }
                & Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >
              ),
              history: (
                Pick<DimensionSummary, 'partialData'>
                & {
                  time: Array<{ summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ) }>,
                  department: Array<(
                    Pick<DepartmentDimension, 'departmentId'>
                    & {
                      departmentObject: (
                        { __typename: 'EntityDepartment' }
                        & Pick<
                          EntityDepartment,
                          | 'id'
                          | 'name'
                          | 'parentId'
                          | 'active'
                        >
                      ),
                      by: { time: Array<{ summary: (
                            Pick<TransactionSummary, 'isPeriodBookClosed'>
                            & {
                              period: Pick<
                                  Period,
                                  | 'name'
                                  | 'interval'
                                  | 'startedAt'
                                  | 'endedAt'
                                >,
                              total: (
                                Pick<
                                  PeriodMonetaryValue,
                                  | 'transactionsCount'
                                  | 'deltaPrevious'
                                  | 'deltaYearAgo'
                                  | 'isFirstOccurrencePeriod'
                                >
                                & {
                                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                  moneyFlow?: Maybe<(
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  )>,
                                  current?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                  prior?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                }
                              ),
                            }
                          ) }> },
                    }
                  )>,
                  location: Array<(
                    Pick<LocationDimension, 'locationId'>
                    & {
                      locationObject: (
                        { __typename: 'EntityLocation' }
                        & Pick<
                          EntityLocation,
                          | 'id'
                          | 'name'
                          | 'parentId'
                          | 'active'
                        >
                      ),
                      by: { time: Array<{ summary: (
                            Pick<TransactionSummary, 'isPeriodBookClosed'>
                            & {
                              period: Pick<
                                  Period,
                                  | 'name'
                                  | 'interval'
                                  | 'startedAt'
                                  | 'endedAt'
                                >,
                              total: (
                                Pick<
                                  PeriodMonetaryValue,
                                  | 'transactionsCount'
                                  | 'deltaPrevious'
                                  | 'deltaYearAgo'
                                  | 'isFirstOccurrencePeriod'
                                >
                                & {
                                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                  moneyFlow?: Maybe<(
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  )>,
                                  current?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                  prior?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                }
                              ),
                            }
                          ) }> },
                    }
                  )>,
                }
              ),
              context?: Maybe<(
                Pick<DimensionSummary, 'partialData'>
                & { party: Array<{
                    partyObject: Pick<
                        EntityParty,
                        | 'id'
                        | 'name'
                        | 'iconUrl'
                        | 'shortDescription'
                        | 'roles'
                        | 'designation'
                      >,
                    summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ),
                  }> }
              )>,
              topTransactions?: Maybe<Array<(
                Pick<
                  EntityTransaction,
                  | 'viewId'
                  | 'factId'
                  | 'timestamp'
                  | 'description'
                  | 'externalId'
                  | 'displayEntry'
                >
                & {
                  moneyFlow: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ),
                  party?: Maybe<Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    >>,
                  displayCategory: Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >,
                  splitCategory?: Maybe<Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >>,
                }
              )>>,
              missingClass?: Maybe<{ time: Array<{ summary: (
                    Pick<TransactionSummary, 'isPeriodBookClosed'>
                    & {
                      period: Pick<
                          Period,
                          | 'name'
                          | 'interval'
                          | 'startedAt'
                          | 'endedAt'
                        >,
                      total: (
                        Pick<
                          PeriodMonetaryValue,
                          | 'transactionsCount'
                          | 'deltaPrevious'
                          | 'deltaYearAgo'
                          | 'isFirstOccurrencePeriod'
                        >
                        & {
                          value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          moneyFlow?: Maybe<(
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          )>,
                          current?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                          prior?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                        }
                      ),
                    }
                  ) }> }>,
              otherClass?: Maybe<{ time: Array<{ summary: (
                    Pick<TransactionSummary, 'isPeriodBookClosed'>
                    & {
                      period: Pick<
                          Period,
                          | 'name'
                          | 'interval'
                          | 'startedAt'
                          | 'endedAt'
                        >,
                      total: (
                        Pick<
                          PeriodMonetaryValue,
                          | 'transactionsCount'
                          | 'deltaPrevious'
                          | 'deltaYearAgo'
                          | 'isFirstOccurrencePeriod'
                        >
                        & {
                          value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          moneyFlow?: Maybe<(
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          )>,
                          current?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                          prior?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                        }
                      ),
                    }
                  ) }> }>,
            }
          )
          | (
            { __typename: 'PartyHover' }
            & {
              entity: (
                { __typename: 'EntityParty' }
                & Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >
              ),
              history: (
                Pick<DimensionSummary, 'partialData'>
                & { time: Array<{ summary: (
                    Pick<TransactionSummary, 'isPeriodBookClosed'>
                    & {
                      period: Pick<
                          Period,
                          | 'name'
                          | 'interval'
                          | 'startedAt'
                          | 'endedAt'
                        >,
                      total: (
                        Pick<
                          PeriodMonetaryValue,
                          | 'transactionsCount'
                          | 'deltaPrevious'
                          | 'deltaYearAgo'
                          | 'isFirstOccurrencePeriod'
                        >
                        & {
                          value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          moneyFlow?: Maybe<(
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          )>,
                          current?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                          prior?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                        }
                      ),
                    }
                  ) }> }
              ),
              context?: Maybe<(
                Pick<DimensionSummary, 'partialData'>
                & { category: Array<{
                    categoryObject: Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >,
                    summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ),
                  }> }
              )>,
              topTransactions?: Maybe<Array<(
                Pick<
                  EntityTransaction,
                  | 'viewId'
                  | 'factId'
                  | 'timestamp'
                  | 'description'
                  | 'externalId'
                  | 'displayEntry'
                >
                & {
                  moneyFlow: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ),
                  party?: Maybe<Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    >>,
                  displayCategory: Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >,
                  splitCategory?: Maybe<Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >>,
                }
              )>>,
            }
          )
          | (
            { __typename: 'SummaryLineItemHover' }
            & Pick<SummaryLineItemHover, 'lineType'>
            & {
              history: (
                Pick<DimensionSummary, 'partialData'>
                & {
                  time: Array<{ summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ) }>,
                  department: Array<(
                    Pick<DepartmentDimension, 'departmentId'>
                    & {
                      departmentObject: (
                        { __typename: 'EntityDepartment' }
                        & Pick<
                          EntityDepartment,
                          | 'id'
                          | 'name'
                          | 'parentId'
                          | 'active'
                        >
                      ),
                      by: { time: Array<{ summary: (
                            Pick<TransactionSummary, 'isPeriodBookClosed'>
                            & {
                              period: Pick<
                                  Period,
                                  | 'name'
                                  | 'interval'
                                  | 'startedAt'
                                  | 'endedAt'
                                >,
                              total: (
                                Pick<
                                  PeriodMonetaryValue,
                                  | 'transactionsCount'
                                  | 'deltaPrevious'
                                  | 'deltaYearAgo'
                                  | 'isFirstOccurrencePeriod'
                                >
                                & {
                                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                  moneyFlow?: Maybe<(
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  )>,
                                  current?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                  prior?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                }
                              ),
                            }
                          ) }> },
                    }
                  )>,
                  location: Array<(
                    Pick<LocationDimension, 'locationId'>
                    & {
                      locationObject: (
                        { __typename: 'EntityLocation' }
                        & Pick<
                          EntityLocation,
                          | 'id'
                          | 'name'
                          | 'parentId'
                          | 'active'
                        >
                      ),
                      by: { time: Array<{ summary: (
                            Pick<TransactionSummary, 'isPeriodBookClosed'>
                            & {
                              period: Pick<
                                  Period,
                                  | 'name'
                                  | 'interval'
                                  | 'startedAt'
                                  | 'endedAt'
                                >,
                              total: (
                                Pick<
                                  PeriodMonetaryValue,
                                  | 'transactionsCount'
                                  | 'deltaPrevious'
                                  | 'deltaYearAgo'
                                  | 'isFirstOccurrencePeriod'
                                >
                                & {
                                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                  moneyFlow?: Maybe<(
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  )>,
                                  current?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                  prior?: Maybe<(
                                    Pick<SummaryTotal, 'count'>
                                    & { total: (
                                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                    ) }
                                  )>,
                                }
                              ),
                            }
                          ) }> },
                    }
                  )>,
                }
              ),
              missingClass?: Maybe<{ time: Array<{ summary: (
                    Pick<TransactionSummary, 'isPeriodBookClosed'>
                    & {
                      period: Pick<
                          Period,
                          | 'name'
                          | 'interval'
                          | 'startedAt'
                          | 'endedAt'
                        >,
                      total: (
                        Pick<
                          PeriodMonetaryValue,
                          | 'transactionsCount'
                          | 'deltaPrevious'
                          | 'deltaYearAgo'
                          | 'isFirstOccurrencePeriod'
                        >
                        & {
                          value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          moneyFlow?: Maybe<(
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          )>,
                          current?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                          prior?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                        }
                      ),
                    }
                  ) }> }>,
              otherClass?: Maybe<{ time: Array<{ summary: (
                    Pick<TransactionSummary, 'isPeriodBookClosed'>
                    & {
                      period: Pick<
                          Period,
                          | 'name'
                          | 'interval'
                          | 'startedAt'
                          | 'endedAt'
                        >,
                      total: (
                        Pick<
                          PeriodMonetaryValue,
                          | 'transactionsCount'
                          | 'deltaPrevious'
                          | 'deltaYearAgo'
                          | 'isFirstOccurrencePeriod'
                        >
                        & {
                          value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          moneyFlow?: Maybe<(
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          )>,
                          current?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                          prior?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                        }
                      ),
                    }
                  ) }> }>,
            }
          )
        ,
        insight?: Maybe<(
          Pick<
            Insight,
            | 'score'
            | 'globalScore'
            | 'subjectType'
            | 'subjectId'
            | 'subjectDisplayKey'
            | 'comparisonIntervalOffset'
            | 'ruleType'
            | 'sentence'
            | 'subjectIconUrl'
            | 'designation'
            | 'type'
            | 'productArea'
          >
          & {
            periodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            absoluteDelta?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            comparisonPeriodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>,
      }>,
    ytdDetails?: Maybe<{
        hover:
          | (
            { __typename: 'CategoryHover' }
            & Pick<CategoryHover, 'balance'>
            & {
              entity: (
                { __typename: 'EntityCategory' }
                & Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >
              ),
              history: (
                Pick<DimensionSummary, 'partialData'>
                & { time: Array<{ summary: (
                    Pick<TransactionSummary, 'isPeriodBookClosed'>
                    & {
                      period: Pick<
                          Period,
                          | 'name'
                          | 'interval'
                          | 'startedAt'
                          | 'endedAt'
                        >,
                      total: (
                        Pick<
                          PeriodMonetaryValue,
                          | 'transactionsCount'
                          | 'deltaPrevious'
                          | 'deltaYearAgo'
                          | 'isFirstOccurrencePeriod'
                        >
                        & {
                          value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          moneyFlow?: Maybe<(
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          )>,
                          current?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                          prior?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                        }
                      ),
                    }
                  ) }> }
              ),
              context?: Maybe<(
                Pick<DimensionSummary, 'partialData'>
                & { party: Array<{
                    partyObject: Pick<
                        EntityParty,
                        | 'id'
                        | 'name'
                        | 'iconUrl'
                        | 'shortDescription'
                        | 'roles'
                        | 'designation'
                      >,
                    summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ),
                  }> }
              )>,
              topTransactions?: Maybe<Array<(
                Pick<
                  EntityTransaction,
                  | 'viewId'
                  | 'factId'
                  | 'timestamp'
                  | 'description'
                  | 'externalId'
                  | 'displayEntry'
                >
                & {
                  moneyFlow: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ),
                  party?: Maybe<Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    >>,
                  displayCategory: Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >,
                  splitCategory?: Maybe<Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >>,
                }
              )>>,
            }
          )
          | (
            { __typename: 'PartyHover' }
            & {
              entity: (
                { __typename: 'EntityParty' }
                & Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >
              ),
              history: (
                Pick<DimensionSummary, 'partialData'>
                & { time: Array<{ summary: (
                    Pick<TransactionSummary, 'isPeriodBookClosed'>
                    & {
                      period: Pick<
                          Period,
                          | 'name'
                          | 'interval'
                          | 'startedAt'
                          | 'endedAt'
                        >,
                      total: (
                        Pick<
                          PeriodMonetaryValue,
                          | 'transactionsCount'
                          | 'deltaPrevious'
                          | 'deltaYearAgo'
                          | 'isFirstOccurrencePeriod'
                        >
                        & {
                          value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                          moneyFlow?: Maybe<(
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          )>,
                          current?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                          prior?: Maybe<(
                            Pick<SummaryTotal, 'count'>
                            & { total: (
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            ) }
                          )>,
                        }
                      ),
                    }
                  ) }> }
              ),
              context?: Maybe<(
                Pick<DimensionSummary, 'partialData'>
                & { category: Array<{
                    categoryObject: Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >,
                    summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ),
                  }> }
              )>,
              topTransactions?: Maybe<Array<(
                Pick<
                  EntityTransaction,
                  | 'viewId'
                  | 'factId'
                  | 'timestamp'
                  | 'description'
                  | 'externalId'
                  | 'displayEntry'
                >
                & {
                  moneyFlow: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ),
                  party?: Maybe<Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    >>,
                  displayCategory: Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >,
                  splitCategory?: Maybe<Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >>,
                }
              )>>,
            }
          )
          | (
            { __typename: 'SummaryLineItemHover' }
            & Pick<SummaryLineItemHover, 'lineType'>
            & { history: (
              Pick<DimensionSummary, 'partialData'>
              & { time: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }> }
            ) }
          )
        ,
        insight?: Maybe<(
          Pick<
            Insight,
            | 'score'
            | 'globalScore'
            | 'subjectType'
            | 'subjectId'
            | 'subjectDisplayKey'
            | 'comparisonIntervalOffset'
            | 'ruleType'
            | 'sentence'
            | 'subjectIconUrl'
            | 'designation'
            | 'type'
            | 'productArea'
          >
          & {
            periodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            absoluteDelta?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            comparisonPeriodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>,
      }>,
    deltas?: Maybe<{
        percentageTotal?: Maybe<(
          Pick<StatementDeltaValue, 'percentageOfAmount'>
          & { moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ) }
        )>,
        percentageIncome?: Maybe<(
          Pick<StatementDeltaValue, 'percentageOfAmount'>
          & { moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ) }
        )>,
        previousPeriod?: Maybe<(
          Pick<StatementDeltaValue, 'percentageOfAmount'>
          & { moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ) }
        )>,
        previousYear?: Maybe<(
          Pick<StatementDeltaValue, 'percentageOfAmount'>
          & { moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ) }
        )>,
      }>,
  }
);

export type StatementRowSummaryFieldsFragment = (
  Pick<StatementRowSummary, 'displayNumber' | 'label'>
  & { moneyFlow: (
    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
  ) }
);

export type StatementRowTitleFieldsFragment = Pick<StatementRowTitle, 'displayNumber' | 'title'>;

export type TextDocumentFieldsFragment = Pick<
    TextDocument,
    | 'id'
    | 'title'
    | 'summary'
    | 'status'
    | 'createdAt'
    | 'updatedAt'
  >;

export type TrialBalanceFieldsFragment = {
    rows: Array<(
      Pick<TrialBalanceRow, 'rowId' | 'name'>
      & {
        debits: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        credits: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      }
    )>,
    categories: Array<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>,
  };

export type TrialBalanceRowFieldsFragment = (
  Pick<TrialBalanceRow, 'rowId' | 'name'>
  & {
    debits: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    credits: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
  }
);

export type AttachReportPackageDocumentMutationVariables = Exact<{
  viewKey: ViewKey;
  origin: IntervalOrigin;
  packageId: Scalars['String']['input'];
  attachments: NewReportAttachments;
}>;


export type AttachReportPackageDocumentMutation = Pick<Mutation, 'attachReportPackageDocument'>;

export type CopyReportPackageMutationVariables = Exact<{
  viewKey: ViewKey;
  packageId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  periodStartAt: DateInput;
  periodEndAt: DateInput;
  interval: Interval;
  attachments: NewReportAttachments;
}>;


export type CopyReportPackageMutation = { copyReportPackage: (
    Pick<
      ReportPackageMetadata,
      | 'id'
      | 'versionId'
      | 'title'
      | 'status'
      | 'startedAt'
      | 'endedAt'
      | 'interval'
      | 'coverUrl'
      | 'publishedAsDraft'
      | 'createdAt'
      | 'updatedAt'
      | 'creationMethod'
    >
    & {
      viewKey: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      author?: Maybe<Pick<
          Contact,
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >>,
      documents: Array<(
        Pick<
          ReportPackageDocumentMetadata,
          | 'id'
          | 'title'
          | 'documentObjectId'
          | 'documentObjectVersionId'
          | 'type'
          | 'status'
          | 'position'
        >
        & {
          reportFile?: Maybe<Pick<
              ReportFileMetadata,
              | 'id'
              | 'fileName'
              | 'mimeType'
              | 'fileSize'
              | 'source'
            >>,
          generationHistory?: Maybe<Pick<
              ReportGenerationHistory,
              | 'id'
              | 'requestId'
              | 'reportId'
              | 'versionId'
              | 'legalEntityId'
              | 'authorId'
              | 'viewVersion'
              | 'kind'
              | 'timezone'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'generationStartedAt'
              | 'generationEndedAt'
              | 'error'
              | 'createdAt'
              | 'updatedAt'
            >>,
        }
      )>,
      versions: Array<Pick<
          ReportPackageVersionMetadata,
          | 'id'
          | 'status'
          | 'createdAt'
          | 'updatedAt'
        >>,
    }
  ) };

export type CreateReportFromUploadMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  reports: Array<NewReportUpload> | NewReportUpload;
}>;


export type CreateReportFromUploadMutation = { createReportFromUpload: Array<(
    Pick<
      Report,
      | 'id'
      | 'versionId'
      | 'title'
      | 'status'
      | 'interval'
      | 'createdAt'
    >
    & {
      author?: Maybe<Pick<
          Contact,
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >>,
      reportFile: Pick<
          ReportFileMetadata,
          | 'id'
          | 'fileName'
          | 'mimeType'
          | 'fileSize'
          | 'source'
        >,
      reportFor?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
      generationHistory?: Maybe<Pick<
          ReportGenerationHistory,
          | 'id'
          | 'requestId'
          | 'reportId'
          | 'versionId'
          | 'legalEntityId'
          | 'authorId'
          | 'viewVersion'
          | 'kind'
          | 'timezone'
          | 'periodStartedAt'
          | 'periodEndedAt'
          | 'generationStartedAt'
          | 'generationEndedAt'
          | 'error'
          | 'createdAt'
          | 'updatedAt'
        >>,
      options?: Maybe<(
        { __typename: 'ReportDocumentOptions' }
        & Pick<
          ReportDocumentOptions,
          | 'sparklineLookbackPeriods'
          | 'reportLookbackPeriods'
          | 'deltaMonthOverMonth'
          | 'deltaMonthOverMonthPeriods'
          | 'deltaYearOverYear'
          | 'comparedToTotal'
          | 'comparedToIncome'
          | 'amountPrecision'
          | 'yearToDate'
          | 'deltaYearToDate'
          | 'breakdownByClass'
        >
        & {
          collapsedSections?: Maybe<Pick<CollapsedSections, 'sections'>>,
          categoryByDepartmentOptions?: Maybe<(
            Pick<CategoryByDepartmentOptions, 'showOther' | 'showUnassigned'>
            & { departments?: Maybe<Array<Pick<DepartmentOption, 'departmentId' | 'name'>>> }
          )>,
          categoryByLocationOptions?: Maybe<(
            Pick<CategoryByLocationOptions, 'showOther' | 'showUnassigned'>
            & { locations?: Maybe<Array<Pick<LocationOption, 'locationId' | 'name'>>> }
          )>,
        }
      )>,
    }
  )> };

export type CreateReportPackageMutationVariables = Exact<{
  viewKey: ViewKey;
  title: Scalars['String']['input'];
  periodStartAt: DateInput;
  periodEndAt: DateInput;
  interval: Interval;
  attachments: NewReportAttachments;
  coverUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateReportPackageMutation = { createReportPackage: (
    Pick<
      ReportPackageMetadata,
      | 'id'
      | 'versionId'
      | 'title'
      | 'status'
      | 'startedAt'
      | 'endedAt'
      | 'interval'
      | 'coverUrl'
      | 'publishedAsDraft'
      | 'createdAt'
      | 'updatedAt'
      | 'creationMethod'
    >
    & {
      viewKey: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      author?: Maybe<Pick<
          Contact,
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >>,
      documents: Array<(
        Pick<
          ReportPackageDocumentMetadata,
          | 'id'
          | 'title'
          | 'documentObjectId'
          | 'documentObjectVersionId'
          | 'type'
          | 'status'
          | 'position'
        >
        & {
          reportFile?: Maybe<Pick<
              ReportFileMetadata,
              | 'id'
              | 'fileName'
              | 'mimeType'
              | 'fileSize'
              | 'source'
            >>,
          generationHistory?: Maybe<Pick<
              ReportGenerationHistory,
              | 'id'
              | 'requestId'
              | 'reportId'
              | 'versionId'
              | 'legalEntityId'
              | 'authorId'
              | 'viewVersion'
              | 'kind'
              | 'timezone'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'generationStartedAt'
              | 'generationEndedAt'
              | 'error'
              | 'createdAt'
              | 'updatedAt'
            >>,
        }
      )>,
      versions: Array<Pick<
          ReportPackageVersionMetadata,
          | 'id'
          | 'status'
          | 'createdAt'
          | 'updatedAt'
        >>,
    }
  ) };

export type DeleteReportPackageMutationVariables = Exact<{
  packageId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type DeleteReportPackageMutation = Pick<Mutation, 'deleteReportPackage'>;

export type EditReportPackageMutationVariables = Exact<{
  viewKey: ViewKey;
  packageId: Scalars['String']['input'];
  packageVersionId: Scalars['String']['input'];
}>;


export type EditReportPackageMutation = { editReportPackage: (
    Pick<
      ReportPackageMetadata,
      | 'id'
      | 'versionId'
      | 'title'
      | 'status'
      | 'startedAt'
      | 'endedAt'
      | 'interval'
      | 'coverUrl'
      | 'publishedAsDraft'
      | 'createdAt'
      | 'updatedAt'
      | 'creationMethod'
    >
    & {
      viewKey: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      author?: Maybe<Pick<
          Contact,
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >>,
      documents: Array<(
        Pick<
          ReportPackageDocumentMetadata,
          | 'id'
          | 'title'
          | 'documentObjectId'
          | 'documentObjectVersionId'
          | 'type'
          | 'status'
          | 'position'
        >
        & {
          reportFile?: Maybe<Pick<
              ReportFileMetadata,
              | 'id'
              | 'fileName'
              | 'mimeType'
              | 'fileSize'
              | 'source'
            >>,
          generationHistory?: Maybe<Pick<
              ReportGenerationHistory,
              | 'id'
              | 'requestId'
              | 'reportId'
              | 'versionId'
              | 'legalEntityId'
              | 'authorId'
              | 'viewVersion'
              | 'kind'
              | 'timezone'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'generationStartedAt'
              | 'generationEndedAt'
              | 'error'
              | 'createdAt'
              | 'updatedAt'
            >>,
        }
      )>,
      versions: Array<Pick<
          ReportPackageVersionMetadata,
          | 'id'
          | 'status'
          | 'createdAt'
          | 'updatedAt'
        >>,
    }
  ) };

export type GenerateReportPackagePdfMutationVariables = Exact<{
  packageId: Scalars['String']['input'];
  packageVersionId: Scalars['String']['input'];
  viewId: ViewIdentifierInput;
  timezone?: InputMaybe<Scalars['String']['input']>;
  coverUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateReportPackagePdfMutation = { generateReportPackagePdf: Pick<DocumentDownload, 'url'> };

export type PublishReportPackageMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
  packageVersionId: Scalars['String']['input'];
  sendNotification?: InputMaybe<Scalars['Boolean']['input']>;
  publishAsDraft: Scalars['Boolean']['input'];
}>;


export type PublishReportPackageMutation = Pick<Mutation, 'publishReportPackage'>;

export type RefreshReportPackageMutationVariables = Exact<{
  viewKey: ViewKey;
  packageId: Scalars['String']['input'];
  packageVersionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RefreshReportPackageMutation = { refreshReportPackage: Pick<ReportRefreshRequest, 'requestId'> };

export type UpdateExecutiveSummaryMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateExecutiveSummaryMutation = Pick<Mutation, 'updateExecutiveSummary'>;

export type UpdateReportAutomationSettingsMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  interval: Interval;
  autoCreateDraft: Scalars['Boolean']['input'];
  autoPublishDraft: Scalars['Boolean']['input'];
  autoPublishDraftDay: Scalars['Int']['input'];
  autoPublishFinal: Scalars['Boolean']['input'];
  autoPublishFinalDay: Scalars['Int']['input'];
}>;


export type UpdateReportAutomationSettingsMutation = Pick<Mutation, 'updateReportAutomationSettings'>;

export type UpdateReportOptionsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  reportPackageId: Scalars['String']['input'];
  packageVersionId: Scalars['String']['input'];
  reportId: Scalars['String']['input'];
  reportVersionId: Scalars['String']['input'];
  sparklineLookbackPeriods?: InputMaybe<Scalars['Int']['input']>;
  reportLookbackPeriods?: InputMaybe<Scalars['Int']['input']>;
  deltaMonthOverMonth?: InputMaybe<ReportOptionComparison>;
  deltaYearOverYear?: InputMaybe<ReportOptionComparison>;
  comparedToTotal?: InputMaybe<ReportOptionComparison>;
  comparedToIncome?: InputMaybe<ReportOptionComparison>;
  collapsedSections?: InputMaybe<CollapsedSectionsInput>;
  breakdownByClass?: InputMaybe<ReportBreakdownByClass>;
  categoryByDepartmentOptions?: InputMaybe<CategoryByDepartmentOptionsInput>;
  categoryByLocationOptions?: InputMaybe<CategoryByLocationOptionsInput>;
}>;


export type UpdateReportOptionsMutation = Pick<Mutation, 'updateReportOptions'>;

export type UpdateReportPackageMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
  packageVersionId: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  customFooter?: InputMaybe<Scalars['String']['input']>;
  preparedBy?: InputMaybe<Scalars['String']['input']>;
  accountNumbersDisplay?: InputMaybe<AccountNumbersDisplay>;
  coverUrl?: InputMaybe<Scalars['String']['input']>;
  coverLogoSource?: InputMaybe<CoverLogoSource>;
  publishedAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateReportPackageMutation = Pick<Mutation, 'updateReportPackage'>;

export type ListReportPackagesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  interval: Interval;
  intervalCount?: InputMaybe<Scalars['Int']['input']>;
  year: Scalars['Int']['input'];
  index: Scalars['Int']['input'];
  paginationLimit: Scalars['Int']['input'];
  paginationOffset: Scalars['Int']['input'];
  direction: DirectionFromOrigin;
  sort?: InputMaybe<PackagesSort>;
}>;


export type ListReportPackagesQuery = { listReportPackages: Array<(
    Pick<
      ReportPackageMetadata,
      | 'id'
      | 'versionId'
      | 'title'
      | 'status'
      | 'startedAt'
      | 'endedAt'
      | 'interval'
      | 'coverUrl'
      | 'publishedAsDraft'
      | 'createdAt'
      | 'updatedAt'
      | 'creationMethod'
    >
    & {
      viewKey: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      author?: Maybe<Pick<
          Contact,
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >>,
      documents: Array<(
        Pick<
          ReportPackageDocumentMetadata,
          | 'id'
          | 'title'
          | 'documentObjectId'
          | 'documentObjectVersionId'
          | 'type'
          | 'status'
          | 'position'
        >
        & {
          reportFile?: Maybe<Pick<
              ReportFileMetadata,
              | 'id'
              | 'fileName'
              | 'mimeType'
              | 'fileSize'
              | 'source'
            >>,
          generationHistory?: Maybe<Pick<
              ReportGenerationHistory,
              | 'id'
              | 'requestId'
              | 'reportId'
              | 'versionId'
              | 'legalEntityId'
              | 'authorId'
              | 'viewVersion'
              | 'kind'
              | 'timezone'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'generationStartedAt'
              | 'generationEndedAt'
              | 'error'
              | 'createdAt'
              | 'updatedAt'
            >>,
        }
      )>,
      versions: Array<Pick<
          ReportPackageVersionMetadata,
          | 'id'
          | 'status'
          | 'createdAt'
          | 'updatedAt'
        >>,
    }
  )> };

export type ListReportTemplatesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  interval: Interval;
  limit: Scalars['Int']['input'];
}>;


export type ListReportTemplatesQuery = { listReportTemplates: Array<Pick<
      ReportTemplate,
      | 'id'
      | 'name'
      | 'hasExecutiveSummary'
      | 'hasProfitAndLoss'
      | 'hasBalanceSheet'
      | 'hasCashFlow'
    >> };

export type ReadReportArchiveQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  reportId: Scalars['String']['input'];
  reportVersionId: Scalars['String']['input'];
  reportPackageId: Scalars['String']['input'];
  reportFileSource?: InputMaybe<ReportFileSource>;
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<DimensionSortMode>;
  timeHistory: Scalars['Boolean']['input'];
  departmentHistory: Scalars['Boolean']['input'];
  locationHistory: Scalars['Boolean']['input'];
}>;


export type ReadReportArchiveQuery = { readReportArchive: (
    Pick<Statement, 'kind'>
    & { rows: Array<(
      Pick<StatementRow, 'rowId' | 'depth'>
      & {
        sectionTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
        sectionSummary?: Maybe<(
          Pick<StatementRowSummary, 'displayNumber' | 'label'>
          & { moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ) }
        )>,
        parentCategoryTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
        parentCategorySummary?: Maybe<(
          Pick<StatementRowSummary, 'displayNumber' | 'label'>
          & { moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ) }
        )>,
        leafCategorySummary?: Maybe<(
          Pick<StatementRowSummary, 'displayNumber' | 'label'>
          & { moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ) }
        )>,
        agingTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
        agingSummary?: Maybe<(
          Pick<AgingSummary, 'label'>
          & { dimensionSummary: (
            Pick<DimensionSummary, 'partialData'>
            & {
              aging: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }>,
              summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ),
            }
          ) }
        )>,
        parentAgingTitle?: Maybe<Pick<StatementRowTitle, 'displayNumber' | 'title'>>,
        parentAgingSummary?: Maybe<(
          Pick<AgingSummary, 'label'>
          & { dimensionSummary: (
            Pick<DimensionSummary, 'partialData'>
            & {
              aging: Array<{ summary: (
                  Pick<TransactionSummary, 'isPeriodBookClosed'>
                  & {
                    period: Pick<
                        Period,
                        | 'name'
                        | 'interval'
                        | 'startedAt'
                        | 'endedAt'
                      >,
                    total: (
                      Pick<
                        PeriodMonetaryValue,
                        | 'transactionsCount'
                        | 'deltaPrevious'
                        | 'deltaYearAgo'
                        | 'isFirstOccurrencePeriod'
                      >
                      & {
                        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                        moneyFlow?: Maybe<(
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        )>,
                        current?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                        prior?: Maybe<(
                          Pick<SummaryTotal, 'count'>
                          & { total: (
                            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                          ) }
                        )>,
                      }
                    ),
                  }
                ) }>,
              summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ),
            }
          ) }
        )>,
        leafAgingSummary?: Maybe<(
          Pick<LeafAgingSummary, 'dueDate' | 'referenceNumber' | 'invoiceDate'>
          & {
            amounts: Array<(
              Pick<LeafAgingSummaryAmount, 'column'>
              & { moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ) }
            )>,
            link: Pick<LeafAgingSummaryLink, 'hasLink'>,
          }
        )>,
        details?: Maybe<{
            hover:
              | (
                { __typename: 'CategoryHover' }
                & Pick<CategoryHover, 'balance'>
                & {
                  entity: (
                    { __typename: 'EntityCategory' }
                    & Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >
                  ),
                  history: (
                    Pick<DimensionSummary, 'partialData'>
                    & {
                      time: Array<{ summary: (
                          Pick<TransactionSummary, 'isPeriodBookClosed'>
                          & {
                            period: Pick<
                                Period,
                                | 'name'
                                | 'interval'
                                | 'startedAt'
                                | 'endedAt'
                              >,
                            total: (
                              Pick<
                                PeriodMonetaryValue,
                                | 'transactionsCount'
                                | 'deltaPrevious'
                                | 'deltaYearAgo'
                                | 'isFirstOccurrencePeriod'
                              >
                              & {
                                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                moneyFlow?: Maybe<(
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                )>,
                                current?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                                prior?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                              }
                            ),
                          }
                        ) }>,
                      department: Array<(
                        Pick<DepartmentDimension, 'departmentId'>
                        & {
                          departmentObject: (
                            { __typename: 'EntityDepartment' }
                            & Pick<
                              EntityDepartment,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          ),
                          by: { time: Array<{ summary: (
                                Pick<TransactionSummary, 'isPeriodBookClosed'>
                                & {
                                  period: Pick<
                                      Period,
                                      | 'name'
                                      | 'interval'
                                      | 'startedAt'
                                      | 'endedAt'
                                    >,
                                  total: (
                                    Pick<
                                      PeriodMonetaryValue,
                                      | 'transactionsCount'
                                      | 'deltaPrevious'
                                      | 'deltaYearAgo'
                                      | 'isFirstOccurrencePeriod'
                                    >
                                    & {
                                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                      moneyFlow?: Maybe<(
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      )>,
                                      current?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                      prior?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                    }
                                  ),
                                }
                              ) }> },
                        }
                      )>,
                      location: Array<(
                        Pick<LocationDimension, 'locationId'>
                        & {
                          locationObject: (
                            { __typename: 'EntityLocation' }
                            & Pick<
                              EntityLocation,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          ),
                          by: { time: Array<{ summary: (
                                Pick<TransactionSummary, 'isPeriodBookClosed'>
                                & {
                                  period: Pick<
                                      Period,
                                      | 'name'
                                      | 'interval'
                                      | 'startedAt'
                                      | 'endedAt'
                                    >,
                                  total: (
                                    Pick<
                                      PeriodMonetaryValue,
                                      | 'transactionsCount'
                                      | 'deltaPrevious'
                                      | 'deltaYearAgo'
                                      | 'isFirstOccurrencePeriod'
                                    >
                                    & {
                                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                      moneyFlow?: Maybe<(
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      )>,
                                      current?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                      prior?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                    }
                                  ),
                                }
                              ) }> },
                        }
                      )>,
                    }
                  ),
                  context?: Maybe<(
                    Pick<DimensionSummary, 'partialData'>
                    & { party: Array<{
                        partyObject: Pick<
                            EntityParty,
                            | 'id'
                            | 'name'
                            | 'iconUrl'
                            | 'shortDescription'
                            | 'roles'
                            | 'designation'
                          >,
                        summary: (
                          Pick<TransactionSummary, 'isPeriodBookClosed'>
                          & {
                            period: Pick<
                                Period,
                                | 'name'
                                | 'interval'
                                | 'startedAt'
                                | 'endedAt'
                              >,
                            total: (
                              Pick<
                                PeriodMonetaryValue,
                                | 'transactionsCount'
                                | 'deltaPrevious'
                                | 'deltaYearAgo'
                                | 'isFirstOccurrencePeriod'
                              >
                              & {
                                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                moneyFlow?: Maybe<(
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                )>,
                                current?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                                prior?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                              }
                            ),
                          }
                        ),
                      }> }
                  )>,
                  topTransactions?: Maybe<Array<(
                    Pick<
                      EntityTransaction,
                      | 'viewId'
                      | 'factId'
                      | 'timestamp'
                      | 'description'
                      | 'externalId'
                      | 'displayEntry'
                    >
                    & {
                      moneyFlow: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ),
                      party?: Maybe<Pick<
                          EntityParty,
                          | 'id'
                          | 'name'
                          | 'iconUrl'
                          | 'shortDescription'
                          | 'roles'
                          | 'designation'
                        >>,
                      displayCategory: Pick<
                          EntityCategory,
                          | 'id'
                          | 'name'
                          | 'displayKey'
                          | 'chartOfAccountsDisplayNumber'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'productArea'
                          | 'active'
                        >,
                      splitCategory?: Maybe<Pick<
                          EntityCategory,
                          | 'id'
                          | 'name'
                          | 'displayKey'
                          | 'chartOfAccountsDisplayNumber'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'productArea'
                          | 'active'
                        >>,
                    }
                  )>>,
                  missingClass?: Maybe<{ time: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }> }>,
                  otherClass?: Maybe<{ time: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }> }>,
                }
              )
              | (
                { __typename: 'PartyHover' }
                & {
                  entity: (
                    { __typename: 'EntityParty' }
                    & Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    >
                  ),
                  history: (
                    Pick<DimensionSummary, 'partialData'>
                    & { time: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }> }
                  ),
                  context?: Maybe<(
                    Pick<DimensionSummary, 'partialData'>
                    & { category: Array<{
                        categoryObject: Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >,
                        summary: (
                          Pick<TransactionSummary, 'isPeriodBookClosed'>
                          & {
                            period: Pick<
                                Period,
                                | 'name'
                                | 'interval'
                                | 'startedAt'
                                | 'endedAt'
                              >,
                            total: (
                              Pick<
                                PeriodMonetaryValue,
                                | 'transactionsCount'
                                | 'deltaPrevious'
                                | 'deltaYearAgo'
                                | 'isFirstOccurrencePeriod'
                              >
                              & {
                                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                moneyFlow?: Maybe<(
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                )>,
                                current?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                                prior?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                              }
                            ),
                          }
                        ),
                      }> }
                  )>,
                  topTransactions?: Maybe<Array<(
                    Pick<
                      EntityTransaction,
                      | 'viewId'
                      | 'factId'
                      | 'timestamp'
                      | 'description'
                      | 'externalId'
                      | 'displayEntry'
                    >
                    & {
                      moneyFlow: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ),
                      party?: Maybe<Pick<
                          EntityParty,
                          | 'id'
                          | 'name'
                          | 'iconUrl'
                          | 'shortDescription'
                          | 'roles'
                          | 'designation'
                        >>,
                      displayCategory: Pick<
                          EntityCategory,
                          | 'id'
                          | 'name'
                          | 'displayKey'
                          | 'chartOfAccountsDisplayNumber'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'productArea'
                          | 'active'
                        >,
                      splitCategory?: Maybe<Pick<
                          EntityCategory,
                          | 'id'
                          | 'name'
                          | 'displayKey'
                          | 'chartOfAccountsDisplayNumber'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'productArea'
                          | 'active'
                        >>,
                    }
                  )>>,
                }
              )
              | (
                { __typename: 'SummaryLineItemHover' }
                & Pick<SummaryLineItemHover, 'lineType'>
                & {
                  history: (
                    Pick<DimensionSummary, 'partialData'>
                    & {
                      time: Array<{ summary: (
                          Pick<TransactionSummary, 'isPeriodBookClosed'>
                          & {
                            period: Pick<
                                Period,
                                | 'name'
                                | 'interval'
                                | 'startedAt'
                                | 'endedAt'
                              >,
                            total: (
                              Pick<
                                PeriodMonetaryValue,
                                | 'transactionsCount'
                                | 'deltaPrevious'
                                | 'deltaYearAgo'
                                | 'isFirstOccurrencePeriod'
                              >
                              & {
                                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                moneyFlow?: Maybe<(
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                )>,
                                current?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                                prior?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                              }
                            ),
                          }
                        ) }>,
                      department: Array<(
                        Pick<DepartmentDimension, 'departmentId'>
                        & {
                          departmentObject: (
                            { __typename: 'EntityDepartment' }
                            & Pick<
                              EntityDepartment,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          ),
                          by: { time: Array<{ summary: (
                                Pick<TransactionSummary, 'isPeriodBookClosed'>
                                & {
                                  period: Pick<
                                      Period,
                                      | 'name'
                                      | 'interval'
                                      | 'startedAt'
                                      | 'endedAt'
                                    >,
                                  total: (
                                    Pick<
                                      PeriodMonetaryValue,
                                      | 'transactionsCount'
                                      | 'deltaPrevious'
                                      | 'deltaYearAgo'
                                      | 'isFirstOccurrencePeriod'
                                    >
                                    & {
                                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                      moneyFlow?: Maybe<(
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      )>,
                                      current?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                      prior?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                    }
                                  ),
                                }
                              ) }> },
                        }
                      )>,
                      location: Array<(
                        Pick<LocationDimension, 'locationId'>
                        & {
                          locationObject: (
                            { __typename: 'EntityLocation' }
                            & Pick<
                              EntityLocation,
                              | 'id'
                              | 'name'
                              | 'parentId'
                              | 'active'
                            >
                          ),
                          by: { time: Array<{ summary: (
                                Pick<TransactionSummary, 'isPeriodBookClosed'>
                                & {
                                  period: Pick<
                                      Period,
                                      | 'name'
                                      | 'interval'
                                      | 'startedAt'
                                      | 'endedAt'
                                    >,
                                  total: (
                                    Pick<
                                      PeriodMonetaryValue,
                                      | 'transactionsCount'
                                      | 'deltaPrevious'
                                      | 'deltaYearAgo'
                                      | 'isFirstOccurrencePeriod'
                                    >
                                    & {
                                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                      moneyFlow?: Maybe<(
                                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                      )>,
                                      current?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                      prior?: Maybe<(
                                        Pick<SummaryTotal, 'count'>
                                        & { total: (
                                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                        ) }
                                      )>,
                                    }
                                  ),
                                }
                              ) }> },
                        }
                      )>,
                    }
                  ),
                  missingClass?: Maybe<{ time: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }> }>,
                  otherClass?: Maybe<{ time: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }> }>,
                }
              )
            ,
            insight?: Maybe<(
              Pick<
                Insight,
                | 'score'
                | 'globalScore'
                | 'subjectType'
                | 'subjectId'
                | 'subjectDisplayKey'
                | 'comparisonIntervalOffset'
                | 'ruleType'
                | 'sentence'
                | 'subjectIconUrl'
                | 'designation'
                | 'type'
                | 'productArea'
              >
              & {
                periodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                absoluteDelta?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                comparisonPeriodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              }
            )>,
          }>,
        ytdDetails?: Maybe<{
            hover:
              | (
                { __typename: 'CategoryHover' }
                & Pick<CategoryHover, 'balance'>
                & {
                  entity: (
                    { __typename: 'EntityCategory' }
                    & Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >
                  ),
                  history: (
                    Pick<DimensionSummary, 'partialData'>
                    & { time: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }> }
                  ),
                  context?: Maybe<(
                    Pick<DimensionSummary, 'partialData'>
                    & { party: Array<{
                        partyObject: Pick<
                            EntityParty,
                            | 'id'
                            | 'name'
                            | 'iconUrl'
                            | 'shortDescription'
                            | 'roles'
                            | 'designation'
                          >,
                        summary: (
                          Pick<TransactionSummary, 'isPeriodBookClosed'>
                          & {
                            period: Pick<
                                Period,
                                | 'name'
                                | 'interval'
                                | 'startedAt'
                                | 'endedAt'
                              >,
                            total: (
                              Pick<
                                PeriodMonetaryValue,
                                | 'transactionsCount'
                                | 'deltaPrevious'
                                | 'deltaYearAgo'
                                | 'isFirstOccurrencePeriod'
                              >
                              & {
                                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                moneyFlow?: Maybe<(
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                )>,
                                current?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                                prior?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                              }
                            ),
                          }
                        ),
                      }> }
                  )>,
                  topTransactions?: Maybe<Array<(
                    Pick<
                      EntityTransaction,
                      | 'viewId'
                      | 'factId'
                      | 'timestamp'
                      | 'description'
                      | 'externalId'
                      | 'displayEntry'
                    >
                    & {
                      moneyFlow: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ),
                      party?: Maybe<Pick<
                          EntityParty,
                          | 'id'
                          | 'name'
                          | 'iconUrl'
                          | 'shortDescription'
                          | 'roles'
                          | 'designation'
                        >>,
                      displayCategory: Pick<
                          EntityCategory,
                          | 'id'
                          | 'name'
                          | 'displayKey'
                          | 'chartOfAccountsDisplayNumber'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'productArea'
                          | 'active'
                        >,
                      splitCategory?: Maybe<Pick<
                          EntityCategory,
                          | 'id'
                          | 'name'
                          | 'displayKey'
                          | 'chartOfAccountsDisplayNumber'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'productArea'
                          | 'active'
                        >>,
                    }
                  )>>,
                }
              )
              | (
                { __typename: 'PartyHover' }
                & {
                  entity: (
                    { __typename: 'EntityParty' }
                    & Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    >
                  ),
                  history: (
                    Pick<DimensionSummary, 'partialData'>
                    & { time: Array<{ summary: (
                        Pick<TransactionSummary, 'isPeriodBookClosed'>
                        & {
                          period: Pick<
                              Period,
                              | 'name'
                              | 'interval'
                              | 'startedAt'
                              | 'endedAt'
                            >,
                          total: (
                            Pick<
                              PeriodMonetaryValue,
                              | 'transactionsCount'
                              | 'deltaPrevious'
                              | 'deltaYearAgo'
                              | 'isFirstOccurrencePeriod'
                            >
                            & {
                              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                              moneyFlow?: Maybe<(
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              )>,
                              current?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                              prior?: Maybe<(
                                Pick<SummaryTotal, 'count'>
                                & { total: (
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                ) }
                              )>,
                            }
                          ),
                        }
                      ) }> }
                  ),
                  context?: Maybe<(
                    Pick<DimensionSummary, 'partialData'>
                    & { category: Array<{
                        categoryObject: Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >,
                        summary: (
                          Pick<TransactionSummary, 'isPeriodBookClosed'>
                          & {
                            period: Pick<
                                Period,
                                | 'name'
                                | 'interval'
                                | 'startedAt'
                                | 'endedAt'
                              >,
                            total: (
                              Pick<
                                PeriodMonetaryValue,
                                | 'transactionsCount'
                                | 'deltaPrevious'
                                | 'deltaYearAgo'
                                | 'isFirstOccurrencePeriod'
                              >
                              & {
                                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                                moneyFlow?: Maybe<(
                                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                )>,
                                current?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                                prior?: Maybe<(
                                  Pick<SummaryTotal, 'count'>
                                  & { total: (
                                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                                  ) }
                                )>,
                              }
                            ),
                          }
                        ),
                      }> }
                  )>,
                  topTransactions?: Maybe<Array<(
                    Pick<
                      EntityTransaction,
                      | 'viewId'
                      | 'factId'
                      | 'timestamp'
                      | 'description'
                      | 'externalId'
                      | 'displayEntry'
                    >
                    & {
                      moneyFlow: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ),
                      party?: Maybe<Pick<
                          EntityParty,
                          | 'id'
                          | 'name'
                          | 'iconUrl'
                          | 'shortDescription'
                          | 'roles'
                          | 'designation'
                        >>,
                      displayCategory: Pick<
                          EntityCategory,
                          | 'id'
                          | 'name'
                          | 'displayKey'
                          | 'chartOfAccountsDisplayNumber'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'productArea'
                          | 'active'
                        >,
                      splitCategory?: Maybe<Pick<
                          EntityCategory,
                          | 'id'
                          | 'name'
                          | 'displayKey'
                          | 'chartOfAccountsDisplayNumber'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'productArea'
                          | 'active'
                        >>,
                    }
                  )>>,
                }
              )
              | (
                { __typename: 'SummaryLineItemHover' }
                & Pick<SummaryLineItemHover, 'lineType'>
                & { history: (
                  Pick<DimensionSummary, 'partialData'>
                  & { time: Array<{ summary: (
                      Pick<TransactionSummary, 'isPeriodBookClosed'>
                      & {
                        period: Pick<
                            Period,
                            | 'name'
                            | 'interval'
                            | 'startedAt'
                            | 'endedAt'
                          >,
                        total: (
                          Pick<
                            PeriodMonetaryValue,
                            | 'transactionsCount'
                            | 'deltaPrevious'
                            | 'deltaYearAgo'
                            | 'isFirstOccurrencePeriod'
                          >
                          & {
                            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                            moneyFlow?: Maybe<(
                              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                            )>,
                            current?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                            prior?: Maybe<(
                              Pick<SummaryTotal, 'count'>
                              & { total: (
                                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                              ) }
                            )>,
                          }
                        ),
                      }
                    ) }> }
                ) }
              )
            ,
            insight?: Maybe<(
              Pick<
                Insight,
                | 'score'
                | 'globalScore'
                | 'subjectType'
                | 'subjectId'
                | 'subjectDisplayKey'
                | 'comparisonIntervalOffset'
                | 'ruleType'
                | 'sentence'
                | 'subjectIconUrl'
                | 'designation'
                | 'type'
                | 'productArea'
              >
              & {
                periodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                absoluteDelta?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                comparisonPeriodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              }
            )>,
          }>,
        deltas?: Maybe<{
            percentageTotal?: Maybe<(
              Pick<StatementDeltaValue, 'percentageOfAmount'>
              & { moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ) }
            )>,
            percentageIncome?: Maybe<(
              Pick<StatementDeltaValue, 'percentageOfAmount'>
              & { moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ) }
            )>,
            previousPeriod?: Maybe<(
              Pick<StatementDeltaValue, 'percentageOfAmount'>
              & { moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ) }
            )>,
            previousYear?: Maybe<(
              Pick<StatementDeltaValue, 'percentageOfAmount'>
              & { moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ) }
            )>,
          }>,
      }
    )> }
  ) };

export type ReadReportAutomationSettingsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  interval: Interval;
}>;


export type ReadReportAutomationSettingsQuery = { readReportAutomationSettings: Pick<
      ReportAutomationSettings,
      | 'organizationId'
      | 'legalEntityId'
      | 'interval'
      | 'autoCreateDraft'
      | 'autoPublishDraft'
      | 'autoPublishDraftDay'
      | 'autoPublishFinal'
      | 'autoPublishFinalDay'
    > };

export type ReadReportPackageQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
  packageVersionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReadReportPackageQuery = { readReportPackage: (
    Pick<
      ReportPackage,
      | 'id'
      | 'versionId'
      | 'title'
      | 'status'
      | 'createdAt'
      | 'updatedAt'
      | 'startedAt'
      | 'endedAt'
      | 'interval'
    >
    & {
      viewKey: Pick<
          ViewIdentifier,
          | 'legalEntityId'
          | 'viewVersion'
          | 'mutationVersion'
          | 'viewType'
        >,
      author?: Maybe<Pick<
          Contact,
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >>,
      authorOrganization?: Maybe<Pick<
          OrganizationPreview,
          | 'id'
          | 'slug'
          | 'name'
          | 'iconUrl'
        >>,
      legalEntityOrganization?: Maybe<Pick<
          OrganizationPreview,
          | 'id'
          | 'slug'
          | 'name'
          | 'iconUrl'
        >>,
      packageOptions?: Maybe<Pick<
          ReportPackageOptions,
          | 'customFooter'
          | 'preparedBy'
          | 'accountNumbersDisplay'
          | 'coverUrl'
          | 'coverLogoSource'
          | 'publishedAsDraft'
        >>,
      documents: Array<{
          metadata: (
            Pick<
              ReportPackageDocumentMetadata,
              | 'id'
              | 'title'
              | 'documentObjectId'
              | 'documentObjectVersionId'
              | 'type'
              | 'status'
              | 'position'
            >
            & {
              reportFile?: Maybe<Pick<
                  ReportFileMetadata,
                  | 'id'
                  | 'fileName'
                  | 'mimeType'
                  | 'fileSize'
                  | 'source'
                >>,
              generationHistory?: Maybe<Pick<
                  ReportGenerationHistory,
                  | 'id'
                  | 'requestId'
                  | 'reportId'
                  | 'versionId'
                  | 'legalEntityId'
                  | 'authorId'
                  | 'viewVersion'
                  | 'kind'
                  | 'timezone'
                  | 'periodStartedAt'
                  | 'periodEndedAt'
                  | 'generationStartedAt'
                  | 'generationEndedAt'
                  | 'error'
                  | 'createdAt'
                  | 'updatedAt'
                >>,
            }
          ),
          document?: Maybe<
            | Pick<
                LayoutDocument,
                | 'id'
                | 'title'
                | 'layoutId'
                | 'status'
                | 'createdAt'
                | 'updatedAt'
              >
            | (
              Pick<
                Report,
                | 'id'
                | 'versionId'
                | 'title'
                | 'status'
                | 'interval'
                | 'createdAt'
              >
              & {
                author?: Maybe<Pick<
                    Contact,
                    | 'givenName'
                    | 'familyName'
                    | 'emailAddress'
                    | 'avatarUrl'
                  >>,
                reportFile: Pick<
                    ReportFileMetadata,
                    | 'id'
                    | 'fileName'
                    | 'mimeType'
                    | 'fileSize'
                    | 'source'
                  >,
                reportFor?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
                generationHistory?: Maybe<Pick<
                    ReportGenerationHistory,
                    | 'id'
                    | 'requestId'
                    | 'reportId'
                    | 'versionId'
                    | 'legalEntityId'
                    | 'authorId'
                    | 'viewVersion'
                    | 'kind'
                    | 'timezone'
                    | 'periodStartedAt'
                    | 'periodEndedAt'
                    | 'generationStartedAt'
                    | 'generationEndedAt'
                    | 'error'
                    | 'createdAt'
                    | 'updatedAt'
                  >>,
                options?: Maybe<(
                  { __typename: 'ReportDocumentOptions' }
                  & Pick<
                    ReportDocumentOptions,
                    | 'sparklineLookbackPeriods'
                    | 'reportLookbackPeriods'
                    | 'deltaMonthOverMonth'
                    | 'deltaMonthOverMonthPeriods'
                    | 'deltaYearOverYear'
                    | 'comparedToTotal'
                    | 'comparedToIncome'
                    | 'amountPrecision'
                    | 'yearToDate'
                    | 'deltaYearToDate'
                    | 'breakdownByClass'
                  >
                  & {
                    collapsedSections?: Maybe<Pick<CollapsedSections, 'sections'>>,
                    categoryByDepartmentOptions?: Maybe<(
                      Pick<CategoryByDepartmentOptions, 'showOther' | 'showUnassigned'>
                      & { departments?: Maybe<Array<Pick<DepartmentOption, 'departmentId' | 'name'>>> }
                    )>,
                    categoryByLocationOptions?: Maybe<(
                      Pick<CategoryByLocationOptions, 'showOther' | 'showUnassigned'>
                      & { locations?: Maybe<Array<Pick<LocationOption, 'locationId' | 'name'>>> }
                    )>,
                  }
                )>,
              }
            )
            | Pick<
                TextDocument,
                | 'id'
                | 'title'
                | 'summary'
                | 'status'
                | 'createdAt'
                | 'updatedAt'
              >
          >,
        }>,
      entities: (
        { __typename: 'ObjectEntities' }
        & {
          users?: Maybe<Array<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>>,
          transactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          comments?: Maybe<Array<Pick<
              EntityComment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
            >>>,
          reports?: Maybe<Array<(
            Pick<
              EntityReport,
              | 'id'
              | 'title'
              | 'authorId'
              | 'mimeType'
              | 'createdAt'
            >
            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
          )>>,
          reportPackages?: Maybe<Array<(
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )>>,
          parties?: Maybe<Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>>,
          datasources?: Maybe<Array<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>>,
          categories?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>>,
          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
          workItems?: Maybe<Array<(
            Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )>>,
          invoices?: Maybe<Array<(
            Pick<
              EntityInvoice,
              | 'id'
              | 'externalDisplayId'
              | 'createdAt'
              | 'dueAt'
            >
            & {
              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              customer: (
                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                & { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              ),
            }
          )>>,
          bills?: Maybe<Array<(
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )>>,
          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
          departments?: Maybe<Array<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          locations?: Maybe<Array<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          reconciliations?: Maybe<Array<(
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )>>,
          ledgerTransactions?: Maybe<Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )>>,
          schedules?: Maybe<Array<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>>,
        }
      ),
      version: Pick<
          ReportPackageVersionMetadata,
          | 'id'
          | 'status'
          | 'createdAt'
          | 'updatedAt'
        >,
    }
  ) };

export type SummarizeTrialBalanceQueryVariables = Exact<{
  viewKey: ViewKey;
  origin: IntervalOrigin;
}>;


export type SummarizeTrialBalanceQuery = { summarizeTrialBalance: {
      rows: Array<(
        Pick<TrialBalanceRow, 'rowId' | 'name'>
        & {
          debits: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
          credits: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        }
      )>,
      categories: Array<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>,
    } };

export type ReportDownloadUrlQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  reportId: Scalars['String']['input'];
  reportVersionId: Scalars['String']['input'];
  reportPackageId: Scalars['String']['input'];
  reportFileSource?: InputMaybe<ReportFileSource>;
}>;


export type ReportDownloadUrlQuery = { reportDownloadUrl: Pick<ReportDownload, 'url'> };

export type SummarizeReportPackagesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  intervalOrigin: IntervalOrigin;
  direction: DirectionFromOrigin;
}>;


export type SummarizeReportPackagesQuery = { summarizeReportPackages: Array<(
    Pick<ReportPackageSummary, 'packagesCount' | 'publishedCount' | 'draftCount'>
    & { period: Pick<
        Period,
        | 'name'
        | 'interval'
        | 'startedAt'
        | 'endedAt'
      > }
  )> };

export type ScheduleSpecializationFieldsFragment = Pick<
    ScheduleSpecialization,
    | 'id'
    | 'scheduleTemplateId'
    | 'name'
    | 'displayKey'
    | 'description'
    | 'organizationId'
    | 'legalEntityId'
  >;

export type UpdateScheduleImportCandidateStatusMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  scheduleImportCandidateId: Scalars['String']['input'];
  status: ScheduleImportCandidateStatus;
}>;


export type UpdateScheduleImportCandidateStatusMutation = Pick<Mutation, 'updateScheduleImportCandidateStatus'>;

export type CreateScheduleMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  schedule: ScheduleInput;
  recategorizeSource?: InputMaybe<SourceRecategorizationInput>;
  viewKey?: InputMaybe<ViewKey>;
  scheduleImportCandidateId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateScheduleMutation = Pick<Mutation, 'createSchedule'>;

export type DeleteScheduleMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  scheduleTemplateId: Scalars['String']['input'];
  scheduleId: Scalars['String']['input'];
}>;


export type DeleteScheduleMutation = Pick<Mutation, 'deleteSchedule'>;

export type UpdateScheduleMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  schedule: ScheduleInput;
  viewKey?: InputMaybe<ViewKey>;
}>;


export type UpdateScheduleMutation = Pick<Mutation, 'updateSchedule'>;

export type ListScheduleEventTemplatesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  scheduleTemplateId: Scalars['String']['input'];
}>;


export type ListScheduleEventTemplatesQuery = { listScheduleEventTemplates: Array<(
    Pick<
      ScheduleEventTemplate,
      | 'id'
      | 'name'
      | 'description'
      | 'displayName'
      | 'ordinal'
      | 'isSingleton'
      | 'isTerminating'
      | 'isInstantiating'
      | 'inCreateFlow'
      | 'displayKey'
    >
    & { variables: Array<(
      Pick<
        ScheduleEventVariableTemplate,
        | 'id'
        | 'variableName'
        | 'displayName'
        | 'required'
        | 'ordinal'
        | 'variableType'
        | 'displayMode'
      >
      & { formulas?: Maybe<Array<Pick<ScheduleEventVariableTemplateFormula, 'id' | 'displayName'>>> }
    )> }
  )> };

export type ListScheduleSnapshotsQueryVariables = Exact<{
  origin: IntervalOrigin;
  filter: ScheduleDashboardFilter;
  pagination: Pagination;
  direction: DirectionFromOrigin;
  order?: InputMaybe<ScheduleOrder>;
}>;


export type ListScheduleSnapshotsQuery = { listScheduleSnapshots: Array<(
    Pick<
      ScheduleSnapshot,
      | 'id'
      | 'name'
      | 'scheduleNumber'
      | 'scheduleType'
      | 'startDate'
      | 'endDate'
      | 'cutoverDate'
    >
    & {
      category?: Maybe<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>,
      relatedCategory?: Maybe<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>,
      party?: Maybe<Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        >>,
      amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      remainingAmount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    }
  )> };

export type ListScheduleSpecializationsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  scheduleTemplateId: Scalars['String']['input'];
}>;


export type ListScheduleSpecializationsQuery = { listScheduleSpecializations: Array<Pick<
      ScheduleSpecialization,
      | 'id'
      | 'scheduleTemplateId'
      | 'name'
      | 'displayKey'
      | 'description'
      | 'organizationId'
      | 'legalEntityId'
    >> };

export type ListScheduleTemplatesByIDsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  scheduleTemplateIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ListScheduleTemplatesByIDsQuery = { listScheduleTemplatesByIDs: Array<Pick<
      ScheduleTemplate,
      | 'id'
      | 'name'
      | 'description'
      | 'scheduleType'
      | 'displayKey'
    >> };

export type ListScheduleTemplatesByTypesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  types?: InputMaybe<Array<ScheduleType> | ScheduleType>;
}>;


export type ListScheduleTemplatesByTypesQuery = { listScheduleTemplatesByTypes: Array<Pick<
      ScheduleTemplate,
      | 'id'
      | 'name'
      | 'description'
      | 'scheduleType'
      | 'displayKey'
    >> };

export type ReadScheduleQueryVariables = Exact<{
  scheduleId: Scalars['String']['input'];
  viewKey: ViewKey;
}>;


export type ReadScheduleQuery = { readSchedule: (
    Pick<
      Schedule,
      | 'id'
      | 'name'
      | 'description'
      | 'scheduleNumber'
      | 'scheduleTemplateId'
      | 'specializationId'
      | 'scheduleType'
      | 'createdAt'
      | 'updatedAt'
      | 'cutoverDate'
    >
    & {
      sourceTransaction?: Maybe<(
        Pick<
          EntityTransaction,
          | 'viewId'
          | 'factId'
          | 'timestamp'
          | 'description'
          | 'externalId'
          | 'displayEntry'
        >
        & {
          moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          party?: Maybe<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>,
          displayCategory: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          splitCategory?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
        }
      )>,
      party?: Maybe<Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        >>,
      createdBy: Pick<
          EntityUser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >,
      updatedBy: Pick<
          EntityUser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >,
      events: Array<(
        Pick<
          ScheduleEvent,
          | 'id'
          | 'displayName'
          | 'eventDate'
          | 'eventTemplateId'
          | 'isGenerated'
          | 'isInstantiating'
          | 'isTerminating'
          | 'isSingleton'
          | 'displayKey'
          | 'skipReason'
          | 'note'
          | 'createdAt'
          | 'updatedAt'
        >
        & {
          createdBy: Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >,
          updatedBy: Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >,
          variables: Array<(
            Pick<
              ScheduleEventVariable,
              | 'id'
              | 'displayName'
              | 'variableName'
              | 'variableTemplateId'
              | 'variableType'
            >
            & { value:
              | Pick<ScheduleBooleanValue, 'boolValue'>
              | { category: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  > }
              | Pick<ScheduleDateValue, 'dateValue'>
              | Pick<ScheduleFloatValue, 'floatValue'>
              | Pick<ScheduleFormulaValue, 'formulaId' | 'formulaDisplayName'>
              | Pick<ScheduleIntervalValue, 'intervalValue'>
              | Pick<ScheduleLongValue, 'longValue'>
              | { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              | { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              | Pick<ScheduleStringValue, 'stringValue'>
              | Pick<ScheduleTermValue, 'intervalCount' | 'endDate'>
              | { transaction: (
                  Pick<
                    EntityTransaction,
                    | 'viewId'
                    | 'factId'
                    | 'timestamp'
                    | 'description'
                    | 'externalId'
                    | 'displayEntry'
                  >
                  & {
                    moneyFlow: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ),
                    party?: Maybe<Pick<
                        EntityParty,
                        | 'id'
                        | 'name'
                        | 'iconUrl'
                        | 'shortDescription'
                        | 'roles'
                        | 'designation'
                      >>,
                    displayCategory: Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >,
                    splitCategory?: Maybe<Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >>,
                  }
                ) }
             }
          )>,
        }
      )>,
      cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    }
  ) };

export type ReadScheduleCandidateQueryVariables = Exact<{
  viewKey: ViewKey;
  sourceTransactionFactId: Scalars['String']['input'];
}>;


export type ReadScheduleCandidateQuery = { readScheduleCandidate?: Maybe<(
    Pick<ScheduleCandidate, 'sourceTransactionFactId' | 'scheduleType'>
    & {
      scheduleTemplate: Pick<
          ScheduleTemplate,
          | 'id'
          | 'name'
          | 'description'
          | 'scheduleType'
          | 'displayKey'
        >,
      specialization?: Maybe<Pick<
          ScheduleSpecialization,
          | 'id'
          | 'scheduleTemplateId'
          | 'name'
          | 'displayKey'
          | 'description'
          | 'organizationId'
          | 'legalEntityId'
        >>,
      sourceRecategorizeCategory?: Maybe<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>,
    }
  )> };

export type ReadScheduleDefaultsQueryVariables = Exact<{
  viewKey: ViewKey;
  scheduleTemplateId: Scalars['String']['input'];
  specializationId?: InputMaybe<Scalars['String']['input']>;
  sourceTransactionFactId?: InputMaybe<Scalars['String']['input']>;
  recategorizedSourceCategoryId?: InputMaybe<Scalars['String']['input']>;
  inCreateFlow?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleImportCandidateId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReadScheduleDefaultsQuery = { readScheduleDefaults: {
      specialization?: Maybe<Pick<
          ScheduleSpecialization,
          | 'id'
          | 'scheduleTemplateId'
          | 'name'
          | 'displayKey'
          | 'description'
          | 'organizationId'
          | 'legalEntityId'
        >>,
      events: Array<(
        Pick<
          ScheduleEvent,
          | 'id'
          | 'displayName'
          | 'eventDate'
          | 'eventTemplateId'
          | 'isGenerated'
          | 'isInstantiating'
          | 'isTerminating'
          | 'isSingleton'
          | 'displayKey'
          | 'skipReason'
          | 'note'
          | 'createdAt'
          | 'updatedAt'
        >
        & {
          createdBy: Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >,
          updatedBy: Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >,
          variables: Array<(
            Pick<
              ScheduleEventVariable,
              | 'id'
              | 'displayName'
              | 'variableName'
              | 'variableTemplateId'
              | 'variableType'
            >
            & { value:
              | Pick<ScheduleBooleanValue, 'boolValue'>
              | { category: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  > }
              | Pick<ScheduleDateValue, 'dateValue'>
              | Pick<ScheduleFloatValue, 'floatValue'>
              | Pick<ScheduleFormulaValue, 'formulaId' | 'formulaDisplayName'>
              | Pick<ScheduleIntervalValue, 'intervalValue'>
              | Pick<ScheduleLongValue, 'longValue'>
              | { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              | { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              | Pick<ScheduleStringValue, 'stringValue'>
              | Pick<ScheduleTermValue, 'intervalCount' | 'endDate'>
              | { transaction: (
                  Pick<
                    EntityTransaction,
                    | 'viewId'
                    | 'factId'
                    | 'timestamp'
                    | 'description'
                    | 'externalId'
                    | 'displayEntry'
                  >
                  & {
                    moneyFlow: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ),
                    party?: Maybe<Pick<
                        EntityParty,
                        | 'id'
                        | 'name'
                        | 'iconUrl'
                        | 'shortDescription'
                        | 'roles'
                        | 'designation'
                      >>,
                    displayCategory: Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >,
                    splitCategory?: Maybe<Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >>,
                  }
                ) }
             }
          )>,
        }
      )>,
      eventTemplates: Array<(
        Pick<
          ScheduleEventTemplate,
          | 'id'
          | 'name'
          | 'description'
          | 'displayName'
          | 'ordinal'
          | 'isSingleton'
          | 'isTerminating'
          | 'isInstantiating'
          | 'inCreateFlow'
          | 'displayKey'
        >
        & { variables: Array<(
          Pick<
            ScheduleEventVariableTemplate,
            | 'id'
            | 'variableName'
            | 'displayName'
            | 'required'
            | 'ordinal'
            | 'variableType'
            | 'displayMode'
          >
          & { formulas?: Maybe<Array<Pick<ScheduleEventVariableTemplateFormula, 'id' | 'displayName'>>> }
        )> }
      )>,
    } };

export type ReadScheduleEditingHistoryQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  scheduleTemplateId: Scalars['String']['input'];
  scheduleId: Scalars['String']['input'];
}>;


export type ReadScheduleEditingHistoryQuery = { readScheduleEditingHistory: Array<(
    Pick<ScheduleHistoryEntry, 'updatedAt'>
    & {
      user?: Maybe<Pick<
          EntityUser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >>,
      editedObjects: Array<Pick<ScheduleEditedObject, 'kind' | 'id' | 'action'>>,
    }
  )> };

export type ReadScheduleImportCandidateQueryVariables = Exact<{
  viewKey: ViewKey;
  scheduleImportCandidateId: Scalars['String']['input'];
}>;


export type ReadScheduleImportCandidateQuery = { readScheduleImportCandidate?: Maybe<(
    Pick<
      ScheduleImportCandidate,
      | 'scheduleImportCandidateId'
      | 'sourceTransactionFactId'
      | 'scheduleType'
      | 'cutoverDate'
    >
    & {
      scheduleTemplate: Pick<
          ScheduleTemplate,
          | 'id'
          | 'name'
          | 'description'
          | 'scheduleType'
          | 'displayKey'
        >,
      specialization?: Maybe<Pick<
          ScheduleSpecialization,
          | 'id'
          | 'scheduleTemplateId'
          | 'name'
          | 'displayKey'
          | 'description'
          | 'organizationId'
          | 'legalEntityId'
        >>,
      sourceRecategorizeCategory?: Maybe<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>,
      sourceTransaction?: Maybe<(
        Pick<
          EntityTransaction,
          | 'viewId'
          | 'factId'
          | 'timestamp'
          | 'description'
          | 'externalId'
          | 'displayEntry'
        >
        & {
          moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          party?: Maybe<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>,
          displayCategory: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          splitCategory?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
        }
      )>,
      cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    }
  )> };

export type ReadSchedulePreviewQueryVariables = Exact<{
  scheduleTemplateId: Scalars['String']['input'];
  events: Array<ScheduleEventInput> | ScheduleEventInput;
  viewKey: ViewKey;
  scheduleId?: InputMaybe<Scalars['String']['input']>;
  sourceTransactionFactId?: InputMaybe<Scalars['String']['input']>;
  recategorizedSourceCategoryId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReadSchedulePreviewQuery = { readSchedulePreview: Array<(
    Pick<
      EntityTransaction,
      | 'viewId'
      | 'factId'
      | 'timestamp'
      | 'description'
      | 'externalId'
      | 'displayEntry'
    >
    & {
      moneyFlow: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ),
      party?: Maybe<Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        >>,
      displayCategory: Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >,
      splitCategory?: Maybe<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>,
    }
  )> };

export type ScheduleFacetCategoryQueryVariables = Exact<{
  filter: ScheduleDashboardFilter;
  origin: IntervalOrigin;
  direction: DirectionFromOrigin;
  pagination: Pagination;
}>;


export type ScheduleFacetCategoryQuery = { scheduleFacet: { category: Array<(
      Pick<CategoryFacet, 'count'>
      & { categoryObject: Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        > }
    )> } };

export type ScheduleFacetPartyQueryVariables = Exact<{
  filter: ScheduleDashboardFilter;
  origin: IntervalOrigin;
  direction: DirectionFromOrigin;
  pagination: Pagination;
}>;


export type ScheduleFacetPartyQuery = { scheduleFacet: { party: Array<(
      Pick<PartyFacet, 'count'>
      & { partyObject: Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        > }
    )> } };

export type ScheduleFacetPartyAggregateQueryVariables = Exact<{
  filter: ScheduleDashboardFilter;
  origin: IntervalOrigin;
}>;


export type ScheduleFacetPartyAggregateQuery = { scheduleFacet: Pick<ScheduleFacet, 'aggregate'> };

export type ScheduleFacetRelatedCategoryQueryVariables = Exact<{
  filter: ScheduleDashboardFilter;
  origin: IntervalOrigin;
  direction: DirectionFromOrigin;
  pagination: Pagination;
}>;


export type ScheduleFacetRelatedCategoryQuery = { scheduleFacet: { relatedCategory: Array<(
      Pick<CategoryFacet, 'count'>
      & { categoryObject: Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        > }
    )> } };

export type SearchResultFieldsFragment = (
  Pick<SearchResult, 'total' | 'tookSecs'>
  & {
    results: Array<(
      Pick<SearchHit, 'score'>
      & {
        highlights: Array<Pick<
            HitHighlight,
            | 'field'
            | 'term'
            | 'start'
            | 'end'
          >>,
        objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
      }
    )>,
    entities: (
      { __typename: 'ObjectEntities' }
      & {
        users?: Maybe<Array<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>>,
        transactions?: Maybe<Array<(
          Pick<
            EntityTransaction,
            | 'viewId'
            | 'factId'
            | 'timestamp'
            | 'description'
            | 'externalId'
            | 'displayEntry'
          >
          & {
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            party?: Maybe<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
            displayCategory: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            splitCategory?: Maybe<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>,
          }
        )>>,
        comments?: Maybe<Array<Pick<
            EntityComment,
            | 'id'
            | 'authorId'
            | 'text'
            | 'timestamp'
          >>>,
        reports?: Maybe<Array<(
          Pick<
            EntityReport,
            | 'id'
            | 'title'
            | 'authorId'
            | 'mimeType'
            | 'createdAt'
          >
          & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
        )>>,
        reportPackages?: Maybe<Array<(
          Pick<
            EntityReportPackage,
            | 'id'
            | 'title'
            | 'authorId'
            | 'interval'
            | 'periodStartedAt'
            | 'periodEndedAt'
            | 'createdAt'
            | 'updatedAt'
            | 'coverUrl'
          >
          & { documents: Array<Pick<
              SharedReportDocumentMetadata,
              | 'id'
              | 'documentObjectId'
              | 'documentObjectVersionId'
              | 'title'
              | 'mimeType'
            >> }
        )>>,
        parties?: Maybe<Array<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>>,
        datasources?: Maybe<Array<Pick<
            EntityDataSource,
            | 'id'
            | 'name'
            | 'url'
            | 'iconUrl'
          >>>,
        categories?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>>,
        threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
        legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
        workItems?: Maybe<Array<(
          Pick<
            EntityWorkItem,
            | 'id'
            | 'time'
            | 'workItemState'
            | 'workItemType'
            | 'reviewCreatedById'
            | 'reviewState'
            | 'ledgerType'
          >
          & { objectTransaction: (
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          ) }
        )>>,
        invoices?: Maybe<Array<(
          Pick<
            EntityInvoice,
            | 'id'
            | 'externalDisplayId'
            | 'createdAt'
            | 'dueAt'
          >
          & {
            amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            customer: (
              Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
              & { party: Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                > }
            ),
          }
        )>>,
        bills?: Maybe<Array<(
          Pick<
            EntityBill,
            | 'id'
            | 'billStatus'
            | 'vendorName'
            | 'billDescription'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
            format: (
              Pick<Format, 'id' | 'formatClass'>
              & { segments: Array<Pick<
                  Segment,
                  | 'collectionId'
                  | 'fileId'
                  | 'sequence'
                  | 'token'
                >> }
            ),
            approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
          }
        )>>,
        identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
        departments?: Maybe<Array<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        locations?: Maybe<Array<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        reconciliations?: Maybe<Array<(
          { __typename: 'EntityReconciliation' }
          & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
          & {
            startDate: Pick<Date, 'year' | 'month' | 'day'>,
            endDate: Pick<Date, 'year' | 'month' | 'day'>,
          }
        )>>,
        ledgerTransactions?: Maybe<Array<(
          Pick<
            EntityLedgerTransaction,
            | 'id'
            | 'timestamp'
            | 'factIds'
            | 'name'
            | 'referenceNumber'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            parties: Array<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
          }
        )>>,
        schedules?: Maybe<Array<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
            | 'cutoverDate'
          >
          & {
            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>>,
      }
    ),
    kindCounts: Array<Pick<ObjectKindFacet, 'kind' | 'count'>>,
  }
);

export type SearchEntitiesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  viewVersion?: InputMaybe<Scalars['String']['input']>;
  viewType?: InputMaybe<ViewType>;
  text: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  kind: ObjectKind;
  sort?: InputMaybe<Array<SearchEntitiesSort> | SearchEntitiesSort>;
  occurredBefore?: InputMaybe<Scalars['Float']['input']>;
  occurredAfter?: InputMaybe<Scalars['Float']['input']>;
  sortHitsLeftmost?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchEntitiesQuery = { search: (
    Pick<SearchResult, 'total' | 'tookSecs'>
    & {
      results: Array<(
        Pick<SearchHit, 'score'>
        & {
          highlights: Array<Pick<
              HitHighlight,
              | 'field'
              | 'term'
              | 'start'
              | 'end'
            >>,
          objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
        }
      )>,
      entities: (
        { __typename: 'ObjectEntities' }
        & {
          users?: Maybe<Array<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>>,
          transactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          comments?: Maybe<Array<Pick<
              EntityComment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
            >>>,
          reports?: Maybe<Array<(
            Pick<
              EntityReport,
              | 'id'
              | 'title'
              | 'authorId'
              | 'mimeType'
              | 'createdAt'
            >
            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
          )>>,
          reportPackages?: Maybe<Array<(
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )>>,
          parties?: Maybe<Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>>,
          datasources?: Maybe<Array<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>>,
          categories?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>>,
          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
          workItems?: Maybe<Array<(
            Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )>>,
          invoices?: Maybe<Array<(
            Pick<
              EntityInvoice,
              | 'id'
              | 'externalDisplayId'
              | 'createdAt'
              | 'dueAt'
            >
            & {
              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              customer: (
                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                & { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              ),
            }
          )>>,
          bills?: Maybe<Array<(
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )>>,
          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
          departments?: Maybe<Array<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          locations?: Maybe<Array<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          reconciliations?: Maybe<Array<(
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )>>,
          ledgerTransactions?: Maybe<Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )>>,
          schedules?: Maybe<Array<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>>,
        }
      ),
      kindCounts: Array<Pick<ObjectKindFacet, 'kind' | 'count'>>,
    }
  ) };

export type SearchGlobalPartiesQueryVariables = Exact<{
  viewType?: InputMaybe<ViewType>;
  text: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  sort?: InputMaybe<Array<SearchEntitiesSort> | SearchEntitiesSort>;
  sortHitsLeftmost?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchGlobalPartiesQuery = { search: (
    Pick<SearchResult, 'total' | 'tookSecs'>
    & {
      results: Array<(
        Pick<SearchHit, 'score'>
        & {
          highlights: Array<Pick<
              HitHighlight,
              | 'field'
              | 'term'
              | 'start'
              | 'end'
            >>,
          objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
        }
      )>,
      entities: (
        { __typename: 'ObjectEntities' }
        & {
          users?: Maybe<Array<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>>,
          transactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          comments?: Maybe<Array<Pick<
              EntityComment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
            >>>,
          reports?: Maybe<Array<(
            Pick<
              EntityReport,
              | 'id'
              | 'title'
              | 'authorId'
              | 'mimeType'
              | 'createdAt'
            >
            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
          )>>,
          reportPackages?: Maybe<Array<(
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )>>,
          parties?: Maybe<Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>>,
          datasources?: Maybe<Array<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>>,
          categories?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>>,
          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
          workItems?: Maybe<Array<(
            Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )>>,
          invoices?: Maybe<Array<(
            Pick<
              EntityInvoice,
              | 'id'
              | 'externalDisplayId'
              | 'createdAt'
              | 'dueAt'
            >
            & {
              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              customer: (
                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                & { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              ),
            }
          )>>,
          bills?: Maybe<Array<(
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )>>,
          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
          departments?: Maybe<Array<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          locations?: Maybe<Array<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          reconciliations?: Maybe<Array<(
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )>>,
          ledgerTransactions?: Maybe<Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )>>,
          schedules?: Maybe<Array<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>>,
        }
      ),
      kindCounts: Array<Pick<ObjectKindFacet, 'kind' | 'count'>>,
    }
  ) };

export type SearchTermsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  viewVersion?: InputMaybe<Scalars['String']['input']>;
  viewType?: InputMaybe<ViewType>;
  text: Scalars['String']['input'];
  kinds?: InputMaybe<Array<ObjectKind> | ObjectKind>;
  sort?: InputMaybe<Array<SearchEntitiesSort> | SearchEntitiesSort>;
}>;


export type SearchTermsQuery = { searchTerms: (
    Pick<SearchResult, 'total' | 'tookSecs'>
    & {
      results: Array<(
        Pick<SearchHit, 'score'>
        & {
          highlights: Array<Pick<
              HitHighlight,
              | 'field'
              | 'term'
              | 'start'
              | 'end'
            >>,
          objectId: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
        }
      )>,
      entities: (
        { __typename: 'ObjectEntities' }
        & {
          users?: Maybe<Array<Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            >>>,
          transactions?: Maybe<Array<(
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          )>>,
          comments?: Maybe<Array<Pick<
              EntityComment,
              | 'id'
              | 'authorId'
              | 'text'
              | 'timestamp'
            >>>,
          reports?: Maybe<Array<(
            Pick<
              EntityReport,
              | 'id'
              | 'title'
              | 'authorId'
              | 'mimeType'
              | 'createdAt'
            >
            & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
          )>>,
          reportPackages?: Maybe<Array<(
            Pick<
              EntityReportPackage,
              | 'id'
              | 'title'
              | 'authorId'
              | 'interval'
              | 'periodStartedAt'
              | 'periodEndedAt'
              | 'createdAt'
              | 'updatedAt'
              | 'coverUrl'
            >
            & { documents: Array<Pick<
                SharedReportDocumentMetadata,
                | 'id'
                | 'documentObjectId'
                | 'documentObjectVersionId'
                | 'title'
                | 'mimeType'
              >> }
          )>>,
          parties?: Maybe<Array<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>>,
          datasources?: Maybe<Array<Pick<
              EntityDataSource,
              | 'id'
              | 'name'
              | 'url'
              | 'iconUrl'
            >>>,
          categories?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>>,
          threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
          legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
          workItems?: Maybe<Array<(
            Pick<
              EntityWorkItem,
              | 'id'
              | 'time'
              | 'workItemState'
              | 'workItemType'
              | 'reviewCreatedById'
              | 'reviewState'
              | 'ledgerType'
            >
            & { objectTransaction: (
              Pick<
                EntityTransaction,
                | 'viewId'
                | 'factId'
                | 'timestamp'
                | 'description'
                | 'externalId'
                | 'displayEntry'
              >
              & {
                moneyFlow: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ),
                party?: Maybe<Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  >>,
                displayCategory: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >,
                splitCategory?: Maybe<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>,
              }
            ) }
          )>>,
          invoices?: Maybe<Array<(
            Pick<
              EntityInvoice,
              | 'id'
              | 'externalDisplayId'
              | 'createdAt'
              | 'dueAt'
            >
            & {
              amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              customer: (
                Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
                & { party: Pick<
                    EntityParty,
                    | 'id'
                    | 'name'
                    | 'iconUrl'
                    | 'shortDescription'
                    | 'roles'
                    | 'designation'
                  > }
              ),
            }
          )>>,
          bills?: Maybe<Array<(
            Pick<
              EntityBill,
              | 'id'
              | 'billStatus'
              | 'vendorName'
              | 'billDescription'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
              format: (
                Pick<Format, 'id' | 'formatClass'>
                & { segments: Array<Pick<
                    Segment,
                    | 'collectionId'
                    | 'fileId'
                    | 'sequence'
                    | 'token'
                  >> }
              ),
              approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
            }
          )>>,
          identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
          departments?: Maybe<Array<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          locations?: Maybe<Array<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>>,
          reconciliations?: Maybe<Array<(
            { __typename: 'EntityReconciliation' }
            & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
            & {
              startDate: Pick<Date, 'year' | 'month' | 'day'>,
              endDate: Pick<Date, 'year' | 'month' | 'day'>,
            }
          )>>,
          ledgerTransactions?: Maybe<Array<(
            Pick<
              EntityLedgerTransaction,
              | 'id'
              | 'timestamp'
              | 'factIds'
              | 'name'
              | 'referenceNumber'
            >
            & {
              totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              parties: Array<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
            }
          )>>,
          schedules?: Maybe<Array<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>>,
        }
      ),
      kindCounts: Array<Pick<ObjectKindFacet, 'kind' | 'count'>>,
    }
  ) };

export type LegalEntityBadgeCountFieldsFragment = Pick<LegalEntityBadgeCount, 'legalEntityId' | 'count'>;

export type ListActionItemsBadgeCountsQueryVariables = Exact<{
  direction?: InputMaybe<DirectionFromOrigin>;
  filter: ActionItemFilter;
  legalEntityIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  legalEntities?: InputMaybe<Array<InputMaybe<LegalEntityPermission>> | InputMaybe<LegalEntityPermission>>;
  origin: IntervalOrigin;
}>;


export type ListActionItemsBadgeCountsQuery = { listActionItemsBadgeCounts: Array<Pick<LegalEntityBadgeCount, 'legalEntityId' | 'count'>> };

export type ListBoostBadgeCountsQueryVariables = Exact<{
  direction: DirectionFromOrigin;
  filter: WorkItemBadgeCountFilter;
  origin: IntervalOrigin;
}>;


export type ListBoostBadgeCountsQuery = { listBoostBadgeCounts: Array<Pick<LegalEntityBadgeCount, 'legalEntityId' | 'count'>> };

export type ListConnectionBadgeCountsQueryVariables = Exact<{
  filter: ConnectionBadgeCountFilter;
}>;


export type ListConnectionBadgeCountsQuery = { listConnectionBadgeCounts: Array<Pick<LegalEntityBadgeCount, 'legalEntityId' | 'count'>> };

export type ListAccountantSuggestedUsersQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  identifier: InputObjectIdentifier;
}>;


export type ListAccountantSuggestedUsersQuery = { listAccountantSuggestedUsers: Array<(
    Pick<
      User,
      | 'id'
      | 'givenName'
      | 'familyName'
      | 'primaryEmailAddress'
      | 'passwordSet'
      | 'avatarUrl'
      | 'createdAt'
      | 'lastActivityAt'
    >
    & {
      employments?: Maybe<Array<(
        Pick<OrganizationEmployment, 'employeeId'>
        & {
          role: Pick<Role, 'id'>,
          organization: Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >,
          legalEntityRoles?: Maybe<Array<(
            Pick<EmployeeLegalEntityRole, 'legalEntityId'>
            & { role?: Maybe<Pick<Role, 'id'>> }
          )>>,
        }
      )>>,
      identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
    }
  )> };

export type ListLimitedSuggestedUsersQueryVariables = Exact<{
  identifier: InputObjectIdentifier;
}>;


export type ListLimitedSuggestedUsersQuery = { listLimitedSuggestedUsers: Array<(
    Pick<
      User,
      | 'id'
      | 'givenName'
      | 'familyName'
      | 'primaryEmailAddress'
      | 'passwordSet'
      | 'avatarUrl'
      | 'createdAt'
      | 'lastActivityAt'
    >
    & {
      employments?: Maybe<Array<(
        Pick<OrganizationEmployment, 'employeeId'>
        & {
          role: Pick<Role, 'id'>,
          organization: Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >,
          legalEntityRoles?: Maybe<Array<(
            Pick<EmployeeLegalEntityRole, 'legalEntityId'>
            & { role?: Maybe<Pick<Role, 'id'>> }
          )>>,
        }
      )>>,
      identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
    }
  )> };

export type ListShareSuggestedUsersQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ListShareSuggestedUsersQuery = { listShareSuggestedUsers: Array<(
    Pick<
      User,
      | 'id'
      | 'givenName'
      | 'familyName'
      | 'primaryEmailAddress'
      | 'passwordSet'
      | 'avatarUrl'
      | 'createdAt'
      | 'lastActivityAt'
    >
    & {
      employments?: Maybe<Array<(
        Pick<OrganizationEmployment, 'employeeId'>
        & {
          role: Pick<Role, 'id'>,
          organization: Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >,
          legalEntityRoles?: Maybe<Array<(
            Pick<EmployeeLegalEntityRole, 'legalEntityId'>
            & { role?: Maybe<Pick<Role, 'id'>> }
          )>>,
        }
      )>>,
      identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
    }
  )> };

export type ListSuggestedUsersQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  identifier: InputObjectIdentifier;
}>;


export type ListSuggestedUsersQuery = { listSuggestedUsers: Array<(
    Pick<
      User,
      | 'id'
      | 'givenName'
      | 'familyName'
      | 'primaryEmailAddress'
      | 'passwordSet'
      | 'avatarUrl'
      | 'createdAt'
      | 'lastActivityAt'
    >
    & {
      employments?: Maybe<Array<(
        Pick<OrganizationEmployment, 'employeeId'>
        & {
          role: Pick<Role, 'id'>,
          organization: Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >,
          legalEntityRoles?: Maybe<Array<(
            Pick<EmployeeLegalEntityRole, 'legalEntityId'>
            & { role?: Maybe<Pick<Role, 'id'>> }
          )>>,
        }
      )>>,
      identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
    }
  )> };

export type MatchTransactionsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  ledgerTransactionIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type MatchTransactionsMutation = Pick<Mutation, 'matchTransactions'>;

export type UnmatchTransactionsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  ledgerTransactionIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UnmatchTransactionsMutation = Pick<Mutation, 'unmatchTransactions'>;

export type TransactionReviewReminderMessageFieldsFragment = Pick<TransactionReviewReminderMessage, 'legalEntityId' | 'message'>;

export type TransactionReviewScheduleFieldsFragment = Pick<
    TransactionReviewSchedule,
    | 'daysOfMonth'
    | 'daysOfWeek'
    | 'enabled'
    | 'legalEntityId'
  >;

export type SendTransactionReviewReminderMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type SendTransactionReviewReminderMutation = Pick<Mutation, 'sendTransactionReviewReminder'>;

export type UpdateTransactionReviewReminderMessageMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type UpdateTransactionReviewReminderMessageMutation = Pick<Mutation, 'updateTransactionReviewReminderMessage'>;

export type UpdateTransactionReviewScheduleMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  daysOfWeek?: InputMaybe<Array<DayOfWeek> | DayOfWeek>;
  daysOfMonth?: InputMaybe<Array<DayOfMonth> | DayOfMonth>;
  enabled: Scalars['Boolean']['input'];
}>;


export type UpdateTransactionReviewScheduleMutation = Pick<Mutation, 'updateTransactionReviewSchedule'>;

export type ReadTransactionReviewNextReminderQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadTransactionReviewNextReminderQuery = Pick<Query, 'readTransactionReviewNextReminder'>;

export type ReadTransactionReviewReminderMessageQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadTransactionReviewReminderMessageQuery = { readTransactionReviewReminderMessage: Pick<TransactionReviewReminderMessage, 'legalEntityId' | 'message'> };

export type ReadTransactionReviewScheduleQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadTransactionReviewScheduleQuery = { readTransactionReviewSchedule: Pick<
      TransactionReviewSchedule,
      | 'daysOfMonth'
      | 'daysOfWeek'
      | 'enabled'
      | 'legalEntityId'
    > };

export type CategorySuggestionFieldsFragment = Pick<
    CategorySuggestion,
    | 'dataSourceId'
    | 'transactionFactId'
    | 'classificationVersionId'
    | 'categoryId'
    | 'type'
    | 'modelConfidence'
    | 'modelVersionId'
    | 'priority'
    | 'createdAt'
    | 'updatedAt'
  >;

export type DepartmentFacetFieldsFragment = (
  Pick<DepartmentFacet, 'count'>
  & { departmentObject: (
    { __typename: 'EntityDepartment' }
    & Pick<
      EntityDepartment,
      | 'id'
      | 'name'
      | 'parentId'
      | 'active'
    >
  ) }
);

export type InstitutionFacetFieldsFragment = (
  Pick<InstitutionFacet, 'count'>
  & { institutionObject: Pick<EntityInstitution, 'id' | 'name' | 'iconUrl'> }
);

export type LedgerTransactionFieldsFragment = (
  Pick<
    LedgerTransaction,
    | 'timestamp'
    | 'externalId'
    | 'type'
    | 'memo'
    | 'referenceNumber'
    | 'isMetadataEditable'
    | 'ledgerTransactionId'
    | 'compileSource'
    | 'matchedLedgerTransactionIds'
    | 'providerTypes'
    | 'isSupersedingLedgerTransaction'
    | 'supersededLedgerTransactionIds'
  >
  & {
    lines: Array<(
      Pick<TransactionLine, 'entryType'>
      & {
        entry: (
          Pick<TransactionEntry, 'factId' | 'externalLineId' | 'description'>
          & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        category: Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >,
        categoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
        party?: Maybe<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>,
        department?: Maybe<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        location?: Maybe<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        schedule?: Maybe<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
            | 'cutoverDate'
          >
          & {
            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>,
      }
    )>,
    sources: Array<(
      Pick<
        TransactionSource,
        | 'timestamp'
        | 'name'
        | 'iconUrl'
        | 'externalDisplayId'
        | 'type'
      >
      & { account?: Maybe<Pick<
          TransactionSourceAccount,
          | 'sourceAccountId'
          | 'externalName'
          | 'mask'
          | 'externalOwnerName'
          | 'externalOfficialName'
        >> }
    )>,
    linkedBill?: Maybe<(
      Pick<
        LinkedBill,
        | 'id'
        | 'dataSourceId'
        | 'invoiceNumber'
        | 'dueDate'
        | 'billDate'
        | 'externalId'
        | 'providerType'
      >
      & { party?: Maybe<Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        >> }
    )>,
    linkedInvoice?: Maybe<(
      Pick<
        LinkedInvoice,
        | 'id'
        | 'dataSourceId'
        | 'invoiceNumber'
        | 'referenceNumber'
        | 'dueDate'
        | 'invoiceDate'
        | 'externalId'
        | 'providerType'
        | 'status'
      >
      & { party?: Maybe<Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        >> }
    )>,
  }
);

export type LedgerTransactionStaleFieldsFragment = Pick<LedgerTransactionStale, 'stale' | 'newViewAvailable'>;

export type LinkedBillFieldsFragment = (
  Pick<
    LinkedBill,
    | 'id'
    | 'dataSourceId'
    | 'invoiceNumber'
    | 'dueDate'
    | 'billDate'
    | 'externalId'
    | 'providerType'
  >
  & { party?: Maybe<Pick<
      EntityParty,
      | 'id'
      | 'name'
      | 'iconUrl'
      | 'shortDescription'
      | 'roles'
      | 'designation'
    >> }
);

export type LinkedInvoiceFieldsFragment = (
  Pick<
    LinkedInvoice,
    | 'id'
    | 'dataSourceId'
    | 'invoiceNumber'
    | 'referenceNumber'
    | 'dueDate'
    | 'invoiceDate'
    | 'externalId'
    | 'providerType'
    | 'status'
  >
  & { party?: Maybe<Pick<
      EntityParty,
      | 'id'
      | 'name'
      | 'iconUrl'
      | 'shortDescription'
      | 'roles'
      | 'designation'
    >> }
);

export type LocationFacetFieldsFragment = (
  Pick<LocationFacet, 'count'>
  & { locationObject: (
    { __typename: 'EntityLocation' }
    & Pick<
      EntityLocation,
      | 'id'
      | 'name'
      | 'parentId'
      | 'active'
    >
  ) }
);

export type MatchedStatusFacetFieldsFragment = Pick<MatchedStatusFacet, 'status' | 'count'>;

export type MetricEquationFieldsFragment = { terms: Array<
    | (
      { __typename: 'MetricCategoriesOperand' }
      & Pick<
        MetricCategoriesOperand,
        | 'name'
        | 'isBalance'
        | 'naturalFlow'
        | 'defaultCategoryType'
      >
      & {
        categories: Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>,
        period?: Maybe<Pick<
            Period,
            | 'name'
            | 'interval'
            | 'startedAt'
            | 'endedAt'
          >>,
      }
    )
    | (
      { __typename: 'MetricOperation' }
      & Pick<MetricOperation, 'symbol'>
    )
    | (
      { __typename: 'MetricSummaryTypeOperand' }
      & Pick<
        MetricSummaryTypeOperand,
        | 'name'
        | 'type'
        | 'naturalFlow'
        | 'defaultCategoryType'
        | 'isBalance'
      >
      & { period?: Maybe<Pick<
          Period,
          | 'name'
          | 'interval'
          | 'startedAt'
          | 'endedAt'
        >> }
    )
  > };

export type MetricTermFields_MetricCategoriesOperand_Fragment = (
  { __typename: 'MetricCategoriesOperand' }
  & Pick<
    MetricCategoriesOperand,
    | 'name'
    | 'isBalance'
    | 'naturalFlow'
    | 'defaultCategoryType'
  >
  & {
    categories: Array<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>,
    period?: Maybe<Pick<
        Period,
        | 'name'
        | 'interval'
        | 'startedAt'
        | 'endedAt'
      >>,
  }
);

export type MetricTermFields_MetricOperation_Fragment = (
  { __typename: 'MetricOperation' }
  & Pick<MetricOperation, 'symbol'>
);

export type MetricTermFields_MetricSummaryTypeOperand_Fragment = (
  { __typename: 'MetricSummaryTypeOperand' }
  & Pick<
    MetricSummaryTypeOperand,
    | 'name'
    | 'type'
    | 'naturalFlow'
    | 'defaultCategoryType'
    | 'isBalance'
  >
  & { period?: Maybe<Pick<
      Period,
      | 'name'
      | 'interval'
      | 'startedAt'
      | 'endedAt'
    >> }
);

export type MetricTermFieldsFragment =
  | MetricTermFields_MetricCategoriesOperand_Fragment
  | MetricTermFields_MetricOperation_Fragment
  | MetricTermFields_MetricSummaryTypeOperand_Fragment
;

export type MetricCategoriesOperandFieldsFragment = (
  Pick<
    MetricCategoriesOperand,
    | 'name'
    | 'isBalance'
    | 'naturalFlow'
    | 'defaultCategoryType'
  >
  & {
    categories: Array<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>,
    period?: Maybe<Pick<
        Period,
        | 'name'
        | 'interval'
        | 'startedAt'
        | 'endedAt'
      >>,
  }
);

export type MetricSummaryTypeOperandFieldsFragment = (
  Pick<
    MetricSummaryTypeOperand,
    | 'name'
    | 'type'
    | 'naturalFlow'
    | 'defaultCategoryType'
    | 'isBalance'
  >
  & { period?: Maybe<Pick<
      Period,
      | 'name'
      | 'interval'
      | 'startedAt'
      | 'endedAt'
    >> }
);

export type MetricOperationFieldsFragment = Pick<MetricOperation, 'symbol'>;

export type MinMaxAmountFieldsFragment = {
    minAmount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    maxAmount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
  };

export type PartyFacetFieldsFragment = (
  Pick<PartyFacet, 'count'>
  & { partyObject: Pick<
      EntityParty,
      | 'id'
      | 'name'
      | 'iconUrl'
      | 'shortDescription'
      | 'roles'
      | 'designation'
    > }
);

export type UserFacetFieldsFragment = (
  Pick<UserFacet, 'count'>
  & { userObject: Pick<
      EntityUser,
      | 'id'
      | 'givenName'
      | 'familyName'
      | 'emailAddress'
      | 'avatarUrl'
    > }
);

export type CreateSupersedingTransactionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  supersededLedgerTransactionIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  transaction: InputTransaction;
}>;


export type CreateSupersedingTransactionMutation = { createSupersedingTransaction?: Maybe<Pick<CreateTransactionResponse, 'transactionFactIds'>> };

export type CreateTransactionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  transaction: InputTransaction;
}>;


export type CreateTransactionMutation = { createTransaction?: Maybe<Pick<CreateTransactionResponse, 'transactionFactIds'>> };

export type DeleteTransactionsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  factIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteTransactionsMutation = Pick<Mutation, 'deleteTransactions'>;

export type EnqueueStatementImportWorkflowsMutationVariables = Exact<{
  input: EnqueueStatementImportWorkflowsInput;
}>;


export type EnqueueStatementImportWorkflowsMutation = { enqueueStatementImportWorkflows: Pick<EnqueueStatementImportWorkflowsPayload, 'workflowIds'> };

export type StartBulkCsvImportMutationVariables = Exact<{
  input: StartBulkCsvImportInput;
}>;


export type StartBulkCsvImportMutation = { startBulkCSVImport: Pick<StartBulkCsvImportPayload, 'workflowId'> };

export type StartJournalEntriesImportMutationVariables = Exact<{
  input: StartJournalEntriesImportInput;
}>;


export type StartJournalEntriesImportMutation = { startJournalEntriesImport: Pick<StartJournalEntriesImportPayload, 'workflowId'> };

export type UpdateTransactionMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  transaction: InputTransaction;
  filter: TransactionFilter;
}>;


export type UpdateTransactionMutation = Pick<Mutation, 'updateTransaction'>;

export type UpdateTransactionBillMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  bill: BillEdit;
}>;


export type UpdateTransactionBillMutation = Pick<Mutation, 'updateTransactionBill'>;

export type UpdateTransactionFieldsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  viewKey: ViewKey;
  updates: Array<InputUpdateFields> | InputUpdateFields;
}>;


export type UpdateTransactionFieldsMutation = Pick<Mutation, 'updateTransactionFields'>;

export type UpdateTransactionInvoiceMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  invoice: InvoiceEdit;
}>;


export type UpdateTransactionInvoiceMutation = Pick<Mutation, 'updateTransactionInvoice'>;

export type CheckLedgerTransactionStaleQueryVariables = Exact<{
  ledgerTransactionId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  viewKey: ViewKey;
}>;


export type CheckLedgerTransactionStaleQuery = { checkLedgerTransactionStale: Pick<LedgerTransactionStale, 'stale' | 'newViewAvailable'> };

export type ExportTransactionsQueryVariables = Exact<{
  filter: TransactionFilter;
  direction: DirectionFromOrigin;
  origin: IntervalOrigin;
  fileName?: InputMaybe<Scalars['String']['input']>;
  temporary?: InputMaybe<Scalars['Boolean']['input']>;
  singleColumnAmount?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Array<CsvExportField> | CsvExportField>;
  orderPairs?: InputMaybe<Array<TransactionOrderPair> | TransactionOrderPair>;
}>;


export type ExportTransactionsQuery = { exportTransactions: Pick<DocumentInitialSegment, 'collectionId' | 'documentId' | 'downloadUrl'> };

export type FacetDepartmentQueryVariables = Exact<{
  pagination: Pagination;
  paginationDirection: DirectionFromOrigin;
  filter: FacetFilter;
  intervalOrigin: IntervalOrigin;
}>;


export type FacetDepartmentQuery = { transactionFacet: { department: Array<(
      Pick<DepartmentFacet, 'count'>
      & { departmentObject: (
        { __typename: 'EntityDepartment' }
        & Pick<
          EntityDepartment,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      ) }
    )> } };

export type FacetDepartmentAggregateQueryVariables = Exact<{
  filter: FacetFilter;
  intervalOrigin: IntervalOrigin;
}>;


export type FacetDepartmentAggregateQuery = { transactionFacet: Pick<Facet, 'aggregate'> };

export type FacetLocationQueryVariables = Exact<{
  pagination: Pagination;
  paginationDirection: DirectionFromOrigin;
  filter: FacetFilter;
  intervalOrigin: IntervalOrigin;
}>;


export type FacetLocationQuery = { transactionFacet: { location: Array<(
      Pick<LocationFacet, 'count'>
      & { locationObject: (
        { __typename: 'EntityLocation' }
        & Pick<
          EntityLocation,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      ) }
    )> } };

export type FacetLocationAggregateQueryVariables = Exact<{
  filter: FacetFilter;
  intervalOrigin: IntervalOrigin;
}>;


export type FacetLocationAggregateQuery = { transactionFacet: Pick<Facet, 'aggregate'> };

export type FacetMatchedStatusQueryVariables = Exact<{
  pagination: Pagination;
  paginationDirection: DirectionFromOrigin;
  filter: FacetFilter;
  intervalOrigin: IntervalOrigin;
}>;


export type FacetMatchedStatusQuery = { transactionFacet: { matchedStatus: Array<Pick<MatchedStatusFacet, 'status' | 'count'>> } };

export type FacetNewPartyQueryVariables = Exact<{
  pagination: Pagination;
  paginationDirection: DirectionFromOrigin;
  filter: FacetFilter;
  intervalOrigin: IntervalOrigin;
}>;


export type FacetNewPartyQuery = { transactionFacet: { party: Array<(
      Pick<PartyFacet, 'count'>
      & { partyObject: Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        > }
    )> } };

export type FacetPartyQueryVariables = Exact<{
  pagination: Pagination;
  paginationDirection: DirectionFromOrigin;
  filter: FacetFilter;
  intervalOrigin: IntervalOrigin;
}>;


export type FacetPartyQuery = { transactionFacet: { party: Array<(
      Pick<PartyFacet, 'count'>
      & { partyObject: Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        > }
    )> } };

export type FacetPartyAggregateQueryVariables = Exact<{
  filter: FacetFilter;
  intervalOrigin: IntervalOrigin;
}>;


export type FacetPartyAggregateQuery = { transactionFacet: Pick<Facet, 'aggregate'> };

export type FacetSourceUserQueryVariables = Exact<{
  pagination: Pagination;
  paginationDirection: DirectionFromOrigin;
  filter: FacetFilter;
  intervalOrigin: IntervalOrigin;
}>;


export type FacetSourceUserQuery = { transactionFacet: { user: Array<(
      Pick<UserFacet, 'count'>
      & { userObject: Pick<
          EntityUser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        > }
    )> } };

export type FacetSourcesQueryVariables = Exact<{
  userPagination: Pagination;
  institutionPagination: Pagination;
  paginationDirection: DirectionFromOrigin;
  filter: FacetFilter;
  intervalOrigin: IntervalOrigin;
}>;


export type FacetSourcesQuery = {
    institution: { institution: Array<(
        Pick<InstitutionFacet, 'count'>
        & { institutionObject: Pick<EntityInstitution, 'id' | 'name' | 'iconUrl'> }
      )> },
    user: { user: Array<(
        Pick<UserFacet, 'count'>
        & { userObject: Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          > }
      )> },
  };

export type FacetSourcesAggregateQueryVariables = Exact<{
  filter: FacetFilter;
  intervalOrigin: IntervalOrigin;
}>;


export type FacetSourcesAggregateQuery = {
    institution: Pick<Facet, 'aggregate'>,
    user: Pick<Facet, 'aggregate'>,
  };

export type ListMetricTransactionsQueryVariables = Exact<{
  viewKey: ViewKey;
  metricSummaryType?: InputMaybe<MetricSummaryItem>;
  summaryLineType?: InputMaybe<SummaryLineItem>;
  pagination: Pagination;
  sortColumnName: TransactionColumnName;
  sortDirection: SortDirection;
  intervalOrigin: IntervalOrigin;
}>;


export type ListMetricTransactionsQuery = { listTransactions: Array<(
    Pick<
      Transaction,
      | 'viewId'
      | 'factId'
      | 'ledgerTransactionId'
      | 'supersededFactIds'
      | 'timestamp'
      | 'recordType'
      | 'name'
      | 'description'
      | 'digitsTransactionType'
      | 'partySource'
      | 'displayEntry'
      | 'displayCategorySource'
      | 'displayCanonicalCategoryName'
      | 'displayUncategorizedReason'
      | 'displayProductArea'
      | 'ownerSource'
      | 'transactionClassificationType'
      | 'compileSource'
      | 'reconciliationStatus'
      | 'referenceNumber'
      | 'taxStatus'
      | 'matchedLedgerTransactionIds'
      | 'providerTypes'
      | 'isSupersedingLedgerTransaction'
      | 'supersededLedgerTransactionIds'
    >
    & {
      party?: Maybe<Pick<
          TransactionParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'iconObjectName'
          | 'designation'
          | 'roles'
        >>,
      facilitatorParty?: Maybe<Pick<
          TransactionParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'iconObjectName'
          | 'designation'
          | 'roles'
        >>,
      product?: Maybe<Pick<
          Product,
          | 'id'
          | 'dataSourceId'
          | 'name'
          | 'providerType'
          | 'active'
          | 'institutionId'
          | 'institutionName'
        >>,
      department?: Maybe<(
        { __typename: 'EntityDepartment' }
        & Pick<
          EntityDepartment,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      splitDepartment?: Maybe<(
        { __typename: 'EntityDepartment' }
        & Pick<
          EntityDepartment,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      location?: Maybe<(
        { __typename: 'EntityLocation' }
        & Pick<
          EntityLocation,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      splitLocation?: Maybe<(
        { __typename: 'EntityLocation' }
        & Pick<
          EntityLocation,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      providers: Array<Pick<Provider, 'name'>>,
      recurrence?: Maybe<Pick<
          TransactionRecurrence,
          | 'recurrenceThreadId'
          | 'interval'
          | 'intervalMultiplier'
          | 'threadIndex'
          | 'totalThreadCount'
          | 'isHidden'
          | 'firstOccurredAt'
          | 'lastOccurredAt'
        >>,
      displayInstitution?: Maybe<Pick<
          TransactionParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'iconObjectName'
          | 'designation'
          | 'roles'
        >>,
      displayCategory: (
        Pick<
          Category,
          | 'id'
          | 'name'
          | 'description'
          | 'displayKey'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'displayNumber'
          | 'active'
          | 'categoryState'
          | 'productArea'
          | 'synthesized'
        >
        & { ancestors?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>> }
      ),
      displayCategoryClassificationProvenance?: Maybe<(
        Pick<
          ClassificationProvenance,
          | 'type'
          | 'changedAt'
          | 'confidenceLevel'
          | 'settingsName'
        >
        & { source?: Maybe<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )> }
      )>,
      splitCategory?: Maybe<(
        Pick<
          Category,
          | 'id'
          | 'name'
          | 'description'
          | 'displayKey'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'displayNumber'
          | 'active'
          | 'categoryState'
          | 'productArea'
          | 'synthesized'
        >
        & { ancestors?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>> }
      )>,
      splitCategoryClassificationProvenance?: Maybe<(
        Pick<
          ClassificationProvenance,
          | 'type'
          | 'changedAt'
          | 'confidenceLevel'
          | 'settingsName'
        >
        & { source?: Maybe<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )> }
      )>,
      splitInstitution?: Maybe<Pick<
          TransactionParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'iconObjectName'
          | 'designation'
          | 'roles'
        >>,
      creditCategoryClassificationProvenance?: Maybe<(
        Pick<
          ClassificationProvenance,
          | 'type'
          | 'changedAt'
          | 'confidenceLevel'
          | 'settingsName'
        >
        & { source?: Maybe<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )> }
      )>,
      debitCategoryClassificationProvenance?: Maybe<(
        Pick<
          ClassificationProvenance,
          | 'type'
          | 'changedAt'
          | 'confidenceLevel'
          | 'settingsName'
        >
        & { source?: Maybe<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )> }
      )>,
      moneyFlow: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ),
      runningTotal?: Maybe<(
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      )>,
      owner?: Maybe<Pick<
          EntityEmployee,
          | 'id'
          | 'organizationId'
          | 'givenName'
          | 'familyName'
          | 'avatarUrl'
        >>,
      sources: Array<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )>,
      creditSources: Array<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )>,
      debitSources: Array<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )>,
      invoiceLineItem?: Maybe<{ value:
          | (
            Pick<
              TransactionDiscountLineItem,
              | 'name'
              | 'description'
              | 'variablePercentage'
              | 'appliesToTransactionFactId'
            >
            & {
              fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              discount?: Maybe<(
                Pick<
                  TransactionInvoiceLineItemDiscount,
                  | 'discountId'
                  | 'name'
                  | 'description'
                  | 'variablePercentage'
                >
                & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
              )>,
            }
          )
          | (
            Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
            & {
              unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              product?: Maybe<(
                Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                & {
                  unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  category?: Maybe<(
                    Pick<
                      Category,
                      | 'id'
                      | 'name'
                      | 'description'
                      | 'displayKey'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'displayNumber'
                      | 'active'
                      | 'categoryState'
                      | 'productArea'
                      | 'synthesized'
                    >
                    & { ancestors?: Maybe<Array<Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >>> }
                  )>,
                  department?: Maybe<(
                    { __typename: 'EntityDepartment' }
                    & Pick<
                      EntityDepartment,
                      | 'id'
                      | 'name'
                      | 'parentId'
                      | 'active'
                    >
                  )>,
                  location?: Maybe<(
                    { __typename: 'EntityLocation' }
                    & Pick<
                      EntityLocation,
                      | 'id'
                      | 'name'
                      | 'parentId'
                      | 'active'
                    >
                  )>,
                }
              )>,
            }
          )
         }>,
      schedule?: Maybe<(
        { __typename: 'EntitySchedule' }
        & Pick<
          EntitySchedule,
          | 'id'
          | 'name'
          | 'scheduleNumber'
          | 'scheduleType'
          | 'scheduleTemplateId'
          | 'categoryId'
          | 'relatedCategoryId'
          | 'partyId'
          | 'startDate'
          | 'endDate'
          | 'cutoverDate'
        >
        & {
          amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        }
      )>,
      splitSchedule?: Maybe<(
        { __typename: 'EntitySchedule' }
        & Pick<
          EntitySchedule,
          | 'id'
          | 'name'
          | 'scheduleNumber'
          | 'scheduleType'
          | 'scheduleTemplateId'
          | 'categoryId'
          | 'relatedCategoryId'
          | 'partyId'
          | 'startDate'
          | 'endDate'
          | 'cutoverDate'
        >
        & {
          amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        }
      )>,
    }
  )> };

export type ListSimilarTransactionsQueryVariables = Exact<{
  viewKey: ViewKey;
  factId: Scalars['String']['input'];
  entryType: EntryType;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  numNeighbors?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListSimilarTransactionsQuery = { listSimilarTransactions: Array<(
    Pick<
      Transaction,
      | 'viewId'
      | 'factId'
      | 'ledgerTransactionId'
      | 'supersededFactIds'
      | 'timestamp'
      | 'recordType'
      | 'name'
      | 'description'
      | 'digitsTransactionType'
      | 'partySource'
      | 'displayEntry'
      | 'displayCategorySource'
      | 'displayCanonicalCategoryName'
      | 'displayUncategorizedReason'
      | 'displayProductArea'
      | 'ownerSource'
      | 'transactionClassificationType'
      | 'compileSource'
      | 'reconciliationStatus'
      | 'referenceNumber'
      | 'taxStatus'
      | 'matchedLedgerTransactionIds'
      | 'providerTypes'
      | 'isSupersedingLedgerTransaction'
      | 'supersededLedgerTransactionIds'
    >
    & {
      party?: Maybe<Pick<
          TransactionParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'iconObjectName'
          | 'designation'
          | 'roles'
        >>,
      facilitatorParty?: Maybe<Pick<
          TransactionParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'iconObjectName'
          | 'designation'
          | 'roles'
        >>,
      product?: Maybe<Pick<
          Product,
          | 'id'
          | 'dataSourceId'
          | 'name'
          | 'providerType'
          | 'active'
          | 'institutionId'
          | 'institutionName'
        >>,
      department?: Maybe<(
        { __typename: 'EntityDepartment' }
        & Pick<
          EntityDepartment,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      splitDepartment?: Maybe<(
        { __typename: 'EntityDepartment' }
        & Pick<
          EntityDepartment,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      location?: Maybe<(
        { __typename: 'EntityLocation' }
        & Pick<
          EntityLocation,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      splitLocation?: Maybe<(
        { __typename: 'EntityLocation' }
        & Pick<
          EntityLocation,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      providers: Array<Pick<Provider, 'name'>>,
      recurrence?: Maybe<Pick<
          TransactionRecurrence,
          | 'recurrenceThreadId'
          | 'interval'
          | 'intervalMultiplier'
          | 'threadIndex'
          | 'totalThreadCount'
          | 'isHidden'
          | 'firstOccurredAt'
          | 'lastOccurredAt'
        >>,
      displayInstitution?: Maybe<Pick<
          TransactionParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'iconObjectName'
          | 'designation'
          | 'roles'
        >>,
      displayCategory: (
        Pick<
          Category,
          | 'id'
          | 'name'
          | 'description'
          | 'displayKey'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'displayNumber'
          | 'active'
          | 'categoryState'
          | 'productArea'
          | 'synthesized'
        >
        & { ancestors?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>> }
      ),
      displayCategoryClassificationProvenance?: Maybe<(
        Pick<
          ClassificationProvenance,
          | 'type'
          | 'changedAt'
          | 'confidenceLevel'
          | 'settingsName'
        >
        & { source?: Maybe<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )> }
      )>,
      splitCategory?: Maybe<(
        Pick<
          Category,
          | 'id'
          | 'name'
          | 'description'
          | 'displayKey'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'displayNumber'
          | 'active'
          | 'categoryState'
          | 'productArea'
          | 'synthesized'
        >
        & { ancestors?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>> }
      )>,
      splitCategoryClassificationProvenance?: Maybe<(
        Pick<
          ClassificationProvenance,
          | 'type'
          | 'changedAt'
          | 'confidenceLevel'
          | 'settingsName'
        >
        & { source?: Maybe<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )> }
      )>,
      splitInstitution?: Maybe<Pick<
          TransactionParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'iconObjectName'
          | 'designation'
          | 'roles'
        >>,
      creditCategoryClassificationProvenance?: Maybe<(
        Pick<
          ClassificationProvenance,
          | 'type'
          | 'changedAt'
          | 'confidenceLevel'
          | 'settingsName'
        >
        & { source?: Maybe<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )> }
      )>,
      debitCategoryClassificationProvenance?: Maybe<(
        Pick<
          ClassificationProvenance,
          | 'type'
          | 'changedAt'
          | 'confidenceLevel'
          | 'settingsName'
        >
        & { source?: Maybe<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )> }
      )>,
      moneyFlow: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ),
      runningTotal?: Maybe<(
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      )>,
      owner?: Maybe<Pick<
          EntityEmployee,
          | 'id'
          | 'organizationId'
          | 'givenName'
          | 'familyName'
          | 'avatarUrl'
        >>,
      sources: Array<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )>,
      creditSources: Array<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )>,
      debitSources: Array<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )>,
      invoiceLineItem?: Maybe<{ value:
          | (
            Pick<
              TransactionDiscountLineItem,
              | 'name'
              | 'description'
              | 'variablePercentage'
              | 'appliesToTransactionFactId'
            >
            & {
              fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              discount?: Maybe<(
                Pick<
                  TransactionInvoiceLineItemDiscount,
                  | 'discountId'
                  | 'name'
                  | 'description'
                  | 'variablePercentage'
                >
                & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
              )>,
            }
          )
          | (
            Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
            & {
              unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              product?: Maybe<(
                Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                & {
                  unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  category?: Maybe<(
                    Pick<
                      Category,
                      | 'id'
                      | 'name'
                      | 'description'
                      | 'displayKey'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'displayNumber'
                      | 'active'
                      | 'categoryState'
                      | 'productArea'
                      | 'synthesized'
                    >
                    & { ancestors?: Maybe<Array<Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >>> }
                  )>,
                  department?: Maybe<(
                    { __typename: 'EntityDepartment' }
                    & Pick<
                      EntityDepartment,
                      | 'id'
                      | 'name'
                      | 'parentId'
                      | 'active'
                    >
                  )>,
                  location?: Maybe<(
                    { __typename: 'EntityLocation' }
                    & Pick<
                      EntityLocation,
                      | 'id'
                      | 'name'
                      | 'parentId'
                      | 'active'
                    >
                  )>,
                }
              )>,
            }
          )
         }>,
      schedule?: Maybe<(
        { __typename: 'EntitySchedule' }
        & Pick<
          EntitySchedule,
          | 'id'
          | 'name'
          | 'scheduleNumber'
          | 'scheduleType'
          | 'scheduleTemplateId'
          | 'categoryId'
          | 'relatedCategoryId'
          | 'partyId'
          | 'startDate'
          | 'endDate'
          | 'cutoverDate'
        >
        & {
          amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        }
      )>,
      splitSchedule?: Maybe<(
        { __typename: 'EntitySchedule' }
        & Pick<
          EntitySchedule,
          | 'id'
          | 'name'
          | 'scheduleNumber'
          | 'scheduleType'
          | 'scheduleTemplateId'
          | 'categoryId'
          | 'relatedCategoryId'
          | 'partyId'
          | 'startDate'
          | 'endDate'
          | 'cutoverDate'
        >
        & {
          amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        }
      )>,
    }
  )> };

export type ListTransactionEditingHistoryQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  factId: Scalars['String']['input'];
}>;


export type ListTransactionEditingHistoryQuery = { listTransactionEditingHistory: Array<(
    Pick<
      TransactionSource,
      | 'timestamp'
      | 'name'
      | 'iconUrl'
      | 'externalDisplayId'
      | 'type'
    >
    & { account?: Maybe<Pick<
        TransactionSourceAccount,
        | 'sourceAccountId'
        | 'externalName'
        | 'mask'
        | 'externalOwnerName'
        | 'externalOfficialName'
      >> }
  )> };

export type ListTransactionsQueryVariables = Exact<{
  pagination: Pagination;
  paginationDirection: DirectionFromOrigin;
  sortColumnName: TransactionColumnName;
  sortDirection: SortDirection;
  filter: TransactionFilter;
  intervalOrigin: IntervalOrigin;
  naturalFlow?: InputMaybe<Flow>;
}>;


export type ListTransactionsQuery = { listTransactions: Array<(
    Pick<
      Transaction,
      | 'viewId'
      | 'factId'
      | 'ledgerTransactionId'
      | 'supersededFactIds'
      | 'timestamp'
      | 'recordType'
      | 'name'
      | 'description'
      | 'digitsTransactionType'
      | 'partySource'
      | 'displayEntry'
      | 'displayCategorySource'
      | 'displayCanonicalCategoryName'
      | 'displayUncategorizedReason'
      | 'displayProductArea'
      | 'ownerSource'
      | 'transactionClassificationType'
      | 'compileSource'
      | 'reconciliationStatus'
      | 'referenceNumber'
      | 'taxStatus'
      | 'matchedLedgerTransactionIds'
      | 'providerTypes'
      | 'isSupersedingLedgerTransaction'
      | 'supersededLedgerTransactionIds'
    >
    & {
      party?: Maybe<Pick<
          TransactionParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'iconObjectName'
          | 'designation'
          | 'roles'
        >>,
      facilitatorParty?: Maybe<Pick<
          TransactionParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'iconObjectName'
          | 'designation'
          | 'roles'
        >>,
      product?: Maybe<Pick<
          Product,
          | 'id'
          | 'dataSourceId'
          | 'name'
          | 'providerType'
          | 'active'
          | 'institutionId'
          | 'institutionName'
        >>,
      department?: Maybe<(
        { __typename: 'EntityDepartment' }
        & Pick<
          EntityDepartment,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      splitDepartment?: Maybe<(
        { __typename: 'EntityDepartment' }
        & Pick<
          EntityDepartment,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      location?: Maybe<(
        { __typename: 'EntityLocation' }
        & Pick<
          EntityLocation,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      splitLocation?: Maybe<(
        { __typename: 'EntityLocation' }
        & Pick<
          EntityLocation,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      providers: Array<Pick<Provider, 'name'>>,
      recurrence?: Maybe<Pick<
          TransactionRecurrence,
          | 'recurrenceThreadId'
          | 'interval'
          | 'intervalMultiplier'
          | 'threadIndex'
          | 'totalThreadCount'
          | 'isHidden'
          | 'firstOccurredAt'
          | 'lastOccurredAt'
        >>,
      displayInstitution?: Maybe<Pick<
          TransactionParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'iconObjectName'
          | 'designation'
          | 'roles'
        >>,
      displayCategory: (
        Pick<
          Category,
          | 'id'
          | 'name'
          | 'description'
          | 'displayKey'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'displayNumber'
          | 'active'
          | 'categoryState'
          | 'productArea'
          | 'synthesized'
        >
        & { ancestors?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>> }
      ),
      displayCategoryClassificationProvenance?: Maybe<(
        Pick<
          ClassificationProvenance,
          | 'type'
          | 'changedAt'
          | 'confidenceLevel'
          | 'settingsName'
        >
        & { source?: Maybe<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )> }
      )>,
      splitCategory?: Maybe<(
        Pick<
          Category,
          | 'id'
          | 'name'
          | 'description'
          | 'displayKey'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'displayNumber'
          | 'active'
          | 'categoryState'
          | 'productArea'
          | 'synthesized'
        >
        & { ancestors?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>> }
      )>,
      splitCategoryClassificationProvenance?: Maybe<(
        Pick<
          ClassificationProvenance,
          | 'type'
          | 'changedAt'
          | 'confidenceLevel'
          | 'settingsName'
        >
        & { source?: Maybe<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )> }
      )>,
      splitInstitution?: Maybe<Pick<
          TransactionParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'iconObjectName'
          | 'designation'
          | 'roles'
        >>,
      creditCategoryClassificationProvenance?: Maybe<(
        Pick<
          ClassificationProvenance,
          | 'type'
          | 'changedAt'
          | 'confidenceLevel'
          | 'settingsName'
        >
        & { source?: Maybe<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )> }
      )>,
      debitCategoryClassificationProvenance?: Maybe<(
        Pick<
          ClassificationProvenance,
          | 'type'
          | 'changedAt'
          | 'confidenceLevel'
          | 'settingsName'
        >
        & { source?: Maybe<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )> }
      )>,
      moneyFlow: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ),
      runningTotal?: Maybe<(
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      )>,
      owner?: Maybe<Pick<
          EntityEmployee,
          | 'id'
          | 'organizationId'
          | 'givenName'
          | 'familyName'
          | 'avatarUrl'
        >>,
      sources: Array<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )>,
      creditSources: Array<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )>,
      debitSources: Array<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )>,
      invoiceLineItem?: Maybe<{ value:
          | (
            Pick<
              TransactionDiscountLineItem,
              | 'name'
              | 'description'
              | 'variablePercentage'
              | 'appliesToTransactionFactId'
            >
            & {
              fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              discount?: Maybe<(
                Pick<
                  TransactionInvoiceLineItemDiscount,
                  | 'discountId'
                  | 'name'
                  | 'description'
                  | 'variablePercentage'
                >
                & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
              )>,
            }
          )
          | (
            Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
            & {
              unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              product?: Maybe<(
                Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                & {
                  unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  category?: Maybe<(
                    Pick<
                      Category,
                      | 'id'
                      | 'name'
                      | 'description'
                      | 'displayKey'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'displayNumber'
                      | 'active'
                      | 'categoryState'
                      | 'productArea'
                      | 'synthesized'
                    >
                    & { ancestors?: Maybe<Array<Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >>> }
                  )>,
                  department?: Maybe<(
                    { __typename: 'EntityDepartment' }
                    & Pick<
                      EntityDepartment,
                      | 'id'
                      | 'name'
                      | 'parentId'
                      | 'active'
                    >
                  )>,
                  location?: Maybe<(
                    { __typename: 'EntityLocation' }
                    & Pick<
                      EntityLocation,
                      | 'id'
                      | 'name'
                      | 'parentId'
                      | 'active'
                    >
                  )>,
                }
              )>,
            }
          )
         }>,
      schedule?: Maybe<(
        { __typename: 'EntitySchedule' }
        & Pick<
          EntitySchedule,
          | 'id'
          | 'name'
          | 'scheduleNumber'
          | 'scheduleType'
          | 'scheduleTemplateId'
          | 'categoryId'
          | 'relatedCategoryId'
          | 'partyId'
          | 'startDate'
          | 'endDate'
          | 'cutoverDate'
        >
        & {
          amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        }
      )>,
      splitSchedule?: Maybe<(
        { __typename: 'EntitySchedule' }
        & Pick<
          EntitySchedule,
          | 'id'
          | 'name'
          | 'scheduleNumber'
          | 'scheduleType'
          | 'scheduleTemplateId'
          | 'categoryId'
          | 'relatedCategoryId'
          | 'partyId'
          | 'startDate'
          | 'endDate'
          | 'cutoverDate'
        >
        & {
          amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        }
      )>,
    }
  )> };

export type ListTransactionsByFactIdsQueryVariables = Exact<{
  viewKey: ViewKey;
  factIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ListTransactionsByFactIdsQuery = { listTransactionsByFactIds: Array<(
    Pick<
      Transaction,
      | 'viewId'
      | 'factId'
      | 'ledgerTransactionId'
      | 'supersededFactIds'
      | 'timestamp'
      | 'recordType'
      | 'name'
      | 'description'
      | 'digitsTransactionType'
      | 'partySource'
      | 'displayEntry'
      | 'displayCategorySource'
      | 'displayCanonicalCategoryName'
      | 'displayUncategorizedReason'
      | 'displayProductArea'
      | 'ownerSource'
      | 'transactionClassificationType'
      | 'compileSource'
      | 'reconciliationStatus'
      | 'referenceNumber'
      | 'taxStatus'
      | 'matchedLedgerTransactionIds'
      | 'providerTypes'
      | 'isSupersedingLedgerTransaction'
      | 'supersededLedgerTransactionIds'
    >
    & {
      party?: Maybe<Pick<
          TransactionParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'iconObjectName'
          | 'designation'
          | 'roles'
        >>,
      facilitatorParty?: Maybe<Pick<
          TransactionParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'iconObjectName'
          | 'designation'
          | 'roles'
        >>,
      product?: Maybe<Pick<
          Product,
          | 'id'
          | 'dataSourceId'
          | 'name'
          | 'providerType'
          | 'active'
          | 'institutionId'
          | 'institutionName'
        >>,
      department?: Maybe<(
        { __typename: 'EntityDepartment' }
        & Pick<
          EntityDepartment,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      splitDepartment?: Maybe<(
        { __typename: 'EntityDepartment' }
        & Pick<
          EntityDepartment,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      location?: Maybe<(
        { __typename: 'EntityLocation' }
        & Pick<
          EntityLocation,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      splitLocation?: Maybe<(
        { __typename: 'EntityLocation' }
        & Pick<
          EntityLocation,
          | 'id'
          | 'name'
          | 'parentId'
          | 'active'
        >
      )>,
      providers: Array<Pick<Provider, 'name'>>,
      recurrence?: Maybe<Pick<
          TransactionRecurrence,
          | 'recurrenceThreadId'
          | 'interval'
          | 'intervalMultiplier'
          | 'threadIndex'
          | 'totalThreadCount'
          | 'isHidden'
          | 'firstOccurredAt'
          | 'lastOccurredAt'
        >>,
      displayInstitution?: Maybe<Pick<
          TransactionParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'iconObjectName'
          | 'designation'
          | 'roles'
        >>,
      displayCategory: (
        Pick<
          Category,
          | 'id'
          | 'name'
          | 'description'
          | 'displayKey'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'displayNumber'
          | 'active'
          | 'categoryState'
          | 'productArea'
          | 'synthesized'
        >
        & { ancestors?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>> }
      ),
      displayCategoryClassificationProvenance?: Maybe<(
        Pick<
          ClassificationProvenance,
          | 'type'
          | 'changedAt'
          | 'confidenceLevel'
          | 'settingsName'
        >
        & { source?: Maybe<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )> }
      )>,
      splitCategory?: Maybe<(
        Pick<
          Category,
          | 'id'
          | 'name'
          | 'description'
          | 'displayKey'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'displayNumber'
          | 'active'
          | 'categoryState'
          | 'productArea'
          | 'synthesized'
        >
        & { ancestors?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>> }
      )>,
      splitCategoryClassificationProvenance?: Maybe<(
        Pick<
          ClassificationProvenance,
          | 'type'
          | 'changedAt'
          | 'confidenceLevel'
          | 'settingsName'
        >
        & { source?: Maybe<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )> }
      )>,
      splitInstitution?: Maybe<Pick<
          TransactionParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'iconObjectName'
          | 'designation'
          | 'roles'
        >>,
      creditCategoryClassificationProvenance?: Maybe<(
        Pick<
          ClassificationProvenance,
          | 'type'
          | 'changedAt'
          | 'confidenceLevel'
          | 'settingsName'
        >
        & { source?: Maybe<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )> }
      )>,
      debitCategoryClassificationProvenance?: Maybe<(
        Pick<
          ClassificationProvenance,
          | 'type'
          | 'changedAt'
          | 'confidenceLevel'
          | 'settingsName'
        >
        & { source?: Maybe<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )> }
      )>,
      moneyFlow: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ),
      runningTotal?: Maybe<(
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      )>,
      owner?: Maybe<Pick<
          EntityEmployee,
          | 'id'
          | 'organizationId'
          | 'givenName'
          | 'familyName'
          | 'avatarUrl'
        >>,
      sources: Array<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )>,
      creditSources: Array<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )>,
      debitSources: Array<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )>,
      invoiceLineItem?: Maybe<{ value:
          | (
            Pick<
              TransactionDiscountLineItem,
              | 'name'
              | 'description'
              | 'variablePercentage'
              | 'appliesToTransactionFactId'
            >
            & {
              fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              discount?: Maybe<(
                Pick<
                  TransactionInvoiceLineItemDiscount,
                  | 'discountId'
                  | 'name'
                  | 'description'
                  | 'variablePercentage'
                >
                & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
              )>,
            }
          )
          | (
            Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
            & {
              unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              product?: Maybe<(
                Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                & {
                  unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  category?: Maybe<(
                    Pick<
                      Category,
                      | 'id'
                      | 'name'
                      | 'description'
                      | 'displayKey'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'displayNumber'
                      | 'active'
                      | 'categoryState'
                      | 'productArea'
                      | 'synthesized'
                    >
                    & { ancestors?: Maybe<Array<Pick<
                        EntityCategory,
                        | 'id'
                        | 'name'
                        | 'displayKey'
                        | 'chartOfAccountsDisplayNumber'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'productArea'
                        | 'active'
                      >>> }
                  )>,
                  department?: Maybe<(
                    { __typename: 'EntityDepartment' }
                    & Pick<
                      EntityDepartment,
                      | 'id'
                      | 'name'
                      | 'parentId'
                      | 'active'
                    >
                  )>,
                  location?: Maybe<(
                    { __typename: 'EntityLocation' }
                    & Pick<
                      EntityLocation,
                      | 'id'
                      | 'name'
                      | 'parentId'
                      | 'active'
                    >
                  )>,
                }
              )>,
            }
          )
         }>,
      schedule?: Maybe<(
        { __typename: 'EntitySchedule' }
        & Pick<
          EntitySchedule,
          | 'id'
          | 'name'
          | 'scheduleNumber'
          | 'scheduleType'
          | 'scheduleTemplateId'
          | 'categoryId'
          | 'relatedCategoryId'
          | 'partyId'
          | 'startDate'
          | 'endDate'
          | 'cutoverDate'
        >
        & {
          amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        }
      )>,
      splitSchedule?: Maybe<(
        { __typename: 'EntitySchedule' }
        & Pick<
          EntitySchedule,
          | 'id'
          | 'name'
          | 'scheduleNumber'
          | 'scheduleType'
          | 'scheduleTemplateId'
          | 'categoryId'
          | 'relatedCategoryId'
          | 'partyId'
          | 'startDate'
          | 'endDate'
          | 'cutoverDate'
        >
        & {
          amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        }
      )>,
    }
  )> };

export type MinMaxAmountQueryVariables = Exact<{
  filter: TransactionFilter;
  origin: IntervalOrigin;
  direction: DirectionFromOrigin;
}>;


export type MinMaxAmountQuery = { minMaxAmount: {
      minAmount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      maxAmount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    } };

export type ReadCategorySuggestionsQueryVariables = Exact<{
  transactionFactId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
  entryType: EntryType;
}>;


export type ReadCategorySuggestionsQuery = { readCategorySuggestions: Array<Pick<
      CategorySuggestion,
      | 'dataSourceId'
      | 'transactionFactId'
      | 'classificationVersionId'
      | 'categoryId'
      | 'type'
      | 'modelConfidence'
      | 'modelVersionId'
      | 'priority'
      | 'createdAt'
      | 'updatedAt'
    >> };

export type ReadLedgerTransactionQueryVariables = Exact<{
  transactionFactId: Scalars['String']['input'];
  filter: TransactionFilter;
}>;


export type ReadLedgerTransactionQuery = { readLedgerTransaction: { transaction: (
      Pick<
        LedgerTransaction,
        | 'timestamp'
        | 'externalId'
        | 'type'
        | 'memo'
        | 'referenceNumber'
        | 'isMetadataEditable'
        | 'ledgerTransactionId'
        | 'compileSource'
        | 'matchedLedgerTransactionIds'
        | 'providerTypes'
        | 'isSupersedingLedgerTransaction'
        | 'supersededLedgerTransactionIds'
      >
      & {
        lines: Array<(
          Pick<TransactionLine, 'entryType'>
          & {
            entry: (
              Pick<TransactionEntry, 'factId' | 'externalLineId' | 'description'>
              & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            category: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            categoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            party?: Maybe<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
            department?: Maybe<(
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            location?: Maybe<(
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            schedule?: Maybe<(
              { __typename: 'EntitySchedule' }
              & Pick<
                EntitySchedule,
                | 'id'
                | 'name'
                | 'scheduleNumber'
                | 'scheduleType'
                | 'scheduleTemplateId'
                | 'categoryId'
                | 'relatedCategoryId'
                | 'partyId'
                | 'startDate'
                | 'endDate'
                | 'cutoverDate'
              >
              & {
                amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              }
            )>,
          }
        )>,
        sources: Array<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )>,
        linkedBill?: Maybe<(
          Pick<
            LinkedBill,
            | 'id'
            | 'dataSourceId'
            | 'invoiceNumber'
            | 'dueDate'
            | 'billDate'
            | 'externalId'
            | 'providerType'
          >
          & { party?: Maybe<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >> }
        )>,
        linkedInvoice?: Maybe<(
          Pick<
            LinkedInvoice,
            | 'id'
            | 'dataSourceId'
            | 'invoiceNumber'
            | 'referenceNumber'
            | 'dueDate'
            | 'invoiceDate'
            | 'externalId'
            | 'providerType'
            | 'status'
          >
          & { party?: Maybe<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >> }
        )>,
      }
    ) } };

export type ReadLedgerTransactionByIdQueryVariables = Exact<{
  ledgerTransactionId: Scalars['String']['input'];
  viewKey: ViewKey;
}>;


export type ReadLedgerTransactionByIdQuery = { readLedgerTransactionById: { transaction: (
      Pick<
        LedgerTransaction,
        | 'timestamp'
        | 'externalId'
        | 'type'
        | 'memo'
        | 'referenceNumber'
        | 'isMetadataEditable'
        | 'ledgerTransactionId'
        | 'compileSource'
        | 'matchedLedgerTransactionIds'
        | 'providerTypes'
        | 'isSupersedingLedgerTransaction'
        | 'supersededLedgerTransactionIds'
      >
      & {
        lines: Array<(
          Pick<TransactionLine, 'entryType'>
          & {
            entry: (
              Pick<TransactionEntry, 'factId' | 'externalLineId' | 'description'>
              & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            category: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            categoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            party?: Maybe<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
            department?: Maybe<(
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            location?: Maybe<(
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            schedule?: Maybe<(
              { __typename: 'EntitySchedule' }
              & Pick<
                EntitySchedule,
                | 'id'
                | 'name'
                | 'scheduleNumber'
                | 'scheduleType'
                | 'scheduleTemplateId'
                | 'categoryId'
                | 'relatedCategoryId'
                | 'partyId'
                | 'startDate'
                | 'endDate'
                | 'cutoverDate'
              >
              & {
                amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              }
            )>,
          }
        )>,
        sources: Array<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )>,
        linkedBill?: Maybe<(
          Pick<
            LinkedBill,
            | 'id'
            | 'dataSourceId'
            | 'invoiceNumber'
            | 'dueDate'
            | 'billDate'
            | 'externalId'
            | 'providerType'
          >
          & { party?: Maybe<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >> }
        )>,
        linkedInvoice?: Maybe<(
          Pick<
            LinkedInvoice,
            | 'id'
            | 'dataSourceId'
            | 'invoiceNumber'
            | 'referenceNumber'
            | 'dueDate'
            | 'invoiceDate'
            | 'externalId'
            | 'providerType'
            | 'status'
          >
          & { party?: Maybe<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >> }
        )>,
      }
    ) } };

export type ReadLedgerTransactionIdQueryVariables = Exact<{
  transactionFactId: Scalars['String']['input'];
  filter: TransactionFilter;
}>;


export type ReadLedgerTransactionIdQuery = { readLedgerTransaction: { transaction: Pick<LedgerTransaction, 'ledgerTransactionId'> } };

export type ReadMetricEquationQueryVariables = Exact<{
  viewKey: ViewKey;
  summaryLineType?: InputMaybe<SummaryLineItem>;
  metricSummaryType?: InputMaybe<MetricSummaryItem>;
  layoutComponentConfig?: InputMaybe<LayoutComponentConfigInput>;
  origin?: InputMaybe<IntervalOrigin>;
}>;


export type ReadMetricEquationQuery = { readMetricEquation: { terms: Array<
      | (
        { __typename: 'MetricCategoriesOperand' }
        & Pick<
          MetricCategoriesOperand,
          | 'name'
          | 'isBalance'
          | 'naturalFlow'
          | 'defaultCategoryType'
        >
        & {
          categories: Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
          period?: Maybe<Pick<
              Period,
              | 'name'
              | 'interval'
              | 'startedAt'
              | 'endedAt'
            >>,
        }
      )
      | (
        { __typename: 'MetricOperation' }
        & Pick<MetricOperation, 'symbol'>
      )
      | (
        { __typename: 'MetricSummaryTypeOperand' }
        & Pick<
          MetricSummaryTypeOperand,
          | 'name'
          | 'type'
          | 'naturalFlow'
          | 'defaultCategoryType'
          | 'isBalance'
        >
        & { period?: Maybe<Pick<
            Period,
            | 'name'
            | 'interval'
            | 'startedAt'
            | 'endedAt'
          >> }
      )
    > } };

export type ReadTransactionDetailsQueryVariables = Exact<{
  transactionFactId: Scalars['String']['input'];
  filter: TransactionFilter;
}>;


export type ReadTransactionDetailsQuery = { readTransactionDetails: (
    Pick<TransactionWithDetails, 'isInBooksClosedPeriod'>
    & {
      transaction: (
        Pick<
          Transaction,
          | 'viewId'
          | 'factId'
          | 'ledgerTransactionId'
          | 'supersededFactIds'
          | 'timestamp'
          | 'recordType'
          | 'name'
          | 'description'
          | 'digitsTransactionType'
          | 'partySource'
          | 'displayEntry'
          | 'displayCategorySource'
          | 'displayCanonicalCategoryName'
          | 'displayUncategorizedReason'
          | 'displayProductArea'
          | 'ownerSource'
          | 'transactionClassificationType'
          | 'compileSource'
          | 'reconciliationStatus'
          | 'referenceNumber'
          | 'taxStatus'
          | 'matchedLedgerTransactionIds'
          | 'providerTypes'
          | 'isSupersedingLedgerTransaction'
          | 'supersededLedgerTransactionIds'
        >
        & {
          party?: Maybe<Pick<
              TransactionParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'iconObjectName'
              | 'designation'
              | 'roles'
            >>,
          facilitatorParty?: Maybe<Pick<
              TransactionParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'iconObjectName'
              | 'designation'
              | 'roles'
            >>,
          product?: Maybe<Pick<
              Product,
              | 'id'
              | 'dataSourceId'
              | 'name'
              | 'providerType'
              | 'active'
              | 'institutionId'
              | 'institutionName'
            >>,
          department?: Maybe<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          splitDepartment?: Maybe<(
            { __typename: 'EntityDepartment' }
            & Pick<
              EntityDepartment,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          location?: Maybe<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          splitLocation?: Maybe<(
            { __typename: 'EntityLocation' }
            & Pick<
              EntityLocation,
              | 'id'
              | 'name'
              | 'parentId'
              | 'active'
            >
          )>,
          providers: Array<Pick<Provider, 'name'>>,
          recurrence?: Maybe<Pick<
              TransactionRecurrence,
              | 'recurrenceThreadId'
              | 'interval'
              | 'intervalMultiplier'
              | 'threadIndex'
              | 'totalThreadCount'
              | 'isHidden'
              | 'firstOccurredAt'
              | 'lastOccurredAt'
            >>,
          displayInstitution?: Maybe<Pick<
              TransactionParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'iconObjectName'
              | 'designation'
              | 'roles'
            >>,
          displayCategory: (
            Pick<
              Category,
              | 'id'
              | 'name'
              | 'description'
              | 'displayKey'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'displayNumber'
              | 'active'
              | 'categoryState'
              | 'productArea'
              | 'synthesized'
            >
            & { ancestors?: Maybe<Array<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>> }
          ),
          displayCategoryClassificationProvenance?: Maybe<(
            Pick<
              ClassificationProvenance,
              | 'type'
              | 'changedAt'
              | 'confidenceLevel'
              | 'settingsName'
            >
            & { source?: Maybe<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )> }
          )>,
          splitCategory?: Maybe<(
            Pick<
              Category,
              | 'id'
              | 'name'
              | 'description'
              | 'displayKey'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'displayNumber'
              | 'active'
              | 'categoryState'
              | 'productArea'
              | 'synthesized'
            >
            & { ancestors?: Maybe<Array<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>> }
          )>,
          splitCategoryClassificationProvenance?: Maybe<(
            Pick<
              ClassificationProvenance,
              | 'type'
              | 'changedAt'
              | 'confidenceLevel'
              | 'settingsName'
            >
            & { source?: Maybe<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )> }
          )>,
          splitInstitution?: Maybe<Pick<
              TransactionParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'iconObjectName'
              | 'designation'
              | 'roles'
            >>,
          creditCategoryClassificationProvenance?: Maybe<(
            Pick<
              ClassificationProvenance,
              | 'type'
              | 'changedAt'
              | 'confidenceLevel'
              | 'settingsName'
            >
            & { source?: Maybe<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )> }
          )>,
          debitCategoryClassificationProvenance?: Maybe<(
            Pick<
              ClassificationProvenance,
              | 'type'
              | 'changedAt'
              | 'confidenceLevel'
              | 'settingsName'
            >
            & { source?: Maybe<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )> }
          )>,
          moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          runningTotal?: Maybe<(
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          )>,
          owner?: Maybe<Pick<
              EntityEmployee,
              | 'id'
              | 'organizationId'
              | 'givenName'
              | 'familyName'
              | 'avatarUrl'
            >>,
          sources: Array<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )>,
          creditSources: Array<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )>,
          debitSources: Array<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )>,
          invoiceLineItem?: Maybe<{ value:
              | (
                Pick<
                  TransactionDiscountLineItem,
                  | 'name'
                  | 'description'
                  | 'variablePercentage'
                  | 'appliesToTransactionFactId'
                >
                & {
                  fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  discount?: Maybe<(
                    Pick<
                      TransactionInvoiceLineItemDiscount,
                      | 'discountId'
                      | 'name'
                      | 'description'
                      | 'variablePercentage'
                    >
                    & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                  )>,
                }
              )
              | (
                Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                & {
                  unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                  product?: Maybe<(
                    Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                    & {
                      unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                      category?: Maybe<(
                        Pick<
                          Category,
                          | 'id'
                          | 'name'
                          | 'description'
                          | 'displayKey'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'displayNumber'
                          | 'active'
                          | 'categoryState'
                          | 'productArea'
                          | 'synthesized'
                        >
                        & { ancestors?: Maybe<Array<Pick<
                            EntityCategory,
                            | 'id'
                            | 'name'
                            | 'displayKey'
                            | 'chartOfAccountsDisplayNumber'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'productArea'
                            | 'active'
                          >>> }
                      )>,
                      department?: Maybe<(
                        { __typename: 'EntityDepartment' }
                        & Pick<
                          EntityDepartment,
                          | 'id'
                          | 'name'
                          | 'parentId'
                          | 'active'
                        >
                      )>,
                      location?: Maybe<(
                        { __typename: 'EntityLocation' }
                        & Pick<
                          EntityLocation,
                          | 'id'
                          | 'name'
                          | 'parentId'
                          | 'active'
                        >
                      )>,
                    }
                  )>,
                }
              )
             }>,
          schedule?: Maybe<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>,
          splitSchedule?: Maybe<(
            { __typename: 'EntitySchedule' }
            & Pick<
              EntitySchedule,
              | 'id'
              | 'name'
              | 'scheduleNumber'
              | 'scheduleType'
              | 'scheduleTemplateId'
              | 'categoryId'
              | 'relatedCategoryId'
              | 'partyId'
              | 'startDate'
              | 'endDate'
              | 'cutoverDate'
            >
            & {
              amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            }
          )>,
        }
      ),
      details: Array<(
        Pick<
          TransactionViewDetail,
          | 'id'
          | 'factId'
          | 'occurredAt'
          | 'externalCreatedAt'
          | 'externalId'
          | 'externalDisplayId'
          | 'quickbooksAppName'
          | 'name'
          | 'description'
          | 'recordType'
        >
        & {
          creditAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          debitAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          creditCategoryHierarchy: Array<(
            Pick<
              Category,
              | 'id'
              | 'name'
              | 'description'
              | 'displayKey'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'displayNumber'
              | 'active'
              | 'categoryState'
              | 'productArea'
              | 'synthesized'
            >
            & { ancestors?: Maybe<Array<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>> }
          )>,
          debitCategoryHierarchy: Array<(
            Pick<
              Category,
              | 'id'
              | 'name'
              | 'description'
              | 'displayKey'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'displayNumber'
              | 'active'
              | 'categoryState'
              | 'productArea'
              | 'synthesized'
            >
            & { ancestors?: Maybe<Array<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>> }
          )>,
          entryLines: Array<(
            Pick<
              TransactionEntryLine,
              | 'lineId'
              | 'factId'
              | 'name'
              | 'description'
              | 'isCredit'
              | 'highlighted'
            >
            & {
              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              category: (
                Pick<
                  Category,
                  | 'id'
                  | 'name'
                  | 'description'
                  | 'displayKey'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'displayNumber'
                  | 'active'
                  | 'categoryState'
                  | 'productArea'
                  | 'synthesized'
                >
                & { ancestors?: Maybe<Array<Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  >>> }
              ),
              categoryClassificationProvenance?: Maybe<(
                Pick<
                  ClassificationProvenance,
                  | 'type'
                  | 'changedAt'
                  | 'confidenceLevel'
                  | 'settingsName'
                >
                & { source?: Maybe<(
                  Pick<
                    TransactionSource,
                    | 'timestamp'
                    | 'name'
                    | 'iconUrl'
                    | 'externalDisplayId'
                    | 'type'
                  >
                  & { account?: Maybe<Pick<
                      TransactionSourceAccount,
                      | 'sourceAccountId'
                      | 'externalName'
                      | 'mask'
                      | 'externalOwnerName'
                      | 'externalOfficialName'
                    >> }
                )> }
              )>,
            }
          )>,
          party?: Maybe<Pick<
              TransactionParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'iconObjectName'
              | 'designation'
              | 'roles'
            >>,
          institution: Pick<
              Institution,
              | 'id'
              | 'name'
              | 'url'
              | 'routingNumber'
              | 'iconUrl'
              | 'partyId'
              | 'createdAt'
            >,
          sourceAccount?: Maybe<Pick<
              SourceAccount,
              | 'id'
              | 'externalId'
              | 'externalName'
              | 'externalOwnerName'
              | 'externalOfficialName'
              | 'externalType'
              | 'externalSubtype'
              | 'mask'
              | 'status'
              | 'ownerEmployeeId'
            >>,
        }
      )>,
    }
  ) };

export type ReadTransactionFactIdQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  dataSourceId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  externalLineItemId: Scalars['String']['input'];
}>;


export type ReadTransactionFactIdQuery = Pick<Query, 'readFactId'>;

export type ReadTransactionWorkItemIdQueryVariables = Exact<{
  transactionFactId: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadTransactionWorkItemIdQuery = Pick<Query, 'readTransactionWorkItemId'>;

export type SummarizeCategoryTransactionsByTimeQueryVariables = Exact<{
  filter: SummaryFilterInput;
  origin: IntervalOrigin;
  direction: DirectionFromOrigin;
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  directBookings?: InputMaybe<Scalars['Boolean']['input']>;
  naturalFlow?: InputMaybe<Flow>;
  defaultCategoryType?: InputMaybe<CategoryType>;
}>;


export type SummarizeCategoryTransactionsByTimeQuery = { dimensionalTransactionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & { time: Array<{ summary: (
        Pick<TransactionSummary, 'isPeriodBookClosed'>
        & {
          period: Pick<
              Period,
              | 'name'
              | 'interval'
              | 'startedAt'
              | 'endedAt'
            >,
          total: (
            Pick<
              PeriodMonetaryValue,
              | 'transactionsCount'
              | 'deltaPrevious'
              | 'deltaYearAgo'
              | 'isFirstOccurrencePeriod'
            >
            & {
              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              moneyFlow?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              current?: Maybe<(
                Pick<SummaryTotal, 'count'>
                & { total: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
              prior?: Maybe<(
                Pick<SummaryTotal, 'count'>
                & { total: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
            }
          ),
        }
      ) }> }
  ) };

export type SummarizeMetricTransactionsByTimeQueryVariables = Exact<{
  viewKey: ViewKey;
  origin: IntervalOrigin;
  metricSummaryType?: InputMaybe<MetricSummaryItem>;
  summaryLineType?: InputMaybe<SummaryLineItem>;
}>;


export type SummarizeMetricTransactionsByTimeQuery = { metricTransactionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & { time: Array<{ summary: (
        Pick<TransactionSummary, 'isPeriodBookClosed'>
        & {
          period: Pick<
              Period,
              | 'name'
              | 'interval'
              | 'startedAt'
              | 'endedAt'
            >,
          total: (
            Pick<
              PeriodMonetaryValue,
              | 'transactionsCount'
              | 'deltaPrevious'
              | 'deltaYearAgo'
              | 'isFirstOccurrencePeriod'
            >
            & {
              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              moneyFlow?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              current?: Maybe<(
                Pick<SummaryTotal, 'count'>
                & { total: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
              prior?: Maybe<(
                Pick<SummaryTotal, 'count'>
                & { total: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
            }
          ),
        }
      ) }> }
  ) };

export type SummarizeTransactionsByCategoryQueryVariables = Exact<{
  filter: SummaryFilterInput;
  direction: DirectionFromOrigin;
  origin: IntervalOrigin;
  sort?: InputMaybe<DimensionSortMode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  directBookings?: InputMaybe<Scalars['Boolean']['input']>;
  naturalFlow?: InputMaybe<Flow>;
  defaultCategoryType?: InputMaybe<CategoryType>;
  pagination?: InputMaybe<DimensionPaginationInput>;
}>;


export type SummarizeTransactionsByCategoryQuery = { dimensionalTransactionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & { category: Array<{
        categoryObject: Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >,
        summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ),
      }> }
  ) };

export type SummarizeTransactionsByCategoryByTimeQueryVariables = Exact<{
  filter: SummaryFilterInput;
  direction: DirectionFromOrigin;
  origin: IntervalOrigin;
  sort?: InputMaybe<DimensionSortMode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  masks?: InputMaybe<Array<Array<SummaryDimension> | SummaryDimension> | Array<SummaryDimension> | SummaryDimension>;
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  directBookings?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SummarizeTransactionsByCategoryByTimeQuery = { dimensionalTransactionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & { category: Array<{
        categoryObject: Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >,
        by: { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> },
      }> }
  ) };

export type SummarizeTransactionsByCategoryHierarchyByTimeQueryVariables = Exact<{
  filter: SummaryFilterInput;
  direction: DirectionFromOrigin;
  origin: IntervalOrigin;
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  directBookings?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SummarizeTransactionsByCategoryHierarchyByTimeQuery = { dimensionalTransactionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & { category: Array<{
        categoryObject: Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >,
        by: { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> },
      }> }
  ) };

export type SummarizeTransactionsByDepartmentQueryVariables = Exact<{
  filter: SummaryFilterInput;
  direction: DirectionFromOrigin;
  origin: IntervalOrigin;
  sort?: InputMaybe<DimensionSortMode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  directBookings?: InputMaybe<Scalars['Boolean']['input']>;
  naturalFlow?: InputMaybe<Flow>;
  defaultCategoryType?: InputMaybe<CategoryType>;
  pagination?: InputMaybe<DimensionPaginationInput>;
}>;


export type SummarizeTransactionsByDepartmentQuery = { dimensionalTransactionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & { department: Array<{
        departmentObject: (
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        ),
        summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ),
      }> }
  ) };

export type SummarizeTransactionsByDepartmentByTimeQueryVariables = Exact<{
  filter: SummaryFilterInput;
  direction: DirectionFromOrigin;
  origin: IntervalOrigin;
  directBookings?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SummarizeTransactionsByDepartmentByTimeQuery = { dimensionalTransactionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & { department: Array<(
      Pick<DepartmentDimension, 'departmentId'>
      & {
        departmentObject: (
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        ),
        by: { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> },
      }
    )> }
  ) };

export type SummarizeTransactionsByLocationQueryVariables = Exact<{
  filter: SummaryFilterInput;
  direction: DirectionFromOrigin;
  origin: IntervalOrigin;
  sort?: InputMaybe<DimensionSortMode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  directBookings?: InputMaybe<Scalars['Boolean']['input']>;
  naturalFlow?: InputMaybe<Flow>;
  defaultCategoryType?: InputMaybe<CategoryType>;
  pagination?: InputMaybe<DimensionPaginationInput>;
}>;


export type SummarizeTransactionsByLocationQuery = { dimensionalTransactionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & { location: Array<{
        locationObject: (
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        ),
        summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ),
      }> }
  ) };

export type SummarizeTransactionsByLocationByTimeQueryVariables = Exact<{
  filter: SummaryFilterInput;
  direction: DirectionFromOrigin;
  origin: IntervalOrigin;
  directBookings?: InputMaybe<Scalars['Boolean']['input']>;
  naturalFlow: Flow;
  defaultCategoryType?: InputMaybe<CategoryType>;
}>;


export type SummarizeTransactionsByLocationByTimeQuery = { dimensionalTransactionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & { location: Array<(
      Pick<LocationDimension, 'locationId'>
      & {
        locationObject: (
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        ),
        by: { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> },
      }
    )> }
  ) };

export type SummarizeTransactionsByPartyQueryVariables = Exact<{
  filter: SummaryFilterInput;
  direction: DirectionFromOrigin;
  origin: IntervalOrigin;
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchBy?: InputMaybe<Matcher>;
  masks?: InputMaybe<Array<Array<SummaryDimension> | SummaryDimension> | Array<SummaryDimension> | SummaryDimension>;
  directBookings?: InputMaybe<Scalars['Boolean']['input']>;
  naturalFlow?: InputMaybe<Flow>;
  defaultCategoryType?: InputMaybe<CategoryType>;
  pagination?: InputMaybe<DimensionPaginationInput>;
}>;


export type SummarizeTransactionsByPartyQuery = { dimensionalTransactionSummary: (
    Pick<DimensionSummary, 'partialData' | 'aggregateFacetCount'>
    & { party: Array<{
        partyObject: Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >,
        summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ),
      }> }
  ) };

export type SummarizeTransactionsByPartyByCategoryQueryVariables = Exact<{
  filter: SummaryFilterInput;
  direction: DirectionFromOrigin;
  origin: IntervalOrigin;
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  matchBy?: InputMaybe<Matcher>;
  masks?: InputMaybe<Array<Array<SummaryDimension> | SummaryDimension> | Array<SummaryDimension> | SummaryDimension>;
  directBookings?: InputMaybe<Scalars['Boolean']['input']>;
  defaultCategoryType?: InputMaybe<CategoryType>;
}>;


export type SummarizeTransactionsByPartyByCategoryQuery = { dimensionalTransactionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & { party: Array<{
        partyObject: Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >,
        summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ),
        by: { category: Array<{ categoryObject: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              > }> },
      }> }
  ) };

export type SummarizeTransactionsByPartyByTimeQueryVariables = Exact<{
  filter: SummaryFilterInput;
  paginationDirection: DirectionFromOrigin;
  intervalOrigin: IntervalOrigin;
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<DimensionSortMode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  masks?: InputMaybe<Array<Array<SummaryDimension> | SummaryDimension> | Array<SummaryDimension> | SummaryDimension>;
  matchBy?: InputMaybe<Matcher>;
  directBookings?: InputMaybe<Scalars['Boolean']['input']>;
  naturalFlow?: InputMaybe<Flow>;
  defaultCategoryType?: InputMaybe<CategoryType>;
}>;


export type SummarizeTransactionsByPartyByTimeQuery = { dimensionalTransactionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & { party: Array<{
        partyObject: Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >,
        by: { time: Array<{ summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ) }> },
      }> }
  ) };

export type SummarizeTransactionsByScheduleAmountByCategoryQueryVariables = Exact<{
  viewKey: ViewKey;
  origin: IntervalOrigin;
  direction: DirectionFromOrigin;
  scheduleCategoryIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  scheduleRelatedCategoryIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  schedulePartyIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  scheduleMinAmount?: InputMaybe<InputMonetaryValue>;
  scheduleMaxAmount?: InputMaybe<InputMonetaryValue>;
  scheduleStartDateMin?: InputMaybe<Scalars['DateTime']['input']>;
  scheduleStartDateMax?: InputMaybe<Scalars['DateTime']['input']>;
  scheduleEndDateMin?: InputMaybe<Scalars['DateTime']['input']>;
  scheduleEndDateMax?: InputMaybe<Scalars['DateTime']['input']>;
  filterTerm?: InputMaybe<Scalars['String']['input']>;
  skipFixedAsset: Scalars['Boolean']['input'];
  skipPrepaidExpense: Scalars['Boolean']['input'];
}>;


export type SummarizeTransactionsByScheduleAmountByCategoryQuery = {
    fixedAssetAmounts?: (
      Pick<DimensionSummary, 'partialData'>
      & { category: Array<{
          categoryObject: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          summary: (
            Pick<TransactionSummary, 'isPeriodBookClosed'>
            & {
              period: Pick<
                  Period,
                  | 'name'
                  | 'interval'
                  | 'startedAt'
                  | 'endedAt'
                >,
              total: (
                Pick<
                  PeriodMonetaryValue,
                  | 'transactionsCount'
                  | 'deltaPrevious'
                  | 'deltaYearAgo'
                  | 'isFirstOccurrencePeriod'
                >
                & {
                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  moneyFlow?: Maybe<(
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  )>,
                  current?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                  prior?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                }
              ),
            }
          ),
          by: { schedule: Array<(
              Pick<ScheduleDimension, 'scheduleId'>
              & { summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }
            )> },
        }> }
    ),
    prepaidExpenseAmounts?: (
      Pick<DimensionSummary, 'partialData'>
      & { category: Array<{
          categoryObject: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          summary: (
            Pick<TransactionSummary, 'isPeriodBookClosed'>
            & {
              period: Pick<
                  Period,
                  | 'name'
                  | 'interval'
                  | 'startedAt'
                  | 'endedAt'
                >,
              total: (
                Pick<
                  PeriodMonetaryValue,
                  | 'transactionsCount'
                  | 'deltaPrevious'
                  | 'deltaYearAgo'
                  | 'isFirstOccurrencePeriod'
                >
                & {
                  value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  moneyFlow?: Maybe<(
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  )>,
                  current?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                  prior?: Maybe<(
                    Pick<SummaryTotal, 'count'>
                    & { total: (
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    ) }
                  )>,
                }
              ),
            }
          ),
          by: { schedule: Array<(
              Pick<ScheduleDimension, 'scheduleId'>
              & { summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }
            )> },
        }> }
    ),
  };

export type SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQueryVariables = Exact<{
  filter: SummaryFilterInput;
  origin: IntervalOrigin;
  direction: DirectionFromOrigin;
}>;


export type SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQuery = { dimensionalTransactionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & { time: Array<{
        summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ),
        by: { schedule: Array<Pick<ScheduleDimension, 'scheduleId'>> },
      }> }
  ) };

export type SummarizeTransactionsByScheduleRecognitionByTimeQueryVariables = Exact<{
  filter: SummaryFilterInput;
  origin: IntervalOrigin;
  direction: DirectionFromOrigin;
}>;


export type SummarizeTransactionsByScheduleRecognitionByTimeQuery = { dimensionalTransactionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & { time: Array<{
        summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ),
        by: { schedule: Array<Pick<ScheduleDimension, 'scheduleId'>> },
      }> }
  ) };

export type SummarizeTransactionsByTimeQueryVariables = Exact<{
  filter: SummaryFilterInput;
  origin: IntervalOrigin;
  direction: DirectionFromOrigin;
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  directBookings?: InputMaybe<Scalars['Boolean']['input']>;
  naturalFlow?: InputMaybe<Flow>;
  defaultCategoryType?: InputMaybe<CategoryType>;
  pagination?: InputMaybe<DimensionPaginationInput>;
}>;


export type SummarizeTransactionsByTimeQuery = { dimensionalTransactionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & { time: Array<{ summary: (
        Pick<TransactionSummary, 'isPeriodBookClosed'>
        & {
          period: Pick<
              Period,
              | 'name'
              | 'interval'
              | 'startedAt'
              | 'endedAt'
            >,
          total: (
            Pick<
              PeriodMonetaryValue,
              | 'transactionsCount'
              | 'deltaPrevious'
              | 'deltaYearAgo'
              | 'isFirstOccurrencePeriod'
            >
            & {
              value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              moneyFlow?: Maybe<(
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )>,
              current?: Maybe<(
                Pick<SummaryTotal, 'count'>
                & { total: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
              prior?: Maybe<(
                Pick<SummaryTotal, 'count'>
                & { total: (
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                ) }
              )>,
            }
          ),
        }
      ) }> }
  ) };

export type SummarizeTransactionsByTimeByCategoryQueryVariables = Exact<{
  filter: SummaryFilterInput;
  direction: DirectionFromOrigin;
  origin: IntervalOrigin;
  sort: DimensionSortMode;
  limit: Scalars['Int']['input'];
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  directBookings?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SummarizeTransactionsByTimeByCategoryQuery = { dimensionalTransactionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & { time: Array<{ by: { category: Array<{
            categoryObject: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ),
          }> } }> }
  ) };

export type SummarizeTransactionsByTimeByPartyQueryVariables = Exact<{
  filter: SummaryFilterInput;
  direction: DirectionFromOrigin;
  origin: IntervalOrigin;
  sort?: InputMaybe<DimensionSortMode>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  masks?: InputMaybe<Array<Array<SummaryDimension> | SummaryDimension> | Array<SummaryDimension> | SummaryDimension>;
  matchBy?: InputMaybe<Matcher>;
  directBookings?: InputMaybe<Scalars['Boolean']['input']>;
  defaultCategoryType?: InputMaybe<CategoryType>;
}>;


export type SummarizeTransactionsByTimeByPartyQuery = { dimensionalTransactionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & { time: Array<{
        summary: (
          Pick<TransactionSummary, 'isPeriodBookClosed'>
          & {
            period: Pick<
                Period,
                | 'name'
                | 'interval'
                | 'startedAt'
                | 'endedAt'
              >,
            total: (
              Pick<
                PeriodMonetaryValue,
                | 'transactionsCount'
                | 'deltaPrevious'
                | 'deltaYearAgo'
                | 'isFirstOccurrencePeriod'
              >
              & {
                value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                moneyFlow?: Maybe<(
                  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                )>,
                current?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
                prior?: Maybe<(
                  Pick<SummaryTotal, 'count'>
                  & { total: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ) }
                )>,
              }
            ),
          }
        ),
        by: { party: Array<{
              partyObject: Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >,
              summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ),
            }> },
      }> }
  ) };

export type SummarizeTransactionsByTimeByPartyByCategoryQueryVariables = Exact<{
  filter: SummaryFilterInput;
  direction: DirectionFromOrigin;
  origin: IntervalOrigin;
  sort: DimensionSortMode;
  limit: Scalars['Int']['input'];
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  masks?: InputMaybe<Array<Array<SummaryDimension> | SummaryDimension> | Array<SummaryDimension> | SummaryDimension>;
  matchBy?: InputMaybe<Matcher>;
  directBookings?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SummarizeTransactionsByTimeByPartyByCategoryQuery = { dimensionalTransactionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & { time: Array<{ by: { parties: Array<{
            party: Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >,
            summary: (
              Pick<TransactionSummary, 'isPeriodBookClosed'>
              & {
                period: Pick<
                    Period,
                    | 'name'
                    | 'interval'
                    | 'startedAt'
                    | 'endedAt'
                  >,
                total: (
                  Pick<
                    PeriodMonetaryValue,
                    | 'transactionsCount'
                    | 'deltaPrevious'
                    | 'deltaYearAgo'
                    | 'isFirstOccurrencePeriod'
                  >
                  & {
                    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    moneyFlow?: Maybe<(
                      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                    )>,
                    current?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                    prior?: Maybe<(
                      Pick<SummaryTotal, 'count'>
                      & { total: (
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      ) }
                    )>,
                  }
                ),
              }
            ),
            by: { categories: Array<{ category: Pick<
                    EntityCategory,
                    | 'id'
                    | 'name'
                    | 'displayKey'
                    | 'chartOfAccountsDisplayNumber'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'productArea'
                    | 'active'
                  > }> },
          }> } }> }
  ) };

export type SummarizeTransactionsWithoutDimensionQueryVariables = Exact<{
  filter: SummaryFilterInput;
  origin: IntervalOrigin;
  direction: DirectionFromOrigin;
  asPermanent?: InputMaybe<Scalars['Boolean']['input']>;
  directBookings?: InputMaybe<Scalars['Boolean']['input']>;
  naturalFlow?: InputMaybe<Flow>;
  defaultCategoryType?: InputMaybe<CategoryType>;
  pagination?: InputMaybe<DimensionPaginationInput>;
}>;


export type SummarizeTransactionsWithoutDimensionQuery = { dimensionalTransactionSummary: (
    Pick<DimensionSummary, 'partialData'>
    & { summary: (
      Pick<TransactionSummary, 'isPeriodBookClosed'>
      & {
        period: Pick<
            Period,
            | 'name'
            | 'interval'
            | 'startedAt'
            | 'endedAt'
          >,
        total: (
          Pick<
            PeriodMonetaryValue,
            | 'transactionsCount'
            | 'deltaPrevious'
            | 'deltaYearAgo'
            | 'isFirstOccurrencePeriod'
          >
          & {
            value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            moneyFlow?: Maybe<(
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            )>,
            current?: Maybe<(
              Pick<SummaryTotal, 'count'>
              & { total: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ) }
            )>,
            prior?: Maybe<(
              Pick<SummaryTotal, 'count'>
              & { total: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ) }
            )>,
          }
        ),
      }
    ) }
  ) };

export type TransactionDashboardDimensionalSummaryQueryVariables = Exact<{
  viewKey: ViewKey;
  direction: DirectionFromOrigin;
  origin: IntervalOrigin;
}>;


export type TransactionDashboardDimensionalSummaryQuery = {
    assetsSummary: { category: Array<{
          categoryObject: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          by: { time: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }> },
        }> },
    liabilitiesSummary: { category: Array<{
          categoryObject: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          by: { time: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }> },
        }> },
    equitySummary: { category: Array<{
          categoryObject: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          by: { time: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }> },
        }> },
    incomeSummary: { category: Array<{
          categoryObject: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          by: { time: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }> },
        }> },
    costOfGoodsSoldSummary: { category: Array<{
          categoryObject: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          by: { time: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }> },
        }> },
    expensesSummary: { category: Array<{
          categoryObject: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          by: { time: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }> },
        }> },
    otherExpensesSummary: { category: Array<{
          categoryObject: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          by: { time: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }> },
        }> },
    otherIncomeSummary: { category: Array<{
          categoryObject: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          by: { time: Array<{ summary: (
                Pick<TransactionSummary, 'isPeriodBookClosed'>
                & {
                  period: Pick<
                      Period,
                      | 'name'
                      | 'interval'
                      | 'startedAt'
                      | 'endedAt'
                    >,
                  total: (
                    Pick<
                      PeriodMonetaryValue,
                      | 'transactionsCount'
                      | 'deltaPrevious'
                      | 'deltaYearAgo'
                      | 'isFirstOccurrencePeriod'
                    >
                    & {
                      value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                      moneyFlow?: Maybe<(
                        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                      )>,
                      current?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                      prior?: Maybe<(
                        Pick<SummaryTotal, 'count'>
                        & { total: (
                          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                        ) }
                      )>,
                    }
                  ),
                }
              ) }> },
        }> },
  };

export type AcceptTermsMutationVariables = Exact<{
  version: Scalars['String']['input'];
}>;


export type AcceptTermsMutation = Pick<Mutation, 'acceptTerms'>;

export type ConfirmTotpEnrollmentMutationVariables = Exact<{
  factorId: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type ConfirmTotpEnrollmentMutation = { confirmTotpEnrollment: Pick<TotpEnrollmentConfirmation, 'recoveryCodes'> };

export type CreatePasswordResetMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
}>;


export type CreatePasswordResetMutation = Pick<Mutation, 'createPasswordReset'>;

export type DisableTotpMutationVariables = Exact<{
  factorId: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
  method: MfaMethod;
}>;


export type DisableTotpMutation = Pick<Mutation, 'disableTotp'>;

export type SetDefaultApproverMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetDefaultApproverMutation = Pick<Mutation, 'setDefaultApprover'>;

export type SetRequireBillApproverDifferentFromCreatorMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
}>;


export type SetRequireBillApproverDifferentFromCreatorMutation = Pick<Mutation, 'setRequireBillApproverDifferentFromCreator'>;

export type StartTotpEnrollmentMutationVariables = Exact<{ [key: string]: never; }>;


export type StartTotpEnrollmentMutation = { startTotpEnrollment: Pick<TotpEnrollmentInit, 'factorId' | 'provisioningUri' | 'sharedSecretBase32'> };

export type UpdateUserMutationVariables = Exact<{
  givenName?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserMutation = Pick<Mutation, 'updateUser'>;

export type ListLegalEntityUsersQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ListLegalEntityUsersQuery = { listLegalEntityUsers: Array<(
    Pick<
      User,
      | 'id'
      | 'givenName'
      | 'familyName'
      | 'primaryEmailAddress'
      | 'passwordSet'
      | 'avatarUrl'
      | 'createdAt'
      | 'lastActivityAt'
    >
    & {
      employments?: Maybe<Array<(
        Pick<OrganizationEmployment, 'employeeId'>
        & {
          role: Pick<Role, 'id'>,
          organization: Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >,
          legalEntityRoles?: Maybe<Array<(
            Pick<EmployeeLegalEntityRole, 'legalEntityId'>
            & { role?: Maybe<Pick<Role, 'id'>> }
          )>>,
        }
      )>>,
      identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
    }
  )> };

export type ReadDefaultApproverQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadDefaultApproverQuery = Pick<Query, 'readDefaultApprover'>;

export type ReadRequireBillApproverDifferentFromCreatorQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadRequireBillApproverDifferentFromCreatorQuery = Pick<Query, 'readRequireBillApproverDifferentFromCreator'>;

export type ReadUserQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReadUserQuery = { readUser: (
    Pick<
      User,
      | 'mfaEnforcedAt'
      | 'id'
      | 'givenName'
      | 'familyName'
      | 'primaryEmailAddress'
      | 'passwordSet'
      | 'avatarUrl'
      | 'createdAt'
      | 'lastActivityAt'
    >
    & {
      employments?: Maybe<Array<(
        Pick<OrganizationEmployment, 'employeeId'>
        & {
          role: Pick<Role, 'id'>,
          organization: Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >,
          legalEntityRoles?: Maybe<Array<(
            Pick<EmployeeLegalEntityRole, 'legalEntityId'>
            & { role?: Maybe<Pick<Role, 'id'>> }
          )>>,
        }
      )>>,
      identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
    }
  ) };

export type VanityStatsFieldsFragment = (
  Pick<
    VanityStats,
    | 'totalParties'
    | 'totalPartiesIdentified'
    | 'totalCalculations'
    | 'totalTransactions'
    | 'totalTransactionsEnhanced'
  >
  & { totalTransactionsValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
);

export type ReadVanityStatsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadVanityStatsQuery = { readVanityStats: (
    Pick<
      VanityStats,
      | 'totalParties'
      | 'totalPartiesIdentified'
      | 'totalCalculations'
      | 'totalTransactions'
      | 'totalTransactionsEnhanced'
    >
    & { totalTransactionsValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
  ) };

export type VaultFeatureFieldsFragment = (
  { __typename: 'Feature' }
  & Pick<Feature, 'id' | 'kind'>
  & {
    groups?: Maybe<Array<Pick<FeatureGroup, 'featureGroupId' | 'kind' | 'position'>>>,
    value:
      | (
        { __typename: 'AddressFeatureValue' }
        & { addressValue: Pick<
            Address,
            | 'street'
            | 'streetAdditional'
            | 'city'
            | 'region'
            | 'postalCode'
            | 'countryCode'
            | 'lat'
            | 'long'
          > }
      )
      | (
        { __typename: 'DateFeatureValue' }
        & { dateValue: Pick<Date, 'year' | 'month' | 'day'> }
      )
      | (
        { __typename: 'LineItemFeatureValue' }
        & { lineItemValue: (
          Pick<
            DocumentLineItem,
            | 'description'
            | 'quantity'
            | 'position'
            | 'categoryId'
          >
          & {
            rate: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
          }
        ) }
      )
      | (
        { __typename: 'MonetaryFeatureValue' }
        & { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      )
      | (
        { __typename: 'NumericFeatureValue' }
        & Pick<NumericFeatureValue, 'numericValue'>
      )
      | (
        { __typename: 'RemittanceFeatureValue' }
        & { remittanceValue: Pick<
            RemittanceItem,
            | 'BankName'
            | 'BankAccountNumber'
            | 'BankAccountName'
            | 'BankRoutingNumber'
            | 'RemittanceType'
          > }
      )
      | (
        { __typename: 'TextFeatureValue' }
        & Pick<TextFeatureValue, 'textValue'>
      )
    ,
  }
);

export type VaultFeatureWithBoundingBoxFieldsFragment = (
  { __typename: 'Feature' }
  & Pick<
    Feature,
    | 'id'
    | 'kind'
    | 'originX'
    | 'originY'
    | 'width'
    | 'height'
    | 'featurePage'
  >
  & {
    groups?: Maybe<Array<Pick<FeatureGroup, 'featureGroupId' | 'kind' | 'position'>>>,
    value:
      | (
        { __typename: 'AddressFeatureValue' }
        & { addressValue: Pick<
            Address,
            | 'street'
            | 'streetAdditional'
            | 'city'
            | 'region'
            | 'postalCode'
            | 'countryCode'
            | 'lat'
            | 'long'
          > }
      )
      | (
        { __typename: 'DateFeatureValue' }
        & { dateValue: Pick<Date, 'year' | 'month' | 'day'> }
      )
      | (
        { __typename: 'LineItemFeatureValue' }
        & { lineItemValue: (
          Pick<
            DocumentLineItem,
            | 'description'
            | 'quantity'
            | 'position'
            | 'categoryId'
          >
          & {
            rate: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
          }
        ) }
      )
      | (
        { __typename: 'MonetaryFeatureValue' }
        & { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      )
      | (
        { __typename: 'NumericFeatureValue' }
        & Pick<NumericFeatureValue, 'numericValue'>
      )
      | (
        { __typename: 'RemittanceFeatureValue' }
        & { remittanceValue: Pick<
            RemittanceItem,
            | 'BankName'
            | 'BankAccountNumber'
            | 'BankAccountName'
            | 'BankRoutingNumber'
            | 'RemittanceType'
          > }
      )
      | (
        { __typename: 'TextFeatureValue' }
        & Pick<TextFeatureValue, 'textValue'>
      )
    ,
  }
);

export type TextFeatureValueFieldsFragment = (
  { __typename: 'TextFeatureValue' }
  & Pick<TextFeatureValue, 'textValue'>
);

export type NumericFeatureValueFieldsFragment = (
  { __typename: 'NumericFeatureValue' }
  & Pick<NumericFeatureValue, 'numericValue'>
);

export type DateFeatureValueFieldsFragment = (
  { __typename: 'DateFeatureValue' }
  & { dateValue: Pick<Date, 'year' | 'month' | 'day'> }
);

export type MonetaryFeatureValueFieldsFragment = (
  { __typename: 'MonetaryFeatureValue' }
  & { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
);

export type AddressFeatureValueFieldsFragment = (
  { __typename: 'AddressFeatureValue' }
  & { addressValue: Pick<
      Address,
      | 'street'
      | 'streetAdditional'
      | 'city'
      | 'region'
      | 'postalCode'
      | 'countryCode'
      | 'lat'
      | 'long'
    > }
);

export type LineItemFeatureValueFieldsFragment = (
  { __typename: 'LineItemFeatureValue' }
  & { lineItemValue: (
    Pick<
      DocumentLineItem,
      | 'description'
      | 'quantity'
      | 'position'
      | 'categoryId'
    >
    & {
      rate: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
      amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    }
  ) }
);

export type RemittanceFeatureValueFieldsFragment = (
  { __typename: 'RemittanceFeatureValue' }
  & { remittanceValue: Pick<
      RemittanceItem,
      | 'BankName'
      | 'BankAccountNumber'
      | 'BankAccountName'
      | 'BankRoutingNumber'
      | 'RemittanceType'
    > }
);

export type VaultFeatureGroupFieldsFragment = Pick<FeatureGroup, 'featureGroupId' | 'kind' | 'position'>;

export type VaultFileFieldsFragment = (
  { __typename: 'RawDocument' }
  & Pick<
    RawDocument,
    | 'id'
    | 'collectionId'
    | 'sourceFormatId'
    | 'createdAt'
    | 'updatedAt'
    | 'status'
    | 'asyncProcessingStatus'
    | 'title'
    | 'fileName'
    | 'fileSize'
    | 'mimeType'
  >
  & {
    formats: Array<(
      { __typename: 'Format' }
      & Pick<Format, 'id' | 'formatClass' | 'mimeType'>
      & { segments: Array<(
        { __typename: 'Segment' }
        & Pick<
          Segment,
          | 'fileId'
          | 'fileSize'
          | 'fileName'
          | 'sequence'
          | 'collectionId'
          | 'token'
        >
      )> }
    )>,
    features: Array<(
      { __typename: 'Feature' }
      & Pick<Feature, 'id' | 'kind'>
      & {
        groups?: Maybe<Array<Pick<FeatureGroup, 'featureGroupId' | 'kind' | 'position'>>>,
        value:
          | (
            { __typename: 'AddressFeatureValue' }
            & { addressValue: Pick<
                Address,
                | 'street'
                | 'streetAdditional'
                | 'city'
                | 'region'
                | 'postalCode'
                | 'countryCode'
                | 'lat'
                | 'long'
              > }
          )
          | (
            { __typename: 'DateFeatureValue' }
            & { dateValue: Pick<Date, 'year' | 'month' | 'day'> }
          )
          | (
            { __typename: 'LineItemFeatureValue' }
            & { lineItemValue: (
              Pick<
                DocumentLineItem,
                | 'description'
                | 'quantity'
                | 'position'
                | 'categoryId'
              >
              & {
                rate: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              }
            ) }
          )
          | (
            { __typename: 'MonetaryFeatureValue' }
            & { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          )
          | (
            { __typename: 'NumericFeatureValue' }
            & Pick<NumericFeatureValue, 'numericValue'>
          )
          | (
            { __typename: 'RemittanceFeatureValue' }
            & { remittanceValue: Pick<
                RemittanceItem,
                | 'BankName'
                | 'BankAccountNumber'
                | 'BankAccountName'
                | 'BankRoutingNumber'
                | 'RemittanceType'
              > }
          )
          | (
            { __typename: 'TextFeatureValue' }
            & Pick<TextFeatureValue, 'textValue'>
          )
        ,
      }
    )>,
    creator?: Maybe<Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
    dataSource?: Maybe<Pick<
        EntityDataSource,
        | 'id'
        | 'name'
        | 'url'
        | 'iconUrl'
      >>,
    thumbnail?: Maybe<(
      { __typename: 'Segment' }
      & Pick<
        Segment,
        | 'fileId'
        | 'fileSize'
        | 'fileName'
        | 'sequence'
        | 'collectionId'
        | 'token'
      >
    )>,
    sourceFormat?: Maybe<(
      { __typename: 'Format' }
      & Pick<Format, 'id' | 'formatClass' | 'mimeType'>
      & { segments: Array<(
        { __typename: 'Segment' }
        & Pick<
          Segment,
          | 'fileId'
          | 'fileSize'
          | 'fileName'
          | 'sequence'
          | 'collectionId'
          | 'token'
        >
      )> }
    )>,
  }
);

export type VaultFileWithBoundingBoxesFieldsFragment = (
  { __typename: 'RawDocument' }
  & Pick<
    RawDocument,
    | 'id'
    | 'collectionId'
    | 'sourceFormatId'
    | 'createdAt'
    | 'updatedAt'
    | 'status'
    | 'asyncProcessingStatus'
    | 'title'
    | 'fileName'
    | 'fileSize'
    | 'mimeType'
  >
  & {
    formats: Array<(
      { __typename: 'Format' }
      & Pick<Format, 'id' | 'formatClass' | 'mimeType'>
      & { segments: Array<(
        { __typename: 'Segment' }
        & Pick<
          Segment,
          | 'fileId'
          | 'fileSize'
          | 'fileName'
          | 'sequence'
          | 'collectionId'
          | 'token'
        >
      )> }
    )>,
    features: Array<(
      { __typename: 'Feature' }
      & Pick<
        Feature,
        | 'id'
        | 'kind'
        | 'originX'
        | 'originY'
        | 'width'
        | 'height'
        | 'featurePage'
      >
      & {
        groups?: Maybe<Array<Pick<FeatureGroup, 'featureGroupId' | 'kind' | 'position'>>>,
        value:
          | (
            { __typename: 'AddressFeatureValue' }
            & { addressValue: Pick<
                Address,
                | 'street'
                | 'streetAdditional'
                | 'city'
                | 'region'
                | 'postalCode'
                | 'countryCode'
                | 'lat'
                | 'long'
              > }
          )
          | (
            { __typename: 'DateFeatureValue' }
            & { dateValue: Pick<Date, 'year' | 'month' | 'day'> }
          )
          | (
            { __typename: 'LineItemFeatureValue' }
            & { lineItemValue: (
              Pick<
                DocumentLineItem,
                | 'description'
                | 'quantity'
                | 'position'
                | 'categoryId'
              >
              & {
                rate: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
              }
            ) }
          )
          | (
            { __typename: 'MonetaryFeatureValue' }
            & { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          )
          | (
            { __typename: 'NumericFeatureValue' }
            & Pick<NumericFeatureValue, 'numericValue'>
          )
          | (
            { __typename: 'RemittanceFeatureValue' }
            & { remittanceValue: Pick<
                RemittanceItem,
                | 'BankName'
                | 'BankAccountNumber'
                | 'BankAccountName'
                | 'BankRoutingNumber'
                | 'RemittanceType'
              > }
          )
          | (
            { __typename: 'TextFeatureValue' }
            & Pick<TextFeatureValue, 'textValue'>
          )
        ,
      }
    )>,
    creator?: Maybe<Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
    dataSource?: Maybe<Pick<
        EntityDataSource,
        | 'id'
        | 'name'
        | 'url'
        | 'iconUrl'
      >>,
    thumbnail?: Maybe<(
      { __typename: 'Segment' }
      & Pick<
        Segment,
        | 'fileId'
        | 'fileSize'
        | 'fileName'
        | 'sequence'
        | 'collectionId'
        | 'token'
      >
    )>,
    sourceFormat?: Maybe<(
      { __typename: 'Format' }
      & Pick<Format, 'id' | 'formatClass' | 'mimeType'>
      & { segments: Array<(
        { __typename: 'Segment' }
        & Pick<
          Segment,
          | 'fileId'
          | 'fileSize'
          | 'fileName'
          | 'sequence'
          | 'collectionId'
          | 'token'
        >
      )> }
    )>,
  }
);

export type VaultFormatFieldsFragment = (
  { __typename: 'Format' }
  & Pick<Format, 'id' | 'formatClass' | 'mimeType'>
  & { segments: Array<(
    { __typename: 'Segment' }
    & Pick<
      Segment,
      | 'fileId'
      | 'fileSize'
      | 'fileName'
      | 'sequence'
      | 'collectionId'
      | 'token'
    >
  )> }
);

export type VaultSegmentFieldsFragment = (
  { __typename: 'Segment' }
  & Pick<
    Segment,
    | 'fileId'
    | 'fileSize'
    | 'fileName'
    | 'sequence'
    | 'collectionId'
    | 'token'
  >
);

export type AddDocumentFeatureMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
  documentCollectionId: Scalars['String']['input'];
  feature: NewDocumentFeature;
  correctedFeatureId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddDocumentFeatureMutation = { addDocumentFeature: Pick<AddedFeature, 'featureId' | 'invalid'> };

export type DocumentDownloadUrlQueryVariables = Exact<{
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type DocumentDownloadUrlQuery = { documentDownloadUrl: Pick<DocumentDownload, 'url'> };

export type DocumentDownloadUrlsQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type DocumentDownloadUrlsQuery = { documentDownloadUrls: Pick<DocumentDownloadUrls, 'urls'> };

export type ListVaultFilesQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  pagination?: InputMaybe<Pagination>;
  filter: DocumentFilter;
  order?: InputMaybe<DocumentSort>;
}>;


export type ListVaultFilesQuery = {
    listDocuments: Array<(
      { __typename: 'RawDocument' }
      & Pick<
        RawDocument,
        | 'id'
        | 'collectionId'
        | 'sourceFormatId'
        | 'createdAt'
        | 'updatedAt'
        | 'status'
        | 'asyncProcessingStatus'
        | 'title'
        | 'fileName'
        | 'fileSize'
        | 'mimeType'
      >
      & {
        formats: Array<(
          { __typename: 'Format' }
          & Pick<Format, 'id' | 'formatClass' | 'mimeType'>
          & { segments: Array<(
            { __typename: 'Segment' }
            & Pick<
              Segment,
              | 'fileId'
              | 'fileSize'
              | 'fileName'
              | 'sequence'
              | 'collectionId'
              | 'token'
            >
          )> }
        )>,
        features: Array<(
          { __typename: 'Feature' }
          & Pick<Feature, 'id' | 'kind'>
          & {
            groups?: Maybe<Array<Pick<FeatureGroup, 'featureGroupId' | 'kind' | 'position'>>>,
            value:
              | (
                { __typename: 'AddressFeatureValue' }
                & { addressValue: Pick<
                    Address,
                    | 'street'
                    | 'streetAdditional'
                    | 'city'
                    | 'region'
                    | 'postalCode'
                    | 'countryCode'
                    | 'lat'
                    | 'long'
                  > }
              )
              | (
                { __typename: 'DateFeatureValue' }
                & { dateValue: Pick<Date, 'year' | 'month' | 'day'> }
              )
              | (
                { __typename: 'LineItemFeatureValue' }
                & { lineItemValue: (
                  Pick<
                    DocumentLineItem,
                    | 'description'
                    | 'quantity'
                    | 'position'
                    | 'categoryId'
                  >
                  & {
                    rate: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                    amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  }
                ) }
              )
              | (
                { __typename: 'MonetaryFeatureValue' }
                & { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              )
              | (
                { __typename: 'NumericFeatureValue' }
                & Pick<NumericFeatureValue, 'numericValue'>
              )
              | (
                { __typename: 'RemittanceFeatureValue' }
                & { remittanceValue: Pick<
                    RemittanceItem,
                    | 'BankName'
                    | 'BankAccountNumber'
                    | 'BankAccountName'
                    | 'BankRoutingNumber'
                    | 'RemittanceType'
                  > }
              )
              | (
                { __typename: 'TextFeatureValue' }
                & Pick<TextFeatureValue, 'textValue'>
              )
            ,
          }
        )>,
        creator?: Maybe<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>,
        dataSource?: Maybe<Pick<
            EntityDataSource,
            | 'id'
            | 'name'
            | 'url'
            | 'iconUrl'
          >>,
        thumbnail?: Maybe<(
          { __typename: 'Segment' }
          & Pick<
            Segment,
            | 'fileId'
            | 'fileSize'
            | 'fileName'
            | 'sequence'
            | 'collectionId'
            | 'token'
          >
        )>,
        sourceFormat?: Maybe<(
          { __typename: 'Format' }
          & Pick<Format, 'id' | 'formatClass' | 'mimeType'>
          & { segments: Array<(
            { __typename: 'Segment' }
            & Pick<
              Segment,
              | 'fileId'
              | 'fileSize'
              | 'fileName'
              | 'sequence'
              | 'collectionId'
              | 'token'
            >
          )> }
        )>,
      }
    )>,
    summarizeDocuments: Pick<DocumentsSummary, 'count'>,
  };

export type ReadVaultFileQueryVariables = Exact<{
  id: Scalars['String']['input'];
  legalEntityId: Scalars['String']['input'];
}>;


export type ReadVaultFileQuery = { readVaultFile: (
    { __typename: 'RawDocument' }
    & Pick<
      RawDocument,
      | 'id'
      | 'collectionId'
      | 'sourceFormatId'
      | 'createdAt'
      | 'updatedAt'
      | 'status'
      | 'asyncProcessingStatus'
      | 'title'
      | 'fileName'
      | 'fileSize'
      | 'mimeType'
    >
    & {
      formats: Array<(
        { __typename: 'Format' }
        & Pick<Format, 'id' | 'formatClass' | 'mimeType'>
        & { segments: Array<(
          { __typename: 'Segment' }
          & Pick<
            Segment,
            | 'fileId'
            | 'fileSize'
            | 'fileName'
            | 'sequence'
            | 'collectionId'
            | 'token'
          >
        )> }
      )>,
      features: Array<(
        { __typename: 'Feature' }
        & Pick<
          Feature,
          | 'id'
          | 'kind'
          | 'originX'
          | 'originY'
          | 'width'
          | 'height'
          | 'featurePage'
        >
        & {
          groups?: Maybe<Array<Pick<FeatureGroup, 'featureGroupId' | 'kind' | 'position'>>>,
          value:
            | (
              { __typename: 'AddressFeatureValue' }
              & { addressValue: Pick<
                  Address,
                  | 'street'
                  | 'streetAdditional'
                  | 'city'
                  | 'region'
                  | 'postalCode'
                  | 'countryCode'
                  | 'lat'
                  | 'long'
                > }
            )
            | (
              { __typename: 'DateFeatureValue' }
              & { dateValue: Pick<Date, 'year' | 'month' | 'day'> }
            )
            | (
              { __typename: 'LineItemFeatureValue' }
              & { lineItemValue: (
                Pick<
                  DocumentLineItem,
                  | 'description'
                  | 'quantity'
                  | 'position'
                  | 'categoryId'
                >
                & {
                  rate: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                  amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
                }
              ) }
            )
            | (
              { __typename: 'MonetaryFeatureValue' }
              & { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            )
            | (
              { __typename: 'NumericFeatureValue' }
              & Pick<NumericFeatureValue, 'numericValue'>
            )
            | (
              { __typename: 'RemittanceFeatureValue' }
              & { remittanceValue: Pick<
                  RemittanceItem,
                  | 'BankName'
                  | 'BankAccountNumber'
                  | 'BankAccountName'
                  | 'BankRoutingNumber'
                  | 'RemittanceType'
                > }
            )
            | (
              { __typename: 'TextFeatureValue' }
              & Pick<TextFeatureValue, 'textValue'>
            )
          ,
        }
      )>,
      creator?: Maybe<Pick<
          EntityUser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        >>,
      dataSource?: Maybe<Pick<
          EntityDataSource,
          | 'id'
          | 'name'
          | 'url'
          | 'iconUrl'
        >>,
      thumbnail?: Maybe<(
        { __typename: 'Segment' }
        & Pick<
          Segment,
          | 'fileId'
          | 'fileSize'
          | 'fileName'
          | 'sequence'
          | 'collectionId'
          | 'token'
        >
      )>,
      sourceFormat?: Maybe<(
        { __typename: 'Format' }
        & Pick<Format, 'id' | 'formatClass' | 'mimeType'>
        & { segments: Array<(
          { __typename: 'Segment' }
          & Pick<
            Segment,
            | 'fileId'
            | 'fileSize'
            | 'fileName'
            | 'sequence'
            | 'collectionId'
            | 'token'
          >
        )> }
      )>,
    }
  ) };

export type WalletStatementFieldsFragment = (
  { __typename: 'RawDocument' }
  & Pick<RawDocument, 'id' | 'collectionId' | 'createdAt'>
  & { features: Array<(
    { __typename: 'Feature' }
    & Pick<Feature, 'id' | 'kind'>
    & { value:
      | (
        { __typename: 'DateFeatureValue' }
        & { dateValue: Pick<Date, 'year' | 'month' | 'day'> }
      )
      | Record<PropertyKey, never>
     }
  )> }
);

export type ListWalletStatementsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  documentType: DocumentType;
  featureKinds?: InputMaybe<Array<FeatureKind> | FeatureKind>;
}>;


export type ListWalletStatementsQuery = { listDocumentsByType: Array<(
    { __typename: 'RawDocument' }
    & Pick<RawDocument, 'id' | 'collectionId' | 'createdAt'>
    & { features: Array<(
      { __typename: 'Feature' }
      & Pick<Feature, 'id' | 'kind'>
      & { value:
        | (
          { __typename: 'DateFeatureValue' }
          & { dateValue: Pick<Date, 'year' | 'month' | 'day'> }
        )
        | Record<PropertyKey, never>
       }
    )> }
  )> };

export type TransactionReviewQuestionFieldsFragment = Pick<TransactionReviewQuestion, 'question' | 'createdAt'>;

export type CloseWorkItemsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  closedWorkItems: Array<ClosedWorkItem> | ClosedWorkItem;
  viewKey?: InputMaybe<ViewKey>;
}>;


export type CloseWorkItemsMutation = Pick<Mutation, 'closeWorkItems'>;

export type PushDigitsWorkItemsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  workItems: Array<DigitsWorkItemPushParams> | DigitsWorkItemPushParams;
}>;


export type PushDigitsWorkItemsMutation = Pick<Mutation, 'pushDigitsWorkItems'>;

export type PushWorkItemsMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  workItems: Array<WorkItemPushParams> | WorkItemPushParams;
}>;


export type PushWorkItemsMutation = Pick<Mutation, 'pushWorkItems'>;

export type ReopenWorkItemMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  workItemId: Scalars['String']['input'];
}>;


export type ReopenWorkItemMutation = Pick<Mutation, 'reopenWorkItem'>;

export type UpdateAccountantReviewStatesMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  period: PeriodInput;
  workItemSubjects: Array<WorkItemSubject> | WorkItemSubject;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAccountantReviewStatesMutation = Pick<Mutation, 'updateAccountantReviewStates'>;

export type UpdateClientReviewStatesMutationVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  responses: Array<WorkItemResponse> | WorkItemResponse;
}>;


export type UpdateClientReviewStatesMutation = Pick<Mutation, 'updateClientReviewStates'>;

export type UpdateTransactionReviewQuestionsMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  deletedQuestions?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  newQuestions?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UpdateTransactionReviewQuestionsMutation = Pick<Mutation, 'updateTransactionReviewQuestions'>;

export type HighlightWorkItemQueryVariables = Exact<{
  similarityType: SimilarityType;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type HighlightWorkItemQuery = { highlightWorkItem: {
      description?: Maybe<Array<Pick<HighlightedToken, 'token' | 'score'>>>,
      name?: Maybe<Array<Pick<HighlightedToken, 'token' | 'score'>>>,
    } };

export type ListTransactionReviewItemsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  filter: WorkItemFilter;
  intervalOrigin: IntervalOrigin;
  direction: DirectionFromOrigin;
}>;


export type ListTransactionReviewItemsQuery = {
    workItems: Array<(
      Pick<
        WorkItem,
        | 'legalEntityId'
        | 'workItemId'
        | 'time'
        | 'itemType'
        | 'itemState'
        | 'ledgerType'
        | 'createdAt'
        | 'updatedBy'
        | 'updatedAt'
        | 'actionable'
        | 'reviewState'
      >
      & {
        transactions: Array<(
          Pick<
            WorkItemTransaction,
            | 'externalTransactionId'
            | 'externalTransactionLineId'
            | 'supportType'
            | 'displayPartyRole'
            | 'displayEntry'
            | 'description'
            | 'name'
            | 'occurredAt'
            | 'dataSourceId'
            | 'quickbooksAppName'
            | 'ledgerTransactionId'
          >
          & {
            displayCategory?: Maybe<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>,
            splitCategory?: Maybe<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>,
            party?: Maybe<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
            creditValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            debitValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            displayValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            moneyFlow?: Maybe<(
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            )>,
          }
        )>,
        review?: Maybe<(
          Pick<WorkItemReview, 'createdAt' | 'updatedAt' | 'subject'>
          & { creator: Pick<
              EntityUser,
              | 'id'
              | 'givenName'
              | 'familyName'
              | 'emailAddress'
              | 'avatarUrl'
            > }
        )>,
        generatedQuestions: Array<Pick<WorkItemGeneratedQuestion, 'question' | 'contextType' | 'active'>>,
        pushes: Array<Pick<
            WorkItemPush,
            | 'field'
            | 'pushState'
            | 'errorType'
            | 'updatedAt'
          >>,
      }
    )>,
    rules: Array<(
      Pick<
        AuditRule,
        | 'auditRuleId'
        | 'name'
        | 'description'
        | 'type'
        | 'action'
        | 'ruleState'
      >
      & {
        amountFilters?: Maybe<Array<(
          Pick<AmountRuleFilter, 'amountRuleFilterId' | 'operator' | 'createdAt'>
          & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        )>>,
        partyFilters?: Maybe<Array<(
          Pick<PartyRuleFilter, 'partyRuleFilterId' | 'operation' | 'createdAt'>
          & { parties: Array<Pick<PartyRuleFilterParty, 'partyId' | 'partyName'>> }
        )>>,
        categoryFilters?: Maybe<Array<(
          Pick<CategoryRuleFilter, 'categoryRuleFilterId' | 'operation' | 'createdAt'>
          & { categories: Array<Pick<CategoryRuleFilterCategory, 'categoryId' | 'categoryName'>> }
        )>>,
      }
    )>,
    ruleStatuses: Array<Pick<AuditRuleStatus, 'type' | 'recentlyUpdated' | 'updaterType'>>,
  };

export type ListTransactionReviewQuestionsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type ListTransactionReviewQuestionsQuery = { listTransactionReviewQuestions?: Maybe<Array<Pick<TransactionReviewQuestion, 'question' | 'createdAt'>>> };

export type ListWorkItemsQueryVariables = Exact<{
  filter: WorkItemFilter;
  intervalOrigin: IntervalOrigin;
  direction: DirectionFromOrigin;
}>;


export type ListWorkItemsQuery = { listWorkItems: Array<(
    Pick<
      WorkItem,
      | 'legalEntityId'
      | 'workItemId'
      | 'time'
      | 'itemType'
      | 'itemState'
      | 'ledgerType'
      | 'createdAt'
      | 'updatedBy'
      | 'updatedAt'
      | 'actionable'
      | 'reviewState'
    >
    & {
      transactions: Array<(
        Pick<
          WorkItemTransaction,
          | 'externalTransactionId'
          | 'externalTransactionLineId'
          | 'supportType'
          | 'displayPartyRole'
          | 'displayEntry'
          | 'description'
          | 'name'
          | 'occurredAt'
          | 'dataSourceId'
          | 'quickbooksAppName'
          | 'ledgerTransactionId'
        >
        & {
          displayCategory?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
          splitCategory?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
          party?: Maybe<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>,
          creditValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          debitValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          displayValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          moneyFlow?: Maybe<(
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          )>,
        }
      )>,
      review?: Maybe<(
        Pick<WorkItemReview, 'createdAt' | 'updatedAt' | 'subject'>
        & { creator: Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          > }
      )>,
      generatedQuestions: Array<Pick<WorkItemGeneratedQuestion, 'question' | 'contextType' | 'active'>>,
      pushes: Array<Pick<
          WorkItemPush,
          | 'field'
          | 'pushState'
          | 'errorType'
          | 'updatedAt'
        >>,
    }
  )> };

export type ListWorkItemsByIdsQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
  workItemIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ListWorkItemsByIdsQuery = { listWorkItemsByIds: Array<(
    Pick<
      WorkItem,
      | 'legalEntityId'
      | 'workItemId'
      | 'time'
      | 'itemType'
      | 'itemState'
      | 'ledgerType'
      | 'createdAt'
      | 'updatedBy'
      | 'updatedAt'
      | 'actionable'
      | 'reviewState'
    >
    & {
      transactions: Array<(
        Pick<
          WorkItemTransaction,
          | 'externalTransactionId'
          | 'externalTransactionLineId'
          | 'supportType'
          | 'displayPartyRole'
          | 'displayEntry'
          | 'description'
          | 'name'
          | 'occurredAt'
          | 'dataSourceId'
          | 'quickbooksAppName'
          | 'ledgerTransactionId'
        >
        & {
          displayCategory?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
          splitCategory?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
          party?: Maybe<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>,
          creditValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          debitValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          displayValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          moneyFlow?: Maybe<(
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          )>,
        }
      )>,
      review?: Maybe<(
        Pick<WorkItemReview, 'createdAt' | 'updatedAt' | 'subject'>
        & { creator: Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          > }
      )>,
      generatedQuestions: Array<Pick<WorkItemGeneratedQuestion, 'question' | 'contextType' | 'active'>>,
      pushes: Array<Pick<
          WorkItemPush,
          | 'field'
          | 'pushState'
          | 'errorType'
          | 'updatedAt'
        >>,
    }
  )> };

export type SummarizeWorkItemsQueryVariables = Exact<{
  filter: WorkItemFilter;
  intervalOrigin: IntervalOrigin;
  direction: DirectionFromOrigin;
}>;


export type SummarizeWorkItemsQuery = { summarizeWorkItems: Array<(
    Pick<WorkItemSummary, 'count'>
    & { period: Pick<
        Period,
        | 'name'
        | 'interval'
        | 'startedAt'
        | 'endedAt'
      > }
  )> };

export type WorkflowActivityItemFieldsFragment = Pick<
    WorkflowActivityItem,
    | 'workflowId'
    | 'definitionName'
    | 'title'
    | 'status'
    | 'businessOutcome'
    | 'createdAt'
    | 'updatedAt'
    | 'completedAt'
    | 'message'
    | 'messageKind'
    | 'displayKey'
    | 'iconUrl'
    | 'targetAction'
  >;

export type WorkflowEventFieldsFragment = Pick<
    WorkflowEvent,
    | 'workflowId'
    | 'definitionName'
    | 'eventKind'
    | 'timestamp'
    | 'businessOutcome'
  >;

export type UserWorkflowActivityQueryVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type UserWorkflowActivityQuery = { userWorkflowActivity: Array<Pick<
      WorkflowActivityItem,
      | 'workflowId'
      | 'definitionName'
      | 'title'
      | 'status'
      | 'businessOutcome'
      | 'createdAt'
      | 'updatedAt'
      | 'completedAt'
      | 'message'
      | 'messageKind'
      | 'displayKey'
      | 'iconUrl'
      | 'targetAction'
    >> };

export type WorkflowEventsSubscriptionVariables = Exact<{
  legalEntityId: Scalars['String']['input'];
}>;


export type WorkflowEventsSubscription = { workflowEvents: Pick<
      WorkflowEvent,
      | 'workflowId'
      | 'definitionName'
      | 'eventKind'
      | 'timestamp'
      | 'businessOutcome'
    > };

export type WorkflowNotificationsSubscriptionVariables = Exact<{
  legalEntityID: Scalars['String']['input'];
}>;


export type WorkflowNotificationsSubscription = { workflowNotifications: Pick<
      WorkflowNotificationEvent,
      | 'workflowNotificationID'
      | 'workflowID'
      | 'definitionName'
      | 'createdAt'
      | 'message'
      | 'kind'
      | 'notificationType'
      | 'targetAction'
      | 'bearerUpdated'
      | 'bearerRefreshDeferred'
    > };

export type AddressFieldsFragment = Pick<
    Address,
    | 'street'
    | 'streetAdditional'
    | 'city'
    | 'region'
    | 'postalCode'
    | 'countryCode'
    | 'lat'
    | 'long'
  >;

export type ArchiveIntervalOriginFieldsFragment = Pick<
    ArchiveIntervalOrigin,
    | 'interval'
    | 'year'
    | 'index'
    | 'intervalCount'
    | 'maxTime'
  >;

export type BooksClosedDateFieldsFragment = (
  Pick<BooksClosedDate, 'legalEntityId' | 'latestBooksClosedDateFact'>
  & { user?: Maybe<Pick<
      EntityUser,
      | 'id'
      | 'givenName'
      | 'familyName'
      | 'emailAddress'
      | 'avatarUrl'
    >> }
);

export type CategoryFieldsFragment = (
  Pick<
    Category,
    | 'id'
    | 'name'
    | 'description'
    | 'displayKey'
    | 'type'
    | 'subtype'
    | 'parentCategoryId'
    | 'displayNumber'
    | 'active'
    | 'categoryState'
    | 'productArea'
    | 'synthesized'
  >
  & { ancestors?: Maybe<Array<Pick<
      EntityCategory,
      | 'id'
      | 'name'
      | 'displayKey'
      | 'chartOfAccountsDisplayNumber'
      | 'type'
      | 'subtype'
      | 'parentCategoryId'
      | 'productArea'
      | 'active'
    >>> }
);

export type CategoryMappingFieldsFragment = (
  Pick<CategoryMapping, 'mappingValue' | 'mappingType' | 'product'>
  & { category: Pick<
      EntityCategory,
      | 'id'
      | 'name'
      | 'displayKey'
      | 'chartOfAccountsDisplayNumber'
      | 'type'
      | 'subtype'
      | 'parentCategoryId'
      | 'productArea'
      | 'active'
    > }
);

export type ClassificationProvenanceFieldsFragment = (
  Pick<
    ClassificationProvenance,
    | 'type'
    | 'changedAt'
    | 'confidenceLevel'
    | 'settingsName'
  >
  & { source?: Maybe<(
    Pick<
      TransactionSource,
      | 'timestamp'
      | 'name'
      | 'iconUrl'
      | 'externalDisplayId'
      | 'type'
    >
    & { account?: Maybe<Pick<
        TransactionSourceAccount,
        | 'sourceAccountId'
        | 'externalName'
        | 'mask'
        | 'externalOwnerName'
        | 'externalOfficialName'
      >> }
  )> }
);

export type CommentFieldsFragment = (
  { __typename: 'Comment' }
  & Pick<
    Comment,
    | 'id'
    | 'authorId'
    | 'text'
    | 'timestamp'
    | 'editedAt'
    | 'deletedAt'
    | 'reactions'
  >
  & { layoutAttachment?: Maybe<Pick<LayoutAttachment, 'layoutId' | 'legalEntityId'>> }
);

export type ConnectorFieldsFragment = (
  Pick<
    Connector,
    | 'id'
    | 'name'
    | 'tagline'
    | 'description'
    | 'category'
    | 'iconObjectName'
    | 'className'
    | 'canInstall'
  >
  & { connectorProperties?: Maybe<
    | (
      { __typename: 'AppConnectorProperties' }
      & Pick<
        AppConnectorProperties,
        | 'organizationId'
        | 'visibility'
        | 'homepageURL'
        | 'supportEmail'
        | 'developerEmail'
        | 'privacyPolicyURL'
        | 'termsOfServiceURL'
        | 'scopes'
        | 'redirectUris'
        | 'installUri'
      >
    )
    | (
      { __typename: 'BillConnectorProperties' }
      & Pick<BillConnectorProperties, 'empty'>
    )
    | (
      { __typename: 'EmptyConnectorProperties' }
      & Pick<EmptyConnectorProperties, 'empty'>
    )
    | (
      { __typename: 'FinchConnectorProperties' }
      & Pick<FinchConnectorProperties, 'empty'>
    )
    | (
      { __typename: 'GustoConnectorProperties' }
      & Pick<GustoConnectorProperties, 'authorizationURL'>
    )
    | (
      { __typename: 'PlaidConnectorProperties' }
      & Pick<PlaidConnectorProperties, 'empty'>
    )
    | (
      { __typename: 'RampConnectorProperties' }
      & Pick<RampConnectorProperties, 'authorizationURL'>
    )
    | (
      { __typename: 'StripeConnectorProperties' }
      & Pick<StripeConnectorProperties, 'appLinkURL'>
    )
  > }
);

export type ContactFieldsFragment = Pick<
    Contact,
    | 'givenName'
    | 'familyName'
    | 'emailAddress'
    | 'avatarUrl'
  >;

export type DataSourceFieldsFragment = (
  Pick<
    DataSource,
    | 'id'
    | 'legalEntityId'
    | 'status'
    | 'statusReason'
    | 'providerType'
    | 'accountAlias'
    | 'createdAt'
    | 'updatedAt'
  >
  & { institution: Pick<
      Institution,
      | 'id'
      | 'name'
      | 'url'
      | 'routingNumber'
      | 'iconUrl'
      | 'partyId'
      | 'createdAt'
    > }
);

export type EnrichedDataSourceFieldsFragment = (
  Pick<
    EnrichedDataSource,
    | 'id'
    | 'legalEntityId'
    | 'status'
    | 'statusReason'
    | 'providerType'
    | 'accountAlias'
    | 'createdAt'
    | 'updatedAt'
    | 'lastActivityAt'
    | 'hasTransactions'
  >
  & {
    institution: Pick<
        Party,
        | 'id'
        | 'legalEntityId'
        | 'name'
        | 'url'
        | 'supportUrl'
        | 'supportEmail'
        | 'supportPhone'
        | 'twitterUrl'
        | 'facebookUrl'
        | 'instagramUrl'
        | 'yelpUrl'
        | 'iconUrl'
        | 'shortDescription'
        | 'designation'
      >,
    quickBooksConfig?: Maybe<Pick<
        QuickBooksConfig,
        | 'id'
        | 'realmId'
        | 'createdAt'
        | 'updatedAt'
      >>,
    plaidConfig?: Maybe<Pick<
        PlaidConfig,
        | 'id'
        | 'itemId'
        | 'externalInstitutionId'
        | 'createdAt'
        | 'updatedAt'
      >>,
    sourceAccounts?: Maybe<Array<Pick<
        SourceAccount,
        | 'id'
        | 'externalId'
        | 'externalName'
        | 'externalOwnerName'
        | 'externalOfficialName'
        | 'externalType'
        | 'externalSubtype'
        | 'mask'
        | 'status'
        | 'ownerEmployeeId'
      >>>,
  }
);

export type QuickBooksConfigFieldsFragment = Pick<
    QuickBooksConfig,
    | 'id'
    | 'realmId'
    | 'createdAt'
    | 'updatedAt'
  >;

export type PlaidConfigFieldsFragment = Pick<
    PlaidConfig,
    | 'id'
    | 'itemId'
    | 'externalInstitutionId'
    | 'createdAt'
    | 'updatedAt'
  >;

export type DataSourcePreferenceFieldsFragment = Pick<
    DataSourcePreference,
    | 'dataSourceId'
    | 'accountingBasis'
    | 'taxForm'
    | 'providerType'
    | 'departmentTerminology'
  >;

export type DateFieldsFragment = Pick<Date, 'year' | 'month' | 'day'>;

export type DepartmentFieldsFragment = (
  Pick<
    Department,
    | 'id'
    | 'name'
    | 'parentId'
    | 'active'
    | 'description'
    | 'displayKey'
  >
  & {
    ancestors: Array<(
      { __typename: 'EntityDepartment' }
      & Pick<
        EntityDepartment,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    matches: Array<Pick<MatchedDepartment, 'id' | 'dataSourceId'>>,
    dataSource?: Maybe<Pick<
        EntityDataSource,
        | 'id'
        | 'name'
        | 'url'
        | 'iconUrl'
      >>,
  }
);

export type DocumentInitialSegmentFieldsFragment = Pick<DocumentInitialSegment, 'collectionId' | 'documentId' | 'downloadUrl'>;

export type DoppelgangerPermitFieldsFragment = (
  Pick<DoppelgangerPermit, 'id' | 'expiresAt' | 'createdAt'>
  & { user: (
    Pick<
      User,
      | 'id'
      | 'givenName'
      | 'familyName'
      | 'primaryEmailAddress'
      | 'passwordSet'
      | 'avatarUrl'
      | 'createdAt'
      | 'lastActivityAt'
    >
    & {
      employments?: Maybe<Array<(
        Pick<OrganizationEmployment, 'employeeId'>
        & {
          role: Pick<Role, 'id'>,
          organization: Pick<
              Organization,
              | 'id'
              | 'slug'
              | 'name'
              | 'iconUrl'
              | 'websiteUrl'
              | 'kind'
            >,
          legalEntityRoles?: Maybe<Array<(
            Pick<EmployeeLegalEntityRole, 'legalEntityId'>
            & { role?: Maybe<Pick<Role, 'id'>> }
          )>>,
        }
      )>>,
      identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
    }
  ) }
);

export type EmployeeAffiliationsFieldsFragment = {
    employee: (
      Pick<
        Employee,
        | 'id'
        | 'organizationId'
        | 'givenName'
        | 'familyName'
        | 'avatarUrl'
        | 'emailAddress'
        | 'jobTitle'
        | 'lastActivityAt'
        | 'status'
        | 'hiddenAt'
      >
      & {
        role?: Maybe<Pick<Role, 'id'>>,
        defaultEntityRole?: Maybe<Pick<Role, 'id'>>,
        user?: Maybe<(
          Pick<
            User,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'primaryEmailAddress'
            | 'passwordSet'
            | 'avatarUrl'
            | 'createdAt'
            | 'lastActivityAt'
          >
          & {
            employments?: Maybe<Array<(
              Pick<OrganizationEmployment, 'employeeId'>
              & {
                role: Pick<Role, 'id'>,
                organization: Pick<
                    Organization,
                    | 'id'
                    | 'slug'
                    | 'name'
                    | 'iconUrl'
                    | 'websiteUrl'
                    | 'kind'
                  >,
                legalEntityRoles?: Maybe<Array<(
                  Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                  & { role?: Maybe<Pick<Role, 'id'>> }
                )>>,
              }
            )>>,
            identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
          }
        )>,
        invitation?: Maybe<(
          Pick<
            Invitation,
            | 'id'
            | 'invitationType'
            | 'status'
            | 'service'
            | 'organizationTemplateId'
            | 'createdAt'
            | 'updatedAt'
            | 'notifiedAt'
          >
          & {
            recipient: Pick<
                Contact,
                | 'givenName'
                | 'familyName'
                | 'emailAddress'
                | 'avatarUrl'
              >,
            sender?: Maybe<Pick<
                Contact,
                | 'givenName'
                | 'familyName'
                | 'emailAddress'
                | 'avatarUrl'
              >>,
            organization?: Maybe<Pick<
                Organization,
                | 'id'
                | 'slug'
                | 'name'
                | 'iconUrl'
                | 'websiteUrl'
                | 'kind'
              >>,
            role?: Maybe<Pick<Role, 'id'>>,
          }
        )>,
        legalEntityRoles?: Maybe<Array<(
          Pick<EmployeeLegalEntityRole, 'legalEntityId'>
          & { role?: Maybe<Pick<Role, 'id'>> }
        )>>,
      }
    ),
    affiliations: Array<{
        organization: Pick<
            EntityOrganization,
            | 'id'
            | 'name'
            | 'slug'
            | 'iconUrl'
          >,
        legalEntity: Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>,
        role: Pick<Role, 'id'>,
      }>,
  };

export type EmployeeFieldsFragment = (
  Pick<
    Employee,
    | 'id'
    | 'organizationId'
    | 'givenName'
    | 'familyName'
    | 'avatarUrl'
    | 'emailAddress'
    | 'jobTitle'
    | 'lastActivityAt'
    | 'status'
    | 'hiddenAt'
  >
  & {
    role?: Maybe<Pick<Role, 'id'>>,
    defaultEntityRole?: Maybe<Pick<Role, 'id'>>,
    user?: Maybe<(
      Pick<
        User,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'primaryEmailAddress'
        | 'passwordSet'
        | 'avatarUrl'
        | 'createdAt'
        | 'lastActivityAt'
      >
      & {
        employments?: Maybe<Array<(
          Pick<OrganizationEmployment, 'employeeId'>
          & {
            role: Pick<Role, 'id'>,
            organization: Pick<
                Organization,
                | 'id'
                | 'slug'
                | 'name'
                | 'iconUrl'
                | 'websiteUrl'
                | 'kind'
              >,
            legalEntityRoles?: Maybe<Array<(
              Pick<EmployeeLegalEntityRole, 'legalEntityId'>
              & { role?: Maybe<Pick<Role, 'id'>> }
            )>>,
          }
        )>>,
        identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
      }
    )>,
    invitation?: Maybe<(
      Pick<
        Invitation,
        | 'id'
        | 'invitationType'
        | 'status'
        | 'service'
        | 'organizationTemplateId'
        | 'createdAt'
        | 'updatedAt'
        | 'notifiedAt'
      >
      & {
        recipient: Pick<
            Contact,
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >,
        sender?: Maybe<Pick<
            Contact,
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>,
        organization?: Maybe<Pick<
            Organization,
            | 'id'
            | 'slug'
            | 'name'
            | 'iconUrl'
            | 'websiteUrl'
            | 'kind'
          >>,
        role?: Maybe<Pick<Role, 'id'>>,
      }
    )>,
    legalEntityRoles?: Maybe<Array<(
      Pick<EmployeeLegalEntityRole, 'legalEntityId'>
      & { role?: Maybe<Pick<Role, 'id'>> }
    )>>,
  }
);

export type HighlightedTokenFieldsFragment = Pick<HighlightedToken, 'token' | 'score'>;

export type HighlightedTokensFieldsFragment = {
    description?: Maybe<Array<Pick<HighlightedToken, 'token' | 'score'>>>,
    name?: Maybe<Array<Pick<HighlightedToken, 'token' | 'score'>>>,
  };

export type IdentityFieldsFragment = Pick<Identity, 'identifier' | 'provider' | 'domain'>;

export type InsightFieldsFragment = (
  Pick<
    Insight,
    | 'score'
    | 'globalScore'
    | 'subjectType'
    | 'subjectId'
    | 'subjectDisplayKey'
    | 'comparisonIntervalOffset'
    | 'ruleType'
    | 'sentence'
    | 'subjectIconUrl'
    | 'designation'
    | 'type'
    | 'productArea'
  >
  & {
    periodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    absoluteDelta?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    comparisonPeriodValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
  }
);

export type InstitutionFieldsFragment = Pick<
    Institution,
    | 'id'
    | 'name'
    | 'url'
    | 'routingNumber'
    | 'iconUrl'
    | 'partyId'
    | 'createdAt'
  >;

export type InvitationFieldsFragment = (
  Pick<
    Invitation,
    | 'id'
    | 'invitationType'
    | 'status'
    | 'service'
    | 'organizationTemplateId'
    | 'createdAt'
    | 'updatedAt'
    | 'notifiedAt'
  >
  & {
    recipient: Pick<
        Contact,
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >,
    sender?: Maybe<Pick<
        Contact,
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
    organization?: Maybe<Pick<
        Organization,
        | 'id'
        | 'slug'
        | 'name'
        | 'iconUrl'
        | 'websiteUrl'
        | 'kind'
      >>,
    role?: Maybe<Pick<Role, 'id'>>,
  }
);

export type InvitationProposalFieldsFragment = (
  Pick<
    InvitationProposal,
    | 'proposalId'
    | 'proposalType'
    | 'status'
    | 'invitationId'
    | 'organizationTemplateId'
    | 'createdAt'
  >
  & {
    legalEntity?: Maybe<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>,
    organization?: Maybe<Pick<
        EntityOrganization,
        | 'id'
        | 'name'
        | 'slug'
        | 'iconUrl'
      >>,
    sender?: Maybe<Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
    recipient?: Maybe<Pick<
        Contact,
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
  }
);

export type TransactionEntryLineFieldsFragment = (
  Pick<
    TransactionEntryLine,
    | 'lineId'
    | 'factId'
    | 'name'
    | 'description'
    | 'isCredit'
    | 'highlighted'
  >
  & {
    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    category: (
      Pick<
        Category,
        | 'id'
        | 'name'
        | 'description'
        | 'displayKey'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'displayNumber'
        | 'active'
        | 'categoryState'
        | 'productArea'
        | 'synthesized'
      >
      & { ancestors?: Maybe<Array<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>> }
    ),
    categoryClassificationProvenance?: Maybe<(
      Pick<
        ClassificationProvenance,
        | 'type'
        | 'changedAt'
        | 'confidenceLevel'
        | 'settingsName'
      >
      & { source?: Maybe<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )> }
    )>,
  }
);

export type LegalEntityFieldsFragment = (
  Pick<
    LegalEntity,
    | 'id'
    | 'slug'
    | 'name'
    | 'websiteUrl'
    | 'industry'
    | 'timezone'
    | 'fiscalYearStartMonth'
    | 'fiscalYearNumberOffset'
    | 'status'
    | 'organizationId'
    | 'sensitive'
    | 'phoneNumber'
    | 'iconUrl'
  >
  & {
    address: Pick<
        Address,
        | 'street'
        | 'streetAdditional'
        | 'city'
        | 'region'
        | 'postalCode'
        | 'countryCode'
        | 'lat'
        | 'long'
      >,
    incorporatedOn?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
  }
);

export type LocationFieldsFragment = (
  Pick<
    Location,
    | 'id'
    | 'name'
    | 'parentId'
    | 'active'
    | 'description'
    | 'displayKey'
  >
  & {
    ancestors: Array<(
      { __typename: 'EntityLocation' }
      & Pick<
        EntityLocation,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    dataSource?: Maybe<Pick<
        EntityDataSource,
        | 'id'
        | 'name'
        | 'url'
        | 'iconUrl'
      >>,
  }
);

export type MonetaryValueFieldsFragment = Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>;

export type MoneyFlowFieldsFragment = (
  Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
  & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
);

export type OrganizationFieldsFragment = Pick<
    Organization,
    | 'id'
    | 'slug'
    | 'name'
    | 'iconUrl'
    | 'websiteUrl'
    | 'kind'
  >;

export type OrganizationPreviewFieldsFragment = Pick<
    OrganizationPreview,
    | 'id'
    | 'slug'
    | 'name'
    | 'iconUrl'
  >;

export type OwnedSourceAccountFieldsFragment = {
    sourceAccount: Pick<
        SourceAccount,
        | 'id'
        | 'externalId'
        | 'externalName'
        | 'externalOwnerName'
        | 'externalOfficialName'
        | 'externalType'
        | 'externalSubtype'
        | 'mask'
        | 'status'
        | 'ownerEmployeeId'
      >,
    owner?: Maybe<(
      Pick<
        Employee,
        | 'id'
        | 'organizationId'
        | 'givenName'
        | 'familyName'
        | 'avatarUrl'
        | 'emailAddress'
        | 'jobTitle'
        | 'lastActivityAt'
        | 'status'
        | 'hiddenAt'
      >
      & {
        role?: Maybe<Pick<Role, 'id'>>,
        defaultEntityRole?: Maybe<Pick<Role, 'id'>>,
        user?: Maybe<(
          Pick<
            User,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'primaryEmailAddress'
            | 'passwordSet'
            | 'avatarUrl'
            | 'createdAt'
            | 'lastActivityAt'
          >
          & {
            employments?: Maybe<Array<(
              Pick<OrganizationEmployment, 'employeeId'>
              & {
                role: Pick<Role, 'id'>,
                organization: Pick<
                    Organization,
                    | 'id'
                    | 'slug'
                    | 'name'
                    | 'iconUrl'
                    | 'websiteUrl'
                    | 'kind'
                  >,
                legalEntityRoles?: Maybe<Array<(
                  Pick<EmployeeLegalEntityRole, 'legalEntityId'>
                  & { role?: Maybe<Pick<Role, 'id'>> }
                )>>,
              }
            )>>,
            identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
          }
        )>,
        invitation?: Maybe<(
          Pick<
            Invitation,
            | 'id'
            | 'invitationType'
            | 'status'
            | 'service'
            | 'organizationTemplateId'
            | 'createdAt'
            | 'updatedAt'
            | 'notifiedAt'
          >
          & {
            recipient: Pick<
                Contact,
                | 'givenName'
                | 'familyName'
                | 'emailAddress'
                | 'avatarUrl'
              >,
            sender?: Maybe<Pick<
                Contact,
                | 'givenName'
                | 'familyName'
                | 'emailAddress'
                | 'avatarUrl'
              >>,
            organization?: Maybe<Pick<
                Organization,
                | 'id'
                | 'slug'
                | 'name'
                | 'iconUrl'
                | 'websiteUrl'
                | 'kind'
              >>,
            role?: Maybe<Pick<Role, 'id'>>,
          }
        )>,
        legalEntityRoles?: Maybe<Array<(
          Pick<EmployeeLegalEntityRole, 'legalEntityId'>
          & { role?: Maybe<Pick<Role, 'id'>> }
        )>>,
      }
    )>,
  };

export type PartyFieldsFragment = Pick<
    Party,
    | 'id'
    | 'legalEntityId'
    | 'name'
    | 'url'
    | 'supportUrl'
    | 'supportEmail'
    | 'supportPhone'
    | 'twitterUrl'
    | 'facebookUrl'
    | 'instagramUrl'
    | 'yelpUrl'
    | 'iconUrl'
    | 'shortDescription'
    | 'designation'
  >;

export type PeriodFieldsFragment = Pick<
    Period,
    | 'name'
    | 'interval'
    | 'startedAt'
    | 'endedAt'
  >;

export type PeriodMonetaryValueFieldsFragment = (
  Pick<
    PeriodMonetaryValue,
    | 'transactionsCount'
    | 'deltaPrevious'
    | 'deltaYearAgo'
    | 'isFirstOccurrencePeriod'
  >
  & {
    value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    moneyFlow?: Maybe<(
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    )>,
    current?: Maybe<(
      Pick<SummaryTotal, 'count'>
      & { total: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ) }
    )>,
    prior?: Maybe<(
      Pick<SummaryTotal, 'count'>
      & { total: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ) }
    )>,
  }
);

export type ProductFieldsFragment = Pick<
    Product,
    | 'id'
    | 'dataSourceId'
    | 'name'
    | 'providerType'
    | 'active'
    | 'institutionId'
    | 'institutionName'
  >;

export type ProductGroupFieldsFragment = Pick<
    ProductGroup,
    | 'id'
    | 'name'
    | 'description'
    | 'iconDisplayKey'
    | 'iconColorKey'
    | 'customIconObjectName'
    | 'customIconUrl'
    | 'createdAt'
    | 'updatedAt'
  >;

export type ProductInstitutionFieldsFragment = (
  Pick<
    ProductInstitution,
    | 'id'
    | 'name'
    | 'products'
    | 'routingNumber'
  >
  & { party?: Maybe<Pick<
      Party,
      | 'id'
      | 'legalEntityId'
      | 'name'
      | 'url'
      | 'supportUrl'
      | 'supportEmail'
      | 'supportPhone'
      | 'twitterUrl'
      | 'facebookUrl'
      | 'instagramUrl'
      | 'yelpUrl'
      | 'iconUrl'
      | 'shortDescription'
      | 'designation'
    >> }
);

export type ReconciliationDiffFieldsFragment = (
  Pick<ReconciliationDiff, 'reconciliationId'>
  & {
    toStartDate: Pick<Date, 'year' | 'month' | 'day'>,
    toEndDate: Pick<Date, 'year' | 'month' | 'day'>,
    transactions: Array<(
      Pick<
        ReconciliationDiffTransaction,
        | 'transactionFactId'
        | 'diffReasons'
        | 'fromStatus'
        | 'toStatus'
        | 'fromOccurredAt'
        | 'toOccurredAt'
        | 'fromEntryType'
        | 'toEntryType'
      >
      & {
        transaction?: Maybe<(
          Pick<
            Transaction,
            | 'viewId'
            | 'factId'
            | 'ledgerTransactionId'
            | 'supersededFactIds'
            | 'timestamp'
            | 'recordType'
            | 'name'
            | 'description'
            | 'digitsTransactionType'
            | 'partySource'
            | 'displayEntry'
            | 'displayCategorySource'
            | 'displayCanonicalCategoryName'
            | 'displayUncategorizedReason'
            | 'displayProductArea'
            | 'ownerSource'
            | 'transactionClassificationType'
            | 'compileSource'
            | 'reconciliationStatus'
            | 'referenceNumber'
            | 'taxStatus'
            | 'matchedLedgerTransactionIds'
            | 'providerTypes'
            | 'isSupersedingLedgerTransaction'
            | 'supersededLedgerTransactionIds'
          >
          & {
            party?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            facilitatorParty?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            product?: Maybe<Pick<
                Product,
                | 'id'
                | 'dataSourceId'
                | 'name'
                | 'providerType'
                | 'active'
                | 'institutionId'
                | 'institutionName'
              >>,
            department?: Maybe<(
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            splitDepartment?: Maybe<(
              { __typename: 'EntityDepartment' }
              & Pick<
                EntityDepartment,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            location?: Maybe<(
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            splitLocation?: Maybe<(
              { __typename: 'EntityLocation' }
              & Pick<
                EntityLocation,
                | 'id'
                | 'name'
                | 'parentId'
                | 'active'
              >
            )>,
            providers: Array<Pick<Provider, 'name'>>,
            recurrence?: Maybe<Pick<
                TransactionRecurrence,
                | 'recurrenceThreadId'
                | 'interval'
                | 'intervalMultiplier'
                | 'threadIndex'
                | 'totalThreadCount'
                | 'isHidden'
                | 'firstOccurredAt'
                | 'lastOccurredAt'
              >>,
            displayInstitution?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            displayCategory: (
              Pick<
                Category,
                | 'id'
                | 'name'
                | 'description'
                | 'displayKey'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'displayNumber'
                | 'active'
                | 'categoryState'
                | 'productArea'
                | 'synthesized'
              >
              & { ancestors?: Maybe<Array<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>> }
            ),
            displayCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            splitCategory?: Maybe<(
              Pick<
                Category,
                | 'id'
                | 'name'
                | 'description'
                | 'displayKey'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'displayNumber'
                | 'active'
                | 'categoryState'
                | 'productArea'
                | 'synthesized'
              >
              & { ancestors?: Maybe<Array<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>> }
            )>,
            splitCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            splitInstitution?: Maybe<Pick<
                TransactionParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'iconObjectName'
                | 'designation'
                | 'roles'
              >>,
            creditCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            debitCategoryClassificationProvenance?: Maybe<(
              Pick<
                ClassificationProvenance,
                | 'type'
                | 'changedAt'
                | 'confidenceLevel'
                | 'settingsName'
              >
              & { source?: Maybe<(
                Pick<
                  TransactionSource,
                  | 'timestamp'
                  | 'name'
                  | 'iconUrl'
                  | 'externalDisplayId'
                  | 'type'
                >
                & { account?: Maybe<Pick<
                    TransactionSourceAccount,
                    | 'sourceAccountId'
                    | 'externalName'
                    | 'mask'
                    | 'externalOwnerName'
                    | 'externalOfficialName'
                  >> }
              )> }
            )>,
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            runningTotal?: Maybe<(
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            )>,
            owner?: Maybe<Pick<
                EntityEmployee,
                | 'id'
                | 'organizationId'
                | 'givenName'
                | 'familyName'
                | 'avatarUrl'
              >>,
            sources: Array<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )>,
            creditSources: Array<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )>,
            debitSources: Array<(
              Pick<
                TransactionSource,
                | 'timestamp'
                | 'name'
                | 'iconUrl'
                | 'externalDisplayId'
                | 'type'
              >
              & { account?: Maybe<Pick<
                  TransactionSourceAccount,
                  | 'sourceAccountId'
                  | 'externalName'
                  | 'mask'
                  | 'externalOwnerName'
                  | 'externalOfficialName'
                >> }
            )>,
            invoiceLineItem?: Maybe<{ value:
                | (
                  Pick<
                    TransactionDiscountLineItem,
                    | 'name'
                    | 'description'
                    | 'variablePercentage'
                    | 'appliesToTransactionFactId'
                  >
                  & {
                    fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                    discount?: Maybe<(
                      Pick<
                        TransactionInvoiceLineItemDiscount,
                        | 'discountId'
                        | 'name'
                        | 'description'
                        | 'variablePercentage'
                      >
                      & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                    )>,
                  }
                )
                | (
                  Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
                  & {
                    unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                    product?: Maybe<(
                      Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                      & {
                        unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                        category?: Maybe<(
                          Pick<
                            Category,
                            | 'id'
                            | 'name'
                            | 'description'
                            | 'displayKey'
                            | 'type'
                            | 'subtype'
                            | 'parentCategoryId'
                            | 'displayNumber'
                            | 'active'
                            | 'categoryState'
                            | 'productArea'
                            | 'synthesized'
                          >
                          & { ancestors?: Maybe<Array<Pick<
                              EntityCategory,
                              | 'id'
                              | 'name'
                              | 'displayKey'
                              | 'chartOfAccountsDisplayNumber'
                              | 'type'
                              | 'subtype'
                              | 'parentCategoryId'
                              | 'productArea'
                              | 'active'
                            >>> }
                        )>,
                        department?: Maybe<(
                          { __typename: 'EntityDepartment' }
                          & Pick<
                            EntityDepartment,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        )>,
                        location?: Maybe<(
                          { __typename: 'EntityLocation' }
                          & Pick<
                            EntityLocation,
                            | 'id'
                            | 'name'
                            | 'parentId'
                            | 'active'
                          >
                        )>,
                      }
                    )>,
                  }
                )
               }>,
            schedule?: Maybe<(
              { __typename: 'EntitySchedule' }
              & Pick<
                EntitySchedule,
                | 'id'
                | 'name'
                | 'scheduleNumber'
                | 'scheduleType'
                | 'scheduleTemplateId'
                | 'categoryId'
                | 'relatedCategoryId'
                | 'partyId'
                | 'startDate'
                | 'endDate'
                | 'cutoverDate'
              >
              & {
                amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              }
            )>,
            splitSchedule?: Maybe<(
              { __typename: 'EntitySchedule' }
              & Pick<
                EntitySchedule,
                | 'id'
                | 'name'
                | 'scheduleNumber'
                | 'scheduleType'
                | 'scheduleTemplateId'
                | 'categoryId'
                | 'relatedCategoryId'
                | 'partyId'
                | 'startDate'
                | 'endDate'
                | 'cutoverDate'
              >
              & {
                amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
              }
            )>,
          }
        )>,
        fromAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        toAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
      }
    )>,
  }
);

export type ReconciliationDiffTransactionFieldsFragment = (
  Pick<
    ReconciliationDiffTransaction,
    | 'transactionFactId'
    | 'diffReasons'
    | 'fromStatus'
    | 'toStatus'
    | 'fromOccurredAt'
    | 'toOccurredAt'
    | 'fromEntryType'
    | 'toEntryType'
  >
  & {
    transaction?: Maybe<(
      Pick<
        Transaction,
        | 'viewId'
        | 'factId'
        | 'ledgerTransactionId'
        | 'supersededFactIds'
        | 'timestamp'
        | 'recordType'
        | 'name'
        | 'description'
        | 'digitsTransactionType'
        | 'partySource'
        | 'displayEntry'
        | 'displayCategorySource'
        | 'displayCanonicalCategoryName'
        | 'displayUncategorizedReason'
        | 'displayProductArea'
        | 'ownerSource'
        | 'transactionClassificationType'
        | 'compileSource'
        | 'reconciliationStatus'
        | 'referenceNumber'
        | 'taxStatus'
        | 'matchedLedgerTransactionIds'
        | 'providerTypes'
        | 'isSupersedingLedgerTransaction'
        | 'supersededLedgerTransactionIds'
      >
      & {
        party?: Maybe<Pick<
            TransactionParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'iconObjectName'
            | 'designation'
            | 'roles'
          >>,
        facilitatorParty?: Maybe<Pick<
            TransactionParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'iconObjectName'
            | 'designation'
            | 'roles'
          >>,
        product?: Maybe<Pick<
            Product,
            | 'id'
            | 'dataSourceId'
            | 'name'
            | 'providerType'
            | 'active'
            | 'institutionId'
            | 'institutionName'
          >>,
        department?: Maybe<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        splitDepartment?: Maybe<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        location?: Maybe<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        splitLocation?: Maybe<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>,
        providers: Array<Pick<Provider, 'name'>>,
        recurrence?: Maybe<Pick<
            TransactionRecurrence,
            | 'recurrenceThreadId'
            | 'interval'
            | 'intervalMultiplier'
            | 'threadIndex'
            | 'totalThreadCount'
            | 'isHidden'
            | 'firstOccurredAt'
            | 'lastOccurredAt'
          >>,
        displayInstitution?: Maybe<Pick<
            TransactionParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'iconObjectName'
            | 'designation'
            | 'roles'
          >>,
        displayCategory: (
          Pick<
            Category,
            | 'id'
            | 'name'
            | 'description'
            | 'displayKey'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'displayNumber'
            | 'active'
            | 'categoryState'
            | 'productArea'
            | 'synthesized'
          >
          & { ancestors?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>> }
        ),
        displayCategoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
        splitCategory?: Maybe<(
          Pick<
            Category,
            | 'id'
            | 'name'
            | 'description'
            | 'displayKey'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'displayNumber'
            | 'active'
            | 'categoryState'
            | 'productArea'
            | 'synthesized'
          >
          & { ancestors?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>> }
        )>,
        splitCategoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
        splitInstitution?: Maybe<Pick<
            TransactionParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'iconObjectName'
            | 'designation'
            | 'roles'
          >>,
        creditCategoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
        debitCategoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
        moneyFlow: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        runningTotal?: Maybe<(
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        )>,
        owner?: Maybe<Pick<
            EntityEmployee,
            | 'id'
            | 'organizationId'
            | 'givenName'
            | 'familyName'
            | 'avatarUrl'
          >>,
        sources: Array<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )>,
        creditSources: Array<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )>,
        debitSources: Array<(
          Pick<
            TransactionSource,
            | 'timestamp'
            | 'name'
            | 'iconUrl'
            | 'externalDisplayId'
            | 'type'
          >
          & { account?: Maybe<Pick<
              TransactionSourceAccount,
              | 'sourceAccountId'
              | 'externalName'
              | 'mask'
              | 'externalOwnerName'
              | 'externalOfficialName'
            >> }
        )>,
        invoiceLineItem?: Maybe<{ value:
            | (
              Pick<
                TransactionDiscountLineItem,
                | 'name'
                | 'description'
                | 'variablePercentage'
                | 'appliesToTransactionFactId'
              >
              & {
                fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                discount?: Maybe<(
                  Pick<
                    TransactionInvoiceLineItemDiscount,
                    | 'discountId'
                    | 'name'
                    | 'description'
                    | 'variablePercentage'
                  >
                  & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
                )>,
              }
            )
            | (
              Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
              & {
                unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                product?: Maybe<(
                  Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
                  & {
                    unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                    category?: Maybe<(
                      Pick<
                        Category,
                        | 'id'
                        | 'name'
                        | 'description'
                        | 'displayKey'
                        | 'type'
                        | 'subtype'
                        | 'parentCategoryId'
                        | 'displayNumber'
                        | 'active'
                        | 'categoryState'
                        | 'productArea'
                        | 'synthesized'
                      >
                      & { ancestors?: Maybe<Array<Pick<
                          EntityCategory,
                          | 'id'
                          | 'name'
                          | 'displayKey'
                          | 'chartOfAccountsDisplayNumber'
                          | 'type'
                          | 'subtype'
                          | 'parentCategoryId'
                          | 'productArea'
                          | 'active'
                        >>> }
                    )>,
                    department?: Maybe<(
                      { __typename: 'EntityDepartment' }
                      & Pick<
                        EntityDepartment,
                        | 'id'
                        | 'name'
                        | 'parentId'
                        | 'active'
                      >
                    )>,
                    location?: Maybe<(
                      { __typename: 'EntityLocation' }
                      & Pick<
                        EntityLocation,
                        | 'id'
                        | 'name'
                        | 'parentId'
                        | 'active'
                      >
                    )>,
                  }
                )>,
              }
            )
           }>,
        schedule?: Maybe<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
            | 'cutoverDate'
          >
          & {
            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>,
        splitSchedule?: Maybe<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
            | 'cutoverDate'
          >
          & {
            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>,
      }
    )>,
    fromAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    toAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
  }
);

export type ReportFileMetadataFieldsFragment = Pick<
    ReportFileMetadata,
    | 'id'
    | 'fileName'
    | 'mimeType'
    | 'fileSize'
    | 'source'
  >;

export type ReportGenerationHistoryFieldsFragment = Pick<
    ReportGenerationHistory,
    | 'id'
    | 'requestId'
    | 'reportId'
    | 'versionId'
    | 'legalEntityId'
    | 'authorId'
    | 'viewVersion'
    | 'kind'
    | 'timezone'
    | 'periodStartedAt'
    | 'periodEndedAt'
    | 'generationStartedAt'
    | 'generationEndedAt'
    | 'error'
    | 'createdAt'
    | 'updatedAt'
  >;

export type ReportPackageDocumentMetadataFieldsFragment = (
  Pick<
    ReportPackageDocumentMetadata,
    | 'id'
    | 'title'
    | 'documentObjectId'
    | 'documentObjectVersionId'
    | 'type'
    | 'status'
    | 'position'
  >
  & {
    reportFile?: Maybe<Pick<
        ReportFileMetadata,
        | 'id'
        | 'fileName'
        | 'mimeType'
        | 'fileSize'
        | 'source'
      >>,
    generationHistory?: Maybe<Pick<
        ReportGenerationHistory,
        | 'id'
        | 'requestId'
        | 'reportId'
        | 'versionId'
        | 'legalEntityId'
        | 'authorId'
        | 'viewVersion'
        | 'kind'
        | 'timezone'
        | 'periodStartedAt'
        | 'periodEndedAt'
        | 'generationStartedAt'
        | 'generationEndedAt'
        | 'error'
        | 'createdAt'
        | 'updatedAt'
      >>,
  }
);

export type ReportPackageMetadataFieldsFragment = (
  Pick<
    ReportPackageMetadata,
    | 'id'
    | 'versionId'
    | 'title'
    | 'status'
    | 'startedAt'
    | 'endedAt'
    | 'interval'
    | 'coverUrl'
    | 'publishedAsDraft'
    | 'createdAt'
    | 'updatedAt'
    | 'creationMethod'
  >
  & {
    viewKey: Pick<
        ViewIdentifier,
        | 'legalEntityId'
        | 'viewVersion'
        | 'mutationVersion'
        | 'viewType'
      >,
    author?: Maybe<Pick<
        Contact,
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>,
    documents: Array<(
      Pick<
        ReportPackageDocumentMetadata,
        | 'id'
        | 'title'
        | 'documentObjectId'
        | 'documentObjectVersionId'
        | 'type'
        | 'status'
        | 'position'
      >
      & {
        reportFile?: Maybe<Pick<
            ReportFileMetadata,
            | 'id'
            | 'fileName'
            | 'mimeType'
            | 'fileSize'
            | 'source'
          >>,
        generationHistory?: Maybe<Pick<
            ReportGenerationHistory,
            | 'id'
            | 'requestId'
            | 'reportId'
            | 'versionId'
            | 'legalEntityId'
            | 'authorId'
            | 'viewVersion'
            | 'kind'
            | 'timezone'
            | 'periodStartedAt'
            | 'periodEndedAt'
            | 'generationStartedAt'
            | 'generationEndedAt'
            | 'error'
            | 'createdAt'
            | 'updatedAt'
          >>,
      }
    )>,
    versions: Array<Pick<
        ReportPackageVersionMetadata,
        | 'id'
        | 'status'
        | 'createdAt'
        | 'updatedAt'
      >>,
  }
);

export type ReportPackageVersionMetadataFieldsFragment = Pick<
    ReportPackageVersionMetadata,
    | 'id'
    | 'status'
    | 'createdAt'
    | 'updatedAt'
  >;

export type RoleFieldsFragment = Pick<Role, 'id'>;

export type ScheduleEventFieldsFragment = (
  Pick<
    ScheduleEvent,
    | 'id'
    | 'displayName'
    | 'eventDate'
    | 'eventTemplateId'
    | 'isGenerated'
    | 'isInstantiating'
    | 'isTerminating'
    | 'isSingleton'
    | 'displayKey'
    | 'skipReason'
    | 'note'
    | 'createdAt'
    | 'updatedAt'
  >
  & {
    createdBy: Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >,
    updatedBy: Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >,
    variables: Array<(
      Pick<
        ScheduleEventVariable,
        | 'id'
        | 'displayName'
        | 'variableName'
        | 'variableTemplateId'
        | 'variableType'
      >
      & { value:
        | Pick<ScheduleBooleanValue, 'boolValue'>
        | { category: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            > }
        | Pick<ScheduleDateValue, 'dateValue'>
        | Pick<ScheduleFloatValue, 'floatValue'>
        | Pick<ScheduleFormulaValue, 'formulaId' | 'formulaDisplayName'>
        | Pick<ScheduleIntervalValue, 'intervalValue'>
        | Pick<ScheduleLongValue, 'longValue'>
        | { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        | { party: Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            > }
        | Pick<ScheduleStringValue, 'stringValue'>
        | Pick<ScheduleTermValue, 'intervalCount' | 'endDate'>
        | { transaction: (
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          ) }
       }
    )>,
  }
);

export type ScheduleEventTemplateFieldsFragment = (
  Pick<
    ScheduleEventTemplate,
    | 'id'
    | 'name'
    | 'description'
    | 'displayName'
    | 'ordinal'
    | 'isSingleton'
    | 'isTerminating'
    | 'isInstantiating'
    | 'inCreateFlow'
    | 'displayKey'
  >
  & { variables: Array<(
    Pick<
      ScheduleEventVariableTemplate,
      | 'id'
      | 'variableName'
      | 'displayName'
      | 'required'
      | 'ordinal'
      | 'variableType'
      | 'displayMode'
    >
    & { formulas?: Maybe<Array<Pick<ScheduleEventVariableTemplateFormula, 'id' | 'displayName'>>> }
  )> }
);

export type ScheduleEventVariableFieldsFragment = (
  Pick<
    ScheduleEventVariable,
    | 'id'
    | 'displayName'
    | 'variableName'
    | 'variableTemplateId'
    | 'variableType'
  >
  & { value:
    | Pick<ScheduleBooleanValue, 'boolValue'>
    | { category: Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        > }
    | Pick<ScheduleDateValue, 'dateValue'>
    | Pick<ScheduleFloatValue, 'floatValue'>
    | Pick<ScheduleFormulaValue, 'formulaId' | 'formulaDisplayName'>
    | Pick<ScheduleIntervalValue, 'intervalValue'>
    | Pick<ScheduleLongValue, 'longValue'>
    | { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    | { party: Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        > }
    | Pick<ScheduleStringValue, 'stringValue'>
    | Pick<ScheduleTermValue, 'intervalCount' | 'endDate'>
    | { transaction: (
        Pick<
          EntityTransaction,
          | 'viewId'
          | 'factId'
          | 'timestamp'
          | 'description'
          | 'externalId'
          | 'displayEntry'
        >
        & {
          moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          party?: Maybe<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>,
          displayCategory: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          splitCategory?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
        }
      ) }
   }
);

export type ScheduleEventVariableTemplateFieldsFragment = (
  Pick<
    ScheduleEventVariableTemplate,
    | 'id'
    | 'variableName'
    | 'displayName'
    | 'required'
    | 'ordinal'
    | 'variableType'
    | 'displayMode'
  >
  & { formulas?: Maybe<Array<Pick<ScheduleEventVariableTemplateFormula, 'id' | 'displayName'>>> }
);

export type ScheduleEventVariableTemplateFormulaFieldsFragment = Pick<ScheduleEventVariableTemplateFormula, 'id' | 'displayName'>;

export type ScheduleFieldsFragment = (
  Pick<
    Schedule,
    | 'id'
    | 'name'
    | 'description'
    | 'scheduleNumber'
    | 'scheduleTemplateId'
    | 'specializationId'
    | 'scheduleType'
    | 'createdAt'
    | 'updatedAt'
    | 'cutoverDate'
  >
  & {
    sourceTransaction?: Maybe<(
      Pick<
        EntityTransaction,
        | 'viewId'
        | 'factId'
        | 'timestamp'
        | 'description'
        | 'externalId'
        | 'displayEntry'
      >
      & {
        moneyFlow: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        party?: Maybe<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>,
        displayCategory: Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >,
        splitCategory?: Maybe<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>,
      }
    )>,
    party?: Maybe<Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >>,
    createdBy: Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >,
    updatedBy: Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >,
    events: Array<(
      Pick<
        ScheduleEvent,
        | 'id'
        | 'displayName'
        | 'eventDate'
        | 'eventTemplateId'
        | 'isGenerated'
        | 'isInstantiating'
        | 'isTerminating'
        | 'isSingleton'
        | 'displayKey'
        | 'skipReason'
        | 'note'
        | 'createdAt'
        | 'updatedAt'
      >
      & {
        createdBy: Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >,
        updatedBy: Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >,
        variables: Array<(
          Pick<
            ScheduleEventVariable,
            | 'id'
            | 'displayName'
            | 'variableName'
            | 'variableTemplateId'
            | 'variableType'
          >
          & { value:
            | Pick<ScheduleBooleanValue, 'boolValue'>
            | { category: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                > }
            | Pick<ScheduleDateValue, 'dateValue'>
            | Pick<ScheduleFloatValue, 'floatValue'>
            | Pick<ScheduleFormulaValue, 'formulaId' | 'formulaDisplayName'>
            | Pick<ScheduleIntervalValue, 'intervalValue'>
            | Pick<ScheduleLongValue, 'longValue'>
            | { monetaryValue: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            | { party: Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                > }
            | Pick<ScheduleStringValue, 'stringValue'>
            | Pick<ScheduleTermValue, 'intervalCount' | 'endDate'>
            | { transaction: (
                Pick<
                  EntityTransaction,
                  | 'viewId'
                  | 'factId'
                  | 'timestamp'
                  | 'description'
                  | 'externalId'
                  | 'displayEntry'
                >
                & {
                  moneyFlow: (
                    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
                  ),
                  party?: Maybe<Pick<
                      EntityParty,
                      | 'id'
                      | 'name'
                      | 'iconUrl'
                      | 'shortDescription'
                      | 'roles'
                      | 'designation'
                    >>,
                  displayCategory: Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >,
                  splitCategory?: Maybe<Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >>,
                }
              ) }
           }
        )>,
      }
    )>,
    cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
  }
);

export type ScheduleSnapshotFieldsFragment = (
  Pick<
    ScheduleSnapshot,
    | 'id'
    | 'name'
    | 'scheduleNumber'
    | 'scheduleType'
    | 'startDate'
    | 'endDate'
    | 'cutoverDate'
  >
  & {
    category?: Maybe<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>,
    relatedCategory?: Maybe<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>,
    party?: Maybe<Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >>,
    amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    remainingAmount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
  }
);

export type ScheduleTemplateFieldsFragment = Pick<
    ScheduleTemplate,
    | 'id'
    | 'name'
    | 'description'
    | 'scheduleType'
    | 'displayKey'
  >;

export type SourceAccountFieldsFragment = Pick<
    SourceAccount,
    | 'id'
    | 'externalId'
    | 'externalName'
    | 'externalOwnerName'
    | 'externalOfficialName'
    | 'externalType'
    | 'externalSubtype'
    | 'mask'
    | 'status'
    | 'ownerEmployeeId'
  >;

export type SummaryTotalFieldsFragment = (
  Pick<SummaryTotal, 'count'>
  & { total: (
    Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
    & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
  ) }
);

export type ThreadDetailsFieldsFragment = (
  Pick<
    ThreadDetails,
    | 'id'
    | 'commentCount'
    | 'resolvedAt'
    | 'authorId'
    | 'commenterIds'
    | 'context'
    | 'pending'
  >
  & {
    targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
    tags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
  }
);

export type ThreadFieldsFragment = (
  { __typename: 'Thread' }
  & Pick<Thread, 'id'>
  & {
    details: (
      Pick<
        ThreadDetails,
        | 'id'
        | 'commentCount'
        | 'resolvedAt'
        | 'authorId'
        | 'commenterIds'
        | 'context'
        | 'pending'
      >
      & {
        targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
        tags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
      }
    ),
    comments: Array<(
      { __typename: 'Comment' }
      & Pick<
        Comment,
        | 'id'
        | 'authorId'
        | 'text'
        | 'timestamp'
        | 'editedAt'
        | 'deletedAt'
        | 'reactions'
      >
      & { layoutAttachment?: Maybe<Pick<LayoutAttachment, 'layoutId' | 'legalEntityId'>> }
    )>,
  }
);

export type ThreadListFieldsFragment = {
    targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
    threads: Array<(
      Pick<
        ThreadDetails,
        | 'id'
        | 'commentCount'
        | 'resolvedAt'
        | 'authorId'
        | 'commenterIds'
        | 'context'
        | 'pending'
      >
      & {
        targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
        tags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
      }
    )>,
  };

export type ThreadWithEntitiesFieldsFragment = (
  { __typename: 'ThreadWithEntities' }
  & {
    thread: (
      { __typename: 'Thread' }
      & Pick<Thread, 'id'>
      & {
        details: (
          Pick<
            ThreadDetails,
            | 'id'
            | 'commentCount'
            | 'resolvedAt'
            | 'authorId'
            | 'commenterIds'
            | 'context'
            | 'pending'
          >
          & {
            targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
            tags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
          }
        ),
        comments: Array<(
          { __typename: 'Comment' }
          & Pick<
            Comment,
            | 'id'
            | 'authorId'
            | 'text'
            | 'timestamp'
            | 'editedAt'
            | 'deletedAt'
            | 'reactions'
          >
          & { layoutAttachment?: Maybe<Pick<LayoutAttachment, 'layoutId' | 'legalEntityId'>> }
        )>,
      }
    ),
    entities?: Maybe<(
      { __typename: 'ObjectEntities' }
      & {
        users?: Maybe<Array<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>>,
        transactions?: Maybe<Array<(
          Pick<
            EntityTransaction,
            | 'viewId'
            | 'factId'
            | 'timestamp'
            | 'description'
            | 'externalId'
            | 'displayEntry'
          >
          & {
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            party?: Maybe<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
            displayCategory: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            splitCategory?: Maybe<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>,
          }
        )>>,
        comments?: Maybe<Array<Pick<
            EntityComment,
            | 'id'
            | 'authorId'
            | 'text'
            | 'timestamp'
          >>>,
        reports?: Maybe<Array<(
          Pick<
            EntityReport,
            | 'id'
            | 'title'
            | 'authorId'
            | 'mimeType'
            | 'createdAt'
          >
          & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
        )>>,
        reportPackages?: Maybe<Array<(
          Pick<
            EntityReportPackage,
            | 'id'
            | 'title'
            | 'authorId'
            | 'interval'
            | 'periodStartedAt'
            | 'periodEndedAt'
            | 'createdAt'
            | 'updatedAt'
            | 'coverUrl'
          >
          & { documents: Array<Pick<
              SharedReportDocumentMetadata,
              | 'id'
              | 'documentObjectId'
              | 'documentObjectVersionId'
              | 'title'
              | 'mimeType'
            >> }
        )>>,
        parties?: Maybe<Array<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>>,
        datasources?: Maybe<Array<Pick<
            EntityDataSource,
            | 'id'
            | 'name'
            | 'url'
            | 'iconUrl'
          >>>,
        categories?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>>,
        threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
        legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
        workItems?: Maybe<Array<(
          Pick<
            EntityWorkItem,
            | 'id'
            | 'time'
            | 'workItemState'
            | 'workItemType'
            | 'reviewCreatedById'
            | 'reviewState'
            | 'ledgerType'
          >
          & { objectTransaction: (
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          ) }
        )>>,
        invoices?: Maybe<Array<(
          Pick<
            EntityInvoice,
            | 'id'
            | 'externalDisplayId'
            | 'createdAt'
            | 'dueAt'
          >
          & {
            amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            customer: (
              Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
              & { party: Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                > }
            ),
          }
        )>>,
        bills?: Maybe<Array<(
          Pick<
            EntityBill,
            | 'id'
            | 'billStatus'
            | 'vendorName'
            | 'billDescription'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
            format: (
              Pick<Format, 'id' | 'formatClass'>
              & { segments: Array<Pick<
                  Segment,
                  | 'collectionId'
                  | 'fileId'
                  | 'sequence'
                  | 'token'
                >> }
            ),
            approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
          }
        )>>,
        identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
        departments?: Maybe<Array<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        locations?: Maybe<Array<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        reconciliations?: Maybe<Array<(
          { __typename: 'EntityReconciliation' }
          & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
          & {
            startDate: Pick<Date, 'year' | 'month' | 'day'>,
            endDate: Pick<Date, 'year' | 'month' | 'day'>,
          }
        )>>,
        ledgerTransactions?: Maybe<Array<(
          Pick<
            EntityLedgerTransaction,
            | 'id'
            | 'timestamp'
            | 'factIds'
            | 'name'
            | 'referenceNumber'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            parties: Array<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
          }
        )>>,
        schedules?: Maybe<Array<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
            | 'cutoverDate'
          >
          & {
            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>>,
      }
    )>,
  }
);

export type ThreadsFieldsFragment = {
    threads: Array<{
        targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
        threads: Array<(
          Pick<
            ThreadDetails,
            | 'id'
            | 'commentCount'
            | 'resolvedAt'
            | 'authorId'
            | 'commenterIds'
            | 'context'
            | 'pending'
          >
          & {
            targetObject: Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>,
            tags: Array<Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>>,
          }
        )>,
      }>,
    entities?: Maybe<(
      { __typename: 'ObjectEntities' }
      & {
        users?: Maybe<Array<Pick<
            EntityUser,
            | 'id'
            | 'givenName'
            | 'familyName'
            | 'emailAddress'
            | 'avatarUrl'
          >>>,
        transactions?: Maybe<Array<(
          Pick<
            EntityTransaction,
            | 'viewId'
            | 'factId'
            | 'timestamp'
            | 'description'
            | 'externalId'
            | 'displayEntry'
          >
          & {
            moneyFlow: (
              Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
              & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
            ),
            party?: Maybe<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
            displayCategory: Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >,
            splitCategory?: Maybe<Pick<
                EntityCategory,
                | 'id'
                | 'name'
                | 'displayKey'
                | 'chartOfAccountsDisplayNumber'
                | 'type'
                | 'subtype'
                | 'parentCategoryId'
                | 'productArea'
                | 'active'
              >>,
          }
        )>>,
        comments?: Maybe<Array<Pick<
            EntityComment,
            | 'id'
            | 'authorId'
            | 'text'
            | 'timestamp'
          >>>,
        reports?: Maybe<Array<(
          Pick<
            EntityReport,
            | 'id'
            | 'title'
            | 'authorId'
            | 'mimeType'
            | 'createdAt'
          >
          & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
        )>>,
        reportPackages?: Maybe<Array<(
          Pick<
            EntityReportPackage,
            | 'id'
            | 'title'
            | 'authorId'
            | 'interval'
            | 'periodStartedAt'
            | 'periodEndedAt'
            | 'createdAt'
            | 'updatedAt'
            | 'coverUrl'
          >
          & { documents: Array<Pick<
              SharedReportDocumentMetadata,
              | 'id'
              | 'documentObjectId'
              | 'documentObjectVersionId'
              | 'title'
              | 'mimeType'
            >> }
        )>>,
        parties?: Maybe<Array<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>>,
        datasources?: Maybe<Array<Pick<
            EntityDataSource,
            | 'id'
            | 'name'
            | 'url'
            | 'iconUrl'
          >>>,
        categories?: Maybe<Array<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>>,
        threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
        legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
        workItems?: Maybe<Array<(
          Pick<
            EntityWorkItem,
            | 'id'
            | 'time'
            | 'workItemState'
            | 'workItemType'
            | 'reviewCreatedById'
            | 'reviewState'
            | 'ledgerType'
          >
          & { objectTransaction: (
            Pick<
              EntityTransaction,
              | 'viewId'
              | 'factId'
              | 'timestamp'
              | 'description'
              | 'externalId'
              | 'displayEntry'
            >
            & {
              moneyFlow: (
                Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
                & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
              ),
              party?: Maybe<Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                >>,
              displayCategory: Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >,
              splitCategory?: Maybe<Pick<
                  EntityCategory,
                  | 'id'
                  | 'name'
                  | 'displayKey'
                  | 'chartOfAccountsDisplayNumber'
                  | 'type'
                  | 'subtype'
                  | 'parentCategoryId'
                  | 'productArea'
                  | 'active'
                >>,
            }
          ) }
        )>>,
        invoices?: Maybe<Array<(
          Pick<
            EntityInvoice,
            | 'id'
            | 'externalDisplayId'
            | 'createdAt'
            | 'dueAt'
          >
          & {
            amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            customer: (
              Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
              & { party: Pick<
                  EntityParty,
                  | 'id'
                  | 'name'
                  | 'iconUrl'
                  | 'shortDescription'
                  | 'roles'
                  | 'designation'
                > }
            ),
          }
        )>>,
        bills?: Maybe<Array<(
          Pick<
            EntityBill,
            | 'id'
            | 'billStatus'
            | 'vendorName'
            | 'billDescription'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
            format: (
              Pick<Format, 'id' | 'formatClass'>
              & { segments: Array<Pick<
                  Segment,
                  | 'collectionId'
                  | 'fileId'
                  | 'sequence'
                  | 'token'
                >> }
            ),
            approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
          }
        )>>,
        identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
        departments?: Maybe<Array<(
          { __typename: 'EntityDepartment' }
          & Pick<
            EntityDepartment,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        locations?: Maybe<Array<(
          { __typename: 'EntityLocation' }
          & Pick<
            EntityLocation,
            | 'id'
            | 'name'
            | 'parentId'
            | 'active'
          >
        )>>,
        reconciliations?: Maybe<Array<(
          { __typename: 'EntityReconciliation' }
          & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
          & {
            startDate: Pick<Date, 'year' | 'month' | 'day'>,
            endDate: Pick<Date, 'year' | 'month' | 'day'>,
          }
        )>>,
        ledgerTransactions?: Maybe<Array<(
          Pick<
            EntityLedgerTransaction,
            | 'id'
            | 'timestamp'
            | 'factIds'
            | 'name'
            | 'referenceNumber'
          >
          & {
            totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
            parties: Array<Pick<
                EntityParty,
                | 'id'
                | 'name'
                | 'iconUrl'
                | 'shortDescription'
                | 'roles'
                | 'designation'
              >>,
          }
        )>>,
        schedules?: Maybe<Array<(
          { __typename: 'EntitySchedule' }
          & Pick<
            EntitySchedule,
            | 'id'
            | 'name'
            | 'scheduleNumber'
            | 'scheduleType'
            | 'scheduleTemplateId'
            | 'categoryId'
            | 'relatedCategoryId'
            | 'partyId'
            | 'startDate'
            | 'endDate'
            | 'cutoverDate'
          >
          & {
            amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
          }
        )>>,
      }
    )>,
  };

export type TransactionFieldsFragment = (
  Pick<
    Transaction,
    | 'viewId'
    | 'factId'
    | 'ledgerTransactionId'
    | 'supersededFactIds'
    | 'timestamp'
    | 'recordType'
    | 'name'
    | 'description'
    | 'digitsTransactionType'
    | 'partySource'
    | 'displayEntry'
    | 'displayCategorySource'
    | 'displayCanonicalCategoryName'
    | 'displayUncategorizedReason'
    | 'displayProductArea'
    | 'ownerSource'
    | 'transactionClassificationType'
    | 'compileSource'
    | 'reconciliationStatus'
    | 'referenceNumber'
    | 'taxStatus'
    | 'matchedLedgerTransactionIds'
    | 'providerTypes'
    | 'isSupersedingLedgerTransaction'
    | 'supersededLedgerTransactionIds'
  >
  & {
    party?: Maybe<Pick<
        TransactionParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'iconObjectName'
        | 'designation'
        | 'roles'
      >>,
    facilitatorParty?: Maybe<Pick<
        TransactionParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'iconObjectName'
        | 'designation'
        | 'roles'
      >>,
    product?: Maybe<Pick<
        Product,
        | 'id'
        | 'dataSourceId'
        | 'name'
        | 'providerType'
        | 'active'
        | 'institutionId'
        | 'institutionName'
      >>,
    department?: Maybe<(
      { __typename: 'EntityDepartment' }
      & Pick<
        EntityDepartment,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    splitDepartment?: Maybe<(
      { __typename: 'EntityDepartment' }
      & Pick<
        EntityDepartment,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    location?: Maybe<(
      { __typename: 'EntityLocation' }
      & Pick<
        EntityLocation,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    splitLocation?: Maybe<(
      { __typename: 'EntityLocation' }
      & Pick<
        EntityLocation,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    providers: Array<Pick<Provider, 'name'>>,
    recurrence?: Maybe<Pick<
        TransactionRecurrence,
        | 'recurrenceThreadId'
        | 'interval'
        | 'intervalMultiplier'
        | 'threadIndex'
        | 'totalThreadCount'
        | 'isHidden'
        | 'firstOccurredAt'
        | 'lastOccurredAt'
      >>,
    displayInstitution?: Maybe<Pick<
        TransactionParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'iconObjectName'
        | 'designation'
        | 'roles'
      >>,
    displayCategory: (
      Pick<
        Category,
        | 'id'
        | 'name'
        | 'description'
        | 'displayKey'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'displayNumber'
        | 'active'
        | 'categoryState'
        | 'productArea'
        | 'synthesized'
      >
      & { ancestors?: Maybe<Array<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>> }
    ),
    displayCategoryClassificationProvenance?: Maybe<(
      Pick<
        ClassificationProvenance,
        | 'type'
        | 'changedAt'
        | 'confidenceLevel'
        | 'settingsName'
      >
      & { source?: Maybe<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )> }
    )>,
    splitCategory?: Maybe<(
      Pick<
        Category,
        | 'id'
        | 'name'
        | 'description'
        | 'displayKey'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'displayNumber'
        | 'active'
        | 'categoryState'
        | 'productArea'
        | 'synthesized'
      >
      & { ancestors?: Maybe<Array<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>> }
    )>,
    splitCategoryClassificationProvenance?: Maybe<(
      Pick<
        ClassificationProvenance,
        | 'type'
        | 'changedAt'
        | 'confidenceLevel'
        | 'settingsName'
      >
      & { source?: Maybe<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )> }
    )>,
    splitInstitution?: Maybe<Pick<
        TransactionParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'iconObjectName'
        | 'designation'
        | 'roles'
      >>,
    creditCategoryClassificationProvenance?: Maybe<(
      Pick<
        ClassificationProvenance,
        | 'type'
        | 'changedAt'
        | 'confidenceLevel'
        | 'settingsName'
      >
      & { source?: Maybe<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )> }
    )>,
    debitCategoryClassificationProvenance?: Maybe<(
      Pick<
        ClassificationProvenance,
        | 'type'
        | 'changedAt'
        | 'confidenceLevel'
        | 'settingsName'
      >
      & { source?: Maybe<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )> }
    )>,
    moneyFlow: (
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    ),
    runningTotal?: Maybe<(
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    )>,
    owner?: Maybe<Pick<
        EntityEmployee,
        | 'id'
        | 'organizationId'
        | 'givenName'
        | 'familyName'
        | 'avatarUrl'
      >>,
    sources: Array<(
      Pick<
        TransactionSource,
        | 'timestamp'
        | 'name'
        | 'iconUrl'
        | 'externalDisplayId'
        | 'type'
      >
      & { account?: Maybe<Pick<
          TransactionSourceAccount,
          | 'sourceAccountId'
          | 'externalName'
          | 'mask'
          | 'externalOwnerName'
          | 'externalOfficialName'
        >> }
    )>,
    creditSources: Array<(
      Pick<
        TransactionSource,
        | 'timestamp'
        | 'name'
        | 'iconUrl'
        | 'externalDisplayId'
        | 'type'
      >
      & { account?: Maybe<Pick<
          TransactionSourceAccount,
          | 'sourceAccountId'
          | 'externalName'
          | 'mask'
          | 'externalOwnerName'
          | 'externalOfficialName'
        >> }
    )>,
    debitSources: Array<(
      Pick<
        TransactionSource,
        | 'timestamp'
        | 'name'
        | 'iconUrl'
        | 'externalDisplayId'
        | 'type'
      >
      & { account?: Maybe<Pick<
          TransactionSourceAccount,
          | 'sourceAccountId'
          | 'externalName'
          | 'mask'
          | 'externalOwnerName'
          | 'externalOfficialName'
        >> }
    )>,
    invoiceLineItem?: Maybe<{ value:
        | (
          Pick<
            TransactionDiscountLineItem,
            | 'name'
            | 'description'
            | 'variablePercentage'
            | 'appliesToTransactionFactId'
          >
          & {
            fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            discount?: Maybe<(
              Pick<
                TransactionInvoiceLineItemDiscount,
                | 'discountId'
                | 'name'
                | 'description'
                | 'variablePercentage'
              >
              & { fixedAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>> }
            )>,
          }
        )
        | (
          Pick<TransactionProductLineItem, 'name' | 'description' | 'quantity'>
          & {
            unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
            product?: Maybe<(
              Pick<TransactionInvoiceLineItemProduct, 'productId' | 'name' | 'description'>
              & {
                unitPrice?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
                category?: Maybe<(
                  Pick<
                    Category,
                    | 'id'
                    | 'name'
                    | 'description'
                    | 'displayKey'
                    | 'type'
                    | 'subtype'
                    | 'parentCategoryId'
                    | 'displayNumber'
                    | 'active'
                    | 'categoryState'
                    | 'productArea'
                    | 'synthesized'
                  >
                  & { ancestors?: Maybe<Array<Pick<
                      EntityCategory,
                      | 'id'
                      | 'name'
                      | 'displayKey'
                      | 'chartOfAccountsDisplayNumber'
                      | 'type'
                      | 'subtype'
                      | 'parentCategoryId'
                      | 'productArea'
                      | 'active'
                    >>> }
                )>,
                department?: Maybe<(
                  { __typename: 'EntityDepartment' }
                  & Pick<
                    EntityDepartment,
                    | 'id'
                    | 'name'
                    | 'parentId'
                    | 'active'
                  >
                )>,
                location?: Maybe<(
                  { __typename: 'EntityLocation' }
                  & Pick<
                    EntityLocation,
                    | 'id'
                    | 'name'
                    | 'parentId'
                    | 'active'
                  >
                )>,
              }
            )>,
          }
        )
       }>,
    schedule?: Maybe<(
      { __typename: 'EntitySchedule' }
      & Pick<
        EntitySchedule,
        | 'id'
        | 'name'
        | 'scheduleNumber'
        | 'scheduleType'
        | 'scheduleTemplateId'
        | 'categoryId'
        | 'relatedCategoryId'
        | 'partyId'
        | 'startDate'
        | 'endDate'
        | 'cutoverDate'
      >
      & {
        amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
      }
    )>,
    splitSchedule?: Maybe<(
      { __typename: 'EntitySchedule' }
      & Pick<
        EntitySchedule,
        | 'id'
        | 'name'
        | 'scheduleNumber'
        | 'scheduleType'
        | 'scheduleTemplateId'
        | 'categoryId'
        | 'relatedCategoryId'
        | 'partyId'
        | 'startDate'
        | 'endDate'
        | 'cutoverDate'
      >
      & {
        amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
      }
    )>,
  }
);

export type TransactionLineFieldsFragment = (
  Pick<TransactionLine, 'entryType'>
  & {
    entry: (
      Pick<TransactionEntry, 'factId' | 'externalLineId' | 'description'>
      & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    ),
    category: Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >,
    categoryClassificationProvenance?: Maybe<(
      Pick<
        ClassificationProvenance,
        | 'type'
        | 'changedAt'
        | 'confidenceLevel'
        | 'settingsName'
      >
      & { source?: Maybe<(
        Pick<
          TransactionSource,
          | 'timestamp'
          | 'name'
          | 'iconUrl'
          | 'externalDisplayId'
          | 'type'
        >
        & { account?: Maybe<Pick<
            TransactionSourceAccount,
            | 'sourceAccountId'
            | 'externalName'
            | 'mask'
            | 'externalOwnerName'
            | 'externalOfficialName'
          >> }
      )> }
    )>,
    party?: Maybe<Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >>,
    department?: Maybe<(
      { __typename: 'EntityDepartment' }
      & Pick<
        EntityDepartment,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    location?: Maybe<(
      { __typename: 'EntityLocation' }
      & Pick<
        EntityLocation,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>,
    schedule?: Maybe<(
      { __typename: 'EntitySchedule' }
      & Pick<
        EntitySchedule,
        | 'id'
        | 'name'
        | 'scheduleNumber'
        | 'scheduleType'
        | 'scheduleTemplateId'
        | 'categoryId'
        | 'relatedCategoryId'
        | 'partyId'
        | 'startDate'
        | 'endDate'
        | 'cutoverDate'
      >
      & {
        amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
      }
    )>,
  }
);

export type TransactionEntryFieldsFragment = (
  Pick<TransactionEntry, 'factId' | 'externalLineId' | 'description'>
  & { amount: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
);

export type TransactionPartyFieldsFragment = Pick<
    TransactionParty,
    | 'id'
    | 'name'
    | 'iconUrl'
    | 'iconObjectName'
    | 'designation'
    | 'roles'
  >;

export type TransactionSourceFieldsFragment = (
  Pick<
    TransactionSource,
    | 'timestamp'
    | 'name'
    | 'iconUrl'
    | 'externalDisplayId'
    | 'type'
  >
  & { account?: Maybe<Pick<
      TransactionSourceAccount,
      | 'sourceAccountId'
      | 'externalName'
      | 'mask'
      | 'externalOwnerName'
      | 'externalOfficialName'
    >> }
);

export type TransactionSummaryFieldsFragment = (
  Pick<TransactionSummary, 'isPeriodBookClosed'>
  & {
    period: Pick<
        Period,
        | 'name'
        | 'interval'
        | 'startedAt'
        | 'endedAt'
      >,
    total: (
      Pick<
        PeriodMonetaryValue,
        | 'transactionsCount'
        | 'deltaPrevious'
        | 'deltaYearAgo'
        | 'isFirstOccurrencePeriod'
      >
      & {
        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        moneyFlow?: Maybe<(
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        )>,
        current?: Maybe<(
          Pick<SummaryTotal, 'count'>
          & { total: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ) }
        )>,
        prior?: Maybe<(
          Pick<SummaryTotal, 'count'>
          & { total: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ) }
        )>,
      }
    ),
  }
);

export type TransactionViewDetailFieldsFragment = (
  Pick<
    TransactionViewDetail,
    | 'id'
    | 'factId'
    | 'occurredAt'
    | 'externalCreatedAt'
    | 'externalId'
    | 'externalDisplayId'
    | 'quickbooksAppName'
    | 'name'
    | 'description'
    | 'recordType'
  >
  & {
    creditAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    debitAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    creditCategoryHierarchy: Array<(
      Pick<
        Category,
        | 'id'
        | 'name'
        | 'description'
        | 'displayKey'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'displayNumber'
        | 'active'
        | 'categoryState'
        | 'productArea'
        | 'synthesized'
      >
      & { ancestors?: Maybe<Array<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>> }
    )>,
    debitCategoryHierarchy: Array<(
      Pick<
        Category,
        | 'id'
        | 'name'
        | 'description'
        | 'displayKey'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'displayNumber'
        | 'active'
        | 'categoryState'
        | 'productArea'
        | 'synthesized'
      >
      & { ancestors?: Maybe<Array<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>> }
    )>,
    entryLines: Array<(
      Pick<
        TransactionEntryLine,
        | 'lineId'
        | 'factId'
        | 'name'
        | 'description'
        | 'isCredit'
        | 'highlighted'
      >
      & {
        value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        category: (
          Pick<
            Category,
            | 'id'
            | 'name'
            | 'description'
            | 'displayKey'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'displayNumber'
            | 'active'
            | 'categoryState'
            | 'productArea'
            | 'synthesized'
          >
          & { ancestors?: Maybe<Array<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>> }
        ),
        categoryClassificationProvenance?: Maybe<(
          Pick<
            ClassificationProvenance,
            | 'type'
            | 'changedAt'
            | 'confidenceLevel'
            | 'settingsName'
          >
          & { source?: Maybe<(
            Pick<
              TransactionSource,
              | 'timestamp'
              | 'name'
              | 'iconUrl'
              | 'externalDisplayId'
              | 'type'
            >
            & { account?: Maybe<Pick<
                TransactionSourceAccount,
                | 'sourceAccountId'
                | 'externalName'
                | 'mask'
                | 'externalOwnerName'
                | 'externalOfficialName'
              >> }
          )> }
        )>,
      }
    )>,
    party?: Maybe<Pick<
        TransactionParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'iconObjectName'
        | 'designation'
        | 'roles'
      >>,
    institution: Pick<
        Institution,
        | 'id'
        | 'name'
        | 'url'
        | 'routingNumber'
        | 'iconUrl'
        | 'partyId'
        | 'createdAt'
      >,
    sourceAccount?: Maybe<Pick<
        SourceAccount,
        | 'id'
        | 'externalId'
        | 'externalName'
        | 'externalOwnerName'
        | 'externalOfficialName'
        | 'externalType'
        | 'externalSubtype'
        | 'mask'
        | 'status'
        | 'ownerEmployeeId'
      >>,
  }
);

export type UserFieldsFragment = (
  Pick<
    User,
    | 'id'
    | 'givenName'
    | 'familyName'
    | 'primaryEmailAddress'
    | 'passwordSet'
    | 'avatarUrl'
    | 'createdAt'
    | 'lastActivityAt'
  >
  & {
    employments?: Maybe<Array<(
      Pick<OrganizationEmployment, 'employeeId'>
      & {
        role: Pick<Role, 'id'>,
        organization: Pick<
            Organization,
            | 'id'
            | 'slug'
            | 'name'
            | 'iconUrl'
            | 'websiteUrl'
            | 'kind'
          >,
        legalEntityRoles?: Maybe<Array<(
          Pick<EmployeeLegalEntityRole, 'legalEntityId'>
          & { role?: Maybe<Pick<Role, 'id'>> }
        )>>,
      }
    )>>,
    identities?: Maybe<Array<Pick<Identity, 'identifier' | 'provider' | 'domain'>>>,
  }
);

export type UserInfoFieldsFragment = Pick<UserInfo, 'givenName' | 'familyName' | 'emailAddress'>;

export type ViewIdentifierFieldsFragment = Pick<
    ViewIdentifier,
    | 'legalEntityId'
    | 'viewVersion'
    | 'mutationVersion'
    | 'viewType'
  >;

export type WorkItemFieldsFragment = (
  Pick<
    WorkItem,
    | 'legalEntityId'
    | 'workItemId'
    | 'time'
    | 'itemType'
    | 'itemState'
    | 'ledgerType'
    | 'createdAt'
    | 'updatedBy'
    | 'updatedAt'
    | 'actionable'
    | 'reviewState'
  >
  & {
    transactions: Array<(
      Pick<
        WorkItemTransaction,
        | 'externalTransactionId'
        | 'externalTransactionLineId'
        | 'supportType'
        | 'displayPartyRole'
        | 'displayEntry'
        | 'description'
        | 'name'
        | 'occurredAt'
        | 'dataSourceId'
        | 'quickbooksAppName'
        | 'ledgerTransactionId'
      >
      & {
        displayCategory?: Maybe<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>,
        splitCategory?: Maybe<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>,
        party?: Maybe<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>,
        creditValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        debitValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        displayValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        moneyFlow?: Maybe<(
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        )>,
      }
    )>,
    review?: Maybe<(
      Pick<WorkItemReview, 'createdAt' | 'updatedAt' | 'subject'>
      & { creator: Pick<
          EntityUser,
          | 'id'
          | 'givenName'
          | 'familyName'
          | 'emailAddress'
          | 'avatarUrl'
        > }
    )>,
    generatedQuestions: Array<Pick<WorkItemGeneratedQuestion, 'question' | 'contextType' | 'active'>>,
    pushes: Array<Pick<
        WorkItemPush,
        | 'field'
        | 'pushState'
        | 'errorType'
        | 'updatedAt'
      >>,
  }
);

export type WorkItemGeneratedQuestionFieldsFragment = Pick<WorkItemGeneratedQuestion, 'question' | 'contextType' | 'active'>;

export type WorkItemPushFieldsFragment = Pick<
    WorkItemPush,
    | 'field'
    | 'pushState'
    | 'errorType'
    | 'updatedAt'
  >;

export type WorkItemReviewFieldsFragment = (
  Pick<WorkItemReview, 'createdAt' | 'updatedAt' | 'subject'>
  & { creator: Pick<
      EntityUser,
      | 'id'
      | 'givenName'
      | 'familyName'
      | 'emailAddress'
      | 'avatarUrl'
    > }
);

export type WorkItemSummaryFieldsFragment = (
  Pick<WorkItemSummary, 'count'>
  & { period: Pick<
      Period,
      | 'name'
      | 'interval'
      | 'startedAt'
      | 'endedAt'
    > }
);

export type WorkItemTransactionFieldsFragment = (
  Pick<
    WorkItemTransaction,
    | 'externalTransactionId'
    | 'externalTransactionLineId'
    | 'supportType'
    | 'displayPartyRole'
    | 'displayEntry'
    | 'description'
    | 'name'
    | 'occurredAt'
    | 'dataSourceId'
    | 'quickbooksAppName'
    | 'ledgerTransactionId'
  >
  & {
    displayCategory?: Maybe<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>,
    splitCategory?: Maybe<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>,
    party?: Maybe<Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >>,
    creditValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    debitValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    displayValue?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    moneyFlow?: Maybe<(
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    )>,
  }
);

export type ActivityObjectIdentifierFieldsFragment = Pick<ActivityObjectIdentifier, 'kind' | 'id' | 'context'>;

export type BillAccessFieldsFragment = Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>;

export type EntityBillFieldsFragment = (
  Pick<
    EntityBill,
    | 'id'
    | 'billStatus'
    | 'vendorName'
    | 'billDescription'
  >
  & {
    totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
    format: (
      Pick<Format, 'id' | 'formatClass'>
      & { segments: Array<Pick<
          Segment,
          | 'collectionId'
          | 'fileId'
          | 'sequence'
          | 'token'
        >> }
    ),
    approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
  }
);

export type EntityCategoryFieldsFragment = Pick<
    EntityCategory,
    | 'id'
    | 'name'
    | 'displayKey'
    | 'chartOfAccountsDisplayNumber'
    | 'type'
    | 'subtype'
    | 'parentCategoryId'
    | 'productArea'
    | 'active'
  >;

export type EntityCommentFieldsFragment = Pick<
    EntityComment,
    | 'id'
    | 'authorId'
    | 'text'
    | 'timestamp'
  >;

export type EntityConnectionFieldsFragment = Pick<EntityConnection, 'id' | 'connectorId' | 'dataSourceId'>;

export type EntityDataSourceFieldsFragment = Pick<
    EntityDataSource,
    | 'id'
    | 'name'
    | 'url'
    | 'iconUrl'
  >;

export type EntityDepartmentFieldsFragment = (
  { __typename: 'EntityDepartment' }
  & Pick<
    EntityDepartment,
    | 'id'
    | 'name'
    | 'parentId'
    | 'active'
  >
);

export type EntityEmployeeFieldsFragment = Pick<
    EntityEmployee,
    | 'id'
    | 'organizationId'
    | 'givenName'
    | 'familyName'
    | 'avatarUrl'
  >;

export type EntityIdentityVerificationFieldsFragment = Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>;

export type EntityInstitutionFieldsFragment = Pick<EntityInstitution, 'id' | 'name' | 'iconUrl'>;

export type EntityInvoiceCustomerFieldsFragment = (
  Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
  & { party: Pick<
      EntityParty,
      | 'id'
      | 'name'
      | 'iconUrl'
      | 'shortDescription'
      | 'roles'
      | 'designation'
    > }
);

export type EntityInvoiceFieldsFragment = (
  Pick<
    EntityInvoice,
    | 'id'
    | 'externalDisplayId'
    | 'createdAt'
    | 'dueAt'
  >
  & {
    amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    customer: (
      Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
      & { party: Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        > }
    ),
  }
);

export type EntityLedgerTransactionFieldsFragment = (
  Pick<
    EntityLedgerTransaction,
    | 'id'
    | 'timestamp'
    | 'factIds'
    | 'name'
    | 'referenceNumber'
  >
  & {
    totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
    parties: Array<Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >>,
  }
);

export type EntityLegalEntityFieldsFragment = Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>;

export type EntityLocationFieldsFragment = (
  { __typename: 'EntityLocation' }
  & Pick<
    EntityLocation,
    | 'id'
    | 'name'
    | 'parentId'
    | 'active'
  >
);

export type EntityMonetaryValueFieldsFragment = Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>;

export type EntityOrganizationFieldsFragment = Pick<
    EntityOrganization,
    | 'id'
    | 'name'
    | 'slug'
    | 'iconUrl'
  >;

export type EntityPartyFieldsFragment = Pick<
    EntityParty,
    | 'id'
    | 'name'
    | 'iconUrl'
    | 'shortDescription'
    | 'roles'
    | 'designation'
  >;

export type EntityReconciliationFieldsFragment = (
  { __typename: 'EntityReconciliation' }
  & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
  & {
    startDate: Pick<Date, 'year' | 'month' | 'day'>,
    endDate: Pick<Date, 'year' | 'month' | 'day'>,
  }
);

export type EntityReportFieldsFragment = (
  Pick<
    EntityReport,
    | 'id'
    | 'title'
    | 'authorId'
    | 'mimeType'
    | 'createdAt'
  >
  & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
);

export type EntityReportPackageFieldsFragment = (
  Pick<
    EntityReportPackage,
    | 'id'
    | 'title'
    | 'authorId'
    | 'interval'
    | 'periodStartedAt'
    | 'periodEndedAt'
    | 'createdAt'
    | 'updatedAt'
    | 'coverUrl'
  >
  & { documents: Array<Pick<
      SharedReportDocumentMetadata,
      | 'id'
      | 'documentObjectId'
      | 'documentObjectVersionId'
      | 'title'
      | 'mimeType'
    >> }
);

export type SharedReportDocumentMetadataFieldsFragment = Pick<
    SharedReportDocumentMetadata,
    | 'id'
    | 'documentObjectId'
    | 'documentObjectVersionId'
    | 'title'
    | 'mimeType'
  >;

export type EntityScheduleFieldsFragment = (
  { __typename: 'EntitySchedule' }
  & Pick<
    EntitySchedule,
    | 'id'
    | 'name'
    | 'scheduleNumber'
    | 'scheduleType'
    | 'scheduleTemplateId'
    | 'categoryId'
    | 'relatedCategoryId'
    | 'partyId'
    | 'startDate'
    | 'endDate'
    | 'cutoverDate'
  >
  & {
    amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
    cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
  }
);

export type EntityThreadFieldsFragment = Pick<EntityThread, 'id' | 'resolvedAt'>;

export type EntityTransactionFieldsFragment = (
  Pick<
    EntityTransaction,
    | 'viewId'
    | 'factId'
    | 'timestamp'
    | 'description'
    | 'externalId'
    | 'displayEntry'
  >
  & {
    moneyFlow: (
      Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
      & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
    ),
    party?: Maybe<Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >>,
    displayCategory: Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >,
    splitCategory?: Maybe<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>,
  }
);

export type EntityUserFieldsFragment = Pick<
    EntityUser,
    | 'id'
    | 'givenName'
    | 'familyName'
    | 'emailAddress'
    | 'avatarUrl'
  >;

export type EntityWorkItemFieldsFragment = (
  Pick<
    EntityWorkItem,
    | 'id'
    | 'time'
    | 'workItemState'
    | 'workItemType'
    | 'reviewCreatedById'
    | 'reviewState'
    | 'ledgerType'
  >
  & { objectTransaction: (
    Pick<
      EntityTransaction,
      | 'viewId'
      | 'factId'
      | 'timestamp'
      | 'description'
      | 'externalId'
      | 'displayEntry'
    >
    & {
      moneyFlow: (
        Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
        & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
      ),
      party?: Maybe<Pick<
          EntityParty,
          | 'id'
          | 'name'
          | 'iconUrl'
          | 'shortDescription'
          | 'roles'
          | 'designation'
        >>,
      displayCategory: Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >,
      splitCategory?: Maybe<Pick<
          EntityCategory,
          | 'id'
          | 'name'
          | 'displayKey'
          | 'chartOfAccountsDisplayNumber'
          | 'type'
          | 'subtype'
          | 'parentCategoryId'
          | 'productArea'
          | 'active'
        >>,
    }
  ) }
);

export type ObjectEntitiesFieldsFragment = (
  { __typename: 'ObjectEntities' }
  & {
    users?: Maybe<Array<Pick<
        EntityUser,
        | 'id'
        | 'givenName'
        | 'familyName'
        | 'emailAddress'
        | 'avatarUrl'
      >>>,
    transactions?: Maybe<Array<(
      Pick<
        EntityTransaction,
        | 'viewId'
        | 'factId'
        | 'timestamp'
        | 'description'
        | 'externalId'
        | 'displayEntry'
      >
      & {
        moneyFlow: (
          Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
          & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
        ),
        party?: Maybe<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>,
        displayCategory: Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >,
        splitCategory?: Maybe<Pick<
            EntityCategory,
            | 'id'
            | 'name'
            | 'displayKey'
            | 'chartOfAccountsDisplayNumber'
            | 'type'
            | 'subtype'
            | 'parentCategoryId'
            | 'productArea'
            | 'active'
          >>,
      }
    )>>,
    comments?: Maybe<Array<Pick<
        EntityComment,
        | 'id'
        | 'authorId'
        | 'text'
        | 'timestamp'
      >>>,
    reports?: Maybe<Array<(
      Pick<
        EntityReport,
        | 'id'
        | 'title'
        | 'authorId'
        | 'mimeType'
        | 'createdAt'
      >
      & { reportFor: Pick<Date, 'year' | 'month' | 'day'> }
    )>>,
    reportPackages?: Maybe<Array<(
      Pick<
        EntityReportPackage,
        | 'id'
        | 'title'
        | 'authorId'
        | 'interval'
        | 'periodStartedAt'
        | 'periodEndedAt'
        | 'createdAt'
        | 'updatedAt'
        | 'coverUrl'
      >
      & { documents: Array<Pick<
          SharedReportDocumentMetadata,
          | 'id'
          | 'documentObjectId'
          | 'documentObjectVersionId'
          | 'title'
          | 'mimeType'
        >> }
    )>>,
    parties?: Maybe<Array<Pick<
        EntityParty,
        | 'id'
        | 'name'
        | 'iconUrl'
        | 'shortDescription'
        | 'roles'
        | 'designation'
      >>>,
    datasources?: Maybe<Array<Pick<
        EntityDataSource,
        | 'id'
        | 'name'
        | 'url'
        | 'iconUrl'
      >>>,
    categories?: Maybe<Array<Pick<
        EntityCategory,
        | 'id'
        | 'name'
        | 'displayKey'
        | 'chartOfAccountsDisplayNumber'
        | 'type'
        | 'subtype'
        | 'parentCategoryId'
        | 'productArea'
        | 'active'
      >>>,
    threads?: Maybe<Array<Pick<EntityThread, 'id' | 'resolvedAt'>>>,
    legalEntities?: Maybe<Array<Pick<EntityLegalEntity, 'id' | 'name' | 'slug'>>>,
    workItems?: Maybe<Array<(
      Pick<
        EntityWorkItem,
        | 'id'
        | 'time'
        | 'workItemState'
        | 'workItemType'
        | 'reviewCreatedById'
        | 'reviewState'
        | 'ledgerType'
      >
      & { objectTransaction: (
        Pick<
          EntityTransaction,
          | 'viewId'
          | 'factId'
          | 'timestamp'
          | 'description'
          | 'externalId'
          | 'displayEntry'
        >
        & {
          moneyFlow: (
            Pick<MoneyFlow, 'isNormal' | 'businessFlow'>
            & { value: Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'> }
          ),
          party?: Maybe<Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            >>,
          displayCategory: Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >,
          splitCategory?: Maybe<Pick<
              EntityCategory,
              | 'id'
              | 'name'
              | 'displayKey'
              | 'chartOfAccountsDisplayNumber'
              | 'type'
              | 'subtype'
              | 'parentCategoryId'
              | 'productArea'
              | 'active'
            >>,
        }
      ) }
    )>>,
    invoices?: Maybe<Array<(
      Pick<
        EntityInvoice,
        | 'id'
        | 'externalDisplayId'
        | 'createdAt'
        | 'dueAt'
      >
      & {
        amount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        customer: (
          Pick<EntityInvoiceCustomer, 'name' | 'phone' | 'email'>
          & { party: Pick<
              EntityParty,
              | 'id'
              | 'name'
              | 'iconUrl'
              | 'shortDescription'
              | 'roles'
              | 'designation'
            > }
        ),
      }
    )>>,
    bills?: Maybe<Array<(
      Pick<
        EntityBill,
        | 'id'
        | 'billStatus'
        | 'vendorName'
        | 'billDescription'
      >
      & {
        totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        dueDate?: Maybe<Pick<Date, 'year' | 'month' | 'day'>>,
        format: (
          Pick<Format, 'id' | 'formatClass'>
          & { segments: Array<Pick<
              Segment,
              | 'collectionId'
              | 'fileId'
              | 'sequence'
              | 'token'
            >> }
        ),
        approvalAccess?: Maybe<Pick<BillAccess, 'objectId' | 'objectKind' | 'role'>>,
      }
    )>>,
    identityVerifications?: Maybe<Array<Pick<EntityIdentityVerification, 'legalEntityId' | 'status'>>>,
    departments?: Maybe<Array<(
      { __typename: 'EntityDepartment' }
      & Pick<
        EntityDepartment,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>>,
    locations?: Maybe<Array<(
      { __typename: 'EntityLocation' }
      & Pick<
        EntityLocation,
        | 'id'
        | 'name'
        | 'parentId'
        | 'active'
      >
    )>>,
    reconciliations?: Maybe<Array<(
      { __typename: 'EntityReconciliation' }
      & Pick<EntityReconciliation, 'id' | 'categoryId' | 'reconciliationStatus'>
      & {
        startDate: Pick<Date, 'year' | 'month' | 'day'>,
        endDate: Pick<Date, 'year' | 'month' | 'day'>,
      }
    )>>,
    ledgerTransactions?: Maybe<Array<(
      Pick<
        EntityLedgerTransaction,
        | 'id'
        | 'timestamp'
        | 'factIds'
        | 'name'
        | 'referenceNumber'
      >
      & {
        totalAmount: Pick<EntityMonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>,
        parties: Array<Pick<
            EntityParty,
            | 'id'
            | 'name'
            | 'iconUrl'
            | 'shortDescription'
            | 'roles'
            | 'designation'
          >>,
      }
    )>>,
    schedules?: Maybe<Array<(
      { __typename: 'EntitySchedule' }
      & Pick<
        EntitySchedule,
        | 'id'
        | 'name'
        | 'scheduleNumber'
        | 'scheduleType'
        | 'scheduleTemplateId'
        | 'categoryId'
        | 'relatedCategoryId'
        | 'partyId'
        | 'startDate'
        | 'endDate'
        | 'cutoverDate'
      >
      & {
        amount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
        cutoverAmount?: Maybe<Pick<MonetaryValue, 'iso4217CurrencyCode' | 'currencyMultiplier' | 'amount'>>,
      }
    )>>,
  }
);

export type ObjectIdentifierFieldsFragment = Pick<ObjectIdentifier, 'legalEntityId' | 'id' | 'kind'>;

export type SegmentFieldsFragment = Pick<
    Segment,
    | 'collectionId'
    | 'fileId'
    | 'sequence'
    | 'token'
  >;

export const ObjectIdentifierFieldsFragmentDoc = gql`
    fragment ObjectIdentifierFields on ObjectIdentifier {
  legalEntityId
  id
  kind
}
    `;
export const UserGrantFieldsFragmentDoc = gql`
    fragment UserGrantFields on UserGrant {
  grantId
  userId
  permission
}
    `;
export const UserIntentFieldsFragmentDoc = gql`
    fragment UserIntentFields on UserIntent {
  intentId
  emailAddress
  permission
}
    `;
export const UserRequestFieldsFragmentDoc = gql`
    fragment UserRequestFields on UserRequest {
  requestId
  userId
}
    `;
export const EntityUserFieldsFragmentDoc = gql`
    fragment EntityUserFields on EntityUser {
  id
  givenName
  familyName
  emailAddress
  avatarUrl
}
    `;
export const MonetaryValueFieldsFragmentDoc = gql`
    fragment MonetaryValueFields on MonetaryValue {
  iso4217CurrencyCode
  currencyMultiplier
  amount
}
    `;
export const MoneyFlowFieldsFragmentDoc = gql`
    fragment MoneyFlowFields on MoneyFlow {
  value {
    ...MonetaryValueFields
  }
  isNormal
  businessFlow
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const EntityPartyFieldsFragmentDoc = gql`
    fragment EntityPartyFields on EntityParty {
  id
  name
  iconUrl
  shortDescription
  roles
  designation
}
    `;
export const EntityCategoryFieldsFragmentDoc = gql`
    fragment EntityCategoryFields on EntityCategory {
  id
  name
  displayKey
  chartOfAccountsDisplayNumber
  type
  subtype
  parentCategoryId
  productArea
  active
}
    `;
export const EntityTransactionFieldsFragmentDoc = gql`
    fragment EntityTransactionFields on EntityTransaction {
  viewId
  factId
  timestamp
  description
  externalId
  moneyFlow {
    ...MoneyFlowFields
  }
  party {
    ...EntityPartyFields
  }
  displayCategory {
    ...EntityCategoryFields
  }
  splitCategory {
    ...EntityCategoryFields
  }
  displayEntry
}
    ${MoneyFlowFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}`;
export const EntityCommentFieldsFragmentDoc = gql`
    fragment EntityCommentFields on EntityComment {
  id
  authorId
  text
  timestamp
}
    `;
export const DateFieldsFragmentDoc = gql`
    fragment DateFields on Date {
  year
  month
  day
}
    `;
export const EntityReportFieldsFragmentDoc = gql`
    fragment EntityReportFields on EntityReport {
  id
  title
  authorId
  mimeType
  reportFor {
    ...DateFields
  }
  createdAt
}
    ${DateFieldsFragmentDoc}`;
export const SharedReportDocumentMetadataFieldsFragmentDoc = gql`
    fragment SharedReportDocumentMetadataFields on SharedReportDocumentMetadata {
  id
  documentObjectId
  documentObjectVersionId
  title
  mimeType
}
    `;
export const EntityReportPackageFieldsFragmentDoc = gql`
    fragment EntityReportPackageFields on EntityReportPackage {
  id
  title
  authorId
  interval
  periodStartedAt
  periodEndedAt
  createdAt
  updatedAt
  documents {
    ...SharedReportDocumentMetadataFields
  }
  coverUrl
}
    ${SharedReportDocumentMetadataFieldsFragmentDoc}`;
export const EntityDataSourceFieldsFragmentDoc = gql`
    fragment EntityDataSourceFields on EntityDataSource {
  id
  name
  url
  iconUrl
}
    `;
export const EntityThreadFieldsFragmentDoc = gql`
    fragment EntityThreadFields on EntityThread {
  id
  resolvedAt
}
    `;
export const EntityLegalEntityFieldsFragmentDoc = gql`
    fragment EntityLegalEntityFields on EntityLegalEntity {
  id
  name
  slug
}
    `;
export const EntityWorkItemFieldsFragmentDoc = gql`
    fragment EntityWorkItemFields on EntityWorkItem {
  id
  time
  workItemState
  workItemType
  reviewCreatedById
  objectTransaction {
    ...EntityTransactionFields
  }
  reviewState
  ledgerType
}
    ${EntityTransactionFieldsFragmentDoc}`;
export const EntityMonetaryValueFieldsFragmentDoc = gql`
    fragment EntityMonetaryValueFields on EntityMonetaryValue {
  iso4217CurrencyCode
  currencyMultiplier
  amount
}
    `;
export const EntityInvoiceCustomerFieldsFragmentDoc = gql`
    fragment EntityInvoiceCustomerFields on EntityInvoiceCustomer {
  name
  phone
  email
  party {
    ...EntityPartyFields
  }
}
    ${EntityPartyFieldsFragmentDoc}`;
export const EntityInvoiceFieldsFragmentDoc = gql`
    fragment EntityInvoiceFields on EntityInvoice {
  id
  externalDisplayId
  amount {
    ...EntityMonetaryValueFields
  }
  customer {
    ...EntityInvoiceCustomerFields
  }
  createdAt
  dueAt
}
    ${EntityMonetaryValueFieldsFragmentDoc}
${EntityInvoiceCustomerFieldsFragmentDoc}`;
export const SegmentFieldsFragmentDoc = gql`
    fragment SegmentFields on Segment {
  collectionId
  fileId
  sequence
  token
}
    `;
export const BillAccessFieldsFragmentDoc = gql`
    fragment BillAccessFields on BillAccess {
  objectId
  objectKind
  role
}
    `;
export const EntityBillFieldsFragmentDoc = gql`
    fragment EntityBillFields on EntityBill {
  id
  billStatus
  vendorName
  totalAmount {
    ...EntityMonetaryValueFields
  }
  dueDate {
    ...DateFields
  }
  billDescription
  format {
    id
    formatClass
    segments {
      ...SegmentFields
    }
  }
  approvalAccess {
    ...BillAccessFields
  }
}
    ${EntityMonetaryValueFieldsFragmentDoc}
${DateFieldsFragmentDoc}
${SegmentFieldsFragmentDoc}
${BillAccessFieldsFragmentDoc}`;
export const EntityIdentityVerificationFieldsFragmentDoc = gql`
    fragment EntityIdentityVerificationFields on EntityIdentityVerification {
  legalEntityId
  status
}
    `;
export const EntityDepartmentFieldsFragmentDoc = gql`
    fragment EntityDepartmentFields on EntityDepartment {
  __typename
  id
  name
  parentId
  active
}
    `;
export const EntityLocationFieldsFragmentDoc = gql`
    fragment EntityLocationFields on EntityLocation {
  __typename
  id
  name
  parentId
  active
}
    `;
export const EntityReconciliationFieldsFragmentDoc = gql`
    fragment EntityReconciliationFields on EntityReconciliation {
  __typename
  id
  categoryId
  reconciliationStatus
  startDate {
    ...DateFields
  }
  endDate {
    ...DateFields
  }
}
    ${DateFieldsFragmentDoc}`;
export const EntityLedgerTransactionFieldsFragmentDoc = gql`
    fragment EntityLedgerTransactionFields on EntityLedgerTransaction {
  id
  timestamp
  factIds
  name
  totalAmount {
    ...EntityMonetaryValueFields
  }
  referenceNumber
  parties {
    ...EntityPartyFields
  }
}
    ${EntityMonetaryValueFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}`;
export const EntityScheduleFieldsFragmentDoc = gql`
    fragment EntityScheduleFields on EntitySchedule {
  __typename
  id
  name
  scheduleNumber
  scheduleType
  scheduleTemplateId
  categoryId
  relatedCategoryId
  partyId
  startDate
  endDate
  cutoverDate
  amount {
    ...MonetaryValueFields
  }
  cutoverAmount {
    ...MonetaryValueFields
  }
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const ObjectEntitiesFieldsFragmentDoc = gql`
    fragment ObjectEntitiesFields on ObjectEntities {
  __typename
  users {
    ...EntityUserFields
  }
  transactions {
    ...EntityTransactionFields
  }
  comments {
    ...EntityCommentFields
  }
  reports {
    ...EntityReportFields
  }
  reportPackages {
    ...EntityReportPackageFields
  }
  parties {
    ...EntityPartyFields
  }
  datasources {
    ...EntityDataSourceFields
  }
  categories {
    ...EntityCategoryFields
  }
  threads {
    ...EntityThreadFields
  }
  legalEntities {
    ...EntityLegalEntityFields
  }
  workItems {
    ...EntityWorkItemFields
  }
  invoices {
    ...EntityInvoiceFields
  }
  bills {
    ...EntityBillFields
  }
  identityVerifications {
    ...EntityIdentityVerificationFields
  }
  departments {
    ...EntityDepartmentFields
  }
  locations {
    ...EntityLocationFields
  }
  reconciliations {
    ...EntityReconciliationFields
  }
  ledgerTransactions {
    ...EntityLedgerTransactionFields
  }
  schedules {
    ...EntityScheduleFields
  }
}
    ${EntityUserFieldsFragmentDoc}
${EntityTransactionFieldsFragmentDoc}
${EntityCommentFieldsFragmentDoc}
${EntityReportFieldsFragmentDoc}
${EntityReportPackageFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}
${EntityDataSourceFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}
${EntityThreadFieldsFragmentDoc}
${EntityLegalEntityFieldsFragmentDoc}
${EntityWorkItemFieldsFragmentDoc}
${EntityInvoiceFieldsFragmentDoc}
${EntityBillFieldsFragmentDoc}
${EntityIdentityVerificationFieldsFragmentDoc}
${EntityDepartmentFieldsFragmentDoc}
${EntityLocationFieldsFragmentDoc}
${EntityReconciliationFieldsFragmentDoc}
${EntityLedgerTransactionFieldsFragmentDoc}
${EntityScheduleFieldsFragmentDoc}`;
export const ObjectAclFieldsFragmentDoc = gql`
    fragment ObjectACLFields on ObjectACL {
  object {
    ...ObjectIdentifierFields
  }
  grants {
    ...UserGrantFields
  }
  intents {
    ...UserIntentFields
  }
  requests {
    ...UserRequestFields
  }
  link
  entities {
    ...ObjectEntitiesFields
  }
}
    ${ObjectIdentifierFieldsFragmentDoc}
${UserGrantFieldsFragmentDoc}
${UserIntentFieldsFragmentDoc}
${UserRequestFieldsFragmentDoc}
${ObjectEntitiesFieldsFragmentDoc}`;
export const ObjectGrantFieldsFragmentDoc = gql`
    fragment ObjectGrantFields on ObjectGrant {
  grantId
  object {
    ...ObjectIdentifierFields
  }
  permission
  createdAt
  viewType
}
    ${ObjectIdentifierFieldsFragmentDoc}`;
export const UserAclFieldsFragmentDoc = gql`
    fragment UserACLFields on UserACL {
  grants {
    ...ObjectGrantFields
  }
  entities {
    ...ObjectEntitiesFields
  }
}
    ${ObjectGrantFieldsFragmentDoc}
${ObjectEntitiesFieldsFragmentDoc}`;
export const AccountReconciliationFieldsFragmentDoc = gql`
    fragment AccountReconciliationFields on AccountReconciliation {
  chartOfAccountsId
  categoryId
  category {
    ...EntityCategoryFields
  }
  reconciliationId
  startDate {
    ...DateFields
  }
  endDate {
    ...DateFields
  }
  status
  updater {
    ...EntityUserFields
  }
  createdAt
  updatedAt
}
    ${EntityCategoryFieldsFragmentDoc}
${DateFieldsFragmentDoc}
${EntityUserFieldsFragmentDoc}`;
export const LedgerBalancesFieldsFragmentDoc = gql`
    fragment LedgerBalancesFields on LedgerBalances {
  debitTotal {
    ...MoneyFlowFields
  }
  creditTotal {
    ...MoneyFlowFields
  }
  netTotal {
    ...MoneyFlowFields
  }
  unsettledTotal {
    ...MoneyFlowFields
  }
  closingBalance {
    ...MoneyFlowFields
  }
}
    ${MoneyFlowFieldsFragmentDoc}`;
export const StatementBalancesFieldsFragmentDoc = gql`
    fragment StatementBalancesFields on StatementBalances {
  debitTotal {
    ...MoneyFlowFields
  }
  creditTotal {
    ...MoneyFlowFields
  }
  netTotal {
    ...MoneyFlowFields
  }
  openingBalance {
    ...MoneyFlowFields
  }
  closingBalance {
    ...MoneyFlowFields
  }
}
    ${MoneyFlowFieldsFragmentDoc}`;
export const LedgerAccountDifferencesFieldsFragmentDoc = gql`
    fragment LedgerAccountDifferencesFields on LedgerAccountDifferences {
  debitDifference {
    ...MoneyFlowFields
  }
  creditDifference {
    ...MoneyFlowFields
  }
  unreconciledDifference {
    ...MoneyFlowFields
  }
}
    ${MoneyFlowFieldsFragmentDoc}`;
export const ReconciliationBalancesFieldsFragmentDoc = gql`
    fragment ReconciliationBalancesFields on ReconciliationBalances {
  ledgerBalances {
    ...LedgerBalancesFields
  }
  statementBalances {
    ...StatementBalancesFields
  }
  ledgerAccountDifferences {
    ...LedgerAccountDifferencesFields
  }
}
    ${LedgerBalancesFieldsFragmentDoc}
${StatementBalancesFieldsFragmentDoc}
${LedgerAccountDifferencesFieldsFragmentDoc}`;
export const TransactionPartyFieldsFragmentDoc = gql`
    fragment TransactionPartyFields on TransactionParty {
  id
  name
  iconUrl
  iconObjectName
  designation
  roles
}
    `;
export const ProductFieldsFragmentDoc = gql`
    fragment ProductFields on Product {
  id
  dataSourceId
  name
  providerType
  active
  institutionId
  institutionName
}
    `;
export const CategoryFieldsFragmentDoc = gql`
    fragment CategoryFields on Category {
  id
  name
  description
  displayKey
  type
  subtype
  parentCategoryId
  displayNumber
  active
  categoryState
  productArea
  synthesized
  ancestors {
    ...EntityCategoryFields
  }
}
    ${EntityCategoryFieldsFragmentDoc}`;
export const TransactionSourceFieldsFragmentDoc = gql`
    fragment TransactionSourceFields on TransactionSource {
  timestamp
  name
  iconUrl
  externalDisplayId
  type
  account {
    sourceAccountId
    externalName
    mask
    externalOwnerName
    externalOfficialName
  }
}
    `;
export const ClassificationProvenanceFieldsFragmentDoc = gql`
    fragment ClassificationProvenanceFields on ClassificationProvenance {
  type
  changedAt
  confidenceLevel
  source {
    ...TransactionSourceFields
  }
  settingsName
}
    ${TransactionSourceFieldsFragmentDoc}`;
export const EntityEmployeeFieldsFragmentDoc = gql`
    fragment EntityEmployeeFields on EntityEmployee {
  id
  organizationId
  givenName
  familyName
  avatarUrl
}
    `;
export const TransactionFieldsFragmentDoc = gql`
    fragment TransactionFields on Transaction {
  viewId
  factId
  ledgerTransactionId
  supersededFactIds
  timestamp
  recordType
  name
  description
  digitsTransactionType
  party {
    ...TransactionPartyFields
  }
  partySource
  facilitatorParty {
    ...TransactionPartyFields
  }
  product {
    ...ProductFields
  }
  department {
    ...EntityDepartmentFields
  }
  splitDepartment {
    ...EntityDepartmentFields
  }
  location {
    ...EntityLocationFields
  }
  splitLocation {
    ...EntityLocationFields
  }
  providers {
    name
  }
  recurrence {
    recurrenceThreadId
    interval
    intervalMultiplier
    threadIndex
    totalThreadCount
    isHidden
    firstOccurredAt
    lastOccurredAt
  }
  displayEntry
  displayInstitution {
    ...TransactionPartyFields
  }
  displayCategory {
    ...CategoryFields
  }
  displayCategorySource
  displayCategoryClassificationProvenance {
    ...ClassificationProvenanceFields
  }
  displayCanonicalCategoryName
  displayUncategorizedReason
  displayProductArea
  splitCategory {
    ...CategoryFields
  }
  splitCategoryClassificationProvenance {
    ...ClassificationProvenanceFields
  }
  splitInstitution {
    ...TransactionPartyFields
  }
  creditCategoryClassificationProvenance {
    ...ClassificationProvenanceFields
  }
  debitCategoryClassificationProvenance {
    ...ClassificationProvenanceFields
  }
  moneyFlow {
    ...MoneyFlowFields
  }
  runningTotal {
    ...MoneyFlowFields
  }
  owner {
    ...EntityEmployeeFields
  }
  ownerSource
  transactionClassificationType
  sources {
    ...TransactionSourceFields
  }
  creditSources {
    ...TransactionSourceFields
  }
  debitSources {
    ...TransactionSourceFields
  }
  compileSource
  reconciliationStatus
  referenceNumber
  taxStatus
  matchedLedgerTransactionIds
  providerTypes
  isSupersedingLedgerTransaction
  supersededLedgerTransactionIds
  invoiceLineItem {
    value {
      ... on TransactionProductLineItem {
        name
        description
        quantity
        unitPrice {
          ...MonetaryValueFields
        }
        product {
          productId
          name
          description
          unitPrice {
            ...MonetaryValueFields
          }
          category {
            ...CategoryFields
          }
          department {
            ...EntityDepartmentFields
          }
          location {
            ...EntityLocationFields
          }
        }
      }
      ... on TransactionDiscountLineItem {
        name
        description
        fixedAmount {
          ...MonetaryValueFields
        }
        variablePercentage
        appliesToTransactionFactId
        discount {
          discountId
          name
          description
          fixedAmount {
            ...MonetaryValueFields
          }
          variablePercentage
        }
      }
    }
  }
  schedule {
    ...EntityScheduleFields
  }
  splitSchedule {
    ...EntityScheduleFields
  }
}
    ${TransactionPartyFieldsFragmentDoc}
${ProductFieldsFragmentDoc}
${EntityDepartmentFieldsFragmentDoc}
${EntityLocationFieldsFragmentDoc}
${CategoryFieldsFragmentDoc}
${ClassificationProvenanceFieldsFragmentDoc}
${MoneyFlowFieldsFragmentDoc}
${EntityEmployeeFieldsFragmentDoc}
${TransactionSourceFieldsFragmentDoc}
${MonetaryValueFieldsFragmentDoc}
${EntityScheduleFieldsFragmentDoc}`;
export const StatementLineItemFieldsFragmentDoc = gql`
    fragment StatementLineItemFields on StatementLineItem {
  featureGroupId
  featureIds
  date
  description
  entryType
  amount {
    ...MonetaryValueFields
  }
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const ReconciliationFlagFieldsFragmentDoc = gql`
    fragment ReconciliationFlagFields on ReconciliationFlag {
  flagId
  flagType
  reconciliationIntentId
  createdAt
  resolvedAt
  resolutionType
  resolvedByUser {
    ...EntityUserFields
  }
  potentialDuplicateDetails {
    transactionFactId
    transaction {
      ...TransactionFields
    }
    potentialDuplicateTransactionFactId
    potentialDuplicateTransaction {
      ...TransactionFields
    }
    statementLineItem {
      ...StatementLineItemFields
    }
  }
  changeDateDetails {
    transactionFactId
    suggestedDate
    statementLineItem {
      ...StatementLineItemFields
    }
    transaction {
      ...TransactionFields
    }
  }
  potentialMismatchDetails {
    transactionFactId
    statementLineItem {
      ...StatementLineItemFields
    }
    transaction {
      ...TransactionFields
    }
  }
  createNewTransactionDetails {
    statementLineItem {
      ...StatementLineItemFields
    }
  }
}
    ${EntityUserFieldsFragmentDoc}
${TransactionFieldsFragmentDoc}
${StatementLineItemFieldsFragmentDoc}`;
export const ReconciliationPeriodStatsFieldsFragmentDoc = gql`
    fragment ReconciliationPeriodStatsFields on ReconciliationPeriodStats {
  notStarted
  noActivity
  drafts
  finalized
  totalCategories
}
    `;
export const TransactionCountsFieldsFragmentDoc = gql`
    fragment TransactionCountsFields on TransactionCounts {
  reconciled
  unsettled
}
    `;
export const TransactionReconciliationClassificationFieldsFragmentDoc = gql`
    fragment TransactionReconciliationClassificationFields on TransactionReconciliationClassification {
  classificationVersion
  transactionFactId
  user {
    ...EntityUserFields
  }
}
    ${EntityUserFieldsFragmentDoc}`;
export const ActionItemsExternalKeySummaryFieldsFragmentDoc = gql`
    fragment ActionItemsExternalKeySummaryFields on ActionItemsExternalKeySummary {
  externalKey
  count
}
    `;
export const ActionItemsGroupSummaryFieldsFragmentDoc = gql`
    fragment ActionItemsGroupSummaryFields on ActionItemsGroupSummary {
  group
  count
}
    `;
export const ActionItemsObjectKindSummaryFieldsFragmentDoc = gql`
    fragment ActionItemsObjectKindSummaryFields on ActionItemsObjectKindSummary {
  objectKind
  count
}
    `;
export const ActionItemThreadFieldsFragmentDoc = gql`
    fragment ActionItemThreadFields on ActionItemThread {
  threadId
  targetEntity {
    __typename
    ... on EntityCategory {
      ...EntityCategoryFields
    }
    ... on EntityParty {
      ...EntityPartyFields
    }
    ... on EntityReportPackage {
      ...EntityReportPackageFields
    }
    ... on EntityWorkItem {
      ...EntityWorkItemFields
    }
    ... on EntityLedgerTransaction {
      ...EntityLedgerTransactionFields
    }
    ... on EntityBill {
      ...EntityBillFields
    }
    ... on EntityDepartment {
      ...EntityDepartmentFields
    }
    ... on EntityLocation {
      ...EntityLocationFields
    }
    ... on EntityTransaction {
      ...EntityTransactionFields
    }
    ... on EntityReconciliation {
      ...EntityReconciliationFields
    }
  }
}
    ${EntityCategoryFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}
${EntityReportPackageFieldsFragmentDoc}
${EntityWorkItemFieldsFragmentDoc}
${EntityLedgerTransactionFieldsFragmentDoc}
${EntityBillFieldsFragmentDoc}
${EntityDepartmentFieldsFragmentDoc}
${EntityLocationFieldsFragmentDoc}
${EntityTransactionFieldsFragmentDoc}
${EntityReconciliationFieldsFragmentDoc}`;
export const ActionItemBillApprovalFieldsFragmentDoc = gql`
    fragment ActionItemBillApprovalFields on ActionItemBillApproval {
  bill {
    ...EntityBillFields
  }
}
    ${EntityBillFieldsFragmentDoc}`;
export const ActionItemPublishedReportFieldsFragmentDoc = gql`
    fragment ActionItemPublishedReportFields on ActionItemPublishedReport {
  package {
    ...EntityReportPackageFields
  }
}
    ${EntityReportPackageFieldsFragmentDoc}`;
export const CategorySuggestionFieldsFragmentDoc = gql`
    fragment CategorySuggestionFields on CategorySuggestion {
  dataSourceId
  transactionFactId
  classificationVersionId
  categoryId
  type
  modelConfidence
  modelVersionId
  priority
  createdAt
  updatedAt
}
    `;
export const ActionItemTransactionFieldsFragmentDoc = gql`
    fragment ActionItemTransactionFields on ActionItemTransaction {
  transaction {
    ...EntityTransactionFields
  }
  categorySuggestions {
    ...CategorySuggestionFields
  }
}
    ${EntityTransactionFieldsFragmentDoc}
${CategorySuggestionFieldsFragmentDoc}`;
export const ActionItemUploadStatementFieldsFragmentDoc = gql`
    fragment ActionItemUploadStatementFields on ActionItemUploadStatement {
  category {
    ...EntityCategoryFields
  }
}
    ${EntityCategoryFieldsFragmentDoc}`;
export const ActionItemReconciliationFlagFieldsFragmentDoc = gql`
    fragment ActionItemReconciliationFlagFields on ActionItemReconciliationFlag {
  flagId
  reconciliationIntentId
  flagType
  createdAt
  resolvedAt
  resolutionType
}
    `;
export const ActionItemReconciliationFieldsFragmentDoc = gql`
    fragment ActionItemReconciliationFields on ActionItemReconciliation {
  reconciliation {
    ...EntityReconciliationFields
  }
  category {
    ...EntityCategoryFields
  }
  flags {
    ...ActionItemReconciliationFlagFields
  }
}
    ${EntityReconciliationFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}
${ActionItemReconciliationFlagFieldsFragmentDoc}`;
export const EntityConnectionFieldsFragmentDoc = gql`
    fragment EntityConnectionFields on EntityConnection {
  id
  connectorId
  dataSourceId
}
    `;
export const ActionItemConnectionFieldsFragmentDoc = gql`
    fragment ActionItemConnectionFields on ActionItemConnection {
  connection {
    ...EntityConnectionFields
  }
  dataSource {
    ...EntityDataSourceFields
  }
}
    ${EntityConnectionFieldsFragmentDoc}
${EntityDataSourceFieldsFragmentDoc}`;
export const ActionItemReviewDraftScheduleFieldsFragmentDoc = gql`
    fragment ActionItemReviewDraftScheduleFields on ActionItemReviewDraftSchedule {
  transaction {
    ...EntityTransactionFields
  }
}
    ${EntityTransactionFieldsFragmentDoc}`;
export const ActionItemReviewImportedScheduleFieldsFragmentDoc = gql`
    fragment ActionItemReviewImportedScheduleFields on ActionItemReviewImportedSchedule {
  scheduleImportCandidateId
}
    `;
export const ActionItemCategoryFieldsFragmentDoc = gql`
    fragment ActionItemCategoryFields on ActionItemCategory {
  category {
    ...EntityCategoryFields
  }
}
    ${EntityCategoryFieldsFragmentDoc}`;
export const ActionItemClosedPeriodRequestFieldsFragmentDoc = gql`
    fragment ActionItemClosedPeriodRequestFields on ActionItemClosedPeriodRequest {
  requestId
  requestType
  ledgerTransactions {
    ...EntityLedgerTransactionFields
  }
}
    ${EntityLedgerTransactionFieldsFragmentDoc}`;
export const ActionItemClosedPeriodTransactionRequestFieldsFragmentDoc = gql`
    fragment ActionItemClosedPeriodTransactionRequestFields on ActionItemClosedPeriodTransactionRequest {
  requestId
  requestType
  ledgerTransaction {
    ...EntityLedgerTransactionFields
  }
}
    ${EntityLedgerTransactionFieldsFragmentDoc}`;
export const ActionItemLedgerTransactionFieldsFragmentDoc = gql`
    fragment ActionItemLedgerTransactionFields on ActionItemLedgerTransaction {
  ledgerTransaction {
    ...EntityLedgerTransactionFields
  }
}
    ${EntityLedgerTransactionFieldsFragmentDoc}`;
export const ActionItemPartyFieldsFragmentDoc = gql`
    fragment ActionItemPartyFields on ActionItemParty {
  party {
    ...EntityPartyFields
  }
}
    ${EntityPartyFieldsFragmentDoc}`;
export const ActionItemFieldsFragmentDoc = gql`
    fragment ActionItemFields on ActionItem {
  id
  title
  description
  author {
    ...EntityUserFields
  }
  status
  createdAt
  updatedAt
  userAssignees {
    ...EntityUserFields
  }
  organizationAssigneeIds
  action
  objectTimestamp
  qualityCheck {
    id
    qualityCheckType
  }
  flaggedObjectKinds
  value {
    __typename
    ... on ActionItemThread {
      ...ActionItemThreadFields
    }
    ... on ActionItemBillApproval {
      ...ActionItemBillApprovalFields
    }
    ... on ActionItemPublishedReport {
      ...ActionItemPublishedReportFields
    }
    ... on ActionItemTransaction {
      ...ActionItemTransactionFields
    }
    ... on ActionItemUploadStatement {
      ...ActionItemUploadStatementFields
    }
    ... on ActionItemReconciliation {
      ...ActionItemReconciliationFields
    }
    ... on ActionItemConnection {
      ...ActionItemConnectionFields
    }
    ... on ActionItemReviewDraftSchedule {
      ...ActionItemReviewDraftScheduleFields
    }
    ... on ActionItemReviewImportedSchedule {
      ...ActionItemReviewImportedScheduleFields
    }
    ... on ActionItemCategory {
      ...ActionItemCategoryFields
    }
    ... on ActionItemClosedPeriodRequest {
      ...ActionItemClosedPeriodRequestFields
    }
    ... on ActionItemClosedPeriodTransactionRequest {
      ...ActionItemClosedPeriodTransactionRequestFields
    }
    ... on ActionItemLedgerTransaction {
      ...ActionItemLedgerTransactionFields
    }
    ... on ActionItemParty {
      ...ActionItemPartyFields
    }
  }
}
    ${EntityUserFieldsFragmentDoc}
${ActionItemThreadFieldsFragmentDoc}
${ActionItemBillApprovalFieldsFragmentDoc}
${ActionItemPublishedReportFieldsFragmentDoc}
${ActionItemTransactionFieldsFragmentDoc}
${ActionItemUploadStatementFieldsFragmentDoc}
${ActionItemReconciliationFieldsFragmentDoc}
${ActionItemConnectionFieldsFragmentDoc}
${ActionItemReviewDraftScheduleFieldsFragmentDoc}
${ActionItemReviewImportedScheduleFieldsFragmentDoc}
${ActionItemCategoryFieldsFragmentDoc}
${ActionItemClosedPeriodRequestFieldsFragmentDoc}
${ActionItemClosedPeriodTransactionRequestFieldsFragmentDoc}
${ActionItemLedgerTransactionFieldsFragmentDoc}
${ActionItemPartyFieldsFragmentDoc}`;
export const PeriodFieldsFragmentDoc = gql`
    fragment PeriodFields on Period {
  name
  interval
  startedAt
  endedAt
}
    `;
export const ActionItemSummaryFieldsFragmentDoc = gql`
    fragment ActionItemSummaryFields on ActionItemSummary {
  period {
    ...PeriodFields
  }
  count
}
    ${PeriodFieldsFragmentDoc}`;
export const ActivityObjectIdentifierFieldsFragmentDoc = gql`
    fragment ActivityObjectIdentifierFields on ActivityObjectIdentifier {
  kind
  id
  context
}
    `;
export const DiscreteEventFieldsFragmentDoc = gql`
    fragment DiscreteEventFields on DiscreteEvent {
  kind
  actorUserId
  target {
    ...ActivityObjectIdentifierFields
  }
  subject {
    ...ActivityObjectIdentifierFields
  }
  targetEmailAddress
}
    ${ActivityObjectIdentifierFieldsFragmentDoc}`;
export const ActivityEventFieldsFragmentDoc = gql`
    fragment ActivityEventFields on ActivityEvent {
  id
  legalEntityId
  occurredAt
  discreteEvent {
    ...DiscreteEventFields
  }
}
    ${DiscreteEventFieldsFragmentDoc}`;
export const ActivityFeedFieldsFragmentDoc = gql`
    fragment ActivityFeedFields on ActivityFeed {
  events {
    ...ActivityEventFields
  }
  entities {
    ...ObjectEntitiesFields
  }
}
    ${ActivityEventFieldsFragmentDoc}
${ObjectEntitiesFieldsFragmentDoc}`;
export const OrganizationFieldsFragmentDoc = gql`
    fragment OrganizationFields on Organization {
  id
  slug
  name
  iconUrl
  websiteUrl
  kind
}
    `;
export const OrganizationBrandingFieldsFragmentDoc = gql`
    fragment OrganizationBrandingFields on OrganizationBranding {
  id
  organizationId
  headerColor
  headerTextColor
}
    `;
export const RoleFieldsFragmentDoc = gql`
    fragment RoleFields on Role {
  id
}
    `;
export const IdentityFieldsFragmentDoc = gql`
    fragment IdentityFields on Identity {
  identifier
  provider
  domain
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  givenName
  familyName
  primaryEmailAddress
  passwordSet
  avatarUrl
  createdAt
  lastActivityAt
  employments {
    employeeId
    role {
      ...RoleFields
    }
    organization {
      ...OrganizationFields
    }
    legalEntityRoles {
      legalEntityId
      role {
        id
      }
    }
  }
  identities {
    ...IdentityFields
  }
}
    ${RoleFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}
${IdentityFieldsFragmentDoc}`;
export const AffiliateUserFieldsFragmentDoc = gql`
    fragment AffiliateUserFields on AffiliateUser {
  user {
    ...UserFields
  }
  role {
    ...RoleFields
  }
}
    ${UserFieldsFragmentDoc}
${RoleFieldsFragmentDoc}`;
export const AffiliateOrganizationFieldsFragmentDoc = gql`
    fragment AffiliateOrganizationFields on AffiliateOrganization {
  organization {
    ...OrganizationFields
    branding {
      ...OrganizationBrandingFields
    }
  }
  type
  affiliatedUsers {
    ...AffiliateUserFields
  }
}
    ${OrganizationFieldsFragmentDoc}
${OrganizationBrandingFieldsFragmentDoc}
${AffiliateUserFieldsFragmentDoc}`;
export const EntityOrganizationFieldsFragmentDoc = gql`
    fragment EntityOrganizationFields on EntityOrganization {
  id
  name
  slug
  iconUrl
}
    `;
export const ContactFieldsFragmentDoc = gql`
    fragment ContactFields on Contact {
  givenName
  familyName
  emailAddress
  avatarUrl
}
    `;
export const InvitationProposalFieldsFragmentDoc = gql`
    fragment InvitationProposalFields on InvitationProposal {
  proposalId
  proposalType
  status
  invitationId
  legalEntity {
    ...EntityLegalEntityFields
  }
  organization {
    ...EntityOrganizationFields
  }
  organizationTemplateId
  sender {
    ...EntityUserFields
  }
  createdAt
  recipient {
    ...ContactFields
  }
}
    ${EntityLegalEntityFieldsFragmentDoc}
${EntityOrganizationFieldsFragmentDoc}
${EntityUserFieldsFragmentDoc}
${ContactFieldsFragmentDoc}`;
export const AffiliateOrganizationsFieldsFragmentDoc = gql`
    fragment AffiliateOrganizationsFields on AffiliateOrganizations {
  organizations {
    ...AffiliateOrganizationFields
  }
  inviteProposals {
    ...InvitationProposalFields
  }
}
    ${AffiliateOrganizationFieldsFragmentDoc}
${InvitationProposalFieldsFragmentDoc}`;
export const AmountRuleFilterFieldsFragmentDoc = gql`
    fragment AmountRuleFilterFields on AmountRuleFilter {
  amountRuleFilterId
  operator
  amount {
    ...MonetaryValueFields
  }
  createdAt
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const PartyRuleFilterPartyFieldsFragmentDoc = gql`
    fragment PartyRuleFilterPartyFields on PartyRuleFilterParty {
  partyId
  partyName
}
    `;
export const PartyRuleFilterFieldsFragmentDoc = gql`
    fragment PartyRuleFilterFields on PartyRuleFilter {
  partyRuleFilterId
  operation
  parties {
    ...PartyRuleFilterPartyFields
  }
  createdAt
}
    ${PartyRuleFilterPartyFieldsFragmentDoc}`;
export const CategoryRuleFilterCategoryFieldsFragmentDoc = gql`
    fragment CategoryRuleFilterCategoryFields on CategoryRuleFilterCategory {
  categoryId
  categoryName
}
    `;
export const CategoryRuleFilterFieldsFragmentDoc = gql`
    fragment CategoryRuleFilterFields on CategoryRuleFilter {
  categoryRuleFilterId
  operation
  categories {
    ...CategoryRuleFilterCategoryFields
  }
  createdAt
}
    ${CategoryRuleFilterCategoryFieldsFragmentDoc}`;
export const AuditRuleFieldsFragmentDoc = gql`
    fragment AuditRuleFields on AuditRule {
  auditRuleId
  name
  description
  type
  action
  ruleState
  amountFilters {
    ...AmountRuleFilterFields
  }
  partyFilters {
    ...PartyRuleFilterFields
  }
  categoryFilters {
    ...CategoryRuleFilterFields
  }
}
    ${AmountRuleFilterFieldsFragmentDoc}
${PartyRuleFilterFieldsFragmentDoc}
${CategoryRuleFilterFieldsFragmentDoc}`;
export const AuditRuleStatusFieldsFragmentDoc = gql`
    fragment AuditRuleStatusFields on AuditRuleStatus {
  type
  recentlyUpdated
  updaterType
}
    `;
export const BillingProductFieldsFragmentDoc = gql`
    fragment BillingProductFields on BillingProduct {
  id
  name
  displayName
  description
  callout
  trialPeriodDays
  availability
  listing
  billable
}
    `;
export const BillingTrialFieldsFragmentDoc = gql`
    fragment BillingTrialFields on BillingTrial {
  start
  end
}
    `;
export const BillingPriceFieldsFragmentDoc = gql`
    fragment BillingPriceFields on BillingPrice {
  id
  amount {
    ...MonetaryValueFields
  }
  interval
  intervalCount
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const CouponFieldsFragmentDoc = gql`
    fragment CouponFields on Coupon {
  valid
  amountOff {
    ...MonetaryValueFields
  }
  percentOff
  duration
  durationInMonths
  stripePromoCodeId
  start
  end
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const BillingOperatorFieldsFragmentDoc = gql`
    fragment BillingOperatorFields on BillingOperator {
  organizationId
  subscriptionId
  product {
    ...BillingProductFields
  }
  activeSubscription
  trial {
    ...BillingTrialFields
  }
  availablePlans {
    product {
      ...BillingProductFields
    }
    price {
      ...BillingPriceFields
    }
  }
  availableCoupons {
    ...CouponFields
  }
  subscriptionDetails {
    status
  }
}
    ${BillingProductFieldsFragmentDoc}
${BillingTrialFieldsFragmentDoc}
${BillingPriceFieldsFragmentDoc}
${CouponFieldsFragmentDoc}`;
export const BillingLegalEntityLimitFieldsFragmentDoc = gql`
    fragment BillingLegalEntityLimitFields on BillingLegalEntityLimit {
  id
  minLegalEntityLimit
  maxLegalEntityLimit
}
    `;
export const BillingPlanFieldsFragmentDoc = gql`
    fragment BillingPlanFields on BillingPlan {
  product {
    ...BillingProductFields
  }
  price {
    ...BillingPriceFields
  }
  legalEntityLimit {
    ...BillingLegalEntityLimitFields
  }
}
    ${BillingProductFieldsFragmentDoc}
${BillingPriceFieldsFragmentDoc}
${BillingLegalEntityLimitFieldsFragmentDoc}`;
export const BillingCardDetailsFieldsFragmentDoc = gql`
    fragment BillingCardDetailsFields on BillingCardDetails {
  name
  brand
  country
  expMonth
  expYear
  last4
}
    `;
export const CreateBillingOnboardingSubscriptionFieldsFragmentDoc = gql`
    fragment CreateBillingOnboardingSubscriptionFields on BillingSubscriptionWithoutStatus {
  id
  periodEnd
  periodStart
}
    `;
export const NewAffiliatedBillingSubscriptionFieldsFragmentDoc = gql`
    fragment NewAffiliatedBillingSubscriptionFields on NewAffiliatedBillingSubscription {
  customerId
  productId
  stripeClientSecret
}
    `;
export const NewBillingSubscriptionFieldsFragmentDoc = gql`
    fragment NewBillingSubscriptionFields on NewBillingSubscription {
  customerId
  stripeClientSecret
}
    `;
export const NewTrialBillingSubscriptionFieldsFragmentDoc = gql`
    fragment NewTrialBillingSubscriptionFields on NewTrialBillingSubscription {
  customerId
}
    `;
export const PricePreviewFieldsFragmentDoc = gql`
    fragment PricePreviewFields on PricePreview {
  total {
    ...MonetaryValueFields
  }
  coupons {
    ...CouponFields
  }
}
    ${MonetaryValueFieldsFragmentDoc}
${CouponFieldsFragmentDoc}`;
export const SubscriptionDetailsFieldsFragmentDoc = gql`
    fragment SubscriptionDetailsFields on SubscriptionDetails {
  startedAt
  billingCycleStart
  billingCycleEnd
  status
  cancelAt
}
    `;
export const DuplicateBillFieldsFragmentDoc = gql`
    fragment DuplicateBillFields on DuplicateBill {
  billId
}
    `;
export const LedgerBillAccessFieldsFragmentDoc = gql`
    fragment LedgerBillAccessFields on BillAccess {
  objectId
  objectKind
  role
}
    `;
export const LedgerBillFormatFieldsFragmentDoc = gql`
    fragment LedgerBillFormatFields on Format {
  id
  formatClass
  mimeType
  segments {
    fileId
    sequence
    collectionId
    token
  }
}
    `;
export const LedgerBillTextFeatureValueFieldsFragmentDoc = gql`
    fragment LedgerBillTextFeatureValueFields on TextFeatureValue {
  __typename
  textValue
}
    `;
export const LedgerBillNumericFeatureValueFieldsFragmentDoc = gql`
    fragment LedgerBillNumericFeatureValueFields on NumericFeatureValue {
  __typename
  numericValue
}
    `;
export const LedgerBillDateFeatureValueFieldsFragmentDoc = gql`
    fragment LedgerBillDateFeatureValueFields on DateFeatureValue {
  __typename
  dateValue {
    year
    month
    day
  }
}
    `;
export const LedgerBillMonetaryValueFieldsFragmentDoc = gql`
    fragment LedgerBillMonetaryValueFields on MonetaryValue {
  iso4217CurrencyCode
  currencyMultiplier
  amount
}
    `;
export const LedgerBillMonetaryFeatureValueFieldsFragmentDoc = gql`
    fragment LedgerBillMonetaryFeatureValueFields on MonetaryFeatureValue {
  __typename
  monetaryValue {
    ...LedgerBillMonetaryValueFields
  }
}
    ${LedgerBillMonetaryValueFieldsFragmentDoc}`;
export const LedgerBillAddressFieldsFragmentDoc = gql`
    fragment LedgerBillAddressFields on Address {
  street
  streetAdditional
  city
  region
  postalCode
  countryCode
  lat
  long
}
    `;
export const LedgerBillAddressFeatureValueFieldsFragmentDoc = gql`
    fragment LedgerBillAddressFeatureValueFields on AddressFeatureValue {
  __typename
  addressValue {
    ...LedgerBillAddressFields
  }
}
    ${LedgerBillAddressFieldsFragmentDoc}`;
export const LedgerBillLineItemFeatureValueFieldsFragmentDoc = gql`
    fragment LedgerBillLineItemFeatureValueFields on LineItemFeatureValue {
  __typename
  lineItemValue {
    description
    quantity
    rate {
      ...LedgerBillMonetaryValueFields
    }
    amount {
      ...LedgerBillMonetaryValueFields
    }
    position
    categoryId
  }
}
    ${LedgerBillMonetaryValueFieldsFragmentDoc}`;
export const LedgerBillRemittanceFeatureValueFieldsFragmentDoc = gql`
    fragment LedgerBillRemittanceFeatureValueFields on RemittanceFeatureValue {
  __typename
  remittanceValue {
    BankName
    BankAccountNumber
    BankAccountName
    BankRoutingNumber
    RemittanceType
  }
}
    `;
export const LedgerBillFeatureFieldsFragmentDoc = gql`
    fragment LedgerBillFeatureFields on Feature {
  __typename
  id
  kind
  featurePage
  originX
  originY
  width
  height
  invalid
  value {
    ... on TextFeatureValue {
      ...LedgerBillTextFeatureValueFields
    }
    ... on NumericFeatureValue {
      ...LedgerBillNumericFeatureValueFields
    }
    ... on DateFeatureValue {
      ...LedgerBillDateFeatureValueFields
    }
    ... on MonetaryFeatureValue {
      ...LedgerBillMonetaryFeatureValueFields
    }
    ... on AddressFeatureValue {
      ...LedgerBillAddressFeatureValueFields
    }
    ... on LineItemFeatureValue {
      ...LedgerBillLineItemFeatureValueFields
    }
    ... on RemittanceFeatureValue {
      ...LedgerBillRemittanceFeatureValueFields
    }
  }
}
    ${LedgerBillTextFeatureValueFieldsFragmentDoc}
${LedgerBillNumericFeatureValueFieldsFragmentDoc}
${LedgerBillDateFeatureValueFieldsFragmentDoc}
${LedgerBillMonetaryFeatureValueFieldsFragmentDoc}
${LedgerBillAddressFeatureValueFieldsFragmentDoc}
${LedgerBillLineItemFeatureValueFieldsFragmentDoc}
${LedgerBillRemittanceFeatureValueFieldsFragmentDoc}`;
export const LedgerBillDocumentFieldsFragmentDoc = gql`
    fragment LedgerBillDocumentFields on LedgerBillDocument {
  id
  collectionId
  sourceFormatId
  status
  asyncProcessingStatus
  isSplitLineItemView
  formats {
    ...LedgerBillFormatFields
  }
  features {
    ...LedgerBillFeatureFields
  }
  createdAt
  updatedAt
  deletedAt
}
    ${LedgerBillFormatFieldsFragmentDoc}
${LedgerBillFeatureFieldsFragmentDoc}`;
export const VendorSummaryFieldsFragmentDoc = gql`
    fragment VendorSummaryFields on VendorSummary {
  id
  name
  icon
}
    `;
export const LedgerBillSummaryFieldsFragmentDoc = gql`
    fragment LedgerBillSummaryFields on LedgerBillSummary {
  id
  documentId
  vendor {
    ...VendorSummaryFields
  }
  detectedVendor {
    ...VendorSummaryFields
  }
  invoiceNumber
  externalId
  referenceId
  providerType
  status
  billDate
  dueDate
  scheduleSendForApproval
  paidAt
  statusAt
  createdAt
  amount {
    ...EntityMonetaryValueFields
  }
  amountDue {
    ...EntityMonetaryValueFields
  }
  transactionFactId
  duplicateDataSourceBillIds
  sourceIconUrls
}
    ${VendorSummaryFieldsFragmentDoc}
${EntityMonetaryValueFieldsFragmentDoc}`;
export const LedgerBillRoleFieldsFragmentDoc = gql`
    fragment LedgerBillRoleFields on Role {
  id
}
    `;
export const LedgerBillOrganizationFieldsFragmentDoc = gql`
    fragment LedgerBillOrganizationFields on Organization {
  id
  slug
  name
  iconUrl
  websiteUrl
  kind
}
    `;
export const LedgerBillIdentityFieldsFragmentDoc = gql`
    fragment LedgerBillIdentityFields on Identity {
  identifier
  provider
  domain
}
    `;
export const LedgerBillUserFieldsFragmentDoc = gql`
    fragment LedgerBillUserFields on User {
  id
  givenName
  familyName
  primaryEmailAddress
  passwordSet
  avatarUrl
  createdAt
  lastActivityAt
  employments {
    employeeId
    role {
      ...LedgerBillRoleFields
    }
    organization {
      ...LedgerBillOrganizationFields
    }
  }
  identities {
    ...LedgerBillIdentityFields
  }
}
    ${LedgerBillRoleFieldsFragmentDoc}
${LedgerBillOrganizationFieldsFragmentDoc}
${LedgerBillIdentityFieldsFragmentDoc}`;
export const VendorFieldsFragmentDoc = gql`
    fragment VendorFields on Vendor {
  vendorId
  name
  email
  providerType
  partyId
  iconUrl
}
    `;
export const ConnectionAccountSummaryFieldsFragmentDoc = gql`
    fragment ConnectionAccountSummaryFields on ConnectionAccountSummary {
  id
  connectionId
  sourceAccountId
  name
  mask
  status
  statusUpdatedAt
  cardHolders {
    id
    name
  }
}
    `;
export const ConnectionCategoryIntegrationsFieldsFragmentDoc = gql`
    fragment ConnectionCategoryIntegrationsFields on ConnectionCategoryIntegrations {
  connectionAccountSummaries {
    ...ConnectionAccountSummaryFields
  }
  party {
    ...EntityPartyFields
  }
}
    ${ConnectionAccountSummaryFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}`;
export const PayCategoryIntegrationsFieldsFragmentDoc = gql`
    fragment PayCategoryIntegrationsFields on PayCategoryIntegrations {
  products
  party {
    ...EntityPartyFields
  }
}
    ${EntityPartyFieldsFragmentDoc}`;
export const CategoryIntegrationsFieldsFragmentDoc = gql`
    fragment CategoryIntegrationsFields on CategoryIntegrations {
  categoryId
  connect {
    ...ConnectionCategoryIntegrationsFields
  }
  pay {
    ...PayCategoryIntegrationsFields
  }
}
    ${ConnectionCategoryIntegrationsFieldsFragmentDoc}
${PayCategoryIntegrationsFieldsFragmentDoc}`;
export const ClosedPeriodTransactionChangeEntityValueFieldsFragmentDoc = gql`
    fragment ClosedPeriodTransactionChangeEntityValueFields on ClosedPeriodTransactionChangeEntityValue {
  __typename
  id
  kind
  entity {
    __typename
    ... on EntityCategory {
      ...EntityCategoryFields
    }
    ... on EntityParty {
      ...EntityPartyFields
    }
    ... on EntityDepartment {
      ...EntityDepartmentFields
      departmentDisplayKey: displayKey
    }
    ... on EntityLocation {
      ...EntityLocationFields
      locationDisplayKey: displayKey
    }
  }
}
    ${EntityCategoryFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}
${EntityDepartmentFieldsFragmentDoc}
${EntityLocationFieldsFragmentDoc}`;
export const ClosedPeriodTransactionChangeTextValueFieldsFragmentDoc = gql`
    fragment ClosedPeriodTransactionChangeTextValueFields on ClosedPeriodTransactionChangeTextValue {
  __typename
  text: value
}
    `;
export const ClosedPeriodTransactionChangeTimestampValueFieldsFragmentDoc = gql`
    fragment ClosedPeriodTransactionChangeTimestampValueFields on ClosedPeriodTransactionChangeTimestampValue {
  __typename
  timestamp: value
}
    `;
export const ClosedPeriodTransactionChangeUnsetValueFieldsFragmentDoc = gql`
    fragment ClosedPeriodTransactionChangeUnsetValueFields on ClosedPeriodTransactionChangeUnsetValue {
  __typename
  isUnset
}
    `;
export const ClosedPeriodTransactionChangeDiffFieldsFragmentDoc = gql`
    fragment ClosedPeriodTransactionChangeDiffFields on ClosedPeriodTransactionChangeDiff {
  __typename
  transactionChangeId
  transactionFactId
  status
  kind
  currentValue {
    __typename
    ... on ClosedPeriodTransactionChangeEntityValue {
      ...ClosedPeriodTransactionChangeEntityValueFields
    }
    ... on ClosedPeriodTransactionChangeTextValue {
      ...ClosedPeriodTransactionChangeTextValueFields
    }
    ... on ClosedPeriodTransactionChangeTimestampValue {
      ...ClosedPeriodTransactionChangeTimestampValueFields
    }
    ... on ClosedPeriodTransactionChangeUnsetValue {
      ...ClosedPeriodTransactionChangeUnsetValueFields
    }
  }
  proposedValue {
    __typename
    ... on ClosedPeriodTransactionChangeEntityValue {
      ...ClosedPeriodTransactionChangeEntityValueFields
    }
    ... on ClosedPeriodTransactionChangeTextValue {
      ...ClosedPeriodTransactionChangeTextValueFields
    }
    ... on ClosedPeriodTransactionChangeTimestampValue {
      ...ClosedPeriodTransactionChangeTimestampValueFields
    }
    ... on ClosedPeriodTransactionChangeUnsetValue {
      ...ClosedPeriodTransactionChangeUnsetValueFields
    }
  }
}
    ${ClosedPeriodTransactionChangeEntityValueFieldsFragmentDoc}
${ClosedPeriodTransactionChangeTextValueFieldsFragmentDoc}
${ClosedPeriodTransactionChangeTimestampValueFieldsFragmentDoc}
${ClosedPeriodTransactionChangeUnsetValueFieldsFragmentDoc}`;
export const AppFieldsFragmentDoc = gql`
    fragment AppFields on App {
  id
  organizationId
  visibility
  name
  description
  homepageURL
  supportEmail
  developerEmail
  privacyPolicyURL
  termsOfServiceURL
  iconObjectName
}
    `;
export const AppAuthorizationFieldsFragmentDoc = gql`
    fragment AppAuthorizationFields on AppAuthorization {
  app {
    ...AppFields
  }
  environment
  eligibleLegalEntities {
    ...EntityLegalEntityFields
  }
  ineligibleLegalEntities {
    ...EntityLegalEntityFields
  }
}
    ${AppFieldsFragmentDoc}
${EntityLegalEntityFieldsFragmentDoc}`;
export const AppCredentialFieldsFragmentDoc = gql`
    fragment AppCredentialFields on AppCredential {
  environment
  clientId
  clientSecret
}
    `;
export const ConnectionSyncStateFieldsFragmentDoc = gql`
    fragment ConnectionSyncStateFields on ConnectionSyncState {
  lastSuccessAt
  lastEventAt
  status
  dataLastModifiedAt
  dataUpdatedAt
}
    `;
export const LabelCategoryFieldsFragmentDoc = gql`
    fragment LabelCategoryFields on LabelCategory {
  label
  category {
    ...EntityCategoryFields
  }
  validCategoryTypes
  displayName
  required
  tooltip
  digitsAi
}
    ${EntityCategoryFieldsFragmentDoc}`;
export const ConnectionAccountSettingsFieldsFragmentDoc = gql`
    fragment ConnectionAccountSettingsFields on ConnectionAccountSettings {
  cutoverDate
  labelCategories {
    ...LabelCategoryFields
  }
}
    ${LabelCategoryFieldsFragmentDoc}`;
export const ConnectionAccountFieldsFragmentDoc = gql`
    fragment ConnectionAccountFields on ConnectionAccount {
  id
  connectionId
  sourceAccountId
  name
  mask
  status
  statusUpdatedAt
  settings {
    ...ConnectionAccountSettingsFields
  }
  cardHolders {
    id
    name
  }
}
    ${ConnectionAccountSettingsFieldsFragmentDoc}`;
export const ConnectorFieldsFragmentDoc = gql`
    fragment ConnectorFields on Connector {
  id
  name
  tagline
  description
  category
  iconObjectName
  className
  canInstall
  connectorProperties {
    __typename
    ... on StripeConnectorProperties {
      __typename
      appLinkURL
    }
    ... on PlaidConnectorProperties {
      __typename
      empty
    }
    ... on RampConnectorProperties {
      __typename
      authorizationURL
    }
    ... on GustoConnectorProperties {
      __typename
      authorizationURL
    }
    ... on BillConnectorProperties {
      __typename
      empty
    }
    ... on FinchConnectorProperties {
      __typename
      empty
    }
    ... on AppConnectorProperties {
      __typename
      organizationId
      visibility
      homepageURL
      supportEmail
      developerEmail
      privacyPolicyURL
      termsOfServiceURL
      scopes
      redirectUris
      installUri
    }
    ... on EmptyConnectorProperties {
      __typename
      empty
    }
  }
}
    `;
export const ConnectionFieldsFragmentDoc = gql`
    fragment ConnectionFields on Connection {
  id
  dataSourceId
  sourceName
  sourceIconURL
  description
  status
  authorizationRequired
  authorizationReason
  authorizationDescription
  upgradedFromConnectionId
  scopes
  sync {
    ...ConnectionSyncStateFields
  }
  settings {
    cutoverDate
  }
  accounts {
    ...ConnectionAccountFields
  }
  connector {
    ...ConnectorFields
  }
  connectorUpgrade {
    ...ConnectorFields
  }
}
    ${ConnectionSyncStateFieldsFragmentDoc}
${ConnectionAccountFieldsFragmentDoc}
${ConnectorFieldsFragmentDoc}`;
export const CreateConnectionResponseFieldsFragmentDoc = gql`
    fragment CreateConnectionResponseFields on CreateConnectionResponse {
  connection {
    ...ConnectionFields
  }
}
    ${ConnectionFieldsFragmentDoc}`;
export const UpgradeConnectionResponseFieldsFragmentDoc = gql`
    fragment UpgradeConnectionResponseFields on CreateConnectionResponse {
  connection {
    ...ConnectionFields
  }
}
    ${ConnectionFieldsFragmentDoc}`;
export const ConnectionSummaryFieldsFragmentDoc = gql`
    fragment ConnectionSummaryFields on ConnectionSummary {
  id
  dataSourceId
  sourceName
  sourceIconURL
  description
  status
  authorizationRequired
  authorizationReason
  authorizationDescription
  upgradeAvailable
  sync {
    ...ConnectionSyncStateFields
  }
  accounts {
    ...ConnectionAccountSummaryFields
  }
  connector {
    ...ConnectorFields
  }
  connectorUpgrade {
    ...ConnectorFields
  }
}
    ${ConnectionSyncStateFieldsFragmentDoc}
${ConnectionAccountSummaryFieldsFragmentDoc}
${ConnectorFieldsFragmentDoc}`;
export const PartyFieldsFragmentDoc = gql`
    fragment PartyFields on Party {
  id
  legalEntityId
  name
  url
  supportUrl
  supportEmail
  supportPhone
  twitterUrl
  facebookUrl
  instagramUrl
  yelpUrl
  iconUrl
  shortDescription
  designation
}
    `;
export const ProductInstitutionFieldsFragmentDoc = gql`
    fragment ProductInstitutionFields on ProductInstitution {
  id
  name
  party {
    ...PartyFields
  }
  products
  routingNumber
}
    ${PartyFieldsFragmentDoc}`;
export const ConnectorTemplateFieldsFragmentDoc = gql`
    fragment ConnectorTemplateFields on ConnectionTemplate {
  connector {
    ...ConnectorFields
  }
  institution {
    ...ProductInstitutionFields
  }
  externalId
}
    ${ConnectorFieldsFragmentDoc}
${ProductInstitutionFieldsFragmentDoc}`;
export const ConnectionTemplateFieldsFragmentDoc = gql`
    fragment ConnectionTemplateFields on ConnectionTemplate {
  connector {
    ...ConnectorFields
  }
  institution {
    ...ProductInstitutionFields
  }
  externalId
}
    ${ConnectorFieldsFragmentDoc}
${ProductInstitutionFieldsFragmentDoc}`;
export const SuggestedConnectionFieldsFragmentDoc = gql`
    fragment SuggestedConnectionFields on SuggestedConnection {
  template {
    ...ConnectionTemplateFields
  }
}
    ${ConnectionTemplateFieldsFragmentDoc}`;
export const WebhookDeliveryEventFieldsFragmentDoc = gql`
    fragment WebhookDeliveryEventFields on WebhookDeliveryEvent {
  webhookDeliveryEventId
  webhookEventId
  webhookDeliveryId
  eventType
  createdAt
  deliveryStatus
  endpointUrl
  httpStatus
  errorCode
}
    `;
export const WebhookEndpointFieldsFragmentDoc = gql`
    fragment WebhookEndpointFields on WebhookEndpoint {
  webhookEndpointId
  connectorId
  environment
  endpointUrl
  status
  statusReason
  eventCategories
  createdAt
  updatedAt
  signingSecret
  oauthCredential {
    tokenEndpointUrl
    clientId
  }
}
    `;
export const DataSourceManualRefreshFieldsFragmentDoc = gql`
    fragment DataSourceManualRefreshFields on DataSourceManualRefresh {
  dataSourceId
  requestedAt
  syncCompletedAt
  earliestViewVersion
  viewFinishedAt
  errors {
    erroredAt
  }
}
    `;
export const QuickBooksAccountingInfoPreferencesFieldsFragmentDoc = gql`
    fragment QuickBooksAccountingInfoPreferencesFields on QuickBooksAccountingInfoPreferences {
  bookCloseDate {
    ...DateFields
  }
}
    ${DateFieldsFragmentDoc}`;
export const QuickBooksPreferencesFieldsFragmentDoc = gql`
    fragment QuickBooksPreferencesFields on QuickBooksPreferences {
  accountingInfo {
    ...QuickBooksAccountingInfoPreferencesFields
  }
}
    ${QuickBooksAccountingInfoPreferencesFieldsFragmentDoc}`;
export const QuickBooksCompanyFieldsFragmentDoc = gql`
    fragment QuickBooksCompanyFields on QuickBooksCompany {
  preferences {
    ...QuickBooksPreferencesFields
  }
}
    ${QuickBooksPreferencesFieldsFragmentDoc}`;
export const DocumentIdentifierFieldsFragmentDoc = gql`
    fragment DocumentIdentifierFields on DocumentIdentifier {
  __typename
  collectionId
  documentId
}
    `;
export const AssociationIdentifierFieldsFragmentDoc = gql`
    fragment AssociationIdentifierFields on AssociationIdentifier {
  __typename
  documentIdentifier {
    ...DocumentIdentifierFields
  }
  objectIdentifier {
    ...ObjectIdentifierFields
  }
}
    ${DocumentIdentifierFieldsFragmentDoc}
${ObjectIdentifierFieldsFragmentDoc}`;
export const AssociationHistoryEventFieldsFragmentDoc = gql`
    fragment AssociationHistoryEventFields on AssociationHistoryEvent {
  __typename
  eventType
  eventTime
  user {
    ...EntityUserFields
  }
}
    ${EntityUserFieldsFragmentDoc}`;
export const DocumentInfoFieldsFragmentDoc = gql`
    fragment DocumentInfoFields on DocumentInfo {
  __typename
  title
  creator {
    ...EntityUserFields
  }
  dataSource {
    ...EntityDataSourceFields
  }
  deletedAt
}
    ${EntityUserFieldsFragmentDoc}
${EntityDataSourceFieldsFragmentDoc}`;
export const AssociationHistoryFieldsFragmentDoc = gql`
    fragment AssociationHistoryFields on AssociationHistory {
  __typename
  associationIdentifier {
    ...AssociationIdentifierFields
  }
  events {
    ...AssociationHistoryEventFields
  }
  documentInfo {
    ...DocumentInfoFields
  }
}
    ${AssociationIdentifierFieldsFragmentDoc}
${AssociationHistoryEventFieldsFragmentDoc}
${DocumentInfoFieldsFragmentDoc}`;
export const DiscountFieldsFragmentDoc = gql`
    fragment DiscountFields on Discount {
  discountId
  name
  fixedDiscountAmount {
    ...MonetaryValueFields
  }
  variablePercentage
  providerType
  categoryId
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const InvoiceBrandingFieldsFragmentDoc = gql`
    fragment InvoiceBrandingFields on InvoiceBranding {
  id
  backgroundColor
  coverURL
}
    `;
export const InvoiceDefaultsFieldsFragmentDoc = gql`
    fragment InvoiceDefaultsFields on InvoiceDefaults {
  id
  invoiceDate
  dueDate
  invoiceNumber
  branding {
    ...InvoiceBrandingFields
  }
}
    ${InvoiceBrandingFieldsFragmentDoc}`;
export const InvoiceFileFieldsFragmentDoc = gql`
    fragment InvoiceFileFields on InvoiceFile {
  documentId
  fileType
}
    `;
export const InvoiceNumberFieldsFragmentDoc = gql`
    fragment InvoiceNumberFields on InvoiceNumber {
  invoiceNumber
}
    `;
export const AddressFieldsFragmentDoc = gql`
    fragment AddressFields on Address {
  street
  streetAdditional
  city
  region
  postalCode
  countryCode
  lat
  long
}
    `;
export const InvoicingAddressFieldsFragmentDoc = gql`
    fragment InvoicingAddressFields on InvoicingAddress {
  id
  address {
    ...AddressFields
  }
}
    ${AddressFieldsFragmentDoc}`;
export const InvoicingProfileFieldsFragmentDoc = gql`
    fragment InvoicingProfileFields on InvoicingProfile {
  id
  companyEmail
  companyName
  companyIcon
  companyAddress {
    ...InvoicingAddressFields
  }
  payoutInstrumentID
  invoiceNumberFormatDefault
  invoiceNumberFormat
}
    ${InvoicingAddressFieldsFragmentDoc}`;
export const CustomerAddressFieldsFragmentDoc = gql`
    fragment CustomerAddressFields on CustomerAddress {
  id
  address {
    ...AddressFields
  }
}
    ${AddressFieldsFragmentDoc}`;
export const LedgerCustomerDetailFieldsFragmentDoc = gql`
    fragment LedgerCustomerDetailFields on LedgerCustomerDetail {
  id: customerId
  name
  email
  phone
  contactName
  secondaryEmail
  paymentTerms
  description
  providerType
  dataSourcePartyId
  party {
    id
    iconUrl
  }
  billingAddress {
    ...CustomerAddressFields
  }
}
    ${CustomerAddressFieldsFragmentDoc}`;
export const LedgerInvoiceDiscountFieldsFragmentDoc = gql`
    fragment LedgerInvoiceDiscountFields on LedgerInvoiceDiscount {
  id
  discountId
  name
  description
  amount {
    ...MonetaryValueFields
  }
  fixedDiscountAmount {
    ...MonetaryValueFields
  }
  variablePercentage
  classificationId
  category {
    ...EntityCategoryFields
  }
  department {
    ...EntityDepartmentFields
  }
  location {
    ...EntityLocationFields
  }
}
    ${MonetaryValueFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}
${EntityDepartmentFieldsFragmentDoc}
${EntityLocationFieldsFragmentDoc}`;
export const LedgerInvoiceLineItemFieldsFragmentDoc = gql`
    fragment LedgerInvoiceLineItemFields on LedgerInvoiceLineItem {
  id
  name
  description
  amount {
    ...MonetaryValueFields
  }
  unitPrice {
    ...MonetaryValueFields
  }
  quantity
  imageUrl
  productId
  productVariantId
  classificationId
  externalLineItemId
  sku
  category {
    ...EntityCategoryFields
  }
  department {
    ...EntityDepartmentFields
  }
  location {
    ...EntityLocationFields
  }
  discounts {
    ...LedgerInvoiceDiscountFields
  }
}
    ${MonetaryValueFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}
${EntityDepartmentFieldsFragmentDoc}
${EntityLocationFieldsFragmentDoc}
${LedgerInvoiceDiscountFieldsFragmentDoc}`;
export const CustomerSummaryFieldsFragmentDoc = gql`
    fragment CustomerSummaryFields on CustomerSummary {
  id
  name
  email
  icon
}
    `;
export const LedgerInvoiceSummaryFieldsFragmentDoc = gql`
    fragment LedgerInvoiceSummaryFields on LedgerInvoiceSummary {
  id
  customer {
    ...CustomerSummaryFields
  }
  amount {
    ...EntityMonetaryValueFields
  }
  amountDue {
    ...EntityMonetaryValueFields
  }
  dueAt
  paidAt
  invoiceNumber
  referenceNumber
  status
  transactionFactId
  statusAt
  createdAt
  providerType
  sourceIconUrls
}
    ${CustomerSummaryFieldsFragmentDoc}
${EntityMonetaryValueFieldsFragmentDoc}`;
export const BankAccountFieldsFragmentDoc = gql`
    fragment BankAccountFields on BankAccount {
  __typename
  id
  institutionName
  name
  accountIdMask
  isDefault
  nickname
  isAutoPayout
  iconObjectName
}
    `;
export const CreditCardFieldsFragmentDoc = gql`
    fragment CreditCardFields on CreditCard {
  __typename
  id
  cardLastFour
  cardBrand
}
    `;
export const InvoicePaymentDetailsFieldsFragmentDoc = gql`
    fragment InvoicePaymentDetailsFields on InvoicePaymentDetails {
  paymentConfirmationId
  paymentDate
  paymentAmount {
    ...MonetaryValueFields
  }
  paymentInstrument {
    ...BankAccountFields
    ...CreditCardFields
  }
}
    ${MonetaryValueFieldsFragmentDoc}
${BankAccountFieldsFragmentDoc}
${CreditCardFieldsFragmentDoc}`;
export const PayInvoiceSummaryFieldsFragmentDoc = gql`
    fragment PayInvoiceSummaryFields on PayInvoiceSummary {
  invoicePaymentDetails {
    ...InvoicePaymentDetailsFields
  }
  status
}
    ${InvoicePaymentDetailsFieldsFragmentDoc}`;
export const BusinessVerificationApplicationFieldsFragmentDoc = gql`
    fragment BusinessVerificationApplicationFields on BusinessVerificationApplication {
  annualRevenue {
    ...MonetaryValueFields
  }
  companyType
  owner {
    firstName
    lastName
    residentialAddress {
      ...AddressFields
    }
  }
  businessName
  phoneNumber
  industryCode
  industryCodeId
  companyWebsite
  address {
    ...AddressFields
  }
  physicalStoreAddress {
    ...AddressFields
  }
}
    ${MonetaryValueFieldsFragmentDoc}
${AddressFieldsFragmentDoc}`;
export const BusinessVerificationStatusResultFieldsFragmentDoc = gql`
    fragment BusinessVerificationStatusResultFields on BusinessVerificationStatusResult {
  status
  expiresAt
  needsPciSaqSigned
  pciSaqDeadline
  isRestricted
}
    `;
export const SummaryTotalFieldsFragmentDoc = gql`
    fragment SummaryTotalFields on SummaryTotal {
  total {
    ...MoneyFlowFields
  }
  count
}
    ${MoneyFlowFieldsFragmentDoc}`;
export const PeriodMonetaryValueFieldsFragmentDoc = gql`
    fragment PeriodMonetaryValueFields on PeriodMonetaryValue {
  value {
    ...MonetaryValueFields
  }
  moneyFlow {
    ...MoneyFlowFields
  }
  current {
    ...SummaryTotalFields
  }
  prior {
    ...SummaryTotalFields
  }
  transactionsCount
  deltaPrevious
  deltaYearAgo
  isFirstOccurrencePeriod
}
    ${MonetaryValueFieldsFragmentDoc}
${MoneyFlowFieldsFragmentDoc}
${SummaryTotalFieldsFragmentDoc}`;
export const TransactionSummaryFieldsFragmentDoc = gql`
    fragment TransactionSummaryFields on TransactionSummary {
  period {
    ...PeriodFields
  }
  total {
    ...PeriodMonetaryValueFields
  }
  isPeriodBookClosed
}
    ${PeriodFieldsFragmentDoc}
${PeriodMonetaryValueFieldsFragmentDoc}`;
export const CashSummaryFieldsFragmentDoc = gql`
    fragment CashSummaryFields on CashSummary {
  cashTotal {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
  }
  cashChange {
    category {
      categoryObject {
        ...EntityCategoryFields
      }
      by {
        time {
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
    partialData
  }
}
    ${TransactionSummaryFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}`;
export const ViewIdentifierFieldsFragmentDoc = gql`
    fragment ViewIdentifierFields on ViewIdentifier {
  legalEntityId
  viewVersion
  mutationVersion
  viewType
}
    `;
export const ArchiveIntervalOriginFieldsFragmentDoc = gql`
    fragment ArchiveIntervalOriginFields on ArchiveIntervalOrigin {
  interval
  year
  index
  intervalCount
  maxTime
}
    `;
export const TextTagOptionsFieldsFragmentDoc = gql`
    fragment TextTagOptionsFields on TextTagOptions {
  partyRole
}
    `;
export const TextComponentConfigFieldsFragmentDoc = gql`
    fragment TextComponentConfigFields on TextComponentConfig {
  body
  current {
    ...ArchiveIntervalOriginFields
  }
  lookback {
    ...ArchiveIntervalOriginFields
  }
  tags {
    displayText
    objectId {
      ...ObjectIdentifierFields
    }
    options {
      ...TextTagOptionsFields
    }
  }
}
    ${ArchiveIntervalOriginFieldsFragmentDoc}
${ObjectIdentifierFieldsFragmentDoc}
${TextTagOptionsFieldsFragmentDoc}`;
export const CategoryChartConfigFieldsFragmentDoc = gql`
    fragment CategoryChartConfigFields on CategoryChartConfig {
  origin {
    ...ArchiveIntervalOriginFields
  }
  categoryId
  withoutCategoryAncestors
  asPermanent
}
    ${ArchiveIntervalOriginFieldsFragmentDoc}`;
export const PartyChartConfigFieldsFragmentDoc = gql`
    fragment PartyChartConfigFields on PartyChartConfig {
  origin {
    ...ArchiveIntervalOriginFields
  }
  partyId
  partyRole
  asPermanent
}
    ${ArchiveIntervalOriginFieldsFragmentDoc}`;
export const TopEntitiesConfigFieldsFragmentDoc = gql`
    fragment TopEntitiesConfigFields on TopEntitiesConfig {
  limit
  origin {
    ...ArchiveIntervalOriginFields
  }
  kind
  partyRole
  categoryType
  filteredBy {
    ...ObjectIdentifierFields
  }
  sort
}
    ${ArchiveIntervalOriginFieldsFragmentDoc}
${ObjectIdentifierFieldsFragmentDoc}`;
export const TopTransactionsConfigFieldsFragmentDoc = gql`
    fragment TopTransactionsConfigFields on TopTransactionsConfig {
  limit
  origin {
    ...ArchiveIntervalOriginFields
  }
  partyRole
  categoryType
  filteredBy {
    ...ObjectIdentifierFields
  }
}
    ${ArchiveIntervalOriginFieldsFragmentDoc}
${ObjectIdentifierFieldsFragmentDoc}`;
export const SummaryLineItemConfigFieldsFragmentDoc = gql`
    fragment SummaryLineItemConfigFields on SummaryLineItemConfig {
  origin {
    ...ArchiveIntervalOriginFields
  }
  item
}
    ${ArchiveIntervalOriginFieldsFragmentDoc}`;
export const PortalMetricConfigFieldsFragmentDoc = gql`
    fragment PortalMetricConfigFields on PortalMetricConfig {
  origin {
    ...ArchiveIntervalOriginFields
  }
  metricType
}
    ${ArchiveIntervalOriginFieldsFragmentDoc}`;
export const EntitiesListConfigFieldsFragmentDoc = gql`
    fragment EntitiesListConfigFields on EntitiesListConfig {
  origin {
    ...ArchiveIntervalOriginFields
  }
  entities {
    ...ObjectEntitiesFields
  }
}
    ${ArchiveIntervalOriginFieldsFragmentDoc}
${ObjectEntitiesFieldsFragmentDoc}`;
export const ReportOptionsFieldsFragmentDoc = gql`
    fragment ReportOptionsFields on ReportDocumentOptions {
  __typename
  sparklineLookbackPeriods
  reportLookbackPeriods
  deltaMonthOverMonth
  deltaMonthOverMonthPeriods
  deltaYearOverYear
  comparedToTotal
  comparedToIncome
  collapsedSections {
    sections
  }
  amountPrecision
  yearToDate
  deltaYearToDate
  breakdownByClass
  categoryByDepartmentOptions {
    departments {
      departmentId
      name
    }
    showOther
    showUnassigned
  }
  categoryByLocationOptions {
    locations {
      locationId
      name
    }
    showOther
    showUnassigned
  }
}
    `;
export const StatementConfigFieldsFragmentDoc = gql`
    fragment StatementConfigFields on StatementConfig {
  kind
  origin {
    ...ArchiveIntervalOriginFields
  }
  options {
    ...ReportOptionsFields
  }
}
    ${ArchiveIntervalOriginFieldsFragmentDoc}
${ReportOptionsFieldsFragmentDoc}`;
export const MetricChartConfigFieldsFragmentDoc = gql`
    fragment MetricChartConfigFields on MetricChartConfig {
  origin {
    ...ArchiveIntervalOriginFields
  }
  item
}
    ${ArchiveIntervalOriginFieldsFragmentDoc}`;
export const RunwayChartConfigFieldsFragmentDoc = gql`
    fragment RunwayChartConfigFields on RunwayChartConfig {
  origin {
    ...ArchiveIntervalOriginFields
  }
  netBurnLookback {
    ...ArchiveIntervalOriginFields
  }
}
    ${ArchiveIntervalOriginFieldsFragmentDoc}`;
export const CashSummaryChartConfigFieldsFragmentDoc = gql`
    fragment CashSummaryChartConfigFields on CashSummaryChartConfig {
  origin {
    ...ArchiveIntervalOriginFields
  }
}
    ${ArchiveIntervalOriginFieldsFragmentDoc}`;
export const StaticMetricConfigFieldsFragmentDoc = gql`
    fragment StaticMetricConfigFields on StaticMetricConfig {
  name
  value
  updatedAt
}
    `;
export const InsightComponentConfigFieldsFragmentDoc = gql`
    fragment InsightComponentConfigFields on InsightComponentConfig {
  objectId {
    ...ObjectIdentifierFields
  }
  options {
    partyRole
  }
  origin {
    ...ArchiveIntervalOriginFields
  }
  lookback {
    ...ArchiveIntervalOriginFields
  }
}
    ${ObjectIdentifierFieldsFragmentDoc}
${ArchiveIntervalOriginFieldsFragmentDoc}`;
export const DepartmentChartConfigFieldsFragmentDoc = gql`
    fragment DepartmentChartConfigFields on DepartmentChartConfig {
  origin {
    ...ArchiveIntervalOriginFields
  }
  departmentId
}
    ${ArchiveIntervalOriginFieldsFragmentDoc}`;
export const LocationChartConfigFieldsFragmentDoc = gql`
    fragment LocationChartConfigFields on LocationChartConfig {
  origin {
    ...ArchiveIntervalOriginFields
  }
  locationId
}
    ${ArchiveIntervalOriginFieldsFragmentDoc}`;
export const SourceAccountMetricConfigFieldsFragmentDoc = gql`
    fragment SourceAccountMetricConfigFields on SourceAccountMetricConfig {
  origin {
    ...ArchiveIntervalOriginFields
  }
  key
  sourceAccountId
  dataSourceId
}
    ${ArchiveIntervalOriginFieldsFragmentDoc}`;
export const AgingSummaryChartConfigFieldsFragmentDoc = gql`
    fragment AgingSummaryChartConfigFields on AgingSummaryChartConfig {
  kind
  origin {
    ...ArchiveIntervalOriginFields
  }
  dimensions
  masks
}
    ${ArchiveIntervalOriginFieldsFragmentDoc}`;
export const CategoryByDepartmentChartConfigFieldsFragmentDoc = gql`
    fragment CategoryByDepartmentChartConfigFields on CategoryByDepartmentChartConfig {
  origin {
    ...ArchiveIntervalOriginFields
  }
  categoryId
  departmentIds
}
    ${ArchiveIntervalOriginFieldsFragmentDoc}`;
export const CategoryByLocationChartConfigFieldsFragmentDoc = gql`
    fragment CategoryByLocationChartConfigFields on CategoryByLocationChartConfig {
  origin {
    ...ArchiveIntervalOriginFields
  }
  categoryId
  locationIds
}
    ${ArchiveIntervalOriginFieldsFragmentDoc}`;
export const LayoutComponentConfigFieldsFragmentDoc = gql`
    fragment LayoutComponentConfigFields on LayoutComponentConfig {
  type
  text {
    ...TextComponentConfigFields
  }
  categoryChart {
    ...CategoryChartConfigFields
  }
  partyChart {
    ...PartyChartConfigFields
  }
  topEntities {
    ...TopEntitiesConfigFields
  }
  topTransactions {
    ...TopTransactionsConfigFields
  }
  summaryLineItem {
    ...SummaryLineItemConfigFields
  }
  portalMetric {
    ...PortalMetricConfigFields
  }
  entitiesList {
    ...EntitiesListConfigFields
  }
  statement {
    ...StatementConfigFields
  }
  metricChart {
    ...MetricChartConfigFields
  }
  runwayChart {
    ...RunwayChartConfigFields
  }
  cashSummaryChart {
    ...CashSummaryChartConfigFields
  }
  staticMetric {
    ...StaticMetricConfigFields
  }
  documentCollection {
    collectionId
  }
  insight {
    ...InsightComponentConfigFields
  }
  departmentChart {
    ...DepartmentChartConfigFields
  }
  locationChart {
    ...LocationChartConfigFields
  }
  sourceAccountMetric {
    ...SourceAccountMetricConfigFields
  }
  agingSummaryChart {
    ...AgingSummaryChartConfigFields
  }
  categoryByDepartmentChart {
    ...CategoryByDepartmentChartConfigFields
  }
  categoryByLocationChart {
    ...CategoryByLocationChartConfigFields
  }
}
    ${TextComponentConfigFieldsFragmentDoc}
${CategoryChartConfigFieldsFragmentDoc}
${PartyChartConfigFieldsFragmentDoc}
${TopEntitiesConfigFieldsFragmentDoc}
${TopTransactionsConfigFieldsFragmentDoc}
${SummaryLineItemConfigFieldsFragmentDoc}
${PortalMetricConfigFieldsFragmentDoc}
${EntitiesListConfigFieldsFragmentDoc}
${StatementConfigFieldsFragmentDoc}
${MetricChartConfigFieldsFragmentDoc}
${RunwayChartConfigFieldsFragmentDoc}
${CashSummaryChartConfigFieldsFragmentDoc}
${StaticMetricConfigFieldsFragmentDoc}
${InsightComponentConfigFieldsFragmentDoc}
${DepartmentChartConfigFieldsFragmentDoc}
${LocationChartConfigFieldsFragmentDoc}
${SourceAccountMetricConfigFieldsFragmentDoc}
${AgingSummaryChartConfigFieldsFragmentDoc}
${CategoryByDepartmentChartConfigFieldsFragmentDoc}
${CategoryByLocationChartConfigFieldsFragmentDoc}`;
export const LayoutFieldsFragmentDoc = gql`
    fragment LayoutFields on Layout {
  viewKey {
    ...ViewIdentifierFields
  }
  layoutId
  layoutVersionId
  sections {
    sectionId
    title
    rows {
      rowId
      title
      components {
        componentId
        title
        config {
          ...LayoutComponentConfigFields
        }
        dataId
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${LayoutComponentConfigFieldsFragmentDoc}`;
export const LocationSummaryFieldsFragmentDoc = gql`
    fragment LocationSummaryFields on LocationSummary {
  location {
    ...EntityLocationFields
  }
  total {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
  }
  expensesChange {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
  }
  otherExpensesChange {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
  }
  incomeChange {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
  }
  otherIncomeChange {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
  }
  cogsChange {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
  }
}
    ${EntityLocationFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;
export const RunwayFieldsFragmentDoc = gql`
    fragment RunwayFields on Runway {
  current {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
  }
  future {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
  }
  cashOutDate
  previousCashOutDate
}
    ${TransactionSummaryFieldsFragmentDoc}`;
export const SourceAccountMetricIdentifierFieldsFragmentDoc = gql`
    fragment SourceAccountMetricIdentifierFields on SourceAccountMetricIdentifier {
  dataSourceId
  sourceAccountId
  key
}
    `;
export const SourceAccountMetricPointFieldsFragmentDoc = gql`
    fragment SourceAccountMetricPointFields on SourceAccountMetricPoint {
  time
  value
}
    `;
export const SourceAccountMetricSeriesFieldsFragmentDoc = gql`
    fragment SourceAccountMetricSeriesFields on SourceAccountMetricSeries {
  identifier {
    ...SourceAccountMetricIdentifierFields
  }
  points {
    ...SourceAccountMetricPointFields
  }
}
    ${SourceAccountMetricIdentifierFieldsFragmentDoc}
${SourceAccountMetricPointFieldsFragmentDoc}`;
export const SourceAccountMetricSeriesDataFieldsFragmentDoc = gql`
    fragment SourceAccountMetricSeriesDataFields on SourceAccountMetricSeriesData {
  series {
    ...SourceAccountMetricSeriesFields
  }
  label
  iconObjectName
}
    ${SourceAccountMetricSeriesFieldsFragmentDoc}`;
export const SourceAccountMetricFieldsFragmentDoc = gql`
    fragment SourceAccountMetricFields on SourceAccountMetric {
  metrics {
    ...SourceAccountMetricSeriesDataFields
  }
}
    ${SourceAccountMetricSeriesDataFieldsFragmentDoc}`;
export const LegalEntityFieldsFragmentDoc = gql`
    fragment LegalEntityFields on LegalEntity {
  id
  slug
  name
  websiteUrl
  industry
  timezone
  fiscalYearStartMonth
  fiscalYearNumberOffset
  status
  organizationId
  address {
    ...AddressFields
  }
  incorporatedOn {
    year
    month
    day
  }
  sensitive
  phoneNumber
  iconUrl
}
    ${AddressFieldsFragmentDoc}`;
export const UserInfoFieldsFragmentDoc = gql`
    fragment UserInfoFields on UserInfo {
  givenName
  familyName
  emailAddress
}
    `;
export const CompanyDetailsFieldsFragmentDoc = gql`
    fragment CompanyDetailsFields on CompanyDetails {
  categories
  companyName
  websiteURL
  address {
    ...AddressFields
  }
  companySize
  incorporationState
  entityType
  subsidiaryCount
  foreignSubsidiaryCount
  incorporationYear
  lastTaxFiling
}
    ${AddressFieldsFragmentDoc}`;
export const CompanyFinancialValueFieldsFragmentDoc = gql`
    fragment CompanyFinancialValueFields on CompanyFinancialValue {
  name
  institutionId
}
    `;
export const CompanyFinancialsFieldsFragmentDoc = gql`
    fragment CompanyFinancialsFields on CompanyFinancials {
  product
  values {
    ...CompanyFinancialValueFields
  }
}
    ${CompanyFinancialValueFieldsFragmentDoc}`;
export const QuotePackageFieldsFragmentDoc = gql`
    fragment QuotePackageFields on QuotePackage {
  id
  recipient {
    ...ContactFields
  }
  companyDetails {
    ...CompanyDetailsFields
  }
  financials {
    ...CompanyFinancialsFields
  }
  contractDocumentId
  status
}
    ${ContactFieldsFragmentDoc}
${CompanyDetailsFieldsFragmentDoc}
${CompanyFinancialsFieldsFragmentDoc}`;
export const AiBookkeeperLegalEntityFieldsFragmentDoc = gql`
    fragment AIBookkeeperLegalEntityFields on NewAIBookkeeperLegalEntity {
  legalEntity {
    ...LegalEntityFields
  }
  userInfo {
    ...UserInfoFields
  }
  quotePackage {
    ...QuotePackageFields
  }
}
    ${LegalEntityFieldsFragmentDoc}
${UserInfoFieldsFragmentDoc}
${QuotePackageFieldsFragmentDoc}`;
export const ViewMetadataFieldsFragmentDoc = gql`
    fragment ViewMetadataFields on ViewMetadata {
  firstTransactionTimestamp
  latestTransactionTimestamp
  legalEntityId
  viewType
  viewVersion
}
    `;
export const LinkedObjectDetailsFieldsFragmentDoc = gql`
    fragment LinkedObjectDetailsFields on LinkedObjectDetails {
  sourceTransaction {
    ...TransactionFields
  }
  linkedTransactions {
    ...TransactionFields
  }
  paid
  paidDate
  reversed
}
    ${TransactionFieldsFragmentDoc}`;
export const WebNotificationFieldsFragmentDoc = gql`
    fragment WebNotificationFields on WebNotification {
  id
  legalEntityId
  eventType
  name
  displayKey
  targetAction
  assetLink
  status
  message
  createdAt
}
    `;
export const ObjectMappingHierarchyNodeFieldsFragmentDoc = gql`
    fragment ObjectMappingHierarchyNodeFields on ObjectMappingHierarchyNode {
  factId
  name
  parentId
  active
  transactionCount
  mappedTo
  depth
  fullyQualifiedName
}
    `;
export const OrganizationAffiliationFieldsFragmentDoc = gql`
    fragment OrganizationAffiliationFields on OrganizationAffiliation {
  legalEntity {
    ...EntityLegalEntityFields
  }
  organization {
    ...EntityOrganizationFields
  }
}
    ${EntityLegalEntityFieldsFragmentDoc}
${EntityOrganizationFieldsFragmentDoc}`;
export const PartyHistoryEntryFieldsFragmentDoc = gql`
    fragment PartyHistoryEntryFields on PartyHistoryEntry {
  userId
  name
  iconUrl
}
    `;
export const CatalogProductClassificationsFieldsFragmentDoc = gql`
    fragment CatalogProductClassificationsFields on ProductClassifications {
  incomeCategory {
    classificationVersionId
    categoryId
  }
  expenseCategory {
    classificationVersionId
    categoryId
  }
  department {
    classificationVersionId
    departmentId
  }
  buyDepartment {
    classificationVersionId
    departmentId
  }
  sellDepartment {
    classificationVersionId
    departmentId
  }
  location {
    classificationVersionId
    locationId
  }
  buyLocation {
    classificationVersionId
    locationId
  }
  sellLocation {
    classificationVersionId
    locationId
  }
}
    `;
export const CatalogProductFieldsFragmentDoc = gql`
    fragment CatalogProductFields on Product {
  id
  dataSourceId
  providerType
  institutionId
  institutionName
  institutionIconUrl
  productGroupId
  sku
  name
  description
  active
  taxable
  assetCategoryId
  iconDisplayKey
  customIconObjectName
  customIconUrl
  createdAt
  updatedAt
  createdByUserId
}
    `;
export const CatalogProductVariantPriceFieldsFragmentDoc = gql`
    fragment CatalogProductVariantPriceFields on ProductVariantPrice {
  id
  dataSourceId
  productId
  variantId
  externalId
  type
  unitPrice {
    iso4217CurrencyCode
    currencyMultiplier
    amount
  }
  createdAt
  updatedAt
}
    `;
export const CatalogProductVariantFieldsFragmentDoc = gql`
    fragment CatalogProductVariantFields on ProductVariant {
  id
  dataSourceId
  productId
  externalId
  sku
  name
  description
  position
  iconDisplayKey
  customIconObjectName
  prices {
    ...CatalogProductVariantPriceFields
  }
  createdAt
  updatedAt
  createdByUserId
}
    ${CatalogProductVariantPriceFieldsFragmentDoc}`;
export const QualityCheckFieldsFragmentDoc = gql`
    fragment QualityCheckFields on QualityCheck {
  __typename
  id
  legalEntityId
  organizationId
  name
  description
  qualityCheckType
  objectKind
  flaggedObjectKinds
  owner
  enabled
  lastRunAt
  status
}
    `;
export const QualityCheckInstructionFieldsFragmentDoc = gql`
    fragment QualityCheckInstructionFields on QualityCheckInstruction {
  __typename
  id
  checkId
  authorId
  userInstruction
  userInstructionTags {
    ...ObjectIdentifierFields
  }
  versionNumber
  summary
  summaryTags {
    ...ObjectIdentifierFields
  }
  createdAt
  updatedAt
}
    ${ObjectIdentifierFieldsFragmentDoc}`;
export const QualityCheckWithEntitiesFieldsFragmentDoc = gql`
    fragment QualityCheckWithEntitiesFields on QualityCheckWithEntities {
  __typename
  check {
    ...QualityCheckFields
  }
  instruction {
    ...QualityCheckInstructionFields
  }
  defaultInstruction
  entities {
    ...ObjectEntitiesFields
  }
}
    ${QualityCheckFieldsFragmentDoc}
${QualityCheckInstructionFieldsFragmentDoc}
${ObjectEntitiesFieldsFragmentDoc}`;
export const QualityCheckGroupFieldsFragmentDoc = gql`
    fragment QualityCheckGroupFields on QualityCheckGroup {
  __typename
  name
  checks {
    ...QualityCheckFields
  }
}
    ${QualityCheckFieldsFragmentDoc}`;
export const ReportAutomationSettingsFieldsFragmentDoc = gql`
    fragment ReportAutomationSettingsFields on ReportAutomationSettings {
  organizationId
  legalEntityId
  interval
  autoCreateDraft
  autoPublishDraft
  autoPublishDraftDay
  autoPublishFinal
  autoPublishFinalDay
}
    `;
export const OrganizationPreviewFieldsFragmentDoc = gql`
    fragment OrganizationPreviewFields on OrganizationPreview {
  id
  slug
  name
  iconUrl
}
    `;
export const ReportFileMetadataFieldsFragmentDoc = gql`
    fragment ReportFileMetadataFields on ReportFileMetadata {
  id
  fileName
  mimeType
  fileSize
  source
}
    `;
export const ReportGenerationHistoryFieldsFragmentDoc = gql`
    fragment ReportGenerationHistoryFields on ReportGenerationHistory {
  id
  requestId
  reportId
  versionId
  legalEntityId
  authorId
  viewVersion
  kind
  timezone
  periodStartedAt
  periodEndedAt
  generationStartedAt
  generationEndedAt
  error
  createdAt
  updatedAt
}
    `;
export const ReportPackageDocumentMetadataFieldsFragmentDoc = gql`
    fragment ReportPackageDocumentMetadataFields on ReportPackageDocumentMetadata {
  id
  title
  documentObjectId
  documentObjectVersionId
  type
  reportFile {
    ...ReportFileMetadataFields
  }
  status
  generationHistory {
    ...ReportGenerationHistoryFields
  }
  position
}
    ${ReportFileMetadataFieldsFragmentDoc}
${ReportGenerationHistoryFieldsFragmentDoc}`;
export const ReportFieldsFragmentDoc = gql`
    fragment ReportFields on Report {
  id
  versionId
  title
  author {
    ...ContactFields
  }
  reportFile {
    ...ReportFileMetadataFields
  }
  reportFor {
    ...DateFields
  }
  status
  interval
  createdAt
  generationHistory {
    ...ReportGenerationHistoryFields
  }
  options {
    ...ReportOptionsFields
  }
}
    ${ContactFieldsFragmentDoc}
${ReportFileMetadataFieldsFragmentDoc}
${DateFieldsFragmentDoc}
${ReportGenerationHistoryFieldsFragmentDoc}
${ReportOptionsFieldsFragmentDoc}`;
export const TextDocumentFieldsFragmentDoc = gql`
    fragment TextDocumentFields on TextDocument {
  id
  title
  summary
  status
  createdAt
  updatedAt
}
    `;
export const LayoutDocumentFieldsFragmentDoc = gql`
    fragment LayoutDocumentFields on LayoutDocument {
  id
  title
  layoutId
  status
  createdAt
  updatedAt
}
    `;
export const ReportPackageVersionMetadataFieldsFragmentDoc = gql`
    fragment ReportPackageVersionMetadataFields on ReportPackageVersionMetadata {
  id
  status
  createdAt
  updatedAt
}
    `;
export const ReportPackageFieldsFragmentDoc = gql`
    fragment ReportPackageFields on ReportPackage {
  id
  versionId
  viewKey {
    ...ViewIdentifierFields
  }
  title
  status
  createdAt
  updatedAt
  startedAt
  endedAt
  interval
  author {
    ...ContactFields
  }
  authorOrganization {
    ...OrganizationPreviewFields
  }
  legalEntityOrganization {
    ...OrganizationPreviewFields
  }
  packageOptions {
    customFooter
    preparedBy
    accountNumbersDisplay
    coverUrl
    coverLogoSource
    publishedAsDraft
  }
  documents {
    metadata {
      ...ReportPackageDocumentMetadataFields
    }
    document {
      ... on Report {
        ...ReportFields
      }
      ... on TextDocument {
        ...TextDocumentFields
      }
      ... on LayoutDocument {
        ...LayoutDocumentFields
      }
    }
  }
  entities {
    ...ObjectEntitiesFields
  }
  version {
    ...ReportPackageVersionMetadataFields
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${ContactFieldsFragmentDoc}
${OrganizationPreviewFieldsFragmentDoc}
${ReportPackageDocumentMetadataFieldsFragmentDoc}
${ReportFieldsFragmentDoc}
${TextDocumentFieldsFragmentDoc}
${LayoutDocumentFieldsFragmentDoc}
${ObjectEntitiesFieldsFragmentDoc}
${ReportPackageVersionMetadataFieldsFragmentDoc}`;
export const StatementRowTitleFieldsFragmentDoc = gql`
    fragment StatementRowTitleFields on StatementRowTitle {
  displayNumber
  title
}
    `;
export const StatementRowSummaryFieldsFragmentDoc = gql`
    fragment StatementRowSummaryFields on StatementRowSummary {
  displayNumber
  label
  moneyFlow {
    ...MoneyFlowFields
  }
}
    ${MoneyFlowFieldsFragmentDoc}`;
export const AgingSummaryFieldsFragmentDoc = gql`
    fragment AgingSummaryFields on AgingSummary {
  label
  dimensionSummary {
    aging {
      summary {
        ...TransactionSummaryFields
      }
    }
    summary {
      ...TransactionSummaryFields
    }
    partialData
  }
}
    ${TransactionSummaryFieldsFragmentDoc}`;
export const LeafAgingSummaryFieldsFragmentDoc = gql`
    fragment LeafAgingSummaryFields on LeafAgingSummary {
  dueDate
  referenceNumber
  invoiceDate
  amounts {
    column
    moneyFlow {
      ...MoneyFlowFields
    }
  }
  link {
    hasLink
  }
}
    ${MoneyFlowFieldsFragmentDoc}`;
export const TimeHistoryFieldsFragmentDoc = gql`
    fragment TimeHistoryFields on DimensionSummary {
  time {
    summary {
      ...TransactionSummaryFields
    }
  }
}
    ${TransactionSummaryFieldsFragmentDoc}`;
export const DepartmentHistoryFieldsFragmentDoc = gql`
    fragment DepartmentHistoryFields on DimensionSummary {
  department {
    departmentId
    departmentObject {
      ...EntityDepartmentFields
    }
    by {
      time {
        summary {
          ...TransactionSummaryFields
        }
      }
    }
  }
}
    ${EntityDepartmentFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;
export const LocationHistoryFieldsFragmentDoc = gql`
    fragment LocationHistoryFields on DimensionSummary {
  location {
    locationId
    locationObject {
      ...EntityLocationFields
    }
    by {
      time {
        summary {
          ...TransactionSummaryFields
        }
      }
    }
  }
}
    ${EntityLocationFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;
export const StatementCategoryHoverFieldsFragmentDoc = gql`
    fragment StatementCategoryHoverFields on CategoryHover {
  __typename
  entity {
    __typename
    ... on EntityCategory {
      ...EntityCategoryFields
    }
  }
  history {
    ...TimeHistoryFields @include(if: $timeHistory)
    ...DepartmentHistoryFields @include(if: $departmentHistory)
    ...LocationHistoryFields @include(if: $locationHistory)
    partialData
  }
  context {
    party(limit: $limit, sort: $sort) {
      partyObject {
        ...EntityPartyFields
      }
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
  }
  topTransactions {
    ...EntityTransactionFields
  }
  balance
  missingClass @skip(if: $timeHistory) {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
  }
  otherClass @skip(if: $timeHistory) {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
  }
}
    ${EntityCategoryFieldsFragmentDoc}
${TimeHistoryFieldsFragmentDoc}
${DepartmentHistoryFieldsFragmentDoc}
${LocationHistoryFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}
${EntityTransactionFieldsFragmentDoc}`;
export const PartyHoverFieldsFragmentDoc = gql`
    fragment PartyHoverFields on PartyHover {
  __typename
  entity {
    __typename
    ... on EntityParty {
      ...EntityPartyFields
    }
  }
  history {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
  }
  context {
    category(limit: $limit, sort: $sort) {
      categoryObject {
        ...EntityCategoryFields
      }
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
  }
  topTransactions {
    ...EntityTransactionFields
  }
}
    ${EntityPartyFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}
${EntityTransactionFieldsFragmentDoc}`;
export const StatementSummaryLineItemHoverFieldsFragmentDoc = gql`
    fragment StatementSummaryLineItemHoverFields on SummaryLineItemHover {
  __typename
  lineType
  history {
    ...TimeHistoryFields @include(if: $timeHistory)
    ...DepartmentHistoryFields @include(if: $departmentHistory)
    ...LocationHistoryFields @include(if: $locationHistory)
    partialData
  }
  missingClass @skip(if: $timeHistory) {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
  }
  otherClass @skip(if: $timeHistory) {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
  }
}
    ${TimeHistoryFieldsFragmentDoc}
${DepartmentHistoryFieldsFragmentDoc}
${LocationHistoryFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;
export const InsightFieldsFragmentDoc = gql`
    fragment InsightFields on Insight {
  score
  globalScore
  subjectType
  subjectId
  subjectDisplayKey
  periodValue {
    ...MonetaryValueFields
  }
  absoluteDelta {
    ...MonetaryValueFields
  }
  comparisonPeriodValue {
    ...MonetaryValueFields
  }
  comparisonIntervalOffset
  ruleType
  sentence
  subjectIconUrl
  designation
  type
  productArea
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const StatementDetailsFieldsFragmentDoc = gql`
    fragment StatementDetailsFields on StatementDetails {
  hover {
    __typename
    ... on CategoryHover {
      ...StatementCategoryHoverFields
    }
    ... on PartyHover {
      ...PartyHoverFields
    }
    ... on SummaryLineItemHover {
      ...StatementSummaryLineItemHoverFields
    }
  }
  insight {
    ...InsightFields
  }
}
    ${StatementCategoryHoverFieldsFragmentDoc}
${PartyHoverFieldsFragmentDoc}
${StatementSummaryLineItemHoverFieldsFragmentDoc}
${InsightFieldsFragmentDoc}`;
export const CategoryHoverFieldsFragmentDoc = gql`
    fragment CategoryHoverFields on CategoryHover {
  __typename
  entity {
    __typename
    ... on EntityCategory {
      ...EntityCategoryFields
    }
  }
  history {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
  }
  context {
    party(limit: $limit, sort: $sort) {
      partyObject {
        ...EntityPartyFields
      }
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
  }
  topTransactions {
    ...EntityTransactionFields
  }
  balance
}
    ${EntityCategoryFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}
${EntityTransactionFieldsFragmentDoc}`;
export const SummaryLineItemHoverFieldsFragmentDoc = gql`
    fragment SummaryLineItemHoverFields on SummaryLineItemHover {
  __typename
  lineType
  history {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
  }
}
    ${TransactionSummaryFieldsFragmentDoc}`;
export const YtdStatementDetailsFieldsFragmentDoc = gql`
    fragment YtdStatementDetailsFields on StatementDetails {
  hover {
    __typename
    ... on CategoryHover {
      ...CategoryHoverFields
    }
    ... on PartyHover {
      ...PartyHoverFields
    }
    ... on SummaryLineItemHover {
      ...SummaryLineItemHoverFields
    }
  }
  insight {
    ...InsightFields
  }
}
    ${CategoryHoverFieldsFragmentDoc}
${PartyHoverFieldsFragmentDoc}
${SummaryLineItemHoverFieldsFragmentDoc}
${InsightFieldsFragmentDoc}`;
export const StatementDeltaValueFieldsFragmentDoc = gql`
    fragment StatementDeltaValueFields on StatementDeltaValue {
  moneyFlow {
    ...MoneyFlowFields
  }
  percentageOfAmount
}
    ${MoneyFlowFieldsFragmentDoc}`;
export const StatementDeltasFieldsFragmentDoc = gql`
    fragment StatementDeltasFields on StatementDeltas {
  percentageTotal {
    ...StatementDeltaValueFields
  }
  percentageIncome {
    ...StatementDeltaValueFields
  }
  previousPeriod {
    ...StatementDeltaValueFields
  }
  previousYear {
    ...StatementDeltaValueFields
  }
}
    ${StatementDeltaValueFieldsFragmentDoc}`;
export const StatementRowFieldsFragmentDoc = gql`
    fragment StatementRowFields on StatementRow {
  rowId
  depth
  sectionTitle {
    ...StatementRowTitleFields
  }
  sectionSummary {
    ...StatementRowSummaryFields
  }
  parentCategoryTitle {
    ...StatementRowTitleFields
  }
  parentCategorySummary {
    ...StatementRowSummaryFields
  }
  leafCategorySummary {
    ...StatementRowSummaryFields
  }
  agingTitle {
    ...StatementRowTitleFields
  }
  agingSummary {
    ...AgingSummaryFields
  }
  parentAgingTitle {
    ...StatementRowTitleFields
  }
  parentAgingSummary {
    ...AgingSummaryFields
  }
  leafAgingSummary {
    ...LeafAgingSummaryFields
  }
  details {
    ...StatementDetailsFields
  }
  ytdDetails {
    ...YtdStatementDetailsFields
  }
  deltas {
    ...StatementDeltasFields
  }
}
    ${StatementRowTitleFieldsFragmentDoc}
${StatementRowSummaryFieldsFragmentDoc}
${AgingSummaryFieldsFragmentDoc}
${LeafAgingSummaryFieldsFragmentDoc}
${StatementDetailsFieldsFragmentDoc}
${YtdStatementDetailsFieldsFragmentDoc}
${StatementDeltasFieldsFragmentDoc}`;
export const StatementFieldsFragmentDoc = gql`
    fragment StatementFields on Statement {
  kind
  rows {
    ...StatementRowFields
  }
}
    ${StatementRowFieldsFragmentDoc}`;
export const TrialBalanceRowFieldsFragmentDoc = gql`
    fragment TrialBalanceRowFields on TrialBalanceRow {
  rowId
  name
  debits {
    ...MonetaryValueFields
  }
  credits {
    ...MonetaryValueFields
  }
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const TrialBalanceFieldsFragmentDoc = gql`
    fragment TrialBalanceFields on TrialBalance {
  rows {
    ...TrialBalanceRowFields
  }
  categories {
    ...EntityCategoryFields
  }
}
    ${TrialBalanceRowFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}`;
export const ScheduleSpecializationFieldsFragmentDoc = gql`
    fragment ScheduleSpecializationFields on ScheduleSpecialization {
  id
  scheduleTemplateId
  name
  displayKey
  description
  organizationId
  legalEntityId
}
    `;
export const SearchResultFieldsFragmentDoc = gql`
    fragment SearchResultFields on SearchResult {
  total
  results {
    score
    highlights {
      field
      term
      start
      end
    }
    objectId {
      ...ObjectIdentifierFields
    }
  }
  entities {
    ...ObjectEntitiesFields
  }
  tookSecs
  kindCounts {
    kind
    count
  }
}
    ${ObjectIdentifierFieldsFragmentDoc}
${ObjectEntitiesFieldsFragmentDoc}`;
export const LegalEntityBadgeCountFieldsFragmentDoc = gql`
    fragment LegalEntityBadgeCountFields on LegalEntityBadgeCount {
  legalEntityId
  count
}
    `;
export const TransactionReviewReminderMessageFieldsFragmentDoc = gql`
    fragment TransactionReviewReminderMessageFields on TransactionReviewReminderMessage {
  legalEntityId
  message
}
    `;
export const TransactionReviewScheduleFieldsFragmentDoc = gql`
    fragment TransactionReviewScheduleFields on TransactionReviewSchedule {
  daysOfMonth
  daysOfWeek
  enabled
  legalEntityId
}
    `;
export const DepartmentFacetFieldsFragmentDoc = gql`
    fragment DepartmentFacetFields on DepartmentFacet {
  departmentObject {
    ...EntityDepartmentFields
  }
  count
}
    ${EntityDepartmentFieldsFragmentDoc}`;
export const EntityInstitutionFieldsFragmentDoc = gql`
    fragment EntityInstitutionFields on EntityInstitution {
  id
  name
  iconUrl
}
    `;
export const InstitutionFacetFieldsFragmentDoc = gql`
    fragment InstitutionFacetFields on InstitutionFacet {
  institutionObject {
    ...EntityInstitutionFields
  }
  count
}
    ${EntityInstitutionFieldsFragmentDoc}`;
export const TransactionEntryFieldsFragmentDoc = gql`
    fragment TransactionEntryFields on TransactionEntry {
  factId
  externalLineId
  description
  amount {
    ...MonetaryValueFields
  }
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const TransactionLineFieldsFragmentDoc = gql`
    fragment TransactionLineFields on TransactionLine {
  entry {
    ...TransactionEntryFields
  }
  entryType
  category {
    ...EntityCategoryFields
  }
  categoryClassificationProvenance {
    ...ClassificationProvenanceFields
  }
  party {
    ...EntityPartyFields
  }
  department {
    ...EntityDepartmentFields
  }
  location {
    ...EntityLocationFields
  }
  schedule {
    ...EntityScheduleFields
  }
}
    ${TransactionEntryFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}
${ClassificationProvenanceFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}
${EntityDepartmentFieldsFragmentDoc}
${EntityLocationFieldsFragmentDoc}
${EntityScheduleFieldsFragmentDoc}`;
export const LinkedBillFieldsFragmentDoc = gql`
    fragment LinkedBillFields on LinkedBill {
  id
  dataSourceId
  invoiceNumber
  dueDate
  billDate
  externalId
  providerType
  party {
    ...EntityPartyFields
  }
}
    ${EntityPartyFieldsFragmentDoc}`;
export const LinkedInvoiceFieldsFragmentDoc = gql`
    fragment LinkedInvoiceFields on LinkedInvoice {
  id
  dataSourceId
  invoiceNumber
  referenceNumber
  dueDate
  invoiceDate
  externalId
  providerType
  party {
    ...EntityPartyFields
  }
  status
}
    ${EntityPartyFieldsFragmentDoc}`;
export const LedgerTransactionFieldsFragmentDoc = gql`
    fragment LedgerTransactionFields on LedgerTransaction {
  timestamp
  externalId
  type
  memo
  referenceNumber
  lines {
    ...TransactionLineFields
  }
  sources {
    ...TransactionSourceFields
  }
  isMetadataEditable
  ledgerTransactionId
  compileSource
  matchedLedgerTransactionIds
  providerTypes
  isSupersedingLedgerTransaction
  supersededLedgerTransactionIds
  linkedBill {
    ...LinkedBillFields
  }
  linkedInvoice {
    ...LinkedInvoiceFields
  }
}
    ${TransactionLineFieldsFragmentDoc}
${TransactionSourceFieldsFragmentDoc}
${LinkedBillFieldsFragmentDoc}
${LinkedInvoiceFieldsFragmentDoc}`;
export const LedgerTransactionStaleFieldsFragmentDoc = gql`
    fragment LedgerTransactionStaleFields on LedgerTransactionStale {
  stale
  newViewAvailable
}
    `;
export const LocationFacetFieldsFragmentDoc = gql`
    fragment LocationFacetFields on LocationFacet {
  locationObject {
    ...EntityLocationFields
  }
  count
}
    ${EntityLocationFieldsFragmentDoc}`;
export const MatchedStatusFacetFieldsFragmentDoc = gql`
    fragment MatchedStatusFacetFields on MatchedStatusFacet {
  status
  count
}
    `;
export const MetricCategoriesOperandFieldsFragmentDoc = gql`
    fragment MetricCategoriesOperandFields on MetricCategoriesOperand {
  name
  categories {
    ...EntityCategoryFields
  }
  period {
    ...PeriodFields
  }
  isBalance
  naturalFlow
  defaultCategoryType
}
    ${EntityCategoryFieldsFragmentDoc}
${PeriodFieldsFragmentDoc}`;
export const MetricSummaryTypeOperandFieldsFragmentDoc = gql`
    fragment MetricSummaryTypeOperandFields on MetricSummaryTypeOperand {
  name
  type
  naturalFlow
  defaultCategoryType
  period {
    ...PeriodFields
  }
  isBalance
}
    ${PeriodFieldsFragmentDoc}`;
export const MetricOperationFieldsFragmentDoc = gql`
    fragment MetricOperationFields on MetricOperation {
  symbol
}
    `;
export const MetricTermFieldsFragmentDoc = gql`
    fragment MetricTermFields on MetricTerm {
  __typename
  ... on MetricCategoriesOperand {
    ...MetricCategoriesOperandFields
  }
  ... on MetricSummaryTypeOperand {
    ...MetricSummaryTypeOperandFields
  }
  ... on MetricOperation {
    ...MetricOperationFields
  }
}
    ${MetricCategoriesOperandFieldsFragmentDoc}
${MetricSummaryTypeOperandFieldsFragmentDoc}
${MetricOperationFieldsFragmentDoc}`;
export const MetricEquationFieldsFragmentDoc = gql`
    fragment MetricEquationFields on MetricEquation {
  terms {
    ...MetricTermFields
  }
}
    ${MetricTermFieldsFragmentDoc}`;
export const MinMaxAmountFieldsFragmentDoc = gql`
    fragment MinMaxAmountFields on MinMaxAmount {
  minAmount {
    ...MonetaryValueFields
  }
  maxAmount {
    ...MonetaryValueFields
  }
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const PartyFacetFieldsFragmentDoc = gql`
    fragment PartyFacetFields on PartyFacet {
  partyObject {
    ...EntityPartyFields
  }
  count
}
    ${EntityPartyFieldsFragmentDoc}`;
export const UserFacetFieldsFragmentDoc = gql`
    fragment UserFacetFields on UserFacet {
  userObject {
    ...EntityUserFields
  }
  count
}
    ${EntityUserFieldsFragmentDoc}`;
export const VanityStatsFieldsFragmentDoc = gql`
    fragment VanityStatsFields on VanityStats {
  totalTransactionsValue {
    ...MonetaryValueFields
  }
  totalParties
  totalPartiesIdentified
  totalCalculations
  totalTransactions
  totalTransactionsEnhanced
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const VaultSegmentFieldsFragmentDoc = gql`
    fragment VaultSegmentFields on Segment {
  __typename
  fileId
  fileSize
  fileName
  sequence
  collectionId
  token
}
    `;
export const VaultFormatFieldsFragmentDoc = gql`
    fragment VaultFormatFields on Format {
  __typename
  id
  formatClass
  mimeType
  segments {
    ...VaultSegmentFields
  }
}
    ${VaultSegmentFieldsFragmentDoc}`;
export const VaultFeatureGroupFieldsFragmentDoc = gql`
    fragment VaultFeatureGroupFields on FeatureGroup {
  featureGroupId
  kind
  position
}
    `;
export const TextFeatureValueFieldsFragmentDoc = gql`
    fragment TextFeatureValueFields on TextFeatureValue {
  __typename
  textValue
}
    `;
export const NumericFeatureValueFieldsFragmentDoc = gql`
    fragment NumericFeatureValueFields on NumericFeatureValue {
  __typename
  numericValue
}
    `;
export const DateFeatureValueFieldsFragmentDoc = gql`
    fragment DateFeatureValueFields on DateFeatureValue {
  __typename
  dateValue {
    year
    month
    day
  }
}
    `;
export const MonetaryFeatureValueFieldsFragmentDoc = gql`
    fragment MonetaryFeatureValueFields on MonetaryFeatureValue {
  __typename
  monetaryValue {
    ...MonetaryValueFields
  }
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const AddressFeatureValueFieldsFragmentDoc = gql`
    fragment AddressFeatureValueFields on AddressFeatureValue {
  __typename
  addressValue {
    ...AddressFields
  }
}
    ${AddressFieldsFragmentDoc}`;
export const LineItemFeatureValueFieldsFragmentDoc = gql`
    fragment LineItemFeatureValueFields on LineItemFeatureValue {
  __typename
  lineItemValue {
    description
    quantity
    rate {
      ...MonetaryValueFields
    }
    amount {
      ...MonetaryValueFields
    }
    position
    categoryId
  }
}
    ${MonetaryValueFieldsFragmentDoc}`;
export const RemittanceFeatureValueFieldsFragmentDoc = gql`
    fragment RemittanceFeatureValueFields on RemittanceFeatureValue {
  __typename
  remittanceValue {
    BankName
    BankAccountNumber
    BankAccountName
    BankRoutingNumber
    RemittanceType
  }
}
    `;
export const VaultFeatureFieldsFragmentDoc = gql`
    fragment VaultFeatureFields on Feature {
  __typename
  id
  kind
  groups {
    ...VaultFeatureGroupFields
  }
  value {
    ... on TextFeatureValue {
      ...TextFeatureValueFields
    }
    ... on NumericFeatureValue {
      ...NumericFeatureValueFields
    }
    ... on DateFeatureValue {
      ...DateFeatureValueFields
    }
    ... on MonetaryFeatureValue {
      ...MonetaryFeatureValueFields
    }
    ... on AddressFeatureValue {
      ...AddressFeatureValueFields
    }
    ... on LineItemFeatureValue {
      ...LineItemFeatureValueFields
    }
    ... on RemittanceFeatureValue {
      ...RemittanceFeatureValueFields
    }
  }
}
    ${VaultFeatureGroupFieldsFragmentDoc}
${TextFeatureValueFieldsFragmentDoc}
${NumericFeatureValueFieldsFragmentDoc}
${DateFeatureValueFieldsFragmentDoc}
${MonetaryFeatureValueFieldsFragmentDoc}
${AddressFeatureValueFieldsFragmentDoc}
${LineItemFeatureValueFieldsFragmentDoc}
${RemittanceFeatureValueFieldsFragmentDoc}`;
export const VaultFileFieldsFragmentDoc = gql`
    fragment VaultFileFields on RawDocument {
  __typename
  id
  collectionId
  sourceFormatId
  formats {
    ...VaultFormatFields
  }
  features {
    ...VaultFeatureFields
  }
  creator {
    ...EntityUserFields
  }
  dataSource {
    ...EntityDataSourceFields
  }
  createdAt
  updatedAt
  status
  asyncProcessingStatus
  title @client
  fileName @client
  fileSize @client
  mimeType @client
  thumbnail @client {
    ...VaultSegmentFields
  }
  sourceFormat @client {
    ...VaultFormatFields
  }
}
    ${VaultFormatFieldsFragmentDoc}
${VaultFeatureFieldsFragmentDoc}
${EntityUserFieldsFragmentDoc}
${EntityDataSourceFieldsFragmentDoc}
${VaultSegmentFieldsFragmentDoc}`;
export const VaultFeatureWithBoundingBoxFieldsFragmentDoc = gql`
    fragment VaultFeatureWithBoundingBoxFields on Feature {
  __typename
  id
  kind
  groups {
    ...VaultFeatureGroupFields
  }
  originX
  originY
  width
  height
  featurePage
  value {
    ... on TextFeatureValue {
      ...TextFeatureValueFields
    }
    ... on NumericFeatureValue {
      ...NumericFeatureValueFields
    }
    ... on DateFeatureValue {
      ...DateFeatureValueFields
    }
    ... on MonetaryFeatureValue {
      ...MonetaryFeatureValueFields
    }
    ... on AddressFeatureValue {
      ...AddressFeatureValueFields
    }
    ... on LineItemFeatureValue {
      ...LineItemFeatureValueFields
    }
    ... on RemittanceFeatureValue {
      ...RemittanceFeatureValueFields
    }
  }
}
    ${VaultFeatureGroupFieldsFragmentDoc}
${TextFeatureValueFieldsFragmentDoc}
${NumericFeatureValueFieldsFragmentDoc}
${DateFeatureValueFieldsFragmentDoc}
${MonetaryFeatureValueFieldsFragmentDoc}
${AddressFeatureValueFieldsFragmentDoc}
${LineItemFeatureValueFieldsFragmentDoc}
${RemittanceFeatureValueFieldsFragmentDoc}`;
export const VaultFileWithBoundingBoxesFieldsFragmentDoc = gql`
    fragment VaultFileWithBoundingBoxesFields on RawDocument {
  __typename
  id
  collectionId
  sourceFormatId
  formats {
    ...VaultFormatFields
  }
  features {
    ...VaultFeatureWithBoundingBoxFields
  }
  creator {
    ...EntityUserFields
  }
  dataSource {
    ...EntityDataSourceFields
  }
  createdAt
  updatedAt
  status
  asyncProcessingStatus
  title @client
  fileName @client
  fileSize @client
  mimeType @client
  thumbnail @client {
    ...VaultSegmentFields
  }
  sourceFormat @client {
    ...VaultFormatFields
  }
}
    ${VaultFormatFieldsFragmentDoc}
${VaultFeatureWithBoundingBoxFieldsFragmentDoc}
${EntityUserFieldsFragmentDoc}
${EntityDataSourceFieldsFragmentDoc}
${VaultSegmentFieldsFragmentDoc}`;
export const WalletStatementFieldsFragmentDoc = gql`
    fragment WalletStatementFields on RawDocument {
  __typename
  id
  collectionId
  createdAt
  features {
    __typename
    id
    kind
    value {
      ... on DateFeatureValue {
        __typename
        dateValue {
          year
          month
          day
        }
      }
    }
  }
}
    `;
export const TransactionReviewQuestionFieldsFragmentDoc = gql`
    fragment TransactionReviewQuestionFields on TransactionReviewQuestion {
  question
  createdAt
}
    `;
export const WorkflowActivityItemFieldsFragmentDoc = gql`
    fragment WorkflowActivityItemFields on WorkflowActivityItem {
  workflowId
  definitionName
  title
  status
  businessOutcome
  createdAt
  updatedAt
  completedAt
  message
  messageKind
  displayKey
  iconUrl
  targetAction
}
    `;
export const WorkflowEventFieldsFragmentDoc = gql`
    fragment WorkflowEventFields on WorkflowEvent {
  workflowId
  definitionName
  eventKind
  timestamp
  businessOutcome
}
    `;
export const BooksClosedDateFieldsFragmentDoc = gql`
    fragment BooksClosedDateFields on BooksClosedDate {
  legalEntityId
  latestBooksClosedDateFact
  user {
    ...EntityUserFields
  }
}
    ${EntityUserFieldsFragmentDoc}`;
export const CategoryMappingFieldsFragmentDoc = gql`
    fragment CategoryMappingFields on CategoryMapping {
  mappingValue
  mappingType
  product
  category {
    ...EntityCategoryFields
  }
}
    ${EntityCategoryFieldsFragmentDoc}`;
export const InstitutionFieldsFragmentDoc = gql`
    fragment InstitutionFields on Institution {
  id
  name
  url
  routingNumber
  iconUrl
  partyId
  createdAt
}
    `;
export const DataSourceFieldsFragmentDoc = gql`
    fragment DataSourceFields on DataSource {
  id
  legalEntityId
  status
  statusReason
  institution {
    ...InstitutionFields
  }
  providerType
  accountAlias
  createdAt
  updatedAt
}
    ${InstitutionFieldsFragmentDoc}`;
export const QuickBooksConfigFieldsFragmentDoc = gql`
    fragment QuickBooksConfigFields on QuickBooksConfig {
  id
  realmId
  createdAt
  updatedAt
}
    `;
export const PlaidConfigFieldsFragmentDoc = gql`
    fragment PlaidConfigFields on PlaidConfig {
  id
  itemId
  externalInstitutionId
  createdAt
  updatedAt
}
    `;
export const SourceAccountFieldsFragmentDoc = gql`
    fragment SourceAccountFields on SourceAccount {
  id
  externalId
  externalName
  externalOwnerName
  externalOfficialName
  externalType
  externalSubtype
  mask
  status
  ownerEmployeeId
}
    `;
export const EnrichedDataSourceFieldsFragmentDoc = gql`
    fragment EnrichedDataSourceFields on EnrichedDataSource {
  id
  legalEntityId
  status
  statusReason
  institution {
    ...PartyFields
  }
  quickBooksConfig {
    ...QuickBooksConfigFields
  }
  plaidConfig {
    ...PlaidConfigFields
  }
  providerType
  accountAlias
  createdAt
  updatedAt
  lastActivityAt
  sourceAccounts {
    ...SourceAccountFields
  }
  hasTransactions
}
    ${PartyFieldsFragmentDoc}
${QuickBooksConfigFieldsFragmentDoc}
${PlaidConfigFieldsFragmentDoc}
${SourceAccountFieldsFragmentDoc}`;
export const DataSourcePreferenceFieldsFragmentDoc = gql`
    fragment DataSourcePreferenceFields on DataSourcePreference {
  dataSourceId
  accountingBasis
  taxForm
  providerType
  departmentTerminology
}
    `;
export const DepartmentFieldsFragmentDoc = gql`
    fragment DepartmentFields on Department {
  id
  name
  parentId
  active
  ancestors {
    ...EntityDepartmentFields
  }
  description
  displayKey
  matches {
    id
    dataSourceId
  }
  dataSource {
    ...EntityDataSourceFields
  }
}
    ${EntityDepartmentFieldsFragmentDoc}
${EntityDataSourceFieldsFragmentDoc}`;
export const DocumentInitialSegmentFieldsFragmentDoc = gql`
    fragment DocumentInitialSegmentFields on DocumentInitialSegment {
  collectionId
  documentId
  downloadUrl
}
    `;
export const DoppelgangerPermitFieldsFragmentDoc = gql`
    fragment DoppelgangerPermitFields on DoppelgangerPermit {
  id
  user {
    ...UserFields
  }
  expiresAt
  createdAt
}
    ${UserFieldsFragmentDoc}`;
export const InvitationFieldsFragmentDoc = gql`
    fragment InvitationFields on Invitation {
  id
  invitationType
  recipient {
    givenName
    familyName
    emailAddress
    avatarUrl
  }
  sender {
    givenName
    familyName
    emailAddress
    avatarUrl
  }
  organization {
    ...OrganizationFields
  }
  role {
    ...RoleFields
  }
  status
  service
  organizationTemplateId
  createdAt
  updatedAt
  notifiedAt
}
    ${OrganizationFieldsFragmentDoc}
${RoleFieldsFragmentDoc}`;
export const EmployeeFieldsFragmentDoc = gql`
    fragment EmployeeFields on Employee {
  id
  organizationId
  givenName
  familyName
  avatarUrl
  emailAddress
  jobTitle
  lastActivityAt
  status
  role {
    ...RoleFields
  }
  defaultEntityRole {
    ...RoleFields
  }
  user {
    ...UserFields
  }
  invitation {
    ...InvitationFields
  }
  hiddenAt
  legalEntityRoles {
    legalEntityId
    role {
      ...RoleFields
    }
  }
}
    ${RoleFieldsFragmentDoc}
${UserFieldsFragmentDoc}
${InvitationFieldsFragmentDoc}`;
export const EmployeeAffiliationsFieldsFragmentDoc = gql`
    fragment EmployeeAffiliationsFields on EmployeeAffiliations {
  employee {
    ...EmployeeFields
  }
  affiliations {
    organization {
      ...EntityOrganizationFields
    }
    legalEntity {
      ...EntityLegalEntityFields
    }
    role {
      id
    }
  }
}
    ${EmployeeFieldsFragmentDoc}
${EntityOrganizationFieldsFragmentDoc}
${EntityLegalEntityFieldsFragmentDoc}`;
export const HighlightedTokenFieldsFragmentDoc = gql`
    fragment HighlightedTokenFields on HighlightedToken {
  token
  score
}
    `;
export const HighlightedTokensFieldsFragmentDoc = gql`
    fragment HighlightedTokensFields on HighlightedTokens {
  description {
    ...HighlightedTokenFields
  }
  name {
    ...HighlightedTokenFields
  }
}
    ${HighlightedTokenFieldsFragmentDoc}`;
export const LocationFieldsFragmentDoc = gql`
    fragment LocationFields on Location {
  id
  name
  parentId
  active
  ancestors {
    ...EntityLocationFields
  }
  description
  displayKey
  dataSource {
    ...EntityDataSourceFields
  }
}
    ${EntityLocationFieldsFragmentDoc}
${EntityDataSourceFieldsFragmentDoc}`;
export const OwnedSourceAccountFieldsFragmentDoc = gql`
    fragment OwnedSourceAccountFields on OwnedSourceAccount {
  sourceAccount {
    ...SourceAccountFields
  }
  owner {
    ...EmployeeFields
  }
}
    ${SourceAccountFieldsFragmentDoc}
${EmployeeFieldsFragmentDoc}`;
export const ProductGroupFieldsFragmentDoc = gql`
    fragment ProductGroupFields on ProductGroup {
  id
  name
  description
  iconDisplayKey
  iconColorKey
  customIconObjectName
  customIconUrl
  createdAt
  updatedAt
}
    `;
export const ReconciliationDiffTransactionFieldsFragmentDoc = gql`
    fragment ReconciliationDiffTransactionFields on ReconciliationDiffTransaction {
  transactionFactId
  transaction {
    ...TransactionFields
  }
  diffReasons
  fromStatus
  toStatus
  fromOccurredAt
  toOccurredAt
  fromAmount {
    ...MonetaryValueFields
  }
  toAmount {
    ...MonetaryValueFields
  }
  fromEntryType
  toEntryType
}
    ${TransactionFieldsFragmentDoc}
${MonetaryValueFieldsFragmentDoc}`;
export const ReconciliationDiffFieldsFragmentDoc = gql`
    fragment ReconciliationDiffFields on ReconciliationDiff {
  reconciliationId
  toStartDate {
    ...DateFields
  }
  toEndDate {
    ...DateFields
  }
  transactions {
    ...ReconciliationDiffTransactionFields
  }
}
    ${DateFieldsFragmentDoc}
${ReconciliationDiffTransactionFieldsFragmentDoc}`;
export const ReportPackageMetadataFieldsFragmentDoc = gql`
    fragment ReportPackageMetadataFields on ReportPackageMetadata {
  id
  versionId
  viewKey {
    ...ViewIdentifierFields
  }
  title
  status
  author {
    ...ContactFields
  }
  documents {
    ...ReportPackageDocumentMetadataFields
  }
  startedAt
  endedAt
  interval
  coverUrl
  publishedAsDraft
  createdAt
  updatedAt
  creationMethod
  versions {
    ...ReportPackageVersionMetadataFields
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${ContactFieldsFragmentDoc}
${ReportPackageDocumentMetadataFieldsFragmentDoc}
${ReportPackageVersionMetadataFieldsFragmentDoc}`;
export const ScheduleEventVariableTemplateFormulaFieldsFragmentDoc = gql`
    fragment ScheduleEventVariableTemplateFormulaFields on ScheduleEventVariableTemplateFormula {
  id
  displayName
}
    `;
export const ScheduleEventVariableTemplateFieldsFragmentDoc = gql`
    fragment ScheduleEventVariableTemplateFields on ScheduleEventVariableTemplate {
  id
  variableName
  displayName
  required
  ordinal
  formulas {
    ...ScheduleEventVariableTemplateFormulaFields
  }
  variableType
  displayMode
}
    ${ScheduleEventVariableTemplateFormulaFieldsFragmentDoc}`;
export const ScheduleEventTemplateFieldsFragmentDoc = gql`
    fragment ScheduleEventTemplateFields on ScheduleEventTemplate {
  id
  name
  description
  displayName
  ordinal
  isSingleton
  isTerminating
  isInstantiating
  inCreateFlow
  displayKey
  variables {
    ...ScheduleEventVariableTemplateFields
  }
}
    ${ScheduleEventVariableTemplateFieldsFragmentDoc}`;
export const ScheduleEventVariableFieldsFragmentDoc = gql`
    fragment ScheduleEventVariableFields on ScheduleEventVariable {
  id
  displayName
  variableName
  variableTemplateId
  variableType
  value {
    ... on ScheduleBooleanValue {
      boolValue
    }
    ... on ScheduleDateValue {
      dateValue
    }
    ... on ScheduleFloatValue {
      floatValue
    }
    ... on ScheduleFormulaValue {
      formulaId
      formulaDisplayName
    }
    ... on ScheduleIntervalValue {
      intervalValue
    }
    ... on ScheduleLongValue {
      longValue
    }
    ... on ScheduleMonetaryValue {
      monetaryValue {
        ...MonetaryValueFields
      }
    }
    ... on ScheduleStringValue {
      stringValue
    }
    ... on ScheduleCategoryValue {
      category {
        ...EntityCategoryFields
      }
    }
    ... on ScheduleTransactionValue {
      transaction {
        ...EntityTransactionFields
      }
    }
    ... on SchedulePartyValue {
      party {
        ...EntityPartyFields
      }
    }
    ... on ScheduleTermValue {
      intervalCount
      endDate
    }
  }
}
    ${MonetaryValueFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}
${EntityTransactionFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}`;
export const ScheduleEventFieldsFragmentDoc = gql`
    fragment ScheduleEventFields on ScheduleEvent {
  id
  displayName
  eventDate
  eventTemplateId
  isGenerated
  isInstantiating
  isTerminating
  isSingleton
  displayKey
  skipReason
  note
  createdAt
  createdBy {
    ...EntityUserFields
  }
  updatedAt
  updatedBy {
    ...EntityUserFields
  }
  variables {
    ...ScheduleEventVariableFields
  }
}
    ${EntityUserFieldsFragmentDoc}
${ScheduleEventVariableFieldsFragmentDoc}`;
export const ScheduleFieldsFragmentDoc = gql`
    fragment ScheduleFields on Schedule {
  id
  name
  description
  scheduleNumber
  scheduleTemplateId
  specializationId
  scheduleType
  sourceTransaction {
    ...EntityTransactionFields
  }
  party {
    ...EntityPartyFields
  }
  createdAt
  createdBy {
    ...EntityUserFields
  }
  updatedAt
  updatedBy {
    ...EntityUserFields
  }
  events {
    ...ScheduleEventFields
  }
  cutoverDate
  cutoverAmount {
    ...MonetaryValueFields
  }
}
    ${EntityTransactionFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}
${EntityUserFieldsFragmentDoc}
${ScheduleEventFieldsFragmentDoc}
${MonetaryValueFieldsFragmentDoc}`;
export const ScheduleSnapshotFieldsFragmentDoc = gql`
    fragment ScheduleSnapshotFields on ScheduleSnapshot {
  id
  name
  scheduleNumber
  scheduleType
  category {
    ...EntityCategoryFields
  }
  relatedCategory {
    ...EntityCategoryFields
  }
  party {
    ...EntityPartyFields
  }
  startDate
  endDate
  amount {
    ...MonetaryValueFields
  }
  remainingAmount {
    ...MonetaryValueFields
  }
  cutoverDate
  cutoverAmount {
    ...MonetaryValueFields
  }
}
    ${EntityCategoryFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}
${MonetaryValueFieldsFragmentDoc}`;
export const ScheduleTemplateFieldsFragmentDoc = gql`
    fragment ScheduleTemplateFields on ScheduleTemplate {
  id
  name
  description
  scheduleType
  displayKey
}
    `;
export const ThreadDetailsFieldsFragmentDoc = gql`
    fragment ThreadDetailsFields on ThreadDetails {
  id
  commentCount
  resolvedAt
  targetObject {
    ...ObjectIdentifierFields
  }
  authorId
  commenterIds
  tags {
    ...ObjectIdentifierFields
  }
  context
  pending @client
}
    ${ObjectIdentifierFieldsFragmentDoc}`;
export const CommentFieldsFragmentDoc = gql`
    fragment CommentFields on Comment {
  __typename
  id
  authorId
  text
  timestamp
  editedAt
  deletedAt
  layoutAttachment {
    layoutId
    legalEntityId
  }
  reactions
}
    `;
export const ThreadFieldsFragmentDoc = gql`
    fragment ThreadFields on Thread {
  __typename
  id
  details {
    ...ThreadDetailsFields
  }
  comments {
    ...CommentFields
  }
}
    ${ThreadDetailsFieldsFragmentDoc}
${CommentFieldsFragmentDoc}`;
export const ThreadWithEntitiesFieldsFragmentDoc = gql`
    fragment ThreadWithEntitiesFields on ThreadWithEntities {
  __typename
  thread {
    ...ThreadFields
  }
  entities {
    ...ObjectEntitiesFields
  }
}
    ${ThreadFieldsFragmentDoc}
${ObjectEntitiesFieldsFragmentDoc}`;
export const ThreadListFieldsFragmentDoc = gql`
    fragment ThreadListFields on ThreadList {
  targetObject {
    ...ObjectIdentifierFields
  }
  threads {
    ...ThreadDetailsFields
  }
}
    ${ObjectIdentifierFieldsFragmentDoc}
${ThreadDetailsFieldsFragmentDoc}`;
export const ThreadsFieldsFragmentDoc = gql`
    fragment ThreadsFields on Threads {
  threads {
    ...ThreadListFields
  }
  entities {
    ...ObjectEntitiesFields
  }
}
    ${ThreadListFieldsFragmentDoc}
${ObjectEntitiesFieldsFragmentDoc}`;
export const TransactionEntryLineFieldsFragmentDoc = gql`
    fragment TransactionEntryLineFields on TransactionEntryLine {
  lineId
  factId
  value {
    ...MonetaryValueFields
  }
  category {
    ...CategoryFields
  }
  categoryClassificationProvenance {
    ...ClassificationProvenanceFields
  }
  name
  description
  isCredit
  highlighted
}
    ${MonetaryValueFieldsFragmentDoc}
${CategoryFieldsFragmentDoc}
${ClassificationProvenanceFieldsFragmentDoc}`;
export const TransactionViewDetailFieldsFragmentDoc = gql`
    fragment TransactionViewDetailFields on TransactionViewDetail {
  id
  factId
  occurredAt
  externalCreatedAt
  externalId
  externalDisplayId
  quickbooksAppName
  name
  description
  creditAmount {
    ...MonetaryValueFields
  }
  debitAmount {
    ...MonetaryValueFields
  }
  creditCategoryHierarchy {
    ...CategoryFields
  }
  debitCategoryHierarchy {
    ...CategoryFields
  }
  entryLines {
    ...TransactionEntryLineFields
  }
  party {
    ...TransactionPartyFields
  }
  institution {
    ...InstitutionFields
  }
  sourceAccount {
    ...SourceAccountFields
  }
  recordType
}
    ${MonetaryValueFieldsFragmentDoc}
${CategoryFieldsFragmentDoc}
${TransactionEntryLineFieldsFragmentDoc}
${TransactionPartyFieldsFragmentDoc}
${InstitutionFieldsFragmentDoc}
${SourceAccountFieldsFragmentDoc}`;
export const WorkItemTransactionFieldsFragmentDoc = gql`
    fragment WorkItemTransactionFields on WorkItemTransaction {
  externalTransactionId
  externalTransactionLineId
  supportType
  displayCategory {
    ...EntityCategoryFields
  }
  displayPartyRole
  displayEntry
  splitCategory {
    ...EntityCategoryFields
  }
  description
  name
  party {
    ...EntityPartyFields
  }
  creditValue {
    ...MonetaryValueFields
  }
  debitValue {
    ...MonetaryValueFields
  }
  displayValue {
    ...MonetaryValueFields
  }
  moneyFlow {
    ...MoneyFlowFields
  }
  occurredAt
  dataSourceId
  quickbooksAppName
  ledgerTransactionId
}
    ${EntityCategoryFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}
${MonetaryValueFieldsFragmentDoc}
${MoneyFlowFieldsFragmentDoc}`;
export const WorkItemReviewFieldsFragmentDoc = gql`
    fragment WorkItemReviewFields on WorkItemReview {
  createdAt
  creator {
    ...EntityUserFields
  }
  updatedAt
  subject
}
    ${EntityUserFieldsFragmentDoc}`;
export const WorkItemGeneratedQuestionFieldsFragmentDoc = gql`
    fragment WorkItemGeneratedQuestionFields on WorkItemGeneratedQuestion {
  question
  contextType
  active
}
    `;
export const WorkItemPushFieldsFragmentDoc = gql`
    fragment WorkItemPushFields on WorkItemPush {
  field
  pushState
  errorType
  updatedAt
}
    `;
export const WorkItemFieldsFragmentDoc = gql`
    fragment WorkItemFields on WorkItem {
  legalEntityId
  workItemId
  time
  itemType
  itemState
  ledgerType
  createdAt
  updatedBy
  updatedAt
  actionable
  transactions {
    ...WorkItemTransactionFields
  }
  reviewState
  review {
    ...WorkItemReviewFields
  }
  generatedQuestions {
    ...WorkItemGeneratedQuestionFields
  }
  pushes {
    ...WorkItemPushFields
  }
}
    ${WorkItemTransactionFieldsFragmentDoc}
${WorkItemReviewFieldsFragmentDoc}
${WorkItemGeneratedQuestionFieldsFragmentDoc}
${WorkItemPushFieldsFragmentDoc}`;
export const WorkItemSummaryFieldsFragmentDoc = gql`
    fragment WorkItemSummaryFields on WorkItemSummary {
  period {
    ...PeriodFields
  }
  count
}
    ${PeriodFieldsFragmentDoc}`;
export const DeleteDocumentDocument = gql`
    mutation DeleteDocument($documentId: String!, $documentCollectionId: String!, $legalEntityId: String!) {
  deleteDocument(
    documentId: $documentId
    documentCollectionId: $documentCollectionId
    legalEntityId: $legalEntityId
  )
}
    `;
export type DeleteDocumentMutationFn = Apollo.MutationFunction<DeleteDocumentMutation, DeleteDocumentMutationVariables>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      documentCollectionId: // value for 'documentCollectionId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(DeleteDocumentDocument, options);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const ApproveObjectAccessRequestDocument = gql`
    mutation ApproveObjectAccessRequest($requestId: String!, $permission: Permission!, $constraint: AccessConstraint) {
  approveObjectAccessRequest(
    requestId: $requestId
    permission: $permission
    constraint: $constraint
  )
}
    `;
export type ApproveObjectAccessRequestMutationFn = Apollo.MutationFunction<ApproveObjectAccessRequestMutation, ApproveObjectAccessRequestMutationVariables>;

/**
 * __useApproveObjectAccessRequestMutation__
 *
 * To run a mutation, you first call `useApproveObjectAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveObjectAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveObjectAccessRequestMutation, { data, loading, error }] = useApproveObjectAccessRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *      permission: // value for 'permission'
 *      constraint: // value for 'constraint'
 *   },
 * });
 */
export function useApproveObjectAccessRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApproveObjectAccessRequestMutation, ApproveObjectAccessRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveObjectAccessRequestMutation, ApproveObjectAccessRequestMutationVariables>(ApproveObjectAccessRequestDocument, options);
      }
export type ApproveObjectAccessRequestMutationHookResult = ReturnType<typeof useApproveObjectAccessRequestMutation>;
export type ApproveObjectAccessRequestMutationResult = Apollo.MutationResult<ApproveObjectAccessRequestMutation>;
export type ApproveObjectAccessRequestMutationOptions = Apollo.BaseMutationOptions<ApproveObjectAccessRequestMutation, ApproveObjectAccessRequestMutationVariables>;
export const CreateIntentDocument = gql`
    mutation CreateIntent($identifier: InputObjectIdentifier!, $permissions: [NewUserGrant!]!, $message: String!, $sendNotification: Boolean!, $constraint: AccessConstraint, $viewKey: ViewKey) {
  createIntent(
    object: $identifier
    permissions: $permissions
    message: $message
    sendNotification: $sendNotification
    constraint: $constraint
    viewKey: $viewKey
  )
}
    `;
export type CreateIntentMutationFn = Apollo.MutationFunction<CreateIntentMutation, CreateIntentMutationVariables>;

/**
 * __useCreateIntentMutation__
 *
 * To run a mutation, you first call `useCreateIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntentMutation, { data, loading, error }] = useCreateIntentMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      permissions: // value for 'permissions'
 *      message: // value for 'message'
 *      sendNotification: // value for 'sendNotification'
 *      constraint: // value for 'constraint'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useCreateIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateIntentMutation, CreateIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIntentMutation, CreateIntentMutationVariables>(CreateIntentDocument, options);
      }
export type CreateIntentMutationHookResult = ReturnType<typeof useCreateIntentMutation>;
export type CreateIntentMutationResult = Apollo.MutationResult<CreateIntentMutation>;
export type CreateIntentMutationOptions = Apollo.BaseMutationOptions<CreateIntentMutation, CreateIntentMutationVariables>;
export const DisableObjectLinkDocument = gql`
    mutation DisableObjectLink($identifier: InputObjectIdentifier!) {
  disableObjectLink(object: $identifier)
}
    `;
export type DisableObjectLinkMutationFn = Apollo.MutationFunction<DisableObjectLinkMutation, DisableObjectLinkMutationVariables>;

/**
 * __useDisableObjectLinkMutation__
 *
 * To run a mutation, you first call `useDisableObjectLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableObjectLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableObjectLinkMutation, { data, loading, error }] = useDisableObjectLinkMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useDisableObjectLinkMutation(baseOptions?: Apollo.MutationHookOptions<DisableObjectLinkMutation, DisableObjectLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableObjectLinkMutation, DisableObjectLinkMutationVariables>(DisableObjectLinkDocument, options);
      }
export type DisableObjectLinkMutationHookResult = ReturnType<typeof useDisableObjectLinkMutation>;
export type DisableObjectLinkMutationResult = Apollo.MutationResult<DisableObjectLinkMutation>;
export type DisableObjectLinkMutationOptions = Apollo.BaseMutationOptions<DisableObjectLinkMutation, DisableObjectLinkMutationVariables>;
export const EnableObjectLinkDocument = gql`
    mutation EnableObjectLink($identifier: InputObjectIdentifier!, $permission: Permission!, $viewType: ViewType) {
  enableObjectLink(
    object: $identifier
    permission: $permission
    viewType: $viewType
  )
}
    `;
export type EnableObjectLinkMutationFn = Apollo.MutationFunction<EnableObjectLinkMutation, EnableObjectLinkMutationVariables>;

/**
 * __useEnableObjectLinkMutation__
 *
 * To run a mutation, you first call `useEnableObjectLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableObjectLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableObjectLinkMutation, { data, loading, error }] = useEnableObjectLinkMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      permission: // value for 'permission'
 *      viewType: // value for 'viewType'
 *   },
 * });
 */
export function useEnableObjectLinkMutation(baseOptions?: Apollo.MutationHookOptions<EnableObjectLinkMutation, EnableObjectLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableObjectLinkMutation, EnableObjectLinkMutationVariables>(EnableObjectLinkDocument, options);
      }
export type EnableObjectLinkMutationHookResult = ReturnType<typeof useEnableObjectLinkMutation>;
export type EnableObjectLinkMutationResult = Apollo.MutationResult<EnableObjectLinkMutation>;
export type EnableObjectLinkMutationOptions = Apollo.BaseMutationOptions<EnableObjectLinkMutation, EnableObjectLinkMutationVariables>;
export const GrantFromShareDocument = gql`
    mutation GrantFromShare($object: InputObjectIdentifier!, $intentId: String, $constraint: AccessConstraint) {
  grantFromShare(object: $object, intentId: $intentId, constraint: $constraint)
}
    `;
export type GrantFromShareMutationFn = Apollo.MutationFunction<GrantFromShareMutation, GrantFromShareMutationVariables>;

/**
 * __useGrantFromShareMutation__
 *
 * To run a mutation, you first call `useGrantFromShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantFromShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantFromShareMutation, { data, loading, error }] = useGrantFromShareMutation({
 *   variables: {
 *      object: // value for 'object'
 *      intentId: // value for 'intentId'
 *      constraint: // value for 'constraint'
 *   },
 * });
 */
export function useGrantFromShareMutation(baseOptions?: Apollo.MutationHookOptions<GrantFromShareMutation, GrantFromShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantFromShareMutation, GrantFromShareMutationVariables>(GrantFromShareDocument, options);
      }
export type GrantFromShareMutationHookResult = ReturnType<typeof useGrantFromShareMutation>;
export type GrantFromShareMutationResult = Apollo.MutationResult<GrantFromShareMutation>;
export type GrantFromShareMutationOptions = Apollo.BaseMutationOptions<GrantFromShareMutation, GrantFromShareMutationVariables>;
export const RejectObjectAccessRequestDocument = gql`
    mutation RejectObjectAccessRequest($requestId: String!) {
  rejectObjectAccessRequest(requestId: $requestId)
}
    `;
export type RejectObjectAccessRequestMutationFn = Apollo.MutationFunction<RejectObjectAccessRequestMutation, RejectObjectAccessRequestMutationVariables>;

/**
 * __useRejectObjectAccessRequestMutation__
 *
 * To run a mutation, you first call `useRejectObjectAccessRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectObjectAccessRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectObjectAccessRequestMutation, { data, loading, error }] = useRejectObjectAccessRequestMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useRejectObjectAccessRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectObjectAccessRequestMutation, RejectObjectAccessRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectObjectAccessRequestMutation, RejectObjectAccessRequestMutationVariables>(RejectObjectAccessRequestDocument, options);
      }
export type RejectObjectAccessRequestMutationHookResult = ReturnType<typeof useRejectObjectAccessRequestMutation>;
export type RejectObjectAccessRequestMutationResult = Apollo.MutationResult<RejectObjectAccessRequestMutation>;
export type RejectObjectAccessRequestMutationOptions = Apollo.BaseMutationOptions<RejectObjectAccessRequestMutation, RejectObjectAccessRequestMutationVariables>;
export const RequestObjectAccessDocument = gql`
    mutation RequestObjectAccess($object: InputObjectIdentifier!, $intentId: String, $constraint: AccessConstraint) {
  requestObjectAccess(
    object: $object
    intentId: $intentId
    constraint: $constraint
  )
}
    `;
export type RequestObjectAccessMutationFn = Apollo.MutationFunction<RequestObjectAccessMutation, RequestObjectAccessMutationVariables>;

/**
 * __useRequestObjectAccessMutation__
 *
 * To run a mutation, you first call `useRequestObjectAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestObjectAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestObjectAccessMutation, { data, loading, error }] = useRequestObjectAccessMutation({
 *   variables: {
 *      object: // value for 'object'
 *      intentId: // value for 'intentId'
 *      constraint: // value for 'constraint'
 *   },
 * });
 */
export function useRequestObjectAccessMutation(baseOptions?: Apollo.MutationHookOptions<RequestObjectAccessMutation, RequestObjectAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestObjectAccessMutation, RequestObjectAccessMutationVariables>(RequestObjectAccessDocument, options);
      }
export type RequestObjectAccessMutationHookResult = ReturnType<typeof useRequestObjectAccessMutation>;
export type RequestObjectAccessMutationResult = Apollo.MutationResult<RequestObjectAccessMutation>;
export type RequestObjectAccessMutationOptions = Apollo.BaseMutationOptions<RequestObjectAccessMutation, RequestObjectAccessMutationVariables>;
export const RevokeGrantDocument = gql`
    mutation RevokeGrant($grantId: String!, $identifier: InputObjectIdentifier!, $constraint: AccessConstraint) {
  revokeGrant(grantId: $grantId, object: $identifier, constraint: $constraint)
}
    `;
export type RevokeGrantMutationFn = Apollo.MutationFunction<RevokeGrantMutation, RevokeGrantMutationVariables>;

/**
 * __useRevokeGrantMutation__
 *
 * To run a mutation, you first call `useRevokeGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeGrantMutation, { data, loading, error }] = useRevokeGrantMutation({
 *   variables: {
 *      grantId: // value for 'grantId'
 *      identifier: // value for 'identifier'
 *      constraint: // value for 'constraint'
 *   },
 * });
 */
export function useRevokeGrantMutation(baseOptions?: Apollo.MutationHookOptions<RevokeGrantMutation, RevokeGrantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeGrantMutation, RevokeGrantMutationVariables>(RevokeGrantDocument, options);
      }
export type RevokeGrantMutationHookResult = ReturnType<typeof useRevokeGrantMutation>;
export type RevokeGrantMutationResult = Apollo.MutationResult<RevokeGrantMutation>;
export type RevokeGrantMutationOptions = Apollo.BaseMutationOptions<RevokeGrantMutation, RevokeGrantMutationVariables>;
export const RevokeIntentDocument = gql`
    mutation RevokeIntent($intentId: String!, $identifier: InputObjectIdentifier!, $constraint: AccessConstraint) {
  revokeIntent(intentId: $intentId, object: $identifier, constraint: $constraint)
}
    `;
export type RevokeIntentMutationFn = Apollo.MutationFunction<RevokeIntentMutation, RevokeIntentMutationVariables>;

/**
 * __useRevokeIntentMutation__
 *
 * To run a mutation, you first call `useRevokeIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeIntentMutation, { data, loading, error }] = useRevokeIntentMutation({
 *   variables: {
 *      intentId: // value for 'intentId'
 *      identifier: // value for 'identifier'
 *      constraint: // value for 'constraint'
 *   },
 * });
 */
export function useRevokeIntentMutation(baseOptions?: Apollo.MutationHookOptions<RevokeIntentMutation, RevokeIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeIntentMutation, RevokeIntentMutationVariables>(RevokeIntentDocument, options);
      }
export type RevokeIntentMutationHookResult = ReturnType<typeof useRevokeIntentMutation>;
export type RevokeIntentMutationResult = Apollo.MutationResult<RevokeIntentMutation>;
export type RevokeIntentMutationOptions = Apollo.BaseMutationOptions<RevokeIntentMutation, RevokeIntentMutationVariables>;
export const UpdateGrantDocument = gql`
    mutation UpdateGrant($grantId: String!, $identifier: InputObjectIdentifier!, $permission: Permission!, $constraint: AccessConstraint) {
  updateGrant(
    grantId: $grantId
    object: $identifier
    permission: $permission
    constraint: $constraint
  )
}
    `;
export type UpdateGrantMutationFn = Apollo.MutationFunction<UpdateGrantMutation, UpdateGrantMutationVariables>;

/**
 * __useUpdateGrantMutation__
 *
 * To run a mutation, you first call `useUpdateGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGrantMutation, { data, loading, error }] = useUpdateGrantMutation({
 *   variables: {
 *      grantId: // value for 'grantId'
 *      identifier: // value for 'identifier'
 *      permission: // value for 'permission'
 *      constraint: // value for 'constraint'
 *   },
 * });
 */
export function useUpdateGrantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGrantMutation, UpdateGrantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGrantMutation, UpdateGrantMutationVariables>(UpdateGrantDocument, options);
      }
export type UpdateGrantMutationHookResult = ReturnType<typeof useUpdateGrantMutation>;
export type UpdateGrantMutationResult = Apollo.MutationResult<UpdateGrantMutation>;
export type UpdateGrantMutationOptions = Apollo.BaseMutationOptions<UpdateGrantMutation, UpdateGrantMutationVariables>;
export const UpdateIntentDocument = gql`
    mutation UpdateIntent($intentId: String!, $identifier: InputObjectIdentifier!, $permission: Permission!, $constraint: AccessConstraint) {
  updateIntent(
    intentId: $intentId
    object: $identifier
    permission: $permission
    constraint: $constraint
  )
}
    `;
export type UpdateIntentMutationFn = Apollo.MutationFunction<UpdateIntentMutation, UpdateIntentMutationVariables>;

/**
 * __useUpdateIntentMutation__
 *
 * To run a mutation, you first call `useUpdateIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntentMutation, { data, loading, error }] = useUpdateIntentMutation({
 *   variables: {
 *      intentId: // value for 'intentId'
 *      identifier: // value for 'identifier'
 *      permission: // value for 'permission'
 *      constraint: // value for 'constraint'
 *   },
 * });
 */
export function useUpdateIntentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIntentMutation, UpdateIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIntentMutation, UpdateIntentMutationVariables>(UpdateIntentDocument, options);
      }
export type UpdateIntentMutationHookResult = ReturnType<typeof useUpdateIntentMutation>;
export type UpdateIntentMutationResult = Apollo.MutationResult<UpdateIntentMutation>;
export type UpdateIntentMutationOptions = Apollo.BaseMutationOptions<UpdateIntentMutation, UpdateIntentMutationVariables>;
export const UpdateObjectLinkDocument = gql`
    mutation UpdateObjectLink($identifier: InputObjectIdentifier!, $permission: Permission!) {
  updateObjectLink(object: $identifier, permission: $permission)
}
    `;
export type UpdateObjectLinkMutationFn = Apollo.MutationFunction<UpdateObjectLinkMutation, UpdateObjectLinkMutationVariables>;

/**
 * __useUpdateObjectLinkMutation__
 *
 * To run a mutation, you first call `useUpdateObjectLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateObjectLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateObjectLinkMutation, { data, loading, error }] = useUpdateObjectLinkMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      permission: // value for 'permission'
 *   },
 * });
 */
export function useUpdateObjectLinkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateObjectLinkMutation, UpdateObjectLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateObjectLinkMutation, UpdateObjectLinkMutationVariables>(UpdateObjectLinkDocument, options);
      }
export type UpdateObjectLinkMutationHookResult = ReturnType<typeof useUpdateObjectLinkMutation>;
export type UpdateObjectLinkMutationResult = Apollo.MutationResult<UpdateObjectLinkMutation>;
export type UpdateObjectLinkMutationOptions = Apollo.BaseMutationOptions<UpdateObjectLinkMutation, UpdateObjectLinkMutationVariables>;
export const ListObjectAcLsDocument = gql`
    query ListObjectACLs($ids: [String!]!, $kind: ObjectKind!, $legalEntityId: String!) {
  listObjectACLs(ids: $ids, kind: $kind, legalEntityId: $legalEntityId) {
    ...ObjectACLFields
  }
}
    ${ObjectAclFieldsFragmentDoc}`;

/**
 * __useListObjectAcLsQuery__
 *
 * To run a query within a React component, call `useListObjectAcLsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListObjectAcLsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListObjectAcLsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      kind: // value for 'kind'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListObjectAcLsQuery(baseOptions: Apollo.QueryHookOptions<ListObjectAcLsQuery, ListObjectAcLsQueryVariables> & ({ variables: ListObjectAcLsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListObjectAcLsQuery, ListObjectAcLsQueryVariables>(ListObjectAcLsDocument, options);
      }
export function useListObjectAcLsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListObjectAcLsQuery, ListObjectAcLsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListObjectAcLsQuery, ListObjectAcLsQueryVariables>(ListObjectAcLsDocument, options);
        }
export function useListObjectAcLsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListObjectAcLsQuery, ListObjectAcLsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListObjectAcLsQuery, ListObjectAcLsQueryVariables>(ListObjectAcLsDocument, options);
        }
export type ListObjectAcLsQueryHookResult = ReturnType<typeof useListObjectAcLsQuery>;
export type ListObjectAcLsLazyQueryHookResult = ReturnType<typeof useListObjectAcLsLazyQuery>;
export type ListObjectAcLsSuspenseQueryHookResult = ReturnType<typeof useListObjectAcLsSuspenseQuery>;
export type ListObjectAcLsQueryResult = Apollo.QueryResult<ListObjectAcLsQuery, ListObjectAcLsQueryVariables>;
export const ReadShareDocument = gql`
    query ReadShare($id: String!, $kind: ObjectKind!, $intentId: String) {
  readShare(id: $id, kind: $kind, intentId: $intentId) {
    object {
      ...ObjectIdentifierFields
    }
    permission
    action
    legalEntity {
      id
      slug
      name
    }
    organizationPreview {
      id
      slug
      name
    }
    viewType
  }
}
    ${ObjectIdentifierFieldsFragmentDoc}`;

/**
 * __useReadShareQuery__
 *
 * To run a query within a React component, call `useReadShareQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadShareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadShareQuery({
 *   variables: {
 *      id: // value for 'id'
 *      kind: // value for 'kind'
 *      intentId: // value for 'intentId'
 *   },
 * });
 */
export function useReadShareQuery(baseOptions: Apollo.QueryHookOptions<ReadShareQuery, ReadShareQueryVariables> & ({ variables: ReadShareQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadShareQuery, ReadShareQueryVariables>(ReadShareDocument, options);
      }
export function useReadShareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadShareQuery, ReadShareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadShareQuery, ReadShareQueryVariables>(ReadShareDocument, options);
        }
export function useReadShareSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadShareQuery, ReadShareQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadShareQuery, ReadShareQueryVariables>(ReadShareDocument, options);
        }
export type ReadShareQueryHookResult = ReturnType<typeof useReadShareQuery>;
export type ReadShareLazyQueryHookResult = ReturnType<typeof useReadShareLazyQuery>;
export type ReadShareSuspenseQueryHookResult = ReturnType<typeof useReadShareSuspenseQuery>;
export type ReadShareQueryResult = Apollo.QueryResult<ReadShareQuery, ReadShareQueryVariables>;
export const ReadShareAdjacencyDocument = gql`
    query ReadShareAdjacency($id: String!, $kind: ObjectKind!, $legalEntitySlug: String!) {
  readShareAdjacency(id: $id, kind: $kind, legalEntitySlug: $legalEntitySlug) {
    object {
      ...ObjectIdentifierFields
    }
    legalEntity {
      id
      slug
      name
    }
    organizationPreview {
      id
      slug
      name
    }
    viewType
  }
}
    ${ObjectIdentifierFieldsFragmentDoc}`;

/**
 * __useReadShareAdjacencyQuery__
 *
 * To run a query within a React component, call `useReadShareAdjacencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadShareAdjacencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadShareAdjacencyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      kind: // value for 'kind'
 *      legalEntitySlug: // value for 'legalEntitySlug'
 *   },
 * });
 */
export function useReadShareAdjacencyQuery(baseOptions: Apollo.QueryHookOptions<ReadShareAdjacencyQuery, ReadShareAdjacencyQueryVariables> & ({ variables: ReadShareAdjacencyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadShareAdjacencyQuery, ReadShareAdjacencyQueryVariables>(ReadShareAdjacencyDocument, options);
      }
export function useReadShareAdjacencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadShareAdjacencyQuery, ReadShareAdjacencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadShareAdjacencyQuery, ReadShareAdjacencyQueryVariables>(ReadShareAdjacencyDocument, options);
        }
export function useReadShareAdjacencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadShareAdjacencyQuery, ReadShareAdjacencyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadShareAdjacencyQuery, ReadShareAdjacencyQueryVariables>(ReadShareAdjacencyDocument, options);
        }
export type ReadShareAdjacencyQueryHookResult = ReturnType<typeof useReadShareAdjacencyQuery>;
export type ReadShareAdjacencyLazyQueryHookResult = ReturnType<typeof useReadShareAdjacencyLazyQuery>;
export type ReadShareAdjacencySuspenseQueryHookResult = ReturnType<typeof useReadShareAdjacencySuspenseQuery>;
export type ReadShareAdjacencyQueryResult = Apollo.QueryResult<ReadShareAdjacencyQuery, ReadShareAdjacencyQueryVariables>;
export const ReadUserAclDocument = gql`
    query ReadUserACL {
  readUserACL {
    ...UserACLFields
  }
}
    ${UserAclFieldsFragmentDoc}`;

/**
 * __useReadUserAclQuery__
 *
 * To run a query within a React component, call `useReadUserAclQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadUserAclQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadUserAclQuery({
 *   variables: {
 *   },
 * });
 */
export function useReadUserAclQuery(baseOptions?: Apollo.QueryHookOptions<ReadUserAclQuery, ReadUserAclQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadUserAclQuery, ReadUserAclQueryVariables>(ReadUserAclDocument, options);
      }
export function useReadUserAclLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadUserAclQuery, ReadUserAclQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadUserAclQuery, ReadUserAclQueryVariables>(ReadUserAclDocument, options);
        }
export function useReadUserAclSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadUserAclQuery, ReadUserAclQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadUserAclQuery, ReadUserAclQueryVariables>(ReadUserAclDocument, options);
        }
export type ReadUserAclQueryHookResult = ReturnType<typeof useReadUserAclQuery>;
export type ReadUserAclLazyQueryHookResult = ReturnType<typeof useReadUserAclLazyQuery>;
export type ReadUserAclSuspenseQueryHookResult = ReturnType<typeof useReadUserAclSuspenseQuery>;
export type ReadUserAclQueryResult = Apollo.QueryResult<ReadUserAclQuery, ReadUserAclQueryVariables>;
export const CancelReconciliationIntentsDocument = gql`
    mutation CancelReconciliationIntents($legalEntityId: String!, $reconciliationIntentIds: [String!]!) {
  cancelReconciliationIntents(
    legalEntityId: $legalEntityId
    reconciliationIntentIds: $reconciliationIntentIds
  )
}
    `;
export type CancelReconciliationIntentsMutationFn = Apollo.MutationFunction<CancelReconciliationIntentsMutation, CancelReconciliationIntentsMutationVariables>;

/**
 * __useCancelReconciliationIntentsMutation__
 *
 * To run a mutation, you first call `useCancelReconciliationIntentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelReconciliationIntentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelReconciliationIntentsMutation, { data, loading, error }] = useCancelReconciliationIntentsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      reconciliationIntentIds: // value for 'reconciliationIntentIds'
 *   },
 * });
 */
export function useCancelReconciliationIntentsMutation(baseOptions?: Apollo.MutationHookOptions<CancelReconciliationIntentsMutation, CancelReconciliationIntentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelReconciliationIntentsMutation, CancelReconciliationIntentsMutationVariables>(CancelReconciliationIntentsDocument, options);
      }
export type CancelReconciliationIntentsMutationHookResult = ReturnType<typeof useCancelReconciliationIntentsMutation>;
export type CancelReconciliationIntentsMutationResult = Apollo.MutationResult<CancelReconciliationIntentsMutation>;
export type CancelReconciliationIntentsMutationOptions = Apollo.BaseMutationOptions<CancelReconciliationIntentsMutation, CancelReconciliationIntentsMutationVariables>;
export const CreateAccountReconciliationDocument = gql`
    mutation CreateAccountReconciliation($legalEntityId: String!, $viewKey: ViewKey!, $reconciliation: InputAccountReconciliation!) {
  createAccountReconciliation(
    legalEntityId: $legalEntityId
    viewKey: $viewKey
    reconciliation: $reconciliation
  )
}
    `;
export type CreateAccountReconciliationMutationFn = Apollo.MutationFunction<CreateAccountReconciliationMutation, CreateAccountReconciliationMutationVariables>;

/**
 * __useCreateAccountReconciliationMutation__
 *
 * To run a mutation, you first call `useCreateAccountReconciliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountReconciliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountReconciliationMutation, { data, loading, error }] = useCreateAccountReconciliationMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      viewKey: // value for 'viewKey'
 *      reconciliation: // value for 'reconciliation'
 *   },
 * });
 */
export function useCreateAccountReconciliationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountReconciliationMutation, CreateAccountReconciliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountReconciliationMutation, CreateAccountReconciliationMutationVariables>(CreateAccountReconciliationDocument, options);
      }
export type CreateAccountReconciliationMutationHookResult = ReturnType<typeof useCreateAccountReconciliationMutation>;
export type CreateAccountReconciliationMutationResult = Apollo.MutationResult<CreateAccountReconciliationMutation>;
export type CreateAccountReconciliationMutationOptions = Apollo.BaseMutationOptions<CreateAccountReconciliationMutation, CreateAccountReconciliationMutationVariables>;
export const CreateReconciliationFlagsTransactionsDocument = gql`
    mutation CreateReconciliationFlagsTransactions($reconciliationIntentId: String!, $flags: [CreateReconciliationFlagsTransactionsInput!]!, $viewKey: ViewKey!) {
  createReconciliationFlagsTransactions(
    reconciliationIntentId: $reconciliationIntentId
    flags: $flags
    viewKey: $viewKey
  )
}
    `;
export type CreateReconciliationFlagsTransactionsMutationFn = Apollo.MutationFunction<CreateReconciliationFlagsTransactionsMutation, CreateReconciliationFlagsTransactionsMutationVariables>;

/**
 * __useCreateReconciliationFlagsTransactionsMutation__
 *
 * To run a mutation, you first call `useCreateReconciliationFlagsTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReconciliationFlagsTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReconciliationFlagsTransactionsMutation, { data, loading, error }] = useCreateReconciliationFlagsTransactionsMutation({
 *   variables: {
 *      reconciliationIntentId: // value for 'reconciliationIntentId'
 *      flags: // value for 'flags'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useCreateReconciliationFlagsTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateReconciliationFlagsTransactionsMutation, CreateReconciliationFlagsTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReconciliationFlagsTransactionsMutation, CreateReconciliationFlagsTransactionsMutationVariables>(CreateReconciliationFlagsTransactionsDocument, options);
      }
export type CreateReconciliationFlagsTransactionsMutationHookResult = ReturnType<typeof useCreateReconciliationFlagsTransactionsMutation>;
export type CreateReconciliationFlagsTransactionsMutationResult = Apollo.MutationResult<CreateReconciliationFlagsTransactionsMutation>;
export type CreateReconciliationFlagsTransactionsMutationOptions = Apollo.BaseMutationOptions<CreateReconciliationFlagsTransactionsMutation, CreateReconciliationFlagsTransactionsMutationVariables>;
export const CreateReconciliationIntentsDocument = gql`
    mutation CreateReconciliationIntents($legalEntityId: String!, $documentIds: [String!]!, $documentCollectionId: String, $intentCategoryId: String, $reconciliationId: String, $reconciliationCategoryId: String, $actionItemId: String) {
  createReconciliationIntents(
    legalEntityId: $legalEntityId
    documentIds: $documentIds
    documentCollectionId: $documentCollectionId
    intentCategoryId: $intentCategoryId
    reconciliationId: $reconciliationId
    reconciliationCategoryId: $reconciliationCategoryId
    actionItemId: $actionItemId
  ) {
    createReconciliationIntentResponses {
      reconciliationIntentId
      state
    }
  }
}
    `;
export type CreateReconciliationIntentsMutationFn = Apollo.MutationFunction<CreateReconciliationIntentsMutation, CreateReconciliationIntentsMutationVariables>;

/**
 * __useCreateReconciliationIntentsMutation__
 *
 * To run a mutation, you first call `useCreateReconciliationIntentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReconciliationIntentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReconciliationIntentsMutation, { data, loading, error }] = useCreateReconciliationIntentsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      documentIds: // value for 'documentIds'
 *      documentCollectionId: // value for 'documentCollectionId'
 *      intentCategoryId: // value for 'intentCategoryId'
 *      reconciliationId: // value for 'reconciliationId'
 *      reconciliationCategoryId: // value for 'reconciliationCategoryId'
 *      actionItemId: // value for 'actionItemId'
 *   },
 * });
 */
export function useCreateReconciliationIntentsMutation(baseOptions?: Apollo.MutationHookOptions<CreateReconciliationIntentsMutation, CreateReconciliationIntentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReconciliationIntentsMutation, CreateReconciliationIntentsMutationVariables>(CreateReconciliationIntentsDocument, options);
      }
export type CreateReconciliationIntentsMutationHookResult = ReturnType<typeof useCreateReconciliationIntentsMutation>;
export type CreateReconciliationIntentsMutationResult = Apollo.MutationResult<CreateReconciliationIntentsMutation>;
export type CreateReconciliationIntentsMutationOptions = Apollo.BaseMutationOptions<CreateReconciliationIntentsMutation, CreateReconciliationIntentsMutationVariables>;
export const DeleteAccountReconciliationDocument = gql`
    mutation DeleteAccountReconciliation($legalEntityId: String!, $reconciliationId: String!) {
  deleteAccountReconciliation(
    legalEntityId: $legalEntityId
    reconciliationId: $reconciliationId
  )
}
    `;
export type DeleteAccountReconciliationMutationFn = Apollo.MutationFunction<DeleteAccountReconciliationMutation, DeleteAccountReconciliationMutationVariables>;

/**
 * __useDeleteAccountReconciliationMutation__
 *
 * To run a mutation, you first call `useDeleteAccountReconciliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountReconciliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountReconciliationMutation, { data, loading, error }] = useDeleteAccountReconciliationMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      reconciliationId: // value for 'reconciliationId'
 *   },
 * });
 */
export function useDeleteAccountReconciliationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountReconciliationMutation, DeleteAccountReconciliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountReconciliationMutation, DeleteAccountReconciliationMutationVariables>(DeleteAccountReconciliationDocument, options);
      }
export type DeleteAccountReconciliationMutationHookResult = ReturnType<typeof useDeleteAccountReconciliationMutation>;
export type DeleteAccountReconciliationMutationResult = Apollo.MutationResult<DeleteAccountReconciliationMutation>;
export type DeleteAccountReconciliationMutationOptions = Apollo.BaseMutationOptions<DeleteAccountReconciliationMutation, DeleteAccountReconciliationMutationVariables>;
export const DeletePotentialDuplicateFlagTransactionsDocument = gql`
    mutation DeletePotentialDuplicateFlagTransactions($reconciliationIntentId: String!, $flag: DeletePotentialDuplicateFlagTransactionsInput!, $viewKey: ViewKey!) {
  deletePotentialDuplicateFlagTransactions(
    reconciliationIntentId: $reconciliationIntentId
    flag: $flag
    viewKey: $viewKey
  )
}
    `;
export type DeletePotentialDuplicateFlagTransactionsMutationFn = Apollo.MutationFunction<DeletePotentialDuplicateFlagTransactionsMutation, DeletePotentialDuplicateFlagTransactionsMutationVariables>;

/**
 * __useDeletePotentialDuplicateFlagTransactionsMutation__
 *
 * To run a mutation, you first call `useDeletePotentialDuplicateFlagTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePotentialDuplicateFlagTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePotentialDuplicateFlagTransactionsMutation, { data, loading, error }] = useDeletePotentialDuplicateFlagTransactionsMutation({
 *   variables: {
 *      reconciliationIntentId: // value for 'reconciliationIntentId'
 *      flag: // value for 'flag'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useDeletePotentialDuplicateFlagTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<DeletePotentialDuplicateFlagTransactionsMutation, DeletePotentialDuplicateFlagTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePotentialDuplicateFlagTransactionsMutation, DeletePotentialDuplicateFlagTransactionsMutationVariables>(DeletePotentialDuplicateFlagTransactionsDocument, options);
      }
export type DeletePotentialDuplicateFlagTransactionsMutationHookResult = ReturnType<typeof useDeletePotentialDuplicateFlagTransactionsMutation>;
export type DeletePotentialDuplicateFlagTransactionsMutationResult = Apollo.MutationResult<DeletePotentialDuplicateFlagTransactionsMutation>;
export type DeletePotentialDuplicateFlagTransactionsMutationOptions = Apollo.BaseMutationOptions<DeletePotentialDuplicateFlagTransactionsMutation, DeletePotentialDuplicateFlagTransactionsMutationVariables>;
export const ExportReconciliationsPdfsDocument = gql`
    mutation ExportReconciliationsPdfs($viewKey: ViewKey!, $reconciliationIds: [String!]!, $documentCollectionId: String!) {
  exportReconciliationsPdfs(
    viewKey: $viewKey
    reconciliationIds: $reconciliationIds
    documentCollectionId: $documentCollectionId
  )
}
    `;
export type ExportReconciliationsPdfsMutationFn = Apollo.MutationFunction<ExportReconciliationsPdfsMutation, ExportReconciliationsPdfsMutationVariables>;

/**
 * __useExportReconciliationsPdfsMutation__
 *
 * To run a mutation, you first call `useExportReconciliationsPdfsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportReconciliationsPdfsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportReconciliationsPdfsMutation, { data, loading, error }] = useExportReconciliationsPdfsMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      reconciliationIds: // value for 'reconciliationIds'
 *      documentCollectionId: // value for 'documentCollectionId'
 *   },
 * });
 */
export function useExportReconciliationsPdfsMutation(baseOptions?: Apollo.MutationHookOptions<ExportReconciliationsPdfsMutation, ExportReconciliationsPdfsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportReconciliationsPdfsMutation, ExportReconciliationsPdfsMutationVariables>(ExportReconciliationsPdfsDocument, options);
      }
export type ExportReconciliationsPdfsMutationHookResult = ReturnType<typeof useExportReconciliationsPdfsMutation>;
export type ExportReconciliationsPdfsMutationResult = Apollo.MutationResult<ExportReconciliationsPdfsMutation>;
export type ExportReconciliationsPdfsMutationOptions = Apollo.BaseMutationOptions<ExportReconciliationsPdfsMutation, ExportReconciliationsPdfsMutationVariables>;
export const FinalizeAccountReconciliationDocument = gql`
    mutation FinalizeAccountReconciliation($legalEntityId: String!, $reconciliationId: String!, $viewKey: ViewKey!) {
  finalizeAccountReconciliation(
    legalEntityId: $legalEntityId
    reconciliationId: $reconciliationId
    viewKey: $viewKey
  )
}
    `;
export type FinalizeAccountReconciliationMutationFn = Apollo.MutationFunction<FinalizeAccountReconciliationMutation, FinalizeAccountReconciliationMutationVariables>;

/**
 * __useFinalizeAccountReconciliationMutation__
 *
 * To run a mutation, you first call `useFinalizeAccountReconciliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeAccountReconciliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeAccountReconciliationMutation, { data, loading, error }] = useFinalizeAccountReconciliationMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      reconciliationId: // value for 'reconciliationId'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useFinalizeAccountReconciliationMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeAccountReconciliationMutation, FinalizeAccountReconciliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeAccountReconciliationMutation, FinalizeAccountReconciliationMutationVariables>(FinalizeAccountReconciliationDocument, options);
      }
export type FinalizeAccountReconciliationMutationHookResult = ReturnType<typeof useFinalizeAccountReconciliationMutation>;
export type FinalizeAccountReconciliationMutationResult = Apollo.MutationResult<FinalizeAccountReconciliationMutation>;
export type FinalizeAccountReconciliationMutationOptions = Apollo.BaseMutationOptions<FinalizeAccountReconciliationMutation, FinalizeAccountReconciliationMutationVariables>;
export const MatchPotentialDuplicateFlagTransactionsDocument = gql`
    mutation MatchPotentialDuplicateFlagTransactions($reconciliationIntentId: String!, $flag: MatchPotentialDuplicateFlagTransactionsInput!, $viewKey: ViewKey!) {
  matchPotentialDuplicateFlagTransactions(
    reconciliationIntentId: $reconciliationIntentId
    flag: $flag
    viewKey: $viewKey
  )
}
    `;
export type MatchPotentialDuplicateFlagTransactionsMutationFn = Apollo.MutationFunction<MatchPotentialDuplicateFlagTransactionsMutation, MatchPotentialDuplicateFlagTransactionsMutationVariables>;

/**
 * __useMatchPotentialDuplicateFlagTransactionsMutation__
 *
 * To run a mutation, you first call `useMatchPotentialDuplicateFlagTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchPotentialDuplicateFlagTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchPotentialDuplicateFlagTransactionsMutation, { data, loading, error }] = useMatchPotentialDuplicateFlagTransactionsMutation({
 *   variables: {
 *      reconciliationIntentId: // value for 'reconciliationIntentId'
 *      flag: // value for 'flag'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useMatchPotentialDuplicateFlagTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<MatchPotentialDuplicateFlagTransactionsMutation, MatchPotentialDuplicateFlagTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MatchPotentialDuplicateFlagTransactionsMutation, MatchPotentialDuplicateFlagTransactionsMutationVariables>(MatchPotentialDuplicateFlagTransactionsDocument, options);
      }
export type MatchPotentialDuplicateFlagTransactionsMutationHookResult = ReturnType<typeof useMatchPotentialDuplicateFlagTransactionsMutation>;
export type MatchPotentialDuplicateFlagTransactionsMutationResult = Apollo.MutationResult<MatchPotentialDuplicateFlagTransactionsMutation>;
export type MatchPotentialDuplicateFlagTransactionsMutationOptions = Apollo.BaseMutationOptions<MatchPotentialDuplicateFlagTransactionsMutation, MatchPotentialDuplicateFlagTransactionsMutationVariables>;
export const ReopenAccountReconciliationDocument = gql`
    mutation ReopenAccountReconciliation($legalEntityId: String!, $reconciliationId: String!) {
  reopenAccountReconciliation(
    legalEntityId: $legalEntityId
    reconciliationId: $reconciliationId
  )
}
    `;
export type ReopenAccountReconciliationMutationFn = Apollo.MutationFunction<ReopenAccountReconciliationMutation, ReopenAccountReconciliationMutationVariables>;

/**
 * __useReopenAccountReconciliationMutation__
 *
 * To run a mutation, you first call `useReopenAccountReconciliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenAccountReconciliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenAccountReconciliationMutation, { data, loading, error }] = useReopenAccountReconciliationMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      reconciliationId: // value for 'reconciliationId'
 *   },
 * });
 */
export function useReopenAccountReconciliationMutation(baseOptions?: Apollo.MutationHookOptions<ReopenAccountReconciliationMutation, ReopenAccountReconciliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenAccountReconciliationMutation, ReopenAccountReconciliationMutationVariables>(ReopenAccountReconciliationDocument, options);
      }
export type ReopenAccountReconciliationMutationHookResult = ReturnType<typeof useReopenAccountReconciliationMutation>;
export type ReopenAccountReconciliationMutationResult = Apollo.MutationResult<ReopenAccountReconciliationMutation>;
export type ReopenAccountReconciliationMutationOptions = Apollo.BaseMutationOptions<ReopenAccountReconciliationMutation, ReopenAccountReconciliationMutationVariables>;
export const ResolvePotentialMismatchFlagDocument = gql`
    mutation ResolvePotentialMismatchFlag($reconciliationIntentId: String!, $flag: ResolvePotentialMismatchInput!, $viewKey: ViewKey!) {
  resolvePotentialMismatchFlag(
    reconciliationIntentId: $reconciliationIntentId
    flag: $flag
    viewKey: $viewKey
  )
}
    `;
export type ResolvePotentialMismatchFlagMutationFn = Apollo.MutationFunction<ResolvePotentialMismatchFlagMutation, ResolvePotentialMismatchFlagMutationVariables>;

/**
 * __useResolvePotentialMismatchFlagMutation__
 *
 * To run a mutation, you first call `useResolvePotentialMismatchFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolvePotentialMismatchFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolvePotentialMismatchFlagMutation, { data, loading, error }] = useResolvePotentialMismatchFlagMutation({
 *   variables: {
 *      reconciliationIntentId: // value for 'reconciliationIntentId'
 *      flag: // value for 'flag'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useResolvePotentialMismatchFlagMutation(baseOptions?: Apollo.MutationHookOptions<ResolvePotentialMismatchFlagMutation, ResolvePotentialMismatchFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolvePotentialMismatchFlagMutation, ResolvePotentialMismatchFlagMutationVariables>(ResolvePotentialMismatchFlagDocument, options);
      }
export type ResolvePotentialMismatchFlagMutationHookResult = ReturnType<typeof useResolvePotentialMismatchFlagMutation>;
export type ResolvePotentialMismatchFlagMutationResult = Apollo.MutationResult<ResolvePotentialMismatchFlagMutation>;
export type ResolvePotentialMismatchFlagMutationOptions = Apollo.BaseMutationOptions<ResolvePotentialMismatchFlagMutation, ResolvePotentialMismatchFlagMutationVariables>;
export const UpdateAccountReconciliationDocument = gql`
    mutation UpdateAccountReconciliation($legalEntityId: String!, $reconciliationId: String!, $viewKey: ViewKey!, $update: InputAccountReconciliationUpdate!) {
  updateAccountReconciliation(
    legalEntityId: $legalEntityId
    reconciliationId: $reconciliationId
    viewKey: $viewKey
    update: $update
  )
}
    `;
export type UpdateAccountReconciliationMutationFn = Apollo.MutationFunction<UpdateAccountReconciliationMutation, UpdateAccountReconciliationMutationVariables>;

/**
 * __useUpdateAccountReconciliationMutation__
 *
 * To run a mutation, you first call `useUpdateAccountReconciliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountReconciliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountReconciliationMutation, { data, loading, error }] = useUpdateAccountReconciliationMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      reconciliationId: // value for 'reconciliationId'
 *      viewKey: // value for 'viewKey'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateAccountReconciliationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountReconciliationMutation, UpdateAccountReconciliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountReconciliationMutation, UpdateAccountReconciliationMutationVariables>(UpdateAccountReconciliationDocument, options);
      }
export type UpdateAccountReconciliationMutationHookResult = ReturnType<typeof useUpdateAccountReconciliationMutation>;
export type UpdateAccountReconciliationMutationResult = Apollo.MutationResult<UpdateAccountReconciliationMutation>;
export type UpdateAccountReconciliationMutationOptions = Apollo.BaseMutationOptions<UpdateAccountReconciliationMutation, UpdateAccountReconciliationMutationVariables>;
export const UpdateReconciliationFlagResolutionDocument = gql`
    mutation UpdateReconciliationFlagResolution($reconciliationIntentId: String!, $flagId: String!, $resolved: Boolean!, $resolutionType: ReconciliationFlagResolutionType!, $viewKey: ViewKey!) {
  updateReconciliationFlagResolution(
    reconciliationIntentId: $reconciliationIntentId
    flagId: $flagId
    resolved: $resolved
    resolutionType: $resolutionType
    viewKey: $viewKey
  ) {
    ...ReconciliationFlagFields
  }
}
    ${ReconciliationFlagFieldsFragmentDoc}`;
export type UpdateReconciliationFlagResolutionMutationFn = Apollo.MutationFunction<UpdateReconciliationFlagResolutionMutation, UpdateReconciliationFlagResolutionMutationVariables>;

/**
 * __useUpdateReconciliationFlagResolutionMutation__
 *
 * To run a mutation, you first call `useUpdateReconciliationFlagResolutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReconciliationFlagResolutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReconciliationFlagResolutionMutation, { data, loading, error }] = useUpdateReconciliationFlagResolutionMutation({
 *   variables: {
 *      reconciliationIntentId: // value for 'reconciliationIntentId'
 *      flagId: // value for 'flagId'
 *      resolved: // value for 'resolved'
 *      resolutionType: // value for 'resolutionType'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useUpdateReconciliationFlagResolutionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReconciliationFlagResolutionMutation, UpdateReconciliationFlagResolutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReconciliationFlagResolutionMutation, UpdateReconciliationFlagResolutionMutationVariables>(UpdateReconciliationFlagResolutionDocument, options);
      }
export type UpdateReconciliationFlagResolutionMutationHookResult = ReturnType<typeof useUpdateReconciliationFlagResolutionMutation>;
export type UpdateReconciliationFlagResolutionMutationResult = Apollo.MutationResult<UpdateReconciliationFlagResolutionMutation>;
export type UpdateReconciliationFlagResolutionMutationOptions = Apollo.BaseMutationOptions<UpdateReconciliationFlagResolutionMutation, UpdateReconciliationFlagResolutionMutationVariables>;
export const UpdateReconciliationFlagTransactionDateDocument = gql`
    mutation UpdateReconciliationFlagTransactionDate($reconciliationIntentId: String!, $flag: UpdateReconciliationFlagTransactionDateInput!, $viewKey: ViewKey!) {
  updateReconciliationFlagTransactionDate(
    reconciliationIntentId: $reconciliationIntentId
    flag: $flag
    viewKey: $viewKey
  )
}
    `;
export type UpdateReconciliationFlagTransactionDateMutationFn = Apollo.MutationFunction<UpdateReconciliationFlagTransactionDateMutation, UpdateReconciliationFlagTransactionDateMutationVariables>;

/**
 * __useUpdateReconciliationFlagTransactionDateMutation__
 *
 * To run a mutation, you first call `useUpdateReconciliationFlagTransactionDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReconciliationFlagTransactionDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReconciliationFlagTransactionDateMutation, { data, loading, error }] = useUpdateReconciliationFlagTransactionDateMutation({
 *   variables: {
 *      reconciliationIntentId: // value for 'reconciliationIntentId'
 *      flag: // value for 'flag'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useUpdateReconciliationFlagTransactionDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReconciliationFlagTransactionDateMutation, UpdateReconciliationFlagTransactionDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReconciliationFlagTransactionDateMutation, UpdateReconciliationFlagTransactionDateMutationVariables>(UpdateReconciliationFlagTransactionDateDocument, options);
      }
export type UpdateReconciliationFlagTransactionDateMutationHookResult = ReturnType<typeof useUpdateReconciliationFlagTransactionDateMutation>;
export type UpdateReconciliationFlagTransactionDateMutationResult = Apollo.MutationResult<UpdateReconciliationFlagTransactionDateMutation>;
export type UpdateReconciliationFlagTransactionDateMutationOptions = Apollo.BaseMutationOptions<UpdateReconciliationFlagTransactionDateMutation, UpdateReconciliationFlagTransactionDateMutationVariables>;
export const UpdateTransactionReconciliationStatusesDocument = gql`
    mutation UpdateTransactionReconciliationStatuses($viewKey: ViewKey!, $statusUpdates: [InputStatusUpdate!]!) {
  updateTransactionReconciliationStatuses(
    viewKey: $viewKey
    statusUpdates: $statusUpdates
  )
}
    `;
export type UpdateTransactionReconciliationStatusesMutationFn = Apollo.MutationFunction<UpdateTransactionReconciliationStatusesMutation, UpdateTransactionReconciliationStatusesMutationVariables>;

/**
 * __useUpdateTransactionReconciliationStatusesMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionReconciliationStatusesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionReconciliationStatusesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionReconciliationStatusesMutation, { data, loading, error }] = useUpdateTransactionReconciliationStatusesMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      statusUpdates: // value for 'statusUpdates'
 *   },
 * });
 */
export function useUpdateTransactionReconciliationStatusesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionReconciliationStatusesMutation, UpdateTransactionReconciliationStatusesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionReconciliationStatusesMutation, UpdateTransactionReconciliationStatusesMutationVariables>(UpdateTransactionReconciliationStatusesDocument, options);
      }
export type UpdateTransactionReconciliationStatusesMutationHookResult = ReturnType<typeof useUpdateTransactionReconciliationStatusesMutation>;
export type UpdateTransactionReconciliationStatusesMutationResult = Apollo.MutationResult<UpdateTransactionReconciliationStatusesMutation>;
export type UpdateTransactionReconciliationStatusesMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionReconciliationStatusesMutation, UpdateTransactionReconciliationStatusesMutationVariables>;
export const GetDocumentsTransactionFeaturesDocument = gql`
    query GetDocumentsTransactionFeatures($legalEntityId: String!, $documentIds: [String!]!) {
  getDocumentsTransactionFeatures(
    legalEntityId: $legalEntityId
    documentIds: $documentIds
  ) {
    documentId
    transactionFeatures {
      transactionFactId
      featureIds
    }
  }
}
    `;

/**
 * __useGetDocumentsTransactionFeaturesQuery__
 *
 * To run a query within a React component, call `useGetDocumentsTransactionFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentsTransactionFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentsTransactionFeaturesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useGetDocumentsTransactionFeaturesQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentsTransactionFeaturesQuery, GetDocumentsTransactionFeaturesQueryVariables> & ({ variables: GetDocumentsTransactionFeaturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentsTransactionFeaturesQuery, GetDocumentsTransactionFeaturesQueryVariables>(GetDocumentsTransactionFeaturesDocument, options);
      }
export function useGetDocumentsTransactionFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentsTransactionFeaturesQuery, GetDocumentsTransactionFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentsTransactionFeaturesQuery, GetDocumentsTransactionFeaturesQueryVariables>(GetDocumentsTransactionFeaturesDocument, options);
        }
export function useGetDocumentsTransactionFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentsTransactionFeaturesQuery, GetDocumentsTransactionFeaturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentsTransactionFeaturesQuery, GetDocumentsTransactionFeaturesQueryVariables>(GetDocumentsTransactionFeaturesDocument, options);
        }
export type GetDocumentsTransactionFeaturesQueryHookResult = ReturnType<typeof useGetDocumentsTransactionFeaturesQuery>;
export type GetDocumentsTransactionFeaturesLazyQueryHookResult = ReturnType<typeof useGetDocumentsTransactionFeaturesLazyQuery>;
export type GetDocumentsTransactionFeaturesSuspenseQueryHookResult = ReturnType<typeof useGetDocumentsTransactionFeaturesSuspenseQuery>;
export type GetDocumentsTransactionFeaturesQueryResult = Apollo.QueryResult<GetDocumentsTransactionFeaturesQuery, GetDocumentsTransactionFeaturesQueryVariables>;
export const ListAccountReconciliationsDocument = gql`
    query ListAccountReconciliations($legalEntityId: String!, $viewKey: ViewKey!, $origin: IntervalOrigin!, $direction: DirectionFromOrigin!, $filter: InputAccountReconciliationsFilter, $categoryId: String) {
  listAccountReconciliations(
    legalEntityId: $legalEntityId
    viewKey: $viewKey
    origin: $origin
    direction: $direction
    filter: $filter
    categoryId: $categoryId
  ) {
    account {
      ...EntityCategoryFields
    }
    reconciliations {
      ...AccountReconciliationFields
    }
    mostRecentFinalizedReconciliation {
      ...AccountReconciliationFields
    }
    earliestOpenReconciliation {
      ...AccountReconciliationFields
    }
  }
}
    ${EntityCategoryFieldsFragmentDoc}
${AccountReconciliationFieldsFragmentDoc}`;

/**
 * __useListAccountReconciliationsQuery__
 *
 * To run a query within a React component, call `useListAccountReconciliationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAccountReconciliationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAccountReconciliationsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      viewKey: // value for 'viewKey'
 *      origin: // value for 'origin'
 *      direction: // value for 'direction'
 *      filter: // value for 'filter'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useListAccountReconciliationsQuery(baseOptions: Apollo.QueryHookOptions<ListAccountReconciliationsQuery, ListAccountReconciliationsQueryVariables> & ({ variables: ListAccountReconciliationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAccountReconciliationsQuery, ListAccountReconciliationsQueryVariables>(ListAccountReconciliationsDocument, options);
      }
export function useListAccountReconciliationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAccountReconciliationsQuery, ListAccountReconciliationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAccountReconciliationsQuery, ListAccountReconciliationsQueryVariables>(ListAccountReconciliationsDocument, options);
        }
export function useListAccountReconciliationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAccountReconciliationsQuery, ListAccountReconciliationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAccountReconciliationsQuery, ListAccountReconciliationsQueryVariables>(ListAccountReconciliationsDocument, options);
        }
export type ListAccountReconciliationsQueryHookResult = ReturnType<typeof useListAccountReconciliationsQuery>;
export type ListAccountReconciliationsLazyQueryHookResult = ReturnType<typeof useListAccountReconciliationsLazyQuery>;
export type ListAccountReconciliationsSuspenseQueryHookResult = ReturnType<typeof useListAccountReconciliationsSuspenseQuery>;
export type ListAccountReconciliationsQueryResult = Apollo.QueryResult<ListAccountReconciliationsQuery, ListAccountReconciliationsQueryVariables>;
export const ListCascadeFinalizableReconciliationsDocument = gql`
    query ListCascadeFinalizableReconciliations($legalEntityId: String!, $reconciliationId: String!, $viewKey: ViewKey!) {
  listCascadeFinalizableReconciliations(
    legalEntityId: $legalEntityId
    reconciliationId: $reconciliationId
    viewKey: $viewKey
  ) {
    ...AccountReconciliationFields
  }
}
    ${AccountReconciliationFieldsFragmentDoc}`;

/**
 * __useListCascadeFinalizableReconciliationsQuery__
 *
 * To run a query within a React component, call `useListCascadeFinalizableReconciliationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCascadeFinalizableReconciliationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCascadeFinalizableReconciliationsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      reconciliationId: // value for 'reconciliationId'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useListCascadeFinalizableReconciliationsQuery(baseOptions: Apollo.QueryHookOptions<ListCascadeFinalizableReconciliationsQuery, ListCascadeFinalizableReconciliationsQueryVariables> & ({ variables: ListCascadeFinalizableReconciliationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCascadeFinalizableReconciliationsQuery, ListCascadeFinalizableReconciliationsQueryVariables>(ListCascadeFinalizableReconciliationsDocument, options);
      }
export function useListCascadeFinalizableReconciliationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCascadeFinalizableReconciliationsQuery, ListCascadeFinalizableReconciliationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCascadeFinalizableReconciliationsQuery, ListCascadeFinalizableReconciliationsQueryVariables>(ListCascadeFinalizableReconciliationsDocument, options);
        }
export function useListCascadeFinalizableReconciliationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCascadeFinalizableReconciliationsQuery, ListCascadeFinalizableReconciliationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCascadeFinalizableReconciliationsQuery, ListCascadeFinalizableReconciliationsQueryVariables>(ListCascadeFinalizableReconciliationsDocument, options);
        }
export type ListCascadeFinalizableReconciliationsQueryHookResult = ReturnType<typeof useListCascadeFinalizableReconciliationsQuery>;
export type ListCascadeFinalizableReconciliationsLazyQueryHookResult = ReturnType<typeof useListCascadeFinalizableReconciliationsLazyQuery>;
export type ListCascadeFinalizableReconciliationsSuspenseQueryHookResult = ReturnType<typeof useListCascadeFinalizableReconciliationsSuspenseQuery>;
export type ListCascadeFinalizableReconciliationsQueryResult = Apollo.QueryResult<ListCascadeFinalizableReconciliationsQuery, ListCascadeFinalizableReconciliationsQueryVariables>;
export const ListReconciliationFlagsDocument = gql`
    query ListReconciliationFlags($reconciliationIntentId: String!, $viewKey: ViewKey!) {
  listReconciliationFlags(
    reconciliationIntentId: $reconciliationIntentId
    viewKey: $viewKey
  ) {
    ...ReconciliationFlagFields
  }
}
    ${ReconciliationFlagFieldsFragmentDoc}`;

/**
 * __useListReconciliationFlagsQuery__
 *
 * To run a query within a React component, call `useListReconciliationFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReconciliationFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReconciliationFlagsQuery({
 *   variables: {
 *      reconciliationIntentId: // value for 'reconciliationIntentId'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useListReconciliationFlagsQuery(baseOptions: Apollo.QueryHookOptions<ListReconciliationFlagsQuery, ListReconciliationFlagsQueryVariables> & ({ variables: ListReconciliationFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListReconciliationFlagsQuery, ListReconciliationFlagsQueryVariables>(ListReconciliationFlagsDocument, options);
      }
export function useListReconciliationFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListReconciliationFlagsQuery, ListReconciliationFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListReconciliationFlagsQuery, ListReconciliationFlagsQueryVariables>(ListReconciliationFlagsDocument, options);
        }
export function useListReconciliationFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListReconciliationFlagsQuery, ListReconciliationFlagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListReconciliationFlagsQuery, ListReconciliationFlagsQueryVariables>(ListReconciliationFlagsDocument, options);
        }
export type ListReconciliationFlagsQueryHookResult = ReturnType<typeof useListReconciliationFlagsQuery>;
export type ListReconciliationFlagsLazyQueryHookResult = ReturnType<typeof useListReconciliationFlagsLazyQuery>;
export type ListReconciliationFlagsSuspenseQueryHookResult = ReturnType<typeof useListReconciliationFlagsSuspenseQuery>;
export type ListReconciliationFlagsQueryResult = Apollo.QueryResult<ListReconciliationFlagsQuery, ListReconciliationFlagsQueryVariables>;
export const ListReconciliationHistoryDocument = gql`
    query ListReconciliationHistory($legalEntityId: String!, $reconciliationId: String!) {
  listReconciliationHistory(
    legalEntityId: $legalEntityId
    reconciliationId: $reconciliationId
  ) {
    reconciliationId
    eventType
    user {
      ...EntityUserFields
    }
    timestamp
  }
}
    ${EntityUserFieldsFragmentDoc}`;

/**
 * __useListReconciliationHistoryQuery__
 *
 * To run a query within a React component, call `useListReconciliationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReconciliationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReconciliationHistoryQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      reconciliationId: // value for 'reconciliationId'
 *   },
 * });
 */
export function useListReconciliationHistoryQuery(baseOptions: Apollo.QueryHookOptions<ListReconciliationHistoryQuery, ListReconciliationHistoryQueryVariables> & ({ variables: ListReconciliationHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListReconciliationHistoryQuery, ListReconciliationHistoryQueryVariables>(ListReconciliationHistoryDocument, options);
      }
export function useListReconciliationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListReconciliationHistoryQuery, ListReconciliationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListReconciliationHistoryQuery, ListReconciliationHistoryQueryVariables>(ListReconciliationHistoryDocument, options);
        }
export function useListReconciliationHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListReconciliationHistoryQuery, ListReconciliationHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListReconciliationHistoryQuery, ListReconciliationHistoryQueryVariables>(ListReconciliationHistoryDocument, options);
        }
export type ListReconciliationHistoryQueryHookResult = ReturnType<typeof useListReconciliationHistoryQuery>;
export type ListReconciliationHistoryLazyQueryHookResult = ReturnType<typeof useListReconciliationHistoryLazyQuery>;
export type ListReconciliationHistorySuspenseQueryHookResult = ReturnType<typeof useListReconciliationHistorySuspenseQuery>;
export type ListReconciliationHistoryQueryResult = Apollo.QueryResult<ListReconciliationHistoryQuery, ListReconciliationHistoryQueryVariables>;
export const ListReconciliationIntentsDocument = gql`
    query ListReconciliationIntents($legalEntityId: String!, $intentCategoryIds: [String!], $states: [ReconciliationIntentState!], $actionItemIds: [String!]) {
  listReconciliationIntents(
    legalEntityId: $legalEntityId
    intentCategoryIds: $intentCategoryIds
    states: $states
    actionItemIds: $actionItemIds
  ) {
    reconciliationIntentId
    documentId
    state
    intentCategoryId
    initiatedByUserId
    processingEndedAt
    actionItemId
    matchedAccountFeatureGroupId
  }
}
    `;

/**
 * __useListReconciliationIntentsQuery__
 *
 * To run a query within a React component, call `useListReconciliationIntentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReconciliationIntentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReconciliationIntentsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      intentCategoryIds: // value for 'intentCategoryIds'
 *      states: // value for 'states'
 *      actionItemIds: // value for 'actionItemIds'
 *   },
 * });
 */
export function useListReconciliationIntentsQuery(baseOptions: Apollo.QueryHookOptions<ListReconciliationIntentsQuery, ListReconciliationIntentsQueryVariables> & ({ variables: ListReconciliationIntentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListReconciliationIntentsQuery, ListReconciliationIntentsQueryVariables>(ListReconciliationIntentsDocument, options);
      }
export function useListReconciliationIntentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListReconciliationIntentsQuery, ListReconciliationIntentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListReconciliationIntentsQuery, ListReconciliationIntentsQueryVariables>(ListReconciliationIntentsDocument, options);
        }
export function useListReconciliationIntentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListReconciliationIntentsQuery, ListReconciliationIntentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListReconciliationIntentsQuery, ListReconciliationIntentsQueryVariables>(ListReconciliationIntentsDocument, options);
        }
export type ListReconciliationIntentsQueryHookResult = ReturnType<typeof useListReconciliationIntentsQuery>;
export type ListReconciliationIntentsLazyQueryHookResult = ReturnType<typeof useListReconciliationIntentsLazyQuery>;
export type ListReconciliationIntentsSuspenseQueryHookResult = ReturnType<typeof useListReconciliationIntentsSuspenseQuery>;
export type ListReconciliationIntentsQueryResult = Apollo.QueryResult<ListReconciliationIntentsQuery, ListReconciliationIntentsQueryVariables>;
export const ListReconciliationIntentsByReconciliationIdDocument = gql`
    query ListReconciliationIntentsByReconciliationId($legalEntityId: String!, $reconciliationId: String!, $states: [ReconciliationIntentState!]) {
  listReconciliationIntentsByReconciliationId(
    legalEntityId: $legalEntityId
    reconciliationId: $reconciliationId
    states: $states
  ) {
    reconciliationIntentId
    documentId
    state
    intentCategoryId
    initiatedByUserId
    processingEndedAt
    matchedAccountFeatureGroupId
  }
}
    `;

/**
 * __useListReconciliationIntentsByReconciliationIdQuery__
 *
 * To run a query within a React component, call `useListReconciliationIntentsByReconciliationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReconciliationIntentsByReconciliationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReconciliationIntentsByReconciliationIdQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      reconciliationId: // value for 'reconciliationId'
 *      states: // value for 'states'
 *   },
 * });
 */
export function useListReconciliationIntentsByReconciliationIdQuery(baseOptions: Apollo.QueryHookOptions<ListReconciliationIntentsByReconciliationIdQuery, ListReconciliationIntentsByReconciliationIdQueryVariables> & ({ variables: ListReconciliationIntentsByReconciliationIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListReconciliationIntentsByReconciliationIdQuery, ListReconciliationIntentsByReconciliationIdQueryVariables>(ListReconciliationIntentsByReconciliationIdDocument, options);
      }
export function useListReconciliationIntentsByReconciliationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListReconciliationIntentsByReconciliationIdQuery, ListReconciliationIntentsByReconciliationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListReconciliationIntentsByReconciliationIdQuery, ListReconciliationIntentsByReconciliationIdQueryVariables>(ListReconciliationIntentsByReconciliationIdDocument, options);
        }
export function useListReconciliationIntentsByReconciliationIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListReconciliationIntentsByReconciliationIdQuery, ListReconciliationIntentsByReconciliationIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListReconciliationIntentsByReconciliationIdQuery, ListReconciliationIntentsByReconciliationIdQueryVariables>(ListReconciliationIntentsByReconciliationIdDocument, options);
        }
export type ListReconciliationIntentsByReconciliationIdQueryHookResult = ReturnType<typeof useListReconciliationIntentsByReconciliationIdQuery>;
export type ListReconciliationIntentsByReconciliationIdLazyQueryHookResult = ReturnType<typeof useListReconciliationIntentsByReconciliationIdLazyQuery>;
export type ListReconciliationIntentsByReconciliationIdSuspenseQueryHookResult = ReturnType<typeof useListReconciliationIntentsByReconciliationIdSuspenseQuery>;
export type ListReconciliationIntentsByReconciliationIdQueryResult = Apollo.QueryResult<ListReconciliationIntentsByReconciliationIdQuery, ListReconciliationIntentsByReconciliationIdQueryVariables>;
export const ReadAccountReconciliationDocument = gql`
    query ReadAccountReconciliation($legalEntityId: String!, $reconciliationId: String!, $viewKey: ViewKey!) {
  readAccountReconciliation(
    legalEntityId: $legalEntityId
    reconciliationId: $reconciliationId
    viewKey: $viewKey
  ) {
    reconciliation {
      ...AccountReconciliationFields
    }
    balances {
      ...ReconciliationBalancesFields
    }
    normalEntryType
    transactionCounts {
      ...TransactionCountsFields
    }
    maxClassificationUpdatedAt
    reconciledSystemClassificationsCount
    unsettledSystemClassificationsCount
  }
}
    ${AccountReconciliationFieldsFragmentDoc}
${ReconciliationBalancesFieldsFragmentDoc}
${TransactionCountsFieldsFragmentDoc}`;

/**
 * __useReadAccountReconciliationQuery__
 *
 * To run a query within a React component, call `useReadAccountReconciliationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadAccountReconciliationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadAccountReconciliationQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      reconciliationId: // value for 'reconciliationId'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useReadAccountReconciliationQuery(baseOptions: Apollo.QueryHookOptions<ReadAccountReconciliationQuery, ReadAccountReconciliationQueryVariables> & ({ variables: ReadAccountReconciliationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadAccountReconciliationQuery, ReadAccountReconciliationQueryVariables>(ReadAccountReconciliationDocument, options);
      }
export function useReadAccountReconciliationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadAccountReconciliationQuery, ReadAccountReconciliationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadAccountReconciliationQuery, ReadAccountReconciliationQueryVariables>(ReadAccountReconciliationDocument, options);
        }
export function useReadAccountReconciliationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadAccountReconciliationQuery, ReadAccountReconciliationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadAccountReconciliationQuery, ReadAccountReconciliationQueryVariables>(ReadAccountReconciliationDocument, options);
        }
export type ReadAccountReconciliationQueryHookResult = ReturnType<typeof useReadAccountReconciliationQuery>;
export type ReadAccountReconciliationLazyQueryHookResult = ReturnType<typeof useReadAccountReconciliationLazyQuery>;
export type ReadAccountReconciliationSuspenseQueryHookResult = ReturnType<typeof useReadAccountReconciliationSuspenseQuery>;
export type ReadAccountReconciliationQueryResult = Apollo.QueryResult<ReadAccountReconciliationQuery, ReadAccountReconciliationQueryVariables>;
export const ReadReconciliationDiffDocument = gql`
    query ReadReconciliationDiff($viewKey: ViewKey!, $reconciliationId: String!) {
  readReconciliationDiff(viewKey: $viewKey, reconciliationId: $reconciliationId) {
    ...ReconciliationDiffFields
  }
}
    ${ReconciliationDiffFieldsFragmentDoc}`;

/**
 * __useReadReconciliationDiffQuery__
 *
 * To run a query within a React component, call `useReadReconciliationDiffQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadReconciliationDiffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadReconciliationDiffQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      reconciliationId: // value for 'reconciliationId'
 *   },
 * });
 */
export function useReadReconciliationDiffQuery(baseOptions: Apollo.QueryHookOptions<ReadReconciliationDiffQuery, ReadReconciliationDiffQueryVariables> & ({ variables: ReadReconciliationDiffQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadReconciliationDiffQuery, ReadReconciliationDiffQueryVariables>(ReadReconciliationDiffDocument, options);
      }
export function useReadReconciliationDiffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadReconciliationDiffQuery, ReadReconciliationDiffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadReconciliationDiffQuery, ReadReconciliationDiffQueryVariables>(ReadReconciliationDiffDocument, options);
        }
export function useReadReconciliationDiffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadReconciliationDiffQuery, ReadReconciliationDiffQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadReconciliationDiffQuery, ReadReconciliationDiffQueryVariables>(ReadReconciliationDiffDocument, options);
        }
export type ReadReconciliationDiffQueryHookResult = ReturnType<typeof useReadReconciliationDiffQuery>;
export type ReadReconciliationDiffLazyQueryHookResult = ReturnType<typeof useReadReconciliationDiffLazyQuery>;
export type ReadReconciliationDiffSuspenseQueryHookResult = ReturnType<typeof useReadReconciliationDiffSuspenseQuery>;
export type ReadReconciliationDiffQueryResult = Apollo.QueryResult<ReadReconciliationDiffQuery, ReadReconciliationDiffQueryVariables>;
export const ReadReconciliationFactClassificationDocument = gql`
    query ReadReconciliationFactClassification($legalEntityId: String!, $transactionFactId: String!) {
  readReconciliationFactClassification(
    legalEntityId: $legalEntityId
    transactionFactId: $transactionFactId
  ) {
    ...TransactionReconciliationClassificationFields
  }
}
    ${TransactionReconciliationClassificationFieldsFragmentDoc}`;

/**
 * __useReadReconciliationFactClassificationQuery__
 *
 * To run a query within a React component, call `useReadReconciliationFactClassificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadReconciliationFactClassificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadReconciliationFactClassificationQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      transactionFactId: // value for 'transactionFactId'
 *   },
 * });
 */
export function useReadReconciliationFactClassificationQuery(baseOptions: Apollo.QueryHookOptions<ReadReconciliationFactClassificationQuery, ReadReconciliationFactClassificationQueryVariables> & ({ variables: ReadReconciliationFactClassificationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadReconciliationFactClassificationQuery, ReadReconciliationFactClassificationQueryVariables>(ReadReconciliationFactClassificationDocument, options);
      }
export function useReadReconciliationFactClassificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadReconciliationFactClassificationQuery, ReadReconciliationFactClassificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadReconciliationFactClassificationQuery, ReadReconciliationFactClassificationQueryVariables>(ReadReconciliationFactClassificationDocument, options);
        }
export function useReadReconciliationFactClassificationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadReconciliationFactClassificationQuery, ReadReconciliationFactClassificationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadReconciliationFactClassificationQuery, ReadReconciliationFactClassificationQueryVariables>(ReadReconciliationFactClassificationDocument, options);
        }
export type ReadReconciliationFactClassificationQueryHookResult = ReturnType<typeof useReadReconciliationFactClassificationQuery>;
export type ReadReconciliationFactClassificationLazyQueryHookResult = ReturnType<typeof useReadReconciliationFactClassificationLazyQuery>;
export type ReadReconciliationFactClassificationSuspenseQueryHookResult = ReturnType<typeof useReadReconciliationFactClassificationSuspenseQuery>;
export type ReadReconciliationFactClassificationQueryResult = Apollo.QueryResult<ReadReconciliationFactClassificationQuery, ReadReconciliationFactClassificationQueryVariables>;
export const ReadReconciliationPeriodStatsDocument = gql`
    query ReadReconciliationPeriodStats($legalEntityId: String!, $viewKey: ViewKey!, $origin: IntervalOrigin!, $direction: DirectionFromOrigin!) {
  readReconciliationPeriodStats(
    legalEntityId: $legalEntityId
    viewKey: $viewKey
    origin: $origin
    direction: $direction
  ) {
    ...ReconciliationPeriodStatsFields
  }
}
    ${ReconciliationPeriodStatsFieldsFragmentDoc}`;

/**
 * __useReadReconciliationPeriodStatsQuery__
 *
 * To run a query within a React component, call `useReadReconciliationPeriodStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadReconciliationPeriodStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadReconciliationPeriodStatsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      viewKey: // value for 'viewKey'
 *      origin: // value for 'origin'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useReadReconciliationPeriodStatsQuery(baseOptions: Apollo.QueryHookOptions<ReadReconciliationPeriodStatsQuery, ReadReconciliationPeriodStatsQueryVariables> & ({ variables: ReadReconciliationPeriodStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadReconciliationPeriodStatsQuery, ReadReconciliationPeriodStatsQueryVariables>(ReadReconciliationPeriodStatsDocument, options);
      }
export function useReadReconciliationPeriodStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadReconciliationPeriodStatsQuery, ReadReconciliationPeriodStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadReconciliationPeriodStatsQuery, ReadReconciliationPeriodStatsQueryVariables>(ReadReconciliationPeriodStatsDocument, options);
        }
export function useReadReconciliationPeriodStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadReconciliationPeriodStatsQuery, ReadReconciliationPeriodStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadReconciliationPeriodStatsQuery, ReadReconciliationPeriodStatsQueryVariables>(ReadReconciliationPeriodStatsDocument, options);
        }
export type ReadReconciliationPeriodStatsQueryHookResult = ReturnType<typeof useReadReconciliationPeriodStatsQuery>;
export type ReadReconciliationPeriodStatsLazyQueryHookResult = ReturnType<typeof useReadReconciliationPeriodStatsLazyQuery>;
export type ReadReconciliationPeriodStatsSuspenseQueryHookResult = ReturnType<typeof useReadReconciliationPeriodStatsSuspenseQuery>;
export type ReadReconciliationPeriodStatsQueryResult = Apollo.QueryResult<ReadReconciliationPeriodStatsQuery, ReadReconciliationPeriodStatsQueryVariables>;
export const ReadReconciliationsPdfsDocument = gql`
    query ReadReconciliationsPdfs($legalEntityId: String!, $documentCollectionId: String!) {
  readReconciliationsPdfs(
    legalEntityId: $legalEntityId
    documentCollectionId: $documentCollectionId
  ) {
    documentCollectionId
    documentUrls
    status
    totalDocumentCount
    completedDocumentCount
  }
}
    `;

/**
 * __useReadReconciliationsPdfsQuery__
 *
 * To run a query within a React component, call `useReadReconciliationsPdfsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadReconciliationsPdfsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadReconciliationsPdfsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      documentCollectionId: // value for 'documentCollectionId'
 *   },
 * });
 */
export function useReadReconciliationsPdfsQuery(baseOptions: Apollo.QueryHookOptions<ReadReconciliationsPdfsQuery, ReadReconciliationsPdfsQueryVariables> & ({ variables: ReadReconciliationsPdfsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadReconciliationsPdfsQuery, ReadReconciliationsPdfsQueryVariables>(ReadReconciliationsPdfsDocument, options);
      }
export function useReadReconciliationsPdfsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadReconciliationsPdfsQuery, ReadReconciliationsPdfsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadReconciliationsPdfsQuery, ReadReconciliationsPdfsQueryVariables>(ReadReconciliationsPdfsDocument, options);
        }
export function useReadReconciliationsPdfsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadReconciliationsPdfsQuery, ReadReconciliationsPdfsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadReconciliationsPdfsQuery, ReadReconciliationsPdfsQueryVariables>(ReadReconciliationsPdfsDocument, options);
        }
export type ReadReconciliationsPdfsQueryHookResult = ReturnType<typeof useReadReconciliationsPdfsQuery>;
export type ReadReconciliationsPdfsLazyQueryHookResult = ReturnType<typeof useReadReconciliationsPdfsLazyQuery>;
export type ReadReconciliationsPdfsSuspenseQueryHookResult = ReturnType<typeof useReadReconciliationsPdfsSuspenseQuery>;
export type ReadReconciliationsPdfsQueryResult = Apollo.QueryResult<ReadReconciliationsPdfsQuery, ReadReconciliationsPdfsQueryVariables>;
export const UpdateActionItemAssignmentStatusDocument = gql`
    mutation UpdateActionItemAssignmentStatus($actionItemId: String!, $legalEntityId: String!, $userAssignees: [UserAssignee!]!, $organizationAssignees: [OrganizationAssignee!]!, $action: ActionItemAction) {
  updateActionItemAssignmentStatus(
    actionItemId: $actionItemId
    legalEntityId: $legalEntityId
    userAssignees: $userAssignees
    organizationAssignees: $organizationAssignees
    action: $action
  )
}
    `;
export type UpdateActionItemAssignmentStatusMutationFn = Apollo.MutationFunction<UpdateActionItemAssignmentStatusMutation, UpdateActionItemAssignmentStatusMutationVariables>;

/**
 * __useUpdateActionItemAssignmentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateActionItemAssignmentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActionItemAssignmentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActionItemAssignmentStatusMutation, { data, loading, error }] = useUpdateActionItemAssignmentStatusMutation({
 *   variables: {
 *      actionItemId: // value for 'actionItemId'
 *      legalEntityId: // value for 'legalEntityId'
 *      userAssignees: // value for 'userAssignees'
 *      organizationAssignees: // value for 'organizationAssignees'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useUpdateActionItemAssignmentStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActionItemAssignmentStatusMutation, UpdateActionItemAssignmentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActionItemAssignmentStatusMutation, UpdateActionItemAssignmentStatusMutationVariables>(UpdateActionItemAssignmentStatusDocument, options);
      }
export type UpdateActionItemAssignmentStatusMutationHookResult = ReturnType<typeof useUpdateActionItemAssignmentStatusMutation>;
export type UpdateActionItemAssignmentStatusMutationResult = Apollo.MutationResult<UpdateActionItemAssignmentStatusMutation>;
export type UpdateActionItemAssignmentStatusMutationOptions = Apollo.BaseMutationOptions<UpdateActionItemAssignmentStatusMutation, UpdateActionItemAssignmentStatusMutationVariables>;
export const UpdateActionItemStatusDocument = gql`
    mutation UpdateActionItemStatus($legalEntityId: String!, $actionItems: [ActionItemStatusChange!]!, $action: ActionItemAction) {
  updateActionItemStatus(
    legalEntityId: $legalEntityId
    actionItems: $actionItems
    action: $action
  )
}
    `;
export type UpdateActionItemStatusMutationFn = Apollo.MutationFunction<UpdateActionItemStatusMutation, UpdateActionItemStatusMutationVariables>;

/**
 * __useUpdateActionItemStatusMutation__
 *
 * To run a mutation, you first call `useUpdateActionItemStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActionItemStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActionItemStatusMutation, { data, loading, error }] = useUpdateActionItemStatusMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      actionItems: // value for 'actionItems'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useUpdateActionItemStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActionItemStatusMutation, UpdateActionItemStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActionItemStatusMutation, UpdateActionItemStatusMutationVariables>(UpdateActionItemStatusDocument, options);
      }
export type UpdateActionItemStatusMutationHookResult = ReturnType<typeof useUpdateActionItemStatusMutation>;
export type UpdateActionItemStatusMutationResult = Apollo.MutationResult<UpdateActionItemStatusMutation>;
export type UpdateActionItemStatusMutationOptions = Apollo.BaseMutationOptions<UpdateActionItemStatusMutation, UpdateActionItemStatusMutationVariables>;
export const UpdateActionItemWatchStatusDocument = gql`
    mutation UpdateActionItemWatchStatus($actionItemId: String!, $legalEntityId: String!, $watch: Boolean!, $action: ActionItemAction) {
  updateActionItemWatchStatus(
    actionItemId: $actionItemId
    legalEntityId: $legalEntityId
    watch: $watch
    action: $action
  )
}
    `;
export type UpdateActionItemWatchStatusMutationFn = Apollo.MutationFunction<UpdateActionItemWatchStatusMutation, UpdateActionItemWatchStatusMutationVariables>;

/**
 * __useUpdateActionItemWatchStatusMutation__
 *
 * To run a mutation, you first call `useUpdateActionItemWatchStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActionItemWatchStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActionItemWatchStatusMutation, { data, loading, error }] = useUpdateActionItemWatchStatusMutation({
 *   variables: {
 *      actionItemId: // value for 'actionItemId'
 *      legalEntityId: // value for 'legalEntityId'
 *      watch: // value for 'watch'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useUpdateActionItemWatchStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActionItemWatchStatusMutation, UpdateActionItemWatchStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActionItemWatchStatusMutation, UpdateActionItemWatchStatusMutationVariables>(UpdateActionItemWatchStatusDocument, options);
      }
export type UpdateActionItemWatchStatusMutationHookResult = ReturnType<typeof useUpdateActionItemWatchStatusMutation>;
export type UpdateActionItemWatchStatusMutationResult = Apollo.MutationResult<UpdateActionItemWatchStatusMutation>;
export type UpdateActionItemWatchStatusMutationOptions = Apollo.BaseMutationOptions<UpdateActionItemWatchStatusMutation, UpdateActionItemWatchStatusMutationVariables>;
export const ListActionItemsDocument = gql`
    query ListActionItems($filter: ActionItemFilter!, $pagination: Pagination!, $viewKey: ViewKey!, $origin: IntervalOrigin) {
  listActionItems(
    filter: $filter
    pagination: $pagination
    viewKey: $viewKey
    origin: $origin
  ) {
    ...ActionItemFields
  }
}
    ${ActionItemFieldsFragmentDoc}`;

/**
 * __useListActionItemsQuery__
 *
 * To run a query within a React component, call `useListActionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActionItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      viewKey: // value for 'viewKey'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useListActionItemsQuery(baseOptions: Apollo.QueryHookOptions<ListActionItemsQuery, ListActionItemsQueryVariables> & ({ variables: ListActionItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListActionItemsQuery, ListActionItemsQueryVariables>(ListActionItemsDocument, options);
      }
export function useListActionItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListActionItemsQuery, ListActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListActionItemsQuery, ListActionItemsQueryVariables>(ListActionItemsDocument, options);
        }
export function useListActionItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListActionItemsQuery, ListActionItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListActionItemsQuery, ListActionItemsQueryVariables>(ListActionItemsDocument, options);
        }
export type ListActionItemsQueryHookResult = ReturnType<typeof useListActionItemsQuery>;
export type ListActionItemsLazyQueryHookResult = ReturnType<typeof useListActionItemsLazyQuery>;
export type ListActionItemsSuspenseQueryHookResult = ReturnType<typeof useListActionItemsSuspenseQuery>;
export type ListActionItemsQueryResult = Apollo.QueryResult<ListActionItemsQuery, ListActionItemsQueryVariables>;
export const ListActionItemsAndBadgeCountDocument = gql`
    query ListActionItemsAndBadgeCount($listFilter: ActionItemFilter!, $pagination: Pagination!, $viewKey: ViewKey!, $direction: DirectionFromOrigin, $badgeCountFilter: ActionItemFilter!, $legalEntityIds: [String!]!, $legalEntities: [LegalEntityPermission], $origin: IntervalOrigin!) {
  listActionItems(filter: $listFilter, pagination: $pagination, viewKey: $viewKey) {
    ...ActionItemFields
  }
  listActionItemsBadgeCounts(
    direction: $direction
    origin: $origin
    legalEntityIds: $legalEntityIds
    legalEntities: $legalEntities
    filter: $badgeCountFilter
  ) {
    ...LegalEntityBadgeCountFields
  }
}
    ${ActionItemFieldsFragmentDoc}
${LegalEntityBadgeCountFieldsFragmentDoc}`;

/**
 * __useListActionItemsAndBadgeCountQuery__
 *
 * To run a query within a React component, call `useListActionItemsAndBadgeCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActionItemsAndBadgeCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActionItemsAndBadgeCountQuery({
 *   variables: {
 *      listFilter: // value for 'listFilter'
 *      pagination: // value for 'pagination'
 *      viewKey: // value for 'viewKey'
 *      direction: // value for 'direction'
 *      badgeCountFilter: // value for 'badgeCountFilter'
 *      legalEntityIds: // value for 'legalEntityIds'
 *      legalEntities: // value for 'legalEntities'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useListActionItemsAndBadgeCountQuery(baseOptions: Apollo.QueryHookOptions<ListActionItemsAndBadgeCountQuery, ListActionItemsAndBadgeCountQueryVariables> & ({ variables: ListActionItemsAndBadgeCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListActionItemsAndBadgeCountQuery, ListActionItemsAndBadgeCountQueryVariables>(ListActionItemsAndBadgeCountDocument, options);
      }
export function useListActionItemsAndBadgeCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListActionItemsAndBadgeCountQuery, ListActionItemsAndBadgeCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListActionItemsAndBadgeCountQuery, ListActionItemsAndBadgeCountQueryVariables>(ListActionItemsAndBadgeCountDocument, options);
        }
export function useListActionItemsAndBadgeCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListActionItemsAndBadgeCountQuery, ListActionItemsAndBadgeCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListActionItemsAndBadgeCountQuery, ListActionItemsAndBadgeCountQueryVariables>(ListActionItemsAndBadgeCountDocument, options);
        }
export type ListActionItemsAndBadgeCountQueryHookResult = ReturnType<typeof useListActionItemsAndBadgeCountQuery>;
export type ListActionItemsAndBadgeCountLazyQueryHookResult = ReturnType<typeof useListActionItemsAndBadgeCountLazyQuery>;
export type ListActionItemsAndBadgeCountSuspenseQueryHookResult = ReturnType<typeof useListActionItemsAndBadgeCountSuspenseQuery>;
export type ListActionItemsAndBadgeCountQueryResult = Apollo.QueryResult<ListActionItemsAndBadgeCountQuery, ListActionItemsAndBadgeCountQueryVariables>;
export const ListSimilarActionItemsDocument = gql`
    query ListSimilarActionItems($legalEntityId: String!, $items: [SimilarActionItem!]!) {
  listSimilarActionItems(legalEntityId: $legalEntityId, items: $items)
}
    `;

/**
 * __useListSimilarActionItemsQuery__
 *
 * To run a query within a React component, call `useListSimilarActionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSimilarActionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSimilarActionItemsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useListSimilarActionItemsQuery(baseOptions: Apollo.QueryHookOptions<ListSimilarActionItemsQuery, ListSimilarActionItemsQueryVariables> & ({ variables: ListSimilarActionItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSimilarActionItemsQuery, ListSimilarActionItemsQueryVariables>(ListSimilarActionItemsDocument, options);
      }
export function useListSimilarActionItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSimilarActionItemsQuery, ListSimilarActionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSimilarActionItemsQuery, ListSimilarActionItemsQueryVariables>(ListSimilarActionItemsDocument, options);
        }
export function useListSimilarActionItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSimilarActionItemsQuery, ListSimilarActionItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSimilarActionItemsQuery, ListSimilarActionItemsQueryVariables>(ListSimilarActionItemsDocument, options);
        }
export type ListSimilarActionItemsQueryHookResult = ReturnType<typeof useListSimilarActionItemsQuery>;
export type ListSimilarActionItemsLazyQueryHookResult = ReturnType<typeof useListSimilarActionItemsLazyQuery>;
export type ListSimilarActionItemsSuspenseQueryHookResult = ReturnType<typeof useListSimilarActionItemsSuspenseQuery>;
export type ListSimilarActionItemsQueryResult = Apollo.QueryResult<ListSimilarActionItemsQuery, ListSimilarActionItemsQueryVariables>;
export const ReadActionItemDocument = gql`
    query ReadActionItem($actionItemId: String!, $viewKey: ViewKey!) {
  readActionItem(actionItemId: $actionItemId, viewKey: $viewKey) {
    ...ActionItemFields
  }
}
    ${ActionItemFieldsFragmentDoc}`;

/**
 * __useReadActionItemQuery__
 *
 * To run a query within a React component, call `useReadActionItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadActionItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadActionItemQuery({
 *   variables: {
 *      actionItemId: // value for 'actionItemId'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useReadActionItemQuery(baseOptions: Apollo.QueryHookOptions<ReadActionItemQuery, ReadActionItemQueryVariables> & ({ variables: ReadActionItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadActionItemQuery, ReadActionItemQueryVariables>(ReadActionItemDocument, options);
      }
export function useReadActionItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadActionItemQuery, ReadActionItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadActionItemQuery, ReadActionItemQueryVariables>(ReadActionItemDocument, options);
        }
export function useReadActionItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadActionItemQuery, ReadActionItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadActionItemQuery, ReadActionItemQueryVariables>(ReadActionItemDocument, options);
        }
export type ReadActionItemQueryHookResult = ReturnType<typeof useReadActionItemQuery>;
export type ReadActionItemLazyQueryHookResult = ReturnType<typeof useReadActionItemLazyQuery>;
export type ReadActionItemSuspenseQueryHookResult = ReturnType<typeof useReadActionItemSuspenseQuery>;
export type ReadActionItemQueryResult = Apollo.QueryResult<ReadActionItemQuery, ReadActionItemQueryVariables>;
export const SummarizeActionItemsByExternalKeyDocument = gql`
    query SummarizeActionItemsByExternalKey($filter: ActionItemFilter!, $legalEntityId: String!, $origin: IntervalOrigin) {
  summarizeActionItemsByExternalKey(
    filter: $filter
    legalEntityId: $legalEntityId
    origin: $origin
  ) {
    ...ActionItemsExternalKeySummaryFields
  }
}
    ${ActionItemsExternalKeySummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeActionItemsByExternalKeyQuery__
 *
 * To run a query within a React component, call `useSummarizeActionItemsByExternalKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeActionItemsByExternalKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeActionItemsByExternalKeyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      legalEntityId: // value for 'legalEntityId'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useSummarizeActionItemsByExternalKeyQuery(baseOptions: Apollo.QueryHookOptions<SummarizeActionItemsByExternalKeyQuery, SummarizeActionItemsByExternalKeyQueryVariables> & ({ variables: SummarizeActionItemsByExternalKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeActionItemsByExternalKeyQuery, SummarizeActionItemsByExternalKeyQueryVariables>(SummarizeActionItemsByExternalKeyDocument, options);
      }
export function useSummarizeActionItemsByExternalKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeActionItemsByExternalKeyQuery, SummarizeActionItemsByExternalKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeActionItemsByExternalKeyQuery, SummarizeActionItemsByExternalKeyQueryVariables>(SummarizeActionItemsByExternalKeyDocument, options);
        }
export function useSummarizeActionItemsByExternalKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeActionItemsByExternalKeyQuery, SummarizeActionItemsByExternalKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeActionItemsByExternalKeyQuery, SummarizeActionItemsByExternalKeyQueryVariables>(SummarizeActionItemsByExternalKeyDocument, options);
        }
export type SummarizeActionItemsByExternalKeyQueryHookResult = ReturnType<typeof useSummarizeActionItemsByExternalKeyQuery>;
export type SummarizeActionItemsByExternalKeyLazyQueryHookResult = ReturnType<typeof useSummarizeActionItemsByExternalKeyLazyQuery>;
export type SummarizeActionItemsByExternalKeySuspenseQueryHookResult = ReturnType<typeof useSummarizeActionItemsByExternalKeySuspenseQuery>;
export type SummarizeActionItemsByExternalKeyQueryResult = Apollo.QueryResult<SummarizeActionItemsByExternalKeyQuery, SummarizeActionItemsByExternalKeyQueryVariables>;
export const SummarizeActionItemsByGroupDocument = gql`
    query SummarizeActionItemsByGroup($filter: ActionItemFilter!, $legalEntityId: String!, $origin: IntervalOrigin) {
  summarizeActionItemsByGroup(
    filter: $filter
    legalEntityId: $legalEntityId
    origin: $origin
  ) {
    ...ActionItemsGroupSummaryFields
  }
}
    ${ActionItemsGroupSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeActionItemsByGroupQuery__
 *
 * To run a query within a React component, call `useSummarizeActionItemsByGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeActionItemsByGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeActionItemsByGroupQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      legalEntityId: // value for 'legalEntityId'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useSummarizeActionItemsByGroupQuery(baseOptions: Apollo.QueryHookOptions<SummarizeActionItemsByGroupQuery, SummarizeActionItemsByGroupQueryVariables> & ({ variables: SummarizeActionItemsByGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeActionItemsByGroupQuery, SummarizeActionItemsByGroupQueryVariables>(SummarizeActionItemsByGroupDocument, options);
      }
export function useSummarizeActionItemsByGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeActionItemsByGroupQuery, SummarizeActionItemsByGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeActionItemsByGroupQuery, SummarizeActionItemsByGroupQueryVariables>(SummarizeActionItemsByGroupDocument, options);
        }
export function useSummarizeActionItemsByGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeActionItemsByGroupQuery, SummarizeActionItemsByGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeActionItemsByGroupQuery, SummarizeActionItemsByGroupQueryVariables>(SummarizeActionItemsByGroupDocument, options);
        }
export type SummarizeActionItemsByGroupQueryHookResult = ReturnType<typeof useSummarizeActionItemsByGroupQuery>;
export type SummarizeActionItemsByGroupLazyQueryHookResult = ReturnType<typeof useSummarizeActionItemsByGroupLazyQuery>;
export type SummarizeActionItemsByGroupSuspenseQueryHookResult = ReturnType<typeof useSummarizeActionItemsByGroupSuspenseQuery>;
export type SummarizeActionItemsByGroupQueryResult = Apollo.QueryResult<SummarizeActionItemsByGroupQuery, SummarizeActionItemsByGroupQueryVariables>;
export const SummarizeActionItemsByObjectKindDocument = gql`
    query SummarizeActionItemsByObjectKind($filter: ActionItemFilter!, $legalEntityId: String!, $origin: IntervalOrigin) {
  summarizeActionItemsByObjectKind(
    filter: $filter
    legalEntityId: $legalEntityId
    origin: $origin
  ) {
    ...ActionItemsObjectKindSummaryFields
  }
}
    ${ActionItemsObjectKindSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeActionItemsByObjectKindQuery__
 *
 * To run a query within a React component, call `useSummarizeActionItemsByObjectKindQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeActionItemsByObjectKindQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeActionItemsByObjectKindQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      legalEntityId: // value for 'legalEntityId'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useSummarizeActionItemsByObjectKindQuery(baseOptions: Apollo.QueryHookOptions<SummarizeActionItemsByObjectKindQuery, SummarizeActionItemsByObjectKindQueryVariables> & ({ variables: SummarizeActionItemsByObjectKindQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeActionItemsByObjectKindQuery, SummarizeActionItemsByObjectKindQueryVariables>(SummarizeActionItemsByObjectKindDocument, options);
      }
export function useSummarizeActionItemsByObjectKindLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeActionItemsByObjectKindQuery, SummarizeActionItemsByObjectKindQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeActionItemsByObjectKindQuery, SummarizeActionItemsByObjectKindQueryVariables>(SummarizeActionItemsByObjectKindDocument, options);
        }
export function useSummarizeActionItemsByObjectKindSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeActionItemsByObjectKindQuery, SummarizeActionItemsByObjectKindQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeActionItemsByObjectKindQuery, SummarizeActionItemsByObjectKindQueryVariables>(SummarizeActionItemsByObjectKindDocument, options);
        }
export type SummarizeActionItemsByObjectKindQueryHookResult = ReturnType<typeof useSummarizeActionItemsByObjectKindQuery>;
export type SummarizeActionItemsByObjectKindLazyQueryHookResult = ReturnType<typeof useSummarizeActionItemsByObjectKindLazyQuery>;
export type SummarizeActionItemsByObjectKindSuspenseQueryHookResult = ReturnType<typeof useSummarizeActionItemsByObjectKindSuspenseQuery>;
export type SummarizeActionItemsByObjectKindQueryResult = Apollo.QueryResult<SummarizeActionItemsByObjectKindQuery, SummarizeActionItemsByObjectKindQueryVariables>;
export const SummarizeActionItemsByTimeDocument = gql`
    query SummarizeActionItemsByTime($filter: ActionItemFilter!, $viewKey: ViewKey!, $origin: IntervalOrigin!) {
  summarizeActionItemsByTime(filter: $filter, viewKey: $viewKey, origin: $origin) {
    ...ActionItemSummaryFields
  }
}
    ${ActionItemSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeActionItemsByTimeQuery__
 *
 * To run a query within a React component, call `useSummarizeActionItemsByTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeActionItemsByTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeActionItemsByTimeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      viewKey: // value for 'viewKey'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useSummarizeActionItemsByTimeQuery(baseOptions: Apollo.QueryHookOptions<SummarizeActionItemsByTimeQuery, SummarizeActionItemsByTimeQueryVariables> & ({ variables: SummarizeActionItemsByTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeActionItemsByTimeQuery, SummarizeActionItemsByTimeQueryVariables>(SummarizeActionItemsByTimeDocument, options);
      }
export function useSummarizeActionItemsByTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeActionItemsByTimeQuery, SummarizeActionItemsByTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeActionItemsByTimeQuery, SummarizeActionItemsByTimeQueryVariables>(SummarizeActionItemsByTimeDocument, options);
        }
export function useSummarizeActionItemsByTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeActionItemsByTimeQuery, SummarizeActionItemsByTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeActionItemsByTimeQuery, SummarizeActionItemsByTimeQueryVariables>(SummarizeActionItemsByTimeDocument, options);
        }
export type SummarizeActionItemsByTimeQueryHookResult = ReturnType<typeof useSummarizeActionItemsByTimeQuery>;
export type SummarizeActionItemsByTimeLazyQueryHookResult = ReturnType<typeof useSummarizeActionItemsByTimeLazyQuery>;
export type SummarizeActionItemsByTimeSuspenseQueryHookResult = ReturnType<typeof useSummarizeActionItemsByTimeSuspenseQuery>;
export type SummarizeActionItemsByTimeQueryResult = Apollo.QueryResult<SummarizeActionItemsByTimeQuery, SummarizeActionItemsByTimeQueryVariables>;
export const SummarizeClosedPeriodActionItemSectionsDocument = gql`
    query SummarizeClosedPeriodActionItemSections($dateChangesFilter: ActionItemFilter!, $transactionCreatesFilter: ActionItemFilter!, $existingTransactionsFilter: ActionItemFilter!, $matchRequestsFilter: ActionItemFilter!, $legalEntityId: String!) {
  dateChanges: summarizeActionItemsByGroup(
    filter: $dateChangesFilter
    legalEntityId: $legalEntityId
  ) {
    ...ActionItemsGroupSummaryFields
  }
  transactionCreates: summarizeActionItemsByGroup(
    filter: $transactionCreatesFilter
    legalEntityId: $legalEntityId
  ) {
    ...ActionItemsGroupSummaryFields
  }
  existingTransactions: summarizeActionItemsByGroup(
    filter: $existingTransactionsFilter
    legalEntityId: $legalEntityId
  ) {
    ...ActionItemsGroupSummaryFields
  }
  matchRequests: summarizeActionItemsByGroup(
    filter: $matchRequestsFilter
    legalEntityId: $legalEntityId
  ) {
    ...ActionItemsGroupSummaryFields
  }
}
    ${ActionItemsGroupSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeClosedPeriodActionItemSectionsQuery__
 *
 * To run a query within a React component, call `useSummarizeClosedPeriodActionItemSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeClosedPeriodActionItemSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeClosedPeriodActionItemSectionsQuery({
 *   variables: {
 *      dateChangesFilter: // value for 'dateChangesFilter'
 *      transactionCreatesFilter: // value for 'transactionCreatesFilter'
 *      existingTransactionsFilter: // value for 'existingTransactionsFilter'
 *      matchRequestsFilter: // value for 'matchRequestsFilter'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useSummarizeClosedPeriodActionItemSectionsQuery(baseOptions: Apollo.QueryHookOptions<SummarizeClosedPeriodActionItemSectionsQuery, SummarizeClosedPeriodActionItemSectionsQueryVariables> & ({ variables: SummarizeClosedPeriodActionItemSectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeClosedPeriodActionItemSectionsQuery, SummarizeClosedPeriodActionItemSectionsQueryVariables>(SummarizeClosedPeriodActionItemSectionsDocument, options);
      }
export function useSummarizeClosedPeriodActionItemSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeClosedPeriodActionItemSectionsQuery, SummarizeClosedPeriodActionItemSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeClosedPeriodActionItemSectionsQuery, SummarizeClosedPeriodActionItemSectionsQueryVariables>(SummarizeClosedPeriodActionItemSectionsDocument, options);
        }
export function useSummarizeClosedPeriodActionItemSectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeClosedPeriodActionItemSectionsQuery, SummarizeClosedPeriodActionItemSectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeClosedPeriodActionItemSectionsQuery, SummarizeClosedPeriodActionItemSectionsQueryVariables>(SummarizeClosedPeriodActionItemSectionsDocument, options);
        }
export type SummarizeClosedPeriodActionItemSectionsQueryHookResult = ReturnType<typeof useSummarizeClosedPeriodActionItemSectionsQuery>;
export type SummarizeClosedPeriodActionItemSectionsLazyQueryHookResult = ReturnType<typeof useSummarizeClosedPeriodActionItemSectionsLazyQuery>;
export type SummarizeClosedPeriodActionItemSectionsSuspenseQueryHookResult = ReturnType<typeof useSummarizeClosedPeriodActionItemSectionsSuspenseQuery>;
export type SummarizeClosedPeriodActionItemSectionsQueryResult = Apollo.QueryResult<SummarizeClosedPeriodActionItemSectionsQuery, SummarizeClosedPeriodActionItemSectionsQueryVariables>;
export const ReadActivityFeedDocument = gql`
    query ReadActivityFeed($legalEntityId: String!, $identifier: InputObjectIdentifier, $pagination: Pagination!) {
  activityFeed: readActivityFeed(
    legalEntityId: $legalEntityId
    identifier: $identifier
    page: $pagination
  ) {
    ...ActivityFeedFields
  }
}
    ${ActivityFeedFieldsFragmentDoc}`;

/**
 * __useReadActivityFeedQuery__
 *
 * To run a query within a React component, call `useReadActivityFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadActivityFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadActivityFeedQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      identifier: // value for 'identifier'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useReadActivityFeedQuery(baseOptions: Apollo.QueryHookOptions<ReadActivityFeedQuery, ReadActivityFeedQueryVariables> & ({ variables: ReadActivityFeedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadActivityFeedQuery, ReadActivityFeedQueryVariables>(ReadActivityFeedDocument, options);
      }
export function useReadActivityFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadActivityFeedQuery, ReadActivityFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadActivityFeedQuery, ReadActivityFeedQueryVariables>(ReadActivityFeedDocument, options);
        }
export function useReadActivityFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadActivityFeedQuery, ReadActivityFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadActivityFeedQuery, ReadActivityFeedQueryVariables>(ReadActivityFeedDocument, options);
        }
export type ReadActivityFeedQueryHookResult = ReturnType<typeof useReadActivityFeedQuery>;
export type ReadActivityFeedLazyQueryHookResult = ReturnType<typeof useReadActivityFeedLazyQuery>;
export type ReadActivityFeedSuspenseQueryHookResult = ReturnType<typeof useReadActivityFeedSuspenseQuery>;
export type ReadActivityFeedQueryResult = Apollo.QueryResult<ReadActivityFeedQuery, ReadActivityFeedQueryVariables>;
export const DisaffiliateLegalEntityDocument = gql`
    mutation DisaffiliateLegalEntity($organizationId: String!, $affiliationId: String!, $affiliatedLegalEntityId: String!, $affiliatedOrganizationId: String!, $comment: String) {
  disaffiliateLegalEntity(
    organizationId: $organizationId
    affiliationId: $affiliationId
    affiliatedLegalEntityId: $affiliatedLegalEntityId
    affiliatedOrganizationId: $affiliatedOrganizationId
    comment: $comment
  )
}
    `;
export type DisaffiliateLegalEntityMutationFn = Apollo.MutationFunction<DisaffiliateLegalEntityMutation, DisaffiliateLegalEntityMutationVariables>;

/**
 * __useDisaffiliateLegalEntityMutation__
 *
 * To run a mutation, you first call `useDisaffiliateLegalEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisaffiliateLegalEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disaffiliateLegalEntityMutation, { data, loading, error }] = useDisaffiliateLegalEntityMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      affiliationId: // value for 'affiliationId'
 *      affiliatedLegalEntityId: // value for 'affiliatedLegalEntityId'
 *      affiliatedOrganizationId: // value for 'affiliatedOrganizationId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useDisaffiliateLegalEntityMutation(baseOptions?: Apollo.MutationHookOptions<DisaffiliateLegalEntityMutation, DisaffiliateLegalEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisaffiliateLegalEntityMutation, DisaffiliateLegalEntityMutationVariables>(DisaffiliateLegalEntityDocument, options);
      }
export type DisaffiliateLegalEntityMutationHookResult = ReturnType<typeof useDisaffiliateLegalEntityMutation>;
export type DisaffiliateLegalEntityMutationResult = Apollo.MutationResult<DisaffiliateLegalEntityMutation>;
export type DisaffiliateLegalEntityMutationOptions = Apollo.BaseMutationOptions<DisaffiliateLegalEntityMutation, DisaffiliateLegalEntityMutationVariables>;
export const RemoveFirmAffiliationDocument = gql`
    mutation RemoveFirmAffiliation($organizationId: String!, $affiliationId: String!, $affiliatedLegalEntityId: String!, $comment: String) {
  removeFirmAffiliation(
    organizationId: $organizationId
    affiliationId: $affiliationId
    affiliatedLegalEntityId: $affiliatedLegalEntityId
    comment: $comment
  )
}
    `;
export type RemoveFirmAffiliationMutationFn = Apollo.MutationFunction<RemoveFirmAffiliationMutation, RemoveFirmAffiliationMutationVariables>;

/**
 * __useRemoveFirmAffiliationMutation__
 *
 * To run a mutation, you first call `useRemoveFirmAffiliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFirmAffiliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFirmAffiliationMutation, { data, loading, error }] = useRemoveFirmAffiliationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      affiliationId: // value for 'affiliationId'
 *      affiliatedLegalEntityId: // value for 'affiliatedLegalEntityId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useRemoveFirmAffiliationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFirmAffiliationMutation, RemoveFirmAffiliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFirmAffiliationMutation, RemoveFirmAffiliationMutationVariables>(RemoveFirmAffiliationDocument, options);
      }
export type RemoveFirmAffiliationMutationHookResult = ReturnType<typeof useRemoveFirmAffiliationMutation>;
export type RemoveFirmAffiliationMutationResult = Apollo.MutationResult<RemoveFirmAffiliationMutation>;
export type RemoveFirmAffiliationMutationOptions = Apollo.BaseMutationOptions<RemoveFirmAffiliationMutation, RemoveFirmAffiliationMutationVariables>;
export const ListAffiliatesDocument = gql`
    query ListAffiliates($legalEntityId: String!, $affiliateType: AffiliateType!) {
  listAffiliates(legalEntityId: $legalEntityId, affiliateType: $affiliateType) {
    ...AffiliateOrganizationsFields
  }
}
    ${AffiliateOrganizationsFieldsFragmentDoc}`;

/**
 * __useListAffiliatesQuery__
 *
 * To run a query within a React component, call `useListAffiliatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAffiliatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAffiliatesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      affiliateType: // value for 'affiliateType'
 *   },
 * });
 */
export function useListAffiliatesQuery(baseOptions: Apollo.QueryHookOptions<ListAffiliatesQuery, ListAffiliatesQueryVariables> & ({ variables: ListAffiliatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAffiliatesQuery, ListAffiliatesQueryVariables>(ListAffiliatesDocument, options);
      }
export function useListAffiliatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAffiliatesQuery, ListAffiliatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAffiliatesQuery, ListAffiliatesQueryVariables>(ListAffiliatesDocument, options);
        }
export function useListAffiliatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAffiliatesQuery, ListAffiliatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAffiliatesQuery, ListAffiliatesQueryVariables>(ListAffiliatesDocument, options);
        }
export type ListAffiliatesQueryHookResult = ReturnType<typeof useListAffiliatesQuery>;
export type ListAffiliatesLazyQueryHookResult = ReturnType<typeof useListAffiliatesLazyQuery>;
export type ListAffiliatesSuspenseQueryHookResult = ReturnType<typeof useListAffiliatesSuspenseQuery>;
export type ListAffiliatesQueryResult = Apollo.QueryResult<ListAffiliatesQuery, ListAffiliatesQueryVariables>;
export const GenerateExecutiveSummaryDocument = gql`
    query GenerateExecutiveSummary($legalEntityId: String!, $prompt: String!) {
  generateExecutiveSummary(legalEntityId: $legalEntityId, prompt: $prompt)
}
    `;

/**
 * __useGenerateExecutiveSummaryQuery__
 *
 * To run a query within a React component, call `useGenerateExecutiveSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateExecutiveSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateExecutiveSummaryQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      prompt: // value for 'prompt'
 *   },
 * });
 */
export function useGenerateExecutiveSummaryQuery(baseOptions: Apollo.QueryHookOptions<GenerateExecutiveSummaryQuery, GenerateExecutiveSummaryQueryVariables> & ({ variables: GenerateExecutiveSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateExecutiveSummaryQuery, GenerateExecutiveSummaryQueryVariables>(GenerateExecutiveSummaryDocument, options);
      }
export function useGenerateExecutiveSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateExecutiveSummaryQuery, GenerateExecutiveSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateExecutiveSummaryQuery, GenerateExecutiveSummaryQueryVariables>(GenerateExecutiveSummaryDocument, options);
        }
export function useGenerateExecutiveSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateExecutiveSummaryQuery, GenerateExecutiveSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateExecutiveSummaryQuery, GenerateExecutiveSummaryQueryVariables>(GenerateExecutiveSummaryDocument, options);
        }
export type GenerateExecutiveSummaryQueryHookResult = ReturnType<typeof useGenerateExecutiveSummaryQuery>;
export type GenerateExecutiveSummaryLazyQueryHookResult = ReturnType<typeof useGenerateExecutiveSummaryLazyQuery>;
export type GenerateExecutiveSummarySuspenseQueryHookResult = ReturnType<typeof useGenerateExecutiveSummarySuspenseQuery>;
export type GenerateExecutiveSummaryQueryResult = Apollo.QueryResult<GenerateExecutiveSummaryQuery, GenerateExecutiveSummaryQueryVariables>;
export const AskAssistantDocument = gql`
    subscription AskAssistant($viewKey: ViewKey!, $threadId: String, $thread: AssistantThread, $includeEntities: Boolean) {
  askAssistant(
    viewKey: $viewKey
    threadId: $threadId
    thread: $thread
    includeEntities: $includeEntities
  ) {
    kind
    comment {
      ...CommentFields
    }
    threadId
    layout {
      ...LayoutFields
    }
    entities {
      ...ObjectEntitiesFields
    }
    suggestions
  }
}
    ${CommentFieldsFragmentDoc}
${LayoutFieldsFragmentDoc}
${ObjectEntitiesFieldsFragmentDoc}`;

/**
 * __useAskAssistantSubscription__
 *
 * To run a query within a React component, call `useAskAssistantSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAskAssistantSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAskAssistantSubscription({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      threadId: // value for 'threadId'
 *      thread: // value for 'thread'
 *      includeEntities: // value for 'includeEntities'
 *   },
 * });
 */
export function useAskAssistantSubscription(baseOptions: Apollo.SubscriptionHookOptions<AskAssistantSubscription, AskAssistantSubscriptionVariables> & ({ variables: AskAssistantSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AskAssistantSubscription, AskAssistantSubscriptionVariables>(AskAssistantDocument, options);
      }
export type AskAssistantSubscriptionHookResult = ReturnType<typeof useAskAssistantSubscription>;
export type AskAssistantSubscriptionResult = Apollo.SubscriptionResult<AskAssistantSubscription>;
export const UpdateAuditRulesDocument = gql`
    mutation UpdateAuditRules($legalEntityId: String!, $rules: [UpdateAuditRule!]!, $isFTE: Boolean, $usedSuggestedCategories: Boolean) {
  updateAuditRules(
    legalEntityId: $legalEntityId
    rules: $rules
    isFTE: $isFTE
    usedSuggestedCategories: $usedSuggestedCategories
  )
}
    `;
export type UpdateAuditRulesMutationFn = Apollo.MutationFunction<UpdateAuditRulesMutation, UpdateAuditRulesMutationVariables>;

/**
 * __useUpdateAuditRulesMutation__
 *
 * To run a mutation, you first call `useUpdateAuditRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuditRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuditRulesMutation, { data, loading, error }] = useUpdateAuditRulesMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      rules: // value for 'rules'
 *      isFTE: // value for 'isFTE'
 *      usedSuggestedCategories: // value for 'usedSuggestedCategories'
 *   },
 * });
 */
export function useUpdateAuditRulesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAuditRulesMutation, UpdateAuditRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAuditRulesMutation, UpdateAuditRulesMutationVariables>(UpdateAuditRulesDocument, options);
      }
export type UpdateAuditRulesMutationHookResult = ReturnType<typeof useUpdateAuditRulesMutation>;
export type UpdateAuditRulesMutationResult = Apollo.MutationResult<UpdateAuditRulesMutation>;
export type UpdateAuditRulesMutationOptions = Apollo.BaseMutationOptions<UpdateAuditRulesMutation, UpdateAuditRulesMutationVariables>;
export const ListAuditRulesDocument = gql`
    query ListAuditRules($legalEntityId: String!) {
  listAuditRules(legalEntityId: $legalEntityId) {
    ...AuditRuleFields
  }
}
    ${AuditRuleFieldsFragmentDoc}`;

/**
 * __useListAuditRulesQuery__
 *
 * To run a query within a React component, call `useListAuditRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAuditRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAuditRulesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListAuditRulesQuery(baseOptions: Apollo.QueryHookOptions<ListAuditRulesQuery, ListAuditRulesQueryVariables> & ({ variables: ListAuditRulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAuditRulesQuery, ListAuditRulesQueryVariables>(ListAuditRulesDocument, options);
      }
export function useListAuditRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAuditRulesQuery, ListAuditRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAuditRulesQuery, ListAuditRulesQueryVariables>(ListAuditRulesDocument, options);
        }
export function useListAuditRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAuditRulesQuery, ListAuditRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAuditRulesQuery, ListAuditRulesQueryVariables>(ListAuditRulesDocument, options);
        }
export type ListAuditRulesQueryHookResult = ReturnType<typeof useListAuditRulesQuery>;
export type ListAuditRulesLazyQueryHookResult = ReturnType<typeof useListAuditRulesLazyQuery>;
export type ListAuditRulesSuspenseQueryHookResult = ReturnType<typeof useListAuditRulesSuspenseQuery>;
export type ListAuditRulesQueryResult = Apollo.QueryResult<ListAuditRulesQuery, ListAuditRulesQueryVariables>;
export const AddAffiliatedSubscriptionPriceDocument = gql`
    mutation AddAffiliatedSubscriptionPrice($affiliatedLegalEntityId: String!, $organizationId: String!, $priceId: String!) {
  addAffiliatedSubscriptionPrice(
    affiliatedLegalEntityId: $affiliatedLegalEntityId
    organizationId: $organizationId
    priceId: $priceId
  )
}
    `;
export type AddAffiliatedSubscriptionPriceMutationFn = Apollo.MutationFunction<AddAffiliatedSubscriptionPriceMutation, AddAffiliatedSubscriptionPriceMutationVariables>;

/**
 * __useAddAffiliatedSubscriptionPriceMutation__
 *
 * To run a mutation, you first call `useAddAffiliatedSubscriptionPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAffiliatedSubscriptionPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAffiliatedSubscriptionPriceMutation, { data, loading, error }] = useAddAffiliatedSubscriptionPriceMutation({
 *   variables: {
 *      affiliatedLegalEntityId: // value for 'affiliatedLegalEntityId'
 *      organizationId: // value for 'organizationId'
 *      priceId: // value for 'priceId'
 *   },
 * });
 */
export function useAddAffiliatedSubscriptionPriceMutation(baseOptions?: Apollo.MutationHookOptions<AddAffiliatedSubscriptionPriceMutation, AddAffiliatedSubscriptionPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAffiliatedSubscriptionPriceMutation, AddAffiliatedSubscriptionPriceMutationVariables>(AddAffiliatedSubscriptionPriceDocument, options);
      }
export type AddAffiliatedSubscriptionPriceMutationHookResult = ReturnType<typeof useAddAffiliatedSubscriptionPriceMutation>;
export type AddAffiliatedSubscriptionPriceMutationResult = Apollo.MutationResult<AddAffiliatedSubscriptionPriceMutation>;
export type AddAffiliatedSubscriptionPriceMutationOptions = Apollo.BaseMutationOptions<AddAffiliatedSubscriptionPriceMutation, AddAffiliatedSubscriptionPriceMutationVariables>;
export const AddSubscriptionItemDocument = gql`
    mutation AddSubscriptionItem($payerOrganizationId: String!, $legalEntityId: String!, $priceId: String!) {
  addSubscriptionItem(
    payerOrganizationId: $payerOrganizationId
    legalEntityId: $legalEntityId
    priceId: $priceId
  )
}
    `;
export type AddSubscriptionItemMutationFn = Apollo.MutationFunction<AddSubscriptionItemMutation, AddSubscriptionItemMutationVariables>;

/**
 * __useAddSubscriptionItemMutation__
 *
 * To run a mutation, you first call `useAddSubscriptionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSubscriptionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSubscriptionItemMutation, { data, loading, error }] = useAddSubscriptionItemMutation({
 *   variables: {
 *      payerOrganizationId: // value for 'payerOrganizationId'
 *      legalEntityId: // value for 'legalEntityId'
 *      priceId: // value for 'priceId'
 *   },
 * });
 */
export function useAddSubscriptionItemMutation(baseOptions?: Apollo.MutationHookOptions<AddSubscriptionItemMutation, AddSubscriptionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSubscriptionItemMutation, AddSubscriptionItemMutationVariables>(AddSubscriptionItemDocument, options);
      }
export type AddSubscriptionItemMutationHookResult = ReturnType<typeof useAddSubscriptionItemMutation>;
export type AddSubscriptionItemMutationResult = Apollo.MutationResult<AddSubscriptionItemMutation>;
export type AddSubscriptionItemMutationOptions = Apollo.BaseMutationOptions<AddSubscriptionItemMutation, AddSubscriptionItemMutationVariables>;
export const CancelBillingSubscriptionDocument = gql`
    mutation CancelBillingSubscription($organizationId: String!, $comment: String!) {
  cancelBillingSubscription(organizationId: $organizationId, comment: $comment)
}
    `;
export type CancelBillingSubscriptionMutationFn = Apollo.MutationFunction<CancelBillingSubscriptionMutation, CancelBillingSubscriptionMutationVariables>;

/**
 * __useCancelBillingSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelBillingSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBillingSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBillingSubscriptionMutation, { data, loading, error }] = useCancelBillingSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useCancelBillingSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelBillingSubscriptionMutation, CancelBillingSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelBillingSubscriptionMutation, CancelBillingSubscriptionMutationVariables>(CancelBillingSubscriptionDocument, options);
      }
export type CancelBillingSubscriptionMutationHookResult = ReturnType<typeof useCancelBillingSubscriptionMutation>;
export type CancelBillingSubscriptionMutationResult = Apollo.MutationResult<CancelBillingSubscriptionMutation>;
export type CancelBillingSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelBillingSubscriptionMutation, CancelBillingSubscriptionMutationVariables>;
export const ConfirmAccountantClientDocument = gql`
    mutation ConfirmAccountantClient($organizationId: String!, $affiliatedLegalEntityId: String!, $affiliatedOrganizationId: String!, $hasConnections: Boolean) {
  confirmAccountantClient(
    organizationId: $organizationId
    affiliatedLegalEntityId: $affiliatedLegalEntityId
    affiliatedOrganizationId: $affiliatedOrganizationId
    hasConnections: $hasConnections
  )
}
    `;
export type ConfirmAccountantClientMutationFn = Apollo.MutationFunction<ConfirmAccountantClientMutation, ConfirmAccountantClientMutationVariables>;

/**
 * __useConfirmAccountantClientMutation__
 *
 * To run a mutation, you first call `useConfirmAccountantClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmAccountantClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmAccountantClientMutation, { data, loading, error }] = useConfirmAccountantClientMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      affiliatedLegalEntityId: // value for 'affiliatedLegalEntityId'
 *      affiliatedOrganizationId: // value for 'affiliatedOrganizationId'
 *      hasConnections: // value for 'hasConnections'
 *   },
 * });
 */
export function useConfirmAccountantClientMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmAccountantClientMutation, ConfirmAccountantClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmAccountantClientMutation, ConfirmAccountantClientMutationVariables>(ConfirmAccountantClientDocument, options);
      }
export type ConfirmAccountantClientMutationHookResult = ReturnType<typeof useConfirmAccountantClientMutation>;
export type ConfirmAccountantClientMutationResult = Apollo.MutationResult<ConfirmAccountantClientMutation>;
export type ConfirmAccountantClientMutationOptions = Apollo.BaseMutationOptions<ConfirmAccountantClientMutation, ConfirmAccountantClientMutationVariables>;
export const ConfirmAffiliatedSubscriptionDocument = gql`
    mutation ConfirmAffiliatedSubscription($organizationId: String!, $affiliatedLegalEntityId: String!, $customerId: String!, $stripePaymentMethodId: String!) {
  confirmAffiliatedSubscription(
    organizationId: $organizationId
    affiliatedLegalEntityId: $affiliatedLegalEntityId
    customerId: $customerId
    stripePaymentMethodId: $stripePaymentMethodId
  )
}
    `;
export type ConfirmAffiliatedSubscriptionMutationFn = Apollo.MutationFunction<ConfirmAffiliatedSubscriptionMutation, ConfirmAffiliatedSubscriptionMutationVariables>;

/**
 * __useConfirmAffiliatedSubscriptionMutation__
 *
 * To run a mutation, you first call `useConfirmAffiliatedSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmAffiliatedSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmAffiliatedSubscriptionMutation, { data, loading, error }] = useConfirmAffiliatedSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      affiliatedLegalEntityId: // value for 'affiliatedLegalEntityId'
 *      customerId: // value for 'customerId'
 *      stripePaymentMethodId: // value for 'stripePaymentMethodId'
 *   },
 * });
 */
export function useConfirmAffiliatedSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmAffiliatedSubscriptionMutation, ConfirmAffiliatedSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmAffiliatedSubscriptionMutation, ConfirmAffiliatedSubscriptionMutationVariables>(ConfirmAffiliatedSubscriptionDocument, options);
      }
export type ConfirmAffiliatedSubscriptionMutationHookResult = ReturnType<typeof useConfirmAffiliatedSubscriptionMutation>;
export type ConfirmAffiliatedSubscriptionMutationResult = Apollo.MutationResult<ConfirmAffiliatedSubscriptionMutation>;
export type ConfirmAffiliatedSubscriptionMutationOptions = Apollo.BaseMutationOptions<ConfirmAffiliatedSubscriptionMutation, ConfirmAffiliatedSubscriptionMutationVariables>;
export const ConfirmBillingSubscriptionDocument = gql`
    mutation ConfirmBillingSubscription($organizationId: String!, $customerId: String!, $stripePaymentMethodId: String!) {
  confirmBillingSubscription(
    organizationId: $organizationId
    customerId: $customerId
    stripePaymentMethodId: $stripePaymentMethodId
  )
}
    `;
export type ConfirmBillingSubscriptionMutationFn = Apollo.MutationFunction<ConfirmBillingSubscriptionMutation, ConfirmBillingSubscriptionMutationVariables>;

/**
 * __useConfirmBillingSubscriptionMutation__
 *
 * To run a mutation, you first call `useConfirmBillingSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmBillingSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmBillingSubscriptionMutation, { data, loading, error }] = useConfirmBillingSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      customerId: // value for 'customerId'
 *      stripePaymentMethodId: // value for 'stripePaymentMethodId'
 *   },
 * });
 */
export function useConfirmBillingSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmBillingSubscriptionMutation, ConfirmBillingSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmBillingSubscriptionMutation, ConfirmBillingSubscriptionMutationVariables>(ConfirmBillingSubscriptionDocument, options);
      }
export type ConfirmBillingSubscriptionMutationHookResult = ReturnType<typeof useConfirmBillingSubscriptionMutation>;
export type ConfirmBillingSubscriptionMutationResult = Apollo.MutationResult<ConfirmBillingSubscriptionMutation>;
export type ConfirmBillingSubscriptionMutationOptions = Apollo.BaseMutationOptions<ConfirmBillingSubscriptionMutation, ConfirmBillingSubscriptionMutationVariables>;
export const ConfirmClientPaysDocument = gql`
    mutation ConfirmClientPays($organizationId: String!, $legalEntityId: String!) {
  confirmClientPays(
    organizationId: $organizationId
    legalEntityId: $legalEntityId
  )
}
    `;
export type ConfirmClientPaysMutationFn = Apollo.MutationFunction<ConfirmClientPaysMutation, ConfirmClientPaysMutationVariables>;

/**
 * __useConfirmClientPaysMutation__
 *
 * To run a mutation, you first call `useConfirmClientPaysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmClientPaysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmClientPaysMutation, { data, loading, error }] = useConfirmClientPaysMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useConfirmClientPaysMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmClientPaysMutation, ConfirmClientPaysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmClientPaysMutation, ConfirmClientPaysMutationVariables>(ConfirmClientPaysDocument, options);
      }
export type ConfirmClientPaysMutationHookResult = ReturnType<typeof useConfirmClientPaysMutation>;
export type ConfirmClientPaysMutationResult = Apollo.MutationResult<ConfirmClientPaysMutation>;
export type ConfirmClientPaysMutationOptions = Apollo.BaseMutationOptions<ConfirmClientPaysMutation, ConfirmClientPaysMutationVariables>;
export const CreateAffiliatedSubscriptionDocument = gql`
    mutation CreateAffiliatedSubscription($organizationId: String!, $affiliatedLegalEntityId: String!, $priceId: String!, $promoCodeId: String, $stripePaymentMethodId: String!) {
  createAffiliatedSubscription(
    organizationId: $organizationId
    affiliatedLegalEntityId: $affiliatedLegalEntityId
    priceId: $priceId
    promoCodeId: $promoCodeId
    stripePaymentMethodId: $stripePaymentMethodId
  ) {
    ...NewAffiliatedBillingSubscriptionFields
  }
}
    ${NewAffiliatedBillingSubscriptionFieldsFragmentDoc}`;
export type CreateAffiliatedSubscriptionMutationFn = Apollo.MutationFunction<CreateAffiliatedSubscriptionMutation, CreateAffiliatedSubscriptionMutationVariables>;

/**
 * __useCreateAffiliatedSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateAffiliatedSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAffiliatedSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAffiliatedSubscriptionMutation, { data, loading, error }] = useCreateAffiliatedSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      affiliatedLegalEntityId: // value for 'affiliatedLegalEntityId'
 *      priceId: // value for 'priceId'
 *      promoCodeId: // value for 'promoCodeId'
 *      stripePaymentMethodId: // value for 'stripePaymentMethodId'
 *   },
 * });
 */
export function useCreateAffiliatedSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateAffiliatedSubscriptionMutation, CreateAffiliatedSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAffiliatedSubscriptionMutation, CreateAffiliatedSubscriptionMutationVariables>(CreateAffiliatedSubscriptionDocument, options);
      }
export type CreateAffiliatedSubscriptionMutationHookResult = ReturnType<typeof useCreateAffiliatedSubscriptionMutation>;
export type CreateAffiliatedSubscriptionMutationResult = Apollo.MutationResult<CreateAffiliatedSubscriptionMutation>;
export type CreateAffiliatedSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateAffiliatedSubscriptionMutation, CreateAffiliatedSubscriptionMutationVariables>;
export const CreateBillingOnboardingSubscriptionDocument = gql`
    mutation CreateBillingOnboardingSubscription($organizationId: String!, $productName: BillingProductName, $promoCode: String) {
  createBillingOnboardingSubscription(
    organizationId: $organizationId
    productName: $productName
    promoCode: $promoCode
  ) {
    ...CreateBillingOnboardingSubscriptionFields
  }
}
    ${CreateBillingOnboardingSubscriptionFieldsFragmentDoc}`;
export type CreateBillingOnboardingSubscriptionMutationFn = Apollo.MutationFunction<CreateBillingOnboardingSubscriptionMutation, CreateBillingOnboardingSubscriptionMutationVariables>;

/**
 * __useCreateBillingOnboardingSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateBillingOnboardingSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingOnboardingSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingOnboardingSubscriptionMutation, { data, loading, error }] = useCreateBillingOnboardingSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      productName: // value for 'productName'
 *      promoCode: // value for 'promoCode'
 *   },
 * });
 */
export function useCreateBillingOnboardingSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateBillingOnboardingSubscriptionMutation, CreateBillingOnboardingSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBillingOnboardingSubscriptionMutation, CreateBillingOnboardingSubscriptionMutationVariables>(CreateBillingOnboardingSubscriptionDocument, options);
      }
export type CreateBillingOnboardingSubscriptionMutationHookResult = ReturnType<typeof useCreateBillingOnboardingSubscriptionMutation>;
export type CreateBillingOnboardingSubscriptionMutationResult = Apollo.MutationResult<CreateBillingOnboardingSubscriptionMutation>;
export type CreateBillingOnboardingSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateBillingOnboardingSubscriptionMutation, CreateBillingOnboardingSubscriptionMutationVariables>;
export const CreateBillingSubscriptionDocument = gql`
    mutation CreateBillingSubscription($organizationId: String!, $priceId: String!, $stripePaymentMethodId: String) {
  createBillingSubscription(
    organizationId: $organizationId
    priceId: $priceId
    stripePaymentMethodId: $stripePaymentMethodId
  ) {
    ...NewBillingSubscriptionFields
  }
}
    ${NewBillingSubscriptionFieldsFragmentDoc}`;
export type CreateBillingSubscriptionMutationFn = Apollo.MutationFunction<CreateBillingSubscriptionMutation, CreateBillingSubscriptionMutationVariables>;

/**
 * __useCreateBillingSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateBillingSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillingSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillingSubscriptionMutation, { data, loading, error }] = useCreateBillingSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      priceId: // value for 'priceId'
 *      stripePaymentMethodId: // value for 'stripePaymentMethodId'
 *   },
 * });
 */
export function useCreateBillingSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateBillingSubscriptionMutation, CreateBillingSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBillingSubscriptionMutation, CreateBillingSubscriptionMutationVariables>(CreateBillingSubscriptionDocument, options);
      }
export type CreateBillingSubscriptionMutationHookResult = ReturnType<typeof useCreateBillingSubscriptionMutation>;
export type CreateBillingSubscriptionMutationResult = Apollo.MutationResult<CreateBillingSubscriptionMutation>;
export type CreateBillingSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateBillingSubscriptionMutation, CreateBillingSubscriptionMutationVariables>;
export const CreateClientPaysSubscriptionDocument = gql`
    mutation CreateClientPaysSubscription($organizationId: String!, $priceId: String!, $promoCodeId: String, $stripePaymentMethodId: String!, $legalEntityId: String) {
  createClientPaysSubscription(
    organizationId: $organizationId
    priceId: $priceId
    promoCodeId: $promoCodeId
    stripePaymentMethodId: $stripePaymentMethodId
    legalEntityId: $legalEntityId
  ) {
    stripeClientSecret
    customerId
    productId
  }
}
    `;
export type CreateClientPaysSubscriptionMutationFn = Apollo.MutationFunction<CreateClientPaysSubscriptionMutation, CreateClientPaysSubscriptionMutationVariables>;

/**
 * __useCreateClientPaysSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateClientPaysSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientPaysSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientPaysSubscriptionMutation, { data, loading, error }] = useCreateClientPaysSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      priceId: // value for 'priceId'
 *      promoCodeId: // value for 'promoCodeId'
 *      stripePaymentMethodId: // value for 'stripePaymentMethodId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useCreateClientPaysSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientPaysSubscriptionMutation, CreateClientPaysSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientPaysSubscriptionMutation, CreateClientPaysSubscriptionMutationVariables>(CreateClientPaysSubscriptionDocument, options);
      }
export type CreateClientPaysSubscriptionMutationHookResult = ReturnType<typeof useCreateClientPaysSubscriptionMutation>;
export type CreateClientPaysSubscriptionMutationResult = Apollo.MutationResult<CreateClientPaysSubscriptionMutation>;
export type CreateClientPaysSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateClientPaysSubscriptionMutation, CreateClientPaysSubscriptionMutationVariables>;
export const ProvisionClientPaysSubscriptionDocument = gql`
    mutation ProvisionClientPaysSubscription($firmOrganizationId: String!, $affiliatedOrganizationId: String!, $affiliatedLegalEntityId: String!, $priceId: String!, $familyName: String!, $givenName: String!, $email: String!, $message: String!) {
  provisionClientPaysSubscription(
    firmOrganizationId: $firmOrganizationId
    affiliatedOrganizationId: $affiliatedOrganizationId
    affiliatedLegalEntityId: $affiliatedLegalEntityId
    priceId: $priceId
    familyName: $familyName
    givenName: $givenName
    email: $email
    message: $message
  )
}
    `;
export type ProvisionClientPaysSubscriptionMutationFn = Apollo.MutationFunction<ProvisionClientPaysSubscriptionMutation, ProvisionClientPaysSubscriptionMutationVariables>;

/**
 * __useProvisionClientPaysSubscriptionMutation__
 *
 * To run a mutation, you first call `useProvisionClientPaysSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionClientPaysSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionClientPaysSubscriptionMutation, { data, loading, error }] = useProvisionClientPaysSubscriptionMutation({
 *   variables: {
 *      firmOrganizationId: // value for 'firmOrganizationId'
 *      affiliatedOrganizationId: // value for 'affiliatedOrganizationId'
 *      affiliatedLegalEntityId: // value for 'affiliatedLegalEntityId'
 *      priceId: // value for 'priceId'
 *      familyName: // value for 'familyName'
 *      givenName: // value for 'givenName'
 *      email: // value for 'email'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useProvisionClientPaysSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionClientPaysSubscriptionMutation, ProvisionClientPaysSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionClientPaysSubscriptionMutation, ProvisionClientPaysSubscriptionMutationVariables>(ProvisionClientPaysSubscriptionDocument, options);
      }
export type ProvisionClientPaysSubscriptionMutationHookResult = ReturnType<typeof useProvisionClientPaysSubscriptionMutation>;
export type ProvisionClientPaysSubscriptionMutationResult = Apollo.MutationResult<ProvisionClientPaysSubscriptionMutation>;
export type ProvisionClientPaysSubscriptionMutationOptions = Apollo.BaseMutationOptions<ProvisionClientPaysSubscriptionMutation, ProvisionClientPaysSubscriptionMutationVariables>;
export const ProvisionTrialBillingSubscriptionDocument = gql`
    mutation ProvisionTrialBillingSubscription($organizationId: String!, $priceId: String!, $stripePaymentMethodId: String!, $promoCodeId: String, $legalEntityId: String) {
  provisionTrialBillingSubscription(
    organizationId: $organizationId
    priceId: $priceId
    stripePaymentMethodId: $stripePaymentMethodId
    promoCodeId: $promoCodeId
    legalEntityId: $legalEntityId
  ) {
    ...NewTrialBillingSubscriptionFields
  }
}
    ${NewTrialBillingSubscriptionFieldsFragmentDoc}`;
export type ProvisionTrialBillingSubscriptionMutationFn = Apollo.MutationFunction<ProvisionTrialBillingSubscriptionMutation, ProvisionTrialBillingSubscriptionMutationVariables>;

/**
 * __useProvisionTrialBillingSubscriptionMutation__
 *
 * To run a mutation, you first call `useProvisionTrialBillingSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionTrialBillingSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionTrialBillingSubscriptionMutation, { data, loading, error }] = useProvisionTrialBillingSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      priceId: // value for 'priceId'
 *      stripePaymentMethodId: // value for 'stripePaymentMethodId'
 *      promoCodeId: // value for 'promoCodeId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useProvisionTrialBillingSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionTrialBillingSubscriptionMutation, ProvisionTrialBillingSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionTrialBillingSubscriptionMutation, ProvisionTrialBillingSubscriptionMutationVariables>(ProvisionTrialBillingSubscriptionDocument, options);
      }
export type ProvisionTrialBillingSubscriptionMutationHookResult = ReturnType<typeof useProvisionTrialBillingSubscriptionMutation>;
export type ProvisionTrialBillingSubscriptionMutationResult = Apollo.MutationResult<ProvisionTrialBillingSubscriptionMutation>;
export type ProvisionTrialBillingSubscriptionMutationOptions = Apollo.BaseMutationOptions<ProvisionTrialBillingSubscriptionMutation, ProvisionTrialBillingSubscriptionMutationVariables>;
export const SetupSubscriptionDocument = gql`
    mutation SetupSubscription($payerOrganizationId: String!, $legalEntityId: String!, $stripePaymentMethodId: String!, $priceId: String!, $stripePromoCodeId: String, $trial: SetupSubscriptionTrial!) {
  setupSubscription(
    payerOrganizationId: $payerOrganizationId
    legalEntityId: $legalEntityId
    stripePaymentMethodId: $stripePaymentMethodId
    priceId: $priceId
    stripePromoCodeId: $stripePromoCodeId
    trial: $trial
  ) {
    arrangement {
      organizationId
      subscription {
        subscriptionId
      }
    }
    stripeClientSecret
  }
}
    `;
export type SetupSubscriptionMutationFn = Apollo.MutationFunction<SetupSubscriptionMutation, SetupSubscriptionMutationVariables>;

/**
 * __useSetupSubscriptionMutation__
 *
 * To run a mutation, you first call `useSetupSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupSubscriptionMutation, { data, loading, error }] = useSetupSubscriptionMutation({
 *   variables: {
 *      payerOrganizationId: // value for 'payerOrganizationId'
 *      legalEntityId: // value for 'legalEntityId'
 *      stripePaymentMethodId: // value for 'stripePaymentMethodId'
 *      priceId: // value for 'priceId'
 *      stripePromoCodeId: // value for 'stripePromoCodeId'
 *      trial: // value for 'trial'
 *   },
 * });
 */
export function useSetupSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<SetupSubscriptionMutation, SetupSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupSubscriptionMutation, SetupSubscriptionMutationVariables>(SetupSubscriptionDocument, options);
      }
export type SetupSubscriptionMutationHookResult = ReturnType<typeof useSetupSubscriptionMutation>;
export type SetupSubscriptionMutationResult = Apollo.MutationResult<SetupSubscriptionMutation>;
export type SetupSubscriptionMutationOptions = Apollo.BaseMutationOptions<SetupSubscriptionMutation, SetupSubscriptionMutationVariables>;
export const UpdateAffiliatedSubscriptionPriceDocument = gql`
    mutation UpdateAffiliatedSubscriptionPrice($affiliatedLegalEntityId: String!, $organizationId: String!, $productId: String!, $priceId: String!) {
  updateAffiliatedSubscriptionPrice(
    affiliatedLegalEntityId: $affiliatedLegalEntityId
    organizationId: $organizationId
    productId: $productId
    priceId: $priceId
  )
}
    `;
export type UpdateAffiliatedSubscriptionPriceMutationFn = Apollo.MutationFunction<UpdateAffiliatedSubscriptionPriceMutation, UpdateAffiliatedSubscriptionPriceMutationVariables>;

/**
 * __useUpdateAffiliatedSubscriptionPriceMutation__
 *
 * To run a mutation, you first call `useUpdateAffiliatedSubscriptionPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAffiliatedSubscriptionPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAffiliatedSubscriptionPriceMutation, { data, loading, error }] = useUpdateAffiliatedSubscriptionPriceMutation({
 *   variables: {
 *      affiliatedLegalEntityId: // value for 'affiliatedLegalEntityId'
 *      organizationId: // value for 'organizationId'
 *      productId: // value for 'productId'
 *      priceId: // value for 'priceId'
 *   },
 * });
 */
export function useUpdateAffiliatedSubscriptionPriceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAffiliatedSubscriptionPriceMutation, UpdateAffiliatedSubscriptionPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAffiliatedSubscriptionPriceMutation, UpdateAffiliatedSubscriptionPriceMutationVariables>(UpdateAffiliatedSubscriptionPriceDocument, options);
      }
export type UpdateAffiliatedSubscriptionPriceMutationHookResult = ReturnType<typeof useUpdateAffiliatedSubscriptionPriceMutation>;
export type UpdateAffiliatedSubscriptionPriceMutationResult = Apollo.MutationResult<UpdateAffiliatedSubscriptionPriceMutation>;
export type UpdateAffiliatedSubscriptionPriceMutationOptions = Apollo.BaseMutationOptions<UpdateAffiliatedSubscriptionPriceMutation, UpdateAffiliatedSubscriptionPriceMutationVariables>;
export const UpdateBillingAddressDocument = gql`
    mutation UpdateBillingAddress($organizationId: String!, $fullName: String!, $address: AddressInput!) {
  updateBillingAddress(
    organizationId: $organizationId
    fullName: $fullName
    address: $address
  )
}
    `;
export type UpdateBillingAddressMutationFn = Apollo.MutationFunction<UpdateBillingAddressMutation, UpdateBillingAddressMutationVariables>;

/**
 * __useUpdateBillingAddressMutation__
 *
 * To run a mutation, you first call `useUpdateBillingAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingAddressMutation, { data, loading, error }] = useUpdateBillingAddressMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      fullName: // value for 'fullName'
 *      address: // value for 'address'
 *   },
 * });
 */
export function useUpdateBillingAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillingAddressMutation, UpdateBillingAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillingAddressMutation, UpdateBillingAddressMutationVariables>(UpdateBillingAddressDocument, options);
      }
export type UpdateBillingAddressMutationHookResult = ReturnType<typeof useUpdateBillingAddressMutation>;
export type UpdateBillingAddressMutationResult = Apollo.MutationResult<UpdateBillingAddressMutation>;
export type UpdateBillingAddressMutationOptions = Apollo.BaseMutationOptions<UpdateBillingAddressMutation, UpdateBillingAddressMutationVariables>;
export const UpdateBillingPaymentMethodDocument = gql`
    mutation UpdateBillingPaymentMethod($organizationId: String!, $stripePaymentMethodId: String!) {
  updateBillingPaymentMethod(
    organizationId: $organizationId
    stripePaymentMethodId: $stripePaymentMethodId
  )
}
    `;
export type UpdateBillingPaymentMethodMutationFn = Apollo.MutationFunction<UpdateBillingPaymentMethodMutation, UpdateBillingPaymentMethodMutationVariables>;

/**
 * __useUpdateBillingPaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdateBillingPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingPaymentMethodMutation, { data, loading, error }] = useUpdateBillingPaymentMethodMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      stripePaymentMethodId: // value for 'stripePaymentMethodId'
 *   },
 * });
 */
export function useUpdateBillingPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillingPaymentMethodMutation, UpdateBillingPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillingPaymentMethodMutation, UpdateBillingPaymentMethodMutationVariables>(UpdateBillingPaymentMethodDocument, options);
      }
export type UpdateBillingPaymentMethodMutationHookResult = ReturnType<typeof useUpdateBillingPaymentMethodMutation>;
export type UpdateBillingPaymentMethodMutationResult = Apollo.MutationResult<UpdateBillingPaymentMethodMutation>;
export type UpdateBillingPaymentMethodMutationOptions = Apollo.BaseMutationOptions<UpdateBillingPaymentMethodMutation, UpdateBillingPaymentMethodMutationVariables>;
export const UpdateBillingSubscriptionDocument = gql`
    mutation UpdateBillingSubscription($organizationId: String!, $priceId: String!) {
  updateBillingSubscription(organizationId: $organizationId, priceId: $priceId)
}
    `;
export type UpdateBillingSubscriptionMutationFn = Apollo.MutationFunction<UpdateBillingSubscriptionMutation, UpdateBillingSubscriptionMutationVariables>;

/**
 * __useUpdateBillingSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateBillingSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBillingSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBillingSubscriptionMutation, { data, loading, error }] = useUpdateBillingSubscriptionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      priceId: // value for 'priceId'
 *   },
 * });
 */
export function useUpdateBillingSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBillingSubscriptionMutation, UpdateBillingSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBillingSubscriptionMutation, UpdateBillingSubscriptionMutationVariables>(UpdateBillingSubscriptionDocument, options);
      }
export type UpdateBillingSubscriptionMutationHookResult = ReturnType<typeof useUpdateBillingSubscriptionMutation>;
export type UpdateBillingSubscriptionMutationResult = Apollo.MutationResult<UpdateBillingSubscriptionMutation>;
export type UpdateBillingSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateBillingSubscriptionMutation, UpdateBillingSubscriptionMutationVariables>;
export const CheckAffiliatedSubscriptionProductDocument = gql`
    query CheckAffiliatedSubscriptionProduct($organizationId: String!, $affiliatedLegalEntityId: String!) {
  checkAffiliatedSubscriptionProduct(
    organizationId: $organizationId
    affiliatedLegalEntityId: $affiliatedLegalEntityId
  ) {
    exists
    product {
      ...BillingProductFields
    }
  }
}
    ${BillingProductFieldsFragmentDoc}`;

/**
 * __useCheckAffiliatedSubscriptionProductQuery__
 *
 * To run a query within a React component, call `useCheckAffiliatedSubscriptionProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckAffiliatedSubscriptionProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckAffiliatedSubscriptionProductQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      affiliatedLegalEntityId: // value for 'affiliatedLegalEntityId'
 *   },
 * });
 */
export function useCheckAffiliatedSubscriptionProductQuery(baseOptions: Apollo.QueryHookOptions<CheckAffiliatedSubscriptionProductQuery, CheckAffiliatedSubscriptionProductQueryVariables> & ({ variables: CheckAffiliatedSubscriptionProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckAffiliatedSubscriptionProductQuery, CheckAffiliatedSubscriptionProductQueryVariables>(CheckAffiliatedSubscriptionProductDocument, options);
      }
export function useCheckAffiliatedSubscriptionProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckAffiliatedSubscriptionProductQuery, CheckAffiliatedSubscriptionProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckAffiliatedSubscriptionProductQuery, CheckAffiliatedSubscriptionProductQueryVariables>(CheckAffiliatedSubscriptionProductDocument, options);
        }
export function useCheckAffiliatedSubscriptionProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckAffiliatedSubscriptionProductQuery, CheckAffiliatedSubscriptionProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckAffiliatedSubscriptionProductQuery, CheckAffiliatedSubscriptionProductQueryVariables>(CheckAffiliatedSubscriptionProductDocument, options);
        }
export type CheckAffiliatedSubscriptionProductQueryHookResult = ReturnType<typeof useCheckAffiliatedSubscriptionProductQuery>;
export type CheckAffiliatedSubscriptionProductLazyQueryHookResult = ReturnType<typeof useCheckAffiliatedSubscriptionProductLazyQuery>;
export type CheckAffiliatedSubscriptionProductSuspenseQueryHookResult = ReturnType<typeof useCheckAffiliatedSubscriptionProductSuspenseQuery>;
export type CheckAffiliatedSubscriptionProductQueryResult = Apollo.QueryResult<CheckAffiliatedSubscriptionProductQuery, CheckAffiliatedSubscriptionProductQueryVariables>;
export const CheckBillingCustomerProfileDocument = gql`
    query CheckBillingCustomerProfile($organizationId: String!) {
  checkBillingCustomerProfile(organizationId: $organizationId) {
    exists
    billingCustomerProfile {
      cardDetails {
        ...BillingCardDetailsFields
      }
    }
  }
}
    ${BillingCardDetailsFieldsFragmentDoc}`;

/**
 * __useCheckBillingCustomerProfileQuery__
 *
 * To run a query within a React component, call `useCheckBillingCustomerProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckBillingCustomerProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckBillingCustomerProfileQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCheckBillingCustomerProfileQuery(baseOptions: Apollo.QueryHookOptions<CheckBillingCustomerProfileQuery, CheckBillingCustomerProfileQueryVariables> & ({ variables: CheckBillingCustomerProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckBillingCustomerProfileQuery, CheckBillingCustomerProfileQueryVariables>(CheckBillingCustomerProfileDocument, options);
      }
export function useCheckBillingCustomerProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckBillingCustomerProfileQuery, CheckBillingCustomerProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckBillingCustomerProfileQuery, CheckBillingCustomerProfileQueryVariables>(CheckBillingCustomerProfileDocument, options);
        }
export function useCheckBillingCustomerProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckBillingCustomerProfileQuery, CheckBillingCustomerProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckBillingCustomerProfileQuery, CheckBillingCustomerProfileQueryVariables>(CheckBillingCustomerProfileDocument, options);
        }
export type CheckBillingCustomerProfileQueryHookResult = ReturnType<typeof useCheckBillingCustomerProfileQuery>;
export type CheckBillingCustomerProfileLazyQueryHookResult = ReturnType<typeof useCheckBillingCustomerProfileLazyQuery>;
export type CheckBillingCustomerProfileSuspenseQueryHookResult = ReturnType<typeof useCheckBillingCustomerProfileSuspenseQuery>;
export type CheckBillingCustomerProfileQueryResult = Apollo.QueryResult<CheckBillingCustomerProfileQuery, CheckBillingCustomerProfileQueryVariables>;
export const CheckBillingOrganizationPlanDocument = gql`
    query CheckBillingOrganizationPlan($organizationId: String!) {
  checkBillingOrganizationPlan(organizationId: $organizationId) {
    exists
    billingPlan {
      ...BillingPlanFields
    }
    trial {
      ...BillingTrialFields
    }
    subscriptionDetails {
      ...SubscriptionDetailsFields
    }
  }
}
    ${BillingPlanFieldsFragmentDoc}
${BillingTrialFieldsFragmentDoc}
${SubscriptionDetailsFieldsFragmentDoc}`;

/**
 * __useCheckBillingOrganizationPlanQuery__
 *
 * To run a query within a React component, call `useCheckBillingOrganizationPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckBillingOrganizationPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckBillingOrganizationPlanQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCheckBillingOrganizationPlanQuery(baseOptions: Apollo.QueryHookOptions<CheckBillingOrganizationPlanQuery, CheckBillingOrganizationPlanQueryVariables> & ({ variables: CheckBillingOrganizationPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckBillingOrganizationPlanQuery, CheckBillingOrganizationPlanQueryVariables>(CheckBillingOrganizationPlanDocument, options);
      }
export function useCheckBillingOrganizationPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckBillingOrganizationPlanQuery, CheckBillingOrganizationPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckBillingOrganizationPlanQuery, CheckBillingOrganizationPlanQueryVariables>(CheckBillingOrganizationPlanDocument, options);
        }
export function useCheckBillingOrganizationPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckBillingOrganizationPlanQuery, CheckBillingOrganizationPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckBillingOrganizationPlanQuery, CheckBillingOrganizationPlanQueryVariables>(CheckBillingOrganizationPlanDocument, options);
        }
export type CheckBillingOrganizationPlanQueryHookResult = ReturnType<typeof useCheckBillingOrganizationPlanQuery>;
export type CheckBillingOrganizationPlanLazyQueryHookResult = ReturnType<typeof useCheckBillingOrganizationPlanLazyQuery>;
export type CheckBillingOrganizationPlanSuspenseQueryHookResult = ReturnType<typeof useCheckBillingOrganizationPlanSuspenseQuery>;
export type CheckBillingOrganizationPlanQueryResult = Apollo.QueryResult<CheckBillingOrganizationPlanQuery, CheckBillingOrganizationPlanQueryVariables>;
export const ListAvailableBillingPlansDocument = gql`
    query ListAvailableBillingPlans($organizationId: String!) {
  listAvailableBillingPlans(organizationId: $organizationId) {
    product {
      ...BillingProductFields
    }
    price {
      ...BillingPriceFields
    }
  }
}
    ${BillingProductFieldsFragmentDoc}
${BillingPriceFieldsFragmentDoc}`;

/**
 * __useListAvailableBillingPlansQuery__
 *
 * To run a query within a React component, call `useListAvailableBillingPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAvailableBillingPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAvailableBillingPlansQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListAvailableBillingPlansQuery(baseOptions: Apollo.QueryHookOptions<ListAvailableBillingPlansQuery, ListAvailableBillingPlansQueryVariables> & ({ variables: ListAvailableBillingPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAvailableBillingPlansQuery, ListAvailableBillingPlansQueryVariables>(ListAvailableBillingPlansDocument, options);
      }
export function useListAvailableBillingPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAvailableBillingPlansQuery, ListAvailableBillingPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAvailableBillingPlansQuery, ListAvailableBillingPlansQueryVariables>(ListAvailableBillingPlansDocument, options);
        }
export function useListAvailableBillingPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAvailableBillingPlansQuery, ListAvailableBillingPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAvailableBillingPlansQuery, ListAvailableBillingPlansQueryVariables>(ListAvailableBillingPlansDocument, options);
        }
export type ListAvailableBillingPlansQueryHookResult = ReturnType<typeof useListAvailableBillingPlansQuery>;
export type ListAvailableBillingPlansLazyQueryHookResult = ReturnType<typeof useListAvailableBillingPlansLazyQuery>;
export type ListAvailableBillingPlansSuspenseQueryHookResult = ReturnType<typeof useListAvailableBillingPlansSuspenseQuery>;
export type ListAvailableBillingPlansQueryResult = Apollo.QueryResult<ListAvailableBillingPlansQuery, ListAvailableBillingPlansQueryVariables>;
export const ListBillingSubscriptionHistoryDocument = gql`
    query ListBillingSubscriptionHistory($organizationId: String!) {
  listBillingSubscriptionHistory(organizationId: $organizationId) {
    createdAt
    paidAt
    status
    invoiceURL
    prorationAmount {
      amount
      currencyMultiplier
      iso4217CurrencyCode
    }
    recurringAmount {
      amount
      currencyMultiplier
      iso4217CurrencyCode
    }
    totalAmount {
      amount
      currencyMultiplier
      iso4217CurrencyCode
    }
    cardDetails {
      ...BillingCardDetailsFields
    }
  }
}
    ${BillingCardDetailsFieldsFragmentDoc}`;

/**
 * __useListBillingSubscriptionHistoryQuery__
 *
 * To run a query within a React component, call `useListBillingSubscriptionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBillingSubscriptionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBillingSubscriptionHistoryQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListBillingSubscriptionHistoryQuery(baseOptions: Apollo.QueryHookOptions<ListBillingSubscriptionHistoryQuery, ListBillingSubscriptionHistoryQueryVariables> & ({ variables: ListBillingSubscriptionHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListBillingSubscriptionHistoryQuery, ListBillingSubscriptionHistoryQueryVariables>(ListBillingSubscriptionHistoryDocument, options);
      }
export function useListBillingSubscriptionHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListBillingSubscriptionHistoryQuery, ListBillingSubscriptionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListBillingSubscriptionHistoryQuery, ListBillingSubscriptionHistoryQueryVariables>(ListBillingSubscriptionHistoryDocument, options);
        }
export function useListBillingSubscriptionHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListBillingSubscriptionHistoryQuery, ListBillingSubscriptionHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListBillingSubscriptionHistoryQuery, ListBillingSubscriptionHistoryQueryVariables>(ListBillingSubscriptionHistoryDocument, options);
        }
export type ListBillingSubscriptionHistoryQueryHookResult = ReturnType<typeof useListBillingSubscriptionHistoryQuery>;
export type ListBillingSubscriptionHistoryLazyQueryHookResult = ReturnType<typeof useListBillingSubscriptionHistoryLazyQuery>;
export type ListBillingSubscriptionHistorySuspenseQueryHookResult = ReturnType<typeof useListBillingSubscriptionHistorySuspenseQuery>;
export type ListBillingSubscriptionHistoryQueryResult = Apollo.QueryResult<ListBillingSubscriptionHistoryQuery, ListBillingSubscriptionHistoryQueryVariables>;
export const ListClientBillingPlansDocument = gql`
    query ListClientBillingPlans($firmOrganizationId: String!, $affiliatedOrganizationId: String!, $affiliatedLegalEntityId: String!) {
  listClientBillingPlans(
    firmOrganizationId: $firmOrganizationId
    affiliatedOrganizationId: $affiliatedOrganizationId
    affiliatedLegalEntityId: $affiliatedLegalEntityId
  ) {
    product {
      ...BillingProductFields
    }
    price {
      ...BillingPriceFields
    }
  }
}
    ${BillingProductFieldsFragmentDoc}
${BillingPriceFieldsFragmentDoc}`;

/**
 * __useListClientBillingPlansQuery__
 *
 * To run a query within a React component, call `useListClientBillingPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useListClientBillingPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListClientBillingPlansQuery({
 *   variables: {
 *      firmOrganizationId: // value for 'firmOrganizationId'
 *      affiliatedOrganizationId: // value for 'affiliatedOrganizationId'
 *      affiliatedLegalEntityId: // value for 'affiliatedLegalEntityId'
 *   },
 * });
 */
export function useListClientBillingPlansQuery(baseOptions: Apollo.QueryHookOptions<ListClientBillingPlansQuery, ListClientBillingPlansQueryVariables> & ({ variables: ListClientBillingPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListClientBillingPlansQuery, ListClientBillingPlansQueryVariables>(ListClientBillingPlansDocument, options);
      }
export function useListClientBillingPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListClientBillingPlansQuery, ListClientBillingPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListClientBillingPlansQuery, ListClientBillingPlansQueryVariables>(ListClientBillingPlansDocument, options);
        }
export function useListClientBillingPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListClientBillingPlansQuery, ListClientBillingPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListClientBillingPlansQuery, ListClientBillingPlansQueryVariables>(ListClientBillingPlansDocument, options);
        }
export type ListClientBillingPlansQueryHookResult = ReturnType<typeof useListClientBillingPlansQuery>;
export type ListClientBillingPlansLazyQueryHookResult = ReturnType<typeof useListClientBillingPlansLazyQuery>;
export type ListClientBillingPlansSuspenseQueryHookResult = ReturnType<typeof useListClientBillingPlansSuspenseQuery>;
export type ListClientBillingPlansQueryResult = Apollo.QueryResult<ListClientBillingPlansQuery, ListClientBillingPlansQueryVariables>;
export const ListOnboardingPromotionCodesDocument = gql`
    query ListOnboardingPromotionCodes($organizationId: String!) {
  listOnboardingPromotionCodes(organizationId: $organizationId)
}
    `;

/**
 * __useListOnboardingPromotionCodesQuery__
 *
 * To run a query within a React component, call `useListOnboardingPromotionCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOnboardingPromotionCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOnboardingPromotionCodesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListOnboardingPromotionCodesQuery(baseOptions: Apollo.QueryHookOptions<ListOnboardingPromotionCodesQuery, ListOnboardingPromotionCodesQueryVariables> & ({ variables: ListOnboardingPromotionCodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOnboardingPromotionCodesQuery, ListOnboardingPromotionCodesQueryVariables>(ListOnboardingPromotionCodesDocument, options);
      }
export function useListOnboardingPromotionCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOnboardingPromotionCodesQuery, ListOnboardingPromotionCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOnboardingPromotionCodesQuery, ListOnboardingPromotionCodesQueryVariables>(ListOnboardingPromotionCodesDocument, options);
        }
export function useListOnboardingPromotionCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOnboardingPromotionCodesQuery, ListOnboardingPromotionCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOnboardingPromotionCodesQuery, ListOnboardingPromotionCodesQueryVariables>(ListOnboardingPromotionCodesDocument, options);
        }
export type ListOnboardingPromotionCodesQueryHookResult = ReturnType<typeof useListOnboardingPromotionCodesQuery>;
export type ListOnboardingPromotionCodesLazyQueryHookResult = ReturnType<typeof useListOnboardingPromotionCodesLazyQuery>;
export type ListOnboardingPromotionCodesSuspenseQueryHookResult = ReturnType<typeof useListOnboardingPromotionCodesSuspenseQuery>;
export type ListOnboardingPromotionCodesQueryResult = Apollo.QueryResult<ListOnboardingPromotionCodesQuery, ListOnboardingPromotionCodesQueryVariables>;
export const PreviewBillingSubscriptionDocument = gql`
    query PreviewBillingSubscription($organizationId: String!, $priceId: String!) {
  previewBillingSubscription(organizationId: $organizationId, priceId: $priceId) {
    ...MonetaryValueFields
  }
}
    ${MonetaryValueFieldsFragmentDoc}`;

/**
 * __usePreviewBillingSubscriptionQuery__
 *
 * To run a query within a React component, call `usePreviewBillingSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewBillingSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewBillingSubscriptionQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      priceId: // value for 'priceId'
 *   },
 * });
 */
export function usePreviewBillingSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<PreviewBillingSubscriptionQuery, PreviewBillingSubscriptionQueryVariables> & ({ variables: PreviewBillingSubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewBillingSubscriptionQuery, PreviewBillingSubscriptionQueryVariables>(PreviewBillingSubscriptionDocument, options);
      }
export function usePreviewBillingSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewBillingSubscriptionQuery, PreviewBillingSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewBillingSubscriptionQuery, PreviewBillingSubscriptionQueryVariables>(PreviewBillingSubscriptionDocument, options);
        }
export function usePreviewBillingSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewBillingSubscriptionQuery, PreviewBillingSubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewBillingSubscriptionQuery, PreviewBillingSubscriptionQueryVariables>(PreviewBillingSubscriptionDocument, options);
        }
export type PreviewBillingSubscriptionQueryHookResult = ReturnType<typeof usePreviewBillingSubscriptionQuery>;
export type PreviewBillingSubscriptionLazyQueryHookResult = ReturnType<typeof usePreviewBillingSubscriptionLazyQuery>;
export type PreviewBillingSubscriptionSuspenseQueryHookResult = ReturnType<typeof usePreviewBillingSubscriptionSuspenseQuery>;
export type PreviewBillingSubscriptionQueryResult = Apollo.QueryResult<PreviewBillingSubscriptionQuery, PreviewBillingSubscriptionQueryVariables>;
export const PreviewBillingSubscriptionPriceDocument = gql`
    query PreviewBillingSubscriptionPrice($organizationId: String!, $priceId: String!, $promoCode: String) {
  previewBillingSubscriptionPrice(
    organizationId: $organizationId
    priceId: $priceId
    promoCode: $promoCode
  ) {
    ...PricePreviewFields
  }
}
    ${PricePreviewFieldsFragmentDoc}`;

/**
 * __usePreviewBillingSubscriptionPriceQuery__
 *
 * To run a query within a React component, call `usePreviewBillingSubscriptionPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewBillingSubscriptionPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewBillingSubscriptionPriceQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      priceId: // value for 'priceId'
 *      promoCode: // value for 'promoCode'
 *   },
 * });
 */
export function usePreviewBillingSubscriptionPriceQuery(baseOptions: Apollo.QueryHookOptions<PreviewBillingSubscriptionPriceQuery, PreviewBillingSubscriptionPriceQueryVariables> & ({ variables: PreviewBillingSubscriptionPriceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewBillingSubscriptionPriceQuery, PreviewBillingSubscriptionPriceQueryVariables>(PreviewBillingSubscriptionPriceDocument, options);
      }
export function usePreviewBillingSubscriptionPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewBillingSubscriptionPriceQuery, PreviewBillingSubscriptionPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewBillingSubscriptionPriceQuery, PreviewBillingSubscriptionPriceQueryVariables>(PreviewBillingSubscriptionPriceDocument, options);
        }
export function usePreviewBillingSubscriptionPriceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewBillingSubscriptionPriceQuery, PreviewBillingSubscriptionPriceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewBillingSubscriptionPriceQuery, PreviewBillingSubscriptionPriceQueryVariables>(PreviewBillingSubscriptionPriceDocument, options);
        }
export type PreviewBillingSubscriptionPriceQueryHookResult = ReturnType<typeof usePreviewBillingSubscriptionPriceQuery>;
export type PreviewBillingSubscriptionPriceLazyQueryHookResult = ReturnType<typeof usePreviewBillingSubscriptionPriceLazyQuery>;
export type PreviewBillingSubscriptionPriceSuspenseQueryHookResult = ReturnType<typeof usePreviewBillingSubscriptionPriceSuspenseQuery>;
export type PreviewBillingSubscriptionPriceQueryResult = Apollo.QueryResult<PreviewBillingSubscriptionPriceQuery, PreviewBillingSubscriptionPriceQueryVariables>;
export const PreviewSubscriptionUpdateDocument = gql`
    query PreviewSubscriptionUpdate($organizationId: String!, $priceId: String!, $promoCode: String) {
  previewSubscriptionUpdate(
    organizationId: $organizationId
    priceId: $priceId
    promoCode: $promoCode
  ) {
    monthlyBillingDay
    amountDue {
      ...MonetaryValueFields
    }
    proratedAmount {
      ...MonetaryValueFields
    }
    subscriptionCoupons {
      ...CouponFields
    }
  }
}
    ${MonetaryValueFieldsFragmentDoc}
${CouponFieldsFragmentDoc}`;

/**
 * __usePreviewSubscriptionUpdateQuery__
 *
 * To run a query within a React component, call `usePreviewSubscriptionUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewSubscriptionUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewSubscriptionUpdateQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      priceId: // value for 'priceId'
 *      promoCode: // value for 'promoCode'
 *   },
 * });
 */
export function usePreviewSubscriptionUpdateQuery(baseOptions: Apollo.QueryHookOptions<PreviewSubscriptionUpdateQuery, PreviewSubscriptionUpdateQueryVariables> & ({ variables: PreviewSubscriptionUpdateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewSubscriptionUpdateQuery, PreviewSubscriptionUpdateQueryVariables>(PreviewSubscriptionUpdateDocument, options);
      }
export function usePreviewSubscriptionUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewSubscriptionUpdateQuery, PreviewSubscriptionUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewSubscriptionUpdateQuery, PreviewSubscriptionUpdateQueryVariables>(PreviewSubscriptionUpdateDocument, options);
        }
export function usePreviewSubscriptionUpdateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewSubscriptionUpdateQuery, PreviewSubscriptionUpdateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewSubscriptionUpdateQuery, PreviewSubscriptionUpdateQueryVariables>(PreviewSubscriptionUpdateDocument, options);
        }
export type PreviewSubscriptionUpdateQueryHookResult = ReturnType<typeof usePreviewSubscriptionUpdateQuery>;
export type PreviewSubscriptionUpdateLazyQueryHookResult = ReturnType<typeof usePreviewSubscriptionUpdateLazyQuery>;
export type PreviewSubscriptionUpdateSuspenseQueryHookResult = ReturnType<typeof usePreviewSubscriptionUpdateSuspenseQuery>;
export type PreviewSubscriptionUpdateQueryResult = Apollo.QueryResult<PreviewSubscriptionUpdateQuery, PreviewSubscriptionUpdateQueryVariables>;
export const ReadBillingDocument = gql`
    query ReadBilling($organizationId: String!) {
  readBilling(organizationId: $organizationId) {
    ... on BillingNone {
      unused
    }
    ... on BillingOperator {
      ...BillingOperatorFields
    }
    ... on BillingLegacyFirm {
      organizationId
      subscriptionId
      product {
        ...BillingProductFields
      }
      activeSubscription
    }
    ... on BillingAccountingFirm {
      organizationId
      subscriptionId
      product {
        ...BillingProductFields
      }
      activeSubscription
      firmPaidClients {
        product {
          ...BillingProductFields
        }
        legalEntityId
        billed
        availablePlans {
          product {
            ...BillingProductFields
          }
          price {
            ...BillingPriceFields
          }
        }
      }
      selfPaidClients {
        operator {
          ...BillingOperatorFields
        }
        legalEntityId
      }
    }
  }
}
    ${BillingOperatorFieldsFragmentDoc}
${BillingProductFieldsFragmentDoc}
${BillingPriceFieldsFragmentDoc}`;

/**
 * __useReadBillingQuery__
 *
 * To run a query within a React component, call `useReadBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadBillingQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useReadBillingQuery(baseOptions: Apollo.QueryHookOptions<ReadBillingQuery, ReadBillingQueryVariables> & ({ variables: ReadBillingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadBillingQuery, ReadBillingQueryVariables>(ReadBillingDocument, options);
      }
export function useReadBillingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadBillingQuery, ReadBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadBillingQuery, ReadBillingQueryVariables>(ReadBillingDocument, options);
        }
export function useReadBillingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadBillingQuery, ReadBillingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadBillingQuery, ReadBillingQueryVariables>(ReadBillingDocument, options);
        }
export type ReadBillingQueryHookResult = ReturnType<typeof useReadBillingQuery>;
export type ReadBillingLazyQueryHookResult = ReturnType<typeof useReadBillingLazyQuery>;
export type ReadBillingSuspenseQueryHookResult = ReturnType<typeof useReadBillingSuspenseQuery>;
export type ReadBillingQueryResult = Apollo.QueryResult<ReadBillingQuery, ReadBillingQueryVariables>;
export const ReadBillingAddressDocument = gql`
    query ReadBillingAddress($organizationId: String!) {
  readBillingAddress(organizationId: $organizationId) {
    organizationId
    fullName
    billingAddress {
      ...AddressFields
    }
  }
}
    ${AddressFieldsFragmentDoc}`;

/**
 * __useReadBillingAddressQuery__
 *
 * To run a query within a React component, call `useReadBillingAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadBillingAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadBillingAddressQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useReadBillingAddressQuery(baseOptions: Apollo.QueryHookOptions<ReadBillingAddressQuery, ReadBillingAddressQueryVariables> & ({ variables: ReadBillingAddressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadBillingAddressQuery, ReadBillingAddressQueryVariables>(ReadBillingAddressDocument, options);
      }
export function useReadBillingAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadBillingAddressQuery, ReadBillingAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadBillingAddressQuery, ReadBillingAddressQueryVariables>(ReadBillingAddressDocument, options);
        }
export function useReadBillingAddressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadBillingAddressQuery, ReadBillingAddressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadBillingAddressQuery, ReadBillingAddressQueryVariables>(ReadBillingAddressDocument, options);
        }
export type ReadBillingAddressQueryHookResult = ReturnType<typeof useReadBillingAddressQuery>;
export type ReadBillingAddressLazyQueryHookResult = ReturnType<typeof useReadBillingAddressLazyQuery>;
export type ReadBillingAddressSuspenseQueryHookResult = ReturnType<typeof useReadBillingAddressSuspenseQuery>;
export type ReadBillingAddressQueryResult = Apollo.QueryResult<ReadBillingAddressQuery, ReadBillingAddressQueryVariables>;
export const ReadBillingArrangementDocument = gql`
    query ReadBillingArrangement($organizationId: String!) {
  readBillingArrangement(organizationId: $organizationId) {
    organizationId
    subscription {
      subscriptionId
      stripe {
        status
        trial {
          start
          end
        }
        startedAt
        billingCycleStart
        billingCycleEnd
        cancelAt
      }
      items {
        plan {
          product {
            ...BillingProductFields
          }
          price {
            ...BillingPriceFields
          }
        }
        contributors {
          id
          type
        }
      }
    }
    legalEntities {
      legalEntityId
      plan {
        product {
          ...BillingProductFields
        }
        price {
          ...BillingPriceFields
        }
      }
      eligiblePlans {
        product {
          ...BillingProductFields
        }
        price {
          ...BillingPriceFields
        }
      }
      payerOrganizationId
      payerSubscriptionStatus
      viewerOrganizationIds
    }
  }
}
    ${BillingProductFieldsFragmentDoc}
${BillingPriceFieldsFragmentDoc}`;

/**
 * __useReadBillingArrangementQuery__
 *
 * To run a query within a React component, call `useReadBillingArrangementQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadBillingArrangementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadBillingArrangementQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useReadBillingArrangementQuery(baseOptions: Apollo.QueryHookOptions<ReadBillingArrangementQuery, ReadBillingArrangementQueryVariables> & ({ variables: ReadBillingArrangementQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadBillingArrangementQuery, ReadBillingArrangementQueryVariables>(ReadBillingArrangementDocument, options);
      }
export function useReadBillingArrangementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadBillingArrangementQuery, ReadBillingArrangementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadBillingArrangementQuery, ReadBillingArrangementQueryVariables>(ReadBillingArrangementDocument, options);
        }
export function useReadBillingArrangementSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadBillingArrangementQuery, ReadBillingArrangementQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadBillingArrangementQuery, ReadBillingArrangementQueryVariables>(ReadBillingArrangementDocument, options);
        }
export type ReadBillingArrangementQueryHookResult = ReturnType<typeof useReadBillingArrangementQuery>;
export type ReadBillingArrangementLazyQueryHookResult = ReturnType<typeof useReadBillingArrangementLazyQuery>;
export type ReadBillingArrangementSuspenseQueryHookResult = ReturnType<typeof useReadBillingArrangementSuspenseQuery>;
export type ReadBillingArrangementQueryResult = Apollo.QueryResult<ReadBillingArrangementQuery, ReadBillingArrangementQueryVariables>;
export const ReadBillingCustomerProfileDocument = gql`
    query ReadBillingCustomerProfile($organizationId: String!) {
  readBillingCustomerProfile(organizationId: $organizationId) {
    cardDetails {
      ...BillingCardDetailsFields
    }
  }
}
    ${BillingCardDetailsFieldsFragmentDoc}`;

/**
 * __useReadBillingCustomerProfileQuery__
 *
 * To run a query within a React component, call `useReadBillingCustomerProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadBillingCustomerProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadBillingCustomerProfileQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useReadBillingCustomerProfileQuery(baseOptions: Apollo.QueryHookOptions<ReadBillingCustomerProfileQuery, ReadBillingCustomerProfileQueryVariables> & ({ variables: ReadBillingCustomerProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadBillingCustomerProfileQuery, ReadBillingCustomerProfileQueryVariables>(ReadBillingCustomerProfileDocument, options);
      }
export function useReadBillingCustomerProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadBillingCustomerProfileQuery, ReadBillingCustomerProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadBillingCustomerProfileQuery, ReadBillingCustomerProfileQueryVariables>(ReadBillingCustomerProfileDocument, options);
        }
export function useReadBillingCustomerProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadBillingCustomerProfileQuery, ReadBillingCustomerProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadBillingCustomerProfileQuery, ReadBillingCustomerProfileQueryVariables>(ReadBillingCustomerProfileDocument, options);
        }
export type ReadBillingCustomerProfileQueryHookResult = ReturnType<typeof useReadBillingCustomerProfileQuery>;
export type ReadBillingCustomerProfileLazyQueryHookResult = ReturnType<typeof useReadBillingCustomerProfileLazyQuery>;
export type ReadBillingCustomerProfileSuspenseQueryHookResult = ReturnType<typeof useReadBillingCustomerProfileSuspenseQuery>;
export type ReadBillingCustomerProfileQueryResult = Apollo.QueryResult<ReadBillingCustomerProfileQuery, ReadBillingCustomerProfileQueryVariables>;
export const ReadBillingPlansDocument = gql`
    query ReadBillingPlans($organizationId: String!, $productNames: [String!]!) {
  readBillingPlans(organizationId: $organizationId, productNames: $productNames) {
    product {
      ...BillingProductFields
    }
    price {
      ...BillingPriceFields
    }
  }
}
    ${BillingProductFieldsFragmentDoc}
${BillingPriceFieldsFragmentDoc}`;

/**
 * __useReadBillingPlansQuery__
 *
 * To run a query within a React component, call `useReadBillingPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadBillingPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadBillingPlansQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      productNames: // value for 'productNames'
 *   },
 * });
 */
export function useReadBillingPlansQuery(baseOptions: Apollo.QueryHookOptions<ReadBillingPlansQuery, ReadBillingPlansQueryVariables> & ({ variables: ReadBillingPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadBillingPlansQuery, ReadBillingPlansQueryVariables>(ReadBillingPlansDocument, options);
      }
export function useReadBillingPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadBillingPlansQuery, ReadBillingPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadBillingPlansQuery, ReadBillingPlansQueryVariables>(ReadBillingPlansDocument, options);
        }
export function useReadBillingPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadBillingPlansQuery, ReadBillingPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadBillingPlansQuery, ReadBillingPlansQueryVariables>(ReadBillingPlansDocument, options);
        }
export type ReadBillingPlansQueryHookResult = ReturnType<typeof useReadBillingPlansQuery>;
export type ReadBillingPlansLazyQueryHookResult = ReturnType<typeof useReadBillingPlansLazyQuery>;
export type ReadBillingPlansSuspenseQueryHookResult = ReturnType<typeof useReadBillingPlansSuspenseQuery>;
export type ReadBillingPlansQueryResult = Apollo.QueryResult<ReadBillingPlansQuery, ReadBillingPlansQueryVariables>;
export const ReadFirmBillingPlansDocument = gql`
    query ReadFirmBillingPlans($organizationId: String!, $affiliatedLegalEntityId: String!) {
  readFirmBillingPlans(
    organizationId: $organizationId
    affiliatedLegalEntityId: $affiliatedLegalEntityId
  ) {
    ...BillingPlanFields
  }
}
    ${BillingPlanFieldsFragmentDoc}`;

/**
 * __useReadFirmBillingPlansQuery__
 *
 * To run a query within a React component, call `useReadFirmBillingPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadFirmBillingPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadFirmBillingPlansQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      affiliatedLegalEntityId: // value for 'affiliatedLegalEntityId'
 *   },
 * });
 */
export function useReadFirmBillingPlansQuery(baseOptions: Apollo.QueryHookOptions<ReadFirmBillingPlansQuery, ReadFirmBillingPlansQueryVariables> & ({ variables: ReadFirmBillingPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadFirmBillingPlansQuery, ReadFirmBillingPlansQueryVariables>(ReadFirmBillingPlansDocument, options);
      }
export function useReadFirmBillingPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadFirmBillingPlansQuery, ReadFirmBillingPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadFirmBillingPlansQuery, ReadFirmBillingPlansQueryVariables>(ReadFirmBillingPlansDocument, options);
        }
export function useReadFirmBillingPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadFirmBillingPlansQuery, ReadFirmBillingPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadFirmBillingPlansQuery, ReadFirmBillingPlansQueryVariables>(ReadFirmBillingPlansDocument, options);
        }
export type ReadFirmBillingPlansQueryHookResult = ReturnType<typeof useReadFirmBillingPlansQuery>;
export type ReadFirmBillingPlansLazyQueryHookResult = ReturnType<typeof useReadFirmBillingPlansLazyQuery>;
export type ReadFirmBillingPlansSuspenseQueryHookResult = ReturnType<typeof useReadFirmBillingPlansSuspenseQuery>;
export type ReadFirmBillingPlansQueryResult = Apollo.QueryResult<ReadFirmBillingPlansQuery, ReadFirmBillingPlansQueryVariables>;
export const ReadLegalEntityResetDocument = gql`
    query ReadLegalEntityReset($legalEntityId: String!) {
  readLegalEntityReset(legalEntityId: $legalEntityId) {
    isReset
  }
}
    `;

/**
 * __useReadLegalEntityResetQuery__
 *
 * To run a query within a React component, call `useReadLegalEntityResetQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadLegalEntityResetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadLegalEntityResetQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadLegalEntityResetQuery(baseOptions: Apollo.QueryHookOptions<ReadLegalEntityResetQuery, ReadLegalEntityResetQueryVariables> & ({ variables: ReadLegalEntityResetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadLegalEntityResetQuery, ReadLegalEntityResetQueryVariables>(ReadLegalEntityResetDocument, options);
      }
export function useReadLegalEntityResetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadLegalEntityResetQuery, ReadLegalEntityResetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadLegalEntityResetQuery, ReadLegalEntityResetQueryVariables>(ReadLegalEntityResetDocument, options);
        }
export function useReadLegalEntityResetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadLegalEntityResetQuery, ReadLegalEntityResetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadLegalEntityResetQuery, ReadLegalEntityResetQueryVariables>(ReadLegalEntityResetDocument, options);
        }
export type ReadLegalEntityResetQueryHookResult = ReturnType<typeof useReadLegalEntityResetQuery>;
export type ReadLegalEntityResetLazyQueryHookResult = ReturnType<typeof useReadLegalEntityResetLazyQuery>;
export type ReadLegalEntityResetSuspenseQueryHookResult = ReturnType<typeof useReadLegalEntityResetSuspenseQuery>;
export type ReadLegalEntityResetQueryResult = Apollo.QueryResult<ReadLegalEntityResetQuery, ReadLegalEntityResetQueryVariables>;
export const ReadOrganizationBillingPlanDocument = gql`
    query ReadOrganizationBillingPlan($organizationId: String!) {
  readOrganizationBillingPlan(organizationId: $organizationId) {
    plan {
      ...BillingPlanFields
    }
    trial {
      ...BillingTrialFields
    }
  }
}
    ${BillingPlanFieldsFragmentDoc}
${BillingTrialFieldsFragmentDoc}`;

/**
 * __useReadOrganizationBillingPlanQuery__
 *
 * To run a query within a React component, call `useReadOrganizationBillingPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadOrganizationBillingPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadOrganizationBillingPlanQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useReadOrganizationBillingPlanQuery(baseOptions: Apollo.QueryHookOptions<ReadOrganizationBillingPlanQuery, ReadOrganizationBillingPlanQueryVariables> & ({ variables: ReadOrganizationBillingPlanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadOrganizationBillingPlanQuery, ReadOrganizationBillingPlanQueryVariables>(ReadOrganizationBillingPlanDocument, options);
      }
export function useReadOrganizationBillingPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadOrganizationBillingPlanQuery, ReadOrganizationBillingPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadOrganizationBillingPlanQuery, ReadOrganizationBillingPlanQueryVariables>(ReadOrganizationBillingPlanDocument, options);
        }
export function useReadOrganizationBillingPlanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadOrganizationBillingPlanQuery, ReadOrganizationBillingPlanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadOrganizationBillingPlanQuery, ReadOrganizationBillingPlanQueryVariables>(ReadOrganizationBillingPlanDocument, options);
        }
export type ReadOrganizationBillingPlanQueryHookResult = ReturnType<typeof useReadOrganizationBillingPlanQuery>;
export type ReadOrganizationBillingPlanLazyQueryHookResult = ReturnType<typeof useReadOrganizationBillingPlanLazyQuery>;
export type ReadOrganizationBillingPlanSuspenseQueryHookResult = ReturnType<typeof useReadOrganizationBillingPlanSuspenseQuery>;
export type ReadOrganizationBillingPlanQueryResult = Apollo.QueryResult<ReadOrganizationBillingPlanQuery, ReadOrganizationBillingPlanQueryVariables>;
export const LedgerApproveAndPayBillDocument = gql`
    mutation LedgerApproveAndPayBill($viewKey: ViewKey!, $billId: String!, $instrumentId: String!) {
  ledgerApproveAndPayBill(
    viewKey: $viewKey
    billId: $billId
    instrumentId: $instrumentId
  ) {
    status
    billPaymentId
  }
}
    `;
export type LedgerApproveAndPayBillMutationFn = Apollo.MutationFunction<LedgerApproveAndPayBillMutation, LedgerApproveAndPayBillMutationVariables>;

/**
 * __useLedgerApproveAndPayBillMutation__
 *
 * To run a mutation, you first call `useLedgerApproveAndPayBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerApproveAndPayBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerApproveAndPayBillMutation, { data, loading, error }] = useLedgerApproveAndPayBillMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      billId: // value for 'billId'
 *      instrumentId: // value for 'instrumentId'
 *   },
 * });
 */
export function useLedgerApproveAndPayBillMutation(baseOptions?: Apollo.MutationHookOptions<LedgerApproveAndPayBillMutation, LedgerApproveAndPayBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerApproveAndPayBillMutation, LedgerApproveAndPayBillMutationVariables>(LedgerApproveAndPayBillDocument, options);
      }
export type LedgerApproveAndPayBillMutationHookResult = ReturnType<typeof useLedgerApproveAndPayBillMutation>;
export type LedgerApproveAndPayBillMutationResult = Apollo.MutationResult<LedgerApproveAndPayBillMutation>;
export type LedgerApproveAndPayBillMutationOptions = Apollo.BaseMutationOptions<LedgerApproveAndPayBillMutation, LedgerApproveAndPayBillMutationVariables>;
export const LedgerApproveBillDocument = gql`
    mutation LedgerApproveBill($legalEntityId: String!, $billId: String!) {
  ledgerApproveBill(legalEntityId: $legalEntityId, billId: $billId)
}
    `;
export type LedgerApproveBillMutationFn = Apollo.MutationFunction<LedgerApproveBillMutation, LedgerApproveBillMutationVariables>;

/**
 * __useLedgerApproveBillMutation__
 *
 * To run a mutation, you first call `useLedgerApproveBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerApproveBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerApproveBillMutation, { data, loading, error }] = useLedgerApproveBillMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      billId: // value for 'billId'
 *   },
 * });
 */
export function useLedgerApproveBillMutation(baseOptions?: Apollo.MutationHookOptions<LedgerApproveBillMutation, LedgerApproveBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerApproveBillMutation, LedgerApproveBillMutationVariables>(LedgerApproveBillDocument, options);
      }
export type LedgerApproveBillMutationHookResult = ReturnType<typeof useLedgerApproveBillMutation>;
export type LedgerApproveBillMutationResult = Apollo.MutationResult<LedgerApproveBillMutation>;
export type LedgerApproveBillMutationOptions = Apollo.BaseMutationOptions<LedgerApproveBillMutation, LedgerApproveBillMutationVariables>;
export const LedgerDeleteBillDocument = gql`
    mutation LedgerDeleteBill($legalEntityId: String!, $billId: String!) {
  ledgerDeleteBill(legalEntityId: $legalEntityId, billId: $billId)
}
    `;
export type LedgerDeleteBillMutationFn = Apollo.MutationFunction<LedgerDeleteBillMutation, LedgerDeleteBillMutationVariables>;

/**
 * __useLedgerDeleteBillMutation__
 *
 * To run a mutation, you first call `useLedgerDeleteBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerDeleteBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerDeleteBillMutation, { data, loading, error }] = useLedgerDeleteBillMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      billId: // value for 'billId'
 *   },
 * });
 */
export function useLedgerDeleteBillMutation(baseOptions?: Apollo.MutationHookOptions<LedgerDeleteBillMutation, LedgerDeleteBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerDeleteBillMutation, LedgerDeleteBillMutationVariables>(LedgerDeleteBillDocument, options);
      }
export type LedgerDeleteBillMutationHookResult = ReturnType<typeof useLedgerDeleteBillMutation>;
export type LedgerDeleteBillMutationResult = Apollo.MutationResult<LedgerDeleteBillMutation>;
export type LedgerDeleteBillMutationOptions = Apollo.BaseMutationOptions<LedgerDeleteBillMutation, LedgerDeleteBillMutationVariables>;
export const LedgerMarkBillAsPaidDocument = gql`
    mutation LedgerMarkBillAsPaid($viewKey: ViewKey!, $legalEntityId: String!, $billId: String!, $internalNote: String, $datePaid: DateTime!, $categoryId: String!, $referenceNumber: String) {
  ledgerMarkBillAsPaid(
    viewKey: $viewKey
    legalEntityId: $legalEntityId
    billId: $billId
    internalNote: $internalNote
    datePaid: $datePaid
    categoryId: $categoryId
    referenceNumber: $referenceNumber
  )
}
    `;
export type LedgerMarkBillAsPaidMutationFn = Apollo.MutationFunction<LedgerMarkBillAsPaidMutation, LedgerMarkBillAsPaidMutationVariables>;

/**
 * __useLedgerMarkBillAsPaidMutation__
 *
 * To run a mutation, you first call `useLedgerMarkBillAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerMarkBillAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerMarkBillAsPaidMutation, { data, loading, error }] = useLedgerMarkBillAsPaidMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      legalEntityId: // value for 'legalEntityId'
 *      billId: // value for 'billId'
 *      internalNote: // value for 'internalNote'
 *      datePaid: // value for 'datePaid'
 *      categoryId: // value for 'categoryId'
 *      referenceNumber: // value for 'referenceNumber'
 *   },
 * });
 */
export function useLedgerMarkBillAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<LedgerMarkBillAsPaidMutation, LedgerMarkBillAsPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerMarkBillAsPaidMutation, LedgerMarkBillAsPaidMutationVariables>(LedgerMarkBillAsPaidDocument, options);
      }
export type LedgerMarkBillAsPaidMutationHookResult = ReturnType<typeof useLedgerMarkBillAsPaidMutation>;
export type LedgerMarkBillAsPaidMutationResult = Apollo.MutationResult<LedgerMarkBillAsPaidMutation>;
export type LedgerMarkBillAsPaidMutationOptions = Apollo.BaseMutationOptions<LedgerMarkBillAsPaidMutation, LedgerMarkBillAsPaidMutationVariables>;
export const LedgerPayBillDocument = gql`
    mutation LedgerPayBill($viewKey: ViewKey!, $billId: String!, $instrumentId: String!) {
  ledgerPayBill(viewKey: $viewKey, billId: $billId, instrumentId: $instrumentId)
}
    `;
export type LedgerPayBillMutationFn = Apollo.MutationFunction<LedgerPayBillMutation, LedgerPayBillMutationVariables>;

/**
 * __useLedgerPayBillMutation__
 *
 * To run a mutation, you first call `useLedgerPayBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerPayBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerPayBillMutation, { data, loading, error }] = useLedgerPayBillMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      billId: // value for 'billId'
 *      instrumentId: // value for 'instrumentId'
 *   },
 * });
 */
export function useLedgerPayBillMutation(baseOptions?: Apollo.MutationHookOptions<LedgerPayBillMutation, LedgerPayBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerPayBillMutation, LedgerPayBillMutationVariables>(LedgerPayBillDocument, options);
      }
export type LedgerPayBillMutationHookResult = ReturnType<typeof useLedgerPayBillMutation>;
export type LedgerPayBillMutationResult = Apollo.MutationResult<LedgerPayBillMutation>;
export type LedgerPayBillMutationOptions = Apollo.BaseMutationOptions<LedgerPayBillMutation, LedgerPayBillMutationVariables>;
export const LedgerRejectBillDocument = gql`
    mutation LedgerRejectBill($viewKey: ViewKey!, $billId: String!, $comment: String!) {
  ledgerRejectBill(viewKey: $viewKey, billId: $billId, comment: $comment)
}
    `;
export type LedgerRejectBillMutationFn = Apollo.MutationFunction<LedgerRejectBillMutation, LedgerRejectBillMutationVariables>;

/**
 * __useLedgerRejectBillMutation__
 *
 * To run a mutation, you first call `useLedgerRejectBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerRejectBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerRejectBillMutation, { data, loading, error }] = useLedgerRejectBillMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      billId: // value for 'billId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useLedgerRejectBillMutation(baseOptions?: Apollo.MutationHookOptions<LedgerRejectBillMutation, LedgerRejectBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerRejectBillMutation, LedgerRejectBillMutationVariables>(LedgerRejectBillDocument, options);
      }
export type LedgerRejectBillMutationHookResult = ReturnType<typeof useLedgerRejectBillMutation>;
export type LedgerRejectBillMutationResult = Apollo.MutationResult<LedgerRejectBillMutation>;
export type LedgerRejectBillMutationOptions = Apollo.BaseMutationOptions<LedgerRejectBillMutation, LedgerRejectBillMutationVariables>;
export const LedgerRetryBillPaymentDocument = gql`
    mutation LedgerRetryBillPayment($viewKey: ViewKey!, $billId: String!, $sourcePaymentInstrumentId: String) {
  ledgerRetryBillPayment(
    viewKey: $viewKey
    billId: $billId
    sourcePaymentInstrumentId: $sourcePaymentInstrumentId
  )
}
    `;
export type LedgerRetryBillPaymentMutationFn = Apollo.MutationFunction<LedgerRetryBillPaymentMutation, LedgerRetryBillPaymentMutationVariables>;

/**
 * __useLedgerRetryBillPaymentMutation__
 *
 * To run a mutation, you first call `useLedgerRetryBillPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerRetryBillPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerRetryBillPaymentMutation, { data, loading, error }] = useLedgerRetryBillPaymentMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      billId: // value for 'billId'
 *      sourcePaymentInstrumentId: // value for 'sourcePaymentInstrumentId'
 *   },
 * });
 */
export function useLedgerRetryBillPaymentMutation(baseOptions?: Apollo.MutationHookOptions<LedgerRetryBillPaymentMutation, LedgerRetryBillPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerRetryBillPaymentMutation, LedgerRetryBillPaymentMutationVariables>(LedgerRetryBillPaymentDocument, options);
      }
export type LedgerRetryBillPaymentMutationHookResult = ReturnType<typeof useLedgerRetryBillPaymentMutation>;
export type LedgerRetryBillPaymentMutationResult = Apollo.MutationResult<LedgerRetryBillPaymentMutation>;
export type LedgerRetryBillPaymentMutationOptions = Apollo.BaseMutationOptions<LedgerRetryBillPaymentMutation, LedgerRetryBillPaymentMutationVariables>;
export const LedgerRetryBillPayoutsDocument = gql`
    mutation LedgerRetryBillPayouts($legalEntityId: String!, $billIds: [String!]!, $correctedDestinationPaymentInstrumentId: String!) {
  ledgerRetryBillPayouts(
    legalEntityId: $legalEntityId
    billIds: $billIds
    correctedDestinationPaymentInstrumentId: $correctedDestinationPaymentInstrumentId
  )
}
    `;
export type LedgerRetryBillPayoutsMutationFn = Apollo.MutationFunction<LedgerRetryBillPayoutsMutation, LedgerRetryBillPayoutsMutationVariables>;

/**
 * __useLedgerRetryBillPayoutsMutation__
 *
 * To run a mutation, you first call `useLedgerRetryBillPayoutsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerRetryBillPayoutsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerRetryBillPayoutsMutation, { data, loading, error }] = useLedgerRetryBillPayoutsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      billIds: // value for 'billIds'
 *      correctedDestinationPaymentInstrumentId: // value for 'correctedDestinationPaymentInstrumentId'
 *   },
 * });
 */
export function useLedgerRetryBillPayoutsMutation(baseOptions?: Apollo.MutationHookOptions<LedgerRetryBillPayoutsMutation, LedgerRetryBillPayoutsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerRetryBillPayoutsMutation, LedgerRetryBillPayoutsMutationVariables>(LedgerRetryBillPayoutsDocument, options);
      }
export type LedgerRetryBillPayoutsMutationHookResult = ReturnType<typeof useLedgerRetryBillPayoutsMutation>;
export type LedgerRetryBillPayoutsMutationResult = Apollo.MutationResult<LedgerRetryBillPayoutsMutation>;
export type LedgerRetryBillPayoutsMutationOptions = Apollo.BaseMutationOptions<LedgerRetryBillPayoutsMutation, LedgerRetryBillPayoutsMutationVariables>;
export const LedgerSaveBillDocument = gql`
    mutation LedgerSaveBill($legalEntityId: String!, $bill: LedgerInputBill!, $approverUserId: String) {
  ledgerSaveBill(
    legalEntityId: $legalEntityId
    bill: $bill
    approverUserId: $approverUserId
  ) {
    ledgerTransactionId
  }
}
    `;
export type LedgerSaveBillMutationFn = Apollo.MutationFunction<LedgerSaveBillMutation, LedgerSaveBillMutationVariables>;

/**
 * __useLedgerSaveBillMutation__
 *
 * To run a mutation, you first call `useLedgerSaveBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerSaveBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerSaveBillMutation, { data, loading, error }] = useLedgerSaveBillMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      bill: // value for 'bill'
 *      approverUserId: // value for 'approverUserId'
 *   },
 * });
 */
export function useLedgerSaveBillMutation(baseOptions?: Apollo.MutationHookOptions<LedgerSaveBillMutation, LedgerSaveBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerSaveBillMutation, LedgerSaveBillMutationVariables>(LedgerSaveBillDocument, options);
      }
export type LedgerSaveBillMutationHookResult = ReturnType<typeof useLedgerSaveBillMutation>;
export type LedgerSaveBillMutationResult = Apollo.MutationResult<LedgerSaveBillMutation>;
export type LedgerSaveBillMutationOptions = Apollo.BaseMutationOptions<LedgerSaveBillMutation, LedgerSaveBillMutationVariables>;
export const LedgerScheduleSendForApprovalDocument = gql`
    mutation LedgerScheduleSendForApproval($billId: String!, $viewKey: ViewKey!, $scheduleSendForApprovalAt: DateTime!) {
  ledgerScheduleSendForApproval(
    billId: $billId
    viewKey: $viewKey
    scheduleSendForApprovalAt: $scheduleSendForApprovalAt
  )
}
    `;
export type LedgerScheduleSendForApprovalMutationFn = Apollo.MutationFunction<LedgerScheduleSendForApprovalMutation, LedgerScheduleSendForApprovalMutationVariables>;

/**
 * __useLedgerScheduleSendForApprovalMutation__
 *
 * To run a mutation, you first call `useLedgerScheduleSendForApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerScheduleSendForApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerScheduleSendForApprovalMutation, { data, loading, error }] = useLedgerScheduleSendForApprovalMutation({
 *   variables: {
 *      billId: // value for 'billId'
 *      viewKey: // value for 'viewKey'
 *      scheduleSendForApprovalAt: // value for 'scheduleSendForApprovalAt'
 *   },
 * });
 */
export function useLedgerScheduleSendForApprovalMutation(baseOptions?: Apollo.MutationHookOptions<LedgerScheduleSendForApprovalMutation, LedgerScheduleSendForApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerScheduleSendForApprovalMutation, LedgerScheduleSendForApprovalMutationVariables>(LedgerScheduleSendForApprovalDocument, options);
      }
export type LedgerScheduleSendForApprovalMutationHookResult = ReturnType<typeof useLedgerScheduleSendForApprovalMutation>;
export type LedgerScheduleSendForApprovalMutationResult = Apollo.MutationResult<LedgerScheduleSendForApprovalMutation>;
export type LedgerScheduleSendForApprovalMutationOptions = Apollo.BaseMutationOptions<LedgerScheduleSendForApprovalMutation, LedgerScheduleSendForApprovalMutationVariables>;
export const LedgerSendForApprovalDocument = gql`
    mutation LedgerSendForApproval($billId: String!, $viewKey: ViewKey!) {
  ledgerSendForApproval(billId: $billId, viewKey: $viewKey)
}
    `;
export type LedgerSendForApprovalMutationFn = Apollo.MutationFunction<LedgerSendForApprovalMutation, LedgerSendForApprovalMutationVariables>;

/**
 * __useLedgerSendForApprovalMutation__
 *
 * To run a mutation, you first call `useLedgerSendForApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerSendForApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerSendForApprovalMutation, { data, loading, error }] = useLedgerSendForApprovalMutation({
 *   variables: {
 *      billId: // value for 'billId'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useLedgerSendForApprovalMutation(baseOptions?: Apollo.MutationHookOptions<LedgerSendForApprovalMutation, LedgerSendForApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerSendForApprovalMutation, LedgerSendForApprovalMutationVariables>(LedgerSendForApprovalDocument, options);
      }
export type LedgerSendForApprovalMutationHookResult = ReturnType<typeof useLedgerSendForApprovalMutation>;
export type LedgerSendForApprovalMutationResult = Apollo.MutationResult<LedgerSendForApprovalMutation>;
export type LedgerSendForApprovalMutationOptions = Apollo.BaseMutationOptions<LedgerSendForApprovalMutation, LedgerSendForApprovalMutationVariables>;
export const LedgerSetDataSourceBillRoleDocument = gql`
    mutation LedgerSetDataSourceBillRole($legalEntityId: String!, $dataSourceId: String!, $dataSourceBillId: String!, $userId: String, $role: BillAccessRole!) {
  ledgerSetDataSourceBillRole(
    legalEntityId: $legalEntityId
    dataSourceId: $dataSourceId
    dataSourceBillId: $dataSourceBillId
    userId: $userId
    role: $role
  )
}
    `;
export type LedgerSetDataSourceBillRoleMutationFn = Apollo.MutationFunction<LedgerSetDataSourceBillRoleMutation, LedgerSetDataSourceBillRoleMutationVariables>;

/**
 * __useLedgerSetDataSourceBillRoleMutation__
 *
 * To run a mutation, you first call `useLedgerSetDataSourceBillRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerSetDataSourceBillRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerSetDataSourceBillRoleMutation, { data, loading, error }] = useLedgerSetDataSourceBillRoleMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      dataSourceId: // value for 'dataSourceId'
 *      dataSourceBillId: // value for 'dataSourceBillId'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useLedgerSetDataSourceBillRoleMutation(baseOptions?: Apollo.MutationHookOptions<LedgerSetDataSourceBillRoleMutation, LedgerSetDataSourceBillRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerSetDataSourceBillRoleMutation, LedgerSetDataSourceBillRoleMutationVariables>(LedgerSetDataSourceBillRoleDocument, options);
      }
export type LedgerSetDataSourceBillRoleMutationHookResult = ReturnType<typeof useLedgerSetDataSourceBillRoleMutation>;
export type LedgerSetDataSourceBillRoleMutationResult = Apollo.MutationResult<LedgerSetDataSourceBillRoleMutation>;
export type LedgerSetDataSourceBillRoleMutationOptions = Apollo.BaseMutationOptions<LedgerSetDataSourceBillRoleMutation, LedgerSetDataSourceBillRoleMutationVariables>;
export const LedgerStartBillSplitLineItemsWorkflowDocument = gql`
    mutation LedgerStartBillSplitLineItemsWorkflow($viewKey: ViewKey!, $dataSourceBillId: String!, $documentCollectionId: String!, $documentId: String!) {
  ledgerStartBillSplitLineItemsWorkflow(
    viewKey: $viewKey
    dataSourceBillId: $dataSourceBillId
    documentCollectionId: $documentCollectionId
    documentId: $documentId
  ) {
    workflowId
  }
}
    `;
export type LedgerStartBillSplitLineItemsWorkflowMutationFn = Apollo.MutationFunction<LedgerStartBillSplitLineItemsWorkflowMutation, LedgerStartBillSplitLineItemsWorkflowMutationVariables>;

/**
 * __useLedgerStartBillSplitLineItemsWorkflowMutation__
 *
 * To run a mutation, you first call `useLedgerStartBillSplitLineItemsWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerStartBillSplitLineItemsWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerStartBillSplitLineItemsWorkflowMutation, { data, loading, error }] = useLedgerStartBillSplitLineItemsWorkflowMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      dataSourceBillId: // value for 'dataSourceBillId'
 *      documentCollectionId: // value for 'documentCollectionId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useLedgerStartBillSplitLineItemsWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<LedgerStartBillSplitLineItemsWorkflowMutation, LedgerStartBillSplitLineItemsWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerStartBillSplitLineItemsWorkflowMutation, LedgerStartBillSplitLineItemsWorkflowMutationVariables>(LedgerStartBillSplitLineItemsWorkflowDocument, options);
      }
export type LedgerStartBillSplitLineItemsWorkflowMutationHookResult = ReturnType<typeof useLedgerStartBillSplitLineItemsWorkflowMutation>;
export type LedgerStartBillSplitLineItemsWorkflowMutationResult = Apollo.MutationResult<LedgerStartBillSplitLineItemsWorkflowMutation>;
export type LedgerStartBillSplitLineItemsWorkflowMutationOptions = Apollo.BaseMutationOptions<LedgerStartBillSplitLineItemsWorkflowMutation, LedgerStartBillSplitLineItemsWorkflowMutationVariables>;
export const LedgerStartBillWorkflowFromDocumentDocument = gql`
    mutation LedgerStartBillWorkflowFromDocument($documentId: String!, $documentCollectionId: String!, $legalEntityId: String!, $objectToken: String!) {
  ledgerStartBillWorkflowFromDocument(
    documentId: $documentId
    documentCollectionId: $documentCollectionId
    legalEntityId: $legalEntityId
    objectToken: $objectToken
  ) {
    workflowId
  }
}
    `;
export type LedgerStartBillWorkflowFromDocumentMutationFn = Apollo.MutationFunction<LedgerStartBillWorkflowFromDocumentMutation, LedgerStartBillWorkflowFromDocumentMutationVariables>;

/**
 * __useLedgerStartBillWorkflowFromDocumentMutation__
 *
 * To run a mutation, you first call `useLedgerStartBillWorkflowFromDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerStartBillWorkflowFromDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerStartBillWorkflowFromDocumentMutation, { data, loading, error }] = useLedgerStartBillWorkflowFromDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      documentCollectionId: // value for 'documentCollectionId'
 *      legalEntityId: // value for 'legalEntityId'
 *      objectToken: // value for 'objectToken'
 *   },
 * });
 */
export function useLedgerStartBillWorkflowFromDocumentMutation(baseOptions?: Apollo.MutationHookOptions<LedgerStartBillWorkflowFromDocumentMutation, LedgerStartBillWorkflowFromDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerStartBillWorkflowFromDocumentMutation, LedgerStartBillWorkflowFromDocumentMutationVariables>(LedgerStartBillWorkflowFromDocumentDocument, options);
      }
export type LedgerStartBillWorkflowFromDocumentMutationHookResult = ReturnType<typeof useLedgerStartBillWorkflowFromDocumentMutation>;
export type LedgerStartBillWorkflowFromDocumentMutationResult = Apollo.MutationResult<LedgerStartBillWorkflowFromDocumentMutation>;
export type LedgerStartBillWorkflowFromDocumentMutationOptions = Apollo.BaseMutationOptions<LedgerStartBillWorkflowFromDocumentMutation, LedgerStartBillWorkflowFromDocumentMutationVariables>;
export const LedgerVoidBillDocument = gql`
    mutation LedgerVoidBill($legalEntityId: String!, $billId: String!, $internalNote: String) {
  ledgerVoidBill(
    legalEntityId: $legalEntityId
    billId: $billId
    internalNote: $internalNote
  )
}
    `;
export type LedgerVoidBillMutationFn = Apollo.MutationFunction<LedgerVoidBillMutation, LedgerVoidBillMutationVariables>;

/**
 * __useLedgerVoidBillMutation__
 *
 * To run a mutation, you first call `useLedgerVoidBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerVoidBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerVoidBillMutation, { data, loading, error }] = useLedgerVoidBillMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      billId: // value for 'billId'
 *      internalNote: // value for 'internalNote'
 *   },
 * });
 */
export function useLedgerVoidBillMutation(baseOptions?: Apollo.MutationHookOptions<LedgerVoidBillMutation, LedgerVoidBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerVoidBillMutation, LedgerVoidBillMutationVariables>(LedgerVoidBillDocument, options);
      }
export type LedgerVoidBillMutationHookResult = ReturnType<typeof useLedgerVoidBillMutation>;
export type LedgerVoidBillMutationResult = Apollo.MutationResult<LedgerVoidBillMutation>;
export type LedgerVoidBillMutationOptions = Apollo.BaseMutationOptions<LedgerVoidBillMutation, LedgerVoidBillMutationVariables>;
export const LedgerGetBillDeliveryTimelineDocument = gql`
    query LedgerGetBillDeliveryTimeline($viewKey: ViewKey!, $billId: String!) {
  ledgerGetBillDeliveryTimeline(viewKey: $viewKey, billId: $billId) {
    estimatedDelivery
    deliveryMethod
    sourceInstrument {
      __typename
      ... on BankAccount {
        id
        institutionName
        name
        accountIdMask
        isDefault
        nickname
        isAutoPayout
        iconObjectName
        isDisabled
      }
      ... on CreditCard {
        id
        cardLastFour
        cardBrand
        isDefault
        nickname
      }
    }
    destinationInstrument {
      __typename
      ... on BankAccount {
        id
        institutionName
        name
        accountIdMask
        isDefault
        nickname
        isAutoPayout
        iconObjectName
        isDisabled
      }
      ... on Check {
        id
        address {
          ...LedgerBillAddressFields
        }
        recipientName
        isDefault
        nickname
        isAutoPayout
        isDisabled
      }
    }
    milestones {
      status
      date
    }
  }
}
    ${LedgerBillAddressFieldsFragmentDoc}`;

/**
 * __useLedgerGetBillDeliveryTimelineQuery__
 *
 * To run a query within a React component, call `useLedgerGetBillDeliveryTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerGetBillDeliveryTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerGetBillDeliveryTimelineQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      billId: // value for 'billId'
 *   },
 * });
 */
export function useLedgerGetBillDeliveryTimelineQuery(baseOptions: Apollo.QueryHookOptions<LedgerGetBillDeliveryTimelineQuery, LedgerGetBillDeliveryTimelineQueryVariables> & ({ variables: LedgerGetBillDeliveryTimelineQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerGetBillDeliveryTimelineQuery, LedgerGetBillDeliveryTimelineQueryVariables>(LedgerGetBillDeliveryTimelineDocument, options);
      }
export function useLedgerGetBillDeliveryTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerGetBillDeliveryTimelineQuery, LedgerGetBillDeliveryTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerGetBillDeliveryTimelineQuery, LedgerGetBillDeliveryTimelineQueryVariables>(LedgerGetBillDeliveryTimelineDocument, options);
        }
export function useLedgerGetBillDeliveryTimelineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerGetBillDeliveryTimelineQuery, LedgerGetBillDeliveryTimelineQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerGetBillDeliveryTimelineQuery, LedgerGetBillDeliveryTimelineQueryVariables>(LedgerGetBillDeliveryTimelineDocument, options);
        }
export type LedgerGetBillDeliveryTimelineQueryHookResult = ReturnType<typeof useLedgerGetBillDeliveryTimelineQuery>;
export type LedgerGetBillDeliveryTimelineLazyQueryHookResult = ReturnType<typeof useLedgerGetBillDeliveryTimelineLazyQuery>;
export type LedgerGetBillDeliveryTimelineSuspenseQueryHookResult = ReturnType<typeof useLedgerGetBillDeliveryTimelineSuspenseQuery>;
export type LedgerGetBillDeliveryTimelineQueryResult = Apollo.QueryResult<LedgerGetBillDeliveryTimelineQuery, LedgerGetBillDeliveryTimelineQueryVariables>;
export const LedgerGetBillExternalPaymentDocument = gql`
    query LedgerGetBillExternalPayment($viewKey: ViewKey!, $billId: String!) {
  ledgerGetBillExternalPayment(viewKey: $viewKey, billId: $billId) {
    id
    status
    statusAt
    paidAt
    amount {
      ...EntityMonetaryValueFields
    }
    externalReferenceNumber
  }
}
    ${EntityMonetaryValueFieldsFragmentDoc}`;

/**
 * __useLedgerGetBillExternalPaymentQuery__
 *
 * To run a query within a React component, call `useLedgerGetBillExternalPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerGetBillExternalPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerGetBillExternalPaymentQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      billId: // value for 'billId'
 *   },
 * });
 */
export function useLedgerGetBillExternalPaymentQuery(baseOptions: Apollo.QueryHookOptions<LedgerGetBillExternalPaymentQuery, LedgerGetBillExternalPaymentQueryVariables> & ({ variables: LedgerGetBillExternalPaymentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerGetBillExternalPaymentQuery, LedgerGetBillExternalPaymentQueryVariables>(LedgerGetBillExternalPaymentDocument, options);
      }
export function useLedgerGetBillExternalPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerGetBillExternalPaymentQuery, LedgerGetBillExternalPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerGetBillExternalPaymentQuery, LedgerGetBillExternalPaymentQueryVariables>(LedgerGetBillExternalPaymentDocument, options);
        }
export function useLedgerGetBillExternalPaymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerGetBillExternalPaymentQuery, LedgerGetBillExternalPaymentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerGetBillExternalPaymentQuery, LedgerGetBillExternalPaymentQueryVariables>(LedgerGetBillExternalPaymentDocument, options);
        }
export type LedgerGetBillExternalPaymentQueryHookResult = ReturnType<typeof useLedgerGetBillExternalPaymentQuery>;
export type LedgerGetBillExternalPaymentLazyQueryHookResult = ReturnType<typeof useLedgerGetBillExternalPaymentLazyQuery>;
export type LedgerGetBillExternalPaymentSuspenseQueryHookResult = ReturnType<typeof useLedgerGetBillExternalPaymentSuspenseQuery>;
export type LedgerGetBillExternalPaymentQueryResult = Apollo.QueryResult<LedgerGetBillExternalPaymentQuery, LedgerGetBillExternalPaymentQueryVariables>;
export const LedgerListBillWorkflowStatusUpdatesDocument = gql`
    query LedgerListBillWorkflowStatusUpdates($legalEntityId: String!, $billId: String!) {
  ledgerListBillWorkflowStatusUpdates(
    legalEntityId: $legalEntityId
    billId: $billId
  ) {
    id
    status
    statusAt
    statusSource
    internalNote
    user {
      ...EntityUserFields
    }
  }
}
    ${EntityUserFieldsFragmentDoc}`;

/**
 * __useLedgerListBillWorkflowStatusUpdatesQuery__
 *
 * To run a query within a React component, call `useLedgerListBillWorkflowStatusUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerListBillWorkflowStatusUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerListBillWorkflowStatusUpdatesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      billId: // value for 'billId'
 *   },
 * });
 */
export function useLedgerListBillWorkflowStatusUpdatesQuery(baseOptions: Apollo.QueryHookOptions<LedgerListBillWorkflowStatusUpdatesQuery, LedgerListBillWorkflowStatusUpdatesQueryVariables> & ({ variables: LedgerListBillWorkflowStatusUpdatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerListBillWorkflowStatusUpdatesQuery, LedgerListBillWorkflowStatusUpdatesQueryVariables>(LedgerListBillWorkflowStatusUpdatesDocument, options);
      }
export function useLedgerListBillWorkflowStatusUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerListBillWorkflowStatusUpdatesQuery, LedgerListBillWorkflowStatusUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerListBillWorkflowStatusUpdatesQuery, LedgerListBillWorkflowStatusUpdatesQueryVariables>(LedgerListBillWorkflowStatusUpdatesDocument, options);
        }
export function useLedgerListBillWorkflowStatusUpdatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerListBillWorkflowStatusUpdatesQuery, LedgerListBillWorkflowStatusUpdatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerListBillWorkflowStatusUpdatesQuery, LedgerListBillWorkflowStatusUpdatesQueryVariables>(LedgerListBillWorkflowStatusUpdatesDocument, options);
        }
export type LedgerListBillWorkflowStatusUpdatesQueryHookResult = ReturnType<typeof useLedgerListBillWorkflowStatusUpdatesQuery>;
export type LedgerListBillWorkflowStatusUpdatesLazyQueryHookResult = ReturnType<typeof useLedgerListBillWorkflowStatusUpdatesLazyQuery>;
export type LedgerListBillWorkflowStatusUpdatesSuspenseQueryHookResult = ReturnType<typeof useLedgerListBillWorkflowStatusUpdatesSuspenseQuery>;
export type LedgerListBillWorkflowStatusUpdatesQueryResult = Apollo.QueryResult<LedgerListBillWorkflowStatusUpdatesQuery, LedgerListBillWorkflowStatusUpdatesQueryVariables>;
export const LedgerListBillWorkflowsDocument = gql`
    query LedgerListBillWorkflows($legalEntityId: String!, $statuses: [WorkflowStatus!], $splitLineItems: Boolean, $prepareSplitLineItems: Boolean, $idempotencyKey: String) {
  ledgerListBillWorkflows(
    legalEntityId: $legalEntityId
    statuses: $statuses
    splitLineItems: $splitLineItems
    prepareSplitLineItems: $prepareSplitLineItems
    idempotencyKey: $idempotencyKey
  ) {
    legalEntityId
    workflowId
    idempotencyKey
    definitionName
    status
    createdAt
    updatedAt
    completedAt
  }
}
    `;

/**
 * __useLedgerListBillWorkflowsQuery__
 *
 * To run a query within a React component, call `useLedgerListBillWorkflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerListBillWorkflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerListBillWorkflowsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      statuses: // value for 'statuses'
 *      splitLineItems: // value for 'splitLineItems'
 *      prepareSplitLineItems: // value for 'prepareSplitLineItems'
 *      idempotencyKey: // value for 'idempotencyKey'
 *   },
 * });
 */
export function useLedgerListBillWorkflowsQuery(baseOptions: Apollo.QueryHookOptions<LedgerListBillWorkflowsQuery, LedgerListBillWorkflowsQueryVariables> & ({ variables: LedgerListBillWorkflowsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerListBillWorkflowsQuery, LedgerListBillWorkflowsQueryVariables>(LedgerListBillWorkflowsDocument, options);
      }
export function useLedgerListBillWorkflowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerListBillWorkflowsQuery, LedgerListBillWorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerListBillWorkflowsQuery, LedgerListBillWorkflowsQueryVariables>(LedgerListBillWorkflowsDocument, options);
        }
export function useLedgerListBillWorkflowsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerListBillWorkflowsQuery, LedgerListBillWorkflowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerListBillWorkflowsQuery, LedgerListBillWorkflowsQueryVariables>(LedgerListBillWorkflowsDocument, options);
        }
export type LedgerListBillWorkflowsQueryHookResult = ReturnType<typeof useLedgerListBillWorkflowsQuery>;
export type LedgerListBillWorkflowsLazyQueryHookResult = ReturnType<typeof useLedgerListBillWorkflowsLazyQuery>;
export type LedgerListBillWorkflowsSuspenseQueryHookResult = ReturnType<typeof useLedgerListBillWorkflowsSuspenseQuery>;
export type LedgerListBillWorkflowsQueryResult = Apollo.QueryResult<LedgerListBillWorkflowsQuery, LedgerListBillWorkflowsQueryVariables>;
export const LedgerListBillsByVendorDocument = gql`
    query LedgerListBillsByVendor($viewKey: ViewKey!, $vendorId: String!) {
  ledgerListBillsByVendor(viewKey: $viewKey, vendorId: $vendorId) {
    id
    status
    vendor {
      id
      icon
      name
    }
    statusAt
    billDate
    createdAt
    amount {
      ...EntityMonetaryValueFields
    }
  }
}
    ${EntityMonetaryValueFieldsFragmentDoc}`;

/**
 * __useLedgerListBillsByVendorQuery__
 *
 * To run a query within a React component, call `useLedgerListBillsByVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerListBillsByVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerListBillsByVendorQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useLedgerListBillsByVendorQuery(baseOptions: Apollo.QueryHookOptions<LedgerListBillsByVendorQuery, LedgerListBillsByVendorQueryVariables> & ({ variables: LedgerListBillsByVendorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerListBillsByVendorQuery, LedgerListBillsByVendorQueryVariables>(LedgerListBillsByVendorDocument, options);
      }
export function useLedgerListBillsByVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerListBillsByVendorQuery, LedgerListBillsByVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerListBillsByVendorQuery, LedgerListBillsByVendorQueryVariables>(LedgerListBillsByVendorDocument, options);
        }
export function useLedgerListBillsByVendorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerListBillsByVendorQuery, LedgerListBillsByVendorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerListBillsByVendorQuery, LedgerListBillsByVendorQueryVariables>(LedgerListBillsByVendorDocument, options);
        }
export type LedgerListBillsByVendorQueryHookResult = ReturnType<typeof useLedgerListBillsByVendorQuery>;
export type LedgerListBillsByVendorLazyQueryHookResult = ReturnType<typeof useLedgerListBillsByVendorLazyQuery>;
export type LedgerListBillsByVendorSuspenseQueryHookResult = ReturnType<typeof useLedgerListBillsByVendorSuspenseQuery>;
export type LedgerListBillsByVendorQueryResult = Apollo.QueryResult<LedgerListBillsByVendorQuery, LedgerListBillsByVendorQueryVariables>;
export const LedgerListConnectBillsDocument = gql`
    query LedgerListConnectBills($viewKey: ViewKey!, $paidSinceDays: Int) {
  ledgerListConnectBills(viewKey: $viewKey, paidSinceDays: $paidSinceDays) {
    ...LedgerBillSummaryFields
  }
}
    ${LedgerBillSummaryFieldsFragmentDoc}`;

/**
 * __useLedgerListConnectBillsQuery__
 *
 * To run a query within a React component, call `useLedgerListConnectBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerListConnectBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerListConnectBillsQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      paidSinceDays: // value for 'paidSinceDays'
 *   },
 * });
 */
export function useLedgerListConnectBillsQuery(baseOptions: Apollo.QueryHookOptions<LedgerListConnectBillsQuery, LedgerListConnectBillsQueryVariables> & ({ variables: LedgerListConnectBillsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerListConnectBillsQuery, LedgerListConnectBillsQueryVariables>(LedgerListConnectBillsDocument, options);
      }
export function useLedgerListConnectBillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerListConnectBillsQuery, LedgerListConnectBillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerListConnectBillsQuery, LedgerListConnectBillsQueryVariables>(LedgerListConnectBillsDocument, options);
        }
export function useLedgerListConnectBillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerListConnectBillsQuery, LedgerListConnectBillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerListConnectBillsQuery, LedgerListConnectBillsQueryVariables>(LedgerListConnectBillsDocument, options);
        }
export type LedgerListConnectBillsQueryHookResult = ReturnType<typeof useLedgerListConnectBillsQuery>;
export type LedgerListConnectBillsLazyQueryHookResult = ReturnType<typeof useLedgerListConnectBillsLazyQuery>;
export type LedgerListConnectBillsSuspenseQueryHookResult = ReturnType<typeof useLedgerListConnectBillsSuspenseQuery>;
export type LedgerListConnectBillsQueryResult = Apollo.QueryResult<LedgerListConnectBillsQuery, LedgerListConnectBillsQueryVariables>;
export const LedgerListPaidBillsDocument = gql`
    query LedgerListPaidBills($viewKey: ViewKey!, $paidSinceDays: Int) {
  ledgerListPaidBills(viewKey: $viewKey, paidSinceDays: $paidSinceDays) {
    ...LedgerBillSummaryFields
  }
}
    ${LedgerBillSummaryFieldsFragmentDoc}`;

/**
 * __useLedgerListPaidBillsQuery__
 *
 * To run a query within a React component, call `useLedgerListPaidBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerListPaidBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerListPaidBillsQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      paidSinceDays: // value for 'paidSinceDays'
 *   },
 * });
 */
export function useLedgerListPaidBillsQuery(baseOptions: Apollo.QueryHookOptions<LedgerListPaidBillsQuery, LedgerListPaidBillsQueryVariables> & ({ variables: LedgerListPaidBillsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerListPaidBillsQuery, LedgerListPaidBillsQueryVariables>(LedgerListPaidBillsDocument, options);
      }
export function useLedgerListPaidBillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerListPaidBillsQuery, LedgerListPaidBillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerListPaidBillsQuery, LedgerListPaidBillsQueryVariables>(LedgerListPaidBillsDocument, options);
        }
export function useLedgerListPaidBillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerListPaidBillsQuery, LedgerListPaidBillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerListPaidBillsQuery, LedgerListPaidBillsQueryVariables>(LedgerListPaidBillsDocument, options);
        }
export type LedgerListPaidBillsQueryHookResult = ReturnType<typeof useLedgerListPaidBillsQuery>;
export type LedgerListPaidBillsLazyQueryHookResult = ReturnType<typeof useLedgerListPaidBillsLazyQuery>;
export type LedgerListPaidBillsSuspenseQueryHookResult = ReturnType<typeof useLedgerListPaidBillsSuspenseQuery>;
export type LedgerListPaidBillsQueryResult = Apollo.QueryResult<LedgerListPaidBillsQuery, LedgerListPaidBillsQueryVariables>;
export const LedgerListPendingBillsDocument = gql`
    query LedgerListPendingBills($viewKey: ViewKey!) {
  ledgerListPendingBills(viewKey: $viewKey) {
    ...LedgerBillSummaryFields
  }
}
    ${LedgerBillSummaryFieldsFragmentDoc}`;

/**
 * __useLedgerListPendingBillsQuery__
 *
 * To run a query within a React component, call `useLedgerListPendingBillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerListPendingBillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerListPendingBillsQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useLedgerListPendingBillsQuery(baseOptions: Apollo.QueryHookOptions<LedgerListPendingBillsQuery, LedgerListPendingBillsQueryVariables> & ({ variables: LedgerListPendingBillsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerListPendingBillsQuery, LedgerListPendingBillsQueryVariables>(LedgerListPendingBillsDocument, options);
      }
export function useLedgerListPendingBillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerListPendingBillsQuery, LedgerListPendingBillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerListPendingBillsQuery, LedgerListPendingBillsQueryVariables>(LedgerListPendingBillsDocument, options);
        }
export function useLedgerListPendingBillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerListPendingBillsQuery, LedgerListPendingBillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerListPendingBillsQuery, LedgerListPendingBillsQueryVariables>(LedgerListPendingBillsDocument, options);
        }
export type LedgerListPendingBillsQueryHookResult = ReturnType<typeof useLedgerListPendingBillsQuery>;
export type LedgerListPendingBillsLazyQueryHookResult = ReturnType<typeof useLedgerListPendingBillsLazyQuery>;
export type LedgerListPendingBillsSuspenseQueryHookResult = ReturnType<typeof useLedgerListPendingBillsSuspenseQuery>;
export type LedgerListPendingBillsQueryResult = Apollo.QueryResult<LedgerListPendingBillsQuery, LedgerListPendingBillsQueryVariables>;
export const LedgerListRetryableBillPayoutIdsDocument = gql`
    query LedgerListRetryableBillPayoutIds($viewKey: ViewKey!, $vendorId: String!) {
  ledgerListRetryableBillPayoutIds(viewKey: $viewKey, vendorId: $vendorId)
}
    `;

/**
 * __useLedgerListRetryableBillPayoutIdsQuery__
 *
 * To run a query within a React component, call `useLedgerListRetryableBillPayoutIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerListRetryableBillPayoutIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerListRetryableBillPayoutIdsQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useLedgerListRetryableBillPayoutIdsQuery(baseOptions: Apollo.QueryHookOptions<LedgerListRetryableBillPayoutIdsQuery, LedgerListRetryableBillPayoutIdsQueryVariables> & ({ variables: LedgerListRetryableBillPayoutIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerListRetryableBillPayoutIdsQuery, LedgerListRetryableBillPayoutIdsQueryVariables>(LedgerListRetryableBillPayoutIdsDocument, options);
      }
export function useLedgerListRetryableBillPayoutIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerListRetryableBillPayoutIdsQuery, LedgerListRetryableBillPayoutIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerListRetryableBillPayoutIdsQuery, LedgerListRetryableBillPayoutIdsQueryVariables>(LedgerListRetryableBillPayoutIdsDocument, options);
        }
export function useLedgerListRetryableBillPayoutIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerListRetryableBillPayoutIdsQuery, LedgerListRetryableBillPayoutIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerListRetryableBillPayoutIdsQuery, LedgerListRetryableBillPayoutIdsQueryVariables>(LedgerListRetryableBillPayoutIdsDocument, options);
        }
export type LedgerListRetryableBillPayoutIdsQueryHookResult = ReturnType<typeof useLedgerListRetryableBillPayoutIdsQuery>;
export type LedgerListRetryableBillPayoutIdsLazyQueryHookResult = ReturnType<typeof useLedgerListRetryableBillPayoutIdsLazyQuery>;
export type LedgerListRetryableBillPayoutIdsSuspenseQueryHookResult = ReturnType<typeof useLedgerListRetryableBillPayoutIdsSuspenseQuery>;
export type LedgerListRetryableBillPayoutIdsQueryResult = Apollo.QueryResult<LedgerListRetryableBillPayoutIdsQuery, LedgerListRetryableBillPayoutIdsQueryVariables>;
export const LedgerReadBillTransactionDocument = gql`
    query LedgerReadBillTransaction($transactionFactId: String, $billId: String, $viewKey: ViewKey!) {
  ledgerReadBillTransaction(
    transactionFactId: $transactionFactId
    billId: $billId
    viewKey: $viewKey
  ) {
    billId
    dataSourceId
    transactionFactId
    ledgerTransactionId
    apFactId
    apCategory {
      ...EntityCategoryFields
    }
    status
    statusAt
    createdAt
    billDate
    dueDate
    scheduleSendForApproval
    billNumber
    referenceNumber
    memo
    candidateMode
    candidateFactSets {
      candidateMode
      transactionFactIds
    }
    totalAmount {
      ...LedgerBillMonetaryValueFields
    }
    vendor {
      ...VendorFields
    }
    document {
      ...LedgerBillDocumentFields
    }
    billAccess {
      ...LedgerBillAccessFields
    }
    users {
      ...LedgerBillUserFields
    }
    duplicates {
      ...DuplicateBillFields
    }
    lineItems {
      id
      entryType
      name
      description
      quantity
      productId
      classificationId
      externalLineItemId
      documentFeatureId
      amount {
        ...LedgerBillMonetaryValueFields
      }
      unitPrice {
        ...LedgerBillMonetaryValueFields
      }
      category {
        ...EntityCategoryFields
      }
      department {
        ...EntityDepartmentFields
      }
      location {
        ...EntityLocationFields
      }
    }
  }
}
    ${EntityCategoryFieldsFragmentDoc}
${LedgerBillMonetaryValueFieldsFragmentDoc}
${VendorFieldsFragmentDoc}
${LedgerBillDocumentFieldsFragmentDoc}
${LedgerBillAccessFieldsFragmentDoc}
${LedgerBillUserFieldsFragmentDoc}
${DuplicateBillFieldsFragmentDoc}
${EntityDepartmentFieldsFragmentDoc}
${EntityLocationFieldsFragmentDoc}`;

/**
 * __useLedgerReadBillTransactionQuery__
 *
 * To run a query within a React component, call `useLedgerReadBillTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerReadBillTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerReadBillTransactionQuery({
 *   variables: {
 *      transactionFactId: // value for 'transactionFactId'
 *      billId: // value for 'billId'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useLedgerReadBillTransactionQuery(baseOptions: Apollo.QueryHookOptions<LedgerReadBillTransactionQuery, LedgerReadBillTransactionQueryVariables> & ({ variables: LedgerReadBillTransactionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerReadBillTransactionQuery, LedgerReadBillTransactionQueryVariables>(LedgerReadBillTransactionDocument, options);
      }
export function useLedgerReadBillTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerReadBillTransactionQuery, LedgerReadBillTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerReadBillTransactionQuery, LedgerReadBillTransactionQueryVariables>(LedgerReadBillTransactionDocument, options);
        }
export function useLedgerReadBillTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerReadBillTransactionQuery, LedgerReadBillTransactionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerReadBillTransactionQuery, LedgerReadBillTransactionQueryVariables>(LedgerReadBillTransactionDocument, options);
        }
export type LedgerReadBillTransactionQueryHookResult = ReturnType<typeof useLedgerReadBillTransactionQuery>;
export type LedgerReadBillTransactionLazyQueryHookResult = ReturnType<typeof useLedgerReadBillTransactionLazyQuery>;
export type LedgerReadBillTransactionSuspenseQueryHookResult = ReturnType<typeof useLedgerReadBillTransactionSuspenseQuery>;
export type LedgerReadBillTransactionQueryResult = Apollo.QueryResult<LedgerReadBillTransactionQuery, LedgerReadBillTransactionQueryVariables>;
export const ReadCategoryDocument = gql`
    query ReadCategory($viewKey: ViewKey!, $categoryId: String!) {
  readCategory(viewKey: $viewKey, categoryId: $categoryId) {
    ...CategoryFields
  }
}
    ${CategoryFieldsFragmentDoc}`;

/**
 * __useReadCategoryQuery__
 *
 * To run a query within a React component, call `useReadCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadCategoryQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useReadCategoryQuery(baseOptions: Apollo.QueryHookOptions<ReadCategoryQuery, ReadCategoryQueryVariables> & ({ variables: ReadCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadCategoryQuery, ReadCategoryQueryVariables>(ReadCategoryDocument, options);
      }
export function useReadCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadCategoryQuery, ReadCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadCategoryQuery, ReadCategoryQueryVariables>(ReadCategoryDocument, options);
        }
export function useReadCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadCategoryQuery, ReadCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadCategoryQuery, ReadCategoryQueryVariables>(ReadCategoryDocument, options);
        }
export type ReadCategoryQueryHookResult = ReturnType<typeof useReadCategoryQuery>;
export type ReadCategoryLazyQueryHookResult = ReturnType<typeof useReadCategoryLazyQuery>;
export type ReadCategorySuspenseQueryHookResult = ReturnType<typeof useReadCategorySuspenseQuery>;
export type ReadCategoryQueryResult = Apollo.QueryResult<ReadCategoryQuery, ReadCategoryQueryVariables>;
export const AutoConfigureProductDocument = gql`
    mutation AutoConfigureProduct($legalEntityId: String!, $product: CategoryToLabelMappingProduct!) {
  autoConfigureProduct(legalEntityId: $legalEntityId, product: $product)
}
    `;
export type AutoConfigureProductMutationFn = Apollo.MutationFunction<AutoConfigureProductMutation, AutoConfigureProductMutationVariables>;

/**
 * __useAutoConfigureProductMutation__
 *
 * To run a mutation, you first call `useAutoConfigureProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoConfigureProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoConfigureProductMutation, { data, loading, error }] = useAutoConfigureProductMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      product: // value for 'product'
 *   },
 * });
 */
export function useAutoConfigureProductMutation(baseOptions?: Apollo.MutationHookOptions<AutoConfigureProductMutation, AutoConfigureProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AutoConfigureProductMutation, AutoConfigureProductMutationVariables>(AutoConfigureProductDocument, options);
      }
export type AutoConfigureProductMutationHookResult = ReturnType<typeof useAutoConfigureProductMutation>;
export type AutoConfigureProductMutationResult = Apollo.MutationResult<AutoConfigureProductMutation>;
export type AutoConfigureProductMutationOptions = Apollo.BaseMutationOptions<AutoConfigureProductMutation, AutoConfigureProductMutationVariables>;
export const CreateCategoryMappingDocument = gql`
    mutation CreateCategoryMapping($legalEntityId: String!, $mappingValue: String!, $mappingType: CategoryToLabelMappingType!, $product: CategoryToLabelMappingProduct!, $categoryId: String!) {
  createCategoryMapping(
    legalEntityId: $legalEntityId
    mappingValue: $mappingValue
    mappingType: $mappingType
    product: $product
    categoryId: $categoryId
  )
}
    `;
export type CreateCategoryMappingMutationFn = Apollo.MutationFunction<CreateCategoryMappingMutation, CreateCategoryMappingMutationVariables>;

/**
 * __useCreateCategoryMappingMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMappingMutation, { data, loading, error }] = useCreateCategoryMappingMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      mappingValue: // value for 'mappingValue'
 *      mappingType: // value for 'mappingType'
 *      product: // value for 'product'
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useCreateCategoryMappingMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryMappingMutation, CreateCategoryMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryMappingMutation, CreateCategoryMappingMutationVariables>(CreateCategoryMappingDocument, options);
      }
export type CreateCategoryMappingMutationHookResult = ReturnType<typeof useCreateCategoryMappingMutation>;
export type CreateCategoryMappingMutationResult = Apollo.MutationResult<CreateCategoryMappingMutation>;
export type CreateCategoryMappingMutationOptions = Apollo.BaseMutationOptions<CreateCategoryMappingMutation, CreateCategoryMappingMutationVariables>;
export const ListCategoryMappingsDocument = gql`
    query ListCategoryMappings($legalEntityId: String!, $product: CategoryToLabelMappingProduct!) {
  listCategoryMappings(legalEntityId: $legalEntityId, product: $product) {
    ...CategoryMappingFields
  }
}
    ${CategoryMappingFieldsFragmentDoc}`;

/**
 * __useListCategoryMappingsQuery__
 *
 * To run a query within a React component, call `useListCategoryMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCategoryMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCategoryMappingsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      product: // value for 'product'
 *   },
 * });
 */
export function useListCategoryMappingsQuery(baseOptions: Apollo.QueryHookOptions<ListCategoryMappingsQuery, ListCategoryMappingsQueryVariables> & ({ variables: ListCategoryMappingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCategoryMappingsQuery, ListCategoryMappingsQueryVariables>(ListCategoryMappingsDocument, options);
      }
export function useListCategoryMappingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCategoryMappingsQuery, ListCategoryMappingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCategoryMappingsQuery, ListCategoryMappingsQueryVariables>(ListCategoryMappingsDocument, options);
        }
export function useListCategoryMappingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCategoryMappingsQuery, ListCategoryMappingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCategoryMappingsQuery, ListCategoryMappingsQueryVariables>(ListCategoryMappingsDocument, options);
        }
export type ListCategoryMappingsQueryHookResult = ReturnType<typeof useListCategoryMappingsQuery>;
export type ListCategoryMappingsLazyQueryHookResult = ReturnType<typeof useListCategoryMappingsLazyQuery>;
export type ListCategoryMappingsSuspenseQueryHookResult = ReturnType<typeof useListCategoryMappingsSuspenseQuery>;
export type ListCategoryMappingsQueryResult = Apollo.QueryResult<ListCategoryMappingsQuery, ListCategoryMappingsQueryVariables>;
export const ValidateCategoryMappingsDocument = gql`
    query ValidateCategoryMappings($legalEntityId: String!, $product: CategoryToLabelMappingProduct!) {
  validateCategoryMappings(
    legalEntityId: $legalEntityId
    product: $product
    useNewPaymentProvider: true
  )
}
    `;

/**
 * __useValidateCategoryMappingsQuery__
 *
 * To run a query within a React component, call `useValidateCategoryMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCategoryMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCategoryMappingsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      product: // value for 'product'
 *   },
 * });
 */
export function useValidateCategoryMappingsQuery(baseOptions: Apollo.QueryHookOptions<ValidateCategoryMappingsQuery, ValidateCategoryMappingsQueryVariables> & ({ variables: ValidateCategoryMappingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateCategoryMappingsQuery, ValidateCategoryMappingsQueryVariables>(ValidateCategoryMappingsDocument, options);
      }
export function useValidateCategoryMappingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateCategoryMappingsQuery, ValidateCategoryMappingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateCategoryMappingsQuery, ValidateCategoryMappingsQueryVariables>(ValidateCategoryMappingsDocument, options);
        }
export function useValidateCategoryMappingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateCategoryMappingsQuery, ValidateCategoryMappingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateCategoryMappingsQuery, ValidateCategoryMappingsQueryVariables>(ValidateCategoryMappingsDocument, options);
        }
export type ValidateCategoryMappingsQueryHookResult = ReturnType<typeof useValidateCategoryMappingsQuery>;
export type ValidateCategoryMappingsLazyQueryHookResult = ReturnType<typeof useValidateCategoryMappingsLazyQuery>;
export type ValidateCategoryMappingsSuspenseQueryHookResult = ReturnType<typeof useValidateCategoryMappingsSuspenseQuery>;
export type ValidateCategoryMappingsQueryResult = Apollo.QueryResult<ValidateCategoryMappingsQuery, ValidateCategoryMappingsQueryVariables>;
export const CreateCategoryDocument = gql`
    mutation CreateCategory($legalEntityId: String!, $category: CreateCategoryInput!) {
  createCategory(category: $category, legalEntityId: $legalEntityId) {
    categoryId
  }
}
    `;
export type CreateCategoryMutationFn = Apollo.MutationFunction<CreateCategoryMutation, CreateCategoryMutationVariables>;

/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMutation, { data, loading, error }] = useCreateCategoryMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useCreateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryMutation, CreateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, options);
      }
export type CreateCategoryMutationHookResult = ReturnType<typeof useCreateCategoryMutation>;
export type CreateCategoryMutationResult = Apollo.MutationResult<CreateCategoryMutation>;
export type CreateCategoryMutationOptions = Apollo.BaseMutationOptions<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const UpdateCategoryDocument = gql`
    mutation UpdateCategory($legalEntityId: String!, $viewKey: ViewKey!, $category: UpdateCategoryInput!) {
  updateCategory(
    legalEntityId: $legalEntityId
    viewKey: $viewKey
    category: $category
  )
}
    `;
export type UpdateCategoryMutationFn = Apollo.MutationFunction<UpdateCategoryMutation, UpdateCategoryMutationVariables>;

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutation, { data, loading, error }] = useUpdateCategoryMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      viewKey: // value for 'viewKey'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useUpdateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
      }
export type UpdateCategoryMutationHookResult = ReturnType<typeof useUpdateCategoryMutation>;
export type UpdateCategoryMutationResult = Apollo.MutationResult<UpdateCategoryMutation>;
export type UpdateCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const UpdateCategoryStatusDocument = gql`
    mutation UpdateCategoryStatus($legalEntityId: String!, $viewKey: ViewKey!, $categoryId: String!, $enabled: Boolean!) {
  updateCategoryStatus(
    legalEntityId: $legalEntityId
    viewKey: $viewKey
    categoryId: $categoryId
    enabled: $enabled
  )
}
    `;
export type UpdateCategoryStatusMutationFn = Apollo.MutationFunction<UpdateCategoryStatusMutation, UpdateCategoryStatusMutationVariables>;

/**
 * __useUpdateCategoryStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryStatusMutation, { data, loading, error }] = useUpdateCategoryStatusMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      viewKey: // value for 'viewKey'
 *      categoryId: // value for 'categoryId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateCategoryStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryStatusMutation, UpdateCategoryStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryStatusMutation, UpdateCategoryStatusMutationVariables>(UpdateCategoryStatusDocument, options);
      }
export type UpdateCategoryStatusMutationHookResult = ReturnType<typeof useUpdateCategoryStatusMutation>;
export type UpdateCategoryStatusMutationResult = Apollo.MutationResult<UpdateCategoryStatusMutation>;
export type UpdateCategoryStatusMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryStatusMutation, UpdateCategoryStatusMutationVariables>;
export const UploadBulkCategoryDocument = gql`
    mutation UploadBulkCategory($legalEntityId: String!, $fileName: String!, $categories: [CreateBulkCategoryInput!]!) {
  uploadBulkCategory(
    legalEntityId: $legalEntityId
    fileName: $fileName
    categories: $categories
  )
}
    `;
export type UploadBulkCategoryMutationFn = Apollo.MutationFunction<UploadBulkCategoryMutation, UploadBulkCategoryMutationVariables>;

/**
 * __useUploadBulkCategoryMutation__
 *
 * To run a mutation, you first call `useUploadBulkCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadBulkCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadBulkCategoryMutation, { data, loading, error }] = useUploadBulkCategoryMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      fileName: // value for 'fileName'
 *      categories: // value for 'categories'
 *   },
 * });
 */
export function useUploadBulkCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UploadBulkCategoryMutation, UploadBulkCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadBulkCategoryMutation, UploadBulkCategoryMutationVariables>(UploadBulkCategoryDocument, options);
      }
export type UploadBulkCategoryMutationHookResult = ReturnType<typeof useUploadBulkCategoryMutation>;
export type UploadBulkCategoryMutationResult = Apollo.MutationResult<UploadBulkCategoryMutation>;
export type UploadBulkCategoryMutationOptions = Apollo.BaseMutationOptions<UploadBulkCategoryMutation, UploadBulkCategoryMutationVariables>;
export const ListCategoriesDocument = gql`
    query ListCategories($viewKey: ViewKey!, $categoryType: CategoryType) {
  listCategories(viewKey: $viewKey, categoryType: $categoryType) {
    ...CategoryFields
  }
}
    ${CategoryFieldsFragmentDoc}`;

/**
 * __useListCategoriesQuery__
 *
 * To run a query within a React component, call `useListCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCategoriesQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      categoryType: // value for 'categoryType'
 *   },
 * });
 */
export function useListCategoriesQuery(baseOptions: Apollo.QueryHookOptions<ListCategoriesQuery, ListCategoriesQueryVariables> & ({ variables: ListCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCategoriesQuery, ListCategoriesQueryVariables>(ListCategoriesDocument, options);
      }
export function useListCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCategoriesQuery, ListCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCategoriesQuery, ListCategoriesQueryVariables>(ListCategoriesDocument, options);
        }
export function useListCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCategoriesQuery, ListCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCategoriesQuery, ListCategoriesQueryVariables>(ListCategoriesDocument, options);
        }
export type ListCategoriesQueryHookResult = ReturnType<typeof useListCategoriesQuery>;
export type ListCategoriesLazyQueryHookResult = ReturnType<typeof useListCategoriesLazyQuery>;
export type ListCategoriesSuspenseQueryHookResult = ReturnType<typeof useListCategoriesSuspenseQuery>;
export type ListCategoriesQueryResult = Apollo.QueryResult<ListCategoriesQuery, ListCategoriesQueryVariables>;
export const ListCategoryIntegrationsDocument = gql`
    query ListCategoryIntegrations($legalEntityId: String!) {
  listCategoryIntegrations(legalEntityId: $legalEntityId) {
    ...CategoryIntegrationsFields
  }
}
    ${CategoryIntegrationsFieldsFragmentDoc}`;

/**
 * __useListCategoryIntegrationsQuery__
 *
 * To run a query within a React component, call `useListCategoryIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCategoryIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCategoryIntegrationsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListCategoryIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<ListCategoryIntegrationsQuery, ListCategoryIntegrationsQueryVariables> & ({ variables: ListCategoryIntegrationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCategoryIntegrationsQuery, ListCategoryIntegrationsQueryVariables>(ListCategoryIntegrationsDocument, options);
      }
export function useListCategoryIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCategoryIntegrationsQuery, ListCategoryIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCategoryIntegrationsQuery, ListCategoryIntegrationsQueryVariables>(ListCategoryIntegrationsDocument, options);
        }
export function useListCategoryIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCategoryIntegrationsQuery, ListCategoryIntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCategoryIntegrationsQuery, ListCategoryIntegrationsQueryVariables>(ListCategoryIntegrationsDocument, options);
        }
export type ListCategoryIntegrationsQueryHookResult = ReturnType<typeof useListCategoryIntegrationsQuery>;
export type ListCategoryIntegrationsLazyQueryHookResult = ReturnType<typeof useListCategoryIntegrationsLazyQuery>;
export type ListCategoryIntegrationsSuspenseQueryHookResult = ReturnType<typeof useListCategoryIntegrationsSuspenseQuery>;
export type ListCategoryIntegrationsQueryResult = Apollo.QueryResult<ListCategoryIntegrationsQuery, ListCategoryIntegrationsQueryVariables>;
export const ListRawCategoriesDocument = gql`
    query ListRawCategories($legalEntityId: String!) {
  listRawCategories(legalEntityId: $legalEntityId) {
    ...EntityCategoryFields
  }
}
    ${EntityCategoryFieldsFragmentDoc}`;

/**
 * __useListRawCategoriesQuery__
 *
 * To run a query within a React component, call `useListRawCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRawCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRawCategoriesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListRawCategoriesQuery(baseOptions: Apollo.QueryHookOptions<ListRawCategoriesQuery, ListRawCategoriesQueryVariables> & ({ variables: ListRawCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRawCategoriesQuery, ListRawCategoriesQueryVariables>(ListRawCategoriesDocument, options);
      }
export function useListRawCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRawCategoriesQuery, ListRawCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRawCategoriesQuery, ListRawCategoriesQueryVariables>(ListRawCategoriesDocument, options);
        }
export function useListRawCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListRawCategoriesQuery, ListRawCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListRawCategoriesQuery, ListRawCategoriesQueryVariables>(ListRawCategoriesDocument, options);
        }
export type ListRawCategoriesQueryHookResult = ReturnType<typeof useListRawCategoriesQuery>;
export type ListRawCategoriesLazyQueryHookResult = ReturnType<typeof useListRawCategoriesLazyQuery>;
export type ListRawCategoriesSuspenseQueryHookResult = ReturnType<typeof useListRawCategoriesSuspenseQuery>;
export type ListRawCategoriesQueryResult = Apollo.QueryResult<ListRawCategoriesQuery, ListRawCategoriesQueryVariables>;
export const ClosedPeriodUpdateTransactionDocument = gql`
    mutation ClosedPeriodUpdateTransaction($legalEntityId: String!, $transaction: InputTransaction!, $filter: TransactionFilter!) {
  closedPeriodUpdateTransaction(
    legalEntityId: $legalEntityId
    transaction: $transaction
    filter: $filter
  )
}
    `;
export type ClosedPeriodUpdateTransactionMutationFn = Apollo.MutationFunction<ClosedPeriodUpdateTransactionMutation, ClosedPeriodUpdateTransactionMutationVariables>;

/**
 * __useClosedPeriodUpdateTransactionMutation__
 *
 * To run a mutation, you first call `useClosedPeriodUpdateTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClosedPeriodUpdateTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closedPeriodUpdateTransactionMutation, { data, loading, error }] = useClosedPeriodUpdateTransactionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      transaction: // value for 'transaction'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useClosedPeriodUpdateTransactionMutation(baseOptions?: Apollo.MutationHookOptions<ClosedPeriodUpdateTransactionMutation, ClosedPeriodUpdateTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClosedPeriodUpdateTransactionMutation, ClosedPeriodUpdateTransactionMutationVariables>(ClosedPeriodUpdateTransactionDocument, options);
      }
export type ClosedPeriodUpdateTransactionMutationHookResult = ReturnType<typeof useClosedPeriodUpdateTransactionMutation>;
export type ClosedPeriodUpdateTransactionMutationResult = Apollo.MutationResult<ClosedPeriodUpdateTransactionMutation>;
export type ClosedPeriodUpdateTransactionMutationOptions = Apollo.BaseMutationOptions<ClosedPeriodUpdateTransactionMutation, ClosedPeriodUpdateTransactionMutationVariables>;
export const EditClosedPeriodTransactionChangeFieldDocument = gql`
    mutation EditClosedPeriodTransactionChangeField($legalEntityId: String!, $requestId: String!, $transactionChangeId: String!, $rejectionReason: String!, $newValue: ClosedPeriodTransactionChangeValueInput!) {
  editFieldRequest(
    legalEntityId: $legalEntityId
    requestId: $requestId
    transactionChangeId: $transactionChangeId
    rejectionReason: $rejectionReason
    newValue: $newValue
  )
}
    `;
export type EditClosedPeriodTransactionChangeFieldMutationFn = Apollo.MutationFunction<EditClosedPeriodTransactionChangeFieldMutation, EditClosedPeriodTransactionChangeFieldMutationVariables>;

/**
 * __useEditClosedPeriodTransactionChangeFieldMutation__
 *
 * To run a mutation, you first call `useEditClosedPeriodTransactionChangeFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditClosedPeriodTransactionChangeFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editClosedPeriodTransactionChangeFieldMutation, { data, loading, error }] = useEditClosedPeriodTransactionChangeFieldMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      requestId: // value for 'requestId'
 *      transactionChangeId: // value for 'transactionChangeId'
 *      rejectionReason: // value for 'rejectionReason'
 *      newValue: // value for 'newValue'
 *   },
 * });
 */
export function useEditClosedPeriodTransactionChangeFieldMutation(baseOptions?: Apollo.MutationHookOptions<EditClosedPeriodTransactionChangeFieldMutation, EditClosedPeriodTransactionChangeFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditClosedPeriodTransactionChangeFieldMutation, EditClosedPeriodTransactionChangeFieldMutationVariables>(EditClosedPeriodTransactionChangeFieldDocument, options);
      }
export type EditClosedPeriodTransactionChangeFieldMutationHookResult = ReturnType<typeof useEditClosedPeriodTransactionChangeFieldMutation>;
export type EditClosedPeriodTransactionChangeFieldMutationResult = Apollo.MutationResult<EditClosedPeriodTransactionChangeFieldMutation>;
export type EditClosedPeriodTransactionChangeFieldMutationOptions = Apollo.BaseMutationOptions<EditClosedPeriodTransactionChangeFieldMutation, EditClosedPeriodTransactionChangeFieldMutationVariables>;
export const RejectClosedPeriodTransactionChangeFieldDocument = gql`
    mutation RejectClosedPeriodTransactionChangeField($legalEntityId: String!, $requestId: String!, $transactionChangeId: String!, $rejectionReason: String!) {
  rejectFieldRequest(
    legalEntityId: $legalEntityId
    requestId: $requestId
    transactionChangeId: $transactionChangeId
    rejectionReason: $rejectionReason
  )
}
    `;
export type RejectClosedPeriodTransactionChangeFieldMutationFn = Apollo.MutationFunction<RejectClosedPeriodTransactionChangeFieldMutation, RejectClosedPeriodTransactionChangeFieldMutationVariables>;

/**
 * __useRejectClosedPeriodTransactionChangeFieldMutation__
 *
 * To run a mutation, you first call `useRejectClosedPeriodTransactionChangeFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectClosedPeriodTransactionChangeFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectClosedPeriodTransactionChangeFieldMutation, { data, loading, error }] = useRejectClosedPeriodTransactionChangeFieldMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      requestId: // value for 'requestId'
 *      transactionChangeId: // value for 'transactionChangeId'
 *      rejectionReason: // value for 'rejectionReason'
 *   },
 * });
 */
export function useRejectClosedPeriodTransactionChangeFieldMutation(baseOptions?: Apollo.MutationHookOptions<RejectClosedPeriodTransactionChangeFieldMutation, RejectClosedPeriodTransactionChangeFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectClosedPeriodTransactionChangeFieldMutation, RejectClosedPeriodTransactionChangeFieldMutationVariables>(RejectClosedPeriodTransactionChangeFieldDocument, options);
      }
export type RejectClosedPeriodTransactionChangeFieldMutationHookResult = ReturnType<typeof useRejectClosedPeriodTransactionChangeFieldMutation>;
export type RejectClosedPeriodTransactionChangeFieldMutationResult = Apollo.MutationResult<RejectClosedPeriodTransactionChangeFieldMutation>;
export type RejectClosedPeriodTransactionChangeFieldMutationOptions = Apollo.BaseMutationOptions<RejectClosedPeriodTransactionChangeFieldMutation, RejectClosedPeriodTransactionChangeFieldMutationVariables>;
export const ResolveClosedPeriodRequestDocument = gql`
    mutation ResolveClosedPeriodRequest($legalEntityId: String!, $requestId: String!, $requestType: ClosedPeriodRequestType!, $resolution: ClosedPeriodRequestResolution!, $rejectionReason: String) {
  resolveClosedPeriodRequest(
    legalEntityId: $legalEntityId
    requestId: $requestId
    requestType: $requestType
    resolution: $resolution
    rejectionReason: $rejectionReason
  )
}
    `;
export type ResolveClosedPeriodRequestMutationFn = Apollo.MutationFunction<ResolveClosedPeriodRequestMutation, ResolveClosedPeriodRequestMutationVariables>;

/**
 * __useResolveClosedPeriodRequestMutation__
 *
 * To run a mutation, you first call `useResolveClosedPeriodRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveClosedPeriodRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveClosedPeriodRequestMutation, { data, loading, error }] = useResolveClosedPeriodRequestMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      requestId: // value for 'requestId'
 *      requestType: // value for 'requestType'
 *      resolution: // value for 'resolution'
 *      rejectionReason: // value for 'rejectionReason'
 *   },
 * });
 */
export function useResolveClosedPeriodRequestMutation(baseOptions?: Apollo.MutationHookOptions<ResolveClosedPeriodRequestMutation, ResolveClosedPeriodRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveClosedPeriodRequestMutation, ResolveClosedPeriodRequestMutationVariables>(ResolveClosedPeriodRequestDocument, options);
      }
export type ResolveClosedPeriodRequestMutationHookResult = ReturnType<typeof useResolveClosedPeriodRequestMutation>;
export type ResolveClosedPeriodRequestMutationResult = Apollo.MutationResult<ResolveClosedPeriodRequestMutation>;
export type ResolveClosedPeriodRequestMutationOptions = Apollo.BaseMutationOptions<ResolveClosedPeriodRequestMutation, ResolveClosedPeriodRequestMutationVariables>;
export const ListClosedPeriodTransactionChangeDiffsDocument = gql`
    query ListClosedPeriodTransactionChangeDiffs($viewKey: ViewKey!, $ledgerTransactionId: String!, $requestIds: [String!]!) {
  listClosedPeriodTransactionChangeDiffs(
    viewKey: $viewKey
    ledgerTransactionId: $ledgerTransactionId
    requestIds: $requestIds
  ) {
    requestId
    diffs {
      ...ClosedPeriodTransactionChangeDiffFields
    }
  }
}
    ${ClosedPeriodTransactionChangeDiffFieldsFragmentDoc}`;

/**
 * __useListClosedPeriodTransactionChangeDiffsQuery__
 *
 * To run a query within a React component, call `useListClosedPeriodTransactionChangeDiffsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListClosedPeriodTransactionChangeDiffsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListClosedPeriodTransactionChangeDiffsQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      ledgerTransactionId: // value for 'ledgerTransactionId'
 *      requestIds: // value for 'requestIds'
 *   },
 * });
 */
export function useListClosedPeriodTransactionChangeDiffsQuery(baseOptions: Apollo.QueryHookOptions<ListClosedPeriodTransactionChangeDiffsQuery, ListClosedPeriodTransactionChangeDiffsQueryVariables> & ({ variables: ListClosedPeriodTransactionChangeDiffsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListClosedPeriodTransactionChangeDiffsQuery, ListClosedPeriodTransactionChangeDiffsQueryVariables>(ListClosedPeriodTransactionChangeDiffsDocument, options);
      }
export function useListClosedPeriodTransactionChangeDiffsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListClosedPeriodTransactionChangeDiffsQuery, ListClosedPeriodTransactionChangeDiffsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListClosedPeriodTransactionChangeDiffsQuery, ListClosedPeriodTransactionChangeDiffsQueryVariables>(ListClosedPeriodTransactionChangeDiffsDocument, options);
        }
export function useListClosedPeriodTransactionChangeDiffsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListClosedPeriodTransactionChangeDiffsQuery, ListClosedPeriodTransactionChangeDiffsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListClosedPeriodTransactionChangeDiffsQuery, ListClosedPeriodTransactionChangeDiffsQueryVariables>(ListClosedPeriodTransactionChangeDiffsDocument, options);
        }
export type ListClosedPeriodTransactionChangeDiffsQueryHookResult = ReturnType<typeof useListClosedPeriodTransactionChangeDiffsQuery>;
export type ListClosedPeriodTransactionChangeDiffsLazyQueryHookResult = ReturnType<typeof useListClosedPeriodTransactionChangeDiffsLazyQuery>;
export type ListClosedPeriodTransactionChangeDiffsSuspenseQueryHookResult = ReturnType<typeof useListClosedPeriodTransactionChangeDiffsSuspenseQuery>;
export type ListClosedPeriodTransactionChangeDiffsQueryResult = Apollo.QueryResult<ListClosedPeriodTransactionChangeDiffsQuery, ListClosedPeriodTransactionChangeDiffsQueryVariables>;
export const ReadDateClosedPeriodRequestAffectedCountDocument = gql`
    query ReadDateClosedPeriodRequestAffectedCount($legalEntityId: String!, $requestId: String!) {
  readDateClosedPeriodRequestAffectedCount(
    legalEntityId: $legalEntityId
    requestId: $requestId
  ) {
    affectedCount
  }
}
    `;

/**
 * __useReadDateClosedPeriodRequestAffectedCountQuery__
 *
 * To run a query within a React component, call `useReadDateClosedPeriodRequestAffectedCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadDateClosedPeriodRequestAffectedCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadDateClosedPeriodRequestAffectedCountQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useReadDateClosedPeriodRequestAffectedCountQuery(baseOptions: Apollo.QueryHookOptions<ReadDateClosedPeriodRequestAffectedCountQuery, ReadDateClosedPeriodRequestAffectedCountQueryVariables> & ({ variables: ReadDateClosedPeriodRequestAffectedCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadDateClosedPeriodRequestAffectedCountQuery, ReadDateClosedPeriodRequestAffectedCountQueryVariables>(ReadDateClosedPeriodRequestAffectedCountDocument, options);
      }
export function useReadDateClosedPeriodRequestAffectedCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadDateClosedPeriodRequestAffectedCountQuery, ReadDateClosedPeriodRequestAffectedCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadDateClosedPeriodRequestAffectedCountQuery, ReadDateClosedPeriodRequestAffectedCountQueryVariables>(ReadDateClosedPeriodRequestAffectedCountDocument, options);
        }
export function useReadDateClosedPeriodRequestAffectedCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadDateClosedPeriodRequestAffectedCountQuery, ReadDateClosedPeriodRequestAffectedCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadDateClosedPeriodRequestAffectedCountQuery, ReadDateClosedPeriodRequestAffectedCountQueryVariables>(ReadDateClosedPeriodRequestAffectedCountDocument, options);
        }
export type ReadDateClosedPeriodRequestAffectedCountQueryHookResult = ReturnType<typeof useReadDateClosedPeriodRequestAffectedCountQuery>;
export type ReadDateClosedPeriodRequestAffectedCountLazyQueryHookResult = ReturnType<typeof useReadDateClosedPeriodRequestAffectedCountLazyQuery>;
export type ReadDateClosedPeriodRequestAffectedCountSuspenseQueryHookResult = ReturnType<typeof useReadDateClosedPeriodRequestAffectedCountSuspenseQuery>;
export type ReadDateClosedPeriodRequestAffectedCountQueryResult = Apollo.QueryResult<ReadDateClosedPeriodRequestAffectedCountQuery, ReadDateClosedPeriodRequestAffectedCountQueryVariables>;
export const BulkCreateOrReplyThreadsDocument = gql`
    mutation BulkCreateOrReplyThreads($targetObjects: [InputObjectIdentifier!]!, $comment: NewComment!, $viewKey: ViewKey!, $assignee: Assignee) {
  bulkCreateOrReplyThreads(
    targetObjects: $targetObjects
    comment: $comment
    viewKey: $viewKey
    assignee: $assignee
  )
}
    `;
export type BulkCreateOrReplyThreadsMutationFn = Apollo.MutationFunction<BulkCreateOrReplyThreadsMutation, BulkCreateOrReplyThreadsMutationVariables>;

/**
 * __useBulkCreateOrReplyThreadsMutation__
 *
 * To run a mutation, you first call `useBulkCreateOrReplyThreadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateOrReplyThreadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateOrReplyThreadsMutation, { data, loading, error }] = useBulkCreateOrReplyThreadsMutation({
 *   variables: {
 *      targetObjects: // value for 'targetObjects'
 *      comment: // value for 'comment'
 *      viewKey: // value for 'viewKey'
 *      assignee: // value for 'assignee'
 *   },
 * });
 */
export function useBulkCreateOrReplyThreadsMutation(baseOptions?: Apollo.MutationHookOptions<BulkCreateOrReplyThreadsMutation, BulkCreateOrReplyThreadsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkCreateOrReplyThreadsMutation, BulkCreateOrReplyThreadsMutationVariables>(BulkCreateOrReplyThreadsDocument, options);
      }
export type BulkCreateOrReplyThreadsMutationHookResult = ReturnType<typeof useBulkCreateOrReplyThreadsMutation>;
export type BulkCreateOrReplyThreadsMutationResult = Apollo.MutationResult<BulkCreateOrReplyThreadsMutation>;
export type BulkCreateOrReplyThreadsMutationOptions = Apollo.BaseMutationOptions<BulkCreateOrReplyThreadsMutation, BulkCreateOrReplyThreadsMutationVariables>;
export const CreateReactionDocument = gql`
    mutation CreateReaction($threadId: String!, $commentId: String!, $reaction: CommentReaction!) {
  createReaction(threadId: $threadId, commentId: $commentId, reaction: $reaction)
}
    `;
export type CreateReactionMutationFn = Apollo.MutationFunction<CreateReactionMutation, CreateReactionMutationVariables>;

/**
 * __useCreateReactionMutation__
 *
 * To run a mutation, you first call `useCreateReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReactionMutation, { data, loading, error }] = useCreateReactionMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      commentId: // value for 'commentId'
 *      reaction: // value for 'reaction'
 *   },
 * });
 */
export function useCreateReactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateReactionMutation, CreateReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReactionMutation, CreateReactionMutationVariables>(CreateReactionDocument, options);
      }
export type CreateReactionMutationHookResult = ReturnType<typeof useCreateReactionMutation>;
export type CreateReactionMutationResult = Apollo.MutationResult<CreateReactionMutation>;
export type CreateReactionMutationOptions = Apollo.BaseMutationOptions<CreateReactionMutation, CreateReactionMutationVariables>;
export const CreateThreadDocument = gql`
    mutation CreateThread($legalEntityId: String!, $kind: ObjectKind!, $id: String!, $comment: NewComment!, $context: String, $viewKey: ViewKey, $assignee: Assignee) {
  thread: createThread(
    targetObject: {legalEntityId: $legalEntityId, kind: $kind, id: $id}
    comment: $comment
    context: $context
    viewKey: $viewKey
    assignee: $assignee
  ) {
    ...ThreadWithEntitiesFields
  }
}
    ${ThreadWithEntitiesFieldsFragmentDoc}`;
export type CreateThreadMutationFn = Apollo.MutationFunction<CreateThreadMutation, CreateThreadMutationVariables>;

/**
 * __useCreateThreadMutation__
 *
 * To run a mutation, you first call `useCreateThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThreadMutation, { data, loading, error }] = useCreateThreadMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      kind: // value for 'kind'
 *      id: // value for 'id'
 *      comment: // value for 'comment'
 *      context: // value for 'context'
 *      viewKey: // value for 'viewKey'
 *      assignee: // value for 'assignee'
 *   },
 * });
 */
export function useCreateThreadMutation(baseOptions?: Apollo.MutationHookOptions<CreateThreadMutation, CreateThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateThreadMutation, CreateThreadMutationVariables>(CreateThreadDocument, options);
      }
export type CreateThreadMutationHookResult = ReturnType<typeof useCreateThreadMutation>;
export type CreateThreadMutationResult = Apollo.MutationResult<CreateThreadMutation>;
export type CreateThreadMutationOptions = Apollo.BaseMutationOptions<CreateThreadMutation, CreateThreadMutationVariables>;
export const DeleteReactionDocument = gql`
    mutation DeleteReaction($threadId: String!, $commentId: String!, $reaction: CommentReaction!) {
  deleteReaction(threadId: $threadId, commentId: $commentId, reaction: $reaction)
}
    `;
export type DeleteReactionMutationFn = Apollo.MutationFunction<DeleteReactionMutation, DeleteReactionMutationVariables>;

/**
 * __useDeleteReactionMutation__
 *
 * To run a mutation, you first call `useDeleteReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReactionMutation, { data, loading, error }] = useDeleteReactionMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      commentId: // value for 'commentId'
 *      reaction: // value for 'reaction'
 *   },
 * });
 */
export function useDeleteReactionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReactionMutation, DeleteReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReactionMutation, DeleteReactionMutationVariables>(DeleteReactionDocument, options);
      }
export type DeleteReactionMutationHookResult = ReturnType<typeof useDeleteReactionMutation>;
export type DeleteReactionMutationResult = Apollo.MutationResult<DeleteReactionMutation>;
export type DeleteReactionMutationOptions = Apollo.BaseMutationOptions<DeleteReactionMutation, DeleteReactionMutationVariables>;
export const ReplyThreadDocument = gql`
    mutation ReplyThread($threadId: String!, $comment: NewComment!, $assignee: Assignee, $viewKey: ViewKey) {
  comment: replyThread(
    threadId: $threadId
    comment: $comment
    viewKey: $viewKey
    assignee: $assignee
  ) {
    comment {
      ...CommentFields
    }
    entities {
      ...ObjectEntitiesFields
    }
  }
}
    ${CommentFieldsFragmentDoc}
${ObjectEntitiesFieldsFragmentDoc}`;
export type ReplyThreadMutationFn = Apollo.MutationFunction<ReplyThreadMutation, ReplyThreadMutationVariables>;

/**
 * __useReplyThreadMutation__
 *
 * To run a mutation, you first call `useReplyThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplyThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replyThreadMutation, { data, loading, error }] = useReplyThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      comment: // value for 'comment'
 *      assignee: // value for 'assignee'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useReplyThreadMutation(baseOptions?: Apollo.MutationHookOptions<ReplyThreadMutation, ReplyThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplyThreadMutation, ReplyThreadMutationVariables>(ReplyThreadDocument, options);
      }
export type ReplyThreadMutationHookResult = ReturnType<typeof useReplyThreadMutation>;
export type ReplyThreadMutationResult = Apollo.MutationResult<ReplyThreadMutation>;
export type ReplyThreadMutationOptions = Apollo.BaseMutationOptions<ReplyThreadMutation, ReplyThreadMutationVariables>;
export const ResolveThreadDocument = gql`
    mutation ResolveThread($threadId: String!, $viewKey: ViewKey) {
  resolveThread(threadId: $threadId, viewKey: $viewKey)
}
    `;
export type ResolveThreadMutationFn = Apollo.MutationFunction<ResolveThreadMutation, ResolveThreadMutationVariables>;

/**
 * __useResolveThreadMutation__
 *
 * To run a mutation, you first call `useResolveThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveThreadMutation, { data, loading, error }] = useResolveThreadMutation({
 *   variables: {
 *      threadId: // value for 'threadId'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useResolveThreadMutation(baseOptions?: Apollo.MutationHookOptions<ResolveThreadMutation, ResolveThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveThreadMutation, ResolveThreadMutationVariables>(ResolveThreadDocument, options);
      }
export type ResolveThreadMutationHookResult = ReturnType<typeof useResolveThreadMutation>;
export type ResolveThreadMutationResult = Apollo.MutationResult<ResolveThreadMutation>;
export type ResolveThreadMutationOptions = Apollo.BaseMutationOptions<ResolveThreadMutation, ResolveThreadMutationVariables>;
export const FindThreadByCommentDocument = gql`
    query FindThreadByComment($legalEntityId: String!, $commentId: String!) {
  thread: findThreadByComment(
    legalEntityId: $legalEntityId
    commentId: $commentId
  ) {
    ...ThreadDetailsFields
  }
}
    ${ThreadDetailsFieldsFragmentDoc}`;

/**
 * __useFindThreadByCommentQuery__
 *
 * To run a query within a React component, call `useFindThreadByCommentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindThreadByCommentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindThreadByCommentQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useFindThreadByCommentQuery(baseOptions: Apollo.QueryHookOptions<FindThreadByCommentQuery, FindThreadByCommentQueryVariables> & ({ variables: FindThreadByCommentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindThreadByCommentQuery, FindThreadByCommentQueryVariables>(FindThreadByCommentDocument, options);
      }
export function useFindThreadByCommentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindThreadByCommentQuery, FindThreadByCommentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindThreadByCommentQuery, FindThreadByCommentQueryVariables>(FindThreadByCommentDocument, options);
        }
export function useFindThreadByCommentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindThreadByCommentQuery, FindThreadByCommentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindThreadByCommentQuery, FindThreadByCommentQueryVariables>(FindThreadByCommentDocument, options);
        }
export type FindThreadByCommentQueryHookResult = ReturnType<typeof useFindThreadByCommentQuery>;
export type FindThreadByCommentLazyQueryHookResult = ReturnType<typeof useFindThreadByCommentLazyQuery>;
export type FindThreadByCommentSuspenseQueryHookResult = ReturnType<typeof useFindThreadByCommentSuspenseQuery>;
export type FindThreadByCommentQueryResult = Apollo.QueryResult<FindThreadByCommentQuery, FindThreadByCommentQueryVariables>;
export const ListThreadsDocument = gql`
    query ListThreads($idsByKind: IdentifiersByKind!, $viewType: ViewType!) {
  listThreads(idsByKind: $idsByKind, viewType: $viewType) {
    ...ThreadsFields
  }
}
    ${ThreadsFieldsFragmentDoc}`;

/**
 * __useListThreadsQuery__
 *
 * To run a query within a React component, call `useListThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListThreadsQuery({
 *   variables: {
 *      idsByKind: // value for 'idsByKind'
 *      viewType: // value for 'viewType'
 *   },
 * });
 */
export function useListThreadsQuery(baseOptions: Apollo.QueryHookOptions<ListThreadsQuery, ListThreadsQueryVariables> & ({ variables: ListThreadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListThreadsQuery, ListThreadsQueryVariables>(ListThreadsDocument, options);
      }
export function useListThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListThreadsQuery, ListThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListThreadsQuery, ListThreadsQueryVariables>(ListThreadsDocument, options);
        }
export function useListThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListThreadsQuery, ListThreadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListThreadsQuery, ListThreadsQueryVariables>(ListThreadsDocument, options);
        }
export type ListThreadsQueryHookResult = ReturnType<typeof useListThreadsQuery>;
export type ListThreadsLazyQueryHookResult = ReturnType<typeof useListThreadsLazyQuery>;
export type ListThreadsSuspenseQueryHookResult = ReturnType<typeof useListThreadsSuspenseQuery>;
export type ListThreadsQueryResult = Apollo.QueryResult<ListThreadsQuery, ListThreadsQueryVariables>;
export const ReadAssociatedThreadsDocument = gql`
    query ReadAssociatedThreads($id: String!, $legalEntityId: String!, $kind: ObjectKind!, $allowResolved: Boolean) {
  response: readAssociatedThreads(
    id: $id
    legalEntityId: $legalEntityId
    kind: $kind
    allowResolved: $allowResolved
  ) {
    threads {
      ...ThreadFields
    }
    entities {
      ...ObjectEntitiesFields
    }
  }
}
    ${ThreadFieldsFragmentDoc}
${ObjectEntitiesFieldsFragmentDoc}`;

/**
 * __useReadAssociatedThreadsQuery__
 *
 * To run a query within a React component, call `useReadAssociatedThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadAssociatedThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadAssociatedThreadsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      legalEntityId: // value for 'legalEntityId'
 *      kind: // value for 'kind'
 *      allowResolved: // value for 'allowResolved'
 *   },
 * });
 */
export function useReadAssociatedThreadsQuery(baseOptions: Apollo.QueryHookOptions<ReadAssociatedThreadsQuery, ReadAssociatedThreadsQueryVariables> & ({ variables: ReadAssociatedThreadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadAssociatedThreadsQuery, ReadAssociatedThreadsQueryVariables>(ReadAssociatedThreadsDocument, options);
      }
export function useReadAssociatedThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadAssociatedThreadsQuery, ReadAssociatedThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadAssociatedThreadsQuery, ReadAssociatedThreadsQueryVariables>(ReadAssociatedThreadsDocument, options);
        }
export function useReadAssociatedThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadAssociatedThreadsQuery, ReadAssociatedThreadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadAssociatedThreadsQuery, ReadAssociatedThreadsQueryVariables>(ReadAssociatedThreadsDocument, options);
        }
export type ReadAssociatedThreadsQueryHookResult = ReturnType<typeof useReadAssociatedThreadsQuery>;
export type ReadAssociatedThreadsLazyQueryHookResult = ReturnType<typeof useReadAssociatedThreadsLazyQuery>;
export type ReadAssociatedThreadsSuspenseQueryHookResult = ReturnType<typeof useReadAssociatedThreadsSuspenseQuery>;
export type ReadAssociatedThreadsQueryResult = Apollo.QueryResult<ReadAssociatedThreadsQuery, ReadAssociatedThreadsQueryVariables>;
export const ReadThreadDocument = gql`
    query ReadThread($id: String!, $allowResolved: Boolean) {
  thread: readThread(threadId: $id, allowResolved: $allowResolved) {
    ...ThreadWithEntitiesFields
  }
}
    ${ThreadWithEntitiesFieldsFragmentDoc}`;

/**
 * __useReadThreadQuery__
 *
 * To run a query within a React component, call `useReadThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadThreadQuery({
 *   variables: {
 *      id: // value for 'id'
 *      allowResolved: // value for 'allowResolved'
 *   },
 * });
 */
export function useReadThreadQuery(baseOptions: Apollo.QueryHookOptions<ReadThreadQuery, ReadThreadQueryVariables> & ({ variables: ReadThreadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadThreadQuery, ReadThreadQueryVariables>(ReadThreadDocument, options);
      }
export function useReadThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadThreadQuery, ReadThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadThreadQuery, ReadThreadQueryVariables>(ReadThreadDocument, options);
        }
export function useReadThreadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadThreadQuery, ReadThreadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadThreadQuery, ReadThreadQueryVariables>(ReadThreadDocument, options);
        }
export type ReadThreadQueryHookResult = ReturnType<typeof useReadThreadQuery>;
export type ReadThreadLazyQueryHookResult = ReturnType<typeof useReadThreadLazyQuery>;
export type ReadThreadSuspenseQueryHookResult = ReturnType<typeof useReadThreadSuspenseQuery>;
export type ReadThreadQueryResult = Apollo.QueryResult<ReadThreadQuery, ReadThreadQueryVariables>;
export const ActivateRampConnectionDocument = gql`
    mutation ActivateRampConnection($legalEntityId: String!, $connectionId: String!) {
  activateRampConnection(
    legalEntityId: $legalEntityId
    connectionId: $connectionId
  )
}
    `;
export type ActivateRampConnectionMutationFn = Apollo.MutationFunction<ActivateRampConnectionMutation, ActivateRampConnectionMutationVariables>;

/**
 * __useActivateRampConnectionMutation__
 *
 * To run a mutation, you first call `useActivateRampConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateRampConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateRampConnectionMutation, { data, loading, error }] = useActivateRampConnectionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useActivateRampConnectionMutation(baseOptions?: Apollo.MutationHookOptions<ActivateRampConnectionMutation, ActivateRampConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateRampConnectionMutation, ActivateRampConnectionMutationVariables>(ActivateRampConnectionDocument, options);
      }
export type ActivateRampConnectionMutationHookResult = ReturnType<typeof useActivateRampConnectionMutation>;
export type ActivateRampConnectionMutationResult = Apollo.MutationResult<ActivateRampConnectionMutation>;
export type ActivateRampConnectionMutationOptions = Apollo.BaseMutationOptions<ActivateRampConnectionMutation, ActivateRampConnectionMutationVariables>;
export const ArchiveConnectionDocument = gql`
    mutation ArchiveConnection($legalEntityId: String!, $connectionId: String!) {
  archiveConnection(legalEntityId: $legalEntityId, connectionId: $connectionId)
}
    `;
export type ArchiveConnectionMutationFn = Apollo.MutationFunction<ArchiveConnectionMutation, ArchiveConnectionMutationVariables>;

/**
 * __useArchiveConnectionMutation__
 *
 * To run a mutation, you first call `useArchiveConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveConnectionMutation, { data, loading, error }] = useArchiveConnectionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useArchiveConnectionMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveConnectionMutation, ArchiveConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveConnectionMutation, ArchiveConnectionMutationVariables>(ArchiveConnectionDocument, options);
      }
export type ArchiveConnectionMutationHookResult = ReturnType<typeof useArchiveConnectionMutation>;
export type ArchiveConnectionMutationResult = Apollo.MutationResult<ArchiveConnectionMutation>;
export type ArchiveConnectionMutationOptions = Apollo.BaseMutationOptions<ArchiveConnectionMutation, ArchiveConnectionMutationVariables>;
export const ArchiveConnectionAccountDocument = gql`
    mutation ArchiveConnectionAccount($legalEntityId: String!, $connectionId: String!, $connectionAccountId: String!) {
  archiveConnectionAccount(
    legalEntityId: $legalEntityId
    connectionId: $connectionId
    connectionAccountId: $connectionAccountId
  )
}
    `;
export type ArchiveConnectionAccountMutationFn = Apollo.MutationFunction<ArchiveConnectionAccountMutation, ArchiveConnectionAccountMutationVariables>;

/**
 * __useArchiveConnectionAccountMutation__
 *
 * To run a mutation, you first call `useArchiveConnectionAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveConnectionAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveConnectionAccountMutation, { data, loading, error }] = useArchiveConnectionAccountMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectionId: // value for 'connectionId'
 *      connectionAccountId: // value for 'connectionAccountId'
 *   },
 * });
 */
export function useArchiveConnectionAccountMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveConnectionAccountMutation, ArchiveConnectionAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveConnectionAccountMutation, ArchiveConnectionAccountMutationVariables>(ArchiveConnectionAccountDocument, options);
      }
export type ArchiveConnectionAccountMutationHookResult = ReturnType<typeof useArchiveConnectionAccountMutation>;
export type ArchiveConnectionAccountMutationResult = Apollo.MutationResult<ArchiveConnectionAccountMutation>;
export type ArchiveConnectionAccountMutationOptions = Apollo.BaseMutationOptions<ArchiveConnectionAccountMutation, ArchiveConnectionAccountMutationVariables>;
export const AutoConfigureConnectionDocument = gql`
    mutation AutoConfigureConnection($legalEntityId: String!, $connectionId: String!) {
  autoConfigureConnection(
    legalEntityId: $legalEntityId
    connectionId: $connectionId
  )
}
    `;
export type AutoConfigureConnectionMutationFn = Apollo.MutationFunction<AutoConfigureConnectionMutation, AutoConfigureConnectionMutationVariables>;

/**
 * __useAutoConfigureConnectionMutation__
 *
 * To run a mutation, you first call `useAutoConfigureConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoConfigureConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoConfigureConnectionMutation, { data, loading, error }] = useAutoConfigureConnectionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useAutoConfigureConnectionMutation(baseOptions?: Apollo.MutationHookOptions<AutoConfigureConnectionMutation, AutoConfigureConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AutoConfigureConnectionMutation, AutoConfigureConnectionMutationVariables>(AutoConfigureConnectionDocument, options);
      }
export type AutoConfigureConnectionMutationHookResult = ReturnType<typeof useAutoConfigureConnectionMutation>;
export type AutoConfigureConnectionMutationResult = Apollo.MutationResult<AutoConfigureConnectionMutation>;
export type AutoConfigureConnectionMutationOptions = Apollo.BaseMutationOptions<AutoConfigureConnectionMutation, AutoConfigureConnectionMutationVariables>;
export const CreateAppDocument = gql`
    mutation CreateApp($organizationId: String!, $name: String!, $tagline: String!, $description: String, $homepageUrl: String!, $supportEmail: String!, $developerEmail: String!, $iconBase64: String!, $scopes: [String!]!, $redirectUris: [String!], $installUri: String, $acceptedTermsOfServiceVersion: String!) {
  createApp(
    organizationId: $organizationId
    name: $name
    tagline: $tagline
    description: $description
    homepageUrl: $homepageUrl
    supportEmail: $supportEmail
    developerEmail: $developerEmail
    iconBase64: $iconBase64
    scopes: $scopes
    redirectUris: $redirectUris
    installUri: $installUri
    acceptedTermsOfServiceVersion: $acceptedTermsOfServiceVersion
  )
}
    `;
export type CreateAppMutationFn = Apollo.MutationFunction<CreateAppMutation, CreateAppMutationVariables>;

/**
 * __useCreateAppMutation__
 *
 * To run a mutation, you first call `useCreateAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppMutation, { data, loading, error }] = useCreateAppMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      tagline: // value for 'tagline'
 *      description: // value for 'description'
 *      homepageUrl: // value for 'homepageUrl'
 *      supportEmail: // value for 'supportEmail'
 *      developerEmail: // value for 'developerEmail'
 *      iconBase64: // value for 'iconBase64'
 *      scopes: // value for 'scopes'
 *      redirectUris: // value for 'redirectUris'
 *      installUri: // value for 'installUri'
 *      acceptedTermsOfServiceVersion: // value for 'acceptedTermsOfServiceVersion'
 *   },
 * });
 */
export function useCreateAppMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppMutation, CreateAppMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppMutation, CreateAppMutationVariables>(CreateAppDocument, options);
      }
export type CreateAppMutationHookResult = ReturnType<typeof useCreateAppMutation>;
export type CreateAppMutationResult = Apollo.MutationResult<CreateAppMutation>;
export type CreateAppMutationOptions = Apollo.BaseMutationOptions<CreateAppMutation, CreateAppMutationVariables>;
export const CreateBillConnectionDocument = gql`
    mutation CreateBillConnection($legalEntityId: String!, $connectorId: String!, $username: String!, $password: String!) {
  createBillConnection(
    legalEntityId: $legalEntityId
    connectorId: $connectorId
    username: $username
    password: $password
  ) {
    ...CreateConnectionResponseFields
  }
}
    ${CreateConnectionResponseFieldsFragmentDoc}`;
export type CreateBillConnectionMutationFn = Apollo.MutationFunction<CreateBillConnectionMutation, CreateBillConnectionMutationVariables>;

/**
 * __useCreateBillConnectionMutation__
 *
 * To run a mutation, you first call `useCreateBillConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBillConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBillConnectionMutation, { data, loading, error }] = useCreateBillConnectionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectorId: // value for 'connectorId'
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCreateBillConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateBillConnectionMutation, CreateBillConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBillConnectionMutation, CreateBillConnectionMutationVariables>(CreateBillConnectionDocument, options);
      }
export type CreateBillConnectionMutationHookResult = ReturnType<typeof useCreateBillConnectionMutation>;
export type CreateBillConnectionMutationResult = Apollo.MutationResult<CreateBillConnectionMutation>;
export type CreateBillConnectionMutationOptions = Apollo.BaseMutationOptions<CreateBillConnectionMutation, CreateBillConnectionMutationVariables>;
export const CreateConnectPlaidLinkTokenDocument = gql`
    mutation CreateConnectPlaidLinkToken($routingNumber: String, $linkCustomizationName: String, $legalEntityId: String, $connectorId: String) {
  createConnectPlaidLinkToken(
    routingNumber: $routingNumber
    linkCustomizationName: $linkCustomizationName
    legalEntityId: $legalEntityId
    connectorId: $connectorId
  ) {
    token
  }
}
    `;
export type CreateConnectPlaidLinkTokenMutationFn = Apollo.MutationFunction<CreateConnectPlaidLinkTokenMutation, CreateConnectPlaidLinkTokenMutationVariables>;

/**
 * __useCreateConnectPlaidLinkTokenMutation__
 *
 * To run a mutation, you first call `useCreateConnectPlaidLinkTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConnectPlaidLinkTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConnectPlaidLinkTokenMutation, { data, loading, error }] = useCreateConnectPlaidLinkTokenMutation({
 *   variables: {
 *      routingNumber: // value for 'routingNumber'
 *      linkCustomizationName: // value for 'linkCustomizationName'
 *      legalEntityId: // value for 'legalEntityId'
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useCreateConnectPlaidLinkTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateConnectPlaidLinkTokenMutation, CreateConnectPlaidLinkTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConnectPlaidLinkTokenMutation, CreateConnectPlaidLinkTokenMutationVariables>(CreateConnectPlaidLinkTokenDocument, options);
      }
export type CreateConnectPlaidLinkTokenMutationHookResult = ReturnType<typeof useCreateConnectPlaidLinkTokenMutation>;
export type CreateConnectPlaidLinkTokenMutationResult = Apollo.MutationResult<CreateConnectPlaidLinkTokenMutation>;
export type CreateConnectPlaidLinkTokenMutationOptions = Apollo.BaseMutationOptions<CreateConnectPlaidLinkTokenMutation, CreateConnectPlaidLinkTokenMutationVariables>;
export const CreateConnectionDocument = gql`
    mutation CreateConnection($legalEntityId: String!, $connectorId: String!, $status: ConnectionStatus!, $institution: ConnectInstitutionInput!, $credential: ConnectCredentialInput, $externalId: String) {
  createConnection(
    legalEntityId: $legalEntityId
    connectorId: $connectorId
    status: $status
    institution: $institution
    credential: $credential
    externalId: $externalId
  ) {
    ...CreateConnectionResponseFields
  }
}
    ${CreateConnectionResponseFieldsFragmentDoc}`;
export type CreateConnectionMutationFn = Apollo.MutationFunction<CreateConnectionMutation, CreateConnectionMutationVariables>;

/**
 * __useCreateConnectionMutation__
 *
 * To run a mutation, you first call `useCreateConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConnectionMutation, { data, loading, error }] = useCreateConnectionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectorId: // value for 'connectorId'
 *      status: // value for 'status'
 *      institution: // value for 'institution'
 *      credential: // value for 'credential'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useCreateConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateConnectionMutation, CreateConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConnectionMutation, CreateConnectionMutationVariables>(CreateConnectionDocument, options);
      }
export type CreateConnectionMutationHookResult = ReturnType<typeof useCreateConnectionMutation>;
export type CreateConnectionMutationResult = Apollo.MutationResult<CreateConnectionMutation>;
export type CreateConnectionMutationOptions = Apollo.BaseMutationOptions<CreateConnectionMutation, CreateConnectionMutationVariables>;
export const CreateFinchConnectionDocument = gql`
    mutation CreateFinchConnection($legalEntityId: String!, $connectorId: String!, $authorizationCode: String!) {
  createFinchConnection(
    legalEntityId: $legalEntityId
    connectorId: $connectorId
    authorizationCode: $authorizationCode
  ) {
    ...CreateConnectionResponseFields
  }
}
    ${CreateConnectionResponseFieldsFragmentDoc}`;
export type CreateFinchConnectionMutationFn = Apollo.MutationFunction<CreateFinchConnectionMutation, CreateFinchConnectionMutationVariables>;

/**
 * __useCreateFinchConnectionMutation__
 *
 * To run a mutation, you first call `useCreateFinchConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFinchConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFinchConnectionMutation, { data, loading, error }] = useCreateFinchConnectionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectorId: // value for 'connectorId'
 *      authorizationCode: // value for 'authorizationCode'
 *   },
 * });
 */
export function useCreateFinchConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateFinchConnectionMutation, CreateFinchConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFinchConnectionMutation, CreateFinchConnectionMutationVariables>(CreateFinchConnectionDocument, options);
      }
export type CreateFinchConnectionMutationHookResult = ReturnType<typeof useCreateFinchConnectionMutation>;
export type CreateFinchConnectionMutationResult = Apollo.MutationResult<CreateFinchConnectionMutation>;
export type CreateFinchConnectionMutationOptions = Apollo.BaseMutationOptions<CreateFinchConnectionMutation, CreateFinchConnectionMutationVariables>;
export const CreateFinchSessionDocument = gql`
    mutation CreateFinchSession($legalEntityId: String!, $connectorId: String!, $payrollProvider: String) {
  createFinchSession(
    legalEntityId: $legalEntityId
    connectorId: $connectorId
    payrollProvider: $payrollProvider
  ) {
    sessionId
  }
}
    `;
export type CreateFinchSessionMutationFn = Apollo.MutationFunction<CreateFinchSessionMutation, CreateFinchSessionMutationVariables>;

/**
 * __useCreateFinchSessionMutation__
 *
 * To run a mutation, you first call `useCreateFinchSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFinchSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFinchSessionMutation, { data, loading, error }] = useCreateFinchSessionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectorId: // value for 'connectorId'
 *      payrollProvider: // value for 'payrollProvider'
 *   },
 * });
 */
export function useCreateFinchSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateFinchSessionMutation, CreateFinchSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFinchSessionMutation, CreateFinchSessionMutationVariables>(CreateFinchSessionDocument, options);
      }
export type CreateFinchSessionMutationHookResult = ReturnType<typeof useCreateFinchSessionMutation>;
export type CreateFinchSessionMutationResult = Apollo.MutationResult<CreateFinchSessionMutation>;
export type CreateFinchSessionMutationOptions = Apollo.BaseMutationOptions<CreateFinchSessionMutation, CreateFinchSessionMutationVariables>;
export const CreateGustoConnectionDocument = gql`
    mutation CreateGustoConnection($legalEntityId: String!, $connectorId: String!, $authorizationCode: String!) {
  createGustoConnection(
    legalEntityId: $legalEntityId
    connectorId: $connectorId
    authorizationCode: $authorizationCode
  ) {
    ...CreateConnectionResponseFields
  }
}
    ${CreateConnectionResponseFieldsFragmentDoc}`;
export type CreateGustoConnectionMutationFn = Apollo.MutationFunction<CreateGustoConnectionMutation, CreateGustoConnectionMutationVariables>;

/**
 * __useCreateGustoConnectionMutation__
 *
 * To run a mutation, you first call `useCreateGustoConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGustoConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGustoConnectionMutation, { data, loading, error }] = useCreateGustoConnectionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectorId: // value for 'connectorId'
 *      authorizationCode: // value for 'authorizationCode'
 *   },
 * });
 */
export function useCreateGustoConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateGustoConnectionMutation, CreateGustoConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGustoConnectionMutation, CreateGustoConnectionMutationVariables>(CreateGustoConnectionDocument, options);
      }
export type CreateGustoConnectionMutationHookResult = ReturnType<typeof useCreateGustoConnectionMutation>;
export type CreateGustoConnectionMutationResult = Apollo.MutationResult<CreateGustoConnectionMutation>;
export type CreateGustoConnectionMutationOptions = Apollo.BaseMutationOptions<CreateGustoConnectionMutation, CreateGustoConnectionMutationVariables>;
export const CreatePlaidConnectionDocument = gql`
    mutation CreatePlaidConnection($legalEntityId: String!, $connectorId: String!, $publicToken: String!, $institutionId: String!, $institutionName: String!, $accounts: [PlaidAccount!]!) {
  createPlaidConnection(
    legalEntityId: $legalEntityId
    connectorId: $connectorId
    publicToken: $publicToken
    institutionId: $institutionId
    institutionName: $institutionName
    accounts: $accounts
  ) {
    ...CreateConnectionResponseFields
  }
}
    ${CreateConnectionResponseFieldsFragmentDoc}`;
export type CreatePlaidConnectionMutationFn = Apollo.MutationFunction<CreatePlaidConnectionMutation, CreatePlaidConnectionMutationVariables>;

/**
 * __useCreatePlaidConnectionMutation__
 *
 * To run a mutation, you first call `useCreatePlaidConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaidConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaidConnectionMutation, { data, loading, error }] = useCreatePlaidConnectionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectorId: // value for 'connectorId'
 *      publicToken: // value for 'publicToken'
 *      institutionId: // value for 'institutionId'
 *      institutionName: // value for 'institutionName'
 *      accounts: // value for 'accounts'
 *   },
 * });
 */
export function useCreatePlaidConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlaidConnectionMutation, CreatePlaidConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlaidConnectionMutation, CreatePlaidConnectionMutationVariables>(CreatePlaidConnectionDocument, options);
      }
export type CreatePlaidConnectionMutationHookResult = ReturnType<typeof useCreatePlaidConnectionMutation>;
export type CreatePlaidConnectionMutationResult = Apollo.MutationResult<CreatePlaidConnectionMutation>;
export type CreatePlaidConnectionMutationOptions = Apollo.BaseMutationOptions<CreatePlaidConnectionMutation, CreatePlaidConnectionMutationVariables>;
export const CreateRampConnectionDocument = gql`
    mutation CreateRampConnection($legalEntityId: String!, $connectorId: String!, $authorizationCode: String!) {
  createRampConnection(
    legalEntityId: $legalEntityId
    connectorId: $connectorId
    authorizationCode: $authorizationCode
  ) {
    ...CreateConnectionResponseFields
  }
}
    ${CreateConnectionResponseFieldsFragmentDoc}`;
export type CreateRampConnectionMutationFn = Apollo.MutationFunction<CreateRampConnectionMutation, CreateRampConnectionMutationVariables>;

/**
 * __useCreateRampConnectionMutation__
 *
 * To run a mutation, you first call `useCreateRampConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRampConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRampConnectionMutation, { data, loading, error }] = useCreateRampConnectionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectorId: // value for 'connectorId'
 *      authorizationCode: // value for 'authorizationCode'
 *   },
 * });
 */
export function useCreateRampConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateRampConnectionMutation, CreateRampConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRampConnectionMutation, CreateRampConnectionMutationVariables>(CreateRampConnectionDocument, options);
      }
export type CreateRampConnectionMutationHookResult = ReturnType<typeof useCreateRampConnectionMutation>;
export type CreateRampConnectionMutationResult = Apollo.MutationResult<CreateRampConnectionMutation>;
export type CreateRampConnectionMutationOptions = Apollo.BaseMutationOptions<CreateRampConnectionMutation, CreateRampConnectionMutationVariables>;
export const CreateStripeConnectionDocument = gql`
    mutation CreateStripeConnection($legalEntityId: String!, $connectorId: String!, $externalId: String!) {
  createStripeConnection(
    legalEntityId: $legalEntityId
    connectorId: $connectorId
    externalId: $externalId
  ) {
    ...CreateConnectionResponseFields
  }
}
    ${CreateConnectionResponseFieldsFragmentDoc}`;
export type CreateStripeConnectionMutationFn = Apollo.MutationFunction<CreateStripeConnectionMutation, CreateStripeConnectionMutationVariables>;

/**
 * __useCreateStripeConnectionMutation__
 *
 * To run a mutation, you first call `useCreateStripeConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeConnectionMutation, { data, loading, error }] = useCreateStripeConnectionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectorId: // value for 'connectorId'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useCreateStripeConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateStripeConnectionMutation, CreateStripeConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripeConnectionMutation, CreateStripeConnectionMutationVariables>(CreateStripeConnectionDocument, options);
      }
export type CreateStripeConnectionMutationHookResult = ReturnType<typeof useCreateStripeConnectionMutation>;
export type CreateStripeConnectionMutationResult = Apollo.MutationResult<CreateStripeConnectionMutation>;
export type CreateStripeConnectionMutationOptions = Apollo.BaseMutationOptions<CreateStripeConnectionMutation, CreateStripeConnectionMutationVariables>;
export const CreateWebhookEndpointDocument = gql`
    mutation CreateWebhookEndpoint($organizationId: String!, $connectorId: String!, $environment: AppEnvironment!, $endpointUrl: String!, $eventCategories: [WebhookEventCategory!]!, $oauthClientCredentials: WebhookEndpointOAuthClientCredentialsInput) {
  createWebhookEndpoint(
    organizationId: $organizationId
    connectorId: $connectorId
    environment: $environment
    endpointUrl: $endpointUrl
    eventCategories: $eventCategories
    oauthClientCredentials: $oauthClientCredentials
  ) {
    ...WebhookEndpointFields
  }
}
    ${WebhookEndpointFieldsFragmentDoc}`;
export type CreateWebhookEndpointMutationFn = Apollo.MutationFunction<CreateWebhookEndpointMutation, CreateWebhookEndpointMutationVariables>;

/**
 * __useCreateWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useCreateWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebhookEndpointMutation, { data, loading, error }] = useCreateWebhookEndpointMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      connectorId: // value for 'connectorId'
 *      environment: // value for 'environment'
 *      endpointUrl: // value for 'endpointUrl'
 *      eventCategories: // value for 'eventCategories'
 *      oauthClientCredentials: // value for 'oauthClientCredentials'
 *   },
 * });
 */
export function useCreateWebhookEndpointMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebhookEndpointMutation, CreateWebhookEndpointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebhookEndpointMutation, CreateWebhookEndpointMutationVariables>(CreateWebhookEndpointDocument, options);
      }
export type CreateWebhookEndpointMutationHookResult = ReturnType<typeof useCreateWebhookEndpointMutation>;
export type CreateWebhookEndpointMutationResult = Apollo.MutationResult<CreateWebhookEndpointMutation>;
export type CreateWebhookEndpointMutationOptions = Apollo.BaseMutationOptions<CreateWebhookEndpointMutation, CreateWebhookEndpointMutationVariables>;
export const DeclineAppDocument = gql`
    mutation DeclineApp($clientId: String!, $redirectUri: String!, $state: String) {
  declineApp(clientId: $clientId, redirectUri: $redirectUri, state: $state) {
    uri
  }
}
    `;
export type DeclineAppMutationFn = Apollo.MutationFunction<DeclineAppMutation, DeclineAppMutationVariables>;

/**
 * __useDeclineAppMutation__
 *
 * To run a mutation, you first call `useDeclineAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineAppMutation, { data, loading, error }] = useDeclineAppMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      redirectUri: // value for 'redirectUri'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useDeclineAppMutation(baseOptions?: Apollo.MutationHookOptions<DeclineAppMutation, DeclineAppMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineAppMutation, DeclineAppMutationVariables>(DeclineAppDocument, options);
      }
export type DeclineAppMutationHookResult = ReturnType<typeof useDeclineAppMutation>;
export type DeclineAppMutationResult = Apollo.MutationResult<DeclineAppMutation>;
export type DeclineAppMutationOptions = Apollo.BaseMutationOptions<DeclineAppMutation, DeclineAppMutationVariables>;
export const DeleteConnectionAccountDocument = gql`
    mutation DeleteConnectionAccount($legalEntityId: String!, $connectionId: String!, $connectionAccountId: String!) {
  deleteConnectionAccount(
    legalEntityId: $legalEntityId
    connectionId: $connectionId
    connectionAccountId: $connectionAccountId
  )
}
    `;
export type DeleteConnectionAccountMutationFn = Apollo.MutationFunction<DeleteConnectionAccountMutation, DeleteConnectionAccountMutationVariables>;

/**
 * __useDeleteConnectionAccountMutation__
 *
 * To run a mutation, you first call `useDeleteConnectionAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConnectionAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConnectionAccountMutation, { data, loading, error }] = useDeleteConnectionAccountMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectionId: // value for 'connectionId'
 *      connectionAccountId: // value for 'connectionAccountId'
 *   },
 * });
 */
export function useDeleteConnectionAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConnectionAccountMutation, DeleteConnectionAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConnectionAccountMutation, DeleteConnectionAccountMutationVariables>(DeleteConnectionAccountDocument, options);
      }
export type DeleteConnectionAccountMutationHookResult = ReturnType<typeof useDeleteConnectionAccountMutation>;
export type DeleteConnectionAccountMutationResult = Apollo.MutationResult<DeleteConnectionAccountMutation>;
export type DeleteConnectionAccountMutationOptions = Apollo.BaseMutationOptions<DeleteConnectionAccountMutation, DeleteConnectionAccountMutationVariables>;
export const DeleteWebhookEndpointDocument = gql`
    mutation DeleteWebhookEndpoint($organizationId: String!, $connectorId: String!, $webhookEndpointId: String!) {
  deleteWebhookEndpoint(
    organizationId: $organizationId
    connectorId: $connectorId
    webhookEndpointId: $webhookEndpointId
  )
}
    `;
export type DeleteWebhookEndpointMutationFn = Apollo.MutationFunction<DeleteWebhookEndpointMutation, DeleteWebhookEndpointMutationVariables>;

/**
 * __useDeleteWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useDeleteWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWebhookEndpointMutation, { data, loading, error }] = useDeleteWebhookEndpointMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      connectorId: // value for 'connectorId'
 *      webhookEndpointId: // value for 'webhookEndpointId'
 *   },
 * });
 */
export function useDeleteWebhookEndpointMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWebhookEndpointMutation, DeleteWebhookEndpointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWebhookEndpointMutation, DeleteWebhookEndpointMutationVariables>(DeleteWebhookEndpointDocument, options);
      }
export type DeleteWebhookEndpointMutationHookResult = ReturnType<typeof useDeleteWebhookEndpointMutation>;
export type DeleteWebhookEndpointMutationResult = Apollo.MutationResult<DeleteWebhookEndpointMutation>;
export type DeleteWebhookEndpointMutationOptions = Apollo.BaseMutationOptions<DeleteWebhookEndpointMutation, DeleteWebhookEndpointMutationVariables>;
export const DestroyConnectionDocument = gql`
    mutation DestroyConnection($legalEntityId: String!, $connectionId: String!) {
  destroyConnection(legalEntityId: $legalEntityId, connectionId: $connectionId)
}
    `;
export type DestroyConnectionMutationFn = Apollo.MutationFunction<DestroyConnectionMutation, DestroyConnectionMutationVariables>;

/**
 * __useDestroyConnectionMutation__
 *
 * To run a mutation, you first call `useDestroyConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyConnectionMutation, { data, loading, error }] = useDestroyConnectionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useDestroyConnectionMutation(baseOptions?: Apollo.MutationHookOptions<DestroyConnectionMutation, DestroyConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyConnectionMutation, DestroyConnectionMutationVariables>(DestroyConnectionDocument, options);
      }
export type DestroyConnectionMutationHookResult = ReturnType<typeof useDestroyConnectionMutation>;
export type DestroyConnectionMutationResult = Apollo.MutationResult<DestroyConnectionMutation>;
export type DestroyConnectionMutationOptions = Apollo.BaseMutationOptions<DestroyConnectionMutation, DestroyConnectionMutationVariables>;
export const DisableWebhookEndpointDocument = gql`
    mutation DisableWebhookEndpoint($organizationId: String!, $connectorId: String!, $webhookEndpointId: String!) {
  disableWebhookEndpoint(
    organizationId: $organizationId
    connectorId: $connectorId
    webhookEndpointId: $webhookEndpointId
  ) {
    ...WebhookEndpointFields
  }
}
    ${WebhookEndpointFieldsFragmentDoc}`;
export type DisableWebhookEndpointMutationFn = Apollo.MutationFunction<DisableWebhookEndpointMutation, DisableWebhookEndpointMutationVariables>;

/**
 * __useDisableWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useDisableWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableWebhookEndpointMutation, { data, loading, error }] = useDisableWebhookEndpointMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      connectorId: // value for 'connectorId'
 *      webhookEndpointId: // value for 'webhookEndpointId'
 *   },
 * });
 */
export function useDisableWebhookEndpointMutation(baseOptions?: Apollo.MutationHookOptions<DisableWebhookEndpointMutation, DisableWebhookEndpointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableWebhookEndpointMutation, DisableWebhookEndpointMutationVariables>(DisableWebhookEndpointDocument, options);
      }
export type DisableWebhookEndpointMutationHookResult = ReturnType<typeof useDisableWebhookEndpointMutation>;
export type DisableWebhookEndpointMutationResult = Apollo.MutationResult<DisableWebhookEndpointMutation>;
export type DisableWebhookEndpointMutationOptions = Apollo.BaseMutationOptions<DisableWebhookEndpointMutation, DisableWebhookEndpointMutationVariables>;
export const EnableWebhookEndpointDocument = gql`
    mutation EnableWebhookEndpoint($organizationId: String!, $connectorId: String!, $webhookEndpointId: String!) {
  enableWebhookEndpoint(
    organizationId: $organizationId
    connectorId: $connectorId
    webhookEndpointId: $webhookEndpointId
  ) {
    ...WebhookEndpointFields
  }
}
    ${WebhookEndpointFieldsFragmentDoc}`;
export type EnableWebhookEndpointMutationFn = Apollo.MutationFunction<EnableWebhookEndpointMutation, EnableWebhookEndpointMutationVariables>;

/**
 * __useEnableWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useEnableWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableWebhookEndpointMutation, { data, loading, error }] = useEnableWebhookEndpointMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      connectorId: // value for 'connectorId'
 *      webhookEndpointId: // value for 'webhookEndpointId'
 *   },
 * });
 */
export function useEnableWebhookEndpointMutation(baseOptions?: Apollo.MutationHookOptions<EnableWebhookEndpointMutation, EnableWebhookEndpointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableWebhookEndpointMutation, EnableWebhookEndpointMutationVariables>(EnableWebhookEndpointDocument, options);
      }
export type EnableWebhookEndpointMutationHookResult = ReturnType<typeof useEnableWebhookEndpointMutation>;
export type EnableWebhookEndpointMutationResult = Apollo.MutationResult<EnableWebhookEndpointMutation>;
export type EnableWebhookEndpointMutationOptions = Apollo.BaseMutationOptions<EnableWebhookEndpointMutation, EnableWebhookEndpointMutationVariables>;
export const InstallAppDocument = gql`
    mutation InstallApp($legalEntityId: String!, $clientId: String!, $redirectUri: String!, $responseType: String!, $scopes: [String!]!, $state: String) {
  installApp(
    legalEntityId: $legalEntityId
    clientId: $clientId
    redirectUri: $redirectUri
    responseType: $responseType
    scopes: $scopes
    state: $state
  ) {
    uri
  }
}
    `;
export type InstallAppMutationFn = Apollo.MutationFunction<InstallAppMutation, InstallAppMutationVariables>;

/**
 * __useInstallAppMutation__
 *
 * To run a mutation, you first call `useInstallAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInstallAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [installAppMutation, { data, loading, error }] = useInstallAppMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      clientId: // value for 'clientId'
 *      redirectUri: // value for 'redirectUri'
 *      responseType: // value for 'responseType'
 *      scopes: // value for 'scopes'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useInstallAppMutation(baseOptions?: Apollo.MutationHookOptions<InstallAppMutation, InstallAppMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InstallAppMutation, InstallAppMutationVariables>(InstallAppDocument, options);
      }
export type InstallAppMutationHookResult = ReturnType<typeof useInstallAppMutation>;
export type InstallAppMutationResult = Apollo.MutationResult<InstallAppMutation>;
export type InstallAppMutationOptions = Apollo.BaseMutationOptions<InstallAppMutation, InstallAppMutationVariables>;
export const ReauthorizeFinchSessionDocument = gql`
    mutation ReauthorizeFinchSession($legalEntityId: String!, $connectionId: String!) {
  reauthorizeFinchSession(
    legalEntityId: $legalEntityId
    connectionId: $connectionId
  ) {
    sessionId
  }
}
    `;
export type ReauthorizeFinchSessionMutationFn = Apollo.MutationFunction<ReauthorizeFinchSessionMutation, ReauthorizeFinchSessionMutationVariables>;

/**
 * __useReauthorizeFinchSessionMutation__
 *
 * To run a mutation, you first call `useReauthorizeFinchSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReauthorizeFinchSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reauthorizeFinchSessionMutation, { data, loading, error }] = useReauthorizeFinchSessionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useReauthorizeFinchSessionMutation(baseOptions?: Apollo.MutationHookOptions<ReauthorizeFinchSessionMutation, ReauthorizeFinchSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReauthorizeFinchSessionMutation, ReauthorizeFinchSessionMutationVariables>(ReauthorizeFinchSessionDocument, options);
      }
export type ReauthorizeFinchSessionMutationHookResult = ReturnType<typeof useReauthorizeFinchSessionMutation>;
export type ReauthorizeFinchSessionMutationResult = Apollo.MutationResult<ReauthorizeFinchSessionMutation>;
export type ReauthorizeFinchSessionMutationOptions = Apollo.BaseMutationOptions<ReauthorizeFinchSessionMutation, ReauthorizeFinchSessionMutationVariables>;
export const RetryWebhookEndpointDeliveryDocument = gql`
    mutation RetryWebhookEndpointDelivery($organizationId: String!, $connectorId: String!, $webhookEndpointId: String!, $webhookDeliveryId: String!) {
  retryWebhookEndpointDelivery(
    organizationId: $organizationId
    connectorId: $connectorId
    webhookEndpointId: $webhookEndpointId
    webhookDeliveryId: $webhookDeliveryId
  )
}
    `;
export type RetryWebhookEndpointDeliveryMutationFn = Apollo.MutationFunction<RetryWebhookEndpointDeliveryMutation, RetryWebhookEndpointDeliveryMutationVariables>;

/**
 * __useRetryWebhookEndpointDeliveryMutation__
 *
 * To run a mutation, you first call `useRetryWebhookEndpointDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryWebhookEndpointDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryWebhookEndpointDeliveryMutation, { data, loading, error }] = useRetryWebhookEndpointDeliveryMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      connectorId: // value for 'connectorId'
 *      webhookEndpointId: // value for 'webhookEndpointId'
 *      webhookDeliveryId: // value for 'webhookDeliveryId'
 *   },
 * });
 */
export function useRetryWebhookEndpointDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<RetryWebhookEndpointDeliveryMutation, RetryWebhookEndpointDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryWebhookEndpointDeliveryMutation, RetryWebhookEndpointDeliveryMutationVariables>(RetryWebhookEndpointDeliveryDocument, options);
      }
export type RetryWebhookEndpointDeliveryMutationHookResult = ReturnType<typeof useRetryWebhookEndpointDeliveryMutation>;
export type RetryWebhookEndpointDeliveryMutationResult = Apollo.MutationResult<RetryWebhookEndpointDeliveryMutation>;
export type RetryWebhookEndpointDeliveryMutationOptions = Apollo.BaseMutationOptions<RetryWebhookEndpointDeliveryMutation, RetryWebhookEndpointDeliveryMutationVariables>;
export const RotateWebhookEndpointSecretDocument = gql`
    mutation RotateWebhookEndpointSecret($organizationId: String!, $connectorId: String!, $webhookEndpointId: String!) {
  rotateWebhookEndpointSecret(
    organizationId: $organizationId
    connectorId: $connectorId
    webhookEndpointId: $webhookEndpointId
  )
}
    `;
export type RotateWebhookEndpointSecretMutationFn = Apollo.MutationFunction<RotateWebhookEndpointSecretMutation, RotateWebhookEndpointSecretMutationVariables>;

/**
 * __useRotateWebhookEndpointSecretMutation__
 *
 * To run a mutation, you first call `useRotateWebhookEndpointSecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRotateWebhookEndpointSecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rotateWebhookEndpointSecretMutation, { data, loading, error }] = useRotateWebhookEndpointSecretMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      connectorId: // value for 'connectorId'
 *      webhookEndpointId: // value for 'webhookEndpointId'
 *   },
 * });
 */
export function useRotateWebhookEndpointSecretMutation(baseOptions?: Apollo.MutationHookOptions<RotateWebhookEndpointSecretMutation, RotateWebhookEndpointSecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RotateWebhookEndpointSecretMutation, RotateWebhookEndpointSecretMutationVariables>(RotateWebhookEndpointSecretDocument, options);
      }
export type RotateWebhookEndpointSecretMutationHookResult = ReturnType<typeof useRotateWebhookEndpointSecretMutation>;
export type RotateWebhookEndpointSecretMutationResult = Apollo.MutationResult<RotateWebhookEndpointSecretMutation>;
export type RotateWebhookEndpointSecretMutationOptions = Apollo.BaseMutationOptions<RotateWebhookEndpointSecretMutation, RotateWebhookEndpointSecretMutationVariables>;
export const SendWebhookEndpointTestEventDocument = gql`
    mutation SendWebhookEndpointTestEvent($organizationId: String!, $connectorId: String!, $webhookEndpointId: String!) {
  sendWebhookEndpointTestEvent(
    organizationId: $organizationId
    connectorId: $connectorId
    webhookEndpointId: $webhookEndpointId
  )
}
    `;
export type SendWebhookEndpointTestEventMutationFn = Apollo.MutationFunction<SendWebhookEndpointTestEventMutation, SendWebhookEndpointTestEventMutationVariables>;

/**
 * __useSendWebhookEndpointTestEventMutation__
 *
 * To run a mutation, you first call `useSendWebhookEndpointTestEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendWebhookEndpointTestEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendWebhookEndpointTestEventMutation, { data, loading, error }] = useSendWebhookEndpointTestEventMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      connectorId: // value for 'connectorId'
 *      webhookEndpointId: // value for 'webhookEndpointId'
 *   },
 * });
 */
export function useSendWebhookEndpointTestEventMutation(baseOptions?: Apollo.MutationHookOptions<SendWebhookEndpointTestEventMutation, SendWebhookEndpointTestEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendWebhookEndpointTestEventMutation, SendWebhookEndpointTestEventMutationVariables>(SendWebhookEndpointTestEventDocument, options);
      }
export type SendWebhookEndpointTestEventMutationHookResult = ReturnType<typeof useSendWebhookEndpointTestEventMutation>;
export type SendWebhookEndpointTestEventMutationResult = Apollo.MutationResult<SendWebhookEndpointTestEventMutation>;
export type SendWebhookEndpointTestEventMutationOptions = Apollo.BaseMutationOptions<SendWebhookEndpointTestEventMutation, SendWebhookEndpointTestEventMutationVariables>;
export const SyncConnectionDocument = gql`
    mutation SyncConnection($legalEntityId: String!, $connectionId: String!) {
  syncConnection(legalEntityId: $legalEntityId, connectionId: $connectionId)
}
    `;
export type SyncConnectionMutationFn = Apollo.MutationFunction<SyncConnectionMutation, SyncConnectionMutationVariables>;

/**
 * __useSyncConnectionMutation__
 *
 * To run a mutation, you first call `useSyncConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncConnectionMutation, { data, loading, error }] = useSyncConnectionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useSyncConnectionMutation(baseOptions?: Apollo.MutationHookOptions<SyncConnectionMutation, SyncConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncConnectionMutation, SyncConnectionMutationVariables>(SyncConnectionDocument, options);
      }
export type SyncConnectionMutationHookResult = ReturnType<typeof useSyncConnectionMutation>;
export type SyncConnectionMutationResult = Apollo.MutationResult<SyncConnectionMutation>;
export type SyncConnectionMutationOptions = Apollo.BaseMutationOptions<SyncConnectionMutation, SyncConnectionMutationVariables>;
export const UpdateAppDocument = gql`
    mutation UpdateApp($organizationId: String!, $connectorId: String!, $name: String, $tagline: String!, $description: String, $homepageUrl: String, $supportEmail: String, $developerEmail: String, $iconBase64: String, $privacyPolicyURL: String, $termsOfServiceURL: String, $scopes: [String!], $redirectUris: [String!], $installUri: String) {
  updateApp(
    organizationId: $organizationId
    connectorId: $connectorId
    name: $name
    tagline: $tagline
    description: $description
    homepageUrl: $homepageUrl
    supportEmail: $supportEmail
    developerEmail: $developerEmail
    iconBase64: $iconBase64
    privacyPolicyUrl: $privacyPolicyURL
    termsOfServiceUrl: $termsOfServiceURL
    scopes: $scopes
    redirectUris: $redirectUris
    installUri: $installUri
  )
}
    `;
export type UpdateAppMutationFn = Apollo.MutationFunction<UpdateAppMutation, UpdateAppMutationVariables>;

/**
 * __useUpdateAppMutation__
 *
 * To run a mutation, you first call `useUpdateAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppMutation, { data, loading, error }] = useUpdateAppMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      connectorId: // value for 'connectorId'
 *      name: // value for 'name'
 *      tagline: // value for 'tagline'
 *      description: // value for 'description'
 *      homepageUrl: // value for 'homepageUrl'
 *      supportEmail: // value for 'supportEmail'
 *      developerEmail: // value for 'developerEmail'
 *      iconBase64: // value for 'iconBase64'
 *      privacyPolicyURL: // value for 'privacyPolicyURL'
 *      termsOfServiceURL: // value for 'termsOfServiceURL'
 *      scopes: // value for 'scopes'
 *      redirectUris: // value for 'redirectUris'
 *      installUri: // value for 'installUri'
 *   },
 * });
 */
export function useUpdateAppMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppMutation, UpdateAppMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppMutation, UpdateAppMutationVariables>(UpdateAppDocument, options);
      }
export type UpdateAppMutationHookResult = ReturnType<typeof useUpdateAppMutation>;
export type UpdateAppMutationResult = Apollo.MutationResult<UpdateAppMutation>;
export type UpdateAppMutationOptions = Apollo.BaseMutationOptions<UpdateAppMutation, UpdateAppMutationVariables>;
export const UpdateConnectPlaidLinkTokenDocument = gql`
    mutation UpdateConnectPlaidLinkToken($legalEntityId: String!, $connectionId: String!) {
  updateConnectPlaidLinkToken(
    legalEntityId: $legalEntityId
    connectionId: $connectionId
  ) {
    token
  }
}
    `;
export type UpdateConnectPlaidLinkTokenMutationFn = Apollo.MutationFunction<UpdateConnectPlaidLinkTokenMutation, UpdateConnectPlaidLinkTokenMutationVariables>;

/**
 * __useUpdateConnectPlaidLinkTokenMutation__
 *
 * To run a mutation, you first call `useUpdateConnectPlaidLinkTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectPlaidLinkTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConnectPlaidLinkTokenMutation, { data, loading, error }] = useUpdateConnectPlaidLinkTokenMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useUpdateConnectPlaidLinkTokenMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConnectPlaidLinkTokenMutation, UpdateConnectPlaidLinkTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConnectPlaidLinkTokenMutation, UpdateConnectPlaidLinkTokenMutationVariables>(UpdateConnectPlaidLinkTokenDocument, options);
      }
export type UpdateConnectPlaidLinkTokenMutationHookResult = ReturnType<typeof useUpdateConnectPlaidLinkTokenMutation>;
export type UpdateConnectPlaidLinkTokenMutationResult = Apollo.MutationResult<UpdateConnectPlaidLinkTokenMutation>;
export type UpdateConnectPlaidLinkTokenMutationOptions = Apollo.BaseMutationOptions<UpdateConnectPlaidLinkTokenMutation, UpdateConnectPlaidLinkTokenMutationVariables>;
export const UpdateConnectionDocument = gql`
    mutation UpdateConnection($legalEntityId: String!, $connectionId: String!, $settings: ConnectionSettingsInput!) {
  updateConnection(
    legalEntityId: $legalEntityId
    connectionId: $connectionId
    settings: $settings
  )
}
    `;
export type UpdateConnectionMutationFn = Apollo.MutationFunction<UpdateConnectionMutation, UpdateConnectionMutationVariables>;

/**
 * __useUpdateConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConnectionMutation, { data, loading, error }] = useUpdateConnectionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectionId: // value for 'connectionId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConnectionMutation, UpdateConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConnectionMutation, UpdateConnectionMutationVariables>(UpdateConnectionDocument, options);
      }
export type UpdateConnectionMutationHookResult = ReturnType<typeof useUpdateConnectionMutation>;
export type UpdateConnectionMutationResult = Apollo.MutationResult<UpdateConnectionMutation>;
export type UpdateConnectionMutationOptions = Apollo.BaseMutationOptions<UpdateConnectionMutation, UpdateConnectionMutationVariables>;
export const UpdateConnectionAccountsDocument = gql`
    mutation UpdateConnectionAccounts($legalEntityId: String!, $connectionId: String!, $accounts: [ConnectionAccountInput!]!) {
  updateConnectionAccounts(
    legalEntityId: $legalEntityId
    connectionId: $connectionId
    accounts: $accounts
  )
}
    `;
export type UpdateConnectionAccountsMutationFn = Apollo.MutationFunction<UpdateConnectionAccountsMutation, UpdateConnectionAccountsMutationVariables>;

/**
 * __useUpdateConnectionAccountsMutation__
 *
 * To run a mutation, you first call `useUpdateConnectionAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectionAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConnectionAccountsMutation, { data, loading, error }] = useUpdateConnectionAccountsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectionId: // value for 'connectionId'
 *      accounts: // value for 'accounts'
 *   },
 * });
 */
export function useUpdateConnectionAccountsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConnectionAccountsMutation, UpdateConnectionAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConnectionAccountsMutation, UpdateConnectionAccountsMutationVariables>(UpdateConnectionAccountsDocument, options);
      }
export type UpdateConnectionAccountsMutationHookResult = ReturnType<typeof useUpdateConnectionAccountsMutation>;
export type UpdateConnectionAccountsMutationResult = Apollo.MutationResult<UpdateConnectionAccountsMutation>;
export type UpdateConnectionAccountsMutationOptions = Apollo.BaseMutationOptions<UpdateConnectionAccountsMutation, UpdateConnectionAccountsMutationVariables>;
export const UpdateConnectionCutoverTimeDocument = gql`
    mutation UpdateConnectionCutoverTime($legalEntityId: String!, $connectionId: String!, $cutoverTime: DateTime!) {
  updateConnectionCutoverTime(
    legalEntityId: $legalEntityId
    connectionId: $connectionId
    cutoverTime: $cutoverTime
  )
}
    `;
export type UpdateConnectionCutoverTimeMutationFn = Apollo.MutationFunction<UpdateConnectionCutoverTimeMutation, UpdateConnectionCutoverTimeMutationVariables>;

/**
 * __useUpdateConnectionCutoverTimeMutation__
 *
 * To run a mutation, you first call `useUpdateConnectionCutoverTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConnectionCutoverTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConnectionCutoverTimeMutation, { data, loading, error }] = useUpdateConnectionCutoverTimeMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectionId: // value for 'connectionId'
 *      cutoverTime: // value for 'cutoverTime'
 *   },
 * });
 */
export function useUpdateConnectionCutoverTimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConnectionCutoverTimeMutation, UpdateConnectionCutoverTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConnectionCutoverTimeMutation, UpdateConnectionCutoverTimeMutationVariables>(UpdateConnectionCutoverTimeDocument, options);
      }
export type UpdateConnectionCutoverTimeMutationHookResult = ReturnType<typeof useUpdateConnectionCutoverTimeMutation>;
export type UpdateConnectionCutoverTimeMutationResult = Apollo.MutationResult<UpdateConnectionCutoverTimeMutation>;
export type UpdateConnectionCutoverTimeMutationOptions = Apollo.BaseMutationOptions<UpdateConnectionCutoverTimeMutation, UpdateConnectionCutoverTimeMutationVariables>;
export const UpdateFinchConnectionDocument = gql`
    mutation UpdateFinchConnection($legalEntityId: String!, $connectionId: String!, $authorizationCode: String!) {
  updateFinchConnection(
    legalEntityId: $legalEntityId
    connectionId: $connectionId
    authorizationCode: $authorizationCode
  ) {
    ...CreateConnectionResponseFields
  }
}
    ${CreateConnectionResponseFieldsFragmentDoc}`;
export type UpdateFinchConnectionMutationFn = Apollo.MutationFunction<UpdateFinchConnectionMutation, UpdateFinchConnectionMutationVariables>;

/**
 * __useUpdateFinchConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateFinchConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinchConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinchConnectionMutation, { data, loading, error }] = useUpdateFinchConnectionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectionId: // value for 'connectionId'
 *      authorizationCode: // value for 'authorizationCode'
 *   },
 * });
 */
export function useUpdateFinchConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFinchConnectionMutation, UpdateFinchConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFinchConnectionMutation, UpdateFinchConnectionMutationVariables>(UpdateFinchConnectionDocument, options);
      }
export type UpdateFinchConnectionMutationHookResult = ReturnType<typeof useUpdateFinchConnectionMutation>;
export type UpdateFinchConnectionMutationResult = Apollo.MutationResult<UpdateFinchConnectionMutation>;
export type UpdateFinchConnectionMutationOptions = Apollo.BaseMutationOptions<UpdateFinchConnectionMutation, UpdateFinchConnectionMutationVariables>;
export const UpdatePlaidConnectionDocument = gql`
    mutation UpdatePlaidConnection($legalEntityId: String!, $connectionId: String!, $accounts: [PlaidAccount!]!) {
  updatePlaidConnection(
    legalEntityId: $legalEntityId
    connectionId: $connectionId
    accounts: $accounts
  )
}
    `;
export type UpdatePlaidConnectionMutationFn = Apollo.MutationFunction<UpdatePlaidConnectionMutation, UpdatePlaidConnectionMutationVariables>;

/**
 * __useUpdatePlaidConnectionMutation__
 *
 * To run a mutation, you first call `useUpdatePlaidConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaidConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaidConnectionMutation, { data, loading, error }] = useUpdatePlaidConnectionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectionId: // value for 'connectionId'
 *      accounts: // value for 'accounts'
 *   },
 * });
 */
export function useUpdatePlaidConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlaidConnectionMutation, UpdatePlaidConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlaidConnectionMutation, UpdatePlaidConnectionMutationVariables>(UpdatePlaidConnectionDocument, options);
      }
export type UpdatePlaidConnectionMutationHookResult = ReturnType<typeof useUpdatePlaidConnectionMutation>;
export type UpdatePlaidConnectionMutationResult = Apollo.MutationResult<UpdatePlaidConnectionMutation>;
export type UpdatePlaidConnectionMutationOptions = Apollo.BaseMutationOptions<UpdatePlaidConnectionMutation, UpdatePlaidConnectionMutationVariables>;
export const UpdateWebhookEndpointDocument = gql`
    mutation UpdateWebhookEndpoint($organizationId: String!, $connectorId: String!, $webhookEndpointId: String!, $endpointUrl: String!, $eventCategories: [WebhookEventCategory!]!) {
  updateWebhookEndpoint(
    organizationId: $organizationId
    connectorId: $connectorId
    webhookEndpointId: $webhookEndpointId
    endpointUrl: $endpointUrl
    eventCategories: $eventCategories
  ) {
    ...WebhookEndpointFields
  }
}
    ${WebhookEndpointFieldsFragmentDoc}`;
export type UpdateWebhookEndpointMutationFn = Apollo.MutationFunction<UpdateWebhookEndpointMutation, UpdateWebhookEndpointMutationVariables>;

/**
 * __useUpdateWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useUpdateWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebhookEndpointMutation, { data, loading, error }] = useUpdateWebhookEndpointMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      connectorId: // value for 'connectorId'
 *      webhookEndpointId: // value for 'webhookEndpointId'
 *      endpointUrl: // value for 'endpointUrl'
 *      eventCategories: // value for 'eventCategories'
 *   },
 * });
 */
export function useUpdateWebhookEndpointMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebhookEndpointMutation, UpdateWebhookEndpointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebhookEndpointMutation, UpdateWebhookEndpointMutationVariables>(UpdateWebhookEndpointDocument, options);
      }
export type UpdateWebhookEndpointMutationHookResult = ReturnType<typeof useUpdateWebhookEndpointMutation>;
export type UpdateWebhookEndpointMutationResult = Apollo.MutationResult<UpdateWebhookEndpointMutation>;
export type UpdateWebhookEndpointMutationOptions = Apollo.BaseMutationOptions<UpdateWebhookEndpointMutation, UpdateWebhookEndpointMutationVariables>;
export const UpdateWebhookEndpointOAuthCredentialDocument = gql`
    mutation UpdateWebhookEndpointOAuthCredential($organizationId: String!, $connectorId: String!, $webhookEndpointId: String!, $oauthClientCredentials: WebhookEndpointOAuthClientCredentialsInput) {
  updateWebhookEndpointOAuthCredential(
    organizationId: $organizationId
    connectorId: $connectorId
    webhookEndpointId: $webhookEndpointId
    oauthClientCredentials: $oauthClientCredentials
  ) {
    ...WebhookEndpointFields
  }
}
    ${WebhookEndpointFieldsFragmentDoc}`;
export type UpdateWebhookEndpointOAuthCredentialMutationFn = Apollo.MutationFunction<UpdateWebhookEndpointOAuthCredentialMutation, UpdateWebhookEndpointOAuthCredentialMutationVariables>;

/**
 * __useUpdateWebhookEndpointOAuthCredentialMutation__
 *
 * To run a mutation, you first call `useUpdateWebhookEndpointOAuthCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebhookEndpointOAuthCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebhookEndpointOAuthCredentialMutation, { data, loading, error }] = useUpdateWebhookEndpointOAuthCredentialMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      connectorId: // value for 'connectorId'
 *      webhookEndpointId: // value for 'webhookEndpointId'
 *      oauthClientCredentials: // value for 'oauthClientCredentials'
 *   },
 * });
 */
export function useUpdateWebhookEndpointOAuthCredentialMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebhookEndpointOAuthCredentialMutation, UpdateWebhookEndpointOAuthCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebhookEndpointOAuthCredentialMutation, UpdateWebhookEndpointOAuthCredentialMutationVariables>(UpdateWebhookEndpointOAuthCredentialDocument, options);
      }
export type UpdateWebhookEndpointOAuthCredentialMutationHookResult = ReturnType<typeof useUpdateWebhookEndpointOAuthCredentialMutation>;
export type UpdateWebhookEndpointOAuthCredentialMutationResult = Apollo.MutationResult<UpdateWebhookEndpointOAuthCredentialMutation>;
export type UpdateWebhookEndpointOAuthCredentialMutationOptions = Apollo.BaseMutationOptions<UpdateWebhookEndpointOAuthCredentialMutation, UpdateWebhookEndpointOAuthCredentialMutationVariables>;
export const UpgradeGustoConnectionDocument = gql`
    mutation UpgradeGustoConnection($legalEntityId: String!, $connectionId: String!, $authorizationCode: String!) {
  upgradeGustoConnection(
    legalEntityId: $legalEntityId
    connectionId: $connectionId
    authorizationCode: $authorizationCode
  ) {
    ...UpgradeConnectionResponseFields
  }
}
    ${UpgradeConnectionResponseFieldsFragmentDoc}`;
export type UpgradeGustoConnectionMutationFn = Apollo.MutationFunction<UpgradeGustoConnectionMutation, UpgradeGustoConnectionMutationVariables>;

/**
 * __useUpgradeGustoConnectionMutation__
 *
 * To run a mutation, you first call `useUpgradeGustoConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeGustoConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeGustoConnectionMutation, { data, loading, error }] = useUpgradeGustoConnectionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectionId: // value for 'connectionId'
 *      authorizationCode: // value for 'authorizationCode'
 *   },
 * });
 */
export function useUpgradeGustoConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeGustoConnectionMutation, UpgradeGustoConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeGustoConnectionMutation, UpgradeGustoConnectionMutationVariables>(UpgradeGustoConnectionDocument, options);
      }
export type UpgradeGustoConnectionMutationHookResult = ReturnType<typeof useUpgradeGustoConnectionMutation>;
export type UpgradeGustoConnectionMutationResult = Apollo.MutationResult<UpgradeGustoConnectionMutation>;
export type UpgradeGustoConnectionMutationOptions = Apollo.BaseMutationOptions<UpgradeGustoConnectionMutation, UpgradeGustoConnectionMutationVariables>;
export const UpgradeStripeConnectionDocument = gql`
    mutation UpgradeStripeConnection($legalEntityId: String!, $connectionId: String!, $externalId: String!) {
  upgradeStripeConnection(
    legalEntityId: $legalEntityId
    connectionId: $connectionId
    externalId: $externalId
  ) {
    ...UpgradeConnectionResponseFields
  }
}
    ${UpgradeConnectionResponseFieldsFragmentDoc}`;
export type UpgradeStripeConnectionMutationFn = Apollo.MutationFunction<UpgradeStripeConnectionMutation, UpgradeStripeConnectionMutationVariables>;

/**
 * __useUpgradeStripeConnectionMutation__
 *
 * To run a mutation, you first call `useUpgradeStripeConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeStripeConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeStripeConnectionMutation, { data, loading, error }] = useUpgradeStripeConnectionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectionId: // value for 'connectionId'
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useUpgradeStripeConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeStripeConnectionMutation, UpgradeStripeConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeStripeConnectionMutation, UpgradeStripeConnectionMutationVariables>(UpgradeStripeConnectionDocument, options);
      }
export type UpgradeStripeConnectionMutationHookResult = ReturnType<typeof useUpgradeStripeConnectionMutation>;
export type UpgradeStripeConnectionMutationResult = Apollo.MutationResult<UpgradeStripeConnectionMutation>;
export type UpgradeStripeConnectionMutationOptions = Apollo.BaseMutationOptions<UpgradeStripeConnectionMutation, UpgradeStripeConnectionMutationVariables>;
export const FindConnectionsByInstitutionDocument = gql`
    query FindConnectionsByInstitution($legalEntityId: String!, $institutionName: String!) {
  findConnectionsByInstitution(
    legalEntityId: $legalEntityId
    institutionName: $institutionName
  ) {
    ...ConnectionSummaryFields
  }
}
    ${ConnectionSummaryFieldsFragmentDoc}`;

/**
 * __useFindConnectionsByInstitutionQuery__
 *
 * To run a query within a React component, call `useFindConnectionsByInstitutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindConnectionsByInstitutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindConnectionsByInstitutionQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      institutionName: // value for 'institutionName'
 *   },
 * });
 */
export function useFindConnectionsByInstitutionQuery(baseOptions: Apollo.QueryHookOptions<FindConnectionsByInstitutionQuery, FindConnectionsByInstitutionQueryVariables> & ({ variables: FindConnectionsByInstitutionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindConnectionsByInstitutionQuery, FindConnectionsByInstitutionQueryVariables>(FindConnectionsByInstitutionDocument, options);
      }
export function useFindConnectionsByInstitutionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindConnectionsByInstitutionQuery, FindConnectionsByInstitutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindConnectionsByInstitutionQuery, FindConnectionsByInstitutionQueryVariables>(FindConnectionsByInstitutionDocument, options);
        }
export function useFindConnectionsByInstitutionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindConnectionsByInstitutionQuery, FindConnectionsByInstitutionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindConnectionsByInstitutionQuery, FindConnectionsByInstitutionQueryVariables>(FindConnectionsByInstitutionDocument, options);
        }
export type FindConnectionsByInstitutionQueryHookResult = ReturnType<typeof useFindConnectionsByInstitutionQuery>;
export type FindConnectionsByInstitutionLazyQueryHookResult = ReturnType<typeof useFindConnectionsByInstitutionLazyQuery>;
export type FindConnectionsByInstitutionSuspenseQueryHookResult = ReturnType<typeof useFindConnectionsByInstitutionSuspenseQuery>;
export type FindConnectionsByInstitutionQueryResult = Apollo.QueryResult<FindConnectionsByInstitutionQuery, FindConnectionsByInstitutionQueryVariables>;
export const ListAppsDocument = gql`
    query ListApps($organizationId: String!) {
  listApps(organizationId: $organizationId) {
    ...ConnectorFields
  }
}
    ${ConnectorFieldsFragmentDoc}`;

/**
 * __useListAppsQuery__
 *
 * To run a query within a React component, call `useListAppsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAppsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAppsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListAppsQuery(baseOptions: Apollo.QueryHookOptions<ListAppsQuery, ListAppsQueryVariables> & ({ variables: ListAppsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAppsQuery, ListAppsQueryVariables>(ListAppsDocument, options);
      }
export function useListAppsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAppsQuery, ListAppsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAppsQuery, ListAppsQueryVariables>(ListAppsDocument, options);
        }
export function useListAppsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAppsQuery, ListAppsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAppsQuery, ListAppsQueryVariables>(ListAppsDocument, options);
        }
export type ListAppsQueryHookResult = ReturnType<typeof useListAppsQuery>;
export type ListAppsLazyQueryHookResult = ReturnType<typeof useListAppsLazyQuery>;
export type ListAppsSuspenseQueryHookResult = ReturnType<typeof useListAppsSuspenseQuery>;
export type ListAppsQueryResult = Apollo.QueryResult<ListAppsQuery, ListAppsQueryVariables>;
export const ListAuthConnectionsDocument = gql`
    query ListAuthConnections($legalEntityId: String!) {
  listAuthConnections(legalEntityId: $legalEntityId, useNewPaymentProvider: true) {
    ...ConnectionSummaryFields
  }
}
    ${ConnectionSummaryFieldsFragmentDoc}`;

/**
 * __useListAuthConnectionsQuery__
 *
 * To run a query within a React component, call `useListAuthConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAuthConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAuthConnectionsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListAuthConnectionsQuery(baseOptions: Apollo.QueryHookOptions<ListAuthConnectionsQuery, ListAuthConnectionsQueryVariables> & ({ variables: ListAuthConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAuthConnectionsQuery, ListAuthConnectionsQueryVariables>(ListAuthConnectionsDocument, options);
      }
export function useListAuthConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAuthConnectionsQuery, ListAuthConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAuthConnectionsQuery, ListAuthConnectionsQueryVariables>(ListAuthConnectionsDocument, options);
        }
export function useListAuthConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAuthConnectionsQuery, ListAuthConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAuthConnectionsQuery, ListAuthConnectionsQueryVariables>(ListAuthConnectionsDocument, options);
        }
export type ListAuthConnectionsQueryHookResult = ReturnType<typeof useListAuthConnectionsQuery>;
export type ListAuthConnectionsLazyQueryHookResult = ReturnType<typeof useListAuthConnectionsLazyQuery>;
export type ListAuthConnectionsSuspenseQueryHookResult = ReturnType<typeof useListAuthConnectionsSuspenseQuery>;
export type ListAuthConnectionsQueryResult = Apollo.QueryResult<ListAuthConnectionsQuery, ListAuthConnectionsQueryVariables>;
export const ListConnectionsDocument = gql`
    query ListConnections($legalEntityId: String!, $filter: ListConnectionsFilter) {
  listConnections(legalEntityId: $legalEntityId, filter: $filter) {
    ...ConnectionSummaryFields
  }
}
    ${ConnectionSummaryFieldsFragmentDoc}`;

/**
 * __useListConnectionsQuery__
 *
 * To run a query within a React component, call `useListConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConnectionsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListConnectionsQuery(baseOptions: Apollo.QueryHookOptions<ListConnectionsQuery, ListConnectionsQueryVariables> & ({ variables: ListConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConnectionsQuery, ListConnectionsQueryVariables>(ListConnectionsDocument, options);
      }
export function useListConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConnectionsQuery, ListConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConnectionsQuery, ListConnectionsQueryVariables>(ListConnectionsDocument, options);
        }
export function useListConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConnectionsQuery, ListConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListConnectionsQuery, ListConnectionsQueryVariables>(ListConnectionsDocument, options);
        }
export type ListConnectionsQueryHookResult = ReturnType<typeof useListConnectionsQuery>;
export type ListConnectionsLazyQueryHookResult = ReturnType<typeof useListConnectionsLazyQuery>;
export type ListConnectionsSuspenseQueryHookResult = ReturnType<typeof useListConnectionsSuspenseQuery>;
export type ListConnectionsQueryResult = Apollo.QueryResult<ListConnectionsQuery, ListConnectionsQueryVariables>;
export const ListConnectorInstallCandidatesDocument = gql`
    query ListConnectorInstallCandidates($legalEntityId: String!) {
  listConnectorInstallCandidates(legalEntityId: $legalEntityId) {
    templates {
      ...ConnectorTemplateFields
    }
    appConnectors {
      ...ConnectorFields
    }
  }
}
    ${ConnectorTemplateFieldsFragmentDoc}
${ConnectorFieldsFragmentDoc}`;

/**
 * __useListConnectorInstallCandidatesQuery__
 *
 * To run a query within a React component, call `useListConnectorInstallCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConnectorInstallCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConnectorInstallCandidatesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListConnectorInstallCandidatesQuery(baseOptions: Apollo.QueryHookOptions<ListConnectorInstallCandidatesQuery, ListConnectorInstallCandidatesQueryVariables> & ({ variables: ListConnectorInstallCandidatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConnectorInstallCandidatesQuery, ListConnectorInstallCandidatesQueryVariables>(ListConnectorInstallCandidatesDocument, options);
      }
export function useListConnectorInstallCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConnectorInstallCandidatesQuery, ListConnectorInstallCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConnectorInstallCandidatesQuery, ListConnectorInstallCandidatesQueryVariables>(ListConnectorInstallCandidatesDocument, options);
        }
export function useListConnectorInstallCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConnectorInstallCandidatesQuery, ListConnectorInstallCandidatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListConnectorInstallCandidatesQuery, ListConnectorInstallCandidatesQueryVariables>(ListConnectorInstallCandidatesDocument, options);
        }
export type ListConnectorInstallCandidatesQueryHookResult = ReturnType<typeof useListConnectorInstallCandidatesQuery>;
export type ListConnectorInstallCandidatesLazyQueryHookResult = ReturnType<typeof useListConnectorInstallCandidatesLazyQuery>;
export type ListConnectorInstallCandidatesSuspenseQueryHookResult = ReturnType<typeof useListConnectorInstallCandidatesSuspenseQuery>;
export type ListConnectorInstallCandidatesQueryResult = Apollo.QueryResult<ListConnectorInstallCandidatesQuery, ListConnectorInstallCandidatesQueryVariables>;
export const ListConnectorTemplatesDocument = gql`
    query ListConnectorTemplates($legalEntityId: String!) {
  listConnectorTemplates(legalEntityId: $legalEntityId) {
    ...ConnectorTemplateFields
  }
}
    ${ConnectorTemplateFieldsFragmentDoc}`;

/**
 * __useListConnectorTemplatesQuery__
 *
 * To run a query within a React component, call `useListConnectorTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConnectorTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConnectorTemplatesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListConnectorTemplatesQuery(baseOptions: Apollo.QueryHookOptions<ListConnectorTemplatesQuery, ListConnectorTemplatesQueryVariables> & ({ variables: ListConnectorTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConnectorTemplatesQuery, ListConnectorTemplatesQueryVariables>(ListConnectorTemplatesDocument, options);
      }
export function useListConnectorTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConnectorTemplatesQuery, ListConnectorTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConnectorTemplatesQuery, ListConnectorTemplatesQueryVariables>(ListConnectorTemplatesDocument, options);
        }
export function useListConnectorTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConnectorTemplatesQuery, ListConnectorTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListConnectorTemplatesQuery, ListConnectorTemplatesQueryVariables>(ListConnectorTemplatesDocument, options);
        }
export type ListConnectorTemplatesQueryHookResult = ReturnType<typeof useListConnectorTemplatesQuery>;
export type ListConnectorTemplatesLazyQueryHookResult = ReturnType<typeof useListConnectorTemplatesLazyQuery>;
export type ListConnectorTemplatesSuspenseQueryHookResult = ReturnType<typeof useListConnectorTemplatesSuspenseQuery>;
export type ListConnectorTemplatesQueryResult = Apollo.QueryResult<ListConnectorTemplatesQuery, ListConnectorTemplatesQueryVariables>;
export const ListConnectorsDocument = gql`
    query ListConnectors($legalEntityId: String!) {
  listConnectors(legalEntityId: $legalEntityId) {
    ...ConnectorFields
  }
}
    ${ConnectorFieldsFragmentDoc}`;

/**
 * __useListConnectorsQuery__
 *
 * To run a query within a React component, call `useListConnectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConnectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConnectorsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListConnectorsQuery(baseOptions: Apollo.QueryHookOptions<ListConnectorsQuery, ListConnectorsQueryVariables> & ({ variables: ListConnectorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConnectorsQuery, ListConnectorsQueryVariables>(ListConnectorsDocument, options);
      }
export function useListConnectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConnectorsQuery, ListConnectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConnectorsQuery, ListConnectorsQueryVariables>(ListConnectorsDocument, options);
        }
export function useListConnectorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConnectorsQuery, ListConnectorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListConnectorsQuery, ListConnectorsQueryVariables>(ListConnectorsDocument, options);
        }
export type ListConnectorsQueryHookResult = ReturnType<typeof useListConnectorsQuery>;
export type ListConnectorsLazyQueryHookResult = ReturnType<typeof useListConnectorsLazyQuery>;
export type ListConnectorsSuspenseQueryHookResult = ReturnType<typeof useListConnectorsSuspenseQuery>;
export type ListConnectorsQueryResult = Apollo.QueryResult<ListConnectorsQuery, ListConnectorsQueryVariables>;
export const ListPaymentConnectorsDocument = gql`
    query ListPaymentConnectors($legalEntityId: String!) {
  listConnectors(legalEntityId: $legalEntityId) {
    ...ConnectorFields
  }
}
    ${ConnectorFieldsFragmentDoc}`;

/**
 * __useListPaymentConnectorsQuery__
 *
 * To run a query within a React component, call `useListPaymentConnectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPaymentConnectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPaymentConnectorsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListPaymentConnectorsQuery(baseOptions: Apollo.QueryHookOptions<ListPaymentConnectorsQuery, ListPaymentConnectorsQueryVariables> & ({ variables: ListPaymentConnectorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPaymentConnectorsQuery, ListPaymentConnectorsQueryVariables>(ListPaymentConnectorsDocument, options);
      }
export function useListPaymentConnectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPaymentConnectorsQuery, ListPaymentConnectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPaymentConnectorsQuery, ListPaymentConnectorsQueryVariables>(ListPaymentConnectorsDocument, options);
        }
export function useListPaymentConnectorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPaymentConnectorsQuery, ListPaymentConnectorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPaymentConnectorsQuery, ListPaymentConnectorsQueryVariables>(ListPaymentConnectorsDocument, options);
        }
export type ListPaymentConnectorsQueryHookResult = ReturnType<typeof useListPaymentConnectorsQuery>;
export type ListPaymentConnectorsLazyQueryHookResult = ReturnType<typeof useListPaymentConnectorsLazyQuery>;
export type ListPaymentConnectorsSuspenseQueryHookResult = ReturnType<typeof useListPaymentConnectorsSuspenseQuery>;
export type ListPaymentConnectorsQueryResult = Apollo.QueryResult<ListPaymentConnectorsQuery, ListPaymentConnectorsQueryVariables>;
export const ListWebhookEndpointDeliveryEventsDocument = gql`
    query ListWebhookEndpointDeliveryEvents($organizationId: String!, $connectorId: String!, $webhookEndpointId: String!, $pagination: Pagination!) {
  listWebhookEndpointDeliveryEvents(
    organizationId: $organizationId
    connectorId: $connectorId
    webhookEndpointId: $webhookEndpointId
    pagination: $pagination
  ) {
    ...WebhookDeliveryEventFields
  }
}
    ${WebhookDeliveryEventFieldsFragmentDoc}`;

/**
 * __useListWebhookEndpointDeliveryEventsQuery__
 *
 * To run a query within a React component, call `useListWebhookEndpointDeliveryEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWebhookEndpointDeliveryEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWebhookEndpointDeliveryEventsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      connectorId: // value for 'connectorId'
 *      webhookEndpointId: // value for 'webhookEndpointId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useListWebhookEndpointDeliveryEventsQuery(baseOptions: Apollo.QueryHookOptions<ListWebhookEndpointDeliveryEventsQuery, ListWebhookEndpointDeliveryEventsQueryVariables> & ({ variables: ListWebhookEndpointDeliveryEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWebhookEndpointDeliveryEventsQuery, ListWebhookEndpointDeliveryEventsQueryVariables>(ListWebhookEndpointDeliveryEventsDocument, options);
      }
export function useListWebhookEndpointDeliveryEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWebhookEndpointDeliveryEventsQuery, ListWebhookEndpointDeliveryEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWebhookEndpointDeliveryEventsQuery, ListWebhookEndpointDeliveryEventsQueryVariables>(ListWebhookEndpointDeliveryEventsDocument, options);
        }
export function useListWebhookEndpointDeliveryEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWebhookEndpointDeliveryEventsQuery, ListWebhookEndpointDeliveryEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWebhookEndpointDeliveryEventsQuery, ListWebhookEndpointDeliveryEventsQueryVariables>(ListWebhookEndpointDeliveryEventsDocument, options);
        }
export type ListWebhookEndpointDeliveryEventsQueryHookResult = ReturnType<typeof useListWebhookEndpointDeliveryEventsQuery>;
export type ListWebhookEndpointDeliveryEventsLazyQueryHookResult = ReturnType<typeof useListWebhookEndpointDeliveryEventsLazyQuery>;
export type ListWebhookEndpointDeliveryEventsSuspenseQueryHookResult = ReturnType<typeof useListWebhookEndpointDeliveryEventsSuspenseQuery>;
export type ListWebhookEndpointDeliveryEventsQueryResult = Apollo.QueryResult<ListWebhookEndpointDeliveryEventsQuery, ListWebhookEndpointDeliveryEventsQueryVariables>;
export const ListWebhookEndpointsDocument = gql`
    query ListWebhookEndpoints($organizationId: String!, $connectorId: String!) {
  listWebhookEndpoints(organizationId: $organizationId, connectorId: $connectorId) {
    ...WebhookEndpointFields
  }
}
    ${WebhookEndpointFieldsFragmentDoc}`;

/**
 * __useListWebhookEndpointsQuery__
 *
 * To run a query within a React component, call `useListWebhookEndpointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWebhookEndpointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWebhookEndpointsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useListWebhookEndpointsQuery(baseOptions: Apollo.QueryHookOptions<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables> & ({ variables: ListWebhookEndpointsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>(ListWebhookEndpointsDocument, options);
      }
export function useListWebhookEndpointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>(ListWebhookEndpointsDocument, options);
        }
export function useListWebhookEndpointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>(ListWebhookEndpointsDocument, options);
        }
export type ListWebhookEndpointsQueryHookResult = ReturnType<typeof useListWebhookEndpointsQuery>;
export type ListWebhookEndpointsLazyQueryHookResult = ReturnType<typeof useListWebhookEndpointsLazyQuery>;
export type ListWebhookEndpointsSuspenseQueryHookResult = ReturnType<typeof useListWebhookEndpointsSuspenseQuery>;
export type ListWebhookEndpointsQueryResult = Apollo.QueryResult<ListWebhookEndpointsQuery, ListWebhookEndpointsQueryVariables>;
export const OnboardConnectionsDocument = gql`
    query OnboardConnections($legalEntityId: String!, $institutionProducts: [InstitutionProduct!]!) {
  onboardConnections(
    legalEntityId: $legalEntityId
    institutionProducts: $institutionProducts
  ) {
    ...SuggestedConnectionFields
  }
}
    ${SuggestedConnectionFieldsFragmentDoc}`;

/**
 * __useOnboardConnectionsQuery__
 *
 * To run a query within a React component, call `useOnboardConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardConnectionsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      institutionProducts: // value for 'institutionProducts'
 *   },
 * });
 */
export function useOnboardConnectionsQuery(baseOptions: Apollo.QueryHookOptions<OnboardConnectionsQuery, OnboardConnectionsQueryVariables> & ({ variables: OnboardConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardConnectionsQuery, OnboardConnectionsQueryVariables>(OnboardConnectionsDocument, options);
      }
export function useOnboardConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardConnectionsQuery, OnboardConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardConnectionsQuery, OnboardConnectionsQueryVariables>(OnboardConnectionsDocument, options);
        }
export function useOnboardConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OnboardConnectionsQuery, OnboardConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardConnectionsQuery, OnboardConnectionsQueryVariables>(OnboardConnectionsDocument, options);
        }
export type OnboardConnectionsQueryHookResult = ReturnType<typeof useOnboardConnectionsQuery>;
export type OnboardConnectionsLazyQueryHookResult = ReturnType<typeof useOnboardConnectionsLazyQuery>;
export type OnboardConnectionsSuspenseQueryHookResult = ReturnType<typeof useOnboardConnectionsSuspenseQuery>;
export type OnboardConnectionsQueryResult = Apollo.QueryResult<OnboardConnectionsQuery, OnboardConnectionsQueryVariables>;
export const ReadAppDocument = gql`
    query ReadApp($organizationId: String!, $connectorId: String!) {
  readApp(organizationId: $organizationId, connectorId: $connectorId) {
    ...ConnectorFields
  }
}
    ${ConnectorFieldsFragmentDoc}`;

/**
 * __useReadAppQuery__
 *
 * To run a query within a React component, call `useReadAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadAppQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadAppQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useReadAppQuery(baseOptions: Apollo.QueryHookOptions<ReadAppQuery, ReadAppQueryVariables> & ({ variables: ReadAppQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadAppQuery, ReadAppQueryVariables>(ReadAppDocument, options);
      }
export function useReadAppLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadAppQuery, ReadAppQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadAppQuery, ReadAppQueryVariables>(ReadAppDocument, options);
        }
export function useReadAppSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadAppQuery, ReadAppQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadAppQuery, ReadAppQueryVariables>(ReadAppDocument, options);
        }
export type ReadAppQueryHookResult = ReturnType<typeof useReadAppQuery>;
export type ReadAppLazyQueryHookResult = ReturnType<typeof useReadAppLazyQuery>;
export type ReadAppSuspenseQueryHookResult = ReturnType<typeof useReadAppSuspenseQuery>;
export type ReadAppQueryResult = Apollo.QueryResult<ReadAppQuery, ReadAppQueryVariables>;
export const ReadAppAuthorizationDocument = gql`
    query ReadAppAuthorization($clientId: String!, $redirectUri: String!, $responseType: String!, $scopes: [String!]!) {
  readAppAuthorization(
    clientId: $clientId
    redirectUri: $redirectUri
    responseType: $responseType
    scopes: $scopes
  ) {
    ...AppAuthorizationFields
  }
}
    ${AppAuthorizationFieldsFragmentDoc}`;

/**
 * __useReadAppAuthorizationQuery__
 *
 * To run a query within a React component, call `useReadAppAuthorizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadAppAuthorizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadAppAuthorizationQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      redirectUri: // value for 'redirectUri'
 *      responseType: // value for 'responseType'
 *      scopes: // value for 'scopes'
 *   },
 * });
 */
export function useReadAppAuthorizationQuery(baseOptions: Apollo.QueryHookOptions<ReadAppAuthorizationQuery, ReadAppAuthorizationQueryVariables> & ({ variables: ReadAppAuthorizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadAppAuthorizationQuery, ReadAppAuthorizationQueryVariables>(ReadAppAuthorizationDocument, options);
      }
export function useReadAppAuthorizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadAppAuthorizationQuery, ReadAppAuthorizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadAppAuthorizationQuery, ReadAppAuthorizationQueryVariables>(ReadAppAuthorizationDocument, options);
        }
export function useReadAppAuthorizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadAppAuthorizationQuery, ReadAppAuthorizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadAppAuthorizationQuery, ReadAppAuthorizationQueryVariables>(ReadAppAuthorizationDocument, options);
        }
export type ReadAppAuthorizationQueryHookResult = ReturnType<typeof useReadAppAuthorizationQuery>;
export type ReadAppAuthorizationLazyQueryHookResult = ReturnType<typeof useReadAppAuthorizationLazyQuery>;
export type ReadAppAuthorizationSuspenseQueryHookResult = ReturnType<typeof useReadAppAuthorizationSuspenseQuery>;
export type ReadAppAuthorizationQueryResult = Apollo.QueryResult<ReadAppAuthorizationQuery, ReadAppAuthorizationQueryVariables>;
export const ReadAppCredentialsDocument = gql`
    query ReadAppCredentials($organizationId: String!, $connectorId: String!) {
  readAppCredentials(organizationId: $organizationId, connectorId: $connectorId) {
    ...AppCredentialFields
  }
}
    ${AppCredentialFieldsFragmentDoc}`;

/**
 * __useReadAppCredentialsQuery__
 *
 * To run a query within a React component, call `useReadAppCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadAppCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadAppCredentialsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      connectorId: // value for 'connectorId'
 *   },
 * });
 */
export function useReadAppCredentialsQuery(baseOptions: Apollo.QueryHookOptions<ReadAppCredentialsQuery, ReadAppCredentialsQueryVariables> & ({ variables: ReadAppCredentialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadAppCredentialsQuery, ReadAppCredentialsQueryVariables>(ReadAppCredentialsDocument, options);
      }
export function useReadAppCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadAppCredentialsQuery, ReadAppCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadAppCredentialsQuery, ReadAppCredentialsQueryVariables>(ReadAppCredentialsDocument, options);
        }
export function useReadAppCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadAppCredentialsQuery, ReadAppCredentialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadAppCredentialsQuery, ReadAppCredentialsQueryVariables>(ReadAppCredentialsDocument, options);
        }
export type ReadAppCredentialsQueryHookResult = ReturnType<typeof useReadAppCredentialsQuery>;
export type ReadAppCredentialsLazyQueryHookResult = ReturnType<typeof useReadAppCredentialsLazyQuery>;
export type ReadAppCredentialsSuspenseQueryHookResult = ReturnType<typeof useReadAppCredentialsSuspenseQuery>;
export type ReadAppCredentialsQueryResult = Apollo.QueryResult<ReadAppCredentialsQuery, ReadAppCredentialsQueryVariables>;
export const ReadConnectionDocument = gql`
    query ReadConnection($legalEntityId: String!, $connectionId: String!) {
  readConnection(legalEntityId: $legalEntityId, connectionId: $connectionId) {
    ...ConnectionFields
  }
}
    ${ConnectionFieldsFragmentDoc}`;

/**
 * __useReadConnectionQuery__
 *
 * To run a query within a React component, call `useReadConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadConnectionQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useReadConnectionQuery(baseOptions: Apollo.QueryHookOptions<ReadConnectionQuery, ReadConnectionQueryVariables> & ({ variables: ReadConnectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadConnectionQuery, ReadConnectionQueryVariables>(ReadConnectionDocument, options);
      }
export function useReadConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadConnectionQuery, ReadConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadConnectionQuery, ReadConnectionQueryVariables>(ReadConnectionDocument, options);
        }
export function useReadConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadConnectionQuery, ReadConnectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadConnectionQuery, ReadConnectionQueryVariables>(ReadConnectionDocument, options);
        }
export type ReadConnectionQueryHookResult = ReturnType<typeof useReadConnectionQuery>;
export type ReadConnectionLazyQueryHookResult = ReturnType<typeof useReadConnectionLazyQuery>;
export type ReadConnectionSuspenseQueryHookResult = ReturnType<typeof useReadConnectionSuspenseQuery>;
export type ReadConnectionQueryResult = Apollo.QueryResult<ReadConnectionQuery, ReadConnectionQueryVariables>;
export const SuggestedConnectionsDocument = gql`
    query SuggestedConnections($legalEntityId: String!, $filter: SuggestedConnectionsFilter!) {
  suggestedConnections(legalEntityId: $legalEntityId, filter: $filter) {
    ...SuggestedConnectionFields
  }
}
    ${SuggestedConnectionFieldsFragmentDoc}`;

/**
 * __useSuggestedConnectionsQuery__
 *
 * To run a query within a React component, call `useSuggestedConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestedConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestedConnectionsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSuggestedConnectionsQuery(baseOptions: Apollo.QueryHookOptions<SuggestedConnectionsQuery, SuggestedConnectionsQueryVariables> & ({ variables: SuggestedConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestedConnectionsQuery, SuggestedConnectionsQueryVariables>(SuggestedConnectionsDocument, options);
      }
export function useSuggestedConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestedConnectionsQuery, SuggestedConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestedConnectionsQuery, SuggestedConnectionsQueryVariables>(SuggestedConnectionsDocument, options);
        }
export function useSuggestedConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestedConnectionsQuery, SuggestedConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestedConnectionsQuery, SuggestedConnectionsQueryVariables>(SuggestedConnectionsDocument, options);
        }
export type SuggestedConnectionsQueryHookResult = ReturnType<typeof useSuggestedConnectionsQuery>;
export type SuggestedConnectionsLazyQueryHookResult = ReturnType<typeof useSuggestedConnectionsLazyQuery>;
export type SuggestedConnectionsSuspenseQueryHookResult = ReturnType<typeof useSuggestedConnectionsSuspenseQuery>;
export type SuggestedConnectionsQueryResult = Apollo.QueryResult<SuggestedConnectionsQuery, SuggestedConnectionsQueryVariables>;
export const LogCustomerEventsDocument = gql`
    mutation LogCustomerEvents($events: [CustomerEvent!]!) {
  logCustomerEvents(events: $events)
}
    `;
export type LogCustomerEventsMutationFn = Apollo.MutationFunction<LogCustomerEventsMutation, LogCustomerEventsMutationVariables>;

/**
 * __useLogCustomerEventsMutation__
 *
 * To run a mutation, you first call `useLogCustomerEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogCustomerEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logCustomerEventsMutation, { data, loading, error }] = useLogCustomerEventsMutation({
 *   variables: {
 *      events: // value for 'events'
 *   },
 * });
 */
export function useLogCustomerEventsMutation(baseOptions?: Apollo.MutationHookOptions<LogCustomerEventsMutation, LogCustomerEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogCustomerEventsMutation, LogCustomerEventsMutationVariables>(LogCustomerEventsDocument, options);
      }
export type LogCustomerEventsMutationHookResult = ReturnType<typeof useLogCustomerEventsMutation>;
export type LogCustomerEventsMutationResult = Apollo.MutationResult<LogCustomerEventsMutation>;
export type LogCustomerEventsMutationOptions = Apollo.BaseMutationOptions<LogCustomerEventsMutation, LogCustomerEventsMutationVariables>;
export const CreateBooksClosedDateDocument = gql`
    mutation CreateBooksClosedDate($legalEntityId: String!, $booksClosedDate: Float) {
  createBooksClosedDate(
    legalEntityId: $legalEntityId
    booksClosedDate: $booksClosedDate
  )
}
    `;
export type CreateBooksClosedDateMutationFn = Apollo.MutationFunction<CreateBooksClosedDateMutation, CreateBooksClosedDateMutationVariables>;

/**
 * __useCreateBooksClosedDateMutation__
 *
 * To run a mutation, you first call `useCreateBooksClosedDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBooksClosedDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBooksClosedDateMutation, { data, loading, error }] = useCreateBooksClosedDateMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      booksClosedDate: // value for 'booksClosedDate'
 *   },
 * });
 */
export function useCreateBooksClosedDateMutation(baseOptions?: Apollo.MutationHookOptions<CreateBooksClosedDateMutation, CreateBooksClosedDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBooksClosedDateMutation, CreateBooksClosedDateMutationVariables>(CreateBooksClosedDateDocument, options);
      }
export type CreateBooksClosedDateMutationHookResult = ReturnType<typeof useCreateBooksClosedDateMutation>;
export type CreateBooksClosedDateMutationResult = Apollo.MutationResult<CreateBooksClosedDateMutation>;
export type CreateBooksClosedDateMutationOptions = Apollo.BaseMutationOptions<CreateBooksClosedDateMutation, CreateBooksClosedDateMutationVariables>;
export const DeleteDataSourceDocument = gql`
    mutation DeleteDataSource($legalEntityId: String!, $dataSourceId: String!, $providerType: ProviderType!) {
  deleteDataSource(
    legalEntityId: $legalEntityId
    dataSourceId: $dataSourceId
    providerType: $providerType
  )
}
    `;
export type DeleteDataSourceMutationFn = Apollo.MutationFunction<DeleteDataSourceMutation, DeleteDataSourceMutationVariables>;

/**
 * __useDeleteDataSourceMutation__
 *
 * To run a mutation, you first call `useDeleteDataSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDataSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDataSourceMutation, { data, loading, error }] = useDeleteDataSourceMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      dataSourceId: // value for 'dataSourceId'
 *      providerType: // value for 'providerType'
 *   },
 * });
 */
export function useDeleteDataSourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDataSourceMutation, DeleteDataSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDataSourceMutation, DeleteDataSourceMutationVariables>(DeleteDataSourceDocument, options);
      }
export type DeleteDataSourceMutationHookResult = ReturnType<typeof useDeleteDataSourceMutation>;
export type DeleteDataSourceMutationResult = Apollo.MutationResult<DeleteDataSourceMutation>;
export type DeleteDataSourceMutationOptions = Apollo.BaseMutationOptions<DeleteDataSourceMutation, DeleteDataSourceMutationVariables>;
export const RefreshDataSourceDocument = gql`
    mutation RefreshDataSource($legalEntityId: String!) {
  refreshDataSource(legalEntityId: $legalEntityId) {
    ...DataSourceManualRefreshFields
  }
}
    ${DataSourceManualRefreshFieldsFragmentDoc}`;
export type RefreshDataSourceMutationFn = Apollo.MutationFunction<RefreshDataSourceMutation, RefreshDataSourceMutationVariables>;

/**
 * __useRefreshDataSourceMutation__
 *
 * To run a mutation, you first call `useRefreshDataSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshDataSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshDataSourceMutation, { data, loading, error }] = useRefreshDataSourceMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useRefreshDataSourceMutation(baseOptions?: Apollo.MutationHookOptions<RefreshDataSourceMutation, RefreshDataSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshDataSourceMutation, RefreshDataSourceMutationVariables>(RefreshDataSourceDocument, options);
      }
export type RefreshDataSourceMutationHookResult = ReturnType<typeof useRefreshDataSourceMutation>;
export type RefreshDataSourceMutationResult = Apollo.MutationResult<RefreshDataSourceMutation>;
export type RefreshDataSourceMutationOptions = Apollo.BaseMutationOptions<RefreshDataSourceMutation, RefreshDataSourceMutationVariables>;
export const ListDataSourcesDocument = gql`
    query ListDataSources($legalEntityId: String!) {
  listDataSources(legalEntityId: $legalEntityId) {
    ...DataSourceFields
  }
}
    ${DataSourceFieldsFragmentDoc}`;

/**
 * __useListDataSourcesQuery__
 *
 * To run a query within a React component, call `useListDataSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDataSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDataSourcesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListDataSourcesQuery(baseOptions: Apollo.QueryHookOptions<ListDataSourcesQuery, ListDataSourcesQueryVariables> & ({ variables: ListDataSourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDataSourcesQuery, ListDataSourcesQueryVariables>(ListDataSourcesDocument, options);
      }
export function useListDataSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDataSourcesQuery, ListDataSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDataSourcesQuery, ListDataSourcesQueryVariables>(ListDataSourcesDocument, options);
        }
export function useListDataSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDataSourcesQuery, ListDataSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDataSourcesQuery, ListDataSourcesQueryVariables>(ListDataSourcesDocument, options);
        }
export type ListDataSourcesQueryHookResult = ReturnType<typeof useListDataSourcesQuery>;
export type ListDataSourcesLazyQueryHookResult = ReturnType<typeof useListDataSourcesLazyQuery>;
export type ListDataSourcesSuspenseQueryHookResult = ReturnType<typeof useListDataSourcesSuspenseQuery>;
export type ListDataSourcesQueryResult = Apollo.QueryResult<ListDataSourcesQuery, ListDataSourcesQueryVariables>;
export const ListEnrichedDataSourcesDocument = gql`
    query ListEnrichedDataSources($legalEntityId: String!) {
  listEnrichedDataSources(legalEntityId: $legalEntityId) {
    ...EnrichedDataSourceFields
  }
}
    ${EnrichedDataSourceFieldsFragmentDoc}`;

/**
 * __useListEnrichedDataSourcesQuery__
 *
 * To run a query within a React component, call `useListEnrichedDataSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEnrichedDataSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEnrichedDataSourcesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListEnrichedDataSourcesQuery(baseOptions: Apollo.QueryHookOptions<ListEnrichedDataSourcesQuery, ListEnrichedDataSourcesQueryVariables> & ({ variables: ListEnrichedDataSourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEnrichedDataSourcesQuery, ListEnrichedDataSourcesQueryVariables>(ListEnrichedDataSourcesDocument, options);
      }
export function useListEnrichedDataSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEnrichedDataSourcesQuery, ListEnrichedDataSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEnrichedDataSourcesQuery, ListEnrichedDataSourcesQueryVariables>(ListEnrichedDataSourcesDocument, options);
        }
export function useListEnrichedDataSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListEnrichedDataSourcesQuery, ListEnrichedDataSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListEnrichedDataSourcesQuery, ListEnrichedDataSourcesQueryVariables>(ListEnrichedDataSourcesDocument, options);
        }
export type ListEnrichedDataSourcesQueryHookResult = ReturnType<typeof useListEnrichedDataSourcesQuery>;
export type ListEnrichedDataSourcesLazyQueryHookResult = ReturnType<typeof useListEnrichedDataSourcesLazyQuery>;
export type ListEnrichedDataSourcesSuspenseQueryHookResult = ReturnType<typeof useListEnrichedDataSourcesSuspenseQuery>;
export type ListEnrichedDataSourcesQueryResult = Apollo.QueryResult<ListEnrichedDataSourcesQuery, ListEnrichedDataSourcesQueryVariables>;
export const ListLatestDataSourceRefreshesDocument = gql`
    query ListLatestDataSourceRefreshes($legalEntityId: String!) {
  listLatestDataSourceRefreshes(legalEntityId: $legalEntityId) {
    ...DataSourceManualRefreshFields
  }
}
    ${DataSourceManualRefreshFieldsFragmentDoc}`;

/**
 * __useListLatestDataSourceRefreshesQuery__
 *
 * To run a query within a React component, call `useListLatestDataSourceRefreshesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLatestDataSourceRefreshesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLatestDataSourceRefreshesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListLatestDataSourceRefreshesQuery(baseOptions: Apollo.QueryHookOptions<ListLatestDataSourceRefreshesQuery, ListLatestDataSourceRefreshesQueryVariables> & ({ variables: ListLatestDataSourceRefreshesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLatestDataSourceRefreshesQuery, ListLatestDataSourceRefreshesQueryVariables>(ListLatestDataSourceRefreshesDocument, options);
      }
export function useListLatestDataSourceRefreshesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLatestDataSourceRefreshesQuery, ListLatestDataSourceRefreshesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLatestDataSourceRefreshesQuery, ListLatestDataSourceRefreshesQueryVariables>(ListLatestDataSourceRefreshesDocument, options);
        }
export function useListLatestDataSourceRefreshesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLatestDataSourceRefreshesQuery, ListLatestDataSourceRefreshesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLatestDataSourceRefreshesQuery, ListLatestDataSourceRefreshesQueryVariables>(ListLatestDataSourceRefreshesDocument, options);
        }
export type ListLatestDataSourceRefreshesQueryHookResult = ReturnType<typeof useListLatestDataSourceRefreshesQuery>;
export type ListLatestDataSourceRefreshesLazyQueryHookResult = ReturnType<typeof useListLatestDataSourceRefreshesLazyQuery>;
export type ListLatestDataSourceRefreshesSuspenseQueryHookResult = ReturnType<typeof useListLatestDataSourceRefreshesSuspenseQuery>;
export type ListLatestDataSourceRefreshesQueryResult = Apollo.QueryResult<ListLatestDataSourceRefreshesQuery, ListLatestDataSourceRefreshesQueryVariables>;
export const ListOwnedDataSourcesDocument = gql`
    query ListOwnedDataSources($legalEntityId: String!) {
  listOwnedDataSources(legalEntityId: $legalEntityId) {
    dataSource {
      ...EnrichedDataSourceFields
    }
    ownedSourceAccounts {
      ...OwnedSourceAccountFields
    }
  }
}
    ${EnrichedDataSourceFieldsFragmentDoc}
${OwnedSourceAccountFieldsFragmentDoc}`;

/**
 * __useListOwnedDataSourcesQuery__
 *
 * To run a query within a React component, call `useListOwnedDataSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOwnedDataSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOwnedDataSourcesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListOwnedDataSourcesQuery(baseOptions: Apollo.QueryHookOptions<ListOwnedDataSourcesQuery, ListOwnedDataSourcesQueryVariables> & ({ variables: ListOwnedDataSourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOwnedDataSourcesQuery, ListOwnedDataSourcesQueryVariables>(ListOwnedDataSourcesDocument, options);
      }
export function useListOwnedDataSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOwnedDataSourcesQuery, ListOwnedDataSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOwnedDataSourcesQuery, ListOwnedDataSourcesQueryVariables>(ListOwnedDataSourcesDocument, options);
        }
export function useListOwnedDataSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOwnedDataSourcesQuery, ListOwnedDataSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOwnedDataSourcesQuery, ListOwnedDataSourcesQueryVariables>(ListOwnedDataSourcesDocument, options);
        }
export type ListOwnedDataSourcesQueryHookResult = ReturnType<typeof useListOwnedDataSourcesQuery>;
export type ListOwnedDataSourcesLazyQueryHookResult = ReturnType<typeof useListOwnedDataSourcesLazyQuery>;
export type ListOwnedDataSourcesSuspenseQueryHookResult = ReturnType<typeof useListOwnedDataSourcesSuspenseQuery>;
export type ListOwnedDataSourcesQueryResult = Apollo.QueryResult<ListOwnedDataSourcesQuery, ListOwnedDataSourcesQueryVariables>;
export const ReadBooksClosedDateDocument = gql`
    query ReadBooksClosedDate($legalEntityId: String!) {
  readBooksClosedDate(legalEntityId: $legalEntityId) {
    ...BooksClosedDateFields
  }
}
    ${BooksClosedDateFieldsFragmentDoc}`;

/**
 * __useReadBooksClosedDateQuery__
 *
 * To run a query within a React component, call `useReadBooksClosedDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadBooksClosedDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadBooksClosedDateQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadBooksClosedDateQuery(baseOptions: Apollo.QueryHookOptions<ReadBooksClosedDateQuery, ReadBooksClosedDateQueryVariables> & ({ variables: ReadBooksClosedDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadBooksClosedDateQuery, ReadBooksClosedDateQueryVariables>(ReadBooksClosedDateDocument, options);
      }
export function useReadBooksClosedDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadBooksClosedDateQuery, ReadBooksClosedDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadBooksClosedDateQuery, ReadBooksClosedDateQueryVariables>(ReadBooksClosedDateDocument, options);
        }
export function useReadBooksClosedDateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadBooksClosedDateQuery, ReadBooksClosedDateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadBooksClosedDateQuery, ReadBooksClosedDateQueryVariables>(ReadBooksClosedDateDocument, options);
        }
export type ReadBooksClosedDateQueryHookResult = ReturnType<typeof useReadBooksClosedDateQuery>;
export type ReadBooksClosedDateLazyQueryHookResult = ReturnType<typeof useReadBooksClosedDateLazyQuery>;
export type ReadBooksClosedDateSuspenseQueryHookResult = ReturnType<typeof useReadBooksClosedDateSuspenseQuery>;
export type ReadBooksClosedDateQueryResult = Apollo.QueryResult<ReadBooksClosedDateQuery, ReadBooksClosedDateQueryVariables>;
export const ReadDataSourcePreferencesDocument = gql`
    query ReadDataSourcePreferences($legalEntityId: String!) {
  readDataSourcePreferences(legalEntityId: $legalEntityId) {
    ...DataSourcePreferenceFields
  }
}
    ${DataSourcePreferenceFieldsFragmentDoc}`;

/**
 * __useReadDataSourcePreferencesQuery__
 *
 * To run a query within a React component, call `useReadDataSourcePreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadDataSourcePreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadDataSourcePreferencesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadDataSourcePreferencesQuery(baseOptions: Apollo.QueryHookOptions<ReadDataSourcePreferencesQuery, ReadDataSourcePreferencesQueryVariables> & ({ variables: ReadDataSourcePreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadDataSourcePreferencesQuery, ReadDataSourcePreferencesQueryVariables>(ReadDataSourcePreferencesDocument, options);
      }
export function useReadDataSourcePreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadDataSourcePreferencesQuery, ReadDataSourcePreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadDataSourcePreferencesQuery, ReadDataSourcePreferencesQueryVariables>(ReadDataSourcePreferencesDocument, options);
        }
export function useReadDataSourcePreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadDataSourcePreferencesQuery, ReadDataSourcePreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadDataSourcePreferencesQuery, ReadDataSourcePreferencesQueryVariables>(ReadDataSourcePreferencesDocument, options);
        }
export type ReadDataSourcePreferencesQueryHookResult = ReturnType<typeof useReadDataSourcePreferencesQuery>;
export type ReadDataSourcePreferencesLazyQueryHookResult = ReturnType<typeof useReadDataSourcePreferencesLazyQuery>;
export type ReadDataSourcePreferencesSuspenseQueryHookResult = ReturnType<typeof useReadDataSourcePreferencesSuspenseQuery>;
export type ReadDataSourcePreferencesQueryResult = Apollo.QueryResult<ReadDataSourcePreferencesQuery, ReadDataSourcePreferencesQueryVariables>;
export const BootstrapDepartmentDocument = gql`
    mutation BootstrapDepartment($legalEntityId: String!) {
  bootstrapDepartments(legalEntityId: $legalEntityId) {
    departmentId
  }
}
    `;
export type BootstrapDepartmentMutationFn = Apollo.MutationFunction<BootstrapDepartmentMutation, BootstrapDepartmentMutationVariables>;

/**
 * __useBootstrapDepartmentMutation__
 *
 * To run a mutation, you first call `useBootstrapDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBootstrapDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bootstrapDepartmentMutation, { data, loading, error }] = useBootstrapDepartmentMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useBootstrapDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<BootstrapDepartmentMutation, BootstrapDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BootstrapDepartmentMutation, BootstrapDepartmentMutationVariables>(BootstrapDepartmentDocument, options);
      }
export type BootstrapDepartmentMutationHookResult = ReturnType<typeof useBootstrapDepartmentMutation>;
export type BootstrapDepartmentMutationResult = Apollo.MutationResult<BootstrapDepartmentMutation>;
export type BootstrapDepartmentMutationOptions = Apollo.BaseMutationOptions<BootstrapDepartmentMutation, BootstrapDepartmentMutationVariables>;
export const CreateDepartmentDocument = gql`
    mutation CreateDepartment($viewKey: ViewKey!, $dimension: CreateDepartmentInput!) {
  createDepartment(viewKey: $viewKey, department: $dimension) {
    departmentId
  }
}
    `;
export type CreateDepartmentMutationFn = Apollo.MutationFunction<CreateDepartmentMutation, CreateDepartmentMutationVariables>;

/**
 * __useCreateDepartmentMutation__
 *
 * To run a mutation, you first call `useCreateDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDepartmentMutation, { data, loading, error }] = useCreateDepartmentMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      dimension: // value for 'dimension'
 *   },
 * });
 */
export function useCreateDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDepartmentMutation, CreateDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDepartmentMutation, CreateDepartmentMutationVariables>(CreateDepartmentDocument, options);
      }
export type CreateDepartmentMutationHookResult = ReturnType<typeof useCreateDepartmentMutation>;
export type CreateDepartmentMutationResult = Apollo.MutationResult<CreateDepartmentMutation>;
export type CreateDepartmentMutationOptions = Apollo.BaseMutationOptions<CreateDepartmentMutation, CreateDepartmentMutationVariables>;
export const MigrateDepartmentQuickBooksDocument = gql`
    mutation MigrateDepartmentQuickBooks($viewKey: ViewKey!, $departmentFactIds: [String!], $lineClassFactIds: [String!]) {
  migrateDepartmentQuickBooks(
    viewKey: $viewKey
    departmentFactIds: $departmentFactIds
    lineClassFactIds: $lineClassFactIds
  )
}
    `;
export type MigrateDepartmentQuickBooksMutationFn = Apollo.MutationFunction<MigrateDepartmentQuickBooksMutation, MigrateDepartmentQuickBooksMutationVariables>;

/**
 * __useMigrateDepartmentQuickBooksMutation__
 *
 * To run a mutation, you first call `useMigrateDepartmentQuickBooksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateDepartmentQuickBooksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateDepartmentQuickBooksMutation, { data, loading, error }] = useMigrateDepartmentQuickBooksMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      departmentFactIds: // value for 'departmentFactIds'
 *      lineClassFactIds: // value for 'lineClassFactIds'
 *   },
 * });
 */
export function useMigrateDepartmentQuickBooksMutation(baseOptions?: Apollo.MutationHookOptions<MigrateDepartmentQuickBooksMutation, MigrateDepartmentQuickBooksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigrateDepartmentQuickBooksMutation, MigrateDepartmentQuickBooksMutationVariables>(MigrateDepartmentQuickBooksDocument, options);
      }
export type MigrateDepartmentQuickBooksMutationHookResult = ReturnType<typeof useMigrateDepartmentQuickBooksMutation>;
export type MigrateDepartmentQuickBooksMutationResult = Apollo.MutationResult<MigrateDepartmentQuickBooksMutation>;
export type MigrateDepartmentQuickBooksMutationOptions = Apollo.BaseMutationOptions<MigrateDepartmentQuickBooksMutation, MigrateDepartmentQuickBooksMutationVariables>;
export const UpdateDepartmentDocument = gql`
    mutation UpdateDepartment($viewKey: ViewKey!, $dimensionId: String!, $dimension: UpdateDepartmentInput!) {
  updateDepartment(
    viewKey: $viewKey
    departmentId: $dimensionId
    department: $dimension
  ) {
    entityId: departmentId
  }
}
    `;
export type UpdateDepartmentMutationFn = Apollo.MutationFunction<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>;

/**
 * __useUpdateDepartmentMutation__
 *
 * To run a mutation, you first call `useUpdateDepartmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDepartmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDepartmentMutation, { data, loading, error }] = useUpdateDepartmentMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      dimensionId: // value for 'dimensionId'
 *      dimension: // value for 'dimension'
 *   },
 * });
 */
export function useUpdateDepartmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>(UpdateDepartmentDocument, options);
      }
export type UpdateDepartmentMutationHookResult = ReturnType<typeof useUpdateDepartmentMutation>;
export type UpdateDepartmentMutationResult = Apollo.MutationResult<UpdateDepartmentMutation>;
export type UpdateDepartmentMutationOptions = Apollo.BaseMutationOptions<UpdateDepartmentMutation, UpdateDepartmentMutationVariables>;
export const UpdateDepartmentStatusDocument = gql`
    mutation UpdateDepartmentStatus($viewKey: ViewKey!, $dimensionId: String!, $enabled: Boolean!) {
  updateDepartmentStatus(
    viewKey: $viewKey
    departmentId: $dimensionId
    enabled: $enabled
  )
}
    `;
export type UpdateDepartmentStatusMutationFn = Apollo.MutationFunction<UpdateDepartmentStatusMutation, UpdateDepartmentStatusMutationVariables>;

/**
 * __useUpdateDepartmentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDepartmentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDepartmentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDepartmentStatusMutation, { data, loading, error }] = useUpdateDepartmentStatusMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      dimensionId: // value for 'dimensionId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateDepartmentStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDepartmentStatusMutation, UpdateDepartmentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDepartmentStatusMutation, UpdateDepartmentStatusMutationVariables>(UpdateDepartmentStatusDocument, options);
      }
export type UpdateDepartmentStatusMutationHookResult = ReturnType<typeof useUpdateDepartmentStatusMutation>;
export type UpdateDepartmentStatusMutationResult = Apollo.MutationResult<UpdateDepartmentStatusMutation>;
export type UpdateDepartmentStatusMutationOptions = Apollo.BaseMutationOptions<UpdateDepartmentStatusMutation, UpdateDepartmentStatusMutationVariables>;
export const ListDepartmentsDocument = gql`
    query ListDepartments($viewKey: ViewKey!, $status: DepartmentStatus) {
  listDepartments(viewKey: $viewKey, status: $status) {
    ...DepartmentFields
  }
}
    ${DepartmentFieldsFragmentDoc}`;

/**
 * __useListDepartmentsQuery__
 *
 * To run a query within a React component, call `useListDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDepartmentsQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useListDepartmentsQuery(baseOptions: Apollo.QueryHookOptions<ListDepartmentsQuery, ListDepartmentsQueryVariables> & ({ variables: ListDepartmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDepartmentsQuery, ListDepartmentsQueryVariables>(ListDepartmentsDocument, options);
      }
export function useListDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDepartmentsQuery, ListDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDepartmentsQuery, ListDepartmentsQueryVariables>(ListDepartmentsDocument, options);
        }
export function useListDepartmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDepartmentsQuery, ListDepartmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDepartmentsQuery, ListDepartmentsQueryVariables>(ListDepartmentsDocument, options);
        }
export type ListDepartmentsQueryHookResult = ReturnType<typeof useListDepartmentsQuery>;
export type ListDepartmentsLazyQueryHookResult = ReturnType<typeof useListDepartmentsLazyQuery>;
export type ListDepartmentsSuspenseQueryHookResult = ReturnType<typeof useListDepartmentsSuspenseQuery>;
export type ListDepartmentsQueryResult = Apollo.QueryResult<ListDepartmentsQuery, ListDepartmentsQueryVariables>;
export const ReadDepartmentDocument = gql`
    query ReadDepartment($viewKey: ViewKey!, $departmentId: String!) {
  readDepartment(viewKey: $viewKey, departmentId: $departmentId) {
    ...DepartmentFields
  }
}
    ${DepartmentFieldsFragmentDoc}`;

/**
 * __useReadDepartmentQuery__
 *
 * To run a query within a React component, call `useReadDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadDepartmentQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useReadDepartmentQuery(baseOptions: Apollo.QueryHookOptions<ReadDepartmentQuery, ReadDepartmentQueryVariables> & ({ variables: ReadDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadDepartmentQuery, ReadDepartmentQueryVariables>(ReadDepartmentDocument, options);
      }
export function useReadDepartmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadDepartmentQuery, ReadDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadDepartmentQuery, ReadDepartmentQueryVariables>(ReadDepartmentDocument, options);
        }
export function useReadDepartmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadDepartmentQuery, ReadDepartmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadDepartmentQuery, ReadDepartmentQueryVariables>(ReadDepartmentDocument, options);
        }
export type ReadDepartmentQueryHookResult = ReturnType<typeof useReadDepartmentQuery>;
export type ReadDepartmentLazyQueryHookResult = ReturnType<typeof useReadDepartmentLazyQuery>;
export type ReadDepartmentSuspenseQueryHookResult = ReturnType<typeof useReadDepartmentSuspenseQuery>;
export type ReadDepartmentQueryResult = Apollo.QueryResult<ReadDepartmentQuery, ReadDepartmentQueryVariables>;
export const AddAssociationsDocument = gql`
    mutation AddAssociations($legalEntityId: String!, $associationIdentifiers: [InputAssociationIdentifier!]!) {
  addAssociations(
    legalEntityId: $legalEntityId
    associationIdentifiers: $associationIdentifiers
  )
}
    `;
export type AddAssociationsMutationFn = Apollo.MutationFunction<AddAssociationsMutation, AddAssociationsMutationVariables>;

/**
 * __useAddAssociationsMutation__
 *
 * To run a mutation, you first call `useAddAssociationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAssociationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAssociationsMutation, { data, loading, error }] = useAddAssociationsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      associationIdentifiers: // value for 'associationIdentifiers'
 *   },
 * });
 */
export function useAddAssociationsMutation(baseOptions?: Apollo.MutationHookOptions<AddAssociationsMutation, AddAssociationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAssociationsMutation, AddAssociationsMutationVariables>(AddAssociationsDocument, options);
      }
export type AddAssociationsMutationHookResult = ReturnType<typeof useAddAssociationsMutation>;
export type AddAssociationsMutationResult = Apollo.MutationResult<AddAssociationsMutation>;
export type AddAssociationsMutationOptions = Apollo.BaseMutationOptions<AddAssociationsMutation, AddAssociationsMutationVariables>;
export const RemoveAssociationsDocument = gql`
    mutation RemoveAssociations($legalEntityId: String!, $associationIdentifiers: [InputAssociationIdentifier!]!) {
  removeAssociations(
    legalEntityId: $legalEntityId
    associationIdentifiers: $associationIdentifiers
  )
}
    `;
export type RemoveAssociationsMutationFn = Apollo.MutationFunction<RemoveAssociationsMutation, RemoveAssociationsMutationVariables>;

/**
 * __useRemoveAssociationsMutation__
 *
 * To run a mutation, you first call `useRemoveAssociationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAssociationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAssociationsMutation, { data, loading, error }] = useRemoveAssociationsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      associationIdentifiers: // value for 'associationIdentifiers'
 *   },
 * });
 */
export function useRemoveAssociationsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAssociationsMutation, RemoveAssociationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAssociationsMutation, RemoveAssociationsMutationVariables>(RemoveAssociationsDocument, options);
      }
export type RemoveAssociationsMutationHookResult = ReturnType<typeof useRemoveAssociationsMutation>;
export type RemoveAssociationsMutationResult = Apollo.MutationResult<RemoveAssociationsMutation>;
export type RemoveAssociationsMutationOptions = Apollo.BaseMutationOptions<RemoveAssociationsMutation, RemoveAssociationsMutationVariables>;
export const ListAssociationsHistoriesDocument = gql`
    query ListAssociationsHistories($legalEntityId: String!, $objectIdentifiers: [InputObjectIdentifier!]!) {
  listAssociationsHistories(
    legalEntityId: $legalEntityId
    objectIdentifiers: $objectIdentifiers
  ) {
    ...AssociationHistoryFields
  }
}
    ${AssociationHistoryFieldsFragmentDoc}`;

/**
 * __useListAssociationsHistoriesQuery__
 *
 * To run a query within a React component, call `useListAssociationsHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAssociationsHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAssociationsHistoriesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      objectIdentifiers: // value for 'objectIdentifiers'
 *   },
 * });
 */
export function useListAssociationsHistoriesQuery(baseOptions: Apollo.QueryHookOptions<ListAssociationsHistoriesQuery, ListAssociationsHistoriesQueryVariables> & ({ variables: ListAssociationsHistoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAssociationsHistoriesQuery, ListAssociationsHistoriesQueryVariables>(ListAssociationsHistoriesDocument, options);
      }
export function useListAssociationsHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAssociationsHistoriesQuery, ListAssociationsHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAssociationsHistoriesQuery, ListAssociationsHistoriesQueryVariables>(ListAssociationsHistoriesDocument, options);
        }
export function useListAssociationsHistoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAssociationsHistoriesQuery, ListAssociationsHistoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAssociationsHistoriesQuery, ListAssociationsHistoriesQueryVariables>(ListAssociationsHistoriesDocument, options);
        }
export type ListAssociationsHistoriesQueryHookResult = ReturnType<typeof useListAssociationsHistoriesQuery>;
export type ListAssociationsHistoriesLazyQueryHookResult = ReturnType<typeof useListAssociationsHistoriesLazyQuery>;
export type ListAssociationsHistoriesSuspenseQueryHookResult = ReturnType<typeof useListAssociationsHistoriesSuspenseQuery>;
export type ListAssociationsHistoriesQueryResult = Apollo.QueryResult<ListAssociationsHistoriesQuery, ListAssociationsHistoriesQueryVariables>;
export const ListDocumentAssociationsDocument = gql`
    query ListDocumentAssociations($legalEntityId: String!, $documentIds: [String!]!) {
  listDocumentAssociations(
    legalEntityId: $legalEntityId
    documentIds: $documentIds
  ) {
    ...AssociationIdentifierFields
  }
}
    ${AssociationIdentifierFieldsFragmentDoc}`;

/**
 * __useListDocumentAssociationsQuery__
 *
 * To run a query within a React component, call `useListDocumentAssociationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDocumentAssociationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDocumentAssociationsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useListDocumentAssociationsQuery(baseOptions: Apollo.QueryHookOptions<ListDocumentAssociationsQuery, ListDocumentAssociationsQueryVariables> & ({ variables: ListDocumentAssociationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDocumentAssociationsQuery, ListDocumentAssociationsQueryVariables>(ListDocumentAssociationsDocument, options);
      }
export function useListDocumentAssociationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDocumentAssociationsQuery, ListDocumentAssociationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDocumentAssociationsQuery, ListDocumentAssociationsQueryVariables>(ListDocumentAssociationsDocument, options);
        }
export function useListDocumentAssociationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDocumentAssociationsQuery, ListDocumentAssociationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDocumentAssociationsQuery, ListDocumentAssociationsQueryVariables>(ListDocumentAssociationsDocument, options);
        }
export type ListDocumentAssociationsQueryHookResult = ReturnType<typeof useListDocumentAssociationsQuery>;
export type ListDocumentAssociationsLazyQueryHookResult = ReturnType<typeof useListDocumentAssociationsLazyQuery>;
export type ListDocumentAssociationsSuspenseQueryHookResult = ReturnType<typeof useListDocumentAssociationsSuspenseQuery>;
export type ListDocumentAssociationsQueryResult = Apollo.QueryResult<ListDocumentAssociationsQuery, ListDocumentAssociationsQueryVariables>;
export const ListObjectAssociationsDocument = gql`
    query ListObjectAssociations($legalEntityId: String!, $objectIdentifiers: [InputObjectIdentifier!]!) {
  listObjectAssociations(
    legalEntityId: $legalEntityId
    objectIdentifiers: $objectIdentifiers
  ) {
    ...AssociationIdentifierFields
  }
}
    ${AssociationIdentifierFieldsFragmentDoc}`;

/**
 * __useListObjectAssociationsQuery__
 *
 * To run a query within a React component, call `useListObjectAssociationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListObjectAssociationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListObjectAssociationsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      objectIdentifiers: // value for 'objectIdentifiers'
 *   },
 * });
 */
export function useListObjectAssociationsQuery(baseOptions: Apollo.QueryHookOptions<ListObjectAssociationsQuery, ListObjectAssociationsQueryVariables> & ({ variables: ListObjectAssociationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListObjectAssociationsQuery, ListObjectAssociationsQueryVariables>(ListObjectAssociationsDocument, options);
      }
export function useListObjectAssociationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListObjectAssociationsQuery, ListObjectAssociationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListObjectAssociationsQuery, ListObjectAssociationsQueryVariables>(ListObjectAssociationsDocument, options);
        }
export function useListObjectAssociationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListObjectAssociationsQuery, ListObjectAssociationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListObjectAssociationsQuery, ListObjectAssociationsQueryVariables>(ListObjectAssociationsDocument, options);
        }
export type ListObjectAssociationsQueryHookResult = ReturnType<typeof useListObjectAssociationsQuery>;
export type ListObjectAssociationsLazyQueryHookResult = ReturnType<typeof useListObjectAssociationsLazyQuery>;
export type ListObjectAssociationsSuspenseQueryHookResult = ReturnType<typeof useListObjectAssociationsSuspenseQuery>;
export type ListObjectAssociationsQueryResult = Apollo.QueryResult<ListObjectAssociationsQuery, ListObjectAssociationsQueryVariables>;
export const ListDoppelgangerPermitsDocument = gql`
    query ListDoppelgangerPermits {
  listDoppelgangerPermits {
    ...DoppelgangerPermitFields
  }
}
    ${DoppelgangerPermitFieldsFragmentDoc}`;

/**
 * __useListDoppelgangerPermitsQuery__
 *
 * To run a query within a React component, call `useListDoppelgangerPermitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDoppelgangerPermitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDoppelgangerPermitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListDoppelgangerPermitsQuery(baseOptions?: Apollo.QueryHookOptions<ListDoppelgangerPermitsQuery, ListDoppelgangerPermitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDoppelgangerPermitsQuery, ListDoppelgangerPermitsQueryVariables>(ListDoppelgangerPermitsDocument, options);
      }
export function useListDoppelgangerPermitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDoppelgangerPermitsQuery, ListDoppelgangerPermitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDoppelgangerPermitsQuery, ListDoppelgangerPermitsQueryVariables>(ListDoppelgangerPermitsDocument, options);
        }
export function useListDoppelgangerPermitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDoppelgangerPermitsQuery, ListDoppelgangerPermitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDoppelgangerPermitsQuery, ListDoppelgangerPermitsQueryVariables>(ListDoppelgangerPermitsDocument, options);
        }
export type ListDoppelgangerPermitsQueryHookResult = ReturnType<typeof useListDoppelgangerPermitsQuery>;
export type ListDoppelgangerPermitsLazyQueryHookResult = ReturnType<typeof useListDoppelgangerPermitsLazyQuery>;
export type ListDoppelgangerPermitsSuspenseQueryHookResult = ReturnType<typeof useListDoppelgangerPermitsSuspenseQuery>;
export type ListDoppelgangerPermitsQueryResult = Apollo.QueryResult<ListDoppelgangerPermitsQuery, ListDoppelgangerPermitsQueryVariables>;
export const ActivateCurrentUserEmploymentDocument = gql`
    mutation ActivateCurrentUserEmployment($organizationId: String!) {
  activateCurrentUserEmployment(organizationId: $organizationId)
}
    `;
export type ActivateCurrentUserEmploymentMutationFn = Apollo.MutationFunction<ActivateCurrentUserEmploymentMutation, ActivateCurrentUserEmploymentMutationVariables>;

/**
 * __useActivateCurrentUserEmploymentMutation__
 *
 * To run a mutation, you first call `useActivateCurrentUserEmploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateCurrentUserEmploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateCurrentUserEmploymentMutation, { data, loading, error }] = useActivateCurrentUserEmploymentMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useActivateCurrentUserEmploymentMutation(baseOptions?: Apollo.MutationHookOptions<ActivateCurrentUserEmploymentMutation, ActivateCurrentUserEmploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateCurrentUserEmploymentMutation, ActivateCurrentUserEmploymentMutationVariables>(ActivateCurrentUserEmploymentDocument, options);
      }
export type ActivateCurrentUserEmploymentMutationHookResult = ReturnType<typeof useActivateCurrentUserEmploymentMutation>;
export type ActivateCurrentUserEmploymentMutationResult = Apollo.MutationResult<ActivateCurrentUserEmploymentMutation>;
export type ActivateCurrentUserEmploymentMutationOptions = Apollo.BaseMutationOptions<ActivateCurrentUserEmploymentMutation, ActivateCurrentUserEmploymentMutationVariables>;
export const CreateEmployeeAffiliationsDocument = gql`
    mutation CreateEmployeeAffiliations($organizationId: String!, $organizationRole: String!, $employeeId: String, $givenName: String!, $familyName: String!, $emailAddress: String!, $affiliations: [LegalEntityRole!]!) {
  createEmployeeAffiliations(
    organizationId: $organizationId
    organizationRole: $organizationRole
    employeeId: $employeeId
    givenName: $givenName
    familyName: $familyName
    emailAddress: $emailAddress
    affiliations: $affiliations
  )
}
    `;
export type CreateEmployeeAffiliationsMutationFn = Apollo.MutationFunction<CreateEmployeeAffiliationsMutation, CreateEmployeeAffiliationsMutationVariables>;

/**
 * __useCreateEmployeeAffiliationsMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeAffiliationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeAffiliationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeAffiliationsMutation, { data, loading, error }] = useCreateEmployeeAffiliationsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      organizationRole: // value for 'organizationRole'
 *      employeeId: // value for 'employeeId'
 *      givenName: // value for 'givenName'
 *      familyName: // value for 'familyName'
 *      emailAddress: // value for 'emailAddress'
 *      affiliations: // value for 'affiliations'
 *   },
 * });
 */
export function useCreateEmployeeAffiliationsMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeAffiliationsMutation, CreateEmployeeAffiliationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeAffiliationsMutation, CreateEmployeeAffiliationsMutationVariables>(CreateEmployeeAffiliationsDocument, options);
      }
export type CreateEmployeeAffiliationsMutationHookResult = ReturnType<typeof useCreateEmployeeAffiliationsMutation>;
export type CreateEmployeeAffiliationsMutationResult = Apollo.MutationResult<CreateEmployeeAffiliationsMutation>;
export type CreateEmployeeAffiliationsMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeAffiliationsMutation, CreateEmployeeAffiliationsMutationVariables>;
export const DeactivateEmployeeDocument = gql`
    mutation DeactivateEmployee($employeeId: String!, $organizationId: String!) {
  deactivateEmployee(employeeId: $employeeId, organizationId: $organizationId)
}
    `;
export type DeactivateEmployeeMutationFn = Apollo.MutationFunction<DeactivateEmployeeMutation, DeactivateEmployeeMutationVariables>;

/**
 * __useDeactivateEmployeeMutation__
 *
 * To run a mutation, you first call `useDeactivateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateEmployeeMutation, { data, loading, error }] = useDeactivateEmployeeMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeactivateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateEmployeeMutation, DeactivateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateEmployeeMutation, DeactivateEmployeeMutationVariables>(DeactivateEmployeeDocument, options);
      }
export type DeactivateEmployeeMutationHookResult = ReturnType<typeof useDeactivateEmployeeMutation>;
export type DeactivateEmployeeMutationResult = Apollo.MutationResult<DeactivateEmployeeMutation>;
export type DeactivateEmployeeMutationOptions = Apollo.BaseMutationOptions<DeactivateEmployeeMutation, DeactivateEmployeeMutationVariables>;
export const DeleteEmployeeAffiliationsDocument = gql`
    mutation DeleteEmployeeAffiliations($employeeIdentifier: EmployeeIdentifier!, $legalEntityIds: [String!]!) {
  deleteEmployeeAffiliations(
    employeeIdentifier: $employeeIdentifier
    legalEntityIds: $legalEntityIds
  )
}
    `;
export type DeleteEmployeeAffiliationsMutationFn = Apollo.MutationFunction<DeleteEmployeeAffiliationsMutation, DeleteEmployeeAffiliationsMutationVariables>;

/**
 * __useDeleteEmployeeAffiliationsMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeAffiliationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeAffiliationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeAffiliationsMutation, { data, loading, error }] = useDeleteEmployeeAffiliationsMutation({
 *   variables: {
 *      employeeIdentifier: // value for 'employeeIdentifier'
 *      legalEntityIds: // value for 'legalEntityIds'
 *   },
 * });
 */
export function useDeleteEmployeeAffiliationsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeAffiliationsMutation, DeleteEmployeeAffiliationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeAffiliationsMutation, DeleteEmployeeAffiliationsMutationVariables>(DeleteEmployeeAffiliationsDocument, options);
      }
export type DeleteEmployeeAffiliationsMutationHookResult = ReturnType<typeof useDeleteEmployeeAffiliationsMutation>;
export type DeleteEmployeeAffiliationsMutationResult = Apollo.MutationResult<DeleteEmployeeAffiliationsMutation>;
export type DeleteEmployeeAffiliationsMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeAffiliationsMutation, DeleteEmployeeAffiliationsMutationVariables>;
export const UpdateEmployeeDocument = gql`
    mutation UpdateEmployee($employeeId: String!, $organizationId: String!, $emailAddress: String, $givenName: String, $familyName: String, $avatarUrl: String, $jobTitle: String, $role: RoleIdentifier, $defaultEntityRole: RoleIdentifier, $hidden: Boolean, $fieldToUpdate: UpdatableEmployeeField!) {
  updateEmployee(
    employeeId: $employeeId
    organizationId: $organizationId
    emailAddress: $emailAddress
    givenName: $givenName
    familyName: $familyName
    avatarUrl: $avatarUrl
    jobTitle: $jobTitle
    role: $role
    defaultEntityRole: $defaultEntityRole
    hidden: $hidden
    fieldToUpdate: $fieldToUpdate
  )
}
    `;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      organizationId: // value for 'organizationId'
 *      emailAddress: // value for 'emailAddress'
 *      givenName: // value for 'givenName'
 *      familyName: // value for 'familyName'
 *      avatarUrl: // value for 'avatarUrl'
 *      jobTitle: // value for 'jobTitle'
 *      role: // value for 'role'
 *      defaultEntityRole: // value for 'defaultEntityRole'
 *      hidden: // value for 'hidden'
 *      fieldToUpdate: // value for 'fieldToUpdate'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
      }
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const UpdateEmployeeAffiliationsDocument = gql`
    mutation UpdateEmployeeAffiliations($employeeIdentifier: EmployeeIdentifier!, $affiliations: [LegalEntityRole!]!) {
  updateEmployeeAffiliations(
    employeeIdentifier: $employeeIdentifier
    affiliations: $affiliations
  )
}
    `;
export type UpdateEmployeeAffiliationsMutationFn = Apollo.MutationFunction<UpdateEmployeeAffiliationsMutation, UpdateEmployeeAffiliationsMutationVariables>;

/**
 * __useUpdateEmployeeAffiliationsMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeAffiliationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeAffiliationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeAffiliationsMutation, { data, loading, error }] = useUpdateEmployeeAffiliationsMutation({
 *   variables: {
 *      employeeIdentifier: // value for 'employeeIdentifier'
 *      affiliations: // value for 'affiliations'
 *   },
 * });
 */
export function useUpdateEmployeeAffiliationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeAffiliationsMutation, UpdateEmployeeAffiliationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeAffiliationsMutation, UpdateEmployeeAffiliationsMutationVariables>(UpdateEmployeeAffiliationsDocument, options);
      }
export type UpdateEmployeeAffiliationsMutationHookResult = ReturnType<typeof useUpdateEmployeeAffiliationsMutation>;
export type UpdateEmployeeAffiliationsMutationResult = Apollo.MutationResult<UpdateEmployeeAffiliationsMutation>;
export type UpdateEmployeeAffiliationsMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeAffiliationsMutation, UpdateEmployeeAffiliationsMutationVariables>;
export const UpdateOrganizationUserLegalEntityRolesDocument = gql`
    mutation UpdateOrganizationUserLegalEntityRoles($organizationId: String!, $roles: [UpdateUserLegalEntityRoleEntry!], $deletes: [UserLegalEntityRoleDelete!]) {
  updateUserLegalEntityRoles(
    organizationId: $organizationId
    roles: $roles
    deletes: $deletes
  )
}
    `;
export type UpdateOrganizationUserLegalEntityRolesMutationFn = Apollo.MutationFunction<UpdateOrganizationUserLegalEntityRolesMutation, UpdateOrganizationUserLegalEntityRolesMutationVariables>;

/**
 * __useUpdateOrganizationUserLegalEntityRolesMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationUserLegalEntityRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationUserLegalEntityRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationUserLegalEntityRolesMutation, { data, loading, error }] = useUpdateOrganizationUserLegalEntityRolesMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      roles: // value for 'roles'
 *      deletes: // value for 'deletes'
 *   },
 * });
 */
export function useUpdateOrganizationUserLegalEntityRolesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationUserLegalEntityRolesMutation, UpdateOrganizationUserLegalEntityRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationUserLegalEntityRolesMutation, UpdateOrganizationUserLegalEntityRolesMutationVariables>(UpdateOrganizationUserLegalEntityRolesDocument, options);
      }
export type UpdateOrganizationUserLegalEntityRolesMutationHookResult = ReturnType<typeof useUpdateOrganizationUserLegalEntityRolesMutation>;
export type UpdateOrganizationUserLegalEntityRolesMutationResult = Apollo.MutationResult<UpdateOrganizationUserLegalEntityRolesMutation>;
export type UpdateOrganizationUserLegalEntityRolesMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationUserLegalEntityRolesMutation, UpdateOrganizationUserLegalEntityRolesMutationVariables>;
export const UpdateUserLegalEntityRolesDocument = gql`
    mutation UpdateUserLegalEntityRoles($roles: [UpdateUserLegalEntityRoleEntry!], $deletes: [UserLegalEntityRoleDelete!]) {
  updateUserLegalEntityRoles(roles: $roles, deletes: $deletes)
}
    `;
export type UpdateUserLegalEntityRolesMutationFn = Apollo.MutationFunction<UpdateUserLegalEntityRolesMutation, UpdateUserLegalEntityRolesMutationVariables>;

/**
 * __useUpdateUserLegalEntityRolesMutation__
 *
 * To run a mutation, you first call `useUpdateUserLegalEntityRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserLegalEntityRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserLegalEntityRolesMutation, { data, loading, error }] = useUpdateUserLegalEntityRolesMutation({
 *   variables: {
 *      roles: // value for 'roles'
 *      deletes: // value for 'deletes'
 *   },
 * });
 */
export function useUpdateUserLegalEntityRolesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserLegalEntityRolesMutation, UpdateUserLegalEntityRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserLegalEntityRolesMutation, UpdateUserLegalEntityRolesMutationVariables>(UpdateUserLegalEntityRolesDocument, options);
      }
export type UpdateUserLegalEntityRolesMutationHookResult = ReturnType<typeof useUpdateUserLegalEntityRolesMutation>;
export type UpdateUserLegalEntityRolesMutationResult = Apollo.MutationResult<UpdateUserLegalEntityRolesMutation>;
export type UpdateUserLegalEntityRolesMutationOptions = Apollo.BaseMutationOptions<UpdateUserLegalEntityRolesMutation, UpdateUserLegalEntityRolesMutationVariables>;
export const ListEmployeesDocument = gql`
    query ListEmployees($filter: EmployeeFilter!, $pagination: Pagination!, $sort: EmployeeSort) {
  listEmployees(filter: $filter, pagination: $pagination, sort: $sort) {
    ...EmployeeFields
  }
}
    ${EmployeeFieldsFragmentDoc}`;

/**
 * __useListEmployeesQuery__
 *
 * To run a query within a React component, call `useListEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEmployeesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListEmployeesQuery(baseOptions: Apollo.QueryHookOptions<ListEmployeesQuery, ListEmployeesQueryVariables> & ({ variables: ListEmployeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEmployeesQuery, ListEmployeesQueryVariables>(ListEmployeesDocument, options);
      }
export function useListEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEmployeesQuery, ListEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEmployeesQuery, ListEmployeesQueryVariables>(ListEmployeesDocument, options);
        }
export function useListEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListEmployeesQuery, ListEmployeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListEmployeesQuery, ListEmployeesQueryVariables>(ListEmployeesDocument, options);
        }
export type ListEmployeesQueryHookResult = ReturnType<typeof useListEmployeesQuery>;
export type ListEmployeesLazyQueryHookResult = ReturnType<typeof useListEmployeesLazyQuery>;
export type ListEmployeesSuspenseQueryHookResult = ReturnType<typeof useListEmployeesSuspenseQuery>;
export type ListEmployeesQueryResult = Apollo.QueryResult<ListEmployeesQuery, ListEmployeesQueryVariables>;
export const ListEmployeesAffiliationsDocument = gql`
    query ListEmployeesAffiliations($filter: EmployeeFilter!, $pagination: Pagination!, $sort: EmployeeSort) {
  listEmployeesAffiliations(filter: $filter, pagination: $pagination, sort: $sort) {
    ...EmployeeAffiliationsFields
  }
}
    ${EmployeeAffiliationsFieldsFragmentDoc}`;

/**
 * __useListEmployeesAffiliationsQuery__
 *
 * To run a query within a React component, call `useListEmployeesAffiliationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEmployeesAffiliationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEmployeesAffiliationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListEmployeesAffiliationsQuery(baseOptions: Apollo.QueryHookOptions<ListEmployeesAffiliationsQuery, ListEmployeesAffiliationsQueryVariables> & ({ variables: ListEmployeesAffiliationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEmployeesAffiliationsQuery, ListEmployeesAffiliationsQueryVariables>(ListEmployeesAffiliationsDocument, options);
      }
export function useListEmployeesAffiliationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEmployeesAffiliationsQuery, ListEmployeesAffiliationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEmployeesAffiliationsQuery, ListEmployeesAffiliationsQueryVariables>(ListEmployeesAffiliationsDocument, options);
        }
export function useListEmployeesAffiliationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListEmployeesAffiliationsQuery, ListEmployeesAffiliationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListEmployeesAffiliationsQuery, ListEmployeesAffiliationsQueryVariables>(ListEmployeesAffiliationsDocument, options);
        }
export type ListEmployeesAffiliationsQueryHookResult = ReturnType<typeof useListEmployeesAffiliationsQuery>;
export type ListEmployeesAffiliationsLazyQueryHookResult = ReturnType<typeof useListEmployeesAffiliationsLazyQuery>;
export type ListEmployeesAffiliationsSuspenseQueryHookResult = ReturnType<typeof useListEmployeesAffiliationsSuspenseQuery>;
export type ListEmployeesAffiliationsQueryResult = Apollo.QueryResult<ListEmployeesAffiliationsQuery, ListEmployeesAffiliationsQueryVariables>;
export const GenerateLayoutComponentPdfDocument = gql`
    mutation GenerateLayoutComponentPdf($legalEntityId: String!, $legalEntityName: String!, $viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!, $title: String!, $periodName: String!, $layoutId: String, $dataId: String, $timezone: String) {
  generateLayoutComponentPdf(
    legalEntityId: $legalEntityId
    legalEntityName: $legalEntityName
    viewId: $viewId
    config: $config
    title: $title
    periodName: $periodName
    layoutId: $layoutId
    dataId: $dataId
    timezone: $timezone
  ) {
    url
  }
}
    `;
export type GenerateLayoutComponentPdfMutationFn = Apollo.MutationFunction<GenerateLayoutComponentPdfMutation, GenerateLayoutComponentPdfMutationVariables>;

/**
 * __useGenerateLayoutComponentPdfMutation__
 *
 * To run a mutation, you first call `useGenerateLayoutComponentPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateLayoutComponentPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateLayoutComponentPdfMutation, { data, loading, error }] = useGenerateLayoutComponentPdfMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      legalEntityName: // value for 'legalEntityName'
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *      title: // value for 'title'
 *      periodName: // value for 'periodName'
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useGenerateLayoutComponentPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateLayoutComponentPdfMutation, GenerateLayoutComponentPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateLayoutComponentPdfMutation, GenerateLayoutComponentPdfMutationVariables>(GenerateLayoutComponentPdfDocument, options);
      }
export type GenerateLayoutComponentPdfMutationHookResult = ReturnType<typeof useGenerateLayoutComponentPdfMutation>;
export type GenerateLayoutComponentPdfMutationResult = Apollo.MutationResult<GenerateLayoutComponentPdfMutation>;
export type GenerateLayoutComponentPdfMutationOptions = Apollo.BaseMutationOptions<GenerateLayoutComponentPdfMutation, GenerateLayoutComponentPdfMutationVariables>;
export const ListFirmClientsDocument = gql`
    query ListFirmClients($filter: FirmClientFilter!, $origin: IntervalOrigin!, $direction: DirectionFromOrigin!, $pagination: Pagination!, $sort: FirmClientSort) {
  listFirmClients(
    filter: $filter
    origin: $origin
    direction: $direction
    pagination: $pagination
    sort: $sort
  ) {
    clients {
      id
      legalEntity {
        ...EntityLegalEntityFields
      }
      organization {
        ...EntityOrganizationFields
      }
      status
      payerOrganizationId
      billingPlan {
        ...BillingProductFields
      }
      counts {
        group
        count
      }
      memberUserIds
    }
    totalCount
    entities {
      ...ObjectEntitiesFields
    }
  }
}
    ${EntityLegalEntityFieldsFragmentDoc}
${EntityOrganizationFieldsFragmentDoc}
${BillingProductFieldsFragmentDoc}
${ObjectEntitiesFieldsFragmentDoc}`;

/**
 * __useListFirmClientsQuery__
 *
 * To run a query within a React component, call `useListFirmClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFirmClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFirmClientsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      origin: // value for 'origin'
 *      direction: // value for 'direction'
 *      pagination: // value for 'pagination'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListFirmClientsQuery(baseOptions: Apollo.QueryHookOptions<ListFirmClientsQuery, ListFirmClientsQueryVariables> & ({ variables: ListFirmClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFirmClientsQuery, ListFirmClientsQueryVariables>(ListFirmClientsDocument, options);
      }
export function useListFirmClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFirmClientsQuery, ListFirmClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFirmClientsQuery, ListFirmClientsQueryVariables>(ListFirmClientsDocument, options);
        }
export function useListFirmClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFirmClientsQuery, ListFirmClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListFirmClientsQuery, ListFirmClientsQueryVariables>(ListFirmClientsDocument, options);
        }
export type ListFirmClientsQueryHookResult = ReturnType<typeof useListFirmClientsQuery>;
export type ListFirmClientsLazyQueryHookResult = ReturnType<typeof useListFirmClientsLazyQuery>;
export type ListFirmClientsSuspenseQueryHookResult = ReturnType<typeof useListFirmClientsSuspenseQuery>;
export type ListFirmClientsQueryResult = Apollo.QueryResult<ListFirmClientsQuery, ListFirmClientsQueryVariables>;
export const ListInsightsDocument = gql`
    query ListInsights($interval: Interval!, $intervalCount: Int, $year: Int!, $index: Int!, $paginationDirection: DirectionFromOrigin!, $paginationLimit: Int!, $paginationOffset: Int!, $filter: InsightFilter!) {
  listInsights(
    filter: $filter
    origin: {interval: $interval, year: $year, index: $index, intervalCount: $intervalCount}
    pagination: {limit: $paginationLimit, offset: $paginationOffset}
    direction: $paginationDirection
  ) {
    period {
      ...PeriodFields
    }
    insights {
      ...InsightFields
    }
    entities {
      ...ObjectEntitiesFields
    }
  }
}
    ${PeriodFieldsFragmentDoc}
${InsightFieldsFragmentDoc}
${ObjectEntitiesFieldsFragmentDoc}`;

/**
 * __useListInsightsQuery__
 *
 * To run a query within a React component, call `useListInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInsightsQuery({
 *   variables: {
 *      interval: // value for 'interval'
 *      intervalCount: // value for 'intervalCount'
 *      year: // value for 'year'
 *      index: // value for 'index'
 *      paginationDirection: // value for 'paginationDirection'
 *      paginationLimit: // value for 'paginationLimit'
 *      paginationOffset: // value for 'paginationOffset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListInsightsQuery(baseOptions: Apollo.QueryHookOptions<ListInsightsQuery, ListInsightsQueryVariables> & ({ variables: ListInsightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListInsightsQuery, ListInsightsQueryVariables>(ListInsightsDocument, options);
      }
export function useListInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListInsightsQuery, ListInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListInsightsQuery, ListInsightsQueryVariables>(ListInsightsDocument, options);
        }
export function useListInsightsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListInsightsQuery, ListInsightsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListInsightsQuery, ListInsightsQueryVariables>(ListInsightsDocument, options);
        }
export type ListInsightsQueryHookResult = ReturnType<typeof useListInsightsQuery>;
export type ListInsightsLazyQueryHookResult = ReturnType<typeof useListInsightsLazyQuery>;
export type ListInsightsSuspenseQueryHookResult = ReturnType<typeof useListInsightsSuspenseQuery>;
export type ListInsightsQueryResult = Apollo.QueryResult<ListInsightsQuery, ListInsightsQueryVariables>;
export const ListInstitutionsDocument = gql`
    query ListInstitutions($pagination: Pagination, $filter: InstitutionFilter) {
  listInstitutions(pagination: $pagination, filter: $filter) {
    ...ProductInstitutionFields
  }
}
    ${ProductInstitutionFieldsFragmentDoc}`;

/**
 * __useListInstitutionsQuery__
 *
 * To run a query within a React component, call `useListInstitutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInstitutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInstitutionsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListInstitutionsQuery(baseOptions?: Apollo.QueryHookOptions<ListInstitutionsQuery, ListInstitutionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListInstitutionsQuery, ListInstitutionsQueryVariables>(ListInstitutionsDocument, options);
      }
export function useListInstitutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListInstitutionsQuery, ListInstitutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListInstitutionsQuery, ListInstitutionsQueryVariables>(ListInstitutionsDocument, options);
        }
export function useListInstitutionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListInstitutionsQuery, ListInstitutionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListInstitutionsQuery, ListInstitutionsQueryVariables>(ListInstitutionsDocument, options);
        }
export type ListInstitutionsQueryHookResult = ReturnType<typeof useListInstitutionsQuery>;
export type ListInstitutionsLazyQueryHookResult = ReturnType<typeof useListInstitutionsLazyQuery>;
export type ListInstitutionsSuspenseQueryHookResult = ReturnType<typeof useListInstitutionsSuspenseQuery>;
export type ListInstitutionsQueryResult = Apollo.QueryResult<ListInstitutionsQuery, ListInstitutionsQueryVariables>;
export const CancelInvitationDocument = gql`
    mutation CancelInvitation($token: String!) {
  cancelInvitation(token: $token)
}
    `;
export type CancelInvitationMutationFn = Apollo.MutationFunction<CancelInvitationMutation, CancelInvitationMutationVariables>;

/**
 * __useCancelInvitationMutation__
 *
 * To run a mutation, you first call `useCancelInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelInvitationMutation, { data, loading, error }] = useCancelInvitationMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCancelInvitationMutation(baseOptions?: Apollo.MutationHookOptions<CancelInvitationMutation, CancelInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelInvitationMutation, CancelInvitationMutationVariables>(CancelInvitationDocument, options);
      }
export type CancelInvitationMutationHookResult = ReturnType<typeof useCancelInvitationMutation>;
export type CancelInvitationMutationResult = Apollo.MutationResult<CancelInvitationMutation>;
export type CancelInvitationMutationOptions = Apollo.BaseMutationOptions<CancelInvitationMutation, CancelInvitationMutationVariables>;
export const CreateFirmAffiliationDocument = gql`
    mutation CreateFirmAffiliation($organizationId: String!, $name: String!, $websiteUrl: String, $address: AddressInput, $minimalCoa: Boolean = false) {
  createFirmAffiliation(
    organizationId: $organizationId
    name: $name
    websiteUrl: $websiteUrl
    address: $address
    minimalCoa: $minimalCoa
  ) {
    ...LegalEntityFields
  }
}
    ${LegalEntityFieldsFragmentDoc}`;
export type CreateFirmAffiliationMutationFn = Apollo.MutationFunction<CreateFirmAffiliationMutation, CreateFirmAffiliationMutationVariables>;

/**
 * __useCreateFirmAffiliationMutation__
 *
 * To run a mutation, you first call `useCreateFirmAffiliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFirmAffiliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFirmAffiliationMutation, { data, loading, error }] = useCreateFirmAffiliationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      websiteUrl: // value for 'websiteUrl'
 *      address: // value for 'address'
 *      minimalCoa: // value for 'minimalCoa'
 *   },
 * });
 */
export function useCreateFirmAffiliationMutation(baseOptions?: Apollo.MutationHookOptions<CreateFirmAffiliationMutation, CreateFirmAffiliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFirmAffiliationMutation, CreateFirmAffiliationMutationVariables>(CreateFirmAffiliationDocument, options);
      }
export type CreateFirmAffiliationMutationHookResult = ReturnType<typeof useCreateFirmAffiliationMutation>;
export type CreateFirmAffiliationMutationResult = Apollo.MutationResult<CreateFirmAffiliationMutation>;
export type CreateFirmAffiliationMutationOptions = Apollo.BaseMutationOptions<CreateFirmAffiliationMutation, CreateFirmAffiliationMutationVariables>;
export const ResendInvitationDocument = gql`
    mutation ResendInvitation($token: String!) {
  resendInvitation(token: $token)
}
    `;
export type ResendInvitationMutationFn = Apollo.MutationFunction<ResendInvitationMutation, ResendInvitationMutationVariables>;

/**
 * __useResendInvitationMutation__
 *
 * To run a mutation, you first call `useResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationMutation, { data, loading, error }] = useResendInvitationMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendInvitationMutation, ResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInvitationMutation, ResendInvitationMutationVariables>(ResendInvitationDocument, options);
      }
export type ResendInvitationMutationHookResult = ReturnType<typeof useResendInvitationMutation>;
export type ResendInvitationMutationResult = Apollo.MutationResult<ResendInvitationMutation>;
export type ResendInvitationMutationOptions = Apollo.BaseMutationOptions<ResendInvitationMutation, ResendInvitationMutationVariables>;
export const ResendManagedOperatorInvitationDocument = gql`
    mutation ResendManagedOperatorInvitation($legalEntityId: String!, $token: String!, $emailAddress: String!, $message: String!) {
  resendManagedOperatorInvitation(
    legalEntityId: $legalEntityId
    token: $token
    emailAddress: $emailAddress
    message: $message
  )
}
    `;
export type ResendManagedOperatorInvitationMutationFn = Apollo.MutationFunction<ResendManagedOperatorInvitationMutation, ResendManagedOperatorInvitationMutationVariables>;

/**
 * __useResendManagedOperatorInvitationMutation__
 *
 * To run a mutation, you first call `useResendManagedOperatorInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendManagedOperatorInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendManagedOperatorInvitationMutation, { data, loading, error }] = useResendManagedOperatorInvitationMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      token: // value for 'token'
 *      emailAddress: // value for 'emailAddress'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useResendManagedOperatorInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendManagedOperatorInvitationMutation, ResendManagedOperatorInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendManagedOperatorInvitationMutation, ResendManagedOperatorInvitationMutationVariables>(ResendManagedOperatorInvitationDocument, options);
      }
export type ResendManagedOperatorInvitationMutationHookResult = ReturnType<typeof useResendManagedOperatorInvitationMutation>;
export type ResendManagedOperatorInvitationMutationResult = Apollo.MutationResult<ResendManagedOperatorInvitationMutation>;
export type ResendManagedOperatorInvitationMutationOptions = Apollo.BaseMutationOptions<ResendManagedOperatorInvitationMutation, ResendManagedOperatorInvitationMutationVariables>;
export const SendInvitationDocument = gql`
    mutation SendInvitation($givenName: String, $familyName: String, $emailAddress: String!, $employeeId: String, $destinationOrganizationId: String, $destinationOrganizationRole: String, $defaultEntityRole: String, $legalEntityId: String, $legalEntityRoles: [LegalEntityRole!], $invitationType: String!, $proposalType: String, $message: String) {
  sendInvitation(
    recipient: {givenName: $givenName, familyName: $familyName, emailAddress: $emailAddress}
    employeeId: $employeeId
    destinationOrganizationId: $destinationOrganizationId
    destinationOrganizationRole: $destinationOrganizationRole
    defaultEntityRole: $defaultEntityRole
    legalEntityId: $legalEntityId
    legalEntityRoles: $legalEntityRoles
    invitationType: $invitationType
    proposalType: $proposalType
    message: $message
  )
}
    `;
export type SendInvitationMutationFn = Apollo.MutationFunction<SendInvitationMutation, SendInvitationMutationVariables>;

/**
 * __useSendInvitationMutation__
 *
 * To run a mutation, you first call `useSendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitationMutation, { data, loading, error }] = useSendInvitationMutation({
 *   variables: {
 *      givenName: // value for 'givenName'
 *      familyName: // value for 'familyName'
 *      emailAddress: // value for 'emailAddress'
 *      employeeId: // value for 'employeeId'
 *      destinationOrganizationId: // value for 'destinationOrganizationId'
 *      destinationOrganizationRole: // value for 'destinationOrganizationRole'
 *      defaultEntityRole: // value for 'defaultEntityRole'
 *      legalEntityId: // value for 'legalEntityId'
 *      legalEntityRoles: // value for 'legalEntityRoles'
 *      invitationType: // value for 'invitationType'
 *      proposalType: // value for 'proposalType'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<SendInvitationMutation, SendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInvitationMutation, SendInvitationMutationVariables>(SendInvitationDocument, options);
      }
export type SendInvitationMutationHookResult = ReturnType<typeof useSendInvitationMutation>;
export type SendInvitationMutationResult = Apollo.MutationResult<SendInvitationMutation>;
export type SendInvitationMutationOptions = Apollo.BaseMutationOptions<SendInvitationMutation, SendInvitationMutationVariables>;
export const SendManagedOperatorInvitationDocument = gql`
    mutation SendManagedOperatorInvitation($recipient: ContactInput!, $legalEntityId: String!, $legalEntityRole: String, $message: String, $redirectPath: String, $contextObject: InputObjectIdentifier) {
  sendManagedOperatorInvitation(
    recipient: $recipient
    legalEntityId: $legalEntityId
    legalEntityRole: $legalEntityRole
    message: $message
    redirectPath: $redirectPath
    contextObject: $contextObject
  )
}
    `;
export type SendManagedOperatorInvitationMutationFn = Apollo.MutationFunction<SendManagedOperatorInvitationMutation, SendManagedOperatorInvitationMutationVariables>;

/**
 * __useSendManagedOperatorInvitationMutation__
 *
 * To run a mutation, you first call `useSendManagedOperatorInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendManagedOperatorInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendManagedOperatorInvitationMutation, { data, loading, error }] = useSendManagedOperatorInvitationMutation({
 *   variables: {
 *      recipient: // value for 'recipient'
 *      legalEntityId: // value for 'legalEntityId'
 *      legalEntityRole: // value for 'legalEntityRole'
 *      message: // value for 'message'
 *      redirectPath: // value for 'redirectPath'
 *      contextObject: // value for 'contextObject'
 *   },
 * });
 */
export function useSendManagedOperatorInvitationMutation(baseOptions?: Apollo.MutationHookOptions<SendManagedOperatorInvitationMutation, SendManagedOperatorInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendManagedOperatorInvitationMutation, SendManagedOperatorInvitationMutationVariables>(SendManagedOperatorInvitationDocument, options);
      }
export type SendManagedOperatorInvitationMutationHookResult = ReturnType<typeof useSendManagedOperatorInvitationMutation>;
export type SendManagedOperatorInvitationMutationResult = Apollo.MutationResult<SendManagedOperatorInvitationMutation>;
export type SendManagedOperatorInvitationMutationOptions = Apollo.BaseMutationOptions<SendManagedOperatorInvitationMutation, SendManagedOperatorInvitationMutationVariables>;
export const LedgerDeleteDraftInvoiceDocument = gql`
    mutation LedgerDeleteDraftInvoice($legalEntityId: String!, $invoiceId: String!) {
  ledgerDeleteDraftInvoice(legalEntityId: $legalEntityId, invoiceId: $invoiceId)
}
    `;
export type LedgerDeleteDraftInvoiceMutationFn = Apollo.MutationFunction<LedgerDeleteDraftInvoiceMutation, LedgerDeleteDraftInvoiceMutationVariables>;

/**
 * __useLedgerDeleteDraftInvoiceMutation__
 *
 * To run a mutation, you first call `useLedgerDeleteDraftInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerDeleteDraftInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerDeleteDraftInvoiceMutation, { data, loading, error }] = useLedgerDeleteDraftInvoiceMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useLedgerDeleteDraftInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<LedgerDeleteDraftInvoiceMutation, LedgerDeleteDraftInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerDeleteDraftInvoiceMutation, LedgerDeleteDraftInvoiceMutationVariables>(LedgerDeleteDraftInvoiceDocument, options);
      }
export type LedgerDeleteDraftInvoiceMutationHookResult = ReturnType<typeof useLedgerDeleteDraftInvoiceMutation>;
export type LedgerDeleteDraftInvoiceMutationResult = Apollo.MutationResult<LedgerDeleteDraftInvoiceMutation>;
export type LedgerDeleteDraftInvoiceMutationOptions = Apollo.BaseMutationOptions<LedgerDeleteDraftInvoiceMutation, LedgerDeleteDraftInvoiceMutationVariables>;
export const LedgerDuplicateInvoiceDocument = gql`
    mutation LedgerDuplicateInvoice($legalEntityId: String!, $invoiceId: String!) {
  ledgerDuplicateInvoice(legalEntityId: $legalEntityId, invoiceId: $invoiceId)
}
    `;
export type LedgerDuplicateInvoiceMutationFn = Apollo.MutationFunction<LedgerDuplicateInvoiceMutation, LedgerDuplicateInvoiceMutationVariables>;

/**
 * __useLedgerDuplicateInvoiceMutation__
 *
 * To run a mutation, you first call `useLedgerDuplicateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerDuplicateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerDuplicateInvoiceMutation, { data, loading, error }] = useLedgerDuplicateInvoiceMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useLedgerDuplicateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<LedgerDuplicateInvoiceMutation, LedgerDuplicateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerDuplicateInvoiceMutation, LedgerDuplicateInvoiceMutationVariables>(LedgerDuplicateInvoiceDocument, options);
      }
export type LedgerDuplicateInvoiceMutationHookResult = ReturnType<typeof useLedgerDuplicateInvoiceMutation>;
export type LedgerDuplicateInvoiceMutationResult = Apollo.MutationResult<LedgerDuplicateInvoiceMutation>;
export type LedgerDuplicateInvoiceMutationOptions = Apollo.BaseMutationOptions<LedgerDuplicateInvoiceMutation, LedgerDuplicateInvoiceMutationVariables>;
export const LedgerMarkDraftInvoiceAsPaidDocument = gql`
    mutation LedgerMarkDraftInvoiceAsPaid($viewKey: ViewKey!, $legalEntityId: String!, $invoiceId: String!, $internalNote: String, $datePaid: DateTime!, $categoryId: String!, $referenceNumber: String) {
  ledgerMarkDraftInvoiceAsPaid(
    viewKey: $viewKey
    legalEntityId: $legalEntityId
    invoiceId: $invoiceId
    internalNote: $internalNote
    datePaid: $datePaid
    categoryId: $categoryId
    referenceNumber: $referenceNumber
  )
}
    `;
export type LedgerMarkDraftInvoiceAsPaidMutationFn = Apollo.MutationFunction<LedgerMarkDraftInvoiceAsPaidMutation, LedgerMarkDraftInvoiceAsPaidMutationVariables>;

/**
 * __useLedgerMarkDraftInvoiceAsPaidMutation__
 *
 * To run a mutation, you first call `useLedgerMarkDraftInvoiceAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerMarkDraftInvoiceAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerMarkDraftInvoiceAsPaidMutation, { data, loading, error }] = useLedgerMarkDraftInvoiceAsPaidMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      legalEntityId: // value for 'legalEntityId'
 *      invoiceId: // value for 'invoiceId'
 *      internalNote: // value for 'internalNote'
 *      datePaid: // value for 'datePaid'
 *      categoryId: // value for 'categoryId'
 *      referenceNumber: // value for 'referenceNumber'
 *   },
 * });
 */
export function useLedgerMarkDraftInvoiceAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<LedgerMarkDraftInvoiceAsPaidMutation, LedgerMarkDraftInvoiceAsPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerMarkDraftInvoiceAsPaidMutation, LedgerMarkDraftInvoiceAsPaidMutationVariables>(LedgerMarkDraftInvoiceAsPaidDocument, options);
      }
export type LedgerMarkDraftInvoiceAsPaidMutationHookResult = ReturnType<typeof useLedgerMarkDraftInvoiceAsPaidMutation>;
export type LedgerMarkDraftInvoiceAsPaidMutationResult = Apollo.MutationResult<LedgerMarkDraftInvoiceAsPaidMutation>;
export type LedgerMarkDraftInvoiceAsPaidMutationOptions = Apollo.BaseMutationOptions<LedgerMarkDraftInvoiceAsPaidMutation, LedgerMarkDraftInvoiceAsPaidMutationVariables>;
export const LedgerMarkInvoiceAsPaidDocument = gql`
    mutation LedgerMarkInvoiceAsPaid($viewKey: ViewKey!, $legalEntityId: String!, $invoiceId: String!, $internalNote: String, $datePaid: DateTime!, $categoryId: String, $referenceNumber: String) {
  ledgerMarkInvoiceAsPaid(
    viewKey: $viewKey
    legalEntityId: $legalEntityId
    invoiceId: $invoiceId
    internalNote: $internalNote
    datePaid: $datePaid
    categoryId: $categoryId
    referenceNumber: $referenceNumber
  )
}
    `;
export type LedgerMarkInvoiceAsPaidMutationFn = Apollo.MutationFunction<LedgerMarkInvoiceAsPaidMutation, LedgerMarkInvoiceAsPaidMutationVariables>;

/**
 * __useLedgerMarkInvoiceAsPaidMutation__
 *
 * To run a mutation, you first call `useLedgerMarkInvoiceAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerMarkInvoiceAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerMarkInvoiceAsPaidMutation, { data, loading, error }] = useLedgerMarkInvoiceAsPaidMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      legalEntityId: // value for 'legalEntityId'
 *      invoiceId: // value for 'invoiceId'
 *      internalNote: // value for 'internalNote'
 *      datePaid: // value for 'datePaid'
 *      categoryId: // value for 'categoryId'
 *      referenceNumber: // value for 'referenceNumber'
 *   },
 * });
 */
export function useLedgerMarkInvoiceAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<LedgerMarkInvoiceAsPaidMutation, LedgerMarkInvoiceAsPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerMarkInvoiceAsPaidMutation, LedgerMarkInvoiceAsPaidMutationVariables>(LedgerMarkInvoiceAsPaidDocument, options);
      }
export type LedgerMarkInvoiceAsPaidMutationHookResult = ReturnType<typeof useLedgerMarkInvoiceAsPaidMutation>;
export type LedgerMarkInvoiceAsPaidMutationResult = Apollo.MutationResult<LedgerMarkInvoiceAsPaidMutation>;
export type LedgerMarkInvoiceAsPaidMutationOptions = Apollo.BaseMutationOptions<LedgerMarkInvoiceAsPaidMutation, LedgerMarkInvoiceAsPaidMutationVariables>;
export const LedgerPayInvoiceDocument = gql`
    mutation LedgerPayInvoice($legalEntityId: String!, $invoiceId: String!, $paymentInstrumentId: String!, $expectedAmount: InputMonetaryValue!) {
  ledgerPayInvoice(
    legalEntityId: $legalEntityId
    invoiceId: $invoiceId
    paymentInstrumentId: $paymentInstrumentId
    expectedAmount: $expectedAmount
  ) {
    ...PayInvoiceSummaryFields
  }
}
    ${PayInvoiceSummaryFieldsFragmentDoc}`;
export type LedgerPayInvoiceMutationFn = Apollo.MutationFunction<LedgerPayInvoiceMutation, LedgerPayInvoiceMutationVariables>;

/**
 * __useLedgerPayInvoiceMutation__
 *
 * To run a mutation, you first call `useLedgerPayInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerPayInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerPayInvoiceMutation, { data, loading, error }] = useLedgerPayInvoiceMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoiceId: // value for 'invoiceId'
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *      expectedAmount: // value for 'expectedAmount'
 *   },
 * });
 */
export function useLedgerPayInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<LedgerPayInvoiceMutation, LedgerPayInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerPayInvoiceMutation, LedgerPayInvoiceMutationVariables>(LedgerPayInvoiceDocument, options);
      }
export type LedgerPayInvoiceMutationHookResult = ReturnType<typeof useLedgerPayInvoiceMutation>;
export type LedgerPayInvoiceMutationResult = Apollo.MutationResult<LedgerPayInvoiceMutation>;
export type LedgerPayInvoiceMutationOptions = Apollo.BaseMutationOptions<LedgerPayInvoiceMutation, LedgerPayInvoiceMutationVariables>;
export const LedgerResendInvoiceDocument = gql`
    mutation LedgerResendInvoice($legalEntityId: String!, $invoiceId: String!, $invoiceNumber: String!, $invoiceDate: DateTime, $dueDate: DateTime, $totalAmount: InputMonetaryValue!, $companyName: String!, $companyIcon: String, $companyEmail: String, $backgroundColor: String, $coverURL: String, $customerName: String, $customerEmail: String, $referenceNumber: String) {
  ledgerResendInvoice(
    legalEntityId: $legalEntityId
    invoiceId: $invoiceId
    invoiceNumber: $invoiceNumber
    invoiceDate: $invoiceDate
    dueDate: $dueDate
    totalAmount: $totalAmount
    companyName: $companyName
    companyIcon: $companyIcon
    companyEmail: $companyEmail
    backgroundColor: $backgroundColor
    coverURL: $coverURL
    customerName: $customerName
    customerEmail: $customerEmail
    referenceNumber: $referenceNumber
  )
}
    `;
export type LedgerResendInvoiceMutationFn = Apollo.MutationFunction<LedgerResendInvoiceMutation, LedgerResendInvoiceMutationVariables>;

/**
 * __useLedgerResendInvoiceMutation__
 *
 * To run a mutation, you first call `useLedgerResendInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerResendInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerResendInvoiceMutation, { data, loading, error }] = useLedgerResendInvoiceMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoiceId: // value for 'invoiceId'
 *      invoiceNumber: // value for 'invoiceNumber'
 *      invoiceDate: // value for 'invoiceDate'
 *      dueDate: // value for 'dueDate'
 *      totalAmount: // value for 'totalAmount'
 *      companyName: // value for 'companyName'
 *      companyIcon: // value for 'companyIcon'
 *      companyEmail: // value for 'companyEmail'
 *      backgroundColor: // value for 'backgroundColor'
 *      coverURL: // value for 'coverURL'
 *      customerName: // value for 'customerName'
 *      customerEmail: // value for 'customerEmail'
 *      referenceNumber: // value for 'referenceNumber'
 *   },
 * });
 */
export function useLedgerResendInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<LedgerResendInvoiceMutation, LedgerResendInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerResendInvoiceMutation, LedgerResendInvoiceMutationVariables>(LedgerResendInvoiceDocument, options);
      }
export type LedgerResendInvoiceMutationHookResult = ReturnType<typeof useLedgerResendInvoiceMutation>;
export type LedgerResendInvoiceMutationResult = Apollo.MutationResult<LedgerResendInvoiceMutation>;
export type LedgerResendInvoiceMutationOptions = Apollo.BaseMutationOptions<LedgerResendInvoiceMutation, LedgerResendInvoiceMutationVariables>;
export const LedgerResendInvoiceManuallyDocument = gql`
    mutation LedgerResendInvoiceManually($legalEntityId: String!, $invoiceId: String!, $invoiceNumber: String!, $invoiceDate: DateTime, $dueDate: DateTime, $totalAmount: InputMonetaryValue!, $companyName: String!, $companyIcon: String, $companyEmail: String, $backgroundColor: String, $coverURL: String, $customerName: String, $customerEmail: String, $referenceNumber: String) {
  ledgerResendInvoiceManually(
    legalEntityId: $legalEntityId
    invoiceId: $invoiceId
    invoiceNumber: $invoiceNumber
    invoiceDate: $invoiceDate
    dueDate: $dueDate
    totalAmount: $totalAmount
    companyName: $companyName
    companyIcon: $companyIcon
    companyEmail: $companyEmail
    backgroundColor: $backgroundColor
    coverURL: $coverURL
    customerName: $customerName
    customerEmail: $customerEmail
    referenceNumber: $referenceNumber
  )
}
    `;
export type LedgerResendInvoiceManuallyMutationFn = Apollo.MutationFunction<LedgerResendInvoiceManuallyMutation, LedgerResendInvoiceManuallyMutationVariables>;

/**
 * __useLedgerResendInvoiceManuallyMutation__
 *
 * To run a mutation, you first call `useLedgerResendInvoiceManuallyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerResendInvoiceManuallyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerResendInvoiceManuallyMutation, { data, loading, error }] = useLedgerResendInvoiceManuallyMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoiceId: // value for 'invoiceId'
 *      invoiceNumber: // value for 'invoiceNumber'
 *      invoiceDate: // value for 'invoiceDate'
 *      dueDate: // value for 'dueDate'
 *      totalAmount: // value for 'totalAmount'
 *      companyName: // value for 'companyName'
 *      companyIcon: // value for 'companyIcon'
 *      companyEmail: // value for 'companyEmail'
 *      backgroundColor: // value for 'backgroundColor'
 *      coverURL: // value for 'coverURL'
 *      customerName: // value for 'customerName'
 *      customerEmail: // value for 'customerEmail'
 *      referenceNumber: // value for 'referenceNumber'
 *   },
 * });
 */
export function useLedgerResendInvoiceManuallyMutation(baseOptions?: Apollo.MutationHookOptions<LedgerResendInvoiceManuallyMutation, LedgerResendInvoiceManuallyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerResendInvoiceManuallyMutation, LedgerResendInvoiceManuallyMutationVariables>(LedgerResendInvoiceManuallyDocument, options);
      }
export type LedgerResendInvoiceManuallyMutationHookResult = ReturnType<typeof useLedgerResendInvoiceManuallyMutation>;
export type LedgerResendInvoiceManuallyMutationResult = Apollo.MutationResult<LedgerResendInvoiceManuallyMutation>;
export type LedgerResendInvoiceManuallyMutationOptions = Apollo.BaseMutationOptions<LedgerResendInvoiceManuallyMutation, LedgerResendInvoiceManuallyMutationVariables>;
export const LedgerSaveInvoiceDocument = gql`
    mutation LedgerSaveInvoice($legalEntityId: String!, $invoice: LedgerInputInvoice!) {
  ledgerSaveInvoice(legalEntityId: $legalEntityId, invoice: $invoice) {
    ledgerTransactionId
  }
}
    `;
export type LedgerSaveInvoiceMutationFn = Apollo.MutationFunction<LedgerSaveInvoiceMutation, LedgerSaveInvoiceMutationVariables>;

/**
 * __useLedgerSaveInvoiceMutation__
 *
 * To run a mutation, you first call `useLedgerSaveInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerSaveInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerSaveInvoiceMutation, { data, loading, error }] = useLedgerSaveInvoiceMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoice: // value for 'invoice'
 *   },
 * });
 */
export function useLedgerSaveInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<LedgerSaveInvoiceMutation, LedgerSaveInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerSaveInvoiceMutation, LedgerSaveInvoiceMutationVariables>(LedgerSaveInvoiceDocument, options);
      }
export type LedgerSaveInvoiceMutationHookResult = ReturnType<typeof useLedgerSaveInvoiceMutation>;
export type LedgerSaveInvoiceMutationResult = Apollo.MutationResult<LedgerSaveInvoiceMutation>;
export type LedgerSaveInvoiceMutationOptions = Apollo.BaseMutationOptions<LedgerSaveInvoiceMutation, LedgerSaveInvoiceMutationVariables>;
export const LedgerSaveInvoiceCustomerDocument = gql`
    mutation LedgerSaveInvoiceCustomer($legalEntityId: String!, $customer: InputLedgerCustomer!) {
  ledgerSaveInvoiceCustomer(legalEntityId: $legalEntityId, customer: $customer) {
    ...LedgerCustomerDetailFields
  }
}
    ${LedgerCustomerDetailFieldsFragmentDoc}`;
export type LedgerSaveInvoiceCustomerMutationFn = Apollo.MutationFunction<LedgerSaveInvoiceCustomerMutation, LedgerSaveInvoiceCustomerMutationVariables>;

/**
 * __useLedgerSaveInvoiceCustomerMutation__
 *
 * To run a mutation, you first call `useLedgerSaveInvoiceCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerSaveInvoiceCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerSaveInvoiceCustomerMutation, { data, loading, error }] = useLedgerSaveInvoiceCustomerMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useLedgerSaveInvoiceCustomerMutation(baseOptions?: Apollo.MutationHookOptions<LedgerSaveInvoiceCustomerMutation, LedgerSaveInvoiceCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerSaveInvoiceCustomerMutation, LedgerSaveInvoiceCustomerMutationVariables>(LedgerSaveInvoiceCustomerDocument, options);
      }
export type LedgerSaveInvoiceCustomerMutationHookResult = ReturnType<typeof useLedgerSaveInvoiceCustomerMutation>;
export type LedgerSaveInvoiceCustomerMutationResult = Apollo.MutationResult<LedgerSaveInvoiceCustomerMutation>;
export type LedgerSaveInvoiceCustomerMutationOptions = Apollo.BaseMutationOptions<LedgerSaveInvoiceCustomerMutation, LedgerSaveInvoiceCustomerMutationVariables>;
export const LedgerSaveInvoiceDiscountDocument = gql`
    mutation LedgerSaveInvoiceDiscount($legalEntityId: String!, $discount: InputDataSourceDiscount!) {
  ledgerSaveInvoiceDiscount(legalEntityId: $legalEntityId, discount: $discount) {
    ...DiscountFields
  }
}
    ${DiscountFieldsFragmentDoc}`;
export type LedgerSaveInvoiceDiscountMutationFn = Apollo.MutationFunction<LedgerSaveInvoiceDiscountMutation, LedgerSaveInvoiceDiscountMutationVariables>;

/**
 * __useLedgerSaveInvoiceDiscountMutation__
 *
 * To run a mutation, you first call `useLedgerSaveInvoiceDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerSaveInvoiceDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerSaveInvoiceDiscountMutation, { data, loading, error }] = useLedgerSaveInvoiceDiscountMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      discount: // value for 'discount'
 *   },
 * });
 */
export function useLedgerSaveInvoiceDiscountMutation(baseOptions?: Apollo.MutationHookOptions<LedgerSaveInvoiceDiscountMutation, LedgerSaveInvoiceDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerSaveInvoiceDiscountMutation, LedgerSaveInvoiceDiscountMutationVariables>(LedgerSaveInvoiceDiscountDocument, options);
      }
export type LedgerSaveInvoiceDiscountMutationHookResult = ReturnType<typeof useLedgerSaveInvoiceDiscountMutation>;
export type LedgerSaveInvoiceDiscountMutationResult = Apollo.MutationResult<LedgerSaveInvoiceDiscountMutation>;
export type LedgerSaveInvoiceDiscountMutationOptions = Apollo.BaseMutationOptions<LedgerSaveInvoiceDiscountMutation, LedgerSaveInvoiceDiscountMutationVariables>;
export const LedgerSaveInvoiceEmailConfigDocument = gql`
    mutation LedgerSaveInvoiceEmailConfig($legalEntityId: String!, $invoiceId: String!, $recipients: [String!], $cc: [String!], $bcc: [String!], $subject: String, $memo: String) {
  ledgerSaveInvoiceEmailConfig(
    legalEntityId: $legalEntityId
    invoiceId: $invoiceId
    recipients: $recipients
    cc: $cc
    bcc: $bcc
    subject: $subject
    memo: $memo
  )
}
    `;
export type LedgerSaveInvoiceEmailConfigMutationFn = Apollo.MutationFunction<LedgerSaveInvoiceEmailConfigMutation, LedgerSaveInvoiceEmailConfigMutationVariables>;

/**
 * __useLedgerSaveInvoiceEmailConfigMutation__
 *
 * To run a mutation, you first call `useLedgerSaveInvoiceEmailConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerSaveInvoiceEmailConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerSaveInvoiceEmailConfigMutation, { data, loading, error }] = useLedgerSaveInvoiceEmailConfigMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoiceId: // value for 'invoiceId'
 *      recipients: // value for 'recipients'
 *      cc: // value for 'cc'
 *      bcc: // value for 'bcc'
 *      subject: // value for 'subject'
 *      memo: // value for 'memo'
 *   },
 * });
 */
export function useLedgerSaveInvoiceEmailConfigMutation(baseOptions?: Apollo.MutationHookOptions<LedgerSaveInvoiceEmailConfigMutation, LedgerSaveInvoiceEmailConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerSaveInvoiceEmailConfigMutation, LedgerSaveInvoiceEmailConfigMutationVariables>(LedgerSaveInvoiceEmailConfigDocument, options);
      }
export type LedgerSaveInvoiceEmailConfigMutationHookResult = ReturnType<typeof useLedgerSaveInvoiceEmailConfigMutation>;
export type LedgerSaveInvoiceEmailConfigMutationResult = Apollo.MutationResult<LedgerSaveInvoiceEmailConfigMutation>;
export type LedgerSaveInvoiceEmailConfigMutationOptions = Apollo.BaseMutationOptions<LedgerSaveInvoiceEmailConfigMutation, LedgerSaveInvoiceEmailConfigMutationVariables>;
export const LedgerSaveInvoicingProfileDocument = gql`
    mutation LedgerSaveInvoicingProfile($legalEntityId: String!, $profile: InputInvoicingProfile!) {
  ledgerSaveInvoicingProfile(legalEntityId: $legalEntityId, profile: $profile) {
    ...InvoicingProfileFields
  }
}
    ${InvoicingProfileFieldsFragmentDoc}`;
export type LedgerSaveInvoicingProfileMutationFn = Apollo.MutationFunction<LedgerSaveInvoicingProfileMutation, LedgerSaveInvoicingProfileMutationVariables>;

/**
 * __useLedgerSaveInvoicingProfileMutation__
 *
 * To run a mutation, you first call `useLedgerSaveInvoicingProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerSaveInvoicingProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerSaveInvoicingProfileMutation, { data, loading, error }] = useLedgerSaveInvoicingProfileMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useLedgerSaveInvoicingProfileMutation(baseOptions?: Apollo.MutationHookOptions<LedgerSaveInvoicingProfileMutation, LedgerSaveInvoicingProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerSaveInvoicingProfileMutation, LedgerSaveInvoicingProfileMutationVariables>(LedgerSaveInvoicingProfileDocument, options);
      }
export type LedgerSaveInvoicingProfileMutationHookResult = ReturnType<typeof useLedgerSaveInvoicingProfileMutation>;
export type LedgerSaveInvoicingProfileMutationResult = Apollo.MutationResult<LedgerSaveInvoicingProfileMutation>;
export type LedgerSaveInvoicingProfileMutationOptions = Apollo.BaseMutationOptions<LedgerSaveInvoicingProfileMutation, LedgerSaveInvoicingProfileMutationVariables>;
export const LedgerSendInvoiceDocument = gql`
    mutation LedgerSendInvoice($legalEntityId: String!, $invoiceId: String!, $invoiceNumber: String!, $invoiceDate: DateTime, $dueDate: DateTime, $totalAmount: InputMonetaryValue!, $companyName: String!, $companyIcon: String, $companyEmail: String, $backgroundColor: String, $coverURL: String, $customerName: String, $customerEmail: String, $referenceNumber: String) {
  ledgerSendInvoice(
    legalEntityId: $legalEntityId
    invoiceId: $invoiceId
    invoiceNumber: $invoiceNumber
    invoiceDate: $invoiceDate
    dueDate: $dueDate
    totalAmount: $totalAmount
    companyName: $companyName
    companyIcon: $companyIcon
    companyEmail: $companyEmail
    backgroundColor: $backgroundColor
    coverURL: $coverURL
    customerName: $customerName
    customerEmail: $customerEmail
    referenceNumber: $referenceNumber
  )
}
    `;
export type LedgerSendInvoiceMutationFn = Apollo.MutationFunction<LedgerSendInvoiceMutation, LedgerSendInvoiceMutationVariables>;

/**
 * __useLedgerSendInvoiceMutation__
 *
 * To run a mutation, you first call `useLedgerSendInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerSendInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerSendInvoiceMutation, { data, loading, error }] = useLedgerSendInvoiceMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoiceId: // value for 'invoiceId'
 *      invoiceNumber: // value for 'invoiceNumber'
 *      invoiceDate: // value for 'invoiceDate'
 *      dueDate: // value for 'dueDate'
 *      totalAmount: // value for 'totalAmount'
 *      companyName: // value for 'companyName'
 *      companyIcon: // value for 'companyIcon'
 *      companyEmail: // value for 'companyEmail'
 *      backgroundColor: // value for 'backgroundColor'
 *      coverURL: // value for 'coverURL'
 *      customerName: // value for 'customerName'
 *      customerEmail: // value for 'customerEmail'
 *      referenceNumber: // value for 'referenceNumber'
 *   },
 * });
 */
export function useLedgerSendInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<LedgerSendInvoiceMutation, LedgerSendInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerSendInvoiceMutation, LedgerSendInvoiceMutationVariables>(LedgerSendInvoiceDocument, options);
      }
export type LedgerSendInvoiceMutationHookResult = ReturnType<typeof useLedgerSendInvoiceMutation>;
export type LedgerSendInvoiceMutationResult = Apollo.MutationResult<LedgerSendInvoiceMutation>;
export type LedgerSendInvoiceMutationOptions = Apollo.BaseMutationOptions<LedgerSendInvoiceMutation, LedgerSendInvoiceMutationVariables>;
export const LedgerSendInvoiceManuallyDocument = gql`
    mutation LedgerSendInvoiceManually($legalEntityId: String!, $invoiceId: String!, $invoiceNumber: String!, $invoiceDate: DateTime, $dueDate: DateTime, $totalAmount: InputMonetaryValue!, $companyName: String!, $companyIcon: String, $companyEmail: String, $backgroundColor: String, $coverURL: String, $customerName: String, $customerEmail: String, $referenceNumber: String) {
  ledgerSendInvoiceManually(
    legalEntityId: $legalEntityId
    invoiceId: $invoiceId
    invoiceNumber: $invoiceNumber
    invoiceDate: $invoiceDate
    dueDate: $dueDate
    totalAmount: $totalAmount
    companyName: $companyName
    companyIcon: $companyIcon
    companyEmail: $companyEmail
    backgroundColor: $backgroundColor
    coverURL: $coverURL
    customerName: $customerName
    customerEmail: $customerEmail
    referenceNumber: $referenceNumber
  )
}
    `;
export type LedgerSendInvoiceManuallyMutationFn = Apollo.MutationFunction<LedgerSendInvoiceManuallyMutation, LedgerSendInvoiceManuallyMutationVariables>;

/**
 * __useLedgerSendInvoiceManuallyMutation__
 *
 * To run a mutation, you first call `useLedgerSendInvoiceManuallyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerSendInvoiceManuallyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerSendInvoiceManuallyMutation, { data, loading, error }] = useLedgerSendInvoiceManuallyMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoiceId: // value for 'invoiceId'
 *      invoiceNumber: // value for 'invoiceNumber'
 *      invoiceDate: // value for 'invoiceDate'
 *      dueDate: // value for 'dueDate'
 *      totalAmount: // value for 'totalAmount'
 *      companyName: // value for 'companyName'
 *      companyIcon: // value for 'companyIcon'
 *      companyEmail: // value for 'companyEmail'
 *      backgroundColor: // value for 'backgroundColor'
 *      coverURL: // value for 'coverURL'
 *      customerName: // value for 'customerName'
 *      customerEmail: // value for 'customerEmail'
 *      referenceNumber: // value for 'referenceNumber'
 *   },
 * });
 */
export function useLedgerSendInvoiceManuallyMutation(baseOptions?: Apollo.MutationHookOptions<LedgerSendInvoiceManuallyMutation, LedgerSendInvoiceManuallyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerSendInvoiceManuallyMutation, LedgerSendInvoiceManuallyMutationVariables>(LedgerSendInvoiceManuallyDocument, options);
      }
export type LedgerSendInvoiceManuallyMutationHookResult = ReturnType<typeof useLedgerSendInvoiceManuallyMutation>;
export type LedgerSendInvoiceManuallyMutationResult = Apollo.MutationResult<LedgerSendInvoiceManuallyMutation>;
export type LedgerSendInvoiceManuallyMutationOptions = Apollo.BaseMutationOptions<LedgerSendInvoiceManuallyMutation, LedgerSendInvoiceManuallyMutationVariables>;
export const LedgerSetInvoiceBrandingDocument = gql`
    mutation LedgerSetInvoiceBranding($legalEntityId: String!, $invoiceId: String!, $branding: InputInvoiceBranding!) {
  ledgerSetInvoiceBranding(
    legalEntityId: $legalEntityId
    invoiceId: $invoiceId
    branding: $branding
  ) {
    ...InvoiceBrandingFields
  }
}
    ${InvoiceBrandingFieldsFragmentDoc}`;
export type LedgerSetInvoiceBrandingMutationFn = Apollo.MutationFunction<LedgerSetInvoiceBrandingMutation, LedgerSetInvoiceBrandingMutationVariables>;

/**
 * __useLedgerSetInvoiceBrandingMutation__
 *
 * To run a mutation, you first call `useLedgerSetInvoiceBrandingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerSetInvoiceBrandingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerSetInvoiceBrandingMutation, { data, loading, error }] = useLedgerSetInvoiceBrandingMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoiceId: // value for 'invoiceId'
 *      branding: // value for 'branding'
 *   },
 * });
 */
export function useLedgerSetInvoiceBrandingMutation(baseOptions?: Apollo.MutationHookOptions<LedgerSetInvoiceBrandingMutation, LedgerSetInvoiceBrandingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerSetInvoiceBrandingMutation, LedgerSetInvoiceBrandingMutationVariables>(LedgerSetInvoiceBrandingDocument, options);
      }
export type LedgerSetInvoiceBrandingMutationHookResult = ReturnType<typeof useLedgerSetInvoiceBrandingMutation>;
export type LedgerSetInvoiceBrandingMutationResult = Apollo.MutationResult<LedgerSetInvoiceBrandingMutation>;
export type LedgerSetInvoiceBrandingMutationOptions = Apollo.BaseMutationOptions<LedgerSetInvoiceBrandingMutation, LedgerSetInvoiceBrandingMutationVariables>;
export const LedgerVoidInvoiceDocument = gql`
    mutation LedgerVoidInvoice($legalEntityId: String!, $invoiceId: String!, $internalNote: String) {
  ledgerVoidInvoice(
    legalEntityId: $legalEntityId
    invoiceId: $invoiceId
    internalNote: $internalNote
  )
}
    `;
export type LedgerVoidInvoiceMutationFn = Apollo.MutationFunction<LedgerVoidInvoiceMutation, LedgerVoidInvoiceMutationVariables>;

/**
 * __useLedgerVoidInvoiceMutation__
 *
 * To run a mutation, you first call `useLedgerVoidInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLedgerVoidInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ledgerVoidInvoiceMutation, { data, loading, error }] = useLedgerVoidInvoiceMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoiceId: // value for 'invoiceId'
 *      internalNote: // value for 'internalNote'
 *   },
 * });
 */
export function useLedgerVoidInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<LedgerVoidInvoiceMutation, LedgerVoidInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LedgerVoidInvoiceMutation, LedgerVoidInvoiceMutationVariables>(LedgerVoidInvoiceDocument, options);
      }
export type LedgerVoidInvoiceMutationHookResult = ReturnType<typeof useLedgerVoidInvoiceMutation>;
export type LedgerVoidInvoiceMutationResult = Apollo.MutationResult<LedgerVoidInvoiceMutation>;
export type LedgerVoidInvoiceMutationOptions = Apollo.BaseMutationOptions<LedgerVoidInvoiceMutation, LedgerVoidInvoiceMutationVariables>;
export const PayInvoiceDocument = gql`
    mutation PayInvoice($legalEntityId: String!, $invoiceId: String!, $receivableInvoiceId: String, $paymentInstrumentId: String!) {
  payInvoice(
    legalEntityId: $legalEntityId
    invoiceId: $invoiceId
    receivableInvoiceId: $receivableInvoiceId
    paymentInstrumentId: $paymentInstrumentId
  ) {
    ...PayInvoiceSummaryFields
  }
}
    ${PayInvoiceSummaryFieldsFragmentDoc}`;
export type PayInvoiceMutationFn = Apollo.MutationFunction<PayInvoiceMutation, PayInvoiceMutationVariables>;

/**
 * __usePayInvoiceMutation__
 *
 * To run a mutation, you first call `usePayInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payInvoiceMutation, { data, loading, error }] = usePayInvoiceMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoiceId: // value for 'invoiceId'
 *      receivableInvoiceId: // value for 'receivableInvoiceId'
 *      paymentInstrumentId: // value for 'paymentInstrumentId'
 *   },
 * });
 */
export function usePayInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<PayInvoiceMutation, PayInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PayInvoiceMutation, PayInvoiceMutationVariables>(PayInvoiceDocument, options);
      }
export type PayInvoiceMutationHookResult = ReturnType<typeof usePayInvoiceMutation>;
export type PayInvoiceMutationResult = Apollo.MutationResult<PayInvoiceMutation>;
export type PayInvoiceMutationOptions = Apollo.BaseMutationOptions<PayInvoiceMutation, PayInvoiceMutationVariables>;
export const SubmitInvoiceCardPaymentDocument = gql`
    mutation SubmitInvoiceCardPayment($invoiceId: String!, $paymentMethodData: String!, $returnUrl: String!, $browserInfo: String, $riskData: String, $billingAddress: CardBillingAddressInput, $holderName: String, $storePaymentMethod: Boolean, $payerLegalEntityId: String, $requestedTestAcquirerResponseCode: String) {
  submitInvoiceCardPayment(
    invoiceId: $invoiceId
    paymentMethodData: $paymentMethodData
    returnUrl: $returnUrl
    browserInfo: $browserInfo
    riskData: $riskData
    billingAddress: $billingAddress
    holderName: $holderName
    storePaymentMethod: $storePaymentMethod
    payerLegalEntityId: $payerLegalEntityId
    requestedTestAcquirerResponseCode: $requestedTestAcquirerResponseCode
  ) {
    result
    paymentConfirmationId
    pspReference
    actionData
    errorMessage
    refusalReasonCode
    cardBrand
    cardLastFour
  }
}
    `;
export type SubmitInvoiceCardPaymentMutationFn = Apollo.MutationFunction<SubmitInvoiceCardPaymentMutation, SubmitInvoiceCardPaymentMutationVariables>;

/**
 * __useSubmitInvoiceCardPaymentMutation__
 *
 * To run a mutation, you first call `useSubmitInvoiceCardPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitInvoiceCardPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitInvoiceCardPaymentMutation, { data, loading, error }] = useSubmitInvoiceCardPaymentMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      paymentMethodData: // value for 'paymentMethodData'
 *      returnUrl: // value for 'returnUrl'
 *      browserInfo: // value for 'browserInfo'
 *      riskData: // value for 'riskData'
 *      billingAddress: // value for 'billingAddress'
 *      holderName: // value for 'holderName'
 *      storePaymentMethod: // value for 'storePaymentMethod'
 *      payerLegalEntityId: // value for 'payerLegalEntityId'
 *      requestedTestAcquirerResponseCode: // value for 'requestedTestAcquirerResponseCode'
 *   },
 * });
 */
export function useSubmitInvoiceCardPaymentMutation(baseOptions?: Apollo.MutationHookOptions<SubmitInvoiceCardPaymentMutation, SubmitInvoiceCardPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitInvoiceCardPaymentMutation, SubmitInvoiceCardPaymentMutationVariables>(SubmitInvoiceCardPaymentDocument, options);
      }
export type SubmitInvoiceCardPaymentMutationHookResult = ReturnType<typeof useSubmitInvoiceCardPaymentMutation>;
export type SubmitInvoiceCardPaymentMutationResult = Apollo.MutationResult<SubmitInvoiceCardPaymentMutation>;
export type SubmitInvoiceCardPaymentMutationOptions = Apollo.BaseMutationOptions<SubmitInvoiceCardPaymentMutation, SubmitInvoiceCardPaymentMutationVariables>;
export const UploadInvoicingProfileIconDocument = gql`
    mutation UploadInvoicingProfileIcon($orgName: String!, $iconBase64: String!) {
  uploadInvoicingProfileIcon(orgName: $orgName, iconBase64: $iconBase64)
}
    `;
export type UploadInvoicingProfileIconMutationFn = Apollo.MutationFunction<UploadInvoicingProfileIconMutation, UploadInvoicingProfileIconMutationVariables>;

/**
 * __useUploadInvoicingProfileIconMutation__
 *
 * To run a mutation, you first call `useUploadInvoicingProfileIconMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadInvoicingProfileIconMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadInvoicingProfileIconMutation, { data, loading, error }] = useUploadInvoicingProfileIconMutation({
 *   variables: {
 *      orgName: // value for 'orgName'
 *      iconBase64: // value for 'iconBase64'
 *   },
 * });
 */
export function useUploadInvoicingProfileIconMutation(baseOptions?: Apollo.MutationHookOptions<UploadInvoicingProfileIconMutation, UploadInvoicingProfileIconMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadInvoicingProfileIconMutation, UploadInvoicingProfileIconMutationVariables>(UploadInvoicingProfileIconDocument, options);
      }
export type UploadInvoicingProfileIconMutationHookResult = ReturnType<typeof useUploadInvoicingProfileIconMutation>;
export type UploadInvoicingProfileIconMutationResult = Apollo.MutationResult<UploadInvoicingProfileIconMutation>;
export type UploadInvoicingProfileIconMutationOptions = Apollo.BaseMutationOptions<UploadInvoicingProfileIconMutation, UploadInvoicingProfileIconMutationVariables>;
export const LedgerGetDraftInvoiceDefaultsDocument = gql`
    query LedgerGetDraftInvoiceDefaults($legalEntityId: String!, $invoiceProfileId: String!) {
  ledgerGetDraftInvoiceDefaults(
    legalEntityId: $legalEntityId
    invoiceProfileId: $invoiceProfileId
  ) {
    ...InvoiceDefaultsFields
  }
}
    ${InvoiceDefaultsFieldsFragmentDoc}`;

/**
 * __useLedgerGetDraftInvoiceDefaultsQuery__
 *
 * To run a query within a React component, call `useLedgerGetDraftInvoiceDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerGetDraftInvoiceDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerGetDraftInvoiceDefaultsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoiceProfileId: // value for 'invoiceProfileId'
 *   },
 * });
 */
export function useLedgerGetDraftInvoiceDefaultsQuery(baseOptions: Apollo.QueryHookOptions<LedgerGetDraftInvoiceDefaultsQuery, LedgerGetDraftInvoiceDefaultsQueryVariables> & ({ variables: LedgerGetDraftInvoiceDefaultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerGetDraftInvoiceDefaultsQuery, LedgerGetDraftInvoiceDefaultsQueryVariables>(LedgerGetDraftInvoiceDefaultsDocument, options);
      }
export function useLedgerGetDraftInvoiceDefaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerGetDraftInvoiceDefaultsQuery, LedgerGetDraftInvoiceDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerGetDraftInvoiceDefaultsQuery, LedgerGetDraftInvoiceDefaultsQueryVariables>(LedgerGetDraftInvoiceDefaultsDocument, options);
        }
export function useLedgerGetDraftInvoiceDefaultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerGetDraftInvoiceDefaultsQuery, LedgerGetDraftInvoiceDefaultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerGetDraftInvoiceDefaultsQuery, LedgerGetDraftInvoiceDefaultsQueryVariables>(LedgerGetDraftInvoiceDefaultsDocument, options);
        }
export type LedgerGetDraftInvoiceDefaultsQueryHookResult = ReturnType<typeof useLedgerGetDraftInvoiceDefaultsQuery>;
export type LedgerGetDraftInvoiceDefaultsLazyQueryHookResult = ReturnType<typeof useLedgerGetDraftInvoiceDefaultsLazyQuery>;
export type LedgerGetDraftInvoiceDefaultsSuspenseQueryHookResult = ReturnType<typeof useLedgerGetDraftInvoiceDefaultsSuspenseQuery>;
export type LedgerGetDraftInvoiceDefaultsQueryResult = Apollo.QueryResult<LedgerGetDraftInvoiceDefaultsQuery, LedgerGetDraftInvoiceDefaultsQueryVariables>;
export const LedgerGetNextInvoiceNumberDocument = gql`
    query LedgerGetNextInvoiceNumber($legalEntityId: String!, $invoiceProfileId: String!) {
  ledgerGetNextInvoiceNumber(
    legalEntityId: $legalEntityId
    invoiceProfileId: $invoiceProfileId
  ) {
    ...InvoiceNumberFields
  }
}
    ${InvoiceNumberFieldsFragmentDoc}`;

/**
 * __useLedgerGetNextInvoiceNumberQuery__
 *
 * To run a query within a React component, call `useLedgerGetNextInvoiceNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerGetNextInvoiceNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerGetNextInvoiceNumberQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoiceProfileId: // value for 'invoiceProfileId'
 *   },
 * });
 */
export function useLedgerGetNextInvoiceNumberQuery(baseOptions: Apollo.QueryHookOptions<LedgerGetNextInvoiceNumberQuery, LedgerGetNextInvoiceNumberQueryVariables> & ({ variables: LedgerGetNextInvoiceNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerGetNextInvoiceNumberQuery, LedgerGetNextInvoiceNumberQueryVariables>(LedgerGetNextInvoiceNumberDocument, options);
      }
export function useLedgerGetNextInvoiceNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerGetNextInvoiceNumberQuery, LedgerGetNextInvoiceNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerGetNextInvoiceNumberQuery, LedgerGetNextInvoiceNumberQueryVariables>(LedgerGetNextInvoiceNumberDocument, options);
        }
export function useLedgerGetNextInvoiceNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerGetNextInvoiceNumberQuery, LedgerGetNextInvoiceNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerGetNextInvoiceNumberQuery, LedgerGetNextInvoiceNumberQueryVariables>(LedgerGetNextInvoiceNumberDocument, options);
        }
export type LedgerGetNextInvoiceNumberQueryHookResult = ReturnType<typeof useLedgerGetNextInvoiceNumberQuery>;
export type LedgerGetNextInvoiceNumberLazyQueryHookResult = ReturnType<typeof useLedgerGetNextInvoiceNumberLazyQuery>;
export type LedgerGetNextInvoiceNumberSuspenseQueryHookResult = ReturnType<typeof useLedgerGetNextInvoiceNumberSuspenseQuery>;
export type LedgerGetNextInvoiceNumberQueryResult = Apollo.QueryResult<LedgerGetNextInvoiceNumberQuery, LedgerGetNextInvoiceNumberQueryVariables>;
export const LedgerListConnectInvoicesDocument = gql`
    query LedgerListConnectInvoices($viewKey: ViewKey!, $paidSinceDays: Int) {
  ledgerListConnectInvoices(viewKey: $viewKey, paidSinceDays: $paidSinceDays) {
    ...LedgerInvoiceSummaryFields
  }
}
    ${LedgerInvoiceSummaryFieldsFragmentDoc}`;

/**
 * __useLedgerListConnectInvoicesQuery__
 *
 * To run a query within a React component, call `useLedgerListConnectInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerListConnectInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerListConnectInvoicesQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      paidSinceDays: // value for 'paidSinceDays'
 *   },
 * });
 */
export function useLedgerListConnectInvoicesQuery(baseOptions: Apollo.QueryHookOptions<LedgerListConnectInvoicesQuery, LedgerListConnectInvoicesQueryVariables> & ({ variables: LedgerListConnectInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerListConnectInvoicesQuery, LedgerListConnectInvoicesQueryVariables>(LedgerListConnectInvoicesDocument, options);
      }
export function useLedgerListConnectInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerListConnectInvoicesQuery, LedgerListConnectInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerListConnectInvoicesQuery, LedgerListConnectInvoicesQueryVariables>(LedgerListConnectInvoicesDocument, options);
        }
export function useLedgerListConnectInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerListConnectInvoicesQuery, LedgerListConnectInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerListConnectInvoicesQuery, LedgerListConnectInvoicesQueryVariables>(LedgerListConnectInvoicesDocument, options);
        }
export type LedgerListConnectInvoicesQueryHookResult = ReturnType<typeof useLedgerListConnectInvoicesQuery>;
export type LedgerListConnectInvoicesLazyQueryHookResult = ReturnType<typeof useLedgerListConnectInvoicesLazyQuery>;
export type LedgerListConnectInvoicesSuspenseQueryHookResult = ReturnType<typeof useLedgerListConnectInvoicesSuspenseQuery>;
export type LedgerListConnectInvoicesQueryResult = Apollo.QueryResult<LedgerListConnectInvoicesQuery, LedgerListConnectInvoicesQueryVariables>;
export const LedgerListInvoiceWorkflowStatusUpdatesDocument = gql`
    query LedgerListInvoiceWorkflowStatusUpdates($legalEntityId: String!, $invoiceId: String!) {
  ledgerListInvoiceWorkflowStatusUpdates(
    legalEntityId: $legalEntityId
    invoiceId: $invoiceId
  ) {
    id
    status
    statusAt
    statusSource
    internalNote
    user {
      ...EntityUserFields
    }
  }
}
    ${EntityUserFieldsFragmentDoc}`;

/**
 * __useLedgerListInvoiceWorkflowStatusUpdatesQuery__
 *
 * To run a query within a React component, call `useLedgerListInvoiceWorkflowStatusUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerListInvoiceWorkflowStatusUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerListInvoiceWorkflowStatusUpdatesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useLedgerListInvoiceWorkflowStatusUpdatesQuery(baseOptions: Apollo.QueryHookOptions<LedgerListInvoiceWorkflowStatusUpdatesQuery, LedgerListInvoiceWorkflowStatusUpdatesQueryVariables> & ({ variables: LedgerListInvoiceWorkflowStatusUpdatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerListInvoiceWorkflowStatusUpdatesQuery, LedgerListInvoiceWorkflowStatusUpdatesQueryVariables>(LedgerListInvoiceWorkflowStatusUpdatesDocument, options);
      }
export function useLedgerListInvoiceWorkflowStatusUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerListInvoiceWorkflowStatusUpdatesQuery, LedgerListInvoiceWorkflowStatusUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerListInvoiceWorkflowStatusUpdatesQuery, LedgerListInvoiceWorkflowStatusUpdatesQueryVariables>(LedgerListInvoiceWorkflowStatusUpdatesDocument, options);
        }
export function useLedgerListInvoiceWorkflowStatusUpdatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerListInvoiceWorkflowStatusUpdatesQuery, LedgerListInvoiceWorkflowStatusUpdatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerListInvoiceWorkflowStatusUpdatesQuery, LedgerListInvoiceWorkflowStatusUpdatesQueryVariables>(LedgerListInvoiceWorkflowStatusUpdatesDocument, options);
        }
export type LedgerListInvoiceWorkflowStatusUpdatesQueryHookResult = ReturnType<typeof useLedgerListInvoiceWorkflowStatusUpdatesQuery>;
export type LedgerListInvoiceWorkflowStatusUpdatesLazyQueryHookResult = ReturnType<typeof useLedgerListInvoiceWorkflowStatusUpdatesLazyQuery>;
export type LedgerListInvoiceWorkflowStatusUpdatesSuspenseQueryHookResult = ReturnType<typeof useLedgerListInvoiceWorkflowStatusUpdatesSuspenseQuery>;
export type LedgerListInvoiceWorkflowStatusUpdatesQueryResult = Apollo.QueryResult<LedgerListInvoiceWorkflowStatusUpdatesQuery, LedgerListInvoiceWorkflowStatusUpdatesQueryVariables>;
export const LedgerListInvoicesByCustomerDocument = gql`
    query LedgerListInvoicesByCustomer($viewKey: ViewKey!, $customerId: String!) {
  ledgerListInvoicesByCustomer(viewKey: $viewKey, customerId: $customerId) {
    ...LedgerInvoiceSummaryFields
  }
}
    ${LedgerInvoiceSummaryFieldsFragmentDoc}`;

/**
 * __useLedgerListInvoicesByCustomerQuery__
 *
 * To run a query within a React component, call `useLedgerListInvoicesByCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerListInvoicesByCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerListInvoicesByCustomerQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useLedgerListInvoicesByCustomerQuery(baseOptions: Apollo.QueryHookOptions<LedgerListInvoicesByCustomerQuery, LedgerListInvoicesByCustomerQueryVariables> & ({ variables: LedgerListInvoicesByCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerListInvoicesByCustomerQuery, LedgerListInvoicesByCustomerQueryVariables>(LedgerListInvoicesByCustomerDocument, options);
      }
export function useLedgerListInvoicesByCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerListInvoicesByCustomerQuery, LedgerListInvoicesByCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerListInvoicesByCustomerQuery, LedgerListInvoicesByCustomerQueryVariables>(LedgerListInvoicesByCustomerDocument, options);
        }
export function useLedgerListInvoicesByCustomerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerListInvoicesByCustomerQuery, LedgerListInvoicesByCustomerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerListInvoicesByCustomerQuery, LedgerListInvoicesByCustomerQueryVariables>(LedgerListInvoicesByCustomerDocument, options);
        }
export type LedgerListInvoicesByCustomerQueryHookResult = ReturnType<typeof useLedgerListInvoicesByCustomerQuery>;
export type LedgerListInvoicesByCustomerLazyQueryHookResult = ReturnType<typeof useLedgerListInvoicesByCustomerLazyQuery>;
export type LedgerListInvoicesByCustomerSuspenseQueryHookResult = ReturnType<typeof useLedgerListInvoicesByCustomerSuspenseQuery>;
export type LedgerListInvoicesByCustomerQueryResult = Apollo.QueryResult<LedgerListInvoicesByCustomerQuery, LedgerListInvoicesByCustomerQueryVariables>;
export const LedgerListInvoicingProfilesDocument = gql`
    query LedgerListInvoicingProfiles($legalEntityId: String!) {
  ledgerListInvoicingProfiles(legalEntityId: $legalEntityId) {
    ...InvoicingProfileFields
  }
}
    ${InvoicingProfileFieldsFragmentDoc}`;

/**
 * __useLedgerListInvoicingProfilesQuery__
 *
 * To run a query within a React component, call `useLedgerListInvoicingProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerListInvoicingProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerListInvoicingProfilesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useLedgerListInvoicingProfilesQuery(baseOptions: Apollo.QueryHookOptions<LedgerListInvoicingProfilesQuery, LedgerListInvoicingProfilesQueryVariables> & ({ variables: LedgerListInvoicingProfilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerListInvoicingProfilesQuery, LedgerListInvoicingProfilesQueryVariables>(LedgerListInvoicingProfilesDocument, options);
      }
export function useLedgerListInvoicingProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerListInvoicingProfilesQuery, LedgerListInvoicingProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerListInvoicingProfilesQuery, LedgerListInvoicingProfilesQueryVariables>(LedgerListInvoicingProfilesDocument, options);
        }
export function useLedgerListInvoicingProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerListInvoicingProfilesQuery, LedgerListInvoicingProfilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerListInvoicingProfilesQuery, LedgerListInvoicingProfilesQueryVariables>(LedgerListInvoicingProfilesDocument, options);
        }
export type LedgerListInvoicingProfilesQueryHookResult = ReturnType<typeof useLedgerListInvoicingProfilesQuery>;
export type LedgerListInvoicingProfilesLazyQueryHookResult = ReturnType<typeof useLedgerListInvoicingProfilesLazyQuery>;
export type LedgerListInvoicingProfilesSuspenseQueryHookResult = ReturnType<typeof useLedgerListInvoicingProfilesSuspenseQuery>;
export type LedgerListInvoicingProfilesQueryResult = Apollo.QueryResult<LedgerListInvoicingProfilesQuery, LedgerListInvoicingProfilesQueryVariables>;
export const LedgerListPaidInvoicesDocument = gql`
    query LedgerListPaidInvoices($viewKey: ViewKey!, $paidSinceDays: Int) {
  ledgerListPaidInvoices(viewKey: $viewKey, paidSinceDays: $paidSinceDays) {
    ...LedgerInvoiceSummaryFields
  }
}
    ${LedgerInvoiceSummaryFieldsFragmentDoc}`;

/**
 * __useLedgerListPaidInvoicesQuery__
 *
 * To run a query within a React component, call `useLedgerListPaidInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerListPaidInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerListPaidInvoicesQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      paidSinceDays: // value for 'paidSinceDays'
 *   },
 * });
 */
export function useLedgerListPaidInvoicesQuery(baseOptions: Apollo.QueryHookOptions<LedgerListPaidInvoicesQuery, LedgerListPaidInvoicesQueryVariables> & ({ variables: LedgerListPaidInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerListPaidInvoicesQuery, LedgerListPaidInvoicesQueryVariables>(LedgerListPaidInvoicesDocument, options);
      }
export function useLedgerListPaidInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerListPaidInvoicesQuery, LedgerListPaidInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerListPaidInvoicesQuery, LedgerListPaidInvoicesQueryVariables>(LedgerListPaidInvoicesDocument, options);
        }
export function useLedgerListPaidInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerListPaidInvoicesQuery, LedgerListPaidInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerListPaidInvoicesQuery, LedgerListPaidInvoicesQueryVariables>(LedgerListPaidInvoicesDocument, options);
        }
export type LedgerListPaidInvoicesQueryHookResult = ReturnType<typeof useLedgerListPaidInvoicesQuery>;
export type LedgerListPaidInvoicesLazyQueryHookResult = ReturnType<typeof useLedgerListPaidInvoicesLazyQuery>;
export type LedgerListPaidInvoicesSuspenseQueryHookResult = ReturnType<typeof useLedgerListPaidInvoicesSuspenseQuery>;
export type LedgerListPaidInvoicesQueryResult = Apollo.QueryResult<LedgerListPaidInvoicesQuery, LedgerListPaidInvoicesQueryVariables>;
export const LedgerListPendingInvoicesDocument = gql`
    query LedgerListPendingInvoices($viewKey: ViewKey!) {
  ledgerListPendingInvoices(viewKey: $viewKey) {
    ...LedgerInvoiceSummaryFields
  }
}
    ${LedgerInvoiceSummaryFieldsFragmentDoc}`;

/**
 * __useLedgerListPendingInvoicesQuery__
 *
 * To run a query within a React component, call `useLedgerListPendingInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerListPendingInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerListPendingInvoicesQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useLedgerListPendingInvoicesQuery(baseOptions: Apollo.QueryHookOptions<LedgerListPendingInvoicesQuery, LedgerListPendingInvoicesQueryVariables> & ({ variables: LedgerListPendingInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerListPendingInvoicesQuery, LedgerListPendingInvoicesQueryVariables>(LedgerListPendingInvoicesDocument, options);
      }
export function useLedgerListPendingInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerListPendingInvoicesQuery, LedgerListPendingInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerListPendingInvoicesQuery, LedgerListPendingInvoicesQueryVariables>(LedgerListPendingInvoicesDocument, options);
        }
export function useLedgerListPendingInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerListPendingInvoicesQuery, LedgerListPendingInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerListPendingInvoicesQuery, LedgerListPendingInvoicesQueryVariables>(LedgerListPendingInvoicesDocument, options);
        }
export type LedgerListPendingInvoicesQueryHookResult = ReturnType<typeof useLedgerListPendingInvoicesQuery>;
export type LedgerListPendingInvoicesLazyQueryHookResult = ReturnType<typeof useLedgerListPendingInvoicesLazyQuery>;
export type LedgerListPendingInvoicesSuspenseQueryHookResult = ReturnType<typeof useLedgerListPendingInvoicesSuspenseQuery>;
export type LedgerListPendingInvoicesQueryResult = Apollo.QueryResult<LedgerListPendingInvoicesQuery, LedgerListPendingInvoicesQueryVariables>;
export const LedgerListVoidedInvoicesDocument = gql`
    query LedgerListVoidedInvoices($viewKey: ViewKey!) {
  ledgerListVoidedInvoices(viewKey: $viewKey) {
    ...LedgerInvoiceSummaryFields
  }
}
    ${LedgerInvoiceSummaryFieldsFragmentDoc}`;

/**
 * __useLedgerListVoidedInvoicesQuery__
 *
 * To run a query within a React component, call `useLedgerListVoidedInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerListVoidedInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerListVoidedInvoicesQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useLedgerListVoidedInvoicesQuery(baseOptions: Apollo.QueryHookOptions<LedgerListVoidedInvoicesQuery, LedgerListVoidedInvoicesQueryVariables> & ({ variables: LedgerListVoidedInvoicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerListVoidedInvoicesQuery, LedgerListVoidedInvoicesQueryVariables>(LedgerListVoidedInvoicesDocument, options);
      }
export function useLedgerListVoidedInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerListVoidedInvoicesQuery, LedgerListVoidedInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerListVoidedInvoicesQuery, LedgerListVoidedInvoicesQueryVariables>(LedgerListVoidedInvoicesDocument, options);
        }
export function useLedgerListVoidedInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerListVoidedInvoicesQuery, LedgerListVoidedInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerListVoidedInvoicesQuery, LedgerListVoidedInvoicesQueryVariables>(LedgerListVoidedInvoicesDocument, options);
        }
export type LedgerListVoidedInvoicesQueryHookResult = ReturnType<typeof useLedgerListVoidedInvoicesQuery>;
export type LedgerListVoidedInvoicesLazyQueryHookResult = ReturnType<typeof useLedgerListVoidedInvoicesLazyQuery>;
export type LedgerListVoidedInvoicesSuspenseQueryHookResult = ReturnType<typeof useLedgerListVoidedInvoicesSuspenseQuery>;
export type LedgerListVoidedInvoicesQueryResult = Apollo.QueryResult<LedgerListVoidedInvoicesQuery, LedgerListVoidedInvoicesQueryVariables>;
export const LedgerPreviewInputInvoiceEmailDocument = gql`
    query LedgerPreviewInputInvoiceEmail($legalEntityId: String!, $invoice: InputInvoice!, $details: InputInvoiceEmailDetails!) {
  ledgerPreviewInputInvoiceEmail(
    legalEntityId: $legalEntityId
    invoice: $invoice
    details: $details
  )
}
    `;

/**
 * __useLedgerPreviewInputInvoiceEmailQuery__
 *
 * To run a query within a React component, call `useLedgerPreviewInputInvoiceEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerPreviewInputInvoiceEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerPreviewInputInvoiceEmailQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoice: // value for 'invoice'
 *      details: // value for 'details'
 *   },
 * });
 */
export function useLedgerPreviewInputInvoiceEmailQuery(baseOptions: Apollo.QueryHookOptions<LedgerPreviewInputInvoiceEmailQuery, LedgerPreviewInputInvoiceEmailQueryVariables> & ({ variables: LedgerPreviewInputInvoiceEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerPreviewInputInvoiceEmailQuery, LedgerPreviewInputInvoiceEmailQueryVariables>(LedgerPreviewInputInvoiceEmailDocument, options);
      }
export function useLedgerPreviewInputInvoiceEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerPreviewInputInvoiceEmailQuery, LedgerPreviewInputInvoiceEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerPreviewInputInvoiceEmailQuery, LedgerPreviewInputInvoiceEmailQueryVariables>(LedgerPreviewInputInvoiceEmailDocument, options);
        }
export function useLedgerPreviewInputInvoiceEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerPreviewInputInvoiceEmailQuery, LedgerPreviewInputInvoiceEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerPreviewInputInvoiceEmailQuery, LedgerPreviewInputInvoiceEmailQueryVariables>(LedgerPreviewInputInvoiceEmailDocument, options);
        }
export type LedgerPreviewInputInvoiceEmailQueryHookResult = ReturnType<typeof useLedgerPreviewInputInvoiceEmailQuery>;
export type LedgerPreviewInputInvoiceEmailLazyQueryHookResult = ReturnType<typeof useLedgerPreviewInputInvoiceEmailLazyQuery>;
export type LedgerPreviewInputInvoiceEmailSuspenseQueryHookResult = ReturnType<typeof useLedgerPreviewInputInvoiceEmailSuspenseQuery>;
export type LedgerPreviewInputInvoiceEmailQueryResult = Apollo.QueryResult<LedgerPreviewInputInvoiceEmailQuery, LedgerPreviewInputInvoiceEmailQueryVariables>;
export const LedgerPreviewInvoiceEmailDocument = gql`
    query LedgerPreviewInvoiceEmail($legalEntityId: String!, $input: LedgerPreviewInvoiceEmailInput!) {
  ledgerPreviewInvoiceEmail(legalEntityId: $legalEntityId, input: $input)
}
    `;

/**
 * __useLedgerPreviewInvoiceEmailQuery__
 *
 * To run a query within a React component, call `useLedgerPreviewInvoiceEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerPreviewInvoiceEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerPreviewInvoiceEmailQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLedgerPreviewInvoiceEmailQuery(baseOptions: Apollo.QueryHookOptions<LedgerPreviewInvoiceEmailQuery, LedgerPreviewInvoiceEmailQueryVariables> & ({ variables: LedgerPreviewInvoiceEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerPreviewInvoiceEmailQuery, LedgerPreviewInvoiceEmailQueryVariables>(LedgerPreviewInvoiceEmailDocument, options);
      }
export function useLedgerPreviewInvoiceEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerPreviewInvoiceEmailQuery, LedgerPreviewInvoiceEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerPreviewInvoiceEmailQuery, LedgerPreviewInvoiceEmailQueryVariables>(LedgerPreviewInvoiceEmailDocument, options);
        }
export function useLedgerPreviewInvoiceEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerPreviewInvoiceEmailQuery, LedgerPreviewInvoiceEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerPreviewInvoiceEmailQuery, LedgerPreviewInvoiceEmailQueryVariables>(LedgerPreviewInvoiceEmailDocument, options);
        }
export type LedgerPreviewInvoiceEmailQueryHookResult = ReturnType<typeof useLedgerPreviewInvoiceEmailQuery>;
export type LedgerPreviewInvoiceEmailLazyQueryHookResult = ReturnType<typeof useLedgerPreviewInvoiceEmailLazyQuery>;
export type LedgerPreviewInvoiceEmailSuspenseQueryHookResult = ReturnType<typeof useLedgerPreviewInvoiceEmailSuspenseQuery>;
export type LedgerPreviewInvoiceEmailQueryResult = Apollo.QueryResult<LedgerPreviewInvoiceEmailQuery, LedgerPreviewInvoiceEmailQueryVariables>;
export const LedgerReadInvoiceEmailConfigDocument = gql`
    query LedgerReadInvoiceEmailConfig($legalEntityId: String!, $invoiceId: String!, $dataSourcePartyId: String, $profileId: String) {
  ledgerReadInvoiceEmailConfig(
    legalEntityId: $legalEntityId
    invoiceId: $invoiceId
    dataSourcePartyId: $dataSourcePartyId
    profileId: $profileId
  ) {
    invoiceId
    recipients
    cc
    bcc
    subject
    memo
  }
}
    `;

/**
 * __useLedgerReadInvoiceEmailConfigQuery__
 *
 * To run a query within a React component, call `useLedgerReadInvoiceEmailConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerReadInvoiceEmailConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerReadInvoiceEmailConfigQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoiceId: // value for 'invoiceId'
 *      dataSourcePartyId: // value for 'dataSourcePartyId'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useLedgerReadInvoiceEmailConfigQuery(baseOptions: Apollo.QueryHookOptions<LedgerReadInvoiceEmailConfigQuery, LedgerReadInvoiceEmailConfigQueryVariables> & ({ variables: LedgerReadInvoiceEmailConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerReadInvoiceEmailConfigQuery, LedgerReadInvoiceEmailConfigQueryVariables>(LedgerReadInvoiceEmailConfigDocument, options);
      }
export function useLedgerReadInvoiceEmailConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerReadInvoiceEmailConfigQuery, LedgerReadInvoiceEmailConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerReadInvoiceEmailConfigQuery, LedgerReadInvoiceEmailConfigQueryVariables>(LedgerReadInvoiceEmailConfigDocument, options);
        }
export function useLedgerReadInvoiceEmailConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerReadInvoiceEmailConfigQuery, LedgerReadInvoiceEmailConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerReadInvoiceEmailConfigQuery, LedgerReadInvoiceEmailConfigQueryVariables>(LedgerReadInvoiceEmailConfigDocument, options);
        }
export type LedgerReadInvoiceEmailConfigQueryHookResult = ReturnType<typeof useLedgerReadInvoiceEmailConfigQuery>;
export type LedgerReadInvoiceEmailConfigLazyQueryHookResult = ReturnType<typeof useLedgerReadInvoiceEmailConfigLazyQuery>;
export type LedgerReadInvoiceEmailConfigSuspenseQueryHookResult = ReturnType<typeof useLedgerReadInvoiceEmailConfigSuspenseQuery>;
export type LedgerReadInvoiceEmailConfigQueryResult = Apollo.QueryResult<LedgerReadInvoiceEmailConfigQuery, LedgerReadInvoiceEmailConfigQueryVariables>;
export const LedgerReadInvoiceTransactionDocument = gql`
    query LedgerReadInvoiceTransaction($transactionFactId: String, $invoiceId: String, $viewKey: ViewKey!) {
  ledgerReadInvoiceTransaction(
    transactionFactId: $transactionFactId
    invoiceId: $invoiceId
    viewKey: $viewKey
  ) {
    id
    transactionFactId
    arFactId
    arCategory {
      ...EntityCategoryFields
    }
    ledgerTransactionId
    status
    invoiceNumber
    referenceNumber
    invoiceDate
    dueDate
    memo
    customer {
      ...LedgerCustomerDetailFields
    }
    lineItems {
      ...LedgerInvoiceLineItemFields
    }
    invoiceDiscounts {
      ...LedgerInvoiceDiscountFields
    }
    subtotal {
      ...MonetaryValueFields
    }
    totalAmount {
      ...MonetaryValueFields
    }
    branding {
      ...InvoiceBrandingFields
    }
  }
}
    ${EntityCategoryFieldsFragmentDoc}
${LedgerCustomerDetailFieldsFragmentDoc}
${LedgerInvoiceLineItemFieldsFragmentDoc}
${LedgerInvoiceDiscountFieldsFragmentDoc}
${MonetaryValueFieldsFragmentDoc}
${InvoiceBrandingFieldsFragmentDoc}`;

/**
 * __useLedgerReadInvoiceTransactionQuery__
 *
 * To run a query within a React component, call `useLedgerReadInvoiceTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerReadInvoiceTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerReadInvoiceTransactionQuery({
 *   variables: {
 *      transactionFactId: // value for 'transactionFactId'
 *      invoiceId: // value for 'invoiceId'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useLedgerReadInvoiceTransactionQuery(baseOptions: Apollo.QueryHookOptions<LedgerReadInvoiceTransactionQuery, LedgerReadInvoiceTransactionQueryVariables> & ({ variables: LedgerReadInvoiceTransactionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerReadInvoiceTransactionQuery, LedgerReadInvoiceTransactionQueryVariables>(LedgerReadInvoiceTransactionDocument, options);
      }
export function useLedgerReadInvoiceTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerReadInvoiceTransactionQuery, LedgerReadInvoiceTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerReadInvoiceTransactionQuery, LedgerReadInvoiceTransactionQueryVariables>(LedgerReadInvoiceTransactionDocument, options);
        }
export function useLedgerReadInvoiceTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerReadInvoiceTransactionQuery, LedgerReadInvoiceTransactionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerReadInvoiceTransactionQuery, LedgerReadInvoiceTransactionQueryVariables>(LedgerReadInvoiceTransactionDocument, options);
        }
export type LedgerReadInvoiceTransactionQueryHookResult = ReturnType<typeof useLedgerReadInvoiceTransactionQuery>;
export type LedgerReadInvoiceTransactionLazyQueryHookResult = ReturnType<typeof useLedgerReadInvoiceTransactionLazyQuery>;
export type LedgerReadInvoiceTransactionSuspenseQueryHookResult = ReturnType<typeof useLedgerReadInvoiceTransactionSuspenseQuery>;
export type LedgerReadInvoiceTransactionQueryResult = Apollo.QueryResult<LedgerReadInvoiceTransactionQuery, LedgerReadInvoiceTransactionQueryVariables>;
export const LedgerReadSentInvoiceFilesDocument = gql`
    query LedgerReadSentInvoiceFiles($legalEntityId: String!, $id: String!) {
  ledgerReadSentInvoiceFiles(legalEntityId: $legalEntityId, id: $id) {
    ...InvoiceFileFields
  }
}
    ${InvoiceFileFieldsFragmentDoc}`;

/**
 * __useLedgerReadSentInvoiceFilesQuery__
 *
 * To run a query within a React component, call `useLedgerReadSentInvoiceFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerReadSentInvoiceFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerReadSentInvoiceFilesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLedgerReadSentInvoiceFilesQuery(baseOptions: Apollo.QueryHookOptions<LedgerReadSentInvoiceFilesQuery, LedgerReadSentInvoiceFilesQueryVariables> & ({ variables: LedgerReadSentInvoiceFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerReadSentInvoiceFilesQuery, LedgerReadSentInvoiceFilesQueryVariables>(LedgerReadSentInvoiceFilesDocument, options);
      }
export function useLedgerReadSentInvoiceFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerReadSentInvoiceFilesQuery, LedgerReadSentInvoiceFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerReadSentInvoiceFilesQuery, LedgerReadSentInvoiceFilesQueryVariables>(LedgerReadSentInvoiceFilesDocument, options);
        }
export function useLedgerReadSentInvoiceFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerReadSentInvoiceFilesQuery, LedgerReadSentInvoiceFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerReadSentInvoiceFilesQuery, LedgerReadSentInvoiceFilesQueryVariables>(LedgerReadSentInvoiceFilesDocument, options);
        }
export type LedgerReadSentInvoiceFilesQueryHookResult = ReturnType<typeof useLedgerReadSentInvoiceFilesQuery>;
export type LedgerReadSentInvoiceFilesLazyQueryHookResult = ReturnType<typeof useLedgerReadSentInvoiceFilesLazyQuery>;
export type LedgerReadSentInvoiceFilesSuspenseQueryHookResult = ReturnType<typeof useLedgerReadSentInvoiceFilesSuspenseQuery>;
export type LedgerReadSentInvoiceFilesQueryResult = Apollo.QueryResult<LedgerReadSentInvoiceFilesQuery, LedgerReadSentInvoiceFilesQueryVariables>;
export const LedgerSearchInvoiceCustomersDocument = gql`
    query LedgerSearchInvoiceCustomers($legalEntityId: String!, $text: String!) {
  ledgerSearchInvoiceCustomers(legalEntityId: $legalEntityId, text: $text) {
    customers {
      ...LedgerCustomerDetailFields
    }
  }
}
    ${LedgerCustomerDetailFieldsFragmentDoc}`;

/**
 * __useLedgerSearchInvoiceCustomersQuery__
 *
 * To run a query within a React component, call `useLedgerSearchInvoiceCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerSearchInvoiceCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerSearchInvoiceCustomersQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useLedgerSearchInvoiceCustomersQuery(baseOptions: Apollo.QueryHookOptions<LedgerSearchInvoiceCustomersQuery, LedgerSearchInvoiceCustomersQueryVariables> & ({ variables: LedgerSearchInvoiceCustomersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerSearchInvoiceCustomersQuery, LedgerSearchInvoiceCustomersQueryVariables>(LedgerSearchInvoiceCustomersDocument, options);
      }
export function useLedgerSearchInvoiceCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerSearchInvoiceCustomersQuery, LedgerSearchInvoiceCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerSearchInvoiceCustomersQuery, LedgerSearchInvoiceCustomersQueryVariables>(LedgerSearchInvoiceCustomersDocument, options);
        }
export function useLedgerSearchInvoiceCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerSearchInvoiceCustomersQuery, LedgerSearchInvoiceCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerSearchInvoiceCustomersQuery, LedgerSearchInvoiceCustomersQueryVariables>(LedgerSearchInvoiceCustomersDocument, options);
        }
export type LedgerSearchInvoiceCustomersQueryHookResult = ReturnType<typeof useLedgerSearchInvoiceCustomersQuery>;
export type LedgerSearchInvoiceCustomersLazyQueryHookResult = ReturnType<typeof useLedgerSearchInvoiceCustomersLazyQuery>;
export type LedgerSearchInvoiceCustomersSuspenseQueryHookResult = ReturnType<typeof useLedgerSearchInvoiceCustomersSuspenseQuery>;
export type LedgerSearchInvoiceCustomersQueryResult = Apollo.QueryResult<LedgerSearchInvoiceCustomersQuery, LedgerSearchInvoiceCustomersQueryVariables>;
export const LedgerSearchInvoiceDiscountsDocument = gql`
    query LedgerSearchInvoiceDiscounts($legalEntityId: String!, $text: String!) {
  ledgerSearchInvoiceDiscounts(legalEntityId: $legalEntityId, text: $text) {
    ...DiscountFields
  }
}
    ${DiscountFieldsFragmentDoc}`;

/**
 * __useLedgerSearchInvoiceDiscountsQuery__
 *
 * To run a query within a React component, call `useLedgerSearchInvoiceDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerSearchInvoiceDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerSearchInvoiceDiscountsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useLedgerSearchInvoiceDiscountsQuery(baseOptions: Apollo.QueryHookOptions<LedgerSearchInvoiceDiscountsQuery, LedgerSearchInvoiceDiscountsQueryVariables> & ({ variables: LedgerSearchInvoiceDiscountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerSearchInvoiceDiscountsQuery, LedgerSearchInvoiceDiscountsQueryVariables>(LedgerSearchInvoiceDiscountsDocument, options);
      }
export function useLedgerSearchInvoiceDiscountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerSearchInvoiceDiscountsQuery, LedgerSearchInvoiceDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerSearchInvoiceDiscountsQuery, LedgerSearchInvoiceDiscountsQueryVariables>(LedgerSearchInvoiceDiscountsDocument, options);
        }
export function useLedgerSearchInvoiceDiscountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerSearchInvoiceDiscountsQuery, LedgerSearchInvoiceDiscountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerSearchInvoiceDiscountsQuery, LedgerSearchInvoiceDiscountsQueryVariables>(LedgerSearchInvoiceDiscountsDocument, options);
        }
export type LedgerSearchInvoiceDiscountsQueryHookResult = ReturnType<typeof useLedgerSearchInvoiceDiscountsQuery>;
export type LedgerSearchInvoiceDiscountsLazyQueryHookResult = ReturnType<typeof useLedgerSearchInvoiceDiscountsLazyQuery>;
export type LedgerSearchInvoiceDiscountsSuspenseQueryHookResult = ReturnType<typeof useLedgerSearchInvoiceDiscountsSuspenseQuery>;
export type LedgerSearchInvoiceDiscountsQueryResult = Apollo.QueryResult<LedgerSearchInvoiceDiscountsQuery, LedgerSearchInvoiceDiscountsQueryVariables>;
export const LedgerValidateInvoiceNumberDocument = gql`
    query LedgerValidateInvoiceNumber($legalEntityId: String!, $invoiceProfileId: String!, $invoiceNumber: String!) {
  ledgerValidateInvoiceNumber(
    legalEntityId: $legalEntityId
    invoiceProfileId: $invoiceProfileId
    invoiceNumber: $invoiceNumber
  )
}
    `;

/**
 * __useLedgerValidateInvoiceNumberQuery__
 *
 * To run a query within a React component, call `useLedgerValidateInvoiceNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerValidateInvoiceNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerValidateInvoiceNumberQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoiceProfileId: // value for 'invoiceProfileId'
 *      invoiceNumber: // value for 'invoiceNumber'
 *   },
 * });
 */
export function useLedgerValidateInvoiceNumberQuery(baseOptions: Apollo.QueryHookOptions<LedgerValidateInvoiceNumberQuery, LedgerValidateInvoiceNumberQueryVariables> & ({ variables: LedgerValidateInvoiceNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerValidateInvoiceNumberQuery, LedgerValidateInvoiceNumberQueryVariables>(LedgerValidateInvoiceNumberDocument, options);
      }
export function useLedgerValidateInvoiceNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerValidateInvoiceNumberQuery, LedgerValidateInvoiceNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerValidateInvoiceNumberQuery, LedgerValidateInvoiceNumberQueryVariables>(LedgerValidateInvoiceNumberDocument, options);
        }
export function useLedgerValidateInvoiceNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerValidateInvoiceNumberQuery, LedgerValidateInvoiceNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerValidateInvoiceNumberQuery, LedgerValidateInvoiceNumberQueryVariables>(LedgerValidateInvoiceNumberDocument, options);
        }
export type LedgerValidateInvoiceNumberQueryHookResult = ReturnType<typeof useLedgerValidateInvoiceNumberQuery>;
export type LedgerValidateInvoiceNumberLazyQueryHookResult = ReturnType<typeof useLedgerValidateInvoiceNumberLazyQuery>;
export type LedgerValidateInvoiceNumberSuspenseQueryHookResult = ReturnType<typeof useLedgerValidateInvoiceNumberSuspenseQuery>;
export type LedgerValidateInvoiceNumberQueryResult = Apollo.QueryResult<LedgerValidateInvoiceNumberQuery, LedgerValidateInvoiceNumberQueryVariables>;
export const ListInvoicingProfilesDocument = gql`
    query ListInvoicingProfiles($legalEntityId: String!) {
  listInvoicingProfiles(legalEntityId: $legalEntityId) {
    ...InvoicingProfileFields
  }
}
    ${InvoicingProfileFieldsFragmentDoc}`;

/**
 * __useListInvoicingProfilesQuery__
 *
 * To run a query within a React component, call `useListInvoicingProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInvoicingProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInvoicingProfilesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListInvoicingProfilesQuery(baseOptions: Apollo.QueryHookOptions<ListInvoicingProfilesQuery, ListInvoicingProfilesQueryVariables> & ({ variables: ListInvoicingProfilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListInvoicingProfilesQuery, ListInvoicingProfilesQueryVariables>(ListInvoicingProfilesDocument, options);
      }
export function useListInvoicingProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListInvoicingProfilesQuery, ListInvoicingProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListInvoicingProfilesQuery, ListInvoicingProfilesQueryVariables>(ListInvoicingProfilesDocument, options);
        }
export function useListInvoicingProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListInvoicingProfilesQuery, ListInvoicingProfilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListInvoicingProfilesQuery, ListInvoicingProfilesQueryVariables>(ListInvoicingProfilesDocument, options);
        }
export type ListInvoicingProfilesQueryHookResult = ReturnType<typeof useListInvoicingProfilesQuery>;
export type ListInvoicingProfilesLazyQueryHookResult = ReturnType<typeof useListInvoicingProfilesLazyQuery>;
export type ListInvoicingProfilesSuspenseQueryHookResult = ReturnType<typeof useListInvoicingProfilesSuspenseQuery>;
export type ListInvoicingProfilesQueryResult = Apollo.QueryResult<ListInvoicingProfilesQuery, ListInvoicingProfilesQueryVariables>;
export const SaveBusinessVerificationApplicationDocument = gql`
    mutation SaveBusinessVerificationApplication($legalEntityId: String!, $application: BusinessVerificationApplicationInput!) {
  saveBusinessVerificationApplication(
    legalEntityId: $legalEntityId
    application: $application
  )
}
    `;
export type SaveBusinessVerificationApplicationMutationFn = Apollo.MutationFunction<SaveBusinessVerificationApplicationMutation, SaveBusinessVerificationApplicationMutationVariables>;

/**
 * __useSaveBusinessVerificationApplicationMutation__
 *
 * To run a mutation, you first call `useSaveBusinessVerificationApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBusinessVerificationApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBusinessVerificationApplicationMutation, { data, loading, error }] = useSaveBusinessVerificationApplicationMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      application: // value for 'application'
 *   },
 * });
 */
export function useSaveBusinessVerificationApplicationMutation(baseOptions?: Apollo.MutationHookOptions<SaveBusinessVerificationApplicationMutation, SaveBusinessVerificationApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBusinessVerificationApplicationMutation, SaveBusinessVerificationApplicationMutationVariables>(SaveBusinessVerificationApplicationDocument, options);
      }
export type SaveBusinessVerificationApplicationMutationHookResult = ReturnType<typeof useSaveBusinessVerificationApplicationMutation>;
export type SaveBusinessVerificationApplicationMutationResult = Apollo.MutationResult<SaveBusinessVerificationApplicationMutation>;
export type SaveBusinessVerificationApplicationMutationOptions = Apollo.BaseMutationOptions<SaveBusinessVerificationApplicationMutation, SaveBusinessVerificationApplicationMutationVariables>;
export const SendBusinessVerificationApplicationDocument = gql`
    mutation SendBusinessVerificationApplication($legalEntityId: String!, $returnUrl: String!, $ownerSSN: String!, $ownerDOB: DateInput!, $ein: String) {
  sendBusinessVerificationApplication(
    legalEntityId: $legalEntityId
    returnUrl: $returnUrl
    ownerSSN: $ownerSSN
    ownerDOB: $ownerDOB
    ein: $ein
  ) {
    url
  }
}
    `;
export type SendBusinessVerificationApplicationMutationFn = Apollo.MutationFunction<SendBusinessVerificationApplicationMutation, SendBusinessVerificationApplicationMutationVariables>;

/**
 * __useSendBusinessVerificationApplicationMutation__
 *
 * To run a mutation, you first call `useSendBusinessVerificationApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBusinessVerificationApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBusinessVerificationApplicationMutation, { data, loading, error }] = useSendBusinessVerificationApplicationMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      returnUrl: // value for 'returnUrl'
 *      ownerSSN: // value for 'ownerSSN'
 *      ownerDOB: // value for 'ownerDOB'
 *      ein: // value for 'ein'
 *   },
 * });
 */
export function useSendBusinessVerificationApplicationMutation(baseOptions?: Apollo.MutationHookOptions<SendBusinessVerificationApplicationMutation, SendBusinessVerificationApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendBusinessVerificationApplicationMutation, SendBusinessVerificationApplicationMutationVariables>(SendBusinessVerificationApplicationDocument, options);
      }
export type SendBusinessVerificationApplicationMutationHookResult = ReturnType<typeof useSendBusinessVerificationApplicationMutation>;
export type SendBusinessVerificationApplicationMutationResult = Apollo.MutationResult<SendBusinessVerificationApplicationMutation>;
export type SendBusinessVerificationApplicationMutationOptions = Apollo.BaseMutationOptions<SendBusinessVerificationApplicationMutation, SendBusinessVerificationApplicationMutationVariables>;
export const GetBusinessVerificationApplicationDocument = gql`
    query GetBusinessVerificationApplication($legalEntityId: String!) {
  getBusinessVerificationApplication(legalEntityId: $legalEntityId) {
    ...BusinessVerificationApplicationFields
  }
}
    ${BusinessVerificationApplicationFieldsFragmentDoc}`;

/**
 * __useGetBusinessVerificationApplicationQuery__
 *
 * To run a query within a React component, call `useGetBusinessVerificationApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessVerificationApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessVerificationApplicationQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useGetBusinessVerificationApplicationQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessVerificationApplicationQuery, GetBusinessVerificationApplicationQueryVariables> & ({ variables: GetBusinessVerificationApplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessVerificationApplicationQuery, GetBusinessVerificationApplicationQueryVariables>(GetBusinessVerificationApplicationDocument, options);
      }
export function useGetBusinessVerificationApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessVerificationApplicationQuery, GetBusinessVerificationApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessVerificationApplicationQuery, GetBusinessVerificationApplicationQueryVariables>(GetBusinessVerificationApplicationDocument, options);
        }
export function useGetBusinessVerificationApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessVerificationApplicationQuery, GetBusinessVerificationApplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessVerificationApplicationQuery, GetBusinessVerificationApplicationQueryVariables>(GetBusinessVerificationApplicationDocument, options);
        }
export type GetBusinessVerificationApplicationQueryHookResult = ReturnType<typeof useGetBusinessVerificationApplicationQuery>;
export type GetBusinessVerificationApplicationLazyQueryHookResult = ReturnType<typeof useGetBusinessVerificationApplicationLazyQuery>;
export type GetBusinessVerificationApplicationSuspenseQueryHookResult = ReturnType<typeof useGetBusinessVerificationApplicationSuspenseQuery>;
export type GetBusinessVerificationApplicationQueryResult = Apollo.QueryResult<GetBusinessVerificationApplicationQuery, GetBusinessVerificationApplicationQueryVariables>;
export const GetBusinessVerificationStatusDocument = gql`
    query GetBusinessVerificationStatus($legalEntityId: String!) {
  getBusinessVerificationStatus(legalEntityId: $legalEntityId) {
    ...BusinessVerificationStatusResultFields
  }
}
    ${BusinessVerificationStatusResultFieldsFragmentDoc}`;

/**
 * __useGetBusinessVerificationStatusQuery__
 *
 * To run a query within a React component, call `useGetBusinessVerificationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessVerificationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessVerificationStatusQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useGetBusinessVerificationStatusQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessVerificationStatusQuery, GetBusinessVerificationStatusQueryVariables> & ({ variables: GetBusinessVerificationStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessVerificationStatusQuery, GetBusinessVerificationStatusQueryVariables>(GetBusinessVerificationStatusDocument, options);
      }
export function useGetBusinessVerificationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessVerificationStatusQuery, GetBusinessVerificationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessVerificationStatusQuery, GetBusinessVerificationStatusQueryVariables>(GetBusinessVerificationStatusDocument, options);
        }
export function useGetBusinessVerificationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessVerificationStatusQuery, GetBusinessVerificationStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessVerificationStatusQuery, GetBusinessVerificationStatusQueryVariables>(GetBusinessVerificationStatusDocument, options);
        }
export type GetBusinessVerificationStatusQueryHookResult = ReturnType<typeof useGetBusinessVerificationStatusQuery>;
export type GetBusinessVerificationStatusLazyQueryHookResult = ReturnType<typeof useGetBusinessVerificationStatusLazyQuery>;
export type GetBusinessVerificationStatusSuspenseQueryHookResult = ReturnType<typeof useGetBusinessVerificationStatusSuspenseQuery>;
export type GetBusinessVerificationStatusQueryResult = Apollo.QueryResult<GetBusinessVerificationStatusQuery, GetBusinessVerificationStatusQueryVariables>;
export const GetHostedOnboardingLinkDocument = gql`
    query GetHostedOnboardingLink($legalEntityId: String!, $returnURL: String!) {
  getHostedOnboardingLink(legalEntityId: $legalEntityId, returnURL: $returnURL) {
    url
  }
}
    `;

/**
 * __useGetHostedOnboardingLinkQuery__
 *
 * To run a query within a React component, call `useGetHostedOnboardingLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHostedOnboardingLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHostedOnboardingLinkQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      returnURL: // value for 'returnURL'
 *   },
 * });
 */
export function useGetHostedOnboardingLinkQuery(baseOptions: Apollo.QueryHookOptions<GetHostedOnboardingLinkQuery, GetHostedOnboardingLinkQueryVariables> & ({ variables: GetHostedOnboardingLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHostedOnboardingLinkQuery, GetHostedOnboardingLinkQueryVariables>(GetHostedOnboardingLinkDocument, options);
      }
export function useGetHostedOnboardingLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHostedOnboardingLinkQuery, GetHostedOnboardingLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHostedOnboardingLinkQuery, GetHostedOnboardingLinkQueryVariables>(GetHostedOnboardingLinkDocument, options);
        }
export function useGetHostedOnboardingLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHostedOnboardingLinkQuery, GetHostedOnboardingLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHostedOnboardingLinkQuery, GetHostedOnboardingLinkQueryVariables>(GetHostedOnboardingLinkDocument, options);
        }
export type GetHostedOnboardingLinkQueryHookResult = ReturnType<typeof useGetHostedOnboardingLinkQuery>;
export type GetHostedOnboardingLinkLazyQueryHookResult = ReturnType<typeof useGetHostedOnboardingLinkLazyQuery>;
export type GetHostedOnboardingLinkSuspenseQueryHookResult = ReturnType<typeof useGetHostedOnboardingLinkSuspenseQuery>;
export type GetHostedOnboardingLinkQueryResult = Apollo.QueryResult<GetHostedOnboardingLinkQuery, GetHostedOnboardingLinkQueryVariables>;
export const ArchiveComponentDataDocument = gql`
    mutation ArchiveComponentData($layoutId: String!, $viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!) {
  archiveComponentData(layoutId: $layoutId, viewId: $viewId, config: $config)
}
    `;
export type ArchiveComponentDataMutationFn = Apollo.MutationFunction<ArchiveComponentDataMutation, ArchiveComponentDataMutationVariables>;

/**
 * __useArchiveComponentDataMutation__
 *
 * To run a mutation, you first call `useArchiveComponentDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveComponentDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveComponentDataMutation, { data, loading, error }] = useArchiveComponentDataMutation({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useArchiveComponentDataMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveComponentDataMutation, ArchiveComponentDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveComponentDataMutation, ArchiveComponentDataMutationVariables>(ArchiveComponentDataDocument, options);
      }
export type ArchiveComponentDataMutationHookResult = ReturnType<typeof useArchiveComponentDataMutation>;
export type ArchiveComponentDataMutationResult = Apollo.MutationResult<ArchiveComponentDataMutation>;
export type ArchiveComponentDataMutationOptions = Apollo.BaseMutationOptions<ArchiveComponentDataMutation, ArchiveComponentDataMutationVariables>;
export const UpdateLayoutDocument = gql`
    mutation UpdateLayout($viewKey: ViewKey, $layout: LayoutInput!) {
  updateLayout(viewKey: $viewKey, layout: $layout) {
    __typename
    ...LayoutFields
  }
}
    ${LayoutFieldsFragmentDoc}`;
export type UpdateLayoutMutationFn = Apollo.MutationFunction<UpdateLayoutMutation, UpdateLayoutMutationVariables>;

/**
 * __useUpdateLayoutMutation__
 *
 * To run a mutation, you first call `useUpdateLayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLayoutMutation, { data, loading, error }] = useUpdateLayoutMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      layout: // value for 'layout'
 *   },
 * });
 */
export function useUpdateLayoutMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLayoutMutation, UpdateLayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLayoutMutation, UpdateLayoutMutationVariables>(UpdateLayoutDocument, options);
      }
export type UpdateLayoutMutationHookResult = ReturnType<typeof useUpdateLayoutMutation>;
export type UpdateLayoutMutationResult = Apollo.MutationResult<UpdateLayoutMutation>;
export type UpdateLayoutMutationOptions = Apollo.BaseMutationOptions<UpdateLayoutMutation, UpdateLayoutMutationVariables>;
export const UpdateReportLayoutDocument = gql`
    mutation UpdateReportLayout($viewKey: ViewKey!, $packageId: String!, $packageVersionId: String!, $documentId: String!, $layout: LayoutInput!) {
  updateReportLayout(
    viewKey: $viewKey
    packageId: $packageId
    packageVersionId: $packageVersionId
    documentId: $documentId
    layout: $layout
  ) {
    __typename
    ...LayoutFields
  }
}
    ${LayoutFieldsFragmentDoc}`;
export type UpdateReportLayoutMutationFn = Apollo.MutationFunction<UpdateReportLayoutMutation, UpdateReportLayoutMutationVariables>;

/**
 * __useUpdateReportLayoutMutation__
 *
 * To run a mutation, you first call `useUpdateReportLayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportLayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportLayoutMutation, { data, loading, error }] = useUpdateReportLayoutMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      packageId: // value for 'packageId'
 *      packageVersionId: // value for 'packageVersionId'
 *      documentId: // value for 'documentId'
 *      layout: // value for 'layout'
 *   },
 * });
 */
export function useUpdateReportLayoutMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportLayoutMutation, UpdateReportLayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportLayoutMutation, UpdateReportLayoutMutationVariables>(UpdateReportLayoutDocument, options);
      }
export type UpdateReportLayoutMutationHookResult = ReturnType<typeof useUpdateReportLayoutMutation>;
export type UpdateReportLayoutMutationResult = Apollo.MutationResult<UpdateReportLayoutMutation>;
export type UpdateReportLayoutMutationOptions = Apollo.BaseMutationOptions<UpdateReportLayoutMutation, UpdateReportLayoutMutationVariables>;
export const ReadAgingSummaryChartComponentDataDocument = gql`
    query ReadAgingSummaryChartComponentData($layoutId: String!, $dataId: String!, $legalEntityId: String!) {
  readComponentData(
    layoutId: $layoutId
    dataId: $dataId
    legalEntityId: $legalEntityId
  ) {
    viewId {
      ...ViewIdentifierFields
    }
    data {
      __typename
      ... on Chart {
        summary {
          aging {
            summary {
              ...TransactionSummaryFields
            }
          }
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useReadAgingSummaryChartComponentDataQuery__
 *
 * To run a query within a React component, call `useReadAgingSummaryChartComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadAgingSummaryChartComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadAgingSummaryChartComponentDataQuery({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadAgingSummaryChartComponentDataQuery(baseOptions: Apollo.QueryHookOptions<ReadAgingSummaryChartComponentDataQuery, ReadAgingSummaryChartComponentDataQueryVariables> & ({ variables: ReadAgingSummaryChartComponentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadAgingSummaryChartComponentDataQuery, ReadAgingSummaryChartComponentDataQueryVariables>(ReadAgingSummaryChartComponentDataDocument, options);
      }
export function useReadAgingSummaryChartComponentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadAgingSummaryChartComponentDataQuery, ReadAgingSummaryChartComponentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadAgingSummaryChartComponentDataQuery, ReadAgingSummaryChartComponentDataQueryVariables>(ReadAgingSummaryChartComponentDataDocument, options);
        }
export function useReadAgingSummaryChartComponentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadAgingSummaryChartComponentDataQuery, ReadAgingSummaryChartComponentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadAgingSummaryChartComponentDataQuery, ReadAgingSummaryChartComponentDataQueryVariables>(ReadAgingSummaryChartComponentDataDocument, options);
        }
export type ReadAgingSummaryChartComponentDataQueryHookResult = ReturnType<typeof useReadAgingSummaryChartComponentDataQuery>;
export type ReadAgingSummaryChartComponentDataLazyQueryHookResult = ReturnType<typeof useReadAgingSummaryChartComponentDataLazyQuery>;
export type ReadAgingSummaryChartComponentDataSuspenseQueryHookResult = ReturnType<typeof useReadAgingSummaryChartComponentDataSuspenseQuery>;
export type ReadAgingSummaryChartComponentDataQueryResult = Apollo.QueryResult<ReadAgingSummaryChartComponentDataQuery, ReadAgingSummaryChartComponentDataQueryVariables>;
export const ReadAgingSummaryChartLiveDataDocument = gql`
    query ReadAgingSummaryChartLiveData($viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!) {
  liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on Chart {
      summary {
        aging {
          summary {
            ...TransactionSummaryFields
          }
        }
        summary {
          ...TransactionSummaryFields
        }
      }
    }
  }
}
    ${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useReadAgingSummaryChartLiveDataQuery__
 *
 * To run a query within a React component, call `useReadAgingSummaryChartLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadAgingSummaryChartLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadAgingSummaryChartLiveDataQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useReadAgingSummaryChartLiveDataQuery(baseOptions: Apollo.QueryHookOptions<ReadAgingSummaryChartLiveDataQuery, ReadAgingSummaryChartLiveDataQueryVariables> & ({ variables: ReadAgingSummaryChartLiveDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadAgingSummaryChartLiveDataQuery, ReadAgingSummaryChartLiveDataQueryVariables>(ReadAgingSummaryChartLiveDataDocument, options);
      }
export function useReadAgingSummaryChartLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadAgingSummaryChartLiveDataQuery, ReadAgingSummaryChartLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadAgingSummaryChartLiveDataQuery, ReadAgingSummaryChartLiveDataQueryVariables>(ReadAgingSummaryChartLiveDataDocument, options);
        }
export function useReadAgingSummaryChartLiveDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadAgingSummaryChartLiveDataQuery, ReadAgingSummaryChartLiveDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadAgingSummaryChartLiveDataQuery, ReadAgingSummaryChartLiveDataQueryVariables>(ReadAgingSummaryChartLiveDataDocument, options);
        }
export type ReadAgingSummaryChartLiveDataQueryHookResult = ReturnType<typeof useReadAgingSummaryChartLiveDataQuery>;
export type ReadAgingSummaryChartLiveDataLazyQueryHookResult = ReturnType<typeof useReadAgingSummaryChartLiveDataLazyQuery>;
export type ReadAgingSummaryChartLiveDataSuspenseQueryHookResult = ReturnType<typeof useReadAgingSummaryChartLiveDataSuspenseQuery>;
export type ReadAgingSummaryChartLiveDataQueryResult = Apollo.QueryResult<ReadAgingSummaryChartLiveDataQuery, ReadAgingSummaryChartLiveDataQueryVariables>;
export const ReadCashSummaryChartComponentDataDocument = gql`
    query ReadCashSummaryChartComponentData($layoutId: String!, $dataId: String!, $legalEntityId: String!) {
  readComponentData(
    layoutId: $layoutId
    dataId: $dataId
    legalEntityId: $legalEntityId
  ) {
    viewId {
      ...ViewIdentifierFields
    }
    data {
      __typename
      ... on CashSummary {
        ...CashSummaryFields
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${CashSummaryFieldsFragmentDoc}`;

/**
 * __useReadCashSummaryChartComponentDataQuery__
 *
 * To run a query within a React component, call `useReadCashSummaryChartComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadCashSummaryChartComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadCashSummaryChartComponentDataQuery({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadCashSummaryChartComponentDataQuery(baseOptions: Apollo.QueryHookOptions<ReadCashSummaryChartComponentDataQuery, ReadCashSummaryChartComponentDataQueryVariables> & ({ variables: ReadCashSummaryChartComponentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadCashSummaryChartComponentDataQuery, ReadCashSummaryChartComponentDataQueryVariables>(ReadCashSummaryChartComponentDataDocument, options);
      }
export function useReadCashSummaryChartComponentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadCashSummaryChartComponentDataQuery, ReadCashSummaryChartComponentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadCashSummaryChartComponentDataQuery, ReadCashSummaryChartComponentDataQueryVariables>(ReadCashSummaryChartComponentDataDocument, options);
        }
export function useReadCashSummaryChartComponentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadCashSummaryChartComponentDataQuery, ReadCashSummaryChartComponentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadCashSummaryChartComponentDataQuery, ReadCashSummaryChartComponentDataQueryVariables>(ReadCashSummaryChartComponentDataDocument, options);
        }
export type ReadCashSummaryChartComponentDataQueryHookResult = ReturnType<typeof useReadCashSummaryChartComponentDataQuery>;
export type ReadCashSummaryChartComponentDataLazyQueryHookResult = ReturnType<typeof useReadCashSummaryChartComponentDataLazyQuery>;
export type ReadCashSummaryChartComponentDataSuspenseQueryHookResult = ReturnType<typeof useReadCashSummaryChartComponentDataSuspenseQuery>;
export type ReadCashSummaryChartComponentDataQueryResult = Apollo.QueryResult<ReadCashSummaryChartComponentDataQuery, ReadCashSummaryChartComponentDataQueryVariables>;
export const ReadCashSummaryChartLiveDataDocument = gql`
    query ReadCashSummaryChartLiveData($viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!) {
  liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on CashSummary {
      ...CashSummaryFields
    }
  }
}
    ${CashSummaryFieldsFragmentDoc}`;

/**
 * __useReadCashSummaryChartLiveDataQuery__
 *
 * To run a query within a React component, call `useReadCashSummaryChartLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadCashSummaryChartLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadCashSummaryChartLiveDataQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useReadCashSummaryChartLiveDataQuery(baseOptions: Apollo.QueryHookOptions<ReadCashSummaryChartLiveDataQuery, ReadCashSummaryChartLiveDataQueryVariables> & ({ variables: ReadCashSummaryChartLiveDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadCashSummaryChartLiveDataQuery, ReadCashSummaryChartLiveDataQueryVariables>(ReadCashSummaryChartLiveDataDocument, options);
      }
export function useReadCashSummaryChartLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadCashSummaryChartLiveDataQuery, ReadCashSummaryChartLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadCashSummaryChartLiveDataQuery, ReadCashSummaryChartLiveDataQueryVariables>(ReadCashSummaryChartLiveDataDocument, options);
        }
export function useReadCashSummaryChartLiveDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadCashSummaryChartLiveDataQuery, ReadCashSummaryChartLiveDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadCashSummaryChartLiveDataQuery, ReadCashSummaryChartLiveDataQueryVariables>(ReadCashSummaryChartLiveDataDocument, options);
        }
export type ReadCashSummaryChartLiveDataQueryHookResult = ReturnType<typeof useReadCashSummaryChartLiveDataQuery>;
export type ReadCashSummaryChartLiveDataLazyQueryHookResult = ReturnType<typeof useReadCashSummaryChartLiveDataLazyQuery>;
export type ReadCashSummaryChartLiveDataSuspenseQueryHookResult = ReturnType<typeof useReadCashSummaryChartLiveDataSuspenseQuery>;
export type ReadCashSummaryChartLiveDataQueryResult = Apollo.QueryResult<ReadCashSummaryChartLiveDataQuery, ReadCashSummaryChartLiveDataQueryVariables>;
export const ReadCategoryByDepartmentComponentDataDocument = gql`
    query ReadCategoryByDepartmentComponentData($layoutId: String!, $dataId: String!, $legalEntityId: String!) {
  readComponentData(
    layoutId: $layoutId
    dataId: $dataId
    legalEntityId: $legalEntityId
  ) {
    viewId {
      ...ViewIdentifierFields
    }
    data {
      __typename
      ... on Chart {
        entity {
          __typename
          ... on EntityCategory {
            ...EntityCategoryFields
          }
        }
        summary {
          department {
            departmentId
            departmentObject {
              ...EntityDepartmentFields
            }
            by {
              time {
                summary {
                  ...TransactionSummaryFields
                }
              }
            }
          }
          partialData
        }
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}
${EntityDepartmentFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useReadCategoryByDepartmentComponentDataQuery__
 *
 * To run a query within a React component, call `useReadCategoryByDepartmentComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadCategoryByDepartmentComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadCategoryByDepartmentComponentDataQuery({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadCategoryByDepartmentComponentDataQuery(baseOptions: Apollo.QueryHookOptions<ReadCategoryByDepartmentComponentDataQuery, ReadCategoryByDepartmentComponentDataQueryVariables> & ({ variables: ReadCategoryByDepartmentComponentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadCategoryByDepartmentComponentDataQuery, ReadCategoryByDepartmentComponentDataQueryVariables>(ReadCategoryByDepartmentComponentDataDocument, options);
      }
export function useReadCategoryByDepartmentComponentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadCategoryByDepartmentComponentDataQuery, ReadCategoryByDepartmentComponentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadCategoryByDepartmentComponentDataQuery, ReadCategoryByDepartmentComponentDataQueryVariables>(ReadCategoryByDepartmentComponentDataDocument, options);
        }
export function useReadCategoryByDepartmentComponentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadCategoryByDepartmentComponentDataQuery, ReadCategoryByDepartmentComponentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadCategoryByDepartmentComponentDataQuery, ReadCategoryByDepartmentComponentDataQueryVariables>(ReadCategoryByDepartmentComponentDataDocument, options);
        }
export type ReadCategoryByDepartmentComponentDataQueryHookResult = ReturnType<typeof useReadCategoryByDepartmentComponentDataQuery>;
export type ReadCategoryByDepartmentComponentDataLazyQueryHookResult = ReturnType<typeof useReadCategoryByDepartmentComponentDataLazyQuery>;
export type ReadCategoryByDepartmentComponentDataSuspenseQueryHookResult = ReturnType<typeof useReadCategoryByDepartmentComponentDataSuspenseQuery>;
export type ReadCategoryByDepartmentComponentDataQueryResult = Apollo.QueryResult<ReadCategoryByDepartmentComponentDataQuery, ReadCategoryByDepartmentComponentDataQueryVariables>;
export const ReadCategoryByDepartmentChartLiveDataDocument = gql`
    query ReadCategoryByDepartmentChartLiveData($viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!) {
  liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on Chart {
      entity {
        __typename
        ... on EntityCategory {
          ...EntityCategoryFields
        }
      }
      summary {
        department {
          departmentId
          departmentObject {
            ...EntityDepartmentFields
          }
          by {
            time {
              summary {
                ...TransactionSummaryFields
              }
            }
          }
        }
        partialData
      }
    }
  }
}
    ${EntityCategoryFieldsFragmentDoc}
${EntityDepartmentFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useReadCategoryByDepartmentChartLiveDataQuery__
 *
 * To run a query within a React component, call `useReadCategoryByDepartmentChartLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadCategoryByDepartmentChartLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadCategoryByDepartmentChartLiveDataQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useReadCategoryByDepartmentChartLiveDataQuery(baseOptions: Apollo.QueryHookOptions<ReadCategoryByDepartmentChartLiveDataQuery, ReadCategoryByDepartmentChartLiveDataQueryVariables> & ({ variables: ReadCategoryByDepartmentChartLiveDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadCategoryByDepartmentChartLiveDataQuery, ReadCategoryByDepartmentChartLiveDataQueryVariables>(ReadCategoryByDepartmentChartLiveDataDocument, options);
      }
export function useReadCategoryByDepartmentChartLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadCategoryByDepartmentChartLiveDataQuery, ReadCategoryByDepartmentChartLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadCategoryByDepartmentChartLiveDataQuery, ReadCategoryByDepartmentChartLiveDataQueryVariables>(ReadCategoryByDepartmentChartLiveDataDocument, options);
        }
export function useReadCategoryByDepartmentChartLiveDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadCategoryByDepartmentChartLiveDataQuery, ReadCategoryByDepartmentChartLiveDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadCategoryByDepartmentChartLiveDataQuery, ReadCategoryByDepartmentChartLiveDataQueryVariables>(ReadCategoryByDepartmentChartLiveDataDocument, options);
        }
export type ReadCategoryByDepartmentChartLiveDataQueryHookResult = ReturnType<typeof useReadCategoryByDepartmentChartLiveDataQuery>;
export type ReadCategoryByDepartmentChartLiveDataLazyQueryHookResult = ReturnType<typeof useReadCategoryByDepartmentChartLiveDataLazyQuery>;
export type ReadCategoryByDepartmentChartLiveDataSuspenseQueryHookResult = ReturnType<typeof useReadCategoryByDepartmentChartLiveDataSuspenseQuery>;
export type ReadCategoryByDepartmentChartLiveDataQueryResult = Apollo.QueryResult<ReadCategoryByDepartmentChartLiveDataQuery, ReadCategoryByDepartmentChartLiveDataQueryVariables>;
export const ReadCategoryByLocationComponentDataDocument = gql`
    query ReadCategoryByLocationComponentData($layoutId: String!, $dataId: String!, $legalEntityId: String!) {
  readComponentData(
    layoutId: $layoutId
    dataId: $dataId
    legalEntityId: $legalEntityId
  ) {
    viewId {
      ...ViewIdentifierFields
    }
    data {
      __typename
      ... on Chart {
        entity {
          __typename
          ... on EntityCategory {
            ...EntityCategoryFields
          }
        }
        summary {
          location {
            locationId
            locationObject {
              ...EntityLocationFields
            }
            by {
              time {
                summary {
                  ...TransactionSummaryFields
                }
              }
            }
          }
          partialData
        }
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}
${EntityLocationFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useReadCategoryByLocationComponentDataQuery__
 *
 * To run a query within a React component, call `useReadCategoryByLocationComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadCategoryByLocationComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadCategoryByLocationComponentDataQuery({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadCategoryByLocationComponentDataQuery(baseOptions: Apollo.QueryHookOptions<ReadCategoryByLocationComponentDataQuery, ReadCategoryByLocationComponentDataQueryVariables> & ({ variables: ReadCategoryByLocationComponentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadCategoryByLocationComponentDataQuery, ReadCategoryByLocationComponentDataQueryVariables>(ReadCategoryByLocationComponentDataDocument, options);
      }
export function useReadCategoryByLocationComponentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadCategoryByLocationComponentDataQuery, ReadCategoryByLocationComponentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadCategoryByLocationComponentDataQuery, ReadCategoryByLocationComponentDataQueryVariables>(ReadCategoryByLocationComponentDataDocument, options);
        }
export function useReadCategoryByLocationComponentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadCategoryByLocationComponentDataQuery, ReadCategoryByLocationComponentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadCategoryByLocationComponentDataQuery, ReadCategoryByLocationComponentDataQueryVariables>(ReadCategoryByLocationComponentDataDocument, options);
        }
export type ReadCategoryByLocationComponentDataQueryHookResult = ReturnType<typeof useReadCategoryByLocationComponentDataQuery>;
export type ReadCategoryByLocationComponentDataLazyQueryHookResult = ReturnType<typeof useReadCategoryByLocationComponentDataLazyQuery>;
export type ReadCategoryByLocationComponentDataSuspenseQueryHookResult = ReturnType<typeof useReadCategoryByLocationComponentDataSuspenseQuery>;
export type ReadCategoryByLocationComponentDataQueryResult = Apollo.QueryResult<ReadCategoryByLocationComponentDataQuery, ReadCategoryByLocationComponentDataQueryVariables>;
export const ReadCategoryByLocationChartLiveDataDocument = gql`
    query ReadCategoryByLocationChartLiveData($viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!) {
  liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on Chart {
      entity {
        __typename
        ... on EntityCategory {
          ...EntityCategoryFields
        }
      }
      summary {
        location {
          locationId
          locationObject {
            ...EntityLocationFields
          }
          by {
            time {
              summary {
                ...TransactionSummaryFields
              }
            }
          }
        }
        partialData
      }
    }
  }
}
    ${EntityCategoryFieldsFragmentDoc}
${EntityLocationFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useReadCategoryByLocationChartLiveDataQuery__
 *
 * To run a query within a React component, call `useReadCategoryByLocationChartLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadCategoryByLocationChartLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadCategoryByLocationChartLiveDataQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useReadCategoryByLocationChartLiveDataQuery(baseOptions: Apollo.QueryHookOptions<ReadCategoryByLocationChartLiveDataQuery, ReadCategoryByLocationChartLiveDataQueryVariables> & ({ variables: ReadCategoryByLocationChartLiveDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadCategoryByLocationChartLiveDataQuery, ReadCategoryByLocationChartLiveDataQueryVariables>(ReadCategoryByLocationChartLiveDataDocument, options);
      }
export function useReadCategoryByLocationChartLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadCategoryByLocationChartLiveDataQuery, ReadCategoryByLocationChartLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadCategoryByLocationChartLiveDataQuery, ReadCategoryByLocationChartLiveDataQueryVariables>(ReadCategoryByLocationChartLiveDataDocument, options);
        }
export function useReadCategoryByLocationChartLiveDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadCategoryByLocationChartLiveDataQuery, ReadCategoryByLocationChartLiveDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadCategoryByLocationChartLiveDataQuery, ReadCategoryByLocationChartLiveDataQueryVariables>(ReadCategoryByLocationChartLiveDataDocument, options);
        }
export type ReadCategoryByLocationChartLiveDataQueryHookResult = ReturnType<typeof useReadCategoryByLocationChartLiveDataQuery>;
export type ReadCategoryByLocationChartLiveDataLazyQueryHookResult = ReturnType<typeof useReadCategoryByLocationChartLiveDataLazyQuery>;
export type ReadCategoryByLocationChartLiveDataSuspenseQueryHookResult = ReturnType<typeof useReadCategoryByLocationChartLiveDataSuspenseQuery>;
export type ReadCategoryByLocationChartLiveDataQueryResult = Apollo.QueryResult<ReadCategoryByLocationChartLiveDataQuery, ReadCategoryByLocationChartLiveDataQueryVariables>;
export const ReadCategorySummaryByTimeComponentDataDocument = gql`
    query ReadCategorySummaryByTimeComponentData($layoutId: String!, $dataId: String!, $legalEntityId: String!) {
  readComponentData(
    layoutId: $layoutId
    dataId: $dataId
    legalEntityId: $legalEntityId
  ) {
    viewId {
      ...ViewIdentifierFields
    }
    data {
      __typename
      ... on Chart {
        entity {
          __typename
          ... on EntityCategory {
            ...EntityCategoryFields
          }
        }
        summary {
          time {
            summary {
              ...TransactionSummaryFields
            }
          }
          partialData
        }
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useReadCategorySummaryByTimeComponentDataQuery__
 *
 * To run a query within a React component, call `useReadCategorySummaryByTimeComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadCategorySummaryByTimeComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadCategorySummaryByTimeComponentDataQuery({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadCategorySummaryByTimeComponentDataQuery(baseOptions: Apollo.QueryHookOptions<ReadCategorySummaryByTimeComponentDataQuery, ReadCategorySummaryByTimeComponentDataQueryVariables> & ({ variables: ReadCategorySummaryByTimeComponentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadCategorySummaryByTimeComponentDataQuery, ReadCategorySummaryByTimeComponentDataQueryVariables>(ReadCategorySummaryByTimeComponentDataDocument, options);
      }
export function useReadCategorySummaryByTimeComponentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadCategorySummaryByTimeComponentDataQuery, ReadCategorySummaryByTimeComponentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadCategorySummaryByTimeComponentDataQuery, ReadCategorySummaryByTimeComponentDataQueryVariables>(ReadCategorySummaryByTimeComponentDataDocument, options);
        }
export function useReadCategorySummaryByTimeComponentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadCategorySummaryByTimeComponentDataQuery, ReadCategorySummaryByTimeComponentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadCategorySummaryByTimeComponentDataQuery, ReadCategorySummaryByTimeComponentDataQueryVariables>(ReadCategorySummaryByTimeComponentDataDocument, options);
        }
export type ReadCategorySummaryByTimeComponentDataQueryHookResult = ReturnType<typeof useReadCategorySummaryByTimeComponentDataQuery>;
export type ReadCategorySummaryByTimeComponentDataLazyQueryHookResult = ReturnType<typeof useReadCategorySummaryByTimeComponentDataLazyQuery>;
export type ReadCategorySummaryByTimeComponentDataSuspenseQueryHookResult = ReturnType<typeof useReadCategorySummaryByTimeComponentDataSuspenseQuery>;
export type ReadCategorySummaryByTimeComponentDataQueryResult = Apollo.QueryResult<ReadCategorySummaryByTimeComponentDataQuery, ReadCategorySummaryByTimeComponentDataQueryVariables>;
export const ReadCategorySummaryByTimeLiveDataDocument = gql`
    query ReadCategorySummaryByTimeLiveData($viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!) {
  liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on Chart {
      entity {
        __typename
        ... on EntityCategory {
          ...EntityCategoryFields
        }
      }
      summary {
        time {
          summary {
            ...TransactionSummaryFields
          }
        }
        partialData
      }
    }
  }
}
    ${EntityCategoryFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useReadCategorySummaryByTimeLiveDataQuery__
 *
 * To run a query within a React component, call `useReadCategorySummaryByTimeLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadCategorySummaryByTimeLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadCategorySummaryByTimeLiveDataQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useReadCategorySummaryByTimeLiveDataQuery(baseOptions: Apollo.QueryHookOptions<ReadCategorySummaryByTimeLiveDataQuery, ReadCategorySummaryByTimeLiveDataQueryVariables> & ({ variables: ReadCategorySummaryByTimeLiveDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadCategorySummaryByTimeLiveDataQuery, ReadCategorySummaryByTimeLiveDataQueryVariables>(ReadCategorySummaryByTimeLiveDataDocument, options);
      }
export function useReadCategorySummaryByTimeLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadCategorySummaryByTimeLiveDataQuery, ReadCategorySummaryByTimeLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadCategorySummaryByTimeLiveDataQuery, ReadCategorySummaryByTimeLiveDataQueryVariables>(ReadCategorySummaryByTimeLiveDataDocument, options);
        }
export function useReadCategorySummaryByTimeLiveDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadCategorySummaryByTimeLiveDataQuery, ReadCategorySummaryByTimeLiveDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadCategorySummaryByTimeLiveDataQuery, ReadCategorySummaryByTimeLiveDataQueryVariables>(ReadCategorySummaryByTimeLiveDataDocument, options);
        }
export type ReadCategorySummaryByTimeLiveDataQueryHookResult = ReturnType<typeof useReadCategorySummaryByTimeLiveDataQuery>;
export type ReadCategorySummaryByTimeLiveDataLazyQueryHookResult = ReturnType<typeof useReadCategorySummaryByTimeLiveDataLazyQuery>;
export type ReadCategorySummaryByTimeLiveDataSuspenseQueryHookResult = ReturnType<typeof useReadCategorySummaryByTimeLiveDataSuspenseQuery>;
export type ReadCategorySummaryByTimeLiveDataQueryResult = Apollo.QueryResult<ReadCategorySummaryByTimeLiveDataQuery, ReadCategorySummaryByTimeLiveDataQueryVariables>;
export const ReadDepartmentSummaryByTimeComponentDataDocument = gql`
    query ReadDepartmentSummaryByTimeComponentData($layoutId: String!, $dataId: String!, $legalEntityId: String!) {
  readComponentData(
    layoutId: $layoutId
    dataId: $dataId
    legalEntityId: $legalEntityId
  ) {
    viewId {
      ...ViewIdentifierFields
    }
    data {
      __typename
      ... on Chart {
        entity {
          __typename
          ... on EntityDepartment {
            ...EntityDepartmentFields
          }
        }
        summary {
          department {
            departmentId
            departmentObject {
              ...EntityDepartmentFields
            }
            by {
              time {
                summary {
                  ...TransactionSummaryFields
                }
              }
            }
          }
          partialData
        }
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${EntityDepartmentFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useReadDepartmentSummaryByTimeComponentDataQuery__
 *
 * To run a query within a React component, call `useReadDepartmentSummaryByTimeComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadDepartmentSummaryByTimeComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadDepartmentSummaryByTimeComponentDataQuery({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadDepartmentSummaryByTimeComponentDataQuery(baseOptions: Apollo.QueryHookOptions<ReadDepartmentSummaryByTimeComponentDataQuery, ReadDepartmentSummaryByTimeComponentDataQueryVariables> & ({ variables: ReadDepartmentSummaryByTimeComponentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadDepartmentSummaryByTimeComponentDataQuery, ReadDepartmentSummaryByTimeComponentDataQueryVariables>(ReadDepartmentSummaryByTimeComponentDataDocument, options);
      }
export function useReadDepartmentSummaryByTimeComponentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadDepartmentSummaryByTimeComponentDataQuery, ReadDepartmentSummaryByTimeComponentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadDepartmentSummaryByTimeComponentDataQuery, ReadDepartmentSummaryByTimeComponentDataQueryVariables>(ReadDepartmentSummaryByTimeComponentDataDocument, options);
        }
export function useReadDepartmentSummaryByTimeComponentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadDepartmentSummaryByTimeComponentDataQuery, ReadDepartmentSummaryByTimeComponentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadDepartmentSummaryByTimeComponentDataQuery, ReadDepartmentSummaryByTimeComponentDataQueryVariables>(ReadDepartmentSummaryByTimeComponentDataDocument, options);
        }
export type ReadDepartmentSummaryByTimeComponentDataQueryHookResult = ReturnType<typeof useReadDepartmentSummaryByTimeComponentDataQuery>;
export type ReadDepartmentSummaryByTimeComponentDataLazyQueryHookResult = ReturnType<typeof useReadDepartmentSummaryByTimeComponentDataLazyQuery>;
export type ReadDepartmentSummaryByTimeComponentDataSuspenseQueryHookResult = ReturnType<typeof useReadDepartmentSummaryByTimeComponentDataSuspenseQuery>;
export type ReadDepartmentSummaryByTimeComponentDataQueryResult = Apollo.QueryResult<ReadDepartmentSummaryByTimeComponentDataQuery, ReadDepartmentSummaryByTimeComponentDataQueryVariables>;
export const ReadDepartmentSummaryByTimeLiveDataDocument = gql`
    query ReadDepartmentSummaryByTimeLiveData($viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!) {
  liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on Chart {
      entity {
        __typename
        ... on EntityDepartment {
          ...EntityDepartmentFields
        }
      }
      summary {
        department {
          departmentId
          departmentObject {
            ...EntityDepartmentFields
          }
          by {
            time {
              summary {
                ...TransactionSummaryFields
              }
            }
          }
        }
        partialData
      }
    }
  }
}
    ${EntityDepartmentFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useReadDepartmentSummaryByTimeLiveDataQuery__
 *
 * To run a query within a React component, call `useReadDepartmentSummaryByTimeLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadDepartmentSummaryByTimeLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadDepartmentSummaryByTimeLiveDataQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useReadDepartmentSummaryByTimeLiveDataQuery(baseOptions: Apollo.QueryHookOptions<ReadDepartmentSummaryByTimeLiveDataQuery, ReadDepartmentSummaryByTimeLiveDataQueryVariables> & ({ variables: ReadDepartmentSummaryByTimeLiveDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadDepartmentSummaryByTimeLiveDataQuery, ReadDepartmentSummaryByTimeLiveDataQueryVariables>(ReadDepartmentSummaryByTimeLiveDataDocument, options);
      }
export function useReadDepartmentSummaryByTimeLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadDepartmentSummaryByTimeLiveDataQuery, ReadDepartmentSummaryByTimeLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadDepartmentSummaryByTimeLiveDataQuery, ReadDepartmentSummaryByTimeLiveDataQueryVariables>(ReadDepartmentSummaryByTimeLiveDataDocument, options);
        }
export function useReadDepartmentSummaryByTimeLiveDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadDepartmentSummaryByTimeLiveDataQuery, ReadDepartmentSummaryByTimeLiveDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadDepartmentSummaryByTimeLiveDataQuery, ReadDepartmentSummaryByTimeLiveDataQueryVariables>(ReadDepartmentSummaryByTimeLiveDataDocument, options);
        }
export type ReadDepartmentSummaryByTimeLiveDataQueryHookResult = ReturnType<typeof useReadDepartmentSummaryByTimeLiveDataQuery>;
export type ReadDepartmentSummaryByTimeLiveDataLazyQueryHookResult = ReturnType<typeof useReadDepartmentSummaryByTimeLiveDataLazyQuery>;
export type ReadDepartmentSummaryByTimeLiveDataSuspenseQueryHookResult = ReturnType<typeof useReadDepartmentSummaryByTimeLiveDataSuspenseQuery>;
export type ReadDepartmentSummaryByTimeLiveDataQueryResult = Apollo.QueryResult<ReadDepartmentSummaryByTimeLiveDataQuery, ReadDepartmentSummaryByTimeLiveDataQueryVariables>;
export const ReadInsightComponentDataDocument = gql`
    query ReadInsightComponentData($layoutId: String!, $dataId: String!, $legalEntityId: String!, $limit: Int!, $sort: DimensionSortMode) {
  readComponentData(
    layoutId: $layoutId
    dataId: $dataId
    legalEntityId: $legalEntityId
  ) {
    viewId {
      ...ViewIdentifierFields
    }
    data {
      __typename
      ... on InsightComponent {
        __typename
        sentence
        hovers {
          __typename
          ... on CategoryHover {
            ...CategoryHoverFields
          }
          ... on PartyHover {
            ...PartyHoverFields
          }
          ... on SummaryLineItemHover {
            ...SummaryLineItemHoverFields
          }
        }
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${CategoryHoverFieldsFragmentDoc}
${PartyHoverFieldsFragmentDoc}
${SummaryLineItemHoverFieldsFragmentDoc}`;

/**
 * __useReadInsightComponentDataQuery__
 *
 * To run a query within a React component, call `useReadInsightComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadInsightComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadInsightComponentDataQuery({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      legalEntityId: // value for 'legalEntityId'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useReadInsightComponentDataQuery(baseOptions: Apollo.QueryHookOptions<ReadInsightComponentDataQuery, ReadInsightComponentDataQueryVariables> & ({ variables: ReadInsightComponentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadInsightComponentDataQuery, ReadInsightComponentDataQueryVariables>(ReadInsightComponentDataDocument, options);
      }
export function useReadInsightComponentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadInsightComponentDataQuery, ReadInsightComponentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadInsightComponentDataQuery, ReadInsightComponentDataQueryVariables>(ReadInsightComponentDataDocument, options);
        }
export function useReadInsightComponentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadInsightComponentDataQuery, ReadInsightComponentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadInsightComponentDataQuery, ReadInsightComponentDataQueryVariables>(ReadInsightComponentDataDocument, options);
        }
export type ReadInsightComponentDataQueryHookResult = ReturnType<typeof useReadInsightComponentDataQuery>;
export type ReadInsightComponentDataLazyQueryHookResult = ReturnType<typeof useReadInsightComponentDataLazyQuery>;
export type ReadInsightComponentDataSuspenseQueryHookResult = ReturnType<typeof useReadInsightComponentDataSuspenseQuery>;
export type ReadInsightComponentDataQueryResult = Apollo.QueryResult<ReadInsightComponentDataQuery, ReadInsightComponentDataQueryVariables>;
export const ReadInsightLiveDataDocument = gql`
    query ReadInsightLiveData($viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!, $limit: Int!, $sort: DimensionSortMode) {
  liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on InsightComponent {
      __typename
      sentence
      hovers {
        __typename
        ... on CategoryHover {
          ...CategoryHoverFields
        }
        ... on PartyHover {
          ...PartyHoverFields
        }
        ... on SummaryLineItemHover {
          ...SummaryLineItemHoverFields
        }
      }
    }
  }
}
    ${CategoryHoverFieldsFragmentDoc}
${PartyHoverFieldsFragmentDoc}
${SummaryLineItemHoverFieldsFragmentDoc}`;

/**
 * __useReadInsightLiveDataQuery__
 *
 * To run a query within a React component, call `useReadInsightLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadInsightLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadInsightLiveDataQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useReadInsightLiveDataQuery(baseOptions: Apollo.QueryHookOptions<ReadInsightLiveDataQuery, ReadInsightLiveDataQueryVariables> & ({ variables: ReadInsightLiveDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadInsightLiveDataQuery, ReadInsightLiveDataQueryVariables>(ReadInsightLiveDataDocument, options);
      }
export function useReadInsightLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadInsightLiveDataQuery, ReadInsightLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadInsightLiveDataQuery, ReadInsightLiveDataQueryVariables>(ReadInsightLiveDataDocument, options);
        }
export function useReadInsightLiveDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadInsightLiveDataQuery, ReadInsightLiveDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadInsightLiveDataQuery, ReadInsightLiveDataQueryVariables>(ReadInsightLiveDataDocument, options);
        }
export type ReadInsightLiveDataQueryHookResult = ReturnType<typeof useReadInsightLiveDataQuery>;
export type ReadInsightLiveDataLazyQueryHookResult = ReturnType<typeof useReadInsightLiveDataLazyQuery>;
export type ReadInsightLiveDataSuspenseQueryHookResult = ReturnType<typeof useReadInsightLiveDataSuspenseQuery>;
export type ReadInsightLiveDataQueryResult = Apollo.QueryResult<ReadInsightLiveDataQuery, ReadInsightLiveDataQueryVariables>;
export const ReadLayoutDocument = gql`
    query ReadLayout($legalEntityId: String!, $layoutId: String!, $layoutVersionId: String, $includeEntities: Boolean) {
  readLayout(
    legalEntityId: $legalEntityId
    layoutId: $layoutId
    layoutVersionId: $layoutVersionId
    includeEntities: $includeEntities
  ) {
    ...LayoutFields
  }
}
    ${LayoutFieldsFragmentDoc}`;

/**
 * __useReadLayoutQuery__
 *
 * To run a query within a React component, call `useReadLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadLayoutQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      layoutId: // value for 'layoutId'
 *      layoutVersionId: // value for 'layoutVersionId'
 *      includeEntities: // value for 'includeEntities'
 *   },
 * });
 */
export function useReadLayoutQuery(baseOptions: Apollo.QueryHookOptions<ReadLayoutQuery, ReadLayoutQueryVariables> & ({ variables: ReadLayoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadLayoutQuery, ReadLayoutQueryVariables>(ReadLayoutDocument, options);
      }
export function useReadLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadLayoutQuery, ReadLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadLayoutQuery, ReadLayoutQueryVariables>(ReadLayoutDocument, options);
        }
export function useReadLayoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadLayoutQuery, ReadLayoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadLayoutQuery, ReadLayoutQueryVariables>(ReadLayoutDocument, options);
        }
export type ReadLayoutQueryHookResult = ReturnType<typeof useReadLayoutQuery>;
export type ReadLayoutLazyQueryHookResult = ReturnType<typeof useReadLayoutLazyQuery>;
export type ReadLayoutSuspenseQueryHookResult = ReturnType<typeof useReadLayoutSuspenseQuery>;
export type ReadLayoutQueryResult = Apollo.QueryResult<ReadLayoutQuery, ReadLayoutQueryVariables>;
export const ReadLocationChartComponentDataDocument = gql`
    query ReadLocationChartComponentData($layoutId: String!, $dataId: String!, $legalEntityId: String!) {
  readComponentData(
    layoutId: $layoutId
    dataId: $dataId
    legalEntityId: $legalEntityId
  ) {
    viewId {
      ...ViewIdentifierFields
    }
    data {
      __typename
      ... on LocationSummary {
        ...LocationSummaryFields
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${LocationSummaryFieldsFragmentDoc}`;

/**
 * __useReadLocationChartComponentDataQuery__
 *
 * To run a query within a React component, call `useReadLocationChartComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadLocationChartComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadLocationChartComponentDataQuery({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadLocationChartComponentDataQuery(baseOptions: Apollo.QueryHookOptions<ReadLocationChartComponentDataQuery, ReadLocationChartComponentDataQueryVariables> & ({ variables: ReadLocationChartComponentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadLocationChartComponentDataQuery, ReadLocationChartComponentDataQueryVariables>(ReadLocationChartComponentDataDocument, options);
      }
export function useReadLocationChartComponentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadLocationChartComponentDataQuery, ReadLocationChartComponentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadLocationChartComponentDataQuery, ReadLocationChartComponentDataQueryVariables>(ReadLocationChartComponentDataDocument, options);
        }
export function useReadLocationChartComponentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadLocationChartComponentDataQuery, ReadLocationChartComponentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadLocationChartComponentDataQuery, ReadLocationChartComponentDataQueryVariables>(ReadLocationChartComponentDataDocument, options);
        }
export type ReadLocationChartComponentDataQueryHookResult = ReturnType<typeof useReadLocationChartComponentDataQuery>;
export type ReadLocationChartComponentDataLazyQueryHookResult = ReturnType<typeof useReadLocationChartComponentDataLazyQuery>;
export type ReadLocationChartComponentDataSuspenseQueryHookResult = ReturnType<typeof useReadLocationChartComponentDataSuspenseQuery>;
export type ReadLocationChartComponentDataQueryResult = Apollo.QueryResult<ReadLocationChartComponentDataQuery, ReadLocationChartComponentDataQueryVariables>;
export const ReadLocationChartLiveDataDocument = gql`
    query ReadLocationChartLiveData($viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!) {
  liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on LocationSummary {
      ...LocationSummaryFields
    }
  }
}
    ${LocationSummaryFieldsFragmentDoc}`;

/**
 * __useReadLocationChartLiveDataQuery__
 *
 * To run a query within a React component, call `useReadLocationChartLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadLocationChartLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadLocationChartLiveDataQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useReadLocationChartLiveDataQuery(baseOptions: Apollo.QueryHookOptions<ReadLocationChartLiveDataQuery, ReadLocationChartLiveDataQueryVariables> & ({ variables: ReadLocationChartLiveDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadLocationChartLiveDataQuery, ReadLocationChartLiveDataQueryVariables>(ReadLocationChartLiveDataDocument, options);
      }
export function useReadLocationChartLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadLocationChartLiveDataQuery, ReadLocationChartLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadLocationChartLiveDataQuery, ReadLocationChartLiveDataQueryVariables>(ReadLocationChartLiveDataDocument, options);
        }
export function useReadLocationChartLiveDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadLocationChartLiveDataQuery, ReadLocationChartLiveDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadLocationChartLiveDataQuery, ReadLocationChartLiveDataQueryVariables>(ReadLocationChartLiveDataDocument, options);
        }
export type ReadLocationChartLiveDataQueryHookResult = ReturnType<typeof useReadLocationChartLiveDataQuery>;
export type ReadLocationChartLiveDataLazyQueryHookResult = ReturnType<typeof useReadLocationChartLiveDataLazyQuery>;
export type ReadLocationChartLiveDataSuspenseQueryHookResult = ReturnType<typeof useReadLocationChartLiveDataSuspenseQuery>;
export type ReadLocationChartLiveDataQueryResult = Apollo.QueryResult<ReadLocationChartLiveDataQuery, ReadLocationChartLiveDataQueryVariables>;
export const ReadMetricByTimeComponentDataDocument = gql`
    query ReadMetricByTimeComponentData($layoutId: String!, $dataId: String!, $legalEntityId: String!) {
  readComponentData(
    layoutId: $layoutId
    dataId: $dataId
    legalEntityId: $legalEntityId
  ) {
    viewId {
      ...ViewIdentifierFields
    }
    data {
      __typename
      ... on DimensionSummary {
        time {
          summary {
            ...TransactionSummaryFields
          }
        }
        partialData
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useReadMetricByTimeComponentDataQuery__
 *
 * To run a query within a React component, call `useReadMetricByTimeComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadMetricByTimeComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadMetricByTimeComponentDataQuery({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadMetricByTimeComponentDataQuery(baseOptions: Apollo.QueryHookOptions<ReadMetricByTimeComponentDataQuery, ReadMetricByTimeComponentDataQueryVariables> & ({ variables: ReadMetricByTimeComponentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadMetricByTimeComponentDataQuery, ReadMetricByTimeComponentDataQueryVariables>(ReadMetricByTimeComponentDataDocument, options);
      }
export function useReadMetricByTimeComponentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadMetricByTimeComponentDataQuery, ReadMetricByTimeComponentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadMetricByTimeComponentDataQuery, ReadMetricByTimeComponentDataQueryVariables>(ReadMetricByTimeComponentDataDocument, options);
        }
export function useReadMetricByTimeComponentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadMetricByTimeComponentDataQuery, ReadMetricByTimeComponentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadMetricByTimeComponentDataQuery, ReadMetricByTimeComponentDataQueryVariables>(ReadMetricByTimeComponentDataDocument, options);
        }
export type ReadMetricByTimeComponentDataQueryHookResult = ReturnType<typeof useReadMetricByTimeComponentDataQuery>;
export type ReadMetricByTimeComponentDataLazyQueryHookResult = ReturnType<typeof useReadMetricByTimeComponentDataLazyQuery>;
export type ReadMetricByTimeComponentDataSuspenseQueryHookResult = ReturnType<typeof useReadMetricByTimeComponentDataSuspenseQuery>;
export type ReadMetricByTimeComponentDataQueryResult = Apollo.QueryResult<ReadMetricByTimeComponentDataQuery, ReadMetricByTimeComponentDataQueryVariables>;
export const ReadMetricByTimeLiveDataDocument = gql`
    query ReadMetricByTimeLiveData($viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!) {
  liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on DimensionSummary {
      time {
        summary {
          ...TransactionSummaryFields
        }
      }
      partialData
    }
  }
}
    ${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useReadMetricByTimeLiveDataQuery__
 *
 * To run a query within a React component, call `useReadMetricByTimeLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadMetricByTimeLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadMetricByTimeLiveDataQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useReadMetricByTimeLiveDataQuery(baseOptions: Apollo.QueryHookOptions<ReadMetricByTimeLiveDataQuery, ReadMetricByTimeLiveDataQueryVariables> & ({ variables: ReadMetricByTimeLiveDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadMetricByTimeLiveDataQuery, ReadMetricByTimeLiveDataQueryVariables>(ReadMetricByTimeLiveDataDocument, options);
      }
export function useReadMetricByTimeLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadMetricByTimeLiveDataQuery, ReadMetricByTimeLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadMetricByTimeLiveDataQuery, ReadMetricByTimeLiveDataQueryVariables>(ReadMetricByTimeLiveDataDocument, options);
        }
export function useReadMetricByTimeLiveDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadMetricByTimeLiveDataQuery, ReadMetricByTimeLiveDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadMetricByTimeLiveDataQuery, ReadMetricByTimeLiveDataQueryVariables>(ReadMetricByTimeLiveDataDocument, options);
        }
export type ReadMetricByTimeLiveDataQueryHookResult = ReturnType<typeof useReadMetricByTimeLiveDataQuery>;
export type ReadMetricByTimeLiveDataLazyQueryHookResult = ReturnType<typeof useReadMetricByTimeLiveDataLazyQuery>;
export type ReadMetricByTimeLiveDataSuspenseQueryHookResult = ReturnType<typeof useReadMetricByTimeLiveDataSuspenseQuery>;
export type ReadMetricByTimeLiveDataQueryResult = Apollo.QueryResult<ReadMetricByTimeLiveDataQuery, ReadMetricByTimeLiveDataQueryVariables>;
export const ReadPartySummaryByTimeComponentDataDocument = gql`
    query ReadPartySummaryByTimeComponentData($layoutId: String!, $dataId: String!, $legalEntityId: String!) {
  readComponentData(
    layoutId: $layoutId
    dataId: $dataId
    legalEntityId: $legalEntityId
  ) {
    viewId {
      ...ViewIdentifierFields
    }
    data {
      __typename
      ... on Chart {
        entity {
          __typename
          ... on EntityParty {
            ...EntityPartyFields
          }
        }
        summary {
          time {
            summary {
              ...TransactionSummaryFields
            }
          }
          partialData
        }
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useReadPartySummaryByTimeComponentDataQuery__
 *
 * To run a query within a React component, call `useReadPartySummaryByTimeComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadPartySummaryByTimeComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadPartySummaryByTimeComponentDataQuery({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadPartySummaryByTimeComponentDataQuery(baseOptions: Apollo.QueryHookOptions<ReadPartySummaryByTimeComponentDataQuery, ReadPartySummaryByTimeComponentDataQueryVariables> & ({ variables: ReadPartySummaryByTimeComponentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadPartySummaryByTimeComponentDataQuery, ReadPartySummaryByTimeComponentDataQueryVariables>(ReadPartySummaryByTimeComponentDataDocument, options);
      }
export function useReadPartySummaryByTimeComponentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadPartySummaryByTimeComponentDataQuery, ReadPartySummaryByTimeComponentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadPartySummaryByTimeComponentDataQuery, ReadPartySummaryByTimeComponentDataQueryVariables>(ReadPartySummaryByTimeComponentDataDocument, options);
        }
export function useReadPartySummaryByTimeComponentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadPartySummaryByTimeComponentDataQuery, ReadPartySummaryByTimeComponentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadPartySummaryByTimeComponentDataQuery, ReadPartySummaryByTimeComponentDataQueryVariables>(ReadPartySummaryByTimeComponentDataDocument, options);
        }
export type ReadPartySummaryByTimeComponentDataQueryHookResult = ReturnType<typeof useReadPartySummaryByTimeComponentDataQuery>;
export type ReadPartySummaryByTimeComponentDataLazyQueryHookResult = ReturnType<typeof useReadPartySummaryByTimeComponentDataLazyQuery>;
export type ReadPartySummaryByTimeComponentDataSuspenseQueryHookResult = ReturnType<typeof useReadPartySummaryByTimeComponentDataSuspenseQuery>;
export type ReadPartySummaryByTimeComponentDataQueryResult = Apollo.QueryResult<ReadPartySummaryByTimeComponentDataQuery, ReadPartySummaryByTimeComponentDataQueryVariables>;
export const ReadPartySummaryByTimeLiveDataDocument = gql`
    query ReadPartySummaryByTimeLiveData($viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!) {
  liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on Chart {
      entity {
        __typename
        ... on EntityParty {
          ...EntityPartyFields
        }
      }
      summary {
        time {
          summary {
            ...TransactionSummaryFields
          }
        }
        partialData
      }
    }
  }
}
    ${EntityPartyFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useReadPartySummaryByTimeLiveDataQuery__
 *
 * To run a query within a React component, call `useReadPartySummaryByTimeLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadPartySummaryByTimeLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadPartySummaryByTimeLiveDataQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useReadPartySummaryByTimeLiveDataQuery(baseOptions: Apollo.QueryHookOptions<ReadPartySummaryByTimeLiveDataQuery, ReadPartySummaryByTimeLiveDataQueryVariables> & ({ variables: ReadPartySummaryByTimeLiveDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadPartySummaryByTimeLiveDataQuery, ReadPartySummaryByTimeLiveDataQueryVariables>(ReadPartySummaryByTimeLiveDataDocument, options);
      }
export function useReadPartySummaryByTimeLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadPartySummaryByTimeLiveDataQuery, ReadPartySummaryByTimeLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadPartySummaryByTimeLiveDataQuery, ReadPartySummaryByTimeLiveDataQueryVariables>(ReadPartySummaryByTimeLiveDataDocument, options);
        }
export function useReadPartySummaryByTimeLiveDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadPartySummaryByTimeLiveDataQuery, ReadPartySummaryByTimeLiveDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadPartySummaryByTimeLiveDataQuery, ReadPartySummaryByTimeLiveDataQueryVariables>(ReadPartySummaryByTimeLiveDataDocument, options);
        }
export type ReadPartySummaryByTimeLiveDataQueryHookResult = ReturnType<typeof useReadPartySummaryByTimeLiveDataQuery>;
export type ReadPartySummaryByTimeLiveDataLazyQueryHookResult = ReturnType<typeof useReadPartySummaryByTimeLiveDataLazyQuery>;
export type ReadPartySummaryByTimeLiveDataSuspenseQueryHookResult = ReturnType<typeof useReadPartySummaryByTimeLiveDataSuspenseQuery>;
export type ReadPartySummaryByTimeLiveDataQueryResult = Apollo.QueryResult<ReadPartySummaryByTimeLiveDataQuery, ReadPartySummaryByTimeLiveDataQueryVariables>;
export const ReadReportStatementComponentDataDocument = gql`
    query ReadReportStatementComponentData($layoutId: String!, $dataId: String!, $legalEntityId: String!, $limit: Int!, $sort: DimensionSortMode, $timeHistory: Boolean!, $departmentHistory: Boolean!, $locationHistory: Boolean!) {
  readComponentData(
    layoutId: $layoutId
    dataId: $dataId
    legalEntityId: $legalEntityId
  ) {
    viewId {
      ...ViewIdentifierFields
    }
    data {
      __typename
      ... on Statement {
        ...StatementFields
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${StatementFieldsFragmentDoc}`;

/**
 * __useReadReportStatementComponentDataQuery__
 *
 * To run a query within a React component, call `useReadReportStatementComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadReportStatementComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadReportStatementComponentDataQuery({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      legalEntityId: // value for 'legalEntityId'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      timeHistory: // value for 'timeHistory'
 *      departmentHistory: // value for 'departmentHistory'
 *      locationHistory: // value for 'locationHistory'
 *   },
 * });
 */
export function useReadReportStatementComponentDataQuery(baseOptions: Apollo.QueryHookOptions<ReadReportStatementComponentDataQuery, ReadReportStatementComponentDataQueryVariables> & ({ variables: ReadReportStatementComponentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadReportStatementComponentDataQuery, ReadReportStatementComponentDataQueryVariables>(ReadReportStatementComponentDataDocument, options);
      }
export function useReadReportStatementComponentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadReportStatementComponentDataQuery, ReadReportStatementComponentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadReportStatementComponentDataQuery, ReadReportStatementComponentDataQueryVariables>(ReadReportStatementComponentDataDocument, options);
        }
export function useReadReportStatementComponentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadReportStatementComponentDataQuery, ReadReportStatementComponentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadReportStatementComponentDataQuery, ReadReportStatementComponentDataQueryVariables>(ReadReportStatementComponentDataDocument, options);
        }
export type ReadReportStatementComponentDataQueryHookResult = ReturnType<typeof useReadReportStatementComponentDataQuery>;
export type ReadReportStatementComponentDataLazyQueryHookResult = ReturnType<typeof useReadReportStatementComponentDataLazyQuery>;
export type ReadReportStatementComponentDataSuspenseQueryHookResult = ReturnType<typeof useReadReportStatementComponentDataSuspenseQuery>;
export type ReadReportStatementComponentDataQueryResult = Apollo.QueryResult<ReadReportStatementComponentDataQuery, ReadReportStatementComponentDataQueryVariables>;
export const ReadReportStatementLiveDataDocument = gql`
    query ReadReportStatementLiveData($viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!, $limit: Int!, $sort: DimensionSortMode, $timeHistory: Boolean!, $departmentHistory: Boolean!, $locationHistory: Boolean!) {
  liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on Statement {
      ...StatementFields
    }
  }
}
    ${StatementFieldsFragmentDoc}`;

/**
 * __useReadReportStatementLiveDataQuery__
 *
 * To run a query within a React component, call `useReadReportStatementLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadReportStatementLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadReportStatementLiveDataQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      timeHistory: // value for 'timeHistory'
 *      departmentHistory: // value for 'departmentHistory'
 *      locationHistory: // value for 'locationHistory'
 *   },
 * });
 */
export function useReadReportStatementLiveDataQuery(baseOptions: Apollo.QueryHookOptions<ReadReportStatementLiveDataQuery, ReadReportStatementLiveDataQueryVariables> & ({ variables: ReadReportStatementLiveDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadReportStatementLiveDataQuery, ReadReportStatementLiveDataQueryVariables>(ReadReportStatementLiveDataDocument, options);
      }
export function useReadReportStatementLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadReportStatementLiveDataQuery, ReadReportStatementLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadReportStatementLiveDataQuery, ReadReportStatementLiveDataQueryVariables>(ReadReportStatementLiveDataDocument, options);
        }
export function useReadReportStatementLiveDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadReportStatementLiveDataQuery, ReadReportStatementLiveDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadReportStatementLiveDataQuery, ReadReportStatementLiveDataQueryVariables>(ReadReportStatementLiveDataDocument, options);
        }
export type ReadReportStatementLiveDataQueryHookResult = ReturnType<typeof useReadReportStatementLiveDataQuery>;
export type ReadReportStatementLiveDataLazyQueryHookResult = ReturnType<typeof useReadReportStatementLiveDataLazyQuery>;
export type ReadReportStatementLiveDataSuspenseQueryHookResult = ReturnType<typeof useReadReportStatementLiveDataSuspenseQuery>;
export type ReadReportStatementLiveDataQueryResult = Apollo.QueryResult<ReadReportStatementLiveDataQuery, ReadReportStatementLiveDataQueryVariables>;
export const ReadRunwayComponentDataDocument = gql`
    query ReadRunwayComponentData($layoutId: String!, $dataId: String!, $legalEntityId: String!) {
  readComponentData(
    layoutId: $layoutId
    dataId: $dataId
    legalEntityId: $legalEntityId
  ) {
    viewId {
      ...ViewIdentifierFields
    }
    data {
      __typename
      ... on Runway {
        ...RunwayFields
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${RunwayFieldsFragmentDoc}`;

/**
 * __useReadRunwayComponentDataQuery__
 *
 * To run a query within a React component, call `useReadRunwayComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadRunwayComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadRunwayComponentDataQuery({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadRunwayComponentDataQuery(baseOptions: Apollo.QueryHookOptions<ReadRunwayComponentDataQuery, ReadRunwayComponentDataQueryVariables> & ({ variables: ReadRunwayComponentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadRunwayComponentDataQuery, ReadRunwayComponentDataQueryVariables>(ReadRunwayComponentDataDocument, options);
      }
export function useReadRunwayComponentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadRunwayComponentDataQuery, ReadRunwayComponentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadRunwayComponentDataQuery, ReadRunwayComponentDataQueryVariables>(ReadRunwayComponentDataDocument, options);
        }
export function useReadRunwayComponentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadRunwayComponentDataQuery, ReadRunwayComponentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadRunwayComponentDataQuery, ReadRunwayComponentDataQueryVariables>(ReadRunwayComponentDataDocument, options);
        }
export type ReadRunwayComponentDataQueryHookResult = ReturnType<typeof useReadRunwayComponentDataQuery>;
export type ReadRunwayComponentDataLazyQueryHookResult = ReturnType<typeof useReadRunwayComponentDataLazyQuery>;
export type ReadRunwayComponentDataSuspenseQueryHookResult = ReturnType<typeof useReadRunwayComponentDataSuspenseQuery>;
export type ReadRunwayComponentDataQueryResult = Apollo.QueryResult<ReadRunwayComponentDataQuery, ReadRunwayComponentDataQueryVariables>;
export const ReadRunwayLiveDataDocument = gql`
    query ReadRunwayLiveData($viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!) {
  liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on Runway {
      ...RunwayFields
    }
  }
}
    ${RunwayFieldsFragmentDoc}`;

/**
 * __useReadRunwayLiveDataQuery__
 *
 * To run a query within a React component, call `useReadRunwayLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadRunwayLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadRunwayLiveDataQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useReadRunwayLiveDataQuery(baseOptions: Apollo.QueryHookOptions<ReadRunwayLiveDataQuery, ReadRunwayLiveDataQueryVariables> & ({ variables: ReadRunwayLiveDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadRunwayLiveDataQuery, ReadRunwayLiveDataQueryVariables>(ReadRunwayLiveDataDocument, options);
      }
export function useReadRunwayLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadRunwayLiveDataQuery, ReadRunwayLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadRunwayLiveDataQuery, ReadRunwayLiveDataQueryVariables>(ReadRunwayLiveDataDocument, options);
        }
export function useReadRunwayLiveDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadRunwayLiveDataQuery, ReadRunwayLiveDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadRunwayLiveDataQuery, ReadRunwayLiveDataQueryVariables>(ReadRunwayLiveDataDocument, options);
        }
export type ReadRunwayLiveDataQueryHookResult = ReturnType<typeof useReadRunwayLiveDataQuery>;
export type ReadRunwayLiveDataLazyQueryHookResult = ReturnType<typeof useReadRunwayLiveDataLazyQuery>;
export type ReadRunwayLiveDataSuspenseQueryHookResult = ReturnType<typeof useReadRunwayLiveDataSuspenseQuery>;
export type ReadRunwayLiveDataQueryResult = Apollo.QueryResult<ReadRunwayLiveDataQuery, ReadRunwayLiveDataQueryVariables>;
export const ReadSourceAccountMetricComponentDataDocument = gql`
    query ReadSourceAccountMetricComponentData($layoutId: String!, $dataId: String!, $legalEntityId: String!) {
  readComponentData(
    layoutId: $layoutId
    dataId: $dataId
    legalEntityId: $legalEntityId
  ) {
    viewId {
      ...ViewIdentifierFields
    }
    data {
      __typename
      ... on SourceAccountMetric {
        ...SourceAccountMetricFields
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${SourceAccountMetricFieldsFragmentDoc}`;

/**
 * __useReadSourceAccountMetricComponentDataQuery__
 *
 * To run a query within a React component, call `useReadSourceAccountMetricComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadSourceAccountMetricComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadSourceAccountMetricComponentDataQuery({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadSourceAccountMetricComponentDataQuery(baseOptions: Apollo.QueryHookOptions<ReadSourceAccountMetricComponentDataQuery, ReadSourceAccountMetricComponentDataQueryVariables> & ({ variables: ReadSourceAccountMetricComponentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadSourceAccountMetricComponentDataQuery, ReadSourceAccountMetricComponentDataQueryVariables>(ReadSourceAccountMetricComponentDataDocument, options);
      }
export function useReadSourceAccountMetricComponentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadSourceAccountMetricComponentDataQuery, ReadSourceAccountMetricComponentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadSourceAccountMetricComponentDataQuery, ReadSourceAccountMetricComponentDataQueryVariables>(ReadSourceAccountMetricComponentDataDocument, options);
        }
export function useReadSourceAccountMetricComponentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadSourceAccountMetricComponentDataQuery, ReadSourceAccountMetricComponentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadSourceAccountMetricComponentDataQuery, ReadSourceAccountMetricComponentDataQueryVariables>(ReadSourceAccountMetricComponentDataDocument, options);
        }
export type ReadSourceAccountMetricComponentDataQueryHookResult = ReturnType<typeof useReadSourceAccountMetricComponentDataQuery>;
export type ReadSourceAccountMetricComponentDataLazyQueryHookResult = ReturnType<typeof useReadSourceAccountMetricComponentDataLazyQuery>;
export type ReadSourceAccountMetricComponentDataSuspenseQueryHookResult = ReturnType<typeof useReadSourceAccountMetricComponentDataSuspenseQuery>;
export type ReadSourceAccountMetricComponentDataQueryResult = Apollo.QueryResult<ReadSourceAccountMetricComponentDataQuery, ReadSourceAccountMetricComponentDataQueryVariables>;
export const ReadSourceAccountMetricLiveDataDocument = gql`
    query ReadSourceAccountMetricLiveData($viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!) {
  liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on SourceAccountMetric {
      ...SourceAccountMetricFields
    }
  }
}
    ${SourceAccountMetricFieldsFragmentDoc}`;

/**
 * __useReadSourceAccountMetricLiveDataQuery__
 *
 * To run a query within a React component, call `useReadSourceAccountMetricLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadSourceAccountMetricLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadSourceAccountMetricLiveDataQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useReadSourceAccountMetricLiveDataQuery(baseOptions: Apollo.QueryHookOptions<ReadSourceAccountMetricLiveDataQuery, ReadSourceAccountMetricLiveDataQueryVariables> & ({ variables: ReadSourceAccountMetricLiveDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadSourceAccountMetricLiveDataQuery, ReadSourceAccountMetricLiveDataQueryVariables>(ReadSourceAccountMetricLiveDataDocument, options);
      }
export function useReadSourceAccountMetricLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadSourceAccountMetricLiveDataQuery, ReadSourceAccountMetricLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadSourceAccountMetricLiveDataQuery, ReadSourceAccountMetricLiveDataQueryVariables>(ReadSourceAccountMetricLiveDataDocument, options);
        }
export function useReadSourceAccountMetricLiveDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadSourceAccountMetricLiveDataQuery, ReadSourceAccountMetricLiveDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadSourceAccountMetricLiveDataQuery, ReadSourceAccountMetricLiveDataQueryVariables>(ReadSourceAccountMetricLiveDataDocument, options);
        }
export type ReadSourceAccountMetricLiveDataQueryHookResult = ReturnType<typeof useReadSourceAccountMetricLiveDataQuery>;
export type ReadSourceAccountMetricLiveDataLazyQueryHookResult = ReturnType<typeof useReadSourceAccountMetricLiveDataLazyQuery>;
export type ReadSourceAccountMetricLiveDataSuspenseQueryHookResult = ReturnType<typeof useReadSourceAccountMetricLiveDataSuspenseQuery>;
export type ReadSourceAccountMetricLiveDataQueryResult = Apollo.QueryResult<ReadSourceAccountMetricLiveDataQuery, ReadSourceAccountMetricLiveDataQueryVariables>;
export const ReadSummaryLineItemByTimeCategoryLiveDataDocument = gql`
    query ReadSummaryLineItemByTimeCategoryLiveData($viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!) {
  total: liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on DimensionSummary {
      time {
        summary {
          ...TransactionSummaryFields
        }
      }
      partialData
    }
  }
  breakdown: liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on DimensionSummary {
      time {
        by {
          category(sort: Total) {
            categoryObject {
              ...EntityCategoryFields
            }
            summary {
              ...TransactionSummaryFields
            }
          }
        }
      }
      partialData
    }
  }
}
    ${TransactionSummaryFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}`;

/**
 * __useReadSummaryLineItemByTimeCategoryLiveDataQuery__
 *
 * To run a query within a React component, call `useReadSummaryLineItemByTimeCategoryLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadSummaryLineItemByTimeCategoryLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadSummaryLineItemByTimeCategoryLiveDataQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useReadSummaryLineItemByTimeCategoryLiveDataQuery(baseOptions: Apollo.QueryHookOptions<ReadSummaryLineItemByTimeCategoryLiveDataQuery, ReadSummaryLineItemByTimeCategoryLiveDataQueryVariables> & ({ variables: ReadSummaryLineItemByTimeCategoryLiveDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadSummaryLineItemByTimeCategoryLiveDataQuery, ReadSummaryLineItemByTimeCategoryLiveDataQueryVariables>(ReadSummaryLineItemByTimeCategoryLiveDataDocument, options);
      }
export function useReadSummaryLineItemByTimeCategoryLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadSummaryLineItemByTimeCategoryLiveDataQuery, ReadSummaryLineItemByTimeCategoryLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadSummaryLineItemByTimeCategoryLiveDataQuery, ReadSummaryLineItemByTimeCategoryLiveDataQueryVariables>(ReadSummaryLineItemByTimeCategoryLiveDataDocument, options);
        }
export function useReadSummaryLineItemByTimeCategoryLiveDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadSummaryLineItemByTimeCategoryLiveDataQuery, ReadSummaryLineItemByTimeCategoryLiveDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadSummaryLineItemByTimeCategoryLiveDataQuery, ReadSummaryLineItemByTimeCategoryLiveDataQueryVariables>(ReadSummaryLineItemByTimeCategoryLiveDataDocument, options);
        }
export type ReadSummaryLineItemByTimeCategoryLiveDataQueryHookResult = ReturnType<typeof useReadSummaryLineItemByTimeCategoryLiveDataQuery>;
export type ReadSummaryLineItemByTimeCategoryLiveDataLazyQueryHookResult = ReturnType<typeof useReadSummaryLineItemByTimeCategoryLiveDataLazyQuery>;
export type ReadSummaryLineItemByTimeCategoryLiveDataSuspenseQueryHookResult = ReturnType<typeof useReadSummaryLineItemByTimeCategoryLiveDataSuspenseQuery>;
export type ReadSummaryLineItemByTimeCategoryLiveDataQueryResult = Apollo.QueryResult<ReadSummaryLineItemByTimeCategoryLiveDataQuery, ReadSummaryLineItemByTimeCategoryLiveDataQueryVariables>;
export const ReadSummaryLineItemByTimeComponentDataDocument = gql`
    query ReadSummaryLineItemByTimeComponentData($layoutId: String!, $dataId: String!, $legalEntityId: String!) {
  readComponentData(
    layoutId: $layoutId
    dataId: $dataId
    legalEntityId: $legalEntityId
  ) {
    viewId {
      ...ViewIdentifierFields
    }
    data {
      __typename
      ... on DimensionSummary {
        time {
          summary {
            ...TransactionSummaryFields
          }
        }
        partialData
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useReadSummaryLineItemByTimeComponentDataQuery__
 *
 * To run a query within a React component, call `useReadSummaryLineItemByTimeComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadSummaryLineItemByTimeComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadSummaryLineItemByTimeComponentDataQuery({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadSummaryLineItemByTimeComponentDataQuery(baseOptions: Apollo.QueryHookOptions<ReadSummaryLineItemByTimeComponentDataQuery, ReadSummaryLineItemByTimeComponentDataQueryVariables> & ({ variables: ReadSummaryLineItemByTimeComponentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadSummaryLineItemByTimeComponentDataQuery, ReadSummaryLineItemByTimeComponentDataQueryVariables>(ReadSummaryLineItemByTimeComponentDataDocument, options);
      }
export function useReadSummaryLineItemByTimeComponentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadSummaryLineItemByTimeComponentDataQuery, ReadSummaryLineItemByTimeComponentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadSummaryLineItemByTimeComponentDataQuery, ReadSummaryLineItemByTimeComponentDataQueryVariables>(ReadSummaryLineItemByTimeComponentDataDocument, options);
        }
export function useReadSummaryLineItemByTimeComponentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadSummaryLineItemByTimeComponentDataQuery, ReadSummaryLineItemByTimeComponentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadSummaryLineItemByTimeComponentDataQuery, ReadSummaryLineItemByTimeComponentDataQueryVariables>(ReadSummaryLineItemByTimeComponentDataDocument, options);
        }
export type ReadSummaryLineItemByTimeComponentDataQueryHookResult = ReturnType<typeof useReadSummaryLineItemByTimeComponentDataQuery>;
export type ReadSummaryLineItemByTimeComponentDataLazyQueryHookResult = ReturnType<typeof useReadSummaryLineItemByTimeComponentDataLazyQuery>;
export type ReadSummaryLineItemByTimeComponentDataSuspenseQueryHookResult = ReturnType<typeof useReadSummaryLineItemByTimeComponentDataSuspenseQuery>;
export type ReadSummaryLineItemByTimeComponentDataQueryResult = Apollo.QueryResult<ReadSummaryLineItemByTimeComponentDataQuery, ReadSummaryLineItemByTimeComponentDataQueryVariables>;
export const ReadSummaryLineItemByTimeLiveDataDocument = gql`
    query ReadSummaryLineItemByTimeLiveData($viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!) {
  liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on DimensionSummary {
      time {
        summary {
          ...TransactionSummaryFields
        }
      }
      partialData
    }
  }
}
    ${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useReadSummaryLineItemByTimeLiveDataQuery__
 *
 * To run a query within a React component, call `useReadSummaryLineItemByTimeLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadSummaryLineItemByTimeLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadSummaryLineItemByTimeLiveDataQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useReadSummaryLineItemByTimeLiveDataQuery(baseOptions: Apollo.QueryHookOptions<ReadSummaryLineItemByTimeLiveDataQuery, ReadSummaryLineItemByTimeLiveDataQueryVariables> & ({ variables: ReadSummaryLineItemByTimeLiveDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadSummaryLineItemByTimeLiveDataQuery, ReadSummaryLineItemByTimeLiveDataQueryVariables>(ReadSummaryLineItemByTimeLiveDataDocument, options);
      }
export function useReadSummaryLineItemByTimeLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadSummaryLineItemByTimeLiveDataQuery, ReadSummaryLineItemByTimeLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadSummaryLineItemByTimeLiveDataQuery, ReadSummaryLineItemByTimeLiveDataQueryVariables>(ReadSummaryLineItemByTimeLiveDataDocument, options);
        }
export function useReadSummaryLineItemByTimeLiveDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadSummaryLineItemByTimeLiveDataQuery, ReadSummaryLineItemByTimeLiveDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadSummaryLineItemByTimeLiveDataQuery, ReadSummaryLineItemByTimeLiveDataQueryVariables>(ReadSummaryLineItemByTimeLiveDataDocument, options);
        }
export type ReadSummaryLineItemByTimeLiveDataQueryHookResult = ReturnType<typeof useReadSummaryLineItemByTimeLiveDataQuery>;
export type ReadSummaryLineItemByTimeLiveDataLazyQueryHookResult = ReturnType<typeof useReadSummaryLineItemByTimeLiveDataLazyQuery>;
export type ReadSummaryLineItemByTimeLiveDataSuspenseQueryHookResult = ReturnType<typeof useReadSummaryLineItemByTimeLiveDataSuspenseQuery>;
export type ReadSummaryLineItemByTimeLiveDataQueryResult = Apollo.QueryResult<ReadSummaryLineItemByTimeLiveDataQuery, ReadSummaryLineItemByTimeLiveDataQueryVariables>;
export const ReadTextComponentDataDocument = gql`
    query ReadTextComponentData($layoutId: String!, $dataId: String!, $legalEntityId: String!, $limit: Int!, $sort: DimensionSortMode) {
  readComponentData(
    layoutId: $layoutId
    dataId: $dataId
    legalEntityId: $legalEntityId
  ) {
    viewId {
      ...ViewIdentifierFields
    }
    data {
      __typename
      ... on EntityHovers {
        hovers {
          __typename
          ... on CategoryHover {
            ...CategoryHoverFields
          }
          ... on PartyHover {
            ...PartyHoverFields
          }
          ... on SummaryLineItemHover {
            ...SummaryLineItemHoverFields
          }
        }
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${CategoryHoverFieldsFragmentDoc}
${PartyHoverFieldsFragmentDoc}
${SummaryLineItemHoverFieldsFragmentDoc}`;

/**
 * __useReadTextComponentDataQuery__
 *
 * To run a query within a React component, call `useReadTextComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadTextComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadTextComponentDataQuery({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      legalEntityId: // value for 'legalEntityId'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useReadTextComponentDataQuery(baseOptions: Apollo.QueryHookOptions<ReadTextComponentDataQuery, ReadTextComponentDataQueryVariables> & ({ variables: ReadTextComponentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadTextComponentDataQuery, ReadTextComponentDataQueryVariables>(ReadTextComponentDataDocument, options);
      }
export function useReadTextComponentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadTextComponentDataQuery, ReadTextComponentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadTextComponentDataQuery, ReadTextComponentDataQueryVariables>(ReadTextComponentDataDocument, options);
        }
export function useReadTextComponentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadTextComponentDataQuery, ReadTextComponentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadTextComponentDataQuery, ReadTextComponentDataQueryVariables>(ReadTextComponentDataDocument, options);
        }
export type ReadTextComponentDataQueryHookResult = ReturnType<typeof useReadTextComponentDataQuery>;
export type ReadTextComponentDataLazyQueryHookResult = ReturnType<typeof useReadTextComponentDataLazyQuery>;
export type ReadTextComponentDataSuspenseQueryHookResult = ReturnType<typeof useReadTextComponentDataSuspenseQuery>;
export type ReadTextComponentDataQueryResult = Apollo.QueryResult<ReadTextComponentDataQuery, ReadTextComponentDataQueryVariables>;
export const ReadTopCategoriesComponentDataDocument = gql`
    query ReadTopCategoriesComponentData($layoutId: String!, $dataId: String!, $legalEntityId: String!, $limit: Int!, $sort: DimensionSortMode) {
  readComponentData(
    layoutId: $layoutId
    dataId: $dataId
    legalEntityId: $legalEntityId
  ) {
    viewId {
      ...ViewIdentifierFields
    }
    data {
      __typename
      ... on TopEntities {
        entities {
          category(limit: $limit, sort: $sort) {
            category: categoryObject {
              ...EntityCategoryFields
            }
            summary {
              ...TransactionSummaryFields
            }
          }
          partialData
        }
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useReadTopCategoriesComponentDataQuery__
 *
 * To run a query within a React component, call `useReadTopCategoriesComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadTopCategoriesComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadTopCategoriesComponentDataQuery({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      legalEntityId: // value for 'legalEntityId'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useReadTopCategoriesComponentDataQuery(baseOptions: Apollo.QueryHookOptions<ReadTopCategoriesComponentDataQuery, ReadTopCategoriesComponentDataQueryVariables> & ({ variables: ReadTopCategoriesComponentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadTopCategoriesComponentDataQuery, ReadTopCategoriesComponentDataQueryVariables>(ReadTopCategoriesComponentDataDocument, options);
      }
export function useReadTopCategoriesComponentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadTopCategoriesComponentDataQuery, ReadTopCategoriesComponentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadTopCategoriesComponentDataQuery, ReadTopCategoriesComponentDataQueryVariables>(ReadTopCategoriesComponentDataDocument, options);
        }
export function useReadTopCategoriesComponentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadTopCategoriesComponentDataQuery, ReadTopCategoriesComponentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadTopCategoriesComponentDataQuery, ReadTopCategoriesComponentDataQueryVariables>(ReadTopCategoriesComponentDataDocument, options);
        }
export type ReadTopCategoriesComponentDataQueryHookResult = ReturnType<typeof useReadTopCategoriesComponentDataQuery>;
export type ReadTopCategoriesComponentDataLazyQueryHookResult = ReturnType<typeof useReadTopCategoriesComponentDataLazyQuery>;
export type ReadTopCategoriesComponentDataSuspenseQueryHookResult = ReturnType<typeof useReadTopCategoriesComponentDataSuspenseQuery>;
export type ReadTopCategoriesComponentDataQueryResult = Apollo.QueryResult<ReadTopCategoriesComponentDataQuery, ReadTopCategoriesComponentDataQueryVariables>;
export const ReadTopCategoriesLiveDataDocument = gql`
    query ReadTopCategoriesLiveData($viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!, $limit: Int!, $sort: DimensionSortMode) {
  liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on TopEntities {
      entities {
        category(limit: $limit, sort: $sort) {
          category: categoryObject {
            ...EntityCategoryFields
          }
          summary {
            ...TransactionSummaryFields
          }
        }
        partialData
      }
    }
  }
}
    ${EntityCategoryFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useReadTopCategoriesLiveDataQuery__
 *
 * To run a query within a React component, call `useReadTopCategoriesLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadTopCategoriesLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadTopCategoriesLiveDataQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useReadTopCategoriesLiveDataQuery(baseOptions: Apollo.QueryHookOptions<ReadTopCategoriesLiveDataQuery, ReadTopCategoriesLiveDataQueryVariables> & ({ variables: ReadTopCategoriesLiveDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadTopCategoriesLiveDataQuery, ReadTopCategoriesLiveDataQueryVariables>(ReadTopCategoriesLiveDataDocument, options);
      }
export function useReadTopCategoriesLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadTopCategoriesLiveDataQuery, ReadTopCategoriesLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadTopCategoriesLiveDataQuery, ReadTopCategoriesLiveDataQueryVariables>(ReadTopCategoriesLiveDataDocument, options);
        }
export function useReadTopCategoriesLiveDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadTopCategoriesLiveDataQuery, ReadTopCategoriesLiveDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadTopCategoriesLiveDataQuery, ReadTopCategoriesLiveDataQueryVariables>(ReadTopCategoriesLiveDataDocument, options);
        }
export type ReadTopCategoriesLiveDataQueryHookResult = ReturnType<typeof useReadTopCategoriesLiveDataQuery>;
export type ReadTopCategoriesLiveDataLazyQueryHookResult = ReturnType<typeof useReadTopCategoriesLiveDataLazyQuery>;
export type ReadTopCategoriesLiveDataSuspenseQueryHookResult = ReturnType<typeof useReadTopCategoriesLiveDataSuspenseQuery>;
export type ReadTopCategoriesLiveDataQueryResult = Apollo.QueryResult<ReadTopCategoriesLiveDataQuery, ReadTopCategoriesLiveDataQueryVariables>;
export const ReadTopPartiesComponentDataDocument = gql`
    query ReadTopPartiesComponentData($layoutId: String!, $dataId: String!, $legalEntityId: String!, $limit: Int!, $sort: DimensionSortMode) {
  readComponentData(
    layoutId: $layoutId
    dataId: $dataId
    legalEntityId: $legalEntityId
  ) {
    viewId {
      ...ViewIdentifierFields
    }
    data {
      __typename
      ... on TopEntities {
        entities {
          party(limit: $limit, sort: $sort) {
            party: partyObject {
              ...EntityPartyFields
            }
            summary {
              ...TransactionSummaryFields
            }
            by {
              categories: category(sort: Active) {
                category: categoryObject {
                  ...EntityCategoryFields
                }
              }
            }
          }
          partialData
        }
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}`;

/**
 * __useReadTopPartiesComponentDataQuery__
 *
 * To run a query within a React component, call `useReadTopPartiesComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadTopPartiesComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadTopPartiesComponentDataQuery({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      legalEntityId: // value for 'legalEntityId'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useReadTopPartiesComponentDataQuery(baseOptions: Apollo.QueryHookOptions<ReadTopPartiesComponentDataQuery, ReadTopPartiesComponentDataQueryVariables> & ({ variables: ReadTopPartiesComponentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadTopPartiesComponentDataQuery, ReadTopPartiesComponentDataQueryVariables>(ReadTopPartiesComponentDataDocument, options);
      }
export function useReadTopPartiesComponentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadTopPartiesComponentDataQuery, ReadTopPartiesComponentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadTopPartiesComponentDataQuery, ReadTopPartiesComponentDataQueryVariables>(ReadTopPartiesComponentDataDocument, options);
        }
export function useReadTopPartiesComponentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadTopPartiesComponentDataQuery, ReadTopPartiesComponentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadTopPartiesComponentDataQuery, ReadTopPartiesComponentDataQueryVariables>(ReadTopPartiesComponentDataDocument, options);
        }
export type ReadTopPartiesComponentDataQueryHookResult = ReturnType<typeof useReadTopPartiesComponentDataQuery>;
export type ReadTopPartiesComponentDataLazyQueryHookResult = ReturnType<typeof useReadTopPartiesComponentDataLazyQuery>;
export type ReadTopPartiesComponentDataSuspenseQueryHookResult = ReturnType<typeof useReadTopPartiesComponentDataSuspenseQuery>;
export type ReadTopPartiesComponentDataQueryResult = Apollo.QueryResult<ReadTopPartiesComponentDataQuery, ReadTopPartiesComponentDataQueryVariables>;
export const ReadTopPartiesLiveDataDocument = gql`
    query ReadTopPartiesLiveData($viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!, $limit: Int!, $sort: DimensionSortMode) {
  liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on TopEntities {
      entities {
        party(limit: $limit, sort: $sort) {
          party: partyObject {
            ...EntityPartyFields
          }
          summary {
            ...TransactionSummaryFields
          }
          by {
            categories: category(sort: Active) {
              category: categoryObject {
                ...EntityCategoryFields
              }
            }
          }
        }
        partialData
      }
    }
  }
}
    ${EntityPartyFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}`;

/**
 * __useReadTopPartiesLiveDataQuery__
 *
 * To run a query within a React component, call `useReadTopPartiesLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadTopPartiesLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadTopPartiesLiveDataQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useReadTopPartiesLiveDataQuery(baseOptions: Apollo.QueryHookOptions<ReadTopPartiesLiveDataQuery, ReadTopPartiesLiveDataQueryVariables> & ({ variables: ReadTopPartiesLiveDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadTopPartiesLiveDataQuery, ReadTopPartiesLiveDataQueryVariables>(ReadTopPartiesLiveDataDocument, options);
      }
export function useReadTopPartiesLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadTopPartiesLiveDataQuery, ReadTopPartiesLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadTopPartiesLiveDataQuery, ReadTopPartiesLiveDataQueryVariables>(ReadTopPartiesLiveDataDocument, options);
        }
export function useReadTopPartiesLiveDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadTopPartiesLiveDataQuery, ReadTopPartiesLiveDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadTopPartiesLiveDataQuery, ReadTopPartiesLiveDataQueryVariables>(ReadTopPartiesLiveDataDocument, options);
        }
export type ReadTopPartiesLiveDataQueryHookResult = ReturnType<typeof useReadTopPartiesLiveDataQuery>;
export type ReadTopPartiesLiveDataLazyQueryHookResult = ReturnType<typeof useReadTopPartiesLiveDataLazyQuery>;
export type ReadTopPartiesLiveDataSuspenseQueryHookResult = ReturnType<typeof useReadTopPartiesLiveDataSuspenseQuery>;
export type ReadTopPartiesLiveDataQueryResult = Apollo.QueryResult<ReadTopPartiesLiveDataQuery, ReadTopPartiesLiveDataQueryVariables>;
export const ReadTopTransactionsComponentDataDocument = gql`
    query ReadTopTransactionsComponentData($layoutId: String!, $dataId: String!, $legalEntityId: String!) {
  readComponentData(
    layoutId: $layoutId
    dataId: $dataId
    legalEntityId: $legalEntityId
  ) {
    viewId {
      ...ViewIdentifierFields
    }
    data {
      __typename
      ... on TopTransactions {
        transactions {
          ...EntityTransactionFields
        }
        partialData
      }
    }
  }
}
    ${ViewIdentifierFieldsFragmentDoc}
${EntityTransactionFieldsFragmentDoc}`;

/**
 * __useReadTopTransactionsComponentDataQuery__
 *
 * To run a query within a React component, call `useReadTopTransactionsComponentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadTopTransactionsComponentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadTopTransactionsComponentDataQuery({
 *   variables: {
 *      layoutId: // value for 'layoutId'
 *      dataId: // value for 'dataId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadTopTransactionsComponentDataQuery(baseOptions: Apollo.QueryHookOptions<ReadTopTransactionsComponentDataQuery, ReadTopTransactionsComponentDataQueryVariables> & ({ variables: ReadTopTransactionsComponentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadTopTransactionsComponentDataQuery, ReadTopTransactionsComponentDataQueryVariables>(ReadTopTransactionsComponentDataDocument, options);
      }
export function useReadTopTransactionsComponentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadTopTransactionsComponentDataQuery, ReadTopTransactionsComponentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadTopTransactionsComponentDataQuery, ReadTopTransactionsComponentDataQueryVariables>(ReadTopTransactionsComponentDataDocument, options);
        }
export function useReadTopTransactionsComponentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadTopTransactionsComponentDataQuery, ReadTopTransactionsComponentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadTopTransactionsComponentDataQuery, ReadTopTransactionsComponentDataQueryVariables>(ReadTopTransactionsComponentDataDocument, options);
        }
export type ReadTopTransactionsComponentDataQueryHookResult = ReturnType<typeof useReadTopTransactionsComponentDataQuery>;
export type ReadTopTransactionsComponentDataLazyQueryHookResult = ReturnType<typeof useReadTopTransactionsComponentDataLazyQuery>;
export type ReadTopTransactionsComponentDataSuspenseQueryHookResult = ReturnType<typeof useReadTopTransactionsComponentDataSuspenseQuery>;
export type ReadTopTransactionsComponentDataQueryResult = Apollo.QueryResult<ReadTopTransactionsComponentDataQuery, ReadTopTransactionsComponentDataQueryVariables>;
export const ReadTopTransactionsLiveDataDocument = gql`
    query ReadTopTransactionsLiveData($viewId: ViewIdentifierInput!, $config: LayoutComponentConfigInput!) {
  liveComponentData(viewId: $viewId, config: $config) {
    __typename
    ... on TopTransactions {
      transactions {
        ...EntityTransactionFields
      }
      partialData
    }
  }
}
    ${EntityTransactionFieldsFragmentDoc}`;

/**
 * __useReadTopTransactionsLiveDataQuery__
 *
 * To run a query within a React component, call `useReadTopTransactionsLiveDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadTopTransactionsLiveDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadTopTransactionsLiveDataQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useReadTopTransactionsLiveDataQuery(baseOptions: Apollo.QueryHookOptions<ReadTopTransactionsLiveDataQuery, ReadTopTransactionsLiveDataQueryVariables> & ({ variables: ReadTopTransactionsLiveDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadTopTransactionsLiveDataQuery, ReadTopTransactionsLiveDataQueryVariables>(ReadTopTransactionsLiveDataDocument, options);
      }
export function useReadTopTransactionsLiveDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadTopTransactionsLiveDataQuery, ReadTopTransactionsLiveDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadTopTransactionsLiveDataQuery, ReadTopTransactionsLiveDataQueryVariables>(ReadTopTransactionsLiveDataDocument, options);
        }
export function useReadTopTransactionsLiveDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadTopTransactionsLiveDataQuery, ReadTopTransactionsLiveDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadTopTransactionsLiveDataQuery, ReadTopTransactionsLiveDataQueryVariables>(ReadTopTransactionsLiveDataDocument, options);
        }
export type ReadTopTransactionsLiveDataQueryHookResult = ReturnType<typeof useReadTopTransactionsLiveDataQuery>;
export type ReadTopTransactionsLiveDataLazyQueryHookResult = ReturnType<typeof useReadTopTransactionsLiveDataLazyQuery>;
export type ReadTopTransactionsLiveDataSuspenseQueryHookResult = ReturnType<typeof useReadTopTransactionsLiveDataSuspenseQuery>;
export type ReadTopTransactionsLiveDataQueryResult = Apollo.QueryResult<ReadTopTransactionsLiveDataQuery, ReadTopTransactionsLiveDataQueryVariables>;
export const FactIdForLedgerTransactionIdDocument = gql`
    query FactIdForLedgerTransactionId($ledgerTransactionId: String!, $viewKey: ViewKey!) {
  factIdForLedgerTransactionId(
    ledgerTransactionId: $ledgerTransactionId
    viewKey: $viewKey
  )
}
    `;

/**
 * __useFactIdForLedgerTransactionIdQuery__
 *
 * To run a query within a React component, call `useFactIdForLedgerTransactionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFactIdForLedgerTransactionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFactIdForLedgerTransactionIdQuery({
 *   variables: {
 *      ledgerTransactionId: // value for 'ledgerTransactionId'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useFactIdForLedgerTransactionIdQuery(baseOptions: Apollo.QueryHookOptions<FactIdForLedgerTransactionIdQuery, FactIdForLedgerTransactionIdQueryVariables> & ({ variables: FactIdForLedgerTransactionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FactIdForLedgerTransactionIdQuery, FactIdForLedgerTransactionIdQueryVariables>(FactIdForLedgerTransactionIdDocument, options);
      }
export function useFactIdForLedgerTransactionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FactIdForLedgerTransactionIdQuery, FactIdForLedgerTransactionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FactIdForLedgerTransactionIdQuery, FactIdForLedgerTransactionIdQueryVariables>(FactIdForLedgerTransactionIdDocument, options);
        }
export function useFactIdForLedgerTransactionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FactIdForLedgerTransactionIdQuery, FactIdForLedgerTransactionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FactIdForLedgerTransactionIdQuery, FactIdForLedgerTransactionIdQueryVariables>(FactIdForLedgerTransactionIdDocument, options);
        }
export type FactIdForLedgerTransactionIdQueryHookResult = ReturnType<typeof useFactIdForLedgerTransactionIdQuery>;
export type FactIdForLedgerTransactionIdLazyQueryHookResult = ReturnType<typeof useFactIdForLedgerTransactionIdLazyQuery>;
export type FactIdForLedgerTransactionIdSuspenseQueryHookResult = ReturnType<typeof useFactIdForLedgerTransactionIdSuspenseQuery>;
export type FactIdForLedgerTransactionIdQueryResult = Apollo.QueryResult<FactIdForLedgerTransactionIdQuery, FactIdForLedgerTransactionIdQueryVariables>;
export const ListLedgerTransactionsDocument = gql`
    query ListLedgerTransactions($ledgerTransactionIds: [String!]!, $viewKey: ViewKey!) {
  listLedgerTransactions(
    ledgerTransactionIds: $ledgerTransactionIds
    viewKey: $viewKey
  ) {
    ...EntityLedgerTransactionFields
  }
}
    ${EntityLedgerTransactionFieldsFragmentDoc}`;

/**
 * __useListLedgerTransactionsQuery__
 *
 * To run a query within a React component, call `useListLedgerTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLedgerTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLedgerTransactionsQuery({
 *   variables: {
 *      ledgerTransactionIds: // value for 'ledgerTransactionIds'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useListLedgerTransactionsQuery(baseOptions: Apollo.QueryHookOptions<ListLedgerTransactionsQuery, ListLedgerTransactionsQueryVariables> & ({ variables: ListLedgerTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLedgerTransactionsQuery, ListLedgerTransactionsQueryVariables>(ListLedgerTransactionsDocument, options);
      }
export function useListLedgerTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLedgerTransactionsQuery, ListLedgerTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLedgerTransactionsQuery, ListLedgerTransactionsQueryVariables>(ListLedgerTransactionsDocument, options);
        }
export function useListLedgerTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLedgerTransactionsQuery, ListLedgerTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLedgerTransactionsQuery, ListLedgerTransactionsQueryVariables>(ListLedgerTransactionsDocument, options);
        }
export type ListLedgerTransactionsQueryHookResult = ReturnType<typeof useListLedgerTransactionsQuery>;
export type ListLedgerTransactionsLazyQueryHookResult = ReturnType<typeof useListLedgerTransactionsLazyQuery>;
export type ListLedgerTransactionsSuspenseQueryHookResult = ReturnType<typeof useListLedgerTransactionsSuspenseQuery>;
export type ListLedgerTransactionsQueryResult = Apollo.QueryResult<ListLedgerTransactionsQuery, ListLedgerTransactionsQueryVariables>;
export const ActivateLegalEntityDocument = gql`
    mutation ActivateLegalEntity($id: String!) {
  activateLegalEntity(id: $id)
}
    `;
export type ActivateLegalEntityMutationFn = Apollo.MutationFunction<ActivateLegalEntityMutation, ActivateLegalEntityMutationVariables>;

/**
 * __useActivateLegalEntityMutation__
 *
 * To run a mutation, you first call `useActivateLegalEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateLegalEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateLegalEntityMutation, { data, loading, error }] = useActivateLegalEntityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateLegalEntityMutation(baseOptions?: Apollo.MutationHookOptions<ActivateLegalEntityMutation, ActivateLegalEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateLegalEntityMutation, ActivateLegalEntityMutationVariables>(ActivateLegalEntityDocument, options);
      }
export type ActivateLegalEntityMutationHookResult = ReturnType<typeof useActivateLegalEntityMutation>;
export type ActivateLegalEntityMutationResult = Apollo.MutationResult<ActivateLegalEntityMutation>;
export type ActivateLegalEntityMutationOptions = Apollo.BaseMutationOptions<ActivateLegalEntityMutation, ActivateLegalEntityMutationVariables>;
export const RequestAccessDocument = gql`
    mutation RequestAccess($legalEntityId: String!) {
  requestAccess(legalEntityId: $legalEntityId)
}
    `;
export type RequestAccessMutationFn = Apollo.MutationFunction<RequestAccessMutation, RequestAccessMutationVariables>;

/**
 * __useRequestAccessMutation__
 *
 * To run a mutation, you first call `useRequestAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAccessMutation, { data, loading, error }] = useRequestAccessMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useRequestAccessMutation(baseOptions?: Apollo.MutationHookOptions<RequestAccessMutation, RequestAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAccessMutation, RequestAccessMutationVariables>(RequestAccessDocument, options);
      }
export type RequestAccessMutationHookResult = ReturnType<typeof useRequestAccessMutation>;
export type RequestAccessMutationResult = Apollo.MutationResult<RequestAccessMutation>;
export type RequestAccessMutationOptions = Apollo.BaseMutationOptions<RequestAccessMutation, RequestAccessMutationVariables>;
export const UpdateAiBookkeeperCutoverDateDocument = gql`
    mutation UpdateAIBookkeeperCutoverDate($legalEntityId: String!, $cutoverDate: DateTime!) {
  updateAIBookkeeperCutoverDate(
    legalEntityId: $legalEntityId
    cutoverDate: $cutoverDate
  )
}
    `;
export type UpdateAiBookkeeperCutoverDateMutationFn = Apollo.MutationFunction<UpdateAiBookkeeperCutoverDateMutation, UpdateAiBookkeeperCutoverDateMutationVariables>;

/**
 * __useUpdateAiBookkeeperCutoverDateMutation__
 *
 * To run a mutation, you first call `useUpdateAiBookkeeperCutoverDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAiBookkeeperCutoverDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAiBookkeeperCutoverDateMutation, { data, loading, error }] = useUpdateAiBookkeeperCutoverDateMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      cutoverDate: // value for 'cutoverDate'
 *   },
 * });
 */
export function useUpdateAiBookkeeperCutoverDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAiBookkeeperCutoverDateMutation, UpdateAiBookkeeperCutoverDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAiBookkeeperCutoverDateMutation, UpdateAiBookkeeperCutoverDateMutationVariables>(UpdateAiBookkeeperCutoverDateDocument, options);
      }
export type UpdateAiBookkeeperCutoverDateMutationHookResult = ReturnType<typeof useUpdateAiBookkeeperCutoverDateMutation>;
export type UpdateAiBookkeeperCutoverDateMutationResult = Apollo.MutationResult<UpdateAiBookkeeperCutoverDateMutation>;
export type UpdateAiBookkeeperCutoverDateMutationOptions = Apollo.BaseMutationOptions<UpdateAiBookkeeperCutoverDateMutation, UpdateAiBookkeeperCutoverDateMutationVariables>;
export const UpdateLegalEntityDocument = gql`
    mutation UpdateLegalEntity($id: String!, $name: String, $street: String, $streetAdditional: String, $city: String, $region: String, $postalCode: String, $countryCode: String, $lat: Float, $long: Float, $timezone: String, $industry: String, $websiteUrl: String, $incorporatedOn: DateInput, $fiscalYearStartMonth: Int, $fiscalYearNumberOffset: Int, $phoneNumber: String) {
  updateLegalEntity(
    id: $id
    name: $name
    address: {street: $street, streetAdditional: $streetAdditional, city: $city, region: $region, postalCode: $postalCode, countryCode: $countryCode, lat: $lat, long: $long}
    timezone: $timezone
    industry: $industry
    websiteUrl: $websiteUrl
    incorporatedOn: $incorporatedOn
    fiscalYearStartMonth: $fiscalYearStartMonth
    fiscalYearNumberOffset: $fiscalYearNumberOffset
    phoneNumber: $phoneNumber
  )
}
    `;
export type UpdateLegalEntityMutationFn = Apollo.MutationFunction<UpdateLegalEntityMutation, UpdateLegalEntityMutationVariables>;

/**
 * __useUpdateLegalEntityMutation__
 *
 * To run a mutation, you first call `useUpdateLegalEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLegalEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLegalEntityMutation, { data, loading, error }] = useUpdateLegalEntityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      street: // value for 'street'
 *      streetAdditional: // value for 'streetAdditional'
 *      city: // value for 'city'
 *      region: // value for 'region'
 *      postalCode: // value for 'postalCode'
 *      countryCode: // value for 'countryCode'
 *      lat: // value for 'lat'
 *      long: // value for 'long'
 *      timezone: // value for 'timezone'
 *      industry: // value for 'industry'
 *      websiteUrl: // value for 'websiteUrl'
 *      incorporatedOn: // value for 'incorporatedOn'
 *      fiscalYearStartMonth: // value for 'fiscalYearStartMonth'
 *      fiscalYearNumberOffset: // value for 'fiscalYearNumberOffset'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdateLegalEntityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLegalEntityMutation, UpdateLegalEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLegalEntityMutation, UpdateLegalEntityMutationVariables>(UpdateLegalEntityDocument, options);
      }
export type UpdateLegalEntityMutationHookResult = ReturnType<typeof useUpdateLegalEntityMutation>;
export type UpdateLegalEntityMutationResult = Apollo.MutationResult<UpdateLegalEntityMutation>;
export type UpdateLegalEntityMutationOptions = Apollo.BaseMutationOptions<UpdateLegalEntityMutation, UpdateLegalEntityMutationVariables>;
export const UploadLegalEntityIconDocument = gql`
    mutation UploadLegalEntityIcon($id: String!, $name: String!, $iconBase64: String!) {
  uploadLegalEntityIcon(id: $id, name: $name, iconBase64: $iconBase64)
}
    `;
export type UploadLegalEntityIconMutationFn = Apollo.MutationFunction<UploadLegalEntityIconMutation, UploadLegalEntityIconMutationVariables>;

/**
 * __useUploadLegalEntityIconMutation__
 *
 * To run a mutation, you first call `useUploadLegalEntityIconMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadLegalEntityIconMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadLegalEntityIconMutation, { data, loading, error }] = useUploadLegalEntityIconMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      iconBase64: // value for 'iconBase64'
 *   },
 * });
 */
export function useUploadLegalEntityIconMutation(baseOptions?: Apollo.MutationHookOptions<UploadLegalEntityIconMutation, UploadLegalEntityIconMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadLegalEntityIconMutation, UploadLegalEntityIconMutationVariables>(UploadLegalEntityIconDocument, options);
      }
export type UploadLegalEntityIconMutationHookResult = ReturnType<typeof useUploadLegalEntityIconMutation>;
export type UploadLegalEntityIconMutationResult = Apollo.MutationResult<UploadLegalEntityIconMutation>;
export type UploadLegalEntityIconMutationOptions = Apollo.BaseMutationOptions<UploadLegalEntityIconMutation, UploadLegalEntityIconMutationVariables>;
export const ReadLegalEntityDocument = gql`
    query ReadLegalEntity($id: String!) {
  readLegalEntity(id: $id) {
    ...LegalEntityFields
  }
}
    ${LegalEntityFieldsFragmentDoc}`;

/**
 * __useReadLegalEntityQuery__
 *
 * To run a query within a React component, call `useReadLegalEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadLegalEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadLegalEntityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadLegalEntityQuery(baseOptions: Apollo.QueryHookOptions<ReadLegalEntityQuery, ReadLegalEntityQueryVariables> & ({ variables: ReadLegalEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadLegalEntityQuery, ReadLegalEntityQueryVariables>(ReadLegalEntityDocument, options);
      }
export function useReadLegalEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadLegalEntityQuery, ReadLegalEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadLegalEntityQuery, ReadLegalEntityQueryVariables>(ReadLegalEntityDocument, options);
        }
export function useReadLegalEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadLegalEntityQuery, ReadLegalEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadLegalEntityQuery, ReadLegalEntityQueryVariables>(ReadLegalEntityDocument, options);
        }
export type ReadLegalEntityQueryHookResult = ReturnType<typeof useReadLegalEntityQuery>;
export type ReadLegalEntityLazyQueryHookResult = ReturnType<typeof useReadLegalEntityLazyQuery>;
export type ReadLegalEntitySuspenseQueryHookResult = ReturnType<typeof useReadLegalEntitySuspenseQuery>;
export type ReadLegalEntityQueryResult = Apollo.QueryResult<ReadLegalEntityQuery, ReadLegalEntityQueryVariables>;
export const ReadLegalEntityPreferencesDocument = gql`
    query ReadLegalEntityPreferences($legalEntityId: String!) {
  readLegalEntityPreferences(legalEntityId: $legalEntityId) {
    legalEntityId
    isCogsInExpenses
    lineClassDisplayName
    lineClassPluralDisplayName
    bookkeeperAiCutoverAt
  }
}
    `;

/**
 * __useReadLegalEntityPreferencesQuery__
 *
 * To run a query within a React component, call `useReadLegalEntityPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadLegalEntityPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadLegalEntityPreferencesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadLegalEntityPreferencesQuery(baseOptions: Apollo.QueryHookOptions<ReadLegalEntityPreferencesQuery, ReadLegalEntityPreferencesQueryVariables> & ({ variables: ReadLegalEntityPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadLegalEntityPreferencesQuery, ReadLegalEntityPreferencesQueryVariables>(ReadLegalEntityPreferencesDocument, options);
      }
export function useReadLegalEntityPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadLegalEntityPreferencesQuery, ReadLegalEntityPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadLegalEntityPreferencesQuery, ReadLegalEntityPreferencesQueryVariables>(ReadLegalEntityPreferencesDocument, options);
        }
export function useReadLegalEntityPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadLegalEntityPreferencesQuery, ReadLegalEntityPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadLegalEntityPreferencesQuery, ReadLegalEntityPreferencesQueryVariables>(ReadLegalEntityPreferencesDocument, options);
        }
export type ReadLegalEntityPreferencesQueryHookResult = ReturnType<typeof useReadLegalEntityPreferencesQuery>;
export type ReadLegalEntityPreferencesLazyQueryHookResult = ReturnType<typeof useReadLegalEntityPreferencesLazyQuery>;
export type ReadLegalEntityPreferencesSuspenseQueryHookResult = ReturnType<typeof useReadLegalEntityPreferencesSuspenseQuery>;
export type ReadLegalEntityPreferencesQueryResult = Apollo.QueryResult<ReadLegalEntityPreferencesQuery, ReadLegalEntityPreferencesQueryVariables>;
export const ReadLegalEntityMetadataDocument = gql`
    query readLegalEntityMetadata($viewKey: ViewKey!) {
  readLegalEntityMetadata(viewKey: $viewKey) {
    ...ViewMetadataFields
  }
}
    ${ViewMetadataFieldsFragmentDoc}`;

/**
 * __useReadLegalEntityMetadataQuery__
 *
 * To run a query within a React component, call `useReadLegalEntityMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadLegalEntityMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadLegalEntityMetadataQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useReadLegalEntityMetadataQuery(baseOptions: Apollo.QueryHookOptions<ReadLegalEntityMetadataQuery, ReadLegalEntityMetadataQueryVariables> & ({ variables: ReadLegalEntityMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadLegalEntityMetadataQuery, ReadLegalEntityMetadataQueryVariables>(ReadLegalEntityMetadataDocument, options);
      }
export function useReadLegalEntityMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadLegalEntityMetadataQuery, ReadLegalEntityMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadLegalEntityMetadataQuery, ReadLegalEntityMetadataQueryVariables>(ReadLegalEntityMetadataDocument, options);
        }
export function useReadLegalEntityMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadLegalEntityMetadataQuery, ReadLegalEntityMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadLegalEntityMetadataQuery, ReadLegalEntityMetadataQueryVariables>(ReadLegalEntityMetadataDocument, options);
        }
export type ReadLegalEntityMetadataQueryHookResult = ReturnType<typeof useReadLegalEntityMetadataQuery>;
export type ReadLegalEntityMetadataLazyQueryHookResult = ReturnType<typeof useReadLegalEntityMetadataLazyQuery>;
export type ReadLegalEntityMetadataSuspenseQueryHookResult = ReturnType<typeof useReadLegalEntityMetadataSuspenseQuery>;
export type ReadLegalEntityMetadataQueryResult = Apollo.QueryResult<ReadLegalEntityMetadataQuery, ReadLegalEntityMetadataQueryVariables>;
export const ReadLinkedObjectDetailsDocument = gql`
    query ReadLinkedObjectDetails($viewKey: ViewKey!, $linkedObjectId: String!, $linkedObjectType: LinkedObjectType!) {
  readLinkedObjectDetails(
    viewKey: $viewKey
    linkedObjectId: $linkedObjectId
    linkedObjectType: $linkedObjectType
  ) {
    ...LinkedObjectDetailsFields
  }
}
    ${LinkedObjectDetailsFieldsFragmentDoc}`;

/**
 * __useReadLinkedObjectDetailsQuery__
 *
 * To run a query within a React component, call `useReadLinkedObjectDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadLinkedObjectDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadLinkedObjectDetailsQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      linkedObjectId: // value for 'linkedObjectId'
 *      linkedObjectType: // value for 'linkedObjectType'
 *   },
 * });
 */
export function useReadLinkedObjectDetailsQuery(baseOptions: Apollo.QueryHookOptions<ReadLinkedObjectDetailsQuery, ReadLinkedObjectDetailsQueryVariables> & ({ variables: ReadLinkedObjectDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadLinkedObjectDetailsQuery, ReadLinkedObjectDetailsQueryVariables>(ReadLinkedObjectDetailsDocument, options);
      }
export function useReadLinkedObjectDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadLinkedObjectDetailsQuery, ReadLinkedObjectDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadLinkedObjectDetailsQuery, ReadLinkedObjectDetailsQueryVariables>(ReadLinkedObjectDetailsDocument, options);
        }
export function useReadLinkedObjectDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadLinkedObjectDetailsQuery, ReadLinkedObjectDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadLinkedObjectDetailsQuery, ReadLinkedObjectDetailsQueryVariables>(ReadLinkedObjectDetailsDocument, options);
        }
export type ReadLinkedObjectDetailsQueryHookResult = ReturnType<typeof useReadLinkedObjectDetailsQuery>;
export type ReadLinkedObjectDetailsLazyQueryHookResult = ReturnType<typeof useReadLinkedObjectDetailsLazyQuery>;
export type ReadLinkedObjectDetailsSuspenseQueryHookResult = ReturnType<typeof useReadLinkedObjectDetailsSuspenseQuery>;
export type ReadLinkedObjectDetailsQueryResult = Apollo.QueryResult<ReadLinkedObjectDetailsQuery, ReadLinkedObjectDetailsQueryVariables>;
export const BootstrapLocationDocument = gql`
    mutation BootstrapLocation($legalEntityId: String!) {
  bootstrapLocations(legalEntityId: $legalEntityId) {
    locationId
  }
}
    `;
export type BootstrapLocationMutationFn = Apollo.MutationFunction<BootstrapLocationMutation, BootstrapLocationMutationVariables>;

/**
 * __useBootstrapLocationMutation__
 *
 * To run a mutation, you first call `useBootstrapLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBootstrapLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bootstrapLocationMutation, { data, loading, error }] = useBootstrapLocationMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useBootstrapLocationMutation(baseOptions?: Apollo.MutationHookOptions<BootstrapLocationMutation, BootstrapLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BootstrapLocationMutation, BootstrapLocationMutationVariables>(BootstrapLocationDocument, options);
      }
export type BootstrapLocationMutationHookResult = ReturnType<typeof useBootstrapLocationMutation>;
export type BootstrapLocationMutationResult = Apollo.MutationResult<BootstrapLocationMutation>;
export type BootstrapLocationMutationOptions = Apollo.BaseMutationOptions<BootstrapLocationMutation, BootstrapLocationMutationVariables>;
export const CreateLocationDocument = gql`
    mutation CreateLocation($viewKey: ViewKey!, $dimension: CreateLocationInput!) {
  createLocation(viewKey: $viewKey, location: $dimension) {
    locationId
  }
}
    `;
export type CreateLocationMutationFn = Apollo.MutationFunction<CreateLocationMutation, CreateLocationMutationVariables>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      dimension: // value for 'dimension'
 *   },
 * });
 */
export function useCreateLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationMutation, CreateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument, options);
      }
export type CreateLocationMutationHookResult = ReturnType<typeof useCreateLocationMutation>;
export type CreateLocationMutationResult = Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>;
export const MigrateLocationQuickBooksDocument = gql`
    mutation MigrateLocationQuickBooks($viewKey: ViewKey!, $departmentFactIds: [String!], $lineClassFactIds: [String!]) {
  migrateLocationQuickBooks(
    viewKey: $viewKey
    departmentFactIds: $departmentFactIds
    lineClassFactIds: $lineClassFactIds
  )
}
    `;
export type MigrateLocationQuickBooksMutationFn = Apollo.MutationFunction<MigrateLocationQuickBooksMutation, MigrateLocationQuickBooksMutationVariables>;

/**
 * __useMigrateLocationQuickBooksMutation__
 *
 * To run a mutation, you first call `useMigrateLocationQuickBooksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMigrateLocationQuickBooksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [migrateLocationQuickBooksMutation, { data, loading, error }] = useMigrateLocationQuickBooksMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      departmentFactIds: // value for 'departmentFactIds'
 *      lineClassFactIds: // value for 'lineClassFactIds'
 *   },
 * });
 */
export function useMigrateLocationQuickBooksMutation(baseOptions?: Apollo.MutationHookOptions<MigrateLocationQuickBooksMutation, MigrateLocationQuickBooksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MigrateLocationQuickBooksMutation, MigrateLocationQuickBooksMutationVariables>(MigrateLocationQuickBooksDocument, options);
      }
export type MigrateLocationQuickBooksMutationHookResult = ReturnType<typeof useMigrateLocationQuickBooksMutation>;
export type MigrateLocationQuickBooksMutationResult = Apollo.MutationResult<MigrateLocationQuickBooksMutation>;
export type MigrateLocationQuickBooksMutationOptions = Apollo.BaseMutationOptions<MigrateLocationQuickBooksMutation, MigrateLocationQuickBooksMutationVariables>;
export const UpdateLocationDocument = gql`
    mutation UpdateLocation($viewKey: ViewKey!, $dimensionId: String!, $dimension: UpdateLocationInput!) {
  updateLocation(
    viewKey: $viewKey
    locationId: $dimensionId
    location: $dimension
  ) {
    entityId: locationId
  }
}
    `;
export type UpdateLocationMutationFn = Apollo.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      dimensionId: // value for 'dimensionId'
 *      dimension: // value for 'dimension'
 *   },
 * });
 */
export function useUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMutation, UpdateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, options);
      }
export type UpdateLocationMutationHookResult = ReturnType<typeof useUpdateLocationMutation>;
export type UpdateLocationMutationResult = Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const UpdateLocationStatusDocument = gql`
    mutation UpdateLocationStatus($viewKey: ViewKey!, $dimensionId: String!, $enabled: Boolean!) {
  updateLocationStatus(
    viewKey: $viewKey
    locationId: $dimensionId
    enabled: $enabled
  )
}
    `;
export type UpdateLocationStatusMutationFn = Apollo.MutationFunction<UpdateLocationStatusMutation, UpdateLocationStatusMutationVariables>;

/**
 * __useUpdateLocationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateLocationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationStatusMutation, { data, loading, error }] = useUpdateLocationStatusMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      dimensionId: // value for 'dimensionId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateLocationStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationStatusMutation, UpdateLocationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationStatusMutation, UpdateLocationStatusMutationVariables>(UpdateLocationStatusDocument, options);
      }
export type UpdateLocationStatusMutationHookResult = ReturnType<typeof useUpdateLocationStatusMutation>;
export type UpdateLocationStatusMutationResult = Apollo.MutationResult<UpdateLocationStatusMutation>;
export type UpdateLocationStatusMutationOptions = Apollo.BaseMutationOptions<UpdateLocationStatusMutation, UpdateLocationStatusMutationVariables>;
export const ListLocationsDocument = gql`
    query ListLocations($viewKey: ViewKey!, $status: LocationStatus) {
  listLocations(viewKey: $viewKey, status: $status) {
    ...LocationFields
  }
}
    ${LocationFieldsFragmentDoc}`;

/**
 * __useListLocationsQuery__
 *
 * To run a query within a React component, call `useListLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLocationsQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useListLocationsQuery(baseOptions: Apollo.QueryHookOptions<ListLocationsQuery, ListLocationsQueryVariables> & ({ variables: ListLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLocationsQuery, ListLocationsQueryVariables>(ListLocationsDocument, options);
      }
export function useListLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLocationsQuery, ListLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLocationsQuery, ListLocationsQueryVariables>(ListLocationsDocument, options);
        }
export function useListLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLocationsQuery, ListLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLocationsQuery, ListLocationsQueryVariables>(ListLocationsDocument, options);
        }
export type ListLocationsQueryHookResult = ReturnType<typeof useListLocationsQuery>;
export type ListLocationsLazyQueryHookResult = ReturnType<typeof useListLocationsLazyQuery>;
export type ListLocationsSuspenseQueryHookResult = ReturnType<typeof useListLocationsSuspenseQuery>;
export type ListLocationsQueryResult = Apollo.QueryResult<ListLocationsQuery, ListLocationsQueryVariables>;
export const ReadLocationDocument = gql`
    query ReadLocation($viewKey: ViewKey!, $locationId: String!) {
  readLocation(viewKey: $viewKey, locationId: $locationId) {
    ...LocationFields
  }
}
    ${LocationFieldsFragmentDoc}`;

/**
 * __useReadLocationQuery__
 *
 * To run a query within a React component, call `useReadLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadLocationQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useReadLocationQuery(baseOptions: Apollo.QueryHookOptions<ReadLocationQuery, ReadLocationQueryVariables> & ({ variables: ReadLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadLocationQuery, ReadLocationQueryVariables>(ReadLocationDocument, options);
      }
export function useReadLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadLocationQuery, ReadLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadLocationQuery, ReadLocationQueryVariables>(ReadLocationDocument, options);
        }
export function useReadLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadLocationQuery, ReadLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadLocationQuery, ReadLocationQueryVariables>(ReadLocationDocument, options);
        }
export type ReadLocationQueryHookResult = ReturnType<typeof useReadLocationQuery>;
export type ReadLocationLazyQueryHookResult = ReturnType<typeof useReadLocationLazyQuery>;
export type ReadLocationSuspenseQueryHookResult = ReturnType<typeof useReadLocationSuspenseQuery>;
export type ReadLocationQueryResult = Apollo.QueryResult<ReadLocationQuery, ReadLocationQueryVariables>;
export const ListMetricsDocument = gql`
    query ListMetrics($legalEntityId: String!, $origin: IntervalOrigin!, $key: SourceAccountMetricKey!) {
  listMetrics(legalEntityId: $legalEntityId, origin: $origin, key: $key) {
    ...SourceAccountMetricIdentifierFields
  }
}
    ${SourceAccountMetricIdentifierFieldsFragmentDoc}`;

/**
 * __useListMetricsQuery__
 *
 * To run a query within a React component, call `useListMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMetricsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      origin: // value for 'origin'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useListMetricsQuery(baseOptions: Apollo.QueryHookOptions<ListMetricsQuery, ListMetricsQueryVariables> & ({ variables: ListMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMetricsQuery, ListMetricsQueryVariables>(ListMetricsDocument, options);
      }
export function useListMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMetricsQuery, ListMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMetricsQuery, ListMetricsQueryVariables>(ListMetricsDocument, options);
        }
export function useListMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMetricsQuery, ListMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMetricsQuery, ListMetricsQueryVariables>(ListMetricsDocument, options);
        }
export type ListMetricsQueryHookResult = ReturnType<typeof useListMetricsQuery>;
export type ListMetricsLazyQueryHookResult = ReturnType<typeof useListMetricsLazyQuery>;
export type ListMetricsSuspenseQueryHookResult = ReturnType<typeof useListMetricsSuspenseQuery>;
export type ListMetricsQueryResult = Apollo.QueryResult<ListMetricsQuery, ListMetricsQueryVariables>;
export const UpdateNotificationStatusDocument = gql`
    mutation UpdateNotificationStatus($id: String!, $status: WebNotificationStatus!) {
  updateNotificationStatus(id: $id, status: $status)
}
    `;
export type UpdateNotificationStatusMutationFn = Apollo.MutationFunction<UpdateNotificationStatusMutation, UpdateNotificationStatusMutationVariables>;

/**
 * __useUpdateNotificationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationStatusMutation, { data, loading, error }] = useUpdateNotificationStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateNotificationStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationStatusMutation, UpdateNotificationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationStatusMutation, UpdateNotificationStatusMutationVariables>(UpdateNotificationStatusDocument, options);
      }
export type UpdateNotificationStatusMutationHookResult = ReturnType<typeof useUpdateNotificationStatusMutation>;
export type UpdateNotificationStatusMutationResult = Apollo.MutationResult<UpdateNotificationStatusMutation>;
export type UpdateNotificationStatusMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationStatusMutation, UpdateNotificationStatusMutationVariables>;
export const ListNotificationsDocument = gql`
    query ListNotifications {
  listNotifications {
    ...WebNotificationFields
  }
}
    ${WebNotificationFieldsFragmentDoc}`;

/**
 * __useListNotificationsQuery__
 *
 * To run a query within a React component, call `useListNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<ListNotificationsQuery, ListNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListNotificationsQuery, ListNotificationsQueryVariables>(ListNotificationsDocument, options);
      }
export function useListNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListNotificationsQuery, ListNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListNotificationsQuery, ListNotificationsQueryVariables>(ListNotificationsDocument, options);
        }
export function useListNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListNotificationsQuery, ListNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListNotificationsQuery, ListNotificationsQueryVariables>(ListNotificationsDocument, options);
        }
export type ListNotificationsQueryHookResult = ReturnType<typeof useListNotificationsQuery>;
export type ListNotificationsLazyQueryHookResult = ReturnType<typeof useListNotificationsLazyQuery>;
export type ListNotificationsSuspenseQueryHookResult = ReturnType<typeof useListNotificationsSuspenseQuery>;
export type ListNotificationsQueryResult = Apollo.QueryResult<ListNotificationsQuery, ListNotificationsQueryVariables>;
export const NotificationCreatedDocument = gql`
    subscription NotificationCreated {
  notificationCreated {
    ...WebNotificationFields
  }
}
    ${WebNotificationFieldsFragmentDoc}`;

/**
 * __useNotificationCreatedSubscription__
 *
 * To run a query within a React component, call `useNotificationCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNotificationCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NotificationCreatedSubscription, NotificationCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NotificationCreatedSubscription, NotificationCreatedSubscriptionVariables>(NotificationCreatedDocument, options);
      }
export type NotificationCreatedSubscriptionHookResult = ReturnType<typeof useNotificationCreatedSubscription>;
export type NotificationCreatedSubscriptionResult = Apollo.SubscriptionResult<NotificationCreatedSubscription>;
export const ApproveOAuthAuthorizationDocument = gql`
    mutation ApproveOAuthAuthorization($clientId: String!, $redirectUri: String!, $codeChallenge: String!, $codeChallengeMethod: String!, $state: String!) {
  approveOAuthAuthorization(
    clientId: $clientId
    redirectUri: $redirectUri
    codeChallenge: $codeChallenge
    codeChallengeMethod: $codeChallengeMethod
    state: $state
  ) {
    redirectURL
  }
}
    `;
export type ApproveOAuthAuthorizationMutationFn = Apollo.MutationFunction<ApproveOAuthAuthorizationMutation, ApproveOAuthAuthorizationMutationVariables>;

/**
 * __useApproveOAuthAuthorizationMutation__
 *
 * To run a mutation, you first call `useApproveOAuthAuthorizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveOAuthAuthorizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveOAuthAuthorizationMutation, { data, loading, error }] = useApproveOAuthAuthorizationMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      redirectUri: // value for 'redirectUri'
 *      codeChallenge: // value for 'codeChallenge'
 *      codeChallengeMethod: // value for 'codeChallengeMethod'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useApproveOAuthAuthorizationMutation(baseOptions?: Apollo.MutationHookOptions<ApproveOAuthAuthorizationMutation, ApproveOAuthAuthorizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveOAuthAuthorizationMutation, ApproveOAuthAuthorizationMutationVariables>(ApproveOAuthAuthorizationDocument, options);
      }
export type ApproveOAuthAuthorizationMutationHookResult = ReturnType<typeof useApproveOAuthAuthorizationMutation>;
export type ApproveOAuthAuthorizationMutationResult = Apollo.MutationResult<ApproveOAuthAuthorizationMutation>;
export type ApproveOAuthAuthorizationMutationOptions = Apollo.BaseMutationOptions<ApproveOAuthAuthorizationMutation, ApproveOAuthAuthorizationMutationVariables>;
export const ReadOAuthClientDocument = gql`
    query ReadOAuthClient($clientId: String!) {
  readOAuthClient(clientId: $clientId) {
    clientId
    clientName
    redirectUris
  }
}
    `;

/**
 * __useReadOAuthClientQuery__
 *
 * To run a query within a React component, call `useReadOAuthClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadOAuthClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadOAuthClientQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useReadOAuthClientQuery(baseOptions: Apollo.QueryHookOptions<ReadOAuthClientQuery, ReadOAuthClientQueryVariables> & ({ variables: ReadOAuthClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadOAuthClientQuery, ReadOAuthClientQueryVariables>(ReadOAuthClientDocument, options);
      }
export function useReadOAuthClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadOAuthClientQuery, ReadOAuthClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadOAuthClientQuery, ReadOAuthClientQueryVariables>(ReadOAuthClientDocument, options);
        }
export function useReadOAuthClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadOAuthClientQuery, ReadOAuthClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadOAuthClientQuery, ReadOAuthClientQueryVariables>(ReadOAuthClientDocument, options);
        }
export type ReadOAuthClientQueryHookResult = ReturnType<typeof useReadOAuthClientQuery>;
export type ReadOAuthClientLazyQueryHookResult = ReturnType<typeof useReadOAuthClientLazyQuery>;
export type ReadOAuthClientSuspenseQueryHookResult = ReturnType<typeof useReadOAuthClientSuspenseQuery>;
export type ReadOAuthClientQueryResult = Apollo.QueryResult<ReadOAuthClientQuery, ReadOAuthClientQueryVariables>;
export const HydrateEntitiesDocument = gql`
    query HydrateEntities($viewKey: ViewKey!, $identifiers: [HydrateIdentifier!]!, $allowMissing: Boolean) {
  hydrateEntities(
    viewKey: $viewKey
    identifiers: $identifiers
    allowMissing: $allowMissing
  ) {
    ...ObjectEntitiesFields
  }
}
    ${ObjectEntitiesFieldsFragmentDoc}`;

/**
 * __useHydrateEntitiesQuery__
 *
 * To run a query within a React component, call `useHydrateEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHydrateEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHydrateEntitiesQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      identifiers: // value for 'identifiers'
 *      allowMissing: // value for 'allowMissing'
 *   },
 * });
 */
export function useHydrateEntitiesQuery(baseOptions: Apollo.QueryHookOptions<HydrateEntitiesQuery, HydrateEntitiesQueryVariables> & ({ variables: HydrateEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HydrateEntitiesQuery, HydrateEntitiesQueryVariables>(HydrateEntitiesDocument, options);
      }
export function useHydrateEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HydrateEntitiesQuery, HydrateEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HydrateEntitiesQuery, HydrateEntitiesQueryVariables>(HydrateEntitiesDocument, options);
        }
export function useHydrateEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HydrateEntitiesQuery, HydrateEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HydrateEntitiesQuery, HydrateEntitiesQueryVariables>(HydrateEntitiesDocument, options);
        }
export type HydrateEntitiesQueryHookResult = ReturnType<typeof useHydrateEntitiesQuery>;
export type HydrateEntitiesLazyQueryHookResult = ReturnType<typeof useHydrateEntitiesLazyQuery>;
export type HydrateEntitiesSuspenseQueryHookResult = ReturnType<typeof useHydrateEntitiesSuspenseQuery>;
export type HydrateEntitiesQueryResult = Apollo.QueryResult<HydrateEntitiesQuery, HydrateEntitiesQueryVariables>;
export const UpdateObjectMappingsDocument = gql`
    mutation UpdateObjectMappings($legalEntityId: String!, $mappedTo: ObjectKind!, $lineClassIds: [String!]!, $departmentIds: [String!]!) {
  updateObjectMappings(
    legalEntityId: $legalEntityId
    mappedTo: $mappedTo
    lineClassIds: $lineClassIds
    departmentIds: $departmentIds
  ) {
    lineClassHierarchy {
      ...ObjectMappingHierarchyNodeFields
    }
    departmentHierarchy {
      ...ObjectMappingHierarchyNodeFields
    }
  }
}
    ${ObjectMappingHierarchyNodeFieldsFragmentDoc}`;
export type UpdateObjectMappingsMutationFn = Apollo.MutationFunction<UpdateObjectMappingsMutation, UpdateObjectMappingsMutationVariables>;

/**
 * __useUpdateObjectMappingsMutation__
 *
 * To run a mutation, you first call `useUpdateObjectMappingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateObjectMappingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateObjectMappingsMutation, { data, loading, error }] = useUpdateObjectMappingsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      mappedTo: // value for 'mappedTo'
 *      lineClassIds: // value for 'lineClassIds'
 *      departmentIds: // value for 'departmentIds'
 *   },
 * });
 */
export function useUpdateObjectMappingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateObjectMappingsMutation, UpdateObjectMappingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateObjectMappingsMutation, UpdateObjectMappingsMutationVariables>(UpdateObjectMappingsDocument, options);
      }
export type UpdateObjectMappingsMutationHookResult = ReturnType<typeof useUpdateObjectMappingsMutation>;
export type UpdateObjectMappingsMutationResult = Apollo.MutationResult<UpdateObjectMappingsMutation>;
export type UpdateObjectMappingsMutationOptions = Apollo.BaseMutationOptions<UpdateObjectMappingsMutation, UpdateObjectMappingsMutationVariables>;
export const ListDepartmentFactHierarchyDocument = gql`
    query ListDepartmentFactHierarchy($legalEntityId: String!) {
  listDepartmentFactHierarchy(legalEntityId: $legalEntityId) {
    ...ObjectMappingHierarchyNodeFields
  }
}
    ${ObjectMappingHierarchyNodeFieldsFragmentDoc}`;

/**
 * __useListDepartmentFactHierarchyQuery__
 *
 * To run a query within a React component, call `useListDepartmentFactHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDepartmentFactHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDepartmentFactHierarchyQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListDepartmentFactHierarchyQuery(baseOptions: Apollo.QueryHookOptions<ListDepartmentFactHierarchyQuery, ListDepartmentFactHierarchyQueryVariables> & ({ variables: ListDepartmentFactHierarchyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDepartmentFactHierarchyQuery, ListDepartmentFactHierarchyQueryVariables>(ListDepartmentFactHierarchyDocument, options);
      }
export function useListDepartmentFactHierarchyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDepartmentFactHierarchyQuery, ListDepartmentFactHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDepartmentFactHierarchyQuery, ListDepartmentFactHierarchyQueryVariables>(ListDepartmentFactHierarchyDocument, options);
        }
export function useListDepartmentFactHierarchySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListDepartmentFactHierarchyQuery, ListDepartmentFactHierarchyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListDepartmentFactHierarchyQuery, ListDepartmentFactHierarchyQueryVariables>(ListDepartmentFactHierarchyDocument, options);
        }
export type ListDepartmentFactHierarchyQueryHookResult = ReturnType<typeof useListDepartmentFactHierarchyQuery>;
export type ListDepartmentFactHierarchyLazyQueryHookResult = ReturnType<typeof useListDepartmentFactHierarchyLazyQuery>;
export type ListDepartmentFactHierarchySuspenseQueryHookResult = ReturnType<typeof useListDepartmentFactHierarchySuspenseQuery>;
export type ListDepartmentFactHierarchyQueryResult = Apollo.QueryResult<ListDepartmentFactHierarchyQuery, ListDepartmentFactHierarchyQueryVariables>;
export const ListLineClassFactHierarchyDocument = gql`
    query ListLineClassFactHierarchy($legalEntityId: String!) {
  listLineClassFactHierarchy(legalEntityId: $legalEntityId) {
    ...ObjectMappingHierarchyNodeFields
  }
}
    ${ObjectMappingHierarchyNodeFieldsFragmentDoc}`;

/**
 * __useListLineClassFactHierarchyQuery__
 *
 * To run a query within a React component, call `useListLineClassFactHierarchyQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLineClassFactHierarchyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLineClassFactHierarchyQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListLineClassFactHierarchyQuery(baseOptions: Apollo.QueryHookOptions<ListLineClassFactHierarchyQuery, ListLineClassFactHierarchyQueryVariables> & ({ variables: ListLineClassFactHierarchyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLineClassFactHierarchyQuery, ListLineClassFactHierarchyQueryVariables>(ListLineClassFactHierarchyDocument, options);
      }
export function useListLineClassFactHierarchyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLineClassFactHierarchyQuery, ListLineClassFactHierarchyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLineClassFactHierarchyQuery, ListLineClassFactHierarchyQueryVariables>(ListLineClassFactHierarchyDocument, options);
        }
export function useListLineClassFactHierarchySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLineClassFactHierarchyQuery, ListLineClassFactHierarchyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLineClassFactHierarchyQuery, ListLineClassFactHierarchyQueryVariables>(ListLineClassFactHierarchyDocument, options);
        }
export type ListLineClassFactHierarchyQueryHookResult = ReturnType<typeof useListLineClassFactHierarchyQuery>;
export type ListLineClassFactHierarchyLazyQueryHookResult = ReturnType<typeof useListLineClassFactHierarchyLazyQuery>;
export type ListLineClassFactHierarchySuspenseQueryHookResult = ReturnType<typeof useListLineClassFactHierarchySuspenseQuery>;
export type ListLineClassFactHierarchyQueryResult = Apollo.QueryResult<ListLineClassFactHierarchyQuery, ListLineClassFactHierarchyQueryVariables>;
export const ConfirmOperatorResetDocument = gql`
    mutation ConfirmOperatorReset($legalEntityId: String!) {
  confirmOperatorReset(legalEntityId: $legalEntityId)
}
    `;
export type ConfirmOperatorResetMutationFn = Apollo.MutationFunction<ConfirmOperatorResetMutation, ConfirmOperatorResetMutationVariables>;

/**
 * __useConfirmOperatorResetMutation__
 *
 * To run a mutation, you first call `useConfirmOperatorResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmOperatorResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmOperatorResetMutation, { data, loading, error }] = useConfirmOperatorResetMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useConfirmOperatorResetMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmOperatorResetMutation, ConfirmOperatorResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmOperatorResetMutation, ConfirmOperatorResetMutationVariables>(ConfirmOperatorResetDocument, options);
      }
export type ConfirmOperatorResetMutationHookResult = ReturnType<typeof useConfirmOperatorResetMutation>;
export type ConfirmOperatorResetMutationResult = Apollo.MutationResult<ConfirmOperatorResetMutation>;
export type ConfirmOperatorResetMutationOptions = Apollo.BaseMutationOptions<ConfirmOperatorResetMutation, ConfirmOperatorResetMutationVariables>;
export const ConfirmOperatorTrialDocument = gql`
    mutation ConfirmOperatorTrial($legalEntityId: String!, $organizationId: String!) {
  confirmOperatorTrial(
    organizationId: $organizationId
    legalEntityId: $legalEntityId
  )
}
    `;
export type ConfirmOperatorTrialMutationFn = Apollo.MutationFunction<ConfirmOperatorTrialMutation, ConfirmOperatorTrialMutationVariables>;

/**
 * __useConfirmOperatorTrialMutation__
 *
 * To run a mutation, you first call `useConfirmOperatorTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmOperatorTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmOperatorTrialMutation, { data, loading, error }] = useConfirmOperatorTrialMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useConfirmOperatorTrialMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmOperatorTrialMutation, ConfirmOperatorTrialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmOperatorTrialMutation, ConfirmOperatorTrialMutationVariables>(ConfirmOperatorTrialDocument, options);
      }
export type ConfirmOperatorTrialMutationHookResult = ReturnType<typeof useConfirmOperatorTrialMutation>;
export type ConfirmOperatorTrialMutationResult = Apollo.MutationResult<ConfirmOperatorTrialMutation>;
export type ConfirmOperatorTrialMutationOptions = Apollo.BaseMutationOptions<ConfirmOperatorTrialMutation, ConfirmOperatorTrialMutationVariables>;
export const OnboardLegalEntityDocument = gql`
    mutation OnboardLegalEntity($name: String!, $contact: ContactInput!, $websiteUrl: String, $phoneNumber: String, $minimalCoa: Boolean) {
  onboardLegalEntity(
    name: $name
    contact: $contact
    websiteUrl: $websiteUrl
    phoneNumber: $phoneNumber
    minimalCoa: $minimalCoa
  ) {
    ...AIBookkeeperLegalEntityFields
  }
}
    ${AiBookkeeperLegalEntityFieldsFragmentDoc}`;
export type OnboardLegalEntityMutationFn = Apollo.MutationFunction<OnboardLegalEntityMutation, OnboardLegalEntityMutationVariables>;

/**
 * __useOnboardLegalEntityMutation__
 *
 * To run a mutation, you first call `useOnboardLegalEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardLegalEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardLegalEntityMutation, { data, loading, error }] = useOnboardLegalEntityMutation({
 *   variables: {
 *      name: // value for 'name'
 *      contact: // value for 'contact'
 *      websiteUrl: // value for 'websiteUrl'
 *      phoneNumber: // value for 'phoneNumber'
 *      minimalCoa: // value for 'minimalCoa'
 *   },
 * });
 */
export function useOnboardLegalEntityMutation(baseOptions?: Apollo.MutationHookOptions<OnboardLegalEntityMutation, OnboardLegalEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardLegalEntityMutation, OnboardLegalEntityMutationVariables>(OnboardLegalEntityDocument, options);
      }
export type OnboardLegalEntityMutationHookResult = ReturnType<typeof useOnboardLegalEntityMutation>;
export type OnboardLegalEntityMutationResult = Apollo.MutationResult<OnboardLegalEntityMutation>;
export type OnboardLegalEntityMutationOptions = Apollo.BaseMutationOptions<OnboardLegalEntityMutation, OnboardLegalEntityMutationVariables>;
export const OnboardLegalEntityFromOAuthServiceDocument = gql`
    mutation OnboardLegalEntityFromOAuthService($code: String!, $service: OAuthService!) {
  onboardLegalEntityFromOAuthService(code: $code, service: $service) {
    ...AIBookkeeperLegalEntityFields
  }
}
    ${AiBookkeeperLegalEntityFieldsFragmentDoc}`;
export type OnboardLegalEntityFromOAuthServiceMutationFn = Apollo.MutationFunction<OnboardLegalEntityFromOAuthServiceMutation, OnboardLegalEntityFromOAuthServiceMutationVariables>;

/**
 * __useOnboardLegalEntityFromOAuthServiceMutation__
 *
 * To run a mutation, you first call `useOnboardLegalEntityFromOAuthServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardLegalEntityFromOAuthServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardLegalEntityFromOAuthServiceMutation, { data, loading, error }] = useOnboardLegalEntityFromOAuthServiceMutation({
 *   variables: {
 *      code: // value for 'code'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useOnboardLegalEntityFromOAuthServiceMutation(baseOptions?: Apollo.MutationHookOptions<OnboardLegalEntityFromOAuthServiceMutation, OnboardLegalEntityFromOAuthServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardLegalEntityFromOAuthServiceMutation, OnboardLegalEntityFromOAuthServiceMutationVariables>(OnboardLegalEntityFromOAuthServiceDocument, options);
      }
export type OnboardLegalEntityFromOAuthServiceMutationHookResult = ReturnType<typeof useOnboardLegalEntityFromOAuthServiceMutation>;
export type OnboardLegalEntityFromOAuthServiceMutationResult = Apollo.MutationResult<OnboardLegalEntityFromOAuthServiceMutation>;
export type OnboardLegalEntityFromOAuthServiceMutationOptions = Apollo.BaseMutationOptions<OnboardLegalEntityFromOAuthServiceMutation, OnboardLegalEntityFromOAuthServiceMutationVariables>;
export const CreateAffiliationFromOAuthServiceDocument = gql`
    mutation CreateAffiliationFromOAuthService($organizationId: String!, $code: String!, $service: OAuthService!, $proposalOrganizationId: String) {
  createAffiliationFromOAuthService(
    organizationId: $organizationId
    code: $code
    service: $service
    proposalOrganizationId: $proposalOrganizationId
  ) {
    legalEntity {
      ...LegalEntityFields
    }
    quickBooksCompany {
      ...QuickBooksCompanyFields
    }
  }
}
    ${LegalEntityFieldsFragmentDoc}
${QuickBooksCompanyFieldsFragmentDoc}`;
export type CreateAffiliationFromOAuthServiceMutationFn = Apollo.MutationFunction<CreateAffiliationFromOAuthServiceMutation, CreateAffiliationFromOAuthServiceMutationVariables>;

/**
 * __useCreateAffiliationFromOAuthServiceMutation__
 *
 * To run a mutation, you first call `useCreateAffiliationFromOAuthServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAffiliationFromOAuthServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAffiliationFromOAuthServiceMutation, { data, loading, error }] = useCreateAffiliationFromOAuthServiceMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      code: // value for 'code'
 *      service: // value for 'service'
 *      proposalOrganizationId: // value for 'proposalOrganizationId'
 *   },
 * });
 */
export function useCreateAffiliationFromOAuthServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateAffiliationFromOAuthServiceMutation, CreateAffiliationFromOAuthServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAffiliationFromOAuthServiceMutation, CreateAffiliationFromOAuthServiceMutationVariables>(CreateAffiliationFromOAuthServiceDocument, options);
      }
export type CreateAffiliationFromOAuthServiceMutationHookResult = ReturnType<typeof useCreateAffiliationFromOAuthServiceMutation>;
export type CreateAffiliationFromOAuthServiceMutationResult = Apollo.MutationResult<CreateAffiliationFromOAuthServiceMutation>;
export type CreateAffiliationFromOAuthServiceMutationOptions = Apollo.BaseMutationOptions<CreateAffiliationFromOAuthServiceMutation, CreateAffiliationFromOAuthServiceMutationVariables>;
export const CreateFirmAffiliationFromOAuthServiceDocument = gql`
    mutation CreateFirmAffiliationFromOAuthService($organizationId: String!, $code: String!, $service: OAuthService!) {
  createFirmAffiliationFromOAuthService(
    organizationId: $organizationId
    code: $code
    service: $service
  ) {
    legalEntity {
      ...LegalEntityFields
    }
    quickBooksCompany {
      ...QuickBooksCompanyFields
    }
  }
}
    ${LegalEntityFieldsFragmentDoc}
${QuickBooksCompanyFieldsFragmentDoc}`;
export type CreateFirmAffiliationFromOAuthServiceMutationFn = Apollo.MutationFunction<CreateFirmAffiliationFromOAuthServiceMutation, CreateFirmAffiliationFromOAuthServiceMutationVariables>;

/**
 * __useCreateFirmAffiliationFromOAuthServiceMutation__
 *
 * To run a mutation, you first call `useCreateFirmAffiliationFromOAuthServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFirmAffiliationFromOAuthServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFirmAffiliationFromOAuthServiceMutation, { data, loading, error }] = useCreateFirmAffiliationFromOAuthServiceMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      code: // value for 'code'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useCreateFirmAffiliationFromOAuthServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateFirmAffiliationFromOAuthServiceMutation, CreateFirmAffiliationFromOAuthServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFirmAffiliationFromOAuthServiceMutation, CreateFirmAffiliationFromOAuthServiceMutationVariables>(CreateFirmAffiliationFromOAuthServiceDocument, options);
      }
export type CreateFirmAffiliationFromOAuthServiceMutationHookResult = ReturnType<typeof useCreateFirmAffiliationFromOAuthServiceMutation>;
export type CreateFirmAffiliationFromOAuthServiceMutationResult = Apollo.MutationResult<CreateFirmAffiliationFromOAuthServiceMutation>;
export type CreateFirmAffiliationFromOAuthServiceMutationOptions = Apollo.BaseMutationOptions<CreateFirmAffiliationFromOAuthServiceMutation, CreateFirmAffiliationFromOAuthServiceMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($companyName: String!, $kind: OrganizationKind!, $iconObjectName: String, $websiteUrl: String, $phoneNumber: String, $numberOfAccountants: String, $numberOfClients: String) {
  createOrganization(
    name: $companyName
    kind: $kind
    iconObjectName: $iconObjectName
    websiteUrl: $websiteUrl
    phoneNumber: $phoneNumber
    numberOfAccountants: $numberOfAccountants
    numberOfClients: $numberOfClients
  ) {
    ...OrganizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      companyName: // value for 'companyName'
 *      kind: // value for 'kind'
 *      iconObjectName: // value for 'iconObjectName'
 *      websiteUrl: // value for 'websiteUrl'
 *      phoneNumber: // value for 'phoneNumber'
 *      numberOfAccountants: // value for 'numberOfAccountants'
 *      numberOfClients: // value for 'numberOfClients'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const ProvisionLegalEntityDocument = gql`
    mutation ProvisionLegalEntity($name: String!, $websiteUrl: String, $iconObjectName: String, $organizationId: String, $affiliatedOrganizationId: String) {
  provisionLegalEntity(
    name: $name
    websiteUrl: $websiteUrl
    iconObjectName: $iconObjectName
    organizationId: $organizationId
    affiliatedOrganizationId: $affiliatedOrganizationId
  ) {
    ...LegalEntityFields
  }
}
    ${LegalEntityFieldsFragmentDoc}`;
export type ProvisionLegalEntityMutationFn = Apollo.MutationFunction<ProvisionLegalEntityMutation, ProvisionLegalEntityMutationVariables>;

/**
 * __useProvisionLegalEntityMutation__
 *
 * To run a mutation, you first call `useProvisionLegalEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionLegalEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionLegalEntityMutation, { data, loading, error }] = useProvisionLegalEntityMutation({
 *   variables: {
 *      name: // value for 'name'
 *      websiteUrl: // value for 'websiteUrl'
 *      iconObjectName: // value for 'iconObjectName'
 *      organizationId: // value for 'organizationId'
 *      affiliatedOrganizationId: // value for 'affiliatedOrganizationId'
 *   },
 * });
 */
export function useProvisionLegalEntityMutation(baseOptions?: Apollo.MutationHookOptions<ProvisionLegalEntityMutation, ProvisionLegalEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProvisionLegalEntityMutation, ProvisionLegalEntityMutationVariables>(ProvisionLegalEntityDocument, options);
      }
export type ProvisionLegalEntityMutationHookResult = ReturnType<typeof useProvisionLegalEntityMutation>;
export type ProvisionLegalEntityMutationResult = Apollo.MutationResult<ProvisionLegalEntityMutation>;
export type ProvisionLegalEntityMutationOptions = Apollo.BaseMutationOptions<ProvisionLegalEntityMutation, ProvisionLegalEntityMutationVariables>;
export const ResetFirmAffiliationDocument = gql`
    mutation ResetFirmAffiliation($organizationId: String!, $affiliationId: String!, $affiliatedLegalEntityId: String!, $minimalCoa: Boolean = false, $reason: String!) {
  resetFirmAffiliation(
    organizationId: $organizationId
    affiliationId: $affiliationId
    affiliatedLegalEntityId: $affiliatedLegalEntityId
    minimalCoa: $minimalCoa
    reason: $reason
  ) {
    ...LegalEntityFields
  }
}
    ${LegalEntityFieldsFragmentDoc}`;
export type ResetFirmAffiliationMutationFn = Apollo.MutationFunction<ResetFirmAffiliationMutation, ResetFirmAffiliationMutationVariables>;

/**
 * __useResetFirmAffiliationMutation__
 *
 * To run a mutation, you first call `useResetFirmAffiliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetFirmAffiliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetFirmAffiliationMutation, { data, loading, error }] = useResetFirmAffiliationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      affiliationId: // value for 'affiliationId'
 *      affiliatedLegalEntityId: // value for 'affiliatedLegalEntityId'
 *      minimalCoa: // value for 'minimalCoa'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useResetFirmAffiliationMutation(baseOptions?: Apollo.MutationHookOptions<ResetFirmAffiliationMutation, ResetFirmAffiliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetFirmAffiliationMutation, ResetFirmAffiliationMutationVariables>(ResetFirmAffiliationDocument, options);
      }
export type ResetFirmAffiliationMutationHookResult = ReturnType<typeof useResetFirmAffiliationMutation>;
export type ResetFirmAffiliationMutationResult = Apollo.MutationResult<ResetFirmAffiliationMutation>;
export type ResetFirmAffiliationMutationOptions = Apollo.BaseMutationOptions<ResetFirmAffiliationMutation, ResetFirmAffiliationMutationVariables>;
export const ResetFirmAffiliationFromOAuthServiceDocument = gql`
    mutation ResetFirmAffiliationFromOAuthService($organizationId: String!, $affiliationId: String!, $affiliatedLegalEntityId: String!, $code: String!, $service: OAuthService!, $reason: String!) {
  resetFirmAffiliationFromOAuthService(
    organizationId: $organizationId
    affiliationId: $affiliationId
    affiliatedLegalEntityId: $affiliatedLegalEntityId
    code: $code
    service: $service
    reason: $reason
  ) {
    legalEntity {
      ...LegalEntityFields
    }
    quickBooksCompany {
      ...QuickBooksCompanyFields
    }
  }
}
    ${LegalEntityFieldsFragmentDoc}
${QuickBooksCompanyFieldsFragmentDoc}`;
export type ResetFirmAffiliationFromOAuthServiceMutationFn = Apollo.MutationFunction<ResetFirmAffiliationFromOAuthServiceMutation, ResetFirmAffiliationFromOAuthServiceMutationVariables>;

/**
 * __useResetFirmAffiliationFromOAuthServiceMutation__
 *
 * To run a mutation, you first call `useResetFirmAffiliationFromOAuthServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetFirmAffiliationFromOAuthServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetFirmAffiliationFromOAuthServiceMutation, { data, loading, error }] = useResetFirmAffiliationFromOAuthServiceMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      affiliationId: // value for 'affiliationId'
 *      affiliatedLegalEntityId: // value for 'affiliatedLegalEntityId'
 *      code: // value for 'code'
 *      service: // value for 'service'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useResetFirmAffiliationFromOAuthServiceMutation(baseOptions?: Apollo.MutationHookOptions<ResetFirmAffiliationFromOAuthServiceMutation, ResetFirmAffiliationFromOAuthServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetFirmAffiliationFromOAuthServiceMutation, ResetFirmAffiliationFromOAuthServiceMutationVariables>(ResetFirmAffiliationFromOAuthServiceDocument, options);
      }
export type ResetFirmAffiliationFromOAuthServiceMutationHookResult = ReturnType<typeof useResetFirmAffiliationFromOAuthServiceMutation>;
export type ResetFirmAffiliationFromOAuthServiceMutationResult = Apollo.MutationResult<ResetFirmAffiliationFromOAuthServiceMutation>;
export type ResetFirmAffiliationFromOAuthServiceMutationOptions = Apollo.BaseMutationOptions<ResetFirmAffiliationFromOAuthServiceMutation, ResetFirmAffiliationFromOAuthServiceMutationVariables>;
export const ResetOperatorLegalEntityDocument = gql`
    mutation ResetOperatorLegalEntity($organizationId: String!, $legalEntityId: String!, $minimalCoa: Boolean = false, $reason: String!) {
  resetOperatorLegalEntity(
    organizationId: $organizationId
    legalEntityId: $legalEntityId
    minimalCoa: $minimalCoa
    reason: $reason
  ) {
    ...LegalEntityFields
  }
}
    ${LegalEntityFieldsFragmentDoc}`;
export type ResetOperatorLegalEntityMutationFn = Apollo.MutationFunction<ResetOperatorLegalEntityMutation, ResetOperatorLegalEntityMutationVariables>;

/**
 * __useResetOperatorLegalEntityMutation__
 *
 * To run a mutation, you first call `useResetOperatorLegalEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetOperatorLegalEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetOperatorLegalEntityMutation, { data, loading, error }] = useResetOperatorLegalEntityMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      legalEntityId: // value for 'legalEntityId'
 *      minimalCoa: // value for 'minimalCoa'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useResetOperatorLegalEntityMutation(baseOptions?: Apollo.MutationHookOptions<ResetOperatorLegalEntityMutation, ResetOperatorLegalEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetOperatorLegalEntityMutation, ResetOperatorLegalEntityMutationVariables>(ResetOperatorLegalEntityDocument, options);
      }
export type ResetOperatorLegalEntityMutationHookResult = ReturnType<typeof useResetOperatorLegalEntityMutation>;
export type ResetOperatorLegalEntityMutationResult = Apollo.MutationResult<ResetOperatorLegalEntityMutation>;
export type ResetOperatorLegalEntityMutationOptions = Apollo.BaseMutationOptions<ResetOperatorLegalEntityMutation, ResetOperatorLegalEntityMutationVariables>;
export const ResetOperatorLegalEntityFromOAuthServiceDocument = gql`
    mutation ResetOperatorLegalEntityFromOAuthService($organizationId: String!, $legalEntityId: String!, $code: String!, $service: OAuthService!, $reason: String!) {
  resetOperatorLegalEntityFromOAuthService(
    organizationId: $organizationId
    legalEntityId: $legalEntityId
    code: $code
    service: $service
    reason: $reason
  ) {
    legalEntity {
      ...LegalEntityFields
    }
    quickBooksCompany {
      ...QuickBooksCompanyFields
    }
  }
}
    ${LegalEntityFieldsFragmentDoc}
${QuickBooksCompanyFieldsFragmentDoc}`;
export type ResetOperatorLegalEntityFromOAuthServiceMutationFn = Apollo.MutationFunction<ResetOperatorLegalEntityFromOAuthServiceMutation, ResetOperatorLegalEntityFromOAuthServiceMutationVariables>;

/**
 * __useResetOperatorLegalEntityFromOAuthServiceMutation__
 *
 * To run a mutation, you first call `useResetOperatorLegalEntityFromOAuthServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetOperatorLegalEntityFromOAuthServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetOperatorLegalEntityFromOAuthServiceMutation, { data, loading, error }] = useResetOperatorLegalEntityFromOAuthServiceMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      legalEntityId: // value for 'legalEntityId'
 *      code: // value for 'code'
 *      service: // value for 'service'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useResetOperatorLegalEntityFromOAuthServiceMutation(baseOptions?: Apollo.MutationHookOptions<ResetOperatorLegalEntityFromOAuthServiceMutation, ResetOperatorLegalEntityFromOAuthServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetOperatorLegalEntityFromOAuthServiceMutation, ResetOperatorLegalEntityFromOAuthServiceMutationVariables>(ResetOperatorLegalEntityFromOAuthServiceDocument, options);
      }
export type ResetOperatorLegalEntityFromOAuthServiceMutationHookResult = ReturnType<typeof useResetOperatorLegalEntityFromOAuthServiceMutation>;
export type ResetOperatorLegalEntityFromOAuthServiceMutationResult = Apollo.MutationResult<ResetOperatorLegalEntityFromOAuthServiceMutation>;
export type ResetOperatorLegalEntityFromOAuthServiceMutationOptions = Apollo.BaseMutationOptions<ResetOperatorLegalEntityFromOAuthServiceMutation, ResetOperatorLegalEntityFromOAuthServiceMutationVariables>;
export const SendManagedOperatorResetDocument = gql`
    mutation SendManagedOperatorReset($firmOrganizationId: String!, $affiliatedLegalEntityId: String!, $message: String!) {
  sendManagedOperatorReset(
    firmOrganizationId: $firmOrganizationId
    affiliatedLegalEntityId: $affiliatedLegalEntityId
    message: $message
  )
}
    `;
export type SendManagedOperatorResetMutationFn = Apollo.MutationFunction<SendManagedOperatorResetMutation, SendManagedOperatorResetMutationVariables>;

/**
 * __useSendManagedOperatorResetMutation__
 *
 * To run a mutation, you first call `useSendManagedOperatorResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendManagedOperatorResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendManagedOperatorResetMutation, { data, loading, error }] = useSendManagedOperatorResetMutation({
 *   variables: {
 *      firmOrganizationId: // value for 'firmOrganizationId'
 *      affiliatedLegalEntityId: // value for 'affiliatedLegalEntityId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendManagedOperatorResetMutation(baseOptions?: Apollo.MutationHookOptions<SendManagedOperatorResetMutation, SendManagedOperatorResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendManagedOperatorResetMutation, SendManagedOperatorResetMutationVariables>(SendManagedOperatorResetDocument, options);
      }
export type SendManagedOperatorResetMutationHookResult = ReturnType<typeof useSendManagedOperatorResetMutation>;
export type SendManagedOperatorResetMutationResult = Apollo.MutationResult<SendManagedOperatorResetMutation>;
export type SendManagedOperatorResetMutationOptions = Apollo.BaseMutationOptions<SendManagedOperatorResetMutation, SendManagedOperatorResetMutationVariables>;
export const SubmitAccountantOnboardingDocument = gql`
    mutation SubmitAccountantOnboarding($legalEntityId: String!) {
  submitAccountantOnboarding(legalEntityId: $legalEntityId)
}
    `;
export type SubmitAccountantOnboardingMutationFn = Apollo.MutationFunction<SubmitAccountantOnboardingMutation, SubmitAccountantOnboardingMutationVariables>;

/**
 * __useSubmitAccountantOnboardingMutation__
 *
 * To run a mutation, you first call `useSubmitAccountantOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAccountantOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAccountantOnboardingMutation, { data, loading, error }] = useSubmitAccountantOnboardingMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useSubmitAccountantOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<SubmitAccountantOnboardingMutation, SubmitAccountantOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAccountantOnboardingMutation, SubmitAccountantOnboardingMutationVariables>(SubmitAccountantOnboardingDocument, options);
      }
export type SubmitAccountantOnboardingMutationHookResult = ReturnType<typeof useSubmitAccountantOnboardingMutation>;
export type SubmitAccountantOnboardingMutationResult = Apollo.MutationResult<SubmitAccountantOnboardingMutation>;
export type SubmitAccountantOnboardingMutationOptions = Apollo.BaseMutationOptions<SubmitAccountantOnboardingMutation, SubmitAccountantOnboardingMutationVariables>;
export const UpdateQuickBooksCredentialsDocument = gql`
    mutation UpdateQuickBooksCredentials($legalEntityId: String!, $code: String!, $service: OAuthService!) {
  updateQuickBooksCredentials(
    legalEntityId: $legalEntityId
    code: $code
    service: $service
  )
}
    `;
export type UpdateQuickBooksCredentialsMutationFn = Apollo.MutationFunction<UpdateQuickBooksCredentialsMutation, UpdateQuickBooksCredentialsMutationVariables>;

/**
 * __useUpdateQuickBooksCredentialsMutation__
 *
 * To run a mutation, you first call `useUpdateQuickBooksCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuickBooksCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuickBooksCredentialsMutation, { data, loading, error }] = useUpdateQuickBooksCredentialsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      code: // value for 'code'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useUpdateQuickBooksCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuickBooksCredentialsMutation, UpdateQuickBooksCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuickBooksCredentialsMutation, UpdateQuickBooksCredentialsMutationVariables>(UpdateQuickBooksCredentialsDocument, options);
      }
export type UpdateQuickBooksCredentialsMutationHookResult = ReturnType<typeof useUpdateQuickBooksCredentialsMutation>;
export type UpdateQuickBooksCredentialsMutationResult = Apollo.MutationResult<UpdateQuickBooksCredentialsMutation>;
export type UpdateQuickBooksCredentialsMutationOptions = Apollo.BaseMutationOptions<UpdateQuickBooksCredentialsMutation, UpdateQuickBooksCredentialsMutationVariables>;
export const CanResetLegalEntityDocument = gql`
    query CanResetLegalEntity($legalEntityId: String!) {
  canResetLegalEntity(legalEntityId: $legalEntityId) {
    canReset
    outstandingBalance {
      ...MonetaryValueFields
    }
  }
}
    ${MonetaryValueFieldsFragmentDoc}`;

/**
 * __useCanResetLegalEntityQuery__
 *
 * To run a query within a React component, call `useCanResetLegalEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanResetLegalEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanResetLegalEntityQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useCanResetLegalEntityQuery(baseOptions: Apollo.QueryHookOptions<CanResetLegalEntityQuery, CanResetLegalEntityQueryVariables> & ({ variables: CanResetLegalEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanResetLegalEntityQuery, CanResetLegalEntityQueryVariables>(CanResetLegalEntityDocument, options);
      }
export function useCanResetLegalEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanResetLegalEntityQuery, CanResetLegalEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanResetLegalEntityQuery, CanResetLegalEntityQueryVariables>(CanResetLegalEntityDocument, options);
        }
export function useCanResetLegalEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CanResetLegalEntityQuery, CanResetLegalEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CanResetLegalEntityQuery, CanResetLegalEntityQueryVariables>(CanResetLegalEntityDocument, options);
        }
export type CanResetLegalEntityQueryHookResult = ReturnType<typeof useCanResetLegalEntityQuery>;
export type CanResetLegalEntityLazyQueryHookResult = ReturnType<typeof useCanResetLegalEntityLazyQuery>;
export type CanResetLegalEntitySuspenseQueryHookResult = ReturnType<typeof useCanResetLegalEntitySuspenseQuery>;
export type CanResetLegalEntityQueryResult = Apollo.QueryResult<CanResetLegalEntityQuery, CanResetLegalEntityQueryVariables>;
export const BootstrapSandboxAccountingOrganizationDocument = gql`
    mutation BootstrapSandboxAccountingOrganization {
  bootstrapSandboxAccountingOrganization
}
    `;
export type BootstrapSandboxAccountingOrganizationMutationFn = Apollo.MutationFunction<BootstrapSandboxAccountingOrganizationMutation, BootstrapSandboxAccountingOrganizationMutationVariables>;

/**
 * __useBootstrapSandboxAccountingOrganizationMutation__
 *
 * To run a mutation, you first call `useBootstrapSandboxAccountingOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBootstrapSandboxAccountingOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bootstrapSandboxAccountingOrganizationMutation, { data, loading, error }] = useBootstrapSandboxAccountingOrganizationMutation({
 *   variables: {
 *   },
 * });
 */
export function useBootstrapSandboxAccountingOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<BootstrapSandboxAccountingOrganizationMutation, BootstrapSandboxAccountingOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BootstrapSandboxAccountingOrganizationMutation, BootstrapSandboxAccountingOrganizationMutationVariables>(BootstrapSandboxAccountingOrganizationDocument, options);
      }
export type BootstrapSandboxAccountingOrganizationMutationHookResult = ReturnType<typeof useBootstrapSandboxAccountingOrganizationMutation>;
export type BootstrapSandboxAccountingOrganizationMutationResult = Apollo.MutationResult<BootstrapSandboxAccountingOrganizationMutation>;
export type BootstrapSandboxAccountingOrganizationMutationOptions = Apollo.BaseMutationOptions<BootstrapSandboxAccountingOrganizationMutation, BootstrapSandboxAccountingOrganizationMutationVariables>;
export const DeleteOrganizationBrandingDocument = gql`
    mutation DeleteOrganizationBranding($organizationId: String!) {
  deleteOrganizationBranding(organizationId: $organizationId)
}
    `;
export type DeleteOrganizationBrandingMutationFn = Apollo.MutationFunction<DeleteOrganizationBrandingMutation, DeleteOrganizationBrandingMutationVariables>;

/**
 * __useDeleteOrganizationBrandingMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationBrandingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationBrandingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationBrandingMutation, { data, loading, error }] = useDeleteOrganizationBrandingMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteOrganizationBrandingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationBrandingMutation, DeleteOrganizationBrandingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationBrandingMutation, DeleteOrganizationBrandingMutationVariables>(DeleteOrganizationBrandingDocument, options);
      }
export type DeleteOrganizationBrandingMutationHookResult = ReturnType<typeof useDeleteOrganizationBrandingMutation>;
export type DeleteOrganizationBrandingMutationResult = Apollo.MutationResult<DeleteOrganizationBrandingMutation>;
export type DeleteOrganizationBrandingMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationBrandingMutation, DeleteOrganizationBrandingMutationVariables>;
export const ResetSandboxAccountingOrganizationDocument = gql`
    mutation ResetSandboxAccountingOrganization {
  resetSandboxAccountingOrganization
}
    `;
export type ResetSandboxAccountingOrganizationMutationFn = Apollo.MutationFunction<ResetSandboxAccountingOrganizationMutation, ResetSandboxAccountingOrganizationMutationVariables>;

/**
 * __useResetSandboxAccountingOrganizationMutation__
 *
 * To run a mutation, you first call `useResetSandboxAccountingOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetSandboxAccountingOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetSandboxAccountingOrganizationMutation, { data, loading, error }] = useResetSandboxAccountingOrganizationMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetSandboxAccountingOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<ResetSandboxAccountingOrganizationMutation, ResetSandboxAccountingOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetSandboxAccountingOrganizationMutation, ResetSandboxAccountingOrganizationMutationVariables>(ResetSandboxAccountingOrganizationDocument, options);
      }
export type ResetSandboxAccountingOrganizationMutationHookResult = ReturnType<typeof useResetSandboxAccountingOrganizationMutation>;
export type ResetSandboxAccountingOrganizationMutationResult = Apollo.MutationResult<ResetSandboxAccountingOrganizationMutation>;
export type ResetSandboxAccountingOrganizationMutationOptions = Apollo.BaseMutationOptions<ResetSandboxAccountingOrganizationMutation, ResetSandboxAccountingOrganizationMutationVariables>;
export const SaveOrganizationBrandingDocument = gql`
    mutation SaveOrganizationBranding($organizationId: String!, $branding: InputOrganizationBranding!) {
  saveOrganizationBranding(organizationId: $organizationId, branding: $branding) {
    ...OrganizationBrandingFields
  }
}
    ${OrganizationBrandingFieldsFragmentDoc}`;
export type SaveOrganizationBrandingMutationFn = Apollo.MutationFunction<SaveOrganizationBrandingMutation, SaveOrganizationBrandingMutationVariables>;

/**
 * __useSaveOrganizationBrandingMutation__
 *
 * To run a mutation, you first call `useSaveOrganizationBrandingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOrganizationBrandingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOrganizationBrandingMutation, { data, loading, error }] = useSaveOrganizationBrandingMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      branding: // value for 'branding'
 *   },
 * });
 */
export function useSaveOrganizationBrandingMutation(baseOptions?: Apollo.MutationHookOptions<SaveOrganizationBrandingMutation, SaveOrganizationBrandingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOrganizationBrandingMutation, SaveOrganizationBrandingMutationVariables>(SaveOrganizationBrandingDocument, options);
      }
export type SaveOrganizationBrandingMutationHookResult = ReturnType<typeof useSaveOrganizationBrandingMutation>;
export type SaveOrganizationBrandingMutationResult = Apollo.MutationResult<SaveOrganizationBrandingMutation>;
export type SaveOrganizationBrandingMutationOptions = Apollo.BaseMutationOptions<SaveOrganizationBrandingMutation, SaveOrganizationBrandingMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($id: String!, $name: String!, $websiteUrl: String, $phoneNumber: String) {
  updateOrganization(
    id: $id
    name: $name
    websiteUrl: $websiteUrl
    phoneNumber: $phoneNumber
  )
}
    `;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      websiteUrl: // value for 'websiteUrl'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdateOrganizationIconDocument = gql`
    mutation UpdateOrganizationIcon($organizationId: String!, $iconObjectName: String) {
  updateOrganizationIcon(
    organizationId: $organizationId
    iconObjectName: $iconObjectName
  )
}
    `;
export type UpdateOrganizationIconMutationFn = Apollo.MutationFunction<UpdateOrganizationIconMutation, UpdateOrganizationIconMutationVariables>;

/**
 * __useUpdateOrganizationIconMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationIconMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationIconMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationIconMutation, { data, loading, error }] = useUpdateOrganizationIconMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      iconObjectName: // value for 'iconObjectName'
 *   },
 * });
 */
export function useUpdateOrganizationIconMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationIconMutation, UpdateOrganizationIconMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationIconMutation, UpdateOrganizationIconMutationVariables>(UpdateOrganizationIconDocument, options);
      }
export type UpdateOrganizationIconMutationHookResult = ReturnType<typeof useUpdateOrganizationIconMutation>;
export type UpdateOrganizationIconMutationResult = Apollo.MutationResult<UpdateOrganizationIconMutation>;
export type UpdateOrganizationIconMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationIconMutation, UpdateOrganizationIconMutationVariables>;
export const UpdateOrganizationPreferencesDocument = gql`
    mutation UpdateOrganizationPreferences($id: String!, $anonymizeEmployees: Boolean!) {
  updateOrganizationPreferences(id: $id, anonymizeEmployees: $anonymizeEmployees)
}
    `;
export type UpdateOrganizationPreferencesMutationFn = Apollo.MutationFunction<UpdateOrganizationPreferencesMutation, UpdateOrganizationPreferencesMutationVariables>;

/**
 * __useUpdateOrganizationPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationPreferencesMutation, { data, loading, error }] = useUpdateOrganizationPreferencesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      anonymizeEmployees: // value for 'anonymizeEmployees'
 *   },
 * });
 */
export function useUpdateOrganizationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationPreferencesMutation, UpdateOrganizationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationPreferencesMutation, UpdateOrganizationPreferencesMutationVariables>(UpdateOrganizationPreferencesDocument, options);
      }
export type UpdateOrganizationPreferencesMutationHookResult = ReturnType<typeof useUpdateOrganizationPreferencesMutation>;
export type UpdateOrganizationPreferencesMutationResult = Apollo.MutationResult<UpdateOrganizationPreferencesMutation>;
export type UpdateOrganizationPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationPreferencesMutation, UpdateOrganizationPreferencesMutationVariables>;
export const UploadOrganizationIconDocument = gql`
    mutation UploadOrganizationIcon($id: String!, $name: String!, $iconBase64: String!) {
  uploadOrganizationIcon(id: $id, name: $name, iconBase64: $iconBase64)
}
    `;
export type UploadOrganizationIconMutationFn = Apollo.MutationFunction<UploadOrganizationIconMutation, UploadOrganizationIconMutationVariables>;

/**
 * __useUploadOrganizationIconMutation__
 *
 * To run a mutation, you first call `useUploadOrganizationIconMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadOrganizationIconMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadOrganizationIconMutation, { data, loading, error }] = useUploadOrganizationIconMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      iconBase64: // value for 'iconBase64'
 *   },
 * });
 */
export function useUploadOrganizationIconMutation(baseOptions?: Apollo.MutationHookOptions<UploadOrganizationIconMutation, UploadOrganizationIconMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadOrganizationIconMutation, UploadOrganizationIconMutationVariables>(UploadOrganizationIconDocument, options);
      }
export type UploadOrganizationIconMutationHookResult = ReturnType<typeof useUploadOrganizationIconMutation>;
export type UploadOrganizationIconMutationResult = Apollo.MutationResult<UploadOrganizationIconMutation>;
export type UploadOrganizationIconMutationOptions = Apollo.BaseMutationOptions<UploadOrganizationIconMutation, UploadOrganizationIconMutationVariables>;
export const UploadProfileIconDocument = gql`
    mutation UploadProfileIcon($kinds: [ProfileIconKind!]!, $iconBase64: String!) {
  uploadProfileIcon(kinds: $kinds, iconBase64: $iconBase64) {
    kind
    objectName
  }
}
    `;
export type UploadProfileIconMutationFn = Apollo.MutationFunction<UploadProfileIconMutation, UploadProfileIconMutationVariables>;

/**
 * __useUploadProfileIconMutation__
 *
 * To run a mutation, you first call `useUploadProfileIconMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProfileIconMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProfileIconMutation, { data, loading, error }] = useUploadProfileIconMutation({
 *   variables: {
 *      kinds: // value for 'kinds'
 *      iconBase64: // value for 'iconBase64'
 *   },
 * });
 */
export function useUploadProfileIconMutation(baseOptions?: Apollo.MutationHookOptions<UploadProfileIconMutation, UploadProfileIconMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadProfileIconMutation, UploadProfileIconMutationVariables>(UploadProfileIconDocument, options);
      }
export type UploadProfileIconMutationHookResult = ReturnType<typeof useUploadProfileIconMutation>;
export type UploadProfileIconMutationResult = Apollo.MutationResult<UploadProfileIconMutation>;
export type UploadProfileIconMutationOptions = Apollo.BaseMutationOptions<UploadProfileIconMutation, UploadProfileIconMutationVariables>;
export const UploadProfileIconFromWebsiteDocument = gql`
    mutation UploadProfileIconFromWebsite($kinds: [ProfileIconKind!]!, $website: String!) {
  uploadProfileIconFromWebsite(kinds: $kinds, website: $website) {
    kind
    objectName
  }
}
    `;
export type UploadProfileIconFromWebsiteMutationFn = Apollo.MutationFunction<UploadProfileIconFromWebsiteMutation, UploadProfileIconFromWebsiteMutationVariables>;

/**
 * __useUploadProfileIconFromWebsiteMutation__
 *
 * To run a mutation, you first call `useUploadProfileIconFromWebsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProfileIconFromWebsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProfileIconFromWebsiteMutation, { data, loading, error }] = useUploadProfileIconFromWebsiteMutation({
 *   variables: {
 *      kinds: // value for 'kinds'
 *      website: // value for 'website'
 *   },
 * });
 */
export function useUploadProfileIconFromWebsiteMutation(baseOptions?: Apollo.MutationHookOptions<UploadProfileIconFromWebsiteMutation, UploadProfileIconFromWebsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadProfileIconFromWebsiteMutation, UploadProfileIconFromWebsiteMutationVariables>(UploadProfileIconFromWebsiteDocument, options);
      }
export type UploadProfileIconFromWebsiteMutationHookResult = ReturnType<typeof useUploadProfileIconFromWebsiteMutation>;
export type UploadProfileIconFromWebsiteMutationResult = Apollo.MutationResult<UploadProfileIconFromWebsiteMutation>;
export type UploadProfileIconFromWebsiteMutationOptions = Apollo.BaseMutationOptions<UploadProfileIconFromWebsiteMutation, UploadProfileIconFromWebsiteMutationVariables>;
export const ListAllOrganizationUsersDocument = gql`
    query ListAllOrganizationUsers($id: String!) {
  listOrganizationUsers(id: $id) {
    ...UserFields
  }
  listOrganizationInvitations(id: $id) {
    ...InvitationFields
  }
}
    ${UserFieldsFragmentDoc}
${InvitationFieldsFragmentDoc}`;

/**
 * __useListAllOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useListAllOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllOrganizationUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListAllOrganizationUsersQuery(baseOptions: Apollo.QueryHookOptions<ListAllOrganizationUsersQuery, ListAllOrganizationUsersQueryVariables> & ({ variables: ListAllOrganizationUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAllOrganizationUsersQuery, ListAllOrganizationUsersQueryVariables>(ListAllOrganizationUsersDocument, options);
      }
export function useListAllOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAllOrganizationUsersQuery, ListAllOrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAllOrganizationUsersQuery, ListAllOrganizationUsersQueryVariables>(ListAllOrganizationUsersDocument, options);
        }
export function useListAllOrganizationUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAllOrganizationUsersQuery, ListAllOrganizationUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAllOrganizationUsersQuery, ListAllOrganizationUsersQueryVariables>(ListAllOrganizationUsersDocument, options);
        }
export type ListAllOrganizationUsersQueryHookResult = ReturnType<typeof useListAllOrganizationUsersQuery>;
export type ListAllOrganizationUsersLazyQueryHookResult = ReturnType<typeof useListAllOrganizationUsersLazyQuery>;
export type ListAllOrganizationUsersSuspenseQueryHookResult = ReturnType<typeof useListAllOrganizationUsersSuspenseQuery>;
export type ListAllOrganizationUsersQueryResult = Apollo.QueryResult<ListAllOrganizationUsersQuery, ListAllOrganizationUsersQueryVariables>;
export const ListOrganizationAffiliationsDocument = gql`
    query ListOrganizationAffiliations($id: String!) {
  listOrganizationAffiliations(id: $id) {
    ...OrganizationAffiliationFields
  }
}
    ${OrganizationAffiliationFieldsFragmentDoc}`;

/**
 * __useListOrganizationAffiliationsQuery__
 *
 * To run a query within a React component, call `useListOrganizationAffiliationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrganizationAffiliationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrganizationAffiliationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListOrganizationAffiliationsQuery(baseOptions: Apollo.QueryHookOptions<ListOrganizationAffiliationsQuery, ListOrganizationAffiliationsQueryVariables> & ({ variables: ListOrganizationAffiliationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrganizationAffiliationsQuery, ListOrganizationAffiliationsQueryVariables>(ListOrganizationAffiliationsDocument, options);
      }
export function useListOrganizationAffiliationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrganizationAffiliationsQuery, ListOrganizationAffiliationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrganizationAffiliationsQuery, ListOrganizationAffiliationsQueryVariables>(ListOrganizationAffiliationsDocument, options);
        }
export function useListOrganizationAffiliationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOrganizationAffiliationsQuery, ListOrganizationAffiliationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOrganizationAffiliationsQuery, ListOrganizationAffiliationsQueryVariables>(ListOrganizationAffiliationsDocument, options);
        }
export type ListOrganizationAffiliationsQueryHookResult = ReturnType<typeof useListOrganizationAffiliationsQuery>;
export type ListOrganizationAffiliationsLazyQueryHookResult = ReturnType<typeof useListOrganizationAffiliationsLazyQuery>;
export type ListOrganizationAffiliationsSuspenseQueryHookResult = ReturnType<typeof useListOrganizationAffiliationsSuspenseQuery>;
export type ListOrganizationAffiliationsQueryResult = Apollo.QueryResult<ListOrganizationAffiliationsQuery, ListOrganizationAffiliationsQueryVariables>;
export const ListOrganizationDefaultLegalEntityRolesDocument = gql`
    query ListOrganizationDefaultLegalEntityRoles($organizationId: String!) {
  listOrganizationDefaultLegalEntityRoles(organizationId: $organizationId) {
    id
  }
}
    `;

/**
 * __useListOrganizationDefaultLegalEntityRolesQuery__
 *
 * To run a query within a React component, call `useListOrganizationDefaultLegalEntityRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrganizationDefaultLegalEntityRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrganizationDefaultLegalEntityRolesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListOrganizationDefaultLegalEntityRolesQuery(baseOptions: Apollo.QueryHookOptions<ListOrganizationDefaultLegalEntityRolesQuery, ListOrganizationDefaultLegalEntityRolesQueryVariables> & ({ variables: ListOrganizationDefaultLegalEntityRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrganizationDefaultLegalEntityRolesQuery, ListOrganizationDefaultLegalEntityRolesQueryVariables>(ListOrganizationDefaultLegalEntityRolesDocument, options);
      }
export function useListOrganizationDefaultLegalEntityRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrganizationDefaultLegalEntityRolesQuery, ListOrganizationDefaultLegalEntityRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrganizationDefaultLegalEntityRolesQuery, ListOrganizationDefaultLegalEntityRolesQueryVariables>(ListOrganizationDefaultLegalEntityRolesDocument, options);
        }
export function useListOrganizationDefaultLegalEntityRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOrganizationDefaultLegalEntityRolesQuery, ListOrganizationDefaultLegalEntityRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOrganizationDefaultLegalEntityRolesQuery, ListOrganizationDefaultLegalEntityRolesQueryVariables>(ListOrganizationDefaultLegalEntityRolesDocument, options);
        }
export type ListOrganizationDefaultLegalEntityRolesQueryHookResult = ReturnType<typeof useListOrganizationDefaultLegalEntityRolesQuery>;
export type ListOrganizationDefaultLegalEntityRolesLazyQueryHookResult = ReturnType<typeof useListOrganizationDefaultLegalEntityRolesLazyQuery>;
export type ListOrganizationDefaultLegalEntityRolesSuspenseQueryHookResult = ReturnType<typeof useListOrganizationDefaultLegalEntityRolesSuspenseQuery>;
export type ListOrganizationDefaultLegalEntityRolesQueryResult = Apollo.QueryResult<ListOrganizationDefaultLegalEntityRolesQuery, ListOrganizationDefaultLegalEntityRolesQueryVariables>;
export const ListOrganizationLegalEntitiesDocument = gql`
    query ListOrganizationLegalEntities($id: String!) {
  listOrganizationLegalEntities(id: $id) {
    id
    name
    slug
    iconUrl
  }
}
    `;

/**
 * __useListOrganizationLegalEntitiesQuery__
 *
 * To run a query within a React component, call `useListOrganizationLegalEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrganizationLegalEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrganizationLegalEntitiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListOrganizationLegalEntitiesQuery(baseOptions: Apollo.QueryHookOptions<ListOrganizationLegalEntitiesQuery, ListOrganizationLegalEntitiesQueryVariables> & ({ variables: ListOrganizationLegalEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrganizationLegalEntitiesQuery, ListOrganizationLegalEntitiesQueryVariables>(ListOrganizationLegalEntitiesDocument, options);
      }
export function useListOrganizationLegalEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrganizationLegalEntitiesQuery, ListOrganizationLegalEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrganizationLegalEntitiesQuery, ListOrganizationLegalEntitiesQueryVariables>(ListOrganizationLegalEntitiesDocument, options);
        }
export function useListOrganizationLegalEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOrganizationLegalEntitiesQuery, ListOrganizationLegalEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOrganizationLegalEntitiesQuery, ListOrganizationLegalEntitiesQueryVariables>(ListOrganizationLegalEntitiesDocument, options);
        }
export type ListOrganizationLegalEntitiesQueryHookResult = ReturnType<typeof useListOrganizationLegalEntitiesQuery>;
export type ListOrganizationLegalEntitiesLazyQueryHookResult = ReturnType<typeof useListOrganizationLegalEntitiesLazyQuery>;
export type ListOrganizationLegalEntitiesSuspenseQueryHookResult = ReturnType<typeof useListOrganizationLegalEntitiesSuspenseQuery>;
export type ListOrganizationLegalEntitiesQueryResult = Apollo.QueryResult<ListOrganizationLegalEntitiesQuery, ListOrganizationLegalEntitiesQueryVariables>;
export const ListOrganizationRoleOptionsDocument = gql`
    query ListOrganizationRoleOptions($organizationId: String!) {
  listOrganizationRoleOptions(organizationId: $organizationId) {
    legalEntityId
    organizationRoles {
      id
    }
    legalEntityRoles {
      id
    }
  }
}
    `;

/**
 * __useListOrganizationRoleOptionsQuery__
 *
 * To run a query within a React component, call `useListOrganizationRoleOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrganizationRoleOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrganizationRoleOptionsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListOrganizationRoleOptionsQuery(baseOptions: Apollo.QueryHookOptions<ListOrganizationRoleOptionsQuery, ListOrganizationRoleOptionsQueryVariables> & ({ variables: ListOrganizationRoleOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrganizationRoleOptionsQuery, ListOrganizationRoleOptionsQueryVariables>(ListOrganizationRoleOptionsDocument, options);
      }
export function useListOrganizationRoleOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrganizationRoleOptionsQuery, ListOrganizationRoleOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrganizationRoleOptionsQuery, ListOrganizationRoleOptionsQueryVariables>(ListOrganizationRoleOptionsDocument, options);
        }
export function useListOrganizationRoleOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOrganizationRoleOptionsQuery, ListOrganizationRoleOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOrganizationRoleOptionsQuery, ListOrganizationRoleOptionsQueryVariables>(ListOrganizationRoleOptionsDocument, options);
        }
export type ListOrganizationRoleOptionsQueryHookResult = ReturnType<typeof useListOrganizationRoleOptionsQuery>;
export type ListOrganizationRoleOptionsLazyQueryHookResult = ReturnType<typeof useListOrganizationRoleOptionsLazyQuery>;
export type ListOrganizationRoleOptionsSuspenseQueryHookResult = ReturnType<typeof useListOrganizationRoleOptionsSuspenseQuery>;
export type ListOrganizationRoleOptionsQueryResult = Apollo.QueryResult<ListOrganizationRoleOptionsQuery, ListOrganizationRoleOptionsQueryVariables>;
export const ListOrganizationUsersDocument = gql`
    query ListOrganizationUsers($id: String!) {
  listOrganizationUsers(id: $id) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useListOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useListOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrganizationUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListOrganizationUsersQuery(baseOptions: Apollo.QueryHookOptions<ListOrganizationUsersQuery, ListOrganizationUsersQueryVariables> & ({ variables: ListOrganizationUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrganizationUsersQuery, ListOrganizationUsersQueryVariables>(ListOrganizationUsersDocument, options);
      }
export function useListOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrganizationUsersQuery, ListOrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrganizationUsersQuery, ListOrganizationUsersQueryVariables>(ListOrganizationUsersDocument, options);
        }
export function useListOrganizationUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOrganizationUsersQuery, ListOrganizationUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOrganizationUsersQuery, ListOrganizationUsersQueryVariables>(ListOrganizationUsersDocument, options);
        }
export type ListOrganizationUsersQueryHookResult = ReturnType<typeof useListOrganizationUsersQuery>;
export type ListOrganizationUsersLazyQueryHookResult = ReturnType<typeof useListOrganizationUsersLazyQuery>;
export type ListOrganizationUsersSuspenseQueryHookResult = ReturnType<typeof useListOrganizationUsersSuspenseQuery>;
export type ListOrganizationUsersQueryResult = Apollo.QueryResult<ListOrganizationUsersQuery, ListOrganizationUsersQueryVariables>;
export const ReadOrganizationDocument = gql`
    query ReadOrganization($id: String!) {
  readOrganization(id: $id) {
    ...OrganizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;

/**
 * __useReadOrganizationQuery__
 *
 * To run a query within a React component, call `useReadOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadOrganizationQuery(baseOptions: Apollo.QueryHookOptions<ReadOrganizationQuery, ReadOrganizationQueryVariables> & ({ variables: ReadOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadOrganizationQuery, ReadOrganizationQueryVariables>(ReadOrganizationDocument, options);
      }
export function useReadOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadOrganizationQuery, ReadOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadOrganizationQuery, ReadOrganizationQueryVariables>(ReadOrganizationDocument, options);
        }
export function useReadOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadOrganizationQuery, ReadOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadOrganizationQuery, ReadOrganizationQueryVariables>(ReadOrganizationDocument, options);
        }
export type ReadOrganizationQueryHookResult = ReturnType<typeof useReadOrganizationQuery>;
export type ReadOrganizationLazyQueryHookResult = ReturnType<typeof useReadOrganizationLazyQuery>;
export type ReadOrganizationSuspenseQueryHookResult = ReturnType<typeof useReadOrganizationSuspenseQuery>;
export type ReadOrganizationQueryResult = Apollo.QueryResult<ReadOrganizationQuery, ReadOrganizationQueryVariables>;
export const ReadOrganizationBrandingDocument = gql`
    query ReadOrganizationBranding($id: String!) {
  readOrganizationBranding(id: $id) {
    ...OrganizationBrandingFields
  }
}
    ${OrganizationBrandingFieldsFragmentDoc}`;

/**
 * __useReadOrganizationBrandingQuery__
 *
 * To run a query within a React component, call `useReadOrganizationBrandingQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadOrganizationBrandingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadOrganizationBrandingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadOrganizationBrandingQuery(baseOptions: Apollo.QueryHookOptions<ReadOrganizationBrandingQuery, ReadOrganizationBrandingQueryVariables> & ({ variables: ReadOrganizationBrandingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadOrganizationBrandingQuery, ReadOrganizationBrandingQueryVariables>(ReadOrganizationBrandingDocument, options);
      }
export function useReadOrganizationBrandingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadOrganizationBrandingQuery, ReadOrganizationBrandingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadOrganizationBrandingQuery, ReadOrganizationBrandingQueryVariables>(ReadOrganizationBrandingDocument, options);
        }
export function useReadOrganizationBrandingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadOrganizationBrandingQuery, ReadOrganizationBrandingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadOrganizationBrandingQuery, ReadOrganizationBrandingQueryVariables>(ReadOrganizationBrandingDocument, options);
        }
export type ReadOrganizationBrandingQueryHookResult = ReturnType<typeof useReadOrganizationBrandingQuery>;
export type ReadOrganizationBrandingLazyQueryHookResult = ReturnType<typeof useReadOrganizationBrandingLazyQuery>;
export type ReadOrganizationBrandingSuspenseQueryHookResult = ReturnType<typeof useReadOrganizationBrandingSuspenseQuery>;
export type ReadOrganizationBrandingQueryResult = Apollo.QueryResult<ReadOrganizationBrandingQuery, ReadOrganizationBrandingQueryVariables>;
export const ReadOrganizationPreferencesDocument = gql`
    query ReadOrganizationPreferences($id: String!) {
  readOrganizationPreferences(id: $id) {
    id
    anonymizeEmployees
  }
}
    `;

/**
 * __useReadOrganizationPreferencesQuery__
 *
 * To run a query within a React component, call `useReadOrganizationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadOrganizationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadOrganizationPreferencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadOrganizationPreferencesQuery(baseOptions: Apollo.QueryHookOptions<ReadOrganizationPreferencesQuery, ReadOrganizationPreferencesQueryVariables> & ({ variables: ReadOrganizationPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadOrganizationPreferencesQuery, ReadOrganizationPreferencesQueryVariables>(ReadOrganizationPreferencesDocument, options);
      }
export function useReadOrganizationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadOrganizationPreferencesQuery, ReadOrganizationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadOrganizationPreferencesQuery, ReadOrganizationPreferencesQueryVariables>(ReadOrganizationPreferencesDocument, options);
        }
export function useReadOrganizationPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadOrganizationPreferencesQuery, ReadOrganizationPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadOrganizationPreferencesQuery, ReadOrganizationPreferencesQueryVariables>(ReadOrganizationPreferencesDocument, options);
        }
export type ReadOrganizationPreferencesQueryHookResult = ReturnType<typeof useReadOrganizationPreferencesQuery>;
export type ReadOrganizationPreferencesLazyQueryHookResult = ReturnType<typeof useReadOrganizationPreferencesLazyQuery>;
export type ReadOrganizationPreferencesSuspenseQueryHookResult = ReturnType<typeof useReadOrganizationPreferencesSuspenseQuery>;
export type ReadOrganizationPreferencesQueryResult = Apollo.QueryResult<ReadOrganizationPreferencesQuery, ReadOrganizationPreferencesQueryVariables>;
export const CreatePartiesDocument = gql`
    mutation CreateParties($legalEntityId: String!, $partyNames: [String!]!) {
  createParties(legalEntityId: $legalEntityId, partyNames: $partyNames) {
    ...PartyFields
  }
}
    ${PartyFieldsFragmentDoc}`;
export type CreatePartiesMutationFn = Apollo.MutationFunction<CreatePartiesMutation, CreatePartiesMutationVariables>;

/**
 * __useCreatePartiesMutation__
 *
 * To run a mutation, you first call `useCreatePartiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartiesMutation, { data, loading, error }] = useCreatePartiesMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      partyNames: // value for 'partyNames'
 *   },
 * });
 */
export function useCreatePartiesMutation(baseOptions?: Apollo.MutationHookOptions<CreatePartiesMutation, CreatePartiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePartiesMutation, CreatePartiesMutationVariables>(CreatePartiesDocument, options);
      }
export type CreatePartiesMutationHookResult = ReturnType<typeof useCreatePartiesMutation>;
export type CreatePartiesMutationResult = Apollo.MutationResult<CreatePartiesMutation>;
export type CreatePartiesMutationOptions = Apollo.BaseMutationOptions<CreatePartiesMutation, CreatePartiesMutationVariables>;
export const UpdatePartyFieldsDocument = gql`
    mutation UpdatePartyFields($legalEntityId: String!, $updates: [InputUpdatePartyFields!]!) {
  updatePartyFields(legalEntityId: $legalEntityId, updates: $updates)
}
    `;
export type UpdatePartyFieldsMutationFn = Apollo.MutationFunction<UpdatePartyFieldsMutation, UpdatePartyFieldsMutationVariables>;

/**
 * __useUpdatePartyFieldsMutation__
 *
 * To run a mutation, you first call `useUpdatePartyFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartyFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartyFieldsMutation, { data, loading, error }] = useUpdatePartyFieldsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdatePartyFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartyFieldsMutation, UpdatePartyFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartyFieldsMutation, UpdatePartyFieldsMutationVariables>(UpdatePartyFieldsDocument, options);
      }
export type UpdatePartyFieldsMutationHookResult = ReturnType<typeof useUpdatePartyFieldsMutation>;
export type UpdatePartyFieldsMutationResult = Apollo.MutationResult<UpdatePartyFieldsMutation>;
export type UpdatePartyFieldsMutationOptions = Apollo.BaseMutationOptions<UpdatePartyFieldsMutation, UpdatePartyFieldsMutationVariables>;
export const ListActivePartyRolesDocument = gql`
    query ListActivePartyRoles($filter: SummaryFilterInput!, $direction: DirectionFromOrigin, $intervalOrigin: IntervalOrigin) {
  listActivePartyRoles(
    filter: $filter
    origin: $intervalOrigin
    direction: $direction
  )
}
    `;

/**
 * __useListActivePartyRolesQuery__
 *
 * To run a query within a React component, call `useListActivePartyRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActivePartyRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActivePartyRolesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      direction: // value for 'direction'
 *      intervalOrigin: // value for 'intervalOrigin'
 *   },
 * });
 */
export function useListActivePartyRolesQuery(baseOptions: Apollo.QueryHookOptions<ListActivePartyRolesQuery, ListActivePartyRolesQueryVariables> & ({ variables: ListActivePartyRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListActivePartyRolesQuery, ListActivePartyRolesQueryVariables>(ListActivePartyRolesDocument, options);
      }
export function useListActivePartyRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListActivePartyRolesQuery, ListActivePartyRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListActivePartyRolesQuery, ListActivePartyRolesQueryVariables>(ListActivePartyRolesDocument, options);
        }
export function useListActivePartyRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListActivePartyRolesQuery, ListActivePartyRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListActivePartyRolesQuery, ListActivePartyRolesQueryVariables>(ListActivePartyRolesDocument, options);
        }
export type ListActivePartyRolesQueryHookResult = ReturnType<typeof useListActivePartyRolesQuery>;
export type ListActivePartyRolesLazyQueryHookResult = ReturnType<typeof useListActivePartyRolesLazyQuery>;
export type ListActivePartyRolesSuspenseQueryHookResult = ReturnType<typeof useListActivePartyRolesSuspenseQuery>;
export type ListActivePartyRolesQueryResult = Apollo.QueryResult<ListActivePartyRolesQuery, ListActivePartyRolesQueryVariables>;
export const ListActivePartyRolesBatchDocument = gql`
    query ListActivePartyRolesBatch($inputs: [SummarizeInput!]!) {
  listActivePartyRolesBatch(inputs: $inputs) {
    partyId
    roles
  }
}
    `;

/**
 * __useListActivePartyRolesBatchQuery__
 *
 * To run a query within a React component, call `useListActivePartyRolesBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActivePartyRolesBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActivePartyRolesBatchQuery({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useListActivePartyRolesBatchQuery(baseOptions: Apollo.QueryHookOptions<ListActivePartyRolesBatchQuery, ListActivePartyRolesBatchQueryVariables> & ({ variables: ListActivePartyRolesBatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListActivePartyRolesBatchQuery, ListActivePartyRolesBatchQueryVariables>(ListActivePartyRolesBatchDocument, options);
      }
export function useListActivePartyRolesBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListActivePartyRolesBatchQuery, ListActivePartyRolesBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListActivePartyRolesBatchQuery, ListActivePartyRolesBatchQueryVariables>(ListActivePartyRolesBatchDocument, options);
        }
export function useListActivePartyRolesBatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListActivePartyRolesBatchQuery, ListActivePartyRolesBatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListActivePartyRolesBatchQuery, ListActivePartyRolesBatchQueryVariables>(ListActivePartyRolesBatchDocument, options);
        }
export type ListActivePartyRolesBatchQueryHookResult = ReturnType<typeof useListActivePartyRolesBatchQuery>;
export type ListActivePartyRolesBatchLazyQueryHookResult = ReturnType<typeof useListActivePartyRolesBatchLazyQuery>;
export type ListActivePartyRolesBatchSuspenseQueryHookResult = ReturnType<typeof useListActivePartyRolesBatchSuspenseQuery>;
export type ListActivePartyRolesBatchQueryResult = Apollo.QueryResult<ListActivePartyRolesBatchQuery, ListActivePartyRolesBatchQueryVariables>;
export const ListLatestPartyHistoriesDocument = gql`
    query ListLatestPartyHistories($legalEntityId: String!, $partyIds: [String!]!) {
  listLatestPartyHistories(legalEntityId: $legalEntityId, partyIds: $partyIds) {
    partyId
    taxpayerIdentificationClassification {
      ...PartyHistoryEntryFields
    }
    entityTypeClassification {
      ...PartyHistoryEntryFields
    }
  }
}
    ${PartyHistoryEntryFieldsFragmentDoc}`;

/**
 * __useListLatestPartyHistoriesQuery__
 *
 * To run a query within a React component, call `useListLatestPartyHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLatestPartyHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLatestPartyHistoriesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      partyIds: // value for 'partyIds'
 *   },
 * });
 */
export function useListLatestPartyHistoriesQuery(baseOptions: Apollo.QueryHookOptions<ListLatestPartyHistoriesQuery, ListLatestPartyHistoriesQueryVariables> & ({ variables: ListLatestPartyHistoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLatestPartyHistoriesQuery, ListLatestPartyHistoriesQueryVariables>(ListLatestPartyHistoriesDocument, options);
      }
export function useListLatestPartyHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLatestPartyHistoriesQuery, ListLatestPartyHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLatestPartyHistoriesQuery, ListLatestPartyHistoriesQueryVariables>(ListLatestPartyHistoriesDocument, options);
        }
export function useListLatestPartyHistoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLatestPartyHistoriesQuery, ListLatestPartyHistoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLatestPartyHistoriesQuery, ListLatestPartyHistoriesQueryVariables>(ListLatestPartyHistoriesDocument, options);
        }
export type ListLatestPartyHistoriesQueryHookResult = ReturnType<typeof useListLatestPartyHistoriesQuery>;
export type ListLatestPartyHistoriesLazyQueryHookResult = ReturnType<typeof useListLatestPartyHistoriesLazyQuery>;
export type ListLatestPartyHistoriesSuspenseQueryHookResult = ReturnType<typeof useListLatestPartyHistoriesSuspenseQuery>;
export type ListLatestPartyHistoriesQueryResult = Apollo.QueryResult<ListLatestPartyHistoriesQuery, ListLatestPartyHistoriesQueryVariables>;
export const ListPartyTaxInfoDocument = gql`
    query ListPartyTaxInfo($filter: TransactionFilter!, $origin: IntervalOrigin!, $direction: DirectionFromOrigin!) {
  listPartyTaxInfo(filter: $filter, origin: $origin, direction: $direction) {
    partyId
    taxpayerIdentification
    entityType
  }
}
    `;

/**
 * __useListPartyTaxInfoQuery__
 *
 * To run a query within a React component, call `useListPartyTaxInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPartyTaxInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPartyTaxInfoQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      origin: // value for 'origin'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useListPartyTaxInfoQuery(baseOptions: Apollo.QueryHookOptions<ListPartyTaxInfoQuery, ListPartyTaxInfoQueryVariables> & ({ variables: ListPartyTaxInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListPartyTaxInfoQuery, ListPartyTaxInfoQueryVariables>(ListPartyTaxInfoDocument, options);
      }
export function useListPartyTaxInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListPartyTaxInfoQuery, ListPartyTaxInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListPartyTaxInfoQuery, ListPartyTaxInfoQueryVariables>(ListPartyTaxInfoDocument, options);
        }
export function useListPartyTaxInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListPartyTaxInfoQuery, ListPartyTaxInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListPartyTaxInfoQuery, ListPartyTaxInfoQueryVariables>(ListPartyTaxInfoDocument, options);
        }
export type ListPartyTaxInfoQueryHookResult = ReturnType<typeof useListPartyTaxInfoQuery>;
export type ListPartyTaxInfoLazyQueryHookResult = ReturnType<typeof useListPartyTaxInfoLazyQuery>;
export type ListPartyTaxInfoSuspenseQueryHookResult = ReturnType<typeof useListPartyTaxInfoSuspenseQuery>;
export type ListPartyTaxInfoQueryResult = Apollo.QueryResult<ListPartyTaxInfoQuery, ListPartyTaxInfoQueryVariables>;
export const ReadPartyDocument = gql`
    query ReadParty($viewKey: ViewKey!, $partyId: String!) {
  readParty(viewKey: $viewKey, partyId: $partyId) {
    ...PartyFields
  }
}
    ${PartyFieldsFragmentDoc}`;

/**
 * __useReadPartyQuery__
 *
 * To run a query within a React component, call `useReadPartyQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadPartyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadPartyQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      partyId: // value for 'partyId'
 *   },
 * });
 */
export function useReadPartyQuery(baseOptions: Apollo.QueryHookOptions<ReadPartyQuery, ReadPartyQueryVariables> & ({ variables: ReadPartyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadPartyQuery, ReadPartyQueryVariables>(ReadPartyDocument, options);
      }
export function useReadPartyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadPartyQuery, ReadPartyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadPartyQuery, ReadPartyQueryVariables>(ReadPartyDocument, options);
        }
export function useReadPartySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadPartyQuery, ReadPartyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadPartyQuery, ReadPartyQueryVariables>(ReadPartyDocument, options);
        }
export type ReadPartyQueryHookResult = ReturnType<typeof useReadPartyQuery>;
export type ReadPartyLazyQueryHookResult = ReturnType<typeof useReadPartyLazyQuery>;
export type ReadPartySuspenseQueryHookResult = ReturnType<typeof useReadPartySuspenseQuery>;
export type ReadPartyQueryResult = Apollo.QueryResult<ReadPartyQuery, ReadPartyQueryVariables>;
export const LedgerReadPaymentErrorStateDocument = gql`
    query LedgerReadPaymentErrorState($legalEntityId: String!) {
  ledgerReadPaymentErrorState(legalEntityId: $legalEntityId) {
    hasPendingBalance
    pendingBalanceUpdatedAt
  }
}
    `;

/**
 * __useLedgerReadPaymentErrorStateQuery__
 *
 * To run a query within a React component, call `useLedgerReadPaymentErrorStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerReadPaymentErrorStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerReadPaymentErrorStateQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useLedgerReadPaymentErrorStateQuery(baseOptions: Apollo.QueryHookOptions<LedgerReadPaymentErrorStateQuery, LedgerReadPaymentErrorStateQueryVariables> & ({ variables: LedgerReadPaymentErrorStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerReadPaymentErrorStateQuery, LedgerReadPaymentErrorStateQueryVariables>(LedgerReadPaymentErrorStateDocument, options);
      }
export function useLedgerReadPaymentErrorStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerReadPaymentErrorStateQuery, LedgerReadPaymentErrorStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerReadPaymentErrorStateQuery, LedgerReadPaymentErrorStateQueryVariables>(LedgerReadPaymentErrorStateDocument, options);
        }
export function useLedgerReadPaymentErrorStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerReadPaymentErrorStateQuery, LedgerReadPaymentErrorStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerReadPaymentErrorStateQuery, LedgerReadPaymentErrorStateQueryVariables>(LedgerReadPaymentErrorStateDocument, options);
        }
export type LedgerReadPaymentErrorStateQueryHookResult = ReturnType<typeof useLedgerReadPaymentErrorStateQuery>;
export type LedgerReadPaymentErrorStateLazyQueryHookResult = ReturnType<typeof useLedgerReadPaymentErrorStateLazyQuery>;
export type LedgerReadPaymentErrorStateSuspenseQueryHookResult = ReturnType<typeof useLedgerReadPaymentErrorStateSuspenseQuery>;
export type LedgerReadPaymentErrorStateQueryResult = Apollo.QueryResult<LedgerReadPaymentErrorStateQuery, LedgerReadPaymentErrorStateQueryVariables>;
export const ReadPaymentErrorStateDocument = gql`
    query ReadPaymentErrorState($legalEntityId: String!, $product: PaymentErrorProduct!) {
  readPaymentErrorState(legalEntityId: $legalEntityId, product: $product) {
    hasPendingBalance
    pendingBalanceUpdatedAt
  }
}
    `;

/**
 * __useReadPaymentErrorStateQuery__
 *
 * To run a query within a React component, call `useReadPaymentErrorStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadPaymentErrorStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadPaymentErrorStateQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      product: // value for 'product'
 *   },
 * });
 */
export function useReadPaymentErrorStateQuery(baseOptions: Apollo.QueryHookOptions<ReadPaymentErrorStateQuery, ReadPaymentErrorStateQueryVariables> & ({ variables: ReadPaymentErrorStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadPaymentErrorStateQuery, ReadPaymentErrorStateQueryVariables>(ReadPaymentErrorStateDocument, options);
      }
export function useReadPaymentErrorStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadPaymentErrorStateQuery, ReadPaymentErrorStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadPaymentErrorStateQuery, ReadPaymentErrorStateQueryVariables>(ReadPaymentErrorStateDocument, options);
        }
export function useReadPaymentErrorStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadPaymentErrorStateQuery, ReadPaymentErrorStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadPaymentErrorStateQuery, ReadPaymentErrorStateQueryVariables>(ReadPaymentErrorStateDocument, options);
        }
export type ReadPaymentErrorStateQueryHookResult = ReturnType<typeof useReadPaymentErrorStateQuery>;
export type ReadPaymentErrorStateLazyQueryHookResult = ReturnType<typeof useReadPaymentErrorStateLazyQuery>;
export type ReadPaymentErrorStateSuspenseQueryHookResult = ReturnType<typeof useReadPaymentErrorStateSuspenseQuery>;
export type ReadPaymentErrorStateQueryResult = Apollo.QueryResult<ReadPaymentErrorStateQuery, ReadPaymentErrorStateQueryVariables>;
export const ReadOrCreatePortalLayoutDocument = gql`
    query ReadOrCreatePortalLayout($viewId: ViewIdentifierInput!) {
  readOrCreatePortalLayout(viewId: $viewId) {
    portalId
    layout {
      ...LayoutFields
    }
  }
}
    ${LayoutFieldsFragmentDoc}`;

/**
 * __useReadOrCreatePortalLayoutQuery__
 *
 * To run a query within a React component, call `useReadOrCreatePortalLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadOrCreatePortalLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadOrCreatePortalLayoutQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useReadOrCreatePortalLayoutQuery(baseOptions: Apollo.QueryHookOptions<ReadOrCreatePortalLayoutQuery, ReadOrCreatePortalLayoutQueryVariables> & ({ variables: ReadOrCreatePortalLayoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadOrCreatePortalLayoutQuery, ReadOrCreatePortalLayoutQueryVariables>(ReadOrCreatePortalLayoutDocument, options);
      }
export function useReadOrCreatePortalLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadOrCreatePortalLayoutQuery, ReadOrCreatePortalLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadOrCreatePortalLayoutQuery, ReadOrCreatePortalLayoutQueryVariables>(ReadOrCreatePortalLayoutDocument, options);
        }
export function useReadOrCreatePortalLayoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadOrCreatePortalLayoutQuery, ReadOrCreatePortalLayoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadOrCreatePortalLayoutQuery, ReadOrCreatePortalLayoutQueryVariables>(ReadOrCreatePortalLayoutDocument, options);
        }
export type ReadOrCreatePortalLayoutQueryHookResult = ReturnType<typeof useReadOrCreatePortalLayoutQuery>;
export type ReadOrCreatePortalLayoutLazyQueryHookResult = ReturnType<typeof useReadOrCreatePortalLayoutLazyQuery>;
export type ReadOrCreatePortalLayoutSuspenseQueryHookResult = ReturnType<typeof useReadOrCreatePortalLayoutSuspenseQuery>;
export type ReadOrCreatePortalLayoutQueryResult = Apollo.QueryResult<ReadOrCreatePortalLayoutQuery, ReadOrCreatePortalLayoutQueryVariables>;
export const DeleteProductVariantDocument = gql`
    mutation DeleteProductVariant($legalEntityId: String!, $dataSourceId: String!, $productId: String!, $variantId: String!) {
  deleteProductVariant(
    legalEntityId: $legalEntityId
    dataSourceId: $dataSourceId
    productId: $productId
    variantId: $variantId
  )
}
    `;
export type DeleteProductVariantMutationFn = Apollo.MutationFunction<DeleteProductVariantMutation, DeleteProductVariantMutationVariables>;

/**
 * __useDeleteProductVariantMutation__
 *
 * To run a mutation, you first call `useDeleteProductVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductVariantMutation, { data, loading, error }] = useDeleteProductVariantMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      dataSourceId: // value for 'dataSourceId'
 *      productId: // value for 'productId'
 *      variantId: // value for 'variantId'
 *   },
 * });
 */
export function useDeleteProductVariantMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductVariantMutation, DeleteProductVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductVariantMutation, DeleteProductVariantMutationVariables>(DeleteProductVariantDocument, options);
      }
export type DeleteProductVariantMutationHookResult = ReturnType<typeof useDeleteProductVariantMutation>;
export type DeleteProductVariantMutationResult = Apollo.MutationResult<DeleteProductVariantMutation>;
export type DeleteProductVariantMutationOptions = Apollo.BaseMutationOptions<DeleteProductVariantMutation, DeleteProductVariantMutationVariables>;
export const DeleteProductVariantPriceDocument = gql`
    mutation DeleteProductVariantPrice($legalEntityId: String!, $dataSourceId: String!, $productId: String!, $variantId: String!, $priceId: String!) {
  deleteProductVariantPrice(
    legalEntityId: $legalEntityId
    dataSourceId: $dataSourceId
    productId: $productId
    variantId: $variantId
    priceId: $priceId
  )
}
    `;
export type DeleteProductVariantPriceMutationFn = Apollo.MutationFunction<DeleteProductVariantPriceMutation, DeleteProductVariantPriceMutationVariables>;

/**
 * __useDeleteProductVariantPriceMutation__
 *
 * To run a mutation, you first call `useDeleteProductVariantPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductVariantPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductVariantPriceMutation, { data, loading, error }] = useDeleteProductVariantPriceMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      dataSourceId: // value for 'dataSourceId'
 *      productId: // value for 'productId'
 *      variantId: // value for 'variantId'
 *      priceId: // value for 'priceId'
 *   },
 * });
 */
export function useDeleteProductVariantPriceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductVariantPriceMutation, DeleteProductVariantPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductVariantPriceMutation, DeleteProductVariantPriceMutationVariables>(DeleteProductVariantPriceDocument, options);
      }
export type DeleteProductVariantPriceMutationHookResult = ReturnType<typeof useDeleteProductVariantPriceMutation>;
export type DeleteProductVariantPriceMutationResult = Apollo.MutationResult<DeleteProductVariantPriceMutation>;
export type DeleteProductVariantPriceMutationOptions = Apollo.BaseMutationOptions<DeleteProductVariantPriceMutation, DeleteProductVariantPriceMutationVariables>;
export const SaveProductDocument = gql`
    mutation SaveProduct($legalEntityId: String!, $providerType: ProviderType!, $product: ProductInput!) {
  saveProduct(
    legalEntityId: $legalEntityId
    providerType: $providerType
    product: $product
  ) {
    ...CatalogProductFields
  }
}
    ${CatalogProductFieldsFragmentDoc}`;
export type SaveProductMutationFn = Apollo.MutationFunction<SaveProductMutation, SaveProductMutationVariables>;

/**
 * __useSaveProductMutation__
 *
 * To run a mutation, you first call `useSaveProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProductMutation, { data, loading, error }] = useSaveProductMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      providerType: // value for 'providerType'
 *      product: // value for 'product'
 *   },
 * });
 */
export function useSaveProductMutation(baseOptions?: Apollo.MutationHookOptions<SaveProductMutation, SaveProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProductMutation, SaveProductMutationVariables>(SaveProductDocument, options);
      }
export type SaveProductMutationHookResult = ReturnType<typeof useSaveProductMutation>;
export type SaveProductMutationResult = Apollo.MutationResult<SaveProductMutation>;
export type SaveProductMutationOptions = Apollo.BaseMutationOptions<SaveProductMutation, SaveProductMutationVariables>;
export const SaveProductVariantPriceDocument = gql`
    mutation SaveProductVariantPrice($legalEntityId: String!, $price: ProductVariantPriceInput!) {
  saveProductVariantPrice(legalEntityId: $legalEntityId, price: $price) {
    ...CatalogProductVariantPriceFields
  }
}
    ${CatalogProductVariantPriceFieldsFragmentDoc}`;
export type SaveProductVariantPriceMutationFn = Apollo.MutationFunction<SaveProductVariantPriceMutation, SaveProductVariantPriceMutationVariables>;

/**
 * __useSaveProductVariantPriceMutation__
 *
 * To run a mutation, you first call `useSaveProductVariantPriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProductVariantPriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProductVariantPriceMutation, { data, loading, error }] = useSaveProductVariantPriceMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      price: // value for 'price'
 *   },
 * });
 */
export function useSaveProductVariantPriceMutation(baseOptions?: Apollo.MutationHookOptions<SaveProductVariantPriceMutation, SaveProductVariantPriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProductVariantPriceMutation, SaveProductVariantPriceMutationVariables>(SaveProductVariantPriceDocument, options);
      }
export type SaveProductVariantPriceMutationHookResult = ReturnType<typeof useSaveProductVariantPriceMutation>;
export type SaveProductVariantPriceMutationResult = Apollo.MutationResult<SaveProductVariantPriceMutation>;
export type SaveProductVariantPriceMutationOptions = Apollo.BaseMutationOptions<SaveProductVariantPriceMutation, SaveProductVariantPriceMutationVariables>;
export const UpdateProductsActiveDocument = gql`
    mutation UpdateProductsActive($input: UpdateProductsActiveInput!) {
  updateProductsActive(input: $input)
}
    `;
export type UpdateProductsActiveMutationFn = Apollo.MutationFunction<UpdateProductsActiveMutation, UpdateProductsActiveMutationVariables>;

/**
 * __useUpdateProductsActiveMutation__
 *
 * To run a mutation, you first call `useUpdateProductsActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductsActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductsActiveMutation, { data, loading, error }] = useUpdateProductsActiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductsActiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductsActiveMutation, UpdateProductsActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductsActiveMutation, UpdateProductsActiveMutationVariables>(UpdateProductsActiveDocument, options);
      }
export type UpdateProductsActiveMutationHookResult = ReturnType<typeof useUpdateProductsActiveMutation>;
export type UpdateProductsActiveMutationResult = Apollo.MutationResult<UpdateProductsActiveMutation>;
export type UpdateProductsActiveMutationOptions = Apollo.BaseMutationOptions<UpdateProductsActiveMutation, UpdateProductsActiveMutationVariables>;
export const UploadProductCatalogIconDocument = gql`
    mutation UploadProductCatalogIcon($legalEntityId: String!, $iconBase64: String!) {
  uploadProductCatalogIcon(legalEntityId: $legalEntityId, iconBase64: $iconBase64) {
    objectName
    iconUrl
  }
}
    `;
export type UploadProductCatalogIconMutationFn = Apollo.MutationFunction<UploadProductCatalogIconMutation, UploadProductCatalogIconMutationVariables>;

/**
 * __useUploadProductCatalogIconMutation__
 *
 * To run a mutation, you first call `useUploadProductCatalogIconMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProductCatalogIconMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProductCatalogIconMutation, { data, loading, error }] = useUploadProductCatalogIconMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      iconBase64: // value for 'iconBase64'
 *   },
 * });
 */
export function useUploadProductCatalogIconMutation(baseOptions?: Apollo.MutationHookOptions<UploadProductCatalogIconMutation, UploadProductCatalogIconMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadProductCatalogIconMutation, UploadProductCatalogIconMutationVariables>(UploadProductCatalogIconDocument, options);
      }
export type UploadProductCatalogIconMutationHookResult = ReturnType<typeof useUploadProductCatalogIconMutation>;
export type UploadProductCatalogIconMutationResult = Apollo.MutationResult<UploadProductCatalogIconMutation>;
export type UploadProductCatalogIconMutationOptions = Apollo.BaseMutationOptions<UploadProductCatalogIconMutation, UploadProductCatalogIconMutationVariables>;
export const LedgerSummarizeProductNetSalesByTimeDocument = gql`
    query LedgerSummarizeProductNetSalesByTime($viewKey: ViewKey!, $productId: String!, $origin: IntervalOrigin!, $direction: DirectionFromOrigin!) {
  invoices: productInsightTransactionSummary(
    filter: {viewKey: $viewKey, productIds: [$productId], categoryTypes: [Assets, Liabilities, Equity, Income, Expenses, CostOfGoodsSold, OtherIncome, OtherExpenses], linkedObjectTypes: [Invoice]}
    origin: $origin
    direction: $direction
    dimensions: [Time]
    defaultCategoryType: Income
  ) {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
  }
  bills: productInsightTransactionSummary(
    filter: {viewKey: $viewKey, productIds: [$productId], categoryTypes: [Assets, Liabilities, Equity, Income, Expenses, CostOfGoodsSold, OtherIncome, OtherExpenses], linkedObjectTypes: [Bill]}
    origin: $origin
    direction: $direction
    dimensions: [Time]
    defaultCategoryType: Income
  ) {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
  }
}
    ${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useLedgerSummarizeProductNetSalesByTimeQuery__
 *
 * To run a query within a React component, call `useLedgerSummarizeProductNetSalesByTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useLedgerSummarizeProductNetSalesByTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLedgerSummarizeProductNetSalesByTimeQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      productId: // value for 'productId'
 *      origin: // value for 'origin'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useLedgerSummarizeProductNetSalesByTimeQuery(baseOptions: Apollo.QueryHookOptions<LedgerSummarizeProductNetSalesByTimeQuery, LedgerSummarizeProductNetSalesByTimeQueryVariables> & ({ variables: LedgerSummarizeProductNetSalesByTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LedgerSummarizeProductNetSalesByTimeQuery, LedgerSummarizeProductNetSalesByTimeQueryVariables>(LedgerSummarizeProductNetSalesByTimeDocument, options);
      }
export function useLedgerSummarizeProductNetSalesByTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LedgerSummarizeProductNetSalesByTimeQuery, LedgerSummarizeProductNetSalesByTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LedgerSummarizeProductNetSalesByTimeQuery, LedgerSummarizeProductNetSalesByTimeQueryVariables>(LedgerSummarizeProductNetSalesByTimeDocument, options);
        }
export function useLedgerSummarizeProductNetSalesByTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LedgerSummarizeProductNetSalesByTimeQuery, LedgerSummarizeProductNetSalesByTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LedgerSummarizeProductNetSalesByTimeQuery, LedgerSummarizeProductNetSalesByTimeQueryVariables>(LedgerSummarizeProductNetSalesByTimeDocument, options);
        }
export type LedgerSummarizeProductNetSalesByTimeQueryHookResult = ReturnType<typeof useLedgerSummarizeProductNetSalesByTimeQuery>;
export type LedgerSummarizeProductNetSalesByTimeLazyQueryHookResult = ReturnType<typeof useLedgerSummarizeProductNetSalesByTimeLazyQuery>;
export type LedgerSummarizeProductNetSalesByTimeSuspenseQueryHookResult = ReturnType<typeof useLedgerSummarizeProductNetSalesByTimeSuspenseQuery>;
export type LedgerSummarizeProductNetSalesByTimeQueryResult = Apollo.QueryResult<LedgerSummarizeProductNetSalesByTimeQuery, LedgerSummarizeProductNetSalesByTimeQueryVariables>;
export const ListProductDepartmentOptionsDocument = gql`
    query ListProductDepartmentOptions($viewKey: ViewKey!, $status: DepartmentStatus) {
  listDepartments(viewKey: $viewKey, status: $status) {
    id
    name
    parentId
    active
  }
}
    `;

/**
 * __useListProductDepartmentOptionsQuery__
 *
 * To run a query within a React component, call `useListProductDepartmentOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProductDepartmentOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProductDepartmentOptionsQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useListProductDepartmentOptionsQuery(baseOptions: Apollo.QueryHookOptions<ListProductDepartmentOptionsQuery, ListProductDepartmentOptionsQueryVariables> & ({ variables: ListProductDepartmentOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProductDepartmentOptionsQuery, ListProductDepartmentOptionsQueryVariables>(ListProductDepartmentOptionsDocument, options);
      }
export function useListProductDepartmentOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProductDepartmentOptionsQuery, ListProductDepartmentOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProductDepartmentOptionsQuery, ListProductDepartmentOptionsQueryVariables>(ListProductDepartmentOptionsDocument, options);
        }
export function useListProductDepartmentOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProductDepartmentOptionsQuery, ListProductDepartmentOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProductDepartmentOptionsQuery, ListProductDepartmentOptionsQueryVariables>(ListProductDepartmentOptionsDocument, options);
        }
export type ListProductDepartmentOptionsQueryHookResult = ReturnType<typeof useListProductDepartmentOptionsQuery>;
export type ListProductDepartmentOptionsLazyQueryHookResult = ReturnType<typeof useListProductDepartmentOptionsLazyQuery>;
export type ListProductDepartmentOptionsSuspenseQueryHookResult = ReturnType<typeof useListProductDepartmentOptionsSuspenseQuery>;
export type ListProductDepartmentOptionsQueryResult = Apollo.QueryResult<ListProductDepartmentOptionsQuery, ListProductDepartmentOptionsQueryVariables>;
export const ListProductLocationOptionsDocument = gql`
    query ListProductLocationOptions($viewKey: ViewKey!, $status: LocationStatus) {
  listLocations(viewKey: $viewKey, status: $status) {
    id
    name
    parentId
    active
  }
}
    `;

/**
 * __useListProductLocationOptionsQuery__
 *
 * To run a query within a React component, call `useListProductLocationOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProductLocationOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProductLocationOptionsQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useListProductLocationOptionsQuery(baseOptions: Apollo.QueryHookOptions<ListProductLocationOptionsQuery, ListProductLocationOptionsQueryVariables> & ({ variables: ListProductLocationOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProductLocationOptionsQuery, ListProductLocationOptionsQueryVariables>(ListProductLocationOptionsDocument, options);
      }
export function useListProductLocationOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProductLocationOptionsQuery, ListProductLocationOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProductLocationOptionsQuery, ListProductLocationOptionsQueryVariables>(ListProductLocationOptionsDocument, options);
        }
export function useListProductLocationOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProductLocationOptionsQuery, ListProductLocationOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProductLocationOptionsQuery, ListProductLocationOptionsQueryVariables>(ListProductLocationOptionsDocument, options);
        }
export type ListProductLocationOptionsQueryHookResult = ReturnType<typeof useListProductLocationOptionsQuery>;
export type ListProductLocationOptionsLazyQueryHookResult = ReturnType<typeof useListProductLocationOptionsLazyQuery>;
export type ListProductLocationOptionsSuspenseQueryHookResult = ReturnType<typeof useListProductLocationOptionsSuspenseQuery>;
export type ListProductLocationOptionsQueryResult = Apollo.QueryResult<ListProductLocationOptionsQuery, ListProductLocationOptionsQueryVariables>;
export const ListProductTransactionsDocument = gql`
    query ListProductTransactions($viewKey: ViewKey!, $productId: String!, $limit: Int) {
  listProductTransactions(viewKey: $viewKey, productId: $productId, limit: $limit) {
    transaction {
      ...TransactionFields
    }
    linkedObjectNumber
    linkedObjectParty {
      ...EntityPartyFields
    }
    linkedObjectType
  }
}
    ${TransactionFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}`;

/**
 * __useListProductTransactionsQuery__
 *
 * To run a query within a React component, call `useListProductTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProductTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProductTransactionsQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      productId: // value for 'productId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListProductTransactionsQuery(baseOptions: Apollo.QueryHookOptions<ListProductTransactionsQuery, ListProductTransactionsQueryVariables> & ({ variables: ListProductTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProductTransactionsQuery, ListProductTransactionsQueryVariables>(ListProductTransactionsDocument, options);
      }
export function useListProductTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProductTransactionsQuery, ListProductTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProductTransactionsQuery, ListProductTransactionsQueryVariables>(ListProductTransactionsDocument, options);
        }
export function useListProductTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProductTransactionsQuery, ListProductTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProductTransactionsQuery, ListProductTransactionsQueryVariables>(ListProductTransactionsDocument, options);
        }
export type ListProductTransactionsQueryHookResult = ReturnType<typeof useListProductTransactionsQuery>;
export type ListProductTransactionsLazyQueryHookResult = ReturnType<typeof useListProductTransactionsLazyQuery>;
export type ListProductTransactionsSuspenseQueryHookResult = ReturnType<typeof useListProductTransactionsSuspenseQuery>;
export type ListProductTransactionsQueryResult = Apollo.QueryResult<ListProductTransactionsQuery, ListProductTransactionsQueryVariables>;
export const ListProductVariantsForCatalogDocument = gql`
    query ListProductVariantsForCatalog($legalEntityId: String!) {
  listProductVariantsForCatalog(legalEntityId: $legalEntityId) {
    ...CatalogProductFields
    variants {
      ...CatalogProductVariantFields
    }
  }
}
    ${CatalogProductFieldsFragmentDoc}
${CatalogProductVariantFieldsFragmentDoc}`;

/**
 * __useListProductVariantsForCatalogQuery__
 *
 * To run a query within a React component, call `useListProductVariantsForCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProductVariantsForCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProductVariantsForCatalogQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListProductVariantsForCatalogQuery(baseOptions: Apollo.QueryHookOptions<ListProductVariantsForCatalogQuery, ListProductVariantsForCatalogQueryVariables> & ({ variables: ListProductVariantsForCatalogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProductVariantsForCatalogQuery, ListProductVariantsForCatalogQueryVariables>(ListProductVariantsForCatalogDocument, options);
      }
export function useListProductVariantsForCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProductVariantsForCatalogQuery, ListProductVariantsForCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProductVariantsForCatalogQuery, ListProductVariantsForCatalogQueryVariables>(ListProductVariantsForCatalogDocument, options);
        }
export function useListProductVariantsForCatalogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProductVariantsForCatalogQuery, ListProductVariantsForCatalogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProductVariantsForCatalogQuery, ListProductVariantsForCatalogQueryVariables>(ListProductVariantsForCatalogDocument, options);
        }
export type ListProductVariantsForCatalogQueryHookResult = ReturnType<typeof useListProductVariantsForCatalogQuery>;
export type ListProductVariantsForCatalogLazyQueryHookResult = ReturnType<typeof useListProductVariantsForCatalogLazyQuery>;
export type ListProductVariantsForCatalogSuspenseQueryHookResult = ReturnType<typeof useListProductVariantsForCatalogSuspenseQuery>;
export type ListProductVariantsForCatalogQueryResult = Apollo.QueryResult<ListProductVariantsForCatalogQuery, ListProductVariantsForCatalogQueryVariables>;
export const ListProductVariantsForInvoiceDocument = gql`
    query ListProductVariantsForInvoice($legalEntityId: String!) {
  listProductVariantsForInvoice(legalEntityId: $legalEntityId) {
    ...CatalogProductFields
    variants {
      ...CatalogProductVariantFields
      classifications {
        ...CatalogProductClassificationsFields
      }
    }
  }
}
    ${CatalogProductFieldsFragmentDoc}
${CatalogProductVariantFieldsFragmentDoc}
${CatalogProductClassificationsFieldsFragmentDoc}`;

/**
 * __useListProductVariantsForInvoiceQuery__
 *
 * To run a query within a React component, call `useListProductVariantsForInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProductVariantsForInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProductVariantsForInvoiceQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListProductVariantsForInvoiceQuery(baseOptions: Apollo.QueryHookOptions<ListProductVariantsForInvoiceQuery, ListProductVariantsForInvoiceQueryVariables> & ({ variables: ListProductVariantsForInvoiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProductVariantsForInvoiceQuery, ListProductVariantsForInvoiceQueryVariables>(ListProductVariantsForInvoiceDocument, options);
      }
export function useListProductVariantsForInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProductVariantsForInvoiceQuery, ListProductVariantsForInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProductVariantsForInvoiceQuery, ListProductVariantsForInvoiceQueryVariables>(ListProductVariantsForInvoiceDocument, options);
        }
export function useListProductVariantsForInvoiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProductVariantsForInvoiceQuery, ListProductVariantsForInvoiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProductVariantsForInvoiceQuery, ListProductVariantsForInvoiceQueryVariables>(ListProductVariantsForInvoiceDocument, options);
        }
export type ListProductVariantsForInvoiceQueryHookResult = ReturnType<typeof useListProductVariantsForInvoiceQuery>;
export type ListProductVariantsForInvoiceLazyQueryHookResult = ReturnType<typeof useListProductVariantsForInvoiceLazyQuery>;
export type ListProductVariantsForInvoiceSuspenseQueryHookResult = ReturnType<typeof useListProductVariantsForInvoiceSuspenseQuery>;
export type ListProductVariantsForInvoiceQueryResult = Apollo.QueryResult<ListProductVariantsForInvoiceQuery, ListProductVariantsForInvoiceQueryVariables>;
export const ListProductsDocument = gql`
    query ListProducts($legalEntityId: String!) {
  listProducts(legalEntityId: $legalEntityId) {
    ...CatalogProductFields
  }
}
    ${CatalogProductFieldsFragmentDoc}`;

/**
 * __useListProductsQuery__
 *
 * To run a query within a React component, call `useListProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProductsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListProductsQuery(baseOptions: Apollo.QueryHookOptions<ListProductsQuery, ListProductsQueryVariables> & ({ variables: ListProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProductsQuery, ListProductsQueryVariables>(ListProductsDocument, options);
      }
export function useListProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProductsQuery, ListProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProductsQuery, ListProductsQueryVariables>(ListProductsDocument, options);
        }
export function useListProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProductsQuery, ListProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProductsQuery, ListProductsQueryVariables>(ListProductsDocument, options);
        }
export type ListProductsQueryHookResult = ReturnType<typeof useListProductsQuery>;
export type ListProductsLazyQueryHookResult = ReturnType<typeof useListProductsLazyQuery>;
export type ListProductsSuspenseQueryHookResult = ReturnType<typeof useListProductsSuspenseQuery>;
export type ListProductsQueryResult = Apollo.QueryResult<ListProductsQuery, ListProductsQueryVariables>;
export const ProductCatalogRevenueByTimeDocument = gql`
    query ProductCatalogRevenueByTime($viewKey: ViewKey!, $origin: IntervalOrigin!, $direction: DirectionFromOrigin!) {
  productRevenue: productInsightTransactionSummary(
    filter: {viewKey: $viewKey, missingProduct: Exclude, categoryTypes: [Assets, Liabilities, Equity, Income, Expenses, CostOfGoodsSold, OtherIncome, OtherExpenses], linkedObjectTypes: [Invoice]}
    origin: $origin
    direction: $direction
    dimensions: [Time]
    defaultCategoryType: Income
  ) {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
  }
}
    ${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useProductCatalogRevenueByTimeQuery__
 *
 * To run a query within a React component, call `useProductCatalogRevenueByTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCatalogRevenueByTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCatalogRevenueByTimeQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      origin: // value for 'origin'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useProductCatalogRevenueByTimeQuery(baseOptions: Apollo.QueryHookOptions<ProductCatalogRevenueByTimeQuery, ProductCatalogRevenueByTimeQueryVariables> & ({ variables: ProductCatalogRevenueByTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCatalogRevenueByTimeQuery, ProductCatalogRevenueByTimeQueryVariables>(ProductCatalogRevenueByTimeDocument, options);
      }
export function useProductCatalogRevenueByTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCatalogRevenueByTimeQuery, ProductCatalogRevenueByTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCatalogRevenueByTimeQuery, ProductCatalogRevenueByTimeQueryVariables>(ProductCatalogRevenueByTimeDocument, options);
        }
export function useProductCatalogRevenueByTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductCatalogRevenueByTimeQuery, ProductCatalogRevenueByTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductCatalogRevenueByTimeQuery, ProductCatalogRevenueByTimeQueryVariables>(ProductCatalogRevenueByTimeDocument, options);
        }
export type ProductCatalogRevenueByTimeQueryHookResult = ReturnType<typeof useProductCatalogRevenueByTimeQuery>;
export type ProductCatalogRevenueByTimeLazyQueryHookResult = ReturnType<typeof useProductCatalogRevenueByTimeLazyQuery>;
export type ProductCatalogRevenueByTimeSuspenseQueryHookResult = ReturnType<typeof useProductCatalogRevenueByTimeSuspenseQuery>;
export type ProductCatalogRevenueByTimeQueryResult = Apollo.QueryResult<ProductCatalogRevenueByTimeQuery, ProductCatalogRevenueByTimeQueryVariables>;
export const ProductCatalogTopSellersDocument = gql`
    query ProductCatalogTopSellers($viewKey: ViewKey!, $origin: IntervalOrigin!, $direction: DirectionFromOrigin!, $sort: DimensionSortMode!, $limit: Int!) {
  topSellers: productInsightTransactionSummary(
    filter: {viewKey: $viewKey, missingProduct: Exclude, categoryTypes: [Assets, Liabilities, Equity, Income, Expenses, CostOfGoodsSold, OtherIncome, OtherExpenses], linkedObjectTypes: [Invoice]}
    origin: $origin
    direction: $direction
    dimensions: [Product]
    masks: [[]]
    defaultCategoryType: Income
  ) {
    summary {
      ...TransactionSummaryFields
    }
    product(limit: $limit, sort: $sort) {
      productId
      productObject {
        dataSourceId
        id
        name
      }
      summary {
        ...TransactionSummaryFields
      }
    }
  }
}
    ${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useProductCatalogTopSellersQuery__
 *
 * To run a query within a React component, call `useProductCatalogTopSellersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCatalogTopSellersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCatalogTopSellersQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      origin: // value for 'origin'
 *      direction: // value for 'direction'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProductCatalogTopSellersQuery(baseOptions: Apollo.QueryHookOptions<ProductCatalogTopSellersQuery, ProductCatalogTopSellersQueryVariables> & ({ variables: ProductCatalogTopSellersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCatalogTopSellersQuery, ProductCatalogTopSellersQueryVariables>(ProductCatalogTopSellersDocument, options);
      }
export function useProductCatalogTopSellersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCatalogTopSellersQuery, ProductCatalogTopSellersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCatalogTopSellersQuery, ProductCatalogTopSellersQueryVariables>(ProductCatalogTopSellersDocument, options);
        }
export function useProductCatalogTopSellersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductCatalogTopSellersQuery, ProductCatalogTopSellersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductCatalogTopSellersQuery, ProductCatalogTopSellersQueryVariables>(ProductCatalogTopSellersDocument, options);
        }
export type ProductCatalogTopSellersQueryHookResult = ReturnType<typeof useProductCatalogTopSellersQuery>;
export type ProductCatalogTopSellersLazyQueryHookResult = ReturnType<typeof useProductCatalogTopSellersLazyQuery>;
export type ProductCatalogTopSellersSuspenseQueryHookResult = ReturnType<typeof useProductCatalogTopSellersSuspenseQuery>;
export type ProductCatalogTopSellersQueryResult = Apollo.QueryResult<ProductCatalogTopSellersQuery, ProductCatalogTopSellersQueryVariables>;
export const ReadProductDocument = gql`
    query ReadProduct($legalEntityId: String!, $dataSourceId: String!, $productId: String!) {
  readProduct(
    legalEntityId: $legalEntityId
    dataSourceId: $dataSourceId
    productId: $productId
  ) {
    ...CatalogProductFields
    variants {
      ...CatalogProductVariantFields
      classifications {
        ...CatalogProductClassificationsFields
      }
    }
  }
}
    ${CatalogProductFieldsFragmentDoc}
${CatalogProductVariantFieldsFragmentDoc}
${CatalogProductClassificationsFieldsFragmentDoc}`;

/**
 * __useReadProductQuery__
 *
 * To run a query within a React component, call `useReadProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadProductQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      dataSourceId: // value for 'dataSourceId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useReadProductQuery(baseOptions: Apollo.QueryHookOptions<ReadProductQuery, ReadProductQueryVariables> & ({ variables: ReadProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadProductQuery, ReadProductQueryVariables>(ReadProductDocument, options);
      }
export function useReadProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadProductQuery, ReadProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadProductQuery, ReadProductQueryVariables>(ReadProductDocument, options);
        }
export function useReadProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadProductQuery, ReadProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadProductQuery, ReadProductQueryVariables>(ReadProductDocument, options);
        }
export type ReadProductQueryHookResult = ReturnType<typeof useReadProductQuery>;
export type ReadProductLazyQueryHookResult = ReturnType<typeof useReadProductLazyQuery>;
export type ReadProductSuspenseQueryHookResult = ReturnType<typeof useReadProductSuspenseQuery>;
export type ReadProductQueryResult = Apollo.QueryResult<ReadProductQuery, ReadProductQueryVariables>;
export const ReadProductActivityDocument = gql`
    query ReadProductActivity($legalEntityId: String!, $dataSourceId: String!, $productId: String!) {
  readProductActivity(
    legalEntityId: $legalEntityId
    dataSourceId: $dataSourceId
    productId: $productId
  ) {
    entityType
    entityId
    name
    eventType
    eventAt
    eventByUserId
  }
}
    `;

/**
 * __useReadProductActivityQuery__
 *
 * To run a query within a React component, call `useReadProductActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadProductActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadProductActivityQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      dataSourceId: // value for 'dataSourceId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useReadProductActivityQuery(baseOptions: Apollo.QueryHookOptions<ReadProductActivityQuery, ReadProductActivityQueryVariables> & ({ variables: ReadProductActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadProductActivityQuery, ReadProductActivityQueryVariables>(ReadProductActivityDocument, options);
      }
export function useReadProductActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadProductActivityQuery, ReadProductActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadProductActivityQuery, ReadProductActivityQueryVariables>(ReadProductActivityDocument, options);
        }
export function useReadProductActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadProductActivityQuery, ReadProductActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadProductActivityQuery, ReadProductActivityQueryVariables>(ReadProductActivityDocument, options);
        }
export type ReadProductActivityQueryHookResult = ReturnType<typeof useReadProductActivityQuery>;
export type ReadProductActivityLazyQueryHookResult = ReturnType<typeof useReadProductActivityLazyQuery>;
export type ReadProductActivitySuspenseQueryHookResult = ReturnType<typeof useReadProductActivitySuspenseQuery>;
export type ReadProductActivityQueryResult = Apollo.QueryResult<ReadProductActivityQuery, ReadProductActivityQueryVariables>;
export const DeleteProductGroupDocument = gql`
    mutation DeleteProductGroup($legalEntityId: String!, $productGroupId: String!) {
  deleteProductGroup(
    legalEntityId: $legalEntityId
    productGroupId: $productGroupId
  )
}
    `;
export type DeleteProductGroupMutationFn = Apollo.MutationFunction<DeleteProductGroupMutation, DeleteProductGroupMutationVariables>;

/**
 * __useDeleteProductGroupMutation__
 *
 * To run a mutation, you first call `useDeleteProductGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductGroupMutation, { data, loading, error }] = useDeleteProductGroupMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      productGroupId: // value for 'productGroupId'
 *   },
 * });
 */
export function useDeleteProductGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductGroupMutation, DeleteProductGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductGroupMutation, DeleteProductGroupMutationVariables>(DeleteProductGroupDocument, options);
      }
export type DeleteProductGroupMutationHookResult = ReturnType<typeof useDeleteProductGroupMutation>;
export type DeleteProductGroupMutationResult = Apollo.MutationResult<DeleteProductGroupMutation>;
export type DeleteProductGroupMutationOptions = Apollo.BaseMutationOptions<DeleteProductGroupMutation, DeleteProductGroupMutationVariables>;
export const SaveProductGroupDocument = gql`
    mutation SaveProductGroup($legalEntityId: String!, $group: ProductGroupInput!) {
  saveProductGroup(legalEntityId: $legalEntityId, group: $group) {
    ...ProductGroupFields
  }
}
    ${ProductGroupFieldsFragmentDoc}`;
export type SaveProductGroupMutationFn = Apollo.MutationFunction<SaveProductGroupMutation, SaveProductGroupMutationVariables>;

/**
 * __useSaveProductGroupMutation__
 *
 * To run a mutation, you first call `useSaveProductGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProductGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProductGroupMutation, { data, loading, error }] = useSaveProductGroupMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useSaveProductGroupMutation(baseOptions?: Apollo.MutationHookOptions<SaveProductGroupMutation, SaveProductGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProductGroupMutation, SaveProductGroupMutationVariables>(SaveProductGroupDocument, options);
      }
export type SaveProductGroupMutationHookResult = ReturnType<typeof useSaveProductGroupMutation>;
export type SaveProductGroupMutationResult = Apollo.MutationResult<SaveProductGroupMutation>;
export type SaveProductGroupMutationOptions = Apollo.BaseMutationOptions<SaveProductGroupMutation, SaveProductGroupMutationVariables>;
export const TransferProductsAndDeleteProductGroupDocument = gql`
    mutation TransferProductsAndDeleteProductGroup($legalEntityId: String!, $sourceProductGroupId: String!, $targetProductGroupId: String!) {
  transferProductsAndDeleteProductGroup(
    legalEntityId: $legalEntityId
    sourceProductGroupId: $sourceProductGroupId
    targetProductGroupId: $targetProductGroupId
  )
}
    `;
export type TransferProductsAndDeleteProductGroupMutationFn = Apollo.MutationFunction<TransferProductsAndDeleteProductGroupMutation, TransferProductsAndDeleteProductGroupMutationVariables>;

/**
 * __useTransferProductsAndDeleteProductGroupMutation__
 *
 * To run a mutation, you first call `useTransferProductsAndDeleteProductGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferProductsAndDeleteProductGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferProductsAndDeleteProductGroupMutation, { data, loading, error }] = useTransferProductsAndDeleteProductGroupMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      sourceProductGroupId: // value for 'sourceProductGroupId'
 *      targetProductGroupId: // value for 'targetProductGroupId'
 *   },
 * });
 */
export function useTransferProductsAndDeleteProductGroupMutation(baseOptions?: Apollo.MutationHookOptions<TransferProductsAndDeleteProductGroupMutation, TransferProductsAndDeleteProductGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferProductsAndDeleteProductGroupMutation, TransferProductsAndDeleteProductGroupMutationVariables>(TransferProductsAndDeleteProductGroupDocument, options);
      }
export type TransferProductsAndDeleteProductGroupMutationHookResult = ReturnType<typeof useTransferProductsAndDeleteProductGroupMutation>;
export type TransferProductsAndDeleteProductGroupMutationResult = Apollo.MutationResult<TransferProductsAndDeleteProductGroupMutation>;
export type TransferProductsAndDeleteProductGroupMutationOptions = Apollo.BaseMutationOptions<TransferProductsAndDeleteProductGroupMutation, TransferProductsAndDeleteProductGroupMutationVariables>;
export const ListProductGroupsDocument = gql`
    query ListProductGroups($legalEntityId: String!) {
  listProductGroups(legalEntityId: $legalEntityId) {
    ...ProductGroupFields
  }
}
    ${ProductGroupFieldsFragmentDoc}`;

/**
 * __useListProductGroupsQuery__
 *
 * To run a query within a React component, call `useListProductGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProductGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProductGroupsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListProductGroupsQuery(baseOptions: Apollo.QueryHookOptions<ListProductGroupsQuery, ListProductGroupsQueryVariables> & ({ variables: ListProductGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProductGroupsQuery, ListProductGroupsQueryVariables>(ListProductGroupsDocument, options);
      }
export function useListProductGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProductGroupsQuery, ListProductGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProductGroupsQuery, ListProductGroupsQueryVariables>(ListProductGroupsDocument, options);
        }
export function useListProductGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProductGroupsQuery, ListProductGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProductGroupsQuery, ListProductGroupsQueryVariables>(ListProductGroupsDocument, options);
        }
export type ListProductGroupsQueryHookResult = ReturnType<typeof useListProductGroupsQuery>;
export type ListProductGroupsLazyQueryHookResult = ReturnType<typeof useListProductGroupsLazyQuery>;
export type ListProductGroupsSuspenseQueryHookResult = ReturnType<typeof useListProductGroupsSuspenseQuery>;
export type ListProductGroupsQueryResult = Apollo.QueryResult<ListProductGroupsQuery, ListProductGroupsQueryVariables>;
export const ReadProductGroupDocument = gql`
    query ReadProductGroup($legalEntityId: String!, $productGroupId: String!) {
  readProductGroup(legalEntityId: $legalEntityId, productGroupId: $productGroupId) {
    ...ProductGroupFields
  }
}
    ${ProductGroupFieldsFragmentDoc}`;

/**
 * __useReadProductGroupQuery__
 *
 * To run a query within a React component, call `useReadProductGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadProductGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadProductGroupQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      productGroupId: // value for 'productGroupId'
 *   },
 * });
 */
export function useReadProductGroupQuery(baseOptions: Apollo.QueryHookOptions<ReadProductGroupQuery, ReadProductGroupQueryVariables> & ({ variables: ReadProductGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadProductGroupQuery, ReadProductGroupQueryVariables>(ReadProductGroupDocument, options);
      }
export function useReadProductGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadProductGroupQuery, ReadProductGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadProductGroupQuery, ReadProductGroupQueryVariables>(ReadProductGroupDocument, options);
        }
export function useReadProductGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadProductGroupQuery, ReadProductGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadProductGroupQuery, ReadProductGroupQueryVariables>(ReadProductGroupDocument, options);
        }
export type ReadProductGroupQueryHookResult = ReturnType<typeof useReadProductGroupQuery>;
export type ReadProductGroupLazyQueryHookResult = ReturnType<typeof useReadProductGroupLazyQuery>;
export type ReadProductGroupSuspenseQueryHookResult = ReturnType<typeof useReadProductGroupSuspenseQuery>;
export type ReadProductGroupQueryResult = Apollo.QueryResult<ReadProductGroupQuery, ReadProductGroupQueryVariables>;
export const ConfirmCustomQualityCheckInstructionDocument = gql`
    mutation ConfirmCustomQualityCheckInstruction($legalEntityId: String, $organizationId: String, $checkId: String!, $instructionId: String!) {
  confirmCustomQualityCheckInstruction(
    legalEntityId: $legalEntityId
    organizationId: $organizationId
    checkId: $checkId
    instructionId: $instructionId
  )
}
    `;
export type ConfirmCustomQualityCheckInstructionMutationFn = Apollo.MutationFunction<ConfirmCustomQualityCheckInstructionMutation, ConfirmCustomQualityCheckInstructionMutationVariables>;

/**
 * __useConfirmCustomQualityCheckInstructionMutation__
 *
 * To run a mutation, you first call `useConfirmCustomQualityCheckInstructionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmCustomQualityCheckInstructionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmCustomQualityCheckInstructionMutation, { data, loading, error }] = useConfirmCustomQualityCheckInstructionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      organizationId: // value for 'organizationId'
 *      checkId: // value for 'checkId'
 *      instructionId: // value for 'instructionId'
 *   },
 * });
 */
export function useConfirmCustomQualityCheckInstructionMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmCustomQualityCheckInstructionMutation, ConfirmCustomQualityCheckInstructionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmCustomQualityCheckInstructionMutation, ConfirmCustomQualityCheckInstructionMutationVariables>(ConfirmCustomQualityCheckInstructionDocument, options);
      }
export type ConfirmCustomQualityCheckInstructionMutationHookResult = ReturnType<typeof useConfirmCustomQualityCheckInstructionMutation>;
export type ConfirmCustomQualityCheckInstructionMutationResult = Apollo.MutationResult<ConfirmCustomQualityCheckInstructionMutation>;
export type ConfirmCustomQualityCheckInstructionMutationOptions = Apollo.BaseMutationOptions<ConfirmCustomQualityCheckInstructionMutation, ConfirmCustomQualityCheckInstructionMutationVariables>;
export const DraftCustomQualityCheckInstructionDocument = gql`
    mutation DraftCustomQualityCheckInstruction($legalEntityId: String, $organizationId: String, $checkId: String!, $userInstruction: String!) {
  draftCustomQualityCheckInstruction(
    legalEntityId: $legalEntityId
    organizationId: $organizationId
    checkId: $checkId
    userInstruction: $userInstruction
  ) {
    ...QualityCheckInstructionFields
  }
}
    ${QualityCheckInstructionFieldsFragmentDoc}`;
export type DraftCustomQualityCheckInstructionMutationFn = Apollo.MutationFunction<DraftCustomQualityCheckInstructionMutation, DraftCustomQualityCheckInstructionMutationVariables>;

/**
 * __useDraftCustomQualityCheckInstructionMutation__
 *
 * To run a mutation, you first call `useDraftCustomQualityCheckInstructionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftCustomQualityCheckInstructionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftCustomQualityCheckInstructionMutation, { data, loading, error }] = useDraftCustomQualityCheckInstructionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      organizationId: // value for 'organizationId'
 *      checkId: // value for 'checkId'
 *      userInstruction: // value for 'userInstruction'
 *   },
 * });
 */
export function useDraftCustomQualityCheckInstructionMutation(baseOptions?: Apollo.MutationHookOptions<DraftCustomQualityCheckInstructionMutation, DraftCustomQualityCheckInstructionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DraftCustomQualityCheckInstructionMutation, DraftCustomQualityCheckInstructionMutationVariables>(DraftCustomQualityCheckInstructionDocument, options);
      }
export type DraftCustomQualityCheckInstructionMutationHookResult = ReturnType<typeof useDraftCustomQualityCheckInstructionMutation>;
export type DraftCustomQualityCheckInstructionMutationResult = Apollo.MutationResult<DraftCustomQualityCheckInstructionMutation>;
export type DraftCustomQualityCheckInstructionMutationOptions = Apollo.BaseMutationOptions<DraftCustomQualityCheckInstructionMutation, DraftCustomQualityCheckInstructionMutationVariables>;
export const ResetCustomQualityCheckInstructionDocument = gql`
    mutation ResetCustomQualityCheckInstruction($legalEntityId: String, $organizationId: String, $checkId: String!) {
  resetCustomQualityCheckInstruction(
    legalEntityId: $legalEntityId
    organizationId: $organizationId
    checkId: $checkId
  )
}
    `;
export type ResetCustomQualityCheckInstructionMutationFn = Apollo.MutationFunction<ResetCustomQualityCheckInstructionMutation, ResetCustomQualityCheckInstructionMutationVariables>;

/**
 * __useResetCustomQualityCheckInstructionMutation__
 *
 * To run a mutation, you first call `useResetCustomQualityCheckInstructionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetCustomQualityCheckInstructionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetCustomQualityCheckInstructionMutation, { data, loading, error }] = useResetCustomQualityCheckInstructionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      organizationId: // value for 'organizationId'
 *      checkId: // value for 'checkId'
 *   },
 * });
 */
export function useResetCustomQualityCheckInstructionMutation(baseOptions?: Apollo.MutationHookOptions<ResetCustomQualityCheckInstructionMutation, ResetCustomQualityCheckInstructionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetCustomQualityCheckInstructionMutation, ResetCustomQualityCheckInstructionMutationVariables>(ResetCustomQualityCheckInstructionDocument, options);
      }
export type ResetCustomQualityCheckInstructionMutationHookResult = ReturnType<typeof useResetCustomQualityCheckInstructionMutation>;
export type ResetCustomQualityCheckInstructionMutationResult = Apollo.MutationResult<ResetCustomQualityCheckInstructionMutation>;
export type ResetCustomQualityCheckInstructionMutationOptions = Apollo.BaseMutationOptions<ResetCustomQualityCheckInstructionMutation, ResetCustomQualityCheckInstructionMutationVariables>;
export const TriggerQualityCheckDryRunDocument = gql`
    mutation TriggerQualityCheckDryRun($viewKey: ViewKey!, $checkId: String!, $draftInstructionId: String) {
  triggerQualityCheckDryRun(
    viewKey: $viewKey
    checkId: $checkId
    draftInstructionId: $draftInstructionId
  )
}
    `;
export type TriggerQualityCheckDryRunMutationFn = Apollo.MutationFunction<TriggerQualityCheckDryRunMutation, TriggerQualityCheckDryRunMutationVariables>;

/**
 * __useTriggerQualityCheckDryRunMutation__
 *
 * To run a mutation, you first call `useTriggerQualityCheckDryRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerQualityCheckDryRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerQualityCheckDryRunMutation, { data, loading, error }] = useTriggerQualityCheckDryRunMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      checkId: // value for 'checkId'
 *      draftInstructionId: // value for 'draftInstructionId'
 *   },
 * });
 */
export function useTriggerQualityCheckDryRunMutation(baseOptions?: Apollo.MutationHookOptions<TriggerQualityCheckDryRunMutation, TriggerQualityCheckDryRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerQualityCheckDryRunMutation, TriggerQualityCheckDryRunMutationVariables>(TriggerQualityCheckDryRunDocument, options);
      }
export type TriggerQualityCheckDryRunMutationHookResult = ReturnType<typeof useTriggerQualityCheckDryRunMutation>;
export type TriggerQualityCheckDryRunMutationResult = Apollo.MutationResult<TriggerQualityCheckDryRunMutation>;
export type TriggerQualityCheckDryRunMutationOptions = Apollo.BaseMutationOptions<TriggerQualityCheckDryRunMutation, TriggerQualityCheckDryRunMutationVariables>;
export const UpdateQualityCheckDocument = gql`
    mutation UpdateQualityCheck($legalEntityId: String, $organizationId: String, $checkId: String!, $isEnabled: Boolean!) {
  updateQualityCheck(
    legalEntityId: $legalEntityId
    organizationId: $organizationId
    checkId: $checkId
    isEnabled: $isEnabled
  )
}
    `;
export type UpdateQualityCheckMutationFn = Apollo.MutationFunction<UpdateQualityCheckMutation, UpdateQualityCheckMutationVariables>;

/**
 * __useUpdateQualityCheckMutation__
 *
 * To run a mutation, you first call `useUpdateQualityCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQualityCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQualityCheckMutation, { data, loading, error }] = useUpdateQualityCheckMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      organizationId: // value for 'organizationId'
 *      checkId: // value for 'checkId'
 *      isEnabled: // value for 'isEnabled'
 *   },
 * });
 */
export function useUpdateQualityCheckMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQualityCheckMutation, UpdateQualityCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQualityCheckMutation, UpdateQualityCheckMutationVariables>(UpdateQualityCheckDocument, options);
      }
export type UpdateQualityCheckMutationHookResult = ReturnType<typeof useUpdateQualityCheckMutation>;
export type UpdateQualityCheckMutationResult = Apollo.MutationResult<UpdateQualityCheckMutation>;
export type UpdateQualityCheckMutationOptions = Apollo.BaseMutationOptions<UpdateQualityCheckMutation, UpdateQualityCheckMutationVariables>;
export const ListQualityCheckGroupsDocument = gql`
    query ListQualityCheckGroups($legalEntityId: String, $organizationId: String) {
  listQualityCheckGroups(
    legalEntityId: $legalEntityId
    organizationId: $organizationId
  ) {
    ...QualityCheckGroupFields
  }
}
    ${QualityCheckGroupFieldsFragmentDoc}`;

/**
 * __useListQualityCheckGroupsQuery__
 *
 * To run a query within a React component, call `useListQualityCheckGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListQualityCheckGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListQualityCheckGroupsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListQualityCheckGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ListQualityCheckGroupsQuery, ListQualityCheckGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListQualityCheckGroupsQuery, ListQualityCheckGroupsQueryVariables>(ListQualityCheckGroupsDocument, options);
      }
export function useListQualityCheckGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListQualityCheckGroupsQuery, ListQualityCheckGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListQualityCheckGroupsQuery, ListQualityCheckGroupsQueryVariables>(ListQualityCheckGroupsDocument, options);
        }
export function useListQualityCheckGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListQualityCheckGroupsQuery, ListQualityCheckGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListQualityCheckGroupsQuery, ListQualityCheckGroupsQueryVariables>(ListQualityCheckGroupsDocument, options);
        }
export type ListQualityCheckGroupsQueryHookResult = ReturnType<typeof useListQualityCheckGroupsQuery>;
export type ListQualityCheckGroupsLazyQueryHookResult = ReturnType<typeof useListQualityCheckGroupsLazyQuery>;
export type ListQualityCheckGroupsSuspenseQueryHookResult = ReturnType<typeof useListQualityCheckGroupsSuspenseQuery>;
export type ListQualityCheckGroupsQueryResult = Apollo.QueryResult<ListQualityCheckGroupsQuery, ListQualityCheckGroupsQueryVariables>;
export const ReadQualityCheckDocument = gql`
    query ReadQualityCheck($viewKey: ViewKey, $organizationId: String, $checkId: String!) {
  readQualityCheck(
    viewKey: $viewKey
    organizationId: $organizationId
    checkId: $checkId
  ) {
    ...QualityCheckWithEntitiesFields
  }
}
    ${QualityCheckWithEntitiesFieldsFragmentDoc}`;

/**
 * __useReadQualityCheckQuery__
 *
 * To run a query within a React component, call `useReadQualityCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadQualityCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadQualityCheckQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      organizationId: // value for 'organizationId'
 *      checkId: // value for 'checkId'
 *   },
 * });
 */
export function useReadQualityCheckQuery(baseOptions: Apollo.QueryHookOptions<ReadQualityCheckQuery, ReadQualityCheckQueryVariables> & ({ variables: ReadQualityCheckQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadQualityCheckQuery, ReadQualityCheckQueryVariables>(ReadQualityCheckDocument, options);
      }
export function useReadQualityCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadQualityCheckQuery, ReadQualityCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadQualityCheckQuery, ReadQualityCheckQueryVariables>(ReadQualityCheckDocument, options);
        }
export function useReadQualityCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadQualityCheckQuery, ReadQualityCheckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadQualityCheckQuery, ReadQualityCheckQueryVariables>(ReadQualityCheckDocument, options);
        }
export type ReadQualityCheckQueryHookResult = ReturnType<typeof useReadQualityCheckQuery>;
export type ReadQualityCheckLazyQueryHookResult = ReturnType<typeof useReadQualityCheckLazyQuery>;
export type ReadQualityCheckSuspenseQueryHookResult = ReturnType<typeof useReadQualityCheckSuspenseQuery>;
export type ReadQualityCheckQueryResult = Apollo.QueryResult<ReadQualityCheckQuery, ReadQualityCheckQueryVariables>;
export const ReadQualityCheckDryRunDocument = gql`
    query ReadQualityCheckDryRun($viewKey: ViewKey!, $checkId: String!, $limit: Int) {
  readQualityCheckDryRun(viewKey: $viewKey, checkId: $checkId, limit: $limit) {
    triggerId
    status
    flaggedCount
    timeRangeStartedAt
    timeRangeEndedAt
    results {
      ...ActionItemFields
    }
  }
}
    ${ActionItemFieldsFragmentDoc}`;

/**
 * __useReadQualityCheckDryRunQuery__
 *
 * To run a query within a React component, call `useReadQualityCheckDryRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadQualityCheckDryRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadQualityCheckDryRunQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      checkId: // value for 'checkId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useReadQualityCheckDryRunQuery(baseOptions: Apollo.QueryHookOptions<ReadQualityCheckDryRunQuery, ReadQualityCheckDryRunQueryVariables> & ({ variables: ReadQualityCheckDryRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadQualityCheckDryRunQuery, ReadQualityCheckDryRunQueryVariables>(ReadQualityCheckDryRunDocument, options);
      }
export function useReadQualityCheckDryRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadQualityCheckDryRunQuery, ReadQualityCheckDryRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadQualityCheckDryRunQuery, ReadQualityCheckDryRunQueryVariables>(ReadQualityCheckDryRunDocument, options);
        }
export function useReadQualityCheckDryRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadQualityCheckDryRunQuery, ReadQualityCheckDryRunQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadQualityCheckDryRunQuery, ReadQualityCheckDryRunQueryVariables>(ReadQualityCheckDryRunDocument, options);
        }
export type ReadQualityCheckDryRunQueryHookResult = ReturnType<typeof useReadQualityCheckDryRunQuery>;
export type ReadQualityCheckDryRunLazyQueryHookResult = ReturnType<typeof useReadQualityCheckDryRunLazyQuery>;
export type ReadQualityCheckDryRunSuspenseQueryHookResult = ReturnType<typeof useReadQualityCheckDryRunSuspenseQuery>;
export type ReadQualityCheckDryRunQueryResult = Apollo.QueryResult<ReadQualityCheckDryRunQuery, ReadQualityCheckDryRunQueryVariables>;
export const UpdateQuotePackageDocument = gql`
    mutation UpdateQuotePackage($legalEntityId: String!, $id: String!, $recipient: ContactInput, $contractDocumentId: String, $companyDetails: CompanyDetailsInput!) {
  updateQuotePackage(
    legalEntityId: $legalEntityId
    id: $id
    recipient: $recipient
    contractDocumentId: $contractDocumentId
    companyDetails: $companyDetails
  )
}
    `;
export type UpdateQuotePackageMutationFn = Apollo.MutationFunction<UpdateQuotePackageMutation, UpdateQuotePackageMutationVariables>;

/**
 * __useUpdateQuotePackageMutation__
 *
 * To run a mutation, you first call `useUpdateQuotePackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuotePackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuotePackageMutation, { data, loading, error }] = useUpdateQuotePackageMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      id: // value for 'id'
 *      recipient: // value for 'recipient'
 *      contractDocumentId: // value for 'contractDocumentId'
 *      companyDetails: // value for 'companyDetails'
 *   },
 * });
 */
export function useUpdateQuotePackageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuotePackageMutation, UpdateQuotePackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuotePackageMutation, UpdateQuotePackageMutationVariables>(UpdateQuotePackageDocument, options);
      }
export type UpdateQuotePackageMutationHookResult = ReturnType<typeof useUpdateQuotePackageMutation>;
export type UpdateQuotePackageMutationResult = Apollo.MutationResult<UpdateQuotePackageMutation>;
export type UpdateQuotePackageMutationOptions = Apollo.BaseMutationOptions<UpdateQuotePackageMutation, UpdateQuotePackageMutationVariables>;
export const ListQuotePackagesByLegalEntityDocument = gql`
    query ListQuotePackagesByLegalEntity($legalEntityId: String!) {
  listQuotePackagesByLegalEntity(legalEntityId: $legalEntityId) {
    ...QuotePackageFields
  }
}
    ${QuotePackageFieldsFragmentDoc}`;

/**
 * __useListQuotePackagesByLegalEntityQuery__
 *
 * To run a query within a React component, call `useListQuotePackagesByLegalEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useListQuotePackagesByLegalEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListQuotePackagesByLegalEntityQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListQuotePackagesByLegalEntityQuery(baseOptions: Apollo.QueryHookOptions<ListQuotePackagesByLegalEntityQuery, ListQuotePackagesByLegalEntityQueryVariables> & ({ variables: ListQuotePackagesByLegalEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListQuotePackagesByLegalEntityQuery, ListQuotePackagesByLegalEntityQueryVariables>(ListQuotePackagesByLegalEntityDocument, options);
      }
export function useListQuotePackagesByLegalEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListQuotePackagesByLegalEntityQuery, ListQuotePackagesByLegalEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListQuotePackagesByLegalEntityQuery, ListQuotePackagesByLegalEntityQueryVariables>(ListQuotePackagesByLegalEntityDocument, options);
        }
export function useListQuotePackagesByLegalEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListQuotePackagesByLegalEntityQuery, ListQuotePackagesByLegalEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListQuotePackagesByLegalEntityQuery, ListQuotePackagesByLegalEntityQueryVariables>(ListQuotePackagesByLegalEntityDocument, options);
        }
export type ListQuotePackagesByLegalEntityQueryHookResult = ReturnType<typeof useListQuotePackagesByLegalEntityQuery>;
export type ListQuotePackagesByLegalEntityLazyQueryHookResult = ReturnType<typeof useListQuotePackagesByLegalEntityLazyQuery>;
export type ListQuotePackagesByLegalEntitySuspenseQueryHookResult = ReturnType<typeof useListQuotePackagesByLegalEntitySuspenseQuery>;
export type ListQuotePackagesByLegalEntityQueryResult = Apollo.QueryResult<ListQuotePackagesByLegalEntityQuery, ListQuotePackagesByLegalEntityQueryVariables>;
export const AttachReportPackageDocumentDocument = gql`
    mutation AttachReportPackageDocument($viewKey: ViewKey!, $origin: IntervalOrigin!, $packageId: String!, $attachments: NewReportAttachments!) {
  attachReportPackageDocument(
    viewKey: $viewKey
    origin: $origin
    packageId: $packageId
    attachments: $attachments
  )
}
    `;
export type AttachReportPackageDocumentMutationFn = Apollo.MutationFunction<AttachReportPackageDocumentMutation, AttachReportPackageDocumentMutationVariables>;

/**
 * __useAttachReportPackageDocumentMutation__
 *
 * To run a mutation, you first call `useAttachReportPackageDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachReportPackageDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachReportPackageDocumentMutation, { data, loading, error }] = useAttachReportPackageDocumentMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      origin: // value for 'origin'
 *      packageId: // value for 'packageId'
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useAttachReportPackageDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AttachReportPackageDocumentMutation, AttachReportPackageDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachReportPackageDocumentMutation, AttachReportPackageDocumentMutationVariables>(AttachReportPackageDocumentDocument, options);
      }
export type AttachReportPackageDocumentMutationHookResult = ReturnType<typeof useAttachReportPackageDocumentMutation>;
export type AttachReportPackageDocumentMutationResult = Apollo.MutationResult<AttachReportPackageDocumentMutation>;
export type AttachReportPackageDocumentMutationOptions = Apollo.BaseMutationOptions<AttachReportPackageDocumentMutation, AttachReportPackageDocumentMutationVariables>;
export const CopyReportPackageDocument = gql`
    mutation CopyReportPackage($viewKey: ViewKey!, $packageId: String!, $title: String!, $periodStartAt: DateInput!, $periodEndAt: DateInput!, $interval: Interval!, $attachments: NewReportAttachments!) {
  copyReportPackage(
    viewKey: $viewKey
    packageId: $packageId
    title: $title
    periodStartAt: $periodStartAt
    periodEndAt: $periodEndAt
    interval: $interval
    attachments: $attachments
  ) {
    ...ReportPackageMetadataFields
  }
}
    ${ReportPackageMetadataFieldsFragmentDoc}`;
export type CopyReportPackageMutationFn = Apollo.MutationFunction<CopyReportPackageMutation, CopyReportPackageMutationVariables>;

/**
 * __useCopyReportPackageMutation__
 *
 * To run a mutation, you first call `useCopyReportPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyReportPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyReportPackageMutation, { data, loading, error }] = useCopyReportPackageMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      packageId: // value for 'packageId'
 *      title: // value for 'title'
 *      periodStartAt: // value for 'periodStartAt'
 *      periodEndAt: // value for 'periodEndAt'
 *      interval: // value for 'interval'
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useCopyReportPackageMutation(baseOptions?: Apollo.MutationHookOptions<CopyReportPackageMutation, CopyReportPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyReportPackageMutation, CopyReportPackageMutationVariables>(CopyReportPackageDocument, options);
      }
export type CopyReportPackageMutationHookResult = ReturnType<typeof useCopyReportPackageMutation>;
export type CopyReportPackageMutationResult = Apollo.MutationResult<CopyReportPackageMutation>;
export type CopyReportPackageMutationOptions = Apollo.BaseMutationOptions<CopyReportPackageMutation, CopyReportPackageMutationVariables>;
export const CreateReportFromUploadDocument = gql`
    mutation CreateReportFromUpload($legalEntityId: String!, $reports: [NewReportUpload!]!) {
  createReportFromUpload(legalEntityId: $legalEntityId, reports: $reports) {
    ...ReportFields
  }
}
    ${ReportFieldsFragmentDoc}`;
export type CreateReportFromUploadMutationFn = Apollo.MutationFunction<CreateReportFromUploadMutation, CreateReportFromUploadMutationVariables>;

/**
 * __useCreateReportFromUploadMutation__
 *
 * To run a mutation, you first call `useCreateReportFromUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportFromUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportFromUploadMutation, { data, loading, error }] = useCreateReportFromUploadMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      reports: // value for 'reports'
 *   },
 * });
 */
export function useCreateReportFromUploadMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportFromUploadMutation, CreateReportFromUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportFromUploadMutation, CreateReportFromUploadMutationVariables>(CreateReportFromUploadDocument, options);
      }
export type CreateReportFromUploadMutationHookResult = ReturnType<typeof useCreateReportFromUploadMutation>;
export type CreateReportFromUploadMutationResult = Apollo.MutationResult<CreateReportFromUploadMutation>;
export type CreateReportFromUploadMutationOptions = Apollo.BaseMutationOptions<CreateReportFromUploadMutation, CreateReportFromUploadMutationVariables>;
export const CreateReportPackageDocument = gql`
    mutation CreateReportPackage($viewKey: ViewKey!, $title: String!, $periodStartAt: DateInput!, $periodEndAt: DateInput!, $interval: Interval!, $attachments: NewReportAttachments!, $coverUrl: String) {
  createReportPackage(
    viewKey: $viewKey
    title: $title
    periodStartAt: $periodStartAt
    periodEndAt: $periodEndAt
    interval: $interval
    attachments: $attachments
    coverUrl: $coverUrl
  ) {
    ...ReportPackageMetadataFields
  }
}
    ${ReportPackageMetadataFieldsFragmentDoc}`;
export type CreateReportPackageMutationFn = Apollo.MutationFunction<CreateReportPackageMutation, CreateReportPackageMutationVariables>;

/**
 * __useCreateReportPackageMutation__
 *
 * To run a mutation, you first call `useCreateReportPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportPackageMutation, { data, loading, error }] = useCreateReportPackageMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      title: // value for 'title'
 *      periodStartAt: // value for 'periodStartAt'
 *      periodEndAt: // value for 'periodEndAt'
 *      interval: // value for 'interval'
 *      attachments: // value for 'attachments'
 *      coverUrl: // value for 'coverUrl'
 *   },
 * });
 */
export function useCreateReportPackageMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportPackageMutation, CreateReportPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportPackageMutation, CreateReportPackageMutationVariables>(CreateReportPackageDocument, options);
      }
export type CreateReportPackageMutationHookResult = ReturnType<typeof useCreateReportPackageMutation>;
export type CreateReportPackageMutationResult = Apollo.MutationResult<CreateReportPackageMutation>;
export type CreateReportPackageMutationOptions = Apollo.BaseMutationOptions<CreateReportPackageMutation, CreateReportPackageMutationVariables>;
export const DeleteReportPackageDocument = gql`
    mutation DeleteReportPackage($packageId: String!, $legalEntityId: String!) {
  deleteReportPackage(packageId: $packageId, legalEntityId: $legalEntityId)
}
    `;
export type DeleteReportPackageMutationFn = Apollo.MutationFunction<DeleteReportPackageMutation, DeleteReportPackageMutationVariables>;

/**
 * __useDeleteReportPackageMutation__
 *
 * To run a mutation, you first call `useDeleteReportPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportPackageMutation, { data, loading, error }] = useDeleteReportPackageMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useDeleteReportPackageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportPackageMutation, DeleteReportPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportPackageMutation, DeleteReportPackageMutationVariables>(DeleteReportPackageDocument, options);
      }
export type DeleteReportPackageMutationHookResult = ReturnType<typeof useDeleteReportPackageMutation>;
export type DeleteReportPackageMutationResult = Apollo.MutationResult<DeleteReportPackageMutation>;
export type DeleteReportPackageMutationOptions = Apollo.BaseMutationOptions<DeleteReportPackageMutation, DeleteReportPackageMutationVariables>;
export const EditReportPackageDocument = gql`
    mutation EditReportPackage($viewKey: ViewKey!, $packageId: String!, $packageVersionId: String!) {
  editReportPackage(
    viewKey: $viewKey
    packageId: $packageId
    packageVersionId: $packageVersionId
  ) {
    ...ReportPackageMetadataFields
  }
}
    ${ReportPackageMetadataFieldsFragmentDoc}`;
export type EditReportPackageMutationFn = Apollo.MutationFunction<EditReportPackageMutation, EditReportPackageMutationVariables>;

/**
 * __useEditReportPackageMutation__
 *
 * To run a mutation, you first call `useEditReportPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditReportPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editReportPackageMutation, { data, loading, error }] = useEditReportPackageMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      packageId: // value for 'packageId'
 *      packageVersionId: // value for 'packageVersionId'
 *   },
 * });
 */
export function useEditReportPackageMutation(baseOptions?: Apollo.MutationHookOptions<EditReportPackageMutation, EditReportPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditReportPackageMutation, EditReportPackageMutationVariables>(EditReportPackageDocument, options);
      }
export type EditReportPackageMutationHookResult = ReturnType<typeof useEditReportPackageMutation>;
export type EditReportPackageMutationResult = Apollo.MutationResult<EditReportPackageMutation>;
export type EditReportPackageMutationOptions = Apollo.BaseMutationOptions<EditReportPackageMutation, EditReportPackageMutationVariables>;
export const GenerateReportPackagePdfDocument = gql`
    mutation GenerateReportPackagePdf($packageId: String!, $packageVersionId: String!, $viewId: ViewIdentifierInput!, $timezone: String, $coverUrl: String) {
  generateReportPackagePdf(
    packageId: $packageId
    packageVersionId: $packageVersionId
    viewId: $viewId
    timezone: $timezone
    coverUrl: $coverUrl
  ) {
    url
  }
}
    `;
export type GenerateReportPackagePdfMutationFn = Apollo.MutationFunction<GenerateReportPackagePdfMutation, GenerateReportPackagePdfMutationVariables>;

/**
 * __useGenerateReportPackagePdfMutation__
 *
 * To run a mutation, you first call `useGenerateReportPackagePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReportPackagePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReportPackagePdfMutation, { data, loading, error }] = useGenerateReportPackagePdfMutation({
 *   variables: {
 *      packageId: // value for 'packageId'
 *      packageVersionId: // value for 'packageVersionId'
 *      viewId: // value for 'viewId'
 *      timezone: // value for 'timezone'
 *      coverUrl: // value for 'coverUrl'
 *   },
 * });
 */
export function useGenerateReportPackagePdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateReportPackagePdfMutation, GenerateReportPackagePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateReportPackagePdfMutation, GenerateReportPackagePdfMutationVariables>(GenerateReportPackagePdfDocument, options);
      }
export type GenerateReportPackagePdfMutationHookResult = ReturnType<typeof useGenerateReportPackagePdfMutation>;
export type GenerateReportPackagePdfMutationResult = Apollo.MutationResult<GenerateReportPackagePdfMutation>;
export type GenerateReportPackagePdfMutationOptions = Apollo.BaseMutationOptions<GenerateReportPackagePdfMutation, GenerateReportPackagePdfMutationVariables>;
export const PublishReportPackageDocument = gql`
    mutation PublishReportPackage($legalEntityId: String!, $packageId: String!, $packageVersionId: String!, $sendNotification: Boolean, $publishAsDraft: Boolean!) {
  publishReportPackage(
    legalEntityId: $legalEntityId
    packageId: $packageId
    packageVersionId: $packageVersionId
    sendNotification: $sendNotification
    publishAsDraft: $publishAsDraft
  )
}
    `;
export type PublishReportPackageMutationFn = Apollo.MutationFunction<PublishReportPackageMutation, PublishReportPackageMutationVariables>;

/**
 * __usePublishReportPackageMutation__
 *
 * To run a mutation, you first call `usePublishReportPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishReportPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishReportPackageMutation, { data, loading, error }] = usePublishReportPackageMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      packageId: // value for 'packageId'
 *      packageVersionId: // value for 'packageVersionId'
 *      sendNotification: // value for 'sendNotification'
 *      publishAsDraft: // value for 'publishAsDraft'
 *   },
 * });
 */
export function usePublishReportPackageMutation(baseOptions?: Apollo.MutationHookOptions<PublishReportPackageMutation, PublishReportPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishReportPackageMutation, PublishReportPackageMutationVariables>(PublishReportPackageDocument, options);
      }
export type PublishReportPackageMutationHookResult = ReturnType<typeof usePublishReportPackageMutation>;
export type PublishReportPackageMutationResult = Apollo.MutationResult<PublishReportPackageMutation>;
export type PublishReportPackageMutationOptions = Apollo.BaseMutationOptions<PublishReportPackageMutation, PublishReportPackageMutationVariables>;
export const RefreshReportPackageDocument = gql`
    mutation RefreshReportPackage($viewKey: ViewKey!, $packageId: String!, $packageVersionId: String) {
  refreshReportPackage(
    viewKey: $viewKey
    packageId: $packageId
    packageVersionId: $packageVersionId
  ) {
    requestId
  }
}
    `;
export type RefreshReportPackageMutationFn = Apollo.MutationFunction<RefreshReportPackageMutation, RefreshReportPackageMutationVariables>;

/**
 * __useRefreshReportPackageMutation__
 *
 * To run a mutation, you first call `useRefreshReportPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshReportPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshReportPackageMutation, { data, loading, error }] = useRefreshReportPackageMutation({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      packageId: // value for 'packageId'
 *      packageVersionId: // value for 'packageVersionId'
 *   },
 * });
 */
export function useRefreshReportPackageMutation(baseOptions?: Apollo.MutationHookOptions<RefreshReportPackageMutation, RefreshReportPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshReportPackageMutation, RefreshReportPackageMutationVariables>(RefreshReportPackageDocument, options);
      }
export type RefreshReportPackageMutationHookResult = ReturnType<typeof useRefreshReportPackageMutation>;
export type RefreshReportPackageMutationResult = Apollo.MutationResult<RefreshReportPackageMutation>;
export type RefreshReportPackageMutationOptions = Apollo.BaseMutationOptions<RefreshReportPackageMutation, RefreshReportPackageMutationVariables>;
export const UpdateExecutiveSummaryDocument = gql`
    mutation UpdateExecutiveSummary($legalEntityId: String!, $documentId: String!, $title: String, $summary: String) {
  updateExecutiveSummary(
    legalEntityId: $legalEntityId
    documentId: $documentId
    title: $title
    summary: $summary
  )
}
    `;
export type UpdateExecutiveSummaryMutationFn = Apollo.MutationFunction<UpdateExecutiveSummaryMutation, UpdateExecutiveSummaryMutationVariables>;

/**
 * __useUpdateExecutiveSummaryMutation__
 *
 * To run a mutation, you first call `useUpdateExecutiveSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExecutiveSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExecutiveSummaryMutation, { data, loading, error }] = useUpdateExecutiveSummaryMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      documentId: // value for 'documentId'
 *      title: // value for 'title'
 *      summary: // value for 'summary'
 *   },
 * });
 */
export function useUpdateExecutiveSummaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExecutiveSummaryMutation, UpdateExecutiveSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExecutiveSummaryMutation, UpdateExecutiveSummaryMutationVariables>(UpdateExecutiveSummaryDocument, options);
      }
export type UpdateExecutiveSummaryMutationHookResult = ReturnType<typeof useUpdateExecutiveSummaryMutation>;
export type UpdateExecutiveSummaryMutationResult = Apollo.MutationResult<UpdateExecutiveSummaryMutation>;
export type UpdateExecutiveSummaryMutationOptions = Apollo.BaseMutationOptions<UpdateExecutiveSummaryMutation, UpdateExecutiveSummaryMutationVariables>;
export const UpdateReportAutomationSettingsDocument = gql`
    mutation UpdateReportAutomationSettings($organizationId: String!, $legalEntityId: String, $interval: Interval!, $autoCreateDraft: Boolean!, $autoPublishDraft: Boolean!, $autoPublishDraftDay: Int!, $autoPublishFinal: Boolean!, $autoPublishFinalDay: Int!) {
  updateReportAutomationSettings(
    organizationId: $organizationId
    legalEntityId: $legalEntityId
    interval: $interval
    autoCreateDraft: $autoCreateDraft
    autoPublishDraft: $autoPublishDraft
    autoPublishDraftDay: $autoPublishDraftDay
    autoPublishFinal: $autoPublishFinal
    autoPublishFinalDay: $autoPublishFinalDay
  )
}
    `;
export type UpdateReportAutomationSettingsMutationFn = Apollo.MutationFunction<UpdateReportAutomationSettingsMutation, UpdateReportAutomationSettingsMutationVariables>;

/**
 * __useUpdateReportAutomationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateReportAutomationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportAutomationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportAutomationSettingsMutation, { data, loading, error }] = useUpdateReportAutomationSettingsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      legalEntityId: // value for 'legalEntityId'
 *      interval: // value for 'interval'
 *      autoCreateDraft: // value for 'autoCreateDraft'
 *      autoPublishDraft: // value for 'autoPublishDraft'
 *      autoPublishDraftDay: // value for 'autoPublishDraftDay'
 *      autoPublishFinal: // value for 'autoPublishFinal'
 *      autoPublishFinalDay: // value for 'autoPublishFinalDay'
 *   },
 * });
 */
export function useUpdateReportAutomationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportAutomationSettingsMutation, UpdateReportAutomationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportAutomationSettingsMutation, UpdateReportAutomationSettingsMutationVariables>(UpdateReportAutomationSettingsDocument, options);
      }
export type UpdateReportAutomationSettingsMutationHookResult = ReturnType<typeof useUpdateReportAutomationSettingsMutation>;
export type UpdateReportAutomationSettingsMutationResult = Apollo.MutationResult<UpdateReportAutomationSettingsMutation>;
export type UpdateReportAutomationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateReportAutomationSettingsMutation, UpdateReportAutomationSettingsMutationVariables>;
export const UpdateReportOptionsDocument = gql`
    mutation UpdateReportOptions($legalEntityId: String!, $reportPackageId: String!, $packageVersionId: String!, $reportId: String!, $reportVersionId: String!, $sparklineLookbackPeriods: Int, $reportLookbackPeriods: Int, $deltaMonthOverMonth: ReportOptionComparison, $deltaYearOverYear: ReportOptionComparison, $comparedToTotal: ReportOptionComparison, $comparedToIncome: ReportOptionComparison, $collapsedSections: CollapsedSectionsInput, $breakdownByClass: ReportBreakdownByClass, $categoryByDepartmentOptions: CategoryByDepartmentOptionsInput, $categoryByLocationOptions: CategoryByLocationOptionsInput) {
  updateReportOptions(
    legalEntityId: $legalEntityId
    reportPackageId: $reportPackageId
    packageVersionId: $packageVersionId
    reportId: $reportId
    reportVersionId: $reportVersionId
    sparklineLookbackPeriods: $sparklineLookbackPeriods
    reportLookbackPeriods: $reportLookbackPeriods
    deltaMonthOverMonth: $deltaMonthOverMonth
    deltaYearOverYear: $deltaYearOverYear
    comparedToTotal: $comparedToTotal
    comparedToIncome: $comparedToIncome
    collapsedSections: $collapsedSections
    breakdownByClass: $breakdownByClass
    categoryByDepartmentOptions: $categoryByDepartmentOptions
    categoryByLocationOptions: $categoryByLocationOptions
  )
}
    `;
export type UpdateReportOptionsMutationFn = Apollo.MutationFunction<UpdateReportOptionsMutation, UpdateReportOptionsMutationVariables>;

/**
 * __useUpdateReportOptionsMutation__
 *
 * To run a mutation, you first call `useUpdateReportOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportOptionsMutation, { data, loading, error }] = useUpdateReportOptionsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      reportPackageId: // value for 'reportPackageId'
 *      packageVersionId: // value for 'packageVersionId'
 *      reportId: // value for 'reportId'
 *      reportVersionId: // value for 'reportVersionId'
 *      sparklineLookbackPeriods: // value for 'sparklineLookbackPeriods'
 *      reportLookbackPeriods: // value for 'reportLookbackPeriods'
 *      deltaMonthOverMonth: // value for 'deltaMonthOverMonth'
 *      deltaYearOverYear: // value for 'deltaYearOverYear'
 *      comparedToTotal: // value for 'comparedToTotal'
 *      comparedToIncome: // value for 'comparedToIncome'
 *      collapsedSections: // value for 'collapsedSections'
 *      breakdownByClass: // value for 'breakdownByClass'
 *      categoryByDepartmentOptions: // value for 'categoryByDepartmentOptions'
 *      categoryByLocationOptions: // value for 'categoryByLocationOptions'
 *   },
 * });
 */
export function useUpdateReportOptionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportOptionsMutation, UpdateReportOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportOptionsMutation, UpdateReportOptionsMutationVariables>(UpdateReportOptionsDocument, options);
      }
export type UpdateReportOptionsMutationHookResult = ReturnType<typeof useUpdateReportOptionsMutation>;
export type UpdateReportOptionsMutationResult = Apollo.MutationResult<UpdateReportOptionsMutation>;
export type UpdateReportOptionsMutationOptions = Apollo.BaseMutationOptions<UpdateReportOptionsMutation, UpdateReportOptionsMutationVariables>;
export const UpdateReportPackageDocument = gql`
    mutation UpdateReportPackage($legalEntityId: String!, $packageId: String!, $packageVersionId: String!, $title: String, $customFooter: String, $preparedBy: String, $accountNumbersDisplay: AccountNumbersDisplay, $coverUrl: String, $coverLogoSource: CoverLogoSource, $publishedAsDraft: Boolean) {
  updateReportPackage(
    legalEntityId: $legalEntityId
    packageId: $packageId
    packageVersionId: $packageVersionId
    title: $title
    customFooter: $customFooter
    preparedBy: $preparedBy
    accountNumbersDisplay: $accountNumbersDisplay
    coverUrl: $coverUrl
    coverLogoSource: $coverLogoSource
    publishedAsDraft: $publishedAsDraft
  )
}
    `;
export type UpdateReportPackageMutationFn = Apollo.MutationFunction<UpdateReportPackageMutation, UpdateReportPackageMutationVariables>;

/**
 * __useUpdateReportPackageMutation__
 *
 * To run a mutation, you first call `useUpdateReportPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportPackageMutation, { data, loading, error }] = useUpdateReportPackageMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      packageId: // value for 'packageId'
 *      packageVersionId: // value for 'packageVersionId'
 *      title: // value for 'title'
 *      customFooter: // value for 'customFooter'
 *      preparedBy: // value for 'preparedBy'
 *      accountNumbersDisplay: // value for 'accountNumbersDisplay'
 *      coverUrl: // value for 'coverUrl'
 *      coverLogoSource: // value for 'coverLogoSource'
 *      publishedAsDraft: // value for 'publishedAsDraft'
 *   },
 * });
 */
export function useUpdateReportPackageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportPackageMutation, UpdateReportPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportPackageMutation, UpdateReportPackageMutationVariables>(UpdateReportPackageDocument, options);
      }
export type UpdateReportPackageMutationHookResult = ReturnType<typeof useUpdateReportPackageMutation>;
export type UpdateReportPackageMutationResult = Apollo.MutationResult<UpdateReportPackageMutation>;
export type UpdateReportPackageMutationOptions = Apollo.BaseMutationOptions<UpdateReportPackageMutation, UpdateReportPackageMutationVariables>;
export const ListReportPackagesDocument = gql`
    query ListReportPackages($legalEntityId: String!, $interval: Interval!, $intervalCount: Int, $year: Int!, $index: Int!, $paginationLimit: Int!, $paginationOffset: Int!, $direction: DirectionFromOrigin!, $sort: PackagesSort) {
  listReportPackages(
    legalEntityId: $legalEntityId
    origin: {interval: $interval, year: $year, index: $index, intervalCount: $intervalCount}
    pagination: {limit: $paginationLimit, offset: $paginationOffset}
    direction: $direction
    sort: $sort
  ) {
    ...ReportPackageMetadataFields
  }
}
    ${ReportPackageMetadataFieldsFragmentDoc}`;

/**
 * __useListReportPackagesQuery__
 *
 * To run a query within a React component, call `useListReportPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReportPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReportPackagesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      interval: // value for 'interval'
 *      intervalCount: // value for 'intervalCount'
 *      year: // value for 'year'
 *      index: // value for 'index'
 *      paginationLimit: // value for 'paginationLimit'
 *      paginationOffset: // value for 'paginationOffset'
 *      direction: // value for 'direction'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useListReportPackagesQuery(baseOptions: Apollo.QueryHookOptions<ListReportPackagesQuery, ListReportPackagesQueryVariables> & ({ variables: ListReportPackagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListReportPackagesQuery, ListReportPackagesQueryVariables>(ListReportPackagesDocument, options);
      }
export function useListReportPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListReportPackagesQuery, ListReportPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListReportPackagesQuery, ListReportPackagesQueryVariables>(ListReportPackagesDocument, options);
        }
export function useListReportPackagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListReportPackagesQuery, ListReportPackagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListReportPackagesQuery, ListReportPackagesQueryVariables>(ListReportPackagesDocument, options);
        }
export type ListReportPackagesQueryHookResult = ReturnType<typeof useListReportPackagesQuery>;
export type ListReportPackagesLazyQueryHookResult = ReturnType<typeof useListReportPackagesLazyQuery>;
export type ListReportPackagesSuspenseQueryHookResult = ReturnType<typeof useListReportPackagesSuspenseQuery>;
export type ListReportPackagesQueryResult = Apollo.QueryResult<ListReportPackagesQuery, ListReportPackagesQueryVariables>;
export const ListReportTemplatesDocument = gql`
    query ListReportTemplates($legalEntityId: String!, $interval: Interval!, $limit: Int!) {
  listReportTemplates(
    legalEntityId: $legalEntityId
    interval: $interval
    limit: $limit
  ) {
    id
    name
    hasExecutiveSummary
    hasProfitAndLoss
    hasBalanceSheet
    hasCashFlow
  }
}
    `;

/**
 * __useListReportTemplatesQuery__
 *
 * To run a query within a React component, call `useListReportTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReportTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReportTemplatesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      interval: // value for 'interval'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListReportTemplatesQuery(baseOptions: Apollo.QueryHookOptions<ListReportTemplatesQuery, ListReportTemplatesQueryVariables> & ({ variables: ListReportTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListReportTemplatesQuery, ListReportTemplatesQueryVariables>(ListReportTemplatesDocument, options);
      }
export function useListReportTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListReportTemplatesQuery, ListReportTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListReportTemplatesQuery, ListReportTemplatesQueryVariables>(ListReportTemplatesDocument, options);
        }
export function useListReportTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListReportTemplatesQuery, ListReportTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListReportTemplatesQuery, ListReportTemplatesQueryVariables>(ListReportTemplatesDocument, options);
        }
export type ListReportTemplatesQueryHookResult = ReturnType<typeof useListReportTemplatesQuery>;
export type ListReportTemplatesLazyQueryHookResult = ReturnType<typeof useListReportTemplatesLazyQuery>;
export type ListReportTemplatesSuspenseQueryHookResult = ReturnType<typeof useListReportTemplatesSuspenseQuery>;
export type ListReportTemplatesQueryResult = Apollo.QueryResult<ListReportTemplatesQuery, ListReportTemplatesQueryVariables>;
export const ReadReportArchiveDocument = gql`
    query ReadReportArchive($legalEntityId: String!, $reportId: String!, $reportVersionId: String!, $reportPackageId: String!, $reportFileSource: ReportFileSource, $limit: Int!, $sort: DimensionSortMode, $timeHistory: Boolean!, $departmentHistory: Boolean!, $locationHistory: Boolean!) {
  readReportArchive(
    legalEntityId: $legalEntityId
    reportId: $reportId
    reportVersionId: $reportVersionId
    reportPackageId: $reportPackageId
    reportFileSource: $reportFileSource
  ) {
    ...StatementFields
  }
}
    ${StatementFieldsFragmentDoc}`;

/**
 * __useReadReportArchiveQuery__
 *
 * To run a query within a React component, call `useReadReportArchiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadReportArchiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadReportArchiveQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      reportId: // value for 'reportId'
 *      reportVersionId: // value for 'reportVersionId'
 *      reportPackageId: // value for 'reportPackageId'
 *      reportFileSource: // value for 'reportFileSource'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      timeHistory: // value for 'timeHistory'
 *      departmentHistory: // value for 'departmentHistory'
 *      locationHistory: // value for 'locationHistory'
 *   },
 * });
 */
export function useReadReportArchiveQuery(baseOptions: Apollo.QueryHookOptions<ReadReportArchiveQuery, ReadReportArchiveQueryVariables> & ({ variables: ReadReportArchiveQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadReportArchiveQuery, ReadReportArchiveQueryVariables>(ReadReportArchiveDocument, options);
      }
export function useReadReportArchiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadReportArchiveQuery, ReadReportArchiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadReportArchiveQuery, ReadReportArchiveQueryVariables>(ReadReportArchiveDocument, options);
        }
export function useReadReportArchiveSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadReportArchiveQuery, ReadReportArchiveQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadReportArchiveQuery, ReadReportArchiveQueryVariables>(ReadReportArchiveDocument, options);
        }
export type ReadReportArchiveQueryHookResult = ReturnType<typeof useReadReportArchiveQuery>;
export type ReadReportArchiveLazyQueryHookResult = ReturnType<typeof useReadReportArchiveLazyQuery>;
export type ReadReportArchiveSuspenseQueryHookResult = ReturnType<typeof useReadReportArchiveSuspenseQuery>;
export type ReadReportArchiveQueryResult = Apollo.QueryResult<ReadReportArchiveQuery, ReadReportArchiveQueryVariables>;
export const ReadReportAutomationSettingsDocument = gql`
    query ReadReportAutomationSettings($organizationId: String!, $legalEntityId: String, $interval: Interval!) {
  readReportAutomationSettings(
    organizationId: $organizationId
    legalEntityId: $legalEntityId
    interval: $interval
  ) {
    ...ReportAutomationSettingsFields
  }
}
    ${ReportAutomationSettingsFieldsFragmentDoc}`;

/**
 * __useReadReportAutomationSettingsQuery__
 *
 * To run a query within a React component, call `useReadReportAutomationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadReportAutomationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadReportAutomationSettingsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      legalEntityId: // value for 'legalEntityId'
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function useReadReportAutomationSettingsQuery(baseOptions: Apollo.QueryHookOptions<ReadReportAutomationSettingsQuery, ReadReportAutomationSettingsQueryVariables> & ({ variables: ReadReportAutomationSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadReportAutomationSettingsQuery, ReadReportAutomationSettingsQueryVariables>(ReadReportAutomationSettingsDocument, options);
      }
export function useReadReportAutomationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadReportAutomationSettingsQuery, ReadReportAutomationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadReportAutomationSettingsQuery, ReadReportAutomationSettingsQueryVariables>(ReadReportAutomationSettingsDocument, options);
        }
export function useReadReportAutomationSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadReportAutomationSettingsQuery, ReadReportAutomationSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadReportAutomationSettingsQuery, ReadReportAutomationSettingsQueryVariables>(ReadReportAutomationSettingsDocument, options);
        }
export type ReadReportAutomationSettingsQueryHookResult = ReturnType<typeof useReadReportAutomationSettingsQuery>;
export type ReadReportAutomationSettingsLazyQueryHookResult = ReturnType<typeof useReadReportAutomationSettingsLazyQuery>;
export type ReadReportAutomationSettingsSuspenseQueryHookResult = ReturnType<typeof useReadReportAutomationSettingsSuspenseQuery>;
export type ReadReportAutomationSettingsQueryResult = Apollo.QueryResult<ReadReportAutomationSettingsQuery, ReadReportAutomationSettingsQueryVariables>;
export const ReadReportPackageDocument = gql`
    query ReadReportPackage($legalEntityId: String!, $packageId: String!, $packageVersionId: String) {
  readReportPackage(
    legalEntityId: $legalEntityId
    packageId: $packageId
    packageVersionId: $packageVersionId
  ) {
    ...ReportPackageFields
  }
}
    ${ReportPackageFieldsFragmentDoc}`;

/**
 * __useReadReportPackageQuery__
 *
 * To run a query within a React component, call `useReadReportPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadReportPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadReportPackageQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      packageId: // value for 'packageId'
 *      packageVersionId: // value for 'packageVersionId'
 *   },
 * });
 */
export function useReadReportPackageQuery(baseOptions: Apollo.QueryHookOptions<ReadReportPackageQuery, ReadReportPackageQueryVariables> & ({ variables: ReadReportPackageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadReportPackageQuery, ReadReportPackageQueryVariables>(ReadReportPackageDocument, options);
      }
export function useReadReportPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadReportPackageQuery, ReadReportPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadReportPackageQuery, ReadReportPackageQueryVariables>(ReadReportPackageDocument, options);
        }
export function useReadReportPackageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadReportPackageQuery, ReadReportPackageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadReportPackageQuery, ReadReportPackageQueryVariables>(ReadReportPackageDocument, options);
        }
export type ReadReportPackageQueryHookResult = ReturnType<typeof useReadReportPackageQuery>;
export type ReadReportPackageLazyQueryHookResult = ReturnType<typeof useReadReportPackageLazyQuery>;
export type ReadReportPackageSuspenseQueryHookResult = ReturnType<typeof useReadReportPackageSuspenseQuery>;
export type ReadReportPackageQueryResult = Apollo.QueryResult<ReadReportPackageQuery, ReadReportPackageQueryVariables>;
export const SummarizeTrialBalanceDocument = gql`
    query SummarizeTrialBalance($viewKey: ViewKey!, $origin: IntervalOrigin!) {
  summarizeTrialBalance(viewKey: $viewKey, origin: $origin) {
    ...TrialBalanceFields
  }
}
    ${TrialBalanceFieldsFragmentDoc}`;

/**
 * __useSummarizeTrialBalanceQuery__
 *
 * To run a query within a React component, call `useSummarizeTrialBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTrialBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTrialBalanceQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useSummarizeTrialBalanceQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTrialBalanceQuery, SummarizeTrialBalanceQueryVariables> & ({ variables: SummarizeTrialBalanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTrialBalanceQuery, SummarizeTrialBalanceQueryVariables>(SummarizeTrialBalanceDocument, options);
      }
export function useSummarizeTrialBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTrialBalanceQuery, SummarizeTrialBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTrialBalanceQuery, SummarizeTrialBalanceQueryVariables>(SummarizeTrialBalanceDocument, options);
        }
export function useSummarizeTrialBalanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTrialBalanceQuery, SummarizeTrialBalanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTrialBalanceQuery, SummarizeTrialBalanceQueryVariables>(SummarizeTrialBalanceDocument, options);
        }
export type SummarizeTrialBalanceQueryHookResult = ReturnType<typeof useSummarizeTrialBalanceQuery>;
export type SummarizeTrialBalanceLazyQueryHookResult = ReturnType<typeof useSummarizeTrialBalanceLazyQuery>;
export type SummarizeTrialBalanceSuspenseQueryHookResult = ReturnType<typeof useSummarizeTrialBalanceSuspenseQuery>;
export type SummarizeTrialBalanceQueryResult = Apollo.QueryResult<SummarizeTrialBalanceQuery, SummarizeTrialBalanceQueryVariables>;
export const ReportDownloadUrlDocument = gql`
    query ReportDownloadUrl($legalEntityId: String!, $reportId: String!, $reportVersionId: String!, $reportPackageId: String!, $reportFileSource: ReportFileSource) {
  reportDownloadUrl(
    legalEntityId: $legalEntityId
    reportId: $reportId
    reportVersionId: $reportVersionId
    reportPackageId: $reportPackageId
    reportFileSource: $reportFileSource
  ) {
    url
  }
}
    `;

/**
 * __useReportDownloadUrlQuery__
 *
 * To run a query within a React component, call `useReportDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportDownloadUrlQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      reportId: // value for 'reportId'
 *      reportVersionId: // value for 'reportVersionId'
 *      reportPackageId: // value for 'reportPackageId'
 *      reportFileSource: // value for 'reportFileSource'
 *   },
 * });
 */
export function useReportDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<ReportDownloadUrlQuery, ReportDownloadUrlQueryVariables> & ({ variables: ReportDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportDownloadUrlQuery, ReportDownloadUrlQueryVariables>(ReportDownloadUrlDocument, options);
      }
export function useReportDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportDownloadUrlQuery, ReportDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportDownloadUrlQuery, ReportDownloadUrlQueryVariables>(ReportDownloadUrlDocument, options);
        }
export function useReportDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportDownloadUrlQuery, ReportDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportDownloadUrlQuery, ReportDownloadUrlQueryVariables>(ReportDownloadUrlDocument, options);
        }
export type ReportDownloadUrlQueryHookResult = ReturnType<typeof useReportDownloadUrlQuery>;
export type ReportDownloadUrlLazyQueryHookResult = ReturnType<typeof useReportDownloadUrlLazyQuery>;
export type ReportDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useReportDownloadUrlSuspenseQuery>;
export type ReportDownloadUrlQueryResult = Apollo.QueryResult<ReportDownloadUrlQuery, ReportDownloadUrlQueryVariables>;
export const SummarizeReportPackagesDocument = gql`
    query SummarizeReportPackages($legalEntityId: String!, $intervalOrigin: IntervalOrigin!, $direction: DirectionFromOrigin!) {
  summarizeReportPackages(
    legalEntityId: $legalEntityId
    origin: $intervalOrigin
    direction: $direction
  ) {
    period {
      ...PeriodFields
    }
    packagesCount
    publishedCount
    draftCount
  }
}
    ${PeriodFieldsFragmentDoc}`;

/**
 * __useSummarizeReportPackagesQuery__
 *
 * To run a query within a React component, call `useSummarizeReportPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeReportPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeReportPackagesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      intervalOrigin: // value for 'intervalOrigin'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useSummarizeReportPackagesQuery(baseOptions: Apollo.QueryHookOptions<SummarizeReportPackagesQuery, SummarizeReportPackagesQueryVariables> & ({ variables: SummarizeReportPackagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeReportPackagesQuery, SummarizeReportPackagesQueryVariables>(SummarizeReportPackagesDocument, options);
      }
export function useSummarizeReportPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeReportPackagesQuery, SummarizeReportPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeReportPackagesQuery, SummarizeReportPackagesQueryVariables>(SummarizeReportPackagesDocument, options);
        }
export function useSummarizeReportPackagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeReportPackagesQuery, SummarizeReportPackagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeReportPackagesQuery, SummarizeReportPackagesQueryVariables>(SummarizeReportPackagesDocument, options);
        }
export type SummarizeReportPackagesQueryHookResult = ReturnType<typeof useSummarizeReportPackagesQuery>;
export type SummarizeReportPackagesLazyQueryHookResult = ReturnType<typeof useSummarizeReportPackagesLazyQuery>;
export type SummarizeReportPackagesSuspenseQueryHookResult = ReturnType<typeof useSummarizeReportPackagesSuspenseQuery>;
export type SummarizeReportPackagesQueryResult = Apollo.QueryResult<SummarizeReportPackagesQuery, SummarizeReportPackagesQueryVariables>;
export const UpdateScheduleImportCandidateStatusDocument = gql`
    mutation UpdateScheduleImportCandidateStatus($legalEntityId: String!, $scheduleImportCandidateId: String!, $status: ScheduleImportCandidateStatus!) {
  updateScheduleImportCandidateStatus(
    legalEntityId: $legalEntityId
    scheduleImportCandidateId: $scheduleImportCandidateId
    status: $status
  )
}
    `;
export type UpdateScheduleImportCandidateStatusMutationFn = Apollo.MutationFunction<UpdateScheduleImportCandidateStatusMutation, UpdateScheduleImportCandidateStatusMutationVariables>;

/**
 * __useUpdateScheduleImportCandidateStatusMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleImportCandidateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleImportCandidateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleImportCandidateStatusMutation, { data, loading, error }] = useUpdateScheduleImportCandidateStatusMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      scheduleImportCandidateId: // value for 'scheduleImportCandidateId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateScheduleImportCandidateStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleImportCandidateStatusMutation, UpdateScheduleImportCandidateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleImportCandidateStatusMutation, UpdateScheduleImportCandidateStatusMutationVariables>(UpdateScheduleImportCandidateStatusDocument, options);
      }
export type UpdateScheduleImportCandidateStatusMutationHookResult = ReturnType<typeof useUpdateScheduleImportCandidateStatusMutation>;
export type UpdateScheduleImportCandidateStatusMutationResult = Apollo.MutationResult<UpdateScheduleImportCandidateStatusMutation>;
export type UpdateScheduleImportCandidateStatusMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleImportCandidateStatusMutation, UpdateScheduleImportCandidateStatusMutationVariables>;
export const CreateScheduleDocument = gql`
    mutation CreateSchedule($legalEntityId: String!, $schedule: ScheduleInput!, $recategorizeSource: SourceRecategorizationInput, $viewKey: ViewKey, $scheduleImportCandidateId: String) {
  createSchedule(
    legalEntityId: $legalEntityId
    schedule: $schedule
    recategorizeSource: $recategorizeSource
    viewKey: $viewKey
    scheduleImportCandidateId: $scheduleImportCandidateId
  )
}
    `;
export type CreateScheduleMutationFn = Apollo.MutationFunction<CreateScheduleMutation, CreateScheduleMutationVariables>;

/**
 * __useCreateScheduleMutation__
 *
 * To run a mutation, you first call `useCreateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleMutation, { data, loading, error }] = useCreateScheduleMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      schedule: // value for 'schedule'
 *      recategorizeSource: // value for 'recategorizeSource'
 *      viewKey: // value for 'viewKey'
 *      scheduleImportCandidateId: // value for 'scheduleImportCandidateId'
 *   },
 * });
 */
export function useCreateScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduleMutation, CreateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduleMutation, CreateScheduleMutationVariables>(CreateScheduleDocument, options);
      }
export type CreateScheduleMutationHookResult = ReturnType<typeof useCreateScheduleMutation>;
export type CreateScheduleMutationResult = Apollo.MutationResult<CreateScheduleMutation>;
export type CreateScheduleMutationOptions = Apollo.BaseMutationOptions<CreateScheduleMutation, CreateScheduleMutationVariables>;
export const DeleteScheduleDocument = gql`
    mutation DeleteSchedule($legalEntityId: String!, $scheduleTemplateId: String!, $scheduleId: String!) {
  deleteSchedule(
    legalEntityId: $legalEntityId
    scheduleTemplateId: $scheduleTemplateId
    scheduleId: $scheduleId
  )
}
    `;
export type DeleteScheduleMutationFn = Apollo.MutationFunction<DeleteScheduleMutation, DeleteScheduleMutationVariables>;

/**
 * __useDeleteScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduleMutation, { data, loading, error }] = useDeleteScheduleMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      scheduleTemplateId: // value for 'scheduleTemplateId'
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useDeleteScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduleMutation, DeleteScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduleMutation, DeleteScheduleMutationVariables>(DeleteScheduleDocument, options);
      }
export type DeleteScheduleMutationHookResult = ReturnType<typeof useDeleteScheduleMutation>;
export type DeleteScheduleMutationResult = Apollo.MutationResult<DeleteScheduleMutation>;
export type DeleteScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteScheduleMutation, DeleteScheduleMutationVariables>;
export const UpdateScheduleDocument = gql`
    mutation UpdateSchedule($legalEntityId: String!, $schedule: ScheduleInput!, $viewKey: ViewKey) {
  updateSchedule(
    legalEntityId: $legalEntityId
    schedule: $schedule
    viewKey: $viewKey
  )
}
    `;
export type UpdateScheduleMutationFn = Apollo.MutationFunction<UpdateScheduleMutation, UpdateScheduleMutationVariables>;

/**
 * __useUpdateScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleMutation, { data, loading, error }] = useUpdateScheduleMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      schedule: // value for 'schedule'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useUpdateScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleMutation, UpdateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleMutation, UpdateScheduleMutationVariables>(UpdateScheduleDocument, options);
      }
export type UpdateScheduleMutationHookResult = ReturnType<typeof useUpdateScheduleMutation>;
export type UpdateScheduleMutationResult = Apollo.MutationResult<UpdateScheduleMutation>;
export type UpdateScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleMutation, UpdateScheduleMutationVariables>;
export const ListScheduleEventTemplatesDocument = gql`
    query ListScheduleEventTemplates($legalEntityId: String!, $scheduleTemplateId: String!) {
  listScheduleEventTemplates(
    scheduleTemplateId: $scheduleTemplateId
    legalEntityId: $legalEntityId
  ) {
    ...ScheduleEventTemplateFields
  }
}
    ${ScheduleEventTemplateFieldsFragmentDoc}`;

/**
 * __useListScheduleEventTemplatesQuery__
 *
 * To run a query within a React component, call `useListScheduleEventTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListScheduleEventTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListScheduleEventTemplatesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      scheduleTemplateId: // value for 'scheduleTemplateId'
 *   },
 * });
 */
export function useListScheduleEventTemplatesQuery(baseOptions: Apollo.QueryHookOptions<ListScheduleEventTemplatesQuery, ListScheduleEventTemplatesQueryVariables> & ({ variables: ListScheduleEventTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListScheduleEventTemplatesQuery, ListScheduleEventTemplatesQueryVariables>(ListScheduleEventTemplatesDocument, options);
      }
export function useListScheduleEventTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListScheduleEventTemplatesQuery, ListScheduleEventTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListScheduleEventTemplatesQuery, ListScheduleEventTemplatesQueryVariables>(ListScheduleEventTemplatesDocument, options);
        }
export function useListScheduleEventTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListScheduleEventTemplatesQuery, ListScheduleEventTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListScheduleEventTemplatesQuery, ListScheduleEventTemplatesQueryVariables>(ListScheduleEventTemplatesDocument, options);
        }
export type ListScheduleEventTemplatesQueryHookResult = ReturnType<typeof useListScheduleEventTemplatesQuery>;
export type ListScheduleEventTemplatesLazyQueryHookResult = ReturnType<typeof useListScheduleEventTemplatesLazyQuery>;
export type ListScheduleEventTemplatesSuspenseQueryHookResult = ReturnType<typeof useListScheduleEventTemplatesSuspenseQuery>;
export type ListScheduleEventTemplatesQueryResult = Apollo.QueryResult<ListScheduleEventTemplatesQuery, ListScheduleEventTemplatesQueryVariables>;
export const ListScheduleSnapshotsDocument = gql`
    query ListScheduleSnapshots($origin: IntervalOrigin!, $filter: ScheduleDashboardFilter!, $pagination: Pagination!, $direction: DirectionFromOrigin!, $order: ScheduleOrder) {
  listScheduleSnapshots(
    origin: $origin
    filter: $filter
    pagination: $pagination
    direction: $direction
    order: $order
  ) {
    ...ScheduleSnapshotFields
  }
}
    ${ScheduleSnapshotFieldsFragmentDoc}`;

/**
 * __useListScheduleSnapshotsQuery__
 *
 * To run a query within a React component, call `useListScheduleSnapshotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListScheduleSnapshotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListScheduleSnapshotsQuery({
 *   variables: {
 *      origin: // value for 'origin'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      direction: // value for 'direction'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListScheduleSnapshotsQuery(baseOptions: Apollo.QueryHookOptions<ListScheduleSnapshotsQuery, ListScheduleSnapshotsQueryVariables> & ({ variables: ListScheduleSnapshotsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListScheduleSnapshotsQuery, ListScheduleSnapshotsQueryVariables>(ListScheduleSnapshotsDocument, options);
      }
export function useListScheduleSnapshotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListScheduleSnapshotsQuery, ListScheduleSnapshotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListScheduleSnapshotsQuery, ListScheduleSnapshotsQueryVariables>(ListScheduleSnapshotsDocument, options);
        }
export function useListScheduleSnapshotsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListScheduleSnapshotsQuery, ListScheduleSnapshotsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListScheduleSnapshotsQuery, ListScheduleSnapshotsQueryVariables>(ListScheduleSnapshotsDocument, options);
        }
export type ListScheduleSnapshotsQueryHookResult = ReturnType<typeof useListScheduleSnapshotsQuery>;
export type ListScheduleSnapshotsLazyQueryHookResult = ReturnType<typeof useListScheduleSnapshotsLazyQuery>;
export type ListScheduleSnapshotsSuspenseQueryHookResult = ReturnType<typeof useListScheduleSnapshotsSuspenseQuery>;
export type ListScheduleSnapshotsQueryResult = Apollo.QueryResult<ListScheduleSnapshotsQuery, ListScheduleSnapshotsQueryVariables>;
export const ListScheduleSpecializationsDocument = gql`
    query ListScheduleSpecializations($legalEntityId: String!, $scheduleTemplateId: String!) {
  listScheduleSpecializations(
    legalEntityId: $legalEntityId
    scheduleTemplateId: $scheduleTemplateId
  ) {
    ...ScheduleSpecializationFields
  }
}
    ${ScheduleSpecializationFieldsFragmentDoc}`;

/**
 * __useListScheduleSpecializationsQuery__
 *
 * To run a query within a React component, call `useListScheduleSpecializationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListScheduleSpecializationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListScheduleSpecializationsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      scheduleTemplateId: // value for 'scheduleTemplateId'
 *   },
 * });
 */
export function useListScheduleSpecializationsQuery(baseOptions: Apollo.QueryHookOptions<ListScheduleSpecializationsQuery, ListScheduleSpecializationsQueryVariables> & ({ variables: ListScheduleSpecializationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListScheduleSpecializationsQuery, ListScheduleSpecializationsQueryVariables>(ListScheduleSpecializationsDocument, options);
      }
export function useListScheduleSpecializationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListScheduleSpecializationsQuery, ListScheduleSpecializationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListScheduleSpecializationsQuery, ListScheduleSpecializationsQueryVariables>(ListScheduleSpecializationsDocument, options);
        }
export function useListScheduleSpecializationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListScheduleSpecializationsQuery, ListScheduleSpecializationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListScheduleSpecializationsQuery, ListScheduleSpecializationsQueryVariables>(ListScheduleSpecializationsDocument, options);
        }
export type ListScheduleSpecializationsQueryHookResult = ReturnType<typeof useListScheduleSpecializationsQuery>;
export type ListScheduleSpecializationsLazyQueryHookResult = ReturnType<typeof useListScheduleSpecializationsLazyQuery>;
export type ListScheduleSpecializationsSuspenseQueryHookResult = ReturnType<typeof useListScheduleSpecializationsSuspenseQuery>;
export type ListScheduleSpecializationsQueryResult = Apollo.QueryResult<ListScheduleSpecializationsQuery, ListScheduleSpecializationsQueryVariables>;
export const ListScheduleTemplatesByIDsDocument = gql`
    query ListScheduleTemplatesByIDs($legalEntityId: String!, $scheduleTemplateIds: [String!]!) {
  listScheduleTemplatesByIDs(
    legalEntityId: $legalEntityId
    scheduleTemplateIds: $scheduleTemplateIds
  ) {
    ...ScheduleTemplateFields
  }
}
    ${ScheduleTemplateFieldsFragmentDoc}`;

/**
 * __useListScheduleTemplatesByIDsQuery__
 *
 * To run a query within a React component, call `useListScheduleTemplatesByIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListScheduleTemplatesByIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListScheduleTemplatesByIDsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      scheduleTemplateIds: // value for 'scheduleTemplateIds'
 *   },
 * });
 */
export function useListScheduleTemplatesByIDsQuery(baseOptions: Apollo.QueryHookOptions<ListScheduleTemplatesByIDsQuery, ListScheduleTemplatesByIDsQueryVariables> & ({ variables: ListScheduleTemplatesByIDsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListScheduleTemplatesByIDsQuery, ListScheduleTemplatesByIDsQueryVariables>(ListScheduleTemplatesByIDsDocument, options);
      }
export function useListScheduleTemplatesByIDsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListScheduleTemplatesByIDsQuery, ListScheduleTemplatesByIDsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListScheduleTemplatesByIDsQuery, ListScheduleTemplatesByIDsQueryVariables>(ListScheduleTemplatesByIDsDocument, options);
        }
export function useListScheduleTemplatesByIDsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListScheduleTemplatesByIDsQuery, ListScheduleTemplatesByIDsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListScheduleTemplatesByIDsQuery, ListScheduleTemplatesByIDsQueryVariables>(ListScheduleTemplatesByIDsDocument, options);
        }
export type ListScheduleTemplatesByIDsQueryHookResult = ReturnType<typeof useListScheduleTemplatesByIDsQuery>;
export type ListScheduleTemplatesByIDsLazyQueryHookResult = ReturnType<typeof useListScheduleTemplatesByIDsLazyQuery>;
export type ListScheduleTemplatesByIDsSuspenseQueryHookResult = ReturnType<typeof useListScheduleTemplatesByIDsSuspenseQuery>;
export type ListScheduleTemplatesByIDsQueryResult = Apollo.QueryResult<ListScheduleTemplatesByIDsQuery, ListScheduleTemplatesByIDsQueryVariables>;
export const ListScheduleTemplatesByTypesDocument = gql`
    query ListScheduleTemplatesByTypes($legalEntityId: String!, $types: [ScheduleType!]) {
  listScheduleTemplatesByTypes(legalEntityId: $legalEntityId, types: $types) {
    ...ScheduleTemplateFields
  }
}
    ${ScheduleTemplateFieldsFragmentDoc}`;

/**
 * __useListScheduleTemplatesByTypesQuery__
 *
 * To run a query within a React component, call `useListScheduleTemplatesByTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListScheduleTemplatesByTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListScheduleTemplatesByTypesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useListScheduleTemplatesByTypesQuery(baseOptions: Apollo.QueryHookOptions<ListScheduleTemplatesByTypesQuery, ListScheduleTemplatesByTypesQueryVariables> & ({ variables: ListScheduleTemplatesByTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListScheduleTemplatesByTypesQuery, ListScheduleTemplatesByTypesQueryVariables>(ListScheduleTemplatesByTypesDocument, options);
      }
export function useListScheduleTemplatesByTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListScheduleTemplatesByTypesQuery, ListScheduleTemplatesByTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListScheduleTemplatesByTypesQuery, ListScheduleTemplatesByTypesQueryVariables>(ListScheduleTemplatesByTypesDocument, options);
        }
export function useListScheduleTemplatesByTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListScheduleTemplatesByTypesQuery, ListScheduleTemplatesByTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListScheduleTemplatesByTypesQuery, ListScheduleTemplatesByTypesQueryVariables>(ListScheduleTemplatesByTypesDocument, options);
        }
export type ListScheduleTemplatesByTypesQueryHookResult = ReturnType<typeof useListScheduleTemplatesByTypesQuery>;
export type ListScheduleTemplatesByTypesLazyQueryHookResult = ReturnType<typeof useListScheduleTemplatesByTypesLazyQuery>;
export type ListScheduleTemplatesByTypesSuspenseQueryHookResult = ReturnType<typeof useListScheduleTemplatesByTypesSuspenseQuery>;
export type ListScheduleTemplatesByTypesQueryResult = Apollo.QueryResult<ListScheduleTemplatesByTypesQuery, ListScheduleTemplatesByTypesQueryVariables>;
export const ReadScheduleDocument = gql`
    query ReadSchedule($scheduleId: String!, $viewKey: ViewKey!) {
  readSchedule(scheduleId: $scheduleId, viewKey: $viewKey) {
    ...ScheduleFields
  }
}
    ${ScheduleFieldsFragmentDoc}`;

/**
 * __useReadScheduleQuery__
 *
 * To run a query within a React component, call `useReadScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadScheduleQuery({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useReadScheduleQuery(baseOptions: Apollo.QueryHookOptions<ReadScheduleQuery, ReadScheduleQueryVariables> & ({ variables: ReadScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadScheduleQuery, ReadScheduleQueryVariables>(ReadScheduleDocument, options);
      }
export function useReadScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadScheduleQuery, ReadScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadScheduleQuery, ReadScheduleQueryVariables>(ReadScheduleDocument, options);
        }
export function useReadScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadScheduleQuery, ReadScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadScheduleQuery, ReadScheduleQueryVariables>(ReadScheduleDocument, options);
        }
export type ReadScheduleQueryHookResult = ReturnType<typeof useReadScheduleQuery>;
export type ReadScheduleLazyQueryHookResult = ReturnType<typeof useReadScheduleLazyQuery>;
export type ReadScheduleSuspenseQueryHookResult = ReturnType<typeof useReadScheduleSuspenseQuery>;
export type ReadScheduleQueryResult = Apollo.QueryResult<ReadScheduleQuery, ReadScheduleQueryVariables>;
export const ReadScheduleCandidateDocument = gql`
    query ReadScheduleCandidate($viewKey: ViewKey!, $sourceTransactionFactId: String!) {
  readScheduleCandidate(
    viewKey: $viewKey
    sourceTransactionFactId: $sourceTransactionFactId
  ) {
    sourceTransactionFactId
    scheduleType
    scheduleTemplate {
      ...ScheduleTemplateFields
    }
    specialization {
      ...ScheduleSpecializationFields
    }
    sourceRecategorizeCategory {
      ...EntityCategoryFields
    }
  }
}
    ${ScheduleTemplateFieldsFragmentDoc}
${ScheduleSpecializationFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}`;

/**
 * __useReadScheduleCandidateQuery__
 *
 * To run a query within a React component, call `useReadScheduleCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadScheduleCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadScheduleCandidateQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      sourceTransactionFactId: // value for 'sourceTransactionFactId'
 *   },
 * });
 */
export function useReadScheduleCandidateQuery(baseOptions: Apollo.QueryHookOptions<ReadScheduleCandidateQuery, ReadScheduleCandidateQueryVariables> & ({ variables: ReadScheduleCandidateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadScheduleCandidateQuery, ReadScheduleCandidateQueryVariables>(ReadScheduleCandidateDocument, options);
      }
export function useReadScheduleCandidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadScheduleCandidateQuery, ReadScheduleCandidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadScheduleCandidateQuery, ReadScheduleCandidateQueryVariables>(ReadScheduleCandidateDocument, options);
        }
export function useReadScheduleCandidateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadScheduleCandidateQuery, ReadScheduleCandidateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadScheduleCandidateQuery, ReadScheduleCandidateQueryVariables>(ReadScheduleCandidateDocument, options);
        }
export type ReadScheduleCandidateQueryHookResult = ReturnType<typeof useReadScheduleCandidateQuery>;
export type ReadScheduleCandidateLazyQueryHookResult = ReturnType<typeof useReadScheduleCandidateLazyQuery>;
export type ReadScheduleCandidateSuspenseQueryHookResult = ReturnType<typeof useReadScheduleCandidateSuspenseQuery>;
export type ReadScheduleCandidateQueryResult = Apollo.QueryResult<ReadScheduleCandidateQuery, ReadScheduleCandidateQueryVariables>;
export const ReadScheduleDefaultsDocument = gql`
    query ReadScheduleDefaults($viewKey: ViewKey!, $scheduleTemplateId: String!, $specializationId: String, $sourceTransactionFactId: String, $recategorizedSourceCategoryId: String, $inCreateFlow: Boolean, $scheduleImportCandidateId: String) {
  readScheduleDefaults(
    viewKey: $viewKey
    scheduleTemplateId: $scheduleTemplateId
    specializationId: $specializationId
    sourceTransactionFactId: $sourceTransactionFactId
    recategorizedSourceCategoryId: $recategorizedSourceCategoryId
    inCreateFlow: $inCreateFlow
    scheduleImportCandidateId: $scheduleImportCandidateId
  ) {
    specialization {
      ...ScheduleSpecializationFields
    }
    events {
      ...ScheduleEventFields
    }
    eventTemplates {
      ...ScheduleEventTemplateFields
    }
  }
}
    ${ScheduleSpecializationFieldsFragmentDoc}
${ScheduleEventFieldsFragmentDoc}
${ScheduleEventTemplateFieldsFragmentDoc}`;

/**
 * __useReadScheduleDefaultsQuery__
 *
 * To run a query within a React component, call `useReadScheduleDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadScheduleDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadScheduleDefaultsQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      scheduleTemplateId: // value for 'scheduleTemplateId'
 *      specializationId: // value for 'specializationId'
 *      sourceTransactionFactId: // value for 'sourceTransactionFactId'
 *      recategorizedSourceCategoryId: // value for 'recategorizedSourceCategoryId'
 *      inCreateFlow: // value for 'inCreateFlow'
 *      scheduleImportCandidateId: // value for 'scheduleImportCandidateId'
 *   },
 * });
 */
export function useReadScheduleDefaultsQuery(baseOptions: Apollo.QueryHookOptions<ReadScheduleDefaultsQuery, ReadScheduleDefaultsQueryVariables> & ({ variables: ReadScheduleDefaultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadScheduleDefaultsQuery, ReadScheduleDefaultsQueryVariables>(ReadScheduleDefaultsDocument, options);
      }
export function useReadScheduleDefaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadScheduleDefaultsQuery, ReadScheduleDefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadScheduleDefaultsQuery, ReadScheduleDefaultsQueryVariables>(ReadScheduleDefaultsDocument, options);
        }
export function useReadScheduleDefaultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadScheduleDefaultsQuery, ReadScheduleDefaultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadScheduleDefaultsQuery, ReadScheduleDefaultsQueryVariables>(ReadScheduleDefaultsDocument, options);
        }
export type ReadScheduleDefaultsQueryHookResult = ReturnType<typeof useReadScheduleDefaultsQuery>;
export type ReadScheduleDefaultsLazyQueryHookResult = ReturnType<typeof useReadScheduleDefaultsLazyQuery>;
export type ReadScheduleDefaultsSuspenseQueryHookResult = ReturnType<typeof useReadScheduleDefaultsSuspenseQuery>;
export type ReadScheduleDefaultsQueryResult = Apollo.QueryResult<ReadScheduleDefaultsQuery, ReadScheduleDefaultsQueryVariables>;
export const ReadScheduleEditingHistoryDocument = gql`
    query ReadScheduleEditingHistory($legalEntityId: String!, $scheduleTemplateId: String!, $scheduleId: String!) {
  readScheduleEditingHistory(
    legalEntityId: $legalEntityId
    scheduleTemplateId: $scheduleTemplateId
    scheduleId: $scheduleId
  ) {
    user {
      ...EntityUserFields
    }
    updatedAt
    editedObjects {
      kind
      id
      action
    }
  }
}
    ${EntityUserFieldsFragmentDoc}`;

/**
 * __useReadScheduleEditingHistoryQuery__
 *
 * To run a query within a React component, call `useReadScheduleEditingHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadScheduleEditingHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadScheduleEditingHistoryQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      scheduleTemplateId: // value for 'scheduleTemplateId'
 *      scheduleId: // value for 'scheduleId'
 *   },
 * });
 */
export function useReadScheduleEditingHistoryQuery(baseOptions: Apollo.QueryHookOptions<ReadScheduleEditingHistoryQuery, ReadScheduleEditingHistoryQueryVariables> & ({ variables: ReadScheduleEditingHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadScheduleEditingHistoryQuery, ReadScheduleEditingHistoryQueryVariables>(ReadScheduleEditingHistoryDocument, options);
      }
export function useReadScheduleEditingHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadScheduleEditingHistoryQuery, ReadScheduleEditingHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadScheduleEditingHistoryQuery, ReadScheduleEditingHistoryQueryVariables>(ReadScheduleEditingHistoryDocument, options);
        }
export function useReadScheduleEditingHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadScheduleEditingHistoryQuery, ReadScheduleEditingHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadScheduleEditingHistoryQuery, ReadScheduleEditingHistoryQueryVariables>(ReadScheduleEditingHistoryDocument, options);
        }
export type ReadScheduleEditingHistoryQueryHookResult = ReturnType<typeof useReadScheduleEditingHistoryQuery>;
export type ReadScheduleEditingHistoryLazyQueryHookResult = ReturnType<typeof useReadScheduleEditingHistoryLazyQuery>;
export type ReadScheduleEditingHistorySuspenseQueryHookResult = ReturnType<typeof useReadScheduleEditingHistorySuspenseQuery>;
export type ReadScheduleEditingHistoryQueryResult = Apollo.QueryResult<ReadScheduleEditingHistoryQuery, ReadScheduleEditingHistoryQueryVariables>;
export const ReadScheduleImportCandidateDocument = gql`
    query ReadScheduleImportCandidate($viewKey: ViewKey!, $scheduleImportCandidateId: String!) {
  readScheduleImportCandidate(
    viewKey: $viewKey
    scheduleImportCandidateId: $scheduleImportCandidateId
  ) {
    scheduleImportCandidateId
    sourceTransactionFactId
    scheduleType
    scheduleTemplate {
      ...ScheduleTemplateFields
    }
    specialization {
      ...ScheduleSpecializationFields
    }
    sourceRecategorizeCategory {
      ...EntityCategoryFields
    }
    sourceTransaction {
      ...EntityTransactionFields
    }
    cutoverDate
    cutoverAmount {
      ...MonetaryValueFields
    }
  }
}
    ${ScheduleTemplateFieldsFragmentDoc}
${ScheduleSpecializationFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}
${EntityTransactionFieldsFragmentDoc}
${MonetaryValueFieldsFragmentDoc}`;

/**
 * __useReadScheduleImportCandidateQuery__
 *
 * To run a query within a React component, call `useReadScheduleImportCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadScheduleImportCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadScheduleImportCandidateQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      scheduleImportCandidateId: // value for 'scheduleImportCandidateId'
 *   },
 * });
 */
export function useReadScheduleImportCandidateQuery(baseOptions: Apollo.QueryHookOptions<ReadScheduleImportCandidateQuery, ReadScheduleImportCandidateQueryVariables> & ({ variables: ReadScheduleImportCandidateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadScheduleImportCandidateQuery, ReadScheduleImportCandidateQueryVariables>(ReadScheduleImportCandidateDocument, options);
      }
export function useReadScheduleImportCandidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadScheduleImportCandidateQuery, ReadScheduleImportCandidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadScheduleImportCandidateQuery, ReadScheduleImportCandidateQueryVariables>(ReadScheduleImportCandidateDocument, options);
        }
export function useReadScheduleImportCandidateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadScheduleImportCandidateQuery, ReadScheduleImportCandidateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadScheduleImportCandidateQuery, ReadScheduleImportCandidateQueryVariables>(ReadScheduleImportCandidateDocument, options);
        }
export type ReadScheduleImportCandidateQueryHookResult = ReturnType<typeof useReadScheduleImportCandidateQuery>;
export type ReadScheduleImportCandidateLazyQueryHookResult = ReturnType<typeof useReadScheduleImportCandidateLazyQuery>;
export type ReadScheduleImportCandidateSuspenseQueryHookResult = ReturnType<typeof useReadScheduleImportCandidateSuspenseQuery>;
export type ReadScheduleImportCandidateQueryResult = Apollo.QueryResult<ReadScheduleImportCandidateQuery, ReadScheduleImportCandidateQueryVariables>;
export const ReadSchedulePreviewDocument = gql`
    query ReadSchedulePreview($scheduleTemplateId: String!, $events: [ScheduleEventInput!]!, $viewKey: ViewKey!, $scheduleId: String, $sourceTransactionFactId: String, $recategorizedSourceCategoryId: String) {
  readSchedulePreview(
    scheduleTemplateId: $scheduleTemplateId
    events: $events
    viewKey: $viewKey
    scheduleId: $scheduleId
    sourceTransactionFactId: $sourceTransactionFactId
    recategorizedSourceCategoryId: $recategorizedSourceCategoryId
  ) {
    ...EntityTransactionFields
  }
}
    ${EntityTransactionFieldsFragmentDoc}`;

/**
 * __useReadSchedulePreviewQuery__
 *
 * To run a query within a React component, call `useReadSchedulePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadSchedulePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadSchedulePreviewQuery({
 *   variables: {
 *      scheduleTemplateId: // value for 'scheduleTemplateId'
 *      events: // value for 'events'
 *      viewKey: // value for 'viewKey'
 *      scheduleId: // value for 'scheduleId'
 *      sourceTransactionFactId: // value for 'sourceTransactionFactId'
 *      recategorizedSourceCategoryId: // value for 'recategorizedSourceCategoryId'
 *   },
 * });
 */
export function useReadSchedulePreviewQuery(baseOptions: Apollo.QueryHookOptions<ReadSchedulePreviewQuery, ReadSchedulePreviewQueryVariables> & ({ variables: ReadSchedulePreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadSchedulePreviewQuery, ReadSchedulePreviewQueryVariables>(ReadSchedulePreviewDocument, options);
      }
export function useReadSchedulePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadSchedulePreviewQuery, ReadSchedulePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadSchedulePreviewQuery, ReadSchedulePreviewQueryVariables>(ReadSchedulePreviewDocument, options);
        }
export function useReadSchedulePreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadSchedulePreviewQuery, ReadSchedulePreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadSchedulePreviewQuery, ReadSchedulePreviewQueryVariables>(ReadSchedulePreviewDocument, options);
        }
export type ReadSchedulePreviewQueryHookResult = ReturnType<typeof useReadSchedulePreviewQuery>;
export type ReadSchedulePreviewLazyQueryHookResult = ReturnType<typeof useReadSchedulePreviewLazyQuery>;
export type ReadSchedulePreviewSuspenseQueryHookResult = ReturnType<typeof useReadSchedulePreviewSuspenseQuery>;
export type ReadSchedulePreviewQueryResult = Apollo.QueryResult<ReadSchedulePreviewQuery, ReadSchedulePreviewQueryVariables>;
export const ScheduleFacetCategoryDocument = gql`
    query ScheduleFacetCategory($filter: ScheduleDashboardFilter!, $origin: IntervalOrigin!, $direction: DirectionFromOrigin!, $pagination: Pagination!) {
  scheduleFacet(
    filter: $filter
    origin: $origin
    direction: $direction
    pagination: $pagination
    field: {kind: ScheduleCategory, type: CountPerValue}
  ) {
    category {
      categoryObject {
        ...EntityCategoryFields
      }
      count
    }
  }
}
    ${EntityCategoryFieldsFragmentDoc}`;

/**
 * __useScheduleFacetCategoryQuery__
 *
 * To run a query within a React component, call `useScheduleFacetCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleFacetCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleFacetCategoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      origin: // value for 'origin'
 *      direction: // value for 'direction'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useScheduleFacetCategoryQuery(baseOptions: Apollo.QueryHookOptions<ScheduleFacetCategoryQuery, ScheduleFacetCategoryQueryVariables> & ({ variables: ScheduleFacetCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleFacetCategoryQuery, ScheduleFacetCategoryQueryVariables>(ScheduleFacetCategoryDocument, options);
      }
export function useScheduleFacetCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleFacetCategoryQuery, ScheduleFacetCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleFacetCategoryQuery, ScheduleFacetCategoryQueryVariables>(ScheduleFacetCategoryDocument, options);
        }
export function useScheduleFacetCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleFacetCategoryQuery, ScheduleFacetCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleFacetCategoryQuery, ScheduleFacetCategoryQueryVariables>(ScheduleFacetCategoryDocument, options);
        }
export type ScheduleFacetCategoryQueryHookResult = ReturnType<typeof useScheduleFacetCategoryQuery>;
export type ScheduleFacetCategoryLazyQueryHookResult = ReturnType<typeof useScheduleFacetCategoryLazyQuery>;
export type ScheduleFacetCategorySuspenseQueryHookResult = ReturnType<typeof useScheduleFacetCategorySuspenseQuery>;
export type ScheduleFacetCategoryQueryResult = Apollo.QueryResult<ScheduleFacetCategoryQuery, ScheduleFacetCategoryQueryVariables>;
export const ScheduleFacetPartyDocument = gql`
    query ScheduleFacetParty($filter: ScheduleDashboardFilter!, $origin: IntervalOrigin!, $direction: DirectionFromOrigin!, $pagination: Pagination!) {
  scheduleFacet(
    filter: $filter
    origin: $origin
    direction: $direction
    pagination: $pagination
    field: {kind: ScheduleParty, type: CountPerValue}
  ) {
    party {
      ...PartyFacetFields
    }
  }
}
    ${PartyFacetFieldsFragmentDoc}`;

/**
 * __useScheduleFacetPartyQuery__
 *
 * To run a query within a React component, call `useScheduleFacetPartyQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleFacetPartyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleFacetPartyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      origin: // value for 'origin'
 *      direction: // value for 'direction'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useScheduleFacetPartyQuery(baseOptions: Apollo.QueryHookOptions<ScheduleFacetPartyQuery, ScheduleFacetPartyQueryVariables> & ({ variables: ScheduleFacetPartyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleFacetPartyQuery, ScheduleFacetPartyQueryVariables>(ScheduleFacetPartyDocument, options);
      }
export function useScheduleFacetPartyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleFacetPartyQuery, ScheduleFacetPartyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleFacetPartyQuery, ScheduleFacetPartyQueryVariables>(ScheduleFacetPartyDocument, options);
        }
export function useScheduleFacetPartySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleFacetPartyQuery, ScheduleFacetPartyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleFacetPartyQuery, ScheduleFacetPartyQueryVariables>(ScheduleFacetPartyDocument, options);
        }
export type ScheduleFacetPartyQueryHookResult = ReturnType<typeof useScheduleFacetPartyQuery>;
export type ScheduleFacetPartyLazyQueryHookResult = ReturnType<typeof useScheduleFacetPartyLazyQuery>;
export type ScheduleFacetPartySuspenseQueryHookResult = ReturnType<typeof useScheduleFacetPartySuspenseQuery>;
export type ScheduleFacetPartyQueryResult = Apollo.QueryResult<ScheduleFacetPartyQuery, ScheduleFacetPartyQueryVariables>;
export const ScheduleFacetPartyAggregateDocument = gql`
    query ScheduleFacetPartyAggregate($filter: ScheduleDashboardFilter!, $origin: IntervalOrigin!) {
  scheduleFacet(
    filter: $filter
    origin: $origin
    direction: Past
    pagination: {limit: 1, offset: 0}
    field: {kind: ScheduleParty, type: AggregateCount}
  ) {
    aggregate
  }
}
    `;

/**
 * __useScheduleFacetPartyAggregateQuery__
 *
 * To run a query within a React component, call `useScheduleFacetPartyAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleFacetPartyAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleFacetPartyAggregateQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useScheduleFacetPartyAggregateQuery(baseOptions: Apollo.QueryHookOptions<ScheduleFacetPartyAggregateQuery, ScheduleFacetPartyAggregateQueryVariables> & ({ variables: ScheduleFacetPartyAggregateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleFacetPartyAggregateQuery, ScheduleFacetPartyAggregateQueryVariables>(ScheduleFacetPartyAggregateDocument, options);
      }
export function useScheduleFacetPartyAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleFacetPartyAggregateQuery, ScheduleFacetPartyAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleFacetPartyAggregateQuery, ScheduleFacetPartyAggregateQueryVariables>(ScheduleFacetPartyAggregateDocument, options);
        }
export function useScheduleFacetPartyAggregateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleFacetPartyAggregateQuery, ScheduleFacetPartyAggregateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleFacetPartyAggregateQuery, ScheduleFacetPartyAggregateQueryVariables>(ScheduleFacetPartyAggregateDocument, options);
        }
export type ScheduleFacetPartyAggregateQueryHookResult = ReturnType<typeof useScheduleFacetPartyAggregateQuery>;
export type ScheduleFacetPartyAggregateLazyQueryHookResult = ReturnType<typeof useScheduleFacetPartyAggregateLazyQuery>;
export type ScheduleFacetPartyAggregateSuspenseQueryHookResult = ReturnType<typeof useScheduleFacetPartyAggregateSuspenseQuery>;
export type ScheduleFacetPartyAggregateQueryResult = Apollo.QueryResult<ScheduleFacetPartyAggregateQuery, ScheduleFacetPartyAggregateQueryVariables>;
export const ScheduleFacetRelatedCategoryDocument = gql`
    query ScheduleFacetRelatedCategory($filter: ScheduleDashboardFilter!, $origin: IntervalOrigin!, $direction: DirectionFromOrigin!, $pagination: Pagination!) {
  scheduleFacet(
    filter: $filter
    origin: $origin
    direction: $direction
    pagination: $pagination
    field: {kind: ScheduleRelatedCategory, type: CountPerValue}
  ) {
    relatedCategory {
      categoryObject {
        ...EntityCategoryFields
      }
      count
    }
  }
}
    ${EntityCategoryFieldsFragmentDoc}`;

/**
 * __useScheduleFacetRelatedCategoryQuery__
 *
 * To run a query within a React component, call `useScheduleFacetRelatedCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleFacetRelatedCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleFacetRelatedCategoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      origin: // value for 'origin'
 *      direction: // value for 'direction'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useScheduleFacetRelatedCategoryQuery(baseOptions: Apollo.QueryHookOptions<ScheduleFacetRelatedCategoryQuery, ScheduleFacetRelatedCategoryQueryVariables> & ({ variables: ScheduleFacetRelatedCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleFacetRelatedCategoryQuery, ScheduleFacetRelatedCategoryQueryVariables>(ScheduleFacetRelatedCategoryDocument, options);
      }
export function useScheduleFacetRelatedCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleFacetRelatedCategoryQuery, ScheduleFacetRelatedCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleFacetRelatedCategoryQuery, ScheduleFacetRelatedCategoryQueryVariables>(ScheduleFacetRelatedCategoryDocument, options);
        }
export function useScheduleFacetRelatedCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScheduleFacetRelatedCategoryQuery, ScheduleFacetRelatedCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScheduleFacetRelatedCategoryQuery, ScheduleFacetRelatedCategoryQueryVariables>(ScheduleFacetRelatedCategoryDocument, options);
        }
export type ScheduleFacetRelatedCategoryQueryHookResult = ReturnType<typeof useScheduleFacetRelatedCategoryQuery>;
export type ScheduleFacetRelatedCategoryLazyQueryHookResult = ReturnType<typeof useScheduleFacetRelatedCategoryLazyQuery>;
export type ScheduleFacetRelatedCategorySuspenseQueryHookResult = ReturnType<typeof useScheduleFacetRelatedCategorySuspenseQuery>;
export type ScheduleFacetRelatedCategoryQueryResult = Apollo.QueryResult<ScheduleFacetRelatedCategoryQuery, ScheduleFacetRelatedCategoryQueryVariables>;
export const SearchEntitiesDocument = gql`
    query SearchEntities($legalEntityId: String!, $viewVersion: String, $viewType: ViewType, $text: String!, $offset: Int!, $limit: Int!, $kind: ObjectKind!, $sort: [SearchEntitiesSort!], $occurredBefore: Float, $occurredAfter: Float, $sortHitsLeftmost: Boolean) {
  search: searchEntities(
    legalEntityId: $legalEntityId
    viewVersion: $viewVersion
    viewType: $viewType
    text: $text
    kind: $kind
    sort: $sort
    occurredBefore: $occurredBefore
    occurredAfter: $occurredAfter
    sortHitsLeftmost: $sortHitsLeftmost
    page: {offset: $offset, limit: $limit}
  ) {
    ...SearchResultFields
  }
}
    ${SearchResultFieldsFragmentDoc}`;

/**
 * __useSearchEntitiesQuery__
 *
 * To run a query within a React component, call `useSearchEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEntitiesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      viewVersion: // value for 'viewVersion'
 *      viewType: // value for 'viewType'
 *      text: // value for 'text'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      kind: // value for 'kind'
 *      sort: // value for 'sort'
 *      occurredBefore: // value for 'occurredBefore'
 *      occurredAfter: // value for 'occurredAfter'
 *      sortHitsLeftmost: // value for 'sortHitsLeftmost'
 *   },
 * });
 */
export function useSearchEntitiesQuery(baseOptions: Apollo.QueryHookOptions<SearchEntitiesQuery, SearchEntitiesQueryVariables> & ({ variables: SearchEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEntitiesQuery, SearchEntitiesQueryVariables>(SearchEntitiesDocument, options);
      }
export function useSearchEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEntitiesQuery, SearchEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEntitiesQuery, SearchEntitiesQueryVariables>(SearchEntitiesDocument, options);
        }
export function useSearchEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchEntitiesQuery, SearchEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchEntitiesQuery, SearchEntitiesQueryVariables>(SearchEntitiesDocument, options);
        }
export type SearchEntitiesQueryHookResult = ReturnType<typeof useSearchEntitiesQuery>;
export type SearchEntitiesLazyQueryHookResult = ReturnType<typeof useSearchEntitiesLazyQuery>;
export type SearchEntitiesSuspenseQueryHookResult = ReturnType<typeof useSearchEntitiesSuspenseQuery>;
export type SearchEntitiesQueryResult = Apollo.QueryResult<SearchEntitiesQuery, SearchEntitiesQueryVariables>;
export const SearchGlobalPartiesDocument = gql`
    query SearchGlobalParties($viewType: ViewType, $text: String!, $offset: Int!, $limit: Int!, $sort: [SearchEntitiesSort!], $sortHitsLeftmost: Boolean) {
  search: searchGlobalParties(
    viewType: $viewType
    text: $text
    sort: $sort
    sortHitsLeftmost: $sortHitsLeftmost
    page: {offset: $offset, limit: $limit}
  ) {
    ...SearchResultFields
  }
}
    ${SearchResultFieldsFragmentDoc}`;

/**
 * __useSearchGlobalPartiesQuery__
 *
 * To run a query within a React component, call `useSearchGlobalPartiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchGlobalPartiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchGlobalPartiesQuery({
 *   variables: {
 *      viewType: // value for 'viewType'
 *      text: // value for 'text'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortHitsLeftmost: // value for 'sortHitsLeftmost'
 *   },
 * });
 */
export function useSearchGlobalPartiesQuery(baseOptions: Apollo.QueryHookOptions<SearchGlobalPartiesQuery, SearchGlobalPartiesQueryVariables> & ({ variables: SearchGlobalPartiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchGlobalPartiesQuery, SearchGlobalPartiesQueryVariables>(SearchGlobalPartiesDocument, options);
      }
export function useSearchGlobalPartiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchGlobalPartiesQuery, SearchGlobalPartiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchGlobalPartiesQuery, SearchGlobalPartiesQueryVariables>(SearchGlobalPartiesDocument, options);
        }
export function useSearchGlobalPartiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchGlobalPartiesQuery, SearchGlobalPartiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchGlobalPartiesQuery, SearchGlobalPartiesQueryVariables>(SearchGlobalPartiesDocument, options);
        }
export type SearchGlobalPartiesQueryHookResult = ReturnType<typeof useSearchGlobalPartiesQuery>;
export type SearchGlobalPartiesLazyQueryHookResult = ReturnType<typeof useSearchGlobalPartiesLazyQuery>;
export type SearchGlobalPartiesSuspenseQueryHookResult = ReturnType<typeof useSearchGlobalPartiesSuspenseQuery>;
export type SearchGlobalPartiesQueryResult = Apollo.QueryResult<SearchGlobalPartiesQuery, SearchGlobalPartiesQueryVariables>;
export const SearchTermsDocument = gql`
    query SearchTerms($legalEntityId: String!, $viewVersion: String, $viewType: ViewType, $text: String!, $kinds: [ObjectKind!], $sort: [SearchEntitiesSort!]) {
  searchTerms(
    legalEntityId: $legalEntityId
    viewVersion: $viewVersion
    viewType: $viewType
    text: $text
    kinds: $kinds
    sort: $sort
  ) {
    ...SearchResultFields
  }
}
    ${SearchResultFieldsFragmentDoc}`;

/**
 * __useSearchTermsQuery__
 *
 * To run a query within a React component, call `useSearchTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTermsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      viewVersion: // value for 'viewVersion'
 *      viewType: // value for 'viewType'
 *      text: // value for 'text'
 *      kinds: // value for 'kinds'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchTermsQuery(baseOptions: Apollo.QueryHookOptions<SearchTermsQuery, SearchTermsQueryVariables> & ({ variables: SearchTermsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTermsQuery, SearchTermsQueryVariables>(SearchTermsDocument, options);
      }
export function useSearchTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTermsQuery, SearchTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTermsQuery, SearchTermsQueryVariables>(SearchTermsDocument, options);
        }
export function useSearchTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTermsQuery, SearchTermsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTermsQuery, SearchTermsQueryVariables>(SearchTermsDocument, options);
        }
export type SearchTermsQueryHookResult = ReturnType<typeof useSearchTermsQuery>;
export type SearchTermsLazyQueryHookResult = ReturnType<typeof useSearchTermsLazyQuery>;
export type SearchTermsSuspenseQueryHookResult = ReturnType<typeof useSearchTermsSuspenseQuery>;
export type SearchTermsQueryResult = Apollo.QueryResult<SearchTermsQuery, SearchTermsQueryVariables>;
export const ListActionItemsBadgeCountsDocument = gql`
    query ListActionItemsBadgeCounts($direction: DirectionFromOrigin, $filter: ActionItemFilter!, $legalEntityIds: [String!], $legalEntities: [LegalEntityPermission], $origin: IntervalOrigin!) {
  listActionItemsBadgeCounts(
    direction: $direction
    origin: $origin
    legalEntityIds: $legalEntityIds
    legalEntities: $legalEntities
    filter: $filter
  ) {
    ...LegalEntityBadgeCountFields
  }
}
    ${LegalEntityBadgeCountFieldsFragmentDoc}`;

/**
 * __useListActionItemsBadgeCountsQuery__
 *
 * To run a query within a React component, call `useListActionItemsBadgeCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActionItemsBadgeCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActionItemsBadgeCountsQuery({
 *   variables: {
 *      direction: // value for 'direction'
 *      filter: // value for 'filter'
 *      legalEntityIds: // value for 'legalEntityIds'
 *      legalEntities: // value for 'legalEntities'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useListActionItemsBadgeCountsQuery(baseOptions: Apollo.QueryHookOptions<ListActionItemsBadgeCountsQuery, ListActionItemsBadgeCountsQueryVariables> & ({ variables: ListActionItemsBadgeCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListActionItemsBadgeCountsQuery, ListActionItemsBadgeCountsQueryVariables>(ListActionItemsBadgeCountsDocument, options);
      }
export function useListActionItemsBadgeCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListActionItemsBadgeCountsQuery, ListActionItemsBadgeCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListActionItemsBadgeCountsQuery, ListActionItemsBadgeCountsQueryVariables>(ListActionItemsBadgeCountsDocument, options);
        }
export function useListActionItemsBadgeCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListActionItemsBadgeCountsQuery, ListActionItemsBadgeCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListActionItemsBadgeCountsQuery, ListActionItemsBadgeCountsQueryVariables>(ListActionItemsBadgeCountsDocument, options);
        }
export type ListActionItemsBadgeCountsQueryHookResult = ReturnType<typeof useListActionItemsBadgeCountsQuery>;
export type ListActionItemsBadgeCountsLazyQueryHookResult = ReturnType<typeof useListActionItemsBadgeCountsLazyQuery>;
export type ListActionItemsBadgeCountsSuspenseQueryHookResult = ReturnType<typeof useListActionItemsBadgeCountsSuspenseQuery>;
export type ListActionItemsBadgeCountsQueryResult = Apollo.QueryResult<ListActionItemsBadgeCountsQuery, ListActionItemsBadgeCountsQueryVariables>;
export const ListBoostBadgeCountsDocument = gql`
    query ListBoostBadgeCounts($direction: DirectionFromOrigin!, $filter: WorkItemBadgeCountFilter!, $origin: IntervalOrigin!) {
  listBoostBadgeCounts(direction: $direction, origin: $origin, filter: $filter) {
    ...LegalEntityBadgeCountFields
  }
}
    ${LegalEntityBadgeCountFieldsFragmentDoc}`;

/**
 * __useListBoostBadgeCountsQuery__
 *
 * To run a query within a React component, call `useListBoostBadgeCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBoostBadgeCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBoostBadgeCountsQuery({
 *   variables: {
 *      direction: // value for 'direction'
 *      filter: // value for 'filter'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useListBoostBadgeCountsQuery(baseOptions: Apollo.QueryHookOptions<ListBoostBadgeCountsQuery, ListBoostBadgeCountsQueryVariables> & ({ variables: ListBoostBadgeCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListBoostBadgeCountsQuery, ListBoostBadgeCountsQueryVariables>(ListBoostBadgeCountsDocument, options);
      }
export function useListBoostBadgeCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListBoostBadgeCountsQuery, ListBoostBadgeCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListBoostBadgeCountsQuery, ListBoostBadgeCountsQueryVariables>(ListBoostBadgeCountsDocument, options);
        }
export function useListBoostBadgeCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListBoostBadgeCountsQuery, ListBoostBadgeCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListBoostBadgeCountsQuery, ListBoostBadgeCountsQueryVariables>(ListBoostBadgeCountsDocument, options);
        }
export type ListBoostBadgeCountsQueryHookResult = ReturnType<typeof useListBoostBadgeCountsQuery>;
export type ListBoostBadgeCountsLazyQueryHookResult = ReturnType<typeof useListBoostBadgeCountsLazyQuery>;
export type ListBoostBadgeCountsSuspenseQueryHookResult = ReturnType<typeof useListBoostBadgeCountsSuspenseQuery>;
export type ListBoostBadgeCountsQueryResult = Apollo.QueryResult<ListBoostBadgeCountsQuery, ListBoostBadgeCountsQueryVariables>;
export const ListConnectionBadgeCountsDocument = gql`
    query ListConnectionBadgeCounts($filter: ConnectionBadgeCountFilter!) {
  listConnectionBadgeCounts(filter: $filter) {
    ...LegalEntityBadgeCountFields
  }
}
    ${LegalEntityBadgeCountFieldsFragmentDoc}`;

/**
 * __useListConnectionBadgeCountsQuery__
 *
 * To run a query within a React component, call `useListConnectionBadgeCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConnectionBadgeCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConnectionBadgeCountsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListConnectionBadgeCountsQuery(baseOptions: Apollo.QueryHookOptions<ListConnectionBadgeCountsQuery, ListConnectionBadgeCountsQueryVariables> & ({ variables: ListConnectionBadgeCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConnectionBadgeCountsQuery, ListConnectionBadgeCountsQueryVariables>(ListConnectionBadgeCountsDocument, options);
      }
export function useListConnectionBadgeCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConnectionBadgeCountsQuery, ListConnectionBadgeCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConnectionBadgeCountsQuery, ListConnectionBadgeCountsQueryVariables>(ListConnectionBadgeCountsDocument, options);
        }
export function useListConnectionBadgeCountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListConnectionBadgeCountsQuery, ListConnectionBadgeCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListConnectionBadgeCountsQuery, ListConnectionBadgeCountsQueryVariables>(ListConnectionBadgeCountsDocument, options);
        }
export type ListConnectionBadgeCountsQueryHookResult = ReturnType<typeof useListConnectionBadgeCountsQuery>;
export type ListConnectionBadgeCountsLazyQueryHookResult = ReturnType<typeof useListConnectionBadgeCountsLazyQuery>;
export type ListConnectionBadgeCountsSuspenseQueryHookResult = ReturnType<typeof useListConnectionBadgeCountsSuspenseQuery>;
export type ListConnectionBadgeCountsQueryResult = Apollo.QueryResult<ListConnectionBadgeCountsQuery, ListConnectionBadgeCountsQueryVariables>;
export const ListAccountantSuggestedUsersDocument = gql`
    query ListAccountantSuggestedUsers($organizationId: String!, $identifier: InputObjectIdentifier!) {
  listAccountantSuggestedUsers(
    organizationId: $organizationId
    object: $identifier
  ) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useListAccountantSuggestedUsersQuery__
 *
 * To run a query within a React component, call `useListAccountantSuggestedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAccountantSuggestedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAccountantSuggestedUsersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useListAccountantSuggestedUsersQuery(baseOptions: Apollo.QueryHookOptions<ListAccountantSuggestedUsersQuery, ListAccountantSuggestedUsersQueryVariables> & ({ variables: ListAccountantSuggestedUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAccountantSuggestedUsersQuery, ListAccountantSuggestedUsersQueryVariables>(ListAccountantSuggestedUsersDocument, options);
      }
export function useListAccountantSuggestedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAccountantSuggestedUsersQuery, ListAccountantSuggestedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAccountantSuggestedUsersQuery, ListAccountantSuggestedUsersQueryVariables>(ListAccountantSuggestedUsersDocument, options);
        }
export function useListAccountantSuggestedUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAccountantSuggestedUsersQuery, ListAccountantSuggestedUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAccountantSuggestedUsersQuery, ListAccountantSuggestedUsersQueryVariables>(ListAccountantSuggestedUsersDocument, options);
        }
export type ListAccountantSuggestedUsersQueryHookResult = ReturnType<typeof useListAccountantSuggestedUsersQuery>;
export type ListAccountantSuggestedUsersLazyQueryHookResult = ReturnType<typeof useListAccountantSuggestedUsersLazyQuery>;
export type ListAccountantSuggestedUsersSuspenseQueryHookResult = ReturnType<typeof useListAccountantSuggestedUsersSuspenseQuery>;
export type ListAccountantSuggestedUsersQueryResult = Apollo.QueryResult<ListAccountantSuggestedUsersQuery, ListAccountantSuggestedUsersQueryVariables>;
export const ListLimitedSuggestedUsersDocument = gql`
    query ListLimitedSuggestedUsers($identifier: InputObjectIdentifier!) {
  listLimitedSuggestedUsers(object: $identifier) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useListLimitedSuggestedUsersQuery__
 *
 * To run a query within a React component, call `useListLimitedSuggestedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLimitedSuggestedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLimitedSuggestedUsersQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useListLimitedSuggestedUsersQuery(baseOptions: Apollo.QueryHookOptions<ListLimitedSuggestedUsersQuery, ListLimitedSuggestedUsersQueryVariables> & ({ variables: ListLimitedSuggestedUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLimitedSuggestedUsersQuery, ListLimitedSuggestedUsersQueryVariables>(ListLimitedSuggestedUsersDocument, options);
      }
export function useListLimitedSuggestedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLimitedSuggestedUsersQuery, ListLimitedSuggestedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLimitedSuggestedUsersQuery, ListLimitedSuggestedUsersQueryVariables>(ListLimitedSuggestedUsersDocument, options);
        }
export function useListLimitedSuggestedUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLimitedSuggestedUsersQuery, ListLimitedSuggestedUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLimitedSuggestedUsersQuery, ListLimitedSuggestedUsersQueryVariables>(ListLimitedSuggestedUsersDocument, options);
        }
export type ListLimitedSuggestedUsersQueryHookResult = ReturnType<typeof useListLimitedSuggestedUsersQuery>;
export type ListLimitedSuggestedUsersLazyQueryHookResult = ReturnType<typeof useListLimitedSuggestedUsersLazyQuery>;
export type ListLimitedSuggestedUsersSuspenseQueryHookResult = ReturnType<typeof useListLimitedSuggestedUsersSuspenseQuery>;
export type ListLimitedSuggestedUsersQueryResult = Apollo.QueryResult<ListLimitedSuggestedUsersQuery, ListLimitedSuggestedUsersQueryVariables>;
export const ListShareSuggestedUsersDocument = gql`
    query ListShareSuggestedUsers($legalEntityId: String!) {
  listShareSuggestedUsers(legalEntityId: $legalEntityId) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useListShareSuggestedUsersQuery__
 *
 * To run a query within a React component, call `useListShareSuggestedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListShareSuggestedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListShareSuggestedUsersQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useListShareSuggestedUsersQuery(baseOptions: Apollo.QueryHookOptions<ListShareSuggestedUsersQuery, ListShareSuggestedUsersQueryVariables> & ({ variables: ListShareSuggestedUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListShareSuggestedUsersQuery, ListShareSuggestedUsersQueryVariables>(ListShareSuggestedUsersDocument, options);
      }
export function useListShareSuggestedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListShareSuggestedUsersQuery, ListShareSuggestedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListShareSuggestedUsersQuery, ListShareSuggestedUsersQueryVariables>(ListShareSuggestedUsersDocument, options);
        }
export function useListShareSuggestedUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListShareSuggestedUsersQuery, ListShareSuggestedUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListShareSuggestedUsersQuery, ListShareSuggestedUsersQueryVariables>(ListShareSuggestedUsersDocument, options);
        }
export type ListShareSuggestedUsersQueryHookResult = ReturnType<typeof useListShareSuggestedUsersQuery>;
export type ListShareSuggestedUsersLazyQueryHookResult = ReturnType<typeof useListShareSuggestedUsersLazyQuery>;
export type ListShareSuggestedUsersSuspenseQueryHookResult = ReturnType<typeof useListShareSuggestedUsersSuspenseQuery>;
export type ListShareSuggestedUsersQueryResult = Apollo.QueryResult<ListShareSuggestedUsersQuery, ListShareSuggestedUsersQueryVariables>;
export const ListSuggestedUsersDocument = gql`
    query ListSuggestedUsers($organizationId: String!, $identifier: InputObjectIdentifier!) {
  listSuggestedUsers(organizationId: $organizationId, object: $identifier) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useListSuggestedUsersQuery__
 *
 * To run a query within a React component, call `useListSuggestedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSuggestedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSuggestedUsersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useListSuggestedUsersQuery(baseOptions: Apollo.QueryHookOptions<ListSuggestedUsersQuery, ListSuggestedUsersQueryVariables> & ({ variables: ListSuggestedUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSuggestedUsersQuery, ListSuggestedUsersQueryVariables>(ListSuggestedUsersDocument, options);
      }
export function useListSuggestedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSuggestedUsersQuery, ListSuggestedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSuggestedUsersQuery, ListSuggestedUsersQueryVariables>(ListSuggestedUsersDocument, options);
        }
export function useListSuggestedUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSuggestedUsersQuery, ListSuggestedUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSuggestedUsersQuery, ListSuggestedUsersQueryVariables>(ListSuggestedUsersDocument, options);
        }
export type ListSuggestedUsersQueryHookResult = ReturnType<typeof useListSuggestedUsersQuery>;
export type ListSuggestedUsersLazyQueryHookResult = ReturnType<typeof useListSuggestedUsersLazyQuery>;
export type ListSuggestedUsersSuspenseQueryHookResult = ReturnType<typeof useListSuggestedUsersSuspenseQuery>;
export type ListSuggestedUsersQueryResult = Apollo.QueryResult<ListSuggestedUsersQuery, ListSuggestedUsersQueryVariables>;
export const MatchTransactionsDocument = gql`
    mutation MatchTransactions($legalEntityId: String!, $ledgerTransactionIds: [String!]!) {
  matchTransactions(
    legalEntityId: $legalEntityId
    ledgerTransactionIds: $ledgerTransactionIds
  )
}
    `;
export type MatchTransactionsMutationFn = Apollo.MutationFunction<MatchTransactionsMutation, MatchTransactionsMutationVariables>;

/**
 * __useMatchTransactionsMutation__
 *
 * To run a mutation, you first call `useMatchTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMatchTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [matchTransactionsMutation, { data, loading, error }] = useMatchTransactionsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      ledgerTransactionIds: // value for 'ledgerTransactionIds'
 *   },
 * });
 */
export function useMatchTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<MatchTransactionsMutation, MatchTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MatchTransactionsMutation, MatchTransactionsMutationVariables>(MatchTransactionsDocument, options);
      }
export type MatchTransactionsMutationHookResult = ReturnType<typeof useMatchTransactionsMutation>;
export type MatchTransactionsMutationResult = Apollo.MutationResult<MatchTransactionsMutation>;
export type MatchTransactionsMutationOptions = Apollo.BaseMutationOptions<MatchTransactionsMutation, MatchTransactionsMutationVariables>;
export const UnmatchTransactionsDocument = gql`
    mutation UnmatchTransactions($legalEntityId: String!, $ledgerTransactionIds: [String!]!) {
  unmatchTransactions(
    legalEntityId: $legalEntityId
    ledgerTransactionIds: $ledgerTransactionIds
  )
}
    `;
export type UnmatchTransactionsMutationFn = Apollo.MutationFunction<UnmatchTransactionsMutation, UnmatchTransactionsMutationVariables>;

/**
 * __useUnmatchTransactionsMutation__
 *
 * To run a mutation, you first call `useUnmatchTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnmatchTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unmatchTransactionsMutation, { data, loading, error }] = useUnmatchTransactionsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      ledgerTransactionIds: // value for 'ledgerTransactionIds'
 *   },
 * });
 */
export function useUnmatchTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<UnmatchTransactionsMutation, UnmatchTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnmatchTransactionsMutation, UnmatchTransactionsMutationVariables>(UnmatchTransactionsDocument, options);
      }
export type UnmatchTransactionsMutationHookResult = ReturnType<typeof useUnmatchTransactionsMutation>;
export type UnmatchTransactionsMutationResult = Apollo.MutationResult<UnmatchTransactionsMutation>;
export type UnmatchTransactionsMutationOptions = Apollo.BaseMutationOptions<UnmatchTransactionsMutation, UnmatchTransactionsMutationVariables>;
export const SendTransactionReviewReminderDocument = gql`
    mutation SendTransactionReviewReminder($legalEntityId: String!, $message: String!) {
  sendTransactionReviewReminder(legalEntityId: $legalEntityId, message: $message)
}
    `;
export type SendTransactionReviewReminderMutationFn = Apollo.MutationFunction<SendTransactionReviewReminderMutation, SendTransactionReviewReminderMutationVariables>;

/**
 * __useSendTransactionReviewReminderMutation__
 *
 * To run a mutation, you first call `useSendTransactionReviewReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTransactionReviewReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTransactionReviewReminderMutation, { data, loading, error }] = useSendTransactionReviewReminderMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendTransactionReviewReminderMutation(baseOptions?: Apollo.MutationHookOptions<SendTransactionReviewReminderMutation, SendTransactionReviewReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTransactionReviewReminderMutation, SendTransactionReviewReminderMutationVariables>(SendTransactionReviewReminderDocument, options);
      }
export type SendTransactionReviewReminderMutationHookResult = ReturnType<typeof useSendTransactionReviewReminderMutation>;
export type SendTransactionReviewReminderMutationResult = Apollo.MutationResult<SendTransactionReviewReminderMutation>;
export type SendTransactionReviewReminderMutationOptions = Apollo.BaseMutationOptions<SendTransactionReviewReminderMutation, SendTransactionReviewReminderMutationVariables>;
export const UpdateTransactionReviewReminderMessageDocument = gql`
    mutation UpdateTransactionReviewReminderMessage($legalEntityId: String!, $message: String!) {
  updateTransactionReviewReminderMessage(
    legalEntityId: $legalEntityId
    message: $message
  )
}
    `;
export type UpdateTransactionReviewReminderMessageMutationFn = Apollo.MutationFunction<UpdateTransactionReviewReminderMessageMutation, UpdateTransactionReviewReminderMessageMutationVariables>;

/**
 * __useUpdateTransactionReviewReminderMessageMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionReviewReminderMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionReviewReminderMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionReviewReminderMessageMutation, { data, loading, error }] = useUpdateTransactionReviewReminderMessageMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useUpdateTransactionReviewReminderMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionReviewReminderMessageMutation, UpdateTransactionReviewReminderMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionReviewReminderMessageMutation, UpdateTransactionReviewReminderMessageMutationVariables>(UpdateTransactionReviewReminderMessageDocument, options);
      }
export type UpdateTransactionReviewReminderMessageMutationHookResult = ReturnType<typeof useUpdateTransactionReviewReminderMessageMutation>;
export type UpdateTransactionReviewReminderMessageMutationResult = Apollo.MutationResult<UpdateTransactionReviewReminderMessageMutation>;
export type UpdateTransactionReviewReminderMessageMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionReviewReminderMessageMutation, UpdateTransactionReviewReminderMessageMutationVariables>;
export const UpdateTransactionReviewScheduleDocument = gql`
    mutation UpdateTransactionReviewSchedule($legalEntityId: String!, $daysOfWeek: [DayOfWeek!], $daysOfMonth: [DayOfMonth!], $enabled: Boolean!) {
  updateTransactionReviewSchedule(
    legalEntityId: $legalEntityId
    daysOfWeek: $daysOfWeek
    daysOfMonth: $daysOfMonth
    enabled: $enabled
  )
}
    `;
export type UpdateTransactionReviewScheduleMutationFn = Apollo.MutationFunction<UpdateTransactionReviewScheduleMutation, UpdateTransactionReviewScheduleMutationVariables>;

/**
 * __useUpdateTransactionReviewScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionReviewScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionReviewScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionReviewScheduleMutation, { data, loading, error }] = useUpdateTransactionReviewScheduleMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      daysOfWeek: // value for 'daysOfWeek'
 *      daysOfMonth: // value for 'daysOfMonth'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateTransactionReviewScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionReviewScheduleMutation, UpdateTransactionReviewScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionReviewScheduleMutation, UpdateTransactionReviewScheduleMutationVariables>(UpdateTransactionReviewScheduleDocument, options);
      }
export type UpdateTransactionReviewScheduleMutationHookResult = ReturnType<typeof useUpdateTransactionReviewScheduleMutation>;
export type UpdateTransactionReviewScheduleMutationResult = Apollo.MutationResult<UpdateTransactionReviewScheduleMutation>;
export type UpdateTransactionReviewScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionReviewScheduleMutation, UpdateTransactionReviewScheduleMutationVariables>;
export const ReadTransactionReviewNextReminderDocument = gql`
    query ReadTransactionReviewNextReminder($legalEntityId: String!) {
  readTransactionReviewNextReminder(legalEntityId: $legalEntityId)
}
    `;

/**
 * __useReadTransactionReviewNextReminderQuery__
 *
 * To run a query within a React component, call `useReadTransactionReviewNextReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadTransactionReviewNextReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadTransactionReviewNextReminderQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadTransactionReviewNextReminderQuery(baseOptions: Apollo.QueryHookOptions<ReadTransactionReviewNextReminderQuery, ReadTransactionReviewNextReminderQueryVariables> & ({ variables: ReadTransactionReviewNextReminderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadTransactionReviewNextReminderQuery, ReadTransactionReviewNextReminderQueryVariables>(ReadTransactionReviewNextReminderDocument, options);
      }
export function useReadTransactionReviewNextReminderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadTransactionReviewNextReminderQuery, ReadTransactionReviewNextReminderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadTransactionReviewNextReminderQuery, ReadTransactionReviewNextReminderQueryVariables>(ReadTransactionReviewNextReminderDocument, options);
        }
export function useReadTransactionReviewNextReminderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadTransactionReviewNextReminderQuery, ReadTransactionReviewNextReminderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadTransactionReviewNextReminderQuery, ReadTransactionReviewNextReminderQueryVariables>(ReadTransactionReviewNextReminderDocument, options);
        }
export type ReadTransactionReviewNextReminderQueryHookResult = ReturnType<typeof useReadTransactionReviewNextReminderQuery>;
export type ReadTransactionReviewNextReminderLazyQueryHookResult = ReturnType<typeof useReadTransactionReviewNextReminderLazyQuery>;
export type ReadTransactionReviewNextReminderSuspenseQueryHookResult = ReturnType<typeof useReadTransactionReviewNextReminderSuspenseQuery>;
export type ReadTransactionReviewNextReminderQueryResult = Apollo.QueryResult<ReadTransactionReviewNextReminderQuery, ReadTransactionReviewNextReminderQueryVariables>;
export const ReadTransactionReviewReminderMessageDocument = gql`
    query ReadTransactionReviewReminderMessage($legalEntityId: String!) {
  readTransactionReviewReminderMessage(legalEntityId: $legalEntityId) {
    ...TransactionReviewReminderMessageFields
  }
}
    ${TransactionReviewReminderMessageFieldsFragmentDoc}`;

/**
 * __useReadTransactionReviewReminderMessageQuery__
 *
 * To run a query within a React component, call `useReadTransactionReviewReminderMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadTransactionReviewReminderMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadTransactionReviewReminderMessageQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadTransactionReviewReminderMessageQuery(baseOptions: Apollo.QueryHookOptions<ReadTransactionReviewReminderMessageQuery, ReadTransactionReviewReminderMessageQueryVariables> & ({ variables: ReadTransactionReviewReminderMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadTransactionReviewReminderMessageQuery, ReadTransactionReviewReminderMessageQueryVariables>(ReadTransactionReviewReminderMessageDocument, options);
      }
export function useReadTransactionReviewReminderMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadTransactionReviewReminderMessageQuery, ReadTransactionReviewReminderMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadTransactionReviewReminderMessageQuery, ReadTransactionReviewReminderMessageQueryVariables>(ReadTransactionReviewReminderMessageDocument, options);
        }
export function useReadTransactionReviewReminderMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadTransactionReviewReminderMessageQuery, ReadTransactionReviewReminderMessageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadTransactionReviewReminderMessageQuery, ReadTransactionReviewReminderMessageQueryVariables>(ReadTransactionReviewReminderMessageDocument, options);
        }
export type ReadTransactionReviewReminderMessageQueryHookResult = ReturnType<typeof useReadTransactionReviewReminderMessageQuery>;
export type ReadTransactionReviewReminderMessageLazyQueryHookResult = ReturnType<typeof useReadTransactionReviewReminderMessageLazyQuery>;
export type ReadTransactionReviewReminderMessageSuspenseQueryHookResult = ReturnType<typeof useReadTransactionReviewReminderMessageSuspenseQuery>;
export type ReadTransactionReviewReminderMessageQueryResult = Apollo.QueryResult<ReadTransactionReviewReminderMessageQuery, ReadTransactionReviewReminderMessageQueryVariables>;
export const ReadTransactionReviewScheduleDocument = gql`
    query ReadTransactionReviewSchedule($legalEntityId: String!) {
  readTransactionReviewSchedule(legalEntityId: $legalEntityId) {
    ...TransactionReviewScheduleFields
  }
}
    ${TransactionReviewScheduleFieldsFragmentDoc}`;

/**
 * __useReadTransactionReviewScheduleQuery__
 *
 * To run a query within a React component, call `useReadTransactionReviewScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadTransactionReviewScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadTransactionReviewScheduleQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadTransactionReviewScheduleQuery(baseOptions: Apollo.QueryHookOptions<ReadTransactionReviewScheduleQuery, ReadTransactionReviewScheduleQueryVariables> & ({ variables: ReadTransactionReviewScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadTransactionReviewScheduleQuery, ReadTransactionReviewScheduleQueryVariables>(ReadTransactionReviewScheduleDocument, options);
      }
export function useReadTransactionReviewScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadTransactionReviewScheduleQuery, ReadTransactionReviewScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadTransactionReviewScheduleQuery, ReadTransactionReviewScheduleQueryVariables>(ReadTransactionReviewScheduleDocument, options);
        }
export function useReadTransactionReviewScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadTransactionReviewScheduleQuery, ReadTransactionReviewScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadTransactionReviewScheduleQuery, ReadTransactionReviewScheduleQueryVariables>(ReadTransactionReviewScheduleDocument, options);
        }
export type ReadTransactionReviewScheduleQueryHookResult = ReturnType<typeof useReadTransactionReviewScheduleQuery>;
export type ReadTransactionReviewScheduleLazyQueryHookResult = ReturnType<typeof useReadTransactionReviewScheduleLazyQuery>;
export type ReadTransactionReviewScheduleSuspenseQueryHookResult = ReturnType<typeof useReadTransactionReviewScheduleSuspenseQuery>;
export type ReadTransactionReviewScheduleQueryResult = Apollo.QueryResult<ReadTransactionReviewScheduleQuery, ReadTransactionReviewScheduleQueryVariables>;
export const CreateSupersedingTransactionDocument = gql`
    mutation CreateSupersedingTransaction($legalEntityId: String!, $supersededLedgerTransactionIds: [String!]!, $transaction: InputTransaction!) {
  createSupersedingTransaction(
    legalEntityId: $legalEntityId
    transaction: $transaction
    supersededLedgerTransactionIds: $supersededLedgerTransactionIds
  ) {
    transactionFactIds
  }
}
    `;
export type CreateSupersedingTransactionMutationFn = Apollo.MutationFunction<CreateSupersedingTransactionMutation, CreateSupersedingTransactionMutationVariables>;

/**
 * __useCreateSupersedingTransactionMutation__
 *
 * To run a mutation, you first call `useCreateSupersedingTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupersedingTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupersedingTransactionMutation, { data, loading, error }] = useCreateSupersedingTransactionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      supersededLedgerTransactionIds: // value for 'supersededLedgerTransactionIds'
 *      transaction: // value for 'transaction'
 *   },
 * });
 */
export function useCreateSupersedingTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupersedingTransactionMutation, CreateSupersedingTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupersedingTransactionMutation, CreateSupersedingTransactionMutationVariables>(CreateSupersedingTransactionDocument, options);
      }
export type CreateSupersedingTransactionMutationHookResult = ReturnType<typeof useCreateSupersedingTransactionMutation>;
export type CreateSupersedingTransactionMutationResult = Apollo.MutationResult<CreateSupersedingTransactionMutation>;
export type CreateSupersedingTransactionMutationOptions = Apollo.BaseMutationOptions<CreateSupersedingTransactionMutation, CreateSupersedingTransactionMutationVariables>;
export const CreateTransactionDocument = gql`
    mutation CreateTransaction($legalEntityId: String!, $transaction: InputTransaction!) {
  createTransaction(legalEntityId: $legalEntityId, transaction: $transaction) {
    transactionFactIds
  }
}
    `;
export type CreateTransactionMutationFn = Apollo.MutationFunction<CreateTransactionMutation, CreateTransactionMutationVariables>;

/**
 * __useCreateTransactionMutation__
 *
 * To run a mutation, you first call `useCreateTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionMutation, { data, loading, error }] = useCreateTransactionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      transaction: // value for 'transaction'
 *   },
 * });
 */
export function useCreateTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransactionMutation, CreateTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransactionMutation, CreateTransactionMutationVariables>(CreateTransactionDocument, options);
      }
export type CreateTransactionMutationHookResult = ReturnType<typeof useCreateTransactionMutation>;
export type CreateTransactionMutationResult = Apollo.MutationResult<CreateTransactionMutation>;
export type CreateTransactionMutationOptions = Apollo.BaseMutationOptions<CreateTransactionMutation, CreateTransactionMutationVariables>;
export const DeleteTransactionsDocument = gql`
    mutation DeleteTransactions($legalEntityId: String!, $factIds: [String!]!) {
  deleteTransactions(legalEntityId: $legalEntityId, factIds: $factIds)
}
    `;
export type DeleteTransactionsMutationFn = Apollo.MutationFunction<DeleteTransactionsMutation, DeleteTransactionsMutationVariables>;

/**
 * __useDeleteTransactionsMutation__
 *
 * To run a mutation, you first call `useDeleteTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransactionsMutation, { data, loading, error }] = useDeleteTransactionsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      factIds: // value for 'factIds'
 *   },
 * });
 */
export function useDeleteTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTransactionsMutation, DeleteTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTransactionsMutation, DeleteTransactionsMutationVariables>(DeleteTransactionsDocument, options);
      }
export type DeleteTransactionsMutationHookResult = ReturnType<typeof useDeleteTransactionsMutation>;
export type DeleteTransactionsMutationResult = Apollo.MutationResult<DeleteTransactionsMutation>;
export type DeleteTransactionsMutationOptions = Apollo.BaseMutationOptions<DeleteTransactionsMutation, DeleteTransactionsMutationVariables>;
export const EnqueueStatementImportWorkflowsDocument = gql`
    mutation EnqueueStatementImportWorkflows($input: EnqueueStatementImportWorkflowsInput!) {
  enqueueStatementImportWorkflows(input: $input) {
    workflowIds
  }
}
    `;
export type EnqueueStatementImportWorkflowsMutationFn = Apollo.MutationFunction<EnqueueStatementImportWorkflowsMutation, EnqueueStatementImportWorkflowsMutationVariables>;

/**
 * __useEnqueueStatementImportWorkflowsMutation__
 *
 * To run a mutation, you first call `useEnqueueStatementImportWorkflowsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnqueueStatementImportWorkflowsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enqueueStatementImportWorkflowsMutation, { data, loading, error }] = useEnqueueStatementImportWorkflowsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnqueueStatementImportWorkflowsMutation(baseOptions?: Apollo.MutationHookOptions<EnqueueStatementImportWorkflowsMutation, EnqueueStatementImportWorkflowsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnqueueStatementImportWorkflowsMutation, EnqueueStatementImportWorkflowsMutationVariables>(EnqueueStatementImportWorkflowsDocument, options);
      }
export type EnqueueStatementImportWorkflowsMutationHookResult = ReturnType<typeof useEnqueueStatementImportWorkflowsMutation>;
export type EnqueueStatementImportWorkflowsMutationResult = Apollo.MutationResult<EnqueueStatementImportWorkflowsMutation>;
export type EnqueueStatementImportWorkflowsMutationOptions = Apollo.BaseMutationOptions<EnqueueStatementImportWorkflowsMutation, EnqueueStatementImportWorkflowsMutationVariables>;
export const StartBulkCsvImportDocument = gql`
    mutation StartBulkCSVImport($input: StartBulkCSVImportInput!) {
  startBulkCSVImport(input: $input) {
    workflowId
  }
}
    `;
export type StartBulkCsvImportMutationFn = Apollo.MutationFunction<StartBulkCsvImportMutation, StartBulkCsvImportMutationVariables>;

/**
 * __useStartBulkCsvImportMutation__
 *
 * To run a mutation, you first call `useStartBulkCsvImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartBulkCsvImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startBulkCsvImportMutation, { data, loading, error }] = useStartBulkCsvImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartBulkCsvImportMutation(baseOptions?: Apollo.MutationHookOptions<StartBulkCsvImportMutation, StartBulkCsvImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartBulkCsvImportMutation, StartBulkCsvImportMutationVariables>(StartBulkCsvImportDocument, options);
      }
export type StartBulkCsvImportMutationHookResult = ReturnType<typeof useStartBulkCsvImportMutation>;
export type StartBulkCsvImportMutationResult = Apollo.MutationResult<StartBulkCsvImportMutation>;
export type StartBulkCsvImportMutationOptions = Apollo.BaseMutationOptions<StartBulkCsvImportMutation, StartBulkCsvImportMutationVariables>;
export const StartJournalEntriesImportDocument = gql`
    mutation StartJournalEntriesImport($input: StartJournalEntriesImportInput!) {
  startJournalEntriesImport(input: $input) {
    workflowId
  }
}
    `;
export type StartJournalEntriesImportMutationFn = Apollo.MutationFunction<StartJournalEntriesImportMutation, StartJournalEntriesImportMutationVariables>;

/**
 * __useStartJournalEntriesImportMutation__
 *
 * To run a mutation, you first call `useStartJournalEntriesImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartJournalEntriesImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startJournalEntriesImportMutation, { data, loading, error }] = useStartJournalEntriesImportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartJournalEntriesImportMutation(baseOptions?: Apollo.MutationHookOptions<StartJournalEntriesImportMutation, StartJournalEntriesImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartJournalEntriesImportMutation, StartJournalEntriesImportMutationVariables>(StartJournalEntriesImportDocument, options);
      }
export type StartJournalEntriesImportMutationHookResult = ReturnType<typeof useStartJournalEntriesImportMutation>;
export type StartJournalEntriesImportMutationResult = Apollo.MutationResult<StartJournalEntriesImportMutation>;
export type StartJournalEntriesImportMutationOptions = Apollo.BaseMutationOptions<StartJournalEntriesImportMutation, StartJournalEntriesImportMutationVariables>;
export const UpdateTransactionDocument = gql`
    mutation UpdateTransaction($legalEntityId: String!, $transaction: InputTransaction!, $filter: TransactionFilter!) {
  updateTransaction(
    legalEntityId: $legalEntityId
    transaction: $transaction
    filter: $filter
  )
}
    `;
export type UpdateTransactionMutationFn = Apollo.MutationFunction<UpdateTransactionMutation, UpdateTransactionMutationVariables>;

/**
 * __useUpdateTransactionMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionMutation, { data, loading, error }] = useUpdateTransactionMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      transaction: // value for 'transaction'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpdateTransactionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionMutation, UpdateTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionMutation, UpdateTransactionMutationVariables>(UpdateTransactionDocument, options);
      }
export type UpdateTransactionMutationHookResult = ReturnType<typeof useUpdateTransactionMutation>;
export type UpdateTransactionMutationResult = Apollo.MutationResult<UpdateTransactionMutation>;
export type UpdateTransactionMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionMutation, UpdateTransactionMutationVariables>;
export const UpdateTransactionBillDocument = gql`
    mutation UpdateTransactionBill($legalEntityId: String!, $bill: BillEdit!) {
  updateTransactionBill(legalEntityId: $legalEntityId, bill: $bill)
}
    `;
export type UpdateTransactionBillMutationFn = Apollo.MutationFunction<UpdateTransactionBillMutation, UpdateTransactionBillMutationVariables>;

/**
 * __useUpdateTransactionBillMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionBillMutation, { data, loading, error }] = useUpdateTransactionBillMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      bill: // value for 'bill'
 *   },
 * });
 */
export function useUpdateTransactionBillMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionBillMutation, UpdateTransactionBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionBillMutation, UpdateTransactionBillMutationVariables>(UpdateTransactionBillDocument, options);
      }
export type UpdateTransactionBillMutationHookResult = ReturnType<typeof useUpdateTransactionBillMutation>;
export type UpdateTransactionBillMutationResult = Apollo.MutationResult<UpdateTransactionBillMutation>;
export type UpdateTransactionBillMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionBillMutation, UpdateTransactionBillMutationVariables>;
export const UpdateTransactionFieldsDocument = gql`
    mutation UpdateTransactionFields($legalEntityId: String!, $viewKey: ViewKey!, $updates: [InputUpdateFields!]!) {
  updateTransactionFields(
    legalEntityId: $legalEntityId
    viewKey: $viewKey
    updates: $updates
  )
}
    `;
export type UpdateTransactionFieldsMutationFn = Apollo.MutationFunction<UpdateTransactionFieldsMutation, UpdateTransactionFieldsMutationVariables>;

/**
 * __useUpdateTransactionFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionFieldsMutation, { data, loading, error }] = useUpdateTransactionFieldsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      viewKey: // value for 'viewKey'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateTransactionFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionFieldsMutation, UpdateTransactionFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionFieldsMutation, UpdateTransactionFieldsMutationVariables>(UpdateTransactionFieldsDocument, options);
      }
export type UpdateTransactionFieldsMutationHookResult = ReturnType<typeof useUpdateTransactionFieldsMutation>;
export type UpdateTransactionFieldsMutationResult = Apollo.MutationResult<UpdateTransactionFieldsMutation>;
export type UpdateTransactionFieldsMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionFieldsMutation, UpdateTransactionFieldsMutationVariables>;
export const UpdateTransactionInvoiceDocument = gql`
    mutation UpdateTransactionInvoice($legalEntityId: String!, $invoice: InvoiceEdit!) {
  updateTransactionInvoice(legalEntityId: $legalEntityId, invoice: $invoice)
}
    `;
export type UpdateTransactionInvoiceMutationFn = Apollo.MutationFunction<UpdateTransactionInvoiceMutation, UpdateTransactionInvoiceMutationVariables>;

/**
 * __useUpdateTransactionInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionInvoiceMutation, { data, loading, error }] = useUpdateTransactionInvoiceMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      invoice: // value for 'invoice'
 *   },
 * });
 */
export function useUpdateTransactionInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionInvoiceMutation, UpdateTransactionInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionInvoiceMutation, UpdateTransactionInvoiceMutationVariables>(UpdateTransactionInvoiceDocument, options);
      }
export type UpdateTransactionInvoiceMutationHookResult = ReturnType<typeof useUpdateTransactionInvoiceMutation>;
export type UpdateTransactionInvoiceMutationResult = Apollo.MutationResult<UpdateTransactionInvoiceMutation>;
export type UpdateTransactionInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionInvoiceMutation, UpdateTransactionInvoiceMutationVariables>;
export const CheckLedgerTransactionStaleDocument = gql`
    query CheckLedgerTransactionStale($ledgerTransactionId: String!, $legalEntityId: String!, $viewKey: ViewKey!) {
  checkLedgerTransactionStale(
    ledgerTransactionId: $ledgerTransactionId
    legalEntityId: $legalEntityId
    viewKey: $viewKey
  ) {
    ...LedgerTransactionStaleFields
  }
}
    ${LedgerTransactionStaleFieldsFragmentDoc}`;

/**
 * __useCheckLedgerTransactionStaleQuery__
 *
 * To run a query within a React component, call `useCheckLedgerTransactionStaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckLedgerTransactionStaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckLedgerTransactionStaleQuery({
 *   variables: {
 *      ledgerTransactionId: // value for 'ledgerTransactionId'
 *      legalEntityId: // value for 'legalEntityId'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useCheckLedgerTransactionStaleQuery(baseOptions: Apollo.QueryHookOptions<CheckLedgerTransactionStaleQuery, CheckLedgerTransactionStaleQueryVariables> & ({ variables: CheckLedgerTransactionStaleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckLedgerTransactionStaleQuery, CheckLedgerTransactionStaleQueryVariables>(CheckLedgerTransactionStaleDocument, options);
      }
export function useCheckLedgerTransactionStaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckLedgerTransactionStaleQuery, CheckLedgerTransactionStaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckLedgerTransactionStaleQuery, CheckLedgerTransactionStaleQueryVariables>(CheckLedgerTransactionStaleDocument, options);
        }
export function useCheckLedgerTransactionStaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckLedgerTransactionStaleQuery, CheckLedgerTransactionStaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckLedgerTransactionStaleQuery, CheckLedgerTransactionStaleQueryVariables>(CheckLedgerTransactionStaleDocument, options);
        }
export type CheckLedgerTransactionStaleQueryHookResult = ReturnType<typeof useCheckLedgerTransactionStaleQuery>;
export type CheckLedgerTransactionStaleLazyQueryHookResult = ReturnType<typeof useCheckLedgerTransactionStaleLazyQuery>;
export type CheckLedgerTransactionStaleSuspenseQueryHookResult = ReturnType<typeof useCheckLedgerTransactionStaleSuspenseQuery>;
export type CheckLedgerTransactionStaleQueryResult = Apollo.QueryResult<CheckLedgerTransactionStaleQuery, CheckLedgerTransactionStaleQueryVariables>;
export const ExportTransactionsDocument = gql`
    query ExportTransactions($filter: TransactionFilter!, $direction: DirectionFromOrigin!, $origin: IntervalOrigin!, $fileName: String, $temporary: Boolean, $singleColumnAmount: Boolean, $fields: [CsvExportField!], $orderPairs: [TransactionOrderPair!] = []) {
  exportTransactions(
    filter: $filter
    direction: $direction
    origin: $origin
    fileName: $fileName
    temporary: $temporary
    singleColumnAmount: $singleColumnAmount
    fields: $fields
    order: {transactionOrderPairs: $orderPairs}
  ) {
    ...DocumentInitialSegmentFields
  }
}
    ${DocumentInitialSegmentFieldsFragmentDoc}`;

/**
 * __useExportTransactionsQuery__
 *
 * To run a query within a React component, call `useExportTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportTransactionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      direction: // value for 'direction'
 *      origin: // value for 'origin'
 *      fileName: // value for 'fileName'
 *      temporary: // value for 'temporary'
 *      singleColumnAmount: // value for 'singleColumnAmount'
 *      fields: // value for 'fields'
 *      orderPairs: // value for 'orderPairs'
 *   },
 * });
 */
export function useExportTransactionsQuery(baseOptions: Apollo.QueryHookOptions<ExportTransactionsQuery, ExportTransactionsQueryVariables> & ({ variables: ExportTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportTransactionsQuery, ExportTransactionsQueryVariables>(ExportTransactionsDocument, options);
      }
export function useExportTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportTransactionsQuery, ExportTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportTransactionsQuery, ExportTransactionsQueryVariables>(ExportTransactionsDocument, options);
        }
export function useExportTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportTransactionsQuery, ExportTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportTransactionsQuery, ExportTransactionsQueryVariables>(ExportTransactionsDocument, options);
        }
export type ExportTransactionsQueryHookResult = ReturnType<typeof useExportTransactionsQuery>;
export type ExportTransactionsLazyQueryHookResult = ReturnType<typeof useExportTransactionsLazyQuery>;
export type ExportTransactionsSuspenseQueryHookResult = ReturnType<typeof useExportTransactionsSuspenseQuery>;
export type ExportTransactionsQueryResult = Apollo.QueryResult<ExportTransactionsQuery, ExportTransactionsQueryVariables>;
export const FacetDepartmentDocument = gql`
    query FacetDepartment($pagination: Pagination!, $paginationDirection: DirectionFromOrigin!, $filter: FacetFilter!, $intervalOrigin: IntervalOrigin!) {
  transactionFacet(
    filter: $filter
    origin: $intervalOrigin
    pagination: $pagination
    direction: $paginationDirection
    field: {type: CountPerValue, kind: TransactionDepartment}
  ) {
    department {
      ...DepartmentFacetFields
    }
  }
}
    ${DepartmentFacetFieldsFragmentDoc}`;

/**
 * __useFacetDepartmentQuery__
 *
 * To run a query within a React component, call `useFacetDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacetDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacetDepartmentQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      paginationDirection: // value for 'paginationDirection'
 *      filter: // value for 'filter'
 *      intervalOrigin: // value for 'intervalOrigin'
 *   },
 * });
 */
export function useFacetDepartmentQuery(baseOptions: Apollo.QueryHookOptions<FacetDepartmentQuery, FacetDepartmentQueryVariables> & ({ variables: FacetDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FacetDepartmentQuery, FacetDepartmentQueryVariables>(FacetDepartmentDocument, options);
      }
export function useFacetDepartmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FacetDepartmentQuery, FacetDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FacetDepartmentQuery, FacetDepartmentQueryVariables>(FacetDepartmentDocument, options);
        }
export function useFacetDepartmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FacetDepartmentQuery, FacetDepartmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FacetDepartmentQuery, FacetDepartmentQueryVariables>(FacetDepartmentDocument, options);
        }
export type FacetDepartmentQueryHookResult = ReturnType<typeof useFacetDepartmentQuery>;
export type FacetDepartmentLazyQueryHookResult = ReturnType<typeof useFacetDepartmentLazyQuery>;
export type FacetDepartmentSuspenseQueryHookResult = ReturnType<typeof useFacetDepartmentSuspenseQuery>;
export type FacetDepartmentQueryResult = Apollo.QueryResult<FacetDepartmentQuery, FacetDepartmentQueryVariables>;
export const FacetDepartmentAggregateDocument = gql`
    query FacetDepartmentAggregate($filter: FacetFilter!, $intervalOrigin: IntervalOrigin!) {
  transactionFacet(
    filter: $filter
    origin: $intervalOrigin
    pagination: {limit: 1, offset: 0}
    direction: Past
    field: {type: AggregateCount, kind: TransactionDepartment}
  ) {
    aggregate
  }
}
    `;

/**
 * __useFacetDepartmentAggregateQuery__
 *
 * To run a query within a React component, call `useFacetDepartmentAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacetDepartmentAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacetDepartmentAggregateQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      intervalOrigin: // value for 'intervalOrigin'
 *   },
 * });
 */
export function useFacetDepartmentAggregateQuery(baseOptions: Apollo.QueryHookOptions<FacetDepartmentAggregateQuery, FacetDepartmentAggregateQueryVariables> & ({ variables: FacetDepartmentAggregateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FacetDepartmentAggregateQuery, FacetDepartmentAggregateQueryVariables>(FacetDepartmentAggregateDocument, options);
      }
export function useFacetDepartmentAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FacetDepartmentAggregateQuery, FacetDepartmentAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FacetDepartmentAggregateQuery, FacetDepartmentAggregateQueryVariables>(FacetDepartmentAggregateDocument, options);
        }
export function useFacetDepartmentAggregateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FacetDepartmentAggregateQuery, FacetDepartmentAggregateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FacetDepartmentAggregateQuery, FacetDepartmentAggregateQueryVariables>(FacetDepartmentAggregateDocument, options);
        }
export type FacetDepartmentAggregateQueryHookResult = ReturnType<typeof useFacetDepartmentAggregateQuery>;
export type FacetDepartmentAggregateLazyQueryHookResult = ReturnType<typeof useFacetDepartmentAggregateLazyQuery>;
export type FacetDepartmentAggregateSuspenseQueryHookResult = ReturnType<typeof useFacetDepartmentAggregateSuspenseQuery>;
export type FacetDepartmentAggregateQueryResult = Apollo.QueryResult<FacetDepartmentAggregateQuery, FacetDepartmentAggregateQueryVariables>;
export const FacetLocationDocument = gql`
    query FacetLocation($pagination: Pagination!, $paginationDirection: DirectionFromOrigin!, $filter: FacetFilter!, $intervalOrigin: IntervalOrigin!) {
  transactionFacet(
    filter: $filter
    origin: $intervalOrigin
    pagination: $pagination
    direction: $paginationDirection
    field: {type: CountPerValue, kind: TransactionLocation}
  ) {
    location {
      ...LocationFacetFields
    }
  }
}
    ${LocationFacetFieldsFragmentDoc}`;

/**
 * __useFacetLocationQuery__
 *
 * To run a query within a React component, call `useFacetLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacetLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacetLocationQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      paginationDirection: // value for 'paginationDirection'
 *      filter: // value for 'filter'
 *      intervalOrigin: // value for 'intervalOrigin'
 *   },
 * });
 */
export function useFacetLocationQuery(baseOptions: Apollo.QueryHookOptions<FacetLocationQuery, FacetLocationQueryVariables> & ({ variables: FacetLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FacetLocationQuery, FacetLocationQueryVariables>(FacetLocationDocument, options);
      }
export function useFacetLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FacetLocationQuery, FacetLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FacetLocationQuery, FacetLocationQueryVariables>(FacetLocationDocument, options);
        }
export function useFacetLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FacetLocationQuery, FacetLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FacetLocationQuery, FacetLocationQueryVariables>(FacetLocationDocument, options);
        }
export type FacetLocationQueryHookResult = ReturnType<typeof useFacetLocationQuery>;
export type FacetLocationLazyQueryHookResult = ReturnType<typeof useFacetLocationLazyQuery>;
export type FacetLocationSuspenseQueryHookResult = ReturnType<typeof useFacetLocationSuspenseQuery>;
export type FacetLocationQueryResult = Apollo.QueryResult<FacetLocationQuery, FacetLocationQueryVariables>;
export const FacetLocationAggregateDocument = gql`
    query FacetLocationAggregate($filter: FacetFilter!, $intervalOrigin: IntervalOrigin!) {
  transactionFacet(
    filter: $filter
    origin: $intervalOrigin
    pagination: {limit: 1, offset: 0}
    direction: Past
    field: {type: AggregateCount, kind: TransactionLocation}
  ) {
    aggregate
  }
}
    `;

/**
 * __useFacetLocationAggregateQuery__
 *
 * To run a query within a React component, call `useFacetLocationAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacetLocationAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacetLocationAggregateQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      intervalOrigin: // value for 'intervalOrigin'
 *   },
 * });
 */
export function useFacetLocationAggregateQuery(baseOptions: Apollo.QueryHookOptions<FacetLocationAggregateQuery, FacetLocationAggregateQueryVariables> & ({ variables: FacetLocationAggregateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FacetLocationAggregateQuery, FacetLocationAggregateQueryVariables>(FacetLocationAggregateDocument, options);
      }
export function useFacetLocationAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FacetLocationAggregateQuery, FacetLocationAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FacetLocationAggregateQuery, FacetLocationAggregateQueryVariables>(FacetLocationAggregateDocument, options);
        }
export function useFacetLocationAggregateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FacetLocationAggregateQuery, FacetLocationAggregateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FacetLocationAggregateQuery, FacetLocationAggregateQueryVariables>(FacetLocationAggregateDocument, options);
        }
export type FacetLocationAggregateQueryHookResult = ReturnType<typeof useFacetLocationAggregateQuery>;
export type FacetLocationAggregateLazyQueryHookResult = ReturnType<typeof useFacetLocationAggregateLazyQuery>;
export type FacetLocationAggregateSuspenseQueryHookResult = ReturnType<typeof useFacetLocationAggregateSuspenseQuery>;
export type FacetLocationAggregateQueryResult = Apollo.QueryResult<FacetLocationAggregateQuery, FacetLocationAggregateQueryVariables>;
export const FacetMatchedStatusDocument = gql`
    query FacetMatchedStatus($pagination: Pagination!, $paginationDirection: DirectionFromOrigin!, $filter: FacetFilter!, $intervalOrigin: IntervalOrigin!) {
  transactionFacet(
    filter: $filter
    origin: $intervalOrigin
    pagination: $pagination
    direction: $paginationDirection
    field: {type: CountPerValue, kind: TransactionMatchedStatus}
  ) {
    matchedStatus {
      ...MatchedStatusFacetFields
    }
  }
}
    ${MatchedStatusFacetFieldsFragmentDoc}`;

/**
 * __useFacetMatchedStatusQuery__
 *
 * To run a query within a React component, call `useFacetMatchedStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacetMatchedStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacetMatchedStatusQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      paginationDirection: // value for 'paginationDirection'
 *      filter: // value for 'filter'
 *      intervalOrigin: // value for 'intervalOrigin'
 *   },
 * });
 */
export function useFacetMatchedStatusQuery(baseOptions: Apollo.QueryHookOptions<FacetMatchedStatusQuery, FacetMatchedStatusQueryVariables> & ({ variables: FacetMatchedStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FacetMatchedStatusQuery, FacetMatchedStatusQueryVariables>(FacetMatchedStatusDocument, options);
      }
export function useFacetMatchedStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FacetMatchedStatusQuery, FacetMatchedStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FacetMatchedStatusQuery, FacetMatchedStatusQueryVariables>(FacetMatchedStatusDocument, options);
        }
export function useFacetMatchedStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FacetMatchedStatusQuery, FacetMatchedStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FacetMatchedStatusQuery, FacetMatchedStatusQueryVariables>(FacetMatchedStatusDocument, options);
        }
export type FacetMatchedStatusQueryHookResult = ReturnType<typeof useFacetMatchedStatusQuery>;
export type FacetMatchedStatusLazyQueryHookResult = ReturnType<typeof useFacetMatchedStatusLazyQuery>;
export type FacetMatchedStatusSuspenseQueryHookResult = ReturnType<typeof useFacetMatchedStatusSuspenseQuery>;
export type FacetMatchedStatusQueryResult = Apollo.QueryResult<FacetMatchedStatusQuery, FacetMatchedStatusQueryVariables>;
export const FacetNewPartyDocument = gql`
    query FacetNewParty($pagination: Pagination!, $paginationDirection: DirectionFromOrigin!, $filter: FacetFilter!, $intervalOrigin: IntervalOrigin!) {
  transactionFacet(
    filter: $filter
    origin: $intervalOrigin
    pagination: $pagination
    direction: $paginationDirection
    field: {type: CountPerValue, kind: TransactionNewParty}
  ) {
    party {
      ...PartyFacetFields
    }
  }
}
    ${PartyFacetFieldsFragmentDoc}`;

/**
 * __useFacetNewPartyQuery__
 *
 * To run a query within a React component, call `useFacetNewPartyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacetNewPartyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacetNewPartyQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      paginationDirection: // value for 'paginationDirection'
 *      filter: // value for 'filter'
 *      intervalOrigin: // value for 'intervalOrigin'
 *   },
 * });
 */
export function useFacetNewPartyQuery(baseOptions: Apollo.QueryHookOptions<FacetNewPartyQuery, FacetNewPartyQueryVariables> & ({ variables: FacetNewPartyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FacetNewPartyQuery, FacetNewPartyQueryVariables>(FacetNewPartyDocument, options);
      }
export function useFacetNewPartyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FacetNewPartyQuery, FacetNewPartyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FacetNewPartyQuery, FacetNewPartyQueryVariables>(FacetNewPartyDocument, options);
        }
export function useFacetNewPartySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FacetNewPartyQuery, FacetNewPartyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FacetNewPartyQuery, FacetNewPartyQueryVariables>(FacetNewPartyDocument, options);
        }
export type FacetNewPartyQueryHookResult = ReturnType<typeof useFacetNewPartyQuery>;
export type FacetNewPartyLazyQueryHookResult = ReturnType<typeof useFacetNewPartyLazyQuery>;
export type FacetNewPartySuspenseQueryHookResult = ReturnType<typeof useFacetNewPartySuspenseQuery>;
export type FacetNewPartyQueryResult = Apollo.QueryResult<FacetNewPartyQuery, FacetNewPartyQueryVariables>;
export const FacetPartyDocument = gql`
    query FacetParty($pagination: Pagination!, $paginationDirection: DirectionFromOrigin!, $filter: FacetFilter!, $intervalOrigin: IntervalOrigin!) {
  transactionFacet(
    filter: $filter
    origin: $intervalOrigin
    pagination: $pagination
    direction: $paginationDirection
    field: {type: CountPerValue, kind: TransactionParty}
  ) {
    party {
      ...PartyFacetFields
    }
  }
}
    ${PartyFacetFieldsFragmentDoc}`;

/**
 * __useFacetPartyQuery__
 *
 * To run a query within a React component, call `useFacetPartyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacetPartyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacetPartyQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      paginationDirection: // value for 'paginationDirection'
 *      filter: // value for 'filter'
 *      intervalOrigin: // value for 'intervalOrigin'
 *   },
 * });
 */
export function useFacetPartyQuery(baseOptions: Apollo.QueryHookOptions<FacetPartyQuery, FacetPartyQueryVariables> & ({ variables: FacetPartyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FacetPartyQuery, FacetPartyQueryVariables>(FacetPartyDocument, options);
      }
export function useFacetPartyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FacetPartyQuery, FacetPartyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FacetPartyQuery, FacetPartyQueryVariables>(FacetPartyDocument, options);
        }
export function useFacetPartySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FacetPartyQuery, FacetPartyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FacetPartyQuery, FacetPartyQueryVariables>(FacetPartyDocument, options);
        }
export type FacetPartyQueryHookResult = ReturnType<typeof useFacetPartyQuery>;
export type FacetPartyLazyQueryHookResult = ReturnType<typeof useFacetPartyLazyQuery>;
export type FacetPartySuspenseQueryHookResult = ReturnType<typeof useFacetPartySuspenseQuery>;
export type FacetPartyQueryResult = Apollo.QueryResult<FacetPartyQuery, FacetPartyQueryVariables>;
export const FacetPartyAggregateDocument = gql`
    query FacetPartyAggregate($filter: FacetFilter!, $intervalOrigin: IntervalOrigin!) {
  transactionFacet(
    filter: $filter
    origin: $intervalOrigin
    pagination: {limit: 1, offset: 0}
    direction: Past
    field: {type: AggregateCount, kind: TransactionParty}
  ) {
    aggregate
  }
}
    `;

/**
 * __useFacetPartyAggregateQuery__
 *
 * To run a query within a React component, call `useFacetPartyAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacetPartyAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacetPartyAggregateQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      intervalOrigin: // value for 'intervalOrigin'
 *   },
 * });
 */
export function useFacetPartyAggregateQuery(baseOptions: Apollo.QueryHookOptions<FacetPartyAggregateQuery, FacetPartyAggregateQueryVariables> & ({ variables: FacetPartyAggregateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FacetPartyAggregateQuery, FacetPartyAggregateQueryVariables>(FacetPartyAggregateDocument, options);
      }
export function useFacetPartyAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FacetPartyAggregateQuery, FacetPartyAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FacetPartyAggregateQuery, FacetPartyAggregateQueryVariables>(FacetPartyAggregateDocument, options);
        }
export function useFacetPartyAggregateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FacetPartyAggregateQuery, FacetPartyAggregateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FacetPartyAggregateQuery, FacetPartyAggregateQueryVariables>(FacetPartyAggregateDocument, options);
        }
export type FacetPartyAggregateQueryHookResult = ReturnType<typeof useFacetPartyAggregateQuery>;
export type FacetPartyAggregateLazyQueryHookResult = ReturnType<typeof useFacetPartyAggregateLazyQuery>;
export type FacetPartyAggregateSuspenseQueryHookResult = ReturnType<typeof useFacetPartyAggregateSuspenseQuery>;
export type FacetPartyAggregateQueryResult = Apollo.QueryResult<FacetPartyAggregateQuery, FacetPartyAggregateQueryVariables>;
export const FacetSourceUserDocument = gql`
    query FacetSourceUser($pagination: Pagination!, $paginationDirection: DirectionFromOrigin!, $filter: FacetFilter!, $intervalOrigin: IntervalOrigin!) {
  transactionFacet(
    filter: $filter
    origin: $intervalOrigin
    pagination: $pagination
    direction: $paginationDirection
    field: {type: CountPerValue, kind: TransactionSourceUser}
  ) {
    user {
      ...UserFacetFields
    }
  }
}
    ${UserFacetFieldsFragmentDoc}`;

/**
 * __useFacetSourceUserQuery__
 *
 * To run a query within a React component, call `useFacetSourceUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacetSourceUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacetSourceUserQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      paginationDirection: // value for 'paginationDirection'
 *      filter: // value for 'filter'
 *      intervalOrigin: // value for 'intervalOrigin'
 *   },
 * });
 */
export function useFacetSourceUserQuery(baseOptions: Apollo.QueryHookOptions<FacetSourceUserQuery, FacetSourceUserQueryVariables> & ({ variables: FacetSourceUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FacetSourceUserQuery, FacetSourceUserQueryVariables>(FacetSourceUserDocument, options);
      }
export function useFacetSourceUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FacetSourceUserQuery, FacetSourceUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FacetSourceUserQuery, FacetSourceUserQueryVariables>(FacetSourceUserDocument, options);
        }
export function useFacetSourceUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FacetSourceUserQuery, FacetSourceUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FacetSourceUserQuery, FacetSourceUserQueryVariables>(FacetSourceUserDocument, options);
        }
export type FacetSourceUserQueryHookResult = ReturnType<typeof useFacetSourceUserQuery>;
export type FacetSourceUserLazyQueryHookResult = ReturnType<typeof useFacetSourceUserLazyQuery>;
export type FacetSourceUserSuspenseQueryHookResult = ReturnType<typeof useFacetSourceUserSuspenseQuery>;
export type FacetSourceUserQueryResult = Apollo.QueryResult<FacetSourceUserQuery, FacetSourceUserQueryVariables>;
export const FacetSourcesDocument = gql`
    query FacetSources($userPagination: Pagination!, $institutionPagination: Pagination!, $paginationDirection: DirectionFromOrigin!, $filter: FacetFilter!, $intervalOrigin: IntervalOrigin!) {
  institution: transactionFacet(
    filter: $filter
    origin: $intervalOrigin
    pagination: $institutionPagination
    direction: $paginationDirection
    field: {type: CountPerValue, kind: TransactionSourceInstitution}
  ) {
    institution {
      ...InstitutionFacetFields
    }
  }
  user: transactionFacet(
    filter: $filter
    origin: $intervalOrigin
    pagination: $userPagination
    direction: $paginationDirection
    field: {type: CountPerValue, kind: TransactionSourceUser}
  ) {
    user {
      ...UserFacetFields
    }
  }
}
    ${InstitutionFacetFieldsFragmentDoc}
${UserFacetFieldsFragmentDoc}`;

/**
 * __useFacetSourcesQuery__
 *
 * To run a query within a React component, call `useFacetSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacetSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacetSourcesQuery({
 *   variables: {
 *      userPagination: // value for 'userPagination'
 *      institutionPagination: // value for 'institutionPagination'
 *      paginationDirection: // value for 'paginationDirection'
 *      filter: // value for 'filter'
 *      intervalOrigin: // value for 'intervalOrigin'
 *   },
 * });
 */
export function useFacetSourcesQuery(baseOptions: Apollo.QueryHookOptions<FacetSourcesQuery, FacetSourcesQueryVariables> & ({ variables: FacetSourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FacetSourcesQuery, FacetSourcesQueryVariables>(FacetSourcesDocument, options);
      }
export function useFacetSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FacetSourcesQuery, FacetSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FacetSourcesQuery, FacetSourcesQueryVariables>(FacetSourcesDocument, options);
        }
export function useFacetSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FacetSourcesQuery, FacetSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FacetSourcesQuery, FacetSourcesQueryVariables>(FacetSourcesDocument, options);
        }
export type FacetSourcesQueryHookResult = ReturnType<typeof useFacetSourcesQuery>;
export type FacetSourcesLazyQueryHookResult = ReturnType<typeof useFacetSourcesLazyQuery>;
export type FacetSourcesSuspenseQueryHookResult = ReturnType<typeof useFacetSourcesSuspenseQuery>;
export type FacetSourcesQueryResult = Apollo.QueryResult<FacetSourcesQuery, FacetSourcesQueryVariables>;
export const FacetSourcesAggregateDocument = gql`
    query FacetSourcesAggregate($filter: FacetFilter!, $intervalOrigin: IntervalOrigin!) {
  institution: transactionFacet(
    filter: $filter
    origin: $intervalOrigin
    pagination: {limit: 1, offset: 0}
    direction: Past
    field: {type: AggregateCount, kind: TransactionSourceInstitution}
  ) {
    aggregate
  }
  user: transactionFacet(
    filter: $filter
    origin: $intervalOrigin
    pagination: {limit: 1, offset: 0}
    direction: Past
    field: {type: AggregateCount, kind: TransactionSourceUser}
  ) {
    aggregate
  }
}
    `;

/**
 * __useFacetSourcesAggregateQuery__
 *
 * To run a query within a React component, call `useFacetSourcesAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacetSourcesAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacetSourcesAggregateQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      intervalOrigin: // value for 'intervalOrigin'
 *   },
 * });
 */
export function useFacetSourcesAggregateQuery(baseOptions: Apollo.QueryHookOptions<FacetSourcesAggregateQuery, FacetSourcesAggregateQueryVariables> & ({ variables: FacetSourcesAggregateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FacetSourcesAggregateQuery, FacetSourcesAggregateQueryVariables>(FacetSourcesAggregateDocument, options);
      }
export function useFacetSourcesAggregateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FacetSourcesAggregateQuery, FacetSourcesAggregateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FacetSourcesAggregateQuery, FacetSourcesAggregateQueryVariables>(FacetSourcesAggregateDocument, options);
        }
export function useFacetSourcesAggregateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FacetSourcesAggregateQuery, FacetSourcesAggregateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FacetSourcesAggregateQuery, FacetSourcesAggregateQueryVariables>(FacetSourcesAggregateDocument, options);
        }
export type FacetSourcesAggregateQueryHookResult = ReturnType<typeof useFacetSourcesAggregateQuery>;
export type FacetSourcesAggregateLazyQueryHookResult = ReturnType<typeof useFacetSourcesAggregateLazyQuery>;
export type FacetSourcesAggregateSuspenseQueryHookResult = ReturnType<typeof useFacetSourcesAggregateSuspenseQuery>;
export type FacetSourcesAggregateQueryResult = Apollo.QueryResult<FacetSourcesAggregateQuery, FacetSourcesAggregateQueryVariables>;
export const ListMetricTransactionsDocument = gql`
    query ListMetricTransactions($viewKey: ViewKey!, $metricSummaryType: MetricSummaryItem, $summaryLineType: SummaryLineItem, $pagination: Pagination!, $sortColumnName: TransactionColumnName!, $sortDirection: SortDirection!, $intervalOrigin: IntervalOrigin!) {
  listTransactions: listMetricTransactions(
    viewKey: $viewKey
    metricSummaryType: $metricSummaryType
    summaryLineType: $summaryLineType
    origin: $intervalOrigin
    pagination: $pagination
    order: {transactionOrderPairs: [{columnName: $sortColumnName, direction: $sortDirection}]}
  ) {
    ...TransactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`;

/**
 * __useListMetricTransactionsQuery__
 *
 * To run a query within a React component, call `useListMetricTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMetricTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMetricTransactionsQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      metricSummaryType: // value for 'metricSummaryType'
 *      summaryLineType: // value for 'summaryLineType'
 *      pagination: // value for 'pagination'
 *      sortColumnName: // value for 'sortColumnName'
 *      sortDirection: // value for 'sortDirection'
 *      intervalOrigin: // value for 'intervalOrigin'
 *   },
 * });
 */
export function useListMetricTransactionsQuery(baseOptions: Apollo.QueryHookOptions<ListMetricTransactionsQuery, ListMetricTransactionsQueryVariables> & ({ variables: ListMetricTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMetricTransactionsQuery, ListMetricTransactionsQueryVariables>(ListMetricTransactionsDocument, options);
      }
export function useListMetricTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMetricTransactionsQuery, ListMetricTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMetricTransactionsQuery, ListMetricTransactionsQueryVariables>(ListMetricTransactionsDocument, options);
        }
export function useListMetricTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListMetricTransactionsQuery, ListMetricTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListMetricTransactionsQuery, ListMetricTransactionsQueryVariables>(ListMetricTransactionsDocument, options);
        }
export type ListMetricTransactionsQueryHookResult = ReturnType<typeof useListMetricTransactionsQuery>;
export type ListMetricTransactionsLazyQueryHookResult = ReturnType<typeof useListMetricTransactionsLazyQuery>;
export type ListMetricTransactionsSuspenseQueryHookResult = ReturnType<typeof useListMetricTransactionsSuspenseQuery>;
export type ListMetricTransactionsQueryResult = Apollo.QueryResult<ListMetricTransactionsQuery, ListMetricTransactionsQueryVariables>;
export const ListSimilarTransactionsDocument = gql`
    query ListSimilarTransactions($viewKey: ViewKey!, $factId: String!, $entryType: EntryType!, $categoryId: String, $numNeighbors: Int) {
  listSimilarTransactions(
    viewKey: $viewKey
    factId: $factId
    entryType: $entryType
    categoryId: $categoryId
    numNeighbors: $numNeighbors
  ) {
    ...TransactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`;

/**
 * __useListSimilarTransactionsQuery__
 *
 * To run a query within a React component, call `useListSimilarTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSimilarTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSimilarTransactionsQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      factId: // value for 'factId'
 *      entryType: // value for 'entryType'
 *      categoryId: // value for 'categoryId'
 *      numNeighbors: // value for 'numNeighbors'
 *   },
 * });
 */
export function useListSimilarTransactionsQuery(baseOptions: Apollo.QueryHookOptions<ListSimilarTransactionsQuery, ListSimilarTransactionsQueryVariables> & ({ variables: ListSimilarTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSimilarTransactionsQuery, ListSimilarTransactionsQueryVariables>(ListSimilarTransactionsDocument, options);
      }
export function useListSimilarTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSimilarTransactionsQuery, ListSimilarTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSimilarTransactionsQuery, ListSimilarTransactionsQueryVariables>(ListSimilarTransactionsDocument, options);
        }
export function useListSimilarTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSimilarTransactionsQuery, ListSimilarTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSimilarTransactionsQuery, ListSimilarTransactionsQueryVariables>(ListSimilarTransactionsDocument, options);
        }
export type ListSimilarTransactionsQueryHookResult = ReturnType<typeof useListSimilarTransactionsQuery>;
export type ListSimilarTransactionsLazyQueryHookResult = ReturnType<typeof useListSimilarTransactionsLazyQuery>;
export type ListSimilarTransactionsSuspenseQueryHookResult = ReturnType<typeof useListSimilarTransactionsSuspenseQuery>;
export type ListSimilarTransactionsQueryResult = Apollo.QueryResult<ListSimilarTransactionsQuery, ListSimilarTransactionsQueryVariables>;
export const ListTransactionEditingHistoryDocument = gql`
    query ListTransactionEditingHistory($legalEntityId: String!, $factId: String!) {
  listTransactionEditingHistory(legalEntityId: $legalEntityId, factId: $factId) {
    ...TransactionSourceFields
  }
}
    ${TransactionSourceFieldsFragmentDoc}`;

/**
 * __useListTransactionEditingHistoryQuery__
 *
 * To run a query within a React component, call `useListTransactionEditingHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTransactionEditingHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTransactionEditingHistoryQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      factId: // value for 'factId'
 *   },
 * });
 */
export function useListTransactionEditingHistoryQuery(baseOptions: Apollo.QueryHookOptions<ListTransactionEditingHistoryQuery, ListTransactionEditingHistoryQueryVariables> & ({ variables: ListTransactionEditingHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTransactionEditingHistoryQuery, ListTransactionEditingHistoryQueryVariables>(ListTransactionEditingHistoryDocument, options);
      }
export function useListTransactionEditingHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTransactionEditingHistoryQuery, ListTransactionEditingHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTransactionEditingHistoryQuery, ListTransactionEditingHistoryQueryVariables>(ListTransactionEditingHistoryDocument, options);
        }
export function useListTransactionEditingHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTransactionEditingHistoryQuery, ListTransactionEditingHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListTransactionEditingHistoryQuery, ListTransactionEditingHistoryQueryVariables>(ListTransactionEditingHistoryDocument, options);
        }
export type ListTransactionEditingHistoryQueryHookResult = ReturnType<typeof useListTransactionEditingHistoryQuery>;
export type ListTransactionEditingHistoryLazyQueryHookResult = ReturnType<typeof useListTransactionEditingHistoryLazyQuery>;
export type ListTransactionEditingHistorySuspenseQueryHookResult = ReturnType<typeof useListTransactionEditingHistorySuspenseQuery>;
export type ListTransactionEditingHistoryQueryResult = Apollo.QueryResult<ListTransactionEditingHistoryQuery, ListTransactionEditingHistoryQueryVariables>;
export const ListTransactionsDocument = gql`
    query ListTransactions($pagination: Pagination!, $paginationDirection: DirectionFromOrigin!, $sortColumnName: TransactionColumnName!, $sortDirection: SortDirection!, $filter: TransactionFilter!, $intervalOrigin: IntervalOrigin!, $naturalFlow: Flow) {
  listTransactions(
    filter: $filter
    origin: $intervalOrigin
    pagination: $pagination
    direction: $paginationDirection
    order: {transactionOrderPairs: [{columnName: $sortColumnName, direction: $sortDirection}]}
    naturalFlow: $naturalFlow
  ) {
    ...TransactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`;

/**
 * __useListTransactionsQuery__
 *
 * To run a query within a React component, call `useListTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTransactionsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      paginationDirection: // value for 'paginationDirection'
 *      sortColumnName: // value for 'sortColumnName'
 *      sortDirection: // value for 'sortDirection'
 *      filter: // value for 'filter'
 *      intervalOrigin: // value for 'intervalOrigin'
 *      naturalFlow: // value for 'naturalFlow'
 *   },
 * });
 */
export function useListTransactionsQuery(baseOptions: Apollo.QueryHookOptions<ListTransactionsQuery, ListTransactionsQueryVariables> & ({ variables: ListTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTransactionsQuery, ListTransactionsQueryVariables>(ListTransactionsDocument, options);
      }
export function useListTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTransactionsQuery, ListTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTransactionsQuery, ListTransactionsQueryVariables>(ListTransactionsDocument, options);
        }
export function useListTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTransactionsQuery, ListTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListTransactionsQuery, ListTransactionsQueryVariables>(ListTransactionsDocument, options);
        }
export type ListTransactionsQueryHookResult = ReturnType<typeof useListTransactionsQuery>;
export type ListTransactionsLazyQueryHookResult = ReturnType<typeof useListTransactionsLazyQuery>;
export type ListTransactionsSuspenseQueryHookResult = ReturnType<typeof useListTransactionsSuspenseQuery>;
export type ListTransactionsQueryResult = Apollo.QueryResult<ListTransactionsQuery, ListTransactionsQueryVariables>;
export const ListTransactionsByFactIdsDocument = gql`
    query ListTransactionsByFactIds($viewKey: ViewKey!, $factIds: [String!]!) {
  listTransactionsByFactIds(viewKey: $viewKey, factIds: $factIds) {
    ...TransactionFields
  }
}
    ${TransactionFieldsFragmentDoc}`;

/**
 * __useListTransactionsByFactIdsQuery__
 *
 * To run a query within a React component, call `useListTransactionsByFactIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTransactionsByFactIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTransactionsByFactIdsQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      factIds: // value for 'factIds'
 *   },
 * });
 */
export function useListTransactionsByFactIdsQuery(baseOptions: Apollo.QueryHookOptions<ListTransactionsByFactIdsQuery, ListTransactionsByFactIdsQueryVariables> & ({ variables: ListTransactionsByFactIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTransactionsByFactIdsQuery, ListTransactionsByFactIdsQueryVariables>(ListTransactionsByFactIdsDocument, options);
      }
export function useListTransactionsByFactIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTransactionsByFactIdsQuery, ListTransactionsByFactIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTransactionsByFactIdsQuery, ListTransactionsByFactIdsQueryVariables>(ListTransactionsByFactIdsDocument, options);
        }
export function useListTransactionsByFactIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTransactionsByFactIdsQuery, ListTransactionsByFactIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListTransactionsByFactIdsQuery, ListTransactionsByFactIdsQueryVariables>(ListTransactionsByFactIdsDocument, options);
        }
export type ListTransactionsByFactIdsQueryHookResult = ReturnType<typeof useListTransactionsByFactIdsQuery>;
export type ListTransactionsByFactIdsLazyQueryHookResult = ReturnType<typeof useListTransactionsByFactIdsLazyQuery>;
export type ListTransactionsByFactIdsSuspenseQueryHookResult = ReturnType<typeof useListTransactionsByFactIdsSuspenseQuery>;
export type ListTransactionsByFactIdsQueryResult = Apollo.QueryResult<ListTransactionsByFactIdsQuery, ListTransactionsByFactIdsQueryVariables>;
export const MinMaxAmountDocument = gql`
    query MinMaxAmount($filter: TransactionFilter!, $origin: IntervalOrigin!, $direction: DirectionFromOrigin!) {
  minMaxAmount(filter: $filter, origin: $origin, direction: $direction) {
    ...MinMaxAmountFields
  }
}
    ${MinMaxAmountFieldsFragmentDoc}`;

/**
 * __useMinMaxAmountQuery__
 *
 * To run a query within a React component, call `useMinMaxAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMinMaxAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMinMaxAmountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      origin: // value for 'origin'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useMinMaxAmountQuery(baseOptions: Apollo.QueryHookOptions<MinMaxAmountQuery, MinMaxAmountQueryVariables> & ({ variables: MinMaxAmountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MinMaxAmountQuery, MinMaxAmountQueryVariables>(MinMaxAmountDocument, options);
      }
export function useMinMaxAmountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MinMaxAmountQuery, MinMaxAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MinMaxAmountQuery, MinMaxAmountQueryVariables>(MinMaxAmountDocument, options);
        }
export function useMinMaxAmountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MinMaxAmountQuery, MinMaxAmountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MinMaxAmountQuery, MinMaxAmountQueryVariables>(MinMaxAmountDocument, options);
        }
export type MinMaxAmountQueryHookResult = ReturnType<typeof useMinMaxAmountQuery>;
export type MinMaxAmountLazyQueryHookResult = ReturnType<typeof useMinMaxAmountLazyQuery>;
export type MinMaxAmountSuspenseQueryHookResult = ReturnType<typeof useMinMaxAmountSuspenseQuery>;
export type MinMaxAmountQueryResult = Apollo.QueryResult<MinMaxAmountQuery, MinMaxAmountQueryVariables>;
export const ReadCategorySuggestionsDocument = gql`
    query ReadCategorySuggestions($transactionFactId: String!, $legalEntityId: String!, $entryType: EntryType!) {
  readCategorySuggestions(
    transactionFactId: $transactionFactId
    legalEntityId: $legalEntityId
    entryType: $entryType
  ) {
    ...CategorySuggestionFields
  }
}
    ${CategorySuggestionFieldsFragmentDoc}`;

/**
 * __useReadCategorySuggestionsQuery__
 *
 * To run a query within a React component, call `useReadCategorySuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadCategorySuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadCategorySuggestionsQuery({
 *   variables: {
 *      transactionFactId: // value for 'transactionFactId'
 *      legalEntityId: // value for 'legalEntityId'
 *      entryType: // value for 'entryType'
 *   },
 * });
 */
export function useReadCategorySuggestionsQuery(baseOptions: Apollo.QueryHookOptions<ReadCategorySuggestionsQuery, ReadCategorySuggestionsQueryVariables> & ({ variables: ReadCategorySuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadCategorySuggestionsQuery, ReadCategorySuggestionsQueryVariables>(ReadCategorySuggestionsDocument, options);
      }
export function useReadCategorySuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadCategorySuggestionsQuery, ReadCategorySuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadCategorySuggestionsQuery, ReadCategorySuggestionsQueryVariables>(ReadCategorySuggestionsDocument, options);
        }
export function useReadCategorySuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadCategorySuggestionsQuery, ReadCategorySuggestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadCategorySuggestionsQuery, ReadCategorySuggestionsQueryVariables>(ReadCategorySuggestionsDocument, options);
        }
export type ReadCategorySuggestionsQueryHookResult = ReturnType<typeof useReadCategorySuggestionsQuery>;
export type ReadCategorySuggestionsLazyQueryHookResult = ReturnType<typeof useReadCategorySuggestionsLazyQuery>;
export type ReadCategorySuggestionsSuspenseQueryHookResult = ReturnType<typeof useReadCategorySuggestionsSuspenseQuery>;
export type ReadCategorySuggestionsQueryResult = Apollo.QueryResult<ReadCategorySuggestionsQuery, ReadCategorySuggestionsQueryVariables>;
export const ReadLedgerTransactionDocument = gql`
    query ReadLedgerTransaction($transactionFactId: String!, $filter: TransactionFilter!) {
  readLedgerTransaction(transactionFactId: $transactionFactId, filter: $filter) {
    transaction {
      ...LedgerTransactionFields
    }
  }
}
    ${LedgerTransactionFieldsFragmentDoc}`;

/**
 * __useReadLedgerTransactionQuery__
 *
 * To run a query within a React component, call `useReadLedgerTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadLedgerTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadLedgerTransactionQuery({
 *   variables: {
 *      transactionFactId: // value for 'transactionFactId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReadLedgerTransactionQuery(baseOptions: Apollo.QueryHookOptions<ReadLedgerTransactionQuery, ReadLedgerTransactionQueryVariables> & ({ variables: ReadLedgerTransactionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadLedgerTransactionQuery, ReadLedgerTransactionQueryVariables>(ReadLedgerTransactionDocument, options);
      }
export function useReadLedgerTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadLedgerTransactionQuery, ReadLedgerTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadLedgerTransactionQuery, ReadLedgerTransactionQueryVariables>(ReadLedgerTransactionDocument, options);
        }
export function useReadLedgerTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadLedgerTransactionQuery, ReadLedgerTransactionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadLedgerTransactionQuery, ReadLedgerTransactionQueryVariables>(ReadLedgerTransactionDocument, options);
        }
export type ReadLedgerTransactionQueryHookResult = ReturnType<typeof useReadLedgerTransactionQuery>;
export type ReadLedgerTransactionLazyQueryHookResult = ReturnType<typeof useReadLedgerTransactionLazyQuery>;
export type ReadLedgerTransactionSuspenseQueryHookResult = ReturnType<typeof useReadLedgerTransactionSuspenseQuery>;
export type ReadLedgerTransactionQueryResult = Apollo.QueryResult<ReadLedgerTransactionQuery, ReadLedgerTransactionQueryVariables>;
export const ReadLedgerTransactionByIdDocument = gql`
    query ReadLedgerTransactionById($ledgerTransactionId: String!, $viewKey: ViewKey!) {
  readLedgerTransactionById(
    ledgerTransactionId: $ledgerTransactionId
    viewKey: $viewKey
  ) {
    transaction {
      ...LedgerTransactionFields
    }
  }
}
    ${LedgerTransactionFieldsFragmentDoc}`;

/**
 * __useReadLedgerTransactionByIdQuery__
 *
 * To run a query within a React component, call `useReadLedgerTransactionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadLedgerTransactionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadLedgerTransactionByIdQuery({
 *   variables: {
 *      ledgerTransactionId: // value for 'ledgerTransactionId'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useReadLedgerTransactionByIdQuery(baseOptions: Apollo.QueryHookOptions<ReadLedgerTransactionByIdQuery, ReadLedgerTransactionByIdQueryVariables> & ({ variables: ReadLedgerTransactionByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadLedgerTransactionByIdQuery, ReadLedgerTransactionByIdQueryVariables>(ReadLedgerTransactionByIdDocument, options);
      }
export function useReadLedgerTransactionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadLedgerTransactionByIdQuery, ReadLedgerTransactionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadLedgerTransactionByIdQuery, ReadLedgerTransactionByIdQueryVariables>(ReadLedgerTransactionByIdDocument, options);
        }
export function useReadLedgerTransactionByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadLedgerTransactionByIdQuery, ReadLedgerTransactionByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadLedgerTransactionByIdQuery, ReadLedgerTransactionByIdQueryVariables>(ReadLedgerTransactionByIdDocument, options);
        }
export type ReadLedgerTransactionByIdQueryHookResult = ReturnType<typeof useReadLedgerTransactionByIdQuery>;
export type ReadLedgerTransactionByIdLazyQueryHookResult = ReturnType<typeof useReadLedgerTransactionByIdLazyQuery>;
export type ReadLedgerTransactionByIdSuspenseQueryHookResult = ReturnType<typeof useReadLedgerTransactionByIdSuspenseQuery>;
export type ReadLedgerTransactionByIdQueryResult = Apollo.QueryResult<ReadLedgerTransactionByIdQuery, ReadLedgerTransactionByIdQueryVariables>;
export const ReadLedgerTransactionIdDocument = gql`
    query ReadLedgerTransactionId($transactionFactId: String!, $filter: TransactionFilter!) {
  readLedgerTransaction(transactionFactId: $transactionFactId, filter: $filter) {
    transaction {
      ledgerTransactionId
    }
  }
}
    `;

/**
 * __useReadLedgerTransactionIdQuery__
 *
 * To run a query within a React component, call `useReadLedgerTransactionIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadLedgerTransactionIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadLedgerTransactionIdQuery({
 *   variables: {
 *      transactionFactId: // value for 'transactionFactId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReadLedgerTransactionIdQuery(baseOptions: Apollo.QueryHookOptions<ReadLedgerTransactionIdQuery, ReadLedgerTransactionIdQueryVariables> & ({ variables: ReadLedgerTransactionIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadLedgerTransactionIdQuery, ReadLedgerTransactionIdQueryVariables>(ReadLedgerTransactionIdDocument, options);
      }
export function useReadLedgerTransactionIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadLedgerTransactionIdQuery, ReadLedgerTransactionIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadLedgerTransactionIdQuery, ReadLedgerTransactionIdQueryVariables>(ReadLedgerTransactionIdDocument, options);
        }
export function useReadLedgerTransactionIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadLedgerTransactionIdQuery, ReadLedgerTransactionIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadLedgerTransactionIdQuery, ReadLedgerTransactionIdQueryVariables>(ReadLedgerTransactionIdDocument, options);
        }
export type ReadLedgerTransactionIdQueryHookResult = ReturnType<typeof useReadLedgerTransactionIdQuery>;
export type ReadLedgerTransactionIdLazyQueryHookResult = ReturnType<typeof useReadLedgerTransactionIdLazyQuery>;
export type ReadLedgerTransactionIdSuspenseQueryHookResult = ReturnType<typeof useReadLedgerTransactionIdSuspenseQuery>;
export type ReadLedgerTransactionIdQueryResult = Apollo.QueryResult<ReadLedgerTransactionIdQuery, ReadLedgerTransactionIdQueryVariables>;
export const ReadMetricEquationDocument = gql`
    query ReadMetricEquation($viewKey: ViewKey!, $summaryLineType: SummaryLineItem, $metricSummaryType: MetricSummaryItem, $layoutComponentConfig: LayoutComponentConfigInput, $origin: IntervalOrigin) {
  readMetricEquation(
    viewKey: $viewKey
    summaryLineType: $summaryLineType
    metricSummaryType: $metricSummaryType
    layoutComponentConfig: $layoutComponentConfig
    origin: $origin
  ) {
    ...MetricEquationFields
  }
}
    ${MetricEquationFieldsFragmentDoc}`;

/**
 * __useReadMetricEquationQuery__
 *
 * To run a query within a React component, call `useReadMetricEquationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadMetricEquationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadMetricEquationQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      summaryLineType: // value for 'summaryLineType'
 *      metricSummaryType: // value for 'metricSummaryType'
 *      layoutComponentConfig: // value for 'layoutComponentConfig'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useReadMetricEquationQuery(baseOptions: Apollo.QueryHookOptions<ReadMetricEquationQuery, ReadMetricEquationQueryVariables> & ({ variables: ReadMetricEquationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadMetricEquationQuery, ReadMetricEquationQueryVariables>(ReadMetricEquationDocument, options);
      }
export function useReadMetricEquationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadMetricEquationQuery, ReadMetricEquationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadMetricEquationQuery, ReadMetricEquationQueryVariables>(ReadMetricEquationDocument, options);
        }
export function useReadMetricEquationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadMetricEquationQuery, ReadMetricEquationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadMetricEquationQuery, ReadMetricEquationQueryVariables>(ReadMetricEquationDocument, options);
        }
export type ReadMetricEquationQueryHookResult = ReturnType<typeof useReadMetricEquationQuery>;
export type ReadMetricEquationLazyQueryHookResult = ReturnType<typeof useReadMetricEquationLazyQuery>;
export type ReadMetricEquationSuspenseQueryHookResult = ReturnType<typeof useReadMetricEquationSuspenseQuery>;
export type ReadMetricEquationQueryResult = Apollo.QueryResult<ReadMetricEquationQuery, ReadMetricEquationQueryVariables>;
export const ReadTransactionDetailsDocument = gql`
    query ReadTransactionDetails($transactionFactId: String!, $filter: TransactionFilter!) {
  readTransactionDetails(transactionFactId: $transactionFactId, filter: $filter) {
    transaction {
      ...TransactionFields
    }
    details {
      ...TransactionViewDetailFields
    }
    isInBooksClosedPeriod
  }
}
    ${TransactionFieldsFragmentDoc}
${TransactionViewDetailFieldsFragmentDoc}`;

/**
 * __useReadTransactionDetailsQuery__
 *
 * To run a query within a React component, call `useReadTransactionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadTransactionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadTransactionDetailsQuery({
 *   variables: {
 *      transactionFactId: // value for 'transactionFactId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReadTransactionDetailsQuery(baseOptions: Apollo.QueryHookOptions<ReadTransactionDetailsQuery, ReadTransactionDetailsQueryVariables> & ({ variables: ReadTransactionDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadTransactionDetailsQuery, ReadTransactionDetailsQueryVariables>(ReadTransactionDetailsDocument, options);
      }
export function useReadTransactionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadTransactionDetailsQuery, ReadTransactionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadTransactionDetailsQuery, ReadTransactionDetailsQueryVariables>(ReadTransactionDetailsDocument, options);
        }
export function useReadTransactionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadTransactionDetailsQuery, ReadTransactionDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadTransactionDetailsQuery, ReadTransactionDetailsQueryVariables>(ReadTransactionDetailsDocument, options);
        }
export type ReadTransactionDetailsQueryHookResult = ReturnType<typeof useReadTransactionDetailsQuery>;
export type ReadTransactionDetailsLazyQueryHookResult = ReturnType<typeof useReadTransactionDetailsLazyQuery>;
export type ReadTransactionDetailsSuspenseQueryHookResult = ReturnType<typeof useReadTransactionDetailsSuspenseQuery>;
export type ReadTransactionDetailsQueryResult = Apollo.QueryResult<ReadTransactionDetailsQuery, ReadTransactionDetailsQueryVariables>;
export const ReadTransactionFactIdDocument = gql`
    query ReadTransactionFactId($legalEntityId: String!, $dataSourceId: String!, $externalId: String!, $externalLineItemId: String!) {
  readFactId(
    legalEntityId: $legalEntityId
    dataSourceId: $dataSourceId
    externalId: $externalId
    externalLineItemId: $externalLineItemId
  )
}
    `;

/**
 * __useReadTransactionFactIdQuery__
 *
 * To run a query within a React component, call `useReadTransactionFactIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadTransactionFactIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadTransactionFactIdQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      dataSourceId: // value for 'dataSourceId'
 *      externalId: // value for 'externalId'
 *      externalLineItemId: // value for 'externalLineItemId'
 *   },
 * });
 */
export function useReadTransactionFactIdQuery(baseOptions: Apollo.QueryHookOptions<ReadTransactionFactIdQuery, ReadTransactionFactIdQueryVariables> & ({ variables: ReadTransactionFactIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadTransactionFactIdQuery, ReadTransactionFactIdQueryVariables>(ReadTransactionFactIdDocument, options);
      }
export function useReadTransactionFactIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadTransactionFactIdQuery, ReadTransactionFactIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadTransactionFactIdQuery, ReadTransactionFactIdQueryVariables>(ReadTransactionFactIdDocument, options);
        }
export function useReadTransactionFactIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadTransactionFactIdQuery, ReadTransactionFactIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadTransactionFactIdQuery, ReadTransactionFactIdQueryVariables>(ReadTransactionFactIdDocument, options);
        }
export type ReadTransactionFactIdQueryHookResult = ReturnType<typeof useReadTransactionFactIdQuery>;
export type ReadTransactionFactIdLazyQueryHookResult = ReturnType<typeof useReadTransactionFactIdLazyQuery>;
export type ReadTransactionFactIdSuspenseQueryHookResult = ReturnType<typeof useReadTransactionFactIdSuspenseQuery>;
export type ReadTransactionFactIdQueryResult = Apollo.QueryResult<ReadTransactionFactIdQuery, ReadTransactionFactIdQueryVariables>;
export const ReadTransactionWorkItemIdDocument = gql`
    query ReadTransactionWorkItemID($transactionFactId: String!, $legalEntityId: String!) {
  readTransactionWorkItemId(
    factId: $transactionFactId
    legalEntityId: $legalEntityId
  )
}
    `;

/**
 * __useReadTransactionWorkItemIdQuery__
 *
 * To run a query within a React component, call `useReadTransactionWorkItemIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadTransactionWorkItemIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadTransactionWorkItemIdQuery({
 *   variables: {
 *      transactionFactId: // value for 'transactionFactId'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadTransactionWorkItemIdQuery(baseOptions: Apollo.QueryHookOptions<ReadTransactionWorkItemIdQuery, ReadTransactionWorkItemIdQueryVariables> & ({ variables: ReadTransactionWorkItemIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadTransactionWorkItemIdQuery, ReadTransactionWorkItemIdQueryVariables>(ReadTransactionWorkItemIdDocument, options);
      }
export function useReadTransactionWorkItemIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadTransactionWorkItemIdQuery, ReadTransactionWorkItemIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadTransactionWorkItemIdQuery, ReadTransactionWorkItemIdQueryVariables>(ReadTransactionWorkItemIdDocument, options);
        }
export function useReadTransactionWorkItemIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadTransactionWorkItemIdQuery, ReadTransactionWorkItemIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadTransactionWorkItemIdQuery, ReadTransactionWorkItemIdQueryVariables>(ReadTransactionWorkItemIdDocument, options);
        }
export type ReadTransactionWorkItemIdQueryHookResult = ReturnType<typeof useReadTransactionWorkItemIdQuery>;
export type ReadTransactionWorkItemIdLazyQueryHookResult = ReturnType<typeof useReadTransactionWorkItemIdLazyQuery>;
export type ReadTransactionWorkItemIdSuspenseQueryHookResult = ReturnType<typeof useReadTransactionWorkItemIdSuspenseQuery>;
export type ReadTransactionWorkItemIdQueryResult = Apollo.QueryResult<ReadTransactionWorkItemIdQuery, ReadTransactionWorkItemIdQueryVariables>;
export const SummarizeCategoryTransactionsByTimeDocument = gql`
    query SummarizeCategoryTransactionsByTime($filter: SummaryFilterInput!, $origin: IntervalOrigin!, $direction: DirectionFromOrigin!, $asPermanent: Boolean, $directBookings: Boolean, $naturalFlow: Flow, $defaultCategoryType: CategoryType) {
  dimensionalTransactionSummary(
    filter: $filter
    origin: $origin
    direction: $direction
    dimensions: [Time, Category]
    masks: [Time]
    asPermanent: $asPermanent
    directBookings: $directBookings
    naturalFlow: $naturalFlow
    defaultCategoryType: $defaultCategoryType
  ) {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
  }
}
    ${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeCategoryTransactionsByTimeQuery__
 *
 * To run a query within a React component, call `useSummarizeCategoryTransactionsByTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeCategoryTransactionsByTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeCategoryTransactionsByTimeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      origin: // value for 'origin'
 *      direction: // value for 'direction'
 *      asPermanent: // value for 'asPermanent'
 *      directBookings: // value for 'directBookings'
 *      naturalFlow: // value for 'naturalFlow'
 *      defaultCategoryType: // value for 'defaultCategoryType'
 *   },
 * });
 */
export function useSummarizeCategoryTransactionsByTimeQuery(baseOptions: Apollo.QueryHookOptions<SummarizeCategoryTransactionsByTimeQuery, SummarizeCategoryTransactionsByTimeQueryVariables> & ({ variables: SummarizeCategoryTransactionsByTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeCategoryTransactionsByTimeQuery, SummarizeCategoryTransactionsByTimeQueryVariables>(SummarizeCategoryTransactionsByTimeDocument, options);
      }
export function useSummarizeCategoryTransactionsByTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeCategoryTransactionsByTimeQuery, SummarizeCategoryTransactionsByTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeCategoryTransactionsByTimeQuery, SummarizeCategoryTransactionsByTimeQueryVariables>(SummarizeCategoryTransactionsByTimeDocument, options);
        }
export function useSummarizeCategoryTransactionsByTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeCategoryTransactionsByTimeQuery, SummarizeCategoryTransactionsByTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeCategoryTransactionsByTimeQuery, SummarizeCategoryTransactionsByTimeQueryVariables>(SummarizeCategoryTransactionsByTimeDocument, options);
        }
export type SummarizeCategoryTransactionsByTimeQueryHookResult = ReturnType<typeof useSummarizeCategoryTransactionsByTimeQuery>;
export type SummarizeCategoryTransactionsByTimeLazyQueryHookResult = ReturnType<typeof useSummarizeCategoryTransactionsByTimeLazyQuery>;
export type SummarizeCategoryTransactionsByTimeSuspenseQueryHookResult = ReturnType<typeof useSummarizeCategoryTransactionsByTimeSuspenseQuery>;
export type SummarizeCategoryTransactionsByTimeQueryResult = Apollo.QueryResult<SummarizeCategoryTransactionsByTimeQuery, SummarizeCategoryTransactionsByTimeQueryVariables>;
export const SummarizeMetricTransactionsByTimeDocument = gql`
    query SummarizeMetricTransactionsByTime($viewKey: ViewKey!, $origin: IntervalOrigin!, $metricSummaryType: MetricSummaryItem, $summaryLineType: SummaryLineItem) {
  metricTransactionSummary(
    viewKey: $viewKey
    origin: $origin
    metricSummaryType: $metricSummaryType
    summaryLineType: $summaryLineType
  ) {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
  }
}
    ${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeMetricTransactionsByTimeQuery__
 *
 * To run a query within a React component, call `useSummarizeMetricTransactionsByTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeMetricTransactionsByTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeMetricTransactionsByTimeQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      origin: // value for 'origin'
 *      metricSummaryType: // value for 'metricSummaryType'
 *      summaryLineType: // value for 'summaryLineType'
 *   },
 * });
 */
export function useSummarizeMetricTransactionsByTimeQuery(baseOptions: Apollo.QueryHookOptions<SummarizeMetricTransactionsByTimeQuery, SummarizeMetricTransactionsByTimeQueryVariables> & ({ variables: SummarizeMetricTransactionsByTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeMetricTransactionsByTimeQuery, SummarizeMetricTransactionsByTimeQueryVariables>(SummarizeMetricTransactionsByTimeDocument, options);
      }
export function useSummarizeMetricTransactionsByTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeMetricTransactionsByTimeQuery, SummarizeMetricTransactionsByTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeMetricTransactionsByTimeQuery, SummarizeMetricTransactionsByTimeQueryVariables>(SummarizeMetricTransactionsByTimeDocument, options);
        }
export function useSummarizeMetricTransactionsByTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeMetricTransactionsByTimeQuery, SummarizeMetricTransactionsByTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeMetricTransactionsByTimeQuery, SummarizeMetricTransactionsByTimeQueryVariables>(SummarizeMetricTransactionsByTimeDocument, options);
        }
export type SummarizeMetricTransactionsByTimeQueryHookResult = ReturnType<typeof useSummarizeMetricTransactionsByTimeQuery>;
export type SummarizeMetricTransactionsByTimeLazyQueryHookResult = ReturnType<typeof useSummarizeMetricTransactionsByTimeLazyQuery>;
export type SummarizeMetricTransactionsByTimeSuspenseQueryHookResult = ReturnType<typeof useSummarizeMetricTransactionsByTimeSuspenseQuery>;
export type SummarizeMetricTransactionsByTimeQueryResult = Apollo.QueryResult<SummarizeMetricTransactionsByTimeQuery, SummarizeMetricTransactionsByTimeQueryVariables>;
export const SummarizeTransactionsByCategoryDocument = gql`
    query SummarizeTransactionsByCategory($filter: SummaryFilterInput!, $direction: DirectionFromOrigin!, $origin: IntervalOrigin!, $sort: DimensionSortMode, $limit: Int, $asPermanent: Boolean, $directBookings: Boolean, $naturalFlow: Flow, $defaultCategoryType: CategoryType, $pagination: DimensionPaginationInput) {
  dimensionalTransactionSummary(
    filter: $filter
    origin: $origin
    direction: $direction
    dimensions: [Category]
    asPermanent: $asPermanent
    directBookings: $directBookings
    naturalFlow: $naturalFlow
    defaultCategoryType: $defaultCategoryType
    pagination: $pagination
  ) {
    category(limit: $limit, sort: $sort) {
      categoryObject {
        ...EntityCategoryFields
      }
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
  }
}
    ${EntityCategoryFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeTransactionsByCategoryQuery__
 *
 * To run a query within a React component, call `useSummarizeTransactionsByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTransactionsByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTransactionsByCategoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      direction: // value for 'direction'
 *      origin: // value for 'origin'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      asPermanent: // value for 'asPermanent'
 *      directBookings: // value for 'directBookings'
 *      naturalFlow: // value for 'naturalFlow'
 *      defaultCategoryType: // value for 'defaultCategoryType'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSummarizeTransactionsByCategoryQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTransactionsByCategoryQuery, SummarizeTransactionsByCategoryQueryVariables> & ({ variables: SummarizeTransactionsByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTransactionsByCategoryQuery, SummarizeTransactionsByCategoryQueryVariables>(SummarizeTransactionsByCategoryDocument, options);
      }
export function useSummarizeTransactionsByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTransactionsByCategoryQuery, SummarizeTransactionsByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTransactionsByCategoryQuery, SummarizeTransactionsByCategoryQueryVariables>(SummarizeTransactionsByCategoryDocument, options);
        }
export function useSummarizeTransactionsByCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTransactionsByCategoryQuery, SummarizeTransactionsByCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTransactionsByCategoryQuery, SummarizeTransactionsByCategoryQueryVariables>(SummarizeTransactionsByCategoryDocument, options);
        }
export type SummarizeTransactionsByCategoryQueryHookResult = ReturnType<typeof useSummarizeTransactionsByCategoryQuery>;
export type SummarizeTransactionsByCategoryLazyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByCategoryLazyQuery>;
export type SummarizeTransactionsByCategorySuspenseQueryHookResult = ReturnType<typeof useSummarizeTransactionsByCategorySuspenseQuery>;
export type SummarizeTransactionsByCategoryQueryResult = Apollo.QueryResult<SummarizeTransactionsByCategoryQuery, SummarizeTransactionsByCategoryQueryVariables>;
export const SummarizeTransactionsByCategoryByTimeDocument = gql`
    query SummarizeTransactionsByCategoryByTime($filter: SummaryFilterInput!, $direction: DirectionFromOrigin!, $origin: IntervalOrigin!, $sort: DimensionSortMode, $limit: Int, $masks: [[SummaryDimension!]!], $asPermanent: Boolean, $directBookings: Boolean) {
  dimensionalTransactionSummary(
    filter: $filter
    origin: $origin
    direction: $direction
    dimensions: [Category, Time]
    masks: $masks
    asPermanent: $asPermanent
    directBookings: $directBookings
  ) {
    category(limit: $limit, sort: $sort) {
      categoryObject {
        ...EntityCategoryFields
      }
      by {
        time {
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
    partialData
  }
}
    ${EntityCategoryFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeTransactionsByCategoryByTimeQuery__
 *
 * To run a query within a React component, call `useSummarizeTransactionsByCategoryByTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTransactionsByCategoryByTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTransactionsByCategoryByTimeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      direction: // value for 'direction'
 *      origin: // value for 'origin'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      masks: // value for 'masks'
 *      asPermanent: // value for 'asPermanent'
 *      directBookings: // value for 'directBookings'
 *   },
 * });
 */
export function useSummarizeTransactionsByCategoryByTimeQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTransactionsByCategoryByTimeQuery, SummarizeTransactionsByCategoryByTimeQueryVariables> & ({ variables: SummarizeTransactionsByCategoryByTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTransactionsByCategoryByTimeQuery, SummarizeTransactionsByCategoryByTimeQueryVariables>(SummarizeTransactionsByCategoryByTimeDocument, options);
      }
export function useSummarizeTransactionsByCategoryByTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTransactionsByCategoryByTimeQuery, SummarizeTransactionsByCategoryByTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTransactionsByCategoryByTimeQuery, SummarizeTransactionsByCategoryByTimeQueryVariables>(SummarizeTransactionsByCategoryByTimeDocument, options);
        }
export function useSummarizeTransactionsByCategoryByTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTransactionsByCategoryByTimeQuery, SummarizeTransactionsByCategoryByTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTransactionsByCategoryByTimeQuery, SummarizeTransactionsByCategoryByTimeQueryVariables>(SummarizeTransactionsByCategoryByTimeDocument, options);
        }
export type SummarizeTransactionsByCategoryByTimeQueryHookResult = ReturnType<typeof useSummarizeTransactionsByCategoryByTimeQuery>;
export type SummarizeTransactionsByCategoryByTimeLazyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByCategoryByTimeLazyQuery>;
export type SummarizeTransactionsByCategoryByTimeSuspenseQueryHookResult = ReturnType<typeof useSummarizeTransactionsByCategoryByTimeSuspenseQuery>;
export type SummarizeTransactionsByCategoryByTimeQueryResult = Apollo.QueryResult<SummarizeTransactionsByCategoryByTimeQuery, SummarizeTransactionsByCategoryByTimeQueryVariables>;
export const SummarizeTransactionsByCategoryHierarchyByTimeDocument = gql`
    query SummarizeTransactionsByCategoryHierarchyByTime($filter: SummaryFilterInput!, $direction: DirectionFromOrigin!, $origin: IntervalOrigin!, $asPermanent: Boolean, $directBookings: Boolean) {
  dimensionalTransactionSummary(
    filter: $filter
    origin: $origin
    direction: $direction
    dimensions: [Category, Time]
    asPermanent: $asPermanent
    directBookings: $directBookings
  ) {
    category {
      categoryObject {
        ...EntityCategoryFields
      }
      by {
        time {
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
    partialData
  }
}
    ${EntityCategoryFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeTransactionsByCategoryHierarchyByTimeQuery__
 *
 * To run a query within a React component, call `useSummarizeTransactionsByCategoryHierarchyByTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTransactionsByCategoryHierarchyByTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTransactionsByCategoryHierarchyByTimeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      direction: // value for 'direction'
 *      origin: // value for 'origin'
 *      asPermanent: // value for 'asPermanent'
 *      directBookings: // value for 'directBookings'
 *   },
 * });
 */
export function useSummarizeTransactionsByCategoryHierarchyByTimeQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTransactionsByCategoryHierarchyByTimeQuery, SummarizeTransactionsByCategoryHierarchyByTimeQueryVariables> & ({ variables: SummarizeTransactionsByCategoryHierarchyByTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTransactionsByCategoryHierarchyByTimeQuery, SummarizeTransactionsByCategoryHierarchyByTimeQueryVariables>(SummarizeTransactionsByCategoryHierarchyByTimeDocument, options);
      }
export function useSummarizeTransactionsByCategoryHierarchyByTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTransactionsByCategoryHierarchyByTimeQuery, SummarizeTransactionsByCategoryHierarchyByTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTransactionsByCategoryHierarchyByTimeQuery, SummarizeTransactionsByCategoryHierarchyByTimeQueryVariables>(SummarizeTransactionsByCategoryHierarchyByTimeDocument, options);
        }
export function useSummarizeTransactionsByCategoryHierarchyByTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTransactionsByCategoryHierarchyByTimeQuery, SummarizeTransactionsByCategoryHierarchyByTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTransactionsByCategoryHierarchyByTimeQuery, SummarizeTransactionsByCategoryHierarchyByTimeQueryVariables>(SummarizeTransactionsByCategoryHierarchyByTimeDocument, options);
        }
export type SummarizeTransactionsByCategoryHierarchyByTimeQueryHookResult = ReturnType<typeof useSummarizeTransactionsByCategoryHierarchyByTimeQuery>;
export type SummarizeTransactionsByCategoryHierarchyByTimeLazyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByCategoryHierarchyByTimeLazyQuery>;
export type SummarizeTransactionsByCategoryHierarchyByTimeSuspenseQueryHookResult = ReturnType<typeof useSummarizeTransactionsByCategoryHierarchyByTimeSuspenseQuery>;
export type SummarizeTransactionsByCategoryHierarchyByTimeQueryResult = Apollo.QueryResult<SummarizeTransactionsByCategoryHierarchyByTimeQuery, SummarizeTransactionsByCategoryHierarchyByTimeQueryVariables>;
export const SummarizeTransactionsByDepartmentDocument = gql`
    query SummarizeTransactionsByDepartment($filter: SummaryFilterInput!, $direction: DirectionFromOrigin!, $origin: IntervalOrigin!, $sort: DimensionSortMode, $limit: Int, $asPermanent: Boolean, $directBookings: Boolean, $naturalFlow: Flow, $defaultCategoryType: CategoryType, $pagination: DimensionPaginationInput) {
  dimensionalTransactionSummary(
    filter: $filter
    origin: $origin
    direction: $direction
    dimensions: [Department]
    asPermanent: $asPermanent
    directBookings: $directBookings
    naturalFlow: $naturalFlow
    defaultCategoryType: $defaultCategoryType
    pagination: $pagination
  ) {
    department(limit: $limit, sort: $sort) {
      departmentObject {
        ...EntityDepartmentFields
      }
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
  }
}
    ${EntityDepartmentFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeTransactionsByDepartmentQuery__
 *
 * To run a query within a React component, call `useSummarizeTransactionsByDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTransactionsByDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTransactionsByDepartmentQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      direction: // value for 'direction'
 *      origin: // value for 'origin'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      asPermanent: // value for 'asPermanent'
 *      directBookings: // value for 'directBookings'
 *      naturalFlow: // value for 'naturalFlow'
 *      defaultCategoryType: // value for 'defaultCategoryType'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSummarizeTransactionsByDepartmentQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTransactionsByDepartmentQuery, SummarizeTransactionsByDepartmentQueryVariables> & ({ variables: SummarizeTransactionsByDepartmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTransactionsByDepartmentQuery, SummarizeTransactionsByDepartmentQueryVariables>(SummarizeTransactionsByDepartmentDocument, options);
      }
export function useSummarizeTransactionsByDepartmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTransactionsByDepartmentQuery, SummarizeTransactionsByDepartmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTransactionsByDepartmentQuery, SummarizeTransactionsByDepartmentQueryVariables>(SummarizeTransactionsByDepartmentDocument, options);
        }
export function useSummarizeTransactionsByDepartmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTransactionsByDepartmentQuery, SummarizeTransactionsByDepartmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTransactionsByDepartmentQuery, SummarizeTransactionsByDepartmentQueryVariables>(SummarizeTransactionsByDepartmentDocument, options);
        }
export type SummarizeTransactionsByDepartmentQueryHookResult = ReturnType<typeof useSummarizeTransactionsByDepartmentQuery>;
export type SummarizeTransactionsByDepartmentLazyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByDepartmentLazyQuery>;
export type SummarizeTransactionsByDepartmentSuspenseQueryHookResult = ReturnType<typeof useSummarizeTransactionsByDepartmentSuspenseQuery>;
export type SummarizeTransactionsByDepartmentQueryResult = Apollo.QueryResult<SummarizeTransactionsByDepartmentQuery, SummarizeTransactionsByDepartmentQueryVariables>;
export const SummarizeTransactionsByDepartmentByTimeDocument = gql`
    query SummarizeTransactionsByDepartmentByTime($filter: SummaryFilterInput!, $direction: DirectionFromOrigin!, $origin: IntervalOrigin!, $directBookings: Boolean) {
  dimensionalTransactionSummary(
    filter: $filter
    origin: $origin
    direction: $direction
    dimensions: [Department, Time]
    directBookings: $directBookings
  ) {
    department {
      departmentId
      departmentObject {
        ...EntityDepartmentFields
      }
      by {
        time {
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
    partialData
  }
}
    ${EntityDepartmentFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeTransactionsByDepartmentByTimeQuery__
 *
 * To run a query within a React component, call `useSummarizeTransactionsByDepartmentByTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTransactionsByDepartmentByTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTransactionsByDepartmentByTimeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      direction: // value for 'direction'
 *      origin: // value for 'origin'
 *      directBookings: // value for 'directBookings'
 *   },
 * });
 */
export function useSummarizeTransactionsByDepartmentByTimeQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTransactionsByDepartmentByTimeQuery, SummarizeTransactionsByDepartmentByTimeQueryVariables> & ({ variables: SummarizeTransactionsByDepartmentByTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTransactionsByDepartmentByTimeQuery, SummarizeTransactionsByDepartmentByTimeQueryVariables>(SummarizeTransactionsByDepartmentByTimeDocument, options);
      }
export function useSummarizeTransactionsByDepartmentByTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTransactionsByDepartmentByTimeQuery, SummarizeTransactionsByDepartmentByTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTransactionsByDepartmentByTimeQuery, SummarizeTransactionsByDepartmentByTimeQueryVariables>(SummarizeTransactionsByDepartmentByTimeDocument, options);
        }
export function useSummarizeTransactionsByDepartmentByTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTransactionsByDepartmentByTimeQuery, SummarizeTransactionsByDepartmentByTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTransactionsByDepartmentByTimeQuery, SummarizeTransactionsByDepartmentByTimeQueryVariables>(SummarizeTransactionsByDepartmentByTimeDocument, options);
        }
export type SummarizeTransactionsByDepartmentByTimeQueryHookResult = ReturnType<typeof useSummarizeTransactionsByDepartmentByTimeQuery>;
export type SummarizeTransactionsByDepartmentByTimeLazyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByDepartmentByTimeLazyQuery>;
export type SummarizeTransactionsByDepartmentByTimeSuspenseQueryHookResult = ReturnType<typeof useSummarizeTransactionsByDepartmentByTimeSuspenseQuery>;
export type SummarizeTransactionsByDepartmentByTimeQueryResult = Apollo.QueryResult<SummarizeTransactionsByDepartmentByTimeQuery, SummarizeTransactionsByDepartmentByTimeQueryVariables>;
export const SummarizeTransactionsByLocationDocument = gql`
    query SummarizeTransactionsByLocation($filter: SummaryFilterInput!, $direction: DirectionFromOrigin!, $origin: IntervalOrigin!, $sort: DimensionSortMode, $limit: Int, $asPermanent: Boolean, $directBookings: Boolean, $naturalFlow: Flow, $defaultCategoryType: CategoryType, $pagination: DimensionPaginationInput) {
  dimensionalTransactionSummary(
    filter: $filter
    origin: $origin
    direction: $direction
    dimensions: [Location]
    asPermanent: $asPermanent
    directBookings: $directBookings
    naturalFlow: $naturalFlow
    defaultCategoryType: $defaultCategoryType
    pagination: $pagination
  ) {
    location(limit: $limit, sort: $sort) {
      locationObject {
        ...EntityLocationFields
      }
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
  }
}
    ${EntityLocationFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeTransactionsByLocationQuery__
 *
 * To run a query within a React component, call `useSummarizeTransactionsByLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTransactionsByLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTransactionsByLocationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      direction: // value for 'direction'
 *      origin: // value for 'origin'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      asPermanent: // value for 'asPermanent'
 *      directBookings: // value for 'directBookings'
 *      naturalFlow: // value for 'naturalFlow'
 *      defaultCategoryType: // value for 'defaultCategoryType'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSummarizeTransactionsByLocationQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTransactionsByLocationQuery, SummarizeTransactionsByLocationQueryVariables> & ({ variables: SummarizeTransactionsByLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTransactionsByLocationQuery, SummarizeTransactionsByLocationQueryVariables>(SummarizeTransactionsByLocationDocument, options);
      }
export function useSummarizeTransactionsByLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTransactionsByLocationQuery, SummarizeTransactionsByLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTransactionsByLocationQuery, SummarizeTransactionsByLocationQueryVariables>(SummarizeTransactionsByLocationDocument, options);
        }
export function useSummarizeTransactionsByLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTransactionsByLocationQuery, SummarizeTransactionsByLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTransactionsByLocationQuery, SummarizeTransactionsByLocationQueryVariables>(SummarizeTransactionsByLocationDocument, options);
        }
export type SummarizeTransactionsByLocationQueryHookResult = ReturnType<typeof useSummarizeTransactionsByLocationQuery>;
export type SummarizeTransactionsByLocationLazyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByLocationLazyQuery>;
export type SummarizeTransactionsByLocationSuspenseQueryHookResult = ReturnType<typeof useSummarizeTransactionsByLocationSuspenseQuery>;
export type SummarizeTransactionsByLocationQueryResult = Apollo.QueryResult<SummarizeTransactionsByLocationQuery, SummarizeTransactionsByLocationQueryVariables>;
export const SummarizeTransactionsByLocationByTimeDocument = gql`
    query SummarizeTransactionsByLocationByTime($filter: SummaryFilterInput!, $direction: DirectionFromOrigin!, $origin: IntervalOrigin!, $directBookings: Boolean, $naturalFlow: Flow!, $defaultCategoryType: CategoryType) {
  dimensionalTransactionSummary(
    filter: $filter
    origin: $origin
    direction: $direction
    dimensions: [Location, Time]
    directBookings: $directBookings
    naturalFlow: $naturalFlow
    defaultCategoryType: $defaultCategoryType
  ) {
    location {
      locationObject {
        ...EntityLocationFields
      }
      locationId
      by {
        time {
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
    partialData
  }
}
    ${EntityLocationFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeTransactionsByLocationByTimeQuery__
 *
 * To run a query within a React component, call `useSummarizeTransactionsByLocationByTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTransactionsByLocationByTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTransactionsByLocationByTimeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      direction: // value for 'direction'
 *      origin: // value for 'origin'
 *      directBookings: // value for 'directBookings'
 *      naturalFlow: // value for 'naturalFlow'
 *      defaultCategoryType: // value for 'defaultCategoryType'
 *   },
 * });
 */
export function useSummarizeTransactionsByLocationByTimeQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTransactionsByLocationByTimeQuery, SummarizeTransactionsByLocationByTimeQueryVariables> & ({ variables: SummarizeTransactionsByLocationByTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTransactionsByLocationByTimeQuery, SummarizeTransactionsByLocationByTimeQueryVariables>(SummarizeTransactionsByLocationByTimeDocument, options);
      }
export function useSummarizeTransactionsByLocationByTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTransactionsByLocationByTimeQuery, SummarizeTransactionsByLocationByTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTransactionsByLocationByTimeQuery, SummarizeTransactionsByLocationByTimeQueryVariables>(SummarizeTransactionsByLocationByTimeDocument, options);
        }
export function useSummarizeTransactionsByLocationByTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTransactionsByLocationByTimeQuery, SummarizeTransactionsByLocationByTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTransactionsByLocationByTimeQuery, SummarizeTransactionsByLocationByTimeQueryVariables>(SummarizeTransactionsByLocationByTimeDocument, options);
        }
export type SummarizeTransactionsByLocationByTimeQueryHookResult = ReturnType<typeof useSummarizeTransactionsByLocationByTimeQuery>;
export type SummarizeTransactionsByLocationByTimeLazyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByLocationByTimeLazyQuery>;
export type SummarizeTransactionsByLocationByTimeSuspenseQueryHookResult = ReturnType<typeof useSummarizeTransactionsByLocationByTimeSuspenseQuery>;
export type SummarizeTransactionsByLocationByTimeQueryResult = Apollo.QueryResult<SummarizeTransactionsByLocationByTimeQuery, SummarizeTransactionsByLocationByTimeQueryVariables>;
export const SummarizeTransactionsByPartyDocument = gql`
    query SummarizeTransactionsByParty($filter: SummaryFilterInput!, $direction: DirectionFromOrigin!, $origin: IntervalOrigin!, $asPermanent: Boolean, $sort: DimensionSortMode, $limit: Int, $matchBy: Matcher, $masks: [[SummaryDimension!]!], $directBookings: Boolean, $naturalFlow: Flow, $defaultCategoryType: CategoryType, $pagination: DimensionPaginationInput) {
  dimensionalTransactionSummary(
    filter: $filter
    origin: $origin
    direction: $direction
    dimensions: [Party]
    asPermanent: $asPermanent
    matchBy: $matchBy
    masks: $masks
    directBookings: $directBookings
    naturalFlow: $naturalFlow
    defaultCategoryType: $defaultCategoryType
    pagination: $pagination
    aggregateFacetKind: TransactionParty
  ) {
    party(limit: $limit, sort: $sort) {
      partyObject {
        ...EntityPartyFields
      }
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
    aggregateFacetCount
  }
}
    ${EntityPartyFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeTransactionsByPartyQuery__
 *
 * To run a query within a React component, call `useSummarizeTransactionsByPartyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTransactionsByPartyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTransactionsByPartyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      direction: // value for 'direction'
 *      origin: // value for 'origin'
 *      asPermanent: // value for 'asPermanent'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      matchBy: // value for 'matchBy'
 *      masks: // value for 'masks'
 *      directBookings: // value for 'directBookings'
 *      naturalFlow: // value for 'naturalFlow'
 *      defaultCategoryType: // value for 'defaultCategoryType'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSummarizeTransactionsByPartyQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTransactionsByPartyQuery, SummarizeTransactionsByPartyQueryVariables> & ({ variables: SummarizeTransactionsByPartyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTransactionsByPartyQuery, SummarizeTransactionsByPartyQueryVariables>(SummarizeTransactionsByPartyDocument, options);
      }
export function useSummarizeTransactionsByPartyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTransactionsByPartyQuery, SummarizeTransactionsByPartyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTransactionsByPartyQuery, SummarizeTransactionsByPartyQueryVariables>(SummarizeTransactionsByPartyDocument, options);
        }
export function useSummarizeTransactionsByPartySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTransactionsByPartyQuery, SummarizeTransactionsByPartyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTransactionsByPartyQuery, SummarizeTransactionsByPartyQueryVariables>(SummarizeTransactionsByPartyDocument, options);
        }
export type SummarizeTransactionsByPartyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByPartyQuery>;
export type SummarizeTransactionsByPartyLazyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByPartyLazyQuery>;
export type SummarizeTransactionsByPartySuspenseQueryHookResult = ReturnType<typeof useSummarizeTransactionsByPartySuspenseQuery>;
export type SummarizeTransactionsByPartyQueryResult = Apollo.QueryResult<SummarizeTransactionsByPartyQuery, SummarizeTransactionsByPartyQueryVariables>;
export const SummarizeTransactionsByPartyByCategoryDocument = gql`
    query SummarizeTransactionsByPartyByCategory($filter: SummaryFilterInput!, $direction: DirectionFromOrigin!, $origin: IntervalOrigin!, $asPermanent: Boolean, $matchBy: Matcher, $masks: [[SummaryDimension!]!], $directBookings: Boolean, $defaultCategoryType: CategoryType) {
  dimensionalTransactionSummary(
    filter: $filter
    origin: $origin
    direction: $direction
    dimensions: [Party, Category]
    asPermanent: $asPermanent
    matchBy: $matchBy
    masks: $masks
    directBookings: $directBookings
    defaultCategoryType: $defaultCategoryType
  ) {
    party {
      partyObject {
        ...EntityPartyFields
      }
      summary {
        ...TransactionSummaryFields
      }
      by {
        category(sort: Active) {
          categoryObject {
            ...EntityCategoryFields
          }
        }
      }
    }
    partialData
  }
}
    ${EntityPartyFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}`;

/**
 * __useSummarizeTransactionsByPartyByCategoryQuery__
 *
 * To run a query within a React component, call `useSummarizeTransactionsByPartyByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTransactionsByPartyByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTransactionsByPartyByCategoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      direction: // value for 'direction'
 *      origin: // value for 'origin'
 *      asPermanent: // value for 'asPermanent'
 *      matchBy: // value for 'matchBy'
 *      masks: // value for 'masks'
 *      directBookings: // value for 'directBookings'
 *      defaultCategoryType: // value for 'defaultCategoryType'
 *   },
 * });
 */
export function useSummarizeTransactionsByPartyByCategoryQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTransactionsByPartyByCategoryQuery, SummarizeTransactionsByPartyByCategoryQueryVariables> & ({ variables: SummarizeTransactionsByPartyByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTransactionsByPartyByCategoryQuery, SummarizeTransactionsByPartyByCategoryQueryVariables>(SummarizeTransactionsByPartyByCategoryDocument, options);
      }
export function useSummarizeTransactionsByPartyByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTransactionsByPartyByCategoryQuery, SummarizeTransactionsByPartyByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTransactionsByPartyByCategoryQuery, SummarizeTransactionsByPartyByCategoryQueryVariables>(SummarizeTransactionsByPartyByCategoryDocument, options);
        }
export function useSummarizeTransactionsByPartyByCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTransactionsByPartyByCategoryQuery, SummarizeTransactionsByPartyByCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTransactionsByPartyByCategoryQuery, SummarizeTransactionsByPartyByCategoryQueryVariables>(SummarizeTransactionsByPartyByCategoryDocument, options);
        }
export type SummarizeTransactionsByPartyByCategoryQueryHookResult = ReturnType<typeof useSummarizeTransactionsByPartyByCategoryQuery>;
export type SummarizeTransactionsByPartyByCategoryLazyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByPartyByCategoryLazyQuery>;
export type SummarizeTransactionsByPartyByCategorySuspenseQueryHookResult = ReturnType<typeof useSummarizeTransactionsByPartyByCategorySuspenseQuery>;
export type SummarizeTransactionsByPartyByCategoryQueryResult = Apollo.QueryResult<SummarizeTransactionsByPartyByCategoryQuery, SummarizeTransactionsByPartyByCategoryQueryVariables>;
export const SummarizeTransactionsByPartyByTimeDocument = gql`
    query SummarizeTransactionsByPartyByTime($filter: SummaryFilterInput!, $paginationDirection: DirectionFromOrigin!, $intervalOrigin: IntervalOrigin!, $asPermanent: Boolean, $sort: DimensionSortMode, $limit: Int, $masks: [[SummaryDimension!]!], $matchBy: Matcher, $directBookings: Boolean, $naturalFlow: Flow, $defaultCategoryType: CategoryType) {
  dimensionalTransactionSummary(
    filter: $filter
    origin: $intervalOrigin
    direction: $paginationDirection
    dimensions: [Party, Time]
    asPermanent: $asPermanent
    matchBy: $matchBy
    masks: $masks
    directBookings: $directBookings
    naturalFlow: $naturalFlow
    defaultCategoryType: $defaultCategoryType
  ) {
    party(limit: $limit, sort: $sort) {
      partyObject {
        ...EntityPartyFields
      }
      by {
        time {
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
    partialData
  }
}
    ${EntityPartyFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeTransactionsByPartyByTimeQuery__
 *
 * To run a query within a React component, call `useSummarizeTransactionsByPartyByTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTransactionsByPartyByTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTransactionsByPartyByTimeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paginationDirection: // value for 'paginationDirection'
 *      intervalOrigin: // value for 'intervalOrigin'
 *      asPermanent: // value for 'asPermanent'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      masks: // value for 'masks'
 *      matchBy: // value for 'matchBy'
 *      directBookings: // value for 'directBookings'
 *      naturalFlow: // value for 'naturalFlow'
 *      defaultCategoryType: // value for 'defaultCategoryType'
 *   },
 * });
 */
export function useSummarizeTransactionsByPartyByTimeQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTransactionsByPartyByTimeQuery, SummarizeTransactionsByPartyByTimeQueryVariables> & ({ variables: SummarizeTransactionsByPartyByTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTransactionsByPartyByTimeQuery, SummarizeTransactionsByPartyByTimeQueryVariables>(SummarizeTransactionsByPartyByTimeDocument, options);
      }
export function useSummarizeTransactionsByPartyByTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTransactionsByPartyByTimeQuery, SummarizeTransactionsByPartyByTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTransactionsByPartyByTimeQuery, SummarizeTransactionsByPartyByTimeQueryVariables>(SummarizeTransactionsByPartyByTimeDocument, options);
        }
export function useSummarizeTransactionsByPartyByTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTransactionsByPartyByTimeQuery, SummarizeTransactionsByPartyByTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTransactionsByPartyByTimeQuery, SummarizeTransactionsByPartyByTimeQueryVariables>(SummarizeTransactionsByPartyByTimeDocument, options);
        }
export type SummarizeTransactionsByPartyByTimeQueryHookResult = ReturnType<typeof useSummarizeTransactionsByPartyByTimeQuery>;
export type SummarizeTransactionsByPartyByTimeLazyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByPartyByTimeLazyQuery>;
export type SummarizeTransactionsByPartyByTimeSuspenseQueryHookResult = ReturnType<typeof useSummarizeTransactionsByPartyByTimeSuspenseQuery>;
export type SummarizeTransactionsByPartyByTimeQueryResult = Apollo.QueryResult<SummarizeTransactionsByPartyByTimeQuery, SummarizeTransactionsByPartyByTimeQueryVariables>;
export const SummarizeTransactionsByScheduleAmountByCategoryDocument = gql`
    query SummarizeTransactionsByScheduleAmountByCategory($viewKey: ViewKey!, $origin: IntervalOrigin!, $direction: DirectionFromOrigin!, $scheduleCategoryIds: [String!], $scheduleRelatedCategoryIds: [String!], $schedulePartyIds: [String!], $scheduleMinAmount: InputMonetaryValue, $scheduleMaxAmount: InputMonetaryValue, $scheduleStartDateMin: DateTime, $scheduleStartDateMax: DateTime, $scheduleEndDateMin: DateTime, $scheduleEndDateMax: DateTime, $filterTerm: String, $skipFixedAsset: Boolean!, $skipPrepaidExpense: Boolean!) {
  fixedAssetAmounts: dimensionalTransactionSummary(
    filter: {viewKey: $viewKey, scheduleTypes: [FixedAsset], categorySubtypes: [FixedAssets], withoutCategoryAncestors: true, scheduleScope: ScheduleInitialization, scheduleCategoryIds: $scheduleCategoryIds, scheduleRelatedCategoryIds: $scheduleRelatedCategoryIds, schedulePartyIds: $schedulePartyIds, scheduleMinAmount: $scheduleMinAmount, scheduleMaxAmount: $scheduleMaxAmount, scheduleStartDateMin: $scheduleStartDateMin, scheduleStartDateMax: $scheduleStartDateMax, scheduleEndDateMin: $scheduleEndDateMin, scheduleEndDateMax: $scheduleEndDateMax, filterTerm: $filterTerm}
    origin: $origin
    direction: $direction
    dimensions: [Schedule, Category]
    masks: [[Category]]
    directBookings: true
  ) @skip(if: $skipFixedAsset) {
    category {
      categoryObject {
        ...EntityCategoryFields
      }
      summary {
        ...TransactionSummaryFields
      }
      by {
        schedule {
          scheduleId
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
    partialData
  }
  prepaidExpenseAmounts: dimensionalTransactionSummary(
    filter: {viewKey: $viewKey, scheduleTypes: [PrepaidExpense], categorySubtypes: [PrepaidExpenses], withoutCategoryAncestors: true, scheduleScope: ScheduleInitialization, scheduleCategoryIds: $scheduleCategoryIds, scheduleRelatedCategoryIds: $scheduleRelatedCategoryIds, schedulePartyIds: $schedulePartyIds, scheduleMinAmount: $scheduleMinAmount, scheduleMaxAmount: $scheduleMaxAmount, scheduleStartDateMin: $scheduleStartDateMin, scheduleStartDateMax: $scheduleStartDateMax, scheduleEndDateMin: $scheduleEndDateMin, scheduleEndDateMax: $scheduleEndDateMax, filterTerm: $filterTerm}
    origin: $origin
    direction: $direction
    dimensions: [Schedule, Category]
    masks: [[Category]]
    directBookings: true
  ) @skip(if: $skipPrepaidExpense) {
    category {
      categoryObject {
        ...EntityCategoryFields
      }
      summary {
        ...TransactionSummaryFields
      }
      by {
        schedule {
          scheduleId
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
    partialData
  }
}
    ${EntityCategoryFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeTransactionsByScheduleAmountByCategoryQuery__
 *
 * To run a query within a React component, call `useSummarizeTransactionsByScheduleAmountByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTransactionsByScheduleAmountByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTransactionsByScheduleAmountByCategoryQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      origin: // value for 'origin'
 *      direction: // value for 'direction'
 *      scheduleCategoryIds: // value for 'scheduleCategoryIds'
 *      scheduleRelatedCategoryIds: // value for 'scheduleRelatedCategoryIds'
 *      schedulePartyIds: // value for 'schedulePartyIds'
 *      scheduleMinAmount: // value for 'scheduleMinAmount'
 *      scheduleMaxAmount: // value for 'scheduleMaxAmount'
 *      scheduleStartDateMin: // value for 'scheduleStartDateMin'
 *      scheduleStartDateMax: // value for 'scheduleStartDateMax'
 *      scheduleEndDateMin: // value for 'scheduleEndDateMin'
 *      scheduleEndDateMax: // value for 'scheduleEndDateMax'
 *      filterTerm: // value for 'filterTerm'
 *      skipFixedAsset: // value for 'skipFixedAsset'
 *      skipPrepaidExpense: // value for 'skipPrepaidExpense'
 *   },
 * });
 */
export function useSummarizeTransactionsByScheduleAmountByCategoryQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTransactionsByScheduleAmountByCategoryQuery, SummarizeTransactionsByScheduleAmountByCategoryQueryVariables> & ({ variables: SummarizeTransactionsByScheduleAmountByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTransactionsByScheduleAmountByCategoryQuery, SummarizeTransactionsByScheduleAmountByCategoryQueryVariables>(SummarizeTransactionsByScheduleAmountByCategoryDocument, options);
      }
export function useSummarizeTransactionsByScheduleAmountByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTransactionsByScheduleAmountByCategoryQuery, SummarizeTransactionsByScheduleAmountByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTransactionsByScheduleAmountByCategoryQuery, SummarizeTransactionsByScheduleAmountByCategoryQueryVariables>(SummarizeTransactionsByScheduleAmountByCategoryDocument, options);
        }
export function useSummarizeTransactionsByScheduleAmountByCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTransactionsByScheduleAmountByCategoryQuery, SummarizeTransactionsByScheduleAmountByCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTransactionsByScheduleAmountByCategoryQuery, SummarizeTransactionsByScheduleAmountByCategoryQueryVariables>(SummarizeTransactionsByScheduleAmountByCategoryDocument, options);
        }
export type SummarizeTransactionsByScheduleAmountByCategoryQueryHookResult = ReturnType<typeof useSummarizeTransactionsByScheduleAmountByCategoryQuery>;
export type SummarizeTransactionsByScheduleAmountByCategoryLazyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByScheduleAmountByCategoryLazyQuery>;
export type SummarizeTransactionsByScheduleAmountByCategorySuspenseQueryHookResult = ReturnType<typeof useSummarizeTransactionsByScheduleAmountByCategorySuspenseQuery>;
export type SummarizeTransactionsByScheduleAmountByCategoryQueryResult = Apollo.QueryResult<SummarizeTransactionsByScheduleAmountByCategoryQuery, SummarizeTransactionsByScheduleAmountByCategoryQueryVariables>;
export const SummarizeTransactionsByScheduleCumulativeRecognitionByTimeDocument = gql`
    query SummarizeTransactionsByScheduleCumulativeRecognitionByTime($filter: SummaryFilterInput!, $origin: IntervalOrigin!, $direction: DirectionFromOrigin!) {
  dimensionalTransactionSummary(
    filter: $filter
    origin: $origin
    direction: $direction
    dimensions: [Time, Schedule]
    masks: [[Time]]
    asPermanent: true
    defaultCategoryType: Expenses
  ) {
    time {
      summary {
        ...TransactionSummaryFields
      }
      by {
        schedule {
          scheduleId
        }
      }
    }
    partialData
  }
}
    ${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeTransactionsByScheduleCumulativeRecognitionByTimeQuery__
 *
 * To run a query within a React component, call `useSummarizeTransactionsByScheduleCumulativeRecognitionByTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTransactionsByScheduleCumulativeRecognitionByTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTransactionsByScheduleCumulativeRecognitionByTimeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      origin: // value for 'origin'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useSummarizeTransactionsByScheduleCumulativeRecognitionByTimeQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQuery, SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQueryVariables> & ({ variables: SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQuery, SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQueryVariables>(SummarizeTransactionsByScheduleCumulativeRecognitionByTimeDocument, options);
      }
export function useSummarizeTransactionsByScheduleCumulativeRecognitionByTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQuery, SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQuery, SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQueryVariables>(SummarizeTransactionsByScheduleCumulativeRecognitionByTimeDocument, options);
        }
export function useSummarizeTransactionsByScheduleCumulativeRecognitionByTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQuery, SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQuery, SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQueryVariables>(SummarizeTransactionsByScheduleCumulativeRecognitionByTimeDocument, options);
        }
export type SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQueryHookResult = ReturnType<typeof useSummarizeTransactionsByScheduleCumulativeRecognitionByTimeQuery>;
export type SummarizeTransactionsByScheduleCumulativeRecognitionByTimeLazyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByScheduleCumulativeRecognitionByTimeLazyQuery>;
export type SummarizeTransactionsByScheduleCumulativeRecognitionByTimeSuspenseQueryHookResult = ReturnType<typeof useSummarizeTransactionsByScheduleCumulativeRecognitionByTimeSuspenseQuery>;
export type SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQueryResult = Apollo.QueryResult<SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQuery, SummarizeTransactionsByScheduleCumulativeRecognitionByTimeQueryVariables>;
export const SummarizeTransactionsByScheduleRecognitionByTimeDocument = gql`
    query SummarizeTransactionsByScheduleRecognitionByTime($filter: SummaryFilterInput!, $origin: IntervalOrigin!, $direction: DirectionFromOrigin!) {
  dimensionalTransactionSummary(
    filter: $filter
    origin: $origin
    direction: $direction
    dimensions: [Time, Schedule]
    masks: [[Time]]
    defaultCategoryType: Expenses
  ) {
    time {
      summary {
        ...TransactionSummaryFields
      }
      by {
        schedule {
          scheduleId
        }
      }
    }
    partialData
  }
}
    ${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeTransactionsByScheduleRecognitionByTimeQuery__
 *
 * To run a query within a React component, call `useSummarizeTransactionsByScheduleRecognitionByTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTransactionsByScheduleRecognitionByTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTransactionsByScheduleRecognitionByTimeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      origin: // value for 'origin'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useSummarizeTransactionsByScheduleRecognitionByTimeQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTransactionsByScheduleRecognitionByTimeQuery, SummarizeTransactionsByScheduleRecognitionByTimeQueryVariables> & ({ variables: SummarizeTransactionsByScheduleRecognitionByTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTransactionsByScheduleRecognitionByTimeQuery, SummarizeTransactionsByScheduleRecognitionByTimeQueryVariables>(SummarizeTransactionsByScheduleRecognitionByTimeDocument, options);
      }
export function useSummarizeTransactionsByScheduleRecognitionByTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTransactionsByScheduleRecognitionByTimeQuery, SummarizeTransactionsByScheduleRecognitionByTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTransactionsByScheduleRecognitionByTimeQuery, SummarizeTransactionsByScheduleRecognitionByTimeQueryVariables>(SummarizeTransactionsByScheduleRecognitionByTimeDocument, options);
        }
export function useSummarizeTransactionsByScheduleRecognitionByTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTransactionsByScheduleRecognitionByTimeQuery, SummarizeTransactionsByScheduleRecognitionByTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTransactionsByScheduleRecognitionByTimeQuery, SummarizeTransactionsByScheduleRecognitionByTimeQueryVariables>(SummarizeTransactionsByScheduleRecognitionByTimeDocument, options);
        }
export type SummarizeTransactionsByScheduleRecognitionByTimeQueryHookResult = ReturnType<typeof useSummarizeTransactionsByScheduleRecognitionByTimeQuery>;
export type SummarizeTransactionsByScheduleRecognitionByTimeLazyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByScheduleRecognitionByTimeLazyQuery>;
export type SummarizeTransactionsByScheduleRecognitionByTimeSuspenseQueryHookResult = ReturnType<typeof useSummarizeTransactionsByScheduleRecognitionByTimeSuspenseQuery>;
export type SummarizeTransactionsByScheduleRecognitionByTimeQueryResult = Apollo.QueryResult<SummarizeTransactionsByScheduleRecognitionByTimeQuery, SummarizeTransactionsByScheduleRecognitionByTimeQueryVariables>;
export const SummarizeTransactionsByTimeDocument = gql`
    query SummarizeTransactionsByTime($filter: SummaryFilterInput!, $origin: IntervalOrigin!, $direction: DirectionFromOrigin!, $asPermanent: Boolean, $directBookings: Boolean, $naturalFlow: Flow, $defaultCategoryType: CategoryType, $pagination: DimensionPaginationInput) {
  dimensionalTransactionSummary(
    filter: $filter
    origin: $origin
    direction: $direction
    dimensions: [Time]
    asPermanent: $asPermanent
    directBookings: $directBookings
    naturalFlow: $naturalFlow
    defaultCategoryType: $defaultCategoryType
    pagination: $pagination
  ) {
    time {
      summary {
        ...TransactionSummaryFields
      }
    }
    partialData
  }
}
    ${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeTransactionsByTimeQuery__
 *
 * To run a query within a React component, call `useSummarizeTransactionsByTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTransactionsByTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTransactionsByTimeQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      origin: // value for 'origin'
 *      direction: // value for 'direction'
 *      asPermanent: // value for 'asPermanent'
 *      directBookings: // value for 'directBookings'
 *      naturalFlow: // value for 'naturalFlow'
 *      defaultCategoryType: // value for 'defaultCategoryType'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSummarizeTransactionsByTimeQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTransactionsByTimeQuery, SummarizeTransactionsByTimeQueryVariables> & ({ variables: SummarizeTransactionsByTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTransactionsByTimeQuery, SummarizeTransactionsByTimeQueryVariables>(SummarizeTransactionsByTimeDocument, options);
      }
export function useSummarizeTransactionsByTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTransactionsByTimeQuery, SummarizeTransactionsByTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTransactionsByTimeQuery, SummarizeTransactionsByTimeQueryVariables>(SummarizeTransactionsByTimeDocument, options);
        }
export function useSummarizeTransactionsByTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTransactionsByTimeQuery, SummarizeTransactionsByTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTransactionsByTimeQuery, SummarizeTransactionsByTimeQueryVariables>(SummarizeTransactionsByTimeDocument, options);
        }
export type SummarizeTransactionsByTimeQueryHookResult = ReturnType<typeof useSummarizeTransactionsByTimeQuery>;
export type SummarizeTransactionsByTimeLazyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByTimeLazyQuery>;
export type SummarizeTransactionsByTimeSuspenseQueryHookResult = ReturnType<typeof useSummarizeTransactionsByTimeSuspenseQuery>;
export type SummarizeTransactionsByTimeQueryResult = Apollo.QueryResult<SummarizeTransactionsByTimeQuery, SummarizeTransactionsByTimeQueryVariables>;
export const SummarizeTransactionsByTimeByCategoryDocument = gql`
    query SummarizeTransactionsByTimeByCategory($filter: SummaryFilterInput!, $direction: DirectionFromOrigin!, $origin: IntervalOrigin!, $sort: DimensionSortMode!, $limit: Int!, $asPermanent: Boolean, $directBookings: Boolean) {
  dimensionalTransactionSummary(
    filter: $filter
    origin: $origin
    direction: $direction
    dimensions: [Time, Category]
    asPermanent: $asPermanent
    directBookings: $directBookings
  ) {
    time {
      by {
        category(limit: $limit, sort: $sort) {
          categoryObject {
            ...EntityCategoryFields
          }
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
    partialData
  }
}
    ${EntityCategoryFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeTransactionsByTimeByCategoryQuery__
 *
 * To run a query within a React component, call `useSummarizeTransactionsByTimeByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTransactionsByTimeByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTransactionsByTimeByCategoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      direction: // value for 'direction'
 *      origin: // value for 'origin'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      asPermanent: // value for 'asPermanent'
 *      directBookings: // value for 'directBookings'
 *   },
 * });
 */
export function useSummarizeTransactionsByTimeByCategoryQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTransactionsByTimeByCategoryQuery, SummarizeTransactionsByTimeByCategoryQueryVariables> & ({ variables: SummarizeTransactionsByTimeByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTransactionsByTimeByCategoryQuery, SummarizeTransactionsByTimeByCategoryQueryVariables>(SummarizeTransactionsByTimeByCategoryDocument, options);
      }
export function useSummarizeTransactionsByTimeByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTransactionsByTimeByCategoryQuery, SummarizeTransactionsByTimeByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTransactionsByTimeByCategoryQuery, SummarizeTransactionsByTimeByCategoryQueryVariables>(SummarizeTransactionsByTimeByCategoryDocument, options);
        }
export function useSummarizeTransactionsByTimeByCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTransactionsByTimeByCategoryQuery, SummarizeTransactionsByTimeByCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTransactionsByTimeByCategoryQuery, SummarizeTransactionsByTimeByCategoryQueryVariables>(SummarizeTransactionsByTimeByCategoryDocument, options);
        }
export type SummarizeTransactionsByTimeByCategoryQueryHookResult = ReturnType<typeof useSummarizeTransactionsByTimeByCategoryQuery>;
export type SummarizeTransactionsByTimeByCategoryLazyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByTimeByCategoryLazyQuery>;
export type SummarizeTransactionsByTimeByCategorySuspenseQueryHookResult = ReturnType<typeof useSummarizeTransactionsByTimeByCategorySuspenseQuery>;
export type SummarizeTransactionsByTimeByCategoryQueryResult = Apollo.QueryResult<SummarizeTransactionsByTimeByCategoryQuery, SummarizeTransactionsByTimeByCategoryQueryVariables>;
export const SummarizeTransactionsByTimeByPartyDocument = gql`
    query SummarizeTransactionsByTimeByParty($filter: SummaryFilterInput!, $direction: DirectionFromOrigin!, $origin: IntervalOrigin!, $sort: DimensionSortMode, $limit: Int, $asPermanent: Boolean, $masks: [[SummaryDimension!]!], $matchBy: Matcher, $directBookings: Boolean, $defaultCategoryType: CategoryType) {
  dimensionalTransactionSummary(
    filter: $filter
    origin: $origin
    direction: $direction
    dimensions: [Time, Party]
    masks: $masks
    asPermanent: $asPermanent
    matchBy: $matchBy
    directBookings: $directBookings
    defaultCategoryType: $defaultCategoryType
  ) {
    time {
      summary {
        ...TransactionSummaryFields
      }
      by {
        party(limit: $limit, sort: $sort) {
          partyObject {
            ...EntityPartyFields
          }
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
    partialData
  }
}
    ${TransactionSummaryFieldsFragmentDoc}
${EntityPartyFieldsFragmentDoc}`;

/**
 * __useSummarizeTransactionsByTimeByPartyQuery__
 *
 * To run a query within a React component, call `useSummarizeTransactionsByTimeByPartyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTransactionsByTimeByPartyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTransactionsByTimeByPartyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      direction: // value for 'direction'
 *      origin: // value for 'origin'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      asPermanent: // value for 'asPermanent'
 *      masks: // value for 'masks'
 *      matchBy: // value for 'matchBy'
 *      directBookings: // value for 'directBookings'
 *      defaultCategoryType: // value for 'defaultCategoryType'
 *   },
 * });
 */
export function useSummarizeTransactionsByTimeByPartyQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTransactionsByTimeByPartyQuery, SummarizeTransactionsByTimeByPartyQueryVariables> & ({ variables: SummarizeTransactionsByTimeByPartyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTransactionsByTimeByPartyQuery, SummarizeTransactionsByTimeByPartyQueryVariables>(SummarizeTransactionsByTimeByPartyDocument, options);
      }
export function useSummarizeTransactionsByTimeByPartyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTransactionsByTimeByPartyQuery, SummarizeTransactionsByTimeByPartyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTransactionsByTimeByPartyQuery, SummarizeTransactionsByTimeByPartyQueryVariables>(SummarizeTransactionsByTimeByPartyDocument, options);
        }
export function useSummarizeTransactionsByTimeByPartySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTransactionsByTimeByPartyQuery, SummarizeTransactionsByTimeByPartyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTransactionsByTimeByPartyQuery, SummarizeTransactionsByTimeByPartyQueryVariables>(SummarizeTransactionsByTimeByPartyDocument, options);
        }
export type SummarizeTransactionsByTimeByPartyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByTimeByPartyQuery>;
export type SummarizeTransactionsByTimeByPartyLazyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByTimeByPartyLazyQuery>;
export type SummarizeTransactionsByTimeByPartySuspenseQueryHookResult = ReturnType<typeof useSummarizeTransactionsByTimeByPartySuspenseQuery>;
export type SummarizeTransactionsByTimeByPartyQueryResult = Apollo.QueryResult<SummarizeTransactionsByTimeByPartyQuery, SummarizeTransactionsByTimeByPartyQueryVariables>;
export const SummarizeTransactionsByTimeByPartyByCategoryDocument = gql`
    query SummarizeTransactionsByTimeByPartyByCategory($filter: SummaryFilterInput!, $direction: DirectionFromOrigin!, $origin: IntervalOrigin!, $sort: DimensionSortMode!, $limit: Int!, $asPermanent: Boolean, $masks: [[SummaryDimension!]!], $matchBy: Matcher, $directBookings: Boolean) {
  dimensionalTransactionSummary(
    filter: $filter
    origin: $origin
    direction: $direction
    dimensions: [Time, Party, Category]
    masks: $masks
    asPermanent: $asPermanent
    matchBy: $matchBy
    directBookings: $directBookings
  ) {
    time {
      by {
        parties: party(limit: $limit, sort: $sort) {
          party: partyObject {
            ...EntityPartyFields
          }
          summary {
            ...TransactionSummaryFields
          }
          by {
            categories: category(sort: Active) {
              category: categoryObject {
                ...EntityCategoryFields
              }
            }
          }
        }
      }
    }
    partialData
  }
}
    ${EntityPartyFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}
${EntityCategoryFieldsFragmentDoc}`;

/**
 * __useSummarizeTransactionsByTimeByPartyByCategoryQuery__
 *
 * To run a query within a React component, call `useSummarizeTransactionsByTimeByPartyByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTransactionsByTimeByPartyByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTransactionsByTimeByPartyByCategoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      direction: // value for 'direction'
 *      origin: // value for 'origin'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      asPermanent: // value for 'asPermanent'
 *      masks: // value for 'masks'
 *      matchBy: // value for 'matchBy'
 *      directBookings: // value for 'directBookings'
 *   },
 * });
 */
export function useSummarizeTransactionsByTimeByPartyByCategoryQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTransactionsByTimeByPartyByCategoryQuery, SummarizeTransactionsByTimeByPartyByCategoryQueryVariables> & ({ variables: SummarizeTransactionsByTimeByPartyByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTransactionsByTimeByPartyByCategoryQuery, SummarizeTransactionsByTimeByPartyByCategoryQueryVariables>(SummarizeTransactionsByTimeByPartyByCategoryDocument, options);
      }
export function useSummarizeTransactionsByTimeByPartyByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTransactionsByTimeByPartyByCategoryQuery, SummarizeTransactionsByTimeByPartyByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTransactionsByTimeByPartyByCategoryQuery, SummarizeTransactionsByTimeByPartyByCategoryQueryVariables>(SummarizeTransactionsByTimeByPartyByCategoryDocument, options);
        }
export function useSummarizeTransactionsByTimeByPartyByCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTransactionsByTimeByPartyByCategoryQuery, SummarizeTransactionsByTimeByPartyByCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTransactionsByTimeByPartyByCategoryQuery, SummarizeTransactionsByTimeByPartyByCategoryQueryVariables>(SummarizeTransactionsByTimeByPartyByCategoryDocument, options);
        }
export type SummarizeTransactionsByTimeByPartyByCategoryQueryHookResult = ReturnType<typeof useSummarizeTransactionsByTimeByPartyByCategoryQuery>;
export type SummarizeTransactionsByTimeByPartyByCategoryLazyQueryHookResult = ReturnType<typeof useSummarizeTransactionsByTimeByPartyByCategoryLazyQuery>;
export type SummarizeTransactionsByTimeByPartyByCategorySuspenseQueryHookResult = ReturnType<typeof useSummarizeTransactionsByTimeByPartyByCategorySuspenseQuery>;
export type SummarizeTransactionsByTimeByPartyByCategoryQueryResult = Apollo.QueryResult<SummarizeTransactionsByTimeByPartyByCategoryQuery, SummarizeTransactionsByTimeByPartyByCategoryQueryVariables>;
export const SummarizeTransactionsWithoutDimensionDocument = gql`
    query SummarizeTransactionsWithoutDimension($filter: SummaryFilterInput!, $origin: IntervalOrigin!, $direction: DirectionFromOrigin!, $asPermanent: Boolean, $directBookings: Boolean, $naturalFlow: Flow, $defaultCategoryType: CategoryType, $pagination: DimensionPaginationInput) {
  dimensionalTransactionSummary(
    filter: $filter
    origin: $origin
    direction: $direction
    dimensions: []
    asPermanent: $asPermanent
    directBookings: $directBookings
    naturalFlow: $naturalFlow
    defaultCategoryType: $defaultCategoryType
    pagination: $pagination
  ) {
    summary {
      ...TransactionSummaryFields
    }
    partialData
  }
}
    ${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeTransactionsWithoutDimensionQuery__
 *
 * To run a query within a React component, call `useSummarizeTransactionsWithoutDimensionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeTransactionsWithoutDimensionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeTransactionsWithoutDimensionQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      origin: // value for 'origin'
 *      direction: // value for 'direction'
 *      asPermanent: // value for 'asPermanent'
 *      directBookings: // value for 'directBookings'
 *      naturalFlow: // value for 'naturalFlow'
 *      defaultCategoryType: // value for 'defaultCategoryType'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSummarizeTransactionsWithoutDimensionQuery(baseOptions: Apollo.QueryHookOptions<SummarizeTransactionsWithoutDimensionQuery, SummarizeTransactionsWithoutDimensionQueryVariables> & ({ variables: SummarizeTransactionsWithoutDimensionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeTransactionsWithoutDimensionQuery, SummarizeTransactionsWithoutDimensionQueryVariables>(SummarizeTransactionsWithoutDimensionDocument, options);
      }
export function useSummarizeTransactionsWithoutDimensionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeTransactionsWithoutDimensionQuery, SummarizeTransactionsWithoutDimensionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeTransactionsWithoutDimensionQuery, SummarizeTransactionsWithoutDimensionQueryVariables>(SummarizeTransactionsWithoutDimensionDocument, options);
        }
export function useSummarizeTransactionsWithoutDimensionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeTransactionsWithoutDimensionQuery, SummarizeTransactionsWithoutDimensionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeTransactionsWithoutDimensionQuery, SummarizeTransactionsWithoutDimensionQueryVariables>(SummarizeTransactionsWithoutDimensionDocument, options);
        }
export type SummarizeTransactionsWithoutDimensionQueryHookResult = ReturnType<typeof useSummarizeTransactionsWithoutDimensionQuery>;
export type SummarizeTransactionsWithoutDimensionLazyQueryHookResult = ReturnType<typeof useSummarizeTransactionsWithoutDimensionLazyQuery>;
export type SummarizeTransactionsWithoutDimensionSuspenseQueryHookResult = ReturnType<typeof useSummarizeTransactionsWithoutDimensionSuspenseQuery>;
export type SummarizeTransactionsWithoutDimensionQueryResult = Apollo.QueryResult<SummarizeTransactionsWithoutDimensionQuery, SummarizeTransactionsWithoutDimensionQueryVariables>;
export const TransactionDashboardDimensionalSummaryDocument = gql`
    query TransactionDashboardDimensionalSummary($viewKey: ViewKey!, $direction: DirectionFromOrigin!, $origin: IntervalOrigin!) {
  assetsSummary: dimensionalTransactionSummary(
    filter: {viewKey: $viewKey, productArea: None, categoryType: Assets}
    origin: $origin
    direction: $direction
    dimensions: [Category, Time]
    asPermanent: true
    directBookings: true
  ) {
    category {
      categoryObject {
        ...EntityCategoryFields
      }
      by {
        time {
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
  }
  liabilitiesSummary: dimensionalTransactionSummary(
    filter: {viewKey: $viewKey, productArea: None, categoryType: Liabilities}
    origin: $origin
    direction: $direction
    dimensions: [Category, Time]
    asPermanent: true
    directBookings: true
  ) {
    category {
      categoryObject {
        ...EntityCategoryFields
      }
      by {
        time {
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
  }
  equitySummary: dimensionalTransactionSummary(
    filter: {viewKey: $viewKey, productArea: None, categoryType: Equity}
    origin: $origin
    direction: $direction
    dimensions: [Category, Time]
    asPermanent: true
    directBookings: true
  ) {
    category {
      categoryObject {
        ...EntityCategoryFields
      }
      by {
        time {
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
  }
  incomeSummary: dimensionalTransactionSummary(
    filter: {viewKey: $viewKey, productArea: None, categoryType: Income}
    origin: $origin
    direction: $direction
    dimensions: [Category, Time]
    asPermanent: false
    directBookings: true
  ) {
    category {
      categoryObject {
        ...EntityCategoryFields
      }
      by {
        time {
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
  }
  costOfGoodsSoldSummary: dimensionalTransactionSummary(
    filter: {viewKey: $viewKey, productArea: None, categoryType: CostOfGoodsSold}
    origin: $origin
    direction: $direction
    dimensions: [Category, Time]
    asPermanent: false
    directBookings: true
  ) {
    category {
      categoryObject {
        ...EntityCategoryFields
      }
      by {
        time {
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
  }
  expensesSummary: dimensionalTransactionSummary(
    filter: {viewKey: $viewKey, productArea: None, categoryType: Expenses}
    origin: $origin
    direction: $direction
    dimensions: [Category, Time]
    asPermanent: false
    directBookings: true
  ) {
    category {
      categoryObject {
        ...EntityCategoryFields
      }
      by {
        time {
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
  }
  otherExpensesSummary: dimensionalTransactionSummary(
    filter: {viewKey: $viewKey, productArea: None, categoryType: OtherExpenses}
    origin: $origin
    direction: $direction
    dimensions: [Category, Time]
    asPermanent: false
    directBookings: true
  ) {
    category {
      categoryObject {
        ...EntityCategoryFields
      }
      by {
        time {
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
  }
  otherIncomeSummary: dimensionalTransactionSummary(
    filter: {viewKey: $viewKey, productArea: None, categoryType: OtherIncome}
    origin: $origin
    direction: $direction
    dimensions: [Category, Time]
    asPermanent: false
    directBookings: true
  ) {
    category {
      categoryObject {
        ...EntityCategoryFields
      }
      by {
        time {
          summary {
            ...TransactionSummaryFields
          }
        }
      }
    }
  }
}
    ${EntityCategoryFieldsFragmentDoc}
${TransactionSummaryFieldsFragmentDoc}`;

/**
 * __useTransactionDashboardDimensionalSummaryQuery__
 *
 * To run a query within a React component, call `useTransactionDashboardDimensionalSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionDashboardDimensionalSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionDashboardDimensionalSummaryQuery({
 *   variables: {
 *      viewKey: // value for 'viewKey'
 *      direction: // value for 'direction'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useTransactionDashboardDimensionalSummaryQuery(baseOptions: Apollo.QueryHookOptions<TransactionDashboardDimensionalSummaryQuery, TransactionDashboardDimensionalSummaryQueryVariables> & ({ variables: TransactionDashboardDimensionalSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionDashboardDimensionalSummaryQuery, TransactionDashboardDimensionalSummaryQueryVariables>(TransactionDashboardDimensionalSummaryDocument, options);
      }
export function useTransactionDashboardDimensionalSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionDashboardDimensionalSummaryQuery, TransactionDashboardDimensionalSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionDashboardDimensionalSummaryQuery, TransactionDashboardDimensionalSummaryQueryVariables>(TransactionDashboardDimensionalSummaryDocument, options);
        }
export function useTransactionDashboardDimensionalSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionDashboardDimensionalSummaryQuery, TransactionDashboardDimensionalSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionDashboardDimensionalSummaryQuery, TransactionDashboardDimensionalSummaryQueryVariables>(TransactionDashboardDimensionalSummaryDocument, options);
        }
export type TransactionDashboardDimensionalSummaryQueryHookResult = ReturnType<typeof useTransactionDashboardDimensionalSummaryQuery>;
export type TransactionDashboardDimensionalSummaryLazyQueryHookResult = ReturnType<typeof useTransactionDashboardDimensionalSummaryLazyQuery>;
export type TransactionDashboardDimensionalSummarySuspenseQueryHookResult = ReturnType<typeof useTransactionDashboardDimensionalSummarySuspenseQuery>;
export type TransactionDashboardDimensionalSummaryQueryResult = Apollo.QueryResult<TransactionDashboardDimensionalSummaryQuery, TransactionDashboardDimensionalSummaryQueryVariables>;
export const AcceptTermsDocument = gql`
    mutation AcceptTerms($version: String!) {
  acceptTerms(version: $version)
}
    `;
export type AcceptTermsMutationFn = Apollo.MutationFunction<AcceptTermsMutation, AcceptTermsMutationVariables>;

/**
 * __useAcceptTermsMutation__
 *
 * To run a mutation, you first call `useAcceptTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTermsMutation, { data, loading, error }] = useAcceptTermsMutation({
 *   variables: {
 *      version: // value for 'version'
 *   },
 * });
 */
export function useAcceptTermsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTermsMutation, AcceptTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTermsMutation, AcceptTermsMutationVariables>(AcceptTermsDocument, options);
      }
export type AcceptTermsMutationHookResult = ReturnType<typeof useAcceptTermsMutation>;
export type AcceptTermsMutationResult = Apollo.MutationResult<AcceptTermsMutation>;
export type AcceptTermsMutationOptions = Apollo.BaseMutationOptions<AcceptTermsMutation, AcceptTermsMutationVariables>;
export const ConfirmTotpEnrollmentDocument = gql`
    mutation ConfirmTotpEnrollment($factorId: String!, $code: String!) {
  confirmTotpEnrollment(factorId: $factorId, code: $code) {
    recoveryCodes
  }
}
    `;
export type ConfirmTotpEnrollmentMutationFn = Apollo.MutationFunction<ConfirmTotpEnrollmentMutation, ConfirmTotpEnrollmentMutationVariables>;

/**
 * __useConfirmTotpEnrollmentMutation__
 *
 * To run a mutation, you first call `useConfirmTotpEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmTotpEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmTotpEnrollmentMutation, { data, loading, error }] = useConfirmTotpEnrollmentMutation({
 *   variables: {
 *      factorId: // value for 'factorId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useConfirmTotpEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmTotpEnrollmentMutation, ConfirmTotpEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmTotpEnrollmentMutation, ConfirmTotpEnrollmentMutationVariables>(ConfirmTotpEnrollmentDocument, options);
      }
export type ConfirmTotpEnrollmentMutationHookResult = ReturnType<typeof useConfirmTotpEnrollmentMutation>;
export type ConfirmTotpEnrollmentMutationResult = Apollo.MutationResult<ConfirmTotpEnrollmentMutation>;
export type ConfirmTotpEnrollmentMutationOptions = Apollo.BaseMutationOptions<ConfirmTotpEnrollmentMutation, ConfirmTotpEnrollmentMutationVariables>;
export const CreatePasswordResetDocument = gql`
    mutation CreatePasswordReset($emailAddress: String!) {
  createPasswordReset(emailAddress: $emailAddress)
}
    `;
export type CreatePasswordResetMutationFn = Apollo.MutationFunction<CreatePasswordResetMutation, CreatePasswordResetMutationVariables>;

/**
 * __useCreatePasswordResetMutation__
 *
 * To run a mutation, you first call `useCreatePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPasswordResetMutation, { data, loading, error }] = useCreatePasswordResetMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *   },
 * });
 */
export function useCreatePasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<CreatePasswordResetMutation, CreatePasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePasswordResetMutation, CreatePasswordResetMutationVariables>(CreatePasswordResetDocument, options);
      }
export type CreatePasswordResetMutationHookResult = ReturnType<typeof useCreatePasswordResetMutation>;
export type CreatePasswordResetMutationResult = Apollo.MutationResult<CreatePasswordResetMutation>;
export type CreatePasswordResetMutationOptions = Apollo.BaseMutationOptions<CreatePasswordResetMutation, CreatePasswordResetMutationVariables>;
export const DisableTotpDocument = gql`
    mutation DisableTotp($factorId: String!, $verificationCode: String!, $method: MfaMethod!) {
  disableTotp(
    factorId: $factorId
    verificationCode: $verificationCode
    method: $method
  )
}
    `;
export type DisableTotpMutationFn = Apollo.MutationFunction<DisableTotpMutation, DisableTotpMutationVariables>;

/**
 * __useDisableTotpMutation__
 *
 * To run a mutation, you first call `useDisableTotpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableTotpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableTotpMutation, { data, loading, error }] = useDisableTotpMutation({
 *   variables: {
 *      factorId: // value for 'factorId'
 *      verificationCode: // value for 'verificationCode'
 *      method: // value for 'method'
 *   },
 * });
 */
export function useDisableTotpMutation(baseOptions?: Apollo.MutationHookOptions<DisableTotpMutation, DisableTotpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableTotpMutation, DisableTotpMutationVariables>(DisableTotpDocument, options);
      }
export type DisableTotpMutationHookResult = ReturnType<typeof useDisableTotpMutation>;
export type DisableTotpMutationResult = Apollo.MutationResult<DisableTotpMutation>;
export type DisableTotpMutationOptions = Apollo.BaseMutationOptions<DisableTotpMutation, DisableTotpMutationVariables>;
export const SetDefaultApproverDocument = gql`
    mutation SetDefaultApprover($legalEntityId: String!, $userId: String) {
  setDefaultApprover(legalEntityId: $legalEntityId, userId: $userId)
}
    `;
export type SetDefaultApproverMutationFn = Apollo.MutationFunction<SetDefaultApproverMutation, SetDefaultApproverMutationVariables>;

/**
 * __useSetDefaultApproverMutation__
 *
 * To run a mutation, you first call `useSetDefaultApproverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultApproverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultApproverMutation, { data, loading, error }] = useSetDefaultApproverMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSetDefaultApproverMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultApproverMutation, SetDefaultApproverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultApproverMutation, SetDefaultApproverMutationVariables>(SetDefaultApproverDocument, options);
      }
export type SetDefaultApproverMutationHookResult = ReturnType<typeof useSetDefaultApproverMutation>;
export type SetDefaultApproverMutationResult = Apollo.MutationResult<SetDefaultApproverMutation>;
export type SetDefaultApproverMutationOptions = Apollo.BaseMutationOptions<SetDefaultApproverMutation, SetDefaultApproverMutationVariables>;
export const SetRequireBillApproverDifferentFromCreatorDocument = gql`
    mutation SetRequireBillApproverDifferentFromCreator($legalEntityId: String!, $required: Boolean!) {
  setRequireBillApproverDifferentFromCreator(
    legalEntityId: $legalEntityId
    required: $required
  )
}
    `;
export type SetRequireBillApproverDifferentFromCreatorMutationFn = Apollo.MutationFunction<SetRequireBillApproverDifferentFromCreatorMutation, SetRequireBillApproverDifferentFromCreatorMutationVariables>;

/**
 * __useSetRequireBillApproverDifferentFromCreatorMutation__
 *
 * To run a mutation, you first call `useSetRequireBillApproverDifferentFromCreatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRequireBillApproverDifferentFromCreatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRequireBillApproverDifferentFromCreatorMutation, { data, loading, error }] = useSetRequireBillApproverDifferentFromCreatorMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      required: // value for 'required'
 *   },
 * });
 */
export function useSetRequireBillApproverDifferentFromCreatorMutation(baseOptions?: Apollo.MutationHookOptions<SetRequireBillApproverDifferentFromCreatorMutation, SetRequireBillApproverDifferentFromCreatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRequireBillApproverDifferentFromCreatorMutation, SetRequireBillApproverDifferentFromCreatorMutationVariables>(SetRequireBillApproverDifferentFromCreatorDocument, options);
      }
export type SetRequireBillApproverDifferentFromCreatorMutationHookResult = ReturnType<typeof useSetRequireBillApproverDifferentFromCreatorMutation>;
export type SetRequireBillApproverDifferentFromCreatorMutationResult = Apollo.MutationResult<SetRequireBillApproverDifferentFromCreatorMutation>;
export type SetRequireBillApproverDifferentFromCreatorMutationOptions = Apollo.BaseMutationOptions<SetRequireBillApproverDifferentFromCreatorMutation, SetRequireBillApproverDifferentFromCreatorMutationVariables>;
export const StartTotpEnrollmentDocument = gql`
    mutation StartTotpEnrollment {
  startTotpEnrollment {
    factorId
    provisioningUri
    sharedSecretBase32
  }
}
    `;
export type StartTotpEnrollmentMutationFn = Apollo.MutationFunction<StartTotpEnrollmentMutation, StartTotpEnrollmentMutationVariables>;

/**
 * __useStartTotpEnrollmentMutation__
 *
 * To run a mutation, you first call `useStartTotpEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartTotpEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startTotpEnrollmentMutation, { data, loading, error }] = useStartTotpEnrollmentMutation({
 *   variables: {
 *   },
 * });
 */
export function useStartTotpEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<StartTotpEnrollmentMutation, StartTotpEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartTotpEnrollmentMutation, StartTotpEnrollmentMutationVariables>(StartTotpEnrollmentDocument, options);
      }
export type StartTotpEnrollmentMutationHookResult = ReturnType<typeof useStartTotpEnrollmentMutation>;
export type StartTotpEnrollmentMutationResult = Apollo.MutationResult<StartTotpEnrollmentMutation>;
export type StartTotpEnrollmentMutationOptions = Apollo.BaseMutationOptions<StartTotpEnrollmentMutation, StartTotpEnrollmentMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($givenName: String, $familyName: String, $emailAddress: String) {
  updateUser(
    givenName: $givenName
    familyName: $familyName
    emailAddress: $emailAddress
  )
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      givenName: // value for 'givenName'
 *      familyName: // value for 'familyName'
 *      emailAddress: // value for 'emailAddress'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const ListLegalEntityUsersDocument = gql`
    query ListLegalEntityUsers($id: String!) {
  listLegalEntityUsers(id: $id) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useListLegalEntityUsersQuery__
 *
 * To run a query within a React component, call `useListLegalEntityUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLegalEntityUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLegalEntityUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListLegalEntityUsersQuery(baseOptions: Apollo.QueryHookOptions<ListLegalEntityUsersQuery, ListLegalEntityUsersQueryVariables> & ({ variables: ListLegalEntityUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLegalEntityUsersQuery, ListLegalEntityUsersQueryVariables>(ListLegalEntityUsersDocument, options);
      }
export function useListLegalEntityUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLegalEntityUsersQuery, ListLegalEntityUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLegalEntityUsersQuery, ListLegalEntityUsersQueryVariables>(ListLegalEntityUsersDocument, options);
        }
export function useListLegalEntityUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListLegalEntityUsersQuery, ListLegalEntityUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListLegalEntityUsersQuery, ListLegalEntityUsersQueryVariables>(ListLegalEntityUsersDocument, options);
        }
export type ListLegalEntityUsersQueryHookResult = ReturnType<typeof useListLegalEntityUsersQuery>;
export type ListLegalEntityUsersLazyQueryHookResult = ReturnType<typeof useListLegalEntityUsersLazyQuery>;
export type ListLegalEntityUsersSuspenseQueryHookResult = ReturnType<typeof useListLegalEntityUsersSuspenseQuery>;
export type ListLegalEntityUsersQueryResult = Apollo.QueryResult<ListLegalEntityUsersQuery, ListLegalEntityUsersQueryVariables>;
export const ReadDefaultApproverDocument = gql`
    query ReadDefaultApprover($legalEntityId: String!) {
  readDefaultApprover(legalEntityId: $legalEntityId)
}
    `;

/**
 * __useReadDefaultApproverQuery__
 *
 * To run a query within a React component, call `useReadDefaultApproverQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadDefaultApproverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadDefaultApproverQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadDefaultApproverQuery(baseOptions: Apollo.QueryHookOptions<ReadDefaultApproverQuery, ReadDefaultApproverQueryVariables> & ({ variables: ReadDefaultApproverQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadDefaultApproverQuery, ReadDefaultApproverQueryVariables>(ReadDefaultApproverDocument, options);
      }
export function useReadDefaultApproverLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadDefaultApproverQuery, ReadDefaultApproverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadDefaultApproverQuery, ReadDefaultApproverQueryVariables>(ReadDefaultApproverDocument, options);
        }
export function useReadDefaultApproverSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadDefaultApproverQuery, ReadDefaultApproverQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadDefaultApproverQuery, ReadDefaultApproverQueryVariables>(ReadDefaultApproverDocument, options);
        }
export type ReadDefaultApproverQueryHookResult = ReturnType<typeof useReadDefaultApproverQuery>;
export type ReadDefaultApproverLazyQueryHookResult = ReturnType<typeof useReadDefaultApproverLazyQuery>;
export type ReadDefaultApproverSuspenseQueryHookResult = ReturnType<typeof useReadDefaultApproverSuspenseQuery>;
export type ReadDefaultApproverQueryResult = Apollo.QueryResult<ReadDefaultApproverQuery, ReadDefaultApproverQueryVariables>;
export const ReadRequireBillApproverDifferentFromCreatorDocument = gql`
    query ReadRequireBillApproverDifferentFromCreator($legalEntityId: String!) {
  readRequireBillApproverDifferentFromCreator(legalEntityId: $legalEntityId)
}
    `;

/**
 * __useReadRequireBillApproverDifferentFromCreatorQuery__
 *
 * To run a query within a React component, call `useReadRequireBillApproverDifferentFromCreatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadRequireBillApproverDifferentFromCreatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadRequireBillApproverDifferentFromCreatorQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadRequireBillApproverDifferentFromCreatorQuery(baseOptions: Apollo.QueryHookOptions<ReadRequireBillApproverDifferentFromCreatorQuery, ReadRequireBillApproverDifferentFromCreatorQueryVariables> & ({ variables: ReadRequireBillApproverDifferentFromCreatorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadRequireBillApproverDifferentFromCreatorQuery, ReadRequireBillApproverDifferentFromCreatorQueryVariables>(ReadRequireBillApproverDifferentFromCreatorDocument, options);
      }
export function useReadRequireBillApproverDifferentFromCreatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadRequireBillApproverDifferentFromCreatorQuery, ReadRequireBillApproverDifferentFromCreatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadRequireBillApproverDifferentFromCreatorQuery, ReadRequireBillApproverDifferentFromCreatorQueryVariables>(ReadRequireBillApproverDifferentFromCreatorDocument, options);
        }
export function useReadRequireBillApproverDifferentFromCreatorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadRequireBillApproverDifferentFromCreatorQuery, ReadRequireBillApproverDifferentFromCreatorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadRequireBillApproverDifferentFromCreatorQuery, ReadRequireBillApproverDifferentFromCreatorQueryVariables>(ReadRequireBillApproverDifferentFromCreatorDocument, options);
        }
export type ReadRequireBillApproverDifferentFromCreatorQueryHookResult = ReturnType<typeof useReadRequireBillApproverDifferentFromCreatorQuery>;
export type ReadRequireBillApproverDifferentFromCreatorLazyQueryHookResult = ReturnType<typeof useReadRequireBillApproverDifferentFromCreatorLazyQuery>;
export type ReadRequireBillApproverDifferentFromCreatorSuspenseQueryHookResult = ReturnType<typeof useReadRequireBillApproverDifferentFromCreatorSuspenseQuery>;
export type ReadRequireBillApproverDifferentFromCreatorQueryResult = Apollo.QueryResult<ReadRequireBillApproverDifferentFromCreatorQuery, ReadRequireBillApproverDifferentFromCreatorQueryVariables>;
export const ReadUserDocument = gql`
    query ReadUser($id: String!) {
  readUser(id: $id) {
    ...UserFields
    mfaEnforcedAt
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useReadUserQuery__
 *
 * To run a query within a React component, call `useReadUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReadUserQuery(baseOptions: Apollo.QueryHookOptions<ReadUserQuery, ReadUserQueryVariables> & ({ variables: ReadUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadUserQuery, ReadUserQueryVariables>(ReadUserDocument, options);
      }
export function useReadUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadUserQuery, ReadUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadUserQuery, ReadUserQueryVariables>(ReadUserDocument, options);
        }
export function useReadUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadUserQuery, ReadUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadUserQuery, ReadUserQueryVariables>(ReadUserDocument, options);
        }
export type ReadUserQueryHookResult = ReturnType<typeof useReadUserQuery>;
export type ReadUserLazyQueryHookResult = ReturnType<typeof useReadUserLazyQuery>;
export type ReadUserSuspenseQueryHookResult = ReturnType<typeof useReadUserSuspenseQuery>;
export type ReadUserQueryResult = Apollo.QueryResult<ReadUserQuery, ReadUserQueryVariables>;
export const ReadVanityStatsDocument = gql`
    query ReadVanityStats($legalEntityId: String!) {
  readVanityStats(legalEntityId: $legalEntityId) {
    ...VanityStatsFields
  }
}
    ${VanityStatsFieldsFragmentDoc}`;

/**
 * __useReadVanityStatsQuery__
 *
 * To run a query within a React component, call `useReadVanityStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadVanityStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadVanityStatsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadVanityStatsQuery(baseOptions: Apollo.QueryHookOptions<ReadVanityStatsQuery, ReadVanityStatsQueryVariables> & ({ variables: ReadVanityStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadVanityStatsQuery, ReadVanityStatsQueryVariables>(ReadVanityStatsDocument, options);
      }
export function useReadVanityStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadVanityStatsQuery, ReadVanityStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadVanityStatsQuery, ReadVanityStatsQueryVariables>(ReadVanityStatsDocument, options);
        }
export function useReadVanityStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadVanityStatsQuery, ReadVanityStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadVanityStatsQuery, ReadVanityStatsQueryVariables>(ReadVanityStatsDocument, options);
        }
export type ReadVanityStatsQueryHookResult = ReturnType<typeof useReadVanityStatsQuery>;
export type ReadVanityStatsLazyQueryHookResult = ReturnType<typeof useReadVanityStatsLazyQuery>;
export type ReadVanityStatsSuspenseQueryHookResult = ReturnType<typeof useReadVanityStatsSuspenseQuery>;
export type ReadVanityStatsQueryResult = Apollo.QueryResult<ReadVanityStatsQuery, ReadVanityStatsQueryVariables>;
export const AddDocumentFeatureDocument = gql`
    mutation AddDocumentFeature($documentId: String!, $documentCollectionId: String!, $feature: NewDocumentFeature!, $correctedFeatureId: String) {
  addDocumentFeature(
    documentId: $documentId
    documentCollectionId: $documentCollectionId
    feature: $feature
    correctedFeatureId: $correctedFeatureId
  ) {
    featureId
    invalid
  }
}
    `;
export type AddDocumentFeatureMutationFn = Apollo.MutationFunction<AddDocumentFeatureMutation, AddDocumentFeatureMutationVariables>;

/**
 * __useAddDocumentFeatureMutation__
 *
 * To run a mutation, you first call `useAddDocumentFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDocumentFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDocumentFeatureMutation, { data, loading, error }] = useAddDocumentFeatureMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      documentCollectionId: // value for 'documentCollectionId'
 *      feature: // value for 'feature'
 *      correctedFeatureId: // value for 'correctedFeatureId'
 *   },
 * });
 */
export function useAddDocumentFeatureMutation(baseOptions?: Apollo.MutationHookOptions<AddDocumentFeatureMutation, AddDocumentFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDocumentFeatureMutation, AddDocumentFeatureMutationVariables>(AddDocumentFeatureDocument, options);
      }
export type AddDocumentFeatureMutationHookResult = ReturnType<typeof useAddDocumentFeatureMutation>;
export type AddDocumentFeatureMutationResult = Apollo.MutationResult<AddDocumentFeatureMutation>;
export type AddDocumentFeatureMutationOptions = Apollo.BaseMutationOptions<AddDocumentFeatureMutation, AddDocumentFeatureMutationVariables>;
export const DocumentDownloadUrlDocument = gql`
    query DocumentDownloadUrl($id: String!, $legalEntityId: String!) {
  documentDownloadUrl(id: $id, legalEntityId: $legalEntityId) {
    url
  }
}
    `;

/**
 * __useDocumentDownloadUrlQuery__
 *
 * To run a query within a React component, call `useDocumentDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentDownloadUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useDocumentDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<DocumentDownloadUrlQuery, DocumentDownloadUrlQueryVariables> & ({ variables: DocumentDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentDownloadUrlQuery, DocumentDownloadUrlQueryVariables>(DocumentDownloadUrlDocument, options);
      }
export function useDocumentDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentDownloadUrlQuery, DocumentDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentDownloadUrlQuery, DocumentDownloadUrlQueryVariables>(DocumentDownloadUrlDocument, options);
        }
export function useDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocumentDownloadUrlQuery, DocumentDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentDownloadUrlQuery, DocumentDownloadUrlQueryVariables>(DocumentDownloadUrlDocument, options);
        }
export type DocumentDownloadUrlQueryHookResult = ReturnType<typeof useDocumentDownloadUrlQuery>;
export type DocumentDownloadUrlLazyQueryHookResult = ReturnType<typeof useDocumentDownloadUrlLazyQuery>;
export type DocumentDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useDocumentDownloadUrlSuspenseQuery>;
export type DocumentDownloadUrlQueryResult = Apollo.QueryResult<DocumentDownloadUrlQuery, DocumentDownloadUrlQueryVariables>;
export const DocumentDownloadUrlsDocument = gql`
    query DocumentDownloadUrls($ids: [String!]!, $legalEntityId: String!) {
  documentDownloadUrls(ids: $ids, legalEntityId: $legalEntityId) {
    urls
  }
}
    `;

/**
 * __useDocumentDownloadUrlsQuery__
 *
 * To run a query within a React component, call `useDocumentDownloadUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentDownloadUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentDownloadUrlsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useDocumentDownloadUrlsQuery(baseOptions: Apollo.QueryHookOptions<DocumentDownloadUrlsQuery, DocumentDownloadUrlsQueryVariables> & ({ variables: DocumentDownloadUrlsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentDownloadUrlsQuery, DocumentDownloadUrlsQueryVariables>(DocumentDownloadUrlsDocument, options);
      }
export function useDocumentDownloadUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentDownloadUrlsQuery, DocumentDownloadUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentDownloadUrlsQuery, DocumentDownloadUrlsQueryVariables>(DocumentDownloadUrlsDocument, options);
        }
export function useDocumentDownloadUrlsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocumentDownloadUrlsQuery, DocumentDownloadUrlsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentDownloadUrlsQuery, DocumentDownloadUrlsQueryVariables>(DocumentDownloadUrlsDocument, options);
        }
export type DocumentDownloadUrlsQueryHookResult = ReturnType<typeof useDocumentDownloadUrlsQuery>;
export type DocumentDownloadUrlsLazyQueryHookResult = ReturnType<typeof useDocumentDownloadUrlsLazyQuery>;
export type DocumentDownloadUrlsSuspenseQueryHookResult = ReturnType<typeof useDocumentDownloadUrlsSuspenseQuery>;
export type DocumentDownloadUrlsQueryResult = Apollo.QueryResult<DocumentDownloadUrlsQuery, DocumentDownloadUrlsQueryVariables>;
export const ListVaultFilesDocument = gql`
    query ListVaultFiles($legalEntityId: String!, $pagination: Pagination, $filter: DocumentFilter!, $order: DocumentSort) {
  listDocuments(
    legalEntityId: $legalEntityId
    filter: $filter
    order: $order
    pagination: $pagination
  ) {
    ...VaultFileFields
  }
  summarizeDocuments(legalEntityId: $legalEntityId, filter: $filter) {
    count
  }
}
    ${VaultFileFieldsFragmentDoc}`;

/**
 * __useListVaultFilesQuery__
 *
 * To run a query within a React component, call `useListVaultFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListVaultFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListVaultFilesQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListVaultFilesQuery(baseOptions: Apollo.QueryHookOptions<ListVaultFilesQuery, ListVaultFilesQueryVariables> & ({ variables: ListVaultFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListVaultFilesQuery, ListVaultFilesQueryVariables>(ListVaultFilesDocument, options);
      }
export function useListVaultFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListVaultFilesQuery, ListVaultFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListVaultFilesQuery, ListVaultFilesQueryVariables>(ListVaultFilesDocument, options);
        }
export function useListVaultFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListVaultFilesQuery, ListVaultFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListVaultFilesQuery, ListVaultFilesQueryVariables>(ListVaultFilesDocument, options);
        }
export type ListVaultFilesQueryHookResult = ReturnType<typeof useListVaultFilesQuery>;
export type ListVaultFilesLazyQueryHookResult = ReturnType<typeof useListVaultFilesLazyQuery>;
export type ListVaultFilesSuspenseQueryHookResult = ReturnType<typeof useListVaultFilesSuspenseQuery>;
export type ListVaultFilesQueryResult = Apollo.QueryResult<ListVaultFilesQuery, ListVaultFilesQueryVariables>;
export const ReadVaultFileDocument = gql`
    query ReadVaultFile($id: String!, $legalEntityId: String!) {
  readVaultFile: readDocument(id: $id, legalEntityId: $legalEntityId) {
    ...VaultFileWithBoundingBoxesFields
  }
}
    ${VaultFileWithBoundingBoxesFieldsFragmentDoc}`;

/**
 * __useReadVaultFileQuery__
 *
 * To run a query within a React component, call `useReadVaultFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadVaultFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadVaultFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useReadVaultFileQuery(baseOptions: Apollo.QueryHookOptions<ReadVaultFileQuery, ReadVaultFileQueryVariables> & ({ variables: ReadVaultFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadVaultFileQuery, ReadVaultFileQueryVariables>(ReadVaultFileDocument, options);
      }
export function useReadVaultFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadVaultFileQuery, ReadVaultFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadVaultFileQuery, ReadVaultFileQueryVariables>(ReadVaultFileDocument, options);
        }
export function useReadVaultFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReadVaultFileQuery, ReadVaultFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReadVaultFileQuery, ReadVaultFileQueryVariables>(ReadVaultFileDocument, options);
        }
export type ReadVaultFileQueryHookResult = ReturnType<typeof useReadVaultFileQuery>;
export type ReadVaultFileLazyQueryHookResult = ReturnType<typeof useReadVaultFileLazyQuery>;
export type ReadVaultFileSuspenseQueryHookResult = ReturnType<typeof useReadVaultFileSuspenseQuery>;
export type ReadVaultFileQueryResult = Apollo.QueryResult<ReadVaultFileQuery, ReadVaultFileQueryVariables>;
export const ListWalletStatementsDocument = gql`
    query ListWalletStatements($legalEntityId: String!, $documentType: DocumentType!, $featureKinds: [FeatureKind!]) {
  listDocumentsByType(
    legalEntityId: $legalEntityId
    documentType: $documentType
    featureKinds: $featureKinds
  ) {
    ...WalletStatementFields
  }
}
    ${WalletStatementFieldsFragmentDoc}`;

/**
 * __useListWalletStatementsQuery__
 *
 * To run a query within a React component, call `useListWalletStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWalletStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWalletStatementsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      documentType: // value for 'documentType'
 *      featureKinds: // value for 'featureKinds'
 *   },
 * });
 */
export function useListWalletStatementsQuery(baseOptions: Apollo.QueryHookOptions<ListWalletStatementsQuery, ListWalletStatementsQueryVariables> & ({ variables: ListWalletStatementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWalletStatementsQuery, ListWalletStatementsQueryVariables>(ListWalletStatementsDocument, options);
      }
export function useListWalletStatementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWalletStatementsQuery, ListWalletStatementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWalletStatementsQuery, ListWalletStatementsQueryVariables>(ListWalletStatementsDocument, options);
        }
export function useListWalletStatementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWalletStatementsQuery, ListWalletStatementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWalletStatementsQuery, ListWalletStatementsQueryVariables>(ListWalletStatementsDocument, options);
        }
export type ListWalletStatementsQueryHookResult = ReturnType<typeof useListWalletStatementsQuery>;
export type ListWalletStatementsLazyQueryHookResult = ReturnType<typeof useListWalletStatementsLazyQuery>;
export type ListWalletStatementsSuspenseQueryHookResult = ReturnType<typeof useListWalletStatementsSuspenseQuery>;
export type ListWalletStatementsQueryResult = Apollo.QueryResult<ListWalletStatementsQuery, ListWalletStatementsQueryVariables>;
export const CloseWorkItemsDocument = gql`
    mutation CloseWorkItems($legalEntityId: String!, $closedWorkItems: [ClosedWorkItem!]!, $viewKey: ViewKey) {
  closeWorkItems(
    legalEntityId: $legalEntityId
    closedWorkItems: $closedWorkItems
    viewKey: $viewKey
  )
}
    `;
export type CloseWorkItemsMutationFn = Apollo.MutationFunction<CloseWorkItemsMutation, CloseWorkItemsMutationVariables>;

/**
 * __useCloseWorkItemsMutation__
 *
 * To run a mutation, you first call `useCloseWorkItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseWorkItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeWorkItemsMutation, { data, loading, error }] = useCloseWorkItemsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      closedWorkItems: // value for 'closedWorkItems'
 *      viewKey: // value for 'viewKey'
 *   },
 * });
 */
export function useCloseWorkItemsMutation(baseOptions?: Apollo.MutationHookOptions<CloseWorkItemsMutation, CloseWorkItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseWorkItemsMutation, CloseWorkItemsMutationVariables>(CloseWorkItemsDocument, options);
      }
export type CloseWorkItemsMutationHookResult = ReturnType<typeof useCloseWorkItemsMutation>;
export type CloseWorkItemsMutationResult = Apollo.MutationResult<CloseWorkItemsMutation>;
export type CloseWorkItemsMutationOptions = Apollo.BaseMutationOptions<CloseWorkItemsMutation, CloseWorkItemsMutationVariables>;
export const PushDigitsWorkItemsDocument = gql`
    mutation PushDigitsWorkItems($legalEntityId: String!, $workItems: [DigitsWorkItemPushParams!]!) {
  pushDigitsWorkItems(legalEntityId: $legalEntityId, workItems: $workItems)
}
    `;
export type PushDigitsWorkItemsMutationFn = Apollo.MutationFunction<PushDigitsWorkItemsMutation, PushDigitsWorkItemsMutationVariables>;

/**
 * __usePushDigitsWorkItemsMutation__
 *
 * To run a mutation, you first call `usePushDigitsWorkItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushDigitsWorkItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushDigitsWorkItemsMutation, { data, loading, error }] = usePushDigitsWorkItemsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      workItems: // value for 'workItems'
 *   },
 * });
 */
export function usePushDigitsWorkItemsMutation(baseOptions?: Apollo.MutationHookOptions<PushDigitsWorkItemsMutation, PushDigitsWorkItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PushDigitsWorkItemsMutation, PushDigitsWorkItemsMutationVariables>(PushDigitsWorkItemsDocument, options);
      }
export type PushDigitsWorkItemsMutationHookResult = ReturnType<typeof usePushDigitsWorkItemsMutation>;
export type PushDigitsWorkItemsMutationResult = Apollo.MutationResult<PushDigitsWorkItemsMutation>;
export type PushDigitsWorkItemsMutationOptions = Apollo.BaseMutationOptions<PushDigitsWorkItemsMutation, PushDigitsWorkItemsMutationVariables>;
export const PushWorkItemsDocument = gql`
    mutation PushWorkItems($legalEntityId: String!, $workItems: [WorkItemPushParams!]!) {
  pushWorkItems(legalEntityId: $legalEntityId, workItems: $workItems)
}
    `;
export type PushWorkItemsMutationFn = Apollo.MutationFunction<PushWorkItemsMutation, PushWorkItemsMutationVariables>;

/**
 * __usePushWorkItemsMutation__
 *
 * To run a mutation, you first call `usePushWorkItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushWorkItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushWorkItemsMutation, { data, loading, error }] = usePushWorkItemsMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      workItems: // value for 'workItems'
 *   },
 * });
 */
export function usePushWorkItemsMutation(baseOptions?: Apollo.MutationHookOptions<PushWorkItemsMutation, PushWorkItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PushWorkItemsMutation, PushWorkItemsMutationVariables>(PushWorkItemsDocument, options);
      }
export type PushWorkItemsMutationHookResult = ReturnType<typeof usePushWorkItemsMutation>;
export type PushWorkItemsMutationResult = Apollo.MutationResult<PushWorkItemsMutation>;
export type PushWorkItemsMutationOptions = Apollo.BaseMutationOptions<PushWorkItemsMutation, PushWorkItemsMutationVariables>;
export const ReopenWorkItemDocument = gql`
    mutation ReopenWorkItem($legalEntityId: String!, $workItemId: String!) {
  reopenWorkItem(legalEntityId: $legalEntityId, workItemId: $workItemId)
}
    `;
export type ReopenWorkItemMutationFn = Apollo.MutationFunction<ReopenWorkItemMutation, ReopenWorkItemMutationVariables>;

/**
 * __useReopenWorkItemMutation__
 *
 * To run a mutation, you first call `useReopenWorkItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenWorkItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenWorkItemMutation, { data, loading, error }] = useReopenWorkItemMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      workItemId: // value for 'workItemId'
 *   },
 * });
 */
export function useReopenWorkItemMutation(baseOptions?: Apollo.MutationHookOptions<ReopenWorkItemMutation, ReopenWorkItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenWorkItemMutation, ReopenWorkItemMutationVariables>(ReopenWorkItemDocument, options);
      }
export type ReopenWorkItemMutationHookResult = ReturnType<typeof useReopenWorkItemMutation>;
export type ReopenWorkItemMutationResult = Apollo.MutationResult<ReopenWorkItemMutation>;
export type ReopenWorkItemMutationOptions = Apollo.BaseMutationOptions<ReopenWorkItemMutation, ReopenWorkItemMutationVariables>;
export const UpdateAccountantReviewStatesDocument = gql`
    mutation UpdateAccountantReviewStates($legalEntityId: String!, $organizationId: String!, $period: PeriodInput!, $workItemSubjects: [WorkItemSubject!]!, $message: String) {
  updateAccountantReviewStates(
    legalEntityId: $legalEntityId
    organizationId: $organizationId
    period: $period
    workItemSubjects: $workItemSubjects
    message: $message
  )
}
    `;
export type UpdateAccountantReviewStatesMutationFn = Apollo.MutationFunction<UpdateAccountantReviewStatesMutation, UpdateAccountantReviewStatesMutationVariables>;

/**
 * __useUpdateAccountantReviewStatesMutation__
 *
 * To run a mutation, you first call `useUpdateAccountantReviewStatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountantReviewStatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountantReviewStatesMutation, { data, loading, error }] = useUpdateAccountantReviewStatesMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      organizationId: // value for 'organizationId'
 *      period: // value for 'period'
 *      workItemSubjects: // value for 'workItemSubjects'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useUpdateAccountantReviewStatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountantReviewStatesMutation, UpdateAccountantReviewStatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountantReviewStatesMutation, UpdateAccountantReviewStatesMutationVariables>(UpdateAccountantReviewStatesDocument, options);
      }
export type UpdateAccountantReviewStatesMutationHookResult = ReturnType<typeof useUpdateAccountantReviewStatesMutation>;
export type UpdateAccountantReviewStatesMutationResult = Apollo.MutationResult<UpdateAccountantReviewStatesMutation>;
export type UpdateAccountantReviewStatesMutationOptions = Apollo.BaseMutationOptions<UpdateAccountantReviewStatesMutation, UpdateAccountantReviewStatesMutationVariables>;
export const UpdateClientReviewStatesDocument = gql`
    mutation UpdateClientReviewStates($legalEntityId: String!, $responses: [WorkItemResponse!]!) {
  updateClientReviewStates(legalEntityId: $legalEntityId, responses: $responses)
}
    `;
export type UpdateClientReviewStatesMutationFn = Apollo.MutationFunction<UpdateClientReviewStatesMutation, UpdateClientReviewStatesMutationVariables>;

/**
 * __useUpdateClientReviewStatesMutation__
 *
 * To run a mutation, you first call `useUpdateClientReviewStatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientReviewStatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientReviewStatesMutation, { data, loading, error }] = useUpdateClientReviewStatesMutation({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      responses: // value for 'responses'
 *   },
 * });
 */
export function useUpdateClientReviewStatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientReviewStatesMutation, UpdateClientReviewStatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientReviewStatesMutation, UpdateClientReviewStatesMutationVariables>(UpdateClientReviewStatesDocument, options);
      }
export type UpdateClientReviewStatesMutationHookResult = ReturnType<typeof useUpdateClientReviewStatesMutation>;
export type UpdateClientReviewStatesMutationResult = Apollo.MutationResult<UpdateClientReviewStatesMutation>;
export type UpdateClientReviewStatesMutationOptions = Apollo.BaseMutationOptions<UpdateClientReviewStatesMutation, UpdateClientReviewStatesMutationVariables>;
export const UpdateTransactionReviewQuestionsDocument = gql`
    mutation UpdateTransactionReviewQuestions($organizationId: String!, $deletedQuestions: [String!], $newQuestions: [String!]) {
  updateTransactionReviewQuestions(
    organizationId: $organizationId
    deletedQuestions: $deletedQuestions
    newQuestions: $newQuestions
  )
}
    `;
export type UpdateTransactionReviewQuestionsMutationFn = Apollo.MutationFunction<UpdateTransactionReviewQuestionsMutation, UpdateTransactionReviewQuestionsMutationVariables>;

/**
 * __useUpdateTransactionReviewQuestionsMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionReviewQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionReviewQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionReviewQuestionsMutation, { data, loading, error }] = useUpdateTransactionReviewQuestionsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      deletedQuestions: // value for 'deletedQuestions'
 *      newQuestions: // value for 'newQuestions'
 *   },
 * });
 */
export function useUpdateTransactionReviewQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransactionReviewQuestionsMutation, UpdateTransactionReviewQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransactionReviewQuestionsMutation, UpdateTransactionReviewQuestionsMutationVariables>(UpdateTransactionReviewQuestionsDocument, options);
      }
export type UpdateTransactionReviewQuestionsMutationHookResult = ReturnType<typeof useUpdateTransactionReviewQuestionsMutation>;
export type UpdateTransactionReviewQuestionsMutationResult = Apollo.MutationResult<UpdateTransactionReviewQuestionsMutation>;
export type UpdateTransactionReviewQuestionsMutationOptions = Apollo.BaseMutationOptions<UpdateTransactionReviewQuestionsMutation, UpdateTransactionReviewQuestionsMutationVariables>;
export const HighlightWorkItemDocument = gql`
    query HighlightWorkItem($similarityType: SimilarityType!, $description: String, $name: String) {
  highlightWorkItem(
    similarityType: $similarityType
    description: $description
    name: $name
  ) {
    ...HighlightedTokensFields
  }
}
    ${HighlightedTokensFieldsFragmentDoc}`;

/**
 * __useHighlightWorkItemQuery__
 *
 * To run a query within a React component, call `useHighlightWorkItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useHighlightWorkItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHighlightWorkItemQuery({
 *   variables: {
 *      similarityType: // value for 'similarityType'
 *      description: // value for 'description'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useHighlightWorkItemQuery(baseOptions: Apollo.QueryHookOptions<HighlightWorkItemQuery, HighlightWorkItemQueryVariables> & ({ variables: HighlightWorkItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HighlightWorkItemQuery, HighlightWorkItemQueryVariables>(HighlightWorkItemDocument, options);
      }
export function useHighlightWorkItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HighlightWorkItemQuery, HighlightWorkItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HighlightWorkItemQuery, HighlightWorkItemQueryVariables>(HighlightWorkItemDocument, options);
        }
export function useHighlightWorkItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HighlightWorkItemQuery, HighlightWorkItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HighlightWorkItemQuery, HighlightWorkItemQueryVariables>(HighlightWorkItemDocument, options);
        }
export type HighlightWorkItemQueryHookResult = ReturnType<typeof useHighlightWorkItemQuery>;
export type HighlightWorkItemLazyQueryHookResult = ReturnType<typeof useHighlightWorkItemLazyQuery>;
export type HighlightWorkItemSuspenseQueryHookResult = ReturnType<typeof useHighlightWorkItemSuspenseQuery>;
export type HighlightWorkItemQueryResult = Apollo.QueryResult<HighlightWorkItemQuery, HighlightWorkItemQueryVariables>;
export const ListTransactionReviewItemsDocument = gql`
    query ListTransactionReviewItems($legalEntityId: String!, $filter: WorkItemFilter!, $intervalOrigin: IntervalOrigin!, $direction: DirectionFromOrigin!) {
  workItems: listWorkItems(
    filter: $filter
    origin: $intervalOrigin
    direction: $direction
  ) {
    ...WorkItemFields
  }
  rules: listAuditRules(legalEntityId: $legalEntityId) {
    ...AuditRuleFields
  }
  ruleStatuses: listAuditRuleStatuses(legalEntityId: $legalEntityId) {
    ...AuditRuleStatusFields
  }
}
    ${WorkItemFieldsFragmentDoc}
${AuditRuleFieldsFragmentDoc}
${AuditRuleStatusFieldsFragmentDoc}`;

/**
 * __useListTransactionReviewItemsQuery__
 *
 * To run a query within a React component, call `useListTransactionReviewItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTransactionReviewItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTransactionReviewItemsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      filter: // value for 'filter'
 *      intervalOrigin: // value for 'intervalOrigin'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useListTransactionReviewItemsQuery(baseOptions: Apollo.QueryHookOptions<ListTransactionReviewItemsQuery, ListTransactionReviewItemsQueryVariables> & ({ variables: ListTransactionReviewItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTransactionReviewItemsQuery, ListTransactionReviewItemsQueryVariables>(ListTransactionReviewItemsDocument, options);
      }
export function useListTransactionReviewItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTransactionReviewItemsQuery, ListTransactionReviewItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTransactionReviewItemsQuery, ListTransactionReviewItemsQueryVariables>(ListTransactionReviewItemsDocument, options);
        }
export function useListTransactionReviewItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTransactionReviewItemsQuery, ListTransactionReviewItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListTransactionReviewItemsQuery, ListTransactionReviewItemsQueryVariables>(ListTransactionReviewItemsDocument, options);
        }
export type ListTransactionReviewItemsQueryHookResult = ReturnType<typeof useListTransactionReviewItemsQuery>;
export type ListTransactionReviewItemsLazyQueryHookResult = ReturnType<typeof useListTransactionReviewItemsLazyQuery>;
export type ListTransactionReviewItemsSuspenseQueryHookResult = ReturnType<typeof useListTransactionReviewItemsSuspenseQuery>;
export type ListTransactionReviewItemsQueryResult = Apollo.QueryResult<ListTransactionReviewItemsQuery, ListTransactionReviewItemsQueryVariables>;
export const ListTransactionReviewQuestionsDocument = gql`
    query ListTransactionReviewQuestions($organizationId: String!) {
  listTransactionReviewQuestions(organizationId: $organizationId) {
    ...TransactionReviewQuestionFields
  }
}
    ${TransactionReviewQuestionFieldsFragmentDoc}`;

/**
 * __useListTransactionReviewQuestionsQuery__
 *
 * To run a query within a React component, call `useListTransactionReviewQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTransactionReviewQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTransactionReviewQuestionsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useListTransactionReviewQuestionsQuery(baseOptions: Apollo.QueryHookOptions<ListTransactionReviewQuestionsQuery, ListTransactionReviewQuestionsQueryVariables> & ({ variables: ListTransactionReviewQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTransactionReviewQuestionsQuery, ListTransactionReviewQuestionsQueryVariables>(ListTransactionReviewQuestionsDocument, options);
      }
export function useListTransactionReviewQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTransactionReviewQuestionsQuery, ListTransactionReviewQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTransactionReviewQuestionsQuery, ListTransactionReviewQuestionsQueryVariables>(ListTransactionReviewQuestionsDocument, options);
        }
export function useListTransactionReviewQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTransactionReviewQuestionsQuery, ListTransactionReviewQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListTransactionReviewQuestionsQuery, ListTransactionReviewQuestionsQueryVariables>(ListTransactionReviewQuestionsDocument, options);
        }
export type ListTransactionReviewQuestionsQueryHookResult = ReturnType<typeof useListTransactionReviewQuestionsQuery>;
export type ListTransactionReviewQuestionsLazyQueryHookResult = ReturnType<typeof useListTransactionReviewQuestionsLazyQuery>;
export type ListTransactionReviewQuestionsSuspenseQueryHookResult = ReturnType<typeof useListTransactionReviewQuestionsSuspenseQuery>;
export type ListTransactionReviewQuestionsQueryResult = Apollo.QueryResult<ListTransactionReviewQuestionsQuery, ListTransactionReviewQuestionsQueryVariables>;
export const ListWorkItemsDocument = gql`
    query ListWorkItems($filter: WorkItemFilter!, $intervalOrigin: IntervalOrigin!, $direction: DirectionFromOrigin!) {
  listWorkItems(filter: $filter, origin: $intervalOrigin, direction: $direction) {
    ...WorkItemFields
  }
}
    ${WorkItemFieldsFragmentDoc}`;

/**
 * __useListWorkItemsQuery__
 *
 * To run a query within a React component, call `useListWorkItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      intervalOrigin: // value for 'intervalOrigin'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useListWorkItemsQuery(baseOptions: Apollo.QueryHookOptions<ListWorkItemsQuery, ListWorkItemsQueryVariables> & ({ variables: ListWorkItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWorkItemsQuery, ListWorkItemsQueryVariables>(ListWorkItemsDocument, options);
      }
export function useListWorkItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWorkItemsQuery, ListWorkItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWorkItemsQuery, ListWorkItemsQueryVariables>(ListWorkItemsDocument, options);
        }
export function useListWorkItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWorkItemsQuery, ListWorkItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWorkItemsQuery, ListWorkItemsQueryVariables>(ListWorkItemsDocument, options);
        }
export type ListWorkItemsQueryHookResult = ReturnType<typeof useListWorkItemsQuery>;
export type ListWorkItemsLazyQueryHookResult = ReturnType<typeof useListWorkItemsLazyQuery>;
export type ListWorkItemsSuspenseQueryHookResult = ReturnType<typeof useListWorkItemsSuspenseQuery>;
export type ListWorkItemsQueryResult = Apollo.QueryResult<ListWorkItemsQuery, ListWorkItemsQueryVariables>;
export const ListWorkItemsByIdsDocument = gql`
    query ListWorkItemsByIds($legalEntityId: String!, $workItemIds: [String!]!) {
  listWorkItemsByIds(legalEntityId: $legalEntityId, workItemIds: $workItemIds) {
    ...WorkItemFields
  }
}
    ${WorkItemFieldsFragmentDoc}`;

/**
 * __useListWorkItemsByIdsQuery__
 *
 * To run a query within a React component, call `useListWorkItemsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkItemsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkItemsByIdsQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *      workItemIds: // value for 'workItemIds'
 *   },
 * });
 */
export function useListWorkItemsByIdsQuery(baseOptions: Apollo.QueryHookOptions<ListWorkItemsByIdsQuery, ListWorkItemsByIdsQueryVariables> & ({ variables: ListWorkItemsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListWorkItemsByIdsQuery, ListWorkItemsByIdsQueryVariables>(ListWorkItemsByIdsDocument, options);
      }
export function useListWorkItemsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListWorkItemsByIdsQuery, ListWorkItemsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListWorkItemsByIdsQuery, ListWorkItemsByIdsQueryVariables>(ListWorkItemsByIdsDocument, options);
        }
export function useListWorkItemsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListWorkItemsByIdsQuery, ListWorkItemsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListWorkItemsByIdsQuery, ListWorkItemsByIdsQueryVariables>(ListWorkItemsByIdsDocument, options);
        }
export type ListWorkItemsByIdsQueryHookResult = ReturnType<typeof useListWorkItemsByIdsQuery>;
export type ListWorkItemsByIdsLazyQueryHookResult = ReturnType<typeof useListWorkItemsByIdsLazyQuery>;
export type ListWorkItemsByIdsSuspenseQueryHookResult = ReturnType<typeof useListWorkItemsByIdsSuspenseQuery>;
export type ListWorkItemsByIdsQueryResult = Apollo.QueryResult<ListWorkItemsByIdsQuery, ListWorkItemsByIdsQueryVariables>;
export const SummarizeWorkItemsDocument = gql`
    query SummarizeWorkItems($filter: WorkItemFilter!, $intervalOrigin: IntervalOrigin!, $direction: DirectionFromOrigin!) {
  summarizeWorkItems(
    filter: $filter
    origin: $intervalOrigin
    direction: $direction
  ) {
    ...WorkItemSummaryFields
  }
}
    ${WorkItemSummaryFieldsFragmentDoc}`;

/**
 * __useSummarizeWorkItemsQuery__
 *
 * To run a query within a React component, call `useSummarizeWorkItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSummarizeWorkItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSummarizeWorkItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      intervalOrigin: // value for 'intervalOrigin'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useSummarizeWorkItemsQuery(baseOptions: Apollo.QueryHookOptions<SummarizeWorkItemsQuery, SummarizeWorkItemsQueryVariables> & ({ variables: SummarizeWorkItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SummarizeWorkItemsQuery, SummarizeWorkItemsQueryVariables>(SummarizeWorkItemsDocument, options);
      }
export function useSummarizeWorkItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SummarizeWorkItemsQuery, SummarizeWorkItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SummarizeWorkItemsQuery, SummarizeWorkItemsQueryVariables>(SummarizeWorkItemsDocument, options);
        }
export function useSummarizeWorkItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SummarizeWorkItemsQuery, SummarizeWorkItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SummarizeWorkItemsQuery, SummarizeWorkItemsQueryVariables>(SummarizeWorkItemsDocument, options);
        }
export type SummarizeWorkItemsQueryHookResult = ReturnType<typeof useSummarizeWorkItemsQuery>;
export type SummarizeWorkItemsLazyQueryHookResult = ReturnType<typeof useSummarizeWorkItemsLazyQuery>;
export type SummarizeWorkItemsSuspenseQueryHookResult = ReturnType<typeof useSummarizeWorkItemsSuspenseQuery>;
export type SummarizeWorkItemsQueryResult = Apollo.QueryResult<SummarizeWorkItemsQuery, SummarizeWorkItemsQueryVariables>;
export const UserWorkflowActivityDocument = gql`
    query UserWorkflowActivity($legalEntityId: String!) {
  userWorkflowActivity(legalEntityId: $legalEntityId) {
    ...WorkflowActivityItemFields
  }
}
    ${WorkflowActivityItemFieldsFragmentDoc}`;

/**
 * __useUserWorkflowActivityQuery__
 *
 * To run a query within a React component, call `useUserWorkflowActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserWorkflowActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserWorkflowActivityQuery({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useUserWorkflowActivityQuery(baseOptions: Apollo.QueryHookOptions<UserWorkflowActivityQuery, UserWorkflowActivityQueryVariables> & ({ variables: UserWorkflowActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserWorkflowActivityQuery, UserWorkflowActivityQueryVariables>(UserWorkflowActivityDocument, options);
      }
export function useUserWorkflowActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserWorkflowActivityQuery, UserWorkflowActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserWorkflowActivityQuery, UserWorkflowActivityQueryVariables>(UserWorkflowActivityDocument, options);
        }
export function useUserWorkflowActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserWorkflowActivityQuery, UserWorkflowActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserWorkflowActivityQuery, UserWorkflowActivityQueryVariables>(UserWorkflowActivityDocument, options);
        }
export type UserWorkflowActivityQueryHookResult = ReturnType<typeof useUserWorkflowActivityQuery>;
export type UserWorkflowActivityLazyQueryHookResult = ReturnType<typeof useUserWorkflowActivityLazyQuery>;
export type UserWorkflowActivitySuspenseQueryHookResult = ReturnType<typeof useUserWorkflowActivitySuspenseQuery>;
export type UserWorkflowActivityQueryResult = Apollo.QueryResult<UserWorkflowActivityQuery, UserWorkflowActivityQueryVariables>;
export const WorkflowEventsDocument = gql`
    subscription WorkflowEvents($legalEntityId: String!) {
  workflowEvents(legalEntityId: $legalEntityId) {
    ...WorkflowEventFields
  }
}
    ${WorkflowEventFieldsFragmentDoc}`;

/**
 * __useWorkflowEventsSubscription__
 *
 * To run a query within a React component, call `useWorkflowEventsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowEventsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowEventsSubscription({
 *   variables: {
 *      legalEntityId: // value for 'legalEntityId'
 *   },
 * });
 */
export function useWorkflowEventsSubscription(baseOptions: Apollo.SubscriptionHookOptions<WorkflowEventsSubscription, WorkflowEventsSubscriptionVariables> & ({ variables: WorkflowEventsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WorkflowEventsSubscription, WorkflowEventsSubscriptionVariables>(WorkflowEventsDocument, options);
      }
export type WorkflowEventsSubscriptionHookResult = ReturnType<typeof useWorkflowEventsSubscription>;
export type WorkflowEventsSubscriptionResult = Apollo.SubscriptionResult<WorkflowEventsSubscription>;
export const WorkflowNotificationsDocument = gql`
    subscription WorkflowNotifications($legalEntityID: String!) {
  workflowNotifications(legalEntityID: $legalEntityID) {
    workflowNotificationID
    workflowID
    definitionName
    createdAt
    message
    kind
    notificationType
    targetAction
    bearerUpdated
    bearerRefreshDeferred
  }
}
    `;

/**
 * __useWorkflowNotificationsSubscription__
 *
 * To run a query within a React component, call `useWorkflowNotificationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowNotificationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowNotificationsSubscription({
 *   variables: {
 *      legalEntityID: // value for 'legalEntityID'
 *   },
 * });
 */
export function useWorkflowNotificationsSubscription(baseOptions: Apollo.SubscriptionHookOptions<WorkflowNotificationsSubscription, WorkflowNotificationsSubscriptionVariables> & ({ variables: WorkflowNotificationsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WorkflowNotificationsSubscription, WorkflowNotificationsSubscriptionVariables>(WorkflowNotificationsDocument, options);
      }
export type WorkflowNotificationsSubscriptionHookResult = ReturnType<typeof useWorkflowNotificationsSubscription>;
export type WorkflowNotificationsSubscriptionResult = Apollo.SubscriptionResult<WorkflowNotificationsSubscription>;